(function () {
    'use strict';

    angular
        .module('atheer', [
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'LocalStorageModule',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.router',
            'permission',
            'ngAnimate',
            'ngSanitize',
            'ngMessages',
            'ngMaterial',
            'angularMoment',
            'md.data.table',
            'ng-jwplayer',
            'froala',
            'signature',
            angularDragula(angular),
            'mdPickers',
            'angAccordion',
            'dibari.angular-ellipsis',
            'ngTagCloud',
            'formlyMaterial',
            'emguo.poller',
            'ng.deviceDetector',
            'highcharts-ng',
            'ngclipboard',
            'pubnub.angular.service',
            'ngMaterialDateRangePicker',
            'ng-showdown',
            //'atheer.profiler',
            'atheer.services',
            'atheer.core',
            'atheer.conversation',
            'atheer.session',
            'atheer.user',
            'atheer.public',
            'atheer.team',
            'atheer.insights',
            'atheer.system',
            'atheer.cloud',
            'atheer.content',
            'atheer.topic',
            'atheer.smartFlow',
            'atheer.datamodel',
            'atheer.workspace',
            'atheer.anchor',
            'atheer.airform',
            'atheer.job',
            'atheer.ticket',
            'atheer.sdk',
            'atheer.doc',
            'atheer.home'
            //atheer-needle-add-module - Atheer will add modules here
        ])
        .run(run);

    function run($rootScope, stateHandler, translationHandler, $location, $cookieStore, $http, Principal, LoginService, $state, AuthServerProvider, Feature, Auth, idleHandler) {
        var host = $location.host();

        $rootScope.isAppWorkspace = false;

        stateHandler.initialize();
        translationHandler.initialize();
        idleHandler.initialize();

        if (angular.isDefined(host) && host.startsWith("app.")) {
            $rootScope.isAppWorkspace = true;
        } else {
            $rootScope.isAppWorkspace = false;
            if (host != 'localhost') {
                Auth.validateWorkspaceName(host.split('.')[0])
                    .then(function (companySetting) {
                        $rootScope.companySetting = JSON.parse(companySetting.data);
                    })
                    .catch(function () {
                        $state.go('account.noaccess');
                    });
            }
        }

        $rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
            if (Principal.isAuthenticated() || AuthServerProvider.hasValidToken()) {
                if ($location.path() == '/') {
                    if ($location.path().startsWith('/deeplink')) {
                        $location.path($location.path())
                    } else {
                        if ($rootScope.isMasterWorkspace) {
                            $location.path('/system/dashboard');
                        } else if (angular.isDefined($rootScope.baseHome)) {
                            $location.path($rootScope.baseHome);
                        } else {
                            $location.path('/home');
                        }
                    }
                }
                if (($location.path() == '/airforms' || $location.path() == '/adv-insights') && $rootScope.isAppletEditActive) {
                    console.log('handling angular redirect for: ' + $location.path())
                    event.preventDefault();
                    $location.replace();
                    var iFrame = document.getElementById('ngxFrame').contentWindow;
                    var targetOrigin = location.hostname === "localhost"
                        ? "https://" + location.hostname + ":4200"
                        : location.origin;
                    iFrame.postMessage({ 'dirtyCheckAppletData': $rootScope.isAppletEditActive }, targetOrigin);
                }

            } else if ($location.path() == '/signout') {
                $location.path('/signout');
            } else if ($location.path() == '/signup') {
                $location.path('/signup');
            } else if ($location.path().startsWith('/invite')) {
                $location.path($location.path());
            } else if ($location.path().startsWith('/signup/')) {
                $location.path($location.path());
            } else if ($location.path() == '/forgot') {
                $location.path('/forgot');
            } else if ($location.path() == '/reset') {
                $location.path('/reset');
            } else if ($rootScope.isAppWorkspace && $location.path().startsWith('/letsgo')) {
                $location.path($location.path());
            } else if ($location.path() == '/join') {
                $location.path('/join');
            } else if ($location.path().startsWith('/join')) {
                $location.path($location.path());
            } else if ($location.path().startsWith('/guest')) {
                $location.path($location.path());
            } else if ($location.path().startsWith('/signin/noaccess')) {
                $location.path($location.path())
            } else if ($location.path().startsWith('/atheer-signin')) {
                $location.path($location.path())
            } else if ($location.path().startsWith('/deeplink')) {
                $location.path($location.path())
            } else if ($location.path().startsWith('/public')) {
                $location.path($location.path())
            } else {
                if ($location.path() !== '/') {
                    $location.path('/signin');
                }
            }
        });
    }
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('atheer')
        .constant('VERSION', "1.0.0")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('HTML5_ENABLED', true)
;
})();
;
(function() {
    'use strict';
    angular
        .module('atheer')
        .constant('ATHEER_FEATURES', {
            'system': {
                'notification_edit': 'feature_system_notification_edit',
                'email_set_up': 'feature_system_email_set_up',
                'adv_image_edit': 'feature_system_adv_image_edit',
                'sso': 'feature_system_sso'
            },
            'studio': {
                'help_center': 'feature_studio-settings_help_center',
            },
            'user': {
                'invitation': 'feature_user_invitation',
                'signup': 'feature_user_signup',
                'extended_fields': 'feature_user_extended_fields'
            },
            'audience': {
                'dynamic': 'feature_audience_dynamic'
            },
            'security_roles': {
                'custom_roles': 'feature_security_role_custom_roles'
            },
            'airsession': {
                'enable': 'feature_airsession_enable',
                'schedule_session': 'feature_airsession_schedule_session',
                'recurring_session': 'feature_airsession_recurring_session',
                'session_template': 'feature_airsession_session_template',
                'personal_session': 'feature_airsession_personal_session',
                'live_annotation': 'feature_airsession_live_annotation',
                'recording': 'feature_airsession_recording'
            },
            'conversation': {
                'enable': 'feature_conversation_enable',
                'group_conversation': 'feature_conversation_group_conversation',
                'recurring_session': 'feature_conversation_typing_indicator'
            },
            'content': {
                'enable': 'feature_content_enable',
                'did_you_know': 'feature_content_did_you_know',
                'announcement': 'feature_content_announcement',
                'video': 'feature_content_video',
                'podcast': 'feature_content_podcast',
                'document': 'feature_content_document',
                'image': 'feature_content_image',
                'page': 'feature_content_page',
                'link': 'feature_content_link',
                'airsession_recording': 'feature_content_airsession_recording',
                'share': 'feature_content_share',
                'bookmark': 'feature_content_bookmark',
                'flag': 'feature_content_extended_flag',
                'rating': 'feature_content_rating',
                'like': 'feature_content_like',
                'problem': 'feature_content_problem',
                'allow_upload': 'feature_content_allow_upload',
                'allow_owner': 'feature_content_allow_owner',
                'extended_fields': 'feature_content_extended_fields'
            },
            'topic': {
                'enable': 'feature_topic_enable',
                'extended_fields': 'feature_topic_extended_fields'
            },
            'badge': {
                'enable': 'feature_badge_enable'
            },
            'airform': {
                'enable': 'feature_airform_enable'
            },
            'smartscan': {
                'enable': 'feature_smartscan_enable'
            },
            'anchor': {
                'enable': 'feature_anchor_enable'
            },
            'smartflow': {
                'enable': 'feature_smartflow_enable'
            },
            'insights': {
                'dashboard': 'feature_insights_dashboard',
                'user': 'feature_insightsuser',
                'conversation': 'feature_insights_conversation',
                'airsession': 'feature_insights_airsession',
                'content': 'feature_insights_content',
                'airform': 'feature_insights_airform',
                'smartscan': 'feature_insights_smartscan',
                'anchor': 'feature_insights_anchor',
                'smartflow': 'feature_insights_mobile_smartflow'
            },
            'adv-insights': {
                'enabled': 'feature_adv-insights_enabled',
                'designer': 'feature_adv-insights_designer'
            },
            'airbridge': {
                'enable': 'feature_airbridge_enable'
            },
            'airsense': {
                'enable': 'feature_airsense_enable'
            },
            'airsdk': {
                'enable': 'feature_airsdk_enable'
            },
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services', [
        ]);
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Workspace', Workspace);

    /* @ngInject */
    function Workspace($resource, DateUtils) {
        var resourceUrl = 'api/system/workspaces/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    return transformResponse(data);
                }
            },
            'update': {
                method: 'PUT',
                transformResponse: function(data) {
                    return transformResponse(data);
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function(data) {
                    return transformResponse(data);
                }
            },
            'saveAsync': {
                url: 'api/system/workspaces/async',
                method: 'POST',
            },
            'getWorkspaceStatus': {
                url: 'api/system/job-streams/:id',
                method: 'GET'
            },
            'getFeatures': {
                url: resourceUrl + '/features',
                method: 'GET',
                isArray: true
            },
            'updateFeatures': {
                url: resourceUrl + '/features',
                method: 'PUT'
            },
            'getDashboard': {
                url: resourceUrl + '/dashboard',
                method: 'GET'
            },
            'getConversationDashboard': {
                url: resourceUrl + '/conversation/dashboard',
                method: 'GET'
            },
            'getSessionDashboard': {
                url: resourceUrl + '/session/dashboard',
                method: 'GET'
            },
            'getContentDashboard': {
                url: resourceUrl + '/content/dashboard',
                method: 'GET'
            },
            'getAirformDashboard': {
                url: resourceUrl + '/airform/dashboard',
                method: 'GET'
            },
            'getSmartScanDashboard': {
                url: resourceUrl + '/smartscan/dashboard',
                method: 'GET'
            },
            'getSmartflowDashboard': {
                url: resourceUrl + '/smartflow/dashboard',
                method: 'GET'
            },
            'getUserDashboard': {
                url: resourceUrl + '/user/dashboard',
                method: 'GET'
            },
            'getInsightSettings': {
                url: resourceUrl + '/insight-settings',
                method: 'GET'
            },
            'setInsightSettings': {
                url: resourceUrl + '/insight-settings',
                method: 'PUT'
            },
            'activateInsights': {
                url: resourceUrl + '/activate-insights',
                method: 'PUT'
            },
        });

        function transformResponse(data) {
            data = angular.fromJson(data);
            data.start_date = DateUtils.convertLocalDateFromServer(data.start_date);
            data.end_date = DateUtils.convertLocalDateFromServer(data.end_date);
            return data;
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('WorkspaceSignup', WorkspaceSignup);

    /* @ngInject */
    function WorkspaceSignup($resource) {
        var resourceUrl = 'api/workspace-signups/:code';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        return data;
                    } else {
                        return null;
                    }
                }
            },
            'checkName': {
                url: 'api/workspace-signups/name/:name',
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        return data;
                    } else {
                        return null;
                    }
                }
            },
            'update': {
                method: 'PUT'
            },
            'activate': {
                url: 'api/workspace-signups/activate',
                method: 'POST'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('WebHook', WebHook);

    /* @ngInject */
    function WebHook($resource) {
        var resourceUrl = 'api/system/webhooks/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'getExecutions': {
                url: resourceUrl + '/executions',
                method: 'GET',
                isArray: true
            },
            'testWebHook': {
                url: 'api/system/webhooks/:id/test',
                method: 'POST'
            },
            'executeWebHook': {
                url: 'api/system/webhooks-executions/:id/run',
                method: 'POST'
            },
        });
    }
})();
;
  (function() {
      'use strict';
      angular
          .module('atheer.services')
          .factory('User', User);


      /* @ngInject */
      function User($resource, DateUtils) {
          var resourceUrl = 'api/users/:id';

          return $resource(resourceUrl, {
              id: '@id'
          }, {
              'query': {
                  method: 'GET',
                  isArray: true
              },
              'get': {
                  method: 'GET',
                  transformResponse: function(result) {
                      return transformResponse(result);
                  }
              },
              'getById': {
                  url: 'api/users/:id?id=true',
                  method: 'GET',
                  transformResponse: function(result) {
                      return transformResponse(result);
                  }
              },
              'getWithPermission': {
                  url: 'api/users/:id?permissions=true',
                  method: 'GET',
              },
              'getFullUser': {
                  url: 'api/users/:id?permissions=true&include-audiences=false&widget-auth=false&update-visit=false',
                  method: 'GET',
              },
              'changeMePassword': {
                  url: 'api/users/me/change_password',
                  method: 'POST'
              },
              'forceMePassword': {
                url: 'api/users/me/force_password',
                method: 'POST'
            },
              'changeUserPassword': {
                  url: 'api/users/:id/change_password',
                  method: 'POST'
              },
              'passwordResetInit': {
                  url: 'api/users/reset_password/init',
                  method: 'POST'
              },
              'passwordResetFinish': {
                  url: 'api/users/reset_password/finish',
                  method: 'POST'
              },
              'passwordResetTemp': {
                  url: 'api/users/reset_password/temp',
                  method: 'POST'
              },
              'validateImportFile': {
                  url: 'api/users/import/validate',
                  method: 'GET',
              },
              'validateImportExcelFile': {
                url: 'api/users/excel/validate',
                method: 'GET',
              },
              'importUsers': {
                  url: 'api/users/import',
                  method: 'POST',
              },
              'getImportStatus': {
                  url: 'api/system/job-streams/:id',
                  method: 'GET'
              },
              'importUsersFromSpreadSheet': {
                url: 'api/users/spreadsheet/upload/media',
                method: 'POST',
              },
              'getSpreadSheetImportStatus': {
                url: 'api/users/spreadsheet/:id',
                method: 'GET',
              },
              'getPersonalSession': {
                  url: 'api/users/me/session',
                  method: 'GET'
              },
              'getConversations': {
                  url: 'api/users/me/conversations',
                  method: 'GET',
                  isArray: true
              },
              'getQRCode': {
                  url: 'api/users/:id/qrcode',
                  method: 'GET'
              },
              'save': {
                  url: 'api/users',
                  method: 'POST',
                  transformResponse: function(result) {
                      return transformResponse(result);
                  }
              },
              'update': {
                  method: 'PUT',
                  transformResponse: function(result) {
                      return transformResponse(result);
                  }
              },
              'updateme': {
                url: 'api/users/me',
                  method: 'PUT',
                  transformResponse: function(result) {
                      return transformResponse(result);
                  }
              },
              'delete': {
                  method: 'DELETE'
              },
              'activate': {
                  url: 'api/users/activate',
                  method: 'GET',
                  params: {},
                  isArray: false
              },
              'signup': {
                  url: 'api/users/signup',
                  method: 'POST'
              },
              'register': {
                  url: 'api/users/register',
                  method: 'POST'
              },
              'checkLogin': {
                  url: 'api/users/check-login/:login',
                  method: 'GET',
                  transformResponse: function(data) {
                      if (data) {
                          data = angular.fromJson(data);
                          return data;
                      } else {
                          return null;
                      }
                  }
              },
              'validateDeviceId': {
                  url: 'api/users/guest/validate/:deviceId',
                  method: 'GET',
                  isArray: false
              },
              'getJobs': {
                  url: resourceUrl + '/recent-applets',
                  method: 'GET',
                  isArray: true
              },
              'bulkRemove': {
                  url: resourceUrl + 'users/bulk/remove',
                  method: 'POST'
              },
          });

          function transformResponse(result) {
              if(result === "") {
                  return result;
              }
              result = angular.fromJson(result);

              if (result.start_date) {
                  result.start_date = DateUtils.convertDateTimeFromServer(result.start_date);
              }

              if (result.terminated_on) {
                  result.terminated_on = DateUtils.convertDateTimeFromServer(result.terminated_on);
              }

              if (result.properties) {
                  var keys = Object.keys(result.properties);
                  angular.forEach(keys, function(key) {
                      if(key.endsWith("_at")) {
                          result.properties[key] = DateUtils.convertDateTimeFromServer(result.properties[key]);
                      }
                  });
              }
              return result;
          }
      }
  })();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('UserInvitation', UserInvitation);


    /* @ngInject */
    function UserInvitation($resource) {
        var resourceUrl = 'api/user-invitations/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByActivationKey': {
                url: 'api/user-invitations/key/:id',
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'resend': {
                url: 'api/user-invitations/:id/resend',
                method: 'PUT'
            },
            'bulkInvitation': {
                url: 'api/user-invitations/bulk',
                method: 'POST',
                isArray: true
            },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('_', UnderScore);

    /* @ngInject */
    function UnderScore() {
        _.mixin(s.exports());
        return window._;
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Topic', Topic);

    /* @ngInject */
    function Topic($resource) {
        var resourceUrl = 'api/topics/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'bulkUpdate': {
                url: 'api/topics/bulk',
                method: 'PUT'
            },
            'assignContents': {
                url: 'api/topics/:id/contents/assign',
                method: 'POST'
            },
            'removeContents': {
                url: 'api/topics/:id/contents/remove',
                method: 'POST'
            },
            'getContents': {
                method: 'GET',
                url: resourceUrl + '/contents?isWeb=true',
                isArray: true,
                transformResponse: function(result) {
                    var resultData = angular.fromJson(result);
                    var returnArray = [];
                    angular.forEach(resultData, function(contentData) {
                        returnArray.push(contentData.content);
                    });
                    return returnArray;
                }
            },
            'getSubTopics': {
                method: 'GET',
                url: resourceUrl + '/sub-topics?isWeb=true',
                isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Timezone', Timezone);

    /* @ngInject */
    function Timezone($resource) {
        var resourceUrl = 'api/system/timezones/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Team', Team);

    /* @ngInject */
    function Team($resource) {
        var resourceUrl = 'api/audiences/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'getMemberHistory': {
                url: resourceUrl + '/history',
                method: 'GET',
                isArray: true
            },
            'getMemberCountHistory': {
                url: resourceUrl + '/count/history',
                method: 'GET',
                isArray: true
            },
            'syncUsers': {
                url: 'api/audiences/:id/sync',
                method: 'POST',
            },
            'getSyncUsersStatus': {
                url: 'api/system/job-streams/:id',
                method: 'GET'
            },
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('System', System);

    /* @ngInject */
    function System($resource) {
        var resourceUrl = 'api/system/settings/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'getTimezones': {
                method: 'GET',
                isArray: true,
                url: 'api/system/timezones'
            },
            'getLanguages': {
                method: 'GET',
                isArray: true,
                url: 'api/system/languages'
            },
            'getInsights': {
                method: 'GET',
                url: 'api/reports/master-dashboard'
            },
            'getCountryCodes': {
                method: 'GET',
                isArray: true,
                url: 'api/system/country-codes'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('SmartFlow', SmartFlow);

    /* @ngInject */
    function SmartFlow($resource, DateUtils) {
        var resourceUrl = 'api/workflows/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(result) {
                    return transformResponse(result);
                }
            },
            'update': {
                method: 'PUT',
                transformResponse: function(result) {
                    return transformResponse(result);
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function(result) {
                    return transformResponse(result);
                }
            }
        });

        function transformResponse(data) {
            data = angular.fromJson(data);

            if (data.start_date) {
                data.start_date = DateUtils.convertDateTimeFromServer(data.start_date);
            }

            if (data.end_date) {
                data.end_date = DateUtils.convertDateTimeFromServer(data.end_date);
            }
            return data;
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Setting', Setting);

    /* @ngInject */
    function Setting($resource) {
        var resourceUrl = 'api/system/settings/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                url: 'api/system/settings',
                method: 'GET',
                isArray: true
            },
            'getSkinSettings': {
                url: 'api/system/settings/skin',
                method: 'GET',
                isArray: true
            },
            'getLabelDictionarySettings': {
                url: 'api/system/settings/label-dictionary',
                method: 'GET',
                isArray: true
            },
            'getBuildInfoSettings': {
                url: 'api/system/settings/build-info',
                method: 'GET',
                isArray: false
            },
            'getEmailSettings': {
                url: 'api/system/settings/email',
                method: 'GET',
                isArray: true
            },
            'getUserSignupSettings': {
                url: 'api/system/settings/user-signup',
                method: 'GET',
                isArray: true
            },
            'getUserSignupMetadata': {
                url: 'api/signup/metadata',
                method: 'GET',
                isArray: false
            },
            'getSessionSettings': {
                url: 'api/system/settings/session',
                method: 'GET',
                isArray: true
            },
            'getAirformSettings': {
                url: '/api/system/settings?query=category==AiRForm',
                method: 'GET',
                isArray: true
            },
            'getCameraSettings': {
                url: '/api/system/settings?query=category=="Lens Camera"',
                method: 'GET',
                isArray: true
            },
            'getAuthenticationSetupSettings': {
                url: 'api/system/settings/authentication-setup',
                method: 'GET',
                isArray: true
            },
            'getAuthenticationSamlMetadata': {
                url: 'api/system/settings/authentication-sp-metadata',
                method: 'GET',
                isArray: false
            },
            'getAuthenticationConfigSettings': {
                url: 'api/system/settings/authentication-config',
                method: 'GET',
                isArray: true
            },
            'getFeaturesSettings': {
                url: 'api/system/settings/features',
                method: 'GET',
                isArray: true
            },
            'getAccessConfigSettings': {
                url: '/api/system/settings/feature-access-config',
                method: 'GET',
                isArray: true
            },
            'getCompanySettings': {
                url: 'api/system/settings/company',
                method: 'GET',
                isArray: true
            },
            'getAPIKeySettings': {
                url: 'api/system/settings/api-key',
                method: 'GET',
                isArray: true
            },
            'generateAPIKeySettings': {
                url: 'api/system/settings/api-key',
                method: 'PUT',
                isArray: true
            },
            'deactivateAPIKeySettings': {
                url: 'api/system/settings/api-key',
                method: 'DELETE'
            },
            'getWidgetSSOSettings': {
                url: 'api/system/settings/widget-sso',
                method: 'GET',
                isArray: true
            },
            'generateWidgetSSOSettings': {
                url: 'api/system/settings/widget-sso',
                method: 'PUT',
                isArray: true
            },
            'deactivateWidgetSSOSettings': {
                url: 'api/system/settings/widget-sso',
                method: 'DELETE'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getSystemTimezones': {
                method: 'GET',
                isArray: true,
                url: 'api/system/timezones'
            },
            'getSystemLanguages': {
                method: 'GET',
                isArray: true,
                url: 'api/system/languages'
            },
            'getActivityTemplates': {
                method: 'GET',
                isArray: true,
                url: 'api/activityTemplates?query=status==Active&sort=name,asc'
            },
            'getJobPDFSettings': {
                url: '/api/system/settings?query=category=="Job_Report_Configuration"',
                method: 'GET',
                isArray: true
            },
            'getJobFileExtSettings': {
                url: '/api/system/settings?query=category=="Job_FileExtensions_Configuration"',
                method: 'GET',
                isArray: true
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Session', Session);


    /* @ngInject */
    function Session($resource) {
        var resourceUrl = 'api/sessions/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getTemplate': {
                url: 'api/sessions/:id?type=TEMPLATE',
                method: 'GET',
            },
            'getSessionSummaryReport': {
                url: 'api/sessions/summary/report',
                method: 'GET',
            },
            'update': {
                method: 'PUT'
            },
            'updateScheduled': {
                url: 'api/sessions/:id?send_invite=true',
                method: 'PUT'
            },
            'invite': {
                url: 'api/sessions/:id/invite',
                method: 'POST'
            },
            'getPersonalRoomSummary': {
                url: 'api/sessions/personal/summary',
                method: 'GET'
            },
            'getPersonalRoomInstances': {
                url: 'api/sessions/personal/instances',
                method: 'GET',
                isArray: true
            },
            'getAnnotationZip': {
                url: 'api/sessions/annotationImages/:id',
                method: 'GET'
            },
            'getImportStatus': {
                url: 'api/system/job-streams/:id',
                method: 'GET'
            },
            'validatePasscode': {
                url: '/api/sessions/:id/validate-passcode?passcode=:passcode',
                method: 'GET',
                transformResponse: function (data) {
                    return data
                }
            },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('SessionConfigService', SessionConfigService)

    /* @ngInject */
    function SessionConfigService($rootScope, $filter) {

        var domain = null;

        var service = {
            init: init,
            getDomain: getDomain
        };
        return service;

        function init(session_config) {
            domain = session_config.domain;
        };

        function getDomain() {
            return domain;
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('SecurityRole', SecurityRole);

    /* @ngInject */
    function SecurityRole($resource) {
        var resourceUrl = 'api/system/security-roles/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Search', Search);

    /* @ngInject */
    function Search($resource, DateUtils) {
        var resourceUrl = 'api/search/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Scorm', Scorm);

    /* @ngInject */
    function Scorm($resource) {
        var resourceUrl = 'api/scorm/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'getCoursePreviewUrl': {
                url: 'api/scorm/preview/:id',
                method: 'GET'
            },
            'getCourseLaunchUrl': {
                url: 'api/scorm/launch/:id',
                method: 'GET'
            },
            'updateProgress': {
                url: 'api/scorm/update/:id',
                method: 'PUT'
            },
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Report', Report);

    /* @ngInject */
    function Report($resource, DateUtils) {
        var resourceUrl = 'api/reports/';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'getQuestionResponseSummary': {
                url: resourceUrl + 'question/response/summary/:id',
                method: 'GET'
            },
            'getUserSummary': {
                url: resourceUrl + 'user/summary',
                method: 'GET',
                isArray: true
            },
            'exportUserSummary': {
                url: resourceUrl + 'user/summary/export',
                method: 'GET'
            },
            'getContentSummary': {
                url: resourceUrl + 'content/summary',
                method: 'GET',
                isArray: true
            },
            'exportContentSummary': {
                url: resourceUrl + 'content/summary/export',
                method: 'GET'
            },
            'getUserOverviewSummary': {
                url: resourceUrl + 'user/overview/summary/:id',
                method: 'GET'
            },
            'getContentOverviewSummary': {
                url: resourceUrl + 'content/overview/summary/:id',
                method: 'GET'
            },
            'getFlowbotOverviewSummary': {
                url: resourceUrl + 'workflow/overview/summary/:id',
                method: 'GET'
            },
            'getFlowbotActivitySummary': {
                url: resourceUrl + 'workflow/activity/summary/:id',
                method: 'GET',
                isArray: true
            },
            'getFlowbotUserActivitySummary': {
                url: resourceUrl + 'workflow/user/activity/summary/:id',
                method: 'GET',
                isArray: true
            },
            'getContentCardsSummary': {
                url: resourceUrl + 'content/cards/summary/:id',
                method: 'GET'
            },
            'getContentUserCardsSummary': {
                url: resourceUrl + 'content/cards/user/summary/:id/:userId',
                method: 'GET'
            },
            'getContentModulesSummary': {
                url: resourceUrl + 'content/modules/summary/:id',
                method: 'GET'
            },
            'getSmartScanSummary': {
                url: resourceUrl + 'smartscan/dashboard/:id',
                method: 'GET'
            },
            'getTopicSummary': {
                url: resourceUrl + 'topic/dashboard/:id',
                method: 'GET'
            },
            'getContentModulesUserSummary': {
                url: resourceUrl + 'content/modules/user/summary/:id/:userId',
                method: 'GET'
            },
            'getDashboard': {
                url: resourceUrl + 'dashboard',
                method: 'GET'
            },
            'getConversationDashboard': {
                url: resourceUrl + 'conversation/dashboard',
                method: 'GET'
            },
            'getSessionDashboard': {
                url: resourceUrl + 'session/dashboard',
                method: 'GET'
            },
            'getContentDashboard': {
                url: resourceUrl + 'content/dashboard',
                method: 'GET'
            },
            'getAirformDashboard': {
                url: resourceUrl + 'airform/dashboard',
                method: 'GET'
            },
            'getSmartScanDashboard': {
                url: resourceUrl + 'smartscan/dashboard',
                method: 'GET'
            },
            'getTopicDashboard': {
                url: resourceUrl + 'topic/dashboard',
                method: 'GET'
            },
            'getSmartflowDashboard': {
                url: resourceUrl + 'smartflow/dashboard',
                method: 'GET'
            },
            'getUserDashboard': {
                url: resourceUrl + 'user/dashboard',
                method: 'GET'
            },
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.services')
        .factory('PubNubService', PubNubService)

    /* @ngInject */
    function PubNubService(Pubnub, $rootScope, $filter, NotificationHandleService, $state, $cookies) {

        var userId = null;
        var channelsDetail = null;
        var globalChannels = [];
        var workspaceChannelName = null;
        var usersState = [];
        var random_uuid = window.localStorage.getItem("random_uuid");
        var userPermissionSet = [];

        var service = {
            init: init,
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            publish: publish,
            getMessageEventNameFor: getMessageEventNameFor,
            getPresenceEventNameFor: getPresenceEventNameFor,
            getUserState: getUserState,
            disconnect: disconnect
        };
        return service;

        function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        function init(id, messaging_config, channelsInfo, permissionSet) {
            if (window.localStorage.getItem("random_uuid") === null) {
                var ruuid = uuidv4();
                window.localStorage.setItem("random_uuid", ruuid);
                random_uuid = id + ruuid;
            } else {
                random_uuid = id + window.localStorage.getItem("random_uuid");
            }
            userId = id;
            channelsDetail = channelsInfo;

            var channels = [];
            var conversationChannels = [];

            userPermissionSet = permissionSet;

            angular.forEach(channelsInfo.personal, function (channel) {
                channels.push(channel.name);
            });

            angular.forEach(channelsInfo.global, function (channel) {
                if (channel.name.startsWith('workspace')) {
                    workspaceChannelName = channel.name;
                } else {
                    channels.push(channel.name);
                    globalChannels.push(channel.name);
                }
            });

            angular.forEach(channelsInfo.conversations, function (channel) {
                conversationChannels.push(channel.name);
            });

            Pubnub.init({
                origin: messaging_config.domain,
                ssl: true,
                publishKey: messaging_config.publish_key,
                subscribeKey: messaging_config.subscribe_key,
                uuid: id,
                restore: true
            });

            //subscribe to all the global channels
            if (channels.length > 0) {
                subscribe(channels, false);
            };

            if (conversationChannels.length > 0) {
                subscribe(conversationChannels, true);
            };

            //subscribe to workspace channels
            if (workspaceChannelName != null) {
                subscribe([workspaceChannelName], true);
            };

            Pubnub.addListener({
                status: function (statusEvent) {
                    console.log("Studio-Pubnub-status", statusEvent);
                    if (statusEvent.category === "PNUnknownCategory") {
                        var newState = {
                            new: 'error'
                        };
                        Pubnub.setState({
                            state: newState
                        },
                            function (status) {
                                console.log(statusEvent.errorData.message)
                            }
                        );
                    }
                },
                message: function (message) {
                    console.log("Studio-Pubnub-Message", message);
                    if (message.message.subject == 'CONVERSATION' && message.message.uuid != random_uuid && (hasAccess('access-conversation') || $cookies.get('isGuest')) && message.publisher != userId) {
                        if ($state.current.url != '/conversations/:id' && message.message.type === 'MESSAGE_CREATED'
                            && $state.current.url != '/player/:session_no') {
                            NotificationHandleService.onNotification(message);
                        } else {
                            $rootScope.$broadcast('conversationMessagePubNub', message);
                            if (message.message.type === 'REFRESH_CONVERSATION') {
                                subscribe(['conversation-' + message.message.data.id], true);
                            }
                        }
                    } else if (message.message.type == 'NOTIFICATION' && message.message.uuid != random_uuid && hasAccess('access-session')) {
                        NotificationHandleService.onNotification(message.message.data)
                    } else if (message.message.subject == 'SESSION') {
                        $rootScope.$broadcast('sessionMessagePubNub', message);
                    } else if (message.message.type === 'JOB' && hasAccess('access-job')) {
                        NotificationHandleService.onNotification(message);
                    }
                },
                presence: function (message) {
                    console.log("Studio-Pubnub-presence", message);
                    if (message.uuid != userId && message.channel == workspaceChannelName) {
                        if (message.action == 'join') {
                            var usersStateIndex = usersState.findIndex(function (userState) {
                                return userState.uuid == message.uuid;
                            });

                            if (usersStateIndex <= 0) {
                                usersState.push({
                                    state: message.state,
                                    uuid: message.uuid
                                });
                            }
                        } else if (message.action == 'leave' || message.action == 'timeout') {
                            usersState = usersState.filter(function (userState) {
                                return userState.uuid != message.uuid;
                            });
                        }
                        $rootScope.$broadcast('refreshUserStatus', message.uuid);
                    }
                }
            });

            Pubnub.hereNow({
                channels: [workspaceChannelName],
                includeUUIDs: true,
                includeState: true
            },
                function (status, response) {
                    console.log("Studio-Pubnub-hereNow", status, response);
                    if (response != undefined && response.channels != undefined) {
                        usersState = response.channels[workspaceChannelName].occupants;
                        console.log("Studio-Pubnub-hereNow-usersState", usersState);
                    }
                }
            );
        };

        function subscribe(channels, withPresence) {
            console.log("Studio-PubNub-subscribe", channels);
            Pubnub.subscribe({
                channels: channels,
                withPresence: withPresence,
                triggerEvents: ['message', 'presence', 'status']
            });
        };

        function unsubscribe(channels) {
            Pubnub.unsubscribe({
                channels: channels,
            });
        };

        function publish(channel, message) {
            //console.log("Studio-Pubnub", channel, message);
            message.uuid = random_uuid;
            Pubnub.publish({
                channel: channel,
                message: message,
                storeInHistory: false
            }, function (status, response) {
                //console.log("Studio-Pubnub-Success", status, response);
            });
        };

        function getMessageEventNameFor(channel) {
            return Pubnub.getMessageEventNameFor(channel);
        };

        function getPresenceEventNameFor(channel) {
            return Pubnub.getPresenceEventNameFor(channel);
        };

        function getUserState(id) {
            var userInfo = $filter('filter')(usersState, {
                uuid: id
            })[0];
            return userInfo;
        };

        function disconnect() {
            console.log("Studio-Pubnub-disconnect");
            Pubnub.unsubscribeAll();
        };


        function hasAccess(permission) {
            if (userPermissionSet.indexOf(permission) > -1) {
                return true;
            } else {
                return false;
            }
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Provider', Provider);

    /* @ngInject */
    function Provider($resource, DateUtils) {
        var resourceUrl = 'api/contents/providers/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(result) {
                    return transformResponse(result);
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function(result) {
                    return transformResponse(result);
                }
            },
            'update': {
                method: 'PUT',
                transformResponse: function(result) {
                    return transformResponse(result);
                }
            }
        });

        function transformResponse(result) {
            result = angular.fromJson(result);
            return result;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('Principal', Principal)

    /* @ngInject */
    function Principal($rootScope, $q, User, PubNubService, SessionConfigService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            logout: logout,
            getUserId: getUserId,
            getUserLogin: getUserLogin,
            getUser: getUser,
            getUserInfo: getUserInfo,
            getUserShortName: getUserShortName,
            getUserFullName: getUserFullName,
            getPrimaryTeam: getPrimaryTeam,
            getWorkspaceDomain: getWorkspaceDomain,
            isWorkspaceAdmin: isWorkspaceAdmin,
            isAdmin: isAdmin,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            getWorkspaceCode: getWorkspaceCode
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        };

        function logout() {
            _identity = undefined;
            _authenticated = false;
        };

        function getUserId() {
            if (!_authenticated || !_identity) {
                return;
            }
            return _identity.id;
        };

        function getUserLogin() {
            if (!_authenticated || !_identity) {
                return;
            }
            return _identity.login;
        };

        function getWorkspaceDomain() {
            if (!_authenticated || !_identity) {
                return;
            }
            return _identity.workspace_info.domain;
        };

        function getUserInfo() {
            if (!_authenticated || !_identity) {
                return;
            }
            var user = _identity;
            return user;
        };

        function getUserShortName() {
            var shortName = "";

            if (!_authenticated || !_identity) {
                return;
            }

            if (_identity.first_name) {
                shortName = shortName + _identity.first_name.charAt(0).toUpperCase();
            }
            if (_identity.last_name) {
                shortName = shortName + _identity.last_name.charAt(0).toUpperCase();
            } else {
                shortName = shortName + ".";
            }
            return shortName;
        };

        function getUserFullName() {
            if (!_authenticated || !_identity) {
                return;
            }
            return _identity.first_name + ' ' + _identity.last_name;
        };

        function getUser() {
            if (!_authenticated || !_identity) {
                return;
            }
            var user = angular.copy(_identity);
            user.permissions = null;
            user.permissionSet = null;
            return user;
        };

        function getPrimaryTeam() {
            if (!_authenticated || !_identity) {
                return;
            }

            if (_identity.audiences && _identity.audiences.length > 0) {
                if (_identity.audiences.length == 1) {
                    return _identity.audiences[0]
                } else {
                    return _identity.audiences[1];
                }
            }
        };

        function isWorkspaceAdmin() {
            if (!_authenticated || !_identity) {
                return false;
            } else {
                var login = _identity.login;
                if (login == 'admin' || login.endsWith("@masterair.com")) {
                    return true;
                } else {
                    return false;
                }
            }
            return _identity.id;
        };

        function isAdmin() {
            if (!_authenticated || !_identity) {
                return false;
            } else {
                return _identity.permissionSet.length > 0;
            }
        };

        function getWorkspaceCode() {
            if (!_authenticated || !_identity) {
                return;
            } else {
                return _identity.workspace_info.code;
            }
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);
                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            User.getFullUser({
                    id: 'me'
                }).$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account;
                _authenticated = true;

                _identity.permissionSet = [];

                angular.forEach(account.permissions, function(permission) {
                    var objectName = permission.object_name;
                    var permissionName = permission.permission_name;

                    _identity.permissionSet.push(permissionName + "-" + objectName);
                });

                var login = _identity.login;
                if (angular.equals(login, "admin")) {
                    $rootScope.isWorkspaceAdmin = true;
                } else {
                    $rootScope.isWorkspaceAdmin = false;
                }

                PubNubService.init(_identity.id, _identity.messaging_config, _identity.channels, _identity.permissionSet);
                SessionConfigService.init(_identity.session_config);

                $rootScope.$broadcast('identityResolved', _identity);
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        };

        function isAuthenticated() {
            return _authenticated;
        };

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        };
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.services")
        .factory("PermissionService", PermissionService);

    /* @ngInject */
    function PermissionService($q, $http, Principal, Feature, $location) {
        var service = {
            hasPermission: hasPermission,
            hasAccess: hasAccess,
        };
        return service;

        function hasPermission(permission, transitionProperties) {
            var deferred = $q.defer();
            if ($location.path().startsWith("/deeplink/sessions")) {
                deferred.reject();
            } else if (permission.startsWith("feature")) {
                if (Feature.isActive(permission)) {
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            } else {
                Principal.identity().then(function (user) {
                    if (user && user.permissionSet.indexOf(permission) > -1) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                });
            }
            return deferred.promise;
        }

        function hasAccess(permission) {
            var user = Principal.getUserInfo();
            if (user && user.permissionSet.indexOf(permission) > -1) {
                return true;
            } else {
                return false;
            }
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Organization', Organization);


    /* @ngInject */
    function Organization($resource) {
        var resourceUrl = 'api/organizations/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'validateImportFile': {
                url: 'api/organizations/import/validate',
                method: 'GET',
            },
            'importOrganizations': {
                url: 'api/organizations/import',
                method: 'POST',
            },
            'getImportStatus': {
                url: 'api/system/job-streams/:id',
                method: 'GET'
            },
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Notification', Notification);

    /* @ngInject */
    function Notification($resource) {
        var resourceUrl = 'api/system/notifications/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'test': {
                url: resourceUrl + '/test',
                method: 'POST'
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer.services')
        .factory('NotificationHandleService', NotificationHandleService);

    /* @ngInject */
    function NotificationHandleService($mdDialog, $mdToast, $filter, $state, ToastService, toastConstants) {

        var service = {
            onNotification: onNotification
        };

        return service;

        function onNotification(message) {
            if (message.type == "instant_session_invite") {
                sessionInvite(message);
            } else if (message.type == "scheduled_session_invite") {
                sessionScheduleInvite(message);
            } else if (message.type == "group_session_invite") {
                groupSessionInvite(message)
            } else if (message.message.type == "MESSAGE_CREATED") {
                onReceiveMessage(message.message);
            } else if (message.message.type == "JOB") {
                jobMessageHandler(message.message);
            } else if (message.message.type == "TICKET") {
                ticketMessageHandler(message.message);
            }
        }


        function sessionScheduleInvite(message) {
            var sessionObj = JSON.parse(message.body);
            ToastService.displayToast($filter('translate')('notification.session.scheduled', { sessionNo: sessionObj.session_no }));
        }



        function sessionInvite(message) {
            if ($state.current.url == "/player/:session_no") {
                var sessionObj = JSON.parse(message.body);
                ToastService.displayToastWithAction($filter('triTranslate')('notification.session.joinInstantSession') + message.userInfo.firstName + " " + message.userInfo.lastName,
                    $filter('triTranslate')('entity.action.join'), 'md-accent', 3000);
            } else {
                $mdToast.show({
                    content: $filter('triTranslate')('notification.session.joinInstantSession') + message.userInfo.firstName + ' ' + message.userInfo.lastName,
                    hideDelay: 8000,
                    position: toastConstants.position,
                    controller: 'sessionNotifierController',
                    controllerAs: "vm",
                    templateUrl: 'modules/session/session-notifier.tmpl.html',
                    highlightClass: 'md-accent',
                    locals: {
                        notification: message
                    },
                });
            }
        }

        function groupSessionInvite(message) {
            if ($state.current.url == "/player/:session_no") {
                var sessionObj = JSON.parse(message.body);
                ToastService.displayToastWithAction($filter('triTranslate')('notification.session.joinGroupSession') + message.userInfo.firstName + " " + message.userInfo.lastName,
                    $filter('triTranslate')('entity.action.join'), 'md-accent', 3000);
            } else {
                $mdToast.show({
                    content: $filter('triTranslate')('notification.session.joinGroupSession') + message.userInfo.firstName + ' ' + message.userInfo.lastName,
                    hideDelay: 8000,
                    position: toastConstants.position,
                    controller: 'sessionNotifierController',
                    controllerAs: "vm",
                    templateUrl: 'modules/session/session-notifier.tmpl.html',
                    highlightClass: 'md-accent',
                    locals: {
                        notification: message
                    },
                });
            }
        }

        function onReceiveMessage(message) {
            $mdToast.show({
                hideDelay: 8000,
                position: toastConstants.position,
                controller: 'conversationMessageNotifier',
                controllerAs: "vm",
                templateUrl: 'modules/conversation/conversation-message-notifier.tmpl.html',
                highlightClass: 'md-accent',
                locals: {
                    notification: message
                },
            });
        }

        function jobMessageHandler(message) {
            var jobObj = JSON.parse(message.data.body);

            var alertMessage = jobObj.job_number + ' - ' + jobObj.airform_name;

            if (message.data.type == "new_job_assignment") {
                alertMessage = $filter('triTranslate')('notification.job.jobAssignedEvent') + jobObj.job_number + ' - ' + jobObj.airform_name;
            } else if (message.data.type == "updated_job_assignment") {
                alertMessage = $filter('triTranslate')('notification.job.jobUpdatedEvent') + jobObj.job_number + ' - ' + jobObj.airform_name;
            } else if (message.data.type == "aborted_job_assignment") {
                alertMessage = $filter('triTranslate')('notification.job.jobAbortedEvent') + jobObj.job_number + ' - ' + jobObj.airform_name;
            } else if (message.data.type == "completed_job_assignment") {
                alertMessage = $filter('triTranslate')('notification.job.jobCompletedEvent') + jobObj.job_number + ' - ' + jobObj.airform_name;
            } else if (message.data.type == "job_due_reminder") {
                alertMessage = $filter('triTranslate')('notification.job.jobDueReminderEvent') + jobObj.job_number + ' - ' + jobObj.airform_name;
            } else if (message.data.type == "notification_alert") {
                alertMessage = jobObj.job_number + ' - ' + jobObj.airform_name + ' : ' + jobObj.message;
            }
            if(message.data.type === "notification_alert") {
                ToastService.displayToastWithRenderHtml(alertMessage, 3000);
            } else {
                ToastService.displayToast(alertMessage, 3000);
            }
        }

        function ticketMessageHandler(message) {
            var ticketObj = JSON.parse(message.data.body);

            var alertMessage = ticketObj.ticket_number + ' - ' + ticketObj.ticket_template_name;

            if (message.data.type == "ticket_assigned") {
                alertMessage = $filter('triTranslate')('notification.ticket.ticketAssignedEvent') + ticketObj.ticket_number + ' - ' + ticketObj.ticket_template_name;
            } else if (message.data.type == "ticket_updated") {
                alertMessage = $filter('triTranslate')('notification.ticket.ticketUpdatedEvent') + ticketObj.ticket_number + ' - ' + ticketObj.ticket_template_name;
            } else if (message.data.type == "ticket_created") {
                alertMessage = $filter('triTranslate')('notification.ticket.ticketCreatedEvent') + ticketObj.ticket_number + ' - ' + ticketObj.ticket_template_name;
            } else if (message.data.type == "ticket_comment") {
                alertMessage = ticketObj.ticket_number + ' - ' + ticketObj.ticket_template_name + ' : ' + ticketObj.message;
            }
            ToastService.displayToast(alertMessage, 3000);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('JhiMetricsService', JhiMetricsService);


    /* @ngInject */
    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('metrics/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('MetaData', MetaData);

    /* @ngInject */
    function MetaData($resource) {
        var resourceUrl = 'api/metadata/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'getPermissions': {
                url: 'api/metadata/permissions',
                method: 'GET',
                isArray: true
            },
            'getPermissionMeta': {
                url: 'api/metadata/permission-meta',
                method: 'GET'
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'getDisplayOrder': {
                url: 'api/topics/settings',
                method: 'GET',
                isArray: true
            },
            'saveDisplayOrder': {
                url: 'api/topics/settings',
                method: 'PUT',
                isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Message', Message);


    /* @ngInject */
    function Message($resource) {
        var resourceUrl = 'api/messages/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                isArray: true
            },
            'getPinned': {
                url: "api/messages/pinned",
                method: 'GET',
                isArray: true
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'pin': {
                url: resourceUrl + '/pinned',
                method: 'POST'
            },
            'reaction': {
                url: resourceUrl + '/reaction',
                method: 'POST'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Media', Media);


    /* @ngInject */
    function Media($resource) {
        var resourceUrl = 'api/media/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'cloudupload': {
                url: 'api/media/cloudupload/:type',
                method: 'POST',
                isArray: false
            },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('LogsService', LogsService);

    /* @ngInject */    
    function LogsService ($resource) {
        var service = $resource('api/system/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('LoginService', LoginService);

    function LoginService() {
        var service = {
            open: open
        };

        return service;

        function open() {}
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Locale', Locale);

    /* @ngInject */
    function Locale ($resource) {
        var resourceUrl =  'api/system/locales/:id';

        return $resource(resourceUrl, {id:'@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer.services')
        .factory('LocalResourceService', LocalResourceService);

    /* @ngInject */
    function LocalResourceService($resource) {
        var resourceUrl = '/assets/samples/:fileName';

        return $resource(resourceUrl, { fileName: '@fileName' }, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('LensApp', LensApp);

    /* @ngInject */
    function LensApp($resource) {
        var resourceUrl = 'api/lens-apps/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Launcher', Launcher);

    /* @ngInject */
    function Launcher($resource) {
        var resourceUrl = 'api/launch/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'getAssignment': {
                method: 'GET'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Language', Language);

    /* @ngInject */
    function Language ($resource) {
        var resourceUrl =  'api/system/languages/:id';

        return $resource(resourceUrl, {id:'@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function () {
	'use strict';
	angular
		.module('atheer.services')
		.factory('JobFlow', JobFlow);

	/* @ngInject */
	function JobFlow($resource) {
		var resourceUrl = 'api/smartflow/';
		var airFormUrl = 'api/applets/authoring';
		var insightsUrl = 'api/smartflow/insights';
		var jobDetailUrl = 'api/jobs';
		var executionUrl = 'api/smartflow/insights/execution';
		var jobScope = 'api/jobWorkflowRegistry'

		return $resource(resourceUrl, {
			id: '@id'
		}, {
			'query': {
				url: insightsUrl,
				method: 'GET',
				isArray: true
			},
			'getMoleculesProperties': {
				url: resourceUrl + 'molecules',
				method: 'GET',
				isArray: true
			},
			'getDataModel': {
				url: resourceUrl + 'datamodels',
				method: 'GET',
				isArray: true
			},
			'getDataMapper': {
				url: resourceUrl + 'datamapper/attributes',
				method: 'GET',
				isArray: true
			},
			'getDatasets': {
				url: 'api/datasets',
				method: 'GET',
				isArray: true
			},
			'getDatasetColumns': {
				url: '/api/datasets/:id/columns',
				method: 'GET',
				isArray: true
			},
			'getObjectList': {
				url: resourceUrl + 'data/:objectType',
				method: 'GET',
				isArray: true
			},
			'getMetaData': {
				url: resourceUrl + 'metadata/:objectType',
				method: 'GET',
				isArray: true
			},
			'getDataModelById': {
				url: resourceUrl + 'datamodels/:id',
				method: 'GET'
			},
			'getAirForm': {
				url: airFormUrl + '/:id',
				method: 'GET'
			},
			'getJobDetail': {
				url: jobDetailUrl,
				method: 'GET',
				isArray: true
			},
			'getExecutionDetail': {
				url: executionUrl + '/:id',
				method: 'GET'
			},

			'updateJobScope': {
				url: jobScope,
				method: 'POST'
			},

			'getJobScope': {
				url: jobScope,
				method: 'GET',
				isArray: true
			}
		});
	}
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('JobStream', JobStream);

    /* @ngInject */
    function JobStream($resource) {
        var resourceUrl = 'api/system/job-streams/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.services')
        .factory('JhiLanguageService', JhiLanguageService);

    /* @ngInject */
    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('IntegrationApp', IntegrationApp);

    /* @ngInject */
    function IntegrationApp($resource) {

        var resourceUrl = 'api/integration/:app?code=:code';

        return $resource(resourceUrl, {
            code: '@code',
            app:'@app'
        },{
            'slack': {
                method: 'GET'
            },
            'udacity': {
                method: 'GET'
            },
            'salesforce':{
                method: 'GET'
            },
            'msftoffice':{
                method: 'GET'
            },
            'googleapp':{
                method: 'GET'
            },
            'googledrive':{
                method: 'GET'
            },
            'dropbox':{
                method: 'GET'
            },
            'box':{
                method: 'GET'
            },
            'onedrive':{
                method: 'GET'
            },
            'vimeo':{
                method: 'GET'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('Insight', Insight);
        
    /* @ngInject */
    function Insight($resource, $http, Workspace, Setting, Dashboard) {

        const advInsights = {
            provisioned: false,
            enabled: false,
            state: 'bingo',
            dataSyncTimestamp: null,
            apiKey: '',
            dashboards: []
        };

        function onSuccess(data, headers) {
			if(data && data.length > 0) {
                advInsights = data;
			}
		}

		function onError(error) {
			AlertService.error(error.data.message);
		}

        function onInsightSyncSuccess(data, headers) {
        }

        return {
            getInsightSettings: function () {
                Workspace.getInsightSettings().$promise.then(onSuccess, onError);
            },

            setInsightSettings: function () {
                Setting.setInsightSettings(advInsights).$promise.then(onSuccess, onError);
            },
            syncAllInsights: function() {
                Dashboard.syncAllInsights().$promise.then(onInsightSyncSuccess, onError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('Home', Home);
        
    /* @ngInject */
    function Home($resource, $http) {

        var resourceUrl = 'api/users/me/foryou?v2=true';

        return $resource(resourceUrl, {
        },{
            'query': {
                method: 'GET'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('JhiHealthService', JhiHealthService);
        
    /* @ngInject */
    function JhiHealthService ($rootScope, $http) {
        var service = {
            checkHealth: checkHealth
        };

        return service;

        function checkHealth () {
            return $http.get('health').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Guest', Guest);

    /* @ngInject */
    function Guest($http) {
        var env;
        var host = window.location.href.split('/')[2];
        var bearerToken = null;
        var userId = null;
        if(host.startsWith('localhost')){
            env = 'dev';
        } else {
            env = host.split('.')[2];
        }
        var parentDomain = host.split('.')[1]; 
        var service = {
            createGuestUser: createGuestUser,
            validateWorkspaceCode: validateWorkspaceCode,
            updateGuestUser: updateGuestUser,
            getSessionDetails: getSessionDetails,
            setBearerToken: setBearerToken,
            getBearerToken: getBearerToken,
            setGuestUserId: setGuestUserId,
            getGuestUserId: getGuestUserId
        };
        return service;

        function createGuestUser(data, workspace) {
            return $http.post('https://' + workspace + '.' + parentDomain + '.' + env + '/api/users/guest', data);
        };

        function validateWorkspaceCode(code, workspace) {
            return $http.get('https://' + workspace + '.' + parentDomain + '.'  + env + '/api/system/settings/workspace/info/code/' + code);
        };

        function updateGuestUser(userId, workspace, data) {
            return $http({
                method: 'POST',
                url: 'https://' + workspace + '.' + parentDomain + '.'  + env + '/api/users/guest/update/' + userId,
                data: data
            });
        };

        function getSessionDetails(userId, roomNo, workspace) {
            return $http({
                method: 'GET',
                url: 'https://' + workspace + '.' + parentDomain + '.' + env + '/api/sessions/guest/session/' + userId + '/' + roomNo
            });
        };

        function setBearerToken(token) {
            bearerToken = token;
        };

        function getBearerToken() {
            return bearerToken;
        };

        function setGuestUserId(id) {
            userId = id;
        };

        function getGuestUserId() {
            return userId;
        };
    }
})();;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Folder', Folder);

    /* @ngInject */
    function Folder($resource, DateUtils) {
        var resourceUrl = 'api/folders/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Filter', Filter);

    /* @ngInject */
    function Filter($resource) {
        var resourceUrl = 'api/filters/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Feed', Feed);

    /* @ngInject */    
    function Feed($resource) {
        var resourceUrl = 'api/feeds/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.services')
        .factory('Feature', Feature);

    /* @ngInject */
    function Feature(Principal) {
        var featureSettings = {};
        var accessPermissions = [];

        var service = {
            setFeatures: setFeatures,
            isActive: isActive,
            isAllActive: isAllActive,
            setDeviceFeaturePermissions: setDeviceFeaturePermissions,
            getCurrentDeviceAccessPermissions: getCurrentDeviceAccessPermissions
        };
        return service;

        function setFeatures(features) {
            angular.forEach(features, function (feature) {
                if (feature.category == 'features') {
                    angular.forEach(feature.fields, function (settingField) {
                        featureSettings['feature' + '_' + settingField.group_name + '_' + settingField.name] = settingField.value;
                    });
                }
            });
        }

        function isActive(featureName) {
            if (Principal.isWorkspaceAdmin()) {
                return true;
            } else {
                if (angular.isDefined(featureSettings[featureName]) && featureSettings[featureName] == 'true') {
                    return true;
                } else {
                    return false;
                }
            }
        }

        function isAllActive(features) {
            var active = true;
            for (var featureIndex in features) {
                if (!isActive(features[featureIndex])) {
                    active = false;
                };
            }
            return active;
        }

        function setDeviceFeaturePermissions(permissons) {
            accessPermissions = permissons;
        }

        function getCurrentDeviceAccessPermissions(device, user) {
            var currentPermissions = accessPermissions.filter(function (permssionSet) {
                return permssionSet.client === 'Web' && permssionSet.device === device && permssionSet.user === user

            });
            return currentPermissions[0].permissions;
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Experience', Experience);

    /* @ngInject */
    function Experience($resource, DateUtils) {
        var resourceUrl = 'api/experiences/';

        return $resource(resourceUrl, {
            id: '@id',
            userId: '@userId',
            conversationId: '@conversationId'
        }, {
            'getRatings': {
                url: resourceUrl + 'ratings',
                method: 'GET',
                isArray: true
            },
            'rate': {
                url: resourceUrl + 'ratings',
                method: 'POST'
            },
            'loginActivity': {
                url: resourceUrl + 'logins',
                method: 'POST'
            },
            'unrate': {
                method: 'DELETE',
                url: resourceUrl + 'ratings/:id'
            },
            'getLikes': {
                url: resourceUrl + 'reactions',
                method: 'GET',
                isArray: true
            },
            'like': {
                url: resourceUrl + 'reactions',
                method: 'POST'
            },
            'unlike': {
                method: 'DELETE',
                url: resourceUrl + 'reactions/:id'
            },
            'getView': {
                url: resourceUrl + 'views/:id',
                method: 'GET'
            },
            'getViews': {
                url: resourceUrl + 'views',
                method: 'GET',
                isArray: true
            },
            'getScans': {
                url: resourceUrl + 'scans',
                method: 'GET',
                isArray: true
            },
            'getTopicScans': {
                url: resourceUrl + 'topic-scans',
                method: 'GET',
                isArray: true
            },
            'markViewed': {
                url: resourceUrl + 'views',
                method: 'POST'
            },
            'updateViewed': {
                url: resourceUrl + 'views/:id',
                method: 'PUT'
            },
            'getShares': {
                url: resourceUrl + 'shares',
                method: 'GET',
                isArray: true
            },
            'share': {
                url: resourceUrl + 'shares',
                method: 'POST'
            },
            'updateShare': {
                url: resourceUrl + 'shares/:id',
                method: 'PUT'
            },
            'getBookmarks': {
                url: resourceUrl + 'bookmarks',
                method: 'GET',
                isArray: true
            },
            'bookmark': {
                url: resourceUrl + 'bookmarks',
                method: 'POST'
            },
            'updateBookmark': {
                url: resourceUrl + 'bookmarks/:id',
                method: 'PUT'
            },
            'getAssignment': {
                url: resourceUrl + 'assignments/:id',
                method: 'GET'
            },
            'getAssignments': {
                url: resourceUrl + 'assignments',
                method: 'GET',
                isArray: true
            },
            'assign': {
                url: resourceUrl + 'assignments',
                method: 'POST'
            },
            'bulkAssign': {
                url: resourceUrl + 'assignments/bulk',
                method: 'POST'
            },
            'bulkAssignRemove': {
                url: resourceUrl + 'assignments/bulk-remove',
                method: 'POST'
            },
            'updateAssignment': {
                url: resourceUrl + 'assignments/:id',
                method: 'PUT'
            },
            'deleteAssignment': {
                url: resourceUrl + 'assignments/:id',
                method: 'DELETE'
            },
            'getNotification': {
                url: resourceUrl + 'notifications/:id',
                method: 'GET'
            },
            'getNotifications': {
                url: resourceUrl + 'notifications',
                method: 'GET',
                isArray: true
            },
            'notification': {
                url: resourceUrl + 'notifications',
                method: 'POST'
            },
            'bulkNotification': {
                url: resourceUrl + 'notifications/bulk',
                method: 'POST'
            },
            'updateNotification': {
                url: resourceUrl + 'notifications/:id',
                method: 'PUT'
            },
            'deleteNotification': {
                url: resourceUrl + 'notifications/:id',
                method: 'DELETE'
            },
            'bulkShare': {
                url: resourceUrl + 'shares/bulk',
                method: 'POST'
            },
            'bulkUserFlowbots': {
                url: resourceUrl + 'workflows/bulk',
                method: 'POST'
            },
            'getCompletions': {
                url: resourceUrl + 'completions',
                method: 'GET',
                isArray: true
            },
            'complete': {
                url: resourceUrl + 'completions',
                method: 'POST'
            },
            'updateCompletion': {
                url: resourceUrl + 'completions/:id',
                method: 'PUT'
            },
            'getFlags': {
                url: resourceUrl + 'flags',
                method: 'GET',
                isArray: true
            },
            'raiseFlag': {
                url: resourceUrl + 'flags',
                method: 'POST'
            },
            'getProblems': {
                url: resourceUrl + 'problems',
                method: 'GET',
                isArray: true
            },
            'reportProblem': {
                url: resourceUrl + 'problems',
                method: 'POST'
            },
            'getFollows': {
                url: resourceUrl + 'follow',
                method: 'GET',
                isArray: true
            },
            'follow': {
                url: resourceUrl + 'follow',
                method: 'POST'
            },
            'unfollow': {
                method: 'DELETE',
                url: resourceUrl + 'follow/:id'
            },
            'getBadges': {
                url: resourceUrl + 'badges',
                method: 'GET',
                isArray: true
            },
            'assignBadge': {
                url: resourceUrl + 'badges',
                method: 'POST'
            },
            'updateBadge': {
                url: resourceUrl + 'badges/:id',
                method: 'PUT'
            },
            'deleteBadge': {
                url: resourceUrl + 'badges/:id',
                method: 'DELETE'
            },
            'getSecurityRoles': {
                url: resourceUrl + 'security-roles',
                method: 'GET',
                isArray: true
            },
            'assignSecurityRole': {
                url: resourceUrl + 'security-roles',
                method: 'POST'
            },
            'bulkSecurityRole': {
                url: resourceUrl + 'security-roles/bulk',
                method: 'POST',
                isArray: true
            },
            'updateSecurityRole': {
                url: resourceUrl + 'security-roles/:id',
                method: 'PUT'
            },
            'deleteSecurityRole': {
                url: resourceUrl + 'security-roles/:id',
                method: 'DELETE'
            },
            'getTeams': {
                url: resourceUrl + 'audiences',
                method: 'GET',
                isArray: true
            },
            'assignTeam': {
                url: resourceUrl + 'audiences',
                method: 'POST'
            },
            'updateTeam': {
                url: resourceUrl + 'audiences/:id',
                method: 'PUT'
            },
            'deleteTeam': {
                url: resourceUrl + 'audiences/:id',
                method: 'DELETE'
            },
            'bulkTeams': {
                url: resourceUrl + 'audiences/bulk',
                method: 'POST',
                isArray: true
            },
            'bulkTeamsRemove': {
                url: resourceUrl + 'audiences/bulk/remove',
                method: 'POST'
            },
            'createEvent': {
                url: resourceUrl + 'events',
                method: 'POST'
            },
            'updateEvent': {
                url: resourceUrl + 'events/:id',
                method: 'PUT'
            },
            'deleteEvent': {
                url: resourceUrl + 'events/:id',
                method: 'DELETE'
            },
            'getEvents': {
                url: resourceUrl + 'events',
                method: 'GET',
                isArray: true
            },
            'createResponse': {
                url: resourceUrl + "responses",
                method: 'POST'
            },
            'updateResponse': {
                url: resourceUrl + "responses/:id",
                method: 'PUT'
            },
            'getResponses': {
                url: resourceUrl + "responses",
                method: 'GET',
                isArray: true
            },
            'getFlowbots': {
                url: resourceUrl + 'workflows',
                method: 'GET',
                isArray: true
            },
            'getBoards': {
                url: '/api/users/me/boards',
                method: 'GET',
                isArray: true
            },
            'getPitches': {
                url: '/api/users/me/pitches',
                method: 'GET',
                isArray: true
            },
            'getActivityIds': {
                url: resourceUrl + 'activities/:id',
                method: 'GET',
                isArray: false
            },
            'getUsers': {
                url: resourceUrl + 'users',
                method: 'POST',
                isArray: true
            },
            'getOrganizations': {
                url: resourceUrl + 'organizations',
                method: 'POST',
                isArray: true
            },
            'sendOverdueReminder': {
                url: resourceUrl + 'overdue-reminder',
                method: 'POST',
                isArray: false
            },
            'createSessionActivity': {
                url: resourceUrl + 'session-activities',
                method: 'POST'
            },
            'updateSessionActivity': {
                url: resourceUrl + 'session-activities/:id',
                method: 'PUT'
            },
            'getSessionActivity': {
                url: resourceUrl + 'session-activities/:id',
                method: 'GET'
            },
            'getSessionActivities': {
                url: resourceUrl + 'session-activities',
                method: 'GET',
                isArray: true
            },
            'getSessionRatingAndComments': {
                url: resourceUrl + 'session-activities',
                method: 'GET',
                isArray: true
            },
            'getUnReadMessageCount': {
                url: resourceUrl + 'messages/unread/:id',
                method: 'GET',
                isArray: true
            },
            'getReadMessages': {
                url: resourceUrl + 'messages/user/:userId/conversation/:conversationId',
                method: 'POST'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('EmailLayout', EmailLayout);

    /* @ngInject */
    function EmailLayout($resource) {
        var resourceUrl = 'api/system/email-layouts/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('DeeplinkService', DeeplinkService);


    /* @ngInject */
    function DeeplinkService () {
        var content = {};
        var service = {
            getContentData: getContentData,
            setContentData: setContentData
        };

        return service;

        function getContentData () {
            return content;
        }

        function setContentData (data) {
            content = data
        }
    }
})();
;
(function () {
    "use strict";
    angular.module("atheer.services").factory("DataModel", DataModel);

    /* @ngInject */
    function DataModel($resource) {
        var resourceUrl = "/api/smartflow/datamodels/:id";

        return $resource(
            resourceUrl,
            {
                id: "@id",
            },
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                },
                save: {
                    method: "POST",
                },
                update: {
                    method: "PUT",
                },
                getContents: {
                    method: "GET",
                    url: resourceUrl,
                    isArray: true,
                    transformResponse: function (result) {
                        var resultData = angular.fromJson(result);
                        var returnArray = [];
                        angular.forEach(resultData, function (contentData) {
                            returnArray.push(contentData.content);
                        });
                        return returnArray;
                    },
                },
            }
        );
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Dashboard', Dashboard);

    /* @ngInject */
    function Dashboard($resource) {
        var resourceUrl = 'api/dashboards/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'insights': {
                url: 'api/insights',
                method: 'GET',
                isArray: true
            },
            'getDashboardInsights': {
                url: resourceUrl + '/insights',
                method: 'GET',
                isArray: true
            },
            'syncAllInsights': {
                url: 'api/sync-insights',
                method: 'GET'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Conversation', Conversation);


    /* @ngInject */
    function Conversation($resource) {
        var resourceUrl = 'api/conversations/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'invite': {
                url: 'api/conversations/:id/members',
                method: 'POST'
            },
            'leave': {
                url: resourceUrl + '/leave',
                method: 'POST'
            },
            'join': {
                url: 'api/conversations/:id/join',
                method: 'POST'
            },
            'pin': {
                url: resourceUrl + '/pin',
                method: 'POST'
            },
            'unpin': {
                url: resourceUrl + '/unpin',
                method: 'POST'
            },
            'archive': {
                url: 'api/conversations/:id/archive',
                method: 'POST'
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Content', Content);

    /* @ngInject */
    function Content($resource, $q, DateUtils) {
        var resourceUrl = 'api/contents/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (result) {
                    return transformResponse(result);
                }
            },
            'getConversationContents': {
                url: 'api/contents/conversation',
                method: 'GET',
                isArray: true
            },
            'getUnfilteredContents': {
                url: 'api/contents/unfiltered',
                method: 'GET',
                isArray: true
            },
            'save': {
                method: 'POST',
                transformResponse: function (result, headers, status) {
                    return (status === 201) ? transformResponse(result) : $q.reject(angular.fromJson(result));
                }
            },
            'update': {
                method: 'PUT',
                transformResponse: function (result, headers, status) {
                    return (status === 200) ? transformResponse(result) : $q.reject(angular.fromJson(result));
                }
            },
            'process': {
                url: 'api/contents/:id/process',
                method: 'PUT',
                transformResponse: function (result) {
                    return transformResponse(result);
                }
            },
            'convert': {
                url: 'api/contents/convert/:id',
                method: 'GET',
                isArray: true
            },
            'extract': {
                url: 'api/contents/extract',
                method: 'GET',
                isArray: false,
                params: {
                    url: null
                }
            },
            'oembed': {
                url: 'api/contents/oembed',
                method: 'GET',
                isArray: false,
                params: {
                    url: null
                }
            },
            'localContentShare': {
                url: 'api/contents/capture',
                method: 'POST',
                isArray: false
            },
            'processDocument': {
                url: 'api/contents/process/',
                method: 'POST',
                isArray: true
            }
        });

        function transformResponse(result) {

            result = angular.fromJson(result);

            if (result.data.available_from) {
                result.data.available_from = DateUtils.convertDateTimeFromServer(result.data.available_from);
            }

            if (result.data.discontinue_from) {
                result.data.discontinue_from = DateUtils.convertDateTimeFromServer(result.data.discontinue_from);
            }

            if (result.data.close_date) {
                result.data.close_date = DateUtils.convertDateTimeFromServer(result.data.close_date);
            }

            if (result.data.cards && result.data.type == 'smart_content') {
                angular.forEach(result.data.cards, function (card) {
                    if (card.data.available_from) {
                        card.data.available_from = DateUtils.convertDateTimeFromServer(card.data.available_from);
                    }

                    if (result.data.discontinue_from) {
                        card.data.discontinue_from = DateUtils.convertDateTimeFromServer(card.data.discontinue_from);
                    }
                });
            }
            return result;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('JhiConfigurationService', JhiConfigurationService);

    /* @ngInject */    
    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {

    angular
        .module('atheer.services')
        .service('CloudUpload', CloudUpload);

    /* @ngInject */
    function CloudUpload ($window) {
    	var fileStackConfig = JSON.parse(window.localStorage.getItem('_filestack'));
    	print(0, fileStackConfig);
    	fileStackConfig = sanitize(fileStackConfig)
    	print(1,fileStackConfig);
    	var filestackPicker = null;
    	try{
			
			if(fileStackConfig.domain == null){
				filestackPicker = filestack.init(fileStackConfig.apiKey);
				print(2, filestackPicker);
				return filestackPicker;
			}
			/*
				Right now copied the security options from filestack api doc.
				May need to get it from filestack team
			*/
			var security = {};

			var cname = {"cname": fileStackConfig.domain };
			// pre 1.0
			filestackPicker = filestack.init(fileStackConfig.apiKey, cname);
			print(3, filestackPicker);
			return filestackPicker;

    	}catch(e){
    		console.error('Error creating filestack with configuration =',fileStackConfig);
    		filestackPicker =  filestack.init(fileStackConfig.apiKey);
    		print(4, filestackPicker);
			return filestackPicker;
    	}

    	function sanitize(fileStackConfig){
    		var defaultFSConfig = {
				"domain":'filestack.atheer.dev',
				"apiKey":'AH9iFHtFCT4WGuoRCgbNBz'
			};
			if(fileStackConfig == null){
				return defaultFSConfig;
			}
			if(_.isUndefined(fileStackConfig.domain) || fileStackConfig.domain == ","){
				return defaultFSConfig;
			}
    		return fileStackConfig;
    	}
    	
    	function print(count, filestackPicker){
    		console.log(count,filestackPicker);
    	}
    	
    }


})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Category', Category);

    /* @ngInject */
    function Category($resource) {
        var resourceUrl = 'api/categories/:categoryId';

        return $resource(resourceUrl, {
            id: '@categoryId'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('BuildLanguages', BuildLanguages);

    /* @ngInject */
    function BuildLanguages ($cookies) {
        // Any changes in this array need to be made in `server/app.js`
        var availableBuildLanguages = [
            "de-DE",
            "el-GR",
            "en-GB",
            "es-CL",
            "fr-FR",
            "it-IT",
            "ja-JP",
            "pt-BR",
            "zh-TW",
            "zh-CN",
            'da_DK',
            'no_NO',
            'pl_PL',
            'ru_RU',
            'sv_SE',
            'tr_TR'
        ];

        var service = {
            getBuildLanguage: getBuildLanguage,
            getAvailableBuildLanguages: getAvailableBuildLanguages
        };
        return service;

        function getBuildLanguage() {
            var selectedBuildLanguage = "en-US";
            var locale = $cookies.get('NG_TRANSLATE_LANG_KEY');
            locale = locale.replace(/_/g, "-").replace(/"/g, "");
            availableBuildLanguages.find(function (buildLanguage) {
                if (buildLanguage.indexOf(locale) > -1) {
                    selectedBuildLanguage = buildLanguage;
                }
            });

            return selectedBuildLanguage;
        }

        function getAvailableBuildLanguages() {
            return availableBuildLanguages;
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Badge', Badge);


    /* @ngInject */
    function Badge($resource) {
        var resourceUrl = 'api/badges/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.services')
        .factory('Auth', Auth);

    /* @ngInject */
    function Auth($rootScope, $state, $q, $translate, Principal, AuthServerProvider, User, LoginService, PubNubService, $http, Setting, paginationConstants, toastConstants) {

        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordInit: resetPasswordInit,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordTemp: resetPasswordTemp,
            validateWorkspaceName: validateWorkspaceName,
            isPublicUser: isPublicUser
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return User.activate(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                if ($rootScope.toState.data && $rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $rootScope.redirected = true;
                        $rootScope.previousStateName = $rootScope.toState;
                        $rootScope.previousStateNameParams = $rootScope.toStateParams;

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied');
                        LoginService.open();
                    }
                }
            }
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                //to set pagination and toaster position we require this call
                Setting.getCompanySettings(function (data) {
                    angular.forEach(data[0].fields, function (field) {
                        if (field.name == 'default_page_size') {
                            paginationConstants.itemsPerPage = field.value;
                        } else if (field.name == 'default_toast_position') {
                            toastConstants.position = field.value.split("-").join(" ").toLowerCase();
                        }
                    });
                });
                Principal.identity(true)
                    .then(function (account) {
                        if (account != null) {
                            deferred.resolve(data);
                        } else {
                            deferred.reject();
                            return cb();
                        }
                    });
                return cb();
            }

            return deferred.promise;
        }


        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.logout(null);
            PubNubService.disconnect();
            // Reset state memory if not redirected
            if (!$rootScope.redirected) {
                $rootScope.previousStateName = undefined;
                $rootScope.previousStateNameParams = undefined;
            }
        }

        function resetPasswordInit(username, callback) {
            var cb = callback || angular.noop;

            var passwordInfo = {
                username: username
            };

            return User.passwordResetInit(passwordInfo, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;
            return User.passwordResetFinish(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordTemp(username, callback) {
            var cb = callback || angular.noop;

            var passwordInfo = {
                username: username
            };

            return User.passwordResetTemp(passwordInfo, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function validateWorkspaceName(workspace) {
            var host = window.location.href.split('/')[2];
            var env = host.startsWith('localhost') ? 'dev' : host.split('.')[2];
            var hostname = host.startsWith('localhost') ? 'atheer' : host.split('.')[1];
            return $http({
                url: 'https://app.' + hostname + '.' + env + '/api/system/settings/workspace/info/' + workspace,
                method: 'GET',
                transformResponse: function(data) {
                    return data
                }})
        }

        function isPublicUser() {
            return localStorage.getItem('Authorization') ? false : true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.services')
        .factory('AuthServerProvider', AuthServerProvider);

    /* @ngInject */
    function AuthServerProvider($http, $cookies, $q, $window, $location) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            logout: logout,
            getPublicUserToken: getPublicUserToken
        };

        return service;

        function getToken() {
            var loginToken = $cookies.get('LoginToken');

            if (loginToken != null) {
                $cookies.remove('LoginToken');
                localStorage.setItem('Authorization', loginToken);

            }
            else if ($location.search().activation_token != undefined) {
                var loginToken = $location.search().activation_token;
                if (loginToken != null) {
                    $location.search('activation_token', null)
                    localStorage.setItem('Authorization', loginToken);
                }
            }

            var jwtToken = localStorage.getItem('Authorization');
            return jwtToken;
        }

        function getPublicUserToken() {
            return $http.get('api/public-access/login').success(publicAuthenticationSuccess);

            function publicAuthenticationSuccess(data, status, headers) {
                sessionStorage.setItem('Authorization', data.id_token)
            }
        }



        function hasValidToken() {
            var token = this.getToken();
            if (token && !isTokenExpired(token)) {
                return true;
            } else {
                return false;
            }
        }

        function login(credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };

            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess(data, status, headers) {
                var bearerToken = headers('Authorization');
                if (bearerToken == null) {
                    bearerToken = headers('x-amzn-remapped-authorization');
                }

                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 11) === 'Bearer ath-') {
                    var jwt = bearerToken.slice(11, bearerToken.length);
                    localStorage.setItem('Authorization', jwt)
                    return jwt;
                };
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                localStorage.setItem('Authorization', jwt)
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }
            return deferred.promise;
        }

        function logout() {
            localStorage.removeItem('Authorization');
            sessionStorage.clear();
            var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
                $cookies.remove(k);
            });
        }

        function urlBase64Decode(str) {
            var output = str.replace(/-/g, '+').replace(/_/g, '/');
            switch (output.length % 4) {
                case 0:
                    {
                        break;
                    }
                case 2:
                    {
                        output += '==';
                        break;
                    }
                case 3:
                    {
                        output += '=';
                        break;
                    }
                default:
                    {
                        throw 'Illegal base64url string!';
                    }
            }
            return $window.decodeURIComponent(escape($window.atob(output))); //polyfill https://github.com/davidchambers/Base64.js
        };


        function decodeToken(token) {
            var parts = token.split('.');

            if (parts.length !== 3) {
                throw new Error('JWT must have 3 parts');
            }

            var decoded = urlBase64Decode(parts[1]);
            if (!decoded) {
                throw new Error('Cannot decode the token');
            }
            return angular.fromJson(decoded);
        };

        function getTokenExpirationDate(token) {
            var decoded = decodeToken(token);

            if (typeof decoded.exp === "undefined") {
                return null;
            }

            var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
            d.setUTCSeconds(decoded.exp);
            return d;
        };

        function isTokenExpired(token, offsetSeconds) {
            var d = getTokenExpirationDate(token);
            offsetSeconds = offsetSeconds || 0;
            if (d === null) {
                return false;
            }
            // Token expired?
            return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('AuditsService', AuditsService);

    /* @ngInject */
    function AuditsService($resource) {
        var service = $resource('api/system/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    fromDate: null,
                    toDate: null
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Audience', Audience);

    /* @ngInject */    
    function Audience($resource) {
        var resourceUrl = 'api/audiences/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getMemberHistory': {
                url: resourceUrl + '/history',
                method: 'GET',
                isArray: true
            },
            'getMemberCountHistory': {
                url: resourceUrl + '/count/history',
                method: 'GET',
                isArray: true
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('App', App);

    /* @ngInject */
    function App($resource) {
        var resourceUrl = 'api/system/apps/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByName': {
                url: 'api/system/apps/:id?name=true',
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Anchor', Anchor);

    /* @ngInject */
    function Anchor($resource) {
        var resourceUrl = 'api/airnotes/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('AirForm', AirForm);

    /* @ngInject */
    function AirForm($resource) {
        var resourceUrl = 'api/applets/authoring/:id';
        var activeAirformUrl = 'api/applets/authoring?';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'getActiveAirform': {
                method: 'GET',
                isArray: true,
                url: activeAirformUrl
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('AirformReport', AirformReport);

    /* @ngInject */
    function AirformReport($resource) {
        var resourceUrl = 'api/applets';

        return $resource(resourceUrl, {
            id: '@id'
        },{
            'getAirform': {
                url: resourceUrl + '/countByStatus',
                method: 'GET',
                isArray:true,
                params:{
                    daysFilter:'@daysFilter'
                }
            },
            'getAirformExecution': {
                url: resourceUrl + '/execution/countByStatus',
                method: 'GET',
                isArray:true,
                params:{
                    daysFilter:'@daysFilter'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core', [
            'ngMaterial',
            'ui.router',
            'ngIdle'
        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triWizard', TriWizard);

    /* @ngInject */
    function TriWizard() {
        // Usage: <div tri-wizard> (put some forms in here) </div>
        //
        // Creates: Nothing
        //
        var directive = {
            bindToController: true,
            controller: WizardController,
            controllerAs: 'triWizard',
            restrict: 'A'
        };
        return directive;
    }

    /* @ngInject */
    function WizardController($scope, $timeout) {
        var vm = this;

        var forms = [];
        var totalErrors = 0;
        var fixedErrors = 0;

        vm.currentStep = 0;
        vm.getForm = getForm;
        vm.isFormValid = isFormValid;
        vm.nextStep = nextStep;
        vm.nextStepDisabled = nextStepDisabled;
        vm.prevStep = prevStep;
        vm.prevStepDisabled = prevStepDisabled;
        vm.progress = 0;
        vm.registerForm = registerForm;
        vm.updateProgress = updateProgress;

        ////////////////

        function getForm(index) {
            return forms[index];
        }

        function nextStep() {
            vm.currentStep = vm.currentStep + 1;
        }

        function nextStepDisabled() {
            // get current active form
            var form = $scope.triWizard.getForm(vm.currentStep);
            var formInvalid = true;
            if(angular.isDefined(form) && angular.isDefined(form.$invalid)) {
                formInvalid = form.$invalid;
            }
            return formInvalid;
        }

        function isFormValid(step) {
            if(angular.isDefined(forms[step])) {
                return forms[step].$valid;
            }
        }

        function prevStep() {
            vm.currentStep = vm.currentStep - 1;
        }

        function prevStepDisabled() {
            return vm.currentStep === 0;
        }

        function registerForm(form) {
            forms.push(form);
        }

        function updateProgress() {
            var errors = calculateErrors();
            fixedErrors = totalErrors - errors;

            // calculate percentage process for completing the wizard
            vm.progress = Math.floor((fixedErrors / totalErrors) * 100);
        }

        function calculateErrors() {
            var errorCount = 0;
            for (var form = forms.length - 1; form >= 0; form--) {
                if(angular.isDefined(forms[form].$error)) {
                    for(var error in forms[form].$error) {
                        errorCount += forms[form].$error[error].length;
                    }
                }
            }
            return errorCount;
        }

        // init

        // wait until this tri wizard is ready (all forms registered)
        // then calculate the total errors
        $timeout(function() {
            totalErrors = calculateErrors();
        });
    }
})();;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triWizardForm', WizardFormProgress);

    /* @ngInject */
    function WizardFormProgress() {
        // Usage:
        //  <div tri-wizard>
        //      <form tri-wizard-form>
        //      </form>
        //  </div>
        //
        var directive = {
            require: ['form', '^triWizard'],
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, require) {
            var ngFormCtrl = require[0];
            var triWizardCtrl = require[1];

            // register this form with the parent triWizard directive
            triWizardCtrl.registerForm(ngFormCtrl);

            // watch for form input changes and update the wizard progress
            element.on('input', function() {
                triWizardCtrl.updateProgress();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triWidget', widget);

    /* @ngInject */
    function widget ($mdTheming) {
        // Usage:
        //
        // ```html
        // <widget title="'Nice Title'" subtitle="'Subtitle'" avatar="http://myavatar.jpg" title-position="top|bottom|left|right" content-padding overlay-title>content here</widget>
        // ```

        // Creates:
        //
        // Widget for use in dashboards
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/widget/widget.tmpl.html',
            transclude: true,
            replace: true,
            scope: {
                title: '@',
                subtitle: '@',
                avatar: '@'
            },
            bindToController: true,
            controller: Controller,
            controllerAs: 'vm',
            link: link
        };
        return directive;

        function link($scope, $element, attrs) {
            // set the value of the widget layout attribute
            $scope.vm.widgetLayout = attrs.titlePosition === 'left' || attrs.titlePosition === 'right' ? 'row' : 'column';
            // set the layout attribute for the widget content
            $scope.vm.contentLayout = angular.isUndefined(attrs.contentLayout) ? 'column' : attrs.contentLayout;
            // set if the layout-padding attribute will be added
            $scope.vm.contentPadding = angular.isDefined(attrs.contentPadding);
            // set the content align
            $scope.vm.contentLayoutAlign = angular.isUndefined(attrs.contentLayoutAlign) ? '' : attrs.contentLayoutAlign;
            // set the order of the title and content based on title position
            $scope.vm.titleOrder = attrs.titlePosition === 'right' || attrs.titlePosition === 'bottom' ? 2 : 1;
            $scope.vm.contentOrder = attrs.titlePosition === 'right' || attrs.titlePosition === 'bottom' ? 1 : 2;
            // set if we overlay the title on top of the widget content
            $scope.vm.overlayTitle = angular.isUndefined(attrs.overlayTitle) ? undefined : true;

            $mdTheming($element);

            if(angular.isDefined(attrs.class)) {
                $element.addClass(attrs.class);
            }

            if(angular.isDefined(attrs.backgroundImage)) {
                $element.css('background-image', 'url(' + attrs.backgroundImage + ')');
            }

            $scope.menuClick = function($event) {
                if(angular.isUndefined($scope.menu.menuClick)) {
                    $scope.menu.menuClick($event);
                }
            };

            // remove title attribute to stop popup on hover
            $element.attr('title', '');
        }
    }

    /* @ngInject */
    function Controller () {
        var vm = this;
        vm.menu = null;
        vm.loading = false;

        this.setMenu = function(menu) {
            vm.menu = menu;
        };

        this.setLoading = function(loading) {
            vm.loading = loading;
        };
    }
})();;
(function() {
    'use strict';

    angular
        .module('atheer')
        .filter('truncate', truncate);

    function truncate() {
        return truncate;

        function truncate(value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                    //Also remove . and , so its gives a cleaner result.
                    if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
                        lastspace = lastspace - 1;
                    }
                    value = value.substr(0, lastspace);
                }
            }
            return value + (tail || ' …');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .filter('readableTime', readableTime);

    function readableTime() {
        return readableTime;

        function readableTime(millisec) {
            if (millisec) {
                var seconds = millisec / 1000;
                var day, format, hour, minute, month, week, year;

                seconds = parseInt(seconds, 10);
                minute = 60;
                hour = minute * 60;
                day = hour * 24;
                week = day * 7;
                year = day * 365;
                month = year / 12;

                format = function(number, string) {
                    string = number === 1 ? string : string + "s";
                    return number + " " + string;
                };
                switch (false) {
                    case !(seconds < minute):
                        return format(seconds, 'second');
                    case !(seconds < hour):
                        return format(Math.floor(seconds / minute), 'minute');
                    case !(seconds < day):
                        return format(Math.floor(seconds / hour), 'hour');
                    case !(seconds < week):
                        return format(Math.floor(seconds / day), 'day');
                    case !(seconds < month):
                        return format(Math.floor(seconds / week), 'week');
                    case !(seconds < year):
                        return format(Math.floor(seconds / month), 'month');
                    default:
                        return format(Math.floor(seconds / year), 'year');
                }
            } else {
                return 0;
            }

        };
    }
})();
;
(function(){
    'use strict';

    angular
        .module('atheer')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .filter('numberToAlphabet', numberToAlphabet);

    function numberToAlphabet() {
        return numberToAlphabet;

        function numberToAlphabet (number) {
            return String.fromCharCode(number+97);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .filter('milisecondToTime', milisecondToTime);

    function milisecondToTime() {
        return getAvgTimespent;

        function getAvgTimespent(millisec) {
            if (millisec) {
                var seconds = (millisec / 1000).toFixed(0);
                var minutes = Math.floor(seconds / 60);
                var hours = "";
                if (minutes > 59) {
                    hours = Math.floor(minutes / 60);
                    hours = (hours >= 10) ? hours : "0" + hours;
                    minutes = minutes - (hours * 60);
                    minutes = (minutes >= 10) ? minutes : "0" + minutes;
                }

                seconds = Math.floor(seconds % 60);
                seconds = (seconds >= 10) ? seconds : "0" + seconds;
                if (hours != "") {
                    return hours + ":" + minutes + ":" + seconds;
                }
                return minutes + ":" + seconds;
            } else {
               return  "00:00";
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('DateUtils', DateUtils);

    /* @ngInject */
    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('DataUtils', DataUtils);

    /* @ngInject */
    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
/*global angular, navigator*/
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('clickOutside', [
            '$document', '$parse', '$timeout',
            clickOutside
        ]);

    function clickOutside($document, $parse, $timeout) {
        return {
            restrict: 'A',
            link: function($scope, elem, attr) {

                // postpone linking to next digest to allow for unique id generation
                $timeout(function() {
                    var classList = (attr.outsideIfNot !== undefined) ? attr.outsideIfNot.split(/[ ,]+/) : [],
                        fn;

                    function eventHandler(e) {
                        var i,
                            element,
                            r,
                            id,
                            classNames,
                            l;

                        // check if our element already hidden and abort if so
                        if (angular.element(elem).hasClass("ng-hide")) {
                            return;
                        }

                        // if there is no click target, no point going on
                        if (!e || !e.target) {
                            return;
                        }

                        // loop through the available elements, looking for classes in the class list that might match and so will eat
                        for (element = e.target; element; element = element.parentNode) {
                            // check if the element is the same element the directive is attached to and exit if so (props @CosticaPuntaru)
                            if (element === elem[0]) {
                                return;
                            }

                            // now we have done the initial checks, start gathering id's and classes
                            id = element.id,
                                classNames = element.className,
                                l = classList.length;

                            // Unwrap SVGAnimatedString classes
                            if (classNames && classNames.baseVal !== undefined) {
                                classNames = classNames.baseVal;
                            }

                            // if there are no class names on the element clicked, skip the check
                            if (classNames || id) {

                                // loop through the elements id's and classnames looking for exceptions
                                for (i = 0; i < l; i++) {
                                    //prepare regex for class word matching
                                    r = new RegExp('\\b' + classList[i] + '\\b');

                                    // check for exact matches on id's or classes, but only if they exist in the first place
                                    if ((id !== undefined && id === classList[i]) || (classNames && r.test(classNames))) {
                                        // now let's exit out as it is an element that has been defined as being ignored for clicking outside
                                        return;
                                    }
                                }
                            }
                        }

                        // if we have got this far, then we are good to go with processing the command passed in via the click-outside attribute
                        $timeout(function() {
                            fn = $parse(attr['clickOutside']);
                            fn($scope);
                        });
                    }

                    // if the devices has a touchscreen, listen for this event
                    if (_hasTouch()) {
                        $document.on('touchstart', eventHandler);
                    }

                    // still listen for the click event even if there is touch to cater for touchscreen laptops
                    $document.on('click', eventHandler);

                    // when the scope is destroyed, clean up the documents event handlers as we don't want it hanging around
                    $scope.$on('$destroy', function() {
                        if (_hasTouch()) {
                            $document.off('touchstart', eventHandler);
                        }

                        $document.off('click', eventHandler);
                    });

                    /**
                     * @description Private function to attempt to figure out if we are on a touch device
                     * @private
                     **/
                    function _hasTouch() {
                        // works on most browsers, IE10/11 and Surface
                        return 'ontouchstart' in window || navigator.maxTouchPoints;
                    };
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('atheer')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
            return output;
        }
    }
})();
;
/*
upgrated filestack to 3.x.x version.
There were 2 changes in this file to be made to make it work

CHANGE-1) the hideWhenUploading: false  , is not supported now IN UPLOAD OPTIONS
CHANGE-2) The pickER function CloudUpload.pick(pickOptions); NO LONGER SUPPORTED NOW
*/
(function () {
    'use strict';

    angular
        .module('atheer')
        .directive('fpUpload', fpUpload);

    function fpUpload() {
        var directive = {
            restrict: 'E',
            scope: {
                'fpNgModel': '=?',
                'fpMultiple': '@',
                'fpAcceptedType': '@',
                'fpMaxSize': '@',
                'fpContentType': '@',
                'fpEnablePreview': '=?',
                'fpPattern': '@',
                'fpAddModelFn': '&?',
                'fpRemoveModelFn': '&?',
                'fpUploadType': "@?",
                'fpSmartUploadLabel': "@?",
                'fpSmartUploadIcon': "@?",
                'fpSmartUploadBackground': "@?",
                "fpBindFullObj": '=?',
                "previewWidth": '@?',
                "fpAllowMediaSelection": '=?',
                "fpUploadStatus": "=?",
                "fpUploadSizeError": "=?",
                "fpUploadIconClass": "@?",
                "fpAllButtonColorClass": "@?",
                "fpPreviewImageClass": "@?",
                "fpSupportedFileTypes": "@",
                "fpProcessDocument": "@"
            },
            controller: uploadController,
            templateUrl: 'core/components/upload/upload.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function uploadController($scope, $timeout, $mdToast, $mdDialog, Upload, CloudUpload, Media, AlertService) {
        $scope.status = $scope.fpUploadStatus ? $scope.fpUploadStatus : 'idle';

        $scope.fpUploadIconClass = $scope.fpUploadIconClass ? $scope.fpUploadIconClass : 'fa fa-upload';
        $scope.fpAllButtonColorClass = $scope.fpAllButtonColorClass ? $scope.fpAllButtonColorClass : 'md-primary';
        $scope.fpPreviewImageClass = $scope.fpPreviewImageClass ? $scope.fpPreviewImageClass : '';

        $scope.upload = upload;
        $scope.removeImage = removeImage;
        $scope.showImage = showImage;
        $scope.uploadReset = uploadReset;
        $scope.getPreviewUrl = getPreviewUrl;
        $scope.getFileName = getFileName;
        $scope.removeFile = removeFile;
        $scope.downloadConfigFile = downloadConfigFile;
        $scope.updateState = updateState;
        $scope.isDocumentForAI = false;
        $scope.isChecked = false;
        $scope.documentTags = [];

        //***************************************
        //Following variables and code is for Media Picker
        //*****************************************

        $scope.openMediaSelector = openMediaSelector;

        function updateState() {
            $scope.isChecked = !$scope.isChecked;
            $scope.isDocumentForAI = $scope.isChecked;
        }

        function openMediaSelector(ev) {
            $mdDialog.show({
                templateUrl: 'modules/system/media/media.html',
                targetEvent: ev,
                controller: 'MediaController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                skipHide: true,
                locals: {
                    pagingParams: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'id,asc',
                            squash: true
                        },
                        search: null
                    },
                    isPickerView: true,
                    isMultiple: false
                }
            })
                .then(function (media) {
                    uploadComplete({
                        data: media
                    });
                });
        }

        //****************************************
        //following variables are for cloud upload
        //****************************************
        $scope.files = [];
        $scope.pickCloudFile = pickCloudFile;

        function upload(file) {
            if (file.length) {
                if (($scope.fpMaxSize === undefined && file[0].size < 1000000) || $scope.fpMaxSize) {
                    $scope.showUploadProgress = true;
                    $scope.status = 'uploading';
                    $scope.fpUploadStatus = 'uploading';
                    Upload.upload({
                        url: ($scope.fpContentType === 'file') ? 'api/homepage/upload' : 'api/media/upload',
                        data: {
                            'file': file,
                            'type': $scope.fpContentType
                        },
                        arrayKey: ''
                    }).then(function (resp) {
                        uploadComplete(resp);
                    }, function (resp) {
                        uploadError();
                    }, function (evt) {
                        uploadProgress(evt);
                    });
                } else {
                    uploadError();
                }
            }
        }

        function removeImage() {
            $scope.fpNgModel = null;
            execRemoveCallBack();
        }

        function removeFile() {
            $scope.fpNgModel = null;
            execRemoveCallBack();
        }

        function downloadConfigFile() {
            var downloadLink = document.createElement('a');
            downloadLink.href = 'media/documents/' + $scope.fpNgModel.split('|')[1] + '.json';
            downloadLink.download = getFileName();
            downloadLink.click();
        }

        function showImage() {
            return angular.isDefined($scope.fpNgModel) && $scope.fpNgModel !== "" && $scope.fpNgModel !== null;
        }

        function uploadReset() {
            $scope.status = 'idle';
            $scope.fpUploadStatus = 'idle';
        }

        function getPreviewUrl() {
            var previewUrl = '';
            if ($scope.showImage()) {
                previewUrl = $scope.fpNgModel.startsWith('http') ? $scope.fpNgModel : '/media/images/' + $scope.fpNgModel;
            }
            return previewUrl;
        }

        function getFileName() {
            var configFileName = '';
            if ($scope.showImage()) {
                configFileName = $scope.fpNgModel.split('|')[0];
            }
            return configFileName;
        }

        function pickCloudFile() {
            var maxFileSize = 2000000;

            if ($scope.fpMaxSize != null) {
                maxFileSize = $scope.fpMaxSize;
            };

            /*
              CHANGE-1: the hideWhenUploading: false  , is not supported now.
            */
            var pickOptions = {
                accept: getCloudUploadMimeTypes(),
                storeTo: {
                    location: "s3"
                },
                fromSources: cloudUploadServices(),
                startUploadingWhenMaxFilesReached: true,
                disableTransformer: true,
                maxSize: parseInt(maxFileSize),
                onFileUploadStarted: onCloudUploadStarted,
                onFileUploadFinished: onCloudUploadFinished,
                onFileUploadProgress: onCloudUploadProgress,
                onFileUploadFailed: onCloudUploadError,
                onClose: onCloudUploadClose
            };

            /*
              CHANGE-2) The pickER function CloudUpload.pick(pickOptions); 
              has been removed from the filestackPicker in 3.x.x version
              Instead we need to use CloudUpload.picker(pickOptions).open();
          */
            CloudUpload.picker(pickOptions).open();
        };

        //*********************************************************
        // Following are helper functions for cloud upload services
        //*********************************************************
        function getCloudUploadMimeTypes() {
            var mimeTypeArray = [];
            if($scope.isChecked) {
                mimeTypeArray.push("application/pdf")
            }
            else {
                angular.forEach($scope.fpPattern.split(','), function (mimeType) {
                    mimeTypeArray.push(mimeType);
                });
            }
            return mimeTypeArray;
        }

        function cloudUploadServices() {
            if ($scope.fpSmartUploadPattern == "image/*") {
                return ['local_file_system', 'googledrive', 'box', 'dropbox', 'clouddrive', 'onedrive', 'picasa', 'imagesearch'];
            } else {
                return ['local_file_system', 'googledrive', 'box', 'dropbox', 'clouddrive', 'onedrive'];
            }
        }

        function onCloudUploadClose() {
            $scope.status = 'idle';
            $scope.fpUploadStatus = 'idle';
        };

        function onCloudUploadStarted(file) {
            $scope.status = 'uploading';
            $scope.fpUploadStatus = 'uploading';
            $scope.showUploadProgress = false;
            $scope.$apply();
        };

        function onCloudUploadFinished(file) {
            $scope.status = 'complete';
            $scope.fpUploadStatus = 'complete';
            $scope.uploadPercentage = 0;

            var cloudUpload = (Array.isArray(file) ? file[0] : file);
            $scope.$apply();

            $timeout(function () {
                Media.cloudupload({
                    type: $scope.fpContentType
                }, cloudUpload, execCloudUploadCallBack, uploadError);
            }, 2000);
        };

        function onCloudUploadError(file, error) {
            $scope.status = 'error';
            $scope.fpUploadStatus = 'error';
            $scope.uploadPercentage = 0;
            $scope.$apply();
        };

        function onCloudUploadProgress(file, progressEvent) {
            $scope.showUploadProgress = true;
            $scope.uploadPercentage = progressEvent.totalPercent;
            $scope.$apply();
        };

        function execCloudUploadCallBack(response) {
            $scope.fpNgModel = $scope.fpBindFullObj ? response : response.cloud_url;
            if (angular.isDefined($scope.fpAddModelFn)) {
                var finalObj = {
                    mediaId: response.source_file_name,
                    responseObj: response
                };
                if ($scope.fpContentType === 'document') {
                    finalObj.isRequiredForProcessing = $scope.isDocumentForAI;
                    finalObj.documentTags = $scope.documentTags;
                }
                $scope.fpAddModelFn(finalObj);
            }
            uploadReset();
        }

        //*********************************************************
        // Following are helper functions for local upload services
        //*********************************************************
        function getLocalUploadMimeTypes() {
            return $scope.fpPattern.replace(",", "','");
        }

        function uploadComplete(resp) {
            $scope.status = 'complete';
            $scope.fpUploadStatus = 'complete';
            $scope.uploadPercentage = 0;
            $scope.fpNgModel = $scope.fpContentType === 'file' ? resp.data.source_file_name + '|' + resp.data.id : ($scope.fpBindFullObj ? resp.data : resp.data.properties.file_name);
            $scope.fpUploadSizeError = false;
            AlertService.clear();
            $timeout(function () {
                execAddCallBack(resp);
            }, 3000);
        }

        function uploadError(resp) {
            $scope.status = 'error';
            $scope.fpUploadStatus = 'error';
            $scope.fpUploadSizeError = true;
            $scope.uploadPercentage = 0;
            $timeout(function () {
                uploadReset();
            }, 3000);
        }

        function uploadProgress(evt) {
            $scope.fpUploadSizeError = false;
            $scope.uploadPercentage = parseInt(100.0 * evt.loaded / evt.total);
        }

        function execAddCallBack(resp) {
            if (angular.isDefined($scope.fpAddModelFn) && $scope.fpAddModelFn !== null) {
                $scope.fpAddModelFn({
                    mediaId: resp.data.properties.file_name,
                    responseObj: resp.data
                });
            }
            uploadReset();
        }

        function execRemoveCallBack() {
            if (angular.isDefined($scope.fpRemoveModelFn) && $scope.fpRemoveModelFn !== null) {
                $scope.fpRemoveModelFn();
            }
        }
    }
})();
;
(function() {
    'use strict';

    function createPath(startScope) {
        return function path() {
            var _path = [];
            var scope = startScope;
            var prevNode;
            while (scope && scope.node !== startScope.synteticRoot) {
                if (prevNode !== scope.node)
                    _path.push(scope.node);
                prevNode = scope.node;
                scope = scope.$parent;
            }
            return _path;
        };
    }

    function ensureDefault(obj, prop, value) {
        if (!obj.hasOwnProperty(prop))
            obj[prop] = value;
    }

    function defaultIsLeaf(node, $scope) {
        return !node[$scope.options.nodeChildren] || node[$scope.options.nodeChildren].length === 0;
    }

    function shallowCopy(src, dst) {
        if (angular.isArray(src)) {
            dst = dst || [];

            for (var i = 0; i < src.length; i++) {
                dst[i] = src[i];
            }
        } else if (angular.isObject(src)) {
            dst = dst || {};

            for (var key in src) {
                if (hasOwnProperty.call(src, key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
                    dst[key] = src[key];
                }
            }
        }

        return dst || src;
    }

    function defaultEquality(a, b, $scope) {
        if (!a || !b)
            return false;
        a = shallowCopy(a);
        a[$scope.options.nodeChildren] = [];
        b = shallowCopy(b);
        b[$scope.options.nodeChildren] = [];
        return angular.equals(a, b);
    }

    function defaultIsSelectable() {
        return true;
    }

    function ensureAllDefaultOptions($scope) {
        ensureDefault($scope.options, "multiSelection", false);
        ensureDefault($scope.options, "nodeChildren", "children");
        ensureDefault($scope.options, "dirSelectable", "true");
        ensureDefault($scope.options, "injectClasses", {});
        ensureDefault($scope.options.injectClasses, "ul", "");
        ensureDefault($scope.options.injectClasses, "li", "");
        ensureDefault($scope.options.injectClasses, "liSelected", "");
        ensureDefault($scope.options.injectClasses, "iExpanded", "");
        ensureDefault($scope.options.injectClasses, "iCollapsed", "");
        ensureDefault($scope.options.injectClasses, "iLeaf", "");
        ensureDefault($scope.options.injectClasses, "label", "");
        ensureDefault($scope.options.injectClasses, "labelSelected", "");
        ensureDefault($scope.options, "equality", defaultEquality);
        ensureDefault($scope.options, "isLeaf", defaultIsLeaf);
        ensureDefault($scope.options, "allowDeselect", true);
        ensureDefault($scope.options, "isSelectable", defaultIsSelectable);
    }

    angular.module('atheer.core')
        .constant('treeConfig', {
            templateUrl: null
        })
        .directive('treecontrol', ['$compile', function($compile) {
            /**
             * @param cssClass - the css class
             * @param addClassProperty - should we wrap the class name with class=""
             */
            function classIfDefined(cssClass, addClassProperty) {
                if (cssClass) {
                    if (addClassProperty)
                        return 'class="' + cssClass + '"';
                    else
                        return cssClass;
                } else
                    return "";
            }

            return {
                restrict: 'EA',
                require: "treecontrol",
                transclude: true,
                scope: {
                    treeModel: "=",
                    selectedNode: "=?",
                    selectedNodes: "=?",
                    expandedNodes: "=?",
                    onSelection: "&?",
                    onNodeToggle: "&?",
                    onRightClick: "&?",
                    menuId: "@",
                    options: "=?",
                    orderBy: "=?",
                    reverseOrder: "@",
                    filterExpression: "=?",
                    filterComparator: "=?"
                },
                controller: ['$scope', '$templateCache', '$interpolate', 'treeConfig', function($scope, $templateCache, $interpolate, treeConfig) {

                    $scope.options = $scope.options || {};

                    ensureAllDefaultOptions($scope);

                    $scope.selectedNodes = $scope.selectedNodes || [];
                    $scope.expandedNodes = $scope.expandedNodes || [];
                    $scope.expandedNodesMap = {};
                    for (var i = 0; i < $scope.expandedNodes.length; i++) {
                        $scope.expandedNodesMap["a" + i] = $scope.expandedNodes[i];
                    }
                    $scope.parentScopeOfTree = $scope.$parent;


                    function isSelectedNode(node) {
                        if (!$scope.options.multiSelection && ($scope.options.equality(node, $scope.selectedNode, $scope)))
                            return true;
                        else if ($scope.options.multiSelection && $scope.selectedNodes) {
                            for (var i = 0;
                                (i < $scope.selectedNodes.length); i++) {
                                if ($scope.options.equality(node, $scope.selectedNodes[i], $scope)) {
                                    return true;
                                }
                            }
                            return false;
                        }
                    }

                    $scope.headClass = function(node) {
                        var liClass = $scope.options.injectClasses.li;

                        if (typeof liClass === "function") {
                            liClass = liClass(node);
                        }

                        var additionalClasses = " " + classIfDefined(liClass, false);

                        var liSelectionClass = classIfDefined($scope.options.injectClasses.liSelected, false);

                        if (liSelectionClass && isSelectedNode(node)) {
                            additionalClasses += " " + liSelectionClass;
                        }

                        if ($scope.options.isLeaf(node, $scope)) {
                            return "tree-leaf" + additionalClasses;
                        }

                        if ($scope.expandedNodesMap[this.$id]) {
                            return "tree-expanded" + additionalClasses;
                        }

                        return "tree-collapsed" + additionalClasses;
                    };

                    $scope.iBranchClass = function() {
                        if ($scope.expandedNodesMap[this.$id])
                            return "open";
                        else
                            return "";
                    };

                    $scope.nodeExpanded = function() {
                        return !!$scope.expandedNodesMap[this.$id];
                    };

                    $scope.selectNodeHead = function() {
                        var transcludedScope = this;
                        var expanding = $scope.expandedNodesMap[transcludedScope.$id] === undefined;
                        $scope.expandedNodesMap[transcludedScope.$id] = (expanding ? transcludedScope.node : undefined);
                        if (expanding) {
                            $scope.expandedNodes.push(transcludedScope.node);
                        } else {
                            var index;
                            for (var i = 0;
                                (i < $scope.expandedNodes.length) && !index; i++) {
                                if ($scope.options.equality($scope.expandedNodes[i], transcludedScope.node, $scope)) {
                                    index = i;
                                }
                            }
                            if (index !== undefined)
                                $scope.expandedNodes.splice(index, 1);
                        }
                        if ($scope.onNodeToggle) {
                            var parentNode = (transcludedScope.$parent.node === transcludedScope.synteticRoot) ? null : transcludedScope.$parent.node;
                            var path = createPath(transcludedScope);
                            $scope.onNodeToggle({
                                node: transcludedScope.node,
                                $parentNode: parentNode,
                                $path: path,
                                $index: transcludedScope.$index,
                                $first: transcludedScope.$first,
                                $middle: transcludedScope.$middle,
                                $last: transcludedScope.$last,
                                $odd: transcludedScope.$odd,
                                $even: transcludedScope.$even,
                                expanded: expanding
                            });

                        }
                    };

                    $scope.selectNodeLabel = function(selectedNode) {
                        var transcludedScope = this;
                        if (!$scope.options.isLeaf(selectedNode, $scope) && (!$scope.options.dirSelectable || !$scope.options.isSelectable(selectedNode))) {
                            // Branch node is not selectable, expand
                            this.selectNodeHead();
                        } else if ($scope.options.isLeaf(selectedNode, $scope) && (!$scope.options.isSelectable(selectedNode))) {
                            // Leaf node is not selectable
                            return;
                        } else {
                            var selected = false;
                            if ($scope.options.multiSelection) {
                                var pos = -1;
                                for (var i = 0; i < $scope.selectedNodes.length; i++) {
                                    if ($scope.options.equality(selectedNode, $scope.selectedNodes[i], $scope)) {
                                        pos = i;
                                        break;
                                    }
                                }
                                if (pos === -1) {
                                    $scope.selectedNodes.push(selectedNode);
                                    selected = true;
                                } else {
                                    $scope.selectedNodes.splice(pos, 1);
                                }
                            } else {
                                if (!$scope.options.equality(selectedNode, $scope.selectedNode, $scope)) {
                                    $scope.selectedNode = selectedNode;
                                    selected = true;
                                } else {
                                    if ($scope.options.allowDeselect) {
                                        $scope.selectedNode = undefined;
                                    } else {
                                        $scope.selectedNode = selectedNode;
                                        selected = true;
                                    }
                                }
                            }
                            if ($scope.onSelection) {
                                var parentNode = (transcludedScope.$parent.node === transcludedScope.synteticRoot) ? null : transcludedScope.$parent.node;
                                var path = createPath(transcludedScope);
                                $scope.onSelection({
                                    node: selectedNode,
                                    selected: selected,
                                    $parentNode: parentNode,
                                    $path: path,
                                    $index: transcludedScope.$index,
                                    $first: transcludedScope.$first,
                                    $middle: transcludedScope.$middle,
                                    $last: transcludedScope.$last,
                                    $odd: transcludedScope.$odd,
                                    $even: transcludedScope.$even
                                });
                            }
                        }
                    };

                    $scope.rightClickNodeLabel = function(targetNode, $event) {

                        // Is there a right click function??
                        if ($scope.onRightClick) {

                            // Turn off the browser default context-menu
                            if ($event)
                                $event.preventDefault();

                            // Are are we changing the 'selected' node (as well)?
                            if ($scope.selectedNode != targetNode) {
                                this.selectNodeLabel(targetNode);
                            }

                            // Finally go do what they asked
                            $scope.onRightClick({
                                node: targetNode
                            });
                        }
                    };

                    $scope.selectedClass = function() {
                        var isThisNodeSelected = isSelectedNode(this.node);
                        var labelSelectionClass = classIfDefined($scope.options.injectClasses.labelSelected, false);
                        var injectSelectionClass = "";
                        if (labelSelectionClass && isThisNodeSelected)
                            injectSelectionClass = " " + labelSelectionClass;

                        return isThisNodeSelected ? "tree-selected" + injectSelectionClass : "";
                    };

                    $scope.unselectableClass = function() {
                        var isThisNodeUnselectable = !$scope.options.isSelectable(this.node);
                        var labelUnselectableClass = classIfDefined($scope.options.injectClasses.labelUnselectable, false);
                        return isThisNodeUnselectable ? "tree-unselectable " + labelUnselectableClass : "";
                    };

                    //tree template
                    var rcLabel = $scope.onRightClick ? ' tree-right-click="rightClickNodeLabel(node)"' : '';
                    var ctxMenuId = $scope.menuId ? ' context-menu-id="' + $scope.menuId + '"' : '';

                    $scope.isReverse = function() {
                        return !($scope.reverseOrder === 'false' || $scope.reverseOrder === 'False' || $scope.reverseOrder === '' || $scope.reverseOrder === false);
                    };

                    $scope.orderByFunc = function() {
                        return $scope.orderBy;
                    };

                    var templateOptions = {
                        orderBy: $scope.orderBy ? " | orderBy:orderByFunc():isReverse()" : '',
                        ulClass: classIfDefined($scope.options.injectClasses.ul, true),
                        nodeChildren: $scope.options.nodeChildren,
                        iLeafClass: classIfDefined($scope.options.injectClasses.iLeaf, false),
                        labelClass: classIfDefined($scope.options.injectClasses.label, false)
                    };

                    var template;
                    var templateUrl = $scope.options.templateUrl || treeConfig.templateUrl;

                    if (templateUrl) {
                        template = $templateCache.get(templateUrl);
                    }

                    if (!template) {
                        template =
                            '<ul {{options.ulClass}}>' +
                            '<li ng-repeat="node in node.{{options.nodeChildren}} | filter:filterExpression:filterComparator {{options.orderBy}}" ng-class="headClass(node)"' + 'set-node-to-data>' +
                            '<div ng-class="[selectedClass(), unselectableClass()]" >' +
                            '<md-icon class="tree-node-toggle-icon md-font material-icons zmdi zmdi-caret-right" ng-class="iBranchClass()" aria-hidden="false" style="" ng-click="selectNodeHead(node)"></md-icon>' +
                            '<div class="tree-label md-subhead {{options.labelClass}}" ng-click="selectNodeLabel(node)" ' + rcLabel + ctxMenuId + ' tree-transclude></div>' +
                            '</div>' +
                            '<treeitem ng-if="nodeExpanded()"></treeitem>' +
                            '</li>' +
                            '</ul>';
                    }



                    this.template = $compile($interpolate(template)({
                        options: templateOptions
                    }));
                }],
                compile: function(element, attrs, childTranscludeFn) {
                    return function(scope, element, attrs, treemodelCntr) {

                        scope.$watch("treeModel", function updateNodeOnRootScope(newValue) {
                            if (angular.isArray(newValue)) {
                                if (angular.isDefined(scope.node) && angular.equals(scope.node[scope.options.nodeChildren], newValue))
                                    return;
                                scope.node = {};
                                scope.synteticRoot = scope.node;
                                scope.node[scope.options.nodeChildren] = newValue;
                            } else {
                                if (angular.equals(scope.node, newValue))
                                    return;
                                scope.node = newValue;
                            }
                        });

                        scope.$watchCollection('expandedNodes', function(newValue, oldValue) {
                            var notFoundIds = 0;
                            var newExpandedNodesMap = {};
                            var $liElements = element.find('li');
                            var existingScopes = [];
                            // find all nodes visible on the tree and the scope $id of the scopes including them
                            angular.forEach($liElements, function(liElement) {
                                var $liElement = angular.element(liElement);
                                var liScope = {
                                    $id: $liElement.data('scope-id'),
                                    node: $liElement.data('node')
                                };
                                existingScopes.push(liScope);
                            });
                            // iterate over the newValue, the new expanded nodes, and for each find it in the existingNodesAndScopes
                            // if found, add the mapping $id -> node into newExpandedNodesMap
                            // if not found, add the mapping num -> node into newExpandedNodesMap
                            angular.forEach(newValue, function(newExNode) {
                                var found = false;
                                for (var i = 0;
                                    (i < existingScopes.length) && !found; i++) {
                                    var existingScope = existingScopes[i];
                                    if (scope.options.equality(newExNode, existingScope.node, scope)) {
                                        newExpandedNodesMap[existingScope.$id] = existingScope.node;
                                        found = true;
                                    }
                                }
                                if (!found)
                                    newExpandedNodesMap['a' + notFoundIds++] = newExNode;
                            });
                            scope.expandedNodesMap = newExpandedNodesMap;
                        });

                        //Rendering template for a root node
                        treemodelCntr.template(scope, function(clone) {
                            element.html('').append(clone);
                        });
                        // save the transclude function from compile (which is not bound to a scope as apposed to the one from link)
                        // we can fix this to work with the link transclude function with angular 1.2.6. as for angular 1.2.0 we need
                        // to keep using the compile function
                        scope.$treeTransclude = childTranscludeFn;
                    };
                }
            };
        }])
        .directive("setNodeToData", ['$parse', function($parse) {
            return {
                restrict: 'A',
                link: function($scope, $element, $attrs) {
                    $element.data('node', $scope.node);
                    $element.data('scope-id', $scope.$id);
                }
            };
        }])
        .directive('treeRightClick', ['$parse', function($parse) {
            return function(scope, element, attrs) {
                var fn = $parse(attrs.treeRightClick);
                element.bind('contextmenu', function(event) {
                    scope.$apply(function() {
                        fn(scope, {
                            $event: event
                        });
                    });
                });
            };
        }])
        .directive("treeitem", function() {
            return {
                restrict: 'E',
                require: "^treecontrol",
                link: function(scope, element, attrs, treemodelCntr) {
                    // Rendering template for the current node
                    treemodelCntr.template(scope, function(clone) {
                        element.html('').append(clone);
                    });
                }
            };
        })
        .directive("treeTransclude", function() {
            return {
                controller: ['$scope', function($scope) {
                    ensureAllDefaultOptions($scope);
                }],

                link: function(scope, element, attrs, controller) {
                    if (!scope.options.isLeaf(scope.node, scope)) {
                        angular.forEach(scope.expandedNodesMap, function(node, id) {
                            if (scope.options.equality(node, scope.node, scope)) {
                                scope.expandedNodesMap[scope.$id] = scope.node;
                                scope.expandedNodesMap[id] = undefined;
                            }
                        });
                    }
                    if (!scope.options.multiSelection && scope.options.equality(scope.node, scope.selectedNode, scope)) {
                        scope.selectedNode = scope.node;
                    } else if (scope.options.multiSelection) {
                        var newSelectedNodes = [];
                        for (var i = 0;
                            (i < scope.selectedNodes.length); i++) {
                            if (scope.options.equality(scope.node, scope.selectedNodes[i], scope)) {
                                newSelectedNodes.push(scope.node);
                            }
                        }
                        scope.selectedNodes = newSelectedNodes;
                    }

                    // create a scope for the transclusion, whos parent is the parent of the tree control
                    scope.transcludeScope = scope.parentScopeOfTree.$new();
                    scope.transcludeScope.node = scope.node;
                    scope.transcludeScope.$path = createPath(scope);
                    scope.transcludeScope.$parentNode = (scope.$parent.node === scope.synteticRoot) ? null : scope.$parent.node;
                    scope.transcludeScope.$index = scope.$index;
                    scope.transcludeScope.$first = scope.$first;
                    scope.transcludeScope.$middle = scope.$middle;
                    scope.transcludeScope.$last = scope.$last;
                    scope.transcludeScope.$odd = scope.$odd;
                    scope.transcludeScope.$even = scope.$even;
                    scope.$on('$destroy', function() {
                        scope.transcludeScope.$destroy();
                    });

                    scope.$treeTransclude(scope.transcludeScope, function(clone) {
                        element.empty();
                        element.append(clone);
                    });
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('fpTooltip', fpTooltip);

    /* @ngInject */
    function fpTooltip($compile, $mdUtil, $interpolate, $timeout) {
        return {
            restrict: 'E',
            scope: {
                options: '<',
                placement: '@',
                class: '@'
            },
            link: function($scope, element, attrs) {

                var parent = element.parent();
                var defaultOptions = {
                    arrow: true,
                    delay: 100,
                    placement: 'bottom',
                    touch: false,
                    onShow: function (instance){
                        if($scope.class) {
                            instance.popper.classList.add($scope.class);
                        }
                        instance.setContent($interpolate(element.text())($scope));
                    }
                };

                if ($scope.placement) {
                    defaultOptions.placement = $scope.placement;
                } else {
                    defaultOptions.placement = 'bottom'
                };

                $scope.$watch('options', function(options) {
                    var tippyOptions = defaultOptions;

                    if (options) {
                        angular.merge(tippyOptions, defaultOptions, options);
                    }

                    var id = parent.attr('id');
                    if (id == undefined || id == null || id.length <= 0) {
                        id = 'id-' + $mdUtil.nextUid();
                        parent.attr("id", id);
                    };

                    $timeout(function() {
                        tippyOptions.content = $interpolate(element.text())($scope);
                        tippy('#' + id, tippyOptions);
                        element.remove();
                    }, 0);
                });
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.core')
        .controller('ToolbarController', DefaultToolbarController);

    /* @ngInject */
    function DefaultToolbarController($scope, $injector, $rootScope, $mdMedia, $window, $state, $stateParams, $element, $filter, $mdUtil, $mdSidenav, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, Auth, Principal, Feature, triMenu, ToastService, $location) {
        var vm = this;
        //vm.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        //vm.emailNew = false;
        vm.languages = triSettings.languages;
        vm.openSideNav = openSideNav;
        vm.hideMenuButton = hideMenuButton;
        vm.switchLanguage = switchLanguage;
        vm.toggleNotificationsSideNav = toggleNotificationsSideNav;
        vm.helpOpened = false;
        vm.isFullScreen = false;
        vm.fullScreenIcon = 'zmdi zmdi-fullscreen';
        vm.toggleFullScreen = toggleFullScreen;
        vm.toggleToolBarMenu = toggleToolBarMenu;
        vm.logout = logout;
        vm.search = search;
        vm.isActiveMenu = isActiveMenu;
        vm.hasMenuPermission = hasMenuPermission;
        vm.isFeatureActive = isFeatureActive;
        vm.getSelectecNavBarMenu = getSelectecNavBarMenu;
        vm.selectedMenu = triMenu.getMenu($state.current.name);
        vm.toolBarTitle;
        vm.isTabMenu = triMenu.isTabMenu($state.current.name);
        vm.selectedNavBarMenu = getSelectecNavBarMenu();
        vm.showToolbarFromParam = angular.isDefined($stateParams.showToolbar) ? $stateParams.showToolbar : true;
        vm.selectedTabIndex = triMenu.getIndex($state.current.name);
        vm.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        vm.pictureUrl = null;
        vm.showHelp = showHelp;

        vm.sidebarInfo = {
            appName: triSettings.name,
            appLogoBig: triSettings.getLogoBig(),
            appLogoSmall: triSettings.getLogoSmall(),
            logoRight: triSettings.getSkinModel().logo_right
        };

        if (!$location.path().startsWith('/deeplink/sessions')) {
            Principal.identity().then(function (user) {
                setUserInfo(user);
            });
        }

        vm.searchText = $state.params.searchText;

        vm.permissions = {
            createContent: 'create-content'
        };

        //vm.sizes = [
        //    "All Content",
        //    "Topics",
        //    "My Uploads",
        //    "My Boards"
        //];

        //calls when hit menu on sidebar to open sub menus in side bar
        $rootScope.$on('toggleLeftHandMenu', function (event, item, open) {
            vm.selectedMenu = item;
            vm.toolBarTitle = item.name;
            if (item.type == 'tab') {
                vm.isTabMenu = true;
            } else {
                vm.isTabMenu = false;
            }
            vm.selectedNavBarMenu = getSelectecNavBarMenu();
        });

        //calls when hit menu on sidebar to open sub menus in side bar
        $rootScope.$on('toggleToolBarMenu', function (event, item) {
            vm.selectedMenu = null;
            vm.toolBarTitle = item;
            vm.isTabMenu = false;
            vm.selectedNavBarMenu = getSelectecNavBarMenu();
        });

        //calls when hit menu on sidebar to open sub menus in side bar
        $rootScope.$on('updateUserInfo', function (event, user) {
            setUserInfo(user);
        });

        function isActiveMenu(tabName) {
            return $state.includes(tabName);
        }

        function getSelectecNavBarMenu() {
            return null;
        }

        function setUserInfo(user) {
            vm.currentUser = {
                displayName: user.first_name,
                userName: user.first_name,
                avatar: 'assets/images/avatars/user-avatar.png',
                id: user.id
            };
            vm.user = user;
            vm.pictureUrl = vm.user.picture_id ? '/media/pictures/' + vm.user.picture_id : 'assets/images/avatars/user-avatar.png';
        }

        function openSideNav(navID) {
            $mdSidenav(navID).toggle();
        }

        function logout() {
            Auth.logout();
            $state.go('account.signout');
        }

        function toggleToolBarMenu(toolbarMenu) {
            $rootScope.$emit('toggleToolBarMenu', toolbarMenu);
        }

        function switchLanguage(languageCode) {
            if ($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                    .then(function () {
                        ToastService.displayToast($filter('triTranslate')('Language Changed'), 500)
                        $rootScope.$emit('changeTitle');
                    });
            }
        }

        function hideMenuButton() {
            switch (triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-sm');
            }
        }

        function toggleNotificationsSideNav(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            vm.openSideNav('notifications');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit' : 'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }

        //$scope.$on('newMailNotification', function(){
        //    vm.emailNew = true;
        //});
        function search() {
            vm.selectedNavBarMenu = null;
            $state.go('storm.search', {
                query: vm.searchText
            });
        }

        function hasMenuPermission(menuItem) {
            var hasPermission = true;
            if (angular.isDefined(menuItem.permission)) {
                if (menuItem.permission.constructor === Array) {
                    angular.forEach(menuItem.permission, function (permission) {
                        if (hasPermission) {
                            if (angular.isDefined(vm.user) && vm.user.permissionSet.indexOf(permission) > -1) {
                                hasPermission = true;
                            } else {
                                hasPermission = false;
                            }
                        }
                    });
                } else {
                    if (angular.isDefined(vm.user) && vm.user.permissionSet.indexOf(menuItem.permission) > -1) {
                        hasPermission = true;
                    } else {
                        hasPermission = false;
                    }
                }
            }
            return hasPermission;
        }

        function isFeatureActive(menuItem) {
            var isActive = true;
            if (angular.isDefined(menuItem.feature)) {
                if (menuItem.feature.constructor === Array) {
                    angular.forEach(menuItem.feature, function (feature) {
                        if (isActive) {
                            if (Feature.isActive(feature)) {
                                isActive = true;
                            } else {
                                isActive = false;
                            }
                        }
                    });
                } else {
                    if (Feature.isActive(menuItem.feature)) {
                        isActive = true;
                    } else {
                        isActive = false;
                    }
                }
            }
            return isActive;
        }

        function showHelp() {
            var currentState = $state.current.name;
            if (currentState.startsWith("storm.admin")) {
                return true;
            } else {
                return false;
            }
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer')
        .directive('fpToggle', fpToggle)

    function fpToggle() {
        var directive = {
            restrict: 'E',
            scope: {
                'key': '@'
            },
            controller: toggleDirectiveController,
            templateUrl: 'core/components/toggle/toggle.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function toggleDirectiveController($scope, $timeout) {

        $scope.key = angular.isDefined($scope.key) ? $scope.key : 'zmdi zmdi-menu';

        $scope.toggleSideMenu = function() {
            $scope.$emit('toggleSideMenu', 'toggle');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('fpTimer', fpTimer);

    function fpTimer() {
        var directive = {
            scope: {
                interval: '=interval',
                startTimeAttr: '=startTime',
                endTimeAttr: '=endTime',
                countdownattr: '=countdown',
                finishCallback: '&finishCallback',
                autoStart: '&autoStart',
                language: '@?',
                fallback: '@?',
                maxTimeUnit: '=',
                seconds: '=?',
                minutes: '=?',
                hours: '=?',
                days: '=?',
                months: '=?',
                years: '=?',
                secondsS: '=?',
                minutesS: '=?',
                hoursS: '=?',
                daysS: '=?',
                monthsS: '=?',
                yearsS: '=?'
            },
            controller: timerController,
            restrict: 'EA',
            replace: false
        };
        return directive;
    }

    /* @ngInject */
    function timerController($scope, $compile, $element, $attrs, $timeout, $interpolate) {
        // Checking for trim function since IE8 doesn't have it
        // If not a function, create tirm with RegEx to mimic native trim
        if (typeof String.prototype.trim !== 'function') {
            String.prototype.trim = function() {
                return this.replace(/^\s+|\s+$/g, '');
            };
        }

        //angular 1.2 doesn't support attributes ending in "-start", so we're
        //supporting both "autostart" and "auto-start" as a solution for
        //backward and forward compatibility.
        $scope.autoStart = $attrs.autoStart || $attrs.autostart;
        $scope.language = $scope.language || 'en';
        $scope.fallback = $scope.fallback || 'en';

        if ($element.html().trim().length === 0) {
            $element.append($compile('<span>' + $interpolate.startSymbol() + 'millis' + $interpolate.endSymbol() + '</span>')($scope));
        } else {
            $element.append($compile($element.contents())($scope));
        }

        $scope.startTime = null;
        $scope.endTime = null;
        $scope.timeoutId = null;
        $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) >= 0 ? parseInt($scope.countdownattr, 10) : undefined;
        $scope.isRunning = false;

        $scope.$on('timer-start', function() {
            $scope.start();
        });

        $scope.$on('timer-resume', function() {
            $scope.resume();
        });

        $scope.$on('timer-stop', function() {
            $scope.stop();
        });

        $scope.$on('timer-clear', function() {
            $scope.clear();
        });

        $scope.$on('timer-reset', function() {
            $scope.reset();
        });

        $scope.$on('timer-set-countdown', function(e, countdown) {
            $scope.countdown = countdown;
        });

        function resetTimeout() {
            if ($scope.timeoutId) {
                clearTimeout($scope.timeoutId);
            }
        }

        $scope.$watch('startTimeAttr', function(newValue, oldValue) {
            if (newValue !== oldValue && $scope.isRunning) {
                $scope.start();
            }
        });

        $scope.$watch('endTimeAttr', function(newValue, oldValue) {
            if (newValue !== oldValue && $scope.isRunning) {
                $scope.start();
            }
        });

        $scope.start = function() {
            $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
            $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
            if (!angular.isNumber($scope.countdown)) {
                $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
            }
            resetTimeout();
            tick();
            $scope.isRunning = true;
            $scope.$emit('timer-started', {
                timeoutId: $scope.timeoutId,
                millis: $scope.millis,
                seconds: $scope.seconds,
                minutes: $scope.minutes,
                hours: $scope.hours,
                days: $scope.days
            });
        };

        $scope.resume = function() {
            resetTimeout();
            if ($scope.countdownattr) {
                $scope.countdown += 1;
            }
            $scope.startTime = moment().diff((moment($scope.stoppedTime).diff(moment($scope.startTime))));
            tick();
            $scope.isRunning = true;
            $scope.$emit('timer-started', {
                timeoutId: $scope.timeoutId,
                millis: $scope.millis,
                seconds: $scope.seconds,
                minutes: $scope.minutes,
                hours: $scope.hours,
                days: $scope.days
            });
        };

        $scope.stop = $scope.pause = function() {
            var timeoutId = $scope.timeoutId;
            $scope.clear();
            $scope.$emit('timer-stopped', {
                timeoutId: timeoutId,
                millis: $scope.millis,
                seconds: $scope.seconds,
                minutes: $scope.minutes,
                hours: $scope.hours,
                days: $scope.days
            });
        };

        $scope.clear = function() {
            // same as stop but without the event being triggered
            $scope.stoppedTime = moment();
            resetTimeout();
            $scope.timeoutId = null;
            $scope.isRunning = false;
        };

        $scope.reset = function() {
            $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
            $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
            $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
            resetTimeout();
            tick();
            $scope.isRunning = false;
            $scope.clear();
            $scope.$emit('timer-reseted', {
                timeoutId: $scope.timeoutId,
                millis: $scope.millis,
                seconds: $scope.seconds,
                minutes: $scope.minutes,
                hours: $scope.hours,
                days: $scope.days
            });
        };

        $element.bind('$destroy', function() {
            resetTimeout();
            $scope.isRunning = false;
        });


        function calculateTimeUnits() {
            if ($attrs.startTime !== undefined) {
                $scope.millis = moment().diff(moment($scope.startTimeAttr));
            }

            // compute time values based on maxTimeUnit specification
            if (!$scope.maxTimeUnit || $scope.maxTimeUnit === 'day') {
                $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
                $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
                $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
                $scope.days = Math.floor((($scope.millis / (3600000)) / 24));
                $scope.months = 0;
                $scope.years = 0;
            } else if ($scope.maxTimeUnit === 'second') {
                $scope.seconds = Math.floor($scope.millis / 1000);
                $scope.minutes = 0;
                $scope.hours = 0;
                $scope.days = 0;
                $scope.months = 0;
                $scope.years = 0;
            } else if ($scope.maxTimeUnit === 'minute') {
                $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
                $scope.minutes = Math.floor($scope.millis / 60000);
                $scope.hours = 0;
                $scope.days = 0;
                $scope.months = 0;
                $scope.years = 0;
            } else if ($scope.maxTimeUnit === 'hour') {
                $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
                $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
                $scope.hours = Math.floor($scope.millis / 3600000);
                $scope.days = 0;
                $scope.months = 0;
                $scope.years = 0;
            } else if ($scope.maxTimeUnit === 'month') {
                $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
                $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
                $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
                $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
                $scope.months = Math.floor((($scope.millis / (3600000)) / 24) / 30);
                $scope.years = 0;
            } else if ($scope.maxTimeUnit === 'year') {
                $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
                $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
                $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
                $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
                $scope.months = Math.floor((($scope.millis / (3600000)) / 24 / 30) % 12);
                $scope.years = Math.floor(($scope.millis / (3600000)) / 24 / 365);
            }
            // plural - singular unit decision (old syntax, for backwards compatibility and English only, could be deprecated!)
            $scope.secondsS = ($scope.seconds === 1) ? '' : 's';
            $scope.minutesS = ($scope.minutes === 1) ? '' : 's';
            $scope.hoursS = ($scope.hours === 1) ? '' : 's';
            $scope.daysS = ($scope.days === 1) ? '' : 's';
            $scope.monthsS = ($scope.months === 1) ? '' : 's';
            $scope.yearsS = ($scope.years === 1) ? '' : 's';


            //add leading zero if number is smaller than 10
            $scope.sseconds = $scope.seconds < 10 ? '0' + $scope.seconds : $scope.seconds;
            $scope.mminutes = $scope.minutes < 10 ? '0' + $scope.minutes : $scope.minutes;
            $scope.hhours = $scope.hours < 10 ? '0' + $scope.hours : $scope.hours;
            $scope.ddays = $scope.days < 10 ? '0' + $scope.days : $scope.days;
            $scope.mmonths = $scope.months < 10 ? '0' + $scope.months : $scope.months;
            $scope.yyears = $scope.years < 10 ? '0' + $scope.years : $scope.years;

        }

        //determine initial values of time units and add AddSeconds functionality
        if ($scope.countdownattr) {
            $scope.millis = $scope.countdownattr * 1000;

            $scope.addCDSeconds = function(extraSeconds) {
                $scope.countdown += extraSeconds;
                if (!$scope.isRunning) {
                    $scope.start();
                }
            };

            $scope.$on('timer-add-cd-seconds', function(e, extraSeconds) {
                $scope.addCDSeconds(extraSeconds);
            });

            $scope.$on('timer-set-countdown-seconds', function(e, countdownSeconds) {
                if (!$scope.isRunning) {
                    $scope.clear();
                }

                $scope.countdown = countdownSeconds;
                $scope.millis = countdownSeconds * 1000;
                calculateTimeUnits();
            });
        } else {
            $scope.millis = 0;
        }
        calculateTimeUnits();

        var tick = function tick() {
            var typeTimer = null; // countdown or endTimeAttr
            $scope.millis = moment().diff($scope.startTime);
            var adjustment = $scope.millis % 1000;

            if ($scope.endTimeAttr) {
                typeTimer = $scope.endTimeAttr;
                $scope.millis = moment($scope.endTime).diff(moment());
                adjustment = $scope.interval - $scope.millis % 1000;
            }

            if ($scope.countdownattr) {
                typeTimer = $scope.countdownattr;
                $scope.millis = $scope.countdown * 1000;
            }

            if ($scope.millis < 0) {
                $scope.stop();
                $scope.millis = 0;
                calculateTimeUnits();
                if ($scope.finishCallback) {
                    $scope.$eval($scope.finishCallback);
                }
                return;
            }
            calculateTimeUnits();

            //We are not using $timeout for a reason. Please read here - https://github.com/siddii/angular-timer/pull/5
            $scope.timeoutId = setTimeout(function() {
                tick();
                // since you choose not to use $timeout, at least preserve angular cycle two way data binding
                // by calling $scope.$apply() instead of $scope.$digest()
                $scope.$apply();
            }, $scope.interval - adjustment);

            $scope.$emit('timer-tick', {
                timeoutId: $scope.timeoutId,
                millis: $scope.millis,
                seconds: $scope.seconds,
                minutes: $scope.minutes,
                hours: $scope.hours,
                days: $scope.days
            });

            if ($scope.countdown > 0) {
                $scope.countdown--;
            } else if ($scope.countdown <= 0) {
                $scope.stop();
                if ($scope.finishCallback) {
                    $scope.$eval($scope.finishCallback);
                }
            }
        };

        if ($scope.autoStart === undefined || $scope.autoStart === true) {
            $scope.start();
        }
    }
})();
;
(function() {
    'use strict';

    function increase(value, min, max, type) {
        var num = parseInt(value);
        if (isNaN(num) || num === max)
            num = min;
        else
            num++;
        if (type === 'MM')
            return format(num);
        return String(num);
    }

    function decrease(value, min, max, type) {
        var num = parseInt(value);
        if (isNaN(num) || num === min)
            num = max;
        else
            num--;
        if (type === 'MM')
            return format(num);
        return String(num);
    }

    function format(num) {
        if (num < 10)
            return '0' + String(num);
        return String(num);
    }

    function handleInput(value, max, blur, type) {
        var num = parseInt(value);
        if (type === 'HH' && num === 0) {
            if (num === 0) {
                return String(num);
            }
            return;
        }
        if (num > max)
            return String(num)[0];
        else if (!isNaN(num)) {
            if (value.length === 2 || (blur && type === 'MM'))
                return format(num);
            return String(num);
        }
    }

    angular.module('atheer.core')

        .directive('mdHoursMinutes', function() {

            return {

                restrict: 'E',
                scope: {
                    type: '@',
                    message: '@',
                    ngModel: '=',
                    readOnly: '<', // true or false
                    mandatory: '<' // true or false
                },
                template: '<md-input-container md-no-float>' +
                    '<input ' +
                    'ng-required="mandatory" ' +
                    'type="text"' +
                    'name="time_{{type}}"' +
                    'ng-model="time[type]"' +
                    'ng-change="handleInput()"' +
                    'placeholder="{{type}}"' +
                    'maxlength="2"' +
                    'ng-blur="handleInput(true)"' +
                    'ng-keydown="handleKeypress($event)" ng-disabled="readOnly"/>' +
                    '<span class="md-up-arrow" aria-hidden="true" ng-click="!readOnly && increase()"></span>' +
                    '<span class="md-down-arrow" aria-hidden="true" ng-click="!readOnly && decrease()"></span>' +
                    '<div class="time-error-messages" ng-messages="$parent.timeForm[\'time_\' + type].$error" role="alert">' +
                    '<div ng-message="required">{{message}}</div>' +
                    '</div>' +
                    '</md-input-container>',
                controller: ["$scope", "$rootScope", function($scope, $rootScope) {

                    if ($scope.type === "HH") {
                        if ($scope.$parent.noMeridiem) {
                            $scope.min = 0;
                            $scope.max = 23;
                        } else {
                            $scope.min = 1;
                            $scope.max = 12;
                        }
                    } else {
                        $scope.min = 0;
                        $scope.max = 59;
                    }

                    function setTime() {
                        if ($scope.type === "HH") {
                            var hours = '';
                            try {
                                hours = $scope.$parent.ngModel.getHours();
                            } catch (e) {
                                // leave hours empty to allow empty values
                            }

                            if (!$scope.$parent.noMeridiem) {
                                if (hours > 12)
                                    hours -= 12;
                                else if (hours === 0)
                                    hours += 12;
                            }
                            $scope.time.HH = String(hours);
                        } else
                        if ($scope.$parent.ngModel) {
                            $scope.time.MM = format($scope.$parent.ngModel.getMinutes());
                        } else {
                            // leave MM empty to allow empty values
                            $scope.time.MM = '';
                        }
                    }

                    $scope.time = {};

                    // make sure we update our variables if new values
                    $scope.$watch("ngModel", function() {
                        setTime();
                    });

                    var removeListener = $scope.$on('mdpTimePickerModalUpdated', setTime);
                    $scope.$on('$destroy', removeListener);

                    function updateTime(next) {
                        // prevent NaN value in input field
                        if (isNaN(next))
                            return;

                        // if $scope.ngModel is undefined, create new date object. else leave as is, which means user has specified date object
                        // Set hours, minutes, seconds and milliseconds to 0 in order for the user to be able to set own values
                        if (angular.isDate($scope.ngModel)) {
                            if (isNaN($scope.ngModel.getTime())) {
                                $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
                            } else {
                                // continue
                            }
                        } else {
                            $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
                        }
                        if ($scope.type === 'MM') {
                            $scope.ngModel.setMinutes(next);
                            return;
                        } else if (!$scope.$parent.noMeridiem) {
                            var hours = $scope.ngModel.getHours();
                            if (hours >= 12 && next != 12)
                                next += 12;
                            else if (hours < 12 && next == 12)
                                next = 0;
                        }
                        $scope.ngModel.setHours(next);
                    }

                    $scope.increase = function() {
                        var next = increase($scope.time[$scope.type], $scope.min, $scope.max, $scope.type)
                        $scope.time[$scope.type] = next;
                        updateTime(parseInt(next));
                        $rootScope.$emit('mdpTimePickerUpdated');
                    }

                    $scope.decrease = function() {
                        var next = decrease($scope.time[$scope.type], $scope.min, $scope.max, $scope.type);
                        $scope.time[$scope.type] = next;
                        updateTime(parseInt(next));
                        $rootScope.$emit('mdpTimePickerUpdated');
                    }

                    $scope.handleInput = function(blur) {
                        var next = handleInput($scope.time[$scope.type], $scope.max, blur, $scope.type);
                        $scope.time[$scope.type] = next;
                        updateTime(parseInt(next));
                        $rootScope.$emit('mdpTimePickerUpdated');
                    }

                    $scope.handleKeypress = function(ev) {
                        if (ev.keyCode === 38) $scope.increase();
                        else if (ev.keyCode === 40) $scope.decrease();
                    }

                }]
            }

        })

        .directive('mdMeridiem', function() {

            return {

                restrict: 'E',
                scope: {
                    message: '@',
                    readOnly: '<', // true or false
                    ngModel: '=',
                    mandatory: '<' // true or false
                },
                template: '<md-input-container md-no-float>' +
                    '<md-select ' +
                    'ng-required="mandatory" ' +
                    'name="meridiem"' +
                    'ng-model="meridiem"' +
                    'ng-change="updateTime()"' +
                    'placeholder="AM/PM"' +
                    'flex-gt-sm ' +
                    'ng-disabled="readOnly">' +
                    '<md-option value="AM" ng-disabled="readOnly">AM</md-option>' +
                    '<md-option value="PM" ng-disabled="readOnly">PM</md-option>' +
                    '</md-select>' +
                    '<div class="time-error-messages" ng-messages="$parent.timeForm.meridiem.$error" role="alert">' +
                    '<div ng-message="required">{{message}}</div>' +
                    '</div>' +
                    '</md-input-container>',
                controller: ["$scope", "$rootScope", function($scope, $rootScope) {

                    function setMeridiem() {
                        var hours = '';
                        try {
                            hours = $scope.$parent.$parent.ngModel.getHours();
                        } catch (e) {
                            // leave hours empty
                        }
                        $scope.meridiem = hours >= 0 && hours < 12 ? 'AM' : 'PM';
                    }

                    // update meridiem on load of view and when model is changing
                    $scope.$watch("ngModel", function() {
                        setMeridiem();
                    });

                    $scope.updateTime = function() {
                        var hours = $scope.$parent.$parent.ngModel.getHours();
                        if ($scope.meridiem === 'AM') $scope.$parent.$parent.ngModel.setHours(hours - 12);
                        else $scope.$parent.$parent.ngModel.setHours(hours + 12);
                        $rootScope.$emit('mdpTimePickerUpdated');
                    }

                    var removeListener = $scope.$on('mdpTimePickerModalUpdated', setMeridiem);
                    $scope.$on('$destroy', removeListener);

                }]

            }

        })

        .directive('mdTimePicker', function() {

            return {

                restrict: 'E',
                scope: {
                    message: '<',
                    ngModel: '=',
                    readOnly: '<', // true or false
                    mandatory: '<' // true or false
                },
                template: '<ng-form name="timeForm">' +
                    '<button class="md-icon-button md-button md-ink-ripple" type="button" ng-click="!readOnly && showPicker($event)" ng-disabled="readOnly">' +
                    '<md-icon md-font-icon="fa fa-clock-o"></md-icon>' +
                    '<div class="md-ripple-container"></div>' +
                    '</button>' +
                    '<md-hours-minutes type="HH" ng-model="ngModel" message="{{message.hour}}" read-only="readOnly" mandatory="mandatory"></md-hours-minutes>' +
                    '<span class="time-colon">:</span>' +
                    '<md-hours-minutes type="MM" ng-model="ngModel" message="{{message.minute}}" read-only="readOnly" mandatory="mandatory"></md-hours-minutes>' +
                    '<md-meridiem ng-if="!noMeridiem" ng-model="ngModel" message="{{message.meridiem}}" read-only="readOnly" mandatory="mandatory"></md-meridiem>' +
                    '</ng-form>',
                controller: ["$scope", "$rootScope", "$mdpTimePicker", "$attrs", function($scope, $rootScope, $mdpTimePicker, $attrs) {

                    $scope.showPicker = function(ev) {

                        $mdpTimePicker($scope.ngModel, {
                            targetEvent: ev,
                            noMeridiem: $scope.noMeridiem,
                            autoSwitch: !$scope.noAutoSwitch
                        }).then(function(time) {
                            // if $scope.ngModel is not a valid date, create new date object.
                            // Set hours, minutes, seconds and milliseconds to 0 in order for the user to be able to set own values
                            if (angular.isDate($scope.ngModel)) {
                                if (isNaN($scope.ngModel.getTime())) {
                                    $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
                                }
                            } else {
                                $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
                            }
                            $scope.ngModel.setHours(time.getHours());
                            $scope.ngModel.setMinutes(time.getMinutes());
                            $scope.$broadcast('mdpTimePickerModalUpdated');
                            $rootScope.$emit('mdpTimePickerUpdated');
                        });
                    }
                }],
                compile: function(tElement, tAttrs) {
                    return {
                        pre: function preLink(scope) {
                            scope.noMeridiem = tAttrs.noMeridiem === "" ? true : false;
                            scope.noAutoSwitch = tAttrs.noAutoSwitch === "" ? true : false;
                        }
                    }
                }
            }
        })

        .provider('$mdpTimePicker', function() {
            var LABEL_OK = "OK",
                LABEL_CANCEL = "Cancel";

            this.setOKButtonLabel = function(label) {
                LABEL_OK = label;
            };

            this.setCancelButtonLabel = function(label) {
                LABEL_CANCEL = label;
            };

            this.$get = ["$mdDialog", function($mdDialog) {
                var timePicker = function(time, options) {

                    return $mdDialog.show({
                        controller: ['$scope', '$mdDialog', '$mdMedia', function($scope, $mdDialog, $mdMedia) {
                            var self = this;

                            // check if time is valid date. Create new date object if not.
                            if (angular.isDate(time)) {
                                if (isNaN(time.getTime())) {
                                    time = new Date(2017, 0, 0, 0, 0, 0, 0);
                                } else {
                                    // continue
                                }
                            } else {
                                time = new Date(2017, 0, 0, 0, 0, 0, 0);
                            }

                            this.time = new Date(time.getTime());
                            this.noMeridiem = options.noMeridiem;
                            if (!self.noMeridiem)
                                this.meridiem = time.getHours() < 12 ? 'AM' : 'PM';

                            this.VIEW_HOURS = 1;
                            this.VIEW_MINUTES = 2;
                            this.currentView = this.VIEW_HOURS;
                            this.autoSwitch = !!options.autoSwitch;

                            $scope.$mdMedia = $mdMedia;

                            this.switchView = function() {
                                self.currentView = self.currentView == self.VIEW_HOURS ? self.VIEW_MINUTES : self.VIEW_HOURS;
                            };

                            this.hours = function() {
                                var hours = self.time.getHours();
                                if (self.noMeridiem) return hours;
                                if (hours > 12) return hours - 12;
                                else if (hours === 0) return 12;
                                return hours;
                            }

                            this.minutes = function() {
                                return format(self.time.getMinutes());
                            }

                            this.setAM = function() {
                                var hours = self.time.getHours();
                                if (hours >= 12) {
                                    self.time.setHours(hours - 12);
                                    self.meridiem = 'AM';
                                }
                            };

                            this.setPM = function() {
                                var hours = self.time.getHours();
                                if (hours < 12) {
                                    self.time.setHours(hours + 12);
                                    self.meridiem = 'PM';
                                }
                            };

                            this.cancel = function() {
                                $mdDialog.cancel();
                            };

                            this.confirm = function() {
                                $mdDialog.hide(this.time);
                            };
                        }],
                        controllerAs: 'timepicker',
                        clickOutsideToClose: true,
                        template: '<md-dialog aria-label="" class="mdp-timepicker" ng-class="{ \'portrait\': !$mdMedia(\'gt-xs\') }">' +
                            '<md-dialog-content layout-gt-xs="row" layout-wrap>' +
                            '<md-toolbar layout-gt-xs="column" layout-xs="row" layout-align="center center" flex class="mdp-timepicker-time md-hue-1 md-primary">' +
                            '<div class="mdp-timepicker-selected-time">' +
                            '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_HOURS }" ng-click="timepicker.currentView = timepicker.VIEW_HOURS">{{ timepicker.hours() }}</span>:' +
                            '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_MINUTES }" ng-click="timepicker.currentView = timepicker.VIEW_MINUTES">{{ timepicker.minutes() }}</span>' +
                            '</div>' +
                            '<div layout="column" class="mdp-timepicker-selected-ampm">' +
                            '<span ng-if="timepicker.meridiem" ng-click="timepicker.setAM()" ng-class="{ \'active\': timepicker.meridiem === \'AM\' }">AM</span>' +
                            '<span ng-if="timepicker.meridiem" ng-click="timepicker.setPM()" ng-class="{ \'active\': timepicker.meridiem === \'PM\' }">PM</span>' +
                            '</div>' +
                            '</md-toolbar>' +
                            '<div>' +
                            '<div class="mdp-clock-switch-container" ng-switch="timepicker.currentView" layout layout-align="center center">' +
                            '<fp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" no-meridiem="noMeridiem" type="hours" ng-switch-when="1"></fp-clock>' +
                            '<fp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="minutes" ng-switch-when="2"></fp-clock>' +
                            '</div>' +

                            '<md-dialog-actions layout="row">' +
                            '<span flex></span>' +
                            '<md-button ng-click="timepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
                            '<md-button ng-click="timepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
                            '</md-dialog-actions>' +
                            '</div>' +
                            '</md-dialog-content>' +
                            '</md-dialog>',
                        targetEvent: options.targetEvent,
                        locals: {
                            time: time,
                            noMeridiem: options.noMeridiem,
                            autoSwitch: options.autoSwitch
                        },
                        skipHide: true,
                        multiple: true
                    });
                };

                return timePicker;
            }];
        })

        .directive("fpClock", ["$animate", "$timeout", function($animate, $timeout) {
            return {
                restrict: 'E',
                bindToController: {
                    'type': '@?',
                    'time': '=',
                    'autoSwitch': '=?'
                },
                replace: true,
                template: '<div class="mdp-clock">' +
                    '<div class="mdp-clock-container">' +
                    '<md-toolbar class="mdp-clock-center md-primary"></md-toolbar>' +
                    '<md-toolbar ng-style="clock.getPointerStyle()" class="mdp-pointer md-primary">' +
                    '<span class="mdp-clock-selected md-button md-raised md-primary"></span>' +
                    '</md-toolbar>' +
                    '<md-button ng-if="clock.type === \'minutes\'" ng-class="{ \'md-primary\': clock.selected == step }" class="md-icon-button md-raised mdp-clock-deg{{ ::(clock.STEP_DEG_MINUTES * ($index + 1)) }}" ng-repeat="step in clock.steps">{{ step }}</md-button>' +
                    '<md-button ng-if="clock.type !== \'minutes\'" ng-class="{ \'md-primary\': clock.selected == step }" class="md-icon-button md-raised mdp-clock-deg{{ ::(clock.STEP_DEG * ($index + 1)) }}" ng-repeat="step in clock.steps">{{ step }}</md-button>' +
                    '</div>' +
                    '</div>',
                controller: ["$scope", function($scope) {
                    var TYPE_HOURS = "hours";
                    var TYPE_MINUTES = "minutes";
                    var self = this;

                    this.noMeridiem = $scope.$parent.timepicker.noMeridiem;

                    this.STEP_DEG = this.noMeridiem ? 360 / 24 : 360 / 12;
                    this.STEP_DEG_MINUTES = 360 / 12;
                    this.steps = [];

                    this.CLOCK_TYPES = {
                        "hours": {
                            range: this.noMeridiem ? 24 : 12,
                        },
                        "minutes": {
                            range: 60,
                        }
                    }

                    this.getPointerStyle = function() {
                        var divider = 1;
                        switch (self.type) {
                            case TYPE_HOURS:
                                divider = self.noMeridiem ? 24 : 12;
                                break;
                            case TYPE_MINUTES:
                                divider = 60;
                                break;
                        }
                        var degrees = Math.round(self.selected * (360 / divider)) - 180;
                        return {
                            "-webkit-transform": "rotate(" + degrees + "deg)",
                            "-ms-transform": "rotate(" + degrees + "deg)",
                            "transform": "rotate(" + degrees + "deg)"
                        }
                    };

                    this.setTimeByDeg = function(deg) {

                        var divider = 0;
                        switch (self.type) {
                            case TYPE_HOURS:
                                divider = self.noMeridiem ? 24 : 12;
                                break;
                            case TYPE_MINUTES:
                                divider = 60;
                                break;
                        }

                        var time = Math.round(divider / 360 * deg);
                        if (!self.noMeridiem && self.type === "hours" && time === 0)
                            time = 12;
                        else if (self.type === "minutes" && time === 60)
                            time = 0;
                        self.setTime(time);
                    };

                    this.setTime = function(time) {

                        this.selected = time;

                        switch (self.type) {
                            case TYPE_HOURS:
                                if (!self.noMeridiem) {
                                    var PM = this.time.getHours() >= 12 ? true : false;
                                    if (PM && time != 12)
                                        time += 12;
                                    else if (!PM && time === 12)
                                        time = 0;
                                }
                                this.time.setHours(time);
                                break;
                            case TYPE_MINUTES:
                                this.time.setMinutes(time);
                                break;
                        }

                    };

                    this.$onInit = function() {

                        self.type = self.type || "hours";

                        switch (self.type) {
                            case TYPE_HOURS:
                                if (self.noMeridiem) {
                                    for (var i = 1; i <= 23; i++)
                                        self.steps.push(i);
                                    self.steps.push(0);
                                    self.selected = self.time.getHours() || 0;
                                } else {
                                    for (var i = 1; i <= 12; i++)
                                        self.steps.push(i);
                                    self.selected = self.time.getHours() || 0;
                                    if (self.selected > 12) self.selected -= 12;
                                }

                                break;
                            case TYPE_MINUTES:
                                for (var i = 5; i <= 55; i += 5)
                                    self.steps.push(i);
                                self.steps.push(0);

                                self.selected = self.time.getMinutes() || 0;

                                break;
                        }
                    };
                    // Prior to v1.5, we need to call `$onInit()` manually.
                    // (Bindings will always be pre-assigned in these versions.)
                    if (angular.version.major === 1 && angular.version.minor < 5) {
                        this.$onInit();
                    }
                }],
                controllerAs: "clock",
                link: function(scope, element, attrs, ctrl) {
                    var pointer = angular.element(element[0].querySelector(".mdp-pointer")),
                        timepickerCtrl = scope.$parent.timepicker;

                    var onEvent = function(event) {
                        var containerCoords = event.currentTarget.getClientRects()[0];
                        var x = ((event.currentTarget.offsetWidth / 2) - (event.pageX - containerCoords.left)),
                            y = ((event.pageY - containerCoords.top) - (event.currentTarget.offsetHeight / 2));

                        var deg = Math.round((Math.atan2(x, y) * (180 / Math.PI)));
                        $timeout(function() {
                            ctrl.setTimeByDeg(deg + 180);
                            if (ctrl.type === 'hours' && ctrl.autoSwitch) timepickerCtrl.switchView();
                        });
                    };

                    element.on("click", onEvent);
                    scope.$on("$destroy", function() {
                        element.off("click", onEvent);
                    });

                }
            }
        }]);
})();
;
(function() {
    'use strict';
    angular
        .module('atheer')
        .component('tabsWidget', {
            templateUrl: 'core/components/tabs/tabs-widget.tmpl.html',
            controller: TabsWidget,
            controllerAs: 'vm',
            bindings: {
                languages: '<',
                countries: '<'
            }
        });

    /* @ngInject */
    function TabsWidget(paginationConstants) {
        var vm = this;

        vm.tableQueries = {
            languages: {
                order: '-percent',
                limit: paginationConstants.itemsPerPage,
                page: 1
            },
            countries: {
                order: '-percent',
                limit: paginationConstants.itemsPerPage,
                page: 1
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triTable', triTable);

    /* @ngInject */
    function triTable($filter) {
        var directive = {
            restrict: 'E',
            scope: {
                columns: '=',
                contents: '=',
                filters: '='
            },
            link: link,
            templateUrl: 'core/components/table/table-directive.tmpl.html'
        };
        return directive;

        function link($scope, $element, attrs) {
            var sortableColumns = [];
            var activeSortColumn = null;
            var activeSortOrder = false;

            // init page size if not set to default
            $scope.pageSize = angular.isUndefined(attrs.pageSize) ? 0 : attrs.pageSize;

            // init page if not set to default
            $scope.page = angular.isUndefined(attrs.page) ? 0 : attrs.page;

            // make an array of all sortable columns
            angular.forEach($scope.columns, function(column) {
                if(column.sortable) {
                    sortableColumns.push(column.field);
                }
            });

            $scope.refresh = function(resetPage) {
                if(resetPage === true) {
                    $scope.page = 0;
                }
                $scope.contents = $filter('orderBy')($scope.contents, activeSortColumn, activeSortOrder);
            };

            // if we have sortable columns sort by first by default
            if(sortableColumns.length > 0) {
                // sort first column by default
                activeSortOrder = false;
                activeSortColumn = sortableColumns[0];
                $scope.refresh();
            }

            $scope.sortClick = function(field) {
                if(sortableColumns.indexOf(field) !== -1) {
                    if(field === activeSortColumn) {
                        activeSortOrder = !activeSortOrder;
                    }
                    activeSortColumn = field;
                    $scope.refresh();
                }
            };

            $scope.showSortOrder = function(field, orderDown) {
                return field === activeSortColumn && activeSortOrder === orderDown;
            };

            $scope.headerClass = function(field) {
                var classes = [];
                if(sortableColumns.indexOf(field) !== -1) {
                    classes.push('sortable');
                }
                if(field === activeSortColumn) {
                    classes.push('sorted');
                }
                return classes;
            };

            $scope.cellContents = function(column, content) {
                if(angular.isDefined(column.filter)) {
                    return $filter(column.filter)(content[column.field]);
                }
                else {
                    return content[column.field];
                }
            };

            $scope.totalItems = function() {
                return $scope.contents.length;
            };

            $scope.numberOfPages = function() {
                return Math.ceil($scope.contents.length / $scope.pageSize);
            };

            $scope.pageStart = function() {
                return ($scope.page * $scope.pageSize) + 1;
            };

            $scope.pageEnd = function() {
                var end = (($scope.page + 1) * $scope.pageSize);
                if(end > $scope.contents.length) {
                    end = $scope.contents.length;
                }
                return end;
            };

            $scope.goToPage = function (page) {
                $scope.page = page;
            };
        }
    }
})();;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .filter('startFrom', startFrom);

    function startFrom() {
        return filterFilter;

        ////////////////

        function filterFilter(input, start) {
            start = +start;
            return input.slice(start);
        }
    }

})();;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .filter('tableImage', tableImage);

    function tableImage($sce) {
        return filterFilter;

        ////////////////

        function filterFilter(value) {
            return $sce.trustAsHtml('<div style=\"background-image: url(\'' + value + '\')\"/>');
        }
    }

})();;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('rotatingPlaneSpinner', rotatingPlaneSpinner)
        .directive('doubleBounceSpinner', doubleBounceSpinner)
        .directive('waveSpinner', waveSpinner)
        .directive('wanderingCubesSpinner', wanderingCubesSpinner)
        .directive('pulseSpinner', pulseSpinner)
        .directive('chasingDotsSpinner', chasingDotsSpinner)
        .directive('circleSpinner', circleSpinner)
        .directive('threeBounceSpinner', threeBounceSpinner)
        .directive('cubeGridSpinner', cubeGridSpinner)
        .directive('wordPressSpinner', wordPressSpinner)
        .directive('fadingCircleSpinner', fadingCircleSpinner)
        .directive('mAppLoading', mAppLoading);

    function rotatingPlaneSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/rotatingPlaneSpinner.html'
        };

        return directive;
    }

    function doubleBounceSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/doubleBounceSpinner.html'
        };

        return directive;
    }

    function waveSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/waveSpinner.html'
        };

        return directive;
    }

    function wanderingCubesSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/wanderingCubesSpinner.html'
        };

        return directive;
    }

    function pulseSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/pulseSpinner.html'
        };

        return directive;
    }

    function chasingDotsSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/chasingDotsSpinner.html'
        };

        return directive;
    }

    function circleSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/circleSpinner.html'
        };

        return directive;
    }

    function threeBounceSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/threeBounceSpinner.html'
        };

        return directive;
    }

    function cubeGridSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/cubeGridSpinner.html'
        };

        return directive;
    }

    function wordPressSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/wordPressSpinner.html'
        };

        return directive;
    }

    function fadingCircleSpinner() {
        var directive = {
            restrict: 'E',
            templateUrl: 'core/components/spinkit/fadingCircleSpinner.html'
        };

        return directive;
    }

    function mAppLoading($animate) {
        var directive = {
            restrict: 'C',
            link: link
        };

        // I bind the JavaScript events to the scope.
        function link(scope, element, attributes) {
            // Due to the way AngularJS prevents animation during the bootstrap
            // of the application, we can't animate the top-level container; but,
            // since we added "ngAnimateChildren", we can animated the inner
            // container during this phase.
            // --
            // NOTE: Am using .eq(1) so that we don't animate the Style block.
            $animate.leave(element.children().eq(1)).then(
                function cleanupAfterAnimation() {
                    // Remove the root directive element.
                    element.remove();
                    // Clear the closed-over variable references.
                    scope = element = attributes = null;
                }
            );
        }
        return directive;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('SessionTimeoutController', SessionTimeoutController);

    /* @ngInject */
    function SessionTimeoutController($mdDialog, $interval, Idle, Auth, $state, Keepalive) {
        var vm = this;

        vm.counter = 15;
        var timer = $interval(function() {
            if(vm.counter == 0) {
                closeDialog();
            }
            vm.counter--;
        }, 1000);
        
        function closeDialog() {
            $mdDialog.cancel();
            Auth.logout();
            $state.go('account.signout');
        };

        vm.close = function() {
            closeDialog();
        };

        vm.continue = function() {
            $interval.cancel(timer);
            $mdDialog.cancel();
            Keepalive.setInterval(15);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .constant('recorderScriptUrl', (function() {
            var scripts = document.getElementsByTagName('script');
            var myUrl = scripts[scripts.length - 1].getAttribute('src');
            var path = myUrl.substr(0, myUrl.lastIndexOf('/') + 1);
            var a = document.createElement('a');
            a.href = path;
            return a.href;
        }()))
        .constant('recorderPlaybackStatus', {
            STOPPED: 0,
            PLAYING: 1,
            PAUSED: 2
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(recorderConfig);

    /* @ngInject */
    function recorderConfig(recorderServiceProvider) {
    }
})();
;
'use strict';

angular.module('atheer')
  .factory('recorderUtils', [
    /**
     * @ngdoc service
     * @name recorderUtils
     *
     */
    function() {

      // Generates UUID
      var factory = {
        generateUuid: function() {
          function _p8(s) {
            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
          }

          return _p8() + _p8(true) + _p8(true) + _p8();
        },
      };

      factory.appendActionToCallback = function(object, callbacks, action, track) {

        callbacks.split(/\|/).forEach(function(callback) {
          if (!angular.isObject(object) || !angular.isFunction(action) || !(callback in object) || !angular.isFunction(object[callback])) {
            throw new Error('One or more parameter supplied is not valid');
          };

          if (!('$$appendTrackers' in object)) {
            object.$$appendTrackers = [];
          }

          var tracker = callback + '|' + track;
          if (object.$$appendTrackers.indexOf(tracker) > -1) {
            return;
          }

          object[callback] = (function(original) {
            return function() {
              original.apply(object, arguments);
              action.apply(object, arguments);
            };
          })(object[callback]);

          object.$$appendTrackers.push(tracker);
        });
      };

      return factory;
    }
  ]);
;
'use strict';

angular.module('atheer')
    .provider('recorderService', ['recorderScriptUrl',
        function(scriptPath) {

            var handler = null,
                service = {
                    isHtml5: false,
                    isReady: false
                },
                permissionHandlers = {
                    onDenied: null,
                    onClosed: null,
                    onAllow: null
                },
                utils;

            var html5AudioProps = {
                audioContext: null,
                inputPoint: null,
                audioInput: null,
                audioRecorder: null,
                analyserNode: null
            };

            var html5HandlerConfig = {
                gotStream: function(stream) {
                    window.streamReference = stream;

                    var audioContext = html5AudioProps.audioContext;
                    // Create an AudioNode from the stream.
                    html5AudioProps.audioInput = audioContext.createMediaStreamSource(stream);
                    html5AudioProps.audioInput.connect((html5AudioProps.inputPoint = audioContext.createGain()));

                    //analyser
                    html5AudioProps.analyserNode = audioContext.createAnalyser();
                    html5AudioProps.analyserNode.fftSize = 2048;
                    html5AudioProps.inputPoint.connect(html5AudioProps.analyserNode);
                    html5AudioProps.audioRecorder = new Recorder(html5AudioProps.audioInput);

                    //create Gain
                    var zeroGain = audioContext.createGain();
                    zeroGain.gain.value = 0.0;
                    html5AudioProps.inputPoint.connect(zeroGain);
                    zeroGain.connect(audioContext.destination);

                    //service booted
                    service.isReady = true;
                    handler = html5AudioProps.audioRecorder;

                    if (angular.isFunction(permissionHandlers.onAllowed)) {
                        if (window.location.protocol == 'https:') {
                            //to store permission for https websites
                            localStorage.setItem("permission", "given");
                        }
                        permissionHandlers.onAllowed();
                    }

                },
                failStream: function(data) {
                    if (angular.isDefined(permissionHandlers.onDenied)) {
                        permissionHandlers.onDenied();
                    }
                },
                getPermission: function() {
                    navigator.getUserMedia({
                        "audio": true
                    }, html5HandlerConfig.gotStream, html5HandlerConfig.failStream);
                },
                init: function() {
                    service.isHtml5 = true;
                    var AudioContext = window.AudioContext || window.webkitAudioContext;
                    if (AudioContext && !html5AudioProps.audioContext) {
                        html5AudioProps.audioContext = new AudioContext();
                    }

                    if (localStorage.getItem("permission") !== null) {
                        //to get permission from browser cache for returning user
                        html5HandlerConfig.getPermission();
                    }
                }
            };

            navigator.getUserMedia = navigator.getUserMedia ||
                navigator.webkitGetUserMedia ||
                navigator.mozGetUserMedia;

            var init = function() {
                if (navigator.getUserMedia) {
                    html5HandlerConfig.init();
                }
            };

            var controllers = {};

            service.controller = function(id) {
                return controllers[id];
            };

            service.setController = function(id, controller) {
                controllers[id] = controller;
            };

            service.isAvailable = function() {
                return service.isHtml5;
            };

            service.getHandler = function() {
                return handler;
            };

            service.removeStream = function() {
                if (!window.streamReference) return;

                window.streamReference.getAudioTracks().forEach(function(track) {
                    track.stop();
                });

                window.streamReference.getVideoTracks().forEach(function(track) {
                    track.stop();
                });

                window.streamReference = null;
            };

            service.refresh = function() {
                return init();
            };

            service.showPermission = function(listeners) {
                if (!service.isAvailable()) {
                    console.warn("Neither HTML5 nor SWF is supported.");
                    return;
                }

                if (listeners) {
                    angular.extend(permissionHandlers, listeners);
                }

                if (service.isHtml5) {
                    html5HandlerConfig.getPermission();
                }
            };

            service.$html5AudioProps = html5AudioProps;

            var provider = {
                $get: ['recorderUtils',
                    function(recorderUtils) {
                        utils = recorderUtils;
                        init();
                        return service;
                    }
                ]
            };
            return provider;
        }
    ]);
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('RecorderController', RecorderController);

    RecorderController.$inject = ['$element', 'recorderService', 'recorderUtils', '$scope', '$timeout', '$filter', '$interval', 'recorderPlaybackStatus', 'Upload'];

    function RecorderController(element, service, recorderUtils, $scope, $timeout, $filter, $interval, PLAYBACK, Upload) {
        //used in NON-Angular Async process
        var scopeApply = function(fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== '$apply' && phase !== '$digest') {
                return $scope.$apply(fn);
            }
        };

        var createReadOnlyVersion = function(object) {
            var obj = {};
            for (var property in object) {
                if (object.hasOwnProperty(property)) {
                    Object.defineProperty(obj, property, {
                        get: (function(a) {
                            var p = a;
                            return function() {
                                return object[p];
                            }
                        })(property),
                        enumerable: true,
                        configurable: true
                    });
                }
            }
            return obj;
        };


        var blobToDataURL = function(blob, callback) {
            var a = new FileReader();
            a.onload = function(e) {
                callback(e.target.result);
            };
            a.readAsDataURL(blob);
        };

        var control = this,
            timing = null,
            audioObjId = 'recorded-audio-' + control.id,
            status = {
                isRecording: false,
                playback: PLAYBACK.STOPPED,
                isDenied: null,
                isSwfLoaded: null,
                isConverting: false,
                get isPlaying() {
                    return status.playback === PLAYBACK.PLAYING;
                },
                get isStopped() {
                    return status.playback === PLAYBACK.STOPPED;
                },
                get isPaused() {
                    return status.playback === PLAYBACK.PAUSED;
                }
            }

        control.timeLimit = control.timeLimit || 0;
        control.status = createReadOnlyVersion(status);
        control.isAvailable = service.isAvailable();
        control.elapsedTime = 0;
        control.elapsedTimeString = "00:00";
        control.playBackTime = 0;
        control.playBackTimeString = "00:00";
        //Sets ID for the element if ID doesn't exists
        if (!control.id) {
            control.id = recorderUtils.generateUuid();
            element.attr("id", control.id);
        }

        //register controller with service
        service.setController(control.id, this);

        var playbackOnEnded = function() {
            status.playback = PLAYBACK.STOPPED;
            control.onPlaybackComplete();
            control.playBackTime = 0;
            control.playBackTimeString = "00:00";
            $interval.cancel(timing);
            scopeApply();
        };

        var playbackOnPause = function() {
            status.playback = PLAYBACK.PAUSED;
            control.onPlaybackPause();
        };

        var playbackOnStart = function() {
            status.playback = PLAYBACK.PLAYING;
            control.onPlaybackStart();
            timing = $interval(function() {
                if (!status.isPaused) {
                    ++control.playBackTime;
                    var duration = new Date(1970, 0, 1).setSeconds(control.playBackTime);
                    var mask = 'mm:ss';
                    control.playBackTimeString = $filter('date')(duration, mask);
                }
            }, 1000);
        };

        var playbackOnResume = function() {
            status.playback = PLAYBACK.PLAYING;
            control.onPlaybackResume();
        };

        var embedPlayer = function(blob) {
            if (document.getElementById(audioObjId) == null) {
                element.append('<audio type="audio/mp3" id="' + audioObjId + '"></audio>');

                var audioPlayer = document.getElementById(audioObjId);
                if (control.showPlayer) {
                    audioPlayer.setAttribute('controls', '');
                }

                audioPlayer.addEventListener("ended", playbackOnEnded);
                audioPlayer.addEventListener("pause", function(e) {
                    if (this.duration !== this.currentTime) {
                        playbackOnPause();
                        scopeApply();
                    }
                });


                audioPlayer.addEventListener("playing", function(e) {
                    if (status.isPaused) {
                        playbackOnResume();
                    } else {
                        playbackOnStart();
                    }
                    scopeApply();
                });
            }

            if (blob) {
                blobToDataURL(blob, function(url) {
                    document.getElementById(audioObjId).src = url;
                });
            } else {
                document.getElementById(audioObjId).removeAttribute('src');
            }
        };

        control.getAudioPlayer = function() {
            return document.getElementById(audioObjId);
        };

        control.startRecord = function() {
            if (!service.isAvailable()) {
                return;
            }

            if (status.isPlaying) {
                control.playbackPause();
                //indicate that this is not paused.
                status.playback = PLAYBACK.STOPPED;
            }

            //clear audio previously recorded
            control.audioModel = null;

            var id = control.id;
            var recordHandler = service.getHandler();

            //Record initiation based on browser type
            var start = function() {
                if (service.isHtml5) {
                    //HTML5 recording
                    if (!recordHandler) {
                        return;
                    }

                    recordHandler.clear();
                    recordHandler.record();
                } else {
                    //Flash recording
                    if (!service.isReady) {
                        //Stop recording if the flash object is not ready
                        return;
                    }
                    recordHandler.record(id, 'audio.wav');
                }

                status.isRecording = true;
                control.onRecordStart();
                control.elapsedTime = 0;

                timing = $interval(function() {
                    ++control.elapsedTime;
                    var duration = new Date(1970, 0, 1).setSeconds(control.elapsedTime);
                    var mask = 'mm:ss';
                    control.elapsedTimeString = $filter('date')(duration, mask);
                    if (control.timeLimit && control.timeLimit > 0 && control.elapsedTime >= control.timeLimit) {
                        control.stopRecord();
                    }
                }, 1000);
            };

            if (recordHandler) {
                start();
            } else if (!status.isDenied) {
                //probably permission was never asked
                service.showPermission({
                    onDenied: function() {
                        status.isDenied = true;
                        scopeApply();
                    },
                    onAllowed: function() {
                        status.isDenied = false;
                        recordHandler = service.getHandler();
                        start();
                        scopeApply();
                    }
                });
            }
        };

        control.stopRecord = function() {
            var id = control.id;
            if (!service.isAvailable() || !status.isRecording) {
                return false;
            }

            var recordHandler = service.getHandler();
            var completed = function(blob) {
                $interval.cancel(timing);
                status.isRecording = false;
                var finalize = function(inputBlob) {
                    control.audioModel = inputBlob;
                    embedPlayer(inputBlob);
                };
                finalize(blob)
                embedPlayer(null);
                control.onRecordComplete();
            };

            //To stop recording
            if (service.isHtml5) {
                recordHandler.stop();
                recordHandler.getBuffer(function() {
                    recordHandler.exportWAV(function(blob) {
                        completed(blob);
                        scopeApply();
                    });
                });
            } else {
                recordHandler.stopRecording(id);
                completed(recordHandler.getBlob(id));
            }

            service.removeStream();
        };

        control.playbackRecording = function() {
            if (status.isPlaying || !service.isAvailable() || status.isRecording || !control.audioModel) {
                return false;
            }
            control.getAudioPlayer().play();
        };

        control.playbackPause = function() {
            if (!status.isPlaying || !service.isAvailable() || status.isRecording || !control.audioModel) {
                return false;
            }
            control.getAudioPlayer().pause();
        };

        control.save = function() {
            control.onSaveComplete();
            service.refresh();
        };

        control.discard = function() {
            control.audioModel = null;
            control.elapsedTime = 0;
            control.elapsedTimeString = "00:00";
            service.refresh();
        };

        control.isHtml5 = function() {
            return service.isHtml5;
        };

        if (control.autoStart) {
            $timeout(function() {
                control.startRecord();
            }, 1000);
        }

        element.on('$destroy', function() {
            $interval.cancel(timing);
        });
    }
})();
;
'use strict';

angular.module('atheer')
    .directive('ngAudioRecorder', ['recorderService', '$timeout',
        function(recorderService, $timeout) {
            return {
                restrict: 'EA',
                scope: {
                    id: '@',
                    audioModel: '=',
                    onRecordStart: '&',
                    onRecordComplete: '&',
                    onPlaybackComplete: '&',
                    onPlaybackStart: '&',
                    onPlaybackPause: '&',
                    onPlaybackResume: '&',
                    onSaveComplete: '&',
                    showPlayer: '=?',
                    autoStart: '=?',
                    timeLimit: '=?'
                },
                controllerAs: 'recorder',
                bindToController: true,
                template: function(element, attrs) {
                    return '<div class="audioRecorder">' +
                        '<div style="width: 250px; margin: 0 auto;"><div id="audioRecorder-fwrecorder"></div></div>' +
                        element.html() +
                        '</div>';
                },
                controller: 'RecorderController',
                link: function(scope, element, attrs) {
                    $timeout(function() {
                        if (recorderService.isAvailable && !(recorderService.isHtml5 || recorderService.isCordova)) {}
                    }, 100);

                }
            };
        }
    ]);
;
'use strict';

angular.module('atheer')
    .directive('ngAudioRecorderWaveView', ['recorderService', 'recorderUtils', '$log',
        function(service, utils, $log) {

            return {
                restrict: 'E',
                require: '^ngAudioRecorder',
                link: function(scope, $element, attrs, recorder) {
                    if (!window.WaveSurfer) {
                        $log.warn('WaveSurfer was found.');
                        return;
                    }

                    var audioPlayer;
                    $element.html('<div class="waveSurfer"></div>');
                    var options = angular.extend({
                        container: $element.find('div')[0],
                        waveColor: 'violet',
                        progressColor: 'purple',
                        barHeight: 1,
                        barWidth: 5
                    }, attrs);
                    var waveSurfer = WaveSurfer.create(options);
                    waveSurfer.setVolume(0);
                    utils.appendActionToCallback(recorder, 'onPlaybackStart|onPlaybackResume', function() {
                        waveSurfer.play();
                    }, 'waveView');
                    utils.appendActionToCallback(recorder, 'onPlaybackComplete|onPlaybackPause', function() {
                        waveSurfer.pause();
                    }, 'waveView');

                    utils.appendActionToCallback(recorder, 'onRecordComplete', function() {
                        if (!audioPlayer) {
                            audioPlayer = recorder.getAudioPlayer();
                            audioPlayer.addEventListener('seeking', function(e) {
                                var progress = audioPlayer.currentTime / audioPlayer.duration;
                                waveSurfer.seekTo(progress);
                            });
                        }
                    }, 'waveView');


                    scope.$watch(function() {
                        return recorder.audioModel;
                    }, function(newBlob) {
                        if (newBlob instanceof Blob) {
                            waveSurfer.loadBlob(newBlob);
                        }
                    });
                }
            };
        }
    ]);
;
'use strict';

angular.module('atheer')
    .directive('ngAudioRecorderAnalyzer', ['recorderService', 'recorderUtils',
        function(service, utils) {

            var link = function(scope, element, attrs, recorder) {
                if (!service.isHtml5) {
                    scope.hide = true;
                    return;
                }

                var canvasWidth, canvasHeight, rafID, analyserContext, props = service.$html5AudioProps;
                var recording = false;

                function updateAnalysers(time) {
                    if (!analyserContext) {
                        var canvas = element.find("canvas")[0];

                        if (attrs.width && !isNaN(attrs.width)) {
                            canvas.width = attrs.width;
                        }

                        if (attrs.height && !isNaN(attrs.height)) {
                            canvas.height = parseInt(attrs.height);
                        }

                        canvasWidth = canvas.width;
                        canvasHeight = canvas.height;
                        analyserContext = canvas.getContext('2d');
                    }

                    if(recording) {
                        var SPACING = 5;
                        var BAR_WIDTH = 2;
                        var numBars = Math.round(canvasWidth / SPACING);
                        var freqByteData = new Uint8Array(props.analyserNode.frequencyBinCount);

                        props.analyserNode.getByteFrequencyData(freqByteData);

                        analyserContext.clearRect(0, 0, canvasWidth, canvasHeight);
                        //analyserContext.fillStyle = '#F6D565';
                        analyserContext.lineCap = 'round';
                        var multiplier = props.analyserNode.frequencyBinCount / numBars;

                        // Draw rectangle for each frequency bin.
                        for (var i = 0; i < numBars; ++i) {
                            var magnitude = 0;
                            var offset = Math.floor(i * multiplier);
                            // gotta sum/average the block, or we miss narrow-bandwidth spikes
                            for (var j = 0; j < multiplier; j++)
                                magnitude += freqByteData[offset + j];
                            magnitude = magnitude / multiplier;
                            var magnitude2 = freqByteData[i * multiplier];
                            if (attrs.waveColor)
                                analyserContext.fillStyle = attrs.waveColor;
                            else
                                analyserContext.fillStyle = "hsl( " + Math.round((i * 360) / numBars) + ", 100%, 50%)";
                            analyserContext.fillRect(i * SPACING, canvasHeight, BAR_WIDTH, -magnitude);
                        }
                    }

                    rafID = window.requestAnimationFrame(updateAnalysers);
                }

                function cancelAnalyserUpdates() {
                    window.cancelAnimationFrame(rafID);
                    rafID = null;
                    recording = false;
                }

                element.on('$destroy', function() {
                    cancelAnalyserUpdates();
                });

                recorder.onRecordStart = (function(original) {
                    return function() {
                        //original.apply();
                        recording = true;
                        updateAnalysers();
                    };
                })(recorder.onRecordStart);

                utils.appendActionToCallback(recorder, 'onRecordStart', updateAnalysers, 'analyzer');
                utils.appendActionToCallback(recorder, 'onRecordComplete', cancelAnalyserUpdates, 'analyzer');
            };

            return {
                restrict: 'E',
                require: '^ngAudioRecorder',
                template: '<div ng-if="!hide" class="audioRecorder-analyzer">' +
                    '<canvas class="analyzer" width="338" height="100" style="max-width: 100%;"></canvas>' +
                    '</div>',
                link: link
            };

        }
    ]);
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('fpRating', fpRating);

    function fpRating() {
        var directive = {
            scope: {
                rating: '=',
                maxRating: '@',
                readOnly: '@',
                click: "&",
                mouseHover: "&",
                mouseLeave: "&",
                shapeType: '@',
                color: '=',
                hoverTextArray: '='
            },
            controller: ratingController,
            restrict: 'EA',
            templateUrl: "core/components/rating/rating-directive.tmpl.html",
            compile: function(element, attrs) {
                if (!attrs.maxRating || (Number(attrs.maxRating) <= 0)) {
                    attrs.maxRating = '5';
                };
            }
        };
        return directive;
    }

    /* @ngInject */
    function ratingController($scope, $timeout, $mdToast, CloudUpload) {
        $scope.maxRatings = [];
        $scope.hoverValue = -1;

        if ($scope.rating) {
            $scope._rating = $scope.rating;
            $scope.hoverValue = 0;
        }

        for (var i = 1; i <= $scope.maxRating; i++) {
            $scope.maxRatings.push(i);
        };

        //$scope._rating = $scope.rating;
        $scope.ratingShape = {
            emptyIconClass: '',
            fullIconClass: ''
        };

        $scope.$watch('shapeType', function(newValue) {
            if (angular.lowercase(newValue) == 'heart') {
                $scope.ratingShape.emptyIconClass = "fa fa-heart-o";
                $scope.ratingShape.fullIconClass = "fa fa-heart";
            } else if (angular.lowercase(newValue) == 'circle') {
                $scope.ratingShape.emptyIconClass = "fa fa-circle-o";
                $scope.ratingShape.fullIconClass = "fa fa-circle";
            } else if (angular.lowercase(newValue) == 'star') {
                $scope.ratingShape.emptyIconClass = "fa fa-star-o";
                $scope.ratingShape.fullIconClass = "fa fa-star";
            } else if (angular.lowercase(newValue) == 'flag') {
                $scope.ratingShape.emptyIconClass = "fa fa-flag-o";
                $scope.ratingShape.fullIconClass = "fa fa-flag";
            }
        });

        $scope.$watch('maxRating', function(newValue, oldValue) {
            if (oldValue == newValue) return;
            $scope.maxRatings = [];
            for (var i = 1; i <= parseInt(newValue); i++) {
                $scope.maxRatings.push({});
            };
        });

        $scope.isolatedClick = function(param) {
            if ($scope.readOnly == 'true') return;
            $scope.rating = $scope._rating = param;
            $scope.hoverValue = 0;
            $scope.click({
                param: param
            });
        };

        $scope.isolatedMouseHover = function(param) {
            if ($scope.readOnly == 'true') return;
            $scope._rating = 0;
            $scope.hoverValue = param;
            $scope.mouseHover({
                param: param
            });
        };

        $scope.isolatedMouseLeave = function(param) {
            if ($scope.readOnly == 'true') return;
            $scope._rating = $scope.rating;
            $scope.hoverValue = 0;
            $scope.mouseLeave({
                param: param
            });
        };
    }
})();
;
(function() {

    'use strict';

    angular
        .module('atheer')
        .directive('fpPasswordStrength', fpPasswordStrength);

    function fpPasswordStrength() {
        var directive = {
            templateUrl: 'core/components/password/password-strength.tmpl.html',
            restrict: 'E',
            scope: {
                pwd: '=fpPasswordValue',
                value: '=strength'
            },
            link: function(scope /*, elem, attrs*/ ) {
                var
                    measureStrength = function(p) {
                        if (!p) return 0;

                        var strength = 0,
                            lower = p.match(/[a-z]/g),
                            upper = p.match(/[A-Z]/g),
                            numbers = p.match(/\d/g),
                            symbols = p.match(/[@#$-/:-?{-~!^_`\[\]]/g);
                        if (lower || p.length >= 8) {
                            strength += 25;
                        }
                        if (upper) {
                            strength += 25;
                        }
                        if (numbers) {
                            strength += 25;
                        }
                        if (symbols) {
                            strength += 25;
                        }

                        return strength;
                    },
                    getClass = function(s) {
                        switch (Math.round(s / 25)) {
                            case 0:
                                {
                                    return {
                                        value: 0,
                                        class: ''
                                    };
                                }
                            case 1:
                                {
                                    return {
                                        value: 1,
                                        class: 'weak'
                                    };
                                }
                            case 2:
                                {
                                    return {
                                        value: 2,
                                        class: 'so-so'
                                    };
                                }
                            case 3:
                                {
                                    return {
                                        value: 3,
                                        class: 'good'
                                    };
                                }
                            case 4:
                                {
                                    return {
                                        value: 4,
                                        class: 'strong'
                                    };
                                }
                        }
                    };

                scope.$watch('pwd', function() {
                    scope.value = measureStrength(scope.pwd);
                    scope.strengthObject = getClass(scope.value);
                });
            },
        };
        return directive;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .controller('NotificationsSideNavController', NotificationsSideNavController);

    /* @ngInject */
    function NotificationsSideNavController($scope, $http, $mdSidenav, $state) {
        var vm = this;
        // sets the current active tab
        vm.close = close;
        vm.currentTab = 0;
        vm.notificationGroups = [{
            name: 'Twitter',
            notifications: [{
                title: 'Mention from oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Followed by Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            }]
        },{
            name: 'Server',
            notifications: [{
                title: 'Server Down',
                icon: 'zmdi zmdi-alert-circle',
                iconColor: 'rgb(244, 67, 54)',
                date: moment().startOf('hour')
            },{
                title: 'Slow Response Time',
                icon: 'zmdi zmdi-alert-triangle',
                iconColor: 'rgb(255, 152, 0)',
                date: moment().startOf('hour')
            },{
                title: 'Server Down',
                icon: 'zmdi zmdi-alert-circle',
                iconColor: 'rgb(244, 67, 54)',
                date: moment().startOf('hour')
            }]
        },{
            name: 'Sales',
            notifications: [{
                title: 'Storm Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Storm WordPress $60',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Storm Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Storm Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Lambda WordPress $60',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Storm Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            }]
        }];

        vm.settingsGroups = [{
            name: 'Account Settings',
            settings: [{
                title: 'Show my location',
                icon: 'zmdi zmdi-pin',
                enabled: true
            },{
                title: 'Show my avatar',
                icon: 'zmdi zmdi-face',
                enabled: false
            },{
                title: 'Send me notifications',
                icon: 'zmdi zmdi-notifications-active',
                enabled: true
            }]
        },{
            name: 'Conversation Settings',
            settings: [{
                title: 'Show my username',
                icon: 'zmdi zmdi-account',
                enabled: true
            },{
                title: 'Make my profile public',
                icon: 'zmdi zmdi-account-box',
                enabled: false
            },{
                title: 'Allow cloud backups',
                icon: 'zmdi zmdi-cloud-upload',
                enabled: true
            }]
        }];

        vm.statisticsGroups = [{
            name: 'User Statistics',
            stats: [{
                title: 'Storage Space (120/160 Gb)',
                mdClass: 'md-primary',
                value: 60
            },{
                title: 'Bandwidth Usage (10/100 Gb)',
                mdClass: 'md-accent',
                value: 10
            },{
                title: 'Memory Usage (1/8 Gb)',
                mdClass: 'md-warn',
                value: 100
            }]
        },{
            name: 'Server Statistics',
            stats: [{
                title: 'Storage Space (120/160 Gb)',
                mdClass: 'md-primary',
                value: 60
            },{
                title: 'Bandwidth Usage (10/100 Gb)',
                mdClass: 'md-accent',
                value: 10
            },{
                title: 'Memory Usage (1/8 Gb)',
                mdClass: 'md-warn',
                value: 100
            }]
        }];

        ////////////////

        // add an event to switch tabs (used when user clicks a menu item before sidebar opens)
        $scope.$on('triSwitchNotificationTab', function($event, tab) {
            vm.currentTab = tab;
        });

        function close() {
            $mdSidenav('notifications').close();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('fpNotificationCount', fpNotificationCount);

    function fpNotificationCount() {
        var directive = {
            controller: notificationCountController,
            restrict: 'EA',
            templateUrl: "core/components/notification-count/notification-count-directive.tmpl.html"
        };
        return directive;
    }

    /* @ngInject */
    function notificationCountController($scope, $q, $timeout, $mdToast, Foryou) {
        $scope.notificationCount = 0;

        function init() {
            $q.all([
                Foryou.get().$promise
            ]).then(function(data) {
                //getting assignment data
                $scope.notificationCount = data[0].todos_count;

                if(data[0].questions && data[0].questions.length > 0) {
                    $scope.notificationCount = $scope.notificationCount + data[0].questions.length;
                };
            }).catch(function(data) {}).finally(function() {});
        }
        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .provider('triMenu', menuProvider);


    /* @ngInject */
    function menuProvider() {
        // Provider
        var menuArray = [];
        var menuInfo = {};

        this.addMenu = addMenu;
        this.removeMenu = removeMenu;
        this.removeAllMenu = removeAllMenu;
        this.isTabMenu = isTabMenu;
        this.getMenu = getMenu;
        this.getIndex = getIndex;

        function addMenu(item) {
            menuArray.push(item);
            createMenuInfo(item, item.type, item, 0);
        }

        function createMenuInfo(item, type, mainMenu, index) {
            menuInfo[item.state] = {
                type: type,
                menu: mainMenu,
                index: index
            };

            if (angular.isDefined(item.children)) {
                var i = 0;
                angular.forEach(item.children, function(children) {
                    createMenuInfo(children, type, mainMenu, i++);
                });
            }
        }

        function removeAllMenu() {
            for (var i = menuArray.length - 1; i >= 0; i--) {
                menuArray.splice(i, 1);
            }
        }

        function getIndex(state) {
            if (menuInfo[state]) {
                return menuInfo[state].index;
            } else {
                return;
            }
        }

        function getMenu(state) {
            if (menuInfo[state]) {
                return menuInfo[state].menu;
            } else {
                return;
            }
        }

        function isTabMenu(state) {
            if (menuInfo[state]) {
                return menuInfo[state].type == 'tab';
            } else {
                return;
            }
        }

        function removeMenu(state, params) {
            findAndDestroyMenu(menuArray, state, params);
        }

        function findAndDestroyMenu(menu, state, params, isChildren) {
            if (menu instanceof Array) {
                for (var i = menu.length - 1; i >= 0; i--) {
                    if (menu[i].state === state && angular.equals(menu[i].params, params)) {
                        menu.splice(i, 1);
                        if (!isNaN(isChildren) && !menuArray[isChildren].children.length) {
                            menuArray.splice(isChildren, 1);
                        }
                        break;
                    } else if (angular.isDefined(menu[i].children)) {
                        findAndDestroyMenu(menu[i].children, state, params, i);
                    }
                }
            }
        }

        // Service
        this.$get = function() {
            return {
                menu: menuArray,
                addMenu: addMenu,
                removeMenu: removeMenu,
                removeAllMenu: removeAllMenu,
                isTabMenu: isTabMenu,
                getMenu: getMenu,
                getIndex: getIndex
            };
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triMenu', triMenuDirective);

    /* @ngInject */
    function triMenuDirective($location, $mdTheming, triTheming) {
        var directive = {
            restrict: 'E',
            template: '<md-toolbar><tri-menu-item ng-repeat="item in triMenuController.menu | orderBy:\'priority\'" item="::item"></tri-menu-item></md-toolbar>',
            scope: {},
            controller: triMenuController,
            controllerAs: 'triMenuController',
            link: link
        };
        return directive;

        function link($scope, $element) {
            $mdTheming($element);
            var $mdTheme = $element.controller('mdTheme'); //eslint-disable-line

            var menuColor = triTheming.getThemeHue($mdTheme.$mdTheme, 'primary', 'default');
            var menuColorRGBA = triTheming.rgba(menuColor.value);
            $element.css({ 'background-color': menuColorRGBA });
            $element.children('md-content').css({ 'background-color': menuColorRGBA });
        }
    }

    /* @ngInject */
    function triMenuController(triMenu) {
        var triMenuController = this;
        // get the menu and order it
        triMenuController.menu = triMenu.menu;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triMenuItem', triMenuItemDirective);

    /* @ngInject */
    function triMenuItemDirective() {
        var directive = {
            restrict: 'E',
            require: '^triMenu',
            scope: {
                item: '='
            },
            // replace: true,
            template: '<div ng-if="triMenuItem.isActive" permission permission-only="triMenuItem.item.permission" ng-include="::triMenuItem.item.template"></div>',
            controller: triMenuItemController,
            controllerAs: 'triMenuItem',
            bindToController: true
        };
        return directive;
    }

    /* @ngInject */
    function triMenuItemController($rootScope, $scope, $mdSidenav, $state, $filter, $location, triBreadcrumbsService, Feature, PermissionService, triSettings, triTheming) {
        var triMenuItem = this;

        triMenuItem.isActive = isFeatureActive();
        triMenuItem.primaryColor = triSettings.getSkinModel().primary_color_hex;
        triMenuItem.subMenus = [];

        $scope.backgroundColor = triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '100').hex;

        // load a template for this directive based on the type ( link | dropdown )
        triMenuItem.item.template = 'core/components/menu/menu-item.tmpl.html';

        triMenuItem.subMenuOpen = subMenuOpen;
        switch (triMenuItem.item.type) {
            case 'dropdown':
                // if we have kids reorder them by priority
                triMenuItem.item.children = $filter('orderBy')(triMenuItem.item.children, 'priority');
                triMenuItem.toggleDropdownMenu = toggleDropdownMenu;
                // add a check for open event
                $scope.$on('toggleDropdownMenu', function (event, item, open) {
                    // if this is the item we are looking for
                    if (triMenuItem.item === item) {
                        triMenuItem.item.open = open;
                    } else {
                        triMenuItem.item.open = false;
                    }
                });

                // this event is emitted up the tree to open parent menus
                $scope.$on('openParents', function () {
                    // openParents event so open the parent item
                    triMenuItem.item.open = true;
                    // also add this to the breadcrumbs
                    triBreadcrumbsService.addCrumb(triMenuItem.item);
                });
                break;
            case 'link':
                triMenuItem.openLink = openLink;

                // on init check if this is current menu
                checkItemActive($state.current.name, $state.params);

                $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
                    checkItemActive(toState.name, toParams);
                });
                break;
            case 'tab':
                triMenuItem.openLink = openLink;

                // on init check if this is current menu
                checkItemActive($state.current.name, $state.params);

                $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
                    checkItemActive(toState.name, toParams);
                });
                break;
            case 'menu':
                $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
                    if (toState.name.startsWith('storm.admin-airsdk')) {
                        $rootScope.selectedLeftNavMenu = 'airsdk';
                    } else if (toState.name.startsWith('storm.insights.adv-dashboards')) {
                        $rootScope.selectedLeftNavMenu = 'insights';
                    } else if (toState.name.startsWith('storm.admin-setting')) {
                        $rootScope.selectedLeftNavMenu = 'settings';
                    } else if (toState.name.startsWith('storm.sessions')) {
                        $rootScope.selectedLeftNavMenu = 'airsessions';
                    } else if (toState.name.startsWith('storm.conversations')) {
                        $rootScope.selectedLeftNavMenu = 'conversations';
                    } else if (toState.name.startsWith('storm.admin-users')) {
                        $rootScope.selectedLeftNavMenu = 'users';
                    } else if (toState.name.startsWith('storm.admin-teams')) {
                        $rootScope.selectedLeftNavMenu = 'users';
                    } else if (toState.name.startsWith('storm.admin-contents')) {
                        $rootScope.selectedLeftNavMenu = 'library';
                    } else if (toState.name.startsWith('storm.content-documents')) {
                        $rootScope.selectedLeftNavMenu = 'library';
                    }
                });

                for (var i = 0; i < triMenuItem.item.children.length; i++) {
                    var hasAccess = true;
                    var featureEnabled = true;

                    if (angular.isDefined(triMenuItem.item.children[i].feature)) {
                        featureEnabled = Feature.isActive(triMenuItem.item.children[i].feature);
                    }

                    if (featureEnabled && angular.isDefined(triMenuItem.item.children[i].permission)) {
                        hasAccess = PermissionService.hasAccess(triMenuItem.item.children[i].permission);
                    } else if (!featureEnabled) {
                        hasAccess = false;
                    };

                    if (hasAccess) {
                        triMenuItem.subMenus.push(triMenuItem.item.children[i]);
                    }
                };

                break;
        }

        function isFeatureActive() {
            if (angular.isDefined(triMenuItem.item.feature)) {
                return Feature.isActive(triMenuItem.item.feature);
            } else {
                return true;
            }
        }

        function checkItemActive() {
            triMenuItem.item.active = $state.includes(triMenuItem.item.state, triMenuItem.item.params);
            // if we are now the active item reset the breadcrumbs and open all parent dropdown items
            if (triMenuItem.item.active) {
                $scope.$emit('toggleLeftHandMenu', triMenuItem.item, false);
            }
        }

        function toggleDropdownMenu() {
            $scope.$parent.$parent.$broadcast('toggleDropdownMenu', triMenuItem.item, !triMenuItem.item.open);
        }

        function openLink() {
            sessionStorage.removeItem('objectHeader');
            sessionStorage.removeItem('objectMenu');
            sessionStorage.removeItem('objectFilters');
            if (!$rootScope.isJobExecutionActive) {
                $rootScope.selectedLeftNavMenu = triMenuItem.item.id;
                var params = angular.isUndefined(triMenuItem.item.params) ? {} : triMenuItem.item.params;
                $state.go(triMenuItem.item.state, params);
                triMenuItem.item.active = true;
                $mdSidenav('left').close();
            } else {
                var params = angular.isUndefined(triMenuItem.item.params) ? {} : triMenuItem.item.params;
                $state.go(triMenuItem.item.state, params);
            }
        }

        function subMenuOpen(menuItem) {
            sessionStorage.removeItem('objectHeader');
            sessionStorage.removeItem('objectMenu');
            sessionStorage.removeItem('objectFilters');
            $state.go(menuItem.state);
        }

        function leftSideNavOpen() {
            $scope.sideBarOpen = true;
        }

        function leftSideNavClose() {
            $scope.sideBarOpen = false;
        }

        function messagesCount(event, count) {
            triMenuItem.count = count;
        }

        // register listeners for loader
        $scope.$on('leftSideNavOpen', leftSideNavOpen);

        // register listeners for loader
        $scope.$on('leftSideNavClose', leftSideNavClose);

        $rootScope.$on('messageCount', messagesCount);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .controller('LoaderController', LoaderController);

    /* @ngInject */
    function LoaderController(triSettings) {
        var vm = this;

        vm.triSettings = triSettings;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .factory('triLoaderService', LoaderService);

    /* @ngInject */
    function LoaderService($rootScope) {
        var queue = [];

        return {
            isActive: isActive,
            setLoaderActive: setLoaderActive
        };

        function isActive() {
            return queue.length !== 0;
        }

        function setLoaderActive(setActive) {
            if (setActive) {
                queue.push(true);
            } else {
                queue.shift();
            }
            $rootScope.$broadcast('loader', isActive());
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.core')
        .controller('LeftSidenavController', LeftSidenavController);

    /* @ngInject */
    function LeftSidenavController($rootScope, $state, $scope, $location, triSettings, triLayout, $mdUtil, $mdSidenav, Principal, Auth, Feature, $window) {
        var vm = this;

        vm.layout = triLayout.layout;
        vm.sidebarInfo = {
            appName: triSettings.name,
            appLogoBig: triSettings.getLogoBig(),
            appLogoSmall: triSettings.getLogoSmall(),
            menuState: triSettings.getSkinModel().side_menu_state,
            logoRight: triSettings.getSkinModel().logo_right
        };

        vm.logOut = logOut;
        vm.goHome = goHome;
        vm.showHelp = showHelp;
        vm.isWorkspaceAdmin = false;
        vm.menuOffset = 50;
        vm.isMasterWorkspace = $rootScope.isMasterWorkspace;
        vm.showHelpCenter = false; // Feature.isActive('feature_studio-settings_help_center');
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.settingPermission = ['manage-setting-system'];
        ////////////
        if (!$location.path().startsWith('/deeplink/sessions')) {
            Principal.identity().then(function (user) {
                setUserInfo(user);
            });
        }

        function showHelp() {
            $window.open('https://frontlineos-atheer.zendesk.com/hc/en-us', '_blank');
        };

        function goHome() {
            var navPath = $rootScope.isMasterWorkspace ? $rootScope.baseHome : '/home';
            $rootScope.selectedLeftNavMenu = $rootScope.isMasterWorkspace ? $rootScope.baseLeftNavMenu : 'home';
            $location.path(navPath);
        };

        function setUserInfo(user) {
            vm.currentUser = {
                id: user.id,
                first_name: user.first_name,
                last_name: user.last_name,
                displayName: user.first_name + ' ' + user.last_name,
                initials: user.first_name.charAt(0) + user.last_name.charAt(0),
                userName: user.first_name,
                picture_id: user.picture_id
            };
            vm.user = user;
            if (Principal.isWorkspaceAdmin()) {
                vm.isWorkspaceAdmin = true;
            }
        };

        function logOut() {
            Auth.logout();
            $state.go('account.signout');
        };

        vm.toggleToolBarMenu = function (menu, submenu) {
            $rootScope.isQR = submenu ? true : false;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('illustrationEmptyScreen', illustrationEmptyScreen);

    /* @ngInject */
    function illustrationEmptyScreen() {
        var directive = {
            restrict: 'E',
            controller: illustrationEmptyScreenController,
            bindToController: true,
            scope: {
                id: '=',
                name: '=',
                callback: '='
            },
            templateUrl: 'core/components/illustration/illustration-empty-screen.html',
            controllerAs: 'vm'
        };

        return directive;
    }

    /* @ngInject */
    function illustrationEmptyScreenController($scope, $sce, $timeout, $state, $attrs, $injector, $filter, $q, $mdDialog) {
        var vm = this;

        vm.modules = {
            air_forms : {
                imgSrc: "/assets/images/card/No_AiRForms.png",
                title: "Create your first AiRForm",
                textMsg1: "Atheer AiRForms allow you to rapidly create and share<br/>anything from work instructions, step by step guidance,<br/> checklists, surveys to full blown apps, without needing to<br/>write a single line of code.",
                button: "Let's begin!",
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_airforms : {
                imgSrc: "/assets/images/card/No_AiRForms.png",
                title: $filter('translate')('illustrationEmptyScreen.noAirForms.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            conversation : {
                imgSrc: "/assets/images/card/FirstTime_Conversations.png",
                title: $filter('translate')('illustrationEmptyScreen.conversation.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.conversation.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            message : {
                imgSrc: "/assets/images/card/NoMessages.png",
                title: $filter('translate')('illustrationEmptyScreen.message.title') + "Name",
                textMsg1: $filter('translate')('illustrationEmptyScreen.message.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            group_conv : {
                imgSrc: "/assets/images/card/No_Groups.png",
                title: $filter('translate')('illustrationEmptyScreen.groupConv.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            session_chat : {
                imgSrc: "/assets/images/card/NoMessages.png",
                title: $filter('translate')('illustrationEmptyScreen.sessionChat.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            session_upcoming : {
                imgSrc: "/assets/images/card/FirstTime_Sessions.png",
                title: $filter('translate')('illustrationEmptyScreen.sessionUpcoming.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.sessionUpcoming.textMsg1'),
                textMsg2: $filter('translate')('illustrationEmptyScreen.sessionUpcoming.textMsg2'),
                bold: true,
                state_param: null
            },
            session_past : {
                imgSrc: "/assets/images/card/FirstTime_Sessions.png",
                title: $filter('translate')('illustrationEmptyScreen.sessionPast.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.sessionPast.textMsg1'),
                button: $filter('translate')('illustrationEmptyScreen.sessionPast.button'),
                create : "create-session",
                bold: true,
                state: "storm.sessions.upcoming-detail",
                state_param: null
            },
            session_all : {
                imgSrc: "/assets/images/card/FirstTime_Sessions.png",
                title: "",
                textMsg1: $filter('translate')('illustrationEmptyScreen.sessionAll.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            session_template : {
                imgSrc: "/assets/images/card/No_Templates_session.png",
                title: $filter('translate')('illustrationEmptyScreen.sessionTemplate.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.sessionTemplate.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            content : {
                imgSrc: "/assets/images/card/FirstTime_Content.png",
                title: $filter('translate')('illustrationEmptyScreen.content.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.content.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_content : {
                imgSrc: "/assets/images/card/NoContent.png",
                title: $filter('translate')('illustrationEmptyScreen.noContent.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            topic : {
                imgSrc: "/assets/images/card/No_Topics.png",
                title: $filter('translate')('illustrationEmptyScreen.topic.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.topic.textMsg1'),
                button: $filter('translate')('illustrationEmptyScreen.topic.button'),
                create : null,
                bold: true,
                state: "storm.admin-topic-detail",
                state_param: {
                    'topicType': 'STATIC',
                    'parentTopic': null
                }
            },
            team : {
                imgSrc: "/assets/images/card/No_Topics.png",
                title: $filter('translate')('illustrationEmptyScreen.team.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.team.textMsg1'),
                button: $filter('translate')('illustrationEmptyScreen.team.button'),
                create : null,
                bold: true,
                state: "storm.admin-team-detail",
                state_param: {
                    'type': 'STATIC'
                }
            },
            dashboard : {
                imgSrc: "/assets/images/card/dashboards-hero.png",
                title: $filter('translate')('illustrationEmptyScreen.dashboard.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.dashboard.textMsg1'),
                create : null,
                bold: true,
                state: "storm.admin-dashboard-detail",
                state_param: {
                    'type': 'STATIC'
                }
            },
            smart_flow : {
                imgSrc: "/assets/images/card/No_SmartFlows@2x.png",
                title: $filter('translate')('illustrationEmptyScreen.smartFlow.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.smartFlow.textMsg1'),
                button: $filter('translate')('illustrationEmptyScreen.smartFlow.button'),
                createPermission : 'create-workflow',
                bold: true,
                state: "storm.admin-smartflow-detail",
                state_param: { 'isJobFlow': true }
            },
            no_smart_flow : {
                imgSrc: "/assets/images/card/NoSmartFlows.png",
                title: $filter('translate')('illustrationEmptyScreen.noSmartFlow.title'),
                textMsg1: "",
                button: null,
                createPermission : 'create-workflow',
                bold: true,
                state: "storm.admin-smartflow-detail",
                state_param: null
            },
            smart_scan : {
                imgSrc: "/assets/images/card/NewBottomAlignTrial.png",
                title: $filter('translate')('illustrationEmptyScreen.smartScan.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.smartScan.textMsg1'),
                button: $filter('translate')('illustrationEmptyScreen.smartScan.button'),
                create : null,
                bold: true,
                state: "storm.admin-smartscan-detail",
                state_param: null
            },
            web_hooks : {
                imgSrc: "/assets/images/card/web-hook-empty-screen-illustration.svg",
                title: $filter('translate')('illustrationEmptyScreen.webHook.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.webHook.textMsg1'),
                button: $filter('translate')('illustrationEmptyScreen.webHook.button'),
                create : null,
                bold: true,
                state: "storm.admin-airsdk-web-hook-detail",
                state_param: null
            },
            web_hooks_logs : {
                imgSrc: "/assets/images/card/web-hook-empty-screen-illustration.svg",
                title: $filter('translate')('illustrationEmptyScreen.webHookLogs.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.webHookLogs.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: "storm.admin-airsdk-web-hook-detail",
                state_param: null
            },
            no_smart_scan : {
                imgSrc: "/assets/images/card/No_SmartScans@2x.png",
                title: $filter('translate')('illustrationEmptyScreen.noSmartScan.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.noSmartScan.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: "storm.admin-smartscan-detail",
                state_param: null
            },
            users : {
                imgSrc: "/assets/images/card/NoUsers.png",
                title: $filter('translate')('illustrationEmptyScreen.users.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            security_role_user: {
                imgSrc: "/assets/images/card/NoUsers.png",
                title: $filter('translate')('illustrationEmptyScreen.securityRoleUser.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            badge : {
                imgSrc: "/assets/images/card/No_Badges.png",
                title: $filter('translate')('illustrationEmptyScreen.badge.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            insight_graph : {
                imgSrc: "/assets/images/card/No_insights.png",
                title: "Not enough activity yet",
                textMsg1: "",
                button: null,
                create : null,
                bold: false,
                state: null,
                state_param: null,

            },
            no_Problem : {
                imgSrc: "/assets/images/card/No_Problems@2x.png",
                title: $filter('translate')('illustrationEmptyScreen.noProblem.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.noProblem.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null,

            },
            no_rating : {
                imgSrc: "/assets/images/card/No_Ratings.png",
                title: $filter('translate')('illustrationEmptyScreen.noRating.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.noRating.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null,

            },
            no_content_smartscan : {
                imgSrc: "/assets/images/card/no_content_smartscan.png",
                title: $filter('translate')('illustrationEmptyScreen.noContentSmartScan.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_airform_smartscan : {
                imgSrc: "/assets/images/card/no_smartscan_airform.png",
                title: $filter('translate')('illustrationEmptyScreen.noAirFormSmartScan.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_user_smartscan : {
                imgSrc: "/assets/images/card/no_smartscan_user.png",
                title: $filter('translate')('illustrationEmptyScreen.noUserSmartScan.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_user_team : {
                imgSrc: "/assets/images/card/no_smartscan_user.png",
                title: $filter('translate')('illustrationEmptyScreen.noUserSmartScan.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_users_session : {
                imgSrc: "/assets/images/card/NoUsers.png",
                title: $filter('translate')('illustrationEmptyScreen.noSessionUsers.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.noSessionUsers.textMsg1'),
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_users_search : {
                imgSrc: "/assets/images/card/NoUsers.png",
                title: $filter('translate')('illustrationEmptyScreen.noUserSearch.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            upcoming_no_scheduled_session: {
                imgSrc: "/assets/images/card/FirstTime_Sessions.png",
                title: $filter('translate')('illustrationEmptyScreen.upcomingNoScheduled.title'),
                textMsg1: $filter('translate')('illustrationEmptyScreen.upcomingNoScheduled.textMsg1'),
                button: null,
                create: null,
                bold: true,
                state: null,
                state_param: null
            },
            upcoming_no_session: {
                imgSrc: "/assets/images/card/FirstTime_Sessions.png",
                title: "",
                textMsg1: $filter('translate')('illustrationEmptyScreen.upcomingNoSession.textMsg1'),
                button: null,
                create: null,
                bold: true,
                state: null,
                state_param: null
            },
            user_import: {
                imgSrc: "/assets/images/card/PeopleIllustration.png",
                title: "",
                textMsg1: "",
                button: null,
                create: null,
                bold: true,
                state: null,
                state_param: null
            },
            no_content_anchor : {
                imgSrc: "/assets/images/card/no_content_smartscan.png",
                title: $filter('translate')('illustrationEmptyScreen.noContentAnchor.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_airform_anchor : {
                imgSrc: "/assets/images/card/no_smartscan_airform.png",
                title: $filter('translate')('illustrationEmptyScreen.noAirFormAnchor.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            no_user_anchor : {
                imgSrc: "/assets/images/card/no_smartscan_user.png",
                title: $filter('translate')('illustrationEmptyScreen.noUserAnchor.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
            anchor : {
                imgSrc: "/assets/images/card/No_Badges.png",
                title: $filter('translate')('illustrationEmptyScreen.badge.title'),
                textMsg1: "",
                button: null,
                create : null,
                bold: true,
                state: null,
                state_param: null
            },
        }


        if (vm.id == 'message') {
            vm.modules[vm.id].title= vm.modules[vm.id].title.replace("Name", vm.name);
            vm.modules[vm.id].textMsg1 = vm.modules[vm.id].textMsg1.replace("Name", vm.name);
        }

        vm.imgSrc = vm.modules[vm.id].imgSrc;
        vm.permission = vm.modules[vm.id].create;
        vm.addButton = vm.modules[vm.id].button == null ? false : true;
        vm.button = vm.modules[vm.id].button;
        vm.permisson = vm.modules[vm.id].createPermission;

        var className = (vm.id == 'web_hooks' || vm.id == 'web_hooks_logs') ? 'fp-illustration-description' : '';
        if (vm.modules[vm.id].bold == true) {
            vm.html = '<span align="center" class="md-title margin-bottom-20">' + vm.modules[vm.id].title + '</span><span align="center" class="md-subhead'+ className +'">' + vm.modules[vm.id].textMsg1 + '</span>';
        } else if (vm.modules[vm.id].bold == false) {
            vm.html = '<span align="center"  class="margin-top-10 main">' + vm.modules[vm.id].title + '</span><span align="center" class="md-subhead'+ className +'">' + vm.modules[vm.id].textMsg1 + '</span>';
        }

        vm.trustedHtml = $sce.trustAsHtml(vm.html);


        if (vm.modules[vm.id].state_param == null) {
            vm.goState = function() {
                $state.go(vm.modules[vm.id].state);
            }
        } else {
            vm.goState = function() {
                $state.go(vm.modules[vm.id].state, vm.modules[vm.id].state_param);
            }
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer')
        .directive('fpHelp', fpHelp)

    function fpHelp() {
        var directive = {
            restrict: 'E',
            scope: {
                'key': '@'
            },
            controller: helpDirectiveController,
            controllerAs: 'vm',
            templateUrl: 'core/components/help/help.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function helpDirectiveController($scope, $timeout, $window, Feature) {
        var vm = this;
        vm.showHelpCenter = false; // Feature.isActive('feature_studio-settings_help_center');
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer')
        .directive('fpHeader', fpHeader);

    function fpHeader() {
        return {
            restrict: 'E',
            scope: {
                isPublicUser: '=',
                pageName: '=',
                userInfo: '=',
                title: '='
            },
            templateUrl: 'core/components/header/header.tmpl.html',
            controller: headerController,
            controllerAs: 'vm'
        }
    }

    /* @ngInject */
    function headerController($scope, $state, $window, Feature, Auth, deviceDetector, triSettings) {
        var vm = this;
        vm.isPublicUser = $scope.isPublicUser;
        vm.pageName = $scope.pageName;
        vm.isMobileBrowser = !deviceDetector.isDesktop();
        vm.triSettings = triSettings;
        vm.userInfo = $scope.userInfo;
        $scope.bgColor = vm.isPublicUser ? triSettings.getSkinModel().primary_color_hex : (vm.pageName !== 'Home' ? '#ffffff' : triSettings.getSkinModel().primary_color_hex);
        vm.signUpEnabled = Feature.isActive('feature_user_signup');
        vm.logout = function () {
            Auth.logout();
            $state.go('account.signout');
        };

        vm.navigateHome = function () {
            $state.go('storm.home');
        };
    }

})();;
(function () {
    'use strict';

    angular
        .module('atheer')
        .config(customFormlyConfig);

    /* @ngInject */
    function customFormlyConfig(formlyConfigProvider) {
        formlyConfigProvider.setType({
            name: 'objectpicker',
            templateUrl: 'core/components/formly/formly-custom-object-picker.tmpl.html'
        });

        formlyConfigProvider.setType({
            name: 'boolean-switch',
            templateUrl: 'core/components/formly/formly-custom-switch-boolean.tmpl.html'
        });

        formlyConfigProvider.setType({
            name: 'custom-datepicker',
            templateUrl: 'core/components/formly/formly-custom-datepicker.tmpl.html'
        });

        formlyConfigProvider.setType({
            name: 'custom-select',
            templateUrl: 'core/components/formly/formly-custom-select.tmpl.html'
        });

        formlyConfigProvider.setType({
            name: 'custom-chips',
            templateUrl: 'core/components/formly/formly-custom-chips.tmpl.html'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';
    angular
        .module('atheer')
        .directive('fpFooter', fpFooter)

    function fpFooter() {
        var directive = {
            restrict: 'E',
            scope: {
                'key': '@'
            },
            controller: footerDirectiveController,
            controllerAs: 'vm',
            templateUrl: 'core/components/footer/footer.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function footerDirectiveController($rootScope, $scope, $timeout, $window, Feature, deviceDetector, $location) {
        var vm = this;
        vm.showTermsAndPrivacy = true;
        vm.poweredByLink = "http://www.atheerair.com/";

        vm.termsLink = "http://www.atheerair.com/";
        vm.privacyLink = "https://www.atheerair.com/privacy-policy/";

        if($rootScope.companySetting) {
            vm.termsLink = $rootScope.companySetting.terms_url;
            vm.privacyLink = $rootScope.companySetting.privacy_policy_url;
        };

        var host = $location.host();
        if (angular.isDefined(host) && host.startsWith("rigpartner.")) {
            vm.termsLink = "https://rigquip.com/terms-conditions/";
            vm.privacyLink = "https://rigquip.com/privacy-policy/";
        };

        vm.buildInfoSettings = $rootScope.buildInfo;
        vm.isMobileBrowser = deviceDetector.isMobile();
        vm.showPoweredBy = Feature.isActive('feature_system_show_powered_by');

        if($location.path().startsWith('/join')) {
            vm.showTermsAndPrivacy =  false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('MatchSelectionPanelController', MatchSelectionPanelController);

    /* @ngInject */
    function MatchSelectionPanelController(mdPanelRef, $scope, $state, $mdDialog, $q, $filter, $mdToast, Principal, $mdPanel, FIELD_CONDITION_CONSTANT) {
        var vm = this;

        vm.matchType = 'all';

        vm.selectMatchType = function(matchType) {
            mdPanelRef.matchAll = matchType;
            mdPanelRef.close();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('FilterDetailDialogController', FilterDetailDialogController);

    /* @ngInject */
    function FilterDetailDialogController($scope, $state, $mdDialog, $q, $filter, $mdToast, $timeout, Filter, mode, object, filter) {
        var vm = this;

        vm.mode = mode;
        vm.object = object;

        vm.filterModel = {
            name: null,
            description: null
        };

        if (filter != null) {
            vm.filterModel = {
                name: filter.name,
                description: filter.desription
            };
        }

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.submit = function() {
            $mdDialog.hide(vm.filterModel);
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer')
        .directive('fpFilterBuilder', fpFilterBuilder);

    function fpFilterBuilder() {
        return {
            restrict: 'AE',
            templateUrl: 'core/components/filter/filter-builder.tmpl.html',
            controller: FilterBuilderDirectiveController,
            scope: {
                'object': '@',
                'label': '@',
                'icon': '@'
            },
        };
    }

    function FilterBuilderDirectiveController($rootScope, $scope, $q, ParseLinks, $mdSidenav, AlertService, $mdToast, $element, $filter, $mdDialog, MetaData, Setting, Filter, FIELD_CONDITION_CONSTANT, DateUtils, $mdPanel, $timeout, triSettings) {

        $scope.primaryColor = triSettings.getSkinModel().primary_color_hex;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        $scope.matchSelected = false;

        $scope.timezones = [];
        $scope.languages = [];
        $scope.metaFieldGroups = [];
        $scope.filters = null;

        $scope.selectedFilter = null;
        $scope.filterDetail = null;
        $scope.hasNewFilter = false;

        $scope.selectedCondition = null;

        function getDateFromItem(item) {
            return item.x;
        }

        $scope.refreshFilter = function() {
            if ($scope.hasNewFilter) {
                $scope.filters.pop();
                $scope.hasNewFilter = false;
            }
            initFilter($scope.selectedFilter);
        };

        $scope.showDelete = function(filterInfo) {
            if (filterInfo.filter_no != 1000 && filterInfo.id != null) {
                return true;
            } else {
                return false;
            }
        }

        $scope.showActions = function(filterInfo) {
            if (filterInfo.filter_no != 1000 && filterInfo.id != null) {
                return true;
            } else {
                return false;
            }
        }

        $scope.showReset = function(filterInfo) {
            if (filterInfo != null) {
                if (filterInfo.filter_no == 1000) {
                    return false;
                } else if (filterInfo.id == null) {
                    return true;
                } else if ($rootScope._.isEqual(angular.toJson(filterInfo), angular.toJson($scope.selectedFilter))) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }

        $scope.showSave = function(filterInfo) {
            if (filterInfo != null) {
                if (filterInfo.filter_no == 1000) {
                    return false;
                } else if (filterInfo.id == null && filterInfo.criteria.condition_groups.length > 0) {
                    return true;
                } else if ($rootScope._.isEqual(angular.toJson(filterInfo), angular.toJson($scope.selectedFilter))) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }

        $scope.resetFilter = function() {
            if ($scope.hasNewFilter) {
                $scope.filters.pop();
                $scope.hasNewFilter = false;
                angular.forEach($scope.filters, function(filterInfo) {
                    if (filterInfo.filter_no == 1000) {
                        initFilter(filterInfo);
                    }
                });
            } else {
                initFilter($scope.selectedFilter);
            };
        };

        $scope.isDefaultFilter = function(filterInfo) {
            if (filterInfo.filter_no == 1000) {
                return true;
            } else {
                return false;
            }
        };

        $scope.getFieldLabel = function(condition) {
            var label = null;
            var fieldGroupMeta = $filter('filter')($scope.metaFieldGroups, {
                'name': condition.field_group_name
            })[0];
            var fieldMeta = $filter('filter')(fieldGroupMeta.fields, {
                'name': condition.field_name
            })[0];

            var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                value: condition.operator
            }, true)[0];

            if (condition.field_group_name == 'profile') {
                label = fieldMeta.label + ' ' + $filter('translate')(operator.label);
            } else {
                label = fieldGroupMeta.label + ':' + fieldMeta.label + ' ' + $filter('translate')(operator.label);
            }

            if (condition.value != null) {
                label = label + ' ' + getFieldDisplayValue(condition);
            };
            return label;
        };

        $scope.getConditionBackgroundColor = function(condition, conditionFocus) {
            if ($scope.isMissingValue(condition)) {
                return $scope.secondaryColor;
            }

            if (condition == $scope.selectedCondition) {
                return $scope.primaryColor;
            }
        };

        $scope.isMissingValue = function(condition) {
            var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                value: condition.operator
            }, true)[0];

            if (operator.showInput && (condition.value == null || condition.value.length <= 0)) {
                return true;
            } else {
                return false;
            }
        };

        $scope.removeField = function(groupIndex, fieldIndex) {
            $scope.filterDetail.criteria.condition_groups[groupIndex].conditions.splice(fieldIndex, 1);
            if ($scope.filterDetail.criteria.condition_groups[groupIndex].conditions.length == 0) {
                $scope.filterDetail.criteria.condition_groups.splice(groupIndex, 1);
            }
            // firing an event downwards
            $scope.$emit('updateResults', $scope.filterDetail);
        };

        $scope.editFilter = function(filter) {
            $mdDialog.show({
                templateUrl: 'core/components/filter/filter-detail-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "FilterDetailDialogController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    mode: 'UPDATE',
                    object: $scope.object,
                    filter: angular.copy(filter)
                }
            }).then(function(updatedFilter) {
                filter.name = updatedFilter.name;
                filter.description = updatedFilter.description;
                filter.status = updatedFilter.status;
                $scope.saveFilter(filter);
            });
        };

        $scope.saveDynamicFilter = function(filter) {
            if (filter.id) {
                $scope.saveFilter(filter);
            } else {
                $mdDialog.show({
                    templateUrl: 'core/components/filter/filter-detail-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "FilterDetailDialogController",
                    controllerAs: "vm",
                    size: 'lg',
                    locals: {
                        mode: 'CREATE',
                        object: $scope.object,
                        filter: filter
                    }
                }).then(function(updatedFilter) {
                    filter.name = updatedFilter.name;
                    filter.description = updatedFilter.description;
                    $scope.saveFilter(filter);
                });
            }
        };

        $scope.deleteFilter = function(filter) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this Filter?')
                .ariaLabel('Are you sure you want to delete this Filter?')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                Filter.delete({
                    id: filter.id
                }, function() {
                    AlertService.displayToast($mdToast);
                    loadAll();
                });
            });
        };

        $scope.saveFilter = function(filter) {
            if (filter.id) {
                Filter.update(filter, onSaveSuccess, onSaveError);
            } else {
                Filter.save(filter, onSaveSuccess, onSaveError);
            }

            function onSaveSuccess(result) {
                resetFilters(result);
                AlertService.displayToast($mdToast);
            };

            function onSaveError() {

            };
        };



        $scope.showMatchType = function(ev) {
            if ($scope.filterDetail.filter_no != 1000) {
                $scope.matchSelected = true;

                var position = $mdPanel.newPanelPosition()
                    .relativeTo('#match-type')
                    .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);

                var config = {
                    attachTo: angular.element(document.body),
                    controller: "MatchSelectionPanelController",
                    controllerAs: 'vm',
                    templateUrl: 'core/components/filter/match-selection-panel.tmpl.html',
                    position: position,
                    openFrom: ev,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: false,
                    zIndex: 2,
                    onCloseSuccess: function(panelRef, reason) {
                        $scope.matchSelected = false;
                        if (panelRef.matchAll != $scope.filterDetail.criteria.match_all) {
                            $scope.filterDetail.criteria.match_all = panelRef.matchAll;
                            // firing an event downwards
                            $scope.$emit('updateResults', $scope.filterDetail);
                        }
                    }
                };
                $mdPanel.open(config);
            }
        };

        $scope.showFields = function(ev) {
            if ($scope.filterDetail.filter_no == 1000) {
                var newDynamicFilter = {
                    filter_no: null,
                    name: 'Your New Filter',
                    object_type: $scope.object,
                    criteria: {
                        match_all: true,
                        condition_groups: []
                    }
                };
                $scope.selectedFilter = newDynamicFilter;
                $scope.filterDetail = newDynamicFilter;
                $scope.filters.push(newDynamicFilter);
                $scope.hasNewFilter = true;
            };

            var position = $mdPanel.newPanelPosition()
                .relativeTo('#add-filter')
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);


            var config = {
                attachTo: angular.element(document.body),
                controller: "FieldSelectionPanelController",
                controllerAs: 'vm',
                templateUrl: 'core/components/filter/field-selection-panel.tmpl.html',
                position: position,
                locals: {
                    metaFieldGroups: $scope.metaFieldGroups,
                    conditionGroups: $scope.filterDetail.criteria.condition_groups
                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function(panelRef, reason) {
                    if (panelRef.condition != null) {
                        $timeout(function() {
                            $scope.showFieldSettting(panelRef.condition);
                        }, 200);
                    }
                }
            };
            $mdPanel.open(config);
        };

        $scope.showFieldSettting = function(condition, ev) {
            $scope.selectedCondition = condition;

            var position = $mdPanel.newPanelPosition()
                .relativeTo('#' + condition.field_group_name + '-' + condition.field_name)
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);

            var config = {
                attachTo: angular.element(document.body),
                controller: "FieldSettingPanelController",
                controllerAs: 'vm',
                templateUrl: 'core/components/filter/field-setting-panel.tmpl.html',
                position: position,
                locals: {
                    metaFieldGroups: $scope.metaFieldGroups,
                    condition: condition,
                    conditionListOptions: []
                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function(panelRef, reason) {
                    $scope.selectedCondition = null;
                    // firing an event downwards
                    $scope.$emit('updateResults', $scope.filterDetail);
                }
            };

            $mdPanel.open(config);
        };

        function getFieldDisplayValue(condition) {
            if (!angular.isDefined(condition.value) || condition.value == null) {
                return null;
            } else {
                if (condition.data_type == 'DATE') {
                    if (condition.operator == 'EXACTLY') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'GREATER_THAN') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'GREATER_THAN_OR_EQUAL') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'LESS_THAN') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'LESS_THAN_OR_EQUAL') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'WITHIN') {
                        return condition.value + ' days';
                    } else if (condition.operator == 'BETWEEN') {
                        var fromDate = (angular.isDefined(condition.value.from_date) && condition.value.from_date != null ? $filter('date')(condition.value.from_date, "MM-dd-yyyy") : null);
                        var toDate = (angular.isDefined(condition.value.to_date) && condition.value.to_date != null ? $filter('date')(condition.value.to_date, "MM-dd-yyyy") : null);
                        return (fromDate == null ? '' : fromDate) + ' and ' + (toDate == null ? '' : toDate);
                    } else if (condition.operator == 'IS') {
                        if (condition.value == 'TODAY') {
                            return 'today';
                        } else if (condition.value == 'YESTERDAY') {
                            return 'yesterday';
                        } else if (condition.value == 'START_OF_WEEK') {
                            return 'start of the week';
                        } else if (condition.value == 'END_OF_WEEK') {
                            return 'end of the week';
                        } else if (condition.value == 'START_OF_MONTH') {
                            return 'start of the month';
                        } else if (condition.value == 'END_OF_MONTH') {
                            return 'end of the month';
                        } else {
                            return condition.value;
                        }
                    } else if (condition.operator == 'AFTER') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else if (condition.operator == 'BEFORE') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else if (condition.operator == 'ON') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else {
                        return condition.value;
                    }
                } else {
                    return condition.value;
                }
            }
        };

        function refreshFilters() {
            $q.all([
                Filter.query({
                    size: 100,
                }).$promise,
            ]).then(function(data) {
                $scope.filters = data[0];

                if ($scope.hasNewFilter) {
                    $scope.filters.push($scope.filterDetail);
                } else {
                    angular.forEach($scope.filters, function(filterInfo) {
                        if (filterInfo.filter_no == $scope.filterDetail.filter_no) {
                            initFilter(filterInfo);
                        }
                    });
                }
            });
        };

        function resetFilters(filter) {
            $q.all([
                Filter.query({
                    size: 100,
                }).$promise,
            ]).then(function(data) {
                $scope.filters = data[0];
                $scope.hasNewFilter = false;

                angular.forEach($scope.filters, function(filterInfo) {
                    if (filterInfo.filter_no == filter.filter_no) {
                        initFilter(filterInfo);
                    }
                });
            });
        };

        function initFilter(filterInfo) {
            $scope.selectedFilter = filterInfo;
            $scope.filterDetail = angular.copy(filterInfo);

            if (!angular.isDefined($scope.filterDetail.criteria) || $scope.filterDetail.criteria == null) {
                $scope.filterDetail.criteria = {
                    match_all: true
                }
            }
            // firing an event downwards
            $scope.$emit('updateResults', $scope.filterDetail);
        };

        function loadAll() {
            $scope.loadingData = true;
            $q.all([
                MetaData.get({
                    id: $scope.object,
                    is_name: true,
                    add_default_properties: true
                }).$promise,
                Setting.getSystemTimezones({
                    size: 100
                }).$promise,
                Setting.getSystemLanguages().$promise,
                Filter.query({
                    query: 'objectType==' + $scope.object,
                    size: 100
                }).$promise,
            ]).then(function(data) {
                $scope.metaFieldGroups = data[0].field_groups;
                $scope.timezones = data[1];
                $scope.languages = data[2];
                $scope.filters = data[3];

                angular.forEach($scope.filters, function(filterInfo) {
                    if (filterInfo.filter_no == 1000) {
                        initFilter(filterInfo);
                    }
                });
                $scope.loadingData = false;
            });
        }

        // listen for the event in the relevant $scope
        $rootScope.$on('refreshFilters', function(event) {
            refreshFilters();
        });
        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('FieldSettingPanelController', FieldSettingPanelController);

    /* @ngInject */
    function FieldSettingPanelController(mdPanelRef, $scope, $state, $mdDialog, $q, $filter, $mdToast, Principal, metaFieldGroups, condition, conditionListOptions, $mdPanel, FIELD_CONDITION_CONSTANT, Audience,SecurityRole) {
        var vm = this;
        vm.booleanTemp = "";
        vm.tmp_date;
        vm.tmp_from_date;
        vm.tmp_to_date;
        vm.stringChoices;
        vm.metaFieldGroups = metaFieldGroups;
        vm.condition = condition;
        vm.conditionListOptions = conditionListOptions;

        if (condition.data_type === "OBJECT") {
            vm.conditionOperators = FIELD_CONDITION_CONSTANT[vm.condition.data_type][vm.condition.field_name];
            if(condition.field_name == "security-role"){
                getSecurityRoles();
            }
            else if(condition.field_name == "audience") {
                getAudienceRoles();
            }
        }
        else if (condition.data_type === "BOOLEAN") {
            //set default to true
            updateBoolean(condition.value);
            vm.conditionOperators = FIELD_CONDITION_CONSTANT[vm.condition.data_type];
        }
        else if (vm.condition.data_type == 'STRING' && (
            vm.condition.operator == 'IN' || vm.condition.operator == 'NOT_IN' )
        ) {
            vm.stringChoices = "";
            if ( condition.value ) {
                vm.stringChoices  = condition.value.join(", "); 
            }
            vm.conditionOperators = FIELD_CONDITION_CONSTANT[vm.condition.data_type];
        }
        else {
            vm.conditionOperators = FIELD_CONDITION_CONSTANT[vm.condition.data_type];
        }

        function getSecurityRoles() {
            $q.all([
                SecurityRole.query({
                    size: 100
                }).$promise
            ]).then(function(data) {
                vm.conditionListOptions = data[0];
            });
        }
        function getAudienceRoles() {
            $q.all([
                Audience.query({
                    size: 100
                }).$promise
            ]).then(function(data) {
                vm.conditionListOptions = data[0];
            });
        }

        if (condition.data_type === "LIST") {
            var fieldMeta;
            var fieldGroupMeta = $filter('filter')(vm.metaFieldGroups, {
                'name': condition.field_group_name
            })[0];
            //filter gets array of all fields which contain condition.field_name
            var fieldMetaArray = $filter('filter')(fieldGroupMeta.fields, {
                'name': condition.field_name
            });
            for(var cnt = 0; cnt < fieldMetaArray.length; cnt++) {
                if(fieldMetaArray[cnt].name === condition.field_name) {
                    fieldMeta = fieldMetaArray[cnt];
                    break;
                }
            }
            vm.conditionListOptions = fieldMeta.list_options;
            if(condition.value){
                var selectedListOption = $filter('filter')(fieldMeta.list_options, {
                    'option_id': condition.value
                })[0];
                condition.displayValue = selectedListOption.label;
            }
        }

        vm.done = function() {
            if(vm.condition.data_type == 'DATE') {
                checkDateValue();
            } else if (vm.condition.data_type == 'STRING' && (
                vm.condition.operator == 'IN' || vm.condition.operator == 'NOT_IN' )
            ) {
                if ( vm.stringChoices ) {
                    condition.value = vm.stringChoices.split(",").map(function(item) {
                        return item.trim();
                      });
                }
            }
            mdPanelRef.close();
        };

        vm.checkFilterOptions = function(condition, index) {
            return condition.value !== 'IN' && condition.value !== 'NOT_IN';
        };

        vm.disallowNegative = function (evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)){
                evt.preventDefault();
                return false;
            }
            return true;
        }

        function checkDateValue() {
            if(vm.tmp_date || vm.tmp_from_date || vm.tmp_to_date) {
                if(vm.condition.operator === "NOT_EXISTS" || vm.condition.operator === "EXISTS") {
                    vm.condition.value = null;
                }
                else if(vm.condition.operator === "BETWEEN") {
                    if(vm.condition.value === null) {
                        vm.condition.value = {};
                    }
                    if(vm.tmp_from_date) {
                        vm.condition.value.from_date = new Date($filter('date')(vm.tmp_from_date, "yyyy-MM-ddT00:00:00.000Z" ,"+0000")).toISOString();
                    }
                    if(vm.tmp_to_date) {
                        vm.condition.value.to_date = new Date($filter('date')(vm.tmp_to_date, "yyyy-MM-ddT00:00:00.000Z" ,"+0000")).toISOString();
                    }
                }
                else if(vm.condition.operator !== "BETWEEN") {
                    if(vm.tmp_date) {
                        vm.condition.value = new Date($filter('date')(vm.tmp_date, "yyyy-MM-ddT00:00:00.000Z" ,"+0000")).toISOString();
                    }
                }
            }
        }

        vm.getDate = function(value) {
            return $filter('fpToDate')(value);
        }

        vm.setDate = function(conditionValue, value) {
            conditionValue = value;
        }

        vm.showInput = function(operator) {
            if (condition.data_type === "OBJECT") {
                var operatorMeta = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type][condition.field_name], {
                    value: operator
                }, true)[0];
            } else {
                var operatorMeta = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                    value: operator
                }, true)[0];
            }

            return operatorMeta.showInput;
        }

        function updateBoolean(val) {
            if(val === "" || val === null) {
                vm.condition.value = null;
                vm.booleanTemp = "";
            }
            else if(val.toString() === "false") {
                vm.condition.value = false;
                vm.booleanTemp = "false";
            }
            else if(val.toString() === "true") {
                vm.condition.value = true;
                vm.booleanTemp = "true";
            }
        }

        vm.updateConditionValue = function(condition) {
            if(vm.condition.data_type == 'BOOLEAN') {
                updateBoolean(condition);
            } else if (vm.condition.data_type == 'STRING' && (
                vm.condition.operator == 'IN' || vm.condition.operator == 'NOT_IN' )
            ) {
                vm.stringChoices = "";
                if ( condition.value ) {
                    vm.stringChoices  = condition.value.join(", "); 
                }
            }
            else {
                if(!vm.showInput(condition.operator)) {
                    condition.value = null;
                }
                if(condition.data_type == 'DATE') {
                    condition.value = null;
                    vm.tmp_date = null;
                    vm.tmp_from_date = null;
                    vm.tmp_to_date = null;
                }
            }
        }
        vm.updateConditionListObject = function(val) {
            vm.condition.value = val;
            vm.condition.displayValue = val.name;
        }
        vm.updateConditionList = function(val) {
            vm.condition.displayValue = val;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('FieldSelectionPanelController', FieldSelectionPanelController);

    /* @ngInject */
    function FieldSelectionPanelController(mdPanelRef, $scope, $state, $mdDialog, $q, $filter, $mdToast, Principal, metaFieldGroups, conditionGroups, $mdPanel, FIELD_CONDITION_CONSTANT) {
        var vm = this;
        var fieldsToHide = ['managed_audiences','first_seen','last_seen','last_contacted','last_heard_from','user_type','browser_name','browser_version','browser_language','browser_os','initial_referrer','initial_referrer_domain','city','continent_code','country_code','country_name','latitude','longitude','postal_code','region_name','timezone','topic','content','manager'];
        var groupsToHide = ['segment', 'badge']
        vm.metaFieldGroups = $filter('filter')(metaFieldGroups, function(group) {
            return (groupsToHide.indexOf(group.name) === -1 && group.enabled && group.search_enabled);
        });

        //hiding fields in list FOS-4066
        for(var fieldIndex = 0; fieldIndex < vm.metaFieldGroups.length; fieldIndex++) {
            var fieldGroup = $filter('filter')(vm.metaFieldGroups[fieldIndex].fields, function(field) {
                return (fieldsToHide.indexOf(field.name) === -1 && field.enabled && field.search_enabled);
            });
            vm.metaFieldGroups[fieldIndex].fields = fieldGroup;
            if(!fieldGroup.length) {
                vm.metaFieldGroups.splice(fieldIndex,1);
                fieldIndex--;
            }
        }

        vm.selectField = function(group, field) {
            var condition = {
                "field_group_name": group.name,
                "field_name": field.name,
                "data_type": field.data_type,
                "operator": getDefaultOperator(field),
                "value": null
            };
            if (field.data_type === "LIST" || field.data_type == 'LANGUAGE' || field.data_type == 'TIMEZONE') {
                condition["displayValue"] = null;
            }

            var conditionGroup = {
                conditions: [condition]
            }
            conditionGroups.push(conditionGroup);
            mdPanelRef.condition = condition;
            if (field.list_options) {
                mdPanelRef.conditionListOptions = field.list_options;
            }
            mdPanelRef.close();

        };

        function getDefaultOperator(field) {
            var fieldConditionsMeta = FIELD_CONDITION_CONSTANT[field.data_type];
            if (field.data_type === "OBJECT") {
                return fieldConditionsMeta[field.ref_object][0].value
            }
            return fieldConditionsMeta[0].value;
        }
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer')
        .constant('FIELD_CONDITION_CONSTANT', {
            'STRING': [{
                defaultValue: null,
                showInput: true,
                label: 'atheer.fieldCondition.is',
                value: 'EQUAL'
            }, {
                defaultValue: null,
                showInput: true,
                label: 'atheer.fieldCondition.isNot',
                value: 'NOT_EQUAL'
            }, {
                defaultValue: null,
                showInput: true,
                label: 'atheer.fieldCondition.startsWith',
                value: 'STARTS_WITH'
            }, {
                defaultValue: null,
                showInput: true,
                label: 'atheer.fieldCondition.endsWith',
                value: 'ENDS_WITH'
            }, {
                defaultValue: null,
                showInput: true,
                label: 'atheer.fieldCondition.contains',
                value: 'CONTAINS'
            }, {
                defaultValue: null,
                showInput: true,
                label: 'atheer.fieldCondition.doesnotContains',
                value: 'NOT_CONTAINS'
            }, {
                defaultValue: null,
                showInput: false,
                label: 'atheer.fieldCondition.isNotSet',
                value: 'NOT_EXISTS'
            }, {
                defaultValue: null,
                showInput: false,
                label: 'atheer.fieldCondition.isSet',
                value: 'EXISTS'
            }, {
                defaultValue: null,
                showInput: false,
                label: 'atheer.fieldCondition.in',
                value: 'IN'
            }, {
                defaultValue: null,
                showInput: false,
                label: 'atheer.fieldCondition.notIn',
                value: 'NOT_IN'
            }],
            'NUMBER': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.is',
                    value: 'EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.isNot',
                    value: 'NOT_EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.greaterThan',
                    value: 'GREATER_THAN'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.greaterThanOrEquals',
                    value: 'GREATER_THAN_OR_EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.lessThan',
                    value: 'LESS_THAN'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.lessThanOrEquals',
                    value: 'LESS_THAN_OR_EQUAL'
                }, {
                    defaultValue: null,
                    showInput: false,
                    label: 'atheer.fieldCondition.isNotSet',
                    value: 'NOT_EXISTS'
                }, {
                    defaultValue: null,
                    showInput: false,
                    label: 'atheer.fieldCondition.isSet',
                    value: 'EXISTS'
                }
            ],
            'DECIMAL': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.is',
                    value: 'EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.isNot',
                    value: 'NOT_EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.greaterThan',
                    value: 'GREATER_THAN'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.greaterThanOrEquals',
                    value: 'GREATER_THAN_OR_EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.lessThan',
                    value: 'LESS_THAN'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.lessThanOrEquals',
                    value: 'LESS_THAN_OR_EQUAL'
                }, {
                    defaultValue: null,
                    showInput: false,
                    label: 'atheer.fieldCondition.isNotSet',
                    value: 'NOT_EXISTS'
                }, {
                    defaultValue: null,
                    showInput: false,
                    label: 'atheer.fieldCondition.isSet',
                    value: 'EXISTS'
                }
            ],
            'BOOLEAN': [{
                defaultValue: "true",
                showInput: false,
                label: 'atheer.fieldCondition.isTrue',
                value: 'EQUAL'
            }, {
                defaultValue: "false",
                showInput: false,
                label: 'atheer.fieldCondition.isFalse',
                value: 'NOT_EQUAL'
            }, {
                defaultValue: "",
                showInput: false,
                label: 'atheer.fieldCondition.isNotSet',
                value: 'EXISTS'
                }],
            'DATE': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.moreThan',
                    value: 'GREATER_THAN'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.moreThanOrEquals',
                    value: 'GREATER_THAN_OR_EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.lessThan',
                    value: 'LESS_THAN'
                }, {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.lessThanOrEquals',
                    value: 'LESS_THAN_OR_EQUAL'
                }, {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.within',
                    value: 'WITHIN'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.after',
                    value: 'AFTER'
                }, {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.on',
                    value: 'ON'
                }, {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.before',
                    value: 'BEFORE'
                }, {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.between',
                    value: 'BETWEEN'
                }, {
                    defaultValue: null,
                    showInput: false,
                    label: 'atheer.fieldCondition.isNotSet',
                    value: 'NOT_EXISTS'
                }, {
                    defaultValue: null,
                    showInput: false,
                    label: 'atheer.fieldCondition.isSet',
                    value: 'EXISTS'
                }
            ],
            'OBJECT': {
                'content': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                }],
                'badge': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                }],
                'security-role': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                }],
                'audience': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                }],
                'topic': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                }]
            },
            'LANGUAGE': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIsNot',
                    value: 'NOT_EQUAL'
                }
            ],
            'TIMEZONE': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIsNot',
                    value: 'NOT_EQUAL'
                }
            ],
            'LIST': [{
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIs',
                    value: 'EQUAL'
                },
                {
                    defaultValue: null,
                    showInput: true,
                    label: 'atheer.fieldCondition.objectIsNot',
                    value: 'NOT_EQUAL'
                }
            ]
        });
})();
;
(function() {

    'use strict';
    angular
        .module('atheer')
        .constant('CRITERIA_CONDITION_CONSTANT', {
            'STRING': [{
                    label: 'Starts With',
                    value: 'STARTS_WITH'
                },
                {
                    label: 'Ends With',
                    value: 'ENDS_WITH'
                },
                {
                    label: 'Contains',
                    value: 'CONTAINS'
                },
                {
                    label: 'Is',
                    value: 'EQUAL'
                },
                {
                    label: 'Is Not',
                    value: 'NOT_EQUAL'
                }
            ],
            'OBJECT': {
                'content': [{
                    label: 'Is',
                    value: 'EQUAL'
                }],
                'badge': [{
                    label: 'Is',
                    value: 'EQUAL'
                }],
                'security-role': [{
                    label: 'Is',
                    value: 'EQUAL'
                }],
                'audience': [{
                    label: 'Is',
                    value: 'EQUAL'
                }],
                'topic': [{
                    label: 'Is',
                    value: 'EQUAL'
                }]
            },
            'LANGUAGE': [{
                    label: 'Is',
                    value: 'EQUAL'
                },
                {
                    label: 'Is Not',
                    value: 'NOT_EQUAL'
                }
            ],
            'TIMEZONE': [{
                    label: 'Is',
                    value: 'EQUAL'
                },
                {
                    label: 'Is Not',
                    value: 'NOT_EQUAL'
                }
            ],
            'LIST': [{
                    label: 'Is',
                    value: 'EQUAL'
                },
                {
                    label: 'Is Not',
                    value: 'NOT_EQUAL'
                }
            ],
            'NUMBER': [{
                    label: 'Is',
                    value: 'EQUAL'
                },
                {
                    label: 'Is Not',
                    value: 'NOT_EQUAL'
                },
                {
                    label: 'Greater Than',
                    value: 'GREATER_THAN'
                },
                {
                    label: 'Less Than',
                    value: 'LESS_THAN'
                },
                {
                    label: 'Greater Than Equals',
                    value: 'GREATER_THAN_OR_EQUAL'
                },
                {
                    label: 'Less Than Equals',
                    value: 'LESS_THAN_OR_EQUAL'
                }
            ],
            'DATE': [{
                    label: 'Is',
                    value: 'IS'
                },
                {
                    label: 'Between',
                    value: 'BETWEEN'
                },
                {
                    label: 'Is Equal',
                    value: 'EQUAL'
                },
                {
                    label: 'Is Not',
                    value: 'NOT_EQUAL'
                },
                {
                    label: 'Greater Than',
                    value: 'GREATER_THAN'
                },
                {
                    label: 'Less Than',
                    value: 'LESS_THAN'
                },
                {
                    label: 'Greater Than Equals',
                    value: 'GREATER_THAN_OR_EQUAL'
                },
                {
                    label: 'Less Than Equals',
                    value: 'LESS_THAN_OR_EQUAL'
                }
            ]
        });
})();
;
(function() {
    'use strict';
    angular
        .module('atheer')
        .directive('fpCriteriaBuilder', fpCriteriaBuilder)
        .directive('fpCriteriaBuilderField', fpCriteriaBuilderField);

    function fpCriteriaBuilder() {
        return {
            restrict: 'AE',
            scope: {
                fpCriteria: '=',
                fpCriteriaFormIsValid: '=?'
            },
            templateUrl: 'core/components/filter/criteria-builder.tmpl.html',
            controller: CriteriaBuilderDirectiveController
        };
    }

    function fpCriteriaBuilderField() {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                fpFieldMeta: '=',
                fpFieldModel: '=',
                fpFieldOperator: '=',
                fpTimeZoneData: '=',
                fpLanguageData: '='
            },
            templateUrl: 'core/components/filter/criteria-builder-fields.tmpl.html',
            controller: CriteriaBuilderFieldsDirectiveController
        };
    }

    function CriteriaBuilderDirectiveController($scope, $q, $element, $filter, MetaData, Setting, CRITERIA_CONDITION_CONSTANT, DateUtils) {

        $scope.metaFieldGroups = [];
        $scope.isDataLoaded = false;
        $scope.timezones = [];
        $scope.languages = [];

        $scope.$watch('criteriaBuilderForm.$valid', function() {
            $scope.fpCriteriaFormIsValid = $scope.criteriaBuilderForm.$valid;
        });

        if (!$scope.fpCriteria) {
            $scope.fpCriteria = {};
            $scope.fpCriteria.condition_groups = [];
        }

        $scope.newFieldMeta = undefined;

        $scope.initFieldDropDownSearch = function() {
            $element.find('input[type="search"]').on('keydown', function(ev) {
                ev.stopPropagation();
            });
        }

        $scope.addField = function(condition_group_index, condition_index) {
            var default_field = {
                "field_group_name": undefined,
                "field_name": undefined,
                "data_type": undefined,
                "operator": null,
                "value": null,
            };
            $scope.fpCriteria.condition_groups[condition_group_index].conditions.splice(condition_index + 1, 0, angular.copy(default_field));
        }

        $scope.getDefaultOperator = function(dataType) {
            var defaultOperator = null;

            if ($scope.newFieldMeta.data_type == "BOOLEAN") {
                defaultOperator = "EQUAL";
            } else {
                var fieldConditionsMeta = CRITERIA_CONDITION_CONSTANT[$scope.newFieldMeta.data_type];
                defaultOperator = fieldConditionsMeta[0].value;
            }
            return defaultOperator;
        }

        $scope.addFieldGroup = function() {
            var defaultOperator = null;

            if ($scope.newFieldMeta.data_type == "BOOLEAN") {
                defaultOperator = "EQUAL";
            } else {
                var fieldConditionsMeta = CRITERIA_CONDITION_CONSTANT[$scope.newFieldMeta.data_type];
                defaultOperator = fieldConditionsMeta[0].value;
            }

            if ($scope.newFieldMeta) {
                var default_field = {
                    "field_group_name": $scope.newFieldMeta.field_group_name,
                    "field_name": $scope.newFieldMeta.field_name,
                    "data_type": $scope.newFieldMeta.data_type,
                    "operator": $scope.getDefaultOperator($scope.newFieldMeta.data_type),
                    "value": null,
                };

                var default_fieldGroup = {
                    conditions: [default_field]
                }

                $scope.fpCriteria.condition_groups.push(default_fieldGroup)
                $scope.newFieldMeta = undefined;
            }

        }

        $scope.hasCondition = function(field_group_name, field_name) {
            var fieldGroupMeta = $filter('filter')($scope.metaFieldGroups, {
                'name': field_group_name
            })[0];

            var fieldMeta = $filter('filter')(fieldGroupMeta.fields, {
                'name': field_name
            })[0];

            var fieldConditionsMeta = CRITERIA_CONDITION_CONSTANT[fieldMeta.data_type]
            if (fieldMeta.data_type === "OBJECT") {
                return fieldConditionsMeta[fieldMeta.ref_object];
            } else {
                return fieldConditionsMeta;
            }
        }

        $scope.getFieldOperators = function(field_group_name, field_name) {
            var fieldGroupMeta = $filter('filter')($scope.metaFieldGroups, {
                'name': field_group_name
            })[0];
            var fieldMeta = $filter('filter')(fieldGroupMeta.fields, {
                'name': field_name
            })[0];

            var fieldConditionsMeta = CRITERIA_CONDITION_CONSTANT[fieldMeta.data_type]
            if (fieldMeta.data_type === "OBJECT") {
                return fieldConditionsMeta[fieldMeta.ref_object];
            } else {
                return fieldConditionsMeta;
            }
        }

        $scope.removeField = function(criteriaIndex, fieldIndex) {
            $scope.fpCriteria.condition_groups[criteriaIndex].conditions.splice(fieldIndex, 1);
            if ($scope.fpCriteria.condition_groups[criteriaIndex].conditions.length == 0) {
                $scope.fpCriteria.condition_groups.splice(criteriaIndex, 1);
            }
        }

        function init() {
            $q.all([
                MetaData.get({
                    id: 'user',
                    is_name: true
                }).$promise,
                Setting.getSystemTimezones({
                    size: 100
                }).$promise,
                Setting.getSystemLanguages().$promise
            ]).then(function(data) {
                $scope.metaFieldGroups = data[0].field_groups;
                $scope.timezones = data[1];
                $scope.languages = data[2];
                $scope.isDataLoaded = true;
            });
        }
        init();
    }

    function CriteriaBuilderFieldsDirectiveController($scope, $filter, DateUtils) {
        $scope.tmp_date_option;

        $scope.formatToMetaObject = function(result) {
            var returnResultObj = [];
            angular.forEach(result, function(item) {
                returnResultObj.push({
                    'title': item.display || item.name || item.title || item.first_name + ' ' + item.last_name,
                    'id': item.id
                });
            })
            return returnResultObj;
        }

        $scope.getInitDateOption = function() {
            if ($scope.fpFieldModel && $scope.fpFieldModel.option) {
                return $scope.fpFieldModel.option;
            } else {
                return $scope.fpFieldModel;
            }
        }

        $scope.setDateFieldModel = function(value) {
            if (value == 'DAYS_BEFORE' || value == 'DAYS_AFTER') {
                $scope.fpFieldModel = {
                    'option': value,
                    'days': 0
                }
            } else {
                $scope.fpFieldModel = value
            }
        }

        $scope.getDate = function() {
            return $filter('fpToDate')($scope.fpFieldModel);
        }

        $scope.setDate = function(value) {
            $scope.fpFieldModel = value;
        }

        $scope.getFromDate = function() {
            if ($scope.fpFieldModel) {
                return $filter('fpToDate')($scope.fpFieldModel.from_date);
            } else {
                return new Date();
            }
        }

        $scope.getToDate = function() {
            if ($scope.fpFieldModel) {
                return $filter('fpToDate')($scope.fpFieldModel.to_date);
            } else {
                return new Date();
            }
        }



        $scope.setFromDateField = function(value) {
            $scope.fpFieldModel = {
                'from_date': value,
                'to_date': $scope.getToDate()
            }
        }

        $scope.setToDateField = function(value) {
            $scope.fpFieldModel = {
                'from_date': $scope.getFromDate(),
                'to_date': value
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    pageTitle: 'atheer.error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'core/components/error/error.html'
                    }
                },
                resolve: {
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                views: {
                    'content@': {
                        templateUrl: 'core/components/error/accessdenied.html'
                    }
                },
                resolve: {
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular.module('atheer')
        .value('baseFrequency', {
            minute: 1,
            hour: 2,
            day: 3,
            week: 4,
            month: 5,
            year: 6
        })
        .factory('cronService', ['baseFrequency', function(baseFrequency) {
            var service = {};

            service.setCron = function(n, cronType) {
                if (cronType === "quartz") {
                    return this.setQuartzCron(n);
                } else {
                    return this.setDefaultCron(n);
                }
            };

            service.setQuartzCron = function(n) {
                var cron = ["0", "*", "*", "*", "*", "?"];
                if (n && n.base && n.base >= baseFrequency.hour) {
                    cron[1] = typeof n.minuteValues !== "undefined" ? n.minuteValues : "0";
                }

                if (n && n.base && n.base >= baseFrequency.day) {
                    cron[2] = typeof n.hourValues !== "undefined" ? n.hourValues : "*";
                }

                if (n && n.base && n.base === baseFrequency.week) {
                    cron[3] = "?";
                    cron[5] = n.dayValues;
                }

                if (n && n.base && n.base >= baseFrequency.month) {
                    cron[3] = typeof n.dayOfMonthValues !== "undefined" ? n.dayOfMonthValues : "?";
                }

                if (n && n.base && n.base === baseFrequency.year) {
                    cron[4] = typeof n.monthValues !== "undefined" ? n.monthValues : "*";
                }

                return cron.join(" ");
            };

            service.setDefaultCron = function(n) {
                var cron = ["*", "*", "*", "*", "*"];

                if (n && n.base && n.base >= baseFrequency.hour) {
                    cron[0] = typeof n.minuteValues !== "undefined" ? n.minuteValues : "*";
                }

                if (n && n.base && n.base >= baseFrequency.day) {
                    cron[1] = typeof n.hourValues !== "undefined" ? n.hourValues : "*";
                }

                if (n && n.base && n.base === baseFrequency.week) {
                    cron[4] = n.dayValues;
                }

                if (n && n.base && n.base >= baseFrequency.month) {
                    cron[2] = typeof n.dayOfMonthValues !== "undefined" ? n.dayOfMonthValues : "*";
                }

                if (n && n.base && n.base === baseFrequency.year) {
                    cron[3] = typeof n.monthValues !== "undefined" ? n.monthValues : "*";
                }
                return cron.join(" ");
            };

            service.fromCron = function(value, allowMultiple, cronType) {
                if (cronType === "quartz") {
                    return this.fromQuartzCron(value, allowMultiple);
                } else {
                    return this.fromDefaultCron(value, allowMultiple);
                }
            };

            service.fromDefaultCron = function(value, allowMultiple) {
                var cron = value.replace(/\s+/g, " ").split(" ");
                var frequency = {
                    base: "1"
                }; // default: every minute
                var tempArray = [];

                if (cron[0] === "*" && cron[1] === "*" && cron[2] === "*" && cron[3] === "*" && cron[4] === "*") {
                    frequency.base = baseFrequency.minute; // every minute
                } else if (cron[1] === "*" && cron[2] === "*" && cron[3] === "*" && cron[4] === "*") {
                    frequency.base = baseFrequency.hour; // every hour
                } else if (cron[2] === "*" && cron[3] === "*" && cron[4] === "*") {
                    frequency.base = baseFrequency.day; // every day
                } else if (cron[2] === "*" && cron[3] === "*") {
                    frequency.base = baseFrequency.week; // every week
                } else if (cron[3] === "*" && cron[4] === "*") {
                    frequency.base = baseFrequency.month; // every month
                } else if (cron[4] === "*") {
                    frequency.base = baseFrequency.year; // every year
                }

                if (cron[0] !== "*") {
                    //preparing to handle multiple minutes
                    if (allowMultiple) {
                        tempArray = cron[0].split(',');
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.minuteValues = tempArray;
                    } else {
                        frequency.minuteValues = parseInt(cron[0]);
                    }
                }
                if (cron[1] !== "*") {
                    //preparing to handle multiple hours
                    if (allowMultiple) {
                        tempArray = cron[1].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.hourValues = tempArray;
                    } else {
                        frequency.hourValues = parseInt(cron[1]);
                    }
                }
                if (cron[2] !== "*") {
                    //preparing to handle multiple days of the month
                    if (allowMultiple) {
                        tempArray = cron[2].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.dayOfMonthValues = tempArray;
                    } else {
                        frequency.dayOfMonthValues = parseInt(cron[2]);
                    }
                }
                if (cron[3] !== "*") {
                    //preparing to handle multiple months
                    if (allowMultiple) {
                        tempArray = cron[3].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.monthValues = tempArray;
                    } else {
                        frequency.monthValues = parseInt(cron[3]);
                    }
                }
                if (cron[4] !== "*") {
                    //preparing to handle multiple days of the week
                    if (allowMultiple) {
                        tempArray = cron[4].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.dayValues = tempArray;
                    } else {
                        frequency.dayValues = parseInt(cron[4]);
                    }
                }
                return frequency;
            };

            service.fromQuartzCron = function(value, allowMultiple) {
                var cron = value.replace(/\s+/g, " ").split(" ");
                var frequency = {
                    base: "1"
                }; // default: every minute
                var tempArray = [];

                if (cron[1] === "*" && cron[2] === "*" && cron[3] === "*" && cron[4] === "*" && cron[5] === "?") {
                    frequency.base = 1; // every minute
                } else if (cron[2] === "*" && cron[3] === "*" && cron[4] === "*" && cron[5] === "?") {
                    frequency.base = 2; // every hour
                } else if (cron[3] === "*" && cron[4] === "*" && cron[5] === "?") {
                    frequency.base = 3; // every day
                } else if (cron[3] === "?") {
                    frequency.base = 4; // every week
                } else if (cron[4] === "*" && cron[5] === "?") {
                    frequency.base = 5; // every month
                } else if (cron[5] === "?") {
                    frequency.base = 6; // every year
                }

                if (cron[1] !== "*") {
                    //preparing to handle multiple minutes
                    if (allowMultiple) {
                        tempArray = cron[1].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.minuteValues = tempArray;
                    } else {
                        frequency.minuteValues = parseInt(cron[1]);
                    }
                }
                if (cron[2] !== "*") {
                    //preparing to handle multiple hours
                    if (allowMultiple) {
                        tempArray = cron[2].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.hourValues = tempArray;
                    } else {
                        frequency.hourValues = parseInt(cron[2]);
                    }
                }
                if (cron[3] !== "*" && cron[3] !== "?") {
                    //preparing to handle multiple days of the month
                    if (allowMultiple) {
                        tempArray = cron[3].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.dayOfMonthValues = tempArray;
                    } else {
                        frequency.dayOfMonthValues = parseInt(cron[3]);
                    }
                }
                if (cron[4] !== "*") {
                    //preparing to handle multiple months
                    if (allowMultiple) {
                        tempArray = cron[4].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.monthValues = tempArray;
                    } else {
                        frequency.monthValues = parseInt(cron[4]);
                    }
                }
                if (cron[5] !== "*" && cron[5] !== "?") {
                    //preparing to handle multiple days of the week
                    if (allowMultiple) {
                        tempArray = cron[5].split(",");
                        for (var i = 0; i < tempArray.length; i++) {
                            tempArray[i] = +tempArray[i];
                        }
                        frequency.dayValues = tempArray;
                    } else {
                        frequency.dayValues = parseInt(cron[5]);
                    }
                }

                return frequency;
            };

            return service;
        }]);
})();
;
(function() {
    'use strict';

    angular
      .module("atheer")
      .directive("cronSelection", ["cronService", "baseFrequency", function(cronService, baseFrequency) {
        return {
            restrict: "EA",
            replace: true,
            transclude: true,
            require: "ngModel",
            scope: {
                ngModel: "=",
                config: "=",
                myFrequency: "=?frequency"
            },
            templateUrl: 'core/components/cron/cron-widget.tmpl.html',
            link: function($scope, $el, $attr, $ngModel) {

                var modelChanged = false;

                $scope.baseFrequency = baseFrequency;

                $scope.frequency = [{
                    value: 1,
                    label: "Minute"
                }, {
                    value: 2,
                    label: "Hour"
                }, {
                    value: 3,
                    label: "Day"
                }, {
                    value: 4,
                    label: "Week"
                }, {
                    value: 5,
                    label: "Month"
                }, {
                    value: 6,
                    label: "Year"
                }];

                $scope.$watch("ngModel", function(newValue) {
                    if (angular.isDefined(newValue) && newValue) {
                        modelChanged = true;
                        $scope.myFrequency = cronService.fromCron(newValue, $scope.allowMultiple, $scope.cronStyle);
                    } else if (newValue === "") {
                        $scope.myFrequency = undefined;
                    }
                });

                if (typeof $scope.config === "object" && !$scope.config.length) {
                    if (typeof $scope.config.options === "object") {
                        var optionsKeyArray = Object.keys($scope.config.options);
                        for (var i in optionsKeyArray) {
                            var currentKey = optionsKeyArray[i].replace(/^allow/, "");
                            var originalKey = optionsKeyArray[i];
                            if (!$scope.config.options[originalKey]) {
                                for (var b in $scope.frequency) {
                                    if ($scope.frequency[b].label === currentKey) {
                                        $scope.frequency.splice(b, 1);
                                    }
                                }
                            }
                        }
                    }
                    if (angular.isDefined($scope.config.allowMultiple)) {
                        $scope.allowMultiple = $scope.config.allowMultiple;
                    } else {
                        $scope.allowMultiple = false;
                    }

                    if (angular.isDefined($scope.config.quartz) && $scope.config.quartz) {
                        $scope.cronStyle = "quartz";
                    } else {
                        $scope.cronStyle = "default";
                    }
                }

                $scope.minuteValues = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
                $scope.hourValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
                $scope.dayOfMonthValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
                $scope.dayValues = [0, 1, 2, 3, 4, 5, 6];
                $scope.monthValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

                if ($scope.cronStyle === "quartz") {
                    $scope.dayValues = [1, 2, 3, 4, 5, 6, 7];
                }

                $scope.$watch("myFrequency", function(n, o) {
                    if (n !== undefined) {
                        if (n && n.base && (!o || n.base !== o.base) && !modelChanged) {
                            setInitialValuesForBase(n);
                        } else if (n && n.base && o && o.base) {
                            modelChanged = false;
                        }

                        var newVal = cronService.setCron(n, $scope.cronStyle);
                        $ngModel.$setViewValue(newVal);
                    }
                }, true);

                function setInitialValuesForBase(freq) {
                    freq.base = parseInt(freq.base);

                    if (freq.base >= baseFrequency.hour) {
                        freq.minuteValues = $scope.minuteValues[0];
                    }

                    if (freq.base >= baseFrequency.day) {
                        freq.hourValues = $scope.hourValues[0];
                    }

                    if (freq.base === baseFrequency.week) {
                        freq.dayValues = $scope.dayValues[0];
                    }

                    if (freq.base >= baseFrequency.month) {
                        freq.dayOfMonthValues = $scope.dayOfMonthValues[0];
                    }

                    if (freq.base === baseFrequency.year) {
                        freq.monthValues = $scope.monthValues[0];
                    }
                }
            }
        };
    }]).filter("cronNumeral", function() {
        return function(input) {
            switch (input) {
                case 1:
                    return "1st";
                case 2:
                    return "2nd";
                case 3:
                    return "3rd";
                case 21:
                    return "21st";
                case 22:
                    return "22nd";
                case 23:
                    return "23rd";
                case 31:
                    return "31st";
                case null:
                    return null;
                default:
                    return input + "th";
            }
        };
    }).filter("cronMonthName", function() {
        return function(input) {
            var months = {
                1: "January",
                2: "February",
                3: "March",
                4: "April",
                5: "May",
                6: "June",
                7: "July",
                8: "August",
                9: "September",
                10: "October",
                11: "November",
                12: "December"
            };

            if (input !== null && angular.isDefined(months[input])) {
                return months[input];
            } else {
                return null;
            }
        };
    }).filter("cronDayName", function() {
        return function(input, cronType) {
            var days;
            if (cronType === "quartz") {
                days = {
                    1: "Sunday",
                    2: "Monday",
                    3: "Tuesday",
                    4: "Wednesday",
                    5: "Thursday",
                    6: "Friday",
                    7: "Saturday",
                };
            } else {
                days = {
                    0: "Sunday",
                    1: "Monday",
                    2: "Tuesday",
                    3: "Wednesday",
                    4: "Thursday",
                    5: "Friday",
                    6: "Saturday",
                };
            }


            if (input !== null && angular.isDefined(days[input])) {
                return days[input];
            } else {
                return null;
            }
        };
    }).directive("ngMultiple", function() {
        return {
            restrict: "A",
            scope: {
                ngMultiple: "="
            },
            link: function(scope, element) {
                var unwatch = scope.$watch("ngMultiple", function(newValue) {
                    if (newValue) {
                        element.attr("multiple", "multiple");
                    } else {
                        element.removeAttr("multiple");
                    }
                });
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('countupto', countupto);

    /* @ngInject */
    function countupto($timeout) {
        // Usage:
        //
        // ```html
        // <h1 countupto="100"></h1>
        // ```
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                'countupto': '=',
                'options': '='
            }
        };
        return directive;

        function link($scope, $element, attrs) {
            var options = {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            };

            var numAnim;

            // override default options?
            if ($scope.options) {
                for(var option in options) {
                    if(angular.isDefined($scope.options[option])) {
                        options[option] = $scope.options[option];
                    }
                }
            }

            attrs.from = angular.isUndefined(attrs.from) ? 0 : parseInt(attrs.from);
            attrs.decimals = angular.isUndefined(attrs.decimals) ? 2 : parseFloat(attrs.decimals);
            attrs.duration = angular.isUndefined(attrs.duration) ? 5 : parseFloat(attrs.duration);

            $timeout(function() {
                numAnim = new CountUp($element[0], attrs.from, $scope.countupto, attrs.decimals, attrs.duration, options);
                numAnim.start();

                $scope.$watch('countupto', function(value, oldValue) {
                    if (angular.isDefined(value) && value != oldValue) {
                        numAnim.update(value);
                    }
                });

            }, 500);
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .component('counterWidget', {
            templateUrl: 'core/components/counter/counter-widget.tmpl.html',
            controllerAs: 'vm',
            bindings: {
                title: '@',
                count: '<',
                icon: '@',
                background: '@',
                color: '@'
            }
        });
})();
;
(function(window, angular, undefined) {
    'use strict';

    var dateClick;


    var canvasTypes = {
        hue: {
            getColorByPoint: function(x, y) {
                var imageData = this.getImageData(x, y);
                this.setMarkerCenter(y);

                var hsl = new tinycolor({
                    r: imageData[0],
                    g: imageData[1],
                    b: imageData[2]
                });
                return hsl.toHsl().h;
            },
            draw: function() {
                this.$element.css({
                    'height': this.height + 'px'
                });

                this.canvas.height = this.height;
                this.canvas.width = this.height;

                // Create gradient
                var hueGrd = this.context.createLinearGradient(90, 0.000, 90, this.height);

                // Add colors
                hueGrd.addColorStop(0.01, 'rgba(255, 0, 0, 1.000)');
                hueGrd.addColorStop(0.167, 'rgba(255, 0, 255, 1.000)');
                hueGrd.addColorStop(0.333, 'rgba(0, 0, 255, 1.000)');
                hueGrd.addColorStop(0.500, 'rgba(0, 255, 255, 1.000)');
                hueGrd.addColorStop(0.666, 'rgba(0, 255, 0, 1.000)');
                hueGrd.addColorStop(0.828, 'rgba(255, 255, 0, 1.000)');
                hueGrd.addColorStop(0.999, 'rgba(255, 0, 0, 1.000)');

                // Fill with gradient
                this.context.fillStyle = hueGrd;
                this.context.fillRect(0, 0, this.canvas.width, this.height);
            }
        },
        alpha: {
            getColorByPoint: function(x, y) {
                var imageData = this.getImageData(x, y);
                this.setMarkerCenter(y);

                return imageData[3] / 255;
            },
            draw: function() {
                this.$element.css({
                    'height': this.height + 'px'
                });

                this.canvas.height = this.height;
                this.canvas.width = this.height;

                // Create gradient
                var hueGrd = this.context.createLinearGradient(90, 0.000, 90, this.height);

                // Add colors
                hueGrd.addColorStop(0.01, 'rgba(' + this.currentColor.r + ',' + this.currentColor.g + ',' + this.currentColor.b + ', 1.000)');
                hueGrd.addColorStop(0.99, 'rgba(' + this.currentColor.r + ',' + this.currentColor.g + ',' + this.currentColor.b + ', 0.000)');

                // Fill with gradient
                this.context.fillStyle = hueGrd;
                this.context.fillRect(-1, -1, this.canvas.width + 2, this.height + 2);
            },
            extra: function() {
                this.$scope.$on('mdColorPicker:spectrumColorChange', angular.bind(this, function(e, args) {
                    this.currentColor = args.color;
                    this.draw();
                }));
            }
        },
        spectrum: {
            getColorByPoint: function(x, y) {

                var imageData = this.getImageData(x, y);
                this.setMarkerCenter(x, y);

                return {
                    r: imageData[0],
                    g: imageData[1],
                    b: imageData[2]
                };
            },
            draw: function() {
                this.canvas.height = this.height;
                this.canvas.width = this.height;
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

                // Odd bug prevented selecting min, max ranges from all gradients.
                // Start at 0.01, end at 0.99 and stretch it to 1px larger in each direction

                // White gradient
                var whiteGrd = this.context.createLinearGradient(0, 0, this.canvas.width, 0);


                whiteGrd.addColorStop(0.01, 'rgba(255, 255, 255, 1.000)');
                whiteGrd.addColorStop(0.99, 'rgba(255, 255, 255, 0.000)');

                // Black Gradient
                var blackGrd = this.context.createLinearGradient(0, 0, 0, this.canvas.height);


                blackGrd.addColorStop(0.01, 'rgba(0, 0, 0, 0.000)');
                blackGrd.addColorStop(0.99, 'rgba(0, 0, 0, 1.000)');

                // Fill with solid
                this.context.fillStyle = 'hsl( ' + this.currentHue + ', 100%, 50%)';
                this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);

                // Fill with white
                // Odd bug prevented selecting min, max ranges from all gradients
                this.context.fillStyle = whiteGrd;
                this.context.fillRect(-1, -1, this.canvas.width + 2, this.canvas.height + 2);

                // Fill with black
                // Odd bug prevented selecting min, max ranges from all gradients
                this.context.fillStyle = blackGrd;
                this.context.fillRect(-1, -1, this.canvas.width + 2, this.canvas.height + 2);
            },
            extra: function() {
                this.$scope.$on('mdColorPicker:spectrumHueChange', angular.bind(this, function(e, args) {
                    this.currentHue = args.hue;
                    this.draw();
                    var markerPos = this.getMarkerCenter();
                    var color = this.getColorByPoint(markerPos.x, markerPos.y);
                    this.setColor(color);

                }));
            }
        }

    };

    function GradientCanvasFactory() {

        return function gradientCanvas(type) {
            var canvas = new GradientCanvas(type, type != 'spectrum');
            canvas = angular.merge(canvas, canvasTypes[type]);

            return {
                template: '<canvas width="100%" height="100%"></canvas><div class="md-color-picker-marker"></div>',
                link: canvas.get,
                controller: function() {
                    //	console.log( "mdColorPickerAlpha Controller", Date.now() - dateClick );
                }
            };
        }

    }

    function GradientCanvas(type, restrictX) {

        this.type = type;
        this.restrictX = restrictX;
        this.offset = {
            x: null,
            y: null
        };
        this.height = 255;

        this.$scope = null;
        this.$element = null;

        this.get = angular.bind(this, function($temp_scope, $temp_element, $temp_attrs) {
            ////////////////////////////
            // Variables
            ////////////////////////////

            this.$scope = $temp_scope;
            this.$element = $temp_element;


            this.canvas = this.$element.children()[0];
            this.marker = this.$element.children()[1];
            this.context = this.canvas.getContext('2d');
            this.currentColor = this.$scope.color.toRgb();
            this.currentHue = this.$scope.color.toHsv().h;
            ////////////////////////////
            // Watchers, Observes, Events
            ////////////////////////////

            //$scope.$watch( function() { return color.getRgb(); }, hslObserver, true );


            this.$element.on('touchstart mousedown', angular.bind(this, this.onMouseDown));
            this.$scope.$on('mdColorPicker:colorSet', angular.bind(this, this.onColorSet));
            if (this.extra) {
                this.extra();
            }
            ////////////////////////////
            // init
            ////////////////////////////

            this.draw();
        });

        //return angular.bind( this, this.get );

    }



    GradientCanvas.prototype.$window = angular.element(window);

    GradientCanvas.prototype.getColorByMouse = function(e) {

        var te = e.touches && e.touches[0];

        var pageX = te && te.pageX || e.pageX;
        var pageY = te && te.pageY || e.pageY;

        var x = Math.round(pageX - this.offset.x);
        var y = Math.round(pageY - this.offset.y);

        return this.getColorByPoint(x, y);
    };

    GradientCanvas.prototype.setMarkerCenter = function(x, y) {
        var xOffset = -1 * this.marker.offsetWidth / 2;
        var yOffset = -1 * this.marker.offsetHeight / 2;
        var xAdjusted, xFinal, yAdjusted, yFinal;

        if (y === undefined) {
            yAdjusted = x + yOffset;
            yFinal = Math.round(Math.max(Math.min(this.height - 1 + yOffset, yAdjusted), yOffset));

            xFinal = 0;
        } else {
            xAdjusted = x + xOffset;
            yAdjusted = y + yOffset;

            xFinal = Math.floor(Math.max(Math.min(this.height + xOffset, xAdjusted), xOffset));
            yFinal = Math.floor(Math.max(Math.min(this.height + yOffset, yAdjusted), yOffset));
            // Debug output
            // console.log( "Raw: ", x+','+y, "Adjusted: ", xAdjusted + ',' + yAdjusted, "Final: ", xFinal + ',' + yFinal );
        }



        angular.element(this.marker).css({
            'left': xFinal + 'px'
        });
        angular.element(this.marker).css({
            'top': yFinal + 'px'
        });
    };

    GradientCanvas.prototype.getMarkerCenter = function() {
        var returnObj = {
            x: this.marker.offsetLeft + (Math.floor(this.marker.offsetWidth / 2)),
            y: this.marker.offsetTop + (Math.floor(this.marker.offsetHeight / 2))
        };
        return returnObj;
    };

    GradientCanvas.prototype.getImageData = function(x, y) {
        x = Math.max(0, Math.min(x, this.canvas.width - 1));
        y = Math.max(0, Math.min(y, this.canvas.height - 1));

        var imageData = this.context.getImageData(x, y, 1, 1).data;
        return imageData;
    };

    GradientCanvas.prototype.onMouseDown = function(e) {
        // Prevent highlighting
        e.preventDefault();
        e.stopImmediatePropagation();

        this.$scope.previewUnfocus();

        this.$element.css({
            'cursor': 'none'
        });

        this.offset.x = this.canvas.getBoundingClientRect().left;
        this.offset.y = this.canvas.getBoundingClientRect().top;

        var fn = angular.bind(this, function(e) {
            switch (this.type) {
                case 'hue':
                    var hue = this.getColorByMouse(e);
                    this.$scope.$broadcast('mdColorPicker:spectrumHueChange', {
                        hue: hue
                    });
                    break;
                case 'alpha':
                    var alpha = this.getColorByMouse(e);
                    this.$scope.color.setAlpha(alpha);
                    this.$scope.alpha = alpha;
                    this.$scope.$apply();
                    break;
                case 'spectrum':
                    var color = this.getColorByMouse(e);
                    this.setColor(color);
                    break;
            }
        });

        this.$window.on('touchmove mousemove', fn);
        this.$window.one('touchend mouseup', angular.bind(this, function(e) {
            this.$window.off('touchmove mousemove', fn);
            this.$element.css({
                'cursor': 'crosshair'
            });
        }));

        // Set the color
        fn(e);
    };

    GradientCanvas.prototype.setColor = function(color) {

        this.$scope.color._r = color.r;
        this.$scope.color._g = color.g;
        this.$scope.color._b = color.b;
        this.$scope.$apply();
        this.$scope.$broadcast('mdColorPicker:spectrumColorChange', {
            color: color
        });
    };

    GradientCanvas.prototype.onColorSet = function(e, args) {
        switch (this.type) {
            case 'hue':
                var hsv = this.$scope.color.toHsv();
                this.setMarkerCenter(this.canvas.height - (this.canvas.height * (hsv.h / 360)));
                break;
            case 'alpha':
                this.currentColor = args.color.toRgb();
                this.draw();

                var alpha = args.color.getAlpha();
                var pos = this.canvas.height - (this.canvas.height * alpha);

                this.setMarkerCenter(pos);
                break;
            case 'spectrum':
                var hsv = args.color.toHsv();
                this.currentHue = hsv.h;
                this.draw();

                var posX = this.canvas.width * hsv.s;
                var posY = this.canvas.height - (this.canvas.height * hsv.v);

                this.setMarkerCenter(posX, posY);
                break;
        }

    };








    angular.module('atheer')
        .run(['$templateCache', function($templateCache) {
            //icon resource should not be dependent
            //credit to materialdesignicons.com
            var shapes = {
                'clear': '<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',
                'gradient': '<path d="M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"/>',
                'tune': '<path d="M13 21v-2h8v-2h-8v-2h-2v6h2zM3 17v2h6v-2H3z"/><path d="M21 13v-2H11v2h10zM7 9v2H3v2h4v2h2V9H7z"/><path d="M15 9h2V7h4V5h-4V3h-2v6zM3 5v2h10V5H3z"/>',
                'view_module': '<path d="M4 11h5V5H4v6z"/><path d="M4 18h5v-6H4v6z"/><path d="M10 18h5v-6h-5v6z"/><path d="M16 18h5v-6h-5v6z"/><path d="M10 11h5V5h-5v6z"/><path d="M16 5v6h5V5h-5z"/>',
                'view_headline': '<path d="M4 15h17v-2H4v2z"/><path d="M4 19h17v-2H4v2z"/><path d="M4 11h17V9H4v2z"/><path d="M4 5v2h17V5H4z"/>',
                'history': '<path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M12 8v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>',
                'clear_all': '<path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"/>'
            };
            for (var i in shapes) {
                if (shapes.hasOwnProperty(i)) {
                    $templateCache.put([i, 'svg'].join('.'),
                        ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">', shapes[i], '</svg>'].join(''));
                }
            }
        }])
        .factory('mdColorGradientCanvas', GradientCanvasFactory)
        .factory('mdColorPickerHistory', ['$injector', function($injector) {

            var history = [];
            var strHistory = [];

            var $cookies = false;
            try {
                $cookies = $injector.get('$cookies');
            } catch (e) {

            }

            if ($cookies) {
                var tmpHistory = $cookies.getObject('mdColorPickerHistory') || [];
                for (var i = 0; i < tmpHistory.length; i++) {
                    history.push(tinycolor(tmpHistory[i]));
                    strHistory.push(tmpHistory[i]);
                }
            }

            var length = 40;

            return {
                length: function() {
                    if (arguments[0]) {
                        length = arguments[0];
                    } else {
                        return history.length;
                    }
                },
                add: function(color) {
                    for (var x = 0; x < history.length; x++) {
                        if (history[x].toRgbString() === color.toRgbString()) {
                            history.splice(x, 1);
                            strHistory.splice(x, 1);
                        }
                    }

                    history.unshift(color);
                    strHistory.unshift(color.toRgbString());

                    if (history.length > length) {
                        history.pop();
                        strHistory.pop();
                    }
                    if ($cookies) {
                        $cookies.putObject('mdColorPickerHistory', strHistory);
                    }
                },
                get: function() {
                    return history;
                },
                reset: function() {
                    history = [];
                    strHistory = [];
                    if ($cookies) {
                        $cookies.putObject('mdColorPickerHistory', strHistory);
                    }
                }
            };
        }])
        .directive('mdColorPicker', ['$timeout', 'mdColorPickerHistory', function($timeout, colorHistory) {

            return {
                templateUrl: "core/components/color-picker/mdColorPicker.tpl.html",

                // Added required controller ngModel
                require: '^ngModel',
                scope: {
                    options: '=mdColorPicker',

                    // Input options
                    type: '@',
                    label: '@?',
                    icon: '@?',
                    random: '@?',
                    default: '@?',

                    // Dialog Options
                    openOnInput: '=?',
                    hasBackdrop: '=?',
                    clickOutsideToClose: '=?',
                    skipHide: '=?',
                    preserveScope: '=?',

                    // Advanced options
                    mdColorClearButton: '=?',
                    mdColorPreview: '=?',

                    mdColorAlphaChannel: '=?',
                    mdColorSpectrum: '=?',
                    mdColorSliders: '=?',
                    mdColorGenericPalette: '=?',
                    mdColorMaterialPalette: '=?',
                    mdColorHistory: '=?',
                    mdColorHex: '=?',
                    mdColorRgb: '=?',
                    mdColorHsl: '=?',
                    mdColorDefaultTab: '=?'
                },
                controller: ['$scope', '$element', '$attrs', '$mdDialog', '$mdColorPicker', function($scope, $element, $attrs, $mdDialog, $mdColorPicker) {
                    var didJustClose = false;

                    // Merge Options Object with scope.  Scope will take precedence much like css vs style attribute.
                    if ($scope.options !== undefined) {
                        for (var opt in $scope.options) {
                            if ($scope.options.hasOwnProperty(opt)) {
                                var scopeKey;
                                //if ( $scope.hasOwnProperty( opt ) ) { // Removing this because optional scope properties are not added to the scope.
                                scopeKey = opt;
                                //} else
                                if ($scope.hasOwnProperty('mdColor' + opt.slice(0, 1).toUpperCase() + opt.slice(1))) {
                                    scopeKey = 'mdColor' + opt.slice(0, 1).toUpperCase() + opt.slice(1);
                                }
                                if (scopeKey && ($scope[scopeKey] === undefined || $scope[scopeKey] === '')) {
                                    $scope[scopeKey] = $scope.options[opt];
                                }
                            }
                        }
                    }

                    // Get ngModelController from the current element
                    var ngModel = $element.controller('ngModel');

                    // Quick function for updating the local 'value' on scope
                    var updateValue = function(val) {
                        $scope.value = val || ngModel.$viewValue || '';
                    };

                    // Defaults
                    // Everything is enabled by default.
                    $scope.mdColorClearButton = $scope.mdColorClearButton === undefined ? true : $scope.mdColorClearButton;
                    $scope.mdColorPreview = $scope.mdColorPreview === undefined ? true : $scope.mdColorPreview;

                    $scope.mdColorAlphaChannel = $scope.mdColorAlphaChannel === undefined ? true : $scope.mdColorAlphaChannel;
                    $scope.mdColorSpectrum = $scope.mdColorSpectrum === undefined ? true : $scope.mdColorSpectrum;
                    $scope.mdColorSliders = $scope.mdColorSliders === undefined ? true : $scope.mdColorSliders;
                    $scope.mdColorGenericPalette = $scope.mdColorGenericPalette === undefined ? true : $scope.mdColorGenericPalette;
                    $scope.mdColorMaterialPalette = $scope.mdColorMaterialPalette === undefined ? true : $scope.mdColorMaterialPalette;
                    $scope.mdColorHistory = $scope.mdColorHistory === undefined ? true : $scope.mdColorHistory;
                    $scope.mdColorHex = $scope.mdColorHex === undefined ? true : $scope.mdColorHex;
                    $scope.mdColorRgb = $scope.mdColorRgb === undefined ? true : $scope.mdColorRgb;
                    $scope.mdColorHsl = $scope.mdColorHsl === undefined ? true : $scope.mdColorHsl;
                    // Set the starting value
                    updateValue();

                    // Keep an eye on changes
                    $scope.$watch(function() {
                        return ngModel.$modelValue;
                    }, function(newVal) {
                        updateValue(newVal);
                    });

                    // Watch for updates to value and set them on the model
                    $scope.$watch('value', function(newVal, oldVal) {
                        if (newVal !== '' && typeof newVal !== 'undefined' && newVal && newVal !== oldVal) {
                            ngModel.$setViewValue(newVal);
                        }
                    });

                    // The only other ngModel changes

                    $scope.clearValue = function clearValue() {
                        ngModel.$setViewValue('');
                    };
                    $scope.showColorPicker = function showColorPicker($event) {
                        if (didJustClose) {
                            return;
                        }
                        //	dateClick = Date.now();
                        //	console.log( "CLICK OPEN", dateClick, $scope );

                        $mdColorPicker.show({
                            value: $scope.value,
                            defaultValue: $scope.default,
                            random: $scope.random,
                            clickOutsideToClose: $scope.clickOutsideToClose,
                            hasBackdrop: $scope.hasBackdrop,
                            skipHide: $scope.skipHide,
                            preserveScope: $scope.preserveScope,

                            mdColorAlphaChannel: $scope.mdColorAlphaChannel,
                            mdColorSpectrum: $scope.mdColorSpectrum,
                            mdColorSliders: $scope.mdColorSliders,
                            mdColorGenericPalette: $scope.mdColorGenericPalette,
                            mdColorMaterialPalette: $scope.mdColorMaterialPalette,
                            mdColorHistory: $scope.mdColorHistory,
                            mdColorHex: $scope.mdColorHex,
                            mdColorRgb: $scope.mdColorRgb,
                            mdColorHsl: $scope.mdColorHsl,
                            mdColorDefaultTab: $scope.mdColorDefaultTab,

                            $event: $event,

                        }).then(function(color) {
                            $scope.value = color;
                        });
                    };
                }],
                compile: function(element, attrs) {

                    //attrs.value = attrs.value || "#ff0000";
                    attrs.type = attrs.type !== undefined ? attrs.type : 0;

                }
            };
        }])
        .directive('mdColorPickerContainer', ['$compile', '$timeout', '$mdColorPalette', 'mdColorPickerHistory', function($compile, $timeout, $mdColorPalette, colorHistory) {
            return {
                templateUrl: 'core/components/color-picker/mdColorPickerContainer.tpl.html',
                scope: {
                    value: '=?',
                    default: '@',
                    random: '@',
                    ok: '=?',
                    mdColorAlphaChannel: '=',
                    mdColorSpectrum: '=',
                    mdColorSliders: '=',
                    mdColorGenericPalette: '=',
                    mdColorMaterialPalette: '=',
                    mdColorHistory: '=',
                    mdColorHex: '=',
                    mdColorRgb: '=',
                    mdColorHsl: '=',
                    mdColorDefaultTab: '='
                },
                controller: function($scope, $element, $attrs) {
                    //	console.log( "mdColorPickerContainer Controller", Date.now() - dateClick, $scope );

                    function getTabIndex(tab) {
                        var index = 0;
                        if (tab && typeof(tab) === 'string') {
                            /* DOM isn't fast enough for this

                            var tabs = $element[0].querySelector('.md-color-picker-colors').getElementsByTagName( 'md-tab' );
                            console.log( tabs.length );
                            */
                            var tabName = 'mdColor' + tab.slice(0, 1).toUpperCase() + tab.slice(1);
                            var tabs = ['mdColorSpectrum', 'mdColorSliders', 'mdColorGenericPalette', 'mdColorMaterialPalette', 'mdColorHistory'];
                            for (var x = 0; x < tabs.length; x++) {
                                //console.log(  tabs[x]('ng-if') );
                                //if ( tabs[x].getAttribute('ng-if') == tabName ) {
                                if (tabs[x] == tabName) {
                                    if ($scope[tabName]) {
                                        index = x;
                                        break;
                                    }
                                }
                            }
                        } else if (tab && typeof(tab) === 'number') {
                            index = tab;
                        }

                        return index;
                    }

                    ///////////////////////////////////
                    // Variables
                    ///////////////////////////////////
                    var container = angular.element($element[0].querySelector('.md-color-picker-container'));
                    var resultSpan = angular.element(container[0].querySelector('.md-color-picker-result'));
                    var previewInput = angular.element($element[0].querySelector('.md-color-picker-preview-input'));

                    var outputFn = [
                        'toHexString',
                        'toRgbString',
                        'toHslString'
                    ];



                    $scope.default = $scope.default ? $scope.default : $scope.random ? tinycolor.random() : 'rgb(255,255,255)';
                    if ($scope.value.search('#') >= 0) {
                        $scope.type = 0;
                    } else if ($scope.value.search('rgb') >= 0) {
                        $scope.type = 1;
                    } else if ($scope.value.search('hsl') >= 0) {
                        $scope.type = 2;
                    }
                    $scope.color = new tinycolor($scope.value || $scope.default); // Set initial color
                    $scope.alpha = $scope.color.getAlpha();
                    $scope.history = colorHistory;
                    $scope.materialFamily = [];

                    $scope.whichPane = getTabIndex($scope.mdColorDefaultTab);
                    $scope.inputFocus = false;

                    // Colors for the palette screen
                    ///////////////////////////////////
                    var steps = 9;
                    var freq = 2 * Math.PI / steps;

                    $scope.palette = [
                        ["rgb(255, 204, 204)", "rgb(255, 230, 204)", "rgb(255, 255, 204)", "rgb(204, 255, 204)", "rgb(204, 255, 230)", "rgb(204, 255, 255)", "rgb(204, 230, 255)", "rgb(204, 204, 255)", "rgb(230, 204, 255)", "rgb(255, 204, 255)"],
                        ["rgb(255, 153, 153)", "rgb(255, 204, 153)", "rgb(255, 255, 153)", "rgb(153, 255, 153)", "rgb(153, 255, 204)", "rgb(153, 255, 255)", "rgb(153, 204, 255)", "rgb(153, 153, 255)", "rgb(204, 153, 255)", "rgb(255, 153, 255)"],
                        ["rgb(255, 102, 102)", "rgb(255, 179, 102)", "rgb(255, 255, 102)", "rgb(102, 255, 102)", "rgb(102, 255, 179)", "rgb(102, 255, 255)", "rgb(102, 179, 255)", "rgb(102, 102, 255)", "rgb(179, 102, 255)", "rgb(255, 102, 255)"],
                        ["rgb(255, 51, 51)", "rgb(255, 153, 51)", "rgb(255, 255, 51)", "rgb(51, 255, 51)", "rgb(51, 255, 153)", "rgb(51, 255, 255)", "rgb(51, 153, 255)", "rgb(51, 51, 255)", "rgb(153, 51, 255)", "rgb(255, 51, 255)"],
                        ["rgb(255, 0, 0)", "rgb(255, 128, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)", "rgb(0, 255, 128)", "rgb(0, 255, 255)", "rgb(0, 128, 255)", "rgb(0, 0, 255)", "rgb(128, 0, 255)", "rgb(255, 0, 255)"],
                        ["rgb(245, 0, 0)", "rgb(245, 123, 0)", "rgb(245, 245, 0)", "rgb(0, 245, 0)", "rgb(0, 245, 123)", "rgb(0, 245, 245)", "rgb(0, 123, 245)", "rgb(0, 0, 245)", "rgb(123, 0, 245)", "rgb(245, 0, 245)"],
                        ["rgb(214, 0, 0)", "rgb(214, 108, 0)", "rgb(214, 214, 0)", "rgb(0, 214, 0)", "rgb(0, 214, 108)", "rgb(0, 214, 214)", "rgb(0, 108, 214)", "rgb(0, 0, 214)", "rgb(108, 0, 214)", "rgb(214, 0, 214)"],
                        ["rgb(163, 0, 0)", "rgb(163, 82, 0)", "rgb(163, 163, 0)", "rgb(0, 163, 0)", "rgb(0, 163, 82)", "rgb(0, 163, 163)", "rgb(0, 82, 163)", "rgb(0, 0, 163)", "rgb(82, 0, 163)", "rgb(163, 0, 163)"],
                        ["rgb(92, 0, 0)", "rgb(92, 46, 0)", "rgb(92, 92, 0)", "rgb(0, 92, 0)", "rgb(0, 92, 46)", "rgb(0, 92, 92)", "rgb(0, 46, 92)", "rgb(0, 0, 92)", "rgb(46, 0, 92)", "rgb(92, 0, 92)"],
                        ["rgb(255, 255, 255)", "rgb(205, 205, 205)", "rgb(178, 178, 178)", "rgb(153, 153, 153)", "rgb(127, 127, 127)", "rgb(102, 102, 102)", "rgb(76, 76, 76)", "rgb(51, 51, 51)", "rgb(25, 25, 25)", "rgb(0, 0, 0)"]
                    ];

                    $scope.materialPalette = $mdColorPalette;

                    ///////////////////////////////////
                    // Functions
                    ///////////////////////////////////
                    $scope.isDark = function isDark(color) {
                        if (angular.isArray(color)) {
                            return tinycolor({
                                r: color[0],
                                g: color[1],
                                b: color[2]
                            }).isDark();
                        } else {
                            return tinycolor(color).isDark();
                        }

                    };
                    $scope.previewFocus = function() {
                        $scope.inputFocus = true;
                        $timeout(function() {
                            previewInput[0].setSelectionRange(0, previewInput[0].value.length);
                        });
                    };
                    $scope.previewUnfocus = function() {
                        $scope.inputFocus = false;
                        previewInput[0].blur();
                    };
                    $scope.previewBlur = function() {
                        $scope.inputFocus = false;
                        $scope.setValue();
                    };
                    $scope.previewKeyDown = function($event) {

                        if ($event.keyCode == 13) {
                            $scope.ok && $scope.ok();
                        }
                    };
                    $scope.setPaletteColor = function(event) {
                        $timeout(function() {
                            $scope.color = tinycolor(event.target.style.backgroundColor);
                        });
                    };

                    $scope.setValue = function setValue() {
                        // Set the value if available
                        if ($scope.color && $scope.color && outputFn[$scope.type] && $scope.color.toRgbString() !== 'rgba(0, 0, 0, 0)') {
                            $scope.value = $scope.color[outputFn[$scope.type]]();
                        }
                    };

                    $scope.changeValue = function changeValue() {
                        $scope.color = tinycolor($scope.value);
                        $scope.$broadcast('mdColorPicker:colorSet', {
                            color: $scope.color
                        });
                    };


                    ///////////////////////////////////
                    // Watches and Events
                    ///////////////////////////////////
                    $scope.$watch('color._a', function(newValue) {
                        $scope.color.setAlpha(newValue);
                    }, true);

                    $scope.$watch('whichPane', function(newValue) {
                        // 0 - spectrum selector
                        // 1 - sliders
                        // 2 - palette
                        $scope.$broadcast('mdColorPicker:colorSet', {
                            color: $scope.color
                        });

                    });

                    $scope.$watch('type', function() {
                        previewInput.removeClass('switch');
                        $timeout(function() {
                            previewInput.addClass('switch');
                        });
                    });

                    $scope.$watchGroup(['color.toRgbString()', 'type'], function(newValue) {
                        if (!$scope.inputFocus) {
                            $scope.setValue();
                        }
                    });


                    ///////////////////////////////////
                    // INIT
                    // Let all the other directives initialize
                    ///////////////////////////////////
                    //	console.log( "mdColorPickerContainer Controller PRE Timeout", Date.now() - dateClick );
                    $timeout(function() {
                        //		console.log( "mdColorPickerContainer Controller Timeout", Date.now() - dateClick );
                        $scope.$broadcast('mdColorPicker:colorSet', {
                            color: $scope.color
                        });
                        previewInput.focus();
                        $scope.previewFocus();
                    });
                },
                link: function(scope, element, attrs) {

                    var tabs = element[0].getElementsByTagName('md-tab');
                    /*
                    Replicating these structure without ng-repeats

                    <div ng-repeat="row in palette track by $index" flex="15"  layout-align="space-between" layout="row"  layout-fill>
                    	<div ng-repeat="col in row track by $index" flex="10" style="height: 25.5px;" ng-style="{'background': col};" ng-click="setPaletteColor($event)"></div>
                    </div>

                    <div ng-repeat="(key, value) in materialColors">
                    	<div ng-style="{'background': 'rgb('+value['500'].value[0]+','+value['500'].value[1]+','+value['500'].value[2]+')', height: '75px'}" class="md-color-picker-material-title" ng-class="{'dark': isDark( value['500'].value )}" ng-click="setPaletteColor($event)">
                    		<span>{{key}}</span>
                    	</div>
                    	<div ng-repeat="(label, color) in value track by $index" ng-style="{'background': 'rgb('+color.value[0]+','+color.value[1]+','+color.value[2]+')', height: '33px'}" class="md-color-picker-with-label" ng-class="{'dark': isDark( color.value )}" ng-click="setPaletteColor($event)">
                    		<span>{{label}}</span>
                    	</div>
                    </div>
                    */


                    $timeout(function() {
                        createDOM();
                    });

                    function createDOM() {
                        var paletteContainer = angular.element(element[0].querySelector('.md-color-picker-palette'));
                        var materialContainer = angular.element(element[0].querySelector('.md-color-picker-material-palette'));
                        var paletteRow = angular.element('<div class="flex-15 layout-fill layout-row layout-align-space-between" layout-align="space-between" layout="row" layout-fill"></div>');
                        var paletteCell = angular.element('<div class="flex-10"></div>');

                        var materialTitle = angular.element('<div class="md-color-picker-material-title"></div>');
                        var materialRow = angular.element('<div class="md-color-picker-with-label"></div>');



                        angular.forEach(scope.palette, function(value, key) {
                            var row = paletteRow.clone();
                            angular.forEach(value, function(color) {
                                var cell = paletteCell.clone();
                                cell.css({
                                    height: '25.5px',
                                    backgroundColor: color
                                });
                                cell.bind('click', scope.setPaletteColor);
                                row.append(cell);
                            });

                            paletteContainer.append(row);
                        });

                        angular.forEach(scope.materialPalette, function(value, key) {
                            var title = materialTitle.clone();
                            title.html('<span>' + key.replace('-', ' ') + '</span>');
                            title.css({
                                height: '75px',
                                backgroundColor: 'rgb(' + value['500'].value[0] + ',' + value['500'].value[1] + ',' + value['500'].value[2] + ')'
                            });
                            if (scope.isDark(value['500'].value)) {
                                title.addClass('dark');
                            }

                            materialContainer.append(title);

                            angular.forEach(value, function(color, label) {

                                var row = materialRow.clone();
                                row.css({
                                    height: '33px',
                                    backgroundColor: 'rgb(' + color.value[0] + ',' + color.value[1] + ',' + color.value[2] + ')'
                                });
                                if (scope.isDark(color.value)) {
                                    row.addClass('dark');
                                }

                                row.html('<span>' + label + '</span>');
                                row.bind('click', scope.setPaletteColor);
                                materialContainer.append(row);
                            });


                        });
                    }
                }
            };
        }])

        .directive('mdColorPickerHue', ['mdColorGradientCanvas', function(mdColorGradientCanvas) {
            return new mdColorGradientCanvas('hue');
        }])
        .directive('mdColorPickerAlpha', ['mdColorGradientCanvas', function(mdColorGradientCanvas) {
            return new mdColorGradientCanvas('alpha');
        }])
        .directive('mdColorPickerSpectrum', ['mdColorGradientCanvas', function(mdColorGradientCanvas) {
            return new mdColorGradientCanvas('spectrum');
        }])

        .factory('$mdColorPicker', ['$q', '$mdDialog', 'mdColorPickerHistory', function($q, $mdDialog, colorHistory) {
            var dialog;

            return {
                show: function(options) {
                    if (options === undefined) {
                        options = {};
                    }
                    //console.log( 'DIALOG OPTIONS', options );
                    // Defaults
                    // Dialog Properties
                    options.hasBackdrop = options.hasBackdrop === undefined ? true : options.hasBackdrop;
                    options.clickOutsideToClose = options.clickOutsideToClose === undefined ? true : options.clickOutsideToClose;
                    options.defaultValue = options.defaultValue === undefined ? '#FFFFFF' : options.defaultValue;
                    options.focusOnOpen = options.focusOnOpen === undefined ? false : options.focusOnOpen;
                    options.preserveScope = options.preserveScope === undefined ? true : options.preserveScope;
                    options.skipHide = options.skipHide === undefined ? true : options.skipHide;

                    // mdColorPicker Properties
                    options.mdColorAlphaChannel = options.mdColorAlphaChannel === undefined ? false : options.mdColorAlphaChannel;
                    options.mdColorSpectrum = options.mdColorSpectrum === undefined ? true : options.mdColorSpectrum;
                    options.mdColorSliders = options.mdColorSliders === undefined ? true : options.mdColorSliders;
                    options.mdColorGenericPalette = options.mdColorGenericPalette === undefined ? true : options.mdColorGenericPalette;
                    options.mdColorMaterialPalette = options.mdColorMaterialPalette === undefined ? true : options.mdColorMaterialPalette;
                    options.mdColorHistory = options.mdColorHistory === undefined ? true : options.mdColorHistory;
                    options.mdColorRgb = options.mdColorRgb === undefined ? true : options.mdColorRgb;
                    options.mdColorHsl = options.mdColorHsl === undefined ? true : options.mdColorHsl;
                    options.mdColorHex = ((options.mdColorHex === undefined) || (!options.mdColorRgb && !options.mdColorHsl)) ? true : options.mdColorHex;
                    options.mdColorAlphaChannel = (!options.mdColorRgb && !options.mdColorHsl) ? false : options.mdColorAlphaChannel;

                    dialog = $mdDialog.show({
                        templateUrl: 'core/components/color-picker/mdColorPickerDialog.tpl.html',
                        hasBackdrop: options.hasBackdrop,
                        clickOutsideToClose: options.clickOutsideToClose,

                        controller: ['$scope', 'options', function($scope, options) {
                            //console.log( "DIALOG CONTROLLER OPEN", Date.now() - dateClick );
                            $scope.close = function close() {
                                $mdDialog.cancel();
                            };
                            $scope.ok = function ok() {
                                $mdDialog.hide($scope.value);
                            };
                            $scope.hide = $scope.ok;



                            $scope.value = options.value;
                            $scope.default = options.defaultValue;
                            $scope.random = options.random;

                            $scope.mdColorAlphaChannel = options.mdColorAlphaChannel;
                            $scope.mdColorSpectrum = options.mdColorSpectrum;
                            $scope.mdColorSliders = options.mdColorSliders;
                            $scope.mdColorGenericPalette = options.mdColorGenericPalette;
                            $scope.mdColorMaterialPalette = options.mdColorMaterialPalette;
                            $scope.mdColorHistory = options.mdColorHistory;
                            $scope.mdColorHex = options.mdColorHex;
                            $scope.mdColorRgb = options.mdColorRgb;
                            $scope.mdColorHsl = options.mdColorHsl;
                            $scope.mdColorDefaultTab = options.mdColorDefaultTab;

                        }],

                        locals: {
                            options: options,
                        },
                        preserveScope: options.preserveScope,
                        skipHide: options.skipHide,

                        targetEvent: options.$event,
                        focusOnOpen: options.focusOnOpen,
                        autoWrap: false,
                        onShowing: function() {
                            //		console.log( "DIALOG OPEN START", Date.now() - dateClick );
                        },
                        onComplete: function() {
                            //		console.log( "DIALOG OPEN COMPLETE", Date.now() - dateClick );
                        }
                    });

                    dialog.then(function(value) {
                        colorHistory.add(new tinycolor(value));
                    }, function() {});

                    return dialog;
                },
                hide: function() {
                    return dialog.hide();
                },
                cancel: function() {
                    return dialog.cancel();
                }
            };
        }]);
})(window, window.angular);
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .factory('triBreadcrumbsService', BreadcrumbsService);

    /* @ngInject */
    function BreadcrumbsService($rootScope) {
        var crumbs = [];

        return {
            breadcrumbs: {
                crumbs: crumbs
            },
            addCrumb: addCrumb,
            reset: reset
        };

        ////////////////

        function addCrumb(item) {
            this.breadcrumbs.crumbs.unshift(item);
            $rootScope.$emit('changeTitle');
        }

        function reset() {
            this.breadcrumbs.crumbs = [];
        }
    }
})();
;
(function () {
    'use strict';
    angular.
        module("atheer").
        directive("fpGroupAvatar", fpGroupAvatar);

    function fpGroupAvatar() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                boxSize: '=',
                iconSize: '=',
                color: '='
            },
            templateUrl: 'core/components/avatar/group-avatar.tmpl.html'
        };
    }
}());
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('fpAvatar', fpAvatar);

    /* @ngInject */
    function fpAvatar(PubNubService) {
        var directive = {
            restrict: 'AE',
            replace: true,
            scope: {
                user: '=',
                presence: '=presence',
                width: '@width',
                bgcolor: '@bgColor',
                textColor: '@textColor',
                wrapper: '=wrapper',
                pictureResolution: '@pictureResolution',
                pixelated: '=pixelated',
                roundShape: '=roundShape',
                class: '@class',
                imgClass: '@imgClass',
                style: '@style',
                cornerRadius: '@cornerRadius',
                pictureFormat: '@pictureFormat',
                colorsPalette: '=colorsPalette',
                autoColor: '=autoColor',
                fontWeight: '@fontWeight',
                fontScale: '@fontScale',
                textShadow: '=textShadow',
                bind: '=bind',
                cameCase: '@camelCase',
            },
            link: function(scope, element, attrs) {

                var _user = null,
                    _long = 45,
                    _picture_resolution = 256,
                    _wrapper = true,
                    _str = "", //scope.initials || "",
                    _picture = null,
                    _presence = false,
                    _bgcolor = "#000",
                    _textcolor = "#fff",
                    _pixelated = false,
                    _img_styling = "vertical-align:top;",
                    _roundShape = false,
                    _wrapper_styling = "border-radius:0; display:block;",
                    _extra_classes = "",
                    _extra_img_classes = "",
                    _extra_styles = "",
                    _corner_radius = "0",
                    _picture_format = "png",
                    _colors_palette = ["#bdc3c7", "#6f7b87", "#2c3e50", "#2f3193", "#662d91", "#922790", "#ec2176", "#ed1c24", "#f36622", "#f8941e", "#fab70f", "#fdde00", "#d1d219", "#8ec73f", "#00a650", "#00aa9c", "#00adef", "#0081cd", "#005bab"],
                    _autoColor = true,
                    _font_weight = 100,
                    _font_scale = 100,
                    _text_shadow = false,
                    _bind = false,
                    _camel_case = false,
                    _img_width = "100%";

                function checkValues() {

                    if (scope.bind != undefined) {
                        _bind = scope.bind;
                    }

                    if (scope.textColor != undefined) {
                        _textcolor = scope.textColor;
                    }

                    if (scope.pictureResolution != undefined) {
                        _picture_resolution = scope.pictureResolution;
                    }

                    if (scope.width != undefined) {
                        _long = scope.width;
                    }

                    if (scope.wrapper != undefined) {
                        _wrapper = scope.wrapper;
                        if (_wrapper === false) {
                            _img_width = _long;
                        }
                    }

                    if (scope.pixelated != undefined) {
                        _pixelated = scope.pixelated;
                        if (_pixelated === true) {
                            _img_styling += "image-rendering:pixelated; image-rendering:-moz-crisp-edges;";
                        }
                    }

                    if (scope.roundShape != undefined) {
                        _roundShape = scope.roundShape;
                        if (_roundShape) _wrapper_styling += "border-radius: " + _long + "px;";
                    } else {
                        if (scope.cornerRadius != undefined) {
                            _corner_radius = scope.cornerRadius;
                            _wrapper_styling += "border-radius: " + _corner_radius + "px;";
                        }
                    }

                    if (scope.class != undefined) {
                        _extra_classes = scope.class;
                    }

                    if (scope.imgClass != undefined) {
                        _extra_img_classes = scope.imgClass;
                    }

                    if (scope.style != undefined) {
                        _extra_styles = scope.style;
                    }

                    if (scope.pictureFormat === 'jpeg') {
                        _picture_format = "jpeg";
                    }

                    if (scope.colorsPalette != undefined) {
                        _colors_palette = scope.colorsPalette;
                    }

                    if (scope.bgcolor != undefined) {
                        _bgcolor = scope.bgcolor;
                    } else {
                        if (scope.autoColor != undefined) {
                            _autoColor = scope.autoColor;
                        }
                    }

                    if (scope.fontWeight != undefined) {
                        _font_weight = scope.fontWeight;
                    }

                    if (scope.fontScale != undefined) {
                        _font_scale = scope.fontScale;
                    }

                    if (scope.textShadow != undefined) {
                        _text_shadow = scope.textShadow;
                    }

                    if (scope.presence === true) {
                        _presence = true;
                    }

                    if (scope.user != undefined) {
                        _user = scope.user;
                    }


                    if (scope.cameCase != undefined) {
                        _camel_case = scope.cameCase;
                    }
                }

                function generateAvatar(name, w, h, bgcolor, textcolor, bgImage) {

                    var WIDTH = 256,
                        HEIGHT = 256,
                        canvas, ctx, _font_size;

                    if (w != undefined && w > 0) {
                        if (h != undefined && h > 0) {
                            WIDTH = w;
                            HEIGHT = h;
                        }
                    }

                    canvas = document.createElement('canvas');
                    canvas.id = "ngAvatar-" + Date.now();
                    canvas.width = WIDTH;
                    canvas.height = HEIGHT;

                    ctx = canvas.getContext('2d');
                    ctx.fillStyle = bgcolor;
                    ctx.fillRect(0, 0, WIDTH, HEIGHT);

                    _font_size = WIDTH / (2.5 / (_font_scale / 100));
                    ctx.font = _font_weight + " " + _font_size + "px sans-serif";

                    if (_text_shadow === true) {
                        ctx.shadowColor = "black";
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 0;
                        ctx.shadowBlur = 5;
                    }

                    ctx.textAlign = "center";
                    ctx.fillStyle = textcolor;
                    ctx.fillText(_str, WIDTH / 2, HEIGHT - (HEIGHT / 2) + (_font_size / 3));

                    return canvas.toDataURL("image/" + _picture_format);
                }

                function getPicture(user) {
                    if (_camel_case) {
                        if (user.pictureId != null && _user.pictureId.length > 0) {
                            return '/media/pictures/' + _user.pictureId
                        } else {
                            return null;
                        }
                    } else {
                        if (user.picture_id != null && _user.picture_id.length > 0) {
                            return '/media/pictures/' + _user.picture_id
                        } else {
                            return null;
                        }
                    }
                }

                function getInitials(user) {
                    var str = null;

                    var firstName = '',
                        lastName = '';

                    if (_camel_case) {
                        firstName = _user.firstName ? _user.firstName.charAt(0) : _user.firstName;
                        lastName = _user.lastName ? _user.lastName.charAt(0) : _user.lastName;
                        str = firstName + ' ' + lastName
                    } else {
                        firstName = _user.first_name ? _user.first_name.charAt(0) : _user.first_name;
                        lastName = _user.last_name ? _user.last_name.charAt(0) : _user.last_name;
                        str = firstName + ' ' + lastName
                    };

                    var output = "",
                        i = 0,
                        str = str.split(" "),
                        len = str.length;

                    for (i; i < len; i++)
                        if (str[i] != "") output += str[i][0]; //.toUpperCase();
                    return output.toUpperCase();
                }

                var currentElement = element;

                function render() {
                    if (_user == null) {
                        return;
                    };

                    var imgData = null;
                    var pubNubState = null;

                    if (_presence) {
                        pubNubState = PubNubService.getUserState(_user.id);
                    }

                    var picture = getPicture(_user);
                    if (picture != null) {
                        imgData = picture;
                    } else {
                        _str = getInitials(_user);

                        if (_autoColor === true) {
                            var i, lon = _str.length,
                                charIndex = 0,
                                colorIndex;
                            charIndex = _str.charCodeAt(lon - 1) - 'A'.charCodeAt(0);
                            colorIndex = charIndex % _colors_palette.length;
                            _bgcolor = _colors_palette[colorIndex];
                        }
                        imgData = generateAvatar(_str, _picture_resolution, _picture_resolution, _bgcolor, _textcolor, null);
                    }

                    var html = '';
                    if (_wrapper) html += '<div class="storm-avatar-wrapper" style="' + _wrapper_styling + ' width:' + _long + 'px; height:' + _long + 'px; ' + _extra_styles + '">';
                    html += '<div style="overflow:hidden; border-radius:' + _long + 'px;' + ' width:' + _long + 'px; height:' + _long + 'px; ' + '">';
                    html += '<img src="' + imgData + '" class="avatar-picture ' + _extra_img_classes + '" style="' + _img_styling + '" width=100% height=100% object-fit="cover" />';
                    html += '</div>'
                    if (_presence && pubNubState != undefined && pubNubState != null) {
                        html += '<div class="presence online"></div>'
                    }
                    if (_wrapper) html += '</div>';

                    var replacementElement = angular.element(html);
                    currentElement.replaceWith(replacementElement);
                    currentElement = replacementElement;
                }

                checkValues();
                render();

                if (_bind === true) {
                    scope.$watch('user', function(value) {
                        checkValues();
                        render();
                    });
                } else {
                    render();
                }

                scope.$on('refreshUserStatus', function(event, userId) {
                    if (userId == _user.id) {
                        checkValues();
                        render();
                    }
                });
            }
        };
        return directive;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('fpAutoComplete', fpAutoComplete);

    function fpAutoComplete() {
        var directive = {
            restrict: 'E',
            replace: 'true',
            scope: {
                'component': '@',
                'placeholder': '@?',
                'autoCompleteModel': '=',
                'multiple': '@?',
                'specialFilter': '&?',
                'queryObjs': '=', //  array of query fields with [{'fieldName' : 'name', operator=''}]
                'required': '@?',
                'isSession': '=',
                'isScheduledSession': '=',
                'isAdmin': '=',
                'schedulerUserInfo': '=?',
                'errorModal': '=?',
                'inputFormFieldName': '@?',
                'skipCurrentUser': '@?'
            },
            controller: autocompleteDirectiveController,
            templateUrl: 'core/components/autocomplete/autocomplete-directive.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function autocompleteDirectiveController($scope, $injector, $filter, $q, $mdDialog, Principal) {
        var componentToInject = $scope.component == "UserInvite" || $scope.component == "SessionSingleUserInvite" ? "User" : $scope.component;
        var service = $injector.get(componentToInject);
        $scope.required = $scope.required == 'true';

        if(!!$scope.inputFormFieldName) {
            $scope.inputFieldName = $scope.inputFormFieldName;
        }
        
        $scope.allowMultiSelect = false;
        if ($scope.multiple == 'true') {
            $scope.allowMultiSelect = true;
        }

        $scope.isCancelDisabled = function () {
            return $scope.component === 'SessionSingleUserInvite' && !$scope.allowMultiSelect && $scope.required;            
        }

        var pickerDialogMeta = {
            'Content': {
                controller: 'ContentPickerController',
                templateUrl: 'modules/content/content-picker.html'
            },
            'Provider': {
                controller: 'ProviderPickerController',
                templateUrl: 'modules/content/provider/provider-picker.tmpl.html'
            },
            'Team': {
                controller: 'TeamPickerController',
                templateUrl: 'modules/team/team-picker.tmpl.html'
            },
            'Badge': {
                controller: 'BadgePickerController',
                templateUrl: 'modules/system/badge/badge-picker.tmpl.html'
            },
            'Folder': {
                controller: 'FolderPickerController',
                templateUrl: 'modules/content/folder/folder-picker.tmpl.html'
            },
            'Topic': {
                controller: 'TopicPickerController',
                templateUrl: 'modules/topic/topic-picker.tmpl.html'
            },
            'SecurityRole': {
                controller: 'SecurityRolePickerController',
                templateUrl: 'modules/system/security-role/security-role-picker.tmpl.html'
            },
            'User': {
                controller: 'UserPickerController',
                templateUrl: 'modules/user/user-picker.tmpl.html'
            },
            'EmailLayout': {
                controller: 'EmailLayoutPickerController',
                templateUrl: 'modules/system/email-layout/email-layout-picker.tmpl.html'
            },
            'UserInvite': {
                controller: 'SessionUserInviteController',
                templateUrl: 'modules/session/session-user-invite.tmpl.html'
            },
            'SessionSingleUserInvite': {
                controller: 'SessionUserInviteController',
                templateUrl: 'modules/session/session-user-invite.tmpl.html'
            },
        };

        var query = '';

        $scope.placeholder = $scope.placeholder ? $scope.placeholder : $filter('translate')('autoComplete.placeholder.' + $filter('lowercase')($scope.component));


        function formQuery(searchText) {
            if (!searchText) {
                return '';
            };

            var searchQuery = "(";

            searchQuery += 'first_name=re="' + searchText + '"';
            searchQuery += ',last_name=re="' + searchText + '"';
            searchQuery += ',email=re="' + searchText + '"';

            searchQuery += ")";

            return searchQuery
        }

        angular.forEach($scope.queryObjs, function(queryObj, index) {
            if (index > 0) {
                query += ';';
            }
            query += (queryObj.fieldName + queryObj.operator + (queryObj.value ? queryObj.value : '{querySearchText}'))
        });

        $scope.itemChanged = function(item) {
            if ($scope.component == 'Topic') {
                $scope.autoCompleteModel = item;
            }
            if ($scope.component == 'Team' && item) {
                $scope.autoCompleteModel = item;
            }
            if ($scope.component == 'SecurityRole' && item) {
                $scope.autoCompleteModel = item;
            }
            if ($scope.component == 'SessionSingleUserInvite' && item) {
                $scope.autoCompleteModel = item;
                $scope.$parent.isHostUpdated(item);
            }
        };

        $scope.onBlur = function () {
            if ($scope.component === "SessionSingleUserInvite") {
                // while search if user not clearing search then on blur clear seach
                // and add current selected host as it is required field
                var currentElement = angular.element(this) ? Array.from(angular.element(this)) : []
                if(currentElement && currentElement.length) {
                    currentElement[0].autoCompleteModel = $scope.autoCompleteModel;
                }
            }
        };

        $scope.isCacheEnabled = function () {
            return ["UserInvite", "User", "SessionSingleUserInvite"].includes($scope.component).toString();
        };


        function isMasterSchedulerPresent() { 
            return $scope.schedulerUserInfo && $scope.schedulerUserInfo.hasOwnProperty('id');
        }

        $scope.querySearch = function(searchText) {
            if (searchText.length >= 2) {
                var deferred = $q.defer();
                var userComponent = ["UserInvite", "User", "SessionSingleUserInvite"].includes(
                    $scope.component
                ) && !angular.isDefined($scope.queryObjs);
                var userQuery = formQuery(searchText);
                
                if (userComponent) {
                    if (
                        $scope.autoCompleteModel.length ||
                        ($scope.component === "SessionSingleUserInvite" &&
                            Object.keys($scope.autoCompleteModel).length)
                    ) {
                        if (!!userQuery) {
                            userQuery += ";";
                        }
                        if ($scope.component === "SessionSingleUserInvite") {
                            userQuery +=
                                "id=out=(" + $scope.autoCompleteModel.id + ")";
                        } else {
                            userQuery +=
                                "id=out=(" +
                                $scope.autoCompleteModel
                                    .map(function (user) {
                                        return user.id;
                                    })
                                    .toString() +
                                "," +
                                (isMasterSchedulerPresent()
                                    ? $scope.schedulerUserInfo.id
                                    : Principal.getUserId()) +
                                ")";
                        }
                    } else if($scope.component === "UserInvite") {
                        userQuery +=
                            ";id=out=(" +
                            (isMasterSchedulerPresent()
                                ? $scope.schedulerUserInfo.id
                                : Principal.getUserId()) +
                            ")";
                    } else {
                        userQuery +=
                            ";id=out=(" + Principal.getUserId() + ")";
                    }
                }
                
                service.query({
                    'query': (userComponent ? userQuery : query).replaceAll(/{querySearchText}/g, searchText),
                    check_admin: $scope.isAdmin
                }, function(result) {
                    if ($scope.specialFilter) {
                      deferred.resolve($scope.specialFilter({
                          result: result
                      }));
                    } else {
                        deferred.resolve(result);
                    }
                    setTimeout(function () {
                        var popups = document.querySelectorAll(
                            ".md-autocomplete-suggestions-container"
                        );

                        Array.from(popups).map(function (popup) {
                            var styles = popup.getAttribute("style");

                            if (
                                !popup.classList.contains("ng-hide") &&
                                result.length && 
                                (!styles.includes(" height:") || (popup.clientHeight > 48 * result.length ))
                            ) {
                                // Reference: 48px Item height 
                                // https://github.com/angular/material/blob/952c06705a7eddaa02fcbb2fd931e06740702404/src/components/autocomplete/js/autocompleteController.js#L5
                                popup.setAttribute(
                                    "style",
                                    styles +
                                        "height: " +
                                        (48 * result.length).toString() +
                                        "px !important;"
                                );
                            }
                        });
                    });
                }, function(result) {
                    deferred.reject([]);
                });
                return deferred.promise;
            } else {
                return [];
            }
        };

        $scope.openPickerDialog = function(ev) {
            var pickerDialogMetaData = pickerDialogMeta[$scope.component];
            var filter = '';

            if ($scope.component == 'Content') {
                filter = 'embedded==false;enabled==true';
            }

            var users = [];
            if ($scope.component == 'User') {
                for (var i = 0; i < $scope.autoCompleteModel.length; i++) {
                    $scope.autoCompleteModel[i].is_guest ? users.push($scope.autoCompleteModel[i].guest_invite_value)
                        : users.push($scope.autoCompleteModel[i].id);
                }
            }

            var topics = []
            if ($scope.allowMultiSelect && $scope.component == 'Topic') {
                for (var i = 0; i < $scope.autoCompleteModel.length; i++) {
                    topics.push($scope.autoCompleteModel[i].id)
                }
            }

            angular.forEach($scope.queryObjs, function(queryObj, index) {
                if (angular.isDefined(queryObj.value)) {
                    if (filter !== '') {
                        filter += ';' + queryObj.fieldName + queryObj.operator + queryObj.value;
                    } else {
                        filter += queryObj.fieldName + queryObj.operator + queryObj.value;
                    }
                }
            });

            var selectedItemIds = [];
            if($scope.allowMultiSelect && $scope.autoCompleteModel) {
                angular.forEach($scope.autoCompleteModel, function(data) {
                    if(data && data.id) {
                        selectedItemIds.push(data.id);
                    }
                });
            } else if ($scope.autoCompleteModel) {
                selectedItemIds.push($scope.autoCompleteModel.id);
            }

            if ($scope.component === "UserInvite") {
                filter = angular.copy(selectedItemIds);
                if (
                    angular.isDefined($scope.schedulerUserInfo) &&
                    $scope.schedulerUserInfo
                ) {
                    filter.push($scope.schedulerUserInfo.id);
                }
            } else if (
                $scope.component === "SessionSingleUserInvite"
            ) {
                if($scope.schedulerUserInfo && $scope.schedulerUserInfo.hasOwnProperty("id")) {
                    filter = [$scope.schedulerUserInfo.id];
                } else {
                    filter = [Principal.getUserId()];
                }
            }

            $mdDialog.show({
                multiple: true,
                templateUrl: pickerDialogMetaData.templateUrl,
                controller: pickerDialogMetaData.controller,
                controllerAs: 'vm',
                locals: {
                    filter: filter,
                    allowMultiSelect: $scope.allowMultiSelect,
                    userslist: users,
                    topics: topics,
                    isSession: $scope.isSession,
                    isScheduledSession: $scope.isScheduledSession,
                    isAdmin: $scope.isAdmin,
                    isConversationSession: false,
                    isSmartScan: false,
                    isWeb: true,
                    isNotFilter: false,
                    selectedItemIds: $scope.component === "SessionSingleUserInvite" ? [$scope.schedulerUserInfo.id] : selectedItemIds,
                    schedulerUserInfo: $scope.schedulerUserInfo,
                    isSessionSingleUserInvite: $scope.component === "SessionSingleUserInvite",
                    autoCompleteModel: $scope.autoCompleteModel
                }
            }).then(function(selectedItems) {
                if ($scope.allowMultiSelect) {
                    if($scope.isScheduledSession) {
                        $scope.autoCompleteModel = selectedItems;
                        return
                    }
                    var deltaItems = [];
                    angular.forEach(selectedItems, function(selectedItem) {
                        if (!$filter('filter')($scope.autoCompleteModel, { id: selectedItem.id, guest_invite_value: selectedItem.guest_invite_value })[0]) {
                            deltaItems.push(selectedItem)
                        }
                    });
                    if (!$scope.autoCompleteModel) {
                        $scope.autoCompleteModel = [];
                    }
                    $scope.autoCompleteModel = $scope.autoCompleteModel.concat($scope.specialFilter ? $scope.specialFilter({result : deltaItems}) : deltaItems)
                } else {
                    if ($scope.component === "SessionSingleUserInvite") {
                        $scope.autoCompleteModel = selectedItems[0];
                        $scope.$$childTail.autoCompleteModel = selectedItems[0];
                        $scope.$parent.isHostUpdated(selectedItems[0]);
                    } else {
                        $scope.autoCompleteModel = $scope.specialFilter
                            ? $scope.specialFilter({ result: selectedItems })[0]
                            : selectedItems[0];
                    }
                }
            });
        }

        $scope.transformChip = function(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
        }

        $scope.clear = function(){
            $scope.autoCompleteModel = null;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('ToastService', ToastService);

    function ToastService ($mdToast, toastConstants) {
        
        return {
            displayToastWithRenderHtml: displayToastWithRenderHtml,
            displayToast: displayToast,
            displayToastWithAction: displayToastWithAction
        };

        function displayToast(message, delay) {
            var timer = delay ? delay : 3000;
            $mdToast.show(
                $mdToast.simple().theme('primary-theme')
                .textContent(message)
                .position(toastConstants.position)
                .hideDelay(timer)
            );
        }

        function displayToastWithRenderHtml(message,delay) {
            var timer = delay ? delay : 3000;
            $mdToast.show({
                template:
                    "<md-toast><span flex>" + message.replace(/\n/g, '<br>') + "</span></md-toast>",
                position: toastConstants.position,
                hideDelay: timer,
            });
        }

        function displayToastWithAction(message, action, highlightClass, delay, callback) {
            var timer = delay ? delay : 3000;
            if(callback) {
                $mdToast.show(
                    $mdToast.simple().theme('primary-theme')
                    .content(message)
                    .action(action)
                    .highlightAction(true)
                    .highlightClass(highlightClass)
                    .position(toastConstants.position)
                    .hideDelay(timer)
                ).then(callback)
            } else {
                $mdToast.show(
                    $mdToast.simple().theme('primary-theme')
                    .content(message)
                    .action(action)
                    .highlightAction(true)
                    .highlightClass(highlightClass)
                    .position(toastConstants.position)
                    .hideDelay(timer)
                );
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .constant('toastConstants', {
            'position': 'top right'
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        /* @ngInject */
        function getService ($timeout, $sce, $translate, toastConstants) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning,
                displayToast: displayToast,
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var msg = alertOptions.msg.charAt(alertOptions.msg.length-1) === '.' || alertOptions.msg.indexOf('.') === -1 || alertOptions.msg.indexOf('atheer.') !== -1 ? alertOptions.msg : 'atheer.' + alertOptions.msg;
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }

            function displayToast($mdToast) {
              for(var i=0, len= alerts.length; i < len; i++){
                $mdToast.show({
                    template: '<md-toast><span flex translate>' + alerts[i].msg + '</span></md-toast>',
                    position: toastConstants.position,
                    hideDelay: 3000
                });
              }
            }
        }
    }
})();
;
(function() {
    'use strict';

    var fpAlert = {
        template: '<div>' + '</div>',
        controller: fpAlertController
    };

    angular
        .module('atheer')
        .component('fpAlert', fpAlert);

    /* @ngInject */
    function fpAlertController($scope, AlertService, $mdToast, toastConstants) {
        var vm = this;
        vm.alerts = AlertService.get();

        for(var i=0, len= vm.alerts.length; i < len; i++){
          $mdToast.show({
              template: '<md-toast><span flex>' + vm.alerts[i].msg + '</span></md-toast>',
              position: toastConstants.position,
              hideDelay: 3000
          });
        }
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    var fpAlertError = {
        template: '<div>' + '</div>',
        controller: fpAlertErrorController,
        controllerAs: 'vm'
    };

    angular
        .module('atheer')
        .component('fpAlertError', fpAlertError);

    /* @ngInject */
    function fpAlertErrorController($scope, AlertService, $rootScope, $translate, $mdToast, toastConstants) {
        var vm = this;

        vm.alerts = AlertService.get();

        if(!angular.isDefined(vm.alerts)) {
            vm.alerts = [];
        }

        for(var i=0, len= vm.alerts.length; i < len; i++){
          $mdToast.show({
              template: '<md-toast><span flex>' + vm.alerts[i].msg + '</span></md-toast>',
              position: toastConstants.position,
              hideDelay: 3000
          });
        }

        function addErrorAlert(message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add({
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('atheer.httpError', function(event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.server.not.reachable');
                    break;

                case 400:
                    var errorHeader = httpResponse.headers('X-atheer-error');
                    var entityKey = httpResponse.headers('X-atheer-params');
                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {
                            entityName: entityName
                        });
                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('atheer.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {
                                fieldName: fieldName
                            });
                        }
                    } else if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                    } else {
                        addErrorAlert(httpResponse.data);
                    }
                    break;

                default:
                    if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data.message);
                    } else {
                        addErrorAlert(angular.toJson(httpResponse));
                    }
            }
        });

        $scope.$on('$destroy', function() {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer')
        .directive('fpAccordion', fpAccordion)
        .directive('fpAccordionExpander', fpAccordionExpander);

    function fpAccordion() {
        return {
            restrict: 'AE',
            replace: true,
            transclude: true,
            scope: {
                'addItem': '&',
                'accordionModel': '=',
                'hideAdd': '=?',
                'allowMultiple': '=?'
            },
            templateUrl: 'core/components/accordion/accordion.tmpl.html',
            link: function (scope, element, attrs) {
                scope.add = function () {
                    scope.addItem();
                }

                scope.showAdd = function () {
                    return !scope.hideAdd;
                }
            },
            controller: function ($scope) {
                var items = [];

                this.register = function (item) {
                    items.push(item);
                };

                this.handleSelectedItem = function (selectedItem) {
                    if ($scope.allowMultiple) {
                        angular.noop();
                    } else {
                        angular.forEach(items, function (item) {
                            if (selectedItem != item) {
                                item.isVisible = false;
                            } else {
                                if (item.isVisible) {
                                    item.isVisible = true;
                                } else {
                                    item.isVisible = false;
                                }
                            }
                        });
                    }

                }
            }
        };
    }

    function fpAccordionExpander() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            require: '?^fpAccordion',
            scope: {
                item: '=',
                index: '=',
                copyItem: '&',
                removeItem: '&',
                hideRemove: '=?',
                hideCopy: '=?',
                hideDone: '=?',
                title: '=',
                isVisible: '=?isOpen'
            },
            templateUrl: 'core/components/accordion/accordion-expander.tmpl.html',

            link: function (scope, element, attrs, fpAccordionController) {
                var hasAccordionController = !!fpAccordionController;

                scope.isVisible = scope.isVisible === undefined ? false : scope.isVisible;

                scope.copy = function () {
                    scope.copyItem({
                        itemObj: scope.item
                    });
                }

                scope.showCopy = function () {
                    return !scope.hideCopy;
                }

                scope.showRemove = function () {
                    return !scope.hideRemove;
                }

                scope.showDone = function () {
                    return !scope.hideDone;
                }

                scope.remove = function () {
                    scope.removeItem({
                        index: scope.index
                    });
                }

                scope.handleToggle = function () {
                    scope.isVisible = !scope.isVisible;

                    if (hasAccordionController) {
                        fpAccordionController.handleSelectedItem(scope);
                    }
                }

                if (hasAccordionController) {
                    fpAccordionController.register(scope);
                }
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .run(UnderScore);

    /* @ngInject */
    function UnderScore($rootScope) {
        $rootScope._ = window._;;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .run(signedRequestRun);

    function signedRequestRun($rootScope, $state, $location, $log, Base64, AuthServerProvider) {
        var signedRequest = $location.search()['signed_request'];

        if ($location.$$search.signed_request) {
            delete $location.$$search.signed_request;
            $location.$$compose();
        }

        if (angular.isDefined(signedRequest) && signedRequest != null) {
            //AuthServerProvider.storeAuthenticationToken(signedRequest, true);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .run(scormCloudRun);

    function scormCloudRun($rootScope, $state, $location, $log, Scorm, Base64) {
        var scormInfo = $location.search()['scormInfo'];

        if ($location.$$search.scormInfo) {
            delete $location.$$search.scormInfo;
            $location.$$compose();
        }

        if (angular.isDefined(scormInfo) && scormInfo != null) {
            var decodedScormInfo = Base64.decode(scormInfo);
            var assignmentId = getQueryVariable('assignmentId', decodedScormInfo);
            var viewId = getQueryVariable('viewId', decodedScormInfo);
            var launchTime = new Date(getQueryVariable('launchTime', decodedScormInfo));

            var closeTime = new Date();
            var time_spent = (closeTime - launchTime);

            Scorm.updateProgress({
                id: assignmentId,
                view_id: viewId,
                time_spent: time_spent
            }, function(result) {
                //$rootScope.$broadcast('scorm-update-complete');
            });
        }

        function getQueryVariable(variable, query) {
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .run(masterRun);

    function masterRun($rootScope, $window, $urlRouter, $q, $cookies, $state, $location, $log, Setting, PermPermissionStore, PermRoleStore, PermissionService, MetaData, Principal, AuthServerProvider, Feature, Experience, $mdTheming, triMenu, triSettings, triSkins, triTheming, ATHEER_FEATURES, paginationConstants, toastConstants) {
        var host = $location.host();
        //console.log('in master run');
        $rootScope.atheer_features = ATHEER_FEATURES;
        $rootScope.isLightTheme = false;
        $rootScope.isDesktopApp = false;
        $rootScope.environment = 'dev';

        $rootScope.isJobExecutionActive = false;
        $rootScope.isJobBoardActive = false;

        if (window.todesktop) {
            $rootScope.isDesktopApp = true;
        };
        //console.log('in master run 2');
        var skinModel = {
            logo_small: null,
            logo_big: null,
            logo_small_dark: null,
            logo_big_dark: null,
            favorite_icon: null,
            use_dark_logos: false,
            primary_color: null,
            primary_color_hex: null,
            secondary_color: null,
            secondary_color_hex: null,
            side_menu: 'DARK',
            side_menu_state: 'CLOSED',
            widget_size: 'SMALL'
        };

        if (angular.isDefined(host) && (host.startsWith("master.") || host.startsWith("master-eu.") || host.startsWith("master-jp.") || host.startsWith("app."))) {
            $rootScope.isMasterWorkspace = true;
        } else {
            $rootScope.isMasterWorkspace = false;
        };
        //console.log('in master run 3');
        if (angular.isDefined(host) && host.endsWith(".dev")) {
            $rootScope.environment = 'dev';
        } else if (angular.isDefined(host) && host.endsWith(".qa")) {
            $rootScope.environment = 'qa';
        } else if (angular.isDefined(host) && host.endsWith(".si")) {
            $rootScope.environment = 'si';
        } else if (angular.isDefined(host) && host.endsWith(".io")) {
            $rootScope.environment = 'io';
        } else {
            $rootScope.environment = 'dev';
        };

        //console.log('in master run 4');

        $q.all([
            Setting.getSkinSettings().$promise,
            Setting.getFeaturesSettings().$promise,
            MetaData.getPermissionMeta().$promise,
            Setting.getBuildInfoSettings().$promise,
            Setting.getAccessConfigSettings().$promise
        ])
            .then(function (results) {
                setSkinModel(results[0]);
                setUpTheme(results[0]);
                Feature.setFeatures(results[1]);
                Feature.setDeviceFeaturePermissions(results[4]);

                if (Principal.isAuthenticated() || AuthServerProvider.hasValidToken()) {
                    Principal.identity().then(function (user) {
                        setupLanguage(user);
                        setUpPermissionStore(results[2], results[1]);
                    });

                    setCompanySettings();

                } else {
                    if(!AuthServerProvider.hasValidToken() && localStorage.getItem('Authorization')) {
                        localStorage.removeItem('Authorization')
                    }
                    if (Feature.isActive('feature_system_public_access') && ($location.path() === '/' || $location.path() === '/public/home')) {
                        $rootScope.baseHome = '/public/home';
                        $location.path('/public/home');
                    } else if ($location.path() === '/') {
                        $location.path('/signin');
                    }
                    setUpPermissionStore(results[2], results[1]);
                }
                $rootScope.buildInfo = results[3];
            });

        function setCompanySettings() {
            Setting.getCompanySettings(function (data) {
                angular.forEach(data[0].fields, function (field) {
                    if (field.name == 'default_page_size') {
                        paginationConstants.itemsPerPage = field.value;
                    } else if (field.name == 'default_toast_position') {
                        toastConstants.position = field.value.split("-").join(" ").toLowerCase();
                    }
                });
            });
        }

        function setupLanguage(user) {
            var supportedLanguages = [
                { name: 'english_us', displayName: 'English (US)', value: 'en_US', serverKey: 'en_US' },
                { name: 'english_uk', displayName: 'English (UK)', value: 'en_GB', serverKey: 'en_GB' },
                { name: 'french', displayName: 'French', value: 'fr_FR', serverKey: 'fr_FR' },
                { name: 'german', displayName: 'German', value: 'de_DE', serverKey: 'de_DE' },
                { name: 'greek', displayName: 'Greek', value: 'el_GR', serverKey: 'el_GR' },
                { name: 'italian', displayName: 'Italian', value: 'it_IT', serverKey: 'it_IT' },
                { name: 'japanese', displayName: 'Japanese', value: 'ja_JP', serverKey: 'ja_JP' },
                { name: 'portuguese', displayName: 'Portuguese', value: 'pt_BR', serverKey: 'pt_BR' },
                { name: 'spanish', displayName: 'Spanish', value: 'es_CL', serverKey: 'es_CL' },
                { name: 'chinese', displayName: 'Chinese (Traditional)', value: 'zh_TW', serverKey: 'zh_TW' },
                { name: 'chinese_cn', displayName: 'Chinese (Simplified)', value: 'zh_CN', serverKey: 'zh_CN' },
                { name: 'dutch', displayName: 'Dutch', value: 'nl_NL', serverKey: 'nl_NL' },
                { name: 'danish', displayName: 'Danish (Denmark)', value: 'da_DK', serverKey: 'da_DK' },
                { name: 'norwegian', displayName: 'Norwegian', value: 'no_NO', serverKey: 'no_NO' },
                { name: 'polish', displayName: 'Polish (Poland)', value: 'pl_PL', serverKey: 'pl_PL' },
                { name: 'russian', displayName: 'Russian', value: 'ru_RU', serverKey: 'ru_RU' },
                { name: 'swedish', displayName: 'Swedish (Sweden)', value: 'sv_SE', serverKey: 'sv_SE' },
                { name: 'turkish', displayName: 'Turkish (Turkey)', value: 'tr_TR', serverKey: 'tr_TR' }
            ];
            angular.forEach(supportedLanguages, function (lang) {
                if (lang.serverKey == user.language_id) {
                    if (user.language_id != 'system_default') {
                        $rootScope.userSelectedLanguage = user.language_id;
                    } else {
                        var lang = ($window.navigator.language || $window.navigator.userLanguage).replace('-', '_');
                        if (lang == 'el') {
                            lang = 'el_GR';
                        } else if (lang == 'ja') {
                            lang = 'ja_JP';
                        } else if (lang.startsWith('zh')) {
                            lang = 'zh_TW';
                        } else if (lang.startsWith('nl')) {
                            lang = 'nl_NL';
                        }
                        $rootScope.userSelectedLanguage = lang;
                    }
                }
            });
        }

        function resolveUserAndNavigateToHome() {
            Principal.identity(true).then(function (user) {
                $state.go('storm.home');
            });
        }

        function setSkinModel(skinSettings) {
            angular.forEach(skinSettings, function (setting) {
                if (setting.category == 'skin_info') {
                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'logo_small') {
                            skinModel.logo_small = settingField.value;
                        }
                        if (settingField.name == 'logo_big') {
                            skinModel.logo_big = settingField.value;
                        }
                        if (settingField.name == 'logo_small_dark') {
                            skinModel.logo_small_dark = settingField.value;
                        }
                        if (settingField.name == 'logo_big_dark') {
                            skinModel.logo_big_dark = settingField.value;
                        }
                        if (settingField.name == 'favorite_icon') {
                            skinModel.favorite_icon = settingField.value;
                        }
                        if (settingField.name == 'use_dark_logos') {
                            if (settingField.value == 'true') {
                                skinModel.use_dark_logos = true;
                            } else {
                                skinModel.use_dark_logos = false;
                            }
                        }
                        if (settingField.name == 'primary_color') {
                            skinModel.primary_color = settingField.value;
                        }
                        if (settingField.name == 'primary_color_hex') {
                            skinModel.primary_color_hex = settingField.value;
                        }
                        if (settingField.name == 'secondary_color') {
                            skinModel.secondary_color = settingField.value;
                        }
                        if (settingField.name == 'secondary_color_hex') {
                            skinModel.secondary_color_hex = settingField.value;
                        }
                        if (settingField.name == 'side_menu') {
                            skinModel.side_menu = settingField.value;
                        }
                        if (settingField.name == 'side_menu_state') {
                            skinModel.side_menu_state = settingField.value;
                        }
                        if (settingField.name == 'logo_right') {
                            skinModel.logo_right = settingField.value;
                        }
                        if (settingField.name == 'widget_size') {
                            skinModel.widget_size = settingField.value;
                        }
                    });
                }
            });

            if (skinModel.use_dark_logos) {
                triSettings.setLogoSmall('assets/images/ath-sm-white.png');
                triSettings.setLogoBig('assets/images/ath-white.png');

                if (skinModel.logo_small_dark != null) {
                    triSettings.setLogoSmall('/media/images/' + skinModel.logo_small_dark);
                }

                if (skinModel.logo_big_dark != null) {
                    triSettings.setLogoBig('/media/images/' + skinModel.logo_big_dark);
                }
            } else {
                triSettings.setLogoSmall('assets/images/ath-sm-color.png');
                triSettings.setLogoBig('assets/images/ath-color.png');

                if (skinModel.logo_small != null) {
                    triSettings.setLogoSmall('/media/images/' + skinModel.logo_small);
                }

                if (skinModel.logo_big != null) {
                    triSettings.setLogoBig('/media/images/' + skinModel.logo_big);
                }
            }
            triSettings.setSkinModel(skinModel);
        };

        function setUpTheme(skinSettings) {
            if (skinModel.primary_color == null && skinModel.secondary_color == null) {
                skinModel.primary_color = 'teal';
                skinModel.secondary_color = 'orange';
            };

            triTheming.registerTheme('primary-theme')
                .primaryPalette(skinModel.primary_color)
                .accentPalette(skinModel.secondary_color)
                .warnPalette('deep-orange');

            triTheming.registerTheme('white-theme')
                .primaryPalette('white')
                .accentPalette(skinModel.primary_color, {
                    'default': '400'
                })
                .warnPalette('deep-orange');

            if (skinModel.side_menu == 'DARK') {
                triSkins.registerSkin('atheer', 'Atheer')
                    .sidebarTheme('primary-theme')
                    .toolbarTheme('white-theme')
                    .contentTheme('primary-theme');
            } else {
                triSkins.registerSkin('atheer', 'Atheer')
                    .sidebarTheme('white-theme')
                    .toolbarTheme('white-theme')
                    .contentTheme('primary-theme');
                $rootScope.isLightTheme = true;
            }

            triSkins.setSkin('atheer');
            $rootScope.triSkin = triSkins.getCurrent();

            $mdTheming.generateTheme('primary-theme');
            $mdTheming.generateTheme('white-theme');

            if (skinModel.favorite_icon != null) {
                var link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = '/media/images/' + skinModel.favorite_icon;
            } else {
                var link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = 'assets/images/ath-sm-color.png';
            }
        };

        function setUpPermissionStore(permissionMeta, features) {
            var permissions = [];
            var roles = [];

            angular.forEach(permissionMeta.permissions, function (permission) {
                var objectName = permission.object_name;
                var permissionName = permission.permission_name;
                permissions.push(permissionName + "-" + objectName);
            });

            angular.forEach(features, function (feature) {
                if (feature.category == 'features') {
                    var features = [];
                    angular.forEach(feature.fields, function (settingField) {
                        permissions.push('feature' + '_' + settingField.group_name + '_' + settingField.name)
                    });
                }
            });

            PermPermissionStore.defineManyPermissions(permissions, checkPermission);

            angular.forEach(permissionMeta.roles, function (role) {
                var roleName = role.name;
                var rolePermissions = [];

                angular.forEach(role.permissions, function (permission) {
                    var objectName = permission.object_name;
                    var permissionName = permission.permission_name;

                    rolePermissions.push(permissionName + "-" + objectName);
                });
                PermRoleStore.defineRole(roleName, rolePermissions);
            });

            // kick-off router and start the application rendering
            $urlRouter.sync();
            // Also enable router to listen to url changes
            $urlRouter.listen();
        };

        // default redirect if access is denied
        function accessDenied() {
            $state.go('401');
        };

        // function that calls user service to check if permission is allowed
        function checkPermission(permission, transitionProperties) {
            return PermissionService.hasPermission(permission, transitionProperties);
        };


        function initializeProductFeedback() {
            if (angular.isDefined(host) && (host.startsWith("atheer."))) {
                // Requires jQuery!
                jQuery.ajax({
                    url: "https://atheerlabs.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/sb53l8/b/24/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=dcf657d8",
                    type: "get",
                    cache: true,
                    dataType: "script"
                });
            }
        }

        initializeProductFeedback()

        // watches
        // redirect all denied permissions to 401
        var deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

        // remove watch on destroy
        $rootScope.$on('$destroy', function () {
            deniedHandle();
        });

        $rootScope.$on('identityResolved', function (event, identity) {
            if ($rootScope.isMasterWorkspace) {
                $rootScope.baseHome = '/system/dashboard';
                $rootScope.baseLeftNavMenu = 'cloud-insights';
                $rootScope.selectedLeftNavMenu = 'cloud-insights';
                $rootScope.showForYou = false;
            } else if (Principal.isWorkspaceAdmin()) {
                var path = $location.path();

                $rootScope.baseHome = '/home';
                $rootScope.baseLeftNavMenu = 'home';
                $rootScope.selectedLeftNavMenu = 'home';

                var menuArray = triMenu.menu;
                for (var i = 0; i < menuArray.length - 1; i++) {
                    if (path.startsWith(menuArray[i].url)) {
                        $rootScope.baseHome = menuArray[i].url;
                        $rootScope.baseLeftNavMenu = menuArray[i].id;
                        $rootScope.selectedLeftNavMenu = menuArray[i].id;
                        break;
                    };
                };

                if (path.startsWith('/settings')) {
                    $rootScope.selectedLeftNavMenu = 'settings';
                };
            } else {
                var path = $location.path();
                var menuArray = triMenu.menu;
                var menuToShow = null;

                for (var i = 0; i < menuArray.length - 1; i++) {
                    var hasAccess = false;
                    var featureEnabled = true;

                    if (angular.isDefined(menuArray[i].feature)) {
                        featureEnabled = Feature.isActive(menuArray[i].feature);
                    }

                    if (featureEnabled && angular.isDefined(menuArray[i].permission)) {
                        hasAccess = PermissionService.hasAccess(menuArray[i].permission);
                    };

                    if (menuArray[i].id == 'home') {
                        hasAccess = true;
                    }

                    if (hasAccess) {
                        menuToShow = menuArray[i];
                        break;
                    }
                };

                if (menuToShow != null) {
                    $rootScope.baseHome = menuToShow.url;
                    $rootScope.baseLeftNavMenu = menuToShow.id;
                    $rootScope.selectedLeftNavMenu = menuToShow.id;
                } else {
                    $rootScope.baseHome = '/noaccess';
                }

                for (var i = 0; i < menuArray.length - 1; i++) {
                    if (path.startsWith(menuArray[i].url)) {
                        $rootScope.baseHome = menuArray[i].url;
                        $rootScope.baseLeftNavMenu = menuArray[i].id;
                        $rootScope.selectedLeftNavMenu = menuArray[i].id;
                        break;
                    };
                };

                if (path.startsWith('/settings')) {
                    $rootScope.selectedLeftNavMenu = 'settings';
                };
                if ((path.startsWith('/conversation') && !(PermissionService.hasAccess('access-conversation') && Feature.isActive('feature_conversation_enable'))) ||
                    (path.startsWith('/jobs') && !(PermissionService.hasAccess('access-job') && Feature.isActive('feature_airform_enable'))) ||
                    (path.startsWith('/sessions') && !(PermissionService.hasAccess('access-session') && Feature.isActive('feature_airsession_enable')) && !$cookies.get('isGuest'))) {
                    $rootScope.baseHome = '/home';
                    $rootScope.baseLeftNavMenu = 'home';
                    $rootScope.selectedLeftNavMenu = 'home';
                    $rootScope.showAlertMessageFor = path.startsWith('/sessions') ? 'session' : (path.startsWith('/jobs') ? 'jobs' : 'conversation')
                    $location.path('/home');
                };
            }
            var featureForcedPassword = Feature.isActive('feature_user_initial_login_forced_password_required');
            if (featureForcedPassword && identity.forced_password_enabled) {
                $location.path('/forced-password');
            }
        });

        function handleNgxEvent(event) {
            var hostUrl =
                (location.hostname === 'localhost' || location.hostname === 'demo.atheer.my')
                    ? 'https://' + location.hostname + ':4200'
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.suggestionConfig) {
                $rootScope.suggestionConfig = event.data.suggestionConfig;
            } else if (event.data.jobExecutionStatus == 'active') {
                $rootScope.isJobExecutionActive = true;
            } else if (event.data.jobExecutionStatus == 'done') {
                $rootScope.isJobExecutionActive = false;
            } else if (event.data.isJobBoardActive === 'true') {
                $rootScope.isJobBoardActive = true;
            } else if (event.data.isJobBoardActive === 'false') {
                $rootScope.isJobBoardActive = false;
            } else if (event.data.appletEditStatus == 'active') {
                $rootScope.isAppletEditActive = true;
            } else if (event.data.appletEditStatus == 'done') {
                $rootScope.isAppletEditActive = false;
            } else if (event.data.openUrl) {
                window.location.href = event.data.openUrl.href;
            } else if(event.data.hasOwnProperty('isDocumentProcessing')) {
                $rootScope.isBulkUploadInProgress = event.data.isDocumentProcessing
            } else if(event.data.hasOwnProperty('isCopilotApiProcessing')) {
                $rootScope.isCopilotApiProcessing = event.data.isCopilotApiProcessing
            } else if (event.data.navigate) {
                var ngState = event.data.navigate.toState;
                var stateParams = event.data.navigate.params;
                if (stateParams) {
                    if (stateParams.id) {
                        if (stateParams.dashboardId) {
                            //console.log('In master run with stateparams: ' + JSON.stringify(stateParams));
                            $state.go(ngState, stateParams);
                        } else if (stateParams.contentType) {
                            $state.go(ngState, stateParams);
                        } else {
                            $state.go(ngState, { id: stateParams.id });
                        }
                    } else if (stateParams.session_no) {
                        $state.go(ngState, { session_no: stateParams.session_no });
                    }
                } else {
                    $state.go(ngState);
                }

            } else if (event.data.resolveUser) {
                //localStorage.setItem('Authorization', event.data.resolveUser.token);
                resolveUserAndNavigateToHome();
                setCompanySettings();

            } else if (event.data.navigateBack) {
                var selectedMenu = {}
                selectedMenu = triMenu.menu.filter(function (value, index) {
                    return value.state == event.data.menuState
                })[0];
                var params = selectedMenu && selectedMenu.params ? params : {};
                $rootScope.selectedLeftNavMenu = selectedMenu ? selectedMenu.id : $rootScope.selectedLeftNavMenu;
                $rootScope.isJobExecutionActive = false;
                $rootScope.isJobBoardActive = false;
                $rootScope.isAppletEditActive = false;
                if (event.data.menuState == 'storm.profile.overview') {
                    params = {
                        id: 'me',
                        launchQrCode: $rootScope.isQR ? true : false
                    }
                };
                $state.go(event.data.menuState, params)
            };
        }

        $window.addEventListener('message', handleNgxEvent, false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('notificationInterceptor', notificationInterceptor);

    /* @ngInject */
    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-atheer-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-atheer-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    /* @ngInject */
    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('atheer.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .factory('authInterceptor', authInterceptor);

    /* @ngInject */
    function authInterceptor() {
        var service = {
            request: request
        };

        return service;

        function request(config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = localStorage.getItem('Authorization');

            if(!token) {
                token = sessionStorage.getItem('Authorization');
            }

            if (token) {
                config.headers.Authorization = 'Bearer ath-' + token;
            }
            return config;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    /* @ngInject */
    function authExpiredInterceptor($rootScope, $q, $injector, $cookies) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                localStorage.removeItem('Authorization');
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .factory('apiInterceptor', apiInterceptor);

    /* @ngInject */
    function apiInterceptor($rootScope, $q) {
        if(typeof $rootScope.isApiProcessing === 'undefined')
            $rootScope.isApiProcessing = 0;
        return {
              'request': function(config) {
                  if(config.url.startsWith('api') || 
                    config.url.startsWith('/api') || 
                    config.url.startsWith('media') || 
                    config.url.startsWith('/meida')) {
                    $rootScope.isApiProcessing++;
                  }
                return config;
              },
        
              'response': function(response) {
                if(response.config.url.startsWith('api') || 
                    response.config.url.startsWith('/api') || 
                    response.config.url.startsWith('media') || 
                    response.config.url.startsWith('/meida')) {
                    $rootScope.isApiProcessing--;
                  }
                return response;
              },

             'responseError': function(rejection) {
                if($rootScope.isApiProcessing>0)
                    $rootScope.isApiProcessing--;
                return $q.reject(rejection);
              }
            };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('translationHandler', translationHandler);

    /* @ngInject */
    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            var globalTitle = $translate.instant('global.title');
            var pageTitle = null;

            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
                pageTitle = $translate.instant(titleKey);
            }

            if(pageTitle && pageTitle != null) {
                $window.document.title = globalTitle + ' - ' + pageTitle;
            } else {
                $window.document.title = globalTitle;
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .factory('stateHandler', stateHandler);

    /* @ngInject */
    function stateHandler($rootScope, $state, $translate, JhiLanguageService, translationHandler, Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;
            $rootScope.back = back;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
                $rootScope.isBulkUploadInProgress = false;
                $rootScope.isCopilotApiProcessing = false;
                if (!$rootScope.isJobExecutionActive && !$rootScope.isJobBoardActive) {
                    $rootScope.toState = toState;
                    $rootScope.toStateParams = toStateParams;

                    if (Principal.isIdentityResolved()) {
                        Auth.authorize();
                    }
                } else {
                    event.preventDefault();
                    var iFrame = document.getElementById('ngxFrame').contentWindow;
                    var targetOrigin = location.hostname === "localhost"
                        ? "https://" + location.hostname + ":4200"
                        : location.origin;
                    iFrame.postMessage({ 'jobExecutionCompleted': false, 'menuState': toState.name, 'type': 'leftNavChange' }, targetOrigin);
                }
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                // Remember previous state unless we've been redirected to login or we've just
                // reset the state memory after logout. If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. If we're going
                // to login directly, we don't want to be sent to some previous state anyway
                if (!$rootScope.redirected && $rootScope.previousStateName) {
                    $rootScope.previousStateName = fromState.name;
                    $rootScope.previousStateParams = fromParams;
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.fallbackLanguage('en_US');
                    $translate.use(language);
                });

            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });

            function back() {
                // If previous state is 'activate' or do not exist go to 'home'
                if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                    $state.go('home');
                } else {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('idleHandler', idleHandler);

    /* @ngInject */
    function idleHandler($rootScope, Idle, Setting, $mdDialog, $location, Keepalive, Auth, $state, $http) {
        var isWarning = false;
        return {
            initialize: initialize
        };

        function initialize() {
            Setting.getAuthenticationSetupSettings(function(result) {
                var autoSignoutEnabled = result[0].fields.filter(function(value) {
                    return value.name == 'auto_signout_enabled'
                })[0].value;
                if(autoSignoutEnabled == "true") {
                    var timer = result[0].fields.filter(function(value) {
                        return value.name == 'auto_signout_wait_time_mins'
                    })[0].value;
                    if(timer > 0) {
                        Idle.setIdle(timer * 60);
                        Idle.watch();

                        isWarning = result[0].fields.filter(function(value) {
                            return value.name == 'auto_signout_show_warning'
                        })[0].value;
                    }
                }
            });

            $rootScope.$on('IdleStart', function() {
                if($location.path() !== '/signin' && $location.path() !== '/signout' && !$location.path().startsWith('/join') && !$rootScope.isSessionStarted
                    && !$rootScope.isJobExecutionActive && !$rootScope.isApiProcessing && !$rootScope.isBulkUploadInProgress && !$rootScope.isCopilotApiProcessing) {
                    if(isWarning == "true") {
                        $mdDialog.show({
                            templateUrl: 'core/components/session-timeout/session-timeout-dialog.tmpl.html',
                            clickOutsideToClose: true,
                            controller: "SessionTimeoutController",
                            controllerAs: "vm",
                        }).then(function(result) {
                        });
                    } else {
                        Auth.logout();
                        $state.go('account.signout')
                    }
                } else {
                    Keepalive.setInterval(15);
                }
            });

            $rootScope.$on('IdleTimeout', function() {
                Keepalive.setInterval(15);
            });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .factory('dictionaryHandler', dictionaryHandler);

    /* @ngInject */
    function dictionaryHandler($q, $http, Setting) {

        'use strict';

        return function (options) {

            if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
                throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
            }

            if (!options.files) {
                options.files = [{
                    prefix: options.prefix,
                    suffix: options.suffix
                }];
            }

            var load = function (file) {
                if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
                    throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
                }

                var fileUrl = [
                    file.prefix,
                    options.key,
                    file.suffix
                ].join('');

                if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
                    fileUrl = options.fileMap[fileUrl];
                }

                return $http(angular.extend({
                    url: fileUrl,
                    method: 'GET'
                }, options.$http))
                    .then(function (result) {
                        return result.data;
                    }, function () {
                        return $q.reject(options.key);
                    });
            };

            var promises = [],
                length = options.files.length;

            for (var i = 0; i < length; i++) {
                promises.push(load({
                    prefix: options.files[i].prefix,
                    key: options.key,
                    suffix: options.files[i].suffix
                }));
            }

            promises.push(Setting.getLabelDictionarySettings().$promise);

            function processStrings(resourceStrings, dictionaryKeys, dictionaryValues) {
                Object.keys(resourceStrings).forEach(function (key) {
                    if (typeof resourceStrings[key] === 'object') {
                        processStrings(resourceStrings[key], dictionaryKeys, dictionaryValues)
                    } else {
                        if (resourceStrings[key] && resourceStrings[key].indexOf("{{") != -1) {
                            var replacedString = resourceStrings[key];

                            for (var i = dictionaryKeys.length - 1; i >= 0; i--) {
                                var finalAns = replacedString.replaceAll(dictionaryKeys[i], dictionaryValues[i]);
                                replacedString = finalAns;
                            }
                            resourceStrings[key] = replacedString;
                        }
                    }
                })
                return resourceStrings;
            }

            function getDictionarySettings(dictionaryModel) {
                var dictionarySettings = {};
                var dictionary = {};

                angular.forEach(dictionaryModel, function (dictionaryModel) {
                    if (dictionaryModel.category == 'label-dictionary') {
                        dictionarySettings = dictionaryModel;

                        angular.forEach(dictionaryModel.fields, function (dictionaryField) {
                            if (options.key == dictionaryField.group_name) {
                                var dictionaryFieldSetting = dictionary[dictionaryField.group_name];
                                if (dictionaryFieldSetting) {
                                    dictionaryFieldSetting.settings.push(dictionaryField);
                                } else {
                                    var dictionaryFieldSetting = {
                                        name: dictionaryField.group_name,
                                        label: dictionaryField.group_label,
                                        editable: dictionaryField.group_editable,
                                        settings: []
                                    }
                                    dictionaryFieldSetting.settings.push(dictionaryField);
                                    dictionary[dictionaryField.group_name] = dictionaryFieldSetting;
                                }
                            }
                        });
                    }
                });
                return dictionary;
            };

            return $q.all(promises)
                .then(function (data) {
                    var mergedData = {};
                    var dictionarySettings = getDictionarySettings(data[1]);
                    var dictionaryKeys = [];
                    var dictionaryValues = [];

                    for (var key in data[0]) {
                        mergedData[key] = data[0][key];
                    }

                    if (dictionarySettings[options.key] && dictionarySettings[options.key] != null) {
                        angular.forEach(dictionarySettings[options.key].settings, function (setting) {
                            dictionaryKeys.push("{{" + setting.name + "}}");
                            dictionaryValues.push(setting.value);
                        });

                        return processStrings(mergedData, dictionaryKeys, dictionaryValues);
                    } else {
                        return mergedData;
                    }
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(translationConfig);

    /* @ngInject */
    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        $translateProvider.determinePreferredLanguage();
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        $translateProvider.useLoader('dictionaryHandler', {
            prefix: 'i18n/studio/studio-',
            suffix: '.json?timestamp=' + new Date().getTime()
        });

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale.replace("_", "-") | lowercase}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .factory('translationStorageProvider', translationStorageProvider);

    /* @ngInject */
    function translationStorageProvider($cookies, $log, LANGUAGES, $window, $rootScope, $location) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if ($location.host().startsWith("app.")) {
                if (LANGUAGES.indexOf($cookies.getObject('NG_TRANSLATE_LANG_KEY_ON_PARENT_DOMAIN')) === -1) {
                    $cookies.putObject(name, 'en_US');
                    setLanguage('en_US');
                } else {
                    $cookies.putObject(name, $cookies.getObject('NG_TRANSLATE_LANG_KEY_ON_PARENT_DOMAIN'));
                    setLanguage($cookies.getObject('NG_TRANSLATE_LANG_KEY_ON_PARENT_DOMAIN'));
                }
                return $cookies.getObject(name);
            }
            if ($rootScope.userSelectedLanguage) {
                $cookies.putObject(name, $rootScope.userSelectedLanguage);
                setLanguage($rootScope.userSelectedLanguage);
            }
            else if (localStorage.getItem('isUserSelectedLanguage')) {
                if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                    $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en_US"');
                    $cookies.putObject(name, 'en_US');
                    setLanguage('en_US');
                }
            } else {
                var lang = ($window.navigator.language || $window.navigator.userLanguage).replace('-', '_');
                if (lang == 'el') {
                    lang = 'el_GR';
                } else if (lang == 'ja') {
                    lang = 'ja_JP';
                } else if (lang.startsWith('zh')) {
                    lang = 'zh_TW';
                } else if (lang.startsWith('nl')) {
                    lang = 'nl_NL';
                }
                if (LANGUAGES.indexOf(lang) === -1) {
                    $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en_US"');
                    $cookies.putObject(name, 'en_US');
                    setLanguage('en_US');
                } else if ($cookies.getObject(name)) {
                    $cookies.putObject(name, $cookies.getObject(name));
                    setLanguage($cookies.getObject(name));
                } else {
                    $cookies.putObject(name, lang);
                    setLanguage(lang);
                }
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
            setLanguage(value);
        }

        function setLanguage(value) {
            var domainParts = $location.host().split('.');
            var parentDomain = domainParts[1] + '.' + domainParts[2];
            $cookies.putObject('NG_TRANSLATE_LANG_KEY_ON_PARENT_DOMAIN', value, { domain: parentDomain });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(pollerConfig);

      /* @ngInject */
    function pollerConfig(pollerConfig) {
        pollerConfig.stopOn = '$stateChangeStart';
        pollerConfig.resetOn = '$stateChangeStart';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(permissionConfig);
        
    function permissionConfig($urlRouterProvider) {
        $urlRouterProvider.deferIntercept();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(function (localStorageServiceProvider) {
            localStorageServiceProvider.setPrefix('atheer');
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(idleConfig);

    /* @ngInject */
    function idleConfig(IdleProvider, KeepaliveProvider) {
        IdleProvider.idle(1);
        IdleProvider.timeout(0);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(httpConfig);

    /* @ngInject */
    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/404');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push('apiInterceptor');
        // atheer-needle-angularjs-add-interceptor Atheer will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(html5ModeConfig);

      /* @ngInject */
    function html5ModeConfig($locationProvider, HTML5_ENABLED) {
        if(HTML5_ENABLED) {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: true
            });
        } else {
            $locationProvider.html5Mode({
                enabled: false,
                requireBase: false
            });
        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer')
        .factory('froalaConfig', froalaConfig);
    /* @ngInject */
    function froalaConfig($cookies) {
        return {
            key: 'Ig1A7vC2A3C3F2G2A3mEZXQUVJe1EZb1IWIAUKLJZMBQuF2C1G1G1A10B1E7A1A5E5==',
            aviaryKey: '1daf90129bbe47de80a0a38c3399f9fc',
            fileUploadParam: 'file',
            fileUploadURL: '/api/media/file_upload',
            fileUploadMethod: 'POST',
            fileAllowedTypes: ['*'],
            imageUploadURL: '/api/media/image_upload',
            imageUploadParam: 'file',
            imageUploadMethod: 'POST',
            imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            toolbarInline: false,
            heightMin: 100,
            heightMax: 200,
            charCounterMax: 1000,
            pastePlain: true,
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'imageManager', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quote', 'save', 'table', 'url', 'video'],
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'undo', 'redo', 'fullscreen'],
            toolbarButtonsMD: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'undo', 'redo', 'fullscreen'],
            toolbarButtonsSM: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'undo', 'redo', 'fullscreen'],
            toolbarButtonsXS: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'undo', 'redo', 'fullscreen'],
            placeholderText: 'Enter Text Here',
            zIndex: 70,
            language: setEditorLanguage(),
            attribution: false,
            linkList: [
                {
                    text: 'Topics',
                    href: window.location.origin + '/deeplink/topic/'
                },
                {
                    text: 'Content',
                    href: window.location.origin + '/deeplink/content/'
                },
                {
                    text: 'User',
                    href: window.location.origin + '/deeplink/user/'
                }
            ],
            requestHeaders: {
                authorization: 'Bearer ath-' + localStorage.getItem('Authorization')
            }
        };
        
        //Function to get the language which is active and set the same language to Froala Object
        function setEditorLanguage() {
            var lang = 'en-US';
            var langKey = $cookies.getObject('NG_TRANSLATE_LANG_KEY');
            if (langKey) {
                lang = langKey.replace(/["]+/g, '').replace('_', '-');
                lang = lang.toLowerCase().replace(/-/g, '_');
            }
            var withRegionLanguages = ['en_gb', 'pt_br', 'zh_tw', 'zh_cn'];
            if (withRegionLanguages.includes(lang)) {
                return lang;
            }
            if (lang && lang.split('_') && lang.split('_')[0]) {
                return lang.split('_')[0]
            }
            else {
                return lang;
            }
        }
    }
})();

;
(function() {
    angular
        .module('atheer')
        .controller('ErrorPageController', ErrorPageController);

    /* @ngInject */
    function ErrorPageController($state) {
        var vm = this;
        vm.goHome = goHome;
        /////////
        function goHome() {
            $state.go('storm.dashboard-analytics');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(compileServiceConfig);

    /* @ngInject */
    function compileServiceConfig($compileProvider, DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		      angular.reloadWithDebugInfo();
		    */
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(ariaConfig);

      /* @ngInject */
    function ariaConfig($mdAriaProvider) {
        // Globally disables all ARIA warnings.
        $mdAriaProvider.disableWarnings();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .config(alertServiceConfig);

    /* @ngInject */    
    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .provider('triTheming', themingProvider);

    /* @ngInject */
    function themingProvider($mdThemingProvider) {
        var themes = {};

        return {
            theme: function(name) {
                if (angular.isDefined(themes[name])) {
                    return themes[name];
                }
                var theme = new Theme(name);
                themes[name] = theme;
                return themes[name];
            },
            $get: function() {
                return {
                    registerTheme: function(name) {
                        if (angular.isDefined(themes[name])) {
                            return themes[name];
                        }
                        var theme = new Theme(name);
                        themes[name] = theme;
                        return themes[name];
                    },
                    getTheme: function(name) {
                        if (angular.isDefined(themes[name])) {
                            return themes[name];
                        }
                        var theme = new Theme(name);
                        themes[name] = theme;
                        return themes[name];
                    },
                    getThemeHue: function(themeName, intentName, hue) {
                        if (angular.isDefined($mdThemingProvider._THEMES[themeName]) && angular.isDefined($mdThemingProvider._THEMES[themeName].colors[intentName])) {
                            var palette = $mdThemingProvider._THEMES[themeName].colors[intentName];
                            if (angular.isDefined($mdThemingProvider._PALETTES[palette.name]) && angular.isDefined($mdThemingProvider._PALETTES[palette.name][palette.hues[hue]])) {
                                return $mdThemingProvider._PALETTES[palette.name][palette.hues[hue]];
                            }
                        }
                    },
                    getPalette: function(name) {
                        return $mdThemingProvider._PALETTES[name];
                    },
                    getPaletteColor: function(paletteName, hue) {
                        if (angular.isDefined($mdThemingProvider._PALETTES[paletteName]) && angular.isDefined($mdThemingProvider._PALETTES[paletteName][hue])) {
                            return $mdThemingProvider._PALETTES[paletteName][hue];
                        }
                    },
                    rgba: $mdThemingProvider._rgba,
                    palettes: $mdThemingProvider._PALETTES,
                    themes: $mdThemingProvider._THEMES,
                    parseRules: $mdThemingProvider._parseRules
                };
            }
        };
    }

    function Theme(name) {
        var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
        var self = this;
        self.name = name;
        self.colors = {};

        THEME_COLOR_TYPES.forEach(function(colorType) {
            self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
                self.colors[colorType] = {
                    name: paletteName,
                    hues: {}
                };
                if (angular.isDefined(hues)) {
                    self.colors[colorType].hues = hues;
                }
                return self;
            };
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .provider('triSkins', skinsProvider)
        .run(addSkinToScope);

    /* @ngInject */
    function skinsProvider($mdThemingProvider, triThemingProvider) {
        var skins = {};
        var currentSkin = null;
        var useSkinCookie = false;

        return {
            skin: function(id, name) {
                if (angular.isDefined(skins[id])) {
                    return skins[id];
                }
                var skin = new Skin(id, name, $mdThemingProvider, triThemingProvider);
                skins[id] = skin;
                return skins[id];
            },
            setSkin: function(id) {
                if (angular.isUndefined(skins[id])) {
                    return;
                }

                // set skin to selected skin
                currentSkin = skins[id];

                // make material load the themes needed for the skin
                currentSkin.loadThemes();

                return currentSkin;
            },
            useSkinCookie: function(skinCookie) {
                useSkinCookie = skinCookie;
            },
            $get: function() {
                return {
                    registerSkin: function(id, name) {
                        if (angular.isDefined(skins[id])) {
                            return skins[id];
                        }
                        var skin = new Skin(id, name, $mdThemingProvider, triThemingProvider);
                        skins[id] = skin;
                        return skins[id];
                    },
                    setSkin: function(id) {
                        if (angular.isUndefined(skins[id])) {
                            return;
                        }
                        // set skin to selected skin
                        currentSkin = skins[id];
                        // make material load the themes needed for the skin
                        currentSkin.loadThemes();
                        return currentSkin;
                    },
                    getCurrent: function() {
                        return currentSkin;
                    },
                    getSkins: function() {
                        return skins;
                    }
                };
            }
        };
    }

    /* @ngInject */
    function Skin(id, name, $mdThemingProvider, triThemingProvider) {
        var THEMABLE_ELEMENTS = ['sidebar', 'toolbar', 'content'];
        var self = this;
        self.id = id;
        self.name = name;
        self.elements = {};

        THEMABLE_ELEMENTS.forEach(function(element) {
            self[element + 'Theme'] = function setElementTheme(themeName) {
                self.elements[element] = themeName;
                return self;
            };
        });

        self.loadThemes = function() {
            // go through each element
            for (var element in self.elements) {
                // register theme with mdThemingProvider (will load css in the header)
                var theme = triThemingProvider.theme(self.elements[element]);

                $mdThemingProvider.theme(theme.name)
                    .primaryPalette(theme.colors.primary.name, theme.colors.primary.hues)
                    .accentPalette(theme.colors.accent.name, {
                        'default': '500',
                    })
                    .warnPalette(theme.colors.warn.name, theme.colors.warn.hues);

                if (angular.isDefined(theme.colors.background)) {
                    $mdThemingProvider
                        .theme(theme.name)
                        .backgroundPalette(theme.colors.background.name, theme.colors.background.hues);
                }
            }

            $mdThemingProvider.setDefaultTheme(self.elements.content);
        };
    }

    /* @ngInject */
    function addSkinToScope($rootScope, triSkins) {
        $rootScope.triSkin = triSkins.getCurrent();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .run(runFunction);

    /* @ngInject */
    function runFunction($rootScope, $window, $state, $filter, $timeout, $injector, triRoute, triBreadcrumbsService) {
        var breadcrumbs = triBreadcrumbsService.breadcrumbs;

        // change title when language changes - when a menu item is clicked - on app init
        var menuTitleHandler = $rootScope.$on('changeTitle', function(){
            setFullTitle();
        });

        $rootScope.$on('$destroy', function(){
            menuTitleHandler();
        });

        function setFullTitle() {
            $timeout(function(){
                var title = triRoute.title;
                angular.forEach(breadcrumbs.crumbs, function(crumb){
                    var name = crumb.name;
                    if($injector.has('translateFilter')) {
                        name = $filter('translate')(crumb.name);
                    }
                    title +=' ' + triRoute.separator + ' ' + name;
                });
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .provider('triRoute', routeProvider);

    /* @ngInject */
    function routeProvider() {
        // Provider
        var settings = {
            docTitle: '',
            separator: ''
        };

        this.setTitle = setTitle;
        this.setSeparator = setSeparator;
        this.$get = routeHelper;

        function setTitle(title) {
            settings.docTitle = title;
        }

        function setSeparator(separator) {
            settings.separator = separator;
        }

        // Service
        function routeHelper() {
            return {
                title: settings.docTitle,
                separator: settings.separator
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.profiler', [
            'digestHud'
        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.profiler')
        .config(profilerConfig);

    /* @ngInject */
    function profilerConfig(digestHudProvider) {
        digestHudProvider.enable();

        // Optional configuration settings:
        digestHudProvider.setHudPosition('top right'); // setup hud position on the page: top right, bottom left, etc. corner
        digestHudProvider.numTopWatches = 25;  // number of items to display in detailed table
        digestHudProvider.numDigestStats = 25;  // number of most recent digests to use f
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .run(layoutRunner)
        .provider('triLayout', layoutProvider);

    /* @ngInject */
    function layoutProvider() {
        var layoutDefaults = {
            toolbarSize: 'default',
            toolbarShrink: true,
            toolbarClass: '',
            contentClass: '',
            innerContentClass: '',
            sideMenuSize: 'full',
            showSideNavMenu: false,
            sideNavMenuSize: 15,
            showToolbar: true,
            footer: true,
            contentLayoutTemplateUrl: 'core/layouts/default-content.tmpl.html',
            contentLayoutController: 'DefaultLayoutController',
            sidebarLeftTemplateUrl: 'core/components/leftsidenav/leftsidenav.tmpl.html',
            sidebarLeftController: 'MenuController',
            sidebarNotificationsTemplateUrl: 'core/components/notifications/notifications.tmpl.html',
            sidebarNotificationsController: 'NotificationsSideNavController',
            toolbarTemplateUrl: 'core/components/toolbars/toolbar.tmpl.html',
            toolbarController: 'DefaultToolbarController',
            footerTemplateUrl: 'core/components/footer/footer.tmpl.html'
        };
        var resetableOptions = [
          'toolbarSize', 'toolbarShrink', 'toolbarClass', 'contentClass',
          'innerContentClass', 'sideMenuSize', 'showToolbar', 'showSideNavMenu', 'sideNavMenuPosition', 'sideNavMenuSize', 'footer',
          'contentLayoutTemplateUrl', 'contentLayoutController',
          'sidebarLeftTemplateUrl', 'sidebarLeftController',
          'sidebarNotificationsTemplateUrl', 'sidebarNotificationsController',
          'toolbarTemplateUrl', 'toolbarController',
          'tabMenuTemplateUrl',
          'tabMenuController', 'footerTemplateUrl', 'loaderTemplateUrl', 'loaderController'];
        var layout = {};

        this.getDefaultOption = getDefaultOption;
        this.setDefaultOption = setDefaultOption;

        function getDefaultOption(name) {
            return layoutDefaults[name];
        }

        function setDefaultOption(name, value) {
            layoutDefaults[name] = value;
        }

        // init

        angular.extend(layout, layoutDefaults);

        // Service
        this.$get = function() {
            function setOption(name, value) {
                layout[name] = value;
            }

            function updateLayoutFromState(event, toState) {
                // reset classes
                angular.forEach(resetableOptions, function(option){
                    layout[option] = layoutDefaults[option];
                });
                var layoutOverrides = angular.isDefined(toState.data) && angular.isDefined(toState.data.layout) ? toState.data.layout : {};
                angular.extend(layout, layout, layoutOverrides);
            }

            return {
                layout: layout,
                setOption: setOption,
                updateLayoutFromState: updateLayoutFromState
            };
        };
    }

    /* @ngInject */
    function layoutRunner($rootScope, triLayout) {
        // check for $stateChangeStart and update the layouts if we have data.layout set
        // if nothing set reset to defaults for every state
        var destroyOn = $rootScope.$on('$stateChangeStart', triLayout.updateLayoutFromState);
        $rootScope.$on('$destroy', removeWatch);

        /////////////

        function removeWatch() {
            destroyOn();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triDefaultContent', triDefaultContent);

    /* @ngInject */
    function triDefaultContent ($rootScope, $compile, $templateRequest, triLayout) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            link: link,
            replace: true,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element) {
            // scroll page to the top when content is loaded (stops pages keeping scroll position even when they have changed url)
            $scope.$on('$stateChangeStart', scrollToTop);

            // when content view has loaded add footer if needed and send mdContentLoaded event
            $scope.$on('$viewContentLoaded', injectFooterUpdateContent);

            ////////////////////////

            function scrollToTop() {
                $element.scrollTop(0);
            }

            function injectFooterUpdateContent() {
                var contentView = $element.find('#admin-panel-content-view');
                var footerElem = contentView.find('#footer');
                if (footerElem.length === 0) {
                    // add footer to the content view
                    $templateRequest(triLayout.layout.footerTemplateUrl)
                    .then(function(template) {
                        // compile template with current scope and add to the content
                        var linkFn = $compile(template);
                        var content = linkFn($scope);
                        contentView.append(content);
                    });

                }
            }
        }
    }
})();
;
'use strict';

/**
 * @ngdoc function
 * @name AdminController
 * @kind function
 *
 * @description
 *
 * Handles the admin view
 */
(function () {
    'use strict';

    angular
        .module('atheer.core')
        .controller('StormStateController', StormStateController);

    /* @ngInject */
    function StormStateController($scope, $state, $rootScope, $timeout, $templateRequest, $compile, $element, $window, triLayout, triLoaderService, triSettings) {
        var loadingQueue = [];
        var vm = this;

        vm.layout = triLayout.layout;
        vm.activateHover = activateHover;
        vm.removeHover = removeHover;
        vm.showLoader = triLoaderService.isActive();

        $scope.sideBarOpen = triSettings.getSkinModel().side_menu_state == 'OPEN';

        $scope.notification = {
            count: 0
        };

        // we need to use the scope here because otherwise the expression in md-is-locked-open doesnt work
        $scope.layout = triLayout.layout; //eslint-disable-line

        $scope.widgetColor = 'rgb(0, 188, 212)';
        $scope.closeWidgetColor = triSettings.getSkinModel().primary_color_hex;
        $scope.widgetSize = '45px';
        $scope.showSideNavMenu = true;

        if (triSettings.getSkinModel().side_menu == 'DARK') {
            $scope.widgetColor = triSettings.getSkinModel().primary_color_hex;
        } else {
            $scope.widgetColor = 'white';
        };

        if (triSettings.getSkinModel().widget_size == 'SMALL') {
            $scope.widgetSize = '45px';
        } else if (triSettings.getSkinModel().widget_size == 'MEDIUM') {
            $scope.widgetSize = '55px';
        } else if (triSettings.getSkinModel().widget_size == 'LARGE') {
            $scope.widgetSize = '65px';
        } else if (triSettings.getSkinModel().widget_size == 'HIDDEN') {
            $scope.widgetSize = 'HIDDEN';
        }

        $scope.widgetLogo = triSettings.getLogoSmall();

        $scope.toggleEmbedUI = function () {
            $scope.showEmbedUI = !$scope.showEmbedUI;

            if ($scope.showEmbedUI) {
                window.parent.postMessage({
                    toggleWidget: {
                        height: '100%',
                        width: '520px'
                    }
                }, "*");
            } else {
                if ($scope.widgetSize == 'HIDDEN') {
                    window.parent.postMessage({
                        toggleWidget: {
                            height: '0px',
                            width: '0px'
                        }
                    }, "*");
                } else {
                    window.parent.postMessage({
                        toggleWidget: {
                            height: '80px',
                            width: '80px'
                        }
                    }, "*");
                }

            }
        }

        ////////////////
        function activateHover() {
            if (triLayout.layout.sideMenuSize === 'icon') {
                $element.find('.storm-sidenav-left').addClass('hover');
                $rootScope.$broadcast('leftSideNavOpen');
                $timeout(function () {
                    $window.dispatchEvent(new Event('resize'));
                }, 300);
            }
        }

        function removeHover() {
            if (triLayout.layout.sideMenuSize === 'icon') {
                $element.find('.storm-sidenav-left').removeClass('hover');
                $rootScope.$broadcast('leftSideNavClose');
                $timeout(function () {
                    $window.dispatchEvent(new Event('resize'));
                }, 300);
            }
        }

        function injectFooterUpdateContent(viewName) {
            var contentView = $element.find('.storm-content');
            if (viewName === '@storm' && angular.isDefined(triLayout.layout.footerTemplateUrl)) {
                // add footer to the content view
                $templateRequest(triLayout.layout.footerTemplateUrl)
                    .then(function (template) {
                        // compile template with current scope and add to the content
                        var linkFn = $compile(template);
                        var content = linkFn($scope);
                        $timeout(function () {
                            contentView.append(content);
                        });
                    });
            }
        }

        function loaderEvent(event, isActive) {
            vm.showLoader = isActive;
        }

        function stateChangeStart() {
            if (!$rootScope.isJobExecutionActive && !$rootScope.isJobBoardActive) {
                // state has changed so start the loader
                triLoaderService.setLoaderActive(true);
            }
        }

        function viewContentLoading($event, viewName) {
            // a view is loading so add it to the queue
            // so we know when to turn off the loader
            loadingQueue.push(viewName);
        }

        function viewContentLoaded($event, viewName) {
            if (angular.isDefined(triLayout.layout.footer) && triLayout.layout.footer === true) {
                // inject footer into content
                injectFooterUpdateContent(viewName);
            }

            // view content has loaded so remove it from queue
            var index = loadingQueue.indexOf(viewName);
            if (-1 !== index) {
                loadingQueue.splice(index, 1);
            }
            // is the loadingQueue empty?
            if (loadingQueue.length === 0) {
                // nothing left to load so turn off the loader
                triLoaderService.setLoaderActive(false);
            }
        }

        function leftSideNavOpen() {
            vm.sideBarOpen = true;
        }

        function leftSideNavClose() {
            vm.sideBarOpen = false;
        }

        // watches
        //calls when hit menu on sidebar to open sub menus in side bar
        $rootScope.$on('toggleSideMenu', function (event, type) {
            if (type == 'toggle') {
                $scope.showSideNavMenu = !$scope.showSideNavMenu;
            } else {
                $scope.showSideNavMenu = true;
            }

        });

        // watches
        //calls when hit menu on sidebar to open sub menus in side bar
        $rootScope.$on('showSideMenu', function (event, type) {
            if (type == 'false') {
                $scope.showSideNavMenu = false;
            } else {
                $scope.showSideNavMenu = true;
            }
        });

        // register listeners for loader
        $scope.$on('loader', loaderEvent);

        // watch for ui router state change
        $scope.$on('$stateChangeStart', stateChangeStart);

        // watch for view content loading
        $scope.$on('$viewContentLoading', viewContentLoading);

        // watch for view content loaded
        $scope.$on('$viewContentLoaded', viewContentLoaded);

        // register listeners for loader
        $scope.$on('leftSideNavOpen', leftSideNavOpen);

        // register listeners for loader
        $scope.$on('leftSideNavClose', leftSideNavClose);
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.core')
        .filter('fpToDate', fpToDate);

    function fpToDate() {
        return function(input) {
            if (input && !isNaN(Date.parse(input))) {
                return new Date(input);
            } else {
                return new Date();
            }

        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.core')
        .filter('fpCapitalizeWord', fpCapitalizeWord);

    function fpCapitalizeWord() {
        return function(text) {
            return (!!text) ? text.charAt(0).toUpperCase() + text.substr(1).toLowerCase() : '';
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('atheer.core').directive('whenScrolled', ['$timeout', function($timeout) {
        return function(scope, elm, attr) {
            var raw = elm[0];

            elm.bind('scroll', function() {
                if (raw.scrollTop <= 100) {
                    var sh = raw.scrollHeight
                    scope.$apply(attr.whenScrolled).then(function() {
                        $timeout(function() {
                            raw.scrollTop > raw.scrollHeight - sh;
                        })
                    });
                }
            });
        };
    }]);
})();
;
(function() {
    'use strict';

    angular.module('atheer.core').directive('whenScrolledNoTimeout', ['$timeout', function($timeout) {
        return function(scope, elm, attr) {
            var raw = elm[0];

            elm.bind('scroll', function() {
                if (!raw.scrollTop) {
                    scope.$apply(attr.whenScrolledNoTimeout); 
                }
            });
        };
    }]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('themeBackground', themeBackground);

    /* @ngInject */
    function themeBackground($mdTheming, triTheming) {
        // Usage:
        // ```html
        // <div md-theme="cyan" theme-background="primary|accent|warn|background:default|hue-1|hue-2|hue-3">Coloured content</div>
        // ```
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs) {
            $mdTheming($element);

            // make sure we have access to the theme - causes an eslint but nothing we can do about AM naming
            var $mdTheme = $element.controller('mdTheme'); //eslint-disable-line
            if(angular.isDefined($mdTheme)) {
                var intent = attrs.themeBackground;
                var hue = 'default';

                // check if we have a hue provided
                if(intent.indexOf(':') !== -1) {
                    var splitIntent = attrs.themeBackground.split(':');
                    intent = splitIntent[0];
                    hue = splitIntent[1];
                }
                // get the color and apply it to the element
                var color = triTheming.getThemeHue($mdTheme.$mdTheme, intent, hue);
                if(angular.isDefined(color)) {
                    $element.css({
                        'background-color': triTheming.rgba(color.value),
                        'border-color': triTheming.rgba(color.value),
                        'color': triTheming.rgba(color.contrast)
                    });
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('scrollToBottom', scrollToBottom);

    /* @ngInject */
    function scrollToBottom($timeout, $window) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                'scrollToBottom': '='
            }
        };
        return directive;

        function link($scope, $element, attrs) {
            $scope.$watch('scrollToBottom', function(newVal) {
                if (newVal) {
                    $timeout(function() {
                        $element[0].scrollTop = $element[0].scrollHeight;
                    }, 0);
                }
            });
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('triSamePassword', samePassword);

    /* @ngInject */
    function samePassword() {
        // Usage:
        //
        // ```html
        // <form name="signup">
        //     <input name="password" type="password" ng-model="user.password" same-password="signup.confirm" />
        //     <input name="confirm" type="password" ng-model="user.confirm" same-password="signup.confirm" />
        // </form>
        // ```
        // Creates:
        //
        // `samePassword` is a directive with the purpose to validate a password input based on the value of another input.
        // When both input values are the same the inputs will be set to valid

        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: link,
            scope: {
                triSamePassword: '='
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            ngModel.$viewChangeListeners.push(function() {
                ngModel.$setValidity('samePassword', scope.triSamePassword.$modelValue === ngModel.$modelValue);
                scope.triSamePassword.$setValidity('samePassword', scope.triSamePassword.$modelValue === ngModel.$modelValue);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('replaceWith', replaceWith);

    /* @ngInject */
    function replaceWith() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$observe('replaceWith', function(value) {
                if (value) {
                    element.replaceWith(angular.isUndefined(value) ? '' : value);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('paletteBackground', paletteBackground);

    /* @ngInject */
    function paletteBackground(triTheming) {
        // Usage:
        // ```html
        // <div palette-background="green:500">Coloured content</div>
        // ```
        //
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs) {
            var splitColor = attrs.paletteBackground.split(':');
            var color = triTheming.getPaletteColor(splitColor[0], splitColor[1]);

            if(angular.isDefined(color)) {
                $element.css({
                    'background-color': triTheming.rgba(color.value),
                    'border-color': triTheming.rgba(color.value),
                    'color': triTheming.rgba(color.contrast)
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('includeReplace', function () {
		    return {
		        require: 'ngInclude',
		        restrict: 'A', /* optional */
		        link: function (scope, el, attrs) {
		            el.replaceWith(el.children());
		        }
		    };
		});
})();;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('dynamicController', dynamicController);

    /* @ngInject */
    function dynamicController($controller) {
      var directive = {
          restrict: 'A',
          scope: true,
          link: function(scope, element, attrs) {
              var locals = {
                  $scope: scope,
                  $element: element,
                  $attrs: attrs,
                  id: attrs.id
              };
              element.data('$Controller', $controller(scope.$eval(attrs.dynamicController), locals));
          }
      };
      return directive;
    }
    
    
    
    angular
    .module('atheer.core').directive('scrollToBookmark', function() {
        return {
            link: function(scope, element, attrs) {
              var value = attrs.scrollToBookmark;
              element.click(function() {
                scope.$apply(function() {
                  var selector = "[scroll-bookmark='"+ value +"']";
                  var element = $(selector);
                  if(element.length)
                    window.scrollTo(0, element[0].offsetTop - 100);  // Don't want the top to be the exact element, -100 will go to the top for a little bit more
                });
              });
            }
          };
      });
    
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('compileHtml', compileHtml);

    function compileHtml($compile) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                scope.$watch(function() {
                    return scope.$eval(attrs.compileHtml);
                }, function(value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .filter('triTranslate', triTranslateFilter);

    /* @ngInject */
    function triTranslateFilter($injector, $filter) {
        return function(input) {
            // if angular translate installed this will return true
            // so we can translate
            if($injector.has('translateFilter')) {
                return $filter('translate')(input);
            }
            else {
                // no translation active so just return the same input
                return input;
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.core')
        .config(themesConfig);

    /* @ngInject */
    function themesConfig($mdThemingProvider, triThemingProvider, triSkinsProvider) {
        $mdThemingProvider.generateThemesOnDemand(true);
        /**
         *  PALETTES
         */
        $mdThemingProvider.definePalette('white', {
            '50': '#ffffff',
            '100': '#ffffff',
            '200': '#ffffff',
            '300': '#ffffff',
            '400': '#ffffff',
            '500': '#ffffff',
            '600': '#ffffff',
            '700': '#ffffff',
            '800': '#ffffff',
            '900': '#ffffff',
            'A100': '#ffffff',
            'A200': '#ffffff',
            'A400': '#ffffff',
            'A700': '#ffffff',
            'contrastDefaultColor': 'dark'
        });

        $mdThemingProvider.definePalette('black', {
            '50': '#e1e1e1',
            '100': '#b6b6b6',
            '200': '#8c8c8c',
            '300': '#646464',
            '400': '#3a3a3a',
            '500': '#e1e1e1',
            '600': '#e1e1e1',
            '700': '#232323',
            '800': '#1a1a1a',
            '900': '#121212',
            'A100': '#3a3a3a',
            'A200': '#ffffff',
            'A400': '#ffffff',
            'A700': '#ffffff',
            'contrastDefaultColor': 'light'
        });

        $mdThemingProvider.definePalette('crimson', {
            '50': '#fae1e4',
            '100': '#f2b4bc',
            '200': '#e9828f',
            '300': '#e05062',
            '400': '#d92b40',
            '500': '#d2051e',
            '600': '#cd041a',
            '700': '#c70416',
            '800': '#c10312',
            '900': '#b6010a',
            'A100': '#ffdfdf',
            'A200': '#ffacad',
            'A400': '#ff797b',
            'A700': '#ff5f62',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100 A200 A400 A700',
            'contrastLightColors': '300 400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('scarlet', {
            '50': '#f8e5e6',
            '100': '#efbfc0',
            '200': '#e49597',
            '300': '#d96a6d',
            '400': '#d04a4d',
            '500': '#c82a2e',
            '600': '#c22529',
            '700': '#bb1f23',
            '800': '#b4191d',
            '900': '#a70f12',
            'A100': '#ffd6d7',
            'A200': '#ffa3a4',
            'A400': '#ff7072',
            'A700': '#ff5759',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 A100 A200 A400 A700',
            'contrastLightColors': '400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('bright-red', {
            '50': '#ffe0e0',
            '100': '#ffb3b3',
            '200': '#ff8080',
            '300': '#ff4d4d',
            '400': '#ff2626',
            '500': '#ff0000',
            '600': '#ff0000',
            '700': '#ff0000',
            '800': '#ff0000',
            '900': '#ff0000',
            'A100': '#ffffff',
            'A200': '#fff2f2',
            'A400': '#ffbfbf',
            'A700': '#ffa6a6',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 A100 A200 A400 A700',
            'contrastLightColors': '400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('bright-pink', {
            '50': '#fee1f7',
            '100': '#fdb5ec',
            '200': '#fc84df',
            '300': '#fb53d2',
            '400': '#fa2ec8',
            '500': '#f909be',
            '600': '#f808b8',
            '700': '#f706af',
            '800': '#f605a7',
            '900': '#f50299',
            'A100': '#ffffff',
            'A200': '#ffe8f5',
            'A400': '#ffb5e0',
            'A700': '#ff9cd5',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 A100 A200 A400 A700',
            'contrastLightColors': '400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('violet', {
            '50': '#f7e0ff',
            '100': '#ecb3ff',
            '200': '#e080ff',
            '300': '#d34dff',
            '400': '#c926ff',
            '500': '#c000ff',
            '600': '#ba00ff',
            '700': '#b200ff',
            '800': '#aa00ff',
            '900': '#9c00ff',
            'A100': '#ffffff',
            'A200': '#f9f2ff',
            'A400': '#e3bfff',
            'A700': '#d8a6ff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 A100 A200 A400 A700',
            'contrastLightColors': '400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('grape', {
            '50': '#ece2ef',
            '100': '#cfb7d7',
            '200': '#b087bc',
            '300': '#9057a1',
            '400': '#78338c',
            '500': '#600f78',
            '600': '#580d70',
            '700': '#4e0b65',
            '800': '#44085b',
            '900': '#330448',
            'A100': '#d07cff',
            'A200': '#be49ff',
            'A400': '#ac16ff',
            'A700': '#a200fc',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100 A200',
            'contrastLightColors': '300 400 500 600 700 800 900 A400 A700'
        });

        $mdThemingProvider.definePalette('navy', {
            '50': '#e2e6f2',
            '100': '#b6bfdf',
            '200': '#8695ca',
            '300': '#556bb5',
            '400': '#304ba5',
            '500': '#0c2b95',
            '600': '#0a268d',
            '700': '#082082',
            '800': '#061a78',
            '900': '#031067',
            'A100': '#969fff',
            'A200': '#6370ff',
            'A400': '#3041ff',
            'A700': '#172aff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100',
            'contrastLightColors': '300 400 500 600 700 800 900 A200 A400 A700'
        });

        $mdThemingProvider.definePalette('cobalt', {
            '50': '#e0e0ff',
            '100': '#b3b3ff',
            '200': '#8080ff',
            '300': '#4d4dff',
            '400': '#2626ff',
            '500': '#0000ff',
            '600': '#0000ff',
            '700': '#0000ff',
            '800': '#0000ff',
            '900': '#0000ff',
            'A100': '#ffffff',
            'A200': '#f2f2ff',
            'A400': '#bfbfff',
            'A700': '#a6a6ff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100 A200 A400 A700',
            'contrastLightColors': '300 400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('cerulean', {
            '50': '#e8ecff',
            '100': '#c5cfff',
            '200': '#9fafff',
            '300': '#798eff',
            '400': '#5c76ff',
            '500': '#3f5eff',
            '600': '#3956ff',
            '700': '#314cff',
            '800': '#2942ff',
            '900': '#1b31ff',
            'A100': '#ffffff',
            'A200': '#ffffff',
            'A400': '#ccd0ff',
            'A700': '#b3b9ff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 A100 A200 A400 A700',
            'contrastLightColors': '400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('sky-blue', {
            '50': '#f0fdfd',
            '100': '#d8fafa',
            '200': '#bff7f7',
            '300': '#a5f3f3',
            '400': '#91f1f1',
            '500': '#7eeeee',
            '600': '#76ecec',
            '700': '#6be9e9',
            '800': '#61e7e7',
            '900': '#4ee2e2',
            'A100': '#ffffff',
            'A200': '#ffffff',
            'A400': '#d8ffff',
            'A700': '#beffff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 400 500 600 700 800 900 A100 A200 A400 A700',
            'contrastLightColors': ''
        });

        $mdThemingProvider.definePalette('process-blue', {
            '50': '#e0f0f9',
            '100': '#b3daef',
            '200': '#80c2e5',
            '300': '#4daada',
            '400': '#2697d2',
            '500': '#0085ca',
            '600': '#007dc5',
            '700': '#0072bd',
            '800': '#0068b7',
            '900': '#0055ab',
            'A100': '#d4e7ff',
            'A200': '#a1caff',
            'A400': '#6eadff',
            'A700': '#559eff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 400 A100 A200 A400',
            'contrastStrongLightColors': '500 600 700 800 900 A700'
        });

        $mdThemingProvider.definePalette('dark-blue', {
            '50': '#e1e2ed',
            '100': '#b3b6d1',
            '200': '#8185b3',
            '300': '#4e5495',
            '400': '#282f7e',
            '500': '#020a67',
            '600': '#02095f',
            '700': '#010754',
            '800': '#01054a',
            '900': '#010339',
            'A100': '#6f6fff',
            'A200': '#3c3cff',
            'A400': '#0909ff',
            'A700': '#0000ef',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 400 A100 A200 A400',
            'contrastStrongLightColors': '500 600 700 800 900 A700'
        });

        $mdThemingProvider.definePalette('cool-grey', {
            '50': '#eeefef',
            '100': '#d6d7d7',
            '200': '#babcbd',
            '300': '#9ea1a3',
            '400': '#8a8c8f',
            '500': '#75787b',
            '600': '#6d7073',
            '700': '#626568',
            '800': '#585b5e',
            '900': '#45484b',
            'A100': '#b2d5f9',
            'A200': '#83bcf5',
            'A400': '#46a2ff',
            'A700': '#2c96ff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 400 A100 A200 A400',
            'contrastStrongLightColors': '500 600 700 800 900 A700'
        });

        $mdThemingProvider.definePalette('sea-green', {
            '50': '#e5f8f4',
            '100': '#beeee4',
            '200': '#93e3d3',
            '300': '#68d8c1',
            '400': '#47cfb3',
            '500': '#27c7a6',
            '600': '#23c19e',
            '700': '#1dba95',
            '800': '#17b38b',
            '900': '#0ea67b',
            'A100': '#d4fff2',
            'A200': '#a1ffe2',
            'A400': '#6effd2',
            'A700': '#55ffca',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 400 500 600 700 A100 A200 A400 A700',
            'contrastLightColors': '800 900'
        });

        $mdThemingProvider.definePalette('deep-green', {
            '50': '#e6eaeb',
            '100': '#c1cbcc',
            '200': '#98a8aa',
            '300': '#6e8588',
            '400': '#4f6a6f',
            '500': '#305055',
            '600': '#2b494e',
            '700': '#244044',
            '800': '#1e373b',
            '900': '#13272a',
            'A100': '#6ce8ff',
            'A200': '#39e0ff',
            'A400': '#06d8ff',
            'A700': '#00c6eb',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100 A200 A400 A700',
            'contrastLightColors': '300 400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('bright-green', {
            '50': '#e1fae6',
            '100': '#b4f2c2',
            '200': '#82e999',
            '300': '#4fe070',
            '400': '#2ad951',
            '500': '#04d232',
            '600': '#03cd2d',
            '700': '#03c726',
            '800': '#02c11f',
            '900': '#01b613',
            'A100': '#dfffe0',
            'A200': '#acffb0',
            'A400': '#79ff80',
            'A700': '#5fff68',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 400 500 A100 A200 A400 A700',
            'contrastLightColors': '600 700 800 900'
        });

        $mdThemingProvider.definePalette('basil-green', {
            '50': '#e1f2ea',
            '100': '#b5dfc9',
            '200': '#84caa6',
            '300': '#52b582',
            '400': '#2da567',
            '500': '#08954c',
            '600': '#078d45',
            '700': '#06823c',
            '800': '#047833',
            '900': '#026724',
            'A100': '#96ffb1',
            'A200': '#63ff8b',
            'A400': '#30ff65',
            'A700': '#17ff52',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 A100 A200 A400 A700',
            'contrastLightColors': '400 500 600 700 800 900'
        });

        $mdThemingProvider.definePalette('bright-yellow', {
            '50': '#fff9e6',
            '100': '#fff1c0',
            '200': '#ffe896',
            '300': '#ffdf6c',
            '400': '#ffd84d',
            '500': '#ffd12d',
            '600': '#ffcc28',
            '700': '#ffc622',
            '800': '#ffc01c',
            '900': '#ffb511',
            'A100': '#ffffff',
            'A200': '#fffdf8',
            'A400': '#ffebc5',
            'A700': '#ffe3ac',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 300 400 500 600 700 800 900 A100 A200 A400 A700',
            'contrastLightColors': ''
        });

        var primaryColor = localStorage.getItem('primary-color');
        var secondaryColor = localStorage.getItem('secondary-color');

        if (primaryColor != null) {
            primaryColor = '#' + primaryColor;
            var tinyColorObject = tinycolor(primaryColor);
            var contrastDefaultColor = tinyColorObject.isLight() ? 'dark' : 'light';

            $mdThemingProvider.definePalette('custom-primary-color', {
                '50': tinyColorObject.lighten(52),
                '100': tinyColorObject.lighten(37),
                '200': tinyColorObject.lighten(26),
                '300': tinyColorObject.lighten(12),
                '400': tinyColorObject.lighten(6),
                '500': primaryColor,
                '600': tinyColorObject.darken(6),
                '700': tinyColorObject.darken(12),
                '800': tinyColorObject.darken(18),
                '900': tinyColorObject.darken(24),
                'A100': tinyColorObject.lighten(50).saturate(30),
                'A200': tinyColorObject.lighten(30).saturate(30),
                'A400': tinyColorObject.lighten(10).saturate(15),
                'A700': tinyColorObject.lighten(5).saturate(5),
                'contrastDefaultColor': contrastDefaultColor
            });
        }

        if (secondaryColor != null) {
            secondaryColor = '#' + secondaryColor;
            var tinyColorObject = tinycolor(secondaryColor);
            var contrastDefaultColor = tinyColorObject.isLight() ? 'dark' : 'light';
            $mdThemingProvider.definePalette('custom-secondary-color', {
                '50': tinyColorObject.lighten(52),
                '100': tinyColorObject.lighten(37),
                '200': tinyColorObject.lighten(26),
                '300': tinyColorObject.lighten(12),
                '400': tinyColorObject.lighten(6),
                '500': secondaryColor,
                '600': tinyColorObject.darken(6),
                '700': tinyColorObject.darken(12),
                '800': tinyColorObject.darken(18),
                '900': tinyColorObject.darken(24),
                'A100': tinyColorObject.lighten(50).saturate(30),
                'A200': tinyColorObject.lighten(30).saturate(30),
                'A400': tinyColorObject.lighten(10).saturate(15),
                'A700': tinyColorObject.lighten(5).saturate(5),
                'contrastDefaultColor': contrastDefaultColor
            });
        }

        var triCyanMap = $mdThemingProvider.extendPalette('cyan', {
            'contrastDefaultColor': 'light',
            'contrastLightColors': '500 700 800 900',
            'contrastStrongLightColors': '500 700 800 900'
        });

        // Register the new color palette map with the name triCyan
        $mdThemingProvider.definePalette('triCyan', triCyanMap);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, $urlRouterProvider) {
        // Setup the apps routes
        // 404 & 500 pages
        $stateProvider
            .state('storm', {
                abstract: true,
                views: {
                    'root': {
                        templateProvider: function($templateRequest, triLayout) {
                            if (angular.isDefined(triLayout.layout.contentLayoutTemplateUrl)) {
                                return $templateRequest(triLayout.layout.contentLayoutTemplateUrl);
                            }
                        },
                        controllerProvider: function(triLayout) {
                            return triLayout.layout.contentLayoutController;
                        },
                        controllerAs: 'stateController'
                    },
                    'sidebarLeft@storm': {
                        templateProvider: function($templateRequest, triLayout) {
                            if (angular.isDefined(triLayout.layout.sidebarLeftTemplateUrl)) {
                                return $templateRequest(triLayout.layout.sidebarLeftTemplateUrl);
                            }
                        },
                        controllerProvider: function(triLayout) {
                            return triLayout.layout.sidebarLeftController;
                        },
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateProvider: function($templateRequest, triLayout) {
                            if (angular.isDefined(triLayout.layout.sideMenuTemplateUrl)) {
                                return $templateRequest(triLayout.layout.sideMenuTemplateUrl);
                            }
                        },
                        controllerProvider: function(triLayout) {
                            return triLayout.layout.sideMenuController;
                        },
                        controllerAs: 'vm'
                    },
                    'sidebarNotifications@storm': {
                        templateProvider: function($templateRequest, triLayout) {
                            if (angular.isDefined(triLayout.layout.sidebarNotificationsTemplateUrl)) {
                                return $templateRequest(triLayout.layout.sidebarNotificationsTemplateUrl);
                            }
                        },
                        controllerProvider: function(triLayout) {
                            return triLayout.layout.sidebarNotificationsController;
                        },
                        controllerAs: 'vm'
                    },
                    'toolbar@storm': {
                        templateProvider: function($templateRequest, triLayout) {
                            if (angular.isDefined(triLayout.layout.toolbarTemplateUrl)) {
                                return $templateRequest(triLayout.layout.toolbarTemplateUrl);
                            }
                        },
                        controllerProvider: function(triLayout) {
                            return triLayout.layout.toolbarController;
                        },
                        controllerAs: 'vm'
                    },
                    'loader@storm': {
                        templateProvider: function($templateRequest, triLayout) {
                            if (angular.isDefined(triLayout.layout.loaderTemplateUrl)) {
                                return $templateRequest(triLayout.layout.loaderTemplateUrl);
                            }
                        },
                        controllerProvider: function(triLayout) {
                            return triLayout.layout.loaderController;
                        },
                        controllerAs: 'loader'
                    }
                }
            })
            .state('404', {
                url: '/404',
                views: {
                    'root': {
                        templateUrl: '/modules/user/noaccess/404.tmpl.html',
                        controller: 'ErrorPageController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('401', {
                url: '/401',
                views: {
                    'root': {
                        templateUrl: '401.tmpl.html',
                        controller: 'ErrorPageController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('500', {
                url: '/500',
                views: {
                    'root': {
                        templateUrl: '500.tmpl.html',
                        controller: 'ErrorPageController',
                        controllerAs: 'vm'
                    }
                }
            });
        // always goto 404 if route not found
        $urlRouterProvider.otherwise('/404');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .provider('triSettings', settingsProvider);

    /* @ngInject */
    function settingsProvider() {
        // Provider
        var settings = {
            languages: [],
            name: '',
            logoBig: '',
            logoSmall: '',
            copyright: '',
            version: '',
            skinModel: null
        };

        return {
            addLanguage: function(newLanguage) {
                settings.languages.push(newLanguage);
            },
            setSkinModel: function(skin) {
                settings.skinModel = skin;
            },
            setLogoBig: function(logo) {
                settings.logo = logo;
            },
            setLogoSmall: function(logo) {
                settings.logoSmall = logo;
            },
            setName: function(name) {
                settings.name = name;
            },
            setCopyright: function(copy) {
                settings.copyright = copy;
            },
            setVersion: function(version) {
                settings.version = version;
            },
            $get: function() {
                return {
                    setSkinModel: function(skin) {
                        settings.skinModel = skin;
                    },
                    getSkinModel: function() {
                        return settings.skinModel;
                    },
                    setLogoBig: function(logo) {
                        settings.logo = logo;
                    },
                    getLogoBig: function() {
                        return settings.logo;
                    },
                    setLogoSmall: function(logo) {
                        settings.logoSmall = logo;
                    },
                    getLogoSmall: function() {
                        return settings.logoSmall;
                    },
                    setName: function(name) {
                        settings.name = name;
                    },
                    getName: function() {
                        return settings.name;
                    },
                    setCopyright: function(copy) {
                        settings.copyright = copy;
                    },
                    getCopyright: function() {
                        return settings.copyright;
                    },
                    setVersion: function(version) {
                        settings.version = version;
                    },
                    getVersion: function() {
                        return settings.version;
                    },
                    languages: settings.languages,
                    name: settings.name,
                    copyright: settings.copyright,
                    logoBig: settings.logo,
                    logoSmall: settings.logoSmall,
                    version: settings.version
                };
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig(triSettingsProvider, triRouteProvider) {
        var now = new Date();
        // set app name & logo (used in loader, sidemenu, footer, login pages, etc)
        triSettingsProvider.setName('Atheer');
        triSettingsProvider.setCopyright('&copy;' + now.getFullYear() + ' Atheer Inc.');
        triSettingsProvider.setLogoBig('assets/images/ath-color.png');
        triSettingsProvider.setLogoSmall('assets/images/ath-sm-white.png');
        // set current version of app (shown in footer)
        triSettingsProvider.setVersion('1.0.0');
        // set the document title that appears on the browser tab
        triRouteProvider.setTitle('Atheer');
        triRouteProvider.setSeparator('|');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .run(runFunction);

    /* @ngInject */
    function runFunction($rootScope, $timeout, $window) {
        // add a class to the body if we are on windows
        if($window.navigator.platform.indexOf('Win') !== -1) {
            $rootScope.bodyClasses = ['os-windows'];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .config(config);

    /* @ngInject */
    function config(triLayoutProvider) {
        // set app templates (all in core/layouts folder so you can tailor them to your needs)

        // loader screen HTML & controller
        triLayoutProvider.setDefaultOption('loaderTemplateUrl', 'core/components/loader/loader.tmpl.html');
        triLayoutProvider.setDefaultOption('loaderController', 'LoaderController');

        // Contenty Layout HTML and controller
        triLayoutProvider.setDefaultOption('contentLayoutTemplateUrl', 'core/layouts/core.tmpl.html');
        triLayoutProvider.setDefaultOption('contentLayoutController', 'StormStateController');

        // left sidemenu HTML and controller
        triLayoutProvider.setDefaultOption('sidebarLeftTemplateUrl', 'core/components/leftsidenav/leftsidenav.tmpl.html');
        triLayoutProvider.setDefaultOption('sidebarLeftController', 'LeftSidenavController');

        // Side Menu HTML and Controller
        triLayoutProvider.setDefaultOption('sideMenuTemplateUrl', 'core/components/menu/sidemenu.tmpl.html');
        triLayoutProvider.setDefaultOption('sideMenuController', 'SideMenuController');

        // top toolbar HTML and controller
        triLayoutProvider.setDefaultOption('toolbarTemplateUrl', 'core/components/toolbars/toolbar.tmpl.html');
        triLayoutProvider.setDefaultOption('toolbarController', 'ToolbarController');

        // right sidemenu HTML and controller
        triLayoutProvider.setDefaultOption('sidebarRightTemplateUrl', 'core/components/rightsidenav/rightsidenav.tmpl.html');
        triLayoutProvider.setDefaultOption('sidebarRightController', 'RightSidenavController');

        triLayoutProvider.setDefaultOption('sidebarNotificationsTemplateUrl', 'core/components/notifications/notifications.tmpl.html');
        triLayoutProvider.setDefaultOption('sidebarNotificationsController', 'NotificationsSideNavController');

        // footer HTML
        triLayoutProvider.setDefaultOption('footerTemplateUrl', 'core/components/footer/footer.tmpl.html');

        triLayoutProvider.setDefaultOption('toolbarSize', 'default');
        triLayoutProvider.setDefaultOption('toolbarShrink', false);
        triLayoutProvider.setDefaultOption('toolbarClass', '');
        triLayoutProvider.setDefaultOption('contentClass', '');
        triLayoutProvider.setDefaultOption('sideMenuSize', 'icon');
        triLayoutProvider.setDefaultOption('showToolbar', true);
        triLayoutProvider.setDefaultOption('showSideNavMenu', false);
        triLayoutProvider.setDefaultOption('sideNavMenuPosition', 'left');
        triLayoutProvider.setDefaultOption('sideMenuNavSize', 15);
        triLayoutProvider.setDefaultOption('footer', false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user', [

        ]);
})();
;
/* global d3 */
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileTimelineController', ProfileTimelineController);

    /* @ngInject */
    function ProfileTimelineController($scope, $timeout, $mdToast, $filter, $mdDialog, id) {
        var vm = this;

        vm.loadingData = false;

        var timelineContent = '<div class="md-padding"><div><span class="md-title" translate="atheer.timeline.date">07 Dec</span></div><div><p translate="atheer.timeline.completedLearningEvents">Completed 5 learning events</p> <p translate="atheer.timeline.providedFeedBack">Provided feedback for 3 questions</p></div></div>';

        vm.events = [];

        for (var i = 0; i <= 4; i++) {
            vm.events.push({
                'content': timelineContent
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .directive('animateElements', animateElements);

    /* @ngInject */
    function animateElements($interval) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element) {
            var $widgets  = [];
            var $dividers = [];


            function isLoaded(widget) {
                return widget.clientHeight > 1;
            }

            // using interval checking since window load event does not work on some machines
            var widgetsLoaded = $interval(function() {
                $widgets = $element.find('.timeline-widget');
                if($widgets.length > 0 && $widgets.toArray().every(isLoaded)) {
                    $dividers = $element.find('.timeline-x-axis');
                    onScrollCallback();
                    $interval.cancel(widgetsLoaded);
                }
            }, 1000);

            var onScrollCallback =  function() {
                for(var i = 0; i < $widgets.length; i++) {
                    if(angular.element($widgets[i]).offset().top <= angular.element(window).scrollTop() + angular.element(window).height() * 0.80 && angular.element($widgets[i]).height() > 1) {
                        var dir = ( i % 2 === 0 ) ? 'left':'right';
                        angular.element($dividers[i]).addClass('timeline-content-animated '+ dir);
                        angular.element($widgets[i]).addClass('timeline-content-animated '+ dir);
                    }
                }
            };

            angular.element('md-content').bind('scroll', onScrollCallback).scroll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileTeamsController', ProfileTeamsController);

    /* @ngInject */
    function ProfileTeamsController($scope, $state, triTheming, triSettings, $mdDialog, Principal, $translate, pagingParams, paginationConstants, $mdToast, $filter, Experience, CONTENT_META, $mdMedia, id) {
        var vm = this;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.user = null;
        vm.loadingData = true;
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.teams = [];
        vm.primaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value
        );
        vm.secondaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().secondary_color, '500').value
        );

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.openAssignModal = function() {
            $mdDialog.show({
                templateUrl: 'modules/team/team-assign-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "TeamAssignController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    team: undefined,
                    userId: vm.userId,
                    teamsFilterList: 1001
                }
            }).then(function() {
                vm.loadData();
            });
        }

        vm.removeTeam = function(team) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.teams.removeTeam'))
                .ariaLabel($filter('translate')('atheer.teams.removeTeam'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Experience.deleteTeam({
                    id: team.id
                }, function() {
                    vm.loadData();
                });
            });
        }

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getTeams({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, function(response, headers) {
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.teams = response;
                vm.loadingData = false;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "user_id==" + vm.userId;
            if (vm.query.filter.length <= 0) {
                return queryString;
            }
        }

        vm.transition = function() {
            vm.promise = Experience.getTeams({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.teams = response;
                vm.queryCount = vm.totalItems;
            });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('SupportController', SupportController);

    /* @ngInject */
    function SupportController($scope, $state, $q, Explore, ParseLinks, triLoaderService, $filter, Experience, Principal, $mdToast, Feature) {
        var vm = this;

        vm.loadingData = false;

        function loadData() {
            vm.loadingData = false;
        }
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('SupportToolbarController', SupportToolbarController);

    /* @ngInject */
    function SupportToolbarController($scope, $state, $q, Explore, ParseLinks, triLoaderService, $filter, Experience, Principal, $mdToast, Feature, $window) {
        var vm = this;

        vm.loadingData = false;

        function loadData() {
            vm.loadingData = false;
        }

        vm.back = function() {
            $window.history.back();
        };
        loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserSignupController', UserSignupController);

    /* @ngInject */
    function UserSignupController($scope, $state, $window, $sce, $location, Feature) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.isIFrameDataLoaded = false;

        function setNgxPageUrl() {
            var ngxUrl = null;
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            var path = $location.path();

            if ($state.current.name == "account.signup") {
                if(!Feature.isActive('feature_user_signup')) {
                    $state.go('account.signin');
                }
                ngxUrl = hostUrl + "/ngx/signup";
            } else if ($state.current.name == "account.signup-confirmed") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/signup/" + id;
            }
            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
        }

        function handleNgxEvent(event) {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;
                var queryParams = event.data.ngxLocationChanged.queryParams;
                id = id ? id : queryParams;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                if (id == null && queryParams == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                } else {
                    $state.transitionTo(
                        ngState,
                        {
                            id: id
                        },
                        {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        }
                    );
                }
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        $window.addEventListener("message", handleNgxEvent, false);

        // Unregister
        $scope.$on("$destroy", function () {
            window.removeEventListener("message", handleNgxEvent, false);
        });

        setNgxPageUrl();

    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('SignoutController', SignoutController);

    /* @ngInject */
    function SignoutController($rootScope, $stateParams, Auth, LoginService, triSettings) {

        var vm = this;
        vm.buildInfoSettings = $rootScope.buildInfo;
        vm.isDesktop = window.isDesktop;
        vm.isWhiteLabelled = window.isWhiteLabelled;

        vm.changeWorkspace = function () {
            if(window && window.nodeAPI) {
                window.nodeAPI.ipc.send('back-to-workspace');
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('SigninController', SigninController);

    /* @ngInject */

    function SigninController($rootScope, $location, $window, $state, $q, Setting, $timeout, Auth, triSettings, Feature, triMenu, Principal, $cookies, deviceDetector, $filter, translationStorageProvider, User, LocalResourceService, ToastService) {
        var vm = this;

        vm.isAppWorkspace = $rootScope.isAppWorkspace;

        vm.useDarkBackGroundLogos = true;
        vm.authenticationError = false;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        vm.workspace = null;
        vm.triSettings = triSettings;
        vm.userSignupSetting = {
            invitation_only: "true"
        };
        vm.buildInfoSettings = $rootScope.buildInfo;

        vm.enableAtheerLogin = true;
        vm.enableForgotPassword = false;
        vm.googleSSO = false;
        vm.twitterSSO = false;
        vm.linkedInSSO = false;
        vm.facebookSSO = false;
        vm.samlSSO = false;
        vm.azureAdSSO = false;
        vm.studioOidcSSO = false;
        vm.featureForcedPassword = Feature.isActive('feature_user_initial_login_forced_password_required');
        vm.isGuestFeature = Feature.isActive('feature_airsession_invite_guest_user');
        vm.isSignUpFeatureActive = Feature.isActive('feature_user_signup');

        vm.showSSOLogin = false;

        vm.isDesktop = window.isDesktop;
        vm.isWhitedLablled = window.isWhiteLabelled;
        vm.isWorkspaceError = false;
        vm.isMobileBrowser = deviceDetector.isMobile();
        vm.backgroundColor = {};
        vm.isLoading = true;
        vm.passwordVisible = false;

        vm.samlLogin = {
            icon: 'fa fa-twitter',
            color: '#5bc0de',
            url: '/sso/saml'
        };

        vm.twitterLogin = {
            icon: 'fa fa-twitter',
            color: '#5bc0de',
            url: '/sso/twitter'
        };

        vm.googleLogin = {
            icon: 'fa fa-google',
            color: '#FFFFFF',
            url: '/sso/google'
        };

        vm.facebookLogin = {
            icon: 'fa fa-facebook',
            color: '#337ab7',
            url: '/sso/facebook'
        };

        vm.linkedInLogin = {
            icon: 'fa fa-linkedin',
            color: '#337ab7',
            url: '/sso/linkedin'
        };

        vm.oidcLogin = {
            icon: 'fa fa-microsoft',
            color: '#FFFFFF',
            url: '/sso/oidc'
        };

        vm.oidcSignOn = {
            url: '/sso/genericOidc'
        };

        vm.isSelectLanguage = false;
        vm.supportedLanguages = [
            { name: 'english_us', displayName: 'English (US)', value: 'en_US', serverKey: 'en_US' },
            { name: 'english_uk', displayName: 'English (UK)', value: 'en_GB', serverKey: 'en_GB' },
            { name: 'french', displayName: 'French', value: 'fr_FR', serverKey: 'fr_FR' },
            { name: 'german', displayName: 'German', value: 'de_DE', serverKey: 'de_DE' },
            { name: 'greek', displayName: 'Greek', value: 'el_GR', serverKey: 'el_GR' },
            { name: 'italian', displayName: 'Italian', value: 'it_IT', serverKey: 'it_IT' },
            { name: 'japanese', displayName: 'Japanese', value: 'ja_JP', serverKey: 'ja_JP' },
            { name: 'portuguese', displayName: 'Portuguese', value: 'pt_BR', serverKey: 'pt_BR' },
            { name: 'spanish', displayName: 'Spanish', value: 'es_CL', serverKey: 'es_CL' },
            { name: 'chinese', displayName: 'Chinese (Traditional)', value: 'zh_TW', serverKey: 'zh_TW' },
            { name: 'chinese_cn', displayName: 'Chinese (Simplified)', value: 'zh_CN', serverKey: 'zh_CN' },
            { name: 'dutch', displayName: 'Dutch', value: 'nl_NL', serverKey: 'nl_NL' },
            { name: 'danish', displayName: 'Danish (Denmark)', value: 'da_DK', serverKey: 'da_DK' },
            { name: 'norwegian', displayName: 'Norwegian', value: 'no_NO', serverKey: 'no_NO' },
            { name: 'polish', displayName: 'Polish (Poland)', value: 'pl_PL', serverKey: 'pl_PL' },
            { name: 'russian', displayName: 'Russian', value: 'ru_RU', serverKey: 'ru_RU' },
            { name: 'swedish', displayName: 'Swedish (Sweden)', value: 'sv_SE', serverKey: 'sv_SE' },
            { name: 'turkish', displayName: 'Turkish (Turkey)', value: 'tr_TR', serverKey: 'tr_TR' }
        ];

        vm.supportedLanguages.sort(function (a, b) {
            if (a['displayName'] > b['displayName']) {
                return 1;
            } else if (a['displayName'] < b['displayName']) {
                return -1;
            }
            return 0;
        });

        LocalResourceService.get({ fileName: 'languages.json' }, function (res) {
            vm.languageCodes = res.languageCodes;
        });

        vm.selectLanguage = function () {
            vm.isSelectLanguage = !vm.isSelectLanguage;
        };

        vm.onLanguageChange = function (value) {
            localStorage.setItem('isUserSelectedLanguage', true)
            translationStorageProvider.put('NG_TRANSLATE_LANG_KEY', value);
            vm.isSelectLanguage = false;
            $window.location.reload();
        };

        vm.redirect = function (url) {
            var hostUrl = $window.location.protocol + '//' + $window.location.host + url;
            $window.location.href = hostUrl;
        };

        vm.chooseWorkspace = function () {
            var subDomain = $window.location.host.split('.')[0]
            var hostUrl = $location.absUrl();
            var path = $location.path();

            var appUrl = hostUrl.replace(subDomain, "app").replace(path, "");
            $window.location.href = appUrl;
        };

        vm.togglePasswordVisibility = function() {
            vm.passwordVisible = !vm.passwordVisible;
        };
        
        vm.selectWorkspace = function () {
            Auth.validateWorkspaceName(vm.workspace).then(function (res) {
                vm.isWorkspaceError = false;

                angular.forEach(vm.languageCodes, function (lang) {
                    if (lang.name == res.data.language_id) {
                        translationStorageProvider.put('NG_TRANSLATE_LANG_KEY', lang.value);
                    }
                });

                var subDomain = $window.location.host.split('.')[0]
                var hostUrl = $location.absUrl();
                var path = $location.path();

                var appUrl = hostUrl.replace("app", vm.workspace).replace(path, "");
                $window.location.href = appUrl;
            }).catch(function (err) {
                if (err && err.data && err.data.WorkspaceActiveState === "workspace is inactive") {
                    $state.go('account.noaccess')
                } else {
                    vm.isWorkspaceError = true;
                }
            });
        };

        vm.onWorkspaceChange = function () {
            if (vm.isWorkspaceError) {
                vm.isWorkspaceError = false;
            }
        }

        vm.onGoBack = function () {
            if (window && window.nodeAPI) {
                window.nodeAPI.ipc.send('back-to-workspace');
            }
        }

        $timeout(function () {
            angular.element('[ng-model="vm.username"]').focus();
        });

        function login(event) {

            var isWorkspaceAdmin = vm.username == 'admin';

            var credentials = {
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                widgetToken: false
            };

            Auth.login(credentials).then(function () {
                vm.authenticationError = false;

                User.getById({
                    id: Principal.getUserId()
                }, function (data) {
                    if (data && data.language_id) {
                        angular.forEach(vm.languageCodes, function (lang) {
                            if (lang.name == data.language_id) {
                                if (lang.name != 'system_default') {
                                    $rootScope.userSelectedLanguage = lang.value;
                                } else {
                                    var lang = ($window.navigator.language || $window.navigator.userLanguage).replace('-', '_');
                                    if (lang == 'el') {
                                        lang = 'el_GR';
                                    } else if (lang == 'ja') {
                                        lang = 'ja_JP';
                                    } else if (lang.startsWith('zh')) {
                                        lang = 'zh_TW';
                                    } else if (lang.startsWith('nl')) {
                                        lang = 'nl_NL';
                                    }
                                    $rootScope.userSelectedLanguage = lang;
                                }
                            }
                        });
                    }

                    // If we're redirected to login, our
                    // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
                    if ($rootScope.redirected && $rootScope.previousStateName) {
                        $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                        $rootScope.redirected = false;
                    } else {
                        $rootScope.$broadcast('authenticationSuccess');
                    }
                    if ($rootScope.isMasterWorkspace) {
                        $state.go('storm.system-admin.dashboard');
                    } else {
                        if (vm.featureForcedPassword) {
                            var userInfo = Principal.getUserInfo();
                            if (userInfo.forced_password_enabled) {
                                $state.go('account.forced-password');
                            } else {
                                $location.path("/");
                            }
                        } else {
                            $location.path("/");
                        }
                    }
                });

            }).catch(function (res, err) {
                vm.authenticationError = true;
                console.log('Studio-Login-error: ' + res.data.ExceptionType);
                var loginError = res.data.ExceptionType;
                var loginErrorMsg = '';
                if (loginError === 'UserNotActivatedException' || loginError === 'AccountExpiredException') {
                    loginErrorMsg = 'atheer.signIn.accountDisabled'
                } else if (loginError === 'Exception') {
                    if(res.data.AuthenticationException === 'User not found') {
                        loginErrorMsg = 'atheer.signIn.userDoesNotExist'
                    }
                    else {
                        loginErrorMsg = 'atheer.signIn.userAccountLocked'
                    }
                } else {
                    loginErrorMsg = 'atheer.signIn.usernameOrPasswordYouEnteredIsInvalid'
                }
                ToastService.displayToastWithAction($filter('translate')(loginErrorMsg),
                    $filter('translate')('entity.action.ok'), 'md-warn', 3000);
            });
        };

        function loadAll() {
            if(localStorage.getItem('Authorization')) {
                $location.path("/");
                return
            }
            sessionStorage.clear();
            vm.useDarkBackGroundLogos = triSettings.getSkinModel().use_dark_logos;
            vm.backgroundColor = {
                "background-color": triSettings.getSkinModel().primary_color_hex
            };
            if ($cookies.get('isGuest')) {
                $cookies.remove('isGuest');
            }
            //for setting language
            var host = $location.host();
            //for localhost
            // var workspace = host == 'localhost' ? 'demo' : host.split('.')[0];
            var workspace = host.split('.')[0];
            if (!$cookies.getObject('isRefreshed') && !localStorage.getItem('isUserSelectedLanguage')) {
                Auth.validateWorkspaceName(workspace).then(function (res) {
                    angular.forEach(vm.languageCodes, function (lang) {
                        if (lang.name == res.data.language_id) {
                            if (res.data.language_id != 'system_default' && lang.value != $cookies.getObject('NG_TRANSLATE_LANG_KEY')) {
                                translationStorageProvider.put('NG_TRANSLATE_LANG_KEY', lang.value);
                                $cookies.putObject('isRefreshed', true);
                                $window.location.reload();
                            }
                            if (res.data.language_id == 'system_default') {
                                var lang = ($window.navigator.language || $window.navigator.userLanguage).replace('-', '_');
                                if (lang == 'el') {
                                    lang = 'el_GR';
                                } else if (lang == 'ja') {
                                    lang = 'ja_JP';
                                } else if (lang.startsWith('zh')) {
                                    lang = 'zh_TW';
                                } else if (lang.startsWith('nl')) {
                                    lang = 'nl_NL';
                                }
                                if (lang != $cookies.getObject('NG_TRANSLATE_LANG_KEY')) {
                                    translationStorageProvider.put('NG_TRANSLATE_LANG_KEY', lang);
                                    $cookies.putObject('isRefreshed', true);
                                    $window.location.reload();
                                }
                            }
                        }
                    });
                });
            } else {
                $cookies.remove('isRefreshed');
            }
            $q.all([
                Setting.getUserSignupSettings().$promise,
                Setting.getAuthenticationSetupSettings().$promise
            ])
                .then(function (results) {
                    setUserSignupSettings(results[0]);
                    setLoginSettings(results[1]);
                    vm.isLoading = false;
                });
        };

        function setUserSignupSettings(signupSettings, ssoSettings) {
            angular.forEach(signupSettings, function (setting) {
                if (setting.category == 'user_signup') {
                    vm.userSignupSetting = setting;

                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'policy') {
                            vm.userSignupSetting.invitation_only = settingField.value === 'invitation_only';
                            vm.isSignupEnabled = vm.isSignUpFeatureActive && !vm.userSignupSetting.invitation_only;
                        }
                    });
                }
            });
        };

        function setLoginSettings(settings) {
            angular.forEach(settings, function (setting) {
                if (setting.category == 'authentication-setup') {
                    vm.loginSettings = setting;
                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'google_sso') {
                            vm.googleSSO = (settingField.value == 'true' ? true : false);
                            if (vm.googleSSO) {
                                vm.showSSOLogin = true;
                            }
                        } else if (settingField.name == 'facebook_sso') {
                            vm.facebookSSO = (settingField.value == 'true' ? true : false);
                            if (vm.facebookSSO) {
                                vm.showSSOLogin = true;
                            }
                        } else if (settingField.name == 'linkedin_sso') {
                            vm.linkedInSSO = (settingField.value == 'true' ? true : false);
                            if (vm.linkedInSSO) {
                                vm.showSSOLogin = true;
                            }
                        } else if (settingField.name == 'twitter_sso') {
                            vm.twitterSSO = (settingField.value == 'true' ? true : false);
                            if (vm.twitterSSO) {
                                vm.showSSOLogin = true;
                            }
                        } else if (settingField.name == 'saml_sso') {
                            vm.samlSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'azureAD_sso') {
                            vm.azureAdSSO = (settingField.value == 'true' ? true : false);
                            if (vm.azureAdSSO) {
                                vm.showSSOLogin = true;
                            }
                        } else if (settingField.name == 'forgot_password') {
                            vm.enableForgotPassword = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'atheer_login') {
                            vm.enableAtheerLogin = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'studio_oidc_sso') {
                            vm.studioOidcSSO = (settingField.value == 'true' ? true : false);
                        }
                    });
                }
            });
            if ($rootScope.isMasterWorkspace) {
                vm.enableForgotPassword = true;
            }
        };

        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileSessionsController', ProfileSessionsController);

    /* @ngInject */
    function ProfileSessionsController($scope, $state, $q, MetaData, Principal, User, JhiLanguageService, $translate, $mdToast, $filter, id, System) {
        var vm = this;

        vm.isAdminMode = id != 'me';
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.profileEvents = [];
        vm.profileMeta = null;
        vm.activeLink = 'user-about';

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise,
                MetaData.get({
                    id: 'user',
                    is_name: true
                }).$promise
            ]).then(function(data) {
                vm.user = data[0];
                angular.forEach(data[1].field_groups, function(field_group) {
                    if(field_group.name == 'profile' && !field_group.is_many) {
                        vm.profileMeta = field_group;
                    }
                    if (field_group.is_many) {
                        vm.profileEvents.push(field_group);
                    }
                });

                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileSessionsUpcomingController', ProfileSessionsUpcomingController);

    /* @ngInject */
    function ProfileSessionsUpcomingController($scope, $state, $q, $filter, Report, Principal, CONTENT_META, Pubnub, Session, ParseLinks, pagingParams, id, paginationConstants, AlertService, $mdDialog, $mdToast, $stateParams, Feature, Setting) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.uId = Principal.getUser().id;
        vm.pageSize = paginationConstants.itemsPerPage;

        vm.isHost = function(session) {
            if (session.owner == vm.uId) {
                return true;
            }
            for (var i = 0; i < session.session_users.length; i++) {
                if (session.session_users[i].user_id == vm.uId) {
                    if (session.session_users[i].role == "HOST") {
                        return true;
                    }
                }
            };
            return false;
        }

        vm.refresh = function() {
            loadData();
        };

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Session.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                user_id: id,
                scheduled: true
            }).$promise;

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ariaLabel($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Session.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadData();
            AlertService.displayToast($mdToast);
        };

        function getQueryString() {
            var query = 'type==' + 'SCHEDULED';
            return query;
        };

        function loadData() {
            vm.loadingData = true;
            Session.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                user_id: id,
                scheduled: true
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileSessionsPastController', ProfileSessionsPastController);

    /* @ngInject */
    function ProfileSessionsPastController($scope, $state, $q, $filter, $mdSidenav, $location, Report, Media, CONTENT_META, Pubnub, id, Session, ParseLinks, pagingParams, paginationConstants, AlertService, $mdDialog, $mdToast, $stateParams, Feature, Experience) {
        var vm = this;

        vm.loadingData = false;
        vm.sessionActivity = null;
        vm.sessionModel = null;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.panelToShow = null;

        vm.togglePanel = function(componentId, session) {
            vm.sessionModel = null;
            if (session) {
                vm.sessionModel = session;
            }
            if(componentId == 'insightsPanel') {
                vm.panelToShow = 'insightsPanel';
            } else if (componentId == 'annotationsPanel') {
                vm.panelToShow = 'annotationsPanel';
            } else if (componentId == 'recordingsPanel'){
                vm.panelToShow = 'recordingsPanel';
            } else if (componentId == 'conversationPanel') {
                vm.panelToShow = 'conversationPanel';
            }

            $mdSidenav(componentId).toggle()
                .then(function() {

                });
        };

        vm.refresh = function() {
            loadData();
        };

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Session.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                user_id: id,
                previous: true
            }).$promise;

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }
        };

        function loadData() {
            vm.loadingData = true;
            Session.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                user_id: id,
                previous: true
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileSecurityRolesController', ProfileSecurityRolesController);

    /* @ngInject */
    function ProfileSecurityRolesController($scope, $state, $mdDialog, Principal, $translate, pagingParams, paginationConstants, $mdToast, $filter, Experience, CONTENT_META, $mdMedia, id, PermissionService) {
        var vm = this;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.user = null;
        vm.loadingData = true;
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.securityRoles = [];
        vm.isSuperUser = PermissionService.hasAccess('is-super-user-user');
        vm.disableAddUpdate = !vm.isSuperUser && Principal.getUserId() == id;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.openAssignModal = function() {
            $mdDialog.show({
                templateUrl: 'modules/system/security-role/security-role-assign-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "SecurityRoleAssignController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    securityRole: undefined,
                    userId: vm.userId,
                    users: []
                }
            }).then(function() {
                vm.loadData();
            });
        }

        vm.removeUserSecurityRole = function(securityRole, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.securityRole.removeUserSecurityRole'))
                .ariaLabel($filter('translate')('atheer.securityRole.removeUserSecurityRole'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Experience.deleteSecurityRole({
                    id: securityRole.id
                }, function() {
                    vm.loadData();
                });
            });
        }

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getSecurityRoles({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, function(response, headers) {
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.securityRoles = response;
                vm.loadingData = false;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "user_id==" + vm.userId;
            if (vm.query.filter.length <= 0) {
                return queryString;
            }
        }

        vm.transition = function() {
            vm.promise = Experience.getSecurityRoles({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.securityRoles = response;
                vm.queryCount = vm.totalItems;
            });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfilePreferncesController', ProfilePreferncesController);

    /* @ngInject */
    function ProfilePreferncesController($scope, $state, $q, Auth, Principal, User, JhiLanguageService, $translate, $mdToast, $filter, id) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.user = null;

        vm.userId = id == 'me' ? Principal.getUserId() : id;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise
            ]).then(function(data) {
                vm.user = data[0];
                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});

            JhiLanguageService.getAll().then(function(languages) {
                vm.languages = languages;
            });
        }

        vm.settingsGroups = [{
            name: 'atheer.preferences.accountSettings',
            settings: [{
                title: 'atheer.preferences.showMyLocation',
                icon: 'zmdi zmdi-pin',
                enabled: true
            }, {
                title: 'atheer.preferences.showMyAvatar',
                icon: 'zmdi zmdi-face',
                enabled: false
            }, {
                title: 'atheer.preferences.sendMeNotifications',
                icon: 'zmdi zmdi-notifications-active',
                enabled: true
            }]
        }, {
            name: 'atheer.preferences.conversationSettings',
            settings: [{
                title: 'atheer.preferences.showMyUsername',
                icon: 'zmdi zmdi-account',
                enabled: true
            }, {
                title: 'atheer.preferences.makeMyProfilePublic',
                icon: 'zmdi zmdi-account-box',
                enabled: false
            }, {
                title: 'atheer.preferences.allowCloudBackups',
                icon: 'zmdi zmdi-cloud-upload',
                enabled: true
            }]
        }];

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ResetFinishController', ResetFinishController);

    /* @ngInject */
    function ResetFinishController($stateParams, $timeout, $filter, Auth, LoginService, triSettings, ToastService) {
        var vm = this;

        vm.triSettings = triSettings;
        vm.useDarkBackGroundLogos = true;
        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;
        vm.passwordVisible = false;
        vm.confirmPasswordVisible = false;

        vm.togglePasswordVisibility = function() {
            vm.passwordVisible = !vm.passwordVisible;
        };

        vm.toggleConfirmPasswordVisibility = function() {
            vm.confirmPasswordVisible = !vm.confirmPasswordVisible;
        };

        vm.loadData = function() {
            vm.useDarkBackGroundLogos = triSettings.getSkinModel().use_dark_logos;
        }

        function finishReset() {
            Auth.resetPasswordFinish({
                key: $stateParams.key,
                newPassword: vm.password
            }).then(function() {
                vm.success = 'OK';
            }).catch(function() {
                ToastService.displayToast($filter('translate')('atheer.reset.finish.messages.error'), 3000);
                vm.success = null;
            });
        }

        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfilePasswordController', ProfilePasswordController);

    /* @ngInject */
    function ProfilePasswordController($q, Principal, User, Feature, JhiLanguageService, triSettings, $filter, id, ToastService) {
        var vm = this;

        vm.changePassword = changePassword;

        vm.useDarkBackGroundLogos = true;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.user = null;
        vm.currentPassword = null;
        vm.isAdminMode = id != 'me';
        vm.minLength = 8;
        vm.maxLength = 50;
        vm.featureForcedPassword = Feature.isActive('feature_user_initial_login_forced_password_required');
        vm.forcedPasswordEnabled = false;
        vm.isPublicUser = false;
        vm.passwordVisibility = {
            newPassword: false,
            confirm: false
        };

        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.title = $filter('translate')('home.changePassword');

        vm.loadData = function () {
            vm.loadingData = true;
            vm.useDarkBackGroundLogos = triSettings.getSkinModel().use_dark_logos;

            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise
            ]).then(function (data) {
                vm.user = data[0];
                vm.loadingData = false;

            }).catch(function (data) { }).finally(function () { });

            JhiLanguageService.getAll().then(function (languages) {
                vm.languages = languages;
            });
        }

        function checkPasswordReq() {
            if (vm.password == null || vm.confirmPassword == null) {
                return false;
            }

            var pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,50}$/;
            if (!vm.password.match(pattern)) {
                ToastService.displayToast($filter('triTranslate')('atheer.password.messages.doesntMeetReq'), 2000);
                return false;
            }

            if (vm.password !== vm.confirmPassword) {
                ToastService.displayToast($filter('triTranslate')('atheer.password.messages.dontMatch'), 2000);
                return false;
            }

            if (vm.password.length < vm.minLength || vm.password.length > vm.maxLength) {
                return false;
            }
            return true;
        }

        function changePassword() {
            if (!checkPasswordReq()) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {

                if (vm.isAdminMode) {
                    changeUserPassword();
                } else {
                    changeMePassword();
                }
            }
        }

        function changeMePassword() {
            vm.doNotMatch = null;

            var passwordInfo = {
                current_password: vm.currentPassword,
                new_password: vm.password
            }

            var promise = User.changeMePassword(passwordInfo).$promise;

            promise.then(function () {
                vm.error = null;
                vm.success = 'OK';

                ToastService.displayToast($filter('triTranslate')('atheer.password.messages.success'), 2000)
                vm.currentPassword = null;
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';

                ToastService.displayToast($filter('triTranslate')('atheer.password.messages.incorrect'), 2000);
            });
        }
        vm.togglePasswordVisibility = function(field) {
            vm.passwordVisibility[field] = !vm.passwordVisibility[field];
        };
        function changeUserPassword() {
            vm.doNotMatch = null;

            var passwordInfo = {
                invitation_key: null,
                notify_user: false,
                password: vm.password,
                forced_password_enabled: vm.forcedPasswordEnabled
            };

            var promise = User.changeUserPassword({
                id: vm.userId
            }, passwordInfo).$promise;

            promise.then(function () {
                vm.error = null;
                vm.success = 'OK';

                ToastService.displayToast($filter('triTranslate')('atheer.password.messages.success'), 2000);
                vm.currentPassword = null;
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';

                ToastService.displayToast($filter('triTranslate')('atheer.password.messages.incorrect'), 2000);
            });
        }
        vm.loadData();
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ForgotController', ForgotController);

    /* @ngInject */
    function ForgotController($rootScope, $scope, $state, $mdToast, $filter, $http, triSettings, $timeout, Auth) {
        var vm = this;

        vm.useDarkBackGroundLogos = true;
        vm.triSettings = triSettings;
        vm.buildInfoSettings = $rootScope.buildInfo;

        vm.resetAccount = {
            username: ''
        };

        vm.resetClick = resetClick;
        vm.status = null;

        $timeout(function() {
            angular.element('[ng-model="resetAccount.email"]').focus();
        });

        vm.loadData = function() {
            vm.useDarkBackGroundLogos = triSettings.getSkinModel().use_dark_logos;
        }

        function resetClick() {
            vm.error = null;
            vm.errorEmailNotExists = null;
            Auth.resetPasswordInit(vm.resetAccount.username).then(function() {
                vm.status = 'OK';
            }).catch(function(response) {
                vm.status = 'FAIL';
            });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ForcedPasswordController', ForcedPasswordController);

    /* @ngInject */
    function ForcedPasswordController($scope, $state, $location, $q, Auth, Principal, User, Feature, triSettings, JhiLanguageService, $translate, $filter, ToastService) {
        var vm = this;

        vm.useDarkBackGroundLogos = true;
        vm.changePassword = changePassword;
        vm.cancelChange = cancelChange;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.user = null;
        vm.currentPassword = null;
        vm.minLength = 8;
        vm.maxLength = 12;
        vm.forcedPasswordEnabled = false;
        vm.password = null;
        vm.confirmPassword = null;

        vm.userId = Principal.getUserId();
        vm.passwordVisibility = {
            newPassword: false,
            confirm: false
        };

        vm.loadData = function() {
            vm.loadingData = true;
            vm.useDarkBackGroundLogos = triSettings.getSkinModel().use_dark_logos;

            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise
            ]).then(function(data) {
                vm.user = data[0];
                vm.forcedPasswordEnabled = vm.user.forced_password_enabled;
                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});

            JhiLanguageService.getAll().then(function(languages) {
                vm.languages = languages;
            });
        }

        function cancelChange() {
            $location.path('/signin');
        }

        function checkPasswordReq() {
            if (vm.password == null || vm.confirmPassword == null) {
                return false;
            }
            if (vm.password !== vm.confirmPassword) {
                ToastService.displayToast($filter('triTranslate')('atheer.forcedPassword.passwordsDontMatch'), 2000);
                return false;
            }

            if (vm.password.length < vm.minLength || vm.password.length > vm.maxLength) {
                return false;
            }

            var pattern=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,12}$/;
            if (!vm.password.match(pattern)) {
                ToastService.displayToast($filter('triTranslate')('atheer.forcedPassword.passwordDoesntMeetRequirement'), 2000);
                return false;
            }

            return true;
        }

        vm.togglePasswordVisibility = function(field) {
            vm.passwordVisibility[field] = !vm.passwordVisibility[field];
        };

        function changePassword() {
            if (!checkPasswordReq()) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                changeMyPassword();
            }
        }

        function changeMyPassword() {
            vm.doNotMatch = null;

            var passwordInfo = {
                invitation_key: null,
                notify_user: false,
                new_password: vm.password,
                forced_password_enabled: false
            };

            var promise = User.forceMePassword({
            }, passwordInfo).$promise;

            promise.then(function() {
                vm.error = null;
                vm.success = 'OK';

                ToastService.displayToast($filter('triTranslate')('atheer.forcedPassword.passwordChangedSuccessfully'), 2000);
                vm.currentPassword = null;
                $location.path("/");
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';

                ToastService.displayToast($filter('triTranslate')('atheer.forcedPassword.incorrectPassword'), 2000);
            });
        }
        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('QrCodeDialogController', QrCodeDialogController);

    /* @ngInject */
    function QrCodeDialogController($rootScope, $q, $scope, $state, $timeout, $mdDialog, filter, Principal, $translate, $mdToast, $filter, User, $mdMedia, $window, $http) {
        var vm = this;

        var expireTime = 5 * 60 * 1000;

        vm.startTime = new Date().getTime() + (expireTime);
        vm.codeExpired = false;
        vm.isQRLoading = true;
        vm.userId = filter == null ? 'me' : filter;
        vm.qrCodeImage;

        function getQRCode() {
            vm.isQRLoading = true;
            var url = '/api/users/' + vm.userId + '/qrcode'
            $http.get(url, { responseType: 'blob' }).then(function (response) {
                vm.qrCodeImage = URL.createObjectURL(response.data);
                vm.isQRLoading = false;
                startTimer();
            })
        }

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.refreshQRCode = function () {
            vm.startTime = new Date().getTime() + (expireTime);
            vm.codeExpired = false;
            getQRCode();
        };

        function startTimer() {
            $timeout(function () {
                vm.codeExpired = true;
            }, expireTime);
        };

        getQRCode();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileOverviewController', ProfileOverviewController);

    /* @ngInject */
    function ProfileOverviewController($q, $scope, $timeout, $filter, $mdDialog, id, User, Experience, Report, System, $stateParams, ToastService) {
        var vm = this;

        vm.user = null;
        vm.userTimezone = null;
        vm.experienceSummary = null;
        vm.isAdminView = id != 'me';
        vm.userOverviewSummary = {
            job_summary: {
                assigned: 0,
                in_progress: 0,
                completed: 0,
                avg_duration: 0
            },
            session_summary: {
                scheduled: 0,
                attended: 0,
                avg_duration: 0,
                total_minutes: 0
            },
            content_summary: {
                shared: 0,
                bookmarked: 0,
                created: 0,
                viewed: 0
            },
            conversation_summary: {
                conversations: 0,
                oneToOne: 0,
                group: 0,
                messages: 0
            }
        };
        vm.start = moment().subtract(30, 'days');
        vm.end = moment();

        vm.getUserProfileImageUrl = function() {
            return vm.loadingData ? 'assets/images/avatars/user-avatar.png' : vm.user.picture_id ? '/media/pictures/' + vm.user.picture_id : 'assets/images/avatars/user-avatar.png';
        }

        vm.updateUserProfileImage = function(mediaId, responseObj) {
            vm.user.picture_id = mediaId;
            updateUser('atheer.overview.updatedSuccessfully');
        };

        vm.removeUserProfileImage = function() {
            vm.user.picture_id = undefined;
            updateUser('atheer.overview.updatedSuccessfully');
        };

        vm.getActivityCount = function(activityName) {
            var activitySummary = vm.experienceSummary.activity_summary;
            for (var i = 0; i < activitySummary.length; i++) {
                if (activitySummary[i].name === activityName) {
                    return activitySummary[i].count;
                }
            }
            return 0;
        };

        vm.linkDevice = function(user) {
            $mdDialog.show({
                templateUrl: 'modules/user/overview/qrcode-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "QrCodeDialogController",
                controllerAs: "vm",
                locals: {
                    filter: user.id
                }
            }).then(function(conversation) {}).finally(function() {});
        };

        function updateUser(message) {
            if (!vm.isAdminView) {
                User.updateme(vm.user, function(result) {
                    vm.user = result;

                    //this is to update the picture in toolbar
                    $rootScope.$broadcast('updateUserInfo', vm.user);
                    Principal.identity(true).then(function(user) {});

                    ToastService.displayToast($filter('triTranslate')(message), 3000);
                });
            }
            else {
                User.update(vm.user, function(result) {
                    vm.user = result;
                    ToastService.displayToast($filter('triTranslate')(message), 3000);
                });
            }
        };

        function createUserOverviewSummary(userOverviewSummary) {
            var jobSummary = userOverviewSummary.job_summary;
            var sessionSummary = userOverviewSummary.session_summary;
            var contentSummary = userOverviewSummary.content_summary;
            var conversationSummary = userOverviewSummary.conversation_summary;

            if (jobSummary && jobSummary.length > 0) {
                jobSummary.forEach(function(res) {
                    if (res.name == 'assigned') {
                        vm.userOverviewSummary.job_summary.assigned = res.count;
                    } else if (res.name == 'in_progress') {
                        vm.userOverviewSummary.job_summary.in_progress = res.count;
                    } else if (res.name == 'completed') {
                        vm.userOverviewSummary.job_summary.completed = res.count;
                    } else if (res.name == 'avg_duration') {
                        vm.userOverviewSummary.job_summary.avg_duration = res.count;
                    }
                });
            }

            if (sessionSummary && sessionSummary.length > 0) {
                sessionSummary.forEach(function(res) {
                    if (res.name == 'scheduled') {
                        vm.userOverviewSummary.session_summary.scheduled = res.count;
                    } else if (res.name == 'attended') {
                        vm.userOverviewSummary.session_summary.attended = res.count;
                    } else if (res.name == 'avg_duration') {
                        vm.userOverviewSummary.session_summary.avg_duration = res.count;
                    } else if (res.name == 'total_minutes') {
                        vm.userOverviewSummary.session_summary.total_minutes = res.count;
                    }
                });
            }

            if (contentSummary && contentSummary.length > 0) {
                contentSummary.forEach(function(res) {
                    if (res.name == 'shared') {
                        vm.userOverviewSummary.content_summary.shared = res.count;
                    } else if (res.name == 'bookmarked') {
                        vm.userOverviewSummary.content_summary.bookmarked = res.count;
                    } else if (res.name == 'created') {
                        vm.userOverviewSummary.content_summary.created = res.count;
                    } else if (res.name == 'viewed') {
                        vm.userOverviewSummary.content_summary.viewed = res.count;
                    }
                });
            }

            if (conversationSummary && conversationSummary.length > 0) {
                conversationSummary.forEach(function(res) {
                    if (res.name == 'conversations') {
                        vm.userOverviewSummary.conversation_summary.conversations = res.count;
                    } else if (res.name == '1-1') {
                        vm.userOverviewSummary.conversation_summary.oneToOne = res.count;
                    } else if (res.name == 'group') {
                        vm.userOverviewSummary.conversation_summary.group = res.count;
                    } else if (res.name == 'messages') {
                        vm.userOverviewSummary.conversation_summary.messages = res.count;
                    }
                });
            }
            vm.loadingData = false;

            if ($stateParams.launchQrCode) {
                $timeout(function() {
                    vm.linkDevice(vm.user);
                }, 1000);    
            }
        };

        function loadData() {
            vm.loadingData = true;

            $q.all([
                User.getById({
                    id: id
                }).$promise,
                Report.getUserOverviewSummary({
                    id: id
                }).$promise,
                System.getTimezones({
                    size: 100
                }).$promise
            ]).then(function(data) {
                vm.user = data[0];
                createUserOverviewSummary(data[1])
                vm.timezones = data[2];

                vm.userTimezone = vm.timezones.find(function(timezone) {
                    return timezone.timezone_no == vm.user.timezone_id;
                });

            }).catch(function(data) {}).finally(function() {});
        };
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, triMenuProvider) {
        $stateProvider
            .state('storm.noaccess', {
                url: '/noaccess',
                templateUrl: 'modules/user/noaccess/noaccess.tmpl.html',
                controller: 'NoAccessContoller',
                controllerAs: 'vm',
                data: {
                    layout: {
                        footer: false,
                        showToolbar: false,
                        contentClass: 'layout-column'
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('NoAccessContoller', NoAccessContoller);

    /* @ngInject */
    function NoAccessContoller($rootScope, $mdDialog, $state, $q, $scope, $sce, triLoaderService, Principal, AlertService, $mdToast, Feature, Experience, $stateParams, $location, Auth, User) {
        var vm = this;
        vm.buildInfoSettings = $rootScope.buildInfo;

        vm.isWorkspaceInactive = $stateParams.isWorkspaceInactive;

        vm.isApiProcessing = true;

        vm.doesWorkspaceExist = true;

        // for localhost
        var workspace = $location.host() == 'localhost' ? 'demo' : $location.host().split('.')[0];
        Auth.validateWorkspaceName(workspace).then(function (res) {
            User.getFullUser({
                id: 'me'
            }).$promise.then(function(user) {
                if(user.workspace_info.domain === workspace || workspace === 'demo') {
                    $state.go('storm.home');
                }
            }).catch(function (error) {
                // If user not signed in redirect to signin page
                if(error.status === 401) {
                    $state.go('account.signin');
                }
                console.error(error);
            }).finally(function () {
                vm.isApiProcessing = false;
            });
        }).catch(function (error) {
            if(error.status === 400) {
                vm.doesWorkspaceExist = false;
            }
            vm.isApiProcessing = false;
            console.error(error)
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserMetaDataController', UserMetaDataController)

    /* @ngInject */
    function UserMetaDataController($state, $scope, $window, $mdSidenav, MetaData, AlertService, $mdDialog, $filter, id, ToastService) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.updateObject = false;
        vm.metaDataObject;
        vm.selectedFieldGroup;

        vm.loadAll();

        function loadAll() {
            MetaData.get({
                id: id,
                is_name: true,
                add_default_properties: true
            }, function(result) {
                vm.metaDataObject = result;
                vm.updateObject = false;
                if (vm.metaDataObject.field_groups && vm.metaDataObject.field_groups.length > 0) {
                    vm.selectedFieldGroup = vm.metaDataObject.field_groups[0];
                }
            });
        }

        vm.selectFieldGroup = function(fieldGroup, index) {
            vm.updateObject = false;
            vm.selectedFieldGroup = fieldGroup;
        }

        vm.addFieldGroup = function(fieldGroup) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: {
                        name: null,
                        label: null,
                        description: null,
                        is_many: true,
                        fields: null,
                    },
                    isAdd: true
                }
            }).then(function(fieldGroup) {
                if (!vm.metaDataObject.field_groups) {
                    vm.metaDataObject.field_groups = [];
                }
                vm.metaDataObject.field_groups.push(fieldGroup);
                vm.updateObject = false;
                vm.selectedFieldGroup = fieldGroup;
                updateMetaData('atheer.userFields.fieldGroupAdded');
            });
        }

        vm.editFieldGroup = function(fieldGroup, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: angular.copy(fieldGroup),
                    isAdd: false
                }
            }).then(function(fieldGroup) {
                vm.metaDataObject.field_groups[index] = fieldGroup;
                updateMetaData('atheer.userFields.fieldGroupUpdated');
            });
        }

        vm.deleteFieldGroup = function(fieldGroup, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.userFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.userFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                vm.metaDataObject.field_groups.splice(index, 1);
                updateMetaData('atheer.userFields.fieldGroupDeleted');
                vm.selectedFieldGroup = vm.metaDataObject.field_groups[index == 0 ? 0 : index - 1];
            });
        }

        vm.addField = function() {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: {
                        name: null,
                        description: null,
                        label: null,
                        data_type: 'STRING',
                        type: 'FLEX',
                        required: false,
                        enabled: true,
                        search_enabled: true
                    },
                    isAdd: true
                }
            }).then(function(field) {
                vm.updateObject = false;
                if (!vm.selectedFieldGroup.fields) {
                    vm.selectedFieldGroup.fields = [];
                };
                vm.selectedFieldGroup.fields.push(field);
                updateMetaData('atheer.userFields.fieldAdded');
            });
        }

        vm.editField = function(field, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: angular.copy(field),
                    isAdd: false
                }
            }).then(function(field) {
                vm.updateObject = false;
                vm.selectedFieldGroup.fields[index] = field;
                updateMetaData('atheer.userFields.fieldUpdated');
            });
        }

        vm.copyField = function(field, index) {
            var newField = angular.copy(field);
            newField.name = "Copy of " + newField.name;
            vm.updateObject = false;
            vm.selectedFieldGroup.fields.push(newField);
            updateMetaData('atheer.userFields.fieldCopied');
        }

        vm.deleteField = function(field, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.userFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.userFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                vm.updateObject = false;
                vm.selectedFieldGroup.fields.splice(index, 1);
                updateMetaData('atheer.userFields.fieldDeleted');
            });
        }

        vm.back = function() {
            $window.history.back();
        };

        function updateMetaData(successMessage) {
            MetaData.update({
                id: id
            }, vm.metaDataObject, onSaveSuccess);

            function onSaveSuccess(result) {
                vm.metaDataObject = result;
                ToastService.displayToast($filter('triTranslate')(successMessage), 3000);
                var fGroup = vm.metaDataObject.field_groups.filter(function(item) {
                    return item.name === vm.selectedFieldGroup.name;
                  })[0];
                vm.selectedFieldGroup = fGroup;
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('MyUploadDialogController', MyUploadDialogController);

    /* @ngInject */
    function MyUploadDialogController($scope, $mdToast, $mdDialog, $state, $timeout, Content, CONTENT_META, $filter, AlertService, poller, Principal) {
        var vm = this;

        vm.contentType = null;
        vm.processStatus = 'IDLE';

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.createContent = function(mediaId, responseObj) {
            if (responseObj.type.toLowerCase() == 'document') {
                vm.contentType = 'document';
            } else if (responseObj.type.toLowerCase() == 'video') {
                vm.contentType = 'video';
            } else if (responseObj.type.toLowerCase() == 'audio') {
                vm.contentType = 'podcast';
            };

            vm.processStatus = 'UPLOADED';

            vm.contentMetaData = angular.copy($filter('filter')(CONTENT_META, {
                type: vm.contentType
            })[0]);

            vm.contentModel = vm.contentMetaData.default_model;
            vm.contentModel.title = responseObj.name;
            vm.contentModel.data.source_media = responseObj;
            vm.contentModel.user_uploaded = true;


            if (vm.contentType == 'document') {
                vm.contentModel.data.doc_status = 'UPLOADED';
            } else if (vm.contentType == 'video') {
                vm.contentModel.data.video_status = 'UPLOADED';
            } else if (vm.contentType == 'podcast') {
                vm.contentModel.data.podcast_status = 'UPLOADED';
            };
            vm.save();
        }

        vm.save = function() {
            if (vm.contentModel.id) {
                Content.update(vm.contentModel, vm.onSaveSuccess, vm.onSaveError);
            } else {
                Content.save(vm.contentModel, vm.onSaveSuccess, vm.onSaveError);
            }
        };

        vm.onSaveSuccess = function(result) {
            vm.contentModel = result;

            if (vm.contentType == 'document') {
                vm.checkDocumentStatus();
            } else if (vm.contentType == 'video') {
                vm.checkVideoStatus();
            } else if (vm.contentType == 'podcast') {
                vm.checkAudioStatus();
            };
        };

        vm.onSaveError = function() {
            $scope.vm.isSaving = false;
        };

        vm.checkDocumentStatus = function() {
            if ((vm.contentModel.data.doc_status == 'UPLOADED' || vm.contentModel.data.doc_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.doc_status;

                // Get poller.
                var contentStatusPoller = poller.get(Content, {
                    action: 'get',
                    delay: 3000,
                    argumentsArray: [{
                        id: vm.contentModel.id
                    }],
                    smart: true
                });

                contentStatusPoller.promise.then(null, null, function(result) {
                    if (result.data.doc_status == 'READY') {
                        poller.stopAll();
                        vm.processStatus = 'COMPLETE';
                        vm.contentModel = result;
                        vm.completeProcess();
                    }
                    if (result.data.doc_status == 'FAILED') {
                        poller.stopAll();
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.doc_status;
                vm.completeProcess();
            }
        };

        vm.checkVideoStatus = function() {
            if ((vm.contentModel.data.video_status == 'UPLOADED' || vm.contentModel.data.video_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.video_status;

                // Get poller.
                var contentStatusPoller = poller.get(Content, {
                    action: 'get',
                    delay: 3000,
                    argumentsArray: [{
                        id: vm.contentModel.id
                    }],
                    smart: true
                });

                contentStatusPoller.promise.then(null, null, function(result) {
                    if (result.data.video_status == 'READY') {
                        poller.stopAll();
                        vm.processStatus = 'COMPLETE';
                        vm.contentModel = result;
                        vm.completeProcess();
                    }
                    if (result.data.video_status == 'FAILED') {
                        poller.stopAll();
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.video_status;
                vm.completeProcess();
            }
        };

        vm.checkAudioStatus = function() {
            if ((vm.contentModel.data.podcast_status == 'UPLOADED' || vm.contentModel.data.podcast_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.podcast_status;

                // Get poller.
                var contentStatusPoller = poller.get(Content, {
                    action: 'get',
                    delay: 3000,
                    argumentsArray: [{
                        id: vm.contentModel.id
                    }],
                    smart: true
                });

                contentStatusPoller.promise.then(null, null, function(result) {
                    if (result.data.podcast_status == 'READY') {
                        poller.stopAll();
                        vm.processStatus = 'COMPLETE';
                        vm.contentModel = result;
                        vm.completeProcess();
                    }
                    if (result.data.podcast_status == 'FAILED') {
                        poller.stopAll();
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.podcast_status;
                vm.completeProcess();
            }
        };

        vm.completeProcess = function() {
            AlertService.displayToast($mdToast);
            $mdDialog.hide();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileLibraryController', ProfileLibraryController);

    /* @ngInject */
    function ProfileLibraryController($scope, $state, $q, MetaData, Principal, User, JhiLanguageService, $translate, $mdToast, $filter, id, System) {
        var vm = this;

        vm.isAdminMode = id != 'me';
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.profileEvents = [];
        vm.profileMeta = null;
        vm.activeLink = 'user-about';

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise,
                MetaData.get({
                    id: 'user',
                    is_name: true
                }).$promise
            ]).then(function(data) {
                vm.user = data[0];
                angular.forEach(data[1].field_groups, function(field_group) {
                    if(field_group.name == 'profile' && !field_group.is_many) {
                        vm.profileMeta = field_group;
                    }
                    if (field_group.is_many) {
                        vm.profileEvents.push(field_group);
                    }
                });

                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileLibraryUploadsController', ProfileLibraryUploadsController);

    /* @ngInject */
    function ProfileLibraryUploadsController($rootScope, $scope, $mdMedia, $state, $q,  $filter, $mdDialog, Content, triLoaderService, Feature, AlertService, pagingParams, paginationConstants, ParseLinks, Principal, CONTENT_META, ContentAction, id, User, Experience, Report, $window, $mdToast, ToastService) {
        var vm = this;
        vm.loadingData = false;
        vm.contents = [];
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.cardView = false;
        vm.listType = 'all';
        vm.listTypeLabel = 'All';
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.profileViewMode = (id == 'me' ? 'me' : 'admin');
        vm.isAdminMode = id != 'me';
        vm.userInfo = null;

        vm.query = {
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: pagingParams.page - 1
        };

        vm.getBackgroundImage = function(imagepath) {
            return {
                'background-image': 'url(/media/images/' + imagepath + ')'
            }
        }

        function loadData() {
            vm.loadingData = true;

            Content.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, function(data, headers) {
                vm.contents = data;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.loadingData = false;
                vm.queryCount = vm.totalItems;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadUserData() {
            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise
            ]).then(function(data) {
                vm.userInfo = data[0];
                loadData();
            });
        }

        vm.transition = function() {
            vm.promise = Content.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.contents = response;
            });
        }

        vm.showList = function(listType) {
            loadData(listType);
        }

        vm.editBoard = function() {
            $mdDialog.show({
                    templateUrl: 'modules/user/board/board-detail-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "BoardDetailDialogController",
                    controllerAs: "vm",
                    locals: {
                        board: vm.boardDetail,
                        isAdd: false
                    }
                })
                .then(function(board) {
                    vm.boardDetail = board;
                });
        }

        vm.deleteBoard = function() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.upload.deleteBoard'))
                .ariaLabel($filter('translate')('atheer.upload.deleteBoard'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Board.delete({
                    id: vm.boardDetail.id
                }, function() {
                    AlertService.displayToast($mdToast);
                });
            });
        };

        vm.deleteContent = function(content) {
            Board.removeContent({
                id: vm.boardDetail.id,
                contentId: content.id
            }, function(result) {
                ToastService.displayToast($filter('triTranslate')('atheer.upload.deleteContent'), 3000);
                loadData('all');
            });
        };

        function getQueryString() {
            return 'user_uploaded=ex=true;user_uploaded==true;created_by==' + vm.userInfo.login;
        };

        vm.openMyUploadDialog = function(ev) {
            ContentAction.openMyUploadDialog(ev, loadData());
        };

        vm.back = function() {
            $window.history.back();
        };

        loadUserData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileLibrarySharedController', ProfileLibrarySharedController);

    /* @ngInject */
    function ProfileLibrarySharedController($rootScope, $scope, $state, $mdDialog, Principal, $translate, pagingParams, paginationConstants, $mdToast, $filter, Experience, CONTENT_META, $mdMedia, ContentAction, $window, id) {
        var vm = this;

        vm.error = null;
        vm.success = null;
        vm.user = null;
        vm.viewType = 'card';
        vm.loadingData = true;
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.contents = [];

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.getMediaUrl = function(mediaUrl){
            return $filter('mediaUrl')(mediaUrl);
        };

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        };

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        };

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        };

        vm.openPlayer = function(feed, isSkill) {
            ContentAction.launchContent(feed);
        };

        vm.openRecommendationModal = function(feed){
            ContentAction.openRecommendDialog(feed);
        };

        vm.openFeedbackDialog = function(reactionType, feed) {
            if (reactionType == "FLAG") {
                ContentAction.openFlagDialog(content);
            }
            else if (reactionType == "PROBLEM"){
                ContentAction.openProblemDialog(content);
            }
        };

        vm.setOtherRelativeData = function(content){
            vm.currentContentPinnedData = undefined;
            vm.currentContentLikeData = undefined;
            vm.currentContent = content;

            ContentAction.getPinnedData(content).then(function(value){
                vm.currentContentPinnedData = value;
            });

            ContentAction.getLikeData(content).then(function(value){
                vm.currentContentLikeData = value;
            });
        };

        vm.isPinned = function(content) {
            return content == vm.currentContent && vm.currentContentPinnedData ? true : false;
        };

        vm.isLiked = function(content) {
            return content == vm.currentContent && vm.currentContentLikeData ? true : false;
        };

        vm.likeOrUnlikeContent = function(content){
            if(content == vm.currentContent)
            {
                ContentAction.likeOrUnlikeContent(content, vm.currentContentLikeData).then(function(value){
                    vm.currentContentLikeData = value;
                })
            }
        };

        vm.pinOrUnpinContent = function(content){
            if(content == vm.currentContent)
            {
                ContentAction.pinOrUnpinContent(content, vm.currentContentPinnedData).then(function(value){
                    vm.currentContentPinnedData = value;
                })
            }
        };

        vm.changeFilter = function(filter) {
            vm.statusFilter = filter;
            vm.loadData();
        };

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getShares({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, function(response, headers) {
                vm.shares = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                prepareContents();
                vm.loadingData = false;
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        };

        function getQueryString() {
            var queryString = 'user_id==' + vm.userId;
            return queryString;
        };

        function prepareContents() {
            vm.contents = [];

            angular.forEach(vm.shares, function(shared) {
                vm.contents.push(shared.object);
            })
        }

        vm.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        vm.launchContent = function(contentFeed) {
            ContentAction.launchContent(contentFeed);
        };

        vm.transition = function() {
            vm.promise = Experience.getShares({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.shares = response;
                vm.queryCount = vm.totalItems;
                prepareContents();
            });
        };

        vm.setDirection = function(direction) {
            vm.direction = direction;
        };

        $scope.$on('$destroy', function() {
            $rootScope.$$listeners['content-player-closed'] = [];
        });

        $rootScope.$on('content-player-closed', function() {
            vm.loadData();
        });

        vm.back = function() {
            $window.history.back();
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileLibraryLikedController', ProfileLibraryLikedController);

    /* @ngInject */
    function ProfileLibraryLikedController($rootScope, $scope, $state, $mdDialog, Principal, $translate, pagingParams, paginationConstants, $mdToast, $filter, Experience, CONTENT_META, $mdMedia, ContentAction, $window, id) {
        var vm = this;

        vm.error = null;
        vm.success = null;
        vm.user = null;
        vm.viewType = 'card';
        vm.loadingData = true;
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.contents = [];

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.getMediaUrl = function(mediaUrl){
            return $filter('mediaUrl')(mediaUrl);
        };

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        };

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        };

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        };

        vm.openPlayer = function(feed, isSkill) {
            ContentAction.launchContent(feed);
        };

        vm.openRecommendationModal = function(feed){
            ContentAction.openRecommendDialog(feed);
        };

        vm.openFeedbackDialog = function(reactionType, feed) {
            if (reactionType == "FLAG") {
                ContentAction.openFlagDialog(content);
            }
            else if (reactionType == "PROBLEM"){
                ContentAction.openProblemDialog(content);
            }
        };

        vm.setOtherRelativeData = function(content){
            vm.currentContentPinnedData = undefined;
            vm.currentContentLikeData = undefined;
            vm.currentContent = content;

            ContentAction.getPinnedData(content).then(function(value){
                vm.currentContentPinnedData = value;
            });

            ContentAction.getLikeData(content).then(function(value){
                vm.currentContentLikeData = value;
            });
        };

        vm.isPinned = function(content) {
            return content == vm.currentContent && vm.currentContentPinnedData ? true : false;
        };

        vm.isLiked = function(content) {
            return content == vm.currentContent && vm.currentContentLikeData ? true : false;
        };

        vm.likeOrUnlikeContent = function(content){
            if(content == vm.currentContent)
            {
                ContentAction.likeOrUnlikeContent(content, vm.currentContentLikeData).then(function(value){
                    vm.currentContentLikeData = value;
                })
            }
        };

        vm.pinOrUnpinContent = function(content){
            if(content == vm.currentContent)
            {
                ContentAction.pinOrUnpinContent(content, vm.currentContentPinnedData).then(function(value){
                    vm.currentContentPinnedData = value;
                })
            }
        };

        vm.changeFilter = function(filter) {
            vm.statusFilter = filter;
            vm.loadData();
        };

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getLikes({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, function(response, headers) {
                vm.likes = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                prepareContents();
                vm.loadingData = false;
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        };

        function getQueryString() {
            var queryString = 'user_id==' + vm.userId;
            return queryString;
        };

        function prepareContents() {
            vm.contents = [];
            angular.forEach(vm.likes, function(like) {
                vm.contents.push(like.object);
            })
        }

        vm.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        vm.launchContent = function(contentFeed) {
            ContentAction.launchContent(contentFeed);
        };

        vm.transition = function() {
            vm.promise = Experience.getLikes({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.likes = response;
                vm.queryCount = vm.totalItems;
                prepareContents();
            });
        };

        vm.setDirection = function(direction) {
            vm.direction = direction;
        };

        $scope.$on('$destroy', function() {
            $rootScope.$$listeners['content-player-closed'] = [];
        });

        $rootScope.$on('content-player-closed', function() {
            vm.loadData();
        });

        vm.back = function() {
            $window.history.back();
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileLibraryBookmarksController', ProfileLibraryBookmarksController);

    /* @ngInject */
    function ProfileLibraryBookmarksController($rootScope, $scope, $state, $mdDialog, Principal, $translate, pagingParams, paginationConstants, $mdToast, $filter, Experience, CONTENT_META, $mdMedia, ContentAction, $window, id) {
        var vm = this;

        vm.error = null;
        vm.success = null;
        vm.user = null;
        vm.viewType = 'card';
        vm.loadingData = true;
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.contents = [];

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.getMediaUrl = function(mediaUrl){
            return $filter('mediaUrl')(mediaUrl);
        };

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        };

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        };

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        };

        vm.openPlayer = function(feed, isSkill) {
            ContentAction.launchContent(feed);
        };

        vm.openRecommendationModal = function(feed){
            ContentAction.openRecommendDialog(feed);
        };

        vm.openFeedbackDialog = function(reactionType, feed) {
            if (reactionType == "FLAG") {
                ContentAction.openFlagDialog(content);
            }
            else if (reactionType == "PROBLEM"){
                ContentAction.openProblemDialog(content);
            }
        };

        vm.setOtherRelativeData = function(content){
            vm.currentContentPinnedData = undefined;
            vm.currentContentLikeData = undefined;
            vm.currentContent = content;

            ContentAction.getPinnedData(content).then(function(value){
                vm.currentContentPinnedData = value;
            });

            ContentAction.getLikeData(content).then(function(value){
                vm.currentContentLikeData = value;
            });
        };

        vm.isPinned = function(content) {
            return content == vm.currentContent && vm.currentContentPinnedData ? true : false;
        };

        vm.isLiked = function(content) {
            return content == vm.currentContent && vm.currentContentLikeData ? true : false;
        };

        vm.likeOrUnlikeContent = function(content){
            if(content == vm.currentContent)
            {
                ContentAction.likeOrUnlikeContent(content, vm.currentContentLikeData).then(function(value){
                    vm.currentContentLikeData = value;
                })
            }
        };

        vm.pinOrUnpinContent = function(content){
            if(content == vm.currentContent)
            {
                ContentAction.pinOrUnpinContent(content, vm.currentContentPinnedData).then(function(value){
                    vm.currentContentPinnedData = value;
                })
            }
        };

        vm.changeFilter = function(filter) {
            vm.statusFilter = filter;
            vm.loadData();
        };

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getBookmarks({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, function(response, headers) {
                vm.bookmarks = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                prepareContents();
                vm.loadingData = false;
            });
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        };

        function getQueryString() {
            var queryString = 'user_id==' + vm.userId;
            return queryString;
        };

        function prepareContents() {
            vm.contents = [];
            angular.forEach(vm.bookmarks, function(bookmark) {
                vm.contents.push(bookmark.object);
            })
        }

        vm.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        vm.launchContent = function(contentFeed) {
            ContentAction.launchContent(contentFeed);
        };

        vm.transition = function() {
            vm.promise = Experience.getBookmarks({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.bookmarks = response;
                vm.queryCount = vm.totalItems;
                prepareContents();
            });
        };

        vm.setDirection = function(direction) {
            vm.direction = direction;
        };

        $scope.$on('$destroy', function() {
            $rootScope.$$listeners['content-player-closed'] = [];
        });

        $rootScope.$on('content-player-closed', function() {
            vm.loadData();
        });

        vm.back = function() {
            $window.history.back();
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en_US',
            'en_GB',
            'fr_FR',
            'de_DE',
            'el_GR',
            'it_IT',
            'ja_JP',
            'pt_BR',
            'es_CL',
            'zh_CN',
            'zh_TW',
            'nl_NL',
            'da_DK',
            'no_NO',
            'pl_PL',
            'ru_RU',
            'sv_SE',
            'tr_TR'
            // atheer-needle-i18n-language-constant - Atheer will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('storm.admin-user-invitation', {
            url: '/users/invitations?page&sort&search',
            templateUrl: 'modules/user/invitation/user-invitations.html',
            controller: 'UserInvitationController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.userInvitation.home.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false,
                    showToolbar: false
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.invitation', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserInvitationController', UserInvitationController);

    /* @ngInject */
    function UserInvitationController($scope, $state, $q, $filter, $window, Setting, UserInvitation, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, ToastService, $stateParams) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.pendingInvitations = null;
        vm.acceptedInvitations = null;
        vm.signupUrl = null;
        vm.invitationOnly = null;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.selectedInvitation = null;

        vm.loadAll = function() {
            loadPending();
            loadAccepted();

            $q.all([
                    Setting.getCompanySettings().$promise,
                    Setting.getUserSignupSettings().$promise
                ])
                .then(function(results) {
                    setSignupUrl(results[0]);
                    setSignupEnabled(results[1]);
                });
        }

        function setSignupUrl(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'company_info') {
                    vm.companySetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'atheer_url') {
                            vm.signupUrl = settingField.value + '/signup';
                        }
                    });
                }
            });
        }

        function setSignupEnabled(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'user_signup') {
                    vm.companySetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'invitation_only') {
                            vm.invitationOnly = settingField.value;
                        }
                    });
                }
            });
        }

        function loadPending() {
            UserInvitation.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: 'status==PENDING;type==ADMIN'
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pendingQueryCount = headers('X-Total-Count');
                vm.pendingInvitations = data;
                vm.pendingPage = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAccepted() {
            UserInvitation.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: 'status==ACCEPTED;type==ADMIN'
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.acceptedQueryCount = headers('X-Total-Count');
                vm.acceptedInvitations = data;
                vm.acceptedPage = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.transitionPending = function() {
            vm.promise = UserInvitation.query({
                page: vm.pendingPage - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: 'status==PENDING'
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.pendingInvitations = data;
            });
        }

        vm.transitionAccepted = function() {
            vm.promise = UserInvitation.query({
                page: vm.acceptedPage - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: 'status==ACCEPTED;type==ADMIN'
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.acceptedInvitations = data;
            });
        }

        vm.createObject = function() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/user/invitation/user-invitation-dialog.html',
                controller: 'UserInvitationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).then(function() {
                resetModal();
            });
        }

        vm.deleteObject = function(objectId) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.userInvitation.revoke'))
                .ariaLabel($filter('translate')('atheer.userInvitation.revoke'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                UserInvitation.delete({
                    id: objectId
                }, function() {
                    resetModal();
                });
            });
        };

        vm.resend = function(objectId) {
            UserInvitation.resend({
                id: objectId
            }, function(result) {
                ToastService.displayToast($filter('triTranslate')('atheer.userInvitation.invitationSent'), 3000);
            });
        };

        vm.back = function() {
            $window.history.back();
        };

        function resetModal() {
            vm.loadAll();
        };
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserInvitationDialogController', UserInvitationDialogController);

    /* @ngInject */
    function UserInvitationDialogController($scope, $stateParams, $mdDialog, $filter, UserInvitation, Principal, ToastService) {
        var vm = this;

        vm.parseToString = parseToString;
        vm.parseToArray = parseToArray;

        vm.invitationSent = false;
        vm.addManyAtOnce = false;

        vm.invitationModel = {
            email: null,
            first_name: null,
            last_name: null,
            type: 'ADMIN',
            invited_by: Principal.getUser()
        };

        vm.invitationsString = '';

        vm.invitations = [];
        vm.invitations.push(angular.copy(vm.invitationModel));
        vm.invitations.push(angular.copy(vm.invitationModel));
        vm.invitations.push(angular.copy(vm.invitationModel));

        vm.invitationsSuccess = [];
        vm.invitationsFailed = [];

        vm.clear = function() {
            $mdDialog.hide();
        };

        vm.seePending = function() {
            $mdDialog.hide();
        };

        vm.addAnother = function() {
            vm.invitations.push(angular.copy(vm.invitationModel));
        };

        vm.remove = function(index) {
            vm.invitations.splice(index, 1);
        };

        vm.sendInvitations = function() {
            var invitationsToSend = [];

            angular.forEach(vm.invitations, function(invitation) {
                if (invitation.email != null) {
                    invitationsToSend.push(invitation);
                }
            });

            if (invitationsToSend.length > 0) {
                UserInvitation.bulkInvitation(invitationsToSend, vm.onSaveSuccess, vm.onSaveError);
            } else {
                ToastService.displayToast($filter('triTranslate')('atheer.userManagement.addAtleatOneEmail'), 3000);
            }
        };

        vm.inviteMore = function() {
            vm.invitations = [];
            vm.invitations.push(angular.copy(vm.invitationModel));
            vm.invitations.push(angular.copy(vm.invitationModel));
            vm.invitations.push(angular.copy(vm.invitationModel));
            vm.invitationSent = false;
        }

        vm.onSaveSuccess = function(result) {
            vm.invitationsSuccess = [];
            vm.invitationsFailed = [];

            angular.forEach(result, function(invitation) {
                if (invitation.status == 'EXIST') {
                    vm.invitationsFailed.push(invitation);
                } else {
                    vm.invitationsSuccess.push(invitation);
                }
            });
            vm.invitationSent = true;
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        function parseToString() {
            vm.invitationsString = ''

            angular.forEach(vm.invitations, function(invitation) {
                if (invitation.email && invitation.email != '') {
                    var nameStr = (invitation.first_name ? invitation.first_name + ' ' : '') + (invitation.last_name ? invitation.last_name + ' ' : '');
                    var emailStr = (invitation.email ? '<' + invitation.email + '>' : '');
                    vm.invitationsString += nameStr + emailStr + ';';
                }

            })
        }

        function parseToArray() {
            vm.invitations = []
            var userStringArray = vm.invitationsString.match(/[^,;]+/g);
            angular.forEach(userStringArray, function(userString) {
                if (vm.isOnlyEmail(userString.trim())) {
                    var nameArray = userString.trim().match(/([a-zA-Z0-9]+)[._]?([a-zA-Z0-9]+)?/i)
                    vm.invitations.push({
                        email: userString.trim(),
                        first_name: nameArray[1],
                        last_name: nameArray[2]
                    });
                } else if (isInitialWithEmail(userString.trim())) {
                    var nameEmailArray = userString.match(/([a-zA-Z0-9]+)[ ]?([a-zA-Z0-9]+)?[ ]?<(.*)>/i)
                    if (vm.isOnlyEmail(nameEmailArray[3].trim())) {
                        vm.invitations.push({
                            email: nameEmailArray[3],
                            first_name: nameEmailArray[1],
                            last_name: nameEmailArray[2]
                        });
                    }
                }
            });
        }

        vm.isOnlyEmail = function(emailStr) {
            if(emailStr != null && emailStr.length > 0)
                return /^\w+([\.-\.+]?\w+)*@\w+([\.-\.+]?\w+)*(\.\w{2,3})+$/.test(emailStr);
            else
                return true
        }

        function isInitialWithEmail(emailStr) {
            return /([a-zA-Z0-9]+)[ ]?([a-zA-Z0-9]+)?[ ]?<(.*)>/i.test(emailStr);
        }

        vm.validEmailList = function () {
            var validEmailCounter = 0;
            angular.forEach(vm.invitations, function (invitation) {
                if (
                    invitation.email != null &&
                    invitation.email.length > 0 &&
                    vm.isOnlyEmail(invitation.email)
                )
                    validEmailCounter++;
            });
            return validEmailCounter == vm.invitations.length;
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserImportController', UserImportController);

    /* @ngInject */
    function UserImportController($rootScope, $scope, $state, Principal, User, $location, ParseLinks, AlertService, $mdDialog, $stateParams, $timeout, poller, $resource, $filter, ToastService, $http) {
        var vm = this;
        var uploadTypeEnum = {
            CSV: 'CSV',
            SPREADSHEET: 'SPREADSHEET'
        }

        vm.currentStep = 'upload';
        vm.uploadStatus = 'idle';
        vm.importStatus = 'idle';
        vm.fileImportInfo = null;
        vm.jobStream = null;
        vm.excelErrors = [];
        vm.jobData = null;
        vm.uploadType = uploadTypeEnum.CSV;
        vm.illustartionEmptyScreenId = "user_import";
        vm.jobStreamId = null;
        vm.responseObj = null;

        var downloadFile = function (url, fileName) {
            $http.get(url, { responseType: 'blob' }).then(function (response) {
                var objectUrl = URL.createObjectURL(response.data);
                var link = document.createElement('a');
                link.download = fileName,
                    link.href = objectUrl;
                link.click();
            })
        }

        vm.handleMediaUpload = function (mediaId, responseObj) {
            vm.responseObj = responseObj;
            if (responseObj.content_type === 'text/csv') {
                vm.uploadType = uploadTypeEnum.CSV;
            } else {
                vm.uploadType = uploadTypeEnum.SPREADSHEET;
            }
            vm.validateCSV(mediaId, responseObj);

        };

        vm.validateCSV = function (mediaId, responseObj) {
            vm.currentStep = 'validating';
            if (responseObj.content_type === 'text/csv') {
                User.validateImportFile({
                    fileId: responseObj.id
                }, function (response, headers) {
                    vm.fileImportInfo = response;
                    if (vm.fileImportInfo.is_valid) {
                        vm.currentStep = 'validate';
                    } else {
                        vm.currentStep = 'upload';
                        vm.uploadStatus = 'idle';
                        vm.importStatus = 'idle';
                        vm.fileImportInfo = null;
                        vm.jobStream = null;
                        vm.excelErrors = [];
                        vm.jobData = null;
                        ToastService.displayToast($filter('translate')('atheer.userImport.invalidFile'), 3000);
                    }
                });
            } else {
                User.validateImportExcelFile({
                    fileId: responseObj.id
                }, function (response, headers) {
                    vm.fileImportInfo = response;
                    if (vm.fileImportInfo.is_valid) {
                        vm.currentStep = 'validate';
                    } else {
                        vm.currentStep = 'upload';
                        vm.uploadStatus = 'idle';
                        vm.importStatus = 'idle';
                        vm.fileImportInfo = null;
                        vm.jobStream = null;
                        vm.excelErrors = [];
                        vm.jobData = null;
                        ToastService.displayToast($filter('translate')('atheer.userImport.invalidFile'), 3000);
                    }
                });
            }
            
        };

        vm.moveNext = function () {
            if (vm.currentStep == 'validate') {
                vm.currentStep = 'import';
                vm.startImport();
            } else if (vm.currentStep == 'import-summary') {
                $state.go('storm.admin-users');
            }
        };

        vm.downloadLogs = function () {
            var url = '/api/system/job-streams/pdf/' + vm.jobStreamId;
            downloadFile(url, 'user_import.xlsx');
        }

        vm.downloadSample = function (type) {
            var url = (type === 'CSV') ? '/api/users/import/template/download-csv' : '/api/users/import/template/download-xls';
            var fileName = (type === 'CSV') ? 'user_import_template.csv' : 'user_import_template.xlsx';
            downloadFile(url, fileName)
        }

        vm.startImport = function () {
            vm.importStatus = 'importing';
            if (vm.uploadType === uploadTypeEnum.CSV) {
                User.importUsers(vm.fileImportInfo, function (response, headers) {
                    vm.jobStream = response;
                    vm.jobStreamId = vm.jobStream.id;
                    vm.getImportJobStatus();
                });
            } else {
                 User.importUsersFromSpreadSheet(
                     vm.responseObj,
                     function (response) {
                         vm.jobStream = response;
                         if (vm.jobStream.job_data.valid) {
                             vm.getImportJobStatus();
                         }
                     }
                 );
            }
        };

        vm.getImportJobStatus = function () {
            // Get poller.
            var jobStreamStatusPoller = poller.get(User, {
                action: (vm.uploadType === uploadTypeEnum.CSV) ? 'getImportStatus' : 'getSpreadSheetImportStatus',
                delay: 3000,
                argumentsArray: [{
                    id: vm.jobStream.id
                }],
                smart: true
            });

            jobStreamStatusPoller.promise.then(null, null, function (result) {
                vm.jobStream = result;
                if (vm.uploadType === uploadTypeEnum.CSV) {
                    $rootScope.isBulkUploadInProgress = true;
                    vm.jobStreamId = vm.jobStream.id;
                    if (result.status == 'COMPLETED') {
                        $rootScope.isBulkUploadInProgress = false;
                        poller.stopAll();
                        vm.currentStep = 'import-summary';
                        vm.importStatus = 'complete';
                    }
                } else {
                    vm.jobData = vm.jobStream.job_data;
                    vm.jobStreamId = vm.jobStream.import_id;
                    if (result.status == 'COMPLETED') {
                        poller.stopAll();
                        vm.currentStep = 'import-summary';
                        vm.importStatus = 'complete';
                        vm.excelErrors = result.errors;
                    }
                }

            });
        };

        vm.resetImport = function () {
            if (vm.importStatus === 'idle') {
                $state.go('storm.admin-users');
            }
            vm.currentStep = 'upload';
            vm.uploadStatus = 'idle';
            vm.importStatus = 'idle';
            vm.fileImportInfo = null;
            vm.jobStream = null;
            vm.excelErrors = [];
            vm.jobData = null;
        };
    }
})();
;
(function() {
    "use strict";

    angular
        .module("atheer.user")
        .controller("GuestJoinController", GuestJoinController);

    /* @ngInject */
    function GuestJoinController(triSettings, deviceDetector, Guest, $state, Session, Auth, Principal, $cookies, $stateParams, $filter, PubNubService, $location, $window, $rootScope, $scope, ToastService, Experience) {
        var vm = this;
        var showLoaderListener = null;

        vm.triSettings = triSettings;
        vm.useDarkBackGroundLogos = true;
        vm.isError = false;
        vm.isLoading = false;
        vm.sessionCode1 = "";
        vm.sessionCode2 = "";
        vm.sessionCode3 = "";
        vm.sessionNumber1 = "";
        vm.sessionNumber2 = "";
        vm.sessionNumber3 = "";
        vm.sessionNumber4 = "";
        vm.sessionNumber5 = "";
        vm.guestUserId = null;
        vm.workspace = 'guest';
        vm.firstName = "";
        vm.lastName = "";
        vm.bearerToken = null;
        vm.sessionModel = null;
        vm.isWaitingForHost = false;
        vm.isInputChanged = false;
        vm.deviceId = null;
        vm.convChannelName = null;
        vm.buildInfoSettings = $rootScope.buildInfo;
        vm.sessionNo = null;
        vm.workspaceCode = null;
        vm.isMobileBrowser = deviceDetector.isMobile();
        vm.launchSession = false;
        vm.termsAndPrivacy = false;
        vm.showTermsAndPrivacy = true;
        vm.poweredByLink = "http://www.atheerair.com/";
        vm.primaryColor;

        vm.termsLink = "http://www.atheerair.com/";
        vm.privacyLink = "https://www.atheerair.com/privacy-policy/";

        function loadAll() {
            vm.useDarkBackGroundLogos = triSettings.getSkinModel().use_dark_logos;
            vm.primaryColor = vm.triSettings.getSkinModel().primary_color_hex;
            $cookies.put('isGuest', true);

            setThemeColor(vm.sessionNo ? 1000 : 200);

            if ($stateParams.session_no && $stateParams.workspace_code && $stateParams.launch_session) {
                vm.sessionNo = $stateParams.session_no;
                vm.workspaceCode = $stateParams.workspace_code;
                vm.launchSession = $stateParams.launch_session;
                vm.isLoading = true;
            }

            if (vm.sessionNo && vm.workspaceCode) {
                setSessionNoAndCode();
            }

            if($rootScope.companySetting) {
                vm.termsLink = $rootScope.companySetting.terms_url;
                vm.privacyLink = $rootScope.companySetting.privacy_policy_url;
            };

            var host = $location.host();
            if (angular.isDefined(host) && host.startsWith("rigpartner.")) {
                vm.termsLink = "https://rigquip.com/terms-conditions/";
                vm.privacyLink = "https://rigquip.com/privacy-policy/";
            };
            createGuestUser();
        };

        function setSessionNoAndCode() {
            vm.sessionNumber1 = vm.sessionNo.charAt(0);
            vm.sessionNumber2 = vm.sessionNo.charAt(1);
            vm.sessionNumber3 = vm.sessionNo.charAt(2);
            vm.sessionNumber4 = vm.sessionNo.charAt(3);
            vm.sessionNumber5 = vm.sessionNo.charAt(4);

            vm.sessionCode1 = vm.workspaceCode.charAt(0);
            vm.sessionCode2 = vm.workspaceCode.charAt(1);
            vm.sessionCode3 = vm.workspaceCode.charAt(2);
        }

        function createGuestUser() {
            vm.isLoading = true;
            var guestUser = {};
            var host = $location.host();

            guestUser.unique_id = $cookies.get('deviceId');
            if (!guestUser.unique_id) {
                var domainParts = host.split('.');
                var parentDomain = domainParts[1] + '.' + domainParts[2];

                guestUser.unique_id = Date.now().toString(36) + Math.random().toString(36).substr(5);
                window.localStorage.setItem('deviceId', guestUser.unique_id);
                $cookies.put('deviceId', guestUser.unique_id, {
                    domain: parentDomain
                });

                guestUser.first_name = (deviceDetector.browser === 'ms-edge-beta' ? deviceDetector.browser.split('-beta')[0] : deviceDetector.browser);
                guestUser.last_name = deviceDetector.os;
            }

            Guest.createGuestUser(guestUser, vm.workspace)
                .then(function(result) {
                    Guest.setBearerToken(result.data.id_token);
                    Guest.setGuestUserId(result.data.user_id);

                    vm.guestUserId = result.data.user_id;
                    vm.bearerToken = result.data.id_token;
                    vm.deviceId = result.data.device_id;
                    vm.userNo = result.data.user_no;

                    if (result.data.hasOwnProperty("first_name") && result.data.first_name != null) {
                        vm.firstName = result.data.first_name;
                    } else {
                        vm.firstName = (deviceDetector.browser === 'ms-edge-beta' ? deviceDetector.browser.split('-beta')[0] : deviceDetector.browser);
                    }
                    if (result.data.hasOwnProperty("last_name") && result.data.last_name != null) {
                        vm.lastName = result.data.last_name;
                    } else {
                        vm.lastName = deviceDetector.os;
                    }

                    PubNubService.init(result.data.user_id, result.data.messaging_config, result.data.channels, ['access-session']);
                    initPubNubHandler(result.data.channels.personal[0].name);

                    if (vm.sessionNo && vm.workspaceCode) {
                        if (vm.launchSession == 'true') {
                            vm.joinGuestSession(true);
                        } else {
                            vm.joinGuestSession(false);
                            vm.isLoading = false;
                        }
                    } else {
                        vm.isLoading = false;
                    }
                })
                .catch(function(err) {
                    vm.isLoading = false;
                    $state.go('account.signin');
                    ToastService.displayToast($filter('triTranslate')('atheer.guestJoin.messages.unableToCreateGuestUser'), 3000);
                });
        };

        function setThemeColor(duration) {
            setTimeout(function() {
                var spinners = document.getElementsByClassName("spinner");
                angular.forEach(spinners, function(spinner) {
                    spinner.style.backgroundColor = vm.triSettings.getSkinModel().primary_color_hex;
                });
            }, duration);
        };

        function resetVariables() {
            vm.isLoading = false;
        };

        function initPubNubHandler(channelName) {
            console.log('initPubNubHandler: ' + vm.convChannelName);
            vm.convChannelName = channelName;
            PubNubService.subscribe([vm.convChannelName], true);
        };

        function showLoader(event, isLoader) {
            vm.isLoading = isLoader;
            setThemeColor(200);
        };

        function redirectToJoin() {
            var host = $location.host();
            if (!host.startsWith('app')) {
                var hostUrl = $location.absUrl();
                var domain = $window.location.host.split('.')[0];
                var path = $location.path()

                var url = hostUrl.replace(domain, 'app').replace(path, '/sessions/player/' + vm.sessionNo + '/guest/' + vm.workspaceCode + '/firstName/' + vm.firstName + '/lastName/' + vm.lastName + '/sessionInvalid/' + true);
                $window.location.href = url;
            } else {
                var hostUrl = $location.absUrl();
                var domain = $window.location.host.split('.')[0];
                var path = $location.path()

                var url = hostUrl.replace(domain, domain).replace(path, '/sessions/player/' + vm.sessionNo + '/guest/' + vm.workspaceCode + '/firstName/' + vm.firstName + '/lastName/' + vm.lastName + '/sessionInvalid/' + true);
                $window.location.href = url;
            }
        };

        vm.joinGuestSession = function(launchSession) {
            var workspaceCode = vm.sessionCode1 + vm.sessionCode2 + vm.sessionCode3;
            var sessionNumber = vm.sessionNumber1 + vm.sessionNumber2 + vm.sessionNumber3 + vm.sessionNumber4 + vm.sessionNumber5;

            vm.isLoading = true;

            setThemeColor(200);

            Guest.validateWorkspaceCode(workspaceCode, vm.workspace).then(function(result) {
                vm.workspace = result.data.api_url.split('.')[0].split(':')[1].split('/')[2];
                var isGuest = $cookies.get('isGuest');
                if (!isGuest) {
                    $cookies.put('isGuest', true);
                }

                var host = $location.host();

                if (host.startsWith('app')) {
                    var hostUrl = $location.absUrl();
                    var path = $location.path()
                    var url = hostUrl.replace('app', vm.workspace).replace(path, '/join/' + sessionNumber + '/' + workspaceCode + '/true');
                    $window.location.href = url;
                } else {
                    Auth.loginWithToken(vm.bearerToken).then(function(response) {
                        var data = {
                            first_name: vm.firstName,
                            last_name: vm.lastName
                        };
                        Guest.updateGuestUser(vm.guestUserId, vm.workspace, data).then(function(res) {
                            var host = $location.host();
                            var domainParts = host.split('.');
                            var parentDomain = domainParts[1] + '.' + domainParts[2];
                            Principal.identity().then(function(user) {
                                Guest.getSessionDetails(vm.guestUserId, sessionNumber, vm.workspace).then(function(result) {
                                    Session.get({
                                        id: sessionNumber,
                                        for_launch: true,
                                        is_session_no: true
                                    }, onSuccess, onError);

                                    function onSuccess(result) {
                                        if (!result.id && result.result && result.result === "NOT_FOUND") {
                                            resetVariables();
                                            ToastService.displayToast($filter('triTranslate')('atheer.guestJoin.messages.airSessionExpired'), 3000);
                                            Auth.logout();
                                            redirectToJoin();
                                        } else {
                                            vm.sessionModel = result;
                                            if (launchSession) {
                                                Experience.createSessionActivity({
                                                    object: vm.sessionModel,
                                                    user_id: user.id,
                                                    activity_type: 'TERMS_ACCEPTED',
                                                    properties: null
                                                }, function(result) {
                                                    $state.go('storm.sessions.player', {
                                                        'session_no': vm.sessionModel.session_no
                                                    });
                                                });
                                            }
                                            vm.isError = false;
                                            PubNubService.unsubscribe([vm.convChannelName]);
                                        }
                                    };

                                    function onError(error) {
                                        resetVariables();
                                        ToastService.displayToast($filter('triTranslate')('atheer.guestJoin.messages.airSessionExpired'), 3000);
                                        Auth.logout();
                                        redirectToJoin();
                                    };
                                }).catch(function(err) {
                                    Auth.logout();
                                    //redirectToJoin();
                                    vm.isError = true;
                                    resetVariables();
                                });
                            });
                        }).catch(function(err) {
                            ToastService.displayToast($filter('triTranslate')('atheer.guestJoin.messages.unableToUpdateGuestUser'), 3000);
                            Auth.logout();
                            resetVariables();
                        });
                    });
                }
            }).catch(function(error) {
                redirectToJoin();
                vm.isError = true;
                resetVariables();
            });
        };

        vm.checkPasscode = function (modelVal, code) {
            if (modelVal != '' && modelVal != null && code < 8) {
                var input_elements = document.getElementsByClassName('inline_input');
                input_elements[code].focus();
            };
        };

        vm.onNumberInputKeydown = function (e) {
            if (
                ![
                    "1", "2", "3", "4", "5", "6", "7","8", "9", "0",
                    "Backspace",
                    "Tab",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowUp",
                    "ArrowDown",
                ].includes(e.key)
            ) {
                e.stopPropagation();
                e.preventDefault();
            }
        };

        vm.redirectToSignin = function() {
            $state.go('account.signin');
        };

        showLoaderListener = $rootScope.$on('show-loader', showLoader);

        $rootScope.$on('$destroy', function() {
            showLoaderListener = null;
        });

        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileEventListController', ProfileEventListController);

    /* @ngInject */
    function ProfileEventListController($scope, $state, $mdDialog, Principal, $translate, pagingParams, paginationConstants, $mdToast, $filter, Experience, id, eventName, eventMeta) {
        var vm = this;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        vm.eventName = eventName;
        vm.eventMeta = eventMeta;

        vm.user = null;
        vm.loadingData = true;
        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.events = [];

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        var eventLabel = vm.eventMeta.label;
        vm.eventMetaTooltip = 'atheer.event.add.' + $filter('lowercase')(eventLabel.replace(/ /g, ""));

        vm.getListValueLabel = function(field, value) {
            return $filter('filter')(field.list_options, {
                'option_id': value
            })[0].label
        };

        vm.getFieldValue = function(field, value) {
            if(field.data_type == 'DATE') {
                return moment(value).format('MM/DD/YYYY');
            } else {
                return value;
            }
        };

        vm.addEvent = function() {
            $mdDialog.show({
                templateUrl: 'modules/user/event/event-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "ProfileEventDialogController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    eventMeta: vm.eventMeta,
                    userEvent: {
                        owner_id: vm.userId,
                        owner_type: 'user',
                        name: vm.eventName,
                        properties: {

                        }
                    }
                }
            }).then(function() {
                vm.loadData();
            });
        }

        vm.editEvent = function(userEvent) {
            $mdDialog.show({
                templateUrl: 'modules/user/event/event-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "ProfileEventDialogController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    eventMeta: vm.eventMeta,
                    userEvent: userEvent
                }
            }).then(function() {
                vm.loadData();
            });
        }

        vm.removeEvent = function(event, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.event.removeEvent'))
                .ariaLabel($filter('translate')('atheer.event.removeEvent'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Experience.deleteEvent({
                    eventType: vm.eventName,
                    id: event.id
                }, function() {
                    vm.loadData();
                });
            });
        }

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getEvents({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, function(response, headers) {
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.events = response;
                vm.loadingData = false;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "name==" + vm.eventName + ";owner_id==" + vm.userId;
            if (vm.query.filter.length <= 0) {
                return queryString;
            }
        }

        vm.transition = function() {
            vm.promise = Experience.getEvents({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.events = response;
                vm.queryCount = vm.totalItems;
            });
        }
        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileEventDialogController', ProfileEventDialogController);

    /* @ngInject */
    function ProfileEventDialogController($scope, $state, $q, $mdDialog, MetaData, User, Experience, $translate, $filter, eventMeta, userEvent, ToastService) {
        var vm = this;

        var FORMLY_ATHEER_DATA_TYPE_MAPPING = {
            'BOOLEAN': 'checkbox',
            'STRING': 'input',
            'LIST': 'select',
            'DATE': 'datepicker',
            'DATETIME': 'datepicker',
            'NUMBER': 'input',
            'OBJECT': 'objectpicker'
        };

        var FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING = {
            'STRING': 'text',
            'NUMBER': 'number'
        };

        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        vm.userEvent = userEvent;
        vm.metaFieldGroup = eventMeta;

        vm.metaFields = [];

        vm.loadingData = false;
        vm.eventMetaCreateTitle = 'atheer.event.create';
        vm.eventMetaUpdateTitle = 'atheer.event.update';
        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.save = function () {
            vm.userEvent.name = vm.metaFieldGroup.name;

            if (vm.userEvent.id) {
                Experience.updateEvent({
                    id: vm.userEvent.id
                }, vm.userEvent, function (result) {
                    ToastService.displayToast(vm.metaFieldGroup.label + $filter('triTranslate')('atheer.event.messages.success.update'), 3000);
                    $mdDialog.hide();
                });
            } else {
                Experience.createEvent(vm.userEvent, function (result) {
                    ToastService.displayToast(vm.metaFieldGroup.label + $filter('triTranslate')('atheer.event.messages.success.added'), 3000);
                    $mdDialog.hide();
                });
            }
        };

        vm.isNew = function () {
            if (vm.userEvent.id) {
                return false;
            } else {
                return true;
            }
        };

        vm.loadData = function () {
            vm.loadingData = true;

            angular.forEach(vm.metaFieldGroup.fields, function (field) {
                if (!field.locked) {
                    vm.metaFields.push(getFormlyField(field));
                }
            });

            vm.loadingData = false;
        };

        function getFormlyField(atheerfield) {
            var formlytype = FORMLY_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyTemplateType = FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyField = {
                type: formlytype ? formlytype : 'input',
                key: atheerfield.name,
                templateOptions: {
                    label: atheerfield.label,
                    required: atheerfield.required
                }
            };

            if (formlyTemplateType) {
                formlyField.templateOptions['type'] = formlyTemplateType;
            }
            
            if (
                (atheerfield.data_type === "DATETIME" ||
                    atheerfield.data_type === "DATE") &&
                formlyField.templateOptions["required"] &&
                formlyField.templateOptions["label"].indexOf("*") === -1
            ) {
                formlyField.templateOptions["label"] =
                    formlyField.templateOptions["label"] + " *";
            }

            if (atheerfield.data_type == 'DATETIME') {
                formlyField.templateOptions['datepickerPopup'] = "HH:MM"
            }

            if (atheerfield.data_type == 'LIST') {
                formlyField.templateOptions['labelProp'] = "label";
                formlyField.templateOptions['valueProp'] = "option_id";
                formlyField.templateOptions['options'] = atheerfield.list_options;
            }

            if (atheerfield.data_type == 'OBJECT') {
                if (atheerfield.ref_object == 'Content') {
                    formlyField.templateOptions['objectName'] = 'Content';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'title',
                        operator: '=re='
                    }];
                } else if (atheerfield.ref_object == 'User') {
                    formlyField.templateOptions['objectName'] = 'User';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'text_search',
                        operator: '=ts='
                    }];
                }
            }
            return formlyField;
        };
        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserActivateInfoController', UserActivateInfoController);

    /* @ngInject */
    function UserActivateInfoController($rootScope, $location, Feature, $translate, Auth, $timeout, User, UserInvitation, $scope, $state, $stateParams, $http, $filter, triSettings, id, ToastService) {
        var vm = this;

        vm.error = null;
        vm.success = false;
        vm.triSettings = triSettings;
        vm.step = 'user-info';
        vm.userInvitation = null;
        vm.status = null;
        vm.baseUrl = $location.protocol() + "://" + $location.host();

        vm.isLoginAvailable = true;
        vm.isCheckingLoginAvailability = false;
        vm.loginInfo = null;
        vm.passwordVisible = false;

        vm.user = {
            first_name: null,
            last_name: null,
            login: null,
            password: null,
            email: null,
            invitation_key: id
        }

        vm.next = function () {
            if (!vm.isLoginAvailable || vm.user.login == null || vm.user.login.length <= 0) {
                ToastService.displayToast($filter('triTranslate')('atheer.userInfo.enterUsername'), 3000);
            } else {
                vm.step = 'password';
            }
        };

        vm.togglePasswordVisibility = function() {
            vm.passwordVisible = !vm.passwordVisible;
        };

        vm.register = function () {
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;

            User.register(vm.user, function (result) {
                vm.success = 'OK';
                login()
            }, function (result) {
                vm.success = null;
                if (result.status === 400 && result.data === 'login already in use') {
                    vm.errorUserExists = 'ERROR';

                    ToastService.displayToast($filter('triTranslate')('atheer.userInfo.usernameAlreadyInUse'), 3000);

                } else if (result.status === 400 && result.data === 'e-mail address already in use') {
                    vm.errorEmailExists = 'ERROR';

                    ToastService.displayToast($filter('triTranslate')('atheer.userInfo.emailAlreadyInUse'), 3000);

                } else {
                    vm.error = 'ERROR';
                }
            });
        }

        vm.loadAll = function () {
            UserInvitation.getByActivationKey({
                id: id
            }, function (result) {
                vm.userInvitation = result;
                if (vm.userInvitation.status == 'ACCEPTED') {
                    vm.status = 'user-exist';
                } else {
                    vm.status = 'valid-key';
                }
                vm.user.email = vm.userInvitation.email;
                vm.user.login = vm.userInvitation.email;
                vm.user.first_name = vm.userInvitation.first_name;
                vm.user.last_name = vm.userInvitation.last_name;
            }, function () {
                vm.status = 'invalid-key';
                vm.userInvitation = null;
            });
        }

        function setupTeamName(settings) {
            angular.forEach(settings, function (setting) {
                if (setting.category == 'company_info') {
                    vm.companySetting = setting;

                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'name') {
                            vm.teamName = settingField.value;
                        }
                    });
                }
            });
        }

        function login() {
            Auth.login({
                username: vm.user.login,
                password: vm.user.password,
                rememberMe: true
            }).then(function () {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                $state.go('storm.home');
            }).catch(function () {
                vm.authenticationError = true;
                ToastService.displayToastWithAction($filter('translate')('atheer.userInfo.errorCreatingAccount'),
                    $filter('translate')('entity.action.ok'), 'md-warn')
            });
        }

        vm.checkLoginAvailable = function (login) {
            vm.isCheckingLoginAvailability = true;
            vm.isLoginAvailable = false;
            User.checkLogin({
                login: login
            }, function (result) {
                vm.isCheckingLoginAvailability = false;
                vm.loginInfo = result;
                vm.isLoginAvailable = vm.loginInfo.available;
            });
        }

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('ProfileAboutController', ProfileAboutController);

    /* @ngInject */
    function ProfileAboutController($q, MetaData, Principal, User, $filter, id, System, LocalResourceService, $window, translationStorageProvider, ToastService, moment) {
        var vm = this;

        var FORMLY_ATHEER_DATA_TYPE_MAPPING = {
            'BOOLEAN': 'checkbox',
            'STRING': 'input',
            'LIST': 'select',
            'DATE': 'datepicker',
            'DATETIME': 'datepicker',
            'NUMBER': 'input',
            'DECIMAL': 'input',
            'OBJECT': 'objectpicker'
        };

        var FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING = {
            'STRING': 'text',
            'NUMBER': 'number',
            'DECIMAL': 'number'
        };

        vm.timezones = [];
        vm.languages = [];
        vm.user = null;
        vm.save = save;
        vm.disableEdit = false;
        vm.isAdminView = id != 'me';
        vm.profile = {};
        vm.profileMeta = null;
        vm.profileMetaFields = [];
        vm.profileViewMode = id == 'me' ? 'me' : 'admin';
        vm.isAdminMode = vm.profileViewMode == 'admin';
        vm.searchText = null;
        vm.userInfo = Principal.getUserInfo();
        vm.isPublicUser = false;

        vm.userId = id == 'me' ? Principal.getUserId() : id;

        vm.loadData = function () {
            vm.loadingData = true;

            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise,
                System.getTimezones({
                    size: 100
                }).$promise,
                System.getLanguages({
                    localisation_support: true
                }).$promise,
                MetaData.get({
                    id: 'user',
                    is_name: true
                }).$promise,
                LocalResourceService.get({ fileName: 'languages.json' }).$promise
            ]).then(function (data) {
                vm.user = data[0];
                vm.title = $filter('translate')('atheer.userDetail.menuTitle', { userFirstName: vm.user.first_name })
                vm.timezones = data[1];
                // vm.languages = data[2];
                if (vm.user.login == 'admin') {
                    vm.disableEdit = true;
                }

                angular.forEach(data[3].field_groups, function (field_group) {
                    if (field_group.name == 'profile') {
                        vm.profileMeta = field_group;
                    }
                });

                angular.forEach(vm.profileMeta.fields, function (field) {
                    if (field.type == 'FLEX') {
                        vm.profileMetaFields.push(getFormlyField(field));
                    }
                });
                vm.languages = data[4].supportedLanguages;
                vm.languageCodes = data[4].languageCodes;
                vm.loadingData = false;

            }).catch(function (data) { }).finally(function () { });
        };

        vm.getLabel = function (item) {
            return item.first_name + " " + item.last_name;
        }

        vm.isTerminatedDateInvalid = function () {
            if (!vm.user || !vm.user.terminated_on || !vm.user.start_date) {
                return false;
            }
            return moment(vm.user.terminated_on).isBefore(
                moment(vm.user.start_date)
            );
        };

        vm.userSearchQuery = function (searchText) {
            return User.query({
                page: 0,
                size: 10,
                sort: 'id,asc',
                query: getQueryString(searchText),
                check_admin: true
            }).$promise
        };

        function getQueryString(searchText) {
            var searchQuery = "(";

            searchQuery += 'first_name=re="' + searchText + '"';
            searchQuery += ',last_name=re="' + searchText + '"';
            searchQuery += ',email=re="' + searchText + '"';

            searchQuery += ")";

            return searchQuery
        };

        function save() {
            var userCopy = JSON.parse(JSON.stringify(vm.user));
            var dateMinusTimeFormat = "yyyy-MM-ddT00:00:00.000Z";
            for (var prop in vm.user) {
                var userAttr = vm.user[prop];
                if (userAttr instanceof Date && !isNaN(userAttr)) {
                    userCopy[prop] = $filter('date')(userAttr, dateMinusTimeFormat);
                }
            }
            if (vm.user.custom_attributes) {
                for (var cust_prop in vm.user.custom_attributes) {
                    if (vm.user.custom_attributes[cust_prop] instanceof Date && !isNaN(vm.user.custom_attributes[cust_prop])) {
                        userCopy.custom_attributes[cust_prop] = $filter('date')(vm.user.custom_attributes[cust_prop], dateMinusTimeFormat);
                    }
                }
            }

            if (vm.isAdminView) {
                User.update(vm.user, function (result) {
                    postSave(result);
                });
            }
            else {
                User.updateme(vm.user, function (result) {
                    postSave(result);
                });
            }
        };

        function postSave(result) {
            vm.profileMetaFields = []
            vm.user = result;
            angular.forEach(vm.profileMeta.fields, function (field) {
                if (field.type == 'FLEX') {
                    vm.profileMetaFields.push(getFormlyField(field));
                }
            });
            if (result.id == Principal.getUserId()) {
                angular.forEach(vm.languageCodes, function (lang) {
                    if (lang.name == result.language_id) {
                        if (lang.name != 'system_default') {
                            translationStorageProvider.put('NG_TRANSLATE_LANG_KEY', lang.value);
                        } else {
                            var lang = ($window.navigator.language || $window.navigator.userLanguage).replace('-', '_');
                            if (lang == 'el') {
                                lang = 'el_GR';
                            } else if (lang == 'ja') {
                                lang = 'ja_JP';
                            }
                            translationStorageProvider.put('NG_TRANSLATE_LANG_KEY', lang);
                        }
                        localStorage.setItem('isUserSelectedLanguage', true)
                    }
                });
                ToastService.displayToastWithAction($filter('triTranslate')("atheer.about.changesUpdated"),
                    $filter('translate')('entity.action.refresh'), 'md-warn', '', function (res) {
                        if (res == 'ok') {
                            $window.location.reload();
                        }
                    });
            } else {
                ToastService.displayToast($filter('triTranslate')("atheer.about.changesUpdated"), 3000);
            }
        }

        function getFormlyField(atheerfield) {
            var formlytype = FORMLY_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyTemplateType = FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyField = {
                type: formlytype ? formlytype : 'input',
                key: atheerfield.name,
                templateOptions: {
                    label: atheerfield.label,
                    required: atheerfield.required
                }
            };
            if (formlytype == "datepicker") {
                formlyField.templateOptions['placeholder'] = $filter('translate')('atheer.about.selectDate');
            }
            if (formlyTemplateType) {
                formlyField.templateOptions['type'] = formlyTemplateType;
            }
            if (atheerfield.data_type === 'DATETIME' || atheerfield.data_type === 'DATE') {
                if (vm.user.custom_attributes[atheerfield.name]) {
                    vm.user.custom_attributes[atheerfield.name] = new Date(vm.user.custom_attributes[atheerfield.name]);
                }
                if (
                    formlyField.templateOptions["required"] &&
                    formlyField.templateOptions["label"].indexOf("*") === -1
                ) {
                    formlyField.templateOptions["label"] =
                        formlyField.templateOptions["label"] + " *";
                }
            }

            if (atheerfield.data_type == 'DATETIME') {
                formlyField.templateOptions['datepickerPopup'] = "HH:MM";
            }

            if (atheerfield.data_type == 'LIST') {
                formlyField.templateOptions['labelProp'] = "label";
                formlyField.templateOptions['valueProp'] = "option_id";
                formlyField.templateOptions['options'] = atheerfield.list_options;
            }

            if (atheerfield.data_type == 'OBJECT') {
                if (atheerfield.ref_object == 'Content') {
                    formlyField.templateOptions['objectName'] = 'Content';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'title',
                        operator: '=re='
                    }];
                } else if (atheerfield.ref_object == 'User') {
                    formlyField.templateOptions['objectName'] = 'User';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'text_search',
                        operator: '=ts='
                    }];
                }
            }
            return formlyField;
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('WorkspaceInfoSettingController', WorkspaceInfoSettingController);

    /* @ngInject */
    function WorkspaceInfoSettingController($scope, $state, $q, Setting, $filter, ToastService, $window) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.timezones = [];
        vm.languages = [];
        vm.companySetting = [];
        vm.pageSizes = [{
            "size": "10"
        }, {
            "size": "20"
        }, {
            "size": "40"
        }, {
            "size": "60"
        }, {
            "size": "80"
        }, {
            "size": "100"
        }];
        vm.toastPositions = [{
            "label": "Top Right",
            "value": "top-right"
        }, {
            "label": "Bottom Right",
            "value": "bottom-right"
        }, {
            "label": "Top Left",
            "value": "top-left"
        }, {
            "label": "Bottom Left",
            "value": "Bottom-left"
        }];
        vm.toastPosition = [20, 40, 60, 80, 100];
        vm.boardRefreshTimechoices = [
            {
                "label": "Never refresh",
                "value": "0"
            },
            {
                "label": "Every 15 min",
                "value": "15"
            },
            {
                "label": "Every 30 min",
                "value": "30"
            },
            {
                "label": "Every 45 min",
                "value": "45"
            },
            {
                "label": "Every 60 min",
                "value": "60"
            }
         ];
        vm.companyModel = {
            name: null,
            website_url: null,
            phone_number: null,
            owner_name: null,
            owner_email: null,
            atheer_url: null,
            timezone_id: null,
            language_id: null,
            default_language: false,
            default_page_size: 20,
            default_toast_position: 'top-right',
            terms_url: null,
            privacy_policy_url: null,
            board_refresh_rate: 0
        };

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getSystemTimezones({
                        size: 100
                    }).$promise,
                    Setting.getSystemLanguages({
                        localisation_support: true
                    }).$promise,
                    Setting.getCompanySettings().$promise
                ])
                .then(function(results) {
                    vm.timezones = results[0];
                    vm.languages = results[1];
                    setCompanyModel(results[2]);
                    vm.loadingData = false;
                });
        };

        function setCompanyModel(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'company_info') {
                    vm.companySetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'name') {
                            vm.companyModel.name = settingField.value;
                        }
                        if (settingField.name == 'website_url') {
                            vm.companyModel.website_url = settingField.value;
                        }
                        if (settingField.name == 'phone_number') {
                            vm.companyModel.phone_number = settingField.value;
                        }
                        if (settingField.name == 'owner_name') {
                            vm.companyModel.owner_name = settingField.value;
                        }
                        if (settingField.name == 'owner_email') {
                            vm.companyModel.owner_email = settingField.value;
                        }
                        if (settingField.name == 'timezone_id') {
                            vm.companyModel.timezone_id = settingField.value;
                        }
                        if (settingField.name == 'language_id') {
                            vm.companyModel.language_id = settingField.value;
                        }
                        if (settingField.name == 'atheer_url') {
                            vm.companyModel.atheer_url = settingField.value;
                        }
                        if (settingField.name == 'default_language') {
                            vm.companyModel.default_language = settingField.value == "true" ? true : false;
                        }
                        if (settingField.name == 'default_page_size') {
                            vm.companyModel.default_page_size = settingField.value;
                        }
                        if (settingField.name == 'default_toast_position') {
                            vm.companyModel.default_toast_position = settingField.value;
                        }
                        if (settingField.name == 'terms_url') {
                            vm.companyModel.terms_url = settingField.value;
                        }
                        if (settingField.name == 'privacy_policy_url') {
                            vm.companyModel.privacy_policy_url = settingField.value;
                        }
                        if (settingField.name == 'board_refresh_rate') {
                            vm.companyModel.board_refresh_rate = settingField.value;
                        }
                    });
                }
            });
        }

        function setCompanySettings() {
            setCompanySettingField("name", vm.companyModel.name);
            setCompanySettingField("website_url", vm.companyModel.website_url);
            setCompanySettingField("phone_number", vm.companyModel.phone_number);
            setCompanySettingField("owner_name", vm.companyModel.owner_name);
            setCompanySettingField("owner_email", vm.companyModel.owner_email);
            setCompanySettingField("timezone_id", vm.companyModel.timezone_id);
            setCompanySettingField("language_id", vm.companyModel.language_id);
            setCompanySettingField("default_language", vm.companyModel.default_language);
            setCompanySettingField("default_page_size", vm.companyModel.default_page_size);
            setCompanySettingField("terms_url", vm.companyModel.terms_url);
            setCompanySettingField("privacy_policy_url", vm.companyModel.privacy_policy_url);
            setCompanySettingField("default_toast_position", vm.companyModel.default_toast_position);
            setCompanySettingField("board_refresh_rate", vm.companyModel.board_refresh_rate);
        }

        function setCompanySettingField(fieldName, fieldValue) {
            var foundField = false;
            angular.forEach(vm.companySetting.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.companySetting.fields.push(settingField);
            }
        }

        vm.isURLInvalid = function(url) {
            var URL_REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([a-z0-9\-&]*\.)+([a-z]{2,}).*$/i;
            return !URL_REGEX.test(url);
        };

        vm.isAnyURLInValid = function () {
            return (
                vm.isURLInvalid(vm.companyModel.website_url) ||
                vm.isURLInvalid(vm.companyModel.terms_url) ||
                vm.isURLInvalid(vm.companyModel.privacy_policy_url)
            );
        };

        vm.save = function() {
            setCompanySettings();
            Setting.update(vm.companySetting, function() {
                ToastService.displayToastWithAction($filter('triTranslate')("atheer.setting.success"),
                    $filter('translate')('entity.action.refresh'), 'md-warn', 3000, function(res) {
                    if(res == 'ok') {
                        $window.location.reload();
                    }
                });
            });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('UserSignupSettingController', UserSignupSettingController);

    /* @ngInject */
    function UserSignupSettingController($mdDialog, $scope, $state, $q, Setting, $filter, ToastService, SecurityRole, MetaData) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.userSignupSetting = [];
        vm.userSignupModel = {
            signup_policy: 'invitation_only',
            allowed_email_addresses: "",
            restricted_email_addresses: "",
            security_role: "",
            profile_attributes: "first_name, last_name"
        };
        vm.selectedUserFields = [];
        vm.selectedSecurityRole = null;
        vm.defaultSelectedUserFields = [
            {
                "name": "first_name",
                "label": "First Name",
                "description": "First Name",
                "order": 1,
                "data_type": "STRING",
                "type": "REGULAR",
                "enabled": true,
                "search_enabled": true,
                "required": true,
                "locked": true
            },
            {
                "name": "last_name",
                "label": "Last Name",
                "description": "Last Name",
                "order": 2,
                "data_type": "STRING",
                "type": "REGULAR",
                "enabled": true,
                "search_enabled": true,
                "required": false,
                "locked": true
            },
            {
                "name": "phone_number",
                "label": "Phone number",
                "description": "Phone number",
                "order": 3,
                "data_type": "STRING",
                "type": "REGULAR",
                "enabled": true,
                "search_enabled": true,
                "required": false,
                "locked": true
            } ];
        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getUserSignupSettings().$promise,
                    Setting.getUserSignupMetadata().$promise
                ])
                .then(function(results) {
                    setUserSignupModel(results[0]);
                
                    setProfileModel(results[1]);

                    SecurityRole.get({
                        id: vm.userSignupModel.security_role
                    }, function(result) {
                            vm.selectedSecurityRole = result;
                    });
                    vm.loadingData = false;
                });
        };

        function setUserSignupModel(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'user_signup') {
                    vm.userSignupSetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'policy') {
                            vm.userSignupModel.signup_policy = settingField.value;
                        }
                        if (settingField.name == 'allow_email_domains') {
                            vm.userSignupModel.allowed_email_addresses = settingField.value;
                        }
                        if (settingField.name == 'exclude_email_domains') {
                            vm.userSignupModel.restricted_email_addresses = settingField.value;
                        }
                        if (settingField.name == 'profile_attributes') {
                            vm.userSignupModel.profile_attributes = settingField.value;
                        }
                        if (settingField.name == 'security_role') {
                            vm.userSignupModel.security_role = settingField.value;
                        }
                    });
                }
            });
        }

        function setProfileModel(selectedUserFields) {
            if (selectedUserFields.field_groups && selectedUserFields.field_groups.length > 0) {
                vm.selectedUserFields = selectedUserFields.field_groups[0].fields; 
                vm.selectedUserFields = vm.selectedUserFields.filter(function (i) { 
                    return i.name !== 'email'; 
                }); 
            }
            else { 
                vm.selectedUserFields = vm.defaultSelectedUserFields;
            }
        }

        function setUserSignupSettings() {
    
            vm.userSignupModel.profile_attributes =  Array.prototype.map.call(vm.selectedUserFields, function(item) { return item.name; }).join(","); 

            setUserSignupSettingField("policy", vm.userSignupModel.signup_policy);
            setUserSignupSettingField("allow_email_domains", vm.userSignupModel.allowed_email_addresses);
            setUserSignupSettingField("exclude_email_domains", vm.userSignupModel.restricted_email_addresses);
            setUserSignupSettingField("profile_attributes", vm.userSignupModel.profile_attributes);
            setUserSignupSettingField("security_role", vm.selectedSecurityRole ? vm.selectedSecurityRole.id : '');
        }

        function setUserSignupSettingField(fieldName, fieldValue) {
            var foundField = false;
            angular.forEach(vm.userSignupSetting.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    if ( fieldName === "security_role" && fieldValue === "" ) { fieldValue = settingField.default_value; }
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.userSignupSetting.fields.push(settingField);
            }
        }

        vm.deleteFieldGroup = function(userField, index) {
            vm.selectedUserFields.splice(index,1);
        }

        vm.openAssignModal = function() {

            $mdDialog.show({
                templateUrl: 'modules/system/user-signup/user-field-picker.tmpl.html',
                clickOutsideToClose: true,
                controller: "UserFieldPickerController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    selectedUserFields: vm.selectedUserFields
                }
            }).then(function(selectedItems) {
              vm.addSelectedFields(selectedItems);
            });
        }

        vm.addSelectedFields = function(selectedItems) {
            angular.forEach(selectedItems, function(userField) {
                    vm.selectedUserFields.push(userField);
            });
        }

        vm.save = function() {

            if (vm.userSignupModel.signup_policy == 'specificEmailAddress' && 
                (vm.userSignupModel.allowed_email_addresses == null || vm.userSignupModel.allowed_email_addresses.length <= 0) && 
                (vm.userSignupModel.restricted_email_addresses == null || vm.userSignupModel.restricted_email_addresses.length <= 0)
                ) {
                ToastService.displayToast($filter('triTranslate')("atheer.userSignup.emailDomain"), 3000);
                return;
            } 

            if (vm.userSignupModel.signup_policy == 'specificEmailAddress' && 
                ( vm.userSignupModel.allowed_email_addresses != null && vm.userSignupModel.allowed_email_addresses.length > 0) && 
                ( vm.userSignupModel.restricted_email_addresses != null && vm.userSignupModel.restricted_email_addresses.length > 0)
            ) {
            ToastService.displayToast($filter('triTranslate')("atheer.userSignup.specifyEitherDomain"), 3000);
            return;
        } 

            setUserSignupSettings();

            Setting.update(vm.userSignupSetting, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"), 3000);
            });

            vm.loadData();
        }
        
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('UserFieldPickerController', UserFieldPickerController);

    /* @ngInject */
    function UserFieldPickerController($scope, $state, $mdDialog, Setting, ParseLinks, AlertService, $mdToast, $filter, MetaData, selectedUserFields) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "id";
        vm.selected = [];
        vm.allowMultiSelect = true; 
        vm.userFields = [];
        vm.selectedUserFields = selectedUserFields;

        vm.currentSelectedItems = [];
        vm.FIELDS_NOT_SUPPORTED_IN_SIGNUP = "user_no,preferred_name,initial_referrer_domain,timezone,login,email,status,picture_id,banner_id, event_summary,external_id,start_date,terminated_on, activated,deleted,activated_on, first_seen,last_seen,last_seen_ip,last_contacted,last_heard_from,activation_key,reset_key, reset_date,web_device,geoip_data,user_type,managed_audiences,browser_name,browser_version,browser_language, browser_os,manager,initial_referrer,initial_referrer_domaim,city,continent_code,country_code,country_name,latitude,longitude,postal_code,region_name";
 

        vm.loadAll();

        function loadAll() {
            MetaData.get({
                id: 'user',
                is_name: true,
                add_default_properties: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                if (data.field_groups && data.field_groups.length > 0) {
                    angular.forEach(data.field_groups[0].fields, function(userField) {
                        if ( ! vm.FIELDS_NOT_SUPPORTED_IN_SIGNUP.includes(userField.name) && userField.enabled === true ) {
                            var flist = $filter('filter')(vm.selectedUserFields, { name: userField.name }, true);
                            if ( flist === undefined || flist == '' ) {
                                vm.userFields.push(userField);
                            }
                        }
                    });
                }
                vm.page = 1;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
        }


        function getSortOrder() {
        }

        function getQueryString() {

        }

        function removeFilter() {

        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedItems);
        }

        vm.close = function() {
            $mdDialog.cancel();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
        .state('storm.system-admin.timezones', {
            url: '/timezones?page&sort&search',
            templateUrl: 'modules/system/timezone/timezones.html',
            controller: 'TimezoneController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.timezone.home.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false,
                    showToolbar: false,
                    showSideNavMenu: false,
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('TimezoneController', TimezoneController);

    /* @ngInject */
    function TimezoneController($scope, $state, Timezone, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams) {
        var vm = this;
        
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;

        function loadAll() {
            Timezone.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.timezones = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            vm.promise = Timezone.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.timezones = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SkinSettingController', SkinSettingController);


    /* @ngInject */
    function SkinSettingController($rootScope, $scope, $state, $q, $cookies, $window, $http, triTheming, $mdDialog, Setting, Content, $filter, ToastService, Feature) {
        var vm = this;
        var triThemingPalettes = angular.copy(triTheming.palettes);
        vm.skinSettings = [];
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.switchModel = true;
        vm.toolBarBackground = '';
        vm.emailLayouts = [];
        vm.skinModel = {
            logo_small: null,
            logo_big: null,
            logo_small_dark: null,
            logo_big_dark: null,
            favorite_icon: null,
            use_dark_logos: false,
            primary_color: 'teal',
            primary_color_hex: '#009688',
            primary_color_rgba: 'rgb(0, 188, 212)',
            secondary_color: 'orange',
            secondary_color_hex: '#ffab40',
            secondary_color_rgba: 'rgb(255,171,64)',
            email_layout: 100,
            logo_right: 'false',
            side_menu_state: 'CLOSED',
            side_menu: 'LIGHT'
        };
        vm.elementPrimaryColors = {
            logo: '',
            sidebar: '',
            content: '',
            toolbar: ''
        };
        vm.elementSecondaryColors = {
            logo: '',
            sidebar: '',
            content: '',
            toolbar: ''
        };

        function loadData() {
            vm.loadingData = true;

            $q.all([
                Setting.getSkinSettings().$promise,
                Content.query({
                    query: 'type==EMAIL_LAYOUT'
                }).$promise
            ])
                .then(function (results) {
                    setSkinModel(results[0]);
                    vm.loadingData = false;
                    vm.emailLayouts = results[1];
                    updatePreview();
                });
        };

        function setSkinModel(skinSettings) {
            angular.forEach(skinSettings, function (setting) {
                if (setting.category == 'skin_info') {
                    vm.skinSettings = setting;
                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.value != null) {
                            if (settingField.name == 'logo_small') {
                                vm.skinModel.logo_small = settingField.value;
                            }
                            if (settingField.name == 'logo_big') {
                                vm.skinModel.logo_big = settingField.value;
                            }
                            if (settingField.name == 'logo_small_dark') {
                                vm.skinModel.logo_small_dark = settingField.value;
                            }
                            if (settingField.name == 'logo_big_dark') {
                                vm.skinModel.logo_big_dark = settingField.value;
                            }
                            if (settingField.name == 'favorite_icon') {
                                vm.skinModel.favorite_icon = settingField.value;
                            }
                            if (settingField.name == 'use_dark_logos') {
                                if (settingField.value == 'true') {
                                    vm.skinModel.use_dark_logos = true;
                                } else {
                                    vm.skinModel.use_dark_logos = false;
                                }
                            }
                            if (settingField.name == 'primary_color') {
                                vm.skinModel.primary_color = settingField.value;
                            }
                            if (settingField.name == 'primary_color_rgba') {
                                vm.skinModel.primary_color_rgba = settingField.value;
                            }
                            if (settingField.name == 'primary_color_hex') {
                                vm.skinModel.primary_color_hex = settingField.value;
                            }
                            if (settingField.name == 'secondary_color') {
                                vm.skinModel.secondary_color = settingField.value;
                            }
                            if (settingField.name == 'secondary_color_hex') {
                                vm.skinModel.secondary_color_hex = settingField.value;
                            }
                            if (settingField.name == 'secondary_color_rgba') {
                                vm.skinModel.secondary_color_rgba = settingField.value;
                            }
                            if (settingField.name == 'email_layout') {
                                vm.skinModel.email_layout = settingField.value;
                            }
                            if (settingField.name == 'side_menu') {
                                vm.skinModel.side_menu = settingField.value;
                            }
                            if (settingField.name == 'logo_right') {
                                vm.skinModel.logo_right = settingField.value;
                            }
                            if (settingField.name == 'side_menu_state') {
                                vm.skinModel.side_menu_state = settingField.value;
                            }
                        }
                    });
                }
            });
            updatePreview();
        }

        function setSkinSettings() {
            setSettingField("logo_small", vm.skinModel.logo_small);
            setSettingField("logo_big", vm.skinModel.logo_big);
            setSettingField("logo_small_dark", vm.skinModel.logo_small_dark);
            setSettingField("logo_big_dark", vm.skinModel.logo_big_dark);

            if (vm.skinModel.use_dark_logos) {
                setSettingField("use_dark_logos", 'true');
            } else {
                setSettingField("use_dark_logos", false);
            }
            setSettingField("favorite_icon", vm.skinModel.favorite_icon);
            setSettingField("primary_color", vm.skinModel.primary_color);
            setSettingField("primary_color_hex", vm.skinModel.primary_color_hex);
            setSettingField("primary_color_rgba", vm.skinModel.primary_color_rgba);
            setSettingField("secondary_color", vm.skinModel.secondary_color);
            setSettingField("secondary_color_hex", vm.skinModel.secondary_color_hex);
            setSettingField("secondary_color_rgba", vm.skinModel.secondary_color_rgba);
            setSettingField("email_layout", vm.skinModel.email_layout);
            setSettingField("side_menu", vm.skinModel.side_menu);
            setSettingField("logo_right", vm.skinModel.logo_right);
            setSettingField("side_menu_state", vm.skinModel.side_menu_state);
            // setSettingField("lense_homepage_json_file", vm.lensHomepageConfigFile);
        }

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;
            angular.forEach(vm.skinSettings.fields, function (settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.skinSettings.fields.push(settingField);
            }
        }

        function updateSwitch() {
            setTimeout(function () {
                var toggleSwitch = document.getElementById('ui-preview-switch');
                if (toggleSwitch) {
                    var toggleSwitchBar = toggleSwitch.children[0].children[0];
                    var barBackgroundColor = vm.skinModel.secondary_color_rgba;
                    toggleSwitchBar.style.backgroundColor = barBackgroundColor;

                    var toggleSwitchRound = toggleSwitch.children[0].children[1].children[0];
                    var roundBackgroundColor = vm.skinModel.secondary_color_rgba;
                    toggleSwitchRound.style.backgroundColor = roundBackgroundColor;
                }
            }, 300);
        }

        function updatePreview() {
            for (var element in vm.elementPrimaryColors) {
                var color = triTheming.getPaletteColor(vm.skinModel.primary_color, '500');
                vm.elementPrimaryColors[element] = vm.skinModel.primary_color_hex;
            }
            for (var element in vm.elementSecondaryColors) {
                var color = triTheming.getPaletteColor(vm.skinModel.secondary_color, '500');
                vm.elementSecondaryColors[element] = vm.skinModel.secondary_color_hex;
            }
            vm.toolBarBackground = vm.skinModel.primary_color_rgba;
            updateSwitch();
        }

        function saveSettings() {
            Setting.update(vm.skinSettings, function (result) {
                vm.skinSettings = result;
                ToastService.displayToastWithAction($filter('triTranslate')("atheer.setting.success"),
                    $filter('translate')('entity.action.refresh'), 'md-accent', '', function (response) {
                        if (response == 'ok') {
                            $window.location.reload();
                        }
                    });
            });
        }

        vm.trySkin = function () {
            if (vm.selectedSkin !== triSkins.getCurrent()) {
                $cookies.put('storm-skin', angular.toJson({
                    skin: vm.selectedSkin.id
                }));
                $window.location.reload();
            }
        }

        vm.save = function () {
            setSkinSettings();
            updatePreview();
            saveSettings();
        }

        $scope.$watch('vm.skinModel.primary_color_hex', function (newVal) {
            var color = tinycolor(newVal);
            var colorName = null;
            var colorHexString = color.toHexString();

            angular.forEach(triThemingPalettes, function (item, key) {
                if (item['500'].hex == colorHexString) {
                    colorName = key;
                }
            });

            if (colorName == null || colorName === 'custom-secondary-color') {
                colorName = 'custom-primary-color';
            };

            vm.skinModel.primary_color = colorName;
            vm.skinModel.primary_color_rgba = color.toRgbString();
            updatePreview();
        });

        $scope.$watch('vm.skinModel.secondary_color_hex', function (newVal) {
            var color = tinycolor(newVal);
            var colorName = null;
            var colorHexString = color.toHexString();

            angular.forEach(triThemingPalettes, function (item, key) {
                if (item['500'].hex == colorHexString) {
                    colorName = key;
                }
            });

            if (colorName == null || colorName === 'custom-primary-color') {
                colorName = 'custom-secondary-color';
            };

            vm.skinModel.secondary_color = colorName;
            vm.skinModel.secondary_color_rgba = color.toRgbString();
            updatePreview();
        });

        $scope.$watch('vm.skinModel.side_menu', function (newVal) {
            updatePreview();
        });

        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SessionSettingController', SessionSettingController)

    /* @ngInject */
    function SessionSettingController($mdDialog, $q, $scope, $filter, $sce, ParseLinks, $state, AlertService, ContentAction, $mdToast, $mdSidenav, Principal, Setting, Feature, ToastService) {
        var vm = this;

        vm.sessionSetting = [];
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.loadingData = false;
        vm.timezones = [];
        vm.templates = [];
        vm.hrs = [];
        vm.minutes = [0, 15, 30, 45];
        vm.repeats = [];
        vm.possible_recurring_session = ["Daily", "Weekly", "Monthly", "No Fixed Time"];
        vm.timeslots = [];
        vm.days = [{name: "Sun", isSelected: false},
            {name: "Mon", isSelected: false},
            {name: "Tue", isSelected: false},
            {name: "Wed", isSelected: false},
            {name: "Thu", isSelected: false},
            {name: "Fri", isSelected: false},
            {name: "Sat", isSelected: false}];
        vm.weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        vm.frequencyDays = ["First", "Second", "Third", "Fourth", "Last"];
        vm.AMPM = ["AM", "PM"];
        vm.sessionSetting = [];
        vm.numOfdays = [];
        vm.enableWaitingRoom = false;
        vm.recurringSessionFeature = Feature.isActive('feature_airsession_recurring_session');

        vm.sessionModel = {
            id: null,
            host_video: false,
            participant_video: false,
            join_before_host: false,
            mute_upon_entry: false,
            sign_in_required: false,
            enable_waiting_room: false,
            record_session: false,
            recurring_Session: false,
            enable_external_survey: false,
            timezone_id: "1007",
            external_survey_url: "",
            wearable_external_survey_url: ""
        };

        vm.onSaveSuccess = function(result) {
            vm.sessionModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        function setSessionSettings() {
            setSessionSettingField("host_video", vm.sessionModel.host_video);
            setSessionSettingField("participant_video", vm.sessionModel.participant_video);
            setSessionSettingField("join_before_host", vm.sessionModel.join_before_host);
            setSessionSettingField("mute_upon_entry", vm.sessionModel.mute_upon_entry);
            setSessionSettingField("sign_in_required", vm.sessionModel.sign_in_required);
            setSessionSettingField("enable_waiting_room", vm.sessionModel.enable_waiting_room);
            setSessionSettingField("record_session", vm.sessionModel.record_session);
            setSessionSettingField("recurring_Session", vm.sessionModel.recurring_Session);
            setSessionSettingField("timezone_id", vm.sessionModel.timezone_id);
            setSessionSettingField("enable_external_survey", vm.sessionModel.enable_external_survey);
            setSessionSettingField("external_survey_url", vm.sessionModel.external_survey_url);
            setSessionSettingField("wearable_external_survey_url", vm.sessionModel.wearable_external_survey_url);
        }

        function setSessionSettingField(fieldName, fieldValue) {
            var foundField = false;
            angular.forEach(vm.sessionSetting.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.sessionSetting.fields.push(settingField);
            }
        }

        vm.save = function() {
            setSessionSettings();

            Setting.update(vm.sessionSetting, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"), 3000);
            });
        }



        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getSystemTimezones({
                            size: 100
                        }).$promise,
                    Setting.getSessionSettings().$promise
                ])
                .then(function(results) {
                    vm.timezones = results[0];
                    setSettingSessionModel(results[1]);
                    vm.loadingData = false;
                });
        };

        function setSettingSessionModel(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'session_setting') {
                    vm.sessionSetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'host_video') {
                            if (settingField.value == "false")
                                vm.sessionModel.host_video = false;
                            else
                                vm.sessionModel.host_video = true;
                        }
                        if (settingField.name == 'participant_video') {
                            if (settingField.value == "false")
                                vm.sessionModel.participant_video = false;
                            else
                                vm.sessionModel.participant_video = true;
                        }
                        if (settingField.name == 'join_before_host') {
                            if (settingField.value == "false")
                                vm.sessionModel.join_before_host = false;
                            else
                                vm.sessionModel.join_before_host = true;
                        }
                        if (settingField.name == 'mute_upon_entry') {
                            if (settingField.value == "false")
                                vm.sessionModel.mute_upon_entry = false;
                            else
                                vm.sessionModel.mute_upon_entry = true;
                        }
                        if (settingField.name == 'sign_in_required') {
                            if (settingField.value == "false")
                                vm.sessionModel.sign_in_required = false;
                            else
                                vm.sessionModel.sign_in_required = true;
                        }
                        if (settingField.name == 'enable_waiting_room') {
                            if (settingField.value == "false")
                                vm.sessionModel.enable_waiting_room = false;
                            else
                                vm.sessionModel.enable_waiting_room = true;
                        }
                        if (settingField.name == 'record_session') {
                            if (settingField.value == "false")
                                vm.sessionModel.record_session = false;
                            else
                                vm.sessionModel.record_session = true;
                        }
                        if (settingField.name == 'recurring_Session') {
                            if (settingField.value == "false")
                                vm.sessionModel.recurring_Session = false;
                            else
                                vm.sessionModel.recurring_Session = true;
                        }
                        if (settingField.name == 'timezone_id') {
                            vm.sessionModel.timezone_id = settingField.value;
                        }
                        if (settingField.name == 'external_survey_url') {
                            if (settingField.value)
                                vm.sessionModel.external_survey_url = settingField.value;
                            else
                                vm.sessionModel.external_survey_url = "";
                        }
                        if (settingField.name == 'wearable_external_survey_url') {
                            if (settingField.value)
                                vm.sessionModel.wearable_external_survey_url = settingField.value;
                            else
                                vm.sessionModel.wearable_external_survey_url = "";
                        }
                        if (settingField.name == 'enable_external_survey') {
                            if (settingField.value == "false")
                                vm.sessionModel.enable_external_survey = false;
                            else
                                vm.sessionModel.enable_external_survey = true;
                        }
                    });
                }
            });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-setting.security-roles', {
                url: '/security-roles?page&sort&search',
                templateUrl: 'modules/system/security-role/security-roles.html',
                controller: 'SecurityRoleController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.securityRole.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-setting.security-role-detail', {
                url: '/security-roles/:id',
                templateUrl: 'modules/system/security-role/security-role-detail.tmpl.html',
                controller: 'SecurityRoleDetailController as vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SecurityRoleController', SecurityRoleController);

    /* @ngInject */
    function SecurityRoleController($scope, $state, triSettings, SecurityRole, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, PermissionService, $filter) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.permissions = {
            create : 'manage-security-role-system',
            update : 'manage-security-role-system',
            delete : 'manage-security-role-system',
            manage : 'manage-security-role-system'
        };

        vm.hasDeletePermission = PermissionService.hasAccess(vm.permissions.manage);

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function loadAll() {
            SecurityRole.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.securityRoles = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            vm.promise = SecurityRole.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.securityRoles = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject() {
            $state.go('storm.admin-setting.security-role-detail');
        }

        function editObject(objectId) {
            $state.go('storm.admin-setting.security-role-detail', {
                'id': objectId
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.securityRole.deleteObject'))
                .ariaLabel($filter('translate')('atheer.securityRole.deleteObject'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                SecurityRole.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return 'acl==false';
            } else {
                return 'acl==false;name=re=' + vm.query.filter;
            }
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        }

        vm.removeFilter = function() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        };

        vm.openAssignModal = function(securityRole) {
            $mdDialog.show({
                templateUrl: 'modules/system/security-role/security-role-assign-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "SecurityRoleAssignController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    securityRole: securityRole,
                    userId: undefined
                }
            });
        }
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SecurityRolePickerController', SecurityRolePickerController);

    /* @ngInject */
    function SecurityRolePickerController($scope, $state, $mdDialog, SecurityRole, ParseLinks, AlertService, $mdToast, $filter, filter, allowMultiSelect, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "id";
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.selected = [];
        vm.allowMultiSelect = allowMultiSelect;

        vm.currentSelectedItems = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.getQueryString = getQueryString;

        vm.loadAll();

        function loadAll() {
            SecurityRole.query({
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = ['id' + ',' + 'asc'];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.securityRoles = data;
                vm.page = 1;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = SecurityRole.query({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: getSortOrder(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.securityRoles = data;
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return null;
            } else {
                return 'name=re="' + vm.query.filter +'"';
            }
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedItems);
        }

        vm.close = function() {
            $mdDialog.cancel();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SecurityRoleDetailController', SecurityRoleDetailController)

    /* @ngInject */
    function SecurityRoleDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, SecurityRole, id, Experience, MetaData) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.securityRoleModel = null;
        vm.view = "PERMISSIONS";
        vm.allMetaObjects = [];
        vm.userSecurityRoles = []
        vm.illustartionEmptyScreenId = "security_role_user";

        vm.jobRole = "Standard Role";
        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };
        vm.isJobRole = function (label) {
            if(vm.jobRole === 'Job Role' && label === "Job") {
               return false;
            } else if(vm.jobRole === 'AiRForm Role' && label === "AiRForm") {
                return false;
            } else if(vm.jobRole !== 'Job Role') {
                return false;
            }
            return true;
        }
        vm.onRoleChange = function () {
            if(vm.securityRoleModel === null) {
                vm.securityRoleModel = {};
            }
            if(vm.jobRole === 'Standard Role') {
                vm.securityRoleModel['acl'] = false;
                vm.securityRoleModel['resource'] = "";
            }else if(vm.jobRole === 'Job Role') {
                vm.securityRoleModel['acl'] = true;
                vm.securityRoleModel['resource'] = "job";
                clearAllJobRoleSettings();
            }else if(vm.jobRole === 'AiRForm Role') {
                vm.securityRoleModel['acl'] = true;
                vm.securityRoleModel['resource'] = "applet";
                clearAllJobRoleSettings();
            }
        }

        vm.removeUserSecurityRole = function(securityRole, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.securityRole.removeSecurityRole'))
                .ariaLabel($filter('translate')('atheer.securityRole.removeSecurityRole'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Experience.deleteSecurityRole({
                    id: securityRole.id
                }, function() {
                    vm.userSecurityRoles.splice(index, 1);
                });
            });
        }

        if (id) {
            vm.loadingData = true;
            SecurityRole.get({
                id: id
            }, function(result) {
                vm.securityRoleModel = result;
                if (!vm.securityRoleModel.permissions) {
                    vm.securityRoleModel.permissions = [];
                }
                if(vm.securityRoleModel.acl && vm.securityRoleModel.resource === 'job') {
                    vm.jobRole = "Job Role";
                    vm.securityRoleModel['resource'] = "job";
                } else if (vm.securityRoleModel.acl && vm.securityRoleModel.resource === 'applet') {
                    vm.jobRole = "AiRForm Role";
                    vm.securityRoleModel['resource'] = "applet";
                }
                else {
                    vm.jobRole = "Standard Role";
                }
                vm.loadUserSecurityRoles();
                vm.loadAllPermissions();
            });
        }

        vm.openAssignModal = function() {
            var users = [];
            if (vm.userSecurityRoles != null) {
                for (var i = 0; i < vm.userSecurityRoles.length; i++) {
                    users.push(vm.userSecurityRoles[i].user_info);
                }
            }

            $mdDialog.show({
                templateUrl: 'modules/system/security-role/security-role-assign-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "SecurityRoleAssignController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    securityRole: vm.securityRoleModel,
                    userId: undefined,
                    users: users
                }
            }).then(function() {
                vm.loadUserSecurityRoles();
            });
        }

        vm.isAllPermissionChecked = function(objectMeta) {
            var objectPermission = 0;
            for (var i = 0, len = vm.securityRoleModel.permissions.length; i < len; i++) {
                if (vm.securityRoleModel.permissions[i].object_name == objectMeta.name) {
                    objectPermission++;
                }
            }
            return objectPermission == objectMeta.permissions.length;
        }

        vm.isAllPermissionIndeterminate = function(objectMeta) {
            var objectPermission = 0;
            for (var i = 0, len = vm.securityRoleModel.permissions.length; i < len; i++) {
                if (vm.securityRoleModel.permissions[i].object_name == objectMeta.name) {
                    objectPermission++;
                }
            }
            return (objectPermission !== 0 &&
                objectPermission !== objectMeta.permissions.length);
        }

        function clearAllJobRoleSettings() {
            for (var j = 0; j < vm.allMetaObjects.length; j++) {
                for (var i = 0, len = vm.allMetaObjects[j].permissions.length; i < len; i++) {
                    if(vm.allMetaObjects[j].label !== "Job") {
                        var permissionInfo = {
                            object_name: vm.allMetaObjects[j].name,
                            permission_name: vm.allMetaObjects[j].permissions[i].name
                        };

                        var idx = getPermissionIndex(permissionInfo);
                        if (idx > -1) {
                            vm.securityRoleModel.permissions.splice(idx, 1);
                        }
                    }
                }
            }
        }
        vm.toggleAllPermissions = function(objectMeta) {
            var objectPermission = 0;
            for (var i = 0, len = vm.securityRoleModel.permissions.length; i < len; i++) {
                if (vm.securityRoleModel.permissions[i].object_name == objectMeta.name) {
                    objectPermission++;
                }
            }

            if (objectPermission == objectMeta.permissions.length) {
                for (var i = 0, len = objectMeta.permissions.length; i < len; i++) {
                    var permissionInfo = {
                        object_name: objectMeta.name,
                        permission_name: objectMeta.permissions[i].name
                    };

                    var idx = getPermissionIndex(permissionInfo);
                    if (idx > -1) {
                        vm.securityRoleModel.permissions.splice(idx, 1);
                    }
                }
            } else {
                for (var i = 0, len = objectMeta.permissions.length; i < len; i++) {
                    var permissionInfo = {
                        object_name: objectMeta.name,
                        permission_name: objectMeta.permissions[i].name
                    };
                    var idx = getPermissionIndex(permissionInfo);
                    if (idx == -1) {
                        vm.securityRoleModel.permissions.push(permissionInfo);
                    }
                }
            }
        }

        vm.permissionExist = function(objectMeta, objectPermission) {
            var permissions = vm.securityRoleModel.permissions;
            var permissionInfo = {
                object_name: objectMeta.name,
                permission_name: objectPermission.name
            };

            for (var i = 0, len = permissions.length; i < len; i++) {
                if (permissionInfo.object_name == permissions[i].object_name && permissionInfo.permission_name == permissions[i].permission_name) {
                    return true;
                }
            }
            return false;
        }

        vm.togglePermission = function(objectMeta, permission) {
            var permissions = vm.securityRoleModel.permissions;
            var permissionInfo = {
                object_name: objectMeta.name,
                permission_name: permission.name
            };

            if (permissions) {
                var idx = getPermissionIndex(permissionInfo);
                if (idx > -1) {
                    permissions.splice(idx, 1);
                } else {
                    permissions.push(permissionInfo);
                }
            } else {
                permissions = [];
                permissions.push(permissionInfo);
            }
        }

        function getPermissionIndex(permissionInfo) {
            var index = -1;
            for (var i = 0, len = vm.securityRoleModel.permissions.length; i < len; i++) {
                if (permissionInfo.object_name == vm.securityRoleModel.permissions[i].object_name && permissionInfo.permission_name == vm.securityRoleModel.permissions[i].permission_name) {
                    index = i;
                }
            }
            return index;
        }

        function showMetaObject(atheerObject) {
            var name = atheerObject.name;
            if(name == 'cloud' || name == 'skill' || name == 'media' || name == 'provider' || name == 'sharing-theme' || name == 'content-field' || name == 'feed') {
                return false;
            } else {
                return true;
            }
        }

        vm.loadAllPermissions = function() {
            MetaData.query({
                page: pagingParams.page - 1,
                size: 100,
                query: getQuery()
            }, function(response, headers) {
                vm.allMetaObjects = [];
                angular.forEach(response, function(atheerObject) {
                    if (atheerObject.permissions && atheerObject.permissions.length > 0 && showMetaObject(atheerObject)) {
                        vm.allMetaObjects.push(atheerObject);
                    }
                });
                vm.loadingData = false;
            });
        }

        vm.loadUserSecurityRoles = function() {
            Experience.getSecurityRoles({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                query: getUserQueryString(),
                user_info: true
            }, function(response, headers) {
                vm.userSecurityRoles = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
            });
        }

        vm.transitionUserSecurityRoles = function() {
            vm.promise = Experience.getSecurityRoles({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                query: getUserQueryString(),
                user_info: true
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.userSecurityRoles = response;
            });
        }

        function getUserQueryString() {
            var queryString = "object_id==" + vm.securityRoleModel.id;
            return queryString;
        }

        vm.onSaveSuccess = function(result) {
            vm.securityRoleModel = result;
            if (!vm.securityRoleModel.permissions) {
                vm.securityRoleModel.permissions = [];
            }
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            if (vm.securityRoleModel.id) {
                SecurityRole.update(vm.securityRoleModel, vm.onSaveSuccess, vm.onSaveError);
            } else {
                SecurityRole.save(vm.securityRoleModel, vm.onSaveSuccess, vm.onSaveError);
                vm.loadAllPermissions();
            }
        };

        vm.goToSecurityRoles = function() {
            $state.go('storm.admin-setting.security-roles');
        };

        vm.isNew = function() {
            if (vm.securityRoleModel == undefined || vm.securityRoleModel.id == null) {
                return true;
            } else {
                return false;
            }
        }

        vm.copySecurityRole = function() {
            delete vm.securityRoleModel['id'];
            vm.securityRoleModel.locked = false;
            vm.securityRoleModel.name = "Copy Of " + vm.securityRoleModel.name;
        }

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };

        function getQuery() {
            var query = "label=out=(Assignment,Organization,Context)";
            return query;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SecurityRoleAssignController', SecurityRoleAssignController);

    /* @ngInject */
    function SecurityRoleAssignController($scope, $state, $mdDialog, $q, $filter, $timeout, securityRole, userId, users, Experience, User, SecurityRole, ToastService) {
        var vm = this;

        vm.asyncUsers = users;
        vm.existingUsers = [];
        if (vm.asyncUsers.length != 0) {
            angular.forEach(vm.asyncUsers, function(user) {
                vm.existingUsers.push(user.id);
            });
        }
        vm.asyncSecurityRoles = [];
        vm.securityRole = securityRole;
        vm.fromProfilePage = userId != undefined;
        vm.searchUser = searchUser;

        vm.searchSecurityRole = searchSecurityRole;

        vm.transformChip = function(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
        }

        function getSecurityRoleQueryString(criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'name=re=' + criteria;
            }
        }

        function searchSecurityRole(criteria) {
            var d = $q.defer();
            var result = SecurityRole.query({
                query: getSecurityRoleQueryString(criteria)
            }, function(result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function getQueryString(criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return '(first_name=re="{searchString}",last_name=re="{searchString}",email=re="{searchString}")'.replaceAll("{searchString}", criteria);
            }
        }

        function searchUser(criteria) {
            var d = $q.defer();
            var result = User.query({
                query: getQueryString(criteria)
            }, function(result) {
                d.resolve(result);
            });
            return d.promise;
        }

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.submit = function() {
            var userSecurityRoles = [];
            if (!vm.fromProfilePage) {
                angular.forEach(vm.asyncUsers, function(user) {
                    userSecurityRoles.push({
                        user_id: user.id,
                        object: vm.securityRole,
                        assigned_on: new Date()
                    });
                });
            } else {
                angular.forEach(vm.asyncSecurityRoles, function(securityRole) {
                    userSecurityRoles.push({
                        user_id: userId,
                        object: securityRole,
                        assigned_on: new Date()
                    });
                });
            };

            Experience.bulkSecurityRole(userSecurityRoles, function(result) {
                ToastService.displayToast($filter('triTranslate')("assignSecurityRole.assignedSuccessfull"), 3000);
                $mdDialog.hide();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('NotificationController', NotificationController);

    /* @ngInject */
    function NotificationController($scope, $state, Notification, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $filter, $stateParams, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.reOrder = reOrder;

        vm.query = {
            filter: '',
            limit: '100',
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;

        vm.editObject = editObject;

        vm.loadAll();

        function loadAll() {
            vm.loadingData = true;

            Notification.query({
                page: pagingParams.page - 1,
                size: 100,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.notifications = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return 'purpose==Generic;name=out=(conversationSendMessage,conversationUserInvite)';
            } else {
                return 'purpose==Generic;name=out=(conversationSendMessage,conversationUserInvite);name=re=' + vm.query.filter;
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.reverse = !vm.reverse;
            vm.transition();
        }

        function transition() {
            vm.promise = Notification.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.notifications = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function editObject(objectId) {
            $state.go('storm.admin-notification-detail', {
                'id': objectId
            });
        }

        function resetModal() {
            loadAll();
        };

        vm.toggleEmail = function(notification) {
            Notification.update(notification, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePush = function(notification) {
            Notification.update(notification, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.toggleMessage = function(notification) {
            Notification.update(notification, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.onSaveSuccess = function(result) {
            resetModal();
        };

        vm.onSaveError = function() {};

        vm.testNotification = function(objectId) {
            Notification.test({
                id: objectId
            }, function(result) {
                ToastService.displayToast($filter('triTranslate')("atheer.notification.testNotificationSuccess"), 3000);
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('NotificationDetailController', NotificationDetailController)

    /* @ngInject */
    function NotificationDetailController($mdDialog, $scope, $filter, $sce, $state, $stateParams, AlertService, $mdToast, $mdSidenav, Notification, id, ToastService) {
        var vm = this;

        vm.notificationModel = null;
        vm.selectedLanguage = "en_US";
        vm.email_subject = null;
        vm.email_body = null;
        vm.push_title = null;
        vm.push_body = null;
        vm.bot_title = null;
        vm.bot_body = null;
        vm.message_title = null;
        vm.message_body = null;
        vm.sms_title = null;
        vm.sms_body = null;

        vm.languages = [
            { name: 'english_us', displayName: 'English (US)', value: 'en_US', serverKey: 'en_US' },
            { name: 'english_uk', displayName: 'English (UK)', value: 'en_GB', serverKey: 'en_GB' },
            { name: 'french', displayName: 'French', value: 'fr_FR', serverKey: 'fr_FR' },
            { name: 'german', displayName: 'German', value: 'de_DE', serverKey: 'de_DE' },
            { name: 'greek', displayName: 'Greek', value: 'el_GR', serverKey: 'el_GR' },
            { name: 'italian', displayName: 'Italian', value: 'it_IT', serverKey: 'it_IT' },
            { name: 'japanese', displayName: 'Japanese', value: 'ja_JP', serverKey: 'ja_JP' },
            { name: 'portuguese', displayName: 'Portuguese', value: 'pt_BR', serverKey: 'pt_BR' },
            { name: 'spanish', displayName: 'Spanish', value: 'es_CL', serverKey: 'es_CL' },
            { name: 'chinese', displayName: 'Chinese (Traditional)', value: 'zh_TW', serverKey: 'zh_TW' },
            { name: 'chinese_cn', displayName: 'Chinese (Simplified)', value: 'zh_CN', serverKey: 'zh_CN' },
            { name: 'dutch', displayName: 'Dutch', value: 'nl_NL', serverKey: 'nl_NL' },
            { name: 'danish', displayName: 'Danish (Denmark)', value: 'da_DK', serverKey: 'da_DK' },
            { name: 'norwegian', displayName: 'Norwegian', value: 'no_NO', serverKey: 'no_NO' },
            { name: 'polish', displayName: 'Polish (Poland)', value: 'pl_PL', serverKey: 'pl_PL' },
            { name: 'russian', displayName: 'Russian', value: 'ru_RU', serverKey: 'ru_RU' },
            { name: 'swedish', displayName: 'Swedish (Sweden)', value: 'sv_SE', serverKey: 'sv_SE' },
            { name: 'turkish', displayName: 'Turkish (Turkey)', value: 'tr_TR', serverKey: 'tr_TR' }
        ];

        vm.languages.sort(function (a, b) {
            if (a['displayName'] > b['displayName']) {
                return 1;
            } else if (a['displayName'] < b['displayName']) {
                return -1;
            }
            return 0;
        });

        vm.froalaOptions = {
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'entities', 'fontFamily', 'fontSize', 'fullscreen', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quote', 'save', 'table', 'url'],
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'quote', 'insertHR', 'insertLink', 'insertTable', '|', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html', 'applyFormat', 'removeFormat', 'fullscreen', 'print', 'help'],
            charCounterMax: -1,
            heightMin: 450,
            heightMax: 450,
            placeholderText: $filter('translate')('global.enterTextHerePlaceholder'),
            htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'th:if']
        };

        if (id) {
            vm.loadingData = true;
            Notification.get({
                id: id
            }, function (result) {
                vm.notificationModel = result;
                setNotificationFields(result);
            });
        }

        vm.onSaveSuccess = function (result) {
            vm.notificationModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            if (vm.froalaOptions.froalaEditor.codeView.isActive()) {
                vm.froalaOptions.froalaEditor.codeView.toggle();
                setTimeout(vm.save, 1000);
                return;
            }
            setNotificationModel();
            Notification.update(vm.notificationModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.goToNotifications = function () {
            $state.go("storm.admin-setting.notifications");
        };

        vm.updateLanguage = function () {
            setNotificationFields();
        };

        function setNotificationFields() {
            if (vm.selectedLanguage == "en_US") {
                vm.email_subject = vm.notificationModel.email_subject;
                vm.email_body = vm.notificationModel.email_body;
                vm.push_title = vm.notificationModel.push_title;
                vm.push_body = vm.notificationModel.push_body;
                vm.bot_title = vm.notificationModel.bot_title;
                vm.bot_body = vm.notificationModel.bot_body;
                vm.message_title = vm.notificationModel.message_title;
                vm.message_body = vm.notificationModel.message_body;
                vm.sms_title = vm.notificationModel.sms_title;
                vm.sms_body = vm.notificationModel.sms_body;
            } else {
                vm.email_subject = getFieldValue(vm.notificationModel.email_subject_language, vm.notificationModel.email_subject);
                vm.email_body = getFieldValue(vm.notificationModel.email_body_language, vm.notificationModel.email_body);
                vm.push_title = getFieldValue(vm.notificationModel.push_title_language, vm.notificationModel.push_title);
                vm.push_body = getFieldValue(vm.notificationModel.push_body_language, vm.notificationModel.push_body);
                vm.bot_title = getFieldValue(vm.notificationModel.bot_title_language, vm.notificationModel.bot_title);
                vm.bot_body = getFieldValue(vm.notificationModel.bot_body_language, vm.notificationModel.bot_body);
                vm.message_title = getFieldValue(vm.notificationModel.message_title_language, vm.notificationModel.message_title);
                vm.message_body = getFieldValue(vm.notificationModel.message_body_language, vm.notificationModel.message_body);
                vm.sms_title = getFieldValue(vm.notificationModel.sms_title_language, vm.notificationModel.sms_title);
                vm.sms_body = getFieldValue(vm.notificationModel.sms_body_language, vm.notificationModel.sms_body);
            };
        };

        function setNotificationModel() {
            if (vm.selectedLanguage == "en_US") {
                vm.notificationModel.email_subject = vm.email_subject;
                vm.notificationModel.email_body = vm.email_body;
                vm.notificationModel.push_title = vm.push_title;
                vm.notificationModel.push_body = vm.push_body;
                vm.notificationModel.bot_title = vm.bot_title;
                vm.notificationModel.bot_body = vm.bot_body;
                vm.notificationModel.message_title = vm.message_title;
                vm.notificationModel.message_body = vm.message_body;
                vm.notificationModel.sms_title = vm.sms_title;
                vm.notificationModel.sms_body = vm.sms_body;
            } else {
                vm.notificationModel.email_subject_language = setFieldValue(vm.notificationModel.email_subject_language, vm.email_subject);
                vm.notificationModel.email_body_language = setFieldValue(vm.notificationModel.email_body_language, vm.email_body);
                vm.notificationModel.sms_title_language = setFieldValue(vm.notificationModel.sms_title_language, vm.sms_title);
                vm.notificationModel.sms_body_language = setFieldValue(vm.notificationModel.sms_body_language, vm.sms_body);
            };
        };

        function getFieldValue(field, defaultFieldValue) {
            if (field && field[vm.selectedLanguage]) {
                return field[vm.selectedLanguage];
            } else {
                return defaultFieldValue;
            };
        };

        function setFieldValue(field, fieldValue) {
            if (field && field[vm.selectedLanguage]) {
                field[vm.selectedLanguage] = fieldValue;
            } else if (field) {
                field[vm.selectedLanguage] = fieldValue;
            } else {
                field = {};
                field[vm.selectedLanguage] = fieldValue;
            };
            return field;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('FieldGroupDialogController', FieldGroupDialogController);

    /* @ngInject */
    function FieldGroupDialogController($scope, $stateParams, $mdDialog, fieldGroup, isAdd, _) {
        var vm = this;
        vm.fieldGroup = fieldGroup;
        vm.isAdd = isAdd;

        vm.add = function() {
            $mdDialog.hide(vm.fieldGroup);
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };

        vm.setFieldGroupName = function() {
            if ( vm.isAdd ) {
                vm.fieldGroup.name = _.underscored(vm.fieldGroup.label);
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('FieldDialogController', FieldDialogController);

    /* @ngInject */
    function FieldDialogController($scope, $stateParams, $mdDialog, field, isAdd, _) {
        var vm = this;
        vm.field = field;
        vm.isAdd = isAdd;

        vm.add = function () {
            $mdDialog.hide(vm.field);
        };

        vm.clear = function () {
            $mdDialog.cancel();
        };

        vm.setFieldName = function () {
            if ( vm.isAdd ) {
                vm.field.name = _.underscored(vm.field.label);
            }
        }

        vm.removeOption = function (index) {
            vm.field.list_options.splice(index, 1);
        }

        vm.copyOption = function (item) {
            var option = angular.copy(item);
            item.option_id = Math.floor((Math.random() * 10000) + 1);
            vm.field.list_options.push(option);
        }

        vm.addNewOption = function () {
            if (vm.field.list_options == null || vm.field.list_options == undefined) {
                vm.field.list_options = [];
            }
            vm.field.list_options.push({
                label: null,
                description: null,
                option_id: Math.floor((Math.random() * 10000) + 1)
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('storm.admin-media', {
            url: '/media?page&sort&search',
            templateUrl: 'modules/system/media/media.html',
            controller: 'MediaController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.media.home.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                isPickerView: [function() {
                    return false;
                }],
                isMultiple: [function() {
                    return false;
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('MediaController', MediaController);

    /* @ngInject */
    function MediaController($scope, $state, $translate, isPickerView, isMultiple, Media, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.removeFilter = removeFilter;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;
        vm.getQueryString = getQueryString;

        vm.getUrl = getUrl;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.isPickerView = isPickerView;
        vm.isMultiple = isPickerView && isMultiple;
        vm.currentMedia = [];

        vm.permissions = {
            create : 'create-media',
            update : 'update-media',
            delete : 'delete-media',
            manage : 'manage-media'
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.isMultiple ? vm.currentMedia : vm.currentMedia[0]);
        }


        function loadAll() {
            Media.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.media = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.reverse = !vm.reverse;
            vm.transition();
        }

        function transition() {
            var sortColumn = (vm.predicate.startsWith("-") ? vm.predicate.slice(1) : vm.predicate);
            vm.promise = Media.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sortColumn + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.media = data;
            });
        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return null;
            } else {
                return 'name=re=' + vm.query.filter;
            }
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            vm.loadAll();
        }

        function createObject() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/system/media/media-dialog.html',
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return undefined;
                    }
                }
            }).then(function() {
                resetModal();
            });
        }

        function editObject(objectId) {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/system/media/media-dialog.html',
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['Media', function(Media) {
                        return Media.get({
                            id: objectId
                        });
                    }]
                }
            }).then(function() {
                resetModal();
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this Media?')
                .ariaLabel('Are you sure you want to delete this Media?')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                Media.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        function getUrl(media) {
            if (media.type == 'IMAGE') {
                var fileExtension = media.source_file_name.substr(media.source_file_name.lastIndexOf('.') + 1);
                return media.id + '.' + fileExtension;
            } else {
                return null;
            }
        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .filter('mediaUrl', mediaUrl);

    function mediaUrl() {
        return mediaUrl;

        function mediaUrl (input) {
            if (input == null || input == undefined || input == '') {
                return;
            } else {
                if(input.startsWith("http")) {
                    return input;
                } else {
                    return '/media/images/' + input;
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('MediaDialogController', MediaDialogController);

    /* @ngInject */    
    function MediaDialogController ($scope, $stateParams, $mdDialog, entity, Media) {
        var vm = this;
        vm.media = entity;
        vm.load = function(id) {
            Media.get({id : id}, function(result) {
                vm.media = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('atheer:mediaUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.media.id !== null) {
                Media.update(vm.media, onSaveSuccess, onSaveError);
            } else {
                Media.save(vm.media, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.system-admin.locales', {
                url: '/locales?page&sort&search',
                templateUrl: 'modules/system/locale/locales.html',
                controller: 'LocaleController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.locale.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LocaleController', LocaleController);

    /* @ngInject */
    function LocaleController ($scope, $state, Locale, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        vm.query = {
                filter: '',
                limit: paginationConstants.itemsPerPage,
                order: '-id',
                page: 1
            };

        vm.filter = {
                options: {
                    debounce: 500
                }
            };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;

        vm.createObject=createObject;
        vm.editObject=editObject;
        vm.deleteObject=deleteObject;

        function loadAll () {
            Locale.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.locales = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition () {
            vm.promise = Locale.query({
        				page: vm.page-1,
        				size: paginationConstants.itemsPerPage,
        				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        				search: vm.currentSearch
      			  }).$promise;

            vm.promise.then(function (data,headers) {
              vm.queryCount = vm.totalItems;
              vm.locales = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if(vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject() {
      			$mdDialog.show({
      				animation : true,
      				templateUrl : 'modules/system/locale/locale-dialog.html',
      				controller : 'LocaleDialogController',
      				controllerAs : 'vm',
      				backdrop : 'static',
      				size : 'lg',
              resolve: {
                  entity: function () {
                      return {
                          localeNo: null,
                          name: null,
                          description: null,
                          code: null,
                          dateFormat: null,
                          timeFormat: null,
                          numberFormat: null,
                          nameFormat: null,
                          textOrientation: null,
                          addressFormat: null,
                          enabled: false,
                          systemProvided: false,
                          id: null
                      };
                  }
              }
      			}).then(function() {
      			     resetModal();
      			});
    		}

        function editObject(objectId) {
      			$mdDialog.show({
      				animation : true,
              templateUrl : 'modules/system/locale/locale-dialog.html',
      				controller : 'LocaleDialogController',
      				controllerAs : 'vm',
      				backdrop : 'static',
      				size : 'lg',
              resolve: {
                  entity: ['Locale', function(Locale) {
                      return Locale.get({
                        id : objectId
                      });
                  }]
              }
      			}).then(function() {
      			     resetModal();
      			});
    		}

    		function deleteObject(objectId) {
      			$mdDialog.show({
      				animation : true,
      				templateUrl : 'modules/system/locale/locale-delete-dialog.html',
      				controller : 'LocaleDeleteController',
      				controllerAs : 'vm',
      				backdrop : 'static',
              resolve: {
                  entity: ['Locale', function(Locale) {
                      return Locale.get({
                        id : objectId
                      });
                  }]
              }
      			}).then(function() {
      			     resetModal();
      			});
      		};

    		function resetModal () {
            loadAll();
            AlertService.displayToast($mdToast);
    		};

    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LocaleDialogController', LocaleDialogController);

    LocaleDialogController.$inject = ['$scope', '$stateParams', '$mdDialog', 'entity', 'Locale'];

    function LocaleDialogController ($scope, $stateParams, $mdDialog, entity, Locale) {
        var vm = this;
        vm.locale = entity;
        vm.load = function(id) {
            Locale.get({id : id}, function(result) {
                vm.locale = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('atheer:localeUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.locale.id !== null) {
                Locale.update(vm.locale, onSaveSuccess, onSaveError);
            } else {
                Locale.save(vm.locale, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LocaleDeleteController',LocaleDeleteController);

    LocaleDeleteController.$inject = ['$mdDialog', 'entity', 'Locale'];

    function LocaleDeleteController($mdDialog, entity, Locale) {
        var vm = this;
        vm.locale = entity;
        vm.clear = function() {
            $mdDialog.cancel();
        };
        vm.confirmDelete = function (id) {
            Locale.delete({id: id},
                function () {
                    $mdDialog.hide();
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LensHomePageConfigController', LensHomePageConfigController)

    /* @ngInject */
    function LensHomePageConfigController($scope, $q, $state, $http, $filter, ToastService, triSettings, Upload, Setting, Content) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.lensHomepageConfigFile;
        vm.configFileName;
        vm.isFileUploadInProgress = false;
        vm.fileMaxSize = 2 * 1024 * 1024;
        vm.loadingData = false;
        vm.selectedHomeScreenConfig = 'lens';
        vm.embedScript = null;
        vm.iconUrl = "https://i.ibb.co/ZfWMD0m/Vector.png";
        vm.themeColor = triSettings.getSkinModel().primary_color_hex;
        vm.bottom = "0";
        vm.right = "0";


        vm.upload = function (files) {
            if (files.length) {
                var file = files[0];
                if (file.size < vm.fileMaxSize) {
                    vm.isFileUploadInProgress = true;
                    Upload.upload({
                        url: vm.selectedHomeScreenConfig === 'studio' ? 'api/homepage/upload?homepageType=Web' : vm.selectedHomeScreenConfig === 'lens' ? 'api/homepage/upload': 'copilot/api/v1/client/copilot-commands/upload',
                        data: {
                            'file': file,
                            'type': 'file'
                        },
                        arrayKey: ''
                    }).then(function (resp) {
                        uploadComplete(resp);
                    }, function (resp) {
                        uploadError();
                    });
                } else {
                    uploadError();
                }
            }
        }

        vm.setDefault = function () {
            vm.isFileUploadInProgress = true;
            var endURL = 'api/homepage/generate-default';
            if (vm.selectedHomeScreenConfig === 'studio') {
                endURL += '?homepageType=Web';
            }
            $http({
                url: endURL,
                method: 'POST',
                transformResponse: [function (data) {
                    return data;
                }]
            }).then(function (resp) {
                vm.isFileUploadInProgress = false;
                vm.lensHomepageConfigFile = resp.data;
                vm.configFileName = vm.lensHomepageConfigFile.split('|')[0];
                ToastService.displayToast($filter('triTranslate')('atheer.homepageconfig.defaultConfigSuccess'));
            }, function (error) {
                vm.isFileUploadInProgress = false;
                ToastService.displayToast($filter('triTranslate')('atheer.homepageconfig.defaultConfigFailure'));
            });
        }

        vm.downloadSampleFile = function () {
            downloadFile('sample_lens_home_page_config.json', 'api/homepage/download/sample')
        }

        vm.downloadConfigFile = function () {
            var fileUrl;
            var mediaId;

            if ( vm.selectedHomeScreenConfig === 'command') {
                fileUrl = 'copilot/api/v1/client/copilot-commands/download';
            }
            else {
                mediaId = vm.lensHomepageConfigFile.split('|')[1];
                fileUrl = 'media/documents/' + mediaId + '.json';
            }
            downloadFile(vm.configFileName, fileUrl);
        }

        vm.tabSelected = function (tab) {
            vm.selectedHomeScreenConfig = tab;
            vm.loadingData = true;
            loadData();
            vm.loadingData = false;
        }

        function downloadFile(fileName, fileUrl) {
            $http.get(fileUrl, { responseType: 'blob' }).then(function (response) {
                var objectUrl = URL.createObjectURL(response.data);
                var link = document.createElement('a');
                link.download = fileName,
                    link.href = objectUrl;
                link.click();
            })
        }

        function uploadComplete(resp) {
            vm.isFileUploadInProgress = false;
            if ( vm.selectedHomeScreenConfig === 'command') {
                vm.configFileName = 'ai_commands.json';
            }
            else {
                vm.configFileName = resp.data.source_file_name;
                vm.lensHomepageConfigFile = resp.data.source_file_name + '|' + resp.data.id;
            }
            ToastService.displayToast($filter('triTranslate')('atheer.homepageconfig.configUpdateSuccess'));
        }

        function uploadError(resp) {
            vm.isFileUploadInProgress = false;
            ToastService.displayToast($filter('triTranslate')('atheer.homepageconfig.configUpdateFailed'));
        }

        function setConfigModel(skinSettings) {
            var fieldKey = 'lense_homepage_json_file';
            if (vm.selectedHomeScreenConfig === 'studio') {
                fieldKey = 'web_homepage_json_file';
            } else if ( vm.selectedHomeScreenConfig === 'command')
            {
                fieldKey = 'ai_commands_json_file';
                vm.configFileName = 'ai_commands.json';
            }

            angular.forEach(skinSettings, function (setting) {
                if (setting.category == 'skin_info') {
                    vm.skinSettings = setting;
                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.value != null && settingField.name == fieldKey) {
                            vm.lensHomepageConfigFile = settingField.value;
                            vm.configFileName = vm.lensHomepageConfigFile.split('|')[0];
                        }
                    });
                }
            });
        }

        function loadData() {
            vm.loadingData = true;

            $q.all([
                Setting.getSkinSettings().$promise,
                Content.query({
                    query: 'type==EMAIL_LAYOUT'
                }).$promise
            ])
                .then(function (results) {
                    setConfigModel(results[0]);
                    vm.loadingData = false;
                });
        };
        loadData();

        vm.generateScript = function () {
            vm.embedScript = "<script src='https://app.atheer."+window.location.origin.split(".").pop()+"/embed/embed_copilot.js' data-atheerdomain='"+window.location.origin+"' data-iconurl='"+vm.iconUrl+"' data-themecolor='"+vm.themeColor+"' data-bottom='"+vm.bottom+"' data-right='"+vm.right+"' > </script>";
        };
        vm.onCopySuccess = function (e) {
            ToastService.displayToast(
                $filter("triTranslate")(
                    "atheer.homepageconfig.copilotEmbedScriptCopied"
                )
            );
        };
    }
})();;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.lens-apps', {
                url: '/settings/lens-apps',
                templateUrl: 'modules/system/lens-app/lens-apps.html',
                controller: 'LensAppsController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.workspace.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LensAppsController', LensAppsController);

    /* @ngInject */
    function LensAppsController($scope, $state, LensApp, $mdPanel, Workspace, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, triSettings, $location) {
        var vm = this;

        vm.loadingData = false;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.showRigPartnerStore = false;

        vm.lensApps = [];
        vm.lensAppsData = [];
        
        var host = $location.host();
        if (angular.isDefined(host) && host.startsWith("rigpartner.")) {
            vm.showRigPartnerStore = true;
        }

        function getDevicesList() {
            vm.lensApps.length = vm.lensAppsData.length;
            angular.forEach(vm.lensAppsData, function(app) {
                if (app.type == "APPLE") {
                    vm.lensApps[0] = app;
                } else if (app.type == "ANDROID") {
                    vm.lensApps[1] = app;
                } else if (app.type == "GLASS") {
                    vm.lensApps[2] = app;
                } else if (app.type == "DESKTOP") {
                    vm.lensApps[3] = app;
                }
            });

            vm.loadingData = false;
        }


        vm.showSupoortedDevice = function(lensType) {
            $mdDialog.show({
                templateUrl: 'modules/system/lens-app/lens-app-support-devices.html',
                clickOutsideToClose: true,
                controller: "LensAppSupportDevicesController",
                locals: {
                    filter: lensType
                },
                controllerAs: "vm"
            }).then(function(result) {

            });
        }


        function loadAll() {
            vm.loadingData = true;

            LensApp.query({
                query: 'isLatest==true'
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.lensAppsData = data;
                getDevicesList();
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LensAppSupportDevicesController', LensAppSupportDevicesController);

    /* @ngInject */
    function LensAppSupportDevicesController ($scope, $state, $q, filter, Principal,  $mdDialog, $mdToast, $stateParams) {
        var vm = this;
        vm.lens = filter;
        vm.type = vm.lens.type;
        vm.loadingData = true;

        vm.load = function() {
            vm.loadingData = false;
        };

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.load();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.system-admin.languages', {
                url: '/languages?page&sort&search',
                templateUrl: 'modules/system/language/languages.html',
                controller: 'LanguageController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.language.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false,
                    }
                },

                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LanguageController', LanguageController);

    /* @ngInject */
    function LanguageController ($scope, $state, Language, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        vm.query = {
                filter: '',
                limit: paginationConstants.itemsPerPage,
                order: '-id',
                page: 1
            };

        vm.filter = {
                options: {
                    debounce: 500
                }
            };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;

        vm.createObject=createObject;
        vm.editObject=editObject;
        vm.deleteObject=deleteObject;

        function loadAll () {
            Language.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.languages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition () {
            vm.promise = Language.query({
        				page: vm.page-1,
        				size: paginationConstants.itemsPerPage,
        				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        				search: vm.currentSearch
      			  }).$promise;

            vm.promise.then(function (data,headers) {
              vm.queryCount = vm.totalItems;
              vm.languages = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if(vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject() {
      			$mdDialog.show({
      				animation : true,
      				templateUrl : 'modules/system/language/language-dialog.html',
      				controller : 'LanguageDialogController',
      				controllerAs : 'vm',
      				backdrop : 'static',
      				size : 'lg',
              resolve: {
                  entity: function () {
                      return {
                          languageNo: null,
                          name: null,
                          description: null,
                          code: null,
                          enabled: false,
                          systemProvided: false,
                          id: null
                      };
                  }
              }
      			}).then(function() {
      			     resetModal();
      			});
    		}

        function editObject(objectId) {
      			$mdDialog.show({
      				animation : true,
              templateUrl : 'modules/system/language/language-dialog.html',
      				controller : 'LanguageDialogController',
      				controllerAs : 'vm',
      				backdrop : 'static',
      				size : 'lg',
              resolve: {
                  entity: ['Language', function(Language) {
                      return Language.get({
                        id : objectId
                      });
                  }]
              }
      			}).then(function() {
      			     resetModal();
      			});
    		}

    		function deleteObject(objectId) {
      			$mdDialog.show({
      				animation : true,
      				templateUrl : 'modules/system/language/language-delete-dialog.html',
      				controller : 'LanguageDeleteController',
      				controllerAs : 'vm',
      				backdrop : 'static',
              resolve: {
                  entity: ['Language', function(Language) {
                      return Language.get({
                        id : objectId
                      });
                  }]
              }
      			}).then(function() {
      			     resetModal();
      			});
      		};

    		function resetModal () {
            loadAll();
            AlertService.displayToast($mdToast);
    		};

    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LanguageDialogController', LanguageDialogController);

    LanguageDialogController.$inject = ['$scope', '$stateParams', '$mdDialog', 'entity', 'Language'];

    function LanguageDialogController ($scope, $stateParams, $mdDialog, entity, Language) {
        var vm = this;
        vm.language = entity;
        vm.load = function(id) {
            Language.get({id : id}, function(result) {
                vm.language = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('atheer:languageUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.language.id !== null) {
                Language.update(vm.language, onSaveSuccess, onSaveError);
            } else {
                Language.save(vm.language, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LanguageDeleteController',LanguageDeleteController);

    LanguageDeleteController.$inject = ['$mdDialog', 'entity', 'Language'];

    function LanguageDeleteController($mdDialog, entity, Language) {
        var vm = this;
        vm.language = entity;
        vm.clear = function() {
            $mdDialog.cancel();
        };
        vm.confirmDelete = function (id) {
            Language.delete({id: id},
                function () {
                    $mdDialog.hide();
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('LabelDictionaryController', LabelDictionaryController)

    /* @ngInject */
    function LabelDictionaryController($scope, $state, $q, LocalResourceService, Setting, $filter, $window, Principal, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.languages = [];
        vm.dictionarySettings = null;
        vm.dictionary = {};
        vm.selectedDictionary = {};
        vm.selectedLanguage = "en_US";

        function setDictionaryModel(dictionarySettings) {
            angular.forEach(dictionarySettings, function (dictionary) {
                if (dictionary.category == 'label-dictionary') {
                    vm.dictionarySettings = dictionary;

                    angular.forEach(dictionary.fields.filter(function (field) {
                        return !field.name.endsWith('_plural')
                    }), function (dictionaryField) {
                        var dictionary = vm.dictionary[dictionaryField.group_name];

                        if (dictionary) {
                            dictionary.settings.push(dictionaryField);
                        } else {
                            dictionary = {
                                name: dictionaryField.group_name,
                                label: dictionaryField.group_label,
                                editable: dictionaryField.group_editable,
                                settings: []
                            }
                            dictionary.settings.push(dictionaryField);
                            vm.dictionary[dictionaryField.group_name] = dictionary;
                        }

                        var dictionaryPluralField = vm.dictionarySettings.fields.filter(function (field) {
                            return (field.name == dictionaryField.name + '_plural' && field.group_name == dictionaryField.group_name);
                        })[0];
                        if (dictionaryPluralField) {
                            dictionaryField['plural_value'] = dictionaryPluralField.value;
                            dictionaryField['default_plural_value'] = dictionaryPluralField.default_value;
                        }
                    });
                }
            });
            vm.selectedDictionary = vm.dictionary[vm.selectedLanguage];
            vm.selectedDictionary.settings = $filter('orderBy')(vm.selectedDictionary.settings, 'group_description != undefined');
        };

        function setDictionarySettings() {
            angular.forEach(vm.selectedDictionary.settings, function (setting) {
                angular.forEach(vm.dictionarySettings.fields, function (dictionaryField) {
                    if (dictionaryField.name == setting.name && dictionaryField.group_name == setting.group_name) {
                        dictionaryField.value = setting.value
                    }

                    if (dictionaryField.name == setting.name + '_plural' && dictionaryField.group_name == setting.group_name) {
                        dictionaryField.value = setting.plural_value
                    }
                });
            });
        };

        vm.updateDictionary = function () {
            vm.selectedDictionary = vm.dictionary[vm.selectedLanguage];
            vm.selectedDictionary.settings = $filter('orderBy')(vm.selectedDictionary.settings, 'group_description != undefined');
        };

        vm.save = function () {
            setDictionarySettings();
            Setting.update(vm.dictionarySettings, function (result) {
                vm.dictionarySettings = result;
                ToastService.displayToastWithAction($filter('triTranslate')("atheer.setting.dictionary.success"),
                    $filter('triTranslate')("entity.action.refresh"), 'md-accent', '', function (response) {
                        if (response == 'ok') {
                            $window.location.reload();
                        }
                    });
            });
        };

        vm.loadData = function () {
            vm.loadingData = true;

            $q.all([
                Setting.getLabelDictionarySettings().$promise
            ])
                .then(function (results) {
                    setDictionaryModel(results[0]);

                    vm.languages = [
                        { name: 'english_us', displayName: 'English (US)', value: 'en_US', serverKey: 'en_US' },
                        { name: 'english_uk', displayName: 'English (UK)', value: 'en_GB', serverKey: 'en_GB' },
                        { name: 'french', displayName: 'French', value: 'fr_FR', serverKey: 'fr_FR' },
                        { name: 'german', displayName: 'German', value: 'de_DE', serverKey: 'de_DE' },
                        { name: 'greek', displayName: 'Greek', value: 'el_GR', serverKey: 'el_GR' },
                        { name: 'italian', displayName: 'Italian', value: 'it_IT', serverKey: 'it_IT' },
                        { name: 'japanese', displayName: 'Japanese', value: 'ja_JP', serverKey: 'ja_JP' },
                        { name: 'portuguese', displayName: 'Portuguese', value: 'pt_BR', serverKey: 'pt_BR' },
                        { name: 'spanish', displayName: 'Spanish', value: 'es_CL', serverKey: 'es_CL' },
                        { name: 'chinese', displayName: 'Chinese (Traditional)', value: 'zh_TW', serverKey: 'zh_TW' },
                        { name: 'chinese_cn', displayName: 'Chinese (Simplified)', value: 'zh_CN', serverKey: 'zh_CN' },
                        { name: 'dutch', displayName: 'Dutch', value: 'nl_NL', serverKey: 'nl_NL' },
                        { name: 'danish', displayName: 'Danish (Denmark)', value: 'da_DK', serverKey: 'da_DK' },
                        { name: 'norwegian', displayName: 'Norwegian', value: 'no_NO', serverKey: 'no_NO' },
                        { name: 'polish', displayName: 'Polish (Poland)', value: 'pl_PL', serverKey: 'pl_PL' },
                        { name: 'russian', displayName: 'Russian', value: 'ru_RU', serverKey: 'ru_RU' },
                        { name: 'swedish', displayName: 'Swedish (Sweden)', value: 'sv_SE', serverKey: 'sv_SE' },
                        { name: 'turkish', displayName: 'Turkish (Turkey)', value: 'tr_TR', serverKey: 'tr_TR' }
                    ];

                    vm.languages.sort(function (a, b) {
                        if (a['displayName'] > b['displayName']) {
                            return 1;
                        } else if (a['displayName'] < b['displayName']) {
                            return -1;
                        }
                        return 0;
                    });

                    vm.loadingData = false;
                });
        };
        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('JobPDFSettingsController', JobPDFSettingsController)

    /* @ngInject */
    function JobPDFSettingsController($scope, $state, $q, $http, Setting, $filter, $window, Principal, ToastService, $location) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.featureSettings = null;
        vm.features = {};
        vm.isAdmin = Principal.isWorkspaceAdmin();
        vm.readOnly = false;

        vm.photo_width = 210;
        vm.photo_height = 280;
        vm.photo_setting = "No";
        vm.photo_setting_options = ["Yes", "No"];
        vm.response_col_width_allocation = "20, 20, 20, 20, 20"
        vm.excludedFields = [];
        vm.fixedKeys = [
            {
                name: "timeline",
                label: "Job timeline"
            },
            {
                name: "sectionHeader",
                label: "Section header"
            },
            {
                name: "stepDuration",
                label: "Step duration"
            },
            {
                name: "stepDescription",
                label: "Step description"
            },
            {
                name: "tableDataMessage",
                label: "Table Step data table caption message"
            },
            {
                name: "response_type",
                label: "Response type column in step response table"
            },
            {
                name: "response_deviation",
                label: "Response deviation column in step response table"
            },
            {
                name: "response_user",
                label: "Response User column in step response table"
            }
        ];

        function setFeaturesModel(activityTemplates, jobpdfConfig) {
            vm.featureSettings = jobpdfConfig[0];

            //Initialize based on current pdf configuration
            angular.forEach(jobpdfConfig[0].fields, function (field) {
                if ( field.name === 'photoSource' ) {
                    vm.photo_setting = field.value === 'original' ? "Yes" : "No";
                } else if ( field.name === 'photoWidth' ) {
                    vm.photo_width = parseInt(field.value);
                } else if ( field.name === 'photoHeight' ) {
                    vm.photo_height = parseInt(field.value);
                } else if ( field.name ===  'responseDataTableColPer' ) {
                    vm.response_col_width_allocation = field.value;
                } else {
                    vm.excludedFields.push(field.name);
                }
            });

            var fixedAttrLoaded = false;
            angular.forEach(activityTemplates, function (template) {
                if ( !fixedAttrLoaded ) {
                    var feature = {
                        name: 'Job fixed fields',
                        label: 'Job fixed fields',
                        editable: true,
                        fields: []
                    }
                    angular.forEach(template.fixedAttributes, function(attribute) {
                        if ( attribute.show ) {
                            var field = {
                                name: attribute.name,
                                label: attribute.label,
                                show: !vm.excludedFields.includes(attribute.name)
                            }
                            feature.fields.push(field);
                        }
                    });
                    vm.features[feature.label] = feature;
                    fixedAttrLoaded = true;
                }
                if ( template.enabledCustomAttributes.length > 0 ) {
                    var feature = {
                        name: template.id,
                        label: template.name + " - Custom fields",
                        editable: true,
                        fields: []
                    }
                    angular.forEach(template.enabledCustomAttributes, function(attribute) {
                        var field = {
                            name: attribute.name,
                            label: attribute.label,
                            show: !vm.excludedFields.includes(attribute.name)
                        }
                        feature.fields.push(field);

                    });
                    vm.features[feature.label] = feature;
                }
            });
            // load fixed entries
            var feature = {
                name: 'Job section fields',
                label: 'Job section fields',
                editable: true,
                fields: []
            }
            angular.forEach(vm.fixedKeys, function(attribute) {
                var field = {
                    name: attribute.name,
                    label: attribute.label,
                    show: !vm.excludedFields.includes(attribute.name)
                }
                feature.fields.push(field);

            });
            vm.features[feature.label] = feature;
        }

        function setFeatureSettings() {
            vm.featureSettings.fields = [];

            for (var key in vm.features) {
                var feature = vm.features[key];
                var settingField;
                angular.forEach(feature.fields, function (field) {
                    if ( ! field.show) {
                        settingField = {
                            name: field.name
                        }
                    } else {
                            return;
                    }
                    vm.featureSettings.fields.push(settingField);
                });
            }

            if ( vm.photo_setting === 'Yes') {
                settingField = {
                    name: 'photoSource',
                    value: 'original'
                }  
                vm.featureSettings.fields.push(settingField);           
        
                settingField = {
                    name: 'photoWidth' ,
                    value: vm.photo_width.toString()
                }      
                vm.featureSettings.fields.push(settingField); 

                settingField = {
                    name: 'photoHeight',
                    value: vm.photo_height.toString()
                }    
                vm.featureSettings.fields.push(settingField); 
            }

            if ( vm.response_col_width_allocation !== '' && vm.response_col_width_allocation !== "20, 20, 20, 20, 20" ) {
                settingField = {
                    name: 'responseDataTableColPer',
                    value: vm.response_col_width_allocation
                }
                vm.featureSettings.fields.push(settingField); 
            } 

        }

        vm.save = function () {
            setFeatureSettings();

            Setting.update(vm.featureSettings, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"), 3000);
            }); 
        }

        vm.loadData = function () {
            vm.loadingData = true;
            var host = $location.host();
            if (angular.isDefined(host) && host.startsWith("rigpartner.")) {
                    vm.readOnly = true;
            }

            $q.all([
                Setting.getActivityTemplates().$promise,
                Setting.getJobPDFSettings().$promise
            ])
                .then(function (results) {
                    setFeaturesModel(results[0], results[1]);
                    vm.loadingData = false;
                });
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('MaterialIconsController', MaterialIconsController);

    /* @ngInject */
    function MaterialIconsController($mdDialog, $document, $compile, $scope, icons) {
        var vm = this;
        vm.groups = [];
        vm.icons = [];
        vm.iconSource = 'Select icon below to see HTML';
        vm.selectIcon = selectIcon;
        vm.icons = icons.data;

        function selectIcon($event, className) {
            $mdDialog.show({
                title: '',
                template:
                    '<md-dialog>' +
                    '  <md-toolbar>' +
                    '    <h2 class="md-toolbar-tools">Here\'s the code for that icon</h2>' +
                    '  </md-toolbar>' +
                    '  <md-dialog-content>' +
                    '    <div hljs language="html"><md-icon md-font-icon="' + className + '"></md-icon></div>' +
                    '  </md-dialog-content>' +
                    '  <md-dialog-actions>' +
                    '    <md-button ng-click="vm.closeDialog()" class="md-primary">' +
                    '      Close' +
                    '    </md-button>' +
                    '  </md-dialog-actions>' +
                    '</md-dialog>',
                targetEvent: $event,
                parent: angular.element($document.body),
                controller: 'IconDialogController',
                controllerAs: 'vm'
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('IconDialogController', IconDialogController);

    /* @ngInject */
    function IconDialogController($mdDialog) {
        var vm = this;
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('FaIconsController', FaIconsController);

    /* @ngInject */
    function FaIconsController($mdDialog, $document, $scope, $compile, icons) {
        var vm = this;
        vm.icons = loadIcons();
        vm.iconSource = 'Select icon below to see HTML';
        vm.selectIcon = selectIcon;

        function loadIcons() {
            var allIcons = [];
            for(var className in icons.data) {
                allIcons.push({
                    className: className,
                    name: icons.data[className]
                });
            }
            return allIcons;
        }

        function selectIcon($event, icon) {
            $mdDialog.show({
                title: '',
                template:
                    '<md-dialog>' +
                    '  <md-toolbar>' +
                    '    <h2 class="md-toolbar-tools">Here\'s the code for that icon</h2>' +
                    '  </md-toolbar>' +
                    '  <md-dialog-content>' +
                    '    <div hljs language="html"><md-icon md-font-icon="' + icon.className + '"></md-icon></div>' +
                    '  </md-dialog-content>' +
                    '  <md-dialog-actions>' +
                    '    <md-button ng-click="vm.closeDialog()" class="md-primary">' +
                    '      Close' +
                    '    </md-button>' +
                    '  </md-dialog-actions>' +
                    '</md-dialog>',
                targetEvent: $event,
                parent: angular.element($document.body),
                controller: 'IconDialogController',
                controllerAs: 'vm'
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('FileExtSettingsController', FileExtSettingsController)

    /* @ngInject */
    function FileExtSettingsController($scope, $state, $q, $http, Setting, $filter, $window, Principal, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.featureSettings = null;
        vm.features = {};
        vm.isAdmin = Principal.isWorkspaceAdmin();
        vm.homePageFeatureValue = false;
        vm.fileExtensions = "";

        function setFeaturesModel(fileExtConfig) {
            vm.featureSettings = fileExtConfig[0];

            //Initialize based on current file ext configuration
            angular.forEach(fileExtConfig[0].fields, function (field) {
                if ( vm.fileExtensions !== "" ) { vm.fileExtensions = vm.fileExtensions.concat(", "); }
                vm.fileExtensions = vm.fileExtensions.concat(field.name);
            });
        }

        function setFeatureSettings() {
            vm.featureSettings.fields = [];
            var settingField;
            angular.forEach(vm.fileExtensions.split(','), function (mimeType) {
                settingField = {
                    name: mimeType.replace(/ /g,"")
                }
                vm.featureSettings.fields.push(settingField);
            });
        }

        vm.save = function () {
            setFeatureSettings();

            Setting.update(vm.featureSettings, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"), 3000);
            }); 
        }

        vm.loadData = function () {
            vm.loadingData = true;

            $q.all([
                Setting.getJobFileExtSettings().$promise
            ])
                .then(function (results) {
                    setFeaturesModel(results[0]);
                    vm.loadingData = false;
                });
        };
        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SettingFeatureController', SettingFeatureController)

    /* @ngInject */
    function SettingFeatureController($scope, $state, $q, $http, Setting, $filter, $window, Principal, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.featureSettings = null;
        vm.features = {};
        vm.isAdmin = Principal.isWorkspaceAdmin();
        vm.homePageFeatureValue = false;
        vm.originalPublicAccessFeatureValue = false;
        vm.publicAccessFeatureValue = false;

        function setFeaturesModel(featureSettings) {
            angular.forEach(featureSettings, function (feature) {
                if (feature.category == 'features') {
                    vm.featureSettings = feature;
                    angular.forEach(feature.fields, function (settingField) {
                        if (settingField.value == 'true') {
                            settingField.value = true;
                        } else {
                            settingField.value = false;
                        }

                        if (settingField.group_name === 'system' && settingField.name === "public_access") {
                            vm.originalPublicAccessFeatureValue = settingField.value;
                            console.log("setting vm.originalPublicAccessFeatureValue", vm.originalPublicAccessFeatureValue)
                        }
                        var feature = vm.features[settingField.group_name];
                        if (feature) {
                            feature.settings.push(settingField);
                        } else {
                            var feature = {
                                name: settingField.group_name,
                                label: settingField.group_label,
                                editable: settingField.group_editable,
                                settings: []
                            }
                            feature.settings.push(settingField);
                            vm.features[settingField.group_name] = feature;
                        }
                    });
                }
            });
        }

        function setFeatureSettings() {
            vm.featureSettings.fields = [];
            for (var key in vm.features) {
                var feature = vm.features[key];
                angular.forEach(feature.settings, function (settingField) {
                    if (settingField.group_name == 'system' && settingField.name == 'enable_configurable_home_page') {
                        vm.homePageFeatureValue = settingField.value;
                    }

                    if (settingField.group_name == 'system' && settingField.name == 'public_access') {
                        vm.publicAccessFeatureValue = settingField.value;
                        console.log("saving vm.publicAccessFeatureValue", vm.publicAccessFeatureValue)
                    }

                    vm.featureSettings.fields.push(settingField);
                });
            }
        }

        vm.save = function () {
            setFeatureSettings();
            Setting.update(vm.featureSettings, function (result) {
                vm.featureSettings = result;
                $http.post('api/homepage/feature-flag/' + vm.homePageFeatureValue).then(function (data) { }, function (error) { });
                console.log("API", vm.originalPublicAccessFeatureValue, vm.publicAccessFeatureValue)
                if (vm.publicAccessFeatureValue !== vm.originalPublicAccessFeatureValue) {
                    $http.post('api/public-access/feature-flag/change/' + vm.publicAccessFeatureValue).then(function (data) {
                        vm.originalPublicAccessFeatureValue = vm.publicAccessFeatureValue;
                    }, function (error) { });
                }
                ToastService.displayToastWithAction($filter('triTranslate')("atheer.setting.featureSuccess"),
                    $filter('triTranslate')("entity.action.refresh"), 'md-accent', '', function (response) {
                        if (response == 'ok') {
                            $window.location.reload();
                        }
                    });
            });
        }

        vm.loadData = function () {
            vm.loadingData = true;

            $q.all([
                Setting.getFeaturesSettings().$promise
            ])
                .then(function (results) {
                    setFeaturesModel(results[0]);
                    vm.loadingData = false;
                });
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('EmailSettingController', EmailSettingController);

    /* @ngInject */
    function EmailSettingController($scope, $state, $q, Setting, $filter, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.emailSetting = [];
        vm.emailModel = {
            from_address: null,
            name: null,
            email_layout: null,
            logo_url: 'https://sitecdn.atheer.ai/wp-content/uploads/2017/04/atheer-logo.png'
        };
        vm.emailLayouts = [];
        vm.view = 'EDIT';
        vm.previewContent = null;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getEmailSettings().$promise
                ])
                .then(function(results) {
                    setEmailModel(results[0]);
                    vm.emailLayouts = results[1];
                    vm.loadingData = false;
                });
        };

        vm.changeView = function(viewType) {
            vm.view = viewType;

            if(viewType == 'PREVIEW') {
                vm.previewContent = vm.emailLayouts[0].body;
                vm.previewContent = vm.previewContent.replace("{{content}}", vm.emailContent.data.content);
            }
        }

        function setEmailModel(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'email_info') {
                    vm.emailSetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'from_address') {
                            vm.emailModel.from_address = settingField.value;
                        }
                        if (settingField.name == 'name') {
                            vm.emailModel.name = settingField.value;
                        }
                        if (settingField.name == 'email_layout') {
                            vm.emailModel.email_layout = settingField.value;
                        }
                        if (settingField.name == 'logo_url') {
                            vm.emailModel.logo_url = settingField.value;
                        }
                    });
                }
            });
        }

        function setEmailSettings() {
            setEmailSettingField("from_address", vm.emailModel.from_address);
            setEmailSettingField("name", vm.emailModel.name);
            setEmailSettingField("email_layout", vm.emailModel.email_layout);
            setEmailSettingField("logo_url", vm.emailModel.logo_url);
        }

        function setEmailSettingField(fieldName, fieldValue) {
            var foundField = false;
            angular.forEach(vm.emailSetting.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.emailSetting.fields.push(settingField);
            }
        }

        vm.save = function() {
            setEmailSettings();
            $q.all([
                    Setting.update(vm.emailSetting).$promise
                ])
                .then(function(results) {
                    ToastService.displayToast($filter('triTranslate')("atheer.setting.success"), 3000);
                });
        }
        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session', []);
})();;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionDeeplinkController', SessionDeeplinkController);

    /* @ngInject */
    function SessionDeeplinkController($stateParams, $http, $window, $filter, ToastService) {
        var vm = this;
        vm.isLoading = true;
        vm.landingUrl;
        vm.workSpace;
        vm.env;
        vm.linkError = false;
        vm.appImageLauncher = 'AppImageLauncher';
        vm.appImage = "AppImage";
        vm.windowsInstallerLink;
        vm.macInstallerLink;
        vm.linuxInstallerLink;
        vm.linuxArmInstallerLink;

        function getDesktopProtocol() {
            return 'x-atheer-' + vm.env;
        }

        function getInstallerLink(osName) {
            if (vm.workSpace === 'rigpartner' || vm.workSpace === 'atheer') {
                return 'https://desktop.atheer.' + vm.env + '/download/' + osName + '/' + vm.workSpace;
            }

            return 'https://desktop.atheer.' + vm.env + '/download/' + osName;

        }

        function onLoad() {
            var host = $window.location.host;
            vm.workSpace = host.split('.')[0];
            vm.env = host.split('.')[2];
            if (host === 'localhost:3000') {
                vm.env = 'dev'
            }
            var url = 'api/secureurls/' + $stateParams.guid;
            $http.get(url).then(function (response) {
                if (response.data.handler === 'DESKTOP') {

                    vm.windowsInstallerLink = response.data.downloadLinks["windows"];
                    vm.macInstallerLink = response.data.downloadLinks["mac"];
                    vm.linuxInstallerLink = response.data.downloadLinks["linuxx64"];
                    vm.linuxArmInstallerLink = response.data.downloadLinks["linuxarm64"];

                    var desktopProtocol = getDesktopProtocol();
                    var targetUrl = response.data.url;
                    vm.landingUrl = desktopProtocol + '://' + targetUrl;
                    vm.openDesktopApp();
                }
                vm.isLoading = false;
            },
                function (error) {
                    vm.isLoading = false;
                    vm.linkError = true;
                })
        }

        vm.openDesktopApp = function () {
            window.protocolCheck(vm.landingUrl,
                //failure case
                function () {
                    console.log("No App available to handle protocol", vm.landingUrl.split(':')[0]);
                    var message = $filter('translate')('deeplink.desktopAppNotInstalledDescription')
                    alert(message);
                },
                //success Case
                function () {
                    console.log("App Available for handle protocol");
                    window.location.href = vm.landingUrl;
                },
                //unsupported case
                function () {
                    console.log("No App available to handle protocol", vm.landingUrl.split(':')[0]);
                    var message = $filter('translate')('deeplink.desktopAppNotInstalledDescription')
                    alert(message);
                }
            )
        }
        onLoad();
    }

})();;
(function () {
    'use strict';

    angular
        .module('atheer')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('deeplink', {
                abstract: true,
                views: {
                    'root': {
                        templateUrl: 'modules/public/public.tmpl.html'
                    }
                }
            })
            .state('deeplink.sessiondeeplink', {
                url: '/deeplink/sessions/:guid',
                templateUrl: 'modules/system/deeplink/session-deeplink.tmpl.html',
                controller: 'SessionDeeplinkController',
                controllerAs: 'vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.guid;
                    }
                }
            })
            .state('deeplink.commonDeepLink', {
                url: '/deeplink/:configType/:id',
                templateUrl: 'modules/system/deeplink/deeplink.tmpl.html',
                controller: 'DeeplinkController',
                controllerAs: 'vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    configType: function ($stateParams) {
                        return $stateParams.configType
                    }
                }
            })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer')
        .controller('DeeplinkController', DeeplinkController);

    /* @ngInject */
    function DeeplinkController($stateParams, $state, Content, DeeplinkService, PermissionService, Feature, $mdDialog, Auth) {
        var vm = this;

        function onLoadData() {
            var isPublicUser = Auth.isPublicUser();
            if ($stateParams.configType == 'topic') {
                if (Feature.isActive('feature_topic_enable')) {
                    if (isPublicUser) {
                        $state.go('public.topics-detail', {
                            id: $stateParams.id
                        })
                    } else {
                        $state.go('storm.topic-view', {
                            id: $stateParams.id
                        })
                    }
                } else {
                    openNoAccessDialog('deeplink.noAccessForTopics');
                }
            } else if ($stateParams.configType == 'user') {
                if (PermissionService.hasAccess('manage-user')) {
                    $state.go('storm.profile.overview', {
                        id: $stateParams.id
                    });
                } else {
                    openNoAccessDialog('deeplink.noAccessForUsers');
                }
            } else if ($stateParams.configType == 'content') {
                if (Feature.isActive('feature_content_enable')) {
                    if (isPublicUser) {
                        $state.go('public.content-detail', {
                            id: $stateParams.id
                        })
                    } else {
                        $state.go('storm.content-view', {
                            id: $stateParams.id
                        })
                    }
                } else {
                    openNoAccessDialog('deeplink.noAccessForContent');
                }
            }
        };

        function openNoAccessDialog(content) {
            $mdDialog.show({
                templateUrl: 'modules/home/no-access-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'NoAccessController',
                controllerAs: 'vm',
                locals: {
                    content: content,
                    title: 'home.permissionError',
                    isDeeplink: true
                }
            });
        }

        onLoadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, triMenuProvider) {

        $stateProvider
            .state('storm.system-admin.dashboard', {
                url: '/dashboard?page&sort&search',
                templateUrl: 'modules/system/dashboard/system-dashboard.tmpl.html',
                controller: 'SystemDashboardController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.language.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SystemDashboardController', SystemDashboardController);

    /* @ngInject */
    function SystemDashboardController($rootScope, $scope, $state, $mdDialog, AlertService, Workspace, System, workspaceId, pagingParams, paginationConstants, ParseLinks, $q, $mdToast, $filter, Report, CONTENT_META) {
        var vm = this;

        vm.loadingData = false;
        vm.dashboard = null;

        vm.getCount = function(activityName) {
            for (var i = 0; i < vm.dashboard.contents_summary.metrics.length; i++) {
                if (vm.dashboard.contents_summary.metrics[i].name === activityName) {
                    return vm.dashboard.contents_summary.metrics[i].count;
                }
            }
            return 0;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    System.getInsights().$promise
                ])
                .then(function(results) {
                    vm.dashboard = results[0];
                    vm.dashboard.conversations_summary.avg_messages_per_conversation = Math.ceil(vm.dashboard.conversations_summary.avg_messages_per_conversation);

                    vm.dashboard.smartflows_summary = {
                        total_smartflows: 0,
                        total_executions: 0,
                        total_active: 0,
                        total_draft: 0
                    };

                    vm.loadingData = false;
                });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('CameraSettingController', CameraSettingController)

    /* @ngInject */
    function CameraSettingController($mdDialog, $q, $scope, $filter, $sce, ParseLinks, $state, AlertService, ContentAction, $mdToast, $mdSidenav, Principal, Setting, Feature, ToastService) {
        var vm = this;

        vm.photo_setting = "Standard";
        vm.video_setting = "Standard x 30 fps";

        vm.photo_setting_options = ["Standard", "High quality"];
        vm.video_setting_options = ["Standard x 30 fps", "HD x 30 fps", "HD x 60 fps"];
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.cameraModel = {
            id: null,
            photo_setting: "Standard",
            video_setting: "Standard x 30 fps"
        };

        vm.onSaveSuccess = function(result) {
            vm.cameraModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        function setCameraettings() {
            setCameraSettingField("photo_setting", vm.cameraModel.photo_setting);
            setCameraSettingField("video_setting", vm.cameraModel.video_setting);
        }

        function setCameraSettingField(fieldName, fieldValue) {
            var foundField = false;
            angular.forEach(vm.cameraSetting.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.airformSetting.fields.push(settingField);
            }
        }

        vm.save = function() {
            setCameraettings();

            Setting.update(vm.cameraSetting, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"), 3000);
            });
        }



        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getCameraSettings().$promise
                ])
                .then(function(results) {
                    setCameraSessionModel(results[0]);
                    vm.loadingData = false;
                });
        };

        function setCameraSessionModel(settings) {

            angular.forEach(settings, function(setting) {
                if (setting.category == 'Lens Camera') {
                    vm.cameraSetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'photo_setting') {
                            vm.cameraModel.photo_setting = settingField.value;
                        }
                        if (settingField.name == 'video_setting') {
                            vm.cameraModel.video_setting = settingField.value;
                        }

                    });
                }
            });
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);


    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-setting.authentication', {
                abstract: true,
                url: '/authentication',
                views: {
                    '@storm': {
                        templateUrl: 'modules/system/authentication/authentication.tmpl.html',
                        controller: 'AuthenticationController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.setting.authentication',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.authentication.studio', {
                url: '/studio-setup',
                controller: 'AuthenticationStudioSetupController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/authentication/authentication-studio-setup.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.authentication',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.authentication.lens', {
                url: '/lens-setup',
                controller: 'AuthenticationLensSetupController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/authentication/authentication-lens-setup.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.authentication',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.authentication.saml', {
                url: '/saml',
                controller: 'AuthenticationSamlController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/authentication/authentication-saml.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.authentication',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.authentication.google', {
                url: '/google',
                controller: 'AuthenticationGoogleController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/authentication/authentication-google.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.authentication',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.authentication.azureAD', {
                url: '/azure-ad',
                controller: 'AuthenticationAzureADController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/authentication/authentication-azure-ad.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.authentication',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.authentication.oidc', {
                url: '/oidc',
                controller: 'AuthenticationOIDCController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/authentication/authentication-oidc.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.authentication',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationController', AuthenticationController);

    /* @ngInject */
    function AuthenticationController($scope, $state, $q, Setting, $mdToast, $filter, $mdDialog, PermissionService, Feature) {
        var vm = this;

        vm.hasPermission = PermissionService.hasAccess('manage-sso-system');
        vm.isFeatureActive = Feature.isActive('feature_system_sso');
        vm.pageTitleKey = $state.$current.data.pageTitle;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationStudioSetupController', AuthenticationStudioSetupController);

    /* @ngInject */
    function AuthenticationStudioSetupController($scope, $state, $q, Setting, $filter, $mdDialog, $window, ToastService, PermissionService, Feature) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.loginSettings = [];
        vm.enableAtheerLogin = true;
        vm.enableForgotPassword = false;
        vm.googleSSO = false;
        vm.twitterSSO = false;
        vm.linkedInSSO = false;
        vm.facebookSSO = false;
        vm.samlSSO = false;
        vm.azureAdSSO = false;
        vm.oidcSSO = false;
        vm.autoSignoutEnabled = false;
        vm.autoSignoutWaitMins = 30;
        vm.autoSignoutWarning = false;
        vm.hasPermission = PermissionService.hasAccess('manage-sso-system');
        vm.isFeatureActive = Feature.isActive('feature_system_sso');

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAuthenticationSetupSettings().$promise
                ])
                .then(function(results) {
                    setLoginFields(results[0]);
                    vm.loadingData = false;
                });
        };

        function setLoginFields(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'authentication-setup') {
                    vm.loginSettings = setting;
                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'google_sso') {
                            vm.googleSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'facebook_sso') {
                            vm.facebookSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'linkedin_sso') {
                            vm.linkedInSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'twitter_sso') {
                            vm.twitterSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'saml_sso') {
                            vm.samlSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'azureAD_sso') {
                            vm.azureAdSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'studio_oidc_sso') {
                            vm.oidcSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'forgot_password') {
                            vm.enableForgotPassword = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'atheer_login') {
                            vm.enableAtheerLogin = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'auto_signout_enabled') {
                            vm.autoSignoutEnabled = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'auto_signout_wait_time_mins') {
                            vm.autoSignoutWaitMins = parseInt(settingField.value);
                        } else if (settingField.name == 'auto_signout_show_warning') {
                            vm.autoSignoutWarning = (settingField.value == 'true' ? true : false);
                        }
                    });
                }
            });
        }

        function setLoginSettings() {
            if(vm.loginSettings.fields == undefined) {
                vm.loginSettings.fields = [];
            };

            setSettingField("atheer_login", (vm.enableAtheerLogin ? 'true' : 'false'));
            setSettingField("forgot_password", (vm.enableForgotPassword ? 'true' : 'false'));
            setSettingField("google_sso", (vm.googleSSO ? 'true' : 'false'));
            setSettingField("facebook_sso", (vm.facebookSSO ? 'true' : 'false'));
            setSettingField("linkedin_sso", (vm.linkedInSSO ? 'true' : 'false'));
            setSettingField("twitter_sso", (vm.twitterSSO ? 'true' : 'false'));
            setSettingField("saml_sso", (vm.samlSSO ? 'true' : 'false'));
            setSettingField("azureAD_sso", (vm.azureAdSSO ? 'true' : 'false'));
            setSettingField("studio_oidc_sso", (vm.oidcSSO ? 'true' : 'false'));
            setSettingField("auto_signout_enabled", (vm.autoSignoutEnabled ? 'true' : 'false'));
            setSettingField("auto_signout_wait_time_mins", vm.autoSignoutWaitMins + '');
            setSettingField("auto_signout_show_warning", (vm.autoSignoutWarning ? 'true' : 'false'));
        };

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;

            angular.forEach(vm.loginSettings.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.loginSettings.fields.push(settingField);
            }
        };

        vm.save = function() {
            setLoginSettings();

            Setting.update(vm.loginSettings, function() {
                ToastService.displayToastWithAction($filter('triTranslate')("atheer.setting.success"),
                    $filter('translate')('entity.action.refresh'), 'md-warn', '', function(res) {
                        if (res == 'ok') {
                            $window.location.reload();
                        }
                    });
            });
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationSamlController', AuthenticationSamlController);

    /* @ngInject */
    function AuthenticationSamlController($scope, $state, $q, Setting, $filter, $mdDialog, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.configSettings = [];
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.samlMetaData = null;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAuthenticationConfigSettings().$promise
                ])
                .then(function(results) {
                    setConfigFields(results[0]);
                    vm.loadingData = false;
                });
        };

        function setConfigFields(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'authentication-config') {
                    vm.configSettings = setting;
                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'saml_metadata') {
                            vm.samlMetaData = settingField.value;
                        }
                    });
                }
            });
        }

        function setConfigSettings() {
            if(vm.configSettings.fields == undefined) {
                vm.configSettings.fields = [];
            };

            setSettingField("saml_metadata", vm.samlMetaData);
        };

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;

            angular.forEach(vm.configSettings.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.configSettings.fields.push(settingField);
            }
        };

        vm.save = function() {
            setConfigSettings();

            Setting.update(vm.configSettings, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"));
            });
        };

        vm.showSPMetaData = function() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/system/authentication/authentication-saml-sp-dialog.tmpl.html',
                controller: 'AuthenticationSamlSPDialogController',
                controllerAs: 'vm',
                backdrop: 'static'
            });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationSamlSPDialogController', AuthenticationSamlSPDialogController);

    /* @ngInject */
    function AuthenticationSamlSPDialogController($scope, $q, Setting, $filter, $mdDialog, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.configSettings = [];

        vm.spMetadata = null;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAuthenticationSamlMetadata().$promise
                ])
                .then(function(results) {
                    vm.spMetadata = results[0].service_provier;
                    vm.loadingData = false;
                });
        };

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.onCopySuccess = function() {
            ToastService.displayToast($filter('translate')('atheer.authentication.setup.copied'), 2000);
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationOIDCController', AuthenticationOIDCController);

    /* @ngInject */
    function AuthenticationOIDCController($scope, $state, $q, Setting, $filter, $mdDialog, ToastService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.loadingData = false;
        vm.configSettings = [];

        vm.applicationId = null;
        vm.tenantId = null;
        vm.discoverUri = null;
        vm.authUri = null;
        vm.tokenUri = null;
        vm.signInLabel = null;
        vm.logoutUri = null;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAuthenticationConfigSettings().$promise
                ])
                .then(function(results) {
                    setConfigFields(results[0]);

                    vm.loadingData = false;
                });
        };

        function setConfigFields(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'authentication-config') {
                    vm.configSettings = setting;
                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'oidc_application_id') {
                            vm.applicationId = settingField.value;
                        } else if (settingField.name == 'oidc_tenant_id') {
                            vm.tenantId = settingField.value;
                        } else if (settingField.name == 'oidc_discover_uri') {
                            vm.discoverUri = settingField.value;
                        } else if (settingField.name == 'oidc_auth_uri') {
                            vm.authUri = settingField.value;
                        } else if (settingField.name == 'oidc_token_uri') {
                            vm.tokenUri = settingField.value;
                        } else if (settingField.name == 'oidc_sign_in_label') {
                            vm.signInLabel = settingField.value;
                        } else if (settingField.name == 'oidc_logout_uri') {
                            vm.logoutUri = settingField.value;
                        }
                    });
                }
            });
        }

        function setConfigSettings() {
            if(vm.configSettings.fields == undefined) {
                vm.configSettings.fields = [];
            };

            setSettingField("oidc_application_id", vm.applicationId);
            setSettingField("oidc_tenant_id", vm.tenantId);
            setSettingField("oidc_discover_uri", vm.discoverUri);
            setSettingField("oidc_auth_uri", vm.authUri);
            setSettingField("oidc_token_uri", vm.tokenUri);
            setSettingField("oidc_sign_in_label", vm.signInLabel);
            setSettingField("oidc_logout_uri", vm.logoutUri);
        };

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;

            angular.forEach(vm.configSettings.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.configSettings.fields.push(settingField);
            }
        };

        vm.save = function() {
            setConfigSettings();

            Setting.update(vm.configSettings, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"));
            });
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationLensSetupController', AuthenticationLensSetupController);

    /* @ngInject */
    function AuthenticationLensSetupController($scope, $state, $q, Setting, $filter, $mdDialog, ToastService, PermissionService, Feature) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.loginSettings = [];
        vm.lensEnableAtheerLogin = true;
        vm.lensEnableForgotPassword = false;
        vm.lensGoogleSSO = false;
        vm.lensTwitterSSO = false;
        vm.lensLinkedInSSO = false;
        vm.lensFacebookSSO = false;
        vm.lensSamlSSO = false;
        vm.lensAzureAdSSO = false;
        vm.oidcSSO = false;
        vm.lensAutoSignoutEnabled = false;
        vm.lensAutoSignoutWaitMins = 30;
        vm.lensAutoSignoutWarning = false;
        vm.hasPermission = PermissionService.hasAccess('manage-sso-system');
        vm.isFeatureActive = Feature.isActive('feature_system_sso');

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAuthenticationSetupSettings().$promise
                ])
                .then(function(results) {
                    setLoginFields(results[0]);
                    vm.loadingData = false;
                });
        };

        function setLoginFields(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'authentication-setup') {
                    vm.loginSettings = setting;
                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'lens_google_sso') {
                            vm.lensGoogleSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_facebook_sso') {
                            vm.lensFacebookSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_linkedin_sso') {
                            vm.lensLinkedInSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_twitter_sso') {
                            vm.lensTwitterSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_saml_sso') {
                            vm.lensSamlSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_azureAD_sso') {
                            vm.lensAzureAdSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_oidc_sso') {
                            vm.oidcSSO = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_forgot_password') {
                            vm.lensEnableForgotPassword = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_atheer_login') {
                            vm.lensEnableAtheerLogin = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_auto_signout_enabled') {
                            vm.lensAutoSignoutEnabled = (settingField.value == 'true' ? true : false);
                        } else if (settingField.name == 'lens_auto_signout_wait_time_mins') {
                            vm.lensAutoSignoutWaitMins = parseInt(settingField.value);
                        } else if (settingField.name == 'lens_auto_signout_show_warning') {
                            vm.lensAutoSignoutWarning = (settingField.value == 'true' ? true : false);
                        }
                    });
                }
            });
        }

        function setLoginSettings() {
            if(vm.loginSettings.fields == undefined) {
                vm.loginSettings.fields = [];
            };

            setSettingField("lens_atheer_login", (vm.lensEnableAtheerLogin ? 'true' : 'false'));
            setSettingField("lens_forgot_password", (vm.lensEnableForgotPassword ? 'true' : 'false'));
            setSettingField("lens_google_sso", (vm.lensGoogleSSO ? 'true' : 'false'));
            setSettingField("lens_facebook_sso", (vm.lensFacebookSSO ? 'true' : 'false'));
            setSettingField("lens_linkedin_sso", (vm.lensLinkedInSSO ? 'true' : 'false'));
            setSettingField("lens_twitter_sso", (vm.lensTwitterSSO ? 'true' : 'false'));
            setSettingField("lens_saml_sso", (vm.lensSamlSSO ? 'true' : 'false'));
            setSettingField("lens_azureAD_sso", (vm.lensAzureAdSSO ? 'true' : 'false'));
            setSettingField("lens_oidc_sso", (vm.oidcSSO ? 'true' : 'false'));
            setSettingField("lens_auto_signout_enabled", (vm.lensAutoSignoutEnabled ? 'true' : 'false'));
            setSettingField("lens_auto_signout_wait_time_mins", vm.lensAutoSignoutWaitMins + '');
            setSettingField("lens_auto_signout_show_warning", (vm.lensAutoSignoutWarning ? 'true' : 'false'));
        };

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;

            angular.forEach(vm.loginSettings.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.loginSettings.fields.push(settingField);
            }
        };

        vm.save = function() {
            setLoginSettings();

            Setting.update(vm.loginSettings, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"));
            });
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationGoogleController', AuthenticationGoogleController);

    /* @ngInject */
    function AuthenticationGoogleController($scope, $state, $q, Setting, $filter, $mdDialog, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.configSettings = [];
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.googleKey = null;
        vm.googleSecret = null;
        vm.googleLensAndroidClientId = null;
        vm.googleLensiOSClientId = null;
        vm.googleLensiOSUrl = null;
        vm.twitterKey = null;
        vm.twitterSecret = null;
        vm.linkedInKey = null;
        vm.linkedInSecret = null;
        vm.facebookKey = null;
        vm.facebookSecret = null;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAuthenticationConfigSettings().$promise
                ])
                .then(function(results) {
                    setConfigFields(results[0]);

                    vm.loadingData = false;
                });
        };

        function setConfigFields(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'authentication-config') {
                    vm.configSettings = setting;
                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'google_key') {
                            vm.googleKey = settingField.value;
                        } else if (settingField.name == 'google_secret') {
                            vm.googleSecret = settingField.value;
                        } else if (settingField.name == 'google_lens_android_client_id') {
                            vm.googleLensAndroidClientId = settingField.value;
                        } else if (settingField.name == 'google_lens_ios_client_id') {
                            vm.googleLensiOSClientId = settingField.value;
                        } else if (settingField.name == 'google_lens_ios_url') {
                            vm.googleLensiOSUrl = settingField.value;
                        } else if (settingField.name == 'facebook_key') {
                            vm.twitterKey = settingField.value;
                        } else if (settingField.name == 'facebook_secret') {
                            vm.twitterSecret = settingField.value;
                        } else if (settingField.name == 'linkedin_key') {
                            vm.linkedInKey = settingField.value;
                        } else if (settingField.name == 'linkedin_secret') {
                            vm.linkedInSecret = settingField.value;
                        } else if (settingField.name == 'twitter_key') {
                            vm.facebookKey = settingField.value;
                        } else if (settingField.name == 'twitter_secret') {
                            vm.facebookSecret = settingField.value;
                        }
                    });
                }
            });
        }

        function setConfigSettings() {
            if(vm.configSettings.fields == undefined) {
                vm.configSettings.fields = [];
            };

            setSettingField("google_key", vm.googleKey);
            setSettingField("google_secret", vm.googleSecret);
            setSettingField("google_lens_android_client_id", vm.googleLensAndroidClientId);
            setSettingField("google_lens_ios_client_id", vm.googleLensiOSClientId);
            setSettingField("google_lens_ios_url", vm.googleLensiOSUrl);
            setSettingField("facebook_key", vm.facebookKey);
            setSettingField("facebook_secret", vm.facebookSecret);
            setSettingField("linkedin_key", vm.linkedInKey);
            setSettingField("linkedin_secret", vm.linkedInSecret);
            setSettingField("twitter_key", vm.twitterKey);
            setSettingField("twitter_secret", vm.twitterSecret);
        };

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;

            angular.forEach(vm.configSettings.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.configSettings.fields.push(settingField);
            }
        };

        vm.save = function() {
            setConfigSettings();

            Setting.update(vm.configSettings, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"));
            });
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuthenticationAzureADController', AuthenticationAzureADController);

    /* @ngInject */
    function AuthenticationAzureADController($scope, $state, $q, Setting, $filter, $mdDialog, ToastService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.loadingData = false;
        vm.configSettings = [];

        vm.applicationId = null;
        vm.tenantId = null;
        vm.discoverUri = null;
        vm.authUri = null;
        vm.tokenUri = null;
        vm.logoutUri = null;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAuthenticationConfigSettings().$promise
                ])
                .then(function(results) {
                    setConfigFields(results[0]);

                    vm.loadingData = false;
                });
        };

        function setConfigFields(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'authentication-config') {
                    vm.configSettings = setting;
                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'azure_ad_application_id') {
                            vm.applicationId = settingField.value;
                        } else if (settingField.name == 'azure_ad_tenant_id') {
                            vm.tenantId = settingField.value;
                        } else if (settingField.name == 'discover_uri') {
                            vm.discoverUri = settingField.value;
                        } else if (settingField.name == 'auth_uri') {
                            vm.authUri = settingField.value;
                        } else if (settingField.name == 'token_uri') {
                            vm.tokenUri = settingField.value;
                        } else if (settingField.name == 'logout_uri') {
                            vm.logoutUri = settingField.value;
                        }
                    });
                }
            });
        }

        function setConfigSettings() {
            if(vm.configSettings.fields == undefined) {
                vm.configSettings.fields = [];
            };

            setSettingField("azure_ad_application_id", vm.applicationId);
            setSettingField("azure_ad_tenant_id", vm.tenantId);
            setSettingField("discover_uri", vm.discoverUri);
            setSettingField("auth_uri", vm.authUri);
            setSettingField("token_uri", vm.tokenUri);
            setSettingField("logout_uri", vm.logoutUri);
        };

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;

            angular.forEach(vm.configSettings.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.configSettings.fields.push(settingField);
            }
        };

        vm.save = function() {
            setConfigSettings();

            Setting.update(vm.configSettings, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"));
            });
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-setting.badges', {
                url: '/badges?page&sort&search',
                templateUrl: 'modules/system/badge/badges.html',
                controller: 'BadgeController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.badge.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-badge-detail', {
                url: '/badges/:id',
                templateUrl: 'modules/system/badge/badge-detail.tmpl.html',
                controller: 'BadgeDetailController as vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('BadgeController', BadgeController);

    /* @ngInject */
    function BadgeController($scope, $state, $window, Badge, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, $filter) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.removeFilter = removeFilter;
        vm.getQueryString = getQueryString;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
         vm.illustartionEmptyScreenId = "badge";

        vm.showCardView = true;
        vm.cardView = true;

        vm.permissions = {
            create : 'manage-badge-system',
            update : 'manage-badge-system',
            delete : 'manage-badge-system',
            manage : 'manage-badge-system'
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.openAssignModal = function(badgeObj) {
            $mdDialog.show({
                templateUrl: 'modules/system/badge/badge-assign-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "BadgeAssignController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    badge: badgeObj,
                    userId: undefined
                }
            });
        }

        function loadAll() {
            Badge.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.badges = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return null;
            } else {
                return 'name=re=' + vm.query.filter;
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.reverse = !vm.reverse;
            vm.transition();
        }

        function transition() {
            vm.promise = Badge.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.badges = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            vm.loadAll();
        }

        function createObject() {
            $state.go('storm.admin-badge-detail');
        }

        function editObject(objectId) {
            $state.go('storm.admin-badge-detail', {
                'id': objectId
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.badge.deleteObject'))
                .ariaLabel($filter('translate')('atheer.badge.deleteObject'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Badge.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.getDefaultBackground = function() {
            return '#bdbec0';
        };

        vm.back = function() {
            $window.history.back();
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('BadgePickerController', BadgePickerController);

    /* @ngInject */
    function BadgePickerController($scope, $state, $mdDialog, Badge, ParseLinks, AlertService, $mdToast, $filter, filter, allowMultiSelect, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "id";
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.selected = [];
        vm.allowMultiSelect = allowMultiSelect;

        vm.currentSelectedItems = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.getQueryString = getQueryString;

        vm.loadAll();

        function loadAll() {
            Badge.query({
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = ['id' + ',' + 'asc'];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.badges = data;
                vm.page = 1;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Badge.query({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: getSortOrder(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.badges = data;
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return filter;
            } else {
                return filter + ';text_search=ts=' + vm.query.filter;
            }
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedItems);
        }

        vm.close = function() {
            $mdDialog.cancel();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('BadgeDetailController', BadgeDetailController)

    /* @ngInject */
    function BadgeDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, Badge, id, Experience) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.userBadges = []

        if (id) {
            Badge.get({
                id: id
            }, function(result) {
                vm.badgeModel = result;
                vm.loadUserBadges();
            });
        } else {
            vm.badgeModel = {
                name: null,
                description: null,
                status: 'DRAFT'
            }
        }

        vm.openAssignModal = function() {
            $mdDialog.show({
                templateUrl: 'modules/system/badge/badge-assign-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "BadgeAssignController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    badge: vm.badgeModel,
                    userId: undefined
                }
            }).then(function() {
                vm.loadUserBadges();
            });
        }

        vm.loadUserBadges = function() {
            Experience.getBadges({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                query: getUserQueryString(),
                user_info: true
            }, function(response, headers) {
                vm.userBadges = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.loadingData = false;
            });
        }

        vm.removeUserBadge = function(badge, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.badge.removeUserBadge'))
                .ariaLabel($filter('translate')('atheer.badge.removeUserBadge'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Experience.deleteBadge(badge, function() {
                    vm.userBadges.splice(index, 1);
                });
            });
        }

        vm.transitionUserBadges = function() {
            vm.promise = Experience.getBadges({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                query: getUserQueryString(),
                user_info: true
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.userBadges = response;
            });
        }

        function getUserQueryString() {
            var queryString = "object_id==" + vm.badgeModel.id;
            return queryString;
        }

        vm.onSaveSuccess = function(result) {
            vm.badgeModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            if (vm.badgeModel.id) {
                Badge.update(vm.badgeModel, vm.onSaveSuccess, vm.onSaveError);
            } else {
                Badge.save(vm.badgeModel, vm.onSaveSuccess, vm.onSaveError);
            }
        };

        vm.goToBadges = function() {
            $state.go('storm.admin-badges');
        };

        vm.isNew = function() {
            if (vm.badgeModel == undefined || vm.badgeModel.id == null) {
                return true;
            } else {
                return false;
            }
        }

        vm.copyBadge = function() {
            delete vm.badgeModel['id'];
        }

        this.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('BadgeAssignController', BadgeAssignController);

    /* @ngInject */
    function BadgeAssignController($scope, $state, $mdDialog, $q, $filter, $timeout, badge, userId, Experience, User, Badge, ToastService) {
        var vm = this;

        vm.asyncUsers = [];
        vm.badge = badge;
        vm.searchUser = searchUser;

        vm.asyncBadges = [];
        vm.fromProfilePage = userId != undefined;
        vm.searchBadge = searchBadge;

        function updateSelectedBadgeIndex(value) {
            if (value) {
                var skillObjectFromList = $filter('filter')(vm.asyncSkills, {
                    skillObj: {
                        id: value.skillObj.id
                    }
                })[0];
                if (skillObjectFromList) {
                    vm.selectedSkillIndex = vm.asyncSkills.indexOf(skillObjectFromList);
                } else {
                    vm.selectedSkillIndex = -1;
                }
            }
        }

        function getUserQueryString(criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'text_search=ts=' + criteria;
            }
        }

        function getBadgeQueryString(criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'name=re=' + criteria;
            }
        }

        function searchBadge(criteria) {
            var d = $q.defer();
            var result = Badge.query({
                query: getBadgeQueryString(criteria)
            }, function(result) {
                d.resolve(result);
            });
            return d.promise;
        }

        vm.transformChip = function(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
        }

        function searchUser(criteria) {
            var d = $q.defer();
            var result = User.query({
                query: getUserQueryString(criteria)
            }, function(result) {
                d.resolve(result);
            });
            return d.promise;
        }

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.submit = function() {
            if (!vm.fromProfilePage) {
                angular.forEach(vm.asyncUsers, function(user) {
                    Experience.assignBadge({
                        user_id: user.id,
                        object: vm.badge,
                        acquired_on: new Date()
                    }, function(result) {
                        ToastService.displayToast($filter('triTranslate')('assignBadge.assignedSuccessfull'), 3000);
                        $mdDialog.hide();
                    });
                });
            } else {
                angular.forEach(vm.asyncBadges, function(badge) {
                    Experience.assignBadge({
                        user_id: userId,
                        object: badge,
                        acquired_on: new Date()
                    }, function(result) {
                        ToastService.displayToast($filter('triTranslate')("assignBadge.assignedSuccessfull"), 3000);
                        $mdDialog.hide();
                    });
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(moduleConfig);

    function moduleConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-audits', {
                url: '/settings/audits',
                templateUrl: 'modules/system/audits/audits.tmpl.html',
                controller: 'AuditsController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.audits.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuditsController', AuditsController);

    /* @ngInject */
    function AuditsController($filter, $state, ParseLinks, AlertService, pagingParams, paginationConstants, AuditsService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        function loadAll() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                fromDate: fromDate,
                toDate: toDate
            }, function(result, headers) {
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
            });
        }

        // Date picker configuration
        function today() {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth() {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }
            vm.fromDate = fromDate;
        }

        function transition() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            vm.promise = AuditsService.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                fromDate: fromDate,
                toDate: toDate
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.audits = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.refresh();
        }

        vm.today();
        vm.previousMonth();
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('WatershedAppDetailController', WatershedAppDetailController)

    /* @ngInject */
    function WatershedAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http, IntegrationApp) {
        var vm = this;

        vm.appModel = null;
        vm.key = null;
        vm.secret = null;

        vm.loadData = function() {
            App.getByName({
                id: appName
            }, function(result) {
                vm.appModel = result;
                angular.forEach(vm.appModel.settings, function(settingField) {
                    if (settingField.value != null) {
                        if (settingField.name == 'key') {
                            vm.key = settingField.value;
                        }
                        if (settingField.name == 'secret') {
                            vm.secret = settingField.value;
                        }
                    }
                });
            });
        }

        function setAppSettings() {
            setSettingField("key", vm.key);
            setSettingField("secret", vm.secret);
        }

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;
            if(!vm.appModel.settings) {
                vm.appModel.settings = [];
            }

            angular.forEach(vm.appModel.settings, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.appModel.settings.push(settingField);
            }
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            setAppSettings();
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('VimeoAppDetailController', VimeoAppDetailController)

    /* @ngInject */
    function VimeoAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            if ($location.search().code != undefined) {
                IntegrationApp.vimeo({
                    code:$location.search().code,
                    app:appName
                },function(result){
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/vimeo');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('UdacityAppDetailController', UdacityAppDetailController)

    /* @ngInject */
    function UdacityAppDetailController($mdDialog, $scope, $controller, appName) {
        

        var basectrl = $controller('AppDetailController as vm', {
            $scope: $scope,
            appName: appName
        });

        angular.extend(this, basectrl);

        var vm = this;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SlackAppDetailController', SlackAppDetailController)

    /* @ngInject */
    function SlackAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            if ($location.search().code != undefined) {
                IntegrationApp.slack({
                    code:$location.search().code,
                    app:appName
                },function(result){debugger
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/slack');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('ScormCloudAppDetailController', ScormCloudAppDetailController)

    /* @ngInject */
    function ScormCloudAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http, IntegrationApp) {
        var vm = this;

        vm.appModel = null;
        vm.appIdentiFier = null;
        vm.secretKey = null;

        vm.loadData = function() {
            App.getByName({
                id: appName
            }, function(result) {
                vm.appModel = result;
                angular.forEach(vm.appModel.settings, function(settingField) {
                    if (settingField.value != null) {
                        if (settingField.name == 'app_identifier') {
                            vm.appIdentiFier = settingField.value;
                        }
                        if (settingField.name == 'secret_key') {
                            vm.secretKey = settingField.value;
                        }
                    }
                });
            });
        }

        function setAppSettings() {
            setSettingField("app_identifier", vm.appIdentiFier);
            setSettingField("secret_key", vm.secretKey);
        }

        function setSettingField(fieldName, fieldValue) {
            var foundField = false;
            if(!vm.appModel.settings) {
                vm.appModel.settings = [];
            }

            angular.forEach(vm.appModel.settings, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.appModel.settings.push(settingField);
            }
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            setAppSettings();
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SalesforceAppDetailController', SalesforceAppDetailController)

    /* @ngInject */
    function SalesforceAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            if($location.search().code != undefined) {
                IntegrationApp.salesforce({
                    code:$location.search().code,
                    app:appName
                },function(result){debugger
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/salesforce');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('OneDriveAppDetailController', OneDriveAppDetailController)

    /* @ngInject */
    function OneDriveAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            if ($location.search().code != undefined) {
                IntegrationApp.onedrive({
                    code:$location.search().code,
                    app:appName
                },function(result){
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/msft-onedrive');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('MicrosoftAppDetailController', MicrosoftAppDetailController)

    /* @ngInject */
    function MicrosoftAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            if ($location.search().code != undefined) {
                IntegrationApp.msftoffice({
                    code:$location.search().code,
                    app:appName
                },function(result){debugger
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/msft-office');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.system')
        .constant('INTEGRATION_APP_META', {
            'adp': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/adp.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'salesforce': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/salesforce.png',
                controller: 'SalesforceAppDetailController',
                template: 'modules/system/app/salesforce-app-detail.tmpl.html'
            },
            'slack': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/slack.png',
                controller: 'SlackAppDetailController',
                template: 'modules/system/app/slack-app-detail.tmpl.html'
            },
            'namely': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/namely.svg',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'zenefits': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/zenefits.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'google-app': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/google.png',
                controller: 'GoogleAppDetailController',
                template: 'modules/system/app/google-app-detail.tmpl.html'
            },
            'google-drive': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/google-drive.png',
                controller: 'GoogleDriveAppDetailController',
                template: 'modules/system/app/google-drive-app-detail.tmpl.html'
            },
            'workday': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/workday.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'udemy': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/udemy.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'lynda': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/lynda.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'udacity' : {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/udacity.png',
                controller: 'UdacityAppDetailController',
                template: 'modules/system/app/udacity-app-detail.tmpl.html'
            },
            'coursera': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/coursera.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'pluralsight': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/pluralsight.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'getabstract': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/getabstract.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'tuts': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/tuts.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'skillshare': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/skillshare.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'codeschool': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/codeschool.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'safari-books': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/safari-books.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'khan-academy': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/khan-academy.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'ted': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/ted.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'vimeo': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/vimeo.png',
                controller: 'VimeoAppDetailController',
                template: 'modules/system/app/vimeo-app-detail.tmpl.html'
            },
            'edx': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/edx.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'box': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/box.png',
                controller: 'BoxAppDetailController',
                template: 'modules/system/app/box-app-detail.tmpl.html'
            },
            'dropbox': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/dropbox.png',
                controller: 'DropboxAppDetailController',
                template: 'modules/system/app/dropbox-app-detail.tmpl.html'
            },
            'saba': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/saba.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'sumtotal': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/sumtotal.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'successfactors': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/successfactors.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'csod': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/csod.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'sap': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/sap.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'oracle': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/oracle.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'peoplesoft': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/peoplesoft.png',
                controller: 'AppDetailController',
                template: 'modules/system/app/app-detail.tmpl.html'
            },
            'msft-office': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/msft-office.png',
                controller: 'MicrosoftAppDetailController',
                template: 'modules/system/app/microsoft-app-detail.tmpl.html'
            },
            'msft-onedrive': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/msft-onedrive.png',
                controller: 'OneDriveAppDetailController',
                template: 'modules/system/app/onedrive-app-detail.tmpl.html'
            },
            'scorm-cloud': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/scorm-cloud.png',
                controller: 'ScormCloudAppDetailController',
                template: 'modules/system/app/scorm-cloud-app-detail.tmpl.html'
            },
            'watershed': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/watershed.png',
                controller: 'WatershedAppDetailController',
                template: 'modules/system/app/watershed-app-detail.tmpl.html'
            },
            'wistia': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/wistia.png',
                controller: 'OneDriveAppDetailController',
                template: 'modules/system/app/onedrive-app-detail.tmpl.html'
            },
            'zoom': {
                icon: 'zmdi zmdi-account',
                logo: '/assets/images/integration/zoom.png',
                controller: 'ZoomAppDetailController',
                template: 'modules/system/app/zoom-app-detail.tmpl.html'
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('GoogleDriveAppDetailController', GoogleDriveAppDetailController)

    /* @ngInject */
    function GoogleDriveAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            if ($location.search().code != undefined) {
                IntegrationApp.googledrive({
                    code:$location.search().code,
                    app:appName
                },function(result){debugger
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/google-drive');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('GoogleAppDetailController', GoogleAppDetailController)

    /* @ngInject */
    function GoogleAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            if ($location.search().code != undefined) {
                IntegrationApp.googleapp({
                    code:$location.search().code,
                    app:appName
                },function(result){debugger
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/google-app');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('DropboxAppDetailController',DropboxAppDetailController)

    /* @ngInject */
    function DropboxAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {

            if ($location.search().code != undefined) {debugger
                IntegrationApp.dropbox({
                    code:$location.search().code,
                    app:appName
                },function(result){debugger
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/dropbox');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        };

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('BoxAppDetailController',BoxAppDetailController)

    /* @ngInject */
    function BoxAppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, AlertService, $mdToast, $mdSidenav, App, appName, Experience, $location, $http,IntegrationApp) {
        var vm = this;

        vm.data2 = true;
        vm.appModel = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {

            if ($location.search().code != undefined) {debugger
                IntegrationApp.box({
                    code:$location.search().code,
                    app:appName
                },function(result){debugger
                    $scope.vm.appModel = result;
                    $location.url('/admin/app/box');
                });
            }
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        };

        vm.onSaveSuccess = function(result) {
            vm.appModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.enable = function() {
            vm.appModel.enabled = true;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.disable = function() {
            vm.appModel.enabled = false;
            vm.appModel.app_type = 'SYSTEM';
            App.update(vm.appModel, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-setting.apps', {
                url: '/apps?page&sort&search',
                templateUrl: 'modules/system/app/apps.tmpl.html',
                controller: 'AppController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.app.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-app-detail', {
                url: '/settings/app/:name',
                templateProvider: function($templateRequest, $stateParams, INTEGRATION_APP_META) {
                    var meta = INTEGRATION_APP_META[$stateParams.name];
                    if (meta) {
                        return $templateRequest(meta.template);
                    } else {
                        return $templateRequest('modules/system/app/app-detail.tmpl.html');
                    }
                },
                controllerProvider: function($stateParams, INTEGRATION_APP_META) {
                    var meta = INTEGRATION_APP_META[$stateParams.name];
                    if (meta) {
                        return meta.controller;
                    } else {
                        return 'AppDetailController';
                    }
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    appName: function($stateParams) {
                        return $stateParams.name;
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AppController', AppController);

    /* @ngInject */
    function AppController($scope, $state, App, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, INTEGRATION_APP_META, Principal) {
        var vm = this;

        vm.loadAll = loadAll;

        vm.editObject = editObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.pageSize = 100;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.getAppMeta = getAppMeta;
        vm.isWorkspaceAdmin = Principal.isWorkspaceAdmin();

        function getAppMeta(appName){
            return INTEGRATION_APP_META[appName];
        }

        vm.query = {
            filter: '',
            limit: vm.pageSize,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function loadAll() {
            App.query({
                page: pagingParams.page - 1,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.apps = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getQueryString() {
            if(vm.isWorkspaceAdmin) {
                return null;
            } else {
                return  'enabled==true';
            }
        }

        function editObject(appName) {
            $state.go('storm.admin-app-detail', {
                'name': appName
            });
        }
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AppDialogController', AppDialogController);

    AppDialogController.$inject = ['$scope', '$stateParams', '$mdDialog', 'entity', 'App'];

    function AppDialogController ($scope, $stateParams, $mdDialog, entity, App) {
        var vm = this;
        vm.app = entity;
        vm.load = function(id) {
            App.get({id : id}, function(result) {
                vm.app = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('atheer:appUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.app.id !== null) {
                App.update(vm.app, onSaveSuccess, onSaveError);
            } else {
                App.save(vm.app, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AppDetailController', AppDetailController)

    /* @ngInject */
    function AppDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, AlertService, $mdToast, $mdSidenav, App, appName) {

        this.appModel = null;

        this.loadData = function() {
            App.getByName({
                id: appName
            }, function(result) {
                $scope.vm.appModel = result;
            });
        }

        function onSaveSuccess(result) {
            $scope.vm.appModel = result;
            $scope.vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        function onSaveError() {
            $scope.vm.isSaving = false;
        };

        this.save = function() {
            this.appModel.app_type = 'SYSTEM';
            App.update(this.appModel, onSaveSuccess, onSaveError);
        };

        this.enable = function() {
            this.appModel.enabled = true;
            this.appModel.app_type = 'SYSTEM';
            App.update(this.appModel, onSaveSuccess, onSaveError);
        };

        this.disable = function() {
            this.appModel.enabled = false;
            this.appModel.app_type = 'SYSTEM';
            App.update(this.appModel, onSaveSuccess, onSaveError);
        };

        this.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };

        this.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AirformSettingController', AirformSettingController)

    /* @ngInject */
    function AirformSettingController($mdDialog, $q, $scope, $filter, $sce, ParseLinks, $state, AlertService, ContentAction, $mdToast, $mdSidenav, Principal, Setting, Feature, ToastService) {
        var vm = this;

        vm.photo_header_max_size = 1;
        vm.video_header_max_size = 5;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.airformModel = {
            id: null,
            photo_header_max_size: 1,
            video_header_max_size: 5
        };

        vm.onSaveSuccess = function(result) {
            vm.airformModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        function setAirformSettings() {
            setAirformSettingField("photo_header_max_size", vm.airformModel.photo_header_max_size);
            setAirformSettingField("video_header_max_size", vm.airformModel.video_header_max_size);
        }

        function setAirformSettingField(fieldName, fieldValue) {
            var foundField = false;
            angular.forEach(vm.airformSetting.fields, function(settingField) {
                if (settingField.name == fieldName) {
                    settingField.value = fieldValue;
                    foundField = true;
                }
            });

            if (!foundField) {
                var settingField = {
                    name: fieldName,
                    value: fieldValue,
                }
                vm.airformSetting.fields.push(settingField);
            }
        }

        vm.onNumberInputKeydown = function(e) {
            if(["-","+","e","."].includes(e.key)) {                
                e.stopPropagation();
                e.preventDefault();
            }
        }

        vm.save = function() {
            if($scope.airformSettingsForm.$invalid) {
                return;
            }
            setAirformSettings();

            Setting.update(vm.airformSetting, function() {
                ToastService.displayToast($filter('triTranslate')("atheer.setting.success"), 3000);
            });
        }



        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAirformSettings().$promise
                ])
                .then(function(results) {
                    setAirformSessionModel(results[0]);
                    vm.loadingData = false;
                });
        };

        function setAirformSessionModel(settings) {

            angular.forEach(settings, function(setting) {
                if (setting.category == 'AiRForm') {
                    vm.airformSetting = setting;

                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'photo_header_max_size') {
                            vm.airformModel.photo_header_max_size = parseInt(settingField.value);
                        }
                        if (settingField.name == 'video_header_max_size') {
                            vm.airformModel.video_header_max_size = parseInt(settingField.value);
                        }

                    });
                }
            });
        };

        vm.loadData();
    }
})();
;
(function () {
    "use strict";
    angular.module("atheer.datamodel", []);
})();
;
(function () {
    "use strict";

    angular.module("atheer.datamodel").config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, CONTENT_INSIGHT_META) {
        $stateProvider.state("storm.admin-datamodel", {
            url: "/datamodels?page&sort&search",
            templateUrl: "modules/smartflow/datamodel/datamodel.html",
            controller: "DataModelController",
            controllerAs: "vm",
            data: {
                pageTitle: "atheer.datamodel.home.title",
                layout: {
                    contentClass: "layout-column",
                    footer: false,
                    showToolbar: false,
                },
            },
            params: {
                page: {
                    value: "1",
                    squash: true,
                },
                sort: {
                    value: "id,asc",
                    squash: true,
                },
                search: null,
            },
            resolve: {
                pagingParams: [
                    "$stateParams",
                    "PaginationUtil",
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate(
                                $stateParams.sort
                            ),
                            ascending: PaginationUtil.parseAscending(
                                $stateParams.sort
                            ),
                            search: $stateParams.search,
                        };
                    },
                ]
            },
        });
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.datamodel")
        .controller("DataModelController", DataModelController);

    /* @ngInject */
    function DataModelController(
        $scope,
        $window,
        $state,
        DataModel,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        $mdDialog,
        $mdToast,
        $stateParams,
        Feature,
        $translate,
        ToastService
    ) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.getQueryString = getQueryString;

        vm.createObject = createObject;
        vm.deleteObject = deleteObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.illustartionEmptyScreenId = "datamodel";

        vm.query = {
            filter: "",
            limit: paginationConstants.itemsPerPage,
            order: "name ",
            page: 1,
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500,
            },
        };

        vm.loadAll();

        function loadAll() {
            DataModel.query(
                {
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    query: getQueryString(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("x-total-count");
                vm.queryCount = vm.totalItems;
                vm.datamodelList = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.reverse = !vm.reverse;
            vm.transition();
        }

        function transition() {
            vm.promise = DataModel.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                query: getQueryString(),
            }).$promise;

            vm.promise.then(function (data, headers) {
                vm.queryCount = vm.totalItems;
                vm.datamodelList = data;
            });
        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return null;
            } else {
                return "name=re=" + vm.query.filter;
            }
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = "";

            if (vm.filter.form && vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject(data) {
            $mdDialog
                .show({
                    animation: true,
                    templateUrl:
                        "modules/smartflow/datamodel/datamodel-create-dialog.html",
                    controller: "DataModelCreateController",
                    controllerAs: "vm",
                    backdrop: "static",
                    size: "lg",
                    data: data,
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                name: null,
                                properties: [],
                            };
                        },
                    },
                })
                .then(function () {
                    resetModal();
                });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('atheer.datamodel.delete.question'))
                .ariaLabel($translate.instant('atheer.datamodel.delete.question'))
                .ok($translate.instant('atheer.datamodel.delete.delete'))
                .cancel($translate.instant('atheer.datamodel.cancel'));

            $mdDialog.show(confirm).then(function () {
                DataModel.delete(
                    {
                        id: entity.id,
                    },
                    function () {
                        ToastService.displayToast($translate.instant('atheer.datamodel.deleted'), 3000);
                        resetModal(false);
                    }
                );
            });
        }

        function resetModal(showToast) {
            loadAll();

            if (!!showToast) {
                AlertService.displayToast($mdToast);
            }
        }

        vm.getDefaultBackground = function () {
            return "#bdbec0";
        };

        vm.back = function () {
            $window.history.back();
        };
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.datamodel")
        .controller("DataModelCreateController", DataModelCreateController);

    /* @ngInject */
    function DataModelCreateController(
        $scope,
        $stateParams,
        $mdDialog,
        entity,
        DataModel,
        User,
        data,
        JhiLanguageService,
        $translate,
        ToastService
    ) {
        var vm = this;
        vm.isEditMode = data ? true : false;
        vm.displayName = vm.isEditMode ? data.displayName : "";
        vm.loadingData = false;
        vm.propertyList = vm.isEditMode
            ? data.properties
            : [{ name: "", dataType: "NUMBER" }];
        vm.title = vm.isEditMode ? $translate.instant('atheer.datamodel.home.createLabel'): $translate.instant('atheer.datamodel.home.editLabel');

        vm.dataTypeList = [
            {
                name: "STRING",
            },
            {
                name: "NUMBER",
            },
            {
                name: "DECIMAL",
            },
            {
                name: "DATE",
            },
            {
                name: "DATETIME",
            },
            {
                name: "TEAM",
            },
            {
                name: "BOOLEAN",
            }
        ];

        vm.togglePanel = function (componentId) {
            $mdSidenav(componentId).toggle();
        };

        vm.getDefaultBackground = function () {
            return "#bdbec0";
        };

        var onSaveSuccess = function (result) {
            var message = vm.isEditMode
                ? $translate.instant('atheer.datamodel.created'): $translate.instant('atheer.datamodel.updated');

            ToastService.displayToast(message, 3000);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;

            if (vm.isEditMode) {
                DataModel.update(
                    {
                        displayName: vm.displayName,
                        properties: vm.propertyList,
                        id: data.id,
                    },
                    onSaveSuccess,
                    onSaveError
                );

                return;
            }

            DataModel.save(
                {
                    displayName: vm.displayName,
                    properties: vm.propertyList,
                },
                onSaveSuccess,
                onSaveError
            );
        };

        vm.remove = function (index) {
            vm.propertyList.splice(index, 1);
        };

        vm.add = function () {
            vm.propertyList.push({ name: "", dataType: "NUMBER" });
        };

        vm.clear = function () {
            $mdDialog.hide();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .config(moduleConfig);

    function moduleConfig($stateProvider) {
        $stateProvider
        .state('storm.cloud-admin.metrics', {
            url: '/metrics',
            templateUrl: 'modules/cloud/metrics/metrics.html',
            controller: 'JhiMetricsMonitoringController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.metrics.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false,
                    showToolbar: false,
                    showSideNavMenu: true,
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);


    /* @ngInject */
    function JhiMetricsMonitoringModalController($mdDialog, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel() {
            $mdDialog.hide();
        }

        function getLabelClass(threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);


    /* @ngInject */
    function JhiMetricsMonitoringController($scope, JhiMetricsService, $mdDialog) {
        var vm = this;
        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function(newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function(value, key) {
                if (key.indexOf('api.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh() {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function(promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function(promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData() {
            JhiMetricsService.threadDump().then(function(data) {
                $mdDialog.show({
                    templateUrl: 'modules/cloud/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .config(moduleConfig);

    function moduleConfig($stateProvider) {
        $stateProvider
        .state('storm.cloud-admin.logs', {
            url: '/logs',
            templateUrl: 'modules/cloud/logs/logs.tmpl.html',
            controller: 'LogsController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.logs.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false,
                    showToolbar: false,
                    showSideNavMenu: true,
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('LogsController', LogsController);

    /* @ngInject */
    function LogsController(LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.getLoggers = getLoggers;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;

        function getLoggers() {
            vm.promise = LogsService.findAll().$promise;
            vm.promise.then(function(data, headers) {
                vm.loggers = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function changeLevel(name, level) {
            LogsService.changeLevel({
                name: name,
                level: level
            }, function() {
                vm.loggers = LogsService.findAll();
            });
        }

        getLoggers();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('storm.cloud-admin.job-streams', {
            url: '/jobs?page&sort&search',
            templateUrl: 'modules/cloud/job-stream/job-streams.html',
            controller: 'JobStreamController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.jobStream.home.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false,
                    showToolbar: false,
                    showSideNavMenu: true,
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('JobStreamController', JobStreamController);

    /* @ngInject */
    function JobStreamController($scope, $state, JobStream, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function loadAll() {
            JobStream.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.jobStreams = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            vm.promise = JobStream.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.jobStreams = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/cloud/job-stream/job-stream-dialog.html',
                controller: 'JobStreamDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            scheduleNo: null,
                            name: null,
                            type: null,
                            status: null,
                            quartzStatus: false,
                            triggerInfo: null,
                            ownerId: null,
                            workspaceId: null,
                            id: null
                        };
                    }
                }
            }).then(function() {
                resetModal();
            });
        }

        function editObject(objectId) {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/cloud/job-stream/job-stream-dialog.html',
                controller: 'JobStreamDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['JobStream', function(JobStream) {
                        return JobStream.get({
                            id: objectId
                        });
                    }]
                }
            }).then(function() {
                resetModal();
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.jobStream.deleteObject'))
                .ariaLabel($filter('translate')('atheer.jobStream.deleteObject'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                JobStream.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('JobStreamDialogController', JobStreamDialogController);

    JobStreamDialogController.$inject = ['$scope', '$stateParams', '$mdDialog', 'entity', 'JobStream'];

    function JobStreamDialogController ($scope, $stateParams, $mdDialog, entity, JobStream) {
        var vm = this;
        vm.jobStream = entity;
        vm.load = function(id) {
            JobStream.get({id : id}, function(result) {
                vm.jobStream = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('atheer:jobStreamUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.jobStream.id !== null) {
                JobStream.update(vm.jobStream, onSaveSuccess, onSaveError);
            } else {
                JobStream.save(vm.jobStream, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .config(moduleConfig);

    function moduleConfig($stateProvider) {
        $stateProvider
        .state('storm.cloud-admin.health', {
             url: '/health',
             templateUrl: 'modules/cloud/health/health.html',
             controller: 'JhiHealthCheckController',
             controllerAs: 'vm',
             data: {
                 pageTitle: 'atheer.health.title',
                 layout: {
                     contentClass: 'layout-column',
                     footer: false,
                     showToolbar: false,
                     showSideNavMenu: true,
                 }
             }
         });
    }
})();
;
(function() {
    'use strict';

    angular.module('atheer.cloud')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    /* @ngInject */
    function JhiHealthCheckController (JhiHealthService, $mdDialog) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $mdDialog.open({
                templateUrl: 'modules/cloud/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .config(moduleConfig);

    function moduleConfig($stateProvider) {
        $stateProvider
        .state('storm.cloud-admin.configuration', {
            url: '/configuration',
            templateUrl: 'modules/cloud/configuration/configuration.html',
            controller: 'JhiConfigurationController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.configuration.title',
                footer: false,
                showToolbar: false,
                showSideNavMenu: true,
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;
        vm.query = {
                filter: '',
                limit: '10',
                order: '-id',
                page: 1
            };

        vm.filter = {
                options: {
                    debounce: 500
                }
            };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if(vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }
        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, CONTENT_INSIGHT_META) {
        $stateProvider
            .state('storm.admin-airsdk-data-export', {
                url: '/sdk/data-export',
                templateUrl: 'modules/sdk/sdk-data-export.tmpl.html',
                controller: 'SdkDataExportController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.airSdk.dataExport',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.admin-airsdk-api-doc', {
                url: '/sdk/api-reference',
                templateUrl: 'modules/sdk/sdk-doc.tmpl.html',
                controller: 'SdkDocumentationController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.airSdk.apiDoc',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.admin-airsdk-api-key', {
                url: '/sdk/api-key',
                templateUrl: 'modules/sdk/sdk-key.tmpl.html',
                controller: 'SdkKeyController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.airSdk.apiKey',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.admin-airsdk-web-hooks', {
                url: '/sdk/webhooks',
                templateUrl: 'modules/sdk/sdk-webhooks.tmpl.html',
                controller: 'SdkWebHooksController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.webHook.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-airsdk-mobile-sdk', {
                url: '/sdk/mobile-sdk',
                templateUrl: 'modules/sdk/sdk-mobile-sdk.tmpl.html',
                controller: 'SdkMobileSdkController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.airSdk.mobileSdk',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.admin-airsdk-web-hook-detail', {
                url: '/sdk/webhooks/:id',
                templateUrl: 'modules/sdk/sdk-webhook-detail.tmpl.html',
                controller: 'SdkWebHookDetailController as vm',
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            })
            .state('storm.admin-airsdk-web-hook-detail-logs', {
                url: '/sdk/webhooks/:id/logs',
                templateUrl: 'modules/sdk/sdk-webhook-detail-logs.tmpl.html',
                controller: 'SdkWebHookDetailLogsController as vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkWebHooksController', SdkWebHooksController);

    /* @ngInject */
    function SdkWebHooksController($scope, $state, WebHook, Feature, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, $filter, ToastService) {
        var vm = this;

        vm.webHooksEnabled = Feature.isActive('feature_airsdk_webhooks');
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.reOrder = reOrder;
        vm.transition = transition;
        vm.illustartionEmptyScreenId = "web_hooks";
        vm.loadAll();

        vm.permissions = {
            create: 'create-web-hook',
            update: 'update-web-hook',
            delete: 'delete-web-hook',
            manage: 'manage-web-hook'
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;

        function loadAll() {
            vm.loadingData = true;
            WebHook.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.webHooks = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                vm.loadingData = false;
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function transition() {
            vm.promise = WebHook.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder(),
                search: vm.currentSearch
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.webHooks = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject() {
            $state.go('storm.admin-airsdk-web-hook-detail');
        };

        function editObject(objectId) {
            $state.go('storm.admin-airsdk-web-hook-detail', {
                'id': objectId
            });
        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.webHook.deleteObject'))
                .ariaLabel($filter('translate')('atheer.webHook.deleteObject'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                WebHook.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.showWebHookLogs = function(webHook) {
          $state.go('storm.admin-airsdk-web-hook-detail-logs', {
              'id': webHook.id
          });
        };

        vm.onEnableChange = function(webHook) {
            WebHook.update(webHook, function() {
                ToastService.displayToast(webHook.name + ' ' + $filter('translate')('atheer.content.enableUpdateSuccess'), 3000);
            }, function() {
                ToastService.displayToast($filter('translate')('atheer.content.enableUpdateError'), 3000);
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkWebHookTestController', SdkWebHookTestController);

    /* @ngInject */
    function SdkWebHookTestController($scope, $state, $mdDialog, $q, WebHook, $timeout, $mdToast, webHook, triSettings) {
        var vm = this;

        vm.webHook = webHook;
        vm.testPending = true;
        vm.webHookExecution = null;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;

        vm.testWebHook = function() {
            WebHook.testWebHook({
                id: vm.webHook.id
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.webHookExecution = data;
                vm.testPending = false;
            };

            function onError(error) {
                vm.testPending = false;
            };
        };

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.testWebHook();
    };
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkWebHookDetailController', SdkWebHookDetailController)

    /* @ngInject */
    function SdkWebHookDetailController($mdDialog, $scope, $filter, $sce, $q, $state, AlertService, $mdToast, $mdSidenav, Principal, WebHook, Feature, User, id, $timeout) {
        var vm = this;

        vm.webHookModel = null;
        vm.webHooksEnabled = Feature.isActive('feature_airsdk_webhooks');
        vm.eventsSupported = [{
          name: 'session-completed',
          label: 'sessionCompleted'
        }, {
          name: 'job-created',
          label: 'jobCreated'
        }, {
          name: 'job-completed',
          label: 'jobCompleted'
        }, {
            name: 'job-aborted',
            label: 'jobAborted'
          }, {
          name: 'user-created',
          label: 'userCreated'
        }, {
          name: 'user-terminated',
          label: 'userTerminated'
        }];

        vm.loadData = function() {
            if (id) {
                vm.loadingData = true;
                WebHook.get({
                    id: id
                }, function(result) {
                    vm.webHookModel = result;
                    vm.loadingData = false;
                });
            } else {
                vm.webHookModel = {
                    name: 'Untitled',
                    description: null,
                    auth_type: 'BEARER_TOKEN',
                    auth_header_key: 'Authorization',
                    payload_format: 'JSON',
                    events: [],
                    headers: [],
                    enable: false,
                    secret: 'Bearer <Your Secret>'
                }
            };
        };

        vm.onSaveSuccess = function(result) {
            vm.webHookModel = result;
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            if (vm.webHookModel.id) {
                WebHook.update(vm.webHookModel, vm.onSaveSuccess, vm.onSaveError);
            } else {
                WebHook.save(vm.webHookModel, vm.onSaveSuccess, vm.onSaveError);
            }
        };

        vm.goToWebHooks = function() {
            $state.go('storm.admin-airsdk-web-hooks');
        };

        vm.isNew = function() {
            if (vm.webHookModel == undefined || vm.webHookModel.id == null) {
                return true;
            } else {
                return false;
            }
        };

        vm.copyWebHook = function() {
            delete vm.webHookModel['id'];
        };

        vm.toggleEvent = function(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };

        vm.existsEvent = function(item, list) {
            return list.indexOf(item) > -1;
        };

        vm.addHeader = function() {
            var header = {
                name: 'x-sample-header',
                value: 'header-value'
            };

            vm.webHookModel.headers.push(header);
        };

        vm.copyHeader = function(header) {
            var headerNew = {
                name: header.name,
                value: header.value
            };
            vm.webHookModel.headers.push(headerNew);
        };

        vm.removeHeader = function(index) {
            vm.webHookModel.headers.splice(index, 1);
        };

        vm.testWebHook = function() {
            $mdDialog.show({
                templateUrl: 'modules/sdk/sdk-webhook-test.tmpl.html',
                clickOutsideToClose: true,
                controller: "SdkWebHookTestController",
                controllerAs: "vm",
                locals: {
                    webHook: vm.webHookModel
                }
            }).then(function(result) {

            });
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkWebHookDetailLogsController', SdkWebHookDetailLogsController)

    /* @ngInject */
    function SdkWebHookDetailLogsController($mdDialog, $scope, ToastService, $filter, ParseLinks, pagingParams, paginationConstants, $sce, $q, $state, AlertService, $mdToast, $mdSidenav, Principal, WebHook, Feature, User, id, $timeout) {
        var vm = this;

        vm.webHookId = id;
        vm.webHookModel = null;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.reOrder = reOrder;
        vm.transition = transition;
        vm.illustartionEmptyScreenId = "web_hooks_logs";

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.loadAll = function() {
            vm.loadingData = true;
            WebHook.getExecutions({
                id: id,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            WebHook.get({
                id: id
            }, function(result) {
                vm.webHookModel = result;
            });

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.webHookExecutions = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        vm.goToWebHooks = function() {
            $state.go('storm.admin-airsdk-web-hooks');
        };

        vm.showInfo = function(webHookExecution) {
            $mdDialog.show({
                templateUrl: 'modules/sdk/sdk-webhook-detail-log-info.tmpl.html',
                clickOutsideToClose: true,
                controller: "SdkWebHookDetailLogInfoController",
                controllerAs: "vm",
                locals: {
                    webHookExecution: webHookExecution
                }
            }).then(function(result) {

            });
        };

        vm.executeRun = function(webHookExecution) {
            WebHook.executeWebHook({
                id: webHookExecution.id
            }, function(result) {
                ToastService.displayToast($filter('translate')('atheer.webHook.runSubmitted'), 3000)
            });
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function transition() {
            vm.promise = WebHook.getExecutions({
                id: id,
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder(),
                search: vm.currentSearch
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.webHookExecutions = data;
            });
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkWebHookDetailLogInfoController', SdkWebHookDetailLogInfoController);

    /* @ngInject */
    function SdkWebHookDetailLogInfoController($scope, $state, $mdDialog, $q, $mdToast, webHookExecution, triSettings) {
        var vm = this;

        vm.webHookExecution = webHookExecution;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.close = function() {
            $mdDialog.cancel();
        };
    };
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkMobileSdkController', SdkMobileSdkController);

    /* @ngInject */
    function SdkMobileSdkController($rootScope, $scope, $sce, $cookies, $q, Setting, $mdToast, $filter, $mdDialog, Feature) {
        var vm = this;

        vm.viewType = "doc";
        vm.webHooksEnabled = Feature.isActive('feature_airsdk_webhooks');
        vm.hostUrl = $sce.trustAsResourceUrl("https://light-sloth-6.redoc.ly/");
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkKeyController', SdkKeyController);

    /* @ngInject */
    function SdkKeyController($rootScope, $scope, $sce, $cookies, $q, Setting, $filter, $mdDialog, Feature, ToastService) {
        var vm = this;

        vm.viewType = "doc";
        vm.webHooksEnabled = Feature.isActive('feature_airsdk_webhooks');
        vm.hostUrl = $sce.trustAsResourceUrl("https://light-sloth-6.redoc.ly/");

        vm.loadingData = false;
        vm.apiKeySettings = [];
        vm.apiKey = null;
        vm.createdOn = null;
        vm.expiresOn = null;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                    Setting.getAPIKeySettings().$promise
                ])
                .then(function(results) {
                    vm.apiKeySettings = results[0];
                    setAPIKey(vm.apiKeySettings);
                    vm.loadingData = false;
                });
        };

        function setAPIKey(settings) {
            angular.forEach(settings, function(setting) {
                if (setting.category == 'api_key') {
                    angular.forEach(setting.fields, function(settingField) {
                        if (settingField.name == 'api_key') {
                            vm.apiKey = settingField.value;
                        }
                    });
                    vm.createdOn = new Date(setting.created_on);
                    vm.expiresOn = new Date(setting.created_on);
                    vm.expiresOn = vm.expiresOn.setDate(vm.expiresOn.getDate() + 365) ;
                }
            });
        }

        vm.generateAPIKeySettings = function() {
            Setting.generateAPIKeySettings(function(result) {
                vm.apiKeySettings = result;
                setAPIKey(vm.apiKeySettings);
                ToastService.displayToast($filter('triTranslate')("atheer.airsdk.generatedSucess"), 3000);
            });
        }

        vm.deactivateAPIKeySettings = function() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.airsdk.deactivateApiKey'))
                .htmlContent($filter('translate')('atheer.airsdk.deactivateHtmlContent'))
                .ariaLabel($filter('translate')('atheer.airsdk.deactivateApiKey'))
                .ok($filter('translate')('atheer.airsdk.deactivateButton'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Setting.deactivateAPIKeySettings(function() {
                    vm.apiKeySettings = null;
                    vm.apiKey = null;
                    vm.createdOn = null;
                    vm.expiresOn = null;

                    ToastService.displayToast($filter('triTranslate')("atheer.airsdk.deactivatedSuccessful"), 3000);
                });
            });
        }

        vm.showDocView = function() {
            vm.viewType = "doc";
        };

        vm.showKeyView = function() {
            vm.viewType = "key";
        };

        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkDocumentationController', SdkDocumentationController);

    /* @ngInject */
    function SdkDocumentationController($rootScope, $location, Principal, $scope, $sce, $cookies, $q, Setting, $mdToast, $filter, $mdDialog, Feature, AuthServerProvider) {
        var vm = this;
        var host = $location.host();
        var domain = Principal.getWorkspaceDomain();
        var authToken = AuthServerProvider.getToken();
        var apiUrl = "https://openapi.atheer.dev?workspace=" + domain + "&instance=dev&authToken=" + authToken;

        vm.viewType = "doc";
        vm.webHooksEnabled = Feature.isActive('feature_airsdk_webhooks');

        if (angular.isDefined(host) && host.endsWith(".dev")) {
            apiUrl = "https://openapi.atheer.dev?workspace=" + domain + "&instance=dev&authToken=" + authToken;
        } else if (angular.isDefined(host) && host.endsWith(".qa")) {
            apiUrl = "https://openapi.atheer.dev?workspace=" + domain + "&instance=qa&authToken=" + authToken;
        } else if (angular.isDefined(host) && host.endsWith(".si")) {
            apiUrl = "https://openapi.atheer.dev?workspace=" + domain + "&instance=si&authToken=" + authToken;
        } else if (angular.isDefined(host) && host.endsWith(".io")) {
            apiUrl = "https://openapi.atheer.io?workspace=" + domain + "&instance=io&authToken=" + authToken;
        } else {
            apiUrl = "https://openapi.atheer.dev?workspace=" + domain + "&instance=dev&authToken=" + authToken;
        };
        vm.hostUrl = $sce.trustAsResourceUrl(apiUrl);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkDataExportController', SdkDataExportController);

    /* @ngInject */
    function SdkDataExportController($rootScope, $state, $scope, $sce, $window, $location, $cookies, $q, Setting, $mdToast, $filter, $mdDialog, Feature) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.webHooksEnabled = Feature.isActive('feature_airsdk_webhooks');
        vm.showToolbar = true;
        vm.viewType = "doc";

        function setNgxPageUrl() {
            var path = $location.path();
            var hostUrl =
                location.hostname === "localhost" ?
                "https://" + location.hostname + ":4200" :
                location.origin;
            var ngxUrl = hostUrl + '/ngx/config/template/dataexport/?sdkView=true';

            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
        };

        function handleNgxEvent(event) {
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;

                if (id == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    })
                    vm.showToolbar = true;
                } else {
                    $state.transitionTo(ngState, {
                        id: id
                    }, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    })
                    vm.showToolbar = false;
                }
            }
        };

        $window.addEventListener('message', handleNgxEvent, false);

        // Unregister
        $scope.$on('$destroy', function() {
            window.removeEventListener('message', handleNgxEvent, false);
        });

        vm.refreshAll = function() {
            var iFrame = document.getElementById('ngxFrame').contentWindow;
            var targetOrigin = location.hostname === "localhost"
                ? "https://" + location.hostname + ":4200"
                : location.origin;
            iFrame.postMessage({ 'refreshDataExportList': true}, targetOrigin);
        };

        vm.createObject = function() {
            var iFrame = document.getElementById('ngxFrame').contentWindow;
            var targetOrigin = location.hostname === "localhost"
                ? "https://" + location.hostname + ":4200"
                : location.origin;
            iFrame.postMessage({ 'createNewDataExport': true}, targetOrigin);
        };

        setNgxPageUrl();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('workspace', {
                url: '/letsgo',
                abstract: true,
                views: {
                    'root': {
                        templateUrl: 'modules/workspace/workspace-account.tmpl.html'
                    }
                }
            })
            .state('workspace.signup', {
                url: '/signup',
                templateUrl: 'modules/workspace/workspace-signup.tmpl.html',
                controller: 'WorkspaceSignupController',
                controllerAs: 'vm'
            })
            .state('workspace.signup-confirm', {
                url: '/confirm',
                templateUrl: 'modules/workspace/workspace-signup-confirm.tmpl.html',
                controller: 'WorkspaceSignupConfirmController',
                controllerAs: 'vm',
                params: {
                    workspaceSignupData: null
                }
            })
            .state('workspace.setup-company', {
                url: '/setup-company',
                templateUrl: 'modules/workspace/workspace-setup-company.tmpl.html',
                controller: 'WorkspaceSetupCompanyController',
                controllerAs: 'vm',
                params: {
                    workspaceSignupData: null
                }
            })
            .state('workspace.setup-url', {
                url: '/setup-url',
                templateUrl: 'modules/workspace/workspace-setup-url.tmpl.html',
                controller: 'WorkspaceSetupURLController',
                controllerAs: 'vm',
                params: {
                    workspaceSignupData: null
                }
            })
            .state('workspace.setup-user-info', {
                url: '/setup-user',
                templateUrl: 'modules/workspace/workspace-setup-user-info.tmpl.html',
                controller: 'WorkspaceSetupUserInfoController',
                controllerAs: 'vm',
                params: {
                    workspaceSignupData: null
                }
            })
            .state('storm.admin-workspaces', {
                url: '/workspaces?page&sort&search',
                views: {
                    '@storm': {
                        templateUrl: 'modules/workspace/workspaces.html',
                        controller: 'WorkspaceController',
                        controllerAs: 'vm',
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/workspace/workspace-menu.tmpl.html',
                        controller: 'WorkspaceMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.workspace.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-workspace-detail', {
                url: '/workspace/:id',
                abstract: true,
                views: {
                    '@storm': {
                        templateUrl: 'modules/workspace/workspace-detail.tmpl.html',
                        controller: 'WorkspaceDetailController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.admin-workspace-detail.info', {
                url: '/info',
                templateUrl: 'modules/workspace/workspace-detail-info.tmpl.html',
                controller: 'WorkspaceDetailInfoController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-workspace-detail.features', {
                url: '/features',
                templateUrl: 'modules/workspace/workspace-detail-features.tmpl.html',
                controller: 'WorkspaceDetailFeaturesController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights', {
                url: '/insights',
                abstract: true,
                views: {
                    '@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights.tmpl.html',
                        controller: 'WorkspaceDetailInsightsController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'Workspace',
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    workspaceId: function($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights.dashboard', {
                url: '/workspace-summary',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-summary.tmpl.html',
                        controller: 'InsightsSummaryController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'Dashboard',
                        showSideNavMenu: false,
                        showToolbar: true,
                    }
                },
            })
            .state('storm.admin-workspace-detail.insights.conversations', {
                url: '/conversations',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-conversation.tmpl.html',
                        controller: 'InsightsConversationController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'Conversations',
                        showSideNavMenu: true,
                        showToolbar: true
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights.contents', {
                url: '/content',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-content.tmpl.html',
                        controller: 'InsightsContentController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'Content',
                        showSideNavMenu: true,
                        showToolbar: true
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights.sessions', {
                url: '/sessions',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-session.tmpl.html',
                        controller: 'InsightsSessionController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'AiRSessions',
                        showSideNavMenu: true,
                        showToolbar: true
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights.airforms', {
                url: '/airforms',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-airform.tmpl.html',
                        controller: 'InsightsAirformController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'AiRForms',
                        showSideNavMenu: true,
                        showToolbar: true
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights.smartflows', {
                url: '/smartflows',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-smartflow.tmpl.html',
                        controller: 'InsightsSmartflowController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'SmartFlows',
                        showSideNavMenu: true,
                        showToolbar: true
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights.jobs', {
                url: '/jobs',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-job.tmpl.html',
                        controller: 'InsightsJobController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'Jobs',
                        showSideNavMenu: true,
                        showToolbar: true
                    }
                }
            })
            .state('storm.admin-workspace-detail.insights.users', {
                url: '/users',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-user.tmpl.html',
                        controller: 'InsightsUserController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/workspace/workspace-detail-insights-toolbar.tmpl.html',
                        controller: 'WorkspaceDetailInsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'Users',
                        showSideNavMenu: true,
                        showToolbar: true
                    }
                }
            })
            .state('storm.admin-workspace-detail.adv-insights', {
                url: '/adv-insights',
                templateUrl: 'modules/workspace/workspace-detail-adv-insights.tmpl.html',
                controller: 'WorkspaceDetailAdvInsightsController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceController', WorkspaceController);

    /* @ngInject */
    function WorkspaceController($scope, $state, Workspace, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams) {
        var vm = this;

        vm.loadingData = false;
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.loadAll();

        function loadAll() {
            vm.loadingData = true;
            Workspace.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.loadingData = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.workspaces = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                vm.loadingData = false;
                AlertService.error(error.data.message);
            }
        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return null;
            } else {
                return 'name=re="' + vm.query.filter + '"'
            }
        }

        function transition() {
            vm.promise = Workspace.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.workspaces = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            vm.loadAll();
        }

        function createObject() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/workspace/workspace-detail-dialog.tmpl.html',
                controller: 'WorkspaceDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).then(function(result) {
                if (result != undefined && result != null) {
                    $state.go('storm.admin-workspace-detail.info', {
                        'id': result.id
                    });
                } else {
                    resetModal();
                }
            });
        }

        function editObject(objectId) {
            $state.go('storm.admin-workspace-detail.info', {
                'id': objectId
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this Workspace?')
                .ariaLabel('Are you sure you want to delete this Workspace?')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                Workspace.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceSignupController', WorkspaceSignupController);

    /* @ngInject */
    function WorkspaceSignupController($translate, $timeout, WorkspaceSignup, $scope, $state, $mdToast, $http, $filter, triSettings) {
        var vm = this;

        vm.error = null;
        vm.success = false;
        vm.triSettings = triSettings;

        vm.workspace = {
            email: null
        }

        vm.workspaceSignupData = {
            email: null,
            first_name: null,
            last_name: null,
            password: null,
            confirmation_code: null,
            company_name: null,
            company_type: null,
            company_size: null,
            company_url: null,
            user_role: null,
            team_url: null
        }

        vm.signup = function() {
            WorkspaceSignup.save(vm.workspace, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.onSaveSuccess = function(result) {
            vm.workspace = result;
            vm.success = true;

            vm.workspaceSignupData.email = result.email;
            vm.workspaceSignupData.confirmation_code = result.confirmation_code;

            $state.go('workspace.signup-confirm', {"workspaceSignupData": vm.workspaceSignupData});
        };

        vm.onSaveError = function() {
            vm.errorCreating = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceSignupConfirmController', WorkspaceSignupConfirmController);

    /* @ngInject */
    function WorkspaceSignupConfirmController($translate, $timeout, WorkspaceSignup, $scope, $state, $stateParams, $mdToast, $http, $filter, triSettings) {
        var vm = this;

        vm.firstTime = true;
        vm.validCode = false;
        vm.checkingCode = false;
        vm.triSettings = triSettings;

        vm.workspaceSignupData = $stateParams.workspaceSignupData;

        vm.confirmCode1 = null;
        vm.confirmCode2 = null;
        vm.confirmCode3 = null;
        vm.confirmCode4 = null;
        vm.confirmCode5 = null;
        vm.confirmCode6 = null;

        if (!vm.workspaceSignupData) {
            $state.go('workspace.signup');
        }

        vm.checkConfirmationCode = function(code) {
            if (code < 6) {
                $timeout(function() {
                    var nextInput = '[ng-model="vm.confirmCode' + (code + 1) + '"]';
                    angular.element(nextInput).focus();
                });
            }

            var confirmationCode = vm.confirmCode1 + vm.confirmCode2 + vm.confirmCode3 + "-" + vm.confirmCode4 + vm.confirmCode5 + vm.confirmCode6;

            if (confirmationCode && confirmationCode.length == 7) {
                vm.firstTime = false;
                vm.checkingCode = true;

                WorkspaceSignup.get({
                    code: confirmationCode
                }, function(result) {
                    if (result && result.confirmation_code && result.confirmation_code == confirmationCode) {
                        vm.validCode = true;
                        $state.go('workspace.setup-user-info', {
                            "workspaceSignupData": vm.workspaceSignupData
                        });
                    } else {
                        vm.validCode = false;

                        vm.confirmCode1 = null;
                        vm.confirmCode2 = null;
                        vm.confirmCode3 = null;
                        vm.confirmCode4 = null;
                        vm.confirmCode5 = null;
                        vm.confirmCode6 = null;

                        $timeout(function() {
                            angular.element('[ng-model="vm.confirmCode1"]').focus();
                        });
                    }
                    vm.checkingCode = false;
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceSetupUserInfoController', WorkspaceSetupUserInfoController);

    /* @ngInject */
    function WorkspaceSetupUserInfoController($translate, $timeout, WorkspaceSignup, $scope, $state, $stateParams, $mdToast, $http, $filter, triSettings) {
        var vm = this;

        vm.error = null;
        vm.success = false;
        vm.triSettings = triSettings;

        vm.workspaceSignupData = $stateParams.workspaceSignupData;

        vm.user = {
            first_name: null,
            last_name: null,
            password: null
        }

        if (!vm.workspaceSignupData) {
            $state.go('workspace.signup');
        }

        vm.next = function() {
            vm.workspaceSignupData.first_name = vm.user.first_name;
            vm.workspaceSignupData.last_name = vm.user.last_name;
            vm.workspaceSignupData.password = vm.user.password;

            $state.go('workspace.setup-company', {"workspaceSignupData": vm.workspaceSignupData});
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceSetupURLController', WorkspaceSetupURLController);

    /* @ngInject */
    function WorkspaceSetupURLController($window, $location, $translate, $timeout, WorkspaceSignup, $scope, $state, $stateParams, $mdToast, $http, $filter, triSettings) {
        var vm = this;

        var host = $location.host();

        vm.domain = host.slice(4, host.length);
        vm.isDomainAvailable = false;
        vm.isCheckingDomainAvailability = false;

        vm.error = null;
        vm.success = false;
        vm.activating = false;

        vm.triSettings = triSettings;

        vm.workspaceSignupData = $stateParams.workspaceSignupData;

        vm.workspace = {
            name: null
        }

        if (!vm.workspaceSignupData) {
            $state.go('workspace.signup');
        }

        vm.checkIsDomainAvailable = function(name) {
            vm.isCheckingDomainAvailability = true;

            WorkspaceSignup.checkName({
                name: vm.workspace.name
            }, function(result) {
                vm.isCheckingDomainAvailability = false;
                vm.workspaceInfo = result;
                vm.isDomainAvailable = vm.workspaceInfo.available;
            });
        }

        vm.activate = function() {
            vm.workspaceSignupData.team_url = vm.workspace.name;
            vm.activating = true;
            WorkspaceSignup.activate(vm.workspaceSignupData, vm.onSaveSuccess, vm.onSaveError);
        };

        vm.onSaveSuccess = function(result) {
            vm.workspaceSignupData = result;
            var successToken = vm.workspaceSignupData.success_token;
            var finalUrl = vm.workspaceSignupData.final_url + "?" + "activation_token=" + successToken;
            $window.location.href = finalUrl;
        };

        vm.onSaveError = function() {
            vm.error = true;
            vm.activating = false;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceSetupCompanyController', WorkspaceSetupCompanyController);

    /* @ngInject */
    function WorkspaceSetupCompanyController($translate, $timeout, WorkspaceSignup, $scope, $state, $stateParams, $mdToast, $http, $filter, triSettings) {
        var vm = this;

        vm.error = null;
        vm.success = false;
        vm.triSettings = triSettings;

        vm.workspaceSignupData = $stateParams.workspaceSignupData;

        vm.workspace = {
            company_name: null,
            company_type: null,
            company_size: null,
            user_role: null
        }

        if (!vm.workspaceSignupData) {
            $state.go('workspace.signup');
        }

        vm.next = function() {
            vm.workspaceSignupData.company_name = vm.workspace.company_name;
            vm.workspaceSignupData.company_type = vm.workspace.company_type;
            vm.workspaceSignupData.company_size = vm.workspace.company_size;
            vm.workspaceSignupData.user_role = vm.workspace.user_role;

            $state.go('workspace.setup-url', {
                "workspaceSignupData": vm.workspaceSignupData
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceMenuController', WorkspaceMenuController);

    /* @ngInject */
    function WorkspaceMenuController($rootScope, $scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;

        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailController', WorkspaceDetailController)

    /* @ngInject */
    function WorkspaceDetailController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, $q, AlertService, $mdToast, $mdSidenav, Workspace, id, $timeout, Setting) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailToolbarController', WorkspaceDetailToolbarController);

    /* @ngInject */
    function WorkspaceDetailToolbarController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Workspace, Principal, Feature, id, PermissionService) {
        var vm = this;

        vm.loadingData = true;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.layout.pageTitle;
        vm.workspaceId = id;
        vm.activeLink = $state.current.name;

        function loadAll() {
            vm.loadingData = true;
            Workspace.get({
                id: id
            }, function(result) {
                vm.loadingData = false;
                vm.workspace = result;
            });
        };

        vm.loadAll();

        $scope.$on('$destroy', function() {
            $scope.$emit('toggleSideMenu', 'reset');
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailInsightsController', WorkspaceDetailInsightsController);

    /* @ngInject */
    function WorkspaceDetailInsightsController($scope, $state, $mdDialog, $mdToast, $stateParams, id, 
        Setting, AlertService, Workspace, Principal, Feature, 
        PermissionService, workspaceId) {
        var vm = this;
        vm.loadingData = false;
        vm.isSaving = false;
        vm.isCreating = false;
        vm.errorSaving = false;

        vm.loadingData = true;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.layout.pageTitle;
        vm.workspaceId = id;
        vm.activeLink = $state.current.name;

        function loadAll() {
            console.log('With workspace id: ' + workspaceId);
            vm.advInsights = Workspace.getInsightSettings({
                id: workspaceId,
            });
            vm.loadingData = true;
        };

        vm.loadAll();

        $scope.$on('$destroy', function () {
            $scope.$emit('toggleSideMenu', 'reset');
        });

        vm.onUpdateSaveSuccess = function(result) {
            vm.advInsights = result;
            AlertService.displayToast($mdToast);
            vm.isSaving = false;
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
            vm.isCreating = false;
            vm.errorSaving = true;
        };

        vm.save = function() {
            vm.isSaving = true;
            Workspace.setInsightSettings({id: workspaceId}, vm.advInsights, vm.onUpdateSaveSuccess, vm.onSaveError);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailInsightsToolbarController', WorkspaceDetailInsightsToolbarController);

    /* @ngInject */
    function WorkspaceDetailInsightsToolbarController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Workspace, Principal, Feature, id, PermissionService) {
        var vm = this;

        vm.loadingData = true;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.layout.pageTitle;
        vm.workspaceId = id;
        vm.activeLink = $state.current.name;

        function loadAll() {
            vm.loadingData = true;
            Workspace.get({
                id: id
            }, function(result) {
                vm.loadingData = false;
                vm.workspace = result;
            });
        };

        vm.loadAll();

        $scope.$on('$destroy', function() {
            $scope.$emit('toggleSideMenu', 'reset');
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailInfoController', WorkspaceDetailInfoController)

    /* @ngInject */
    function WorkspaceDetailInfoController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, $q, AlertService, $mdToast, $mdSidenav, Workspace, id, $timeout, Setting) {
        var vm = this;

        vm.loadingData = false;
        vm.isSaving = false;
        vm.isCreating = false;
        vm.errorSaving = false;

        vm.loadingData = true;

        Workspace.get({
            id: id
        }, function(result) {
            vm.loadingData = false;
            vm.workspace = result;
        });

        vm.onUpdateSaveSuccess = function(result) {
            vm.workspace = result;

            AlertService.displayToast($mdToast);
            vm.isSaving = false;
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
            vm.isCreating = false;
            vm.errorSaving = true;
        };

        vm.save = function() {
            vm.isSaving = true;
            Workspace.update(vm.workspace, vm.onUpdateSaveSuccess, vm.onSaveError);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailFeaturesController', WorkspaceDetailFeaturesController)

    /* @ngInject */
    function WorkspaceDetailFeaturesController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, $q, AlertService, $mdToast, $mdSidenav, Workspace, id, $timeout, Setting) {
        var vm = this;

        vm.loadingData = false;
        vm.isSaving = false;
        vm.isCreating = false;
        vm.errorSaving = false;

        vm.featureSettings = null;
        vm.features = {};

        vm.loadingData = true;
        Workspace.get({
            id: id
        }, function(result) {
            vm.workspace = result;
            loadFeaturesData();
        });

        vm.onFeatureSaveSuccess = function(result) {
            vm.featureSettings = result;
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
            vm.isCreating = false;
            vm.errorSaving = true;
        };

        vm.save = function() {
            vm.isSaving = true;
            setFeatureSettings();
            Workspace.updateFeatures({
              id: id
            }, vm.featureSettings, vm.onFeatureSaveSuccess, vm.onSaveError);
        };

        vm.goToWorkspaces = function() {
            $state.go("storm.admin-workspaces");
        };

        function setFeaturesModel(featureSettings) {
            angular.forEach(featureSettings, function(feature) {
                if (feature.category == 'features') {
                    vm.featureSettings = feature;
                    angular.forEach(feature.fields, function(settingField) {
                        if (settingField.value == 'true') {
                            settingField.value = true;
                        } else {
                            settingField.value = false;
                        }
                        var feature = vm.features[settingField.group_name];
                        if (feature) {
                            feature.settings.push(settingField);
                        } else {
                            var feature = {
                                name: settingField.group_name,
                                label: settingField.group_label,
                                settings: []
                            }
                            feature.settings.push(settingField);
                            vm.features[settingField.group_name] = feature;
                        }
                    });
                }
            });
        }

        function setFeatureSettings() {
            vm.featureSettings.fields = [];
            for (var key in vm.features) {
                var feature = vm.features[key];
                angular.forEach(feature.settings, function(settingField) {
                    vm.featureSettings.fields.push(settingField);
                });
            }
        }

        function loadFeaturesData() {
            vm.loadingData = true;
            $q.all([
                    Workspace.getFeatures({
                      id: id
                    }).$promise
                ])
                .then(function(results) {
                    setFeaturesModel(results[0]);
                    vm.loadingData = false;
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailDialogController', WorkspaceDetailDialogController)

    /* @ngInject */
    function WorkspaceDetailDialogController($mdDialog, $scope, $filter, $sce, $state, $q, AlertService, $mdToast, $mdSidenav, Workspace, poller, $timeout, Setting) {
        var vm = this;

        vm.loadingData = false;
        vm.isSaving = false;
        vm.successSave = false;
        vm.errorSaving = false;
        vm.specialCharFlag = false;
        vm.duplicateDomainError = '';
        vm.passwordVisible = false;

        vm.workspace = {
            id: null,
            workspace_no: null,
            name: null,
            description: null,
            nosql_schema: null,
            sql_schema: null,
            sub_domain: null,
            email_domain: null,
            status: 'ACTIVE',
            subscription_type: 'TRIAL',
            start_date: new Date(),
            end_date: null,
            admin_fname: null,
            admin_lname: null,
            admin_email: null,
            website_url: null,
            enabled: true
        };

        vm.validateSpecialChars = function(e) {
            var regex = new RegExp("[/\\\\.\"\'$]");
            var key = e.keyCode || e.which;
            key = String.fromCharCode(key);
            if(regex.test(key)) {
                vm.specialCharFlag = true;
                e.returnValue = false;
                if(e.preventDefault) {
                    e.preventDefault();
                }
            } else {
                vm.specialCharFlag = false;
            }
        };
        vm.onCreateSaveSuccess = function(result) {
            vm.jobStream = result;

            // Get poller.
            var jobStreamStatusPoller = poller.get(Workspace, {
                action: 'getWorkspaceStatus',
                delay: 3000,
                argumentsArray: [{
                    id: vm.jobStream.id
                }],
                smart: true
            });

            jobStreamStatusPoller.promise.then(null, null, function(result) {
                vm.jobStream = result;
                if (result.status == 'COMPLETED') {
                    poller.stopAll();
                    vm.successSave = true;
                    vm.isSaving = false;

                    Workspace.get({
                        id: vm.jobStream.workspace_id
                    }, function(result) {
                        vm.workspace = result;
                    });
                }
            });
        };

        vm.onSaveError = function(err) {
            $timeout(function() {
                vm.isSaving = false;
                vm.errorSaving = true;
                if(err && err.data){
                    vm.duplicateDomainError = err.data.description;
                }
            }, 1000);
        };

        vm.togglePasswordVisibility = function() {
            vm.passwordVisible = !vm.passwordVisible;
        };

        vm.save = function() {
            vm.isSaving = true;
            vm.workspace.nosql_schema = vm.workspace.sub_domain;
            vm.workspace.sql_schema = vm.workspace.sub_domain;
            vm.duplicateDomainError = '';
            Workspace.saveAsync(vm.workspace, vm.onCreateSaveSuccess, vm.onSaveError);
        };

        vm.close = function() {
            $mdDialog.hide();
        };

        vm.checkDetail = function() {
            $mdDialog.hide(vm.workspace);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.workspace')
        .controller('WorkspaceDetailAdvInsightsController', WorkspaceDetailAdvInsightsController)

    /* @ngInject */
    function WorkspaceDetailAdvInsightsController($mdDialog, $scope, $filter, $sce, ParseLinks, pagingParams, paginationConstants, $state, $q, AlertService, $mdToast, $mdSidenav, Workspace, id, $timeout, Setting) {
        var vm = this;

        vm.loadingData = false;
        vm.isSaving = false;
        vm.isCreating = false;
        vm.errorSaving = false;
        vm.currentStep = 'provisioned';
        vm.uploadStatus = 'idle';
        vm.importStatus = 'idle';
        vm.insightsSettings = null;

        vm.featureSettings = null;
        vm.features = {};

        vm.loadingData = true;

        vm.onFeatureSaveSuccess = function(result) {
            vm.featureSettings = result;
            AlertService.displayToast($mdToast);
            checkProvisioningStatus();
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
            vm.isCreating = false;
            vm.errorSaving = true;
        };

        vm.save = function() {
            vm.isSaving = true;
            vm.currentStep == 'provisioning';
            Workspace.activateInsights({
                id: id
            }, vm.onFeatureSaveSuccess, vm.onSaveError);
        };

        function loadAll() {
            vm.loadingData = true;

            $q.all([
                Workspace.get({
                    id: id
                }).$promise,
                Workspace.getInsightSettings({
                    id: id
                }).$promise
            ]).then(function(results) {
                vm.workspace = results[0];
                vm.insightsSettings = results[1];
                if(vm.insightsSettings.state == 'UNKNOWN' || !vm.insightsSettings.state) {
                    vm.currentStep = 'default'
                } else if(vm.insightsSettings.state == 'INPROGRESS' || vm.insightsSettings.state == 'INITIATED') {
                    vm.currentStep = 'provisioning'
                } else if(vm.insightsSettings.state == 'ERROR') {
                    vm.currentStep = 'error'
                };

                vm.loadingData = false;
            }).catch(function(data) {}).finally(function() {});
        }

        function checkProvisioningStatus() {
            // Get poller.
            var statusPoller = poller.get(Workspace, {
                action: 'getInsightSettings',
                delay: 3000,
                argumentsArray: [{
                    id: id
                }],
                smart: true
            });

            statusPoller.promise.then(null, null, function(result) {
                var insightSettings = result;
                if (result.provisioned) {
                    poller.stopAll();
                    vm.currentStep = 'provisioned';
                }
            });
        };

        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .config(moduleConfig);

    function moduleConfig($stateProvider, triMenuProvider) {
        $stateProvider
            .state('storm.admin-users', {
                url: '/users',
                views: {
                    '@storm': {
                        templateUrl: 'modules/user/users.tmpl.html',
                        controller: 'UserController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/user/user-toolbar.tmpl.html',
                        controller: 'UserToolbarController',
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/user/user-menu.tmpl.html',
                        controller: 'UserMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.userManagement.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        showToolbar: false,
                        sideNavMenuSize: 20,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.ops-users', {
                url: '/ops-users',
                views: {
                    '@storm': {
                        templateUrl: 'modules/user/users.tmpl.html',
                        controller: 'UserController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/user/user-toolbar.tmpl.html',
                        controller: 'UserToolbarController',
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/user/user-menu.tmpl.html',
                        controller: 'UserMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.userManagement.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        showToolbar: true,
                        sideNavMenuSize: 20,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-users-import', {
                url: '/users/import',
                templateUrl: 'modules/user/import/user-import.tmpl.html',
                controller: 'UserImportController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.userManagement.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-user-fields', {
                url: '/users/meta-data',
                templateUrl: 'modules/user/metadata/user-metadata.tmpl.html',
                // set the controller to load for this page
                controller: 'UserMetaDataController',
                controllerAs: 'vm',
                // layout-column class added to make footer move to
                // bottom of the page on short pages
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return 'user';
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserController', UserController);

    /* @ngInject */
    function UserController($rootScope, $scope, $state, Principal, $timeout, User, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, JhiLanguageService, Team, Experience, PermissionService, Feature, $filter, ToastService) {
        var vm = this;

        vm.emptyCriteria = {
            match_all: true,
            condition_groups: []
        };

        vm.loadingData = false;
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.removeFilter = removeFilter;
        vm.updateUserListListener = null;
        vm.selectedUsers = [];
        vm.selectedTeam = null;
        vm.showNewUserMenu = false;
        vm.showUserSideMenu = $state.$current.data.showSideNavMenu;
        vm.teamEnabled = Feature.isActive('feature_audience_enable');

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;
        vm.getQueryString = getQueryString;

        vm.clear = clear;
        vm.setActive = setActive;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.page = 1;
        vm.illustartionEmptyScreenId = "users";

        vm.permissions = {
            create: 'create-user',
            update: 'update-user',
            delete: 'delete-user',
            manage: 'manage-user',
            import: 'import-user',
            invite: 'manage-invitation-user',
            team: 'manage-segment-user',
            user_field: 'manage-user-field-user'
        };

        vm.totalItems = null;

        vm.query = {
            field: 'first_name=re=',
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.clearSelection = function() {
            vm.selectedUsers = [];
        };

        vm.init = function() {
            JhiLanguageService.getAll().then(function(languages) {
                vm.languages = languages;
            });
            vm.showNewUserMenu = PermissionService.hasPermission(vm.permissions.create) && (PermissionService.hasPermission(vm.permissions.import) || (Feature.isActive('feature_user_invitation') && PermissionService.hasPermission(vm.permissions.invite)))
        };

        function loadAll() {
            vm.loadingData = true;
            vm.selectedUsers = [];

            var savedQuery = getSavedFilters();
            if ( savedQuery ) {
                vm.query = savedQuery;
            }
            vm.page = vm.query.page;

            if (vm.selectedTeam == null || vm.selectedTeam.audience_no == 1000) {
                var criteria = vm.selectedTeam == null ? vm.emptyCriteria : vm.selectedTeam.criteria;

                User.query({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    query: getQueryString(),
                    check_admin: true
                }, function(data, headers) {
                    vm.users = data;
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    //vm.page = pagingParams.page;
                    vm.loadingData = false;
                }, onError);
            } else if (vm.selectedTeam.type == 'SMART') {
                var criteria = vm.selectedTeam == null ? vm.emptyCriteria : vm.selectedTeam.criteria;

                Experience.getUsers({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, criteria, function(data, headers) {
                    vm.users = data;
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    //vm.page = pagingParams.page;
                    vm.loadingData = false;
                }, onError);
            } else if (vm.selectedTeam.type == 'STATIC') {
                Experience.getTeams({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    query: "object_id==" + vm.selectedTeam.id,
                    user_info: true
                }, function(data, headers) {
                    vm.users = [];
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;

                    angular.forEach(data, function(userTeam) {
                        vm.users.push(userTeam.user_info);
                    });

                    //vm.page = pagingParams.page;
                    vm.loadingData = false;
                }, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            if (vm.selectedTeam == null || vm.selectedTeam.audience_no == 1000) {
                var criteria = vm.selectedTeam == null ? vm.emptyCriteria : vm.selectedTeam.criteria;
                vm.promise = User.query({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: getSortOrder(),
                    query: getQueryString(),
                    check_admin: true
                }).$promise;

                vm.promise.then(function(data, headers) {
                    vm.users = data;
                    vm.queryCount = vm.totalItems;
                });
            } else if (vm.selectedTeam.type == 'SMART') {
                var criteria = vm.selectedTeam == null ? vm.emptyCriteria : vm.selectedTeam.criteria;
                vm.promise = Experience.getUsers({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: getSortOrder(),
                }, criteria).$promise;

                vm.promise.then(function(data, headers) {
                    vm.users = data;
                    vm.queryCount = vm.totalItems;
                });
            } else if (vm.selectedTeam.type == 'STATIC') {
                vm.promise = Experience.getTeams({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    query: "object_id==" + vm.selectedTeam.id,
                    user_info: true
                }).$promise;

                vm.promise.then(function(data, headers) {
                    vm.users = [];
                    vm.queryCount = vm.totalItems;
                    angular.forEach(data, function(userTeam) {
                        vm.users.push(userTeam.user_info);
                    });
                });
            }
            vm.query.page = vm.page;
            saveFilters(vm.query);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return null;
            } else {
                var queryArr = vm.query.filter.split(" ");
                var searchQuery = "(";

                searchQuery += 'first_name=re="' + vm.query.filter + '"';
                searchQuery += ',last_name=re="' + vm.query.filter + '"';
                searchQuery += ',email=re="' + vm.query.filter + '"';

                searchQuery += ")";

                return searchQuery
            }
        };

        function createObject() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/user/user-detail-dialog.html',
                controller: 'UserDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            login: null,
                            password: null,
                            first_name: null,
                            last_name: null,
                            email: null,
                            invite_user: false,
                            activated: true,
                            language_id: null,
                            timezone_id: null,
                            created_by: null,
                            created_date: null,
                            last_modified_by: null,
                            last_modified_on: null
                        };
                    }
                }
            }).then(function() {
                resetModal();
            });
        };

        function editObject(objectId) {
            $state.go('storm.admin-profile.overview', {
                'id': objectId
            });
        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.userManagement.deleteUser'))
                .ariaLabel($filter('translate')('atheer.userManagement.deleteUser'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                User.delete({
                    login: entity.login
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        function clear() {
            vm.user = {
                id: null,
                login: null,
                first_name: null,
                last_name: null,
                email: null,
                activated: true,
                language_id: 'en',
                timezone_id: null,
                created_by: null,
                created_date: null,
                last_modified_by: null,
                last_modified_on: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        };

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function() {
                vm.loadAll();
                vm.clear();
            });
        };

        $scope.$watchCollection('vm.selectedUsers', function(newVal) {
            $scope.$emit('refreshSelectedCardsToolbar', vm.selectedUsers);
        });

        var refreshUsersListener = $rootScope.$on('refreshUsers', function(event, filter) {
            vm.query.filter = filter;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.loadAll();
        });

        //calls when hit menu on sidebar to open sub menus in side bar
        var updateUserListListener = $rootScope.$on('updateUserList', function(event, team) {
            if ( vm.selectedTeam !== null ) { vm.query.page = 1; saveFilters(vm.query);}
            vm.selectedTeam = team;
            vm.loadAll();
        });

        var refreshSelectedCardsListing = $rootScope.$on('refreshSelectedCardsListing', function(event, selectedUsers) {
            vm.selectedUsers = selectedUsers;
        });

        function saveFilters(filterData) {
            sessionStorage.setItem('objectFilters', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectFilters'));
        };

        // Unregister
        $scope.$on('$destroy', function() {
            refreshUsersListener();
            updateUserListListener();
            refreshSelectedCardsListing();
        });

        vm.init();

        if(!vm.teamEnabled) {
            vm.loadAll();
            $scope.$emit('showSideMenu', 'false');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserToolbarController', UserToolbarController);

    /* @ngInject */
    function UserToolbarController($rootScope, $scope, $state, $mdDialog, PermissionService, User, Team, ParseLinks, Experience, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.selectedUsers = [];
        vm.selectedTeam = null;
        vm.showNewUserMenu = false;

        vm.permissions = {
            create: 'create-user',
            update: 'update-user',
            delete: 'delete-user',
            manage: 'manage-user',
            import: 'import-user',
            invite: 'manage-invitation-user',
            team: 'manage-segment-user',
            user_field: 'manage-user-field-user'
        };

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        if ( getSavedFilters() ) {
            vm.query = getSavedFilters();
        }

        vm.removeFilter = removeFilter;
        vm.filter.show = vm.query.filter.length > 0 ? true : false;
        vm.createObject = createObject;

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.selectMenu = function(item) {
            $state.go('storm.admin-content-detail', {
                'contentType': item.type.replace(/-/g, '_')
            });
        };

        vm.clearSelection = function() {
            vm.selectedUsers = [];
            $scope.$emit('refreshSelectedCardsListing', vm.selectedUsers);
        };

        vm.createObject = function() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/user/user-detail-dialog.html',
                controller: 'UserDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            login: null,
                            password: null,
                            first_name: null,
                            last_name: null,
                            email: null,
                            invite_user: false,
                            activated: true,
                            language_id: null,
                            timezone_id: null,
                            created_by: null,
                            created_date: null,
                            last_modified_by: null,
                            last_modified_on: null
                        };
                    }
                }
            }).then(function() {
                $scope.$emit('refreshUsers', vm.query.filter);
            });
        };

        vm.openCreateDialog = function() {
            $mdDialog.show({
                templateUrl: 'modules/team/team-detail-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "TeamDetailDialogController",
                controllerAs: "vm",
                locals: {
                    mode: 'STATIC',
                    team: null
                },
                size: 'lg'
            }).then(function(updatedTeam) {
                vm.saveTeam(updatedTeam);
            });
        };

        vm.onTeamSaveSuccess = function (result) {
            var userTeams = [];
            angular.forEach(vm.selectedUsers, function (user) {
                userTeams.push({
                    user_id: user.id,
                    object: result,
                    source: 'ADMIN',
                    assigned_on: new Date()
                });
            });

            ToastService.displayToast(result.name + $filter('translate')('atheer.userManagement.create'), 3000);

            Experience.bulkTeams(userTeams, function (result) {
                $scope.$emit('refreshTeams');
            });
        };

        vm.onTeamUpdateSuccess = function(result) {
            var userTeams = [];
            angular.forEach(vm.selectedUsers, function(user) {
                userTeams.push({
                    user_id: user.id,
                    object: result,
                    source: 'ADMIN',
                    assigned_on: new Date()
                });
            });

            ToastService.displayToast(result.name + $filter('translate')('atheer.userManagement.update'), 3000);

            Experience.bulkTeams(userTeams, function(result) {
                $scope.$emit('refreshTeams');
            });
        };

        vm.onTeamSaveError = function() {

        };

        vm.saveTeam = function(updatedTeam) {
            if (updatedTeam.id) {
                Team.update(updatedTeam, vm.onTeamUpdateSuccess, vm.onTeamSaveError);
            } else {
                updatedTeam.audience_no = null;
                updatedTeam.type = 'STATIC';
                Team.save(updatedTeam, vm.onTeamSaveSuccess, vm.onTeamSaveError);
            }
        };

        vm.removeUsersFromList = function() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.userManagement.removeUsers') + vm.selectedUsers.length + $filter('translate')('atheer.userManagement.usersFrom') + vm.selectedTeam.name + $filter('translate')('atheer.userManagement.teams'))
                .ariaLabel($filter('translate')('atheer.userManagement.removeUsers') + vm.selectedUsers.length + $filter('translate')('atheer.userManagement.usersFrom') + vm.selectedTeam.name + $filter('translate')('atheer.userManagement.teams'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                var userTeams = [];
                angular.forEach(vm.selectedUsers, function(user) {
                    userTeams.push({
                        user_id: user.id,
                        object: vm.selectedTeam,
                        source: 'ADMIN',
                        assigned_on: new Date()
                    });
                });

                Experience.bulkTeamsRemove(userTeams, function(result) {
                    $scope.$emit('refreshUsers', vm.query.filter);
                });
            });
        };

        vm.removeBulkUsers = function() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.userManagement.removeUsers') + vm.selectedUsers.length + " " + $filter('translate')('atheer.userManagement.home.title') + " ?")
                .ariaLabel($filter('translate')('atheer.userManagement.removeUsers') + vm.selectedUsers.length + " " + $filter('translate')('atheer.userManagement.home.title') + " ?")
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                var usersToRemove = [];
                angular.forEach(vm.selectedUsers, function(user) {
                    usersToRemove.push(user.login);
                });

                User.bulkRemove(usersToRemove, function(result) {
                    ToastService.displayToast(vm.selectedUsers.length + $filter('translate')('atheer.userManagement.usersDeleted'), 3000);
                    $scope.$emit('refreshUsers', vm.query.filter);
                });
            });
        };

        vm.init = function() {
            vm.showNewUserMenu = PermissionService.hasPermission(vm.permissions.create) && (PermissionService.hasPermission(vm.permissions.import) || (Feature.isActive('feature_user_invitation') && PermissionService.hasPermission(vm.permissions.invite)))
        };

        //calls when hit menu on sidebar to open sub menus in side bar
        var updateUserListListener = $rootScope.$on('updateUserList', function(event, team) {
            vm.selectedTeam = team;
        });

        var refreshSelectedCardsToolbar = $rootScope.$on('refreshSelectedCardsToolbar', function(event, selectedUsers) {
            vm.selectedUsers = selectedUsers;
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSelectedCardsToolbar();
        });

        function refreshAll() {
            saveFilters(vm.query);
            $scope.$emit('refreshUsers', vm.query.filter);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            saveFilters(vm.query);
            $scope.$emit('refreshUsers', vm.query.filter);
        };

        function createObject() {
            $state.go("storm.admin-content-detail");
        };

        function saveFilters(filterData) {
            sessionStorage.setItem('objectHeader', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectHeader'));
        };

        vm.init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserPickerController', UserPickerController);

    /* @ngInject */
    function UserPickerController($scope, $state, triSettings, User, allowMultiSelect, filter, userslist, ParseLinks, AlertService, $mdDialog, Principal, Feature, isAdmin, isSession, isScheduledSession, isConversationSession, isSmartScan, paginationConstants) {
        var vm = this;

        vm.loadingData = false;
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.changeSort = changeSort;
        vm.allowMultiSelect = allowMultiSelect;
        vm.userFilter = filter == null ? [] : filter;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "";
        vm.page = 1;
        vm.reverse = true;
        vm.userFilter = userslist.length == 0 ? vm.userFilter : userslist;
        vm.isAdmin = isAdmin;
        vm.isConversationSession = isConversationSession;
        vm.isSmartScan = isSmartScan;
        vm.isGuestFeature = Feature.isActive('feature_airsession_invite_guest_user');
        vm.illustartionEmptyScreenId = vm.isSession ? "no_users_session" : "no_users_search";
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.totalItems = null;
        vm.currentSelectedUsers = [];

        vm.isEmailGuestEnabled = Feature.isActive('feature_airsession_enable_email_invite');
        vm.isSmsGuestEnabled = Feature.isActive('feature_airsession_enable_sms_invite');
        vm.isGuestButtonVisible = true;
        if (isScheduledSession) {
            vm.isGuestButtonVisible = vm.isEmailGuestEnabled || vm.isSmsGuestEnabled;
        }

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-first_name',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function formQuery() {
            if (!vm.query.filter) {
                return;
            };

            var queryArr = vm.query.filter.split(" ");
            var searchQuery = "(";

            searchQuery += 'first_name=re="' + vm.query.filter + '"';
            searchQuery += ',last_name=re="' + vm.query.filter + '"';
            searchQuery += ',email=re="' + vm.query.filter + '"';

            searchQuery += ")";

            return searchQuery
        }

        function loadAll() {
            vm.loadingData = true;
            var query = null;
            if (vm.userFilter.length != 0) {
                query = 'id=out=(' + vm.userFilter.toString() + ')';
            } else {
                if (!isSmartScan) {
                    query = 'id=out=(' + Principal.getUserId() + ')';
                }
            }

            if (vm.query.filter.length != 0) {
                if (query == null) {
                    query = formQuery();
                } else {
                    query = formQuery() + ';' + query;
                }
            }
            User.query({
                query: query,
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                check_admin: vm.isAdmin
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'first_name') {
                    result = ['first_name,' + (vm.reverse ? 'asc' : 'desc')];
                    vm.predicate = 'first_name';
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.users = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function changeSort(newSort) {
            if (vm.predicate == newSort) {
                vm.reverse = !vm.reverse;
            } else {
                vm.reverse = true;
                vm.predicate = newSort;
            }

            transition();

        }

        function transition() {
            var query = null;
            if (vm.userFilter.length != 0) {
                query = 'id=out=(' + vm.userFilter.toString() + ')';
            } else {
                if (!isSmartScan) {
                    query = 'id=out=(' + Principal.getUserId() + ')';
                }
            }

            if (vm.query.filter.length != 0) {
                if (query == null) {
                    query = formQuery();
                } else {
                    query = formQuery() + ';' + query;
                }
            }

            vm.promise = User.query({
                query: query,
                page: vm.page - 1,
                size: vm.query.limit,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                check_admin: vm.isAdmin
            }).$promise;

            vm.promise.then(function (data, headers) {
                vm.queryCount = vm.totalItems;
                vm.users = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            loadAll();

            if (vm.filter.form && vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        vm.updateParentObject = function () {
            $mdDialog.hide(vm.currentSelectedUsers);
        }

        vm.onDeselectUser = function (user) {
            var updatedSelectedUsers = vm.currentSelectedUsers.filter(function (value) {
                return value.id != user.id || value.guest_invite_value != user.guest_invite_value;
            });

            vm.currentSelectedUsers = updatedSelectedUsers;
        }

        function resetModal() {
            loadAll();
        };

        vm.close = function () {
            $mdDialog.cancel();
        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserMenuController', UserMenuController);

    /* @ngInject */
    function UserMenuController($rootScope, $scope, $state, $mdDialog, Content, Team, ParseLinks, AlertService, ContentAction, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature) {
        var vm = this;

        vm.loadAll = function() {
            vm.loadingData = false;
        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .config(moduleConfig);

    function moduleConfig($stateProvider, triMenuProvider) {
        $stateProvider
            .state('storm.profile', {
                abstract: true,
                url: '/profile/{id}',
                views: {
                    '@storm': {
                        templateUrl: 'modules/user/user-detail.tmpl.html',
                        controller: 'UserDetailController',
                        controllerAs: 'vm',
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/user/user-detail-menu.tmpl.html',
                        controller: 'UserDetailMenuController',
                        controllerAs: 'vm',
                    }
                },
                params: {
                    id: null
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        footer: false,
                        showToolbar: true,
                        contentClass: 'layout-column'
                    }
                },
            })
            .state('storm.profile.overview', {
                url: '/overview',
                templateUrl: 'modules/user/overview/overview.tmpl.html',
                controller: 'ProfileOverviewController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    launchQrCode: false
                },
            })
            .state('storm.profile.jobs', {
                url: '/jobs',
                templateUrl: 'modules/user/job/jobs.tmpl.html',
                controller: 'ProfileJobsController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.library', {
                abstract: true,
                url: '/library',
                templateUrl: 'modules/user/library/library.tmpl.html',
                controller: 'ProfileLibraryController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.library.bookmarks', {
                url: '/bookmarks',
                templateUrl: 'modules/user/library/library-bookmarks.tmpl.html',
                controller: 'ProfileLibraryBookmarksController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.library.shared', {
                url: '/shared',
                templateUrl: 'modules/user/library/library-shared.tmpl.html',
                controller: 'ProfileLibrarySharedController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.library.uploads', {
                url: '/uploads',
                templateUrl: 'modules/user/library/library-uploads.tmpl.html',
                controller: 'ProfileLibraryUploadsController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.library.liked', {
                url: '/liked',
                templateUrl: 'modules/user/library/library-liked.tmpl.html',
                controller: 'ProfileLibraryLikedController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.sessions', {
                abstract: true,
                url: '/sessions',
                templateUrl: 'modules/user/session/sessions.tmpl.html',
                controller: 'ProfileSessionsController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.sessions.upcoming', {
                url: '/upcoming',
                templateUrl: 'modules/user/session/sessions-upcoming.tmpl.html',
                controller: 'ProfileSessionsUpcomingController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.sessions.past', {
                url: '/past',
                templateUrl: 'modules/user/session/sessions-past.tmpl.html',
                controller: 'ProfileSessionsPastController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    id: null,
                    showToolbar: false,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.timeline', {
                url: '/timeline',
                templateUrl: 'modules/user/timeline/timeline.tmpl.html',
                controller: 'ProfileTimelineController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                }
            })
            .state('storm.profile.about', {
                url: '/about',
                templateUrl: 'modules/user/about/about.tmpl.html',
                controller: 'ProfileAboutController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                }
            })
            .state('storm.profile.password', {
                url: '/password',
                templateUrl: 'modules/user/password/password.tmpl.html',
                controller: 'ProfilePasswordController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                }
            })
            .state('storm.profile.preferences', {
                url: '/preferences',
                templateUrl: 'modules/user/preference/preferences.tmpl.html',
                controller: 'ProfilePreferncesController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                }
            })
            .state('storm.profile.properties', {
                url: '/properties',
                templateUrl: 'modules/user/properties/properties.tmpl.html',
                controller: 'ProfilePropertiesController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    profileMeta: null
                },
                resolve: {
                    profileMeta: ['$stateParams', function($stateParams) {
                        return $stateParams.profileMeta;
                    }]
                }
            })
            .state('storm.profile.teams', {
                url: '/teams',
                templateUrl: 'modules/user/team/teams.tmpl.html',
                controller: 'ProfileTeamsController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.security-roles', {
                url: '/security-roles',
                templateUrl: 'modules/user/security-role/security-roles.tmpl.html',
                controller: 'ProfileSecurityRolesController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.profile.event', {
                url: '/{eventName}',
                templateUrl: 'modules/user/event/event-list.tmpl.html',
                controller: 'ProfileEventListController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    eventMeta: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    eventName: ['$stateParams', function($stateParams) {
                        return $stateParams.eventName;
                    }],
                    eventMeta: ['$stateParams', function($stateParams) {
                        return JSON.parse($stateParams.eventMeta);
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserDetailController', UserDetailController);

    /* @ngInject */
    function UserDetailController($rootScope, $q, $scope, $state, PermissionService, Auth, Principal, $translate, $mdToast, $mdMenu, $filter, id, User, Experience, MetaData, Report, Feature, $window) {
        var vm = this;

        if(!angular.isDefined(id)) {
            id = 'me';
        };

        vm.user = null;
        vm.experienceSummary = null;
        vm.userId = id;
        vm.profileViewMode = id == 'me' ? 'me' : 'admin';
        vm.hasOverDue = false;
        vm.hasPendingAssignments = false;
        //vm.overDueChartData = angular.copy(pieChartConfig);
        //vm.assignmentChartData = angular.copy(pieChartConfig);
        vm.allCompleted = true;
        vm.loadingData = false;
        vm.isAdminMode = vm.profileViewMode == 'admin';
        vm.isMeMode = vm.profileViewMode == 'me';
        vm.isBoardActive = false;
        vm.isMyUploadActive = false;
        vm.activeLink = 'overview';
        vm.showBoards =  false;

        if(vm.profileViewMode == 'me' && !$rootScope.showForYou) {
            vm.activeLink = 'about';
        }

        vm.loadData = function() {

        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserDetailToolbarController', UserDetailToolbarController);

    /* @ngInject */
    function UserDetailToolbarController($rootScope, $q, $scope, $state, PermissionService, Auth, Principal, $translate, $mdDialog, $mdToast, $mdMenu, $filter, id, User, Experience, MetaData, Report, Feature, $window) {
        var vm = this;

        vm.user = null;
        vm.userId = id;
        vm.profileViewMode = id == 'me' ? 'me' : 'admin';
        vm.loadingData = false;
        vm.isAdminMode = vm.profileViewMode == 'admin';
        vm.isMeMode = vm.profileViewMode == 'me';
        vm.isBoardActive = false;
        vm.isMyUploadActive = false;

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                User.getById({
                    id: id
                }).$promise

            ]).then(function(data) {
                vm.user = data[0];
                vm.isMyUploadActive = Feature.isActive("feature_content_allow_upload") && hasPermission('create-content');
                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});
        }

        function hasPermission(permission) {
            return PermissionService.hasAccess(permission);
        }

        vm.goToUsers = function() {
            $state.go("storm.admin-users");
        };

        vm.back = function() {
            $window.history.back();
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserDetailMenuController', UserDetailMenuController);

    /* @ngInject */
    function UserDetailMenuController($scope, $q, $state, id, User, MetaData, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.userId = id == 'me' ? Principal.getUserId() : id;
        vm.profileViewMode = id == 'me' ? 'me' : 'admin';
        vm.isAdminMode = vm.profileViewMode == 'admin';

        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.settings = [];
        vm.activeLink = $state.current.name;
        vm.profileEvents = [];
        vm.profileMeta = null;

        vm.settingsConfig = [{
            label: 'atheer.userDetail.menu.overview',
            state: 'storm.profile.overview',
            isAdminOnly: false
        }, {
            label: 'atheer.userDetail.menu.about',
            state: 'storm.profile.about',
            isAdminOnly: false
        }, {
            label: 'atheer.userDetail.menu.password',
            state: 'storm.profile.password',
            isAdminOnly: false
        }, {
            label: 'atheer.userDetail.menu.library',
            state: 'storm.profile.library.bookmarks',
            isAdminOnly: false
        }, {
            label: 'atheer.userDetail.menu.airSessions',
            state: 'storm.profile.sessions.upcoming',
            isAdminOnly: true
        }, {
            label: 'atheer.userDetail.menu.teams',
            state: 'storm.profile.teams',
            isAdminOnly: true
        }, {
            label: 'atheer.userDetail.menu.securityRoles',
            state: 'storm.profile.security-roles',
            isAdminOnly: true
        }, ]

        function loadData() {
            vm.loadingData = true;

            $q.all([
                User.getById({
                    id: vm.userId
                }).$promise,
                MetaData.get({
                    id: 'user',
                    is_name: true
                }).$promise
            ]).then(function(data) {
                vm.user = data[0];
                angular.forEach(data[1].field_groups, function(field_group) {
                    if (field_group.name == 'profile' && !field_group.is_many) {
                        vm.profileMeta = field_group;
                    }
                    if (field_group.is_many) {
                        vm.profileEvents.push(field_group);
                    }
                });
                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});

            if (vm.isAdminMode) {
                angular.forEach(vm.settingsConfig, function(setting) {
                    vm.settings.push(setting);
                });
            } else {
                angular.forEach(vm.settingsConfig, function(setting) {
                    if (!setting.isAdminOnly) {
                        vm.settings.push(setting);
                    }
                });
            }
        }

        vm.goToUsers = function() {
            if($stateParams.isDeeplink) {
                $window.history.go(-2);
            } else {
                // $window.history.back();
                $state.go('storm.admin-users');
            }
        };

        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.user')
        .controller('UserDetailDialogController', UserDetailDialogController);

    /* @ngInject */
    function UserDetailDialogController($scope, $stateParams,Feature, $mdDialog, entity, User) {
        var vm = this;
        vm.user = entity;
        vm.isSavingError = false;
        vm.errorMessage = '';
        vm.showPassword = false;
        vm.showConfirmPassword = false;
        vm.featureForcedPassword = Feature.isActive('feature_user_initial_login_forced_password_required');
        vm.user.notify_user = true;
        var re = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,50}$/);
        var reWhiteSpace = /\s/;

        var onSaveSuccess = function(result) {
            $scope.$emit('atheer:userUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function(err) {
            vm.isSaving = false;
            vm.isSavingError = true;
            if(err) {
                var obj = err.headers();
                vm.errorMessage = obj['x-atheer-error-message'];
            }
        };

        vm.checkPassword = function(){
            if((vm.user.password !== vm.confirm_password) && vm.confirm_password ){
                vm.profileForm.confirm_password.$setValidity('passwordNoMatchErr', false);
            }
            else {
                vm.profileForm.confirm_password.$setValidity('passwordNoMatchErr', true);
            }
            if(!re.test(vm.user.password)) {
                vm.profileForm.password.$setValidity('passwordPolicyErr', false);
            }
            else {
                vm.profileForm.password.$setValidity('passwordPolicyErr', true);
            }
        }

        vm.checkLogin = function(){
            if (vm.user.login !== undefined && (reWhiteSpace.test(vm.user.login) || vm.user.login.indexOf(' ') > 0)) {
                vm.profileForm.login.$setValidity('loginWhiteSpaceError', false);
            } else {
                vm.profileForm.login.$setValidity('loginWhiteSpaceError', true);
            }
        }

        vm.save = function() {
            vm.isSaving = true;
            if ( vm.user.notify_user !== undefined && vm.user.notify_user == true ) {
                vm.user.forced_password_enabled = false;
            }
            User.save(vm.user, onSaveSuccess, onSaveError);
        };

        vm.clear = function() {
            $mdDialog.hide();
        };

        vm.forcePasswordToggle = function() {
            if ( vm.user.notify_user !== undefined && vm.user.notify_user == true ) {
                vm.user.forced_password_enabled = false;
            }
        }

        vm.dynamicTitle = null !== vm.user.id ? 'atheer.userManagement.home.editLabel' : 'atheer.userManagement.home.createLabel';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('account', {
                abstract: true,
                views: {
                    'root': {
                        templateUrl: 'modules/user/user-account.tmpl.html'
                    }
                }
            })
            .state('account.signin', {
                url: '/signin',
                templateUrl: 'modules/user/signin/signin.tmpl.html',
                controller: 'SigninController',
                controllerAs: 'vm'
            })
            .state('account.atheer-signin', {
                url: '/atheer-signin',
                templateUrl: 'modules/user/signin/atheer-signin.tmpl.html',
                controller: 'SigninController',
                controllerAs: 'vm'
            })
            .state('account.signout', {
                url: '/signout',
                templateUrl: 'modules/user/signout/signout.tmpl.html',
                controller: 'SignoutController',
                controllerAs: 'vm'
            })
            .state('account.signup', {
                url: '/signup',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'UserSignupController',
                controllerAs: 'vm'
            })
            .state('account.invite', {
                url: '/invite/:id',
                templateUrl: 'modules/user/activate/user-info.tmpl.html',
                controller: 'UserActivateInfoController',
                controllerAs: 'vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('account.conversations', {
                url: '/conversations',
                templateUrl: 'modules/conversation/conversations.tmpl.html',
                controller: 'ConversationsController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.conversation.home.title',
                    layout: {
                        showSideNavMenu: false,
                        contentClass: 'layout-column',
                        showToolbar: false,
                        footer: false
                    }
                }
            })
            .state('account.signup-confirmed', {
                url: '/signup/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'UserSignupController',
                controllerAs: 'vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('account.activate', {
                url: '/activate?key',
                templateUrl: 'modules/user/actiate/activate.tmpl.html',
                controller: 'ActivationController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.activate.title'
                }
            })
            .state('account.forgot', {
                url: '/forgot',
                templateUrl: 'modules/user/password/forgot.tmpl.html',
                controller: 'ForgotController',
                controllerAs: 'vm',
            })
            .state('account.forced-password', {
                url: '/forced-password',
                templateUrl: 'modules/user/password/forced-password.tmpl.html',
                // set the controller to load for this page
                controller: 'ForcedPasswordController',
                controllerAs: 'vm',
                // layout-column class added to make footer move to
                // bottom of the page on short pages
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    id: function ($stateParams) {
                        return 'user';
                    }
                }
            })
            .state('account.reset', {
                url: '/reset?key',
                templateUrl: 'modules/user/password/reset.tmpl.html',
                controller: 'ResetFinishController',
                controllerAs: 'vm'
            })
            .state('account.guest-join', {
                url: '/join',
                templateUrl: 'modules/user/guest/guest-join.tmpl.html',
                controller: 'GuestJoinController',
                controllerAs: 'vm'
            })
            .state('account.join', {
                url: '/join/:session_no/:workspace_code/:launch_session',
                templateUrl: 'modules/user/guest/guest-join.tmpl.html',
                controller: 'GuestJoinController',
                controllerAs: 'vm',
                resolve: {
                    session_no: function ($stateParams) {
                        return $stateParams.session_no;
                    },
                    workspace_code: function ($stateParams) {
                        return $stateParams.workspace_code;
                    },
                    launch_session: function ($stateParams) {
                        return $stateParams.launch_session;
                    }
                }
            })
            .state('account.guest', {
                url: '/guest/join/:session_no/:workspace_code/:launch_session',
                templateUrl: 'modules/user/guest/guest-join.tmpl.html',
                controller: 'GuestJoinController',
                controllerAs: 'vm',
                resolve: {
                    session_no: function ($stateParams) {
                        return $stateParams.session_no;
                    },
                    workspace_code: function ($stateParams) {
                        return $stateParams.workspace_code;
                    },
                    launch_session: function ($stateParams) {
                        return $stateParams.launch_session;
                    }
                }
            })
            .state('account.noaccess', {
                url: '/signin/noaccess',
                templateUrl: 'modules/user/noaccess/noaccess.tmpl.html',
                controller: 'NoAccessContoller',
                controllerAs: 'vm',
                params: {
                    isWorkspaceInactive: true
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic', [

        ]);
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.topic')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, CONTENT_INSIGHT_META, TOPIC_RECOGNITION_META, TOPIC_INSIGHT_META) {
        $stateProvider
            .state('storm.topic-list', {
                url: '/topics/list/view',
                views: {
                    '@storm': {
                        templateUrl: 'modules/ngx-frame.html',
                        controller: 'TopicViewController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.topic.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.topic-view', {
                url: '/topics/view/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/ngx-frame.html',
                        controller: 'TopicViewController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.topic.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.admin-topics', {
                url: '/topics?page&sort&search',
                views: {
                    '@storm': {
                        templateUrl: 'modules/topic/topics.html',
                        controller: 'TopicController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/topic/topic-toolbar.tmpl.html',
                        controller: 'TopicToolbarController',
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/topic/topic-menu.tmpl.html',
                        controller: 'TopicMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.topic.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-topic-fields', {
                url: '/topics/meta-data',
                templateUrl: 'modules/topic/topic-metadata.tmpl.html',
                // set the controller to load for this page
                controller: 'TopicMetaDataController',
                controllerAs: 'vm',
                // layout-column class added to make footer move to
                // bottom of the page on short pages
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    id: function ($stateParams) {
                        return 'topic';
                    }
                }
            })
            .state('storm.admin-topic-detail', {
                url: '/topics/:id',
                templateUrl: 'modules/topic/topic-detail.tmpl.html',
                controller: 'TopicDetailController',
                controllerAs: 'vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    topicType: null,
                    parentTopic: [],
                    isDeeplink: false
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            })
            .state('storm.admin-topic-detail-recognition', {
                url: '/topics/:id/recognition',
                templateUrl: 'modules/topic/topic-detail-recoginition.tmpl.html',
                controller: 'TopicDetailRecognitionController as vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.admin-topic-detail-recognition.section', {
                url: '/:section',
                templateUrl: function ($stateParams) {
                    return TOPIC_RECOGNITION_META['topic'].sections[$stateParams.section || 'overview'].template;
                },
                controllerProvider: function ($stateParams) {
                    return TOPIC_RECOGNITION_META['topic'].sections[$stateParams.section || 'overview'].controller;
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-topic-detail-insights', {
                url: '/topics/:id/insights',
                templateUrl: 'modules/topic/topic-detail-insights.tmpl.html',
                controller: 'TopicDetailInsightsController as vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.admin-topic-detail-insights.section', {
                url: '/:section',
                templateUrl: function ($stateParams) {
                    return TOPIC_INSIGHT_META['topic'].sections[$stateParams.section || 'overview'].template;
                },
                controllerProvider: function ($stateParams) {
                    return TOPIC_INSIGHT_META['topic'].sections[$stateParams.section || 'overview'].controller;
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            ;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicController', TopicController);

    /* @ngInject */
    function TopicController($rootScope, $scope, $window, $state, Topic, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, Feature, $filter, ToastService) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.getQueryString = getQueryString;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate =
            !pagingParams.ascending && pagingParams.predicate
                ? "-" + pagingParams.predicate
                : pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.reOrder = reOrder;
        vm.illustartionEmptyScreenId = "topic";

        vm.permissions = {
            create: 'manage-topic-content',
            update: 'manage-topic-content',
            delete: 'manage-topic-content',
            manage: 'manage-topic-content'
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1,
            filters: {
                enabled: false,
                externalId: false,
                allowScan: false
            }
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.getPredicate = function () {
            if (vm.predicate.startsWith("-")) {
                if (
                    vm.predicate.endsWith(",desc") ||
                    vm.predicate.endsWith(",asc")
                ) {
                    return vm.predicate.substr(1);
                }
                return vm.predicate.substr(1) + ",desc";
            } else {
                if (
                    vm.predicate.endsWith(",desc") ||
                    vm.predicate.endsWith(",asc")
                ) {
                    return vm.predicate;
                } else {
                    return vm.predicate + ",asc";
                }
            }
        };

        function loadAll() {
            vm.loadingData = true;
            var savedQuery = getSavedFilters();
            if ( savedQuery ) {
                vm.query = savedQuery;
            }
            vm.page = vm.query.page;

            Topic.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: [vm.getPredicate()],
                query: getQueryString()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.loadingData = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.topics = data;
                //vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.reverse = !vm.reverse;
            vm.transition();
        }

        function transition() {
            vm.promise = Topic.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.getPredicate(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.topics = data;
            });

            vm.query.page = vm.page;
            saveFilters(vm.query);
        };

        function getQueryString() {
            var topicQuery = "";

            if (vm.query.filters.enabled) {
                if (topicQuery === "") {
                    topicQuery = 'enabled==true';
                } else {
                    topicQuery = topicQuery + ';enabled==true';
                }
            }

            if (vm.query.filters.externalId) {
                if (topicQuery === "") {
                    topicQuery = 'externalId=ex=true';
                } else {
                    topicQuery = topicQuery + ';externalId=ex=true';
                }
            }

            if (vm.query.filters.allowScan) {
                if (topicQuery === "") {
                    topicQuery = 'allowScan==true';
                } else {
                    topicQuery = topicQuery + ';allowScan==true';
                }
            }

            if (vm.query.filter.length > 0) {
                topicQuery = 'name=re=' + vm.query.filter;
            }

            return topicQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        };

        vm.getDefaultBackground = function() {
            return '#bdbec0';
        };

        vm.back = function() {
            $window.history.back();
        };

        vm.onPublishChange = function(topic) {
            Topic.update(topic, function() {
                ToastService.displayToast(topic.name + ' ' + $filter('translate')('atheer.content.enableUpdateSuccess'), 3000);
            }, function() {
                ToastService.displayToast($filter('translate')('atheer.content.enableUpdateError'), 3000)
            });
        }

        function createObject(parentTopic) {
            $state.go('storm.admin-topic-detail', {
                'topicType': 'STATIC',
                'parentTopic': null
            });
        };

        function editObject(objectId) {
            $state.go("storm.admin-topic-detail", {
                'id': objectId
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.topic.deleteTopic'))
                .ariaLabel($filter('translate')('atheer.topic.deleteTopic'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Topic.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        function saveFilters(filterData) {
            sessionStorage.setItem('objectFilters', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectFilters'));
        };

        var refreshTopicListener = $rootScope.$on('refreshTopics', function(event, filter) {
            vm.query.filter = filter;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.loadAll();
        });

        var updateTopicListener = $rootScope.$on('updateTopicList', function(event, filters) {
            vm.query.filters = filters;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.loadAll();
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshTopicListener();
            updateTopicListener();
        });

        vm.loadAll();
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.topic")
        .controller("TopicViewController", TopicViewController);

    /* @ngInject */
    function TopicViewController($scope, $window, $state, $sce, $location, $rootScope) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.isIFrameDataLoaded = false;

        function setNgxPageUrl() {
            var ngxUrl = null;
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            var path = $location.path();

            if ($state.current.name === "storm.topic-list") {
                ngxUrl = hostUrl + "/ngx/topics";
            } else if ($state.current.name === "storm.topic-view") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/topics/" + id;
            }
            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
            $rootScope.selectedLeftNavMenu = 'home';
        }

        function handleNgxEvent(event) {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                if (id == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                } else {
                    $state.transitionTo(
                        ngState,
                        {
                            id: id
                        },
                        {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        }
                    );
                }
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        $window.addEventListener("message", handleNgxEvent, false);

        // Unregister
        $scope.$on("$destroy", function () {
            window.removeEventListener("message", handleNgxEvent, false);
        });

        setNgxPageUrl();
    }

})();;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicToolbarController', TopicToolbarController);

    /* @ngInject */
    function TopicToolbarController($rootScope, $scope, $state, $mdDialog, Topic, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        if ( getSavedFilters() ) {
            vm.query = getSavedFilters();
        }

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = vm.query.filter.length > 0 ? true : false;
        vm.createObject = createObject;

        vm.permissions = {
            create: 'manage-topic-content',
            update: 'manage-topic-content',
            delete: 'manage-topic-content',
            manage: 'manage-topic-content'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        function refreshAll() {
            saveFilters(vm.query);
            $scope.$emit('refreshTopics', vm.query.filter);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            saveFilters(vm.query);
            $scope.$emit('refreshTopics', vm.query.filter);
        };

        function createObject() {
            $state.go('storm.admin-topic-detail', {
                'topicType': 'STATIC',
                'parentTopic': null
            });
        };

        function saveFilters(filterData) {
            sessionStorage.setItem('objectHeader', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectHeader'));
        };
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.topic')
        .constant('TOPIC_RECOGNITION_META', {
            topic: {
                sections: {
                    qr_code: {
                        label: 'atheer.topic.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'TopicDetailQRCodeController',
                        template: 'modules/topic/topic-detail-qrcode.tmpl.html'
                    }
                }
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicPickerController', TopicPickerController);

    /* @ngInject */
    function TopicPickerController($scope, $state, $mdDialog, triSettings, Topic, ParseLinks, topics, AlertService, $mdToast, $filter, filter, allowMultiSelect, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "id";
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.selected = [];
        vm.allowMultiSelect = allowMultiSelect;
        vm.topicsOut = topics;

        vm.currentSelectedItems = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.getQueryString = getQueryString;

        vm.loadAll();

        function loadAll() {
            Topic.query({
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = ['id' + ',' + 'asc'];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.topics = data;
                vm.page = 1;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Topic.query({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: getSortOrder(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.topics = data;
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                if (vm.topicsOut.length == 0) {
                    return filter;
                }
                if (filter.length == 0 || filter == '') {
                    return filter + 'id=out=(' + vm.topicsOut.toString() + ')';
                }
                return filter + ';id=out=(' + vm.topicsOut.toString() + ')';
            } else {
                if (vm.topicsOut.length == 0) {
                    return (!!filter ? filter + ';' : '') + 'name=re="' + vm.query.filter +'"';
                }
                return (!!filter ? filter + ';' : '' ) + 'name=re="' + vm.query.filter +'";' + 'id=out=(' + vm.topicsOut.toString() + ')';
            }
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedItems);
        }

        vm.close = function() {
            $mdDialog.cancel();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicMetaDataController', TopicMetaDataController)

    /* @ngInject */
    function TopicMetaDataController($state, $scope, $window, $mdSidenav, MetaData, AlertService, $mdDialog, $filter, id, ToastService) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.updateObject = false;
        vm.metaDataObject;
        vm.selectedFieldGroup;
        vm.loadingData = true;
        vm.showDisplayOrderPage = false;
        vm.topicDisplayOrder = [];
        vm.loadAll();

        function loadAll() {
            MetaData.get({
                id: id,
                is_name: true,
                add_default_properties: true
            }, function (result) {
                vm.metaDataObject = result;
                vm.updateObject = false;
                if (vm.metaDataObject.field_groups && vm.metaDataObject.field_groups.length > 0) {
                    vm.selectedFieldGroup = vm.metaDataObject.field_groups[0];
                }
                vm.loadingData = false;
            });
            MetaData.getDisplayOrder({}, function (result) {
                vm.topicDisplayOrder = result.reduce(function(arr, value, index) {
                    if( value !== 'Sub-Topics') {
                        arr.push({'name': value, order: index-1})
                    }
                    return arr
                }, [])
            })
        };

        vm.selectFieldGroup = function (fieldGroup) {
            vm.updateObject = false;
            vm.showDisplayOrderPage=false;
            angular.forEach(vm.metaDataObject.field_groups, function (tempFieldGroup) {
                if (tempFieldGroup.name == fieldGroup.name) {
                    vm.selectedFieldGroup = tempFieldGroup;
                }
            });
        };

        vm.addFieldGroup = function (fieldGroup) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: {
                        name: null,
                        label: null,
                        description: null,
                        is_many: true,
                        fields: null,
                    },
                    isAdd: true
                }
            }).then(function (fieldGroup) {
                if (!vm.metaDataObject.field_groups) {
                    vm.metaDataObject.field_groups = [];
                }
                vm.metaDataObject.field_groups.push(fieldGroup);
                vm.updateObject = false;
                vm.selectedFieldGroup = fieldGroup;
                updateMetaData('atheer.contentFields.fieldGroupAdded', fieldGroup);
            });
        }

        vm.editFieldGroup = function (fieldGroup, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: angular.copy(fieldGroup),
                    isAdd: false
                }
            }).then(function (fieldGroup) {
                vm.metaDataObject.field_groups[index] = fieldGroup;
                updateMetaData('atheer.contentFields.fieldGroupUpdated');
            });
        }

        vm.deleteFieldGroup = function (fieldGroup, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.metaDataObject.field_groups.splice(index, 1);
                updateMetaData('atheer.contentFields.fieldGroupDeleted', vm.metaDataObject.field_groups[index == 0 ? 0 : index - 1]);
            });
        }

        vm.addField = function () {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: {
                        name: null,
                        description: null,
                        label: null,
                        data_type: 'STRING',
                        type: 'FLEX',
                        required: false,
                        enabled: true,
                        search_enabled: true
                    },
                    isAdd: true
                }
            }).then(function (field) {
                vm.updateObject = false;
                if (!vm.selectedFieldGroup.fields) {
                    vm.selectedFieldGroup.fields = [];
                };
                vm.selectedFieldGroup.fields.push(field);
                updateMetaData('atheer.contentFields.fieldAdded');
            });
        }

        vm.editField = function (field, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: angular.copy(field),
                    isAdd: false
                }
            }).then(function (field) {
                vm.updateObject = false;
                vm.selectedFieldGroup.fields[index] = field;
                updateMetaData('atheer.contentFields.fieldUpdated');
            });
        }

        vm.copyField = function (field, index) {
            var newField = angular.copy(field);
            newField.name = "Copy of " + newField.name;
            vm.updateObject = false;
            vm.selectedFieldGroup.fields.push(newField);
            updateMetaData('atheer.contentFields.fieldCopied');
        }

        vm.deleteField = function (field, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.updateObject = false;
                vm.selectedFieldGroup.fields.splice(index, 1);
                updateMetaData('atheer.contentFields.fieldDeleted');
            });
        }

        vm.back = function () {
            $window.history.back();
        };

        vm.showDisplayOrder = function() {
            vm.showDisplayOrderPage = true
        }

        function updateMetaData(successMessage, fieldGroupToSelect) {
            vm.loadingData = true;
            MetaData.update({
                id: id
            }, vm.metaDataObject, onSaveSuccess);

            function onSaveSuccess(result) {
                vm.metaDataObject = result;
                if (fieldGroupToSelect != null) {
                    vm.selectFieldGroup(fieldGroupToSelect);
                } else {
                    vm.selectedFieldGroup = vm.metaDataObject.field_groups[0];
                }
                ToastService.displayToast($filter('triTranslate')(successMessage), 3000);
                vm.loadingData = false;
            };
        }
        vm.saveDisplayOrder = function () {
            const order = ['Sub-Topics'].concat(vm.topicDisplayOrder.map(function(field) {
                return field.name
            }))

            MetaData.saveDisplayOrder(order, function (result) {
                ToastService.displayToast($filter('triTranslate')("atheer.topic.metadata.displayOrderUpdated"), 3000);
            })
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicMenuController', TopicMenuController);

    /* @ngInject */
    function TopicMenuController($scope, $state, $mdDialog, $mdPanel, Topic, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, CONTENT_META, $translate, Feature) {
        var vm = this;

        vm.loadingData = true;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;

        vm.filters = {
            metaType: 'all',
            enabled: false,
            allowScan: false,
            externalId: false,
            status: null,
        };

        if ( getSavedFilters() ) {
            vm.filters = getSavedFilters();
        }

        vm.updateFilters = function() {
            saveFilters(vm.filters);
            $scope.$emit('updateTopicList', vm.filters);
        }

        function saveFilters(filterData) {
            sessionStorage.setItem('objectMenu', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectMenu'));
        };

        vm.loadAll = function() {
            vm.loadingData = false;
        }
        vm.loadAll();
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.topic')
        .constant('TOPIC_INSIGHT_META', {
            topic: {
                sections: {
                    overview: {
                        label: 'atheer.topic.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'TopicInsightOverviewController',
                        template: 'modules/topic/topic-insight-overview.tmpl.html'
                    },
                    scan_history: {
                        label: 'atheer.topic.scanHistory',
                        icon: 'zmdi zmdi-account',
                        controller: 'TopicInsightScanHistoryController',
                        template: 'modules/topic/topic-insight-scan-history.tmpl.html'
                    }
                }
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicInsightScanHistoryController', TopicInsightScanHistoryController)

    /* @ngInject */
    function TopicInsightScanHistoryController($scope, $q, $state, $filter, id, Report, Experience, ParseLinks, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.pageSize = paginationConstants.itemsPerPage;

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Experience.getTopicScans({
                    query: "object_id==" + id,
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    user_info: true
                }).$promise;

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('id')) {
                return vm.predicate + ',' + 'desc';
            }

            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }
        };

        vm.loadData = function() {
           vm.loadingData = true;
           Experience.getTopicScans({
                    query: "object_id==" + id,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    user_info: true
                }, onSuccess, onError);

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicInsightOverviewController', TopicInsightOverviewController)

    /* @ngInject */
    function TopicInsightOverviewController($scope, $q, $filter, id, Report) {
        var vm = this;

        vm.loadingData = false;

        vm.topicScansByDay = {
            chart: {
                type: 'column',
            },
            title: {
                text: $filter('translate')('atheer.topic.scanPerDay')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.topic.noOfScans')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $filter('translate')('atheer.topic.dates'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            angular.forEach(vm.dashboardModel.topic_scan_by_day, function(topicScansByDay) {
                vm.topicScansByDay.xAxis.categories.push(topicScansByDay.name);
                vm.topicScansByDay.series[0].data.push(topicScansByDay.count);
            });

            vm.loadingData = false;
        }

        vm.loadData = function() {
           vm.loadingData = true;

            var resource = Report.getTopicSummary({
                id : id
            }).$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess();
                });
        }

        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicDetailController', TopicDetailController)

    /* @ngInject */
    function TopicDetailController($rootScope, $scope, $mdDialog, $filter, $q, id, MetaData, Topic, ContentAction, CONTENT_META, $state, AlertService, $mdToast, $mdSidenav, Content, Team, AirForm, User, ParseLinks, $timeout, pagingParams, paginationConstants, $stateParams, $window, ToastService) {
        var vm = this;

        var FORMLY_ATHEER_DATA_TYPE_MAPPING = {
            'BOOLEAN': 'boolean-switch',
            'STRING': 'input',
            'LIST': 'custom-select',
            'DATE': 'custom-datepicker',
            'DATETIME': 'datepicker',
            'NUMBER': 'input',
            'DECIMAL': 'input',
            'OBJECT': 'objectpicker',
            'ARRAY': 'custom-chips'
        };

        var FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING = {
            'STRING': 'text',
            'NUMBER': 'number',
            'DECIMAL': 'number'
        };

        vm.loadingData = false;
        vm.topicDataModel = null;
        vm.oldTopicDataModel = null;
        vm.audiences = [];
        vm.parentTopic = null;
        vm.topicType = 'STATIC';
        vm.tabView = 'SUB-TOPIC';
        vm.pageContent = null;
        vm.subTopics = [];
        vm.contents = [];
        vm.airForms = [];
        vm.users = [];
        vm.old_subTopics = [];
        vm.old_contents = [];
        vm.old_airForms = [];
        vm.old_users = [];
        vm.owner = null;
        vm.loadingContent = false;
        vm.loadingAirForms = false;
        vm.loadingUsers = false;
        vm.loadingSubTopics = false;
        vm.subTopicsPage = 1;
        vm.contentsPage = 1;
        vm.isSubTopic = $stateParams.isSubTopic;
        vm.illustartionEmptyScreenIdContent = "no_content_smartscan";
        vm.illustartionEmptyScreenIdSmartScan = "no_airform_smartscan";
        vm.illustartionEmptyScreenIdUser = "no_user_smartscan";
        vm.isHovered = false;
        vm.topicMeta = null;
        vm.topicMetaFields = [];

        if (angular.isDefined($stateParams.topicType) && $stateParams.topicType != null) {
            vm.topicType = $stateParams.topicType;
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            page: 1
        };

        vm.getQueryString = function (criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'name=re=' + criteria;
            }
        };

        vm.searchTeams = function (criteria) {
            var d = $q.defer();
            var result = Team.query({
                query: vm.getQueryString(criteria)
            }, function (result) {
                d.resolve(result);
            });
            return d.promise;
        };

        vm.backButtonClickHandler = function () {
            if (vm.isNew()) {
                vm.oldTopicDataModel.custom_attributes = angular.copy(
                    vm.topicDataModel.custom_attributes
                );
            }
            if (
                !$rootScope._.isEqual(
                    vm.topicDataModel,
                    vm.oldTopicDataModel
                ) ||
                !vm.isArrayEqual(vm.old_subTopics, vm.subTopics) ||
                !vm.isArrayEqual(vm.old_airForms, vm.airForms) ||
                !vm.isArrayEqual(vm.old_users, vm.users) ||
                !vm.isArrayEqual(vm.old_contents, vm.contents)
            ) {
                var success_callback = function () {
                    $state.go("storm.admin-topics");
                };
                getModal(success_callback, "");
            } else {
                $state.go("storm.admin-topics");
            }
        };

        vm.saveContent = function (contentIds) {
            Topic.assignContents(
                {
                    id: vm.topicDataModel.id,
                },
                contentIds,
                onSaveSuccess,
                onSaveError
            );

            function onSaveSuccess(result) {
                vm.loadContents(vm.topicDataModel.id);
            }

            function onSaveError(err) {
                console.error(err);
            }
        };

        vm.removeContentData = function (contentIds) {
            Topic.removeContents(
                {
                    id: vm.topicDataModel.id,
                },
                contentIds,
                onSaveSuccess,
                onSaveError
            );
            function onSaveSuccess(result) {
                vm.loadContents(vm.topicDataModel.id);
            }

            function onSaveError() {
                console.error(err);
            }
        };

        vm.loadParentTopic = function (parentId) {
            Topic.get({
                id: parentId
            }, function (result, headers) {
                vm.parentTopic = result;
            });
        };

        vm.openTopicPicker = function () {
            var sTopics = [];
            if (!vm.topicDataModel.sub_topics) {
                vm.topicDataModel.sub_topics = [];
            }
            sTopics = vm.topicDataModel.sub_topics;
            $mdDialog.show({
                multiple: true,
                controller: 'TopicPickerController',
                templateUrl: 'modules/topic/topic-picker.tmpl.html',
                controllerAs: 'vm',
                locals: {
                    filter: 'id!=' + vm.topicDataModel.id,
                    allowMultiSelect: true,
                    topics: sTopics
                }
            })
                .then(function (selectedItems) {
                    var subTopicIds = [];
                    subTopicIds = selectedItems;

                    if (angular.isUndefined(vm.topicDataModel.sub_topics)) {
                        vm.topicDataModel.sub_topics = subTopicIds;
                    } else {
                        angular.forEach(subTopicIds, function (subTopicId) {
                            if (
                                vm.topicDataModel.sub_topics.indexOf(
                                    subTopicId.id
                                ) == -1
                            ) {
                                vm.topicDataModel.sub_topics.push(
                                    subTopicId.id
                                );
                            }
                        });
                    }
                    if (selectedItems.length) {
                        vm.subTopics = vm.subTopics.concat(selectedItems);
                    }
                })
                .finally(function () {
                    vm.subTopicsPage = 1;
                 });
        };

        vm.isArrayEqual = function (arr1, arr2, key) {
            if (arr1.length !== arr2.length) {
                return false;
            }
            var hashmap = {};
            arr1.map(function (item) {
                hashmap[item[key]] = 1;
            });
            return (
                arr2.filter(function (item) {
                    return hashmap.hasOwnProperty(item[key]);
                }).length === arr1.length
            );
        };

        vm.getTopicThumbnail = function (topic) {
            if (topic.use_custom_thumbnail && !!topic.thumbnail_url) {
                return {
                    "background-image":
                        "url(/media/images/" + topic.thumbnail_url + ")",
                };
            }
            return {
                "background-image":
                    "url(/assets/images/topic/no_topic-preview.svg)",
                "background-position": "center",
                "background-size": "auto",
            };
        };

        vm.removeSubTopic = function (subTopic) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.topic.removeSubTopic'))
                .ariaLabel($filter('translate')('atheer.topic.removeSubTopic'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                var index = vm.topicDataModel.sub_topics.indexOf(subTopic.id);
                vm.topicDataModel.sub_topics.splice(index, 1);
                var sIndex = vm.subTopics.findIndex(function (sub_topic) {
                    return subTopic.id === sub_topic.id;
                });
                if (sIndex !== -1) {
                    vm.subTopics.splice(sIndex, 1);
                }              
            }).finally(function () {
             });
        };

        vm.loadPageContent = function (contentId) {
            Content.get({
                id: contentId
            }, function (result, headers) {
                vm.pageContent = result;
            });
        };

        vm.loadOwner = function () {
            Team.get({
                id: vm.topicDataModel.owner_id
            }, function (result, headers) {
                vm.owner = result;
            });
        };

        vm.getSubTopic = function (topicId) {
            $state.go("storm.admin-topic-detail", {
                'id': topicId
            });
        };

        vm.loadContents = function (topicId) {
            vm.loadingContent = true;
            Topic.getContents({
                id: topicId
            }, function (result, headers) {
                vm.contents = angular.copy(result);
                vm.old_contents = angular.copy(result);
                vm.loadingContent = false;
                vm.contentsPage = pagingParams.page;
                vm.contentsQueryCount = headers('X-Total-Count');
            });
        };

        vm.loadSubTopics = function (topicId) {
            vm.loadingSubTopics = true;
            Topic.getSubTopics({
                id: topicId,
                page: vm.subTopicsPage - 1,
                size: paginationConstants.itemsPerPage,
            }, function (result, headers) {
                if(!!vm.topicDataModel.sub_topics) {
                    vm.topicDataModel.sub_topics = angular.copy(vm.oldTopicDataModel.sub_topics);
                }
                vm.subTopics = angular.copy(result);
                vm.old_subTopics = angular.copy(result);
                vm.loadingSubTopics = false;
                vm.subTopicsQueryCount = headers('X-Total-Count');
            });
        };

        vm.loadAirForms = function () {
            vm.loadingAirForms = true;
            if (angular.isDefined(vm.topicDataModel.air_forms) && vm.topicDataModel.air_forms.length > 0) {
                AirForm.query({
                    page: 0,
                    size: 50,
                    sort: 'name,asc',
                    query: 'id=in=(' + vm.topicDataModel.air_forms + ');status==ACTIVE'
                }, function (data, headers) {
                    vm.airForms = angular.copy(data);
                    vm.old_airForms = angular.copy(data);
                    vm.loadingAirForms = false;
                });
            } else {
                vm.airForms = [];
                vm.loadingAirForms = false;
            };
        };

        vm.loadUsers = function () {
            vm.loadingUsers = true;
            if (angular.isDefined(vm.topicDataModel.users) && vm.topicDataModel.users.length > 0) {
                User.query({
                    page: 0,
                    size: 50,
                    sort: 'first_name,asc',
                    query: 'id=in=(' + vm.topicDataModel.users + ')'
                }, function (data, headers) {
                    vm.users = angular.copy(data);
                    vm.old_users = angular.copy(data);
                    vm.loadingUsers = false;
                });
            } else {
                vm.users = [];
                vm.loadingUsers = false;
            };
        };

        vm.openAirFormPicker = function () {
            var filterQuery = 'status==ACTIVE';
            if (vm.airForms.length) {
                filterQuery = filterQuery + ';id=out=(' + vm.airForms.map(function(airform ){return airform.id }).toString() + ')'
            }
            $mdDialog.show({
                controller: 'AirFormPickerController',
                templateUrl: 'modules/airform/airform-picker.tmpl.html',
                controllerAs: 'vm',
                locals: {
                    filter: filterQuery,
                    allowMultiSelect: true
                }
            })
                .then(function (selectedItems) {
                    var airformIds = [];
                    angular.forEach(selectedItems, function (airform) {
                        airformIds.push(airform.id);
                    });

                    if (angular.isUndefined(vm.topicDataModel.air_forms)) {
                        vm.topicDataModel.air_forms = airformIds;
                    } else {
                        angular.forEach(airformIds, function (airformId) {
                            if (vm.topicDataModel.air_forms.indexOf(airformId) == -1) {
                                vm.topicDataModel.air_forms.push(airformId);
                            }
                        });
                    };
                    vm.airForms = vm.airForms.concat(selectedItems);
                });
        };

        vm.openUserPicker = function () {
            $mdDialog.show({
                templateUrl: 'modules/user/user-picker.tmpl.html',
                controller: 'UserPickerController',
                controllerAs: 'vm',
                locals: {
                    filter: vm.users.map(function(user ){return user.id }).toString(),
                    allowMultiSelect: true,
                    userslist: [],
                    isSession: false,
                    isScheduledSession: false,
                    isAdmin: true,
                    isConversationSession: false,
                    isSmartScan: true
                }
            })
                .then(function (selectedItems) {
                    var userIds = [];
                    angular.forEach(selectedItems, function (user) {
                        userIds.push(user.id);
                    });

                    if (angular.isUndefined(vm.topicDataModel.users)) {
                        vm.topicDataModel.users = userIds;
                    } else {
                        angular.forEach(userIds, function (userId) {
                            if (vm.topicDataModel.users.indexOf(userId) == -1) {
                                vm.topicDataModel.users.push(userId);
                            }
                        });
                    };
                    vm.users = vm.users.concat(selectedItems);
                });
        };

        vm.openContentPicker = function () {
            var contentFilter = vm.contents.length ? 'id=out=('+ vm.contents.map(function(content) { return content.id })+');' : ''
            $mdDialog.show({
                templateUrl: 'modules/content/content-picker.html',
                controller: 'ContentPickerController',
                controllerAs: 'vm',
                locals: {
                    filter: 'embedded==false;type=out=(SERIES,EMAIL_LAYOUT);'+ contentFilter +'meta_type==DISCOVERABLE;status!=ARCHIVED',
                    allowMultiSelect: true,
                    isWeb: false,
                    isNotFilter: false
                }
            })
                .then(function (selectedItems) {
                    var contentIds = [];
                    selectedItems = selectedItems.filter(function (content) {
                        return !vm.contents.filter(function (cont) {
                            return cont.id === content.id;
                        }).length;
                    });
                    angular.forEach(selectedItems, function (selectedItem) {
                        contentIds.push(selectedItem.id);
                    });
                    vm.contents = vm.contents.concat(selectedItems);
                });
        };

        vm.removeContent = function (content) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.topic.removeContent'))
                .ariaLabel($filter('translate')('atheer.topic.removeContent'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                var contentIds = [];
                contentIds.push(content.id);

                var index = vm.contents.findIndex(function (cnt) {
                    return cnt.id === content.id;
                });
                if (index !== -1) {
                    vm.contents.splice(index, 1);
                }

            }).finally(function () { });
        };

        vm.removeAirForm = function (airform) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.topic.removeAirForm'))
                .ariaLabel($filter('translate')('atheer.topic.removeAirForm'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                var index = vm.topicDataModel.air_forms.indexOf(airform.id);
                vm.topicDataModel.air_forms.splice(index, 1);
                var aIndex = vm.airForms.findIndex(function (air_form) {
                    return air_form.id === airform.id;
                });
                if (aIndex !== -1) {
                    vm.airForms.splice(aIndex, 1);
                }
            }).finally(function () { });
        };

        vm.removeUser = function (user) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.topic.removeUser'))
                .ariaLabel($filter('translate')('atheer.topic.removeUser'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                var index = vm.topicDataModel.users.indexOf(user.id);
                vm.topicDataModel.users.splice(index, 1);
                var uIndex = vm.users.findIndex(function (usr) {
                    return usr.id === user.id;
                });
                if (uIndex !== -1) {
                    vm.users.splice(uIndex, 1);
                };
            }).finally(function () { });
        };

        vm.getCardMeta = function (card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        function getModal(success_callback, title) {
            if (!title) {
                title = "atheer.topic.unsavedChanged";
            }
            var confirmModal = $mdDialog
                .confirm()
                .title($filter("translate")(title))
                .ariaLabel($filter("translate")(title))
                .ok($filter("translate")("entity.action.ok"))
                .cancel($filter("translate")("entity.action.cancel"));
            $mdDialog.show(confirmModal).then(function (event) {
                success_callback();
            });
        }

        vm.refresh = function () {
            if (vm.tabView == "SUB-TOPIC") {
                if (!vm.isArrayEqual(vm.old_subTopics, vm.subTopics, "id")) {
                    var success_callback = function () {
                        vm.loadSubTopics(vm.topicDataModel.id);
                    };
                    getModal(success_callback, "atheer.topic.unsavedSubtopic");
                } else {
                    vm.loadSubTopics(vm.topicDataModel.id);
                }
            } else if (vm.tabView == "CONTENTS") {
                if (!vm.isArrayEqual(vm.old_contents, vm.contents, "id")) {
                    var success_callback = function () {
                        vm.loadContents(vm.topicDataModel.id);
                    };
                    getModal(success_callback, "atheer.topic.unsavedContent");
                } else {
                    vm.loadContents(vm.topicDataModel.id);
                }
            }
        };

        vm.loadAll = function () {

            vm.loadingData = true;

            MetaData.get({
                id: 'topic',
                is_name: true
            }, function (result, headers) {
                angular.forEach(result.field_groups, function (field_group) {
                    if (field_group.name == 'base') {
                        vm.topicMeta = field_group;
                    }
                });

                angular.forEach(vm.topicMeta.fields, function (field) {
                    if (field.type == 'FLEX') {
                        vm.topicMetaFields.push(getFormlyField(field));
                    }
                });
                if (id) {
                    Topic.get({
                        id: id
                    }, function (result, headers) {
                        vm.topicDataModel = angular.copy(result);
                        vm.oldTopicDataModel = angular.copy(result);
                        vm.topicType = result.type;
                        vm.loadTeams(vm.topicDataModel);
                        vm.loadSubTopics(vm.topicDataModel.id);
                        vm.loadContents(vm.topicDataModel.id);
                        vm.loadAirForms();
                        vm.loadUsers();

                        if (vm.topicDataModel.owner_id) {
                            vm.loadOwner();
                        };

                        if (vm.topicDataModel.parent_id != null) {
                            vm.loadParentTopic(vm.topicDataModel.parent_id);
                        };

                        if (vm.topicType == 'PAGE' && vm.topicDataModel.content_id != null) {
                            vm.loadPageContent(vm.topicDataModel.content_id);
                        };

                        if (vm.topicDataModel.available_from) {
                            vm.topicDataModel.available_from = new Date(vm.topicDataModel.available_from)
                            vm.oldTopicDataModel.available_from = new Date(vm.oldTopicDataModel.available_from)
                        }
                        if (vm.topicDataModel.discontinue_from) {
                            vm.topicDataModel.discontinue_from = new Date(vm.topicDataModel.discontinue_from)
                            vm.oldTopicDataModel.discontinue_from = new Date(vm.oldTopicDataModel.discontinue_from)
                        };

                        vm.loadingData = false;
                    });
                } else {
                    vm.loadingData = false;
                    vm.topicDataModel = {
                        name: "Topic Title",
                        description: "",
                        external_id: null,
                        type: vm.topicType,
                        status: "DRAFT",
                        enabled: false,
                        allow_scan: false,
                        available_from: new Date(),
                        discontinue_from: null,
                        featured: false,
                        parent_id: null,
                        tags: []
                    };
                    vm.oldTopicDataModel = angular.copy(vm.topicDataModel);
                }
            });


        };

        vm.loadTeams = function (topic) {
            if (topic.audiences && topic.audiences.length > 0) {
                Team.query({
                    query: 'id=in=(' + topic.audiences.toString() + ')',
                }, function (response, headers) {
                    vm.audiences = response;
                });
            }
        };

        vm.launchContentPreview = function (content) {
            ContentAction.previewContent(content);
        };

        vm.transformChip = function (chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
        };

        vm.save = function () {
            if (vm.owner) {
                vm.topicDataModel.owner_id = vm.owner.id
            } else {
                vm.topicDataModel.owner_id = null;
            };

            if (vm.audiences && vm.audiences.length > 0) {
                var audienceIds = [];
                angular.forEach(vm.audiences, function (audience) {
                    audienceIds.push(audience.id);
                });
                vm.topicDataModel.audiences = audienceIds;
            } else {
                vm.topicDataModel.audiences = null;
            }

            if (vm.parentTopic != null) {
                vm.topicDataModel.parent_id = vm.parentTopic.id;
            } else {
                vm.topicDataModel.parent_id = null;
            }

            if (vm.pageContent != null) {
                vm.topicDataModel.content_id = vm.pageContent.id;
            }

            if (vm.topicDataModel.id) {
                Topic.update(vm.topicDataModel, onSaveSuccess);
            } else {
                Topic.save(vm.topicDataModel, onSaveSuccess);
            }

            var addedContent = vm.contents
                .filter(function (content) {
                    return !vm.old_contents.some(function (c) {
                        return c.id === content.id;
                    });
                })
                .map(function (content) {
                    return content.id;
                });

            var removedContent = vm.old_contents
                .filter(function (content) {
                    return !vm.contents.some(function (c) {
                        return c.id === content.id;
                    });
                })
                .map(function (content) {
                    return content.id;
                });
            if (addedContent.length) {
                vm.saveContent(addedContent);
            }
            if (removedContent.length) {
                vm.removeContentData(removedContent);
            }

            function onSaveSuccess(result) {
                id = result.id;
                vm.topicDataModel = angular.copy(result);
                vm.oldTopicDataModel = angular.copy(result);
                vm.loadContents(vm.topicDataModel.id);
                vm.loadSubTopics(vm.topicDataModel.id);
                vm.isSaving = false;
                AlertService.displayToast($mdToast);
            }
        };

        vm.copyTopic = function () {
            vm.topicDataModel.id = null;
            vm.topicDataModel.name = "Copy of " + vm.topicDataModel.name;
            id = null;
        };

        vm.isNew = function () {
            if (!vm.topicDataModel) {
                return false;
            } else {
                if (vm.topicDataModel.id == null) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        vm.togglePanel = function (componentId) {
            $mdSidenav(componentId).toggle();
        };

        vm.transitionSubTopics = function () {
            vm.loadingSubTopics = true;
            vm.promise = Topic.getSubTopics({
                id: vm.topicDataModel.id,
                page: vm.subTopicsPage - 1,
                size: paginationConstants.itemsPerPage
            }).$promise;

            vm.promise.then(function (result, headers) {
                vm.loadingSubTopics = false;
                vm.subTopics = angular.copy(result);
                vm.old_subTopics = angular.copy(result);
                vm.subTopicsQueryCount = headers('X-Total-Count');
            });
        };

        vm.transitionContents = function () {
            vm.loadingContent = true;

            vm.promise = Topic.getContents({
                page: vm.contentsPage - 1,
                size: paginationConstants.itemsPerPage,
                id: vm.topicDataModel.id
            }).$promise;

            vm.promise.then(function (result, headers) {
                vm.loadingContent = false;
                vm.contents = angular.copy(result);
                vm.old_contents = angular.copy(result);
            });
        };

        vm.getDefaultBackground = function () {
            return '#bdbec0';
        };

        vm.hideInfo = function () {
            $timeout(function () {
                if (vm.isHovered) {
                    vm.isHovered = false;
                }
            }, 1000);
        };

        function getFormlyField(atheerfield) {
            var formlytype = FORMLY_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyTemplateType = FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyField = {
                type: formlytype ? formlytype : 'input',
                key: atheerfield.name,
                templateOptions: {
                    label: atheerfield.label,
                    required: atheerfield.required
                }
            };
            if (formlytype == "datepicker") {
                formlyField.templateOptions['placeholder'] = $filter('translate')('atheer.about.selectDate');
            }
            if (formlyTemplateType) {
                formlyField.templateOptions['type'] = formlyTemplateType;
            }

            if (atheerfield.data_type == 'DATETIME') {
                formlyField.templateOptions['datepickerPopup'] = "HH:MM";
            }

            if (atheerfield.data_type == 'ARRAY') {
                formlyField.templateOptions['labelProp'] = "label";
                formlyField.defaultValue = [];
            }

            if (atheerfield.data_type == 'LIST') {
                formlyField.templateOptions['labelProp'] = "label";
                formlyField.templateOptions['valueProp'] = "option_id";
                formlyField.templateOptions['options'] = atheerfield.list_options;
            }

            if (atheerfield.data_type == 'OBJECT') {
                if (atheerfield.ref_object == 'Content') {
                    formlyField.templateOptions['objectName'] = 'Content';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'title',
                        operator: '=re='
                    }];
                } else if (atheerfield.ref_object == 'User') {
                    formlyField.templateOptions['objectName'] = 'User';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'text_search',
                        operator: '=ts='
                    }];
                }
            }
            return formlyField;
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicDetailRecognitionController', TopicDetailRecognitionController)

    /* @ngInject */
    function TopicDetailRecognitionController($mdDialog, $scope, $filter, $sce, $q, ParseLinks, pagingParams, paginationConstants, $state, Team, AlertService, $mdToast, $mdSidenav, TOPIC_RECOGNITION_META, Principal, Topic, Feature, User, id) {

      var vm = this;

      vm.loadingData = true;

      vm.recognitionSections = angular.copy(TOPIC_RECOGNITION_META['topic'].sections);

      vm.topicModel = null;

      vm.loadData = function() {
          if (id) {
              Topic.get({
                  id: id
              }, function(result) {
                  vm.topicModel = result;
                  vm.loadingData = false;
              });
          }
      };
      vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicDetailQRCodeController', TopicDetailQRCodeController)

    /* @ngInject */
    function TopicDetailQRCodeController($scope, $q, $filter, id, Report, Topic, $timeout, $http) {
        var vm = this;

        vm.loadingData = false;
        vm.topicModel = null;
        vm.showActions = false;

        vm.qrCodeLink = '';
        vm.qrCodeImage;

        vm.loadData = function () {
            if (id) {
                vm.loadingData = true;
                Topic.get({
                    id: id
                }, function (result) {
                    vm.topicModel = result;
                    vm.loadingData = false;

                    $timeout(function () {
                        vm.showActions = true;
                    }, 1000);

                    vm.qrCodeLink = '/api/topics/' + vm.topicModel.id + '/qrcode';
                    $http.get(vm.qrCodeLink, { responseType: 'blob' }).then(function (response) {
                        vm.qrCodeImage = URL.createObjectURL(response.data);
                    })
                });
            }
        };

        vm.downloadQR = function () {
            var link = document.createElement('a');
            link.download = 'QR-Code',
                link.href = vm.qrCodeImage;
            link.click();
        };

        vm.printQR = function () {
            var printWin = window.open();
            printWin.document.open();
            printWin.document.write(ImagetoPrint());
            printWin.document.close();
        };

        function ImagetoPrint() {
            return "<html><head><script>function step1(){\n" +
                "setTimeout('step2()', 10);}\n" +
                "function step2(){window.print();window.close()}\n" +
                "</script></head><body onload='step1()'>\n" +
                "<img src='" + vm.qrCodeImage + "' /></body></html>";
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicDetailInsightsController', TopicDetailInsightsController)

    /* @ngInject */
    function TopicDetailInsightsController($mdDialog, $scope, $filter, $sce, $q, ParseLinks, pagingParams, paginationConstants, $state, Team, AlertService, $mdToast, $mdSidenav, TOPIC_INSIGHT_META, Principal, Topic, ContentAction, User, id) {

        var vm = this;

        vm.loadingData = true;

        vm.insightSections = angular.copy(TOPIC_INSIGHT_META['topic'].sections);

        vm.topicModel = null;

        vm.loadData = function() {
            if (id) {
                Topic.get({
                    id: id
                }, function(result) {
                    vm.topicModel = result;
                    vm.loadingData = false;
                });
            }
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.topic')
        .controller('TopicDetailImagesController', TopicDetailImagesController)

    /* @ngInject */
    function TopicDetailImagesController($scope, $q, $filter, id, Report, Topic, $timeout) {
        var vm = this;

        vm.loadingData = false;
        vm.topicModel = null;
        vm.showActions = false;

        vm.loadData = function() {
            if (id) {
                Topic.get({
                    id: id
                }, function(result) {
                    vm.topicModel = result;
                    vm.loadingData = false;

                    $timeout(function() {
                        vm.showActions = true;
                    }, 1000);
                });
            }
        };

        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.ticket', [

        ]);
})();
;
(function () {
    'use strict';

    angular.module('atheer.ticket').config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.tickets', {
                url: '/tickets',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'TicketController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.ticket.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
    }
})();;
(function () {
    "use strict";

    angular
        .module("atheer.ticket")
        .controller("TicketController", TicketController);

    /* @ngInject */
    function TicketController($scope, $window, $state, $sce, $rootScope) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.isIFrameDataLoaded = false;

        function setNgxPageUrl() {
            var ngxUrl = null;
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;

            if ($state.current.name == "storm.tickets") {
                ngxUrl = hostUrl + "/ngx/tickets";
            }

            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
            $rootScope.selectedLeftNavMenu = 'tickets';
        }

        function handleNgxEvent(event) {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                $state.transitionTo(ngState, null, {
                    location: true,
                    inherit: true,
                    relative: $state.$current,
                    notify: false,
                });
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        $window.addEventListener("message", handleNgxEvent, false);

        // Unregister
        $scope.$on("$destroy", function () {
            window.removeEventListener("message", handleNgxEvent, false);
        });

        setNgxPageUrl();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-teams', {
                url: '/teams?page&sort&search',
                views: {
                    '@storm': {
                        templateUrl: 'modules/team/teams.html',
                        controller: 'TeamController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/team/team-toolbar.tmpl.html',
                        controller: 'TeamToolbarController',
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/team/team-menu.tmpl.html',
                        controller: 'TeamMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.team.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-team-detail', {
                url: '/teams/:id',
                templateUrl: 'modules/team/team-detail.tmpl.html',
                controller: 'TeamDetailController',
                controllerAs: 'vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    teamType: null,
                    parentTeam: [],
                    isDeeplink: false
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamController', TeamController);

    /* @ngInject */
    function TeamController($rootScope, $scope, triTheming, triSettings, $window, $state, Team, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, Feature, $filter, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.getQueryString = getQueryString;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;
        vm.primaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value
        );
        vm.secondaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().secondary_color, '500').value
        );

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.reOrder = reOrder;
        vm.illustartionEmptyScreenId = "team";

        vm.permissions = {
            create: 'manage-audience',
            update: 'manage-audience',
            delete: 'manage-audience',
            manage: 'manage-audience'
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1,
            filters: {
                active: false,
                externalId: false,
                functionalTeam: false,
                type: null,
                static: false,
                dynamic: false
            }
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function loadAll() {
            vm.loadingData = true;
            var savedQuery = getSavedFilters();
            if ( savedQuery ) {
                vm.query = savedQuery;
            }
            vm.page = vm.query.page;

            Team.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder(),
                query: getQueryString()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.loadingData = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.teams = data;
                //vm.page = pagingParams.page;

                processData();
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function processData() {
            angular.forEach(vm.teams, function(team) {
                if (team.status == 'DRAFT') {
                    team.active = false;
                } else {
                    team.active = true;
                }
            });
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.reverse = !vm.reverse;
            vm.transition();
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function transition() {
            vm.promise = Team.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.teams = data;
                processData();
            });
            vm.query.page = vm.page;
            saveFilters(vm.query);
        };

        function getQueryString() {
            var teamQuery = "audienceNo=out=(1000,1001)";

            if (vm.query.filters.active) {
                if (teamQuery === "") {
                    teamQuery = 'status=in=(ACTIVE)';
                } else {
                    teamQuery = teamQuery + ';status=in=(ACTIVE)';
                }
            }

            if (vm.query.filters.externalId) {
                if (teamQuery === "") {
                    teamQuery = 'externalId=ex=true';
                } else {
                    teamQuery = teamQuery + ';externalId=ex=true';
                }
            }

            if (vm.query.filters.functionalTeam) {
                if (teamQuery === "") {
                    teamQuery = 'functionalTeam==true';
                } else {
                    teamQuery = teamQuery + ';functionalTeam==true';
                }
            }

            if (vm.query.filters.static || vm.query.filters.dynamic) {
                var typeFilter  = "";
                if(vm.query.filters.static && !vm.query.filters.dynamic) {
                    typeFilter = typeFilter + 'type=in=(STATIC)'
                }
                if(!vm.query.filters.static && vm.query.filters.dynamic) {
                    typeFilter = typeFilter + 'type=in=(SMART)'
                }
                if(vm.query.filters.static && vm.query.filters.dynamic) {
                    typeFilter = typeFilter + 'type=in=(STATIC,SMART)'
                }

                if (teamQuery === "") {
                    teamQuery = typeFilter;
                } else {
                    teamQuery = teamQuery + ';' + typeFilter;
                }
            }

            if (vm.query.filter.length > 0) {
                teamQuery = teamQuery + ';' + 'name=re=' + vm.query.filter;
            }

            return teamQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        };

        vm.getDefaultBackground = function() {
            return '#bdbec0';
        };

        vm.back = function() {
            $window.history.back();
        };

        vm.onPublishChange = function(team) {
            Team.update(team, function() {
                ToastService.displayToast(team.name + ' ' + $filter('translate')('atheer.content.enableUpdateSuccess'), 3000);
            }, function() {
                ToastService.displayToast($filter('translate')('atheer.content.enableUpdateError'), 3000)
            });
        }

        function createObject(parentTeam) {
            $state.go('storm.admin-team-detail', {
                'teamType': 'STATIC',
                'parentTeam': null
            });
        };

        function editObject(objectId) {
            $state.go("storm.admin-team-detail", {
                'id': objectId
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.team.deleteTeam'))
                .ariaLabel($filter('translate')('atheer.team.deleteTeam'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Team.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                },function(error) {
                    var errorMessage;
                    if(error.data.description && error.data.description != '') {
                        errorMessage = error.data.description;
                    } else {
                        errorMessage = $filter('translate')('atheer.team.errorDeletingTeam');
                    }
                    var errorWindow = $mdDialog.alert()
                        .title(errorMessage)
                        .ok('Close');
                    $mdDialog.show(errorWindow);
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        var refreshTeamListener = $rootScope.$on('refreshTeams', function(event, filter) {
            vm.query.filter = filter;
            vm.query.page = 1;
            saveFilters(vm.query);
            loadAll();
        });

        var updateTeamListener = $rootScope.$on('updateTeamList', function(event, filters) {
            vm.query.filters = filters;
            vm.query.page = 1;
            saveFilters(vm.query);
            loadAll();
        });

        function saveFilters(filterData) {
            sessionStorage.setItem('objectFilters', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectFilters'));
        };

        // Unregister
        $scope.$on('$destroy', function() {
            refreshTeamListener();
            updateTeamListener();
        });

        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamToolbarController', TeamToolbarController);

    /* @ngInject */
    function TeamToolbarController($rootScope, $scope, $state, $mdDialog, Team, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.showNewTeamMenu = false;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        if ( getSavedFilters() ) {
            vm.query = getSavedFilters();
        }

        vm.removeFilter = removeFilter;
        vm.filter.show = vm.query.filter.length > 0 ? true : false;

        vm.permissions = {
            create: 'manage-audience',
            update: 'manage-audience',
            delete: 'manage-audience',
            manage: 'manage-audience'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        function refreshAll() {
            saveFilters(vm.query);
            $scope.$emit('refreshTeams', vm.query.filter);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            saveFilters(vm.query);
            $scope.$emit('refreshTeams', vm.query.filter);
        };

        vm.createStaticTeam = function() {
            $state.go('storm.admin-team-detail', {
                'teamType': 'STATIC'
            });
        };

        vm.createSmartTeam = function () {
          $state.go('storm.admin-team-detail', {
              'teamType': 'SMART'
          });
        };

        function saveFilters(filterData) {
            sessionStorage.setItem('objectHeader', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectHeader'));
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamPickerController', TeamPickerController);

    /* @ngInject */
    function TeamPickerController($scope, $state, triSettings, $mdDialog, Team, ParseLinks, AlertService, $mdToast, $filter, filter, allowMultiSelect, selectedItemIds, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "id";
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.selected = [];
        vm.allowMultiSelect = allowMultiSelect;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.currentSelectedItems = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.getQueryString = getQueryString;

        vm.loadAll();

        function loadAll() {
            Team.query({
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = ['id' + ',' + 'asc'];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.teams = data;
                vm.page = 1;

                setOrUpdateSelectedItems();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Team.query({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: getSortOrder(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.teams = data;

                setOrUpdateSelectedItems();
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            if (vm.query.filter.length <= 0) {
                return filter;
            } else {
                return filter + ';name=re="' + vm.query.filter +'"';
            }
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        function setOrUpdateSelectedItems() {
            angular.forEach(selectedItemIds, function(selectedItemId) {
                angular.forEach(vm.teams, function(team) {
                    if(selectedItemId === team.id) {
                        vm.currentSelectedItems.push(team);
                    }
                });
            });
        };

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedItems);
        }

        vm.close = function() {
            $mdDialog.cancel();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamMenuController', TeamMenuController);

    /* @ngInject */
    function TeamMenuController($scope, $state, $mdDialog, $mdPanel, Team, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature) {
        var vm = this;

        vm.loadingData = true;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;

        vm.filters = {
            active: false,
            externalId: false,
            functionalTeam: false,
            type: null,
            static: false,
            dynamic: false
        };

        if ( getSavedFilters() ) {
            vm.filters = getSavedFilters();
        }

        vm.updateFilters = function() {
            saveFilters(vm.filters);
            $scope.$emit('updateTeamList', vm.filters);
        }

        function saveFilters(filterData) {
            sessionStorage.setItem('objectMenu', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectMenu'));
        };

        vm.loadAll = function() {
            vm.loadingData = false;
        }
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamDetailController', TeamDetailController)

    /* @ngInject */
    function TeamDetailController($scope, $rootScope, $mdDialog, $filter, $q, id, triTheming, triSettings, Experience, Team, $state, AlertService, $mdToast, $mdSidenav, Content, AirForm, User, ParseLinks, $timeout, pagingParams, paginationConstants, $stateParams, $window, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.loadingUsers = false;
        vm.teamDataModel = null;
        vm.showTeamDetails = true;
        vm.emptyCriteria = {
            match_all: true,
            condition_groups: []
        };
        vm.showTeamFilters = true;
        vm.showUsersUsingFilters = false;
        vm.teamType = 'STATIC';
        vm.users = [];
        vm.owner = null;
        vm.isHovered = false;
        vm.predicate = "id";
        vm.primaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value
        );
        vm.secondaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().secondary_color, '500').value
        );

        vm.userHistoryPredicate = 'id';
        vm.userHistoryReverse = 'asc';
        vm.userHistoryPage = 1;
        vm.userHistoryTotalItems = null;
        vm.userHistory = [];
        vm.isUserHistoryLoaded = false;
        vm.userHistoryQueryCount = 0;
        vm.userHistoryQueryLimit = paginationConstants.itemsPerPage;
        vm.illustartionEmptyScreenIdUser = "no_user_team";
        vm.isTeamInsightsLoaded = false;

        if (angular.isDefined($stateParams.teamType) && $stateParams.teamType != null) {
            vm.teamType = $stateParams.teamType;
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            page: 1
        };

        vm.teamUserChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.teamInsights.members')
            },
            credits: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.teamInsights.noOfMembers')
                }
            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.teamInsights.date')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }

            },
            series: [{
                name: $filter('translate')('atheer.teamInsights.members'),
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> Members : ' + this.y;
                }
            }
        };

        function loadTeamInsights() {
            vm.isTeamInsightsLoaded = true;

            Team.getMemberCountHistory({
                id: id,
                page: 0,
                size: 90,
                sort: 'id,desc',
                query: null
            }, onInsightsSuccess, onInsightsError);

            function onInsightsSuccess(result) {
                vm.teamUserChartData.series[0].data = [];
                vm.teamMemberCountHistory = result;
                angular.forEach(result, function(countHistory) {
                    vm.teamUserChartData.series[0].data.push({
                        x: new Date(countHistory.record_date),
                        y: countHistory.member_count
                    })
                });
                vm.teamUserChartData.series[0].data = $filter('orderBy')(vm.teamUserChartData.series[0].data, getDateFromItem);
                vm.isTeamInsightsLoaded = false;
            }

            function onInsightsError(error) {
                AlertService.error(error.data.message);
                vm.isTeamInsightsLoaded = false;
            }
        };

        function getDateFromItem(item) {
            return item.x;
        }

        function loadAll() {
            if (id) {
                vm.loadingData = true;

                Team.get({
                    id: id
                }, function(result, headers) {
                    vm.teamDataModel = result;
                    vm.teamType = result.type;
                    vm.loadingData = false;
                    if (vm.teamType == 'SMART') {
                        vm.showTeamDetails = false;
                        vm.showTeamFilters = true;
                    };
                    if (vm.teamDataModel.status == 'DRAFT' && vm.teamType == 'SMART') {
                        vm.showUsersUsingFilters = true;
                    } else {
                        vm.showUsersUsingFilters = false;
                    }
                    loadUsers();
                });
            } else {
                if (vm.teamType == 'SMART') {
                    vm.teamDataModel = {
                        name: "Team Title",
                        description: "",
                        external_id: null,
                        type: vm.teamType,
                        status: "DRAFT",
                        enabled: false,
                        criteria: vm.emptyCriteria
                    };
                } else {
                    vm.teamDataModel = {
                        name: "Team Title",
                        description: "",
                        external_id: null,
                        type: vm.teamType,
                        status: "DRAFT",
                        enabled: false
                    };
                }

            }
        };

        function loadUsers() {
            vm.loadingUsers = true;

            if (vm.teamDataModel.type == 'SMART' && vm.showUsersUsingFilters) {
                var criteria = vm.teamDataModel.criteria;

                Experience.getUsers({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: getSortOrder()
                }, criteria, function(data, headers) {
                    vm.users = data;
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    vm.loadingUsers = false;
                }, function onError(error) {
                    AlertService.error(error.data.message);
                    vm.loadingUsers = false;
                });
            } else {
                Experience.getTeams({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    query: "object_id==" + id,
                    user_info: true
                }, function(data, headers) {
                    vm.users = [];
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;

                    angular.forEach(data, function(userTeam) {
                        var userDetails = userTeam.user_info;
                        userDetails.assigned_on = userTeam.assigned_on;
                        vm.users.push(userDetails);
                    });

                    vm.page = pagingParams.page;
                    vm.loadingUsers = false;
                }, function onError(error) {
                    AlertService.error(error.data.message);
                    vm.loadingUsers = false;
                });
            }
        };

        function saveTeam() {
            $mdDialog.show({
                templateUrl: 'modules/team/team-detail-save-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "TeamDetailSaveDialogController",
                controllerAs: "vm",
                locals: {
                    mode: 'STATIC',
                    team: vm.teamDataModel
                },
                size: 'lg'
            }).then(function() {
                if (vm.teamDataModel.type == 'SMART') {
                    loadAll();
                }
            });
        };

        vm.transitionUsers = function() {
            if (vm.teamDataModel.type == 'SMART' && vm.showUsersUsingFilters) {
                var criteria = vm.teamDataModel.criteria;

                vm.promise = Experience.getUsers({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: getSortOrder(),
                }, criteria).$promise;

                vm.promise.then(function(data, headers) {
                    vm.users = data;
                    vm.queryCount = vm.totalItems;
                });
            } else {
                vm.promise = Experience.getTeams({
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    query: "object_id==" + id,
                    user_info: true
                }).$promise;

                vm.promise.then(function(data, headers) {
                    vm.users = [];
                    vm.queryCount = vm.totalItems;
                    angular.forEach(data, function(userTeam) {
                        vm.users.push(userTeam.user_info);
                    });
                });
            }
        };

        vm.getQueryString = function(criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'name=re=' + criteria;
            }
        };

        vm.refreshUsers = function() {
            loadUsers();
        };

        vm.save = function() {
            if (vm.teamDataModel.id) {
                if (vm.teamDataModel.type == 'SMART' && vm.teamDataModel.status == 'ACTIVE') {
                    saveTeam();
                } else {
                    Team.update(vm.teamDataModel, onSaveSuccess, onSaveFailure);
                }
            } else {
                Team.save(vm.teamDataModel, onSaveSuccess, onSaveFailure);
            };

            function onSaveSuccess(result) {
                if (vm.teamDataModel.id == null) {
                    $state.go("storm.admin-team-detail", {
                        'id': result.id
                    });
                    AlertService.displayToast($mdToast);
                } else {
                    id = result.id;
                    vm.teamDataModel = result;
                    vm.isSaving = false;
                    AlertService.displayToast($mdToast);

                    // firing an event downwards
                    $scope.$emit('updateTeam');
                }
            }

            function onSaveFailure(error) {
                var msg = error.data.description;
                vm.isSaving = false;
                if ( msg.includes("duplicate key error") ) {
                    msg = $filter('translate')('atheer.team.uniqueNameRequired');
                }
                ToastService.displayToast($filter('translate')('atheer.team.saveFailed', { reason: msg }));
            }
        };

        vm.goToTeams = function() {
            $state.go('storm.admin-teams');
        };

        vm.isNew = function() {
            if (!vm.teamDataModel) {
                return false;
            } else {
                if (vm.teamDataModel.id == null) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        vm.togglePanel = function(componentId) {
            vm.isUserHistoryLoaded = false;
            vm.isTeamInsightsLoaded = false;
            $mdSidenav(componentId).toggle()
                .then(function() {
                    if (componentId == 'teamHistoryPanel') {
                        vm.loadMemberHistory();
                    }
                    if (componentId == 'teamInsightsPanel') {
                        loadTeamInsights();
                    }
                });
        };

        vm.getDefaultBackground = function() {
            return '#bdbec0';
        };

        vm.hideInfo = function() {
            $timeout(function() {
                if (vm.isHovered) {
                    vm.isHovered = false;
                }
            }, 1000);
        };

        vm.loadMemberHistory = function() {
            vm.userHistory = [];
            vm.isUserHistoryLoaded = false;
            Team.getMemberHistory({
                id: id,
                page: 0,
                size: paginationConstants.itemsPerPage,
                query: null
            }, onUserHistorySuccess, onUserHistoryError);

            function onUserHistorySuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.userHistoryTotalItems = headers('X-Total-Count');
                vm.userHistoryQueryCount = vm.userHistoryTotalItems;
                vm.userHistoryPage = 1;
                vm.userHistory = data;
                vm.isUserHistoryLoaded = true;
            }

            function onUserHistoryError(error) {
                AlertService.error(error.data.message);
                vm.isUserHistoryDataLoaded = true;
            }
        };

        vm.userHistoryTransition = function(pageNo) {
            if (!pageNo) {
                pageNo = vm.userHistoryPage;
            } else {
                $scope.userHistoryPage = pageNo;
            }

            vm.promise = Team.getMemberHistory({
                id: id,
                page: pageNo - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.userHistoryQueryCount = vm.userHistoryTotalItems;
                vm.userHistory = data;
            });
        };

        vm.removeUser = function(userToRemove, index) {
            var usersToRemove = [];
            usersToRemove.push(userToRemove);

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.team.deleteUser'))
                .ariaLabel($filter('translate')('atheer.team.deleteUser'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                var userTeams = [];
                angular.forEach(usersToRemove, function(user) {
                    userTeams.push({
                        user_id: user.id,
                        object: vm.teamDataModel,
                        source: 'ADMIN',
                        assigned_on: new Date()
                    });
                });
                Experience.bulkTeamsRemove(userTeams, function(result) {
                    loadUsers();
                });
            });
        };

        vm.removeUsers = function(usersToRemove, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.team.deleteUser'))
                .ariaLabel($filter('translate')('atheer.team.deleteUser'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                var userTeams = [];
                angular.forEach(vm.selectedUsers, function(user) {
                    userTeams.push({
                        user_id: id,
                        object: vm.teamDataModel,
                        source: 'ADMIN',
                        assigned_on: new Date()
                    });
                });
                Experience.bulkTeamsRemove(userTeams, function(result) {
                    loadUsers();
                });
            });
        };

        vm.openUserPicker = function() {
            $mdDialog.show({
                    templateUrl: 'modules/user/user-picker.tmpl.html',
                    controller: 'UserPickerController',
                    controllerAs: 'vm',
                    locals: {
                        filter: vm.invitedUserIds,
                        allowMultiSelect: true,
                        userslist: [],
                        isSession: false,
                        isScheduledSession: false,
                        isAdmin: true,
                        isConversationSession: false,
                        isSmartScan: true
                    }
                })
                .then(function(selectedItems) {
                    var userTeams = [];
                    angular.forEach(selectedItems, function(user) {
                        userTeams.push({
                            user_id: user.id,
                            object: vm.teamDataModel,
                            source: 'ADMIN',
                            assigned_on: new Date()
                        });
                    });
                    Experience.bulkTeams(userTeams, function(result) {
                        loadUsers();
                    });
                });
        };

        vm.togglerShowUsersFilter = function() {
            loadUsers();
        };

        //calls when filters are updated
        var updateUserListListener = $rootScope.$on('updateUserList', function(event) {
            if (vm.teamDataModel.type == 'SMART' && vm.showUsersUsingFilters) {
                loadUsers();
            }
        });

        // Unregister
        $scope.$on('$destroy', function() {
            updateUserListListener();
        });

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }
        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamDetailSaveDialogController', TeamDetailSaveDialogController);

    /* @ngInject */
    function TeamDetailSaveDialogController($scope, $state, $q, $filter, $window, $http, $location, Report, Team, poller, ParseLinks, AlertService, $mdDialog, $mdToast, $stateParams, team) {
        var vm = this;

        vm.loadingData = false;
        vm.teamModel = team;
        vm.jobStatus = 'idle';
        vm.jobResult = null;

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.saveClose = function() {
            $mdDialog.hide();
        };

        vm.saveTeam = function() {
            Team.update(vm.teamModel, onSaveSuccess);

            function onSaveSuccess(result) {
                Team.syncUsers({
                    id: vm.teamModel.id,
                }, onSyncSuccess, onSyncError);
            }

            function onSyncSuccess(result) {
                vm.jobResult = result;
                vm.getImportJobStatus();
            };

            function onSyncError() {
                AlertService.displayToast($mdToast);
            };
        }

        vm.getImportJobStatus = function() {
            // Get poller.
            var jobStreamStatusPoller = poller.get(Team, {
                action: 'getSyncUsersStatus',
                delay: 3000,
                argumentsArray: [{
                    id: vm.jobResult.id
                }],
                smart: true
            });

            jobStreamStatusPoller.promise.then(null, null, function(result) {
                vm.jobStream = result;
                vm.jobStreamId = vm.jobResult.id;
                if (result.status == 'COMPLETED') {
                    poller.stopAll();
                    vm.jobStatus = 'complete';
                }
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamDetailDialogController', TeamDetailDialogController);

    /* @ngInject */
    function TeamDetailDialogController($scope, $state, $mdDialog, $q, $filter, $mdToast, $timeout, Team, mode, team) {
        var vm = this;

        vm.teams = [];
        vm.mode = mode;
        vm.createNewTeam = "true";
        vm.addToExistingTeam = "false";

        vm.teamModel = {
            name: null,
            description: null,
            type: 'STATIC',
            status: 'DRAFT'
        };

        vm.statusCheck= '';
        vm.fileSizeErrorMsg = false;
        if (team != null) {
            vm.teamModel = angular.copy(team);
        };

        vm.toggleMode = function(createMode) {
            if (createMode == 'create') {
                vm.createNewTeam = 'true';
                vm.addToExistingTeam = 'false';
            } else {
                vm.createNewTeam = 'false';
                vm.addToExistingTeam = 'true';
            }
        };

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.getTeamProfileImageUrl = function() {
            return vm.teamModel.picture_id ? '/media/pictures/' + vm.teamModel.picture_id : 'assets/images/avatars/group-avatar.png';
        };

        vm.updateTeamProfileImage = function(mediaId, responseObj) {
            vm.teamModel.picture_id = mediaId;
        };

        vm.removeTeamProfileImage = function() {
            vm.teamModel.picture_id = undefined;
        };

        vm.submit = function() {
            if (mode == 'DYNAMIC' || mode == 'UPDATE') {
                $mdDialog.hide(vm.teamModel);
            } else {
                if (vm.createNewTeam == 'true') {
                    $mdDialog.hide(vm.teamModel);
                } else {
                    $mdDialog.hide(vm.selectedTeam);
                }
            }
        };

        vm.loadAll = function() {
            $q.all([
                Team.query().$promise,
            ]).then(function(data) {

                angular.forEach(data[0], function(team) {
                    if (team.type == 'STATIC' && team.audience_no != 1000) {
                        vm.teams.push(team);
                    }
                });
            });
        };

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer.team')
        .directive('fpTeamDetailBuilder', fpTeamDetailBuilder);

    function fpTeamDetailBuilder() {
        var directive = {
            scope: {
                teamModel: '='
            },
            bindToController: true,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'modules/team/team-detail-builder.tmpl.html',
            controller: TeamDetailBuilderDirectiveController
        };
        return directive;
    }

    /* @ngInject */
    function TeamDetailBuilderDirectiveController($rootScope, $scope, $q, ParseLinks, $mdSidenav, AlertService, $element, $filter, $mdDialog, MetaData, Setting, Team, FIELD_CONDITION_CONSTANT, DateUtils, $mdPanel, $timeout, triSettings, paginationConstants, ToastService) {
        var vm = this;

        vm.originalTeam = angular.copy(vm.teamModel);
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        vm.isMasterWorkspace = $rootScope.isMasterWorkspace;
        vm.matchSelected = false;
        vm.timezones = [];
        vm.languages = [];
        vm.metaFieldGroups = [];
        vm.selectedCondition = null;
        vm.showReset = false;

        vm.predicate = "id";
        vm.conditionListOptions = [];

        vm.getFieldLabel = function (condition) {
            var label = null;
            var fieldMeta;
            var fieldGroupMeta = $filter('filter')(vm.metaFieldGroups, {
                'name': condition.field_group_name
            })[0];
            //filter gets array of all fields which contain condition.field_name
            var fieldMetaArray = $filter('filter')(fieldGroupMeta.fields, {
                'name': condition.field_name
            });
            for (var cnt = 0; cnt < fieldMetaArray.length; cnt++) {
                if (fieldMetaArray[cnt].name === condition.field_name) {
                    fieldMeta = fieldMetaArray[cnt];
                    break;
                }
            }

            if (condition.data_type === "LIST" && condition.value) {
                var selectedListOption = $filter('filter')(fieldMeta.list_options, {
                    'option_id': condition.value
                })[0];
                vm.conditionListOptions = fieldMeta.list_options;
                condition.displayValue = selectedListOption.label;
            }
            if (condition.data_type === "LANGUAGE" && condition.value) {
                var selectedListOption = $filter('filter')(vm.languages, {
                    'name': condition.value
                })[0];
                vm.conditionListOptions = vm.languages;
                condition.displayValue = selectedListOption.description;
            }
            if (condition.data_type === "TIMEZONE" && condition.value) {
                var selectedListOption = $filter('filter')(vm.timezones, {
                    'timezone_no': condition.value
                })[0];
                vm.conditionListOptions = vm.timezones;
                condition.displayValue = selectedListOption.display_name;
            }
            if (condition.data_type === "OBJECT") {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type][condition.field_name], {
                    value: condition.operator
                }, true)[0];
                condition.displayValue = condition.value ? condition.value.name : '';
            }
            else if (condition.data_type === "BOOLEAN") {
                var operator;
                if (condition.value === null) {
                    operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                        defaultValue: ""
                    }, true)[0];
                } else {
                    operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                        defaultValue: condition.value.toString()
                    }, true)[0];
                }
            }
            else {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                    value: condition.operator
                }, true)[0];
            }

            if (condition.field_group_name == 'profile') {
                label = fieldMeta.label + ' ' + $filter('translate')(operator.label);
            } else {
                label = fieldGroupMeta.label + ':' + fieldMeta.label + ' ' + $filter('translate')(operator.label);
            }

            if (condition.value != null && condition.data_type !== "BOOLEAN") {
                label = label + ' ' + getFieldDisplayValue(condition);
            }
            return label;
        };

        vm.getConditionBackgroundColor = function (condition, conditionFocus) {
            if (vm.isMissingValue(condition)) {
                return vm.secondaryColor;
            }

            if (condition == vm.selectedCondition) {
                return vm.primaryColor;
            }
        };

        vm.isMissingValue = function (condition) {
            if (condition.data_type === "OBJECT") {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type][condition.field_name], {
                    value: condition.operator
                }, true)[0];
            } else {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                    value: condition.operator
                }, true)[0];
            }

            if (operator.showInput && (condition.value == null || condition.value.length <= 0)) {
                return true;
            } else {
                return false;
            }
        };

        vm.removeField = function (groupIndex, fieldIndex) {
            vm.teamModel.criteria.condition_groups[groupIndex].conditions.splice(fieldIndex, 1);
            if (vm.teamModel.criteria.condition_groups[groupIndex].conditions.length == 0) {
                vm.teamModel.criteria.condition_groups.splice(groupIndex, 1);
            }
            // firing an event downwards
            $scope.$emit('updateUserList');
            updateResetFilter();
        };

        vm.showMatchType = function (ev) {
            vm.matchSelected = true;

            var position = $mdPanel.newPanelPosition()
                .relativeTo('#match-type')
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);

            var config = {
                attachTo: angular.element(document.body),
                controller: "MatchSelectionPanelController",
                controllerAs: 'vm',
                templateUrl: 'core/components/filter/match-selection-panel.tmpl.html',
                position: position,
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function (panelRef, reason) {
                    vm.matchSelected = false;
                    if (panelRef.matchAll != vm.teamModel.criteria.match_all) {
                        vm.teamModel.criteria.match_all = panelRef.matchAll;
                        $scope.$emit('updateUserList');
                        updateResetFilter()
                    }
                }
            };
            $mdPanel.open(config);
        };

        vm.showFields = function (ev) {
            var position = $mdPanel.newPanelPosition()
                .relativeTo('#add-filter')
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);


            var config = {
                attachTo: angular.element(document.body),
                controller: "FieldSelectionPanelController",
                controllerAs: 'vm',
                templateUrl: 'core/components/filter/field-selection-panel.tmpl.html',
                position: position,
                locals: {
                    metaFieldGroups: vm.metaFieldGroups,
                    conditionGroups: vm.teamModel.criteria.condition_groups
                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function (panelRef, reason) {
                    if (panelRef.condition != null) {
                        $timeout(function () {
                            vm.showFieldSettting(panelRef.condition);
                        }, 200);
                    }
                    updateResetFilter();
                }
            };
            $mdPanel.open(config);
        };

        vm.showFieldSettting = function (condition) {
            vm.selectedCondition = condition;
            var position = $mdPanel.newPanelPosition()
                .relativeTo('#' + condition.field_group_name + '-' + condition.field_name)
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);

            if (condition.data_type === 'LANGUAGE') {
                vm.conditionListOptions = vm.languages;
            }
            else if (condition.data_type === 'TIMEZONE') {
                vm.conditionListOptions = vm.timezones
            } else {
                vm.conditionListOptions = [];
            }
            var config = {
                attachTo: angular.element(document.body),
                controller: "FieldSettingPanelController",
                controllerAs: 'vm',
                templateUrl: 'core/components/filter/field-setting-panel.tmpl.html',
                position: position,
                locals: {
                    metaFieldGroups: vm.metaFieldGroups,
                    condition: condition,
                    conditionListOptions: vm.conditionListOptions
                },
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function (panelRef, reason) {
                    vm.selectedCondition = null;
                    $scope.$emit('updateUserList');
                    updateResetFilter()
                }
            };

            $mdPanel.open(config);
        };

        vm.resetFilter = function () {
            vm.teamModel.criteria = vm.originalTeam.criteria;
            $scope.$emit('updateUserList');
            updateResetFilter();
        };

        function getFieldDisplayValue(condition) {
            if (!angular.isDefined(condition.value) || condition.value == null) {
                return null;
            } else {
                if (condition.data_type == 'DATE') {
                    if (condition.operator == 'EXACTLY') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'GREATER_THAN') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'GREATER_THAN_OR_EQUAL') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'LESS_THAN') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'LESS_THAN_OR_EQUAL') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'WITHIN') {
                        return condition.value + ' days';
                    } else if (condition.operator == 'BETWEEN') {
                        var fromDate = (angular.isDefined(condition.value.from_date) && condition.value.from_date != null ? $filter('date')(condition.value.from_date, "MM-dd-yyyy") : null);
                        var toDate = (angular.isDefined(condition.value.to_date) && condition.value.to_date != null ? $filter('date')(condition.value.to_date, "MM-dd-yyyy") : null);
                        return (fromDate == null ? '' : fromDate) + ' and ' + (toDate == null ? '' : toDate);
                    } else if (condition.operator == 'IS') {
                        if (condition.value == 'TODAY') {
                            return 'today';
                        } else if (condition.value == 'YESTERDAY') {
                            return 'yesterday';
                        } else if (condition.value == 'START_OF_WEEK') {
                            return 'start of the week';
                        } else if (condition.value == 'END_OF_WEEK') {
                            return 'end of the week';
                        } else if (condition.value == 'START_OF_MONTH') {
                            return 'start of the month';
                        } else if (condition.value == 'END_OF_MONTH') {
                            return 'end of the month';
                        } else {
                            return condition.value;
                        }
                    } else if (condition.operator == 'AFTER') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else if (condition.operator == 'BEFORE') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else if (condition.operator == 'ON') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else {
                        return condition.value;
                    }
                }
                else if (condition.data_type == 'LIST' || condition.data_type == 'LANGUAGE' || condition.data_type == 'TIMEZONE' || condition.data_type == 'OBJECT') {
                    return condition.displayValue;
                }
                else {
                    return condition.value;
                }
            }
        };

        function updateResetFilter() {
            if ($rootScope._.isEqual(angular.toJson(vm.originalTeam.criteria), angular.toJson(vm.teamModel.criteria))) {
                vm.showReset = false;
            } else {
                vm.showReset = true;
            }
        };

        function initTeam() {
            if (!angular.isDefined(vm.teamModel.criteria) || vm.teamModel.criteria == null) {
                vm.teamModel.criteria = {
                    match_all: true
                }
            }
        };

        function loadAll() {
            vm.loadingData = true;
            initTeam();
            $q.all([
                MetaData.get({
                    id: 'user',
                    is_name: true,
                    add_default_properties: true
                }).$promise,
                Setting.getSystemTimezones({
                    size: 100
                }).$promise,
                Setting.getSystemLanguages().$promise
            ]).then(function (data) {
                vm.metaFieldGroups = data[0].field_groups;
                vm.timezones = data[1];
                vm.languages = data[2];
                vm.loadingData = false;
            });
        };

        //calls when filters are updated
        var updateTeamListener = $rootScope.$on('updateTeam', function (event) {
            vm.originalTeam = vm.teamModel;
            updateResetFilter();
        });

        // Unregister
        $scope.$on('$destroy', function () {
            updateTeamListener();
        });

        loadAll();
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.team')
        .directive('fpTeamBuilder', fpTeamBuilder);

    function fpTeamBuilder() {
        var directive = {
            restrict: 'AE',
            templateUrl: 'modules/team/team-builder.tmpl.html',
            controller: TeamDBuilderDirectiveController
        };
        return directive;
    }

    /* @ngInject */
    function TeamDBuilderDirectiveController($rootScope, $scope, $q, ParseLinks, $mdSidenav, AlertService, $element, $filter, $mdDialog, MetaData, Setting, Team, FIELD_CONDITION_CONSTANT, DateUtils, $mdPanel, $timeout, triSettings, paginationConstants, ToastService) {

        $scope.primaryColor = triSettings.getSkinModel().primary_color_hex;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        $scope.isMasterWorkspace = $rootScope.isMasterWorkspace;
        $scope.matchSelected = false;

        $scope.timezones = [];
        $scope.languages = [];
        $scope.metaFieldGroups = [];
        $scope.teams = null;

        $scope.selectedTeam = null;
        $scope.teamDetail = null;
        $scope.hasNewTeam = false;

        $scope.selectedCondition = null;

        $scope.userHistoryPredicate = 'id';
        $scope.userHistoryReverse = 'asc';
        $scope.userHistoryPage = 1;
        $scope.userHistoryTotalItems = null;
        $scope.userHistory = [];
        $scope.isUserHistoryLoaded = false;
        $scope.userHistoryQueryCount = 0;
        $scope.userHistoryQueryLimit = paginationConstants.itemsPerPage;
        $scope.teamMemberCountHistory = null;
        $scope.predicate = "id";
        $scope.conditionListOptions = [];
        $scope.permissions = {
            manageTeam: 'manage-segment-user'
        };

        $scope.teamUserChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.teamInsights.members')
            },
            credits: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.teamInsights.noOfMembers')
                }
            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.teamInsights.date')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }

            },
            series: [{
                name: $filter('translate')('atheer.teamInsights.members'),
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> Members : ' + this.y;
                }
            }
        };

        function getDateFromItem(item) {
            return item.x;
        }
        function getSortOrder() {
            if ($scope.predicate.startsWith('-')) {
                return $scope.predicate.substr(1) + ',' + 'desc';
            } else {
                return $scope.predicate + ',' + 'asc';
            }

        }

        $scope.reOrder = function (order){
            $scope.predicate = order;
            $scope.userHistoryTransition();
        }
        $scope.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle()
                .then(function() {
                    if (componentId == 'historyPanel') {
                        $scope.isUserDataLoaded = false;
                        $scope.loadMemberHistory();
                    } else if (componentId == 'insightsPanel') {
                        $scope.isInsightsLoaded = false;
                        $scope.loadTeamInsights();
                    }
                });
        };

        $scope.loadMemberHistory = function() {
            $scope.userHistory = [];
            $scope.isUserHistoryLoaded = false;
            Team.getMemberHistory({
                id: $scope.teamDetail.id,
                page: 0,
                size: 10,
                query: null
            }, onUserHistorySuccess, onUserHistoryError);

            function onUserHistorySuccess(data, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.userHistoryTotalItems = headers('X-Total-Count');
                $scope.userHistoryQueryCount = $scope.userHistoryTotalItems;
                $scope.userHistoryPage = 1;
                $scope.userHistory = data;
                $scope.isUserHistoryLoaded = true;
            }

            function onUserHistoryError(error) {
                AlertService.error(error.data.message);
                $scope.isUserHistoryDataLoaded = true;
            }
        };

        $scope.userHistoryTransition = function(pageNo) {
            if(!pageNo) {
                pageNo = $scope.userHistoryPage;
            } else {
                $scope.userHistoryPage = pageNo;
            }

            $scope.promise = Team.getMemberHistory({
                id: $scope.teamDetail.id,
                page: pageNo - 1,
                size: $scope.userHistoryQueryLimit,
                sort: getSortOrder()
            }).$promise;

            $scope.promise.then(function(data, headers) {
                $scope.userHistoryQueryCount = $scope.userHistoryTotalItems;
                $scope.userHistory = data;
            });
        }

        $scope.loadTeamInsights = function() {
            $scope.isInsightsLoaded = false;

            Team.getMemberCountHistory({
                id: $scope.teamDetail.id,
                page: 0,
                size: 90,
                sort: 'id,desc',
                query: null
            }, onInsightsSuccess, onInsightsError);

            function onInsightsSuccess(result) {
                $scope.teamUserChartData.series[0].data = [];
                $scope.teamMemberCountHistory = result;
                angular.forEach(result, function(countHistory) {
                    $scope.teamUserChartData.series[0].data.push({
                        x: new Date(countHistory.record_date),
                        y: countHistory.member_count
                    })
                });
                $scope.teamUserChartData.series[0].data = $filter('orderBy')($scope.teamUserChartData.series[0].data, getDateFromItem);
                $scope.isInsightsLoaded = true;
            }

            function onInsightsError(error) {
                AlertService.error(error.data.message);
                $scope.isInsightsLoaded = true;
            }
        };

        $scope.refreshTeam = function() {
            if ($scope.hasNewTeam) {
                $scope.teams.pop();
                $scope.hasNewTeam = false;
            }
            initTeam($scope.selectedTeam);
        };

        $scope.showDelete = function(teamInfo) {
            if (teamInfo.audience_no != 1000 && teamInfo.id != null) {
                return true;
            } else {
                return false;
            }
        }

        $scope.showActions = function(teamInfo) {
            if (teamInfo.audience_no != 1000 && teamInfo.id != null) {
                return true;
            } else {
                return false;
            }
        }

        $scope.showReset = function(teamInfo) {
            if (teamInfo != null && teamInfo.type == 'SMART') {
                if (teamInfo.audience_no == 1000) {
                    return false;
                } else if (teamInfo.id == null) {
                    return true;
                } else if (teamInfo.picture_id != $scope.selectedTeam.picture_id) {
                    return false;
                } else if (teamInfo.use_conversation != $scope.selectedTeam.use_conversation) {
                    return false;
                } else if ($rootScope._.isEqual(angular.toJson(teamInfo), angular.toJson($scope.selectedTeam))) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }

        $scope.showSave = function(teamInfo) {
            if (teamInfo != null && angular.isDefined(teamInfo.criteria) && teamInfo.criteria != null) {
                angular.forEach(teamInfo.criteria.condition_groups, function(condition) {
                    angular.forEach(condition.conditions, function (selectedOption) {
                        if(selectedOption.displayValue) {
                            delete selectedOption.displayValue;
                        }
                    });
                });
            }
            if (teamInfo != null && teamInfo.type == 'SMART') {
                if (teamInfo.audience_no == 1000) {
                    return false;
                } else if (teamInfo.id == null && teamInfo.criteria.condition_groups.length > 0) {
                    return true;
                } else if (teamInfo.picture_id != $scope.selectedTeam.picture_id) {
                    return false;
                } else if (teamInfo.use_conversation != $scope.selectedTeam.use_conversation) {
                    return false;
                } else if ($rootScope._.isEqual(angular.toJson(teamInfo), angular.toJson($scope.selectedTeam))) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }

        $scope.resetFilter = function() {
            if ($scope.hasNewTeam) {
                $scope.teams.pop();
                $scope.hasNewTeam = false;
                angular.forEach($scope.teams, function(teamInfo) {
                    if (teamInfo.audience_no == 1000) {
                        initTeam(teamInfo);
                    }
                });
            } else {
                initTeam($scope.selectedTeam);
            };
        };

        $scope.isDefaultTeam = function(teamInfo) {
            if (teamInfo.audience_no == 1000) {
                return true;
            } else {
                return false;
            }
        };

        $scope.getFieldLabel = function(condition) {
            var label = null;
            var fieldMeta;
            var fieldGroupMeta = $filter('filter')($scope.metaFieldGroups, {
                'name': condition.field_group_name
            })[0];
            //filter gets array of all fields which contain condition.field_name
            var fieldMetaArray = $filter('filter')(fieldGroupMeta.fields, {
                'name': condition.field_name
            });
            for(var cnt = 0; cnt < fieldMetaArray.length; cnt++) {
                if(fieldMetaArray[cnt].name === condition.field_name) {
                    fieldMeta = fieldMetaArray[cnt];
                    break;
                }
            }

            if (condition.data_type === "LIST" && condition.value) {
                var selectedListOption = $filter('filter')(fieldMeta.list_options, {
                    'option_id': condition.value
                })[0];
                $scope.conditionListOptions = fieldMeta.list_options;
                condition.displayValue = selectedListOption.label;
            }
            if (condition.data_type === "LANGUAGE" && condition.value) {
                var selectedListOption = $filter('filter')($scope.languages, {
                    'name': condition.value
                })[0];
                $scope.conditionListOptions = $scope.languages;
                condition.displayValue = selectedListOption.description;
            }
            if (condition.data_type === "TIMEZONE" && condition.value) {
                var selectedListOption = $filter('filter')($scope.timezones, {
                    'timezone_no': condition.value
                })[0];
                $scope.conditionListOptions = $scope.timezones;
                condition.displayValue = selectedListOption.display_name;
            }
            if (condition.data_type === "OBJECT") {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type][condition.field_name], {
                    value: condition.operator
                }, true)[0];
                condition.displayValue = condition.value.name;
            }
            else if (condition.data_type === "BOOLEAN") {
                var operator;
                if(condition.value === null) {
                    operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                        defaultValue: ""
                    }, true)[0];
                }else {
                    operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                        defaultValue: condition.value.toString()
                    }, true)[0];
                }
            }
            else {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                    value: condition.operator
                }, true)[0];
            }

            if (condition.field_group_name == 'profile') {
                label = fieldMeta.label + ' ' + $filter('translate')(operator.label);
            } else {
                label = fieldGroupMeta.label + ':' + fieldMeta.label + ' ' + $filter('translate')(operator.label);
            }

            if (condition.value != null && condition.data_type !== "BOOLEAN") {
                label = label + ' ' + getFieldDisplayValue(condition);
            }
            return label;
        };

        $scope.getConditionBackgroundColor = function(condition, conditionFocus) {
            if ($scope.isMissingValue(condition)) {
                return $scope.secondaryColor;
            }

            if (condition == $scope.selectedCondition) {
                return $scope.primaryColor;
            }
        };

        $scope.isMissingValue = function(condition) {
            if(condition.data_type === "OBJECT") {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type][condition.field_name], {
                    value: condition.operator
                }, true)[0];
            } else {
                var operator = $filter('filter')(FIELD_CONDITION_CONSTANT[condition.data_type], {
                    value: condition.operator
                }, true)[0];
            }

            if (operator.showInput && (condition.value == null || condition.value.length <= 0)) {
                return true;
            } else {
                return false;
            }
        };

        $scope.removeField = function(groupIndex, fieldIndex) {
            $scope.teamDetail.criteria.condition_groups[groupIndex].conditions.splice(fieldIndex, 1);
            if ($scope.teamDetail.criteria.condition_groups[groupIndex].conditions.length == 0) {
                $scope.teamDetail.criteria.condition_groups.splice(groupIndex, 1);
            }
            // firing an event downwards
            $scope.$emit('updateUserList', $scope.teamDetail);
        };

        $scope.editTeam = function(team) {
            $mdDialog.show({
                templateUrl: 'modules/team/team-detail-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "TeamDetailDialogController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    mode: 'UPDATE',
                    team: angular.copy(team)
                }
            }).then(function(updatedTeam) {
                team.name = updatedTeam.name;
                team.description = updatedTeam.description;
                team.status = updatedTeam.status;
                team.use_conversation = updatedTeam.use_conversation;
                team.functional_team = updatedTeam.functional_team;
                team.picture_id = updatedTeam.picture_id;
                $scope.saveTeam(team);
            });
        };

        $scope.saveDynamicTeam = function(team) {
            if (team.id) {
                $scope.saveTeam(team);
            } else {
                $mdDialog.show({
                    templateUrl: 'modules/team/team-detail-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "TeamDetailDialogController",
                    controllerAs: "vm",
                    size: 'lg',
                    locals: {
                        mode: 'DYNAMIC',
                        team: team
                    }
                }).then(function(updatedTeam) {
                    team.name = updatedTeam.name;
                    team.description = updatedTeam.description;
                    team.status = updatedTeam.status;
                    team.use_conversation = updatedTeam.use_conversation;
                    team.functional_team = updatedTeam.functional_team;
                    team.picture_id = updatedTeam.picture_id;
                    $scope.saveTeam(team);
                });
            }
        };

        $scope.deleteTeam = function(team) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.teamBuilder.delete'))
                .ariaLabel($filter('translate')('atheer.teamBuilder.delete'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Team.delete({
                    id: team.id
                }, function() {
                    ToastService.displayToast(team.name + $filter('translate')('atheer.teamBuilder.deleted'), 3000);
                    loadAll();
                },function(error) {
                    var errorMessage;
                    if(error.data.description && error.data.description != '') {
                        errorMessage = error.data.description;
                    } else {
                        errorMessage = $filter('translate')('atheer.teamBuilder.errorDeletingTeam');
                    }
                    var errorWindow = $mdDialog.alert()
                        .title(errorMessage)
                        .ok('Close');
                    $mdDialog.show(errorWindow);
                });
            });
        };

        $scope.saveTeam = function(team) {
            if (team != null && angular.isDefined(team.criteria) && team.criteria != null) {
                angular.forEach(team.criteria.condition_groups, function(condition) {
                    angular.forEach(condition.conditions, function (selectedOption) {
                        if(selectedOption.displayValue) {
                            delete selectedOption.displayValue;
                        }
                    });
                });
            }
            if (team.id) {
                Team.update(team, onSaveSuccess, onSaveError);
            } else {
                Team.save(team, onSaveSuccess, onSaveError);
            }

            function onSaveSuccess(result) {
                resetTeams(result);
                ToastService.displayToast(result.name + $filter('translate')('atheer.teamBuilder.updated'), 3000);
            };

            function onSaveError() {

            };
        };

        $scope.showMatchType = function(ev) {
            if ($scope.teamDetail.audience_no != 1000) {
                $scope.matchSelected = true;

                var position = $mdPanel.newPanelPosition()
                    .relativeTo('#match-type')
                    .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);

                var config = {
                    attachTo: angular.element(document.body),
                    controller: "MatchSelectionPanelController",
                    controllerAs: 'vm',
                    templateUrl: 'core/components/filter/match-selection-panel.tmpl.html',
                    position: position,
                    openFrom: ev,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: false,
                    zIndex: 2,
                    onCloseSuccess: function(panelRef, reason) {
                        $scope.matchSelected = false;
                        if (panelRef.matchAll != $scope.teamDetail.criteria.match_all) {
                            $scope.teamDetail.criteria.match_all = panelRef.matchAll;
                            // firing an event downwards
                            $scope.$emit('updateUserList', $scope.teamDetail);
                        }
                    }
                };
                $mdPanel.open(config);
            }
        };

        $scope.showFields = function(ev) {
            if ($scope.teamDetail.audience_no == 1000) {
                var newDynamicTeam = {
                    audience_no: null,
                    name: 'Your New Team',
                    type: 'SMART',
                    status: 'DRAFT',
                    criteria: {
                        match_all: true,
                        condition_groups: []
                    }
                };
                $scope.selectedTeam = newDynamicTeam;
                $scope.teamDetail = newDynamicTeam;
                $scope.teams.push(newDynamicTeam);
                $scope.hasNewTeam = true;
            };

            var position = $mdPanel.newPanelPosition()
                .relativeTo('#add-filter')
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);


            var config = {
                attachTo: angular.element(document.body),
                controller: "FieldSelectionPanelController",
                controllerAs: 'vm',
                templateUrl: 'core/components/filter/field-selection-panel.tmpl.html',
                position: position,
                locals: {
                    metaFieldGroups: $scope.metaFieldGroups,
                    conditionGroups: $scope.teamDetail.criteria.condition_groups
                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function(panelRef, reason) {
                    if (panelRef.condition != null) {
                        $timeout(function() {
                            $scope.showFieldSettting(panelRef.condition);
                        }, 200);
                    }
                }
            };
            $mdPanel.open(config);
        };

        $scope.showFieldSettting = function(condition) {
            $scope.selectedCondition = condition;
            var position = $mdPanel.newPanelPosition()
                .relativeTo('#' + condition.field_group_name + '-' + condition.field_name)
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);

            if(condition.data_type === 'LANGUAGE') {
                $scope.conditionListOptions = $scope.languages;
            }
            else if(condition.data_type === 'TIMEZONE') {
                $scope.conditionListOptions = $scope.timezones
            } else {
                $scope.conditionListOptions = [];
            }
            var config = {
                attachTo: angular.element(document.body),
                controller: "FieldSettingPanelController",
                controllerAs: 'vm',
                templateUrl: 'core/components/filter/field-setting-panel.tmpl.html',
                position: position,
                locals: {
                    metaFieldGroups: $scope.metaFieldGroups,
                    condition: condition,
                    conditionListOptions: $scope.conditionListOptions
                },
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function(panelRef, reason) {
                    $scope.selectedCondition = null;
                    // firing an event downwards
                    $scope.$emit('updateUserList', $scope.teamDetail);
                }
            };

            $mdPanel.open(config);
        };

        $scope.getUserProfilePicture = function(pictureId) {
            return "/media/pictures/" + pictureId;
        }

        $scope.teamFilter = function (item) { 
            return item.audience_no != 1001; 
        };

        function getFieldDisplayValue(condition) {
            if (!angular.isDefined(condition.value) || condition.value == null) {
                return null;
            } else {
                if (condition.data_type == 'DATE') {
                    if (condition.operator == 'EXACTLY') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'GREATER_THAN') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'GREATER_THAN_OR_EQUAL') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'LESS_THAN') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'LESS_THAN_OR_EQUAL') {
                        return condition.value + ' days ago';
                    } else if (condition.operator == 'WITHIN') {
                        return condition.value + ' days';
                    } else if (condition.operator == 'BETWEEN') {
                        var fromDate = (angular.isDefined(condition.value.from_date) && condition.value.from_date != null ? $filter('date')(condition.value.from_date, "MM-dd-yyyy") : null);
                        var toDate = (angular.isDefined(condition.value.to_date) && condition.value.to_date != null ? $filter('date')(condition.value.to_date, "MM-dd-yyyy") : null);
                        return (fromDate == null ? '' : fromDate) + ' and ' + (toDate == null ? '' : toDate);
                    } else if (condition.operator == 'IS') {
                        if (condition.value == 'TODAY') {
                            return 'today';
                        } else if (condition.value == 'YESTERDAY') {
                            return 'yesterday';
                        } else if (condition.value == 'START_OF_WEEK') {
                            return 'start of the week';
                        } else if (condition.value == 'END_OF_WEEK') {
                            return 'end of the week';
                        } else if (condition.value == 'START_OF_MONTH') {
                            return 'start of the month';
                        } else if (condition.value == 'END_OF_MONTH') {
                            return 'end of the month';
                        } else {
                            return condition.value;
                        }
                    } else if (condition.operator == 'AFTER') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else if (condition.operator == 'BEFORE') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else if (condition.operator == 'ON') {
                        return $filter('date')(condition.value, "MM-dd-yyyy");
                    } else {
                        return condition.value;
                    }
                }
                else if (condition.data_type == 'LIST' || condition.data_type == 'LANGUAGE' || condition.data_type == 'TIMEZONE' || condition.data_type == 'OBJECT') {
                    return condition.displayValue;
                }
                else {
                    return condition.value;
                }
            }
        };

        function refreshTeams() {
            $q.all([
                Team.query({
                    size: 250,
                    sort: sortTeam()
                }).$promise,
            ]).then(function(data) {
                $scope.teams = data[0];

                if ($scope.hasNewTeam) {
                    $scope.teams.push($scope.teamDetail);
                } else {
                    angular.forEach($scope.teams, function(teamInfo) {
                        if (teamInfo.audience_no == $scope.teamDetail.audience_no) {
                            initTeam(teamInfo);
                        }
                    });
                }
            });
        };

        function sortTeam() {
            return ['name' + ',' + 'asc'];
        }

        function resetTeams(team) {
            $q.all([
                Team.query({
                    size: 250,
                    sort: sortTeam()
                }).$promise,
            ]).then(function(data) {
                $scope.teams = data[0];
                $scope.hasNewTeam = false;

                angular.forEach($scope.teams, function(teamInfo) {
                    if (teamInfo.audience_no == team.audience_no) {
                        initTeam(teamInfo);
                    }
                });
            });
        };

        function initTeam(teamInfo) {
            $scope.selectedTeam = teamInfo;
            $scope.teamDetail = angular.copy(teamInfo);

            if (!angular.isDefined($scope.teamDetail.criteria) || $scope.teamDetail.criteria == null) {
                $scope.teamDetail.criteria = {
                    match_all: true
                }
            }
            // firing an event downwards
            $scope.$emit('updateUserList', $scope.teamDetail);
            localStorage.setItem("team-list-selected-team", teamInfo.audience_no.toString());
        };

        function loadAll() {
            $scope.loadingData = true;
            $q.all([
                MetaData.get({
                    id: 'user',
                    is_name: true,
                    add_default_properties: true
                }).$promise,
                Setting.getSystemTimezones({
                    size: 100
                }).$promise,
                Setting.getSystemLanguages().$promise,
                Team.query({
                    size: 250,
                    sort: sortTeam()
                }).$promise,
            ]).then(function(data) {
                $scope.metaFieldGroups = data[0].field_groups;
                $scope.timezones = data[1];
                $scope.languages = data[2];
                $scope.teams = data[3];

                var selectedTeam = "1000";
                if (localStorage.getItem("team-list-selected-team") !== null) {
                    //to get permission from browser cache for returning user
                    selectedTeam = localStorage.getItem("team-list-selected-team");
                }

                for(var teamNo in $scope.teams){
                    if ($scope.teams[teamNo].audience_no.toString() == selectedTeam) {
                        initTeam($scope.teams[teamNo]);
                        break;
                    }
                };
                $scope.loadingData = false;
            });
        }

        // listen for the event in the relevant $scope
        $rootScope.$on('refreshTeams', function(event) {
            refreshTeams();
        });


        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.team')
        .controller('TeamAssignController', TeamAssignController);

    /* @ngInject */
    function TeamAssignController($scope, $state, $mdDialog, $q, $filter, $timeout, team, userId, teamsFilterList, Experience, User, Team, ToastService) {
        var vm = this;

        vm.asyncUsers = [];
        vm.asyncTeams = [];
        vm.fromProfilePage = userId != undefined;
        vm.team = team;
        vm.searchUser = searchUser;
        vm.teamsFilterList = teamsFilterList;

        vm.searchTeam = searchTeam;

        vm.transformChip = function(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
        }

        function getTeamQueryString(criteria) {
            var query;
            if ( vm.teamsFilterList ) {
                query = "audienceNo!=" + vm.teamsFilterList;
            }
            if (criteria.length > 0) {
                query += ';name=re=' + criteria;
            }
            return query;
        }

        function searchTeam(criteria) {
            var d = $q.defer();
            var result = Team.query({
                query: getTeamQueryString(criteria)
            }, function(result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function getQueryString(criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'text_search=ts=' + criteria;
            }
        }

        function searchUser(criteria) {
            var d = $q.defer();
            var result = User.query({
                query: getQueryString(criteria)
            }, function(result) {
                d.resolve(result);
            });
            return d.promise;
        }

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.submit = function() {
            if (!vm.fromProfilePage) {
                angular.forEach(vm.asyncUsers, function(user) {
                    Experience.assignTeam({
                        user_id: user.id,
                        object: vm.team,
                        source: 'ADMIN',
                        assigned_on: new Date()
                    }, function(result) {
                        ToastService.displayToast($filter('triTranslate')("assignTeam.membersAdded"), 3000);
                        $mdDialog.hide();
                    });
                });
            } else {
                angular.forEach(vm.asyncTeams, function(team) {
                    Experience.assignTeam({
                        user_id: userId,
                        object: team,
                        assigned_on: new Date()
                    }, function(result) {
                        ToastService.displayToast($filter('triTranslate')("assignTeam.teamAdded"), 3000);
                        $mdDialog.hide();
                    });
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.system-admin', {
                url: '/system',
                abstract: true,
                views: {
                    '@storm': {
                        templateUrl: 'modules/system/system.tmpl.html',
                        controller: 'SystemController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.setting.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                },
                resolve: {
                    workspaceId: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.admin-setting', {
                url: '/settings',
                abstract: true,
                views: {
                    '@storm': {
                        templateUrl: 'modules/system/settings.tmpl.html',
                        controller: 'SettingController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.setting.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.workspace-info', {
                url: '/workspace',
                controller: 'WorkspaceInfoSettingController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/workspace-info/workspace-info-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.workspaceInfo',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.skin', {
                url: '/skin',
                controller: 'SkinSettingController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/skin/skin-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.logoAndColor',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.dictionary', {
                url: '/label-dictionary',
                controller: 'LabelDictionaryController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/label-dictionary/label-dictionary.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.dictionary.mainTitle',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.notifications', {
                url: '/notifications?page&sort&search',
                templateUrl: 'modules/system/notification/notifications.html',
                controller: 'NotificationController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.setting.notifications',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                },

                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-notification-detail', {
                url: '/settings/notifications/:id',
                templateUrl: 'modules/system/notification/notification-detail.tmpl.html',
                controller: 'NotificationDetailController as vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            })
            .state('storm.admin-setting.email', {
                url: '/email-setup',
                controller: 'EmailSettingController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/email-setup/email-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.setup',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.user-signup', {
                url: '/user-signup',
                controller: 'UserSignupSettingController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/user-signup/user-signup-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.signup',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.session', {
                url: '/session',
                controller: 'SessionSettingController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/session/session-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.session',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.airform', {
                url: '/airform',
                controller: 'AirformSettingController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/airform/airform-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.airform',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.camera', {
                url: '/camera-setting',
                controller: 'CameraSettingController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/camera/camera-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.camera',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.features', {
                url: '/features',
                controller: 'SettingFeatureController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/feature/feature-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.features',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.homepageconfig', {
                url: '/lens-home-page-config',
                controller: 'LensHomePageConfigController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/lens-home-page-config/lens-home-page-config.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.homepageconfig',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.jobpdfconfig', {
                url: '/jobreport-config',
                controller: 'JobPDFSettingsController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/jobreport-config/jobpdf-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.pdfconfig',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.jobfileextconfig', {
                url: '/jobfileext-config',
                controller: 'FileExtSettingsController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/fileext-config/fileext-setting.tmpl.html',
                data: {
                    pageTitle: 'atheer.setting.fileExtConfig',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            })
            .state('storm.admin-setting.material-icons', {
                url: '/material-icons',
                controller: 'MaterialIconsController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/icons/material-icons.tmpl.html',
                resolve: {
                    icons: function ($http) {
                        return $http({
                            method: 'GET',
                            url: '/assets/samples/icons.json'
                        });
                    }
                }
            })
            .state('storm.admin-setting.fa-icons', {
                url: '/fa-icons',
                controller: 'FaIconsController',
                controllerAs: 'vm',
                templateUrl: 'modules/system/icons/fa-icons.tmpl.html',
                resolve: {
                    icons: function ($http) {
                        return $http({
                            method: 'GET',
                            url: '/assets/samples/fa.json'
                        });
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SystemController', SystemController);

    /* @ngInject */
    function SystemController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SystemMenuController', SystemMenuController);

    /* @ngInject */
    function SystemMenuController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.settings = [];
        vm.activeLink = $state.current.name;

        vm.settingsConfig = [{
            state: 'storm.system-admin.dashboard',
            icon: 'zmdi zmdi-chart',
            label: 'atheer.system.dashboard',
            adminOnly: false,
        }, {
            state: 'storm.system-admin.locales',
            icon: 'fa fa-globe',
            label: 'atheer.system.locales',
            adminOnly: false,
        }, {
            state: 'storm.system-admin.languages',
            icon: 'zmdi zmdi-globe-alt',
            label: 'atheer.system.languages',
            adminOnly: false,
        }, {
            state: 'storm.system-admin.timezones',
            icon: 'fa fa-clock-o',
            label: 'atheer.system.timezones',
            adminOnly: false,
        }];


        function loadAll() {
            vm.loadingData = false;

            angular.forEach(vm.settingsConfig, function(setting) {
                var featureActive = true;
                var hasPermission = true;

                if (angular.isDefined(setting.feature)) {
                    featureActive = Feature.isActive(setting.feature);
                };

                if (angular.isDefined(setting.permission)) {
                    hasPermission = PermissionService.hasAccess(setting.permission);
                };

                if (setting.adminOnly && Principal.isWorkspaceAdmin()) {
                    vm.settings.push(setting);
                } else if (!setting.adminOnly && featureActive && hasPermission) {
                    vm.settings.push(setting);
                };
            });
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SettingController', SettingController);

    /* @ngInject */
    function SettingController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow', [

        ]);
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-smartflows', {
                url: '/smartflows?page&sort&search',
                views: {
                    '@storm': {
                        templateUrl: 'modules/smartflow/smartflows.html',
                        controller: 'SmartFlowController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/smartflow/smartflow-toolbar.tmpl.html',
                        controller: 'SmartFlowToolbarController',
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/smartflow/smartflow-menu.tmpl.html',
                        controller: 'SmartFlowMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.smartFlow.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        sideNavMenuPosition: 'left',
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-smartflow-template', {
                url: '/smartflow/templates',
                templateUrl: 'modules/smartflow/smartflow-template.tmpl.html',
                // set the controller to load for this page
                controller: 'SmartFlowTemplatePageController',
                controllerAs: 'vm',
                // layout-column class added to make footer move to
                // bottom of the page on short pages
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            })
            .state('storm.admin-smartflow-detail', {
                url: '/smartflows/:id',
                templateUrl: 'modules/smartflow/smartflow-detail.tmpl.html',
                controller: 'SmartFlowDetailController',
                controllerAs: 'vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    viewType: 'build',
                    isCopy: function ($stateParams) {
                        return $stateParams.isCopy
                    },
                    isJobFlow: function ($stateParams) {
                        return $stateParams.isJobFlow;
                    }

                }
            })
            .state('storm.admin-jobflow-insights', {
                url: '/smartflows/:id/insights',
                templateUrl: 'modules/smartflow/jobflow-insights-overview.tmpl.html',
                controller: 'JobFlowInsightsOverviewController',
                controllerAs: 'vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    name: function ($stateParams) {
                        return $stateParams.name;
                    }
                },
                params: {
                    name: function ($stateParams) {
                        return $stateParams.name;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            })
            .state('storm.admin-smartflow-insights', {
                url: '/smartflows/:id/insights',
                templateUrl: 'modules/smartflow/smartflow-builder-insights.tmpl.html',
                controller: 'SmartFlowBuilderInsightsController',
                controllerAs: 'vm',
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                },
                abstract: true,
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            })
            .state('storm.admin-smartflow-insights.section', {
                url: '/:section',
                templateUrl: function ($stateParams) {
                    return 'modules/smartflow/smartflow-builder-insights-' + $stateParams.section + '.tmpl.html';
                },
                controllerProvider: function ($stateParams, $filter) {
                    return 'SmartFlowBuilderInsights' + $filter('capitalize')($stateParams.section) + 'Controller';
                },
                controllerAs: 'vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }]
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowController', SmartFlowController);

    /* @ngInject */
    function SmartFlowController($rootScope, $scope, $state, SmartFlow, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, $stateParams, $filter) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.transition = transition;
        vm.removeFilter = removeFilter;

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;
        vm.executeNow = executeNow;
        vm.copyObject = copyObject;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.descending;

        vm.updateSmartFlowListListener = null;

        vm.illustartionEmptyScreenId = "smart_flow";

        vm.permissions = {
            create: 'create-workflow',
            update: 'update-workflow',
            delete: 'delete-workflow',
            manage: 'manage-workflow'
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1,
            filters: {
                status: null,
                type: null
            },
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function loadAll() {
            vm.loadingData = true;
            SmartFlow.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.smartFlows = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function transition() {
            vm.loadingData = true;
            vm.promise = SmartFlow.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function (data, headers) {
                vm.queryCount = vm.totalItems;
                vm.smartFlows = data;
                vm.loadingData = false;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function createObject() {
            $state.go("storm.admin-smartflow-detail", {
                'id': '',
                'isCopy': false,
                'isJobFlow': true
            });
        }

        function editObject(objectId, isJobFlow) {
            $state.go('storm.admin-smartflow-detail', {
                'id': objectId,
                'isCopy': false,
                'isJobFlow': isJobFlow
            });
        }

        function copyObject(objectId, isJobFlow) {
            $state.go('storm.admin-smartflow-detail', {
                'id': objectId,
                'isCopy': true,
                'isJobFlow': isJobFlow
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.smartFlow.deleteSmartFlow'))
                .ariaLabel($filter('translate')('atheer.smartFlow.deleteSmartFlow'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                SmartFlow.delete({
                    id: entity.id
                }, function () {
                    resetModal();
                });
            });
        };

        function executeNow(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.smartFlow.executeSmartFlow'))
                .ariaLabel($filter('translate')('atheer.smartFlow.executeSmartFlow'))
                .ok($filter('translate')('atheer.smartFlow.executeNow'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                entity.type = 'EXECUTE';
                SmartFlow.update(entity, function () {
                    $state.go('storm.admin-smartflow-detail', {
                        'id': entity.id,
                        'isJobFlow': entity.newSmartFlow
                    });
                });
            });
        };

        function getQueryString() {
            var query = null;
            if (vm.query.filter !== '') {
                query = 'name=re=' + vm.query.filter;
            }
            if (vm.query.filters.status && vm.query.filters.status != 'ALL') {
                if(query) {
                    query = query + ';status==' + vm.query.filters.status;
                } else {
                    query = 'status==' + vm.query.filters.status;
                }

            } else {
                if(query) {
                    query = query + ';status=in=(DRAFT, LIVE, ENDED, PAUSED)';
                } else {
                    query = 'status=in=(DRAFT, LIVE, ENDED, PAUSED)';
                }

            }

            if (vm.query.filters.type && vm.query.filters.type != 'ALL') {
                query = query + ';type==' + vm.query.filters.type;
            }
            return query;
        }

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        var refreshSmartFlowListener = $rootScope.$on('refreshSmartFlows', function(event, filter) {
            vm.query.filter = filter;
            vm.loadAll();
        });

        var updateSmartFlowListListener = $rootScope.$on('updateSmartFlowList', function (event, filters) {
            vm.illustartionEmptyScreenId = "no_smart_flow";
            vm.query.filters = filters;
            vm.loadAll();
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSmartFlowListener();
            updateSmartFlowListListener();
        });

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowToolbarController', SmartFlowToolbarController);

    /* @ngInject */
    function SmartFlowToolbarController($rootScope, $scope, $state, $mdDialog, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.createObject = createObject;

        vm.permissions = {
            create: 'create-workflow',
            update: 'update-workflow',
            delete: 'delete-workflow',
            manage: 'manage-workflow'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        function refreshAll() {
            $scope.$emit('refreshSmartFlows', vm.query.filter);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            $scope.$emit('refreshSmartFlows', vm.query.filter);
        };

        function createObject() {
            $state.go("storm.admin-smartflow-detail", {
                'id': '',
                'isCopy': false,
                'isJobFlow': true
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowTemplatePageController', SmartFlowTemplatePageController)

    /* @ngInject */
    function SmartFlowTemplatePageController($scope, $state, $mdDialog, $mdSidenav, SmartFlow, SmartFlowBuilder, $element, WORFLOW_CELL_CONSTANT) {
        var vm = this;

        vm.smartFlowTemplates = SmartFlow.query();
        vm.smartFlowTemplateId = null;
        vm.smartFlowTemplate = null;
        vm.useSetting = true

        vm.goToSmartFlowDetail = function() {
            $state.go("storm.admin-smartflow-detail");
        }

        vm.useThisSmartFlow = function() {
            var newSmartFlow = angular.copy(vm.smartFlowTemplate);

            delete newSmartFlow['id'];
            newSmartFlow.status = 'DRAFT';

            if (!vm.useSetting) {
                var cellsArray = [];
                var canvas_data = JSON.parse(vm.smartFlowTemplate.canvas_data);

                angular.forEach(canvas_data.cells, function(cell) {
                    if (cell.setting) {
                        var setting = WORFLOW_CELL_CONSTANT[cell.setting.typeId].setting;
                        setting.type = cell.setting.type;
                        setting.typeId = cell.setting.typeId;
                        cell.setting = setting;
                    }
                    cellsArray.push(cell);
                });

                canvas_data.cells = cellsArray;
                newSmartFlow.canvas_data = angular.toJson(canvas_data);
                //newSmartFlow.canvas_data = JSON.stringify(canvas_data);
            }

            SmartFlow.save(newSmartFlow, function(result) {
                $state.go("storm.admin-smartflow-detail", {
                    'id': result.id
                });
                vm.useSetting = true;
                $mdDialog.hide();
            });
        }




        vm.previewSmartFlowTemplate = function(smartFlowTemplate) {
            vm.smartFlowTemplateId = smartFlowTemplate.id;
            vm.smartFlowTemplate = smartFlowTemplate;

            // firing an event downwards
            $scope.$broadcast('templateChange', smartFlowTemplate.canvas_data);
        }

        vm.openTemplateOptionDialog = function() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/smartflow/smartflow-template-options-dialog.tmpl.html',
                scope: $scope,
                backdrop: 'static',
                clickOutsideToClose: true,
                size: 'lg'
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowOptionsDialogController', SmartFlowOptionsDialogController);

    /* @ngInject */
    function SmartFlowOptionsDialogController($scope, $mdDialog, $state) {
        var vm = this;

        vm.launchSmartFlowTemplateSelector = launchSmartFlowTemplateSelector;
        vm.launchSmartFlowBuilder = launchSmartFlowBuilder;

        function launchSmartFlowTemplateSelector() {
            $state.go("storm.admin-smartflow-template");
            $mdDialog.hide();
        }

        function launchSmartFlowBuilder() {
            $state.go("storm.admin-smartflow-detail");
            $mdDialog.hide();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowMenuController', SmartFlowMenuController);

    /* @ngInject */
    function SmartFlowMenuController($scope, $state, $mdDialog, Content, Team, ParseLinks, AlertService, ContentAction, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, CONTENT_META, $translate, Feature) {
        var vm = this;

        vm.loadingData = true;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.filters = {
            type: 'ALL',
            status: 'ALL'
        };

        vm.updateFilters = function() {
            vm.filters.audience = vm.selectedTeam;
            $scope.$emit('updateSmartFlowList', vm.filters);
        }

        vm.loadAll = function() {
          vm.loadingData = false;
        }
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowDialogController', SmartFlowDialogController);

    /* @ngInject */
    function SmartFlowDialogController($scope, $stateParams, $mdDialog, entity, SmartFlow) {
        var vm = this;
        vm.smartFlow = entity;

        vm.isNew = function() {
            if (vm.smartFlow == undefined || vm.smartFlow.id == null) {
                return true;
            } else {
                return false;
            }
        }

        vm.load = function(id) {
            if (id) {
                SmartFlow.get({
                    id: id
                }, function(result) {
                    vm.smartFlow = result;
                });
            }
        };

        var onSaveSuccess = function(result) {
            $scope.$emit('smartFlowUpdate', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            vm.isSaving = true;
            if (vm.smartFlow.id !== null) {
                SmartFlow.update(vm.smartFlow, onSaveSuccess, onSaveError);
            } else {
                SmartFlow.save(vm.smartFlow, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $mdDialog.cancel();
        };
    }
})();
;
(function () {
    "use strict";
    angular
        .module("atheer.smartFlow")
        .controller("SmartFlowDetailController", SmartFlowDetailController);

    /* @ngInject */
    function SmartFlowDetailController(
        $mdDialog,
        $stateParams,
        $scope,
        $filter,
        $sce,
        $state,
        AlertService,
        $mdSidenav,
        SmartFlow,
        id,
        SmartFlowBuilder,
        WORFLOW_CELL_CONSTANT,
        ToastService
    ) {
        var vm = this;

        vm.viewType = $state.params.viewType;
        vm.dataLoaded = false;
        vm.gridSize = 10;
        vm.showAnalyticView = false;
        vm.useSetting = true;
        vm.isReadOnly = true;
        vm.isJobFlow = $state.params.isJobFlow;
        vm.scheduleConfig = {
            allowMultiple: false,
            options: {
                allowMinute: false,
                allowHour: false,
            },
            quartz: true,
        };

        vm.isUpdate = false;
        vm.isSmartflowSaved = true;
        vm.minDate = new Date();
        vm.tempSmartFlowName = "";

        if (id) {
            vm.viewType = $state.params.viewType;

            SmartFlow.get(
                {
                    id: id,
                },
                function (result) {
                    vm.smartFlowModel = result;
                    vm.dataLoaded = true;
                    vm.viewType = $state.params.viewType;

                    vm.isJobFlow = result.newSmartFlow;
                    if (result.canvas_data) {
                        var resultCanvasCells = JSON.parse(result.canvas_data);
                        for (
                            var cnt = 0;
                            cnt < resultCanvasCells.cells.length;
                            cnt++
                        ) {
                            if (
                                resultCanvasCells.cells[cnt].type ===
                                "smartflow.DataMapper" &&
                                resultCanvasCells.cells[cnt].setting
                                    .properties &&
                                resultCanvasCells.cells[cnt].setting.properties
                                    .mapping
                            ) {
                                SmartFlowBuilder.setDatamapperModel(
                                    Object.keys(
                                        resultCanvasCells.cells[cnt].setting
                                            .properties.mapping
                                    )
                                );
                                break;
                            }
                        }
                    }
                    if (result.category) {
                        SmartFlowBuilder.setSmartFlowCategory(result.category);
                    }

                    if (vm.smartFlowModel.status == "DRAFT") {
                        vm.isReadOnly = false;
                    }

                    if ($stateParams.isCopy) {
                        vm.copySmartFlow();
                        $stateParams.isCopy = false;
                    }

                    vm.tempSmartFlowName = vm.smartFlowModel.name;
                }
            );
        } else {
            vm.viewType = "settings";
            vm.dataLoaded = true;
            vm.smartFlowModel = {
                smart_flow_no: null,
                name: null,
                description: null,
                status: "DRAFT",
                type: "ON_GOING",
                schedule_info: null,
                newSmartFlow: vm.isJobFlow,
            };
        }

        vm.onSaveSuccess = function (result) {
            vm.smartFlowModel = result;
            if (vm.smartFlowModel.status == "DRAFT") {
                vm.isReadOnly = false;
            }
            vm.isSaving = false;
            var message;
            if (vm.isJobFlow) {
                message = vm.isUpdate
                    ? $filter('translate')('atheer.smartFlow.detail.jobFlowUpdateSuccess')
                    : $filter('translate')('atheer.smartFlow.detail.jobFlowCreateSuccess');
            } else {
                message = vm.isUpdate
                    ? $filter('translate')('atheer.smartFlow.detail.smartFlowUpdateSuccess')
                    : $filter('translate')('atheer.smartFlow.detail.smartFlowCreateSuccess');
            }

            ToastService.displayToast(message, 3000);

            SmartFlowBuilder.setSmartFlowStatus();
            SmartFlowBuilder.setSmartFlowData(result);
            vm.dataLoaded = true;
            vm.viewType = "build";
        };

        vm.onSaveCopiedSuccess = function (result) {
            vm.smartFlowModel = result;
            if (vm.smartFlowModel.status == "DRAFT") {
                vm.isReadOnly = false;
            }
            vm.isSaving = false;

            $state.go("storm.admin-smartflow-detail", {
                id: result.id,
                isCopy: false,
            });
            vm.dataLoaded = true;
            vm.viewType = "build";
        };

        vm.onSaveError = function (err) {
            var message;
            if(err) {
                message = err.data.description ? err.data.description : $filter('translate')('atheer.smartFlow.detail.jobFlowSaveFailed');
                vm.errorMessage = err.data.description;
            }

            ToastService.displayToast(message, 3000);

            document.getElementById('field_name').focus();
            vm.smartFlowModel.name = vm.tempSmartFlowName;

            vm.isSaving = false;
            vm.isCreating = false;
            vm.errorSaving = true;
        };

        vm.save = function (isFromCopy) {
            if (isFromCopy && vm.isJobFlow) {
                delete vm.smartFlowModel["worfklow_id"];
                delete vm.smartFlowModel["bpaid"];
            }

            if (vm.smartFlowModel.id) {
                vm.isUpdate = true;
                vm.setOrUpdateSmartFlowModelData();
                SmartFlow.update(
                    vm.smartFlowModel,
                    vm.onSaveSuccess,
                    vm.onSaveError
                );
            } else {
                vm.isUpdate = false;
                SmartFlow.save(
                    vm.smartFlowModel,
                    isFromCopy ? vm.onSaveCopiedSuccess : vm.onSaveSuccess,
                    vm.onSaveError
                );
            }
        };

        vm.onPublishSuccess = function (result) {
            vm.smartFlowModel = result;
            vm.isReadOnly = true;
            vm.isSaving = false;
            ToastService.displayToast($filter("triTranslate")("atheer.smartFlow.detail.smartFlowPublishSuccess"), 3000);
        };

        vm.onPublishError = function () {
            vm.isSaving = false;
        };

        vm.publish = function () {
            var valid = SmartFlowBuilder.validate(vm.smartFlowModel.category);
            if (valid) {
                var confirm = $mdDialog
                    .confirm()
                    .title($filter('translate')('atheer.smartFlow.detail.publishSmartFlow'))
                    .ariaLabel(
                        $filter('translate')('atheer.smartFlow.detail.publishSmartFlow')
                    )
                    .ok($filter('translate')('atheer.smartFlow.detail.publish'))
                    .cancel($filter('translate')('entity.action.cancel'));

                $mdDialog.show(confirm).then(function () {
                    vm.smartFlowModel.status = "LIVE";
                    vm.setOrUpdateSmartFlowModelData();
                    SmartFlow.update(
                        vm.smartFlowModel,
                        vm.onPublishSuccess,
                        vm.onPublishError
                    );
                });
            }
        };

        vm.onPauseSuccess = function (result) {
            vm.smartFlowModel = result;
            vm.isSaving = false;
            ToastService.displayToast($filter("triTranslate")("atheer.smartFlow.detail.smartFlowPauseSuccess"), 3000);
        };

        vm.onPauseError = function () {
            vm.isSaving = false;
        };

        vm.pause = function () {
            var confirm = $mdDialog
                .confirm()
                .title($filter('translate')('atheer.smartFlow.detail.pauseSmartFlow'))
                .ariaLabel($filter('translate')('atheer.smartFlow.detail.pauseSmartFlow'))
                .ok($filter('translate')('atheer.smartFlow.detail.pause'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.smartFlowModel.status = "PAUSED";
                vm.smartFlowModel.canvas_data = SmartFlowBuilder.getCanvasData();
                SmartFlow.update(
                    vm.smartFlowModel,
                    vm.onPauseSuccess,
                    vm.onPauseError
                );
            });
        };

        vm.onResumeSuccess = function (result) {
            vm.smartFlowModel = result;
            vm.isSaving = false;
            ToastService.displayToast($filter("triTranslate")('atheer.smartFlow.detail.smartFlowResumeSuccess'), 3000);
        };

        vm.onResumeError = function () {
            vm.isSaving = false;
        };

        vm.resume = function () {
            var confirm = $mdDialog
                .confirm()
                .title($filter('translate')('atheer.smartFlow.detail.resumeSmartFlow'))
                .ariaLabel($filter('translate')('atheer.smartFlow.detail.resumeSmartFlow'))
                .ok($filter('translate')('atheer.smartFlow.detail.resume'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.smartFlowModel.status = "LIVE";
                vm.smartFlowModel.canvas_data = SmartFlowBuilder.getCanvasData();
                SmartFlow.update(
                    vm.smartFlowModel,
                    vm.onResumeSuccess,
                    vm.onResumeError
                );
            });
        };

        vm.onEndSuccess = function (result) {
            vm.smartFlowModel = result;
            vm.isSaving = false;
            ToastService.displayToast($filter("triTranslate")("atheer.smartFlow.detail.smartFlowEndedSucess"), 3000);
        };

        vm.onEndError = function () {
            vm.isSaving = false;
        };

        vm.end = function () {
            var confirm = $mdDialog
                .confirm()
                .title($filter('translate')('atheer.smartFlow.detail.endedSmartFlow'))
                .ariaLabel($filter('translate')('atheer.smartFlow.detail.endedSmartFlow'))
                .ok($filter('translate')('atheer.smartFlow.detail.end'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.smartFlowModel.status = "ENDED";
                vm.smartFlowModel.canvas_data = SmartFlowBuilder.getCanvasData();
                SmartFlow.update(
                    vm.smartFlowModel,
                    vm.onEndSuccess,
                    vm.onEndError
                );
            });
        };

        vm.goToSmartFlows = function () {
            $state.go("storm.admin-smartflows");
        };

        vm.showJobInsightsView = function () {
            $state.go("storm.admin-jobflow-insights", {
                id: vm.smartFlowModel.id,
                name: vm.smartFlowModel.name,
            });
        };

        vm.isDraft = function () {
            if (vm.smartFlowModel.status == "DRAFT") {
                return true;
            } else {
                return false;
            }
        };

        vm.isPaused = function () {
            if (vm.smartFlowModel.status == "PAUSED") {
                return true;
            } else {
                return false;
            }
        };

        vm.isLive = function () {
            if (vm.smartFlowModel.status == "LIVE") {
                return true;
            } else {
                return false;
            }
        };

        vm.isEnded = function () {
            if (vm.smartFlowModel.status == "ENDED") {
                return true;
            } else {
                return false;
            }
        };

        vm.isNew = function () {
            if (
                vm.smartFlowModel == undefined ||
                vm.smartFlowModel.id == null
            ) {
                return true;
            } else {
                return false;
            }
        };

        vm.useThisSmartFlow = function () {
            delete vm.smartFlowModel["id"];
            vm.smartFlowModel.status = "DRAFT";
            vm.smartFlowModel.smart_flow_id = null;
            vm.smartFlowModel.smart_flow_no = null;

            vm.smartFlowModel.name = $filter('translate')('atheer.smartFlow.detail.copyOf') + vm.smartFlowModel.name;
            if (!vm.useSetting) {
                var cellsArray = [];
                var canvas_data = JSON.parse(vm.smartFlowModel.canvas_data);

                angular.forEach(canvas_data.cells, function (cell) {
                    if (cell.setting) {
                        var setting =
                            WORFLOW_CELL_CONSTANT[cell.setting.typeId].setting;
                        setting.type = cell.setting.type;
                        setting.typeId = cell.setting.typeId;
                        cell.setting = setting;
                    }
                    cellsArray.push(cell);
                });

                canvas_data.cells = cellsArray;
                vm.smartFlowModel.canvas_data = angular.toJson(canvas_data);
            }
            vm.save(true);
            $mdDialog.hide();
        };

        vm.copySmartFlow = function () {
            $mdDialog.show({
                animation: true,
                templateUrl:
                    "modules/smartflow/smartflow-template-options-dialog.tmpl.html",
                scope: $scope,
                backdrop: "static",
                clickOutsideToClose: !$stateParams.copy,
                size: "lg",
            });
        };

        vm.setGridSize = function () {
            SmartFlowBuilder.setGridSize(vm.gridSize);
        };

        vm.centerAndFit = function () {
            SmartFlowBuilder.centerAndFit();
        };

        vm.togglePanel = function (componentId) {
            $mdSidenav(componentId).toggle();
        };

        vm.showBuildView = function () {
            vm.viewType = "build";
        };

        vm.showSettingsView = function () {
            vm.isSmartflowSaved = SmartFlowBuilder.getSmartFlowStatus();

            if (vm.isSmartflowSaved) {
                var confirm = $mdDialog
                    .confirm()
                    .title(
                        $filter('translate')('atheer.smartFlow.detail.unsavedChanged')
                    )
                    .ariaLabel(
                        $filter('translate')('atheer.smartFlow.detail.unsavedChanged')
                    )
                    .ok($filter('translate')('entity.action.save'))
                    .cancel($filter('translate')('entity.action.cancel'));

                vm.viewType = "";

                $mdDialog.show(confirm).then(
                    function () {
                        vm.save();
                        vm.viewType = "settings";
                    },
                    function () {
                        SmartFlowBuilder.setSmartFlowStatus();
                        vm.viewType = "settings";
                    }
                );
            } else {
                vm.viewType = "settings";
            }
        };

        vm.changeType = function () {
            if (vm.smartFlowModel.type == "ONE_TIME") {
                vm.smartFlowModel.end_date = null;
                vm.smartFlowModel.allow_reentry = false;
                vm.smartFlowModel.schedule_info = null;
            } else if (vm.smartFlowModel.type == "ON_GOING") {
                vm.smartFlowModel.allow_reentry = false;
                vm.smartFlowModel.schedule_info = null;
            } else if (vm.smartFlowModel.type == "TIME_BASED") {
                vm.smartFlowModel.allow_reentry = true;
            } else if (vm.smartFlowModel.type === "JOB_EVENT") {
                vm.smartFlowModel.end_date = null;
                vm.smartFlowModel.allow_reentry = false;
                vm.smartFlowModel.schedule_info = null;
            }
        };

        vm.disableReEntry = function () {
            return (
                vm.smartFlowModel.status != "DRAFT" &&
                vm.smartFlowModel.status != "JOB_EVENT"
            );
        };

        vm.disableType = function () {
            return (
                vm.smartFlowModel.status != "DRAFT" &&
                vm.smartFlowModel.status != "JOB_EVENT"
            );
        };

        vm.disableStartDate = function () {
            return (
                vm.smartFlowModel.status != "DRAFT" &&
                vm.smartFlowModel.type == "ONE_TIME" &&
                vm.smartFlowModel.status != "JOB_EVENT"
            );
        };

        vm.disableEndDate = function () {
            return (
                vm.smartFlowModel.status != "DRAFT" &&
                vm.smartFlowModel.type == "ONE_TIME" &&
                vm.smartFlowModel.status != "JOB_EVENT"
            );
        };

        vm.addUsers = function () {
            $mdDialog.show({
                templateUrl: "modules/smartflow/smartflow-add-users.tmpl.html",
                clickOutsideToClose: true,
                controller: "SmartFlowAddUsersController",
                controllerAs: "vm",
                size: "lg",
                locals: {
                    smartFlow: vm.smartFlowModel,
                },
            });
        };

        vm.setOrUpdateSmartFlowModelData = function () {
            if (vm.isJobFlow) {
                var canvas_data = JSON.parse(SmartFlowBuilder.getCanvasData());
                vm.smartFlowModel.readerNodes = { cells: [] };
                angular.forEach(canvas_data.cells, function (cell) {
                    if (cell.smartFlowStencilType == "TRIGGER_READ") {
                        vm.smartFlowModel.readerNodes.cells.push(cell);
                    }
                });
                vm.smartFlowModel.readerNodes = angular.toJson(
                    vm.smartFlowModel.readerNodes
                );
                vm.smartFlowModel.canvas_data = angular.toJson(canvas_data);
            } else {
                vm.smartFlowModel.canvas_data = SmartFlowBuilder.getCanvasData();
                vm.smartFlowModel.trigger_info = SmartFlowBuilder.getTriggerInfo();
            }
        };

        vm.setFocusOnInput = function() {
            setTimeout(function() {
                document.getElementById('field_name').focus();
            }, 700);
        };

        $scope.$watch('vm.viewType', function(newValue) {
            if(newValue == 'settings') {
                vm.setFocusOnInput();
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .service('SmartFlowBuilder', SmartFlowBuilder);

    /* @ngInject */
    function SmartFlowBuilder($mdDialog, $filter, Feature, JobFlowBuilder, LocalResourceService, ToastService) {

        var paper;
        var graph;
        var paperScroller;
        var navigator;
        var stencil;
        var snapLines;
        var selection;
        var selectionView;
        var clipboard;
        var commandManager;
        var validator;
        var smartFlowDataModel;
        var smartFlowData;
        var isCellSelected = false;
        var typeId;
        var cellView;
        var halo = null;
        var inAction = false;
        var scheduler;
        var jobEnd;
        var jobFlowStencil;

        var hasTriggerCell = false;
        var triggerInfo = {
            trigger_type: null,
            audiences: null,
            user_field_condition: null
        };

        var audienceTrigger = new joint.shapes.atheer.TeamTrigger({
            position: {
                x: 100,
                y: 100
            }
        });

        var endSmartFlow = new joint.shapes.atheer.End({
            position: {
                x: 700,
                y: 100
            }
        });

        var gridSize = 10;
        var showSnaplines = true;
        var zoomLevel = 100;

        var isJobFlow;
        var isModified = false;
        var category = '';
        var datamapperDatamodel = [];

        var service = {
            init: init,
            initPreview: initPreview,
            initInsights: initInsights,
            loadCanvasData: loadCanvasData,
            getCanvasData: getCanvasData,
            getCellMetaData: getCellMetaData,
            getTriggerInfo: getTriggerInfo,
            setTriggerInfo: setTriggerInfo,
            setGridSize: setGridSize,
            centerAndFit: centerAndFit,
            showAnalyticView: showAnalyticView,
            undo: undo,
            redo: redo,
            destroy: destroy,
            validate: validate,
            getDataModelId: getDataModelId,
            getAirFormId: getAirFormId,
            getSmartFlowStatus: getSmartFlowStatus,
            setSmartFlowStatus: setSmartFlowStatus,
            setSmartFlowCategory: setSmartFlowCategory,
            getSmartFlowCategory: getSmartFlowCategory,
            setDatamapperModel: setDatamapperModel,
            getDatamapperModel: getDatamapperModel,
            getSmartFlowData: getSmartFlowData,
            setSmartFlowData: setSmartFlowData,
            getJobUpdateStatus: getJobUpdateStatus
        }
        return service;

        function init(element, canvasData, triggerData, type, isJob) {
            joint.dia.ElementView.prototype.getStrokeBBox = function () {
                return this.model.getBBox();
            };

            isJobFlow = isJob;

            if (isJobFlow) {
                LocalResourceService.get({ fileName: 'jobflow-builder.json' }, function (sections) {
                    jobFlowStencil = JobFlowBuilder.buildStencil(sections, type);
                    scheduler = new joint.shapes.smartflow.Start({
                        position: {
                            x: 100,
                            y: 100
                        }
                    });
                    jobEnd = new joint.shapes.smartflow.End({
                        position: {
                            x: 700,
                            y: 100
                        }
                    });
                    initSmartFlow(element, canvasData, triggerData, type);
                });
            } else {
                initSmartFlow(element, canvasData, triggerData, type);
            }
        }

        function initSmartFlow(element, canvasData, triggerData, type) {
            initPaper(element);
            initStencil(element, type);
            initNavigator(element);
            initInteraction(element);
            initClipBoard(element);
            initCommandManager(element);
            initValidator(element);
            initToolTips(element);

            //load graph data
            loadCanvasData(canvasData);
            setTriggerInfo(triggerData);
        }

        function initPreview(element, canvasData, isJob, type) {
            isJobFlow = isJob;
            if (isJobFlow) {
                LocalResourceService.get({ fileName: 'jobflow-builder.json' }, function (sections) {
                    jobFlowStencil = JobFlowBuilder.buildStencil(sections, type);
                    scheduler = new joint.shapes.smartflow.Start({
                        position: {
                            x: 100,
                            y: 100
                        }
                    });
                    jobEnd = new joint.shapes.smartflow.End({
                        position: {
                            x: 700,
                            y: 100
                        }
                    });
                    initSmartFlowPreview(element, canvasData);
                });
            } else {
                initSmartFlowPreview(element, canvasData);
            }
        }

        function initSmartFlowPreview(element, canvasData) {
            initPaper(element);
            initPreviewInteraction(element);
            initNavigator(element);

            //load Graph Data
            loadCanvasData(canvasData);
        }

        function initInsights(element) {
            initPaper(element);
            initNavigator(element);
        }

        function destroy() {
            paper = null;
            graph = null;
            paperScroller = null;
            navigator = null;
            stencil = null;
            snapLines = null;
            selection = null;
            selectionView = null;
            clipboard = null;
            commandManager = null;
            smartFlowDataModel = null;
            typeId = null;
            cellView = null;
        }

        function initPaper(element) {
            var CustomPaper = joint.dia.Paper.extend({
                events: function () {
                    return _.extend({}, joint.dia.Paper.prototype.events, {
                        'mouseenter .joint-cell': 'cellMouseenter',
                        'mouseleave .joint-cell': 'cellMouseleave'
                    });
                },
                cellMouseenter: function (evt) {
                    evt = joint.util.normalizeEvent(evt);
                    var view = this.findView(evt.target);
                    if (view) {
                        if (this.guard(evt, view)) return;
                        view.mouseenter(evt);
                    }
                },
                cellMouseleave: function (evt) {
                    evt = joint.util.normalizeEvent(evt);
                    var view = this.findView(evt.target);
                    if (view) {
                        if (this.guard(evt, view)) return;
                        view.mouseleave(evt);
                    }
                }
            });

            joint.dia.CellView.prototype.mouseenter = function (evt) {
                this.notify('cell:mouseenter', evt);
            };
            joint.dia.CellView.prototype.mouseleave = function (evt) {
                this.notify('cell:mouseleave', evt);
            };

            graph = new joint.dia.Graph;

            paper = new CustomPaper({
                width: $('.paper-container').width() - 25,
                height: $('.paper-container').height() - 25,
                gridSize: gridSize,
                drawGrid: true,
                model: graph,
                linkPinning: false
            });

            paperScroller = new joint.ui.PaperScroller({
                paper: paper,
                autoResizePaper: true,
                cursor: 'grab'
            });

            snapLines = new joint.ui.Snaplines({
                paper: paper
            });

            $('.paper-container', element).append(paperScroller.el);

            paperScroller.render().center();
        }

        // Create stencil.
        function initStencil(element, type) {

            var stencilShapes = {};
            var groups = {};
            var group_index = 1;

            var stencilType = isJobFlow ? jobFlowStencil : SmartFlowStencil;

            angular.forEach(stencilType.config.stencil.shapes,
                function (value, key) {
                    var shapesForGroup = $filter('filter')(value, function (shape) {
                        var isActiveStencil = true;
                        angular.forEach(shape.feature_permissions, function (permission) {
                            if (isActiveStencil) {
                                isActiveStencil = Feature.isActive(permission);
                            }
                        });
                        return isActiveStencil;
                    });

                    if (shapesForGroup.length != 0) {
                        stencilShapes[key] = shapesForGroup;
                        var groupMeta = stencilType.config.stencil.groups[key];
                        if (groupMeta) {
                            groupMeta.index = group_index;
                            groups[key] = groupMeta;
                        }
                    }
                });

            stencil = new joint.ui.Stencil({
                graph: graph,
                paper: paper,
                width: 240,
                snaplines: snapLines,
                dropAnimation: true,
                // Use default Grid Layout
                layout: {
                    columnWidth: 120,
                    columns: 2,
                    rowHeight: 90,
                    resizeToFit: false,
                    marginX: -10
                },
                dragEndClone: function (cell) {
                    return stencilType.getPaperCell(cell);
                },
                groups: groups
            });

            $('.stencil-container', element).append(stencil.render().el);

            if (type == 'ONE_TIME' || type == 'TIME_BASED') {
                //remove user profile field trigger
                var triggers = $filter('filter')(stencilShapes.triggers, {
                    type: '!atheer.UserFieldTrigger'
                });
                stencilShapes.triggers = triggers;
            }
            stencil.render().load(stencilShapes);
        }

        function initNavigator(element) {
            navigator = new joint.ui.Navigator({
                width: 250,
                height: 150,
                paperScroller: paperScroller,
                zoom: true,
                padding: 25,
                zoomOptions: {
                    max: 2,
                    min: 0.5
                }
            });

            $('.navigator-container').append(navigator.el);
            navigator.render();
        }


        function initPreviewInteraction(element) {
            selection = new Backbone.Collection;
            selectionView = new joint.ui.Selection({
                paper: paper,
                graph: graph,
                model: selection
            });

            paper.on('cell:mouseenter', function (cellView) {
                var cell = cellView.model;

                var shapeType = null;

                if (cell instanceof joint.shapes.atheer.Trigger) {
                    shapeType = 'trigger';
                } else if (cell instanceof joint.shapes.atheer.Activity) {
                    shapeType = 'activity';
                } else if (cell instanceof joint.shapes.atheer.Condition) {
                    shapeType = 'condition';
                } else if (cell instanceof joint.shapes.atheer.Flow) {
                    shapeType = 'flow';
                }

                if (cell.isElement()) {
                    if (!halo && !inAction) {
                        var slices = cell.get('slices');
                        var toolPosition2;

                        switch (shapeType) {
                            case 'trigger':
                                toolPosition2 = function (bbox) {
                                    return g.Ellipse.fromRect(bbox).intersectionWithLineFromCenterToPoint(bbox.topRight());
                                };
                                break;
                            case 'flow': // Pentagon
                                toolPosition2 = function (bbox) {
                                    return g.Line(bbox.topMiddle(), bbox.topMiddle().rotate(bbox.center(), -72)).midpoint();
                                };
                                break;
                            case 'condition': // Hexagon
                                toolPosition2 = function (bbox) {
                                    return g.Line(bbox.topRight(), bbox.topMiddle()).midpoint().offset(0, 10);
                                };
                                break;
                            case 'activity': //rectangle
                                toolPosition2 = function (bbox) {
                                    return bbox.topRight();
                                };
                                break;
                            default:
                                toolPosition2 = function (bbox) {
                                    return bbox.topRight();
                                };
                                break;
                        }

                        var tools = [{
                            color: 'grey',
                            position: toolPosition2,
                            action: function (model) {
                                showSettings(cellView, true);
                            }
                        }];

                        halo = joint.custom.Halo.open(cellView, {
                            previewMode: true,
                            tools: tools
                        }).on('linking:start', function () {
                            inAction = true;
                        }).on('linking:end', function () {
                            halo.remove();
                            halo = null;
                            inAction = false;
                        });
                        halo.$el.on('mouseleave', function (evt) {
                            if (evt.buttons === 0) {
                                halo.remove();
                                halo = null;
                            }
                        });
                    }
                }
            });

            paper.on('cell:mouseleave', function (cellView, evt) {
                if (cellView.model.isElement()) {
                    if (halo && !inAction && !$.contains(halo.el, evt.relatedTarget)) {
                        halo.remove();
                        halo = null;
                    }
                }
            });

            // Initiate selecting when the user grabs the blank area of the paper while the Shift key is pressed.
            // Otherwise, initiate paper pan.
            paper.on('blank:pointerdown', function (evt, x, y) {
                if (_.contains(KeyboardJS.activeKeys(), 'shift')) {
                    selectionView.startSelecting(evt, x, y);
                } else {
                    selectionView.cancelSelection();
                    paperScroller.startPanning(evt, x, y);
                }
            });

            paper.on('element:pointerdown', function (cellView, evt) {
                // Select an element if CTRL/Meta key is pressed while the element is clicked.
                if ((evt.ctrlKey || evt.metaKey)) {
                    selection.add(cellView.model);
                }
            });

            paper.on('element:pointerup', function (elementView, evt, x, y) {
                if (V(evt.target).hasClass('delete-icon')) {
                    elementView.model.remove();
                } else {
                    var cell = elementView.model;
                    var setting = cell.prop('setting');

                    if (!setting.isConfigured) {
                        if (!(cell instanceof joint.shapes.atheer.End
                            || (joint.shapes.smartflow.End && cell instanceof joint.shapes.smartflow.End))) {
                            showSettings(elementView, true);
                        }
                    }
                }
            });

            paper.on('cell:mouseover', function (cellView, evt) {
                // Select an element if CTRL/Meta key is pressed while the element is clicked.
                handleCellMouseOver(cellView);
            });

            paper.on('cell:mouseout', function (cellView, evt) {
                // Select an element if CTRL/Meta key is pressed while the element is clicked.
                handleCellMouseOut(cellView);
            });

            paper.on('cell:pointerup', function (cellView) {
                // We don't want a Halo for links.
                if (cellView.model instanceof joint.dia.Link) return;
            });


            selectionView.on('selection-box:pointerdown', function (cellView, evt) {
                // Unselect an element if the CTRL/Meta key is pressed while a selected element is clicked.
                if (evt.ctrlKey || evt.metaKey) {
                    selection.remove(cellView.model);
                }
            });

            KeyboardJS.on('delete, backspace', _.bind(function (evt) {
                if (!$.contains(evt.target, paper.el)) {
                    // remove selected elements from the paper only if the target is the paper
                    return;
                }

                commandManager.initBatchCommand();
                selection.invoke('remove');
                commandManager.storeBatchCommand();
                selectionView.cancelSelection();

                if (_.contains(KeyboardJS.activeKeys(), 'backspace') && !$(evt.target).is("input, textarea")) {
                    // Prevent Backspace from navigating back.
                    evt.preventDefault();
                }
            }));
        }

        function initInteraction(element) {
            selection = new Backbone.Collection;
            selectionView = new joint.ui.Selection({
                paper: paper,
                graph: graph,
                model: selection
            });

            paper.on('cell:mouseenter', function (cellView) {
                var cell = cellView.model;

                var shapeType = null;

                if (cell instanceof joint.shapes.atheer.Trigger) {
                    shapeType = 'trigger';
                } else if (cell instanceof joint.shapes.atheer.Activity) {
                    shapeType = 'activity';
                } else if (cell instanceof joint.shapes.atheer.Condition) {
                    shapeType = 'condition';
                } else if (cell instanceof joint.shapes.atheer.Flow) {
                    shapeType = 'flow';
                }

                if (cell.isElement()) {
                    if (!halo && !inAction) {
                        var slices = cell.get('slices');
                        var toolPosition1, toolPosition2;

                        switch (shapeType) {
                            case 'trigger':
                                toolPosition1 = function (bbox) {
                                    return g.Ellipse.fromRect(bbox).intersectionWithLineFromCenterToPoint(bbox.origin());
                                };
                                toolPosition2 = function (bbox) {
                                    return g.Ellipse.fromRect(bbox).intersectionWithLineFromCenterToPoint(bbox.topRight());
                                };
                                break;
                            case 'flow': // Pentagon
                                toolPosition1 = function (bbox) {
                                    return g.Line(bbox.topMiddle(), bbox.topMiddle().rotate(bbox.center(), 72)).midpoint();
                                };
                                toolPosition2 = function (bbox) {
                                    return g.Line(bbox.topMiddle(), bbox.topMiddle().rotate(bbox.center(), -72)).midpoint();
                                };
                                break;
                            case 'condition': // Hexagon
                                toolPosition1 = function (bbox) {
                                    return g.Line(bbox.origin(), bbox.topMiddle()).midpoint().offset(0, 10);
                                };
                                toolPosition2 = function (bbox) {
                                    return g.Line(bbox.topRight(), bbox.topMiddle()).midpoint().offset(0, 10);
                                };
                                break;
                            case 'activity': //rectangle
                                toolPosition1 = function (bbox) {
                                    return bbox.origin();
                                };
                                toolPosition2 = function (bbox) {
                                    return bbox.topRight();
                                };
                                break;
                            default:
                                toolPosition1 = function (bbox) {
                                    return bbox.origin();
                                };
                                toolPosition2 = function (bbox) {
                                    return bbox.topRight();
                                };
                                break;
                        }

                        var tools = [{
                            color: 'red',
                            position: toolPosition1,
                            action: function (model) {
                                model.remove({
                                    halo: this.cid
                                });
                            }
                        }, {
                            color: 'grey',
                            position: toolPosition2,
                            action: function (model) {
                                showSettings(cellView, false);
                            }
                        }];

                        if (cell instanceof joint.shapes.atheer.End ||
                            (joint.shapes.smartflow.End && cell instanceof joint.shapes.smartflow.End)
                            || (joint.shapes.smartflow.Trigger && cell instanceof joint.shapes.smartflow.Trigger && !(cell instanceof joint.shapes.smartflow.JobScope))
                            || (joint.shapes.smartflow.JobCreate && cell instanceof joint.shapes.smartflow.JobCreate)
                            || (joint.shapes.smartflow.JobUpdate && cell instanceof joint.shapes.smartflow.JobUpdate)) {
                            tools = [{
                                color: 'red',
                                position: toolPosition1,
                                action: function (model) {
                                    model.remove({
                                        halo: this.cid
                                    });
                                }
                            }];
                        }

                        halo = joint.custom.Halo.open(cellView, {
                            slices: _.map(slices, function (slice) {
                                var title = slice.title || '';
                                var color = slice.color || 'gray';
                                return _.defaults({
                                    link: createLink(color, title)
                                }, slice);
                            }),
                            tools: tools
                        }).on('linking:start', function () {
                            inAction = true;
                        }).on('linking:end', function () {
                            halo.remove();
                            halo = null;
                            inAction = false;
                        });
                        halo.$el.on('mouseleave', function (evt) {
                            if (evt.buttons === 0) {
                                halo.remove();
                                halo = null;
                            }
                        });
                    }
                }
            });

            paper.on('cell:mouseleave', function (cellView, evt) {
                if (cellView.model.isElement()) {
                    if (halo && !inAction && !$.contains(halo.el, evt.relatedTarget)) {
                        halo.remove();
                        halo = null;
                    }
                }
            });

            // Initiate selecting when the user grabs the blank area of the paper while the Shift key is pressed.
            // Otherwise, initiate paper pan.
            paper.on('blank:pointerdown', function (evt, x, y) {
                if (_.contains(KeyboardJS.activeKeys(), 'shift')) {
                    selectionView.startSelecting(evt, x, y);
                } else {
                    selectionView.cancelSelection();
                    paperScroller.startPanning(evt, x, y);
                }
            });

            paper.on('element:pointerdown', function (cellView, evt) {
                // Select an element if CTRL/Meta key is pressed while the element is clicked.
                if ((evt.ctrlKey || evt.metaKey)) {
                    selection.add(cellView.model);
                }
            });

            paper.on('element:pointerup', function (elementView, evt, x, y) {
                if (V(evt.target).hasClass('delete-icon')) {
                    elementView.model.remove();
                }
            });

            paper.on('cell:mouseover', function (cellView, evt) {
                // Select an element if CTRL/Meta key is pressed while the element is clicked.
                handleCellMouseOver(cellView);
            });

            paper.on('cell:mouseout', function (cellView, evt) {
                // Select an element if CTRL/Meta key is pressed while the element is clicked.
                handleCellMouseOut(cellView);
            });

            paper.on('cell:pointerup', function (cellView) {
                // We don't want a Halo for links.
                if (cellView.model instanceof joint.dia.Link) return;
            });

            graph.on('add', function (cell) {
                isModified = true;
                if (cell instanceof joint.dia.Element) {
                    shapeForPaper(cell);

                    if (cell instanceof joint.shapes.atheer.Trigger
                        || (joint.shapes.smartflow.Trigger && cell instanceof joint.shapes.smartflow.Trigger)) {
                        if (hasTriggerCell && cell.attributes.pageId !== "job-scope") {
                            ToastService.displayToast($filter('translate')('atheer.smartFlow.builder.trigger'), 3000);
                            cell.graph.removeCells([cell]);
                        } else {
                            hasTriggerCell = true;

                            if (cell instanceof joint.shapes.atheer.TeamTrigger) {
                                triggerInfo.trigger_type = 'AUDIENCE';
                            } else if (cell instanceof joint.shapes.atheer.UserFieldTrigger) {
                                triggerInfo.trigger_type = 'USER_FIELD';
                            }
                        }
                    } else if (cell.get('active') === false) {
                        ToastService.displayToast($filter('translate')('atheer.smartFlow.builder.comingSoon'), 3000);
                        cell.graph.removeCells([cell]);
                    }
                }
            });

            graph.on('remove', function (cell) {

                isModified = true;
                if (cell instanceof joint.shapes.atheer.Trigger
                    || (joint.shapes.smartflow.Trigger && cell instanceof joint.shapes.smartflow.Trigger)) {

                    hasTriggerCell = false;

                    if (cell instanceof joint.shapes.atheer.TeamTrigger) {
                        triggerInfo.trigger_type = null;
                        triggerInfo.audiences = null;
                    } else if (cell instanceof joint.shapes.atheer.UserFieldTrigger) {
                        triggerInfo.trigger_type = null;
                        triggerInfo.user_field_condition = null;
                    }
                }
            });

            //window.addEventListener('resize', function() {
            //    paperScroller.center();
            //});

            selectionView.on('selection-box:pointerdown', function (cellView, evt) {
                // Unselect an element if the CTRL/Meta key is pressed while a selected element is clicked.
                if (evt.ctrlKey || evt.metaKey) {
                    selection.remove(cellView.model);
                }
            });

            KeyboardJS.on('delete, backspace', _.bind(function (evt) {
                if (!$.contains(evt.target, paper.el)) {
                    // remove selected elements from the paper only if the target is the paper
                    return;
                }

                commandManager.initBatchCommand();
                selection.invoke('remove');
                commandManager.storeBatchCommand();
                selectionView.cancelSelection();

                if (_.contains(KeyboardJS.activeKeys(), 'backspace') && !$(evt.target).is("input, textarea")) {
                    // Prevent Backspace from navigating back.
                    evt.preventDefault();
                }
            }));
        }

        function initClipBoard(element) {
            clipboard = new joint.ui.Clipboard;

            KeyboardJS.on('ctrl + c', function () {
                // Copy all selected elements and their associated links.
                clipboard.copyElements(selection, graph, {
                    translate: {
                        dx: 20,
                        dy: 20
                    },
                    useLocalStorage: true
                });
            });

            KeyboardJS.on('ctrl + v', function () {
                selectionView.cancelSelection();
                clipboard.pasteCells(graph, {
                    link: {
                        z: -1
                    },
                    useLocalStorage: true
                });

                // Make sure pasted elements get selected immediately. This makes the UX better as
                // the user can immediately manipulate the pasted elements.
                clipboard.each(function (cell) {
                    if (cell.get('type') === 'link') return;
                    // Push to the selection not to the model from the clipboard but put the model into the graph.
                    // Note that they are different models. There is no views associated with the models
                    // in clipboard.
                    selection.add(graph.getCell(cell.id));
                });
            });

            KeyboardJS.on('ctrl + x', function () {
                var originalCells = clipboard.copyElements(selection, graph, {
                    useLocalStorage: true
                });
                commandManager.initBatchCommand();
                _.invoke(originalCells, 'remove');
                commandManager.storeBatchCommand();
                selectionView.cancelSelection();
            });
        }

        function initCommandManager(element) {
            commandManager = new joint.dia.CommandManager({
                graph: graph
            });

            KeyboardJS.on('ctrl + z', function () {
                commandManager.undo();
                selectionView.cancelSelection();
            });

            KeyboardJS.on('ctrl + y', function () {
                commandManager.redo();
                selectionView.cancelSelection();
            });
        }

        function initValidator(element) {
            validator = new joint.dia.Validator({
                commandManager: commandManager
            });

            validator.validate('change:source change:target remove',
                function (err, command, next) {
                    //if (command.data.type === 'basic.Rect') return next('Rectangles cannot be removed.');
                    //return next();
                },
                function (err, command, next) {
                    if (err) { }
                    return next(err);
                }
            );
        }

        function initToolTips(element) {
            new joint.ui.Tooltip({
                rootTarget: document.body,
                target: '[data-tooltip]',
                direction: 'auto',
                padding: 10
            });
        }

        function createLink(color, title) {
            return function () {
                return new joint.dia.Link({
                    router: {
                        name: 'manhattan'
                    },
                    attrs: {
                        '.connection': {
                            stroke: '#999',
                            'stroke-width': 2
                        },
                        '.marker-target': {
                            d: 'M 10 0 L 0 5 L 10 10 z',
                            fill: '#999',
                            stroke: '#999'
                        },
                        '.marker-source': {
                            d: V.convertCircleToPathData(V('circle', {
                                r: 7
                            })),
                            fill: color,
                            stroke: '#fff',
                            'stroke-width': 2
                        }
                    },
                    z: -1,
                    labels: [{
                        position: {
                            distance: 0.5,
                            offset: 20
                        },
                        attrs: {
                            text: {
                                text: title,
                                fill: '#999',
                                'font-family': 'sans-serif',
                                'font-size': 14,
                                'font-weight': 'bold'
                            }
                        }
                    }]
                });
            };
        };

        function loadCanvasData(canvasData) {
            hasTriggerCell = false;
            if (canvasData != null && canvasData.length > 0) {
                graph.fromJSON(JSON.parse(canvasData));
            } else {
                graph.clear();
                var firstCell = isJobFlow ? angular.copy(scheduler) : angular.copy(audienceTrigger);
                var lastCell = isJobFlow ? angular.copy(jobEnd) : angular.copy(endSmartFlow);
                graph.addCells([firstCell, lastCell]);
            }

            _.each(graph.getElements(), function (cell) {
                shapeForPaper(cell);

                if ((!isJobFlow && cell instanceof joint.shapes.atheer.Trigger) ||
                    (isJobFlow && cell instanceof joint.shapes.smartflow.Trigger)) {
                    hasTriggerCell = true;
                }
            });
        }

        function getCellMetaData() {
            var cellData = [];
            _.each(graph.getElements(), function (cell) {
                var cellInfo = {
                    id: cell.id,
                    title: cell.attr('text/text')
                }
                cellData.push(cellInfo);
            });
            return cellData;;
        }

        function getCanvasData() {
            return JSON.stringify(graph);
        }

        function getTriggerInfo() {
            return triggerInfo;
        }

        function setTriggerInfo(triggerData) {
            if (triggerData) {
                triggerInfo = triggerData;
            } else {
                triggerInfo = {
                    trigger_type: null,
                    audiences: null,
                    user_field_condition: null
                };
            }
        }

        function shapeForPaper(cell) {
            var setting = cell.prop("setting");
            setting.type = cell.prop("type");
            setting.typeId = cell.prop("typeId");
            cell.prop("setting", setting);

            //var size = cell.size();
            //cell.scale(125/size.width, 125/size.height, cell.getBBox().center());
            cell.resize(125, 125);
        }

        function handleCellMouseOver(cellView) {
            var cell = graph.getCell(cellView.model.id);
        }

        function handleCellMouseOut(cellView) {
            var cell = graph.getCell(cellView.model.id);
        }

        function showAnalyticView(analyticsView) {
            if (analyticsView) {
                _.each(graph.getElements(), function (cell) {
                    cell.attr({
                        '.analytics': {
                            display: ''
                        }
                    });
                    cell.resize(cell.attributes.analyticsSize.width, cell.attributes.analyticsSize.height);
                });
            } else {
                _.each(graph.getElements(), function (cell) {
                    cell.attr({
                        '.analytics': {
                            display: 'none'
                        }
                    });
                    cell.resize(cell.attributes.defaultSize.width, cell.attributes.defaultSize.height);
                });
            }
        }

        function showSettings(cellView, previewMode) {
            var cell = cellView.model;
            var pageId = cellView.model.attributes.pageId;
            var element = graph.getCell(cellView.model.id);
            var setting = element.prop("setting");

            var cellType = cellView.model.attributes.type;

            var templateUrl = isJobFlow ? 'modules/smartflow/jobflow-molecules-' + pageId + '.tmpl.html' :
                'modules/smartflow/smartflow-builder-setting-' + pageId + '.tmpl.html';

            var controller = isJobFlow ? getController(pageId) : 'SmartFlowBuilderSettingController';
            $mdDialog
                .show({
                    controller: controller,
                    controllerAs: 'vm',
                    templateUrl: templateUrl,
                    escapeToClose: true,
                    clickOutsideToClose: true,
                    locals: {
                        setting: setting,
                        pageId: pageId,
                        previewMode: previewMode,
                        cellType: cellType
                    }
                })
                .then(function (result) {
                    if (result.properties && result.properties.mapping && result.type === 'smartflow.DataMapper') {
                        datamapperDatamodel = Object.keys(result.properties.mapping);
                    }
                    cell.updateSetting(result);
                    if (cell instanceof joint.shapes.atheer.TeamTrigger) {
                        triggerInfo.trigger_type = 'AUDIENCE';
                        if (result.data) {
                            triggerInfo.audiences = result.data;
                        }
                    } else if (cell instanceof joint.shapes.atheer.UserFieldTrigger) {
                        triggerInfo.trigger_type = 'USER_FIELD';

                        if (result.criteria) {
                            triggerInfo.user_field_condition = angular.fromJson(result.criteria);
                        }
                    }
                });
        }

        function getController(pageId) {
            var controller;
            if (pageId == 'data-mapper') {
                controller = 'JobFlowMoleculesDataMapperController';
            } else if (pageId == 'airform-resolver') {
                controller = 'JobFlowMoleculesAirFormResolverController';
            } else if (pageId == 'audience-resolver') {
                controller = 'JobFlowMoleculesTeamResolverController';
            } else if (pageId == 'user-resolver') {
                controller = 'JobFlowMoleculesUserResolverController';
            } else if (pageId == 'resolver') {
                controller = 'JobFlowMoleculesResolverController';
            } else if (pageId == "job-scope") {
                controller = "JobFlowMoleculesJobScopeController";
            } else if (pageId == 'job-seed') {
                controller = 'JobFlowMoleculesJobSeedController';
            } else {
                controller = 'JobFlowMoleculesSettingController';
            }

            return controller;
        }

        function setGridSize(gridSize) {
            paper.setGridSize(gridSize);
        };

        function centerAndFit() {
            paperScroller.center();
        };

        function undo() {
            commandManager.undo();
        };

        function redo() {
            commandManager.redo();
        };

        function validate(type) {
            var validGraph = true;
            var hasActivityCell = false;
            var hasEndCell = false;
            var hasHandlerCell = false;
            var hasAiRFormResolver = false;
            var hasTeamResolver = false;
            var hasUserResolver = false;
            var hasJobCreateCell = false;
            var hasJobUpdateCell = false;
            var isJobEvent = type === 'JOB_EVENT' ? true : false;

            var flowType = isJobFlow ? $filter('translate')('atheer.smartFlow.builder.jobFlow') : $filter('translate')('atheer.smartFlow.builder.smartFlow');

            if (!hasTriggerCell) {
                validGraph = false;
                showValidationMessage( $filter('translate')('atheer.smartFlow.builder.addTrigger') + flowType + '.');
                return validGraph;
            }

            var allElements = graph.getElements();

            if (validGraph) {
                for (var i = 0; i < allElements.length; i++) {
                    if (joint.shapes.smartflow.JobUpdate && allElements[i] instanceof joint.shapes.smartflow.JobUpdate) {
                        hasJobUpdateCell = true;
                        validGraph = validateJobUpdate(allElements[i]);
                        break;
                    }
                }
            }
            _.each(allElements, function (cell) {
                if (validGraph) {
                    if (cell instanceof joint.shapes.atheer.Trigger || (joint.shapes.smartflow.Trigger && cell instanceof joint.shapes.smartflow.Trigger)) {
                        validGraph = validateTrigger(cell);
                    } else if (cell instanceof joint.shapes.atheer.Activity) {
                        validGraph = validateActivity(cell);
                        hasActivityCell = true;
                    } else if (cell instanceof joint.shapes.atheer.Condition) {
                        validGraph = validateCondition(cell);
                        hasActivityCell = true;
                    } else if (cell instanceof joint.shapes.atheer.Wait) {
                        validGraph = validateWait(cell);
                    } else if (cell instanceof joint.shapes.atheer.End || (joint.shapes.smartflow.End && cell instanceof joint.shapes.smartflow.End)) {
                        validGraph = validateEnd(cell);
                        hasEndCell = true;
                    } else if (!isJobEvent && (joint.shapes.smartflow.Handlers && cell instanceof joint.shapes.smartflow.Handlers)) {
                        validGraph = validateHandlers(cell);
                        hasHandlerCell = true;
                    } else if (joint.shapes.smartflow.Mappers && cell instanceof joint.shapes.smartflow.Mappers) {
                        validGraph = validateMappers(cell);
                    } else if ((joint.shapes.smartflow.AirFormResolver && cell instanceof joint.shapes.smartflow.AirFormResolver) && !hasJobUpdateCell) {
                        validGraph = validateResolver(cell);
                        hasAiRFormResolver = true;
                    } else if ((joint.shapes.smartflow.TeamResolver && cell instanceof joint.shapes.smartflow.TeamResolver) && !hasJobUpdateCell) {
                        validGraph = validateResolver(cell);
                        hasTeamResolver = true;
                    } else if ((joint.shapes.smartflow.UserResolver && cell instanceof joint.shapes.smartflow.UserResolver) && !hasJobUpdateCell) {
                        validGraph = validateResolver(cell);
                        hasUserResolver = true;
                    } else if ((joint.shapes.smartflow.JobCreate && cell instanceof joint.shapes.smartflow.JobCreate) && !hasJobUpdateCell) {
                        validGraph = validateJobCreate(cell);
                        hasJobCreateCell = true;
                    }
                } else {
                    return validGraph;
                }
            });

            if (validGraph && !hasActivityCell && !isJobFlow) {
                validGraph = false;
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.activity'));
                return validGraph;
            }

            if (validGraph && !hasEndCell) {
                validGraph = false;
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.endActivity') + flowType + '.');
                return validGraph;
            }

            if (validGraph && !hasHandlerCell && isJobFlow) {
                if (isJobEvent) {
                    return true;
                }

                validGraph = false;
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.handler'));
                return validGraph;
            }

            if (validGraph && !hasAiRFormResolver && isJobFlow && !hasJobUpdateCell) {
                validGraph = false;
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.airFormResolver'));
                return validGraph;
            }

            if (validGraph && !hasTeamResolver && !hasUserResolver && isJobFlow && !hasJobUpdateCell) {
                validGraph = false;
                showValidationMessage(
                    $filter('translate')('atheer.smartFlow.builder.resolver')
                );
                return validGraph;
            }

            if (validGraph && !hasJobCreateCell && isJobFlow && !hasJobUpdateCell) {
                validGraph = false;
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.jobCreate'));
                return validGraph;
            }

            return validGraph;
        }

        function validateTrigger(cell) {
            if (!cell.validate() && (cell instanceof joint.shapes.atheer.Trigger || cell instanceof joint.shapes.smartflow.Trigger) && !(cell instanceof joint.shapes.smartflow.Start)) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseConfigure') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.configure.trigger'));
                return false;
            }
            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });
            if (outboundLinks.length == 0) {
                var message = $filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.triggerWith') + ((isJobFlow) ? $filter('translate')('atheer.smartFlow.builder.dataHandler') : $filter('translate')('atheer.smartFlow.builder.configure.activity')) + '.'
                showValidationMessage(message);
                return false;
            }
            return true;
        }

        function validateActivity(cell) {
            if (!cell.validate()) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseConfigure') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.configure.trigger'));
                return false;
            }
            var inboundLinks = graph.getConnectedLinks(cell, {
                inbound: true
            });
            if (inboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.activityWithOther'));
                return false;
            }
            return true;
        }

        function validateCondition(cell) {
            if (!cell.validate()) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseConfigure') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.configure.condition'));
                return false;
            }

            var inboundLinks = graph.getConnectedLinks(cell, {
                inbound: true
            });
            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });

            if (inboundLinks.length == 0 || outboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.conditionWithOther'));
                return false;
            }
            return true;
        }

        function validateWait(cell) {
            if (!cell.validate()) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseConfigure') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.configure.activities'));
                return false;
            }

            var inboundLinks = graph.getConnectedLinks(cell, {
                inbound: true
            });
            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });

            if (inboundLinks.length == 0 || outboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.conditionWithOther'));
                return false;
            }
            return true;
        }

        function validateEnd(cell) {
            var inboundLinks = graph.getConnectedLinks(cell, {
                inbound: true
            });

            if (inboundLinks.length == 0) {
                if (isJobFlow) {
                    showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text') + '.');
                } else {
                    showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text') + $filter('translate')('atheer.smartFlow.builder.oneOfTheActivity'));
                }
                return false;
            }
            return true;
        }

        function validateHandlers(cell) {
            if (!cell.validate()) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseConfigure') + cell.attr('text/text'));
                return false;
            }

            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });

            if (outboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text'));
                return false;
            }

            return true;
        }

        function validateMappers(cell) {
            if (!cell.validate()) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseConfigure') + cell.attr('text/text'));
                return false;
            }

            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });

            if (outboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text'));
                return false;
            }

            return true;
        }

        function validateResolver(cell) {
            if (!cell.validate()) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseConfigure') + (cell.attr('text/text') == 'Resolver' ? '' : cell.attr('text/text')) + $filter('translate')('atheer.smartFlow.builder.configure.resolver'));
                return false;
            }

            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });

            if (outboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text'));
                return false;
            }

            return true;
        }

        function validateJobCreate(cell) {
            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });

            if (outboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text'));
                return false;
            }

            return true;
        }

        function validateJobUpdate(cell) {
            var outboundLinks = graph.getConnectedLinks(cell, {
                outbound: true
            });

            if (outboundLinks.length == 0) {
                showValidationMessage($filter('translate')('atheer.smartFlow.builder.pleaseLink') + cell.attr('text/text'));
                return false;
            }

            return true;
        }

        function showValidationMessage(message) {
            ToastService.displayToast(message, 3000);
        }

        function getDataModelId() {
            var canvas_data = JSON.parse(getCanvasData());
            var id;
            angular.forEach(canvas_data.cells, function (cell) {
                if (cell.type == 'smartflow.DataMapper') {
                    id = cell.setting.dataModel;
                }
            });

            return id;
        }

        function getAirFormId() {
            var canvas_data = JSON.parse(getCanvasData());
            var id;
            angular.forEach(canvas_data.cells, function (cell) {
                if (cell.type == "smartflow.AirFormResolver") {
                    id = cell.setting.properties.staticResult;
                }
            });

            return id;
        }

        function getJobUpdateStatus() {
            var canvas_data = JSON.parse(getCanvasData());
            var hasJobUpdate = false;

            angular.forEach(canvas_data.cells, function (cell) {
                if (cell.type == "smartflow.JobUpdate") {
                    hasJobUpdate = true;
                }
            });

            return hasJobUpdate;
        }

        function getSmartFlowStatus() {
            return isModified;
        }

        function setSmartFlowData(data) {
            smartFlowData = data;
        }

        function getSmartFlowData() {
            return smartFlowData;
        }

        function setSmartFlowStatus() {
            isModified = false;
        }

        function getSmartFlowCategory() {
            return category;
        }
        function setSmartFlowCategory(value) {
            category = value;
        }
        function getDatamapperModel() {
            return datamapperDatamodel;
        }
        function setDatamapperModel(value) {
            datamapperDatamodel = value;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .directive('smartFlowBuilder', smartFlowBuilderDirective);

    /* @ngInject */
    function smartFlowBuilderDirective() {
        var directive = {
            restrict: 'E',
            require: '^smartFlowBuilder',
            replace: true,
            templateUrl: 'modules/smartflow/smartflow-builder.tmpl.html',
            scope: {
                canvasData: '=',
                triggerData: '=',
                type: '=',
                isJobFlow: '='
            },
            controller: SmartFlowBuilderController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, element, attrs) {
                scope.init(element, attrs);
            }
        };
        return directive;
    }

    /* @ngInject */
    function SmartFlowBuilderController($scope, SmartFlow, $mdToast, AlertService, $state, $mdDialog, SmartFlowBuilder) {
        var vm = this;

        vm.undo = function () {
            SmartFlowBuilder.undo();
        };

        vm.redo = function () {
            SmartFlowBuilder.redo();
        };

        vm.centerAndFit = function () {
            SmartFlowBuilder.centerAndFit();
        };

        $scope.init = function (element, attrs) {
            SmartFlowBuilder.init(element, vm.canvasData, vm.triggerData, vm.type, vm.isJobFlow, vm.type);
        };
    }
})();
;
var SmartFlowStencil = SmartFlowStencil || {};
SmartFlowStencil.config = SmartFlowStencil.config || {};

(function() {

    'use strict';

    var svgns = "http://www.w3.org/2000/svg";

    SmartFlowStencil.config.stencil = {};

    SmartFlowStencil.config.stencil.groups = {
        triggers: {
            index: 1,
            label: 'Triggers'
        },
        activities: {
            index: 2,
            label: 'Activities'
        },
        decisions: {
            index: 3,
            label: 'Decisions'
        },
        flow: {
            index: 4,
            label: 'Flow Control'
        }
    };

    SmartFlowStencil.config.stencil.shapes = {};

    SmartFlowStencil.config.stencil.shapes.triggers = [{
        type: 'atheer.TeamTrigger'
    }];

    SmartFlowStencil.config.stencil.shapes.activities = [{
            type: 'atheer.ContentAssign'
        },
        {
            type: 'atheer.ContentRemove'
        },
        {
            type: 'atheer.ContentRecommend'
        },
        {
            type: 'atheer.AnnouncementAssign'
        },
        {
            type: 'atheer.EmailSend'
        },
        {
            type: 'atheer.PushNotificationSend'
        },
        {
            type: 'atheer.TeamAssign'
        },
        {
            type: 'atheer.TeamRemove'
        },
        {
            type: 'atheer.BadgeAssign'
        },
        {
            type: 'atheer.BadgeRemove'
        }
    ];

    SmartFlowStencil.config.stencil.shapes.decisions = [{
            type: 'atheer.ContentCheck'
        },
        {
            type: 'atheer.QuestionCheck'
        },
        {
            type: 'atheer.UserFieldCheck'
        },
        {
            type: 'atheer.TeamCheck'
        }
    ];

    SmartFlowStencil.config.stencil.shapes.flow = [{
            type: 'atheer.Wait'
        },
        {
            type: 'atheer.End'
        }
    ];

    SmartFlowStencil.getPaperCell = function(cell) {
        return cell.clone();
    }
})();
;
/******************************************************************************************/
/** For any change in default setting update smartflow-builder-cell-settings.constant.js **
/******************************************************************************************/
(function (joint) {

    'use strict';

    joint.shapes.atheer = joint.shapes.atheer || {};

    joint.shapes.atheer = joint.shapes.atheer || {};

    joint.shapes.smartflow = joint.shapes.smartflow || {};

    joint.shapes.atheer.Base = joint.shapes.basic.Generic.extend({
        markup: '<g class="rotatable"><g class="scalable"><image/></g><text/></g>',
        defaults: joint.util.deepSupplement({
            type: 'atheer.Base',
            size: {
                width: 50,
                height: 50
            },
            attrs: {
                image: {
                    width: 45,
                    height: 45
                },
                text: {
                    text: '',
                    'text-anchor': 'middle',
                    'ref-x': .5,
                    'ref-dy': 15,
                    'font-family': 'RobotoDraft, Roboto, Helvetica Neue, sans-serif',
                    'font-weight': 'Normal',
                    'font-size': 14,
                    display: '',
                    stroke: '#000',
                    'stroke-width': 0,
                    'fill': '#222138'
                }
            }
        }, joint.shapes.basic.Generic.prototype.defaults),
        updateSetting: function (setting) {
            //do nothing
        },
        validate: function () {
            //do nothing
        },
        updateTitle: function (title) {
            var wrapText = joint.util.breakText(title, {
                width: 100
            });
            var lines = wrapText.split(/\r\n|\r|\n/).length;
            this.attr('text', { text: wrapText, 'data-tooltip': title });
        }
    });

    joint.shapes.atheer.Trigger = joint.shapes.atheer.Base.extend({
        defaults: joint.util.deepSupplement({}, joint.shapes.atheer.Base.defaults)
    });

    joint.shapes.atheer.Activity = joint.shapes.atheer.Base.extend({
        defaults: joint.util.deepSupplement({}, joint.shapes.atheer.Base.defaults)
    });

    joint.shapes.atheer.Condition = joint.shapes.atheer.Base.extend({
        defaults: joint.util.deepSupplement({}, joint.shapes.atheer.Base.defaults)
    });

    joint.shapes.atheer.Flow = joint.shapes.atheer.Base.extend({
        defaults: joint.util.deepSupplement({}, joint.shapes.atheer.Base.defaults)
    });

    joint.shapes.atheer.TeamTrigger = joint.shapes.atheer.Trigger.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.TeamTrigger',
            typeId: 'audienceTrigger',
            pageId: 'audience-trigger',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/audience.svg'
                },
                text: {
                    text: 'Team'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                myTeam: false,
                data: [],
                title: undefined,
                objectType: 'Team'
            },
            slices: [{
                color: '#80C3D9'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Team');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.TeamAssign = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.TeamAssign',
            typeId: 'audienceAssign',
            pageId: 'audience-assign',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/assign-audience.svg'
                },
                text: {
                    text: 'Assign Team'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Team'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Assign',
                typeId: 'branch',
                value: 'onAssign'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Assign Team');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.TeamRemove = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.TeamRemove',
            typeId: 'audienceRemove',
            pageId: 'audience-remove',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/remove-audience.svg'
                },
                text: {
                    text: 'Remove Team'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Team'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Remove',
                typeId: 'branch',
                value: 'onRemove'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Remove Team');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.TeamCheck = joint.shapes.atheer.Condition.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.TeamCheck',
            typeId: 'audienceCheck',
            pageId: 'audience-check',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/audience-check.svg'
                },
                text: {
                    text: 'Team'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Team'
            },
            slices: [{
                color: '#80C3D9',
                title: 'YES',
                typeId: 'condition',
                value: 'yes'
            }, {
                color: '#96D186',
                title: 'NO',
                typeId: 'condition',
                value: 'no'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Team');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.data) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.UserFieldTrigger = joint.shapes.atheer.Trigger.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.UserFieldTrigger',
            typeId: 'userFieldTrigger',
            pageId: 'user-field-trigger',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/user-field-trigger.svg'
                },
                text: {
                    text: 'User Profile Field'
                }
            },
            active: true,
            setting: {
                isConfigured: false
            },
            slices: [{
                color: '#80C3D9'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            setting.isConfigured = true;

            //fix the json
            var criteria = angular.toJson(setting.criteria);
            setting.criteria = criteria;

            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
            } else {
                this.updateTitle('User Profile Field');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.criteria) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.UserFieldCheck = joint.shapes.atheer.Condition.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.UserFieldCheck',
            typeId: 'userFieldCheck',
            pageId: 'user-field-check',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/user-field-check.svg'
                },
                text: {
                    text: 'User Profile'
                }
            },
            active: true,
            setting: {
                isConfigured: false
            },
            slices: [{
                color: '#80C3D9',
                title: 'YES',
                typeId: 'condition',
                value: 'yes'
            }, {
                color: '#96D186',
                title: 'NO',
                typeId: 'condition',
                value: 'no'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            setting.isConfigured = true;

            //fix the json
            var criteria = angular.toJson(setting.criteria);
            setting.criteria = criteria;

            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
            } else {
                this.updateTitle('User Profile');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.criteria) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.AnnouncementAssign = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.AnnouncementAssign',
            typeId: 'announcementAssign',
            pageId: 'announcement-assign',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/announcement.svg'
                },
                text: {
                    text: 'Announcement'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                absoluteDate: moment().add(5, 'd').toDate(),
                relativeDate: {
                    period: 'days',
                    value: 5
                },
                isDueDateRelative: 1,
                data: [],
                title: undefined,
                objectType: 'Content'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Assign',
                typeId: 'branch',
                value: 'onAssign'
            }, {
                color: '#96D186',
                title: 'On Dismiss',
                typeId: 'branch',
                value: 'onCompletion'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Announcement');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            }
            if (setting.isDueDateRelative == 0) {
                if (!setting.absoluteDate) {
                    return false;
                }
            } else {
                if (setting.relativeDate.value == 0) {
                    return false;
                }
            }
            return true;
        },
    });

    joint.shapes.atheer.ContentAssign = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.ContentAssign',
            typeId: 'contentAssign',
            pageId: 'content-assign',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/assign.svg'
                },
                text: {
                    text: 'Assign'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                required: false,
                absoluteDate: moment().add(5, 'd').toDate(),
                relativeDate: {
                    period: 'days',
                    value: 5
                },
                isDueDateRelative: 1,
                data: [],
                title: undefined,
                note: null,
                objectType: 'Content'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Assign',
                typeId: 'branch',
                value: 'onAssign'
            }, {
                color: '#F4A787',
                title: 'On Completion',
                typeId: 'branch',
                value: 'onCompletion'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Assign Content');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            }
            if (setting.isDueDateRelative == 0) {
                if (!setting.absoluteDate) {
                    return false;
                }
            } else {
                if (setting.relativeDate.value == 0) {
                    return false;
                }
            }
            return true;
        },
    });

    joint.shapes.atheer.ContentRemove = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.ContentRemove',
            typeId: 'contentRemove',
            pageId: 'content-remove',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/remove-content.svg'
                },
                text: {
                    text: 'Remove Assignment'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Content'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Remove',
                typeId: 'branch',
                value: 'onRemove'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Remove Assignment');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.ContentRecommend = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.ContentRecommend',
            typeId: 'contentRecommend',
            pageId: 'content-recommend',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/recommend.svg'
                },
                text: {
                    text: 'Recommend'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                note: null,
                objectType: 'Content'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Recommmend',
                typeId: 'branch',
                value: 'onRecommend'
            }, {
                color: '#96D186',
                title: 'On View',
                typeId: 'branch',
                value: 'onView'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Recommmend Content');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.ContentCheck = joint.shapes.atheer.Condition.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.ContentCheck',
            typeId: 'contentCheck',
            pageId: 'content-check',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/assignment-check.svg'
                },
                text: {
                    text: 'Assignment'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Content',
                status: 'COMPLETED'
            },
            slices: [{
                color: '#80C3D9',
                title: 'YES',
                typeId: 'condition',
                value: 'yes'
            }, {
                color: '#96D186',
                title: 'NO',
                typeId: 'condition',
                value: 'no'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                var title = title;
                if (setting.status == 'ASSIGNED') {
                    title = title + ' Is ' + 'Assigned';
                } else if (setting.status == 'IN_PROGRESS') {
                    title = title + ' Is ' + 'In Progress';
                } else if (setting.status == 'COMPLETED') {
                    title = title + ' Is ' + 'Completed';
                }
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Assignment');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.data) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.QuestionCheck = joint.shapes.atheer.Condition.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.QuestionCheck',
            typeId: 'questionCheck',
            pageId: 'question-check',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/question-check.svg'
                },
                text: {
                    text: 'Answer'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                status: 'COMPLETED',
                pass: true,
                objectType: 'Content'
            },
            slices: [{
                color: '#80C3D9',
                title: 'TRUE',
                typeId: 'condition',
                value: 'yes'
            }, {
                color: '#96D186',
                title: 'FALSE',
                typeId: 'condition',
                value: 'no'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                if (setting.status == 'ASSIGNED') {
                    title = title + ' Is ' + 'Assigned';
                } else if (setting.status == 'IN_PROGRESS') {
                    title = title + ' Is ' + 'In Progress';
                } else if (setting.status == 'COMPLETED') {
                    if (setting.pass) {
                        title = title + ' Is ' + 'Correct';
                    } else {
                        title = title + ' Is ' + 'Incorrect';
                    }
                }
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Answer');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.BadgeAssign = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.BadgeAssign',
            typeId: 'badgeAssign',
            pageId: 'badge-assign',
            attrs: {
                image: {
                    width: 45,
                    height: 45,
                    'xlink:href': 'assets/images/smartflow/assign-badge.svg'
                },
                text: {
                    text: 'Assign Badge'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Badge'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Assign',
                typeId: 'branch',
                value: 'onAssign'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Assign Badge');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.BadgeRemove = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.BadgeRemove',
            typeId: 'badgeRemove',
            pageId: 'badge-remove',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/remove-badge.svg'
                },
                text: {
                    text: 'Remove Badge'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Badge'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Remove',
                typeId: 'branch',
                value: 'onRemove'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Remove Badge');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.SecurityRoleAssign = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.SecurityRoleAssign',
            typeId: 'securityRoleAssign',
            pageId: 'securityrole-assign',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/assign-securityrole.svg'
                },
                text: {
                    text: 'Assign Sec. Role'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'SecurityRole'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Assign',
                typeId: 'branch',
                value: 'onAssign'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Assign Security Role');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.data.length == 0) {
                return false;
            }
            else {
                return true;
            }
        },
    });

    joint.shapes.atheer.SecurityRoleRemove = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.SecurityRoleRemove',
            typeId: 'securityRoleRemove',
            pageId: 'securityrole-remove',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/remove-securityrole.svg'
                },
                text: {
                    text: 'Remove Sec. Role'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'SecurityRole'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Remove',
                typeId: 'branch',
                value: 'onRemove'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Remove Security Role');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.data.length == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.EmailSend = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.EmailSend',
            typeId: 'emailSend',
            pageId: 'email-send',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/email.svg'
                },
                text: {
                    text: 'Newsletter'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                data: [],
                title: undefined,
                objectType: 'Content'
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Send',
                typeId: 'branch',
                value: 'onSend'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('E-Mail/Newsletter');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.data) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.SlackMessageSend = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.SlackMessageSend',
            typeId: 'slackMessageSend',
            pageId: 'slack-message-send',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/slack-message.svg'
                },
                text: {
                    text: 'Slack Message'
                }
            },
            active: false,
            setting: {
                isConfigured: false,
                title: null,
                message: null
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Send',
                typeId: 'branch',
                value: 'onSend'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Slack Message');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.message) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.PushNotificationSend = joint.shapes.atheer.Activity.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.PushNotificationSend',
            typeId: 'pushNotificationSend',
            pageId: 'push-notification-send',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/push-notification.svg'
                },
                text: {
                    text: 'Push Notification'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                title: null,
                message: null
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Send',
                typeId: 'branch',
                value: 'onSend'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var title = this.prop('setting/title');
            if (title) {
                this.updateTitle(title);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Push Notification');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (!setting.message) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.Wait = joint.shapes.atheer.Flow.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.Wait',
            typeId: 'wait',
            pageId: 'wait',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/wait.svg'
                },
                text: {
                    text: 'Wait'
                }
            },
            active: true,
            setting: {
                isConfigured: false,
                period: 'hrs',
                value: 0
            },
            slices: [{
                color: '#80C3D9',
                title: 'On Wait',
                typeId: 'branch',
                value: 'onWait'
            }]
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            this.prop('setting', setting);
            var value = this.prop('setting/value');
            var period = this.prop('setting/period');
            if (value != 0) {
                this.updateTitle(value + ' ' + period);
                setting.isConfigured = true;
            } else {
                this.updateTitle('Wait');
            }
        },
        validate: function () {
            var setting = this.prop('setting');
            if (setting.value == 0) {
                return false;
            } else {
                return true;
            }
        },
    });

    joint.shapes.atheer.End = joint.shapes.atheer.Flow.extend({
        defaults: joint.util.deepSupplement({
            type: 'atheer.End',
            typeId: 'end',
            pageId: 'end',
            attrs: {
                image: {
                    'xlink:href': 'assets/images/smartflow/end.svg'
                },
                text: {
                    text: 'End'
                }
            },
            setting: {
                isConfigured: false
            },
            active: true
        }, joint.shapes.atheer.Base.prototype.defaults),
        updateSetting: function (setting) {
            //do nothing
        },
        validate: function () {
            return true;
        },
    });
})(joint);
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowBuilderSettingController', SmartFlowBuilderSettingController)

    /* @ngInject */
    function SmartFlowBuilderSettingController($scope, $injector, $state, $element, $filter, $q, Setting, $mdDialog, MetaData, CONTENT_META, FIELD_CONDITION_CONSTANT, setting, pageId, previewMode, ToastService) {
        var vm = this;
        vm.loadingData = true;
        vm.previewMode = previewMode;

        function init() {
            vm.receivedSetting = angular.copy(setting);
            vm.setting = angular.copy(setting);

            if (vm.setting.objectType) {
                var service = $injector.get(vm.setting.objectType);
                if (vm.setting.data instanceof Array) {
                    if (vm.setting.data.length > 0) {
                        service.query({
                            'query': 'id=in=(' + vm.setting.data + ')'
                        }, function(result) {
                            vm.loadingData = false;
                            vm.setting.data = result;
                        }, function(result) {
                            vm.loadingData = false
                        });
                    } else {
                        vm.loadingData = false;
                    }
                } else {
                    service.query({
                        'query': 'id=eq=(' + vm.setting.data + ')'
                    }, function(result) {
                        vm.loadingData = false;
                        vm.setting.data = result;
                    }, function(result) {
                        vm.loadingData = false;
                    });
                }
            } else {
                vm.loadingData = false;
            }
        }

        init();

        vm.criteriaIsValid = true;

        if (pageId == 'user-field-trigger' || pageId == 'user-field-check') {
            if (vm.setting.criteria) {
                var criteria = angular.fromJson(vm.setting.criteria);
                vm.setting.criteria = criteria;
            }
            vm.dataIsLoaded = false;
            vm.timezones = [];
            vm.languages = [];

            vm.field_groups = [];

            vm.tmp_criteria = angular.copy(vm.setting.criteria);

            vm.initFieldDropDownSearch = function() {
                $element.find('input[type="search"]').on('keydown', function(ev) {
                    ev.stopPropagation();
                });
            }

            vm.conditionChange = function() {
                var default_field = {
                    "field_group_name": vm.tmp_field.field_group_name,
                    "field_name": vm.tmp_field.field_name,
                    "data_type": vm.tmp_field.data_type,
                    "operator": vm.tmp_field.data_type == "BOOLEAN" ? "EQUAL" : null,
                    "value": null,
                };

                if (vm.setting.criteria) {
                    if (default_field.field_group_name != vm.setting.criteria.field_group_name || default_field.field_name != vm.setting.criteria.field_name) {
                        vm.setting.criteria = default_field;
                    }
                } else {
                    vm.setting.criteria = default_field;
                }
            }

            vm.setTitle = function() {
                var fieldGroupMeta = $filter('filter')(vm.field_groups, {
                    'name': vm.setting.criteria.field_group_name
                })[0];

                var fieldMeta = $filter('filter')(fieldGroupMeta.fields, {
                    'name': vm.setting.criteria.field_name
                })[0];

                var returnStr = '';

                if (fieldGroupMeta && fieldMeta) {
                    returnStr += fieldMeta.label + ' ';

                    if (vm.setting.criteria.data_type == 'BOOLEAN') {
                        if (vm.setting.criteria.value) {
                            returnStr += 'Is True';
                        } else {
                            returnStr += 'Is False';
                        }
                    } else {
                        var fieldOperators = vm.getFieldOperators(vm.setting.criteria.field_group_name, vm.setting.criteria.field_name);
                        var operator = $filter('filter')(fieldOperators, {
                            'value': vm.setting.criteria.operator
                        })[0]
                        if (operator) {
                            if (operator.value == 'IS' && vm.setting.criteria.data_type == 'DATE' && vm.setting.criteria.value.option) {
                                returnStr += operator.label + ' ' + vm.setting.criteria.value.days + ' ' + vm.setting.criteria.value.option;
                            } else {
                                if (vm.setting.criteria.value && vm.setting.criteria.value != '') {
                                    returnStr += operator.label + ' ' + vm.setting.criteria.value
                                }
                            }
                        } else {
                            returnStr += vm.setting.criteria.value;
                        }
                    }
                }
                vm.setting.title = returnStr;
            }

            vm.hasCondition = function(field_group_name, field_name) {
                var fieldGroupMeta = $filter('filter')(vm.field_groups, {
                    'name': field_group_name
                })[0];

                var fieldMeta = $filter('filter')(fieldGroupMeta.fields, {
                    'name': field_name
                })[0];

                var fieldConditionsMeta = FIELD_CONDITION_CONSTANT[fieldMeta.data_type]
                if (fieldMeta.data_type === "OBJECT") {
                    return fieldConditionsMeta[fieldMeta.ref_object];
                } else {
                    return fieldConditionsMeta;
                }
            }

            vm.getFieldOperators = function(field_group_name, field_name) {
                var fieldGroupMeta = $filter('filter')(vm.field_groups, {
                    'name': field_group_name
                })[0];
                var fieldMeta = $filter('filter')(fieldGroupMeta.fields, {
                    'name': field_name
                })[0];

                var fieldConditionsMeta = FIELD_CONDITION_CONSTANT[fieldMeta.data_type]
                if (fieldMeta.data_type === "OBJECT") {
                    return fieldConditionsMeta[fieldMeta.ref_object];
                } else {
                    return fieldConditionsMeta;
                }
            }

            vm.filterFieldGroup = function(fieldGroup) {
                if (fieldGroup.name == 'profile' || fieldGroup.name == 'job' || fieldGroup.locked == false) {
                    return true;
                } else {
                    false;
                }
            }

            $q.all([
                MetaData.get({
                    id: 'user',
                    is_name: true
                }).$promise,
                Setting.getSystemTimezones({
                    size: 100
                }).$promise,
                Setting.getSystemLanguages().$promise
            ]).then(function(data) {
                angular.forEach(data[0].field_groups, function(field_group) {
                    if (field_group.fields != null) {
                        vm.field_groups.push(field_group);
                    }
                });
                vm.timezones = data[1];
                vm.languages = data[2];
                vm.dataIsLoaded = true;
            });

        }

        vm.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        }

        vm.filterAssignment = function(result) {
            var returnResult = [];

            angular.forEach(result, function(data) {
                if (vm.getCardMeta(data).show_assign_action) {
                    returnResult.push(data);
                }
            });
            return returnResult;
        };

        vm.filterQuestion = function(result) {
            var returnResult = [];

            angular.forEach(result, function(data) {
                if (vm.getCardMeta(data).show_ask_action) {
                    returnResult.push(data);
                }
            });
            return returnResult;
        };

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.autoCompleteCallBack = function(result) {
            if (vm.setting.objectType) {
                var service = $injector.get(vm.setting.objectType);
                if ( (vm.setting.title && vm.setting.title.trim() == '') || !vm.setting.title) {
                    if (vm.setting.data instanceof Array) {
                        if (result.length > 1) {
                            vm.setting.title = result.length + $filter('translate')('atheer.smartFlow.builder.itemsSelected');
                        } else {
                            var selectedFirstObject = result[0];
                            vm.setting.title = selectedFirstObject.display || selectedFirstObject.name || selectedFirstObject.title || selectedFirstObject.first_name + ' ' + selectedFirstObject.last_name;
                        }
                    } else {
                        var selectedFirstObject = result;
                        vm.setting.title = selectedFirstObject.display || selectedFirstObject.name || selectedFirstObject.title || selectedFirstObject.first_name + ' ' + selectedFirstObject.last_name;
                    }
                }

            }
            return result;
        }

        vm.submit = function() {
            if (vm.criteriaIsValid) {

                if (vm.setting.objectType && vm.setting.data instanceof Array && vm.setting.data.length > 0) {
                    var dataIds = [];
                    angular.forEach(vm.setting.data, function(dataObj) {
                        dataIds.push(dataObj.id)
                    });

                    vm.setting.data = dataIds;
                }

                $mdDialog.hide(vm.setting);
            } else {
                ToastService.displayToast($filter('triTranslate')("atheer.smartFlow.builder.fillRequiredFields"), 3000);
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .directive('smartFlowBuilderReadOnly', smartFlowBuilderReadOnlyDirective);

    /* @ngInject */
    function smartFlowBuilderReadOnlyDirective() {
        var directive = {
            restrict: 'E',
            require: '^smartFlowBuilderReadOnly',
            replace: true,
            templateUrl: 'modules/smartflow/smartflow-builder-read-only.tmpl.html',
            scope: {
                canvasData: '=',
                type: '=',
                isJobFlow: '='
            },
            controller: smartFlowBuilderReadOnlyController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, element, attrs) {
                scope.init(element, attrs);
            }
        };
        return directive;
    }

    /* @ngInject */
    /* @ngInject */
    function smartFlowBuilderReadOnlyController($scope, $mdToast, AlertService, $state, $mdDialog, SmartFlowBuilder) {
        var vm = this;

        $scope.init = function (element, attrs) {
            SmartFlowBuilder.initPreview(element, vm.canvasData, vm.isJobFlow, vm.type);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .directive('smartFlowBuilderPreview', smartFlowBuilderPreviewDirective);

    /* @ngInject */
    function smartFlowBuilderPreviewDirective() {
        var directive = {
            restrict: 'E',
            require: '^smartFlowBuilderPreview',
            replace: true,
            templateUrl: 'modules/smartflow/smartflow-builder-preview.tmpl.html',
            scope: {
                canvasData: '='
            },
            controller: smartFlowBuilderPreviewController,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, element, attrs) {
                scope.init(element, attrs);
            }
        };
        return directive;
    }

    /* @ngInject */
    /* @ngInject */
    function smartFlowBuilderPreviewController($scope, $mdToast, AlertService, $state, $mdDialog, SmartFlowBuilder) {
        var vm = this;

        $scope.init = function(element, attrs) {
            SmartFlowBuilder.initPreview(element);
            SmartFlowBuilder.loadCanvasData(vm.canvasData);
        };

        // listen for the event in the relevant $scope
        $scope.$on('templateChange', function(event, data) {
            vm.canvasData = data;
            SmartFlowBuilder.loadCanvasData(vm.canvasData);
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowBuilderInsightsController', SmartFlowBuilderInsightsController);

    /* @ngInject */
    function SmartFlowBuilderInsightsController($scope, id, SmartFlow, $state, SmartFlowBuilder) {
        var vm = this;
        vm.viewType = 'insights';
        vm.dataLoaded = false;

        if (id) {
            SmartFlow.get({
                id: id
            }, function(result) {
                vm.smartFlowModel = result;
                vm.dataLoaded = true;
            });
        }

        vm.goToSmartFlows = function() {
            $state.go("storm.admin-smartflows");
        };

        vm.isDraft = function() {
            if (vm.smartFlowModel.status == 'DRAFT') {
                return true;
            } else {
                return false;
            }
        }

        vm.isPaused = function() {
            if (vm.smartFlowModel.status == 'PAUSED') {
                return true;
            } else {
                return false;
            }
        }

        vm.isLive = function() {
            if (vm.smartFlowModel.status == 'LIVE') {
                return true;
            } else {
                return false;
            }
        }

        vm.isEnded = function() {
            if (vm.smartFlowModel.status == 'ENDED') {
                return true;
            } else {
                return false;
            }
        }

        vm.isNew = function() {
            if (vm.smartFlowModel == undefined || vm.smartFlowModel.id == null) {
                return true;
            } else {
                return false;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowBuilderInsightsUserController', SmartFlowBuilderInsightsUserController);

    /* @ngInject */
    function SmartFlowBuilderInsightsUserController($scope, pagingParams, Experience, paginationConstants, $mdDialog, $filter, id, SmartFlow, $state, SmartFlowBuilder) {
        var vm = this;
        vm.viewType = 'insights';
        vm.dataLoaded = false;

        vm.smartFlowModel = $scope.$parent.vm.smartFlowModel;
        vm.goToSmartFlows = $scope.$parent.vm.goToSmartFlows;
        vm.isNew = $scope.$parent.vm.isNew;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.smartFlows = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            Experience.getSmartFlows({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, function(response, headers) {
                vm.smartFlows = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dataLoaded = true;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "object_id==" + id;
            return queryString;
        }

        vm.transition = function() {
            vm.promise = Experience.getSmartFlows({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.smartFlows = response;
                vm.queryCount = vm.totalItems;
            });
        }

        vm.launchUserActivitySummary = function(userSmartFlow) {
            $mdDialog.show({
                templateUrl: 'modules/smartflow/smartflow-builder-insights-user-activity.tmpl.html',
                clickOutsideToClose: true,
                controller: "SmartFlowBuilderInsightsUserActivityController",
                controllerAs: "vm",
                locals: {
                    userSmartFlow: userSmartFlow,
                    smartFlow: $scope.$parent.vm.smartFlowModel
                }
            });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowBuilderInsightsUserActivityController', SmartFlowBuilderInsightsUserActivityController);

    /* @ngInject */
    function SmartFlowBuilderInsightsUserActivityController($scope, $q, $filter, smartFlow, $state, Report, SmartFlowBuilder, $mdDialog, userSmartFlow, WORFLOW_CELL_CONSTANT) {
        var vm = this;
        vm.viewType = 'insights';
        vm.loadingData = false;

        vm.smartFlowModel = smartFlow;
        vm.userSmartFlow = userSmartFlow;

        vm.activitySummary = null;

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                Report.getSmartFlowUserActivitySummary({
                    id: userSmartFlow.smart_flow_instance_id
                }).$promise
            ]).then(function(data) {
                vm.activitySummary = data[0];
                vm.loadingData = false;

                if (vm.smartFlowModel.canvas_data != null && vm.smartFlowModel.canvas_data.length > 0) {
                    var graph = new joint.dia.Graph;
                    graph.fromJSON(JSON.parse(vm.smartFlowModel.canvas_data));

                    _.each(vm.activitySummary, function(activitySummary) {
                        var cell = graph.getCell(activitySummary.id);
                        if (cell) {
                            var title = cell.attr('text/text');
                            activitySummary.title = title;
                            if(WORFLOW_CELL_CONSTANT[activitySummary.name]) {
                                  activitySummary.type_label = WORFLOW_CELL_CONSTANT[activitySummary.name].label;
                            }
                        }
                    });
                }
            }).catch(function(data) {}).finally(function() {});
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowBuilderInsightsOverviewController', SmartFlowBuilderInsightsOverviewController);

    /* @ngInject */
    function SmartFlowBuilderInsightsOverviewController($scope, $filter, $q, id, SmartFlow, $state, SmartFlowBuilder, Report, WORFLOW_CELL_CONSTANT) {
        var vm = this;
        vm.viewType = 'insights';
        vm.loadingData = false;

        vm.smartFlowModel = $scope.$parent.vm.smartFlowModel;

        vm.overviewSummary = null;
        vm.activitySummary = null;

        function getDateFromItem(item) {
            return item.x;
        }

        vm.userEnteredChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.smartFlow.insights.completions')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.smartFlow.insights.noOfUsers')
                }
            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.smartFlow.insights.dates')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }

            },
            series: [{
                name: $filter('translate')('atheer.smartFlow.insights.usersEntered'),
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> Users : ' + this.y;
                }
            }
        };

        vm.goToSmartFlows = function() {
            $state.go("storm.admin-smartflows");
        };

        vm.getCount = function(activityName) {
            for (var i = 0; i < vm.overviewSummary.metrics.length; i++) {
                if (vm.overviewSummary.metrics[i].name === activityName) {
                    return vm.overviewSummary.metrics[i].count;
                }
            }
            return 0;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                Report.getSmartFlowOverviewSummary({
                    id: id
                }).$promise,
                Report.getSmartFlowActivitySummary({
                    id: id
                }).$promise
            ]).then(function(data) {
                vm.overviewSummary = data[0];
                vm.activitySummary = data[1];
                vm.loadingData = false;

                angular.forEach(vm.overviewSummary.history, function(userCountObj) {
                    vm.userEnteredChartData.series[0].data.push({x :new Date(userCountObj.name), y :userCountObj.count})
                });
                vm.userEnteredChartData.series[0].data = $filter('orderBy')(vm.userEnteredChartData.series[0].data, getDateFromItem);

                if (vm.smartFlowModel.canvas_data != null && vm.smartFlowModel.canvas_data.length > 0) {
                    var graph = new joint.dia.Graph;
                    graph.fromJSON(JSON.parse(vm.smartFlowModel.canvas_data));

                    _.each(vm.activitySummary, function(activitySummary) {
                        var cell = graph.getCell(activitySummary.id);
                        if (cell) {
                            var title = cell.attr('text/text');
                            activitySummary.title = title;
                            if(WORFLOW_CELL_CONSTANT[activitySummary.name]) {
                                  activitySummary.type_label = WORFLOW_CELL_CONSTANT[activitySummary.name].label;
                            }

                        }
                    });
                }

            }).catch(function(data) {}).finally(function() {});
        }
        vm.loadData();
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.smartFlow')
        .constant('WORFLOW_CELL_CONSTANT', {
            'audienceTrigger': {
                setting: {
                    isConfigured: false,
                    myTeam: false,
                    audience: undefined
                },
                label: 'Team'

            },
            'audienceAssign': {
                setting: {
                    isConfigured: false,
                    audience: undefined
                },
                label: 'Assign Team'

            },
            'audienceRemove': {
                setting: {
                    title: '',
                    isConfigured: false,
                    audience: undefined
                },
                label: 'Remove Team'

            },
            'audienceCheck': {
                setting: {
                    isConfigured: false,
                    audience: undefined
                },
                label: 'Team'

            },
            'userFieldTrigger': {
                setting: {
                    isConfigured: false
                },
                label: 'User Profile Field'

            },
            'userFieldCheck': {
                setting: {
                    isConfigured: false,
                    content: undefined
                },
                label: 'User Profile'

            },
            'announcementAssign': {
                setting: {
                    isConfigured: false,
                    absoluteDate: null,
                    relativeDate: {
                        period: 'hrs',
                        value: ''
                    },
                    isDueDateRelative: 0,
                    content: undefined
                },
                label: 'Announcement'

            },
            'contentAssign': {
                setting: {
                    isConfigured: false,
                    required: false,
                    absoluteDate: null,
                    relativeDate: {
                        period: 'hrs',
                        value: ''
                    },
                    isDueDateRelative: 0,
                    content: undefined
                },
                label: 'Assign Content'

            },
            'contentRemove': {
                setting: {
                    isConfigured: false,
                    content: undefined
                },
                label: 'Remove Assignment'

            },
            'contentRecommend': {
                setting: {
                    title: '',
                    isConfigured: false,
                    content: undefined,
                    note: null
                },
                label: 'Recommend'

            },
            'contentCheck': {
                setting: {
                    isConfigured: false,
                    content: undefined
                },
                label: 'Assignment'

            },
            'questionAssign': {
                setting: {
                    isConfigured: false,
                    required: false,
                    isDueDate: 0,
                    content: undefined,
                    absoluteDate: null
                },
                label: 'Ask Question'

            },
            'questionCheck': {
                setting: {
                    status: 'COMPLETED',
                    pass: true,
                    isConfigured: false,
                    content: undefined
                },
                label: 'Answer'

            },
            'badgeAssign': {
                setting: {
                    isConfigured: false,
                    badge: undefined
                },
                label: 'Assign Badge'

            },
            'badgeRemove': {
                setting: {
                    isConfigured: false,
                    badge: undefined
                },
                label: 'Remove Badge'

            },
            'taskAssign': {
                setting: {
                    isConfigured: false,
                    required: false,
                    absoluteDate: null,
                    relativeDate: {
                        period: 'hrs',
                        value: ''
                    },
                    isDueDateRelative: 0,
                    content: undefined
                },
                label: 'Assign Task'

            },
            'taskRemove': {
                setting: {
                    isConfigured: false,
                    content: undefined
                },
                label: 'Remove Task'

            },
            'taskListAssign': {
                setting: {
                    isConfigured: false,
                    required: false,
                    absoluteDate: null,
                    relativeDate: {
                        period: 'hrs',
                        value: ''
                    },
                    isDueDateRelative: 0,
                    content: undefined
                },
                label: 'Assign Task List'

            },
            'taskListRemove': {
                setting: {
                    isConfigured: false,
                    task: undefined
                },
                label: 'Remove Task List'

            },
            'securityRoleAssign': {
                setting: {
                    isConfigured: false,
                    securityrole: undefined
                },
                label: 'Assign Sec. Role'

            },
            'securityRoleRemove': {
                setting: {
                    isConfigured: false,
                    securityrole: undefined
                },
                label: 'Remove Sec. Role'

            },
            'emailSend': {
                setting: {
                    isConfigured: false,
                    content: undefined
                },
                label: 'Newsletter'

            },
            'slackMessageSend': {
                setting: {
                    isConfigured: false,
                    message: ''
                },
                label: 'Slack Message'

            },
            'pushNotificationSend': {
                setting: {
                    isConfigured: false,
                    content: undefined
                },
                label: 'Push Notification'

            },
            'smsSend': {
                setting: {
                    isConfigured: false,
                    message: ''
                },
                label: 'SMS'

            },
            'externalSystem': {
                setting: {
                    title: '',
                    isConfigured: false
                },
                label: 'External System'

            },
            'wait': {
                setting: {
                    isConfigured: false,
                    period: 'hrs',
                    value: 0
                },
                label: 'Wait'
            },
            'end': {
                setting: {
                    isConfigured: false
                },
                label: 'End'
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowAddUsersController', SmartFlowAddUsersController)

    /* @ngInject */
    function SmartFlowAddUsersController($scope, $injector, $state, $mdToast, $element, $filter, $q, Experience, $mdDialog, smartFlow) {
        var vm = this;

        vm.users = [];
        vm.assignProgress = 'idle';

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.submit = function() {
            vm.assignProgress = 'started';

            var userSmartFlows = [];

            angular.forEach(vm.users, function(user) {
                var userSmartFlow = {
                    user_id: user.id,
                    object: smartFlow,
                    status: 'STARTED',
                    started_on: new Date()
                }
                userSmartFlows.push(userSmartFlow);
            });

            Experience.bulkUserSmartFlows(userSmartFlows, function(result) {
                vm.assignProgress = 'complete';
                vm.assignSuccess = result.success;
            });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .directive('jobFlowObjectBuilder', jobFlowObjectBuilderDirective);

    /* @ngInject */
    function jobFlowObjectBuilderDirective() {
        var directive = {
            restrict: 'E',
            require: '^jobFlowObjectBuilder',
            replace: true,
            templateUrl: 'modules/smartflow/jobflow-object-builder.tmpl.html',
            scope: {
                setting: '=',
                type: '=',
                name: '='
            },
            controller: jobFlowObjectBuilderController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    /* @ngInject */
    function jobFlowObjectBuilderController($scope) {
        var vm = this;

        vm.object;

        var object = {
            key_name: "key",
            key_label: "Key",
            key_description: "Key",
            key_type: "text",
            key_value: "",
            value_name: "value",
            value_label: "Value",
            value_description: "Value",
            value_type: "text",
            value_value: ""
        };

        function init() {
            vm.object = [];
            var keys = Object.keys(vm.setting);
            if (keys && keys.length > 0) {
                angular.forEach(keys, function (key) {
                    vm.addField(key);
                });
            } else {
                vm.addField();
            }
        }

        vm.addField = function (key) {
            var obj = angular.copy(object);
            obj.key_value = key ? key : '';
            if (vm.type === 'OBJECT_LIST') {
                vm.setting[obj.key_value] = vm.setting[obj.key_value] ? vm.setting[obj.key_value] : [];
            }
            vm.object.push(obj);
        };

        vm.removeField = function (id, object) {
            delete vm.setting[object.key_value];
            vm.object.splice(id, 1);
        }

        vm.onkeydown = function (event, obj) {
            if (vm.type === 'OBJECT_LIST') {
                if (event.keyCode === 9) {
                    return;
                }
                if (event.keyCode === 8 && obj.key_value !== "") {
                    vm.setting[obj.key_value.substring(0, obj.key_value.length - 1)] = vm.setting[obj.key_value];
                } else {
                    vm.setting[obj.key_value + event.key] = vm.setting[obj.key_value];
                }
                delete vm.setting[obj.key_value];
            }
        }

        init();

    }
})();
;
(function () {
	"use strict";

	angular
		.module("atheer.smartFlow")
		.controller(
			"JobFlowMoleculesUserResolverController",
			JobFlowMoleculesUserResolverController
		);

	/* @ngInject */
	function JobFlowMoleculesUserResolverController(
		$mdDialog,
		JobFlow,
		setting,
		SmartFlowBuilder
	) {
		var vm = this;

		var object = {
			search_key_name: "searchKeys",
			search_key_value: "",
			data_model_name: "dataModel",
			data_model_value: "",
		};

		vm.resolverTypeList = [
			{ name: "Static", value: "STATIC" },
			{ name: "Query", value: "QUERY" },
			{ name: "Lookup", value: "LOOKUP" },
		];

		vm.resolverList = [];
		vm.lookUpData = [];
		vm.loadingData = true;
		vm.listItems = [];
		vm.staticObject = [];
		vm.dynamicObject = [];
		vm.isStaticObjectLoaded = false;
		vm.isDynamicObjectLoaded = false;
		vm.dataModelProperties = [];
		vm.objects = [];

		vm.close = function () {
			$mdDialog.cancel();
		};

		vm.submit = function () {
			var rawData = angular.copy(vm.setting.properties);
			vm.setting.properties = {};

			switch (rawData.resolverType) {
				case "STATIC":
					vm.setting.properties = {
						objectType: rawData.objectType,
						staticResult: rawData.staticResult,
						resolverType: rawData.resolverType,
					};
					break;
				case "QUERY":
					var searchKeyList = Object.keys(rawData.searchCriteria.searchKeys);
					var searchKeyObject = {};

					angular.forEach(searchKeyList, function(searchKey) {
						searchKeyObject[rawData.searchCriteria.searchKeys[searchKey]] = searchKey;
					});

					vm.setting.properties = {
						objectType: rawData.objectType,
						resolverType: rawData.resolverType,
						searchCriteria: {
							searchKeys: searchKeyObject,
							returnSingleObject: true,
						},
					};
					break;
				case "LOOKUP":
					var lookupCriteria = [];
					angular.forEach(vm.lookUpData, function (row) {
						var obj = {
							conditionGroup: {
								logicalOperator: "AND",
								conditions: [],
							},
							onSuccessResult: row["onSuccessResult"],
						};

						angular.forEach(row, function (value, key) {
							if (key === "onSuccessResult") {
								return;
							}

							obj.conditionGroup.conditions.push({
								operand: key,
								operator: "EQ",
								value: value,
							});
						});

						lookupCriteria.push(obj);
					});
					vm.setting.properties = {
						objectType: rawData.objectType,
						resolverType: rawData.resolverType,
						returnSingleObject: true,
						lookupCriteria: lookupCriteria,
					};
					break;
			}

			if (vm.setting.properties.resolverType !== "STATIC") {
				vm.setting.properties.returnSingleObject = true;
			}

			$mdDialog.hide(vm.setting);
		};

		vm.onResolveTypeChnage = function () {
			if (vm.lookUpData && vm.lookUpData.length > 0) {
                var keys = Object.keys(vm.lookUpData[0]);
                for(var i = 0; i < keys.length; i++) {
                    if(vm.resolverList && vm.resolverList.length) {
                        if(vm.resolverList.indexOf(keys[i]) === -1 && keys[i] !== 'onSuccessResult') {
                            angular.forEach(vm.lookUpData, function (obj) {
                                delete obj[keys[i]];
                            });
                        }
                    } else {
                        vm.lookUpData = [];
                    }
                }
			} else {
                var obj = {};
                angular.forEach(vm.resolverList, function (value) {
                    obj[value] = undefined;
                });
                vm.lookUpData.push(obj);
            }
		};

		vm.onObjectTypeChange = function (isData) {
			vm.loadingData = true;
			vm.staticObject = [];
			vm.dynamicObject = [];

			JobFlow.getObjectList(
				{ objectType: vm.setting.properties["objectType"],
				sort: 'name,asc'
			 },
				function (result) {
					vm.isStaticObjectLoaded = true;
					vm.loadingData = false;
					vm.staticObject = result;
				}
			);

			if (vm.setting.properties.resolverType === "QUERY") {
				JobFlow.getMetaData(
					{ objectType: vm.setting.properties["objectType"] },
					function (result) {
						vm.isDynamicObjectLoaded = true;
						vm.loadingData = false;
						vm.setMetaData(result);
					}
				);

				vm.setting.properties["searchCriteria"]["searchKeys"] = isData
					? vm.setting.properties["searchCriteria"]["searchKeys"]
					: {};
			}

			if (vm.setting.properties.resolverType === "LOOKUP") {
				var dataModelId = SmartFlowBuilder.getDataModelId();

				if (!dataModelId) {
					vm.loadingData = false;
					return;
				}

				setDataModelProperties(dataModelId);
			}
		};

		vm.setMetaData = function (result) {
			angular.forEach(result, function (metaData) {
				var value = metaData.split(".").join("##");
				var data = {
					label: metaData,
					value: value,
				};
				vm.dynamicObject.push(data);
			});
		};

		vm.onResolverTypeChange = function () {
			if (vm.setting.properties.resolverType === "QUERY") {
				vm.setting.properties["searchCriteria"] = {};
				vm.setting.properties.searchCriteria["searchKeys"] = {};
				vm.objects = [];

				initQueryData();
			}

			if (vm.setting.properties.resolverType === "LOOKUP") {
				vm.onObjectTypeChange();
			}
		};

		vm.showProperties = function (object, index) {
			$mdDialog
				.show({
					controller: "JobFlowMoleculesPropertiesController",
					controllerAs: "vm",
					templateUrl:
						"modules/smartflow/jobflow-molecules-properties.tmpl.html",
					escapeToClose: true,
					clickOutsideToClose: true,
					locals: {
						dataModelProperties: vm.dataModelProperties,
						type: vm.setting.properties["objectType"],
					},
					multiple: true,
				})
				.then(function (result) {
					vm.setting.properties.searchCriteria.searchKeys[
						result.name
					] = "";
					vm.objects[index].data_model_value = result.name;

                    var datamodelKeys = [];
                    angular.forEach(vm.objects, function (row) {
                        datamodelKeys.push(row.data_model_value);
                    });
                    for (var key in vm.setting.properties.searchCriteria.searchKeys) {
                        if (datamodelKeys.length && datamodelKeys.indexOf(key) == -1) {
                            delete vm.setting.properties.searchCriteria.searchKeys[key];
                        }
                    }
				});
		};

		vm.addRow = function () {
			var obj = {};
			angular.forEach(vm.resolverList, function (value) {
				obj[value] = undefined;
			});

			vm.lookUpData.push(obj);
		};

		vm.deleteRow = function (index) {
			vm.lookUpData.splice(index, 1);
		};

		function initLookUp() {
			var properties = angular.copy(vm.setting.properties);
			vm.resolverList = [];
			vm.lookUpData = [];
			var obj = {};

			angular.forEach(properties.lookupCriteria, function (row) {
				obj = {};
				angular.forEach(row.conditionGroup.conditions, function (
					value
				) {
					obj[value.operand] = value.value;
					if (!vm.resolverList[value.operand]) {
						vm.resolverList.push(value.operand);
					}
				});

				obj["onSuccessResult"] = row.onSuccessResult;
				vm.lookUpData.push(obj);
			});
		}

		function init() {
			vm.setting = angular.copy(setting);
			vm.setting.properties.objectType = "User";

			if (!vm.setting.properties.resolverType) {
				vm.setting.properties.resolverType = "STATIC";
			}

			if (vm.setting.properties.resolverType === "LOOKUP") {
				initLookUp();
			}

			if (
				!vm.setting.properties.resolverType ||
				vm.setting.properties.resolverType !== "QUERY"
			) {
				if (vm.setting.properties.objectType) {
					vm.onObjectTypeChange();
				}
				return;
			}

			initQueryData();
		}

		vm.addField = function (key) {
			var obj = angular.copy(object);
			obj.data_model_value = key ? key : "";
			vm.objects.push(obj);
		};

		vm.removeField = function (id, obj) {
			vm.objects.splice(id, 1);
			delete vm.setting.properties.searchCriteria.searchKeys[
				obj.data_model_value
			];
		};

		function initQueryData() {
			var dataModelId = SmartFlowBuilder.getDataModelId();
			setDataModelProperties(dataModelId);

			var keys = Object.keys(vm.setting.properties.searchCriteria);
			var searchKeyList = Object.keys(vm.setting.properties.searchCriteria.searchKeys);
			var searchKeyObject = {};

			angular.forEach(searchKeyList, function(searchKey) {
				searchKeyObject[vm.setting.properties.searchCriteria.searchKeys[searchKey]] = searchKey;
			});

			vm.setting.properties.searchCriteria.searchKeys = searchKeyObject;

			if (keys && keys.length > 0) {
				var searchKeys = Object.keys(
					vm.setting.properties.searchCriteria.searchKeys
				);
				if (
					searchKeys &&
					searchKeys.length > 0 &&
					vm.setting.properties["resolverType"] === "QUERY"
				) {
					angular.forEach(searchKeys, function (key) {
						vm.addField(key);
					});
				} else {
					vm.addField();
				}
				vm.onObjectTypeChange(true);
			} else {
				vm.resolverType = true;
				vm.addField();
			}
		}

		function setDataModelProperties(dataModelId) {
			JobFlow.getDataModelById({ id: dataModelId }, function (result) {
				vm.dataModelProperties = result.properties;
				vm.loadingData = false;
			});
		}

		init();
	}
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('JobFlowMoleculesSettingController', JobFlowMoleculesSettingController)

    /* @ngInject */
    function JobFlowMoleculesSettingController($mdDialog, $mdToast, JobFlow, cellType, setting) {
        var vm = this;

        vm.settingForm = {};
        vm.settingFields = [];
        vm.title = '';
        vm.loadingData = true;
        vm.data;
        vm.isObjectList = false;

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.submit = function () {
            if (vm.isObjectList) {
                checkForNullObjects();
            }
            $mdDialog.hide(vm.setting);
        };

        function checkForNullObjects() {
            angular.forEach(vm.setting.properties, function (property) {
                var keys = Object.keys(property);
                angular.forEach(keys, function (key) {
                    if (key == '') {
                        delete property[key];
                    }
                });
            });
        }

        function init() {
            vm.setting = angular.copy(setting);

            JobFlow.getMoleculesProperties(function (data) {
                vm.loadingData = true;
                vm.data = data;
                getCurrentCellMolecule(data);
            });
        }

        function getCurrentCellMolecule(data) {
            angular.forEach(data, function (inputElement) {
                if (inputElement.type == cellType) {
                    vm.title = inputElement.title;
                    getProperties(inputElement.properties);
                }
            });
        }

        function getProperties(properties) {
            angular.forEach(properties, function (property) {

                var field = {
                    description: property.description,
                    label: property.label,
                    name: property.name,
                    required: property.required,
                    type: property.type
                }

                if (field.type == 'LIST') {
                    field.list = property.list;
                }

                if (field.type == 'OBJECT' || field.type == 'OBJECT_LIST') {
                    vm.isObjectList = field.type == 'OBJECT_LIST' ? true : false;
                    vm.setting.properties[property.name] = vm.setting.properties[property.name] ? vm.setting.properties[property.name] : {};
                }

                vm.settingFields.push(field);
                vm.loadingData = false;
            });
        }

        init();
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.smartFlow")
        .controller(
            "JobFlowMoleculesResolverController",
            JobFlowMoleculesResolverController
        );

    /* @ngInject */
    function JobFlowMoleculesResolverController(
        $mdDialog,
        JobFlow,
        cellType,
        setting,
        SmartFlowBuilder
    ) {
        var vm = this;

        var object = {
            search_key_name: "searchKeys",
            search_key_value: "",
            data_model_name: "dataModel",
            data_model_value: "",
        };

        vm.resolverTypeList = [
            { name: "Static", value: "STATIC" },
            { name: "Query", value: "QUERY" },
            { name: "Lookup", value: "LOOKUP" },
        ];

        vm.resolverList = [];
        vm.lookUpData = [];
        vm.loadingData = true;
        vm.listItems = [];
        vm.staticObject = [];
        vm.dynamicObject = [];
        vm.isStaticObjectLoaded = false;
        vm.isDynamicObjectLoaded = false;
        vm.dataModelProperties = [];
        vm.objects = [];

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.submit = function () {
            var rawData = angular.copy(vm.setting.properties);
            vm.setting.properties = {};

            switch (rawData.resolverType) {
                case "STATIC":
                    vm.setting.properties = {
                        objectType: rawData.objectType,
                        staticResult: rawData.staticResult,
                        resolverType: rawData.resolverType,
                    };
                    break;
                case "QUERY":
                    vm.setting.properties = {
                        objectType: rawData.objectType,
                        resolverType: rawData.resolverType,
                        searchCriteria: {
                            searchKeys: rawData.searchCriteria.searchKeys,
                            returnSingleObject: true,
                        },
                    };
                    break;
                case "LOOKUP":
                    var lookupCriteria = [];
                    angular.forEach(vm.lookUpData, function (row) {
                        var obj = {
                            conditionGroup: {
                                logicalOperator: "AND",
                                conditions: [],
                            },
                            onSuccessResult: row["onSuccessResult"],
                        };

                        angular.forEach(row, function (value, key) {
                            if (key === "onSuccessResult") {
                                return;
                            }

                            obj.conditionGroup.conditions.push({
                                operand: key,
                                operator: "EQ",
                                value: value,
                            });
                        });

                        lookupCriteria.push(obj);
                    });
                    vm.setting.properties = {
                        objectType: rawData.objectType,
                        resolverType: rawData.resolverType,
                        returnSingleObject: true,
                        lookupCriteria: lookupCriteria,
                    };
                    break;
            }

            if (vm.setting.properties.resolverType !== "STATIC") {
                vm.setting.properties.returnSingleObject = true;
            }

            $mdDialog.hide(vm.setting);
        };

        vm.onResolveTypeChnage = function () {
            if (vm.lookUpData && vm.lookUpData.length > 0) {
                return;
            }

            var obj = {};
            angular.forEach(vm.resolverList, function (value) {
                obj[value] = undefined;
            });

            vm.lookUpData.push(obj);
        };

        vm.onObjectTypeChange = function (isData) {
            vm.loadingData = true;
            vm.staticObject = [];
            vm.dynamicObject = [];

            if (vm.setting.properties.objectType === "AiRForm") {
                vm.setting.properties.resolverType = "STATIC";
            }

            JobFlow.getObjectList(
                { objectType: vm.setting.properties["objectType"] },
                function (result) {
                    vm.isStaticObjectLoaded = true;
                    vm.loadingData = false;
                    vm.staticObject = result;
                }
            );

            if (vm.setting.properties.resolverType === "QUERY") {
                JobFlow.getMetaData(
                    { objectType: vm.setting.properties["objectType"] },
                    function (result) {
                        vm.isDynamicObjectLoaded = true;
                        vm.loadingData = false;
                        vm.setMetaData(result);
                    }
                );

                vm.setting.properties["searchCriteria"]["searchKeys"] = isData
                    ? vm.setting.properties["searchCriteria"]["searchKeys"]
                    : {};
            }

            if (vm.setting.properties.resolverType === "LOOKUP") {
                var dataModelId = SmartFlowBuilder.getDataModelId();

                if (!dataModelId) {
                    vm.loadingData = false;
                    return;
                }

                setDataModelProperties(dataModelId);
            }
        };

        vm.setMetaData = function (result) {
            angular.forEach(result, function (metaData) {
                var value = metaData.split(".").join("##");
                var data = {
                    label: metaData,
                    value: value,
                };
                vm.dynamicObject.push(data);
            });
        };

        vm.onResolverTypeChange = function () {
            if (vm.setting.properties.resolverType === "QUERY") {
                vm.setting.properties["searchCriteria"] = {};
                vm.setting.properties.searchCriteria["searchKeys"] = {};
                vm.objects = [];

                initQueryData();
            }

            if (vm.setting.properties.resolverType === "LOOKUP") {
                vm.onObjectTypeChange();
            }
        };

        vm.showProperties = function (object) {
            $mdDialog
                .show({
                    controller: "JobFlowMoleculesPropertiesController",
                    controllerAs: "vm",
                    templateUrl:
                        "modules/smartflow/jobflow-molecules-properties.tmpl.html",
                    escapeToClose: true,
                    clickOutsideToClose: true,
                    locals: {
                        dataModelProperties: vm.dataModelProperties,
                        type: vm.setting.properties["objectType"],
                    },
                    multiple: true,
                })
                .then(function (result) {
                    vm.setting.properties.searchCriteria.searchKeys[
                        object.search_key_value
                    ] = result.name;
                });
        };

        vm.addRow = function (key) {
            var obj = {};
            angular.forEach(vm.resolverList, function (value) {
                obj[value] = undefined;
            });

            vm.lookUpData.push(obj);
        };

        vm.deleteRow = function (index) {
            vm.lookUpData.splice(index, 1);
        };

        function initLookUp() {
            var properties = angular.copy(vm.setting.properties);
            vm.resolverList = [];
            vm.lookUpData = [];
            var obj = {};

            angular.forEach(properties.lookupCriteria, function (row) {
                obj = {};
                angular.forEach(row.conditionGroup.conditions, function (
                    value
                ) {
                    obj[value.operand] = value.value;
                    if (!vm.resolverList[value.operand]) {
                        vm.resolverList.push(value.operand);
                    }
                });

                obj["onSuccessResult"] = row.onSuccessResult;
                vm.lookUpData.push(obj);
            });
        }

        function init() {
            vm.setting = angular.copy(setting);

            if (!vm.setting.properties.resolverType) {
                vm.setting.properties.resolverType = "STATIC";
            }

            JobFlow.getMoleculesProperties(function (data) {
                vm.loadingData = true;
                setListItem(data);
            });

            if (vm.setting.properties.resolverType === "LOOKUP") {
                initLookUp();
            }

            if (
                !vm.setting.properties.resolverType ||
                vm.setting.properties.resolverType !== "QUERY"
            ) {
                if (vm.setting.properties.objectType) {
                    vm.onObjectTypeChange();
                }
                return;
            }

            initQueryData();
        }

        vm.addField = function (key) {
            var obj = angular.copy(object);
            obj.search_key_value = key ? key : "";
            vm.objects.push(obj);
        };

        vm.removeField = function (id, obj) {
            vm.objects.splice(id, 1);
            delete vm.setting.properties.searchCriteria.searchKeys[
                obj.search_key_value
            ];
        };

        function initQueryData() {
            var dataModelId = SmartFlowBuilder.getDataModelId();
            setDataModelProperties(dataModelId);

            var keys = Object.keys(vm.setting.properties.searchCriteria);
            if (keys && keys.length > 0) {
                var searchKeys = Object.keys(
                    vm.setting.properties.searchCriteria.searchKeys
                );
                if (
                    searchKeys &&
                    searchKeys.length > 0 &&
                    vm.setting.properties["resolverType"] === "QUERY"
                ) {
                    angular.forEach(searchKeys, function (key) {
                        vm.addField(key);
                    });
                } else {
                    vm.addField();
                }
                vm.onObjectTypeChange(true);
            } else {
                vm.resolverType = true;
                vm.addField();
            }
        }

        function setDataModelProperties(dataModelId) {
            JobFlow.getDataModelById({ id: dataModelId }, function (result) {
                vm.dataModelProperties = result.properties;
                vm.loadingData = false;
            });
        }

        function setListItem(data) {
            angular.forEach(data, function (inputElement) {
                if (inputElement.type == cellType) {
                    angular.forEach(inputElement.properties, function (
                        property
                    ) {
                        if (
                            property.type == "LIST" &&
                            property.name === "objectType"
                        ) {
                            vm.listItems = property.list;
                        }
                    });
                    vm.loadingData = false;
                }
            });
        }

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('JobFlowMoleculesPropertiesController', JobFlowMoleculesPropertiesController)

    /* @ngInject */
    function JobFlowMoleculesPropertiesController($mdDialog, dataModelProperties, type) {
        var vm = this;

        vm.loadingData = true;
        vm.tableQuery = {
            limit: 6,
            page: 1,
            order: 'name'
        };

        vm.selectedObject;

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.submit = function () {
            $mdDialog.hide(vm.selectedObject);
        };

        vm.onObjectSelection = function (data) {
            vm.selectedObject = data;
        }

        function init() {
            vm.dataModelProperties = angular.copy(dataModelProperties);

            vm.title = type;
            vm.loadingData = false;
        }

        init();
    }
})();
;
(function () {
	"use strict";

	angular
		.module("atheer.smartFlow")
		.controller(
			"JobFlowMoleculesJobSeedController",
			JobFlowMoleculesJobSeedController
		);

	/* @ngInject */
	function JobFlowMoleculesJobSeedController(
		$mdDialog,
		JobFlow,
		setting,
		SmartFlowBuilder,
        $q
	) {
		var vm = this;

		var object = {
			data_mapper_value: "",
			data_mapper_key: "data_mapper_key",
			airForm_value: "",
			airForm_key: "airForm_key",
		};

		var jobObject = {
			data_mapper_value: "",
			data_mapper_key: "data_mapper_key",
			jobAttribute_value: "",
			jobAttribute_key: "jobAttribute_key",
		};

		vm.isAiRFormMapper = false;
		vm.isJobMapper = false;
		vm.loadingData = false;
		vm.dataModelProperties = [];
		vm.objectList = [];
		vm.jobObjectList = [];
		vm.smartflowCategory = SmartFlowBuilder.getSmartFlowCategory();
		vm.close = function () {
			$mdDialog.cancel();
		};
		vm.hasJobUpdate = SmartFlowBuilder.getJobUpdateStatus();

		vm.submit = function () {
			vm.setting.properties.mapping = {};

			if (vm.isAiRFormMapper) {
				angular.forEach(vm.objectList, function (object) {
					var valueList = object.airForm_value.split(":");
					if(valueList[0] === "AUTOMATION_LABEL") {
                        vm.setting.properties.mapping[object.data_mapper_value] = {
                            dataType: valueList[2],
                            name: valueList[1],
                            objectType: "AUTOMATION_LABEL",
                            jobKey: "",
                        };
                    } else {
                        vm.setting.properties.mapping[object.data_mapper_value] = {
                            dataType: valueList[2],
                            name: valueList[0] + ":" + valueList[1],
                            jobKey: "",
                        };
                    }
				});
			}

			if (vm.isJobMapper) {
				angular.forEach(vm.jobObjectList, function (object) {
					if (
						vm.setting.properties.mapping[object.data_mapper_value]
					) {
						vm.setting.properties.mapping[object.data_mapper_value][
							"jobKey"
						] = object.jobAttribute_value;
					} else {
						vm.setting.properties.mapping[
							object.data_mapper_value
						] = {
							name: "",
							dataType: "STRING",
							jobKey: object.jobAttribute_value,
						};
					}
				});
			}

			$mdDialog.hide(vm.setting);
		};

		vm.addField = function (key) {
			var obj = angular.copy(object);
			vm.objectList.push(obj);
		};

		vm.removeField = function (id, obj) {
			vm.objectList.splice(id, 1);
			delete vm.setting.properties[obj.airForm_value];
		};

		vm.addJobField = function (key) {
			var obj = angular.copy(jobObject);
			vm.jobObjectList.push(obj);
		};

		vm.removeJobField = function (id, obj) {
			vm.jobObjectList.splice(id, 1);
			delete vm.setting.properties[obj.jobAttribute_value];
		};

		vm.populateAirFormResponseList = function () {
			vm.responseList = [];
			angular.forEach(vm.airFormData.lanes, function (lane) {
				angular.forEach(lane.sections, function (section) {
					angular.forEach(section.steps, function (step) {
						var key = "";
						if (step.moleculeType == "BRANCH") {
							angular.forEach(step.paths, function (path) {
								angular.forEach(path.steps, function (step) {
									key = "";
									angular.forEach(step.metadata, function (
										data
									) {
										if (data.level === "HEADER") {
											angular.forEach(
												data.values,
												function (value) {
													if (
														value.name === "title"
													) {
														key = value.value;
													}
												}
											);
										}
										if (data.level === "RESPONSE") {
											angular.forEach(
												data.values,
												function (value) {
													var resLabel = "";
													if (
														value.moleculeType ===
														"NUMERIC" ||
														value.moleculeType ===
														"TEXT" ||
														value.moleculeType ===
														"SCIENTIFIC" ||
														value.moleculeType ===
														"PERCENTAGE" ||
														value.moleculeType ===
														"YES_NO" ||
														value.moleculeType ===
														"DATE" ||
                                                        value.moleculeType ===
                                                        "DATE_TIME" ||
                                                        value.moleculeType ===
                                                        "MULTIPLE_CHOICE" ||
                                                        value.moleculeType ===
                                                        "CHECKBOX" ||
                                                        value.moleculeType ===
                                                        "QRCODE" ||
                                                        value.moleculeType ===
                                                        "BARCODE"
													) {
														resLabel =
															key +
															" : " +
															value.label;
														vm.responseList.push({
															value: resLabel,
															key:
																step.id +
																":" +
																value.id +
																":STRING",
														});
                                                        // for automation labels
                                                        angular.forEach(value.metadata, function (metadataProp) {
                                                            if(metadataProp.level === "PROPERTY") {
                                                                angular.forEach(metadataProp.values, function (metaValue) {
                                                                    if(metaValue.label === "Automation Label" && metaValue.value) {
                                                                        vm.responseList.push({
                                                                            value: metaValue.value,
                                                                            key: "AUTOMATION_LABEL:" + metaValue.value + ":STRING"
                                                                        });
                                                                    }
                                                                });
                                                            }
                                                        });
													}
												}
											);
										}
									});
								});
							});
						} else {
							angular.forEach(step.metadata, function (data) {
								if (data.level === "HEADER") {
									angular.forEach(data.values, function (
										value
									) {
										if (value.name === "title") {
											key = value.value;
										}
									});
								}
								if (data.level === "RESPONSE") {
									angular.forEach(data.values, function (
										value
									) {
										var resLabel = "";
										if (
                                            value.moleculeType ===
                                            "NUMERIC" ||
                                            value.moleculeType ===
                                            "TEXT" ||
                                            value.moleculeType ===
                                            "SCIENTIFIC" ||
                                            value.moleculeType ===
                                            "PERCENTAGE" ||
                                            value.moleculeType ===
                                            "YES_NO" ||
                                            value.moleculeType ===
                                            "DATE" ||
                                            value.moleculeType ===
                                            "DATE_TIME" ||
                                            value.moleculeType ===
                                            "MULTIPLE_CHOICE" ||
                                            value.moleculeType ===
                                            "CHECKBOX" ||
                                            value.moleculeType ===
                                            "QRCODE" ||
                                            value.moleculeType ===
                                            "BARCODE"
										) {
											resLabel =
												key + " : " + value.label;
											vm.responseList.push({
												value: resLabel,
												key:
													step.id +
													":" +
													value.id +
													":STRING",
											});
											// for automation labels
                                            angular.forEach(value.metadata, function (metadataProp) {
                                                if(metadataProp.level === "PROPERTY") {
                                                    angular.forEach(metadataProp.values, function (metaValue) {
                                                        if(metaValue.label === "Automation Label" && metaValue.value) {
                                                            vm.responseList.push({
                                                                value: metaValue.value,
                                                                key: "AUTOMATION_LABEL:" + metaValue.value + ":STRING"
                                                            });
                                                        }
                                                    });
                                                }
                                            });
										}
									});
								}
							});
						}
					});
				});
			});
		};

        vm.populateAutomationLabelsList = function () {
            vm.responseList = [];
            angular.forEach(vm.dataAttributes, function (attr) {
                if(attr.category === "AUTOMATION_LABEL") {
                    vm.responseList.push({
                        value: attr.label,
                        key: "AUTOMATION_LABEL:" + attr.label + ":STRING"
                    });
                }
            });
        };

		vm.onJobMapperChange = function (addField) {
			if (vm.isJobMapper && !vm.jobAttributeData) {
				vm.loadingAirForm = true;
                $q.all([
                    JobFlow.getDataMapper().$promise,
                    JobFlow.getMetaData({ objectType: "Job" }).$promise
                ]).then(function(data) {
                    vm.loadingAirForm = false;
                    vm.loadingData = false;
                    var jobAttributesLabels = data[0];
                    vm.jobAttributeData = data[1];
                    vm.jobAttributeList = [];
                    angular.forEach(vm.jobAttributeData, function (value) {
                        angular.forEach(jobAttributesLabels, function (attr){
                            if(attr.name === value) {
                                vm.jobAttributeList.push({ key: value, value: attr.label });
                            }
                        });
                    });

                    if (!addField) {
                        vm.addJobField();
                    }
                });
			}
		};

		vm.onAiRFormMapperChange = function (addField) {
			if (vm.isAiRFormMapper && !vm.airFormData) {
				vm.loadingAirForm = true;
				var airFormId = SmartFlowBuilder.getAirFormId();
				if(airFormId) {
                    JobFlow.getAirForm({ id: airFormId }, function (result) {
                        vm.airFormData = result.toJSON();
                        vm.populateAirFormResponseList();
                        vm.loadingAirForm = false;
                    });
                } else {
                    JobFlow.getDataMapper(function (result) {
                        vm.dataAttributes = result;
                        vm.populateAutomationLabelsList();
                        vm.loadingAirForm = false;
                    })
                }

				if (!addField) {
					vm.addField();
				}
			}
		};

		function init() {
			vm.setting = angular.copy(setting);
			if (!vm.setting.properties.mapping) {
				vm.setting.properties = {
					mapping: {},
				};
			} else {
				angular.forEach(vm.setting.properties.mapping, function (
					value,
					key
				) {
					if (!!value.name) {
                        vm.isAiRFormMapper = true;
                        var obj = angular.copy(object);
                        obj.data_mapper_value = key;
					    if(value.objectType === "AUTOMATION_LABEL") {
                            obj.airForm_value = "AUTOMATION_LABEL:" + value.name + ":" + value.dataType;
                        } else {
                            obj.airForm_value = value.name + ":" + value.dataType;
                        }
                        vm.objectList.push(obj);
					}

					if (!!value.jobKey) {
						vm.isJobMapper = true;
						var obj = angular.copy(jobObject);
						obj.data_mapper_value = key;
						obj.jobAttribute_value = value.jobKey;
						vm.jobObjectList.push(obj);
					}
				});

				if (vm.isAiRFormMapper) {
					vm.onAiRFormMapperChange(true);
				}

				if (vm.isJobMapper) {
					vm.onJobMapperChange(true);
				}
			}
			var dataModelId = SmartFlowBuilder.getDataModelId();

			if (dataModelId) {
				vm.loadingDataModel = true;
				JobFlow.getDataModelById({ id: dataModelId }, function (
					result
				) {
					vm.dataModelProperties = result.properties;
					vm.loadingDataModel = false;
				});
			}
		}

		init();
	}
})();
;
(function () {
	"use strict";

	angular
		.module("atheer.smartFlow")
		.controller(
			"JobFlowMoleculesJobScopeController",
			JobFlowMoleculesJobScopeController
		);

	/* @ngInject */
	function JobFlowMoleculesJobScopeController(
		$mdDialog,
		JobFlow,
		setting,
		SmartFlowBuilder,
		$state,
		$q
	) {
		var vm = this;
		vm.airFormList = [];
		vm.selectedAirFormList = [];
		vm.loadingData = true;
		vm.jobScopeType = "Completed";
		var smartFlowData = SmartFlowBuilder.getSmartFlowData();
		vm.smartFlowId = $state.params.id || smartFlowData.id;

		vm.close = function () {
			$mdDialog.cancel();
		};

		vm.submit = function () {
			vm.setting = {
				properties: {
					jobStatus: vm.jobScopeType,
					airForms: vm.selectedAirFormList,
					workflow: vm.smartFlowId
				}
			};

			JobFlow.updateJobScope({
				jobStatus: vm.jobScopeType,
				airForms: vm.selectedAirFormList,
				workflow: vm.smartFlowId
			}, function (result) {
				vm.loadingData = false;
				$mdDialog.hide(vm.setting);
			});
		};

		function init() {
			JobFlow.getObjectList({ objectType: "AiRForm" }, function (result) {
				vm.loadingData = false;
				vm.airFormList = result;
			});

			JobFlow.getJobScope({ query: "workflow==" + vm.smartFlowId }, function (result) {
				vm.loadingData = false;

				if (result.length > 0) {
					vm.selectedAirFormList = result[0].airForms;
					vm.jobScopeType = result[0].jobStatus
				}
			});
		}

		init();
	}
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('JobFlowMoleculesDataMapperController', JobFlowMoleculesDataMapperController)

    /* @ngInject */
    function JobFlowMoleculesDataMapperController($mdDialog, JobFlow, setting, Upload, SmartFlowBuilder, $q, $filter, ToastService) {
        var vm = this;

        var object = {
            header_value: '',
            header_name: 'header',
            data_model_value: '',
            data_model_name: 'data_model'
        };

        vm.loadingData = true;
        vm.data;
        vm.object = [];
        vm.smartflowCategory = SmartFlowBuilder.getSmartFlowCategory();

        vm.headerModel;
        vm.dataModels = [];
        vm.dataModel;
        vm.file = {};
        vm.headers = [];
        vm.isUploaded = false;

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.submit = function () {
            syncSettings();
            var keys = vm.setting.properties.mapping ? Object.keys(vm.setting.properties.mapping) : '';
            if (keys && keys.length > 0) {
                angular.forEach(keys, function (key) {
                    angular.forEach(vm.dataModel.properties, function (model) {
                        if (vm.setting.properties.mapping[key].name == model.name) {
                            vm.setting.properties.mapping[key].dataType = model.dataType;
                        }
                    });
                });
            }
            $mdDialog.hide(vm.setting);
        };

        function syncSettings() {
            var rawSettings = vm.setting.properties.mapping;
            vm.setting.properties.mapping = {};
            for (var objCnt = 0; objCnt < vm.object.length; objCnt++) {
                if (rawSettings[vm.object[objCnt].header_value]) {
                    vm.setting.properties.mapping[vm.object[objCnt].header_value] = rawSettings[vm.object[objCnt].header_value];
                }
            }
        }

        vm.uploadDataMapper = function () {
            if(vm.file == null) {
                return;
            }
            var fileExt = vm.file && vm.file.name.split('.')[1];
            if(fileExt == 'csv') {
                Upload.upload({
                    url: 'api/smartflow/datamapper/headers',
                    data: {
                        'file': vm.file,
                        'type': 'csv'
                    }
                }).then(function (data) {
                    vm.setting.headers = data.data;
                    vm.setting.properties.mapping = {};
                    vm.isUploaded = true;
                    ToastService.displayToast($filter('translate')('atheer.smartFlow.builder.fileSuccess'), 3000);
                }, function () {
                    ToastService.displayToast($filter('translate')('atheer.smartFlow.builder.fileNotUploaded'), 3000);
                });
            } else {
                vm.file = {};
                ToastService.displayToast($filter('translate')('atheer.smartFlow.builder.fileDoesntSupport'), 3000);
            }
        };

        vm.addField = function (key) {
            var obj = angular.copy(object);
            obj.header_value = key ? key : '';
            vm.object.push(obj);
        };

        vm.removeField = function (id, obj) {
            vm.object.splice(id, 1);
            delete vm.setting.properties.mapping[obj.header_value];
        };

        vm.onDataModelChange = function () {
            angular.forEach(vm.dataModels, function (model) {
                if (vm.setting.dataModel == model.id) {
                    vm.dataModel = model;
                }
            })
        }

        function init() {
            vm.setting = angular.copy(setting);
            $q.all([
                JobFlow.getDataModel().$promise,
                JobFlow.getDataMapper().$promise
            ]).then(function (data) {
                vm.dataModels = data[0];
                vm.loadingData = false;
                vm.isUploaded = true;

                if (vm.smartflowCategory === 'JOB_EVENT') {
                    vm.setting.headers = data[1];
                }

                if (vm.setting && vm.setting.dataModel) {
                    vm.onDataModelChange();
                }
            });

            vm.isUploaded = vm.setting && vm.setting.headers ? true : false;
            if (vm.setting.properties && vm.setting.properties.mapping) {
                var keys = Object.keys(vm.setting.properties.mapping);
                if (keys && keys.length > 0) {
                    angular.forEach(keys, function (key) {
                        vm.addField(key);
                    });
                } else {
                    vm.addField();
                }
            } else {
                vm.addField();
            }
        }

        init();
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.smartFlow")
        .controller(
            "JobFlowMoleculesTeamResolverController",
            JobFlowMoleculesTeamResolverController
        );

    /* @ngInject */
    function JobFlowMoleculesTeamResolverController(
        $mdDialog,
        JobFlow,
        setting,
        SmartFlowBuilder
    ) {
        var vm = this;
        var object = {
            search_key_name: "searchKeys",
            search_key_value: "",
            data_model_name: "dataModel",
            data_model_value: "",
        };

        vm.resolverTypeList = [
            { name: "Static", value: "STATIC" },
            { name: "Query", value: "QUERY" },
            { name: "Lookup", value: "LOOKUP" },
            { name: "Datamodel", value: "DATAMODEL" },
        ];

        vm.resolverList = [];
        vm.lookUpData = [];
        vm.loadingData = true;
        vm.listItems = [];
        vm.staticObject = [];
        vm.dynamicObject = [];
        vm.isStaticObjectLoaded = false;
        vm.isDynamicObjectLoaded = false;
        vm.dataModelProperties = [];
        vm.objects = [];
        vm.selectedDataModelId = "";

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.submit = function () {
            var rawData = angular.copy(vm.setting.properties);
            vm.setting.properties = {};

            switch (rawData.resolverType) {
                case "STATIC":
                    vm.setting.properties = {
                        objectType: rawData.objectType,
                        staticResult: rawData.staticResult,
                        resolverType: rawData.resolverType,
                    };
                    break;
                case "DATAMODEL":
                    vm.setting.properties = {
                        objectType: rawData.objectType,
                        resolverType: rawData.resolverType,
                        dataModelCriteria: {
                            dataModelColumnName:
                                rawData.dataModelCriteria.dataModelColumnName,
                            dataModelId: rawData.dataModelCriteria.dataModelId,
                        },
                    };
                    break;
                case "QUERY":
                    var searchKeyList = Object.keys(
                        rawData.searchCriteria.searchKeys
                    );
                    var searchKeyObject = {};

                    angular.forEach(searchKeyList, function (searchKey) {
                        searchKeyObject[
                            rawData.searchCriteria.searchKeys[searchKey]
                        ] = searchKey;
                    });

                    vm.setting.properties = {
                        objectType: rawData.objectType,
                        resolverType: rawData.resolverType,
                        searchCriteria: {
                            searchKeys: searchKeyObject,
                            returnSingleObject: true,
                        },
                    };
                    break;
                case "LOOKUP":
                    var lookupCriteria = [];
                    angular.forEach(vm.lookUpData, function (row) {
                        var obj = {
                            conditionGroup: {
                                logicalOperator: "AND",
                                conditions: [],
                            },
                            onSuccessResult: row["onSuccessResult"],
                        };

                        angular.forEach(row, function (value, key) {
                            if (key === "onSuccessResult") {
                                return;
                            }

                            obj.conditionGroup.conditions.push({
                                operand: key,
                                operator: "EQ",
                                value: value,
                            });
                        });

                        lookupCriteria.push(obj);
                    });
                    vm.setting.properties = {
                        objectType: rawData.objectType,
                        resolverType: rawData.resolverType,
                        returnSingleObject: true,
                        lookupCriteria: lookupCriteria,
                    };
                    break;
            }

            $mdDialog.hide(vm.setting);
        };

        vm.onDataModelChange = function (option) {
            if (!vm.setting.properties.dataModelCriteria) {
                vm.setting.properties.dataModelCriteria = {
                    dataModelColumnName: option.name,
                    dataModelId: vm.selectedDataModelId,
                };
            } else {
                vm.setting.properties.dataModelCriteria.dataModelColumnName =
                    option.name;
            }
        };
        vm.onResolveTypeChnage = function () {
            if (vm.lookUpData && vm.lookUpData.length > 0) {
                var keys = Object.keys(vm.lookUpData[0]);
                for(var i = 0; i < keys.length; i++) {
                    if(vm.resolverList && vm.resolverList.length) {
                        if(vm.resolverList.indexOf(keys[i]) === -1 && keys[i] !== 'onSuccessResult') {
                            angular.forEach(vm.lookUpData, function (obj) {
                                delete obj[keys[i]];
                            });
                        }
                    } else {
                        vm.lookUpData = [];
                    }
                }
            } else {
                var obj = {};
                angular.forEach(vm.resolverList, function (value) {
                    obj[value] = undefined;
                });

                vm.lookUpData.push(obj);
            }
        };

        vm.onObjectTypeChange = function (isData) {
            vm.loadingData = true;
            vm.staticObject = [];
            vm.dynamicObject = [];

            JobFlow.getObjectList(
                {
                    objectType: vm.setting.properties["objectType"],
                    sort: "name,asc",
                },
                function (result) {
                    vm.isStaticObjectLoaded = true;
                    vm.loadingData = false;
                    vm.staticObject = result;
                }
            );

            if (vm.setting.properties.resolverType === "QUERY") {
                JobFlow.getMetaData(
                    { objectType: vm.setting.properties["objectType"] },
                    function (result) {
                        vm.isDynamicObjectLoaded = true;
                        vm.loadingData = false;
                        vm.setMetaData(result);
                    }
                );

                vm.setting.properties["searchCriteria"]["searchKeys"] = isData
                    ? vm.setting.properties["searchCriteria"]["searchKeys"]
                    : {};
            }

            if (vm.setting.properties.resolverType === "LOOKUP") {
                var dataModelId = SmartFlowBuilder.getDataModelId();

                if (!dataModelId) {
                    vm.loadingData = false;
                    return;
                }

                setDataModelProperties(dataModelId);
            }
        };

        vm.setMetaData = function (result) {
            angular.forEach(result, function (metaData) {
                var value = metaData.split(".").join("##");
                var data = {
                    label: metaData,
                    value: value,
                };
                vm.dynamicObject.push(data);
            });
        };

        vm.onResolverTypeChange = function () {
            if (vm.setting.properties.resolverType === "QUERY") {
                vm.setting.properties["searchCriteria"] = {};
                vm.setting.properties.searchCriteria["searchKeys"] = {};
                vm.objects = [];

                initQueryData();
            }

            if (vm.setting.properties.resolverType === "LOOKUP") {
                vm.onObjectTypeChange();
            }
            if (vm.setting.properties.resolverType === "DATAMODEL") {
                initDatamodel();
            }
        };

        vm.showProperties = function (object, index) {
            $mdDialog
                .show({
                    controller: "JobFlowMoleculesPropertiesController",
                    controllerAs: "vm",
                    templateUrl:
                        "modules/smartflow/jobflow-molecules-properties.tmpl.html",
                    escapeToClose: true,
                    clickOutsideToClose: true,
                    locals: {
                        dataModelProperties: vm.dataModelProperties,
                        type: vm.setting.properties["objectType"],
                    },
                    multiple: true,
                })
                .then(function (result) {
                    vm.setting.properties.searchCriteria.searchKeys[
                        result.name
                    ] = "";
                    vm.objects[index].data_model_value = result.name;

                    var datamodelKeys = [];
                    angular.forEach(vm.objects, function (row) {
                        datamodelKeys.push(row.data_model_value);
                    });
                    for (var key in vm.setting.properties.searchCriteria.searchKeys) {
                        if (datamodelKeys.length && datamodelKeys.indexOf(key) == -1) {
                            delete vm.setting.properties.searchCriteria.searchKeys[key];
                        }
                    }
                });
        };

        vm.addRow = function () {
            var obj = {};
            angular.forEach(vm.resolverList, function (value) {
                obj[value] = undefined;
            });

            vm.lookUpData.push(obj);
        };

        vm.deleteRow = function (index) {
            vm.lookUpData.splice(index, 1);
        };

        function initLookUp() {
            var properties = angular.copy(vm.setting.properties);
            vm.resolverList = [];
            vm.lookUpData = [];
            var obj = {};

            angular.forEach(properties.lookupCriteria, function (row) {
                obj = {};
                angular.forEach(row.conditionGroup.conditions, function (
                    value
                ) {
                    obj[value.operand] = value.value;
                    if (!vm.resolverList[value.operand]) {
                        vm.resolverList.push(value.operand);
                    }
                });

                obj["onSuccessResult"] = row.onSuccessResult;
                vm.lookUpData.push(obj);
            });
        }

        function init() {
            vm.setting = angular.copy(setting);
            vm.setting.properties.objectType = "Team";

            if (!vm.setting.properties.resolverType) {
                vm.setting.properties.resolverType = "STATIC";
            }

            if (vm.setting.properties.resolverType === "LOOKUP") {
                initLookUp();
            }
            if (vm.setting.properties.resolverType === "DATAMODEL") {
                initDatamodel();
            }
            if (
                !vm.setting.properties.resolverType ||
                vm.setting.properties.resolverType !== "QUERY"
            ) {
                if (vm.setting.properties.objectType) {
                    vm.onObjectTypeChange();
                }
                return;
            }

            initQueryData();
        }

        vm.addField = function (key) {
            var obj = angular.copy(object);
            obj.data_model_value = key ? key : "";
            vm.objects.push(obj);
        };

        vm.removeField = function (id, obj) {
            vm.objects.splice(id, 1);
            delete vm.setting.properties.searchCriteria.searchKeys[
                obj.data_model_value
            ];
        };

        function initDatamodel() {
            vm.loadingData = true;
            vm.selectedDataModelId = SmartFlowBuilder.getDataModelId();
            if (!vm.selectedDataModelId) {
                vm.loadingData = false;
                return;
            }
            setDataModelProperties(vm.selectedDataModelId);
        }

        function initQueryData() {
            var dataModelId = SmartFlowBuilder.getDataModelId();
            setDataModelProperties(dataModelId);

            var keys = Object.keys(vm.setting.properties.searchCriteria);
            var searchKeyList = Object.keys(
                vm.setting.properties.searchCriteria.searchKeys
            );
            var searchKeyObject = {};

            angular.forEach(searchKeyList, function (searchKey) {
                searchKeyObject[
                    vm.setting.properties.searchCriteria.searchKeys[searchKey]
                ] = searchKey;
            });

            vm.setting.properties.searchCriteria.searchKeys = searchKeyObject;

            if (keys && keys.length > 0) {
                var searchKeys = Object.keys(
                    vm.setting.properties.searchCriteria.searchKeys
                );
                if (
                    searchKeys &&
                    searchKeys.length > 0 &&
                    vm.setting.properties["resolverType"] === "QUERY"
                ) {
                    angular.forEach(searchKeys, function (key) {
                        vm.addField(key);
                    });
                } else {
                    vm.addField();
                }
                vm.onObjectTypeChange(true);
            } else {
                vm.resolverType = true;
                vm.addField();
            }
        }

        function setDataModelProperties(dataModelId) {
            JobFlow.getDataModelById({ id: dataModelId }, function (result) {
                vm.dataModelProperties = result.properties;
                vm.loadingData = false;
            });
        }

        init();
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.smartFlow")
        .controller(
            "JobFlowMoleculesAirFormResolverController",
            JobFlowMoleculesAirFormResolverController
        );

    /* @ngInject */
    function JobFlowMoleculesAirFormResolverController(
        $mdDialog,
        JobFlow,
        setting,
        DataModel,
        SmartFlowBuilder,
        $q,
        $filter
    ) {
        var vm = this;
        vm.object = {
            dataSetId: "",
            dataSetColumnId: "",
            dataModelPropertyName: "",
            outputColumnId: "",
        };
        vm.loadingData = true;
        vm.listItems = [];
        vm.staticObject = [];
        vm.datasetObject = [];
        vm.datasetColumnsObject = [];
        vm.dataModels = [];
        vm.isStaticObjectLoaded = false;
        vm.isDynamicObjectLoaded = false;
        vm.dataset = "";

        vm.resolverTypeList = [
            { name: "Static", value: "STATIC" },
            { name: "Dataset Lookup", value: "DATASET" },
        ];
        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.submit = function () {
            var rawData = angular.copy(vm.setting.properties);
            vm.setting.properties = {};
            if (rawData.resolverType === "STATIC") {
                vm.setting.properties = {
                    objectType: rawData.objectType,
                    staticResult: rawData.staticResult,
                    resolverType: rawData.resolverType,
                };
            } else if (rawData.resolverType === "DATASET") {
                vm.setting.properties = {
                    objectType: rawData.objectType,
                    dataSetQueryCriteria: rawData.dataSetQueryCriteria,
                    resolverType: rawData.resolverType,
                };
            }
            $mdDialog.hide(vm.setting);
        };

        vm.onResolverTypeChange = function () {
            if (vm.setting.properties.resolverType === "DATASET") {
                getDatasetQueryData();
            }

            if (vm.setting.properties.resolverType === "STATIC") {
                getStaticResults();
            }
        };

        vm.onSelectDataset = function () {
            vm.loadingData = true;
            JobFlow.getDatasetColumns(
                { id: vm.setting.properties.dataSetQueryCriteria.dataSetId },
                function (data) {
                    vm.loadingData = false;
                    vm.datasetColumnsObject = data;
                }
            );
        };

        function getDatasetQueryData() {
            vm.setting.properties.resolverType = "DATASET";
            vm.setting.properties.objectType = "AiRForm";
            vm.loadingData = true;
            var dataModelId = SmartFlowBuilder.getDataModelId();
            if (!dataModelId) {
                vm.loadingData = false;
                return;
            } else {
                if (!vm.setting.properties.dataSetQueryCriteria) {
                    vm.setting.properties["dataSetQueryCriteria"] = vm.object;
                    $q.all([
                        JobFlow.getDatasets().$promise,
                        JobFlow.getDataModelById({ id: dataModelId }).$promise,
                    ]).then(function (data) {
                        vm.loadingData = false;
                        vm.isDynamicObjectLoaded = true;
                        vm.datasetObject = data[0];
                        vm.dataModels = data[1].properties;
                    });
                } else if (
                    vm.setting.properties.dataSetQueryCriteria.dataSetId !== ""
                ) {
                    vm.object = vm.setting.properties.dataSetQueryCriteria;
                    $q.all([
                        JobFlow.getDatasets().$promise,
                        JobFlow.getDatasetColumns({
                            id:
                                vm.setting.properties.dataSetQueryCriteria
                                    .dataSetId,
                        }).$promise,
                        JobFlow.getDataModelById({ id: dataModelId }).$promise,
                    ]).then(function (data) {
                        vm.loadingData = false;
                        vm.isDynamicObjectLoaded = true;
                        vm.datasetObject = data[0];
                        vm.datasetColumnsObject = data[1];
                        vm.dataModels = data[2].properties;
                    });
                }
            }
        }
        function getStaticResults() {
            vm.setting.properties.resolverType = "STATIC";
            vm.setting.properties.objectType = "AiRForm";

            JobFlow.getObjectList(
                { objectType: vm.setting.properties["objectType"] },
                function (result) {
                    vm.loadingData = false;
                    vm.isStaticObjectLoaded = true;
                    vm.staticObject = result;
                }
            );
        }
        function init() {
            vm.setting = angular.copy(setting);
            if (!vm.setting.properties.resolverType) {
                vm.setting.properties.resolverType = "STATIC";
                getStaticResults();
            } else if (vm.setting.properties.resolverType === "DATASET") {
                getDatasetQueryData();
            } else {
                getStaticResults();
            }
        }

        init();
    }
})();
;
(function () {
	"use strict";

	angular
		.module("atheer.smartFlow")
		.controller(
			"JobFlowInsightsOverviewController",
			JobFlowInsightsOverviewController
		);

	/* @ngInject */
	function JobFlowInsightsOverviewController(
		$scope,
		$filter,
		JobFlow,
		id,
		SmartFlow,
		$state,
		SmartFlowBuilder,
		Report,
		$mdDialog,
		name,
		WORFLOW_CELL_CONSTANT,
		paginationConstants
	) {
		var vm = this;
		vm.smartFlowModel = { id: id, name: name };
		vm.viewType = "insights";
		vm.loadingData = true;
		vm.runList = [];
		vm.query = {
			limit: paginationConstants.itemsPerPage,
			page: 1
		}
		vm.init = init;

		var query = "workflowId==" + id;
		var category = "";

		vm.goToSmartFlows = function () {
			$state.go("storm.admin-smartflows");
		};

		vm.openJobDetails = function (job) {
			$mdDialog
				.show({
					animation: true,
					templateUrl:
						"modules/smartflow/jobflow-insights-job-detail.tmpl.html",
					controller: "JobFlowInsightsJobDetailsController",
					controllerAs: "vm",
					backdrop: "static",
					size: "lg",
					data: job,
					resolve: {
						entity: function () {
							return {
								id: null,
								name: null,
								properties: [],
							};
						},
					},
				})
		}

		vm.openErrorDetails = function (data) {
			$mdDialog
				.show({
					animation: true,
					templateUrl:
						"modules/smartflow/jobflow-insights-error-detail.tmpl.html",
					controller: "JobFlowInsightsErrorDetailsController",
					controllerAs: "vm",
					backdrop: "static",
					size: "lg",
					data: data
				})
		}

		vm.openInputDetails = function (inputData, key) {
            $mdDialog
                .show({
                    animation: true,
                    templateUrl:
                        "modules/smartflow/jobflow-insights-input-detail.tmpl.html",
                    controller: "JobFlowInsightsInputDetailsController",
                    controllerAs: "vm",
                    backdrop: "static",
                    size: "lg",
                    data: inputData,
                    inputId: key
                });
		}

		function init() {
            category = SmartFlowBuilder.getSmartFlowCategory();
			JobFlow.query(
				{
					page: vm.query.page - 1,
					size: vm.query.limit,
					query: query,
					sort: 'startDate,desc'
				},
				function (result, headers) {
					vm.loadingData = false;
					vm.runList = result;
					vm.queryCount = headers("x-total-count");
					angular.forEach(vm.runList, function (run) {
						var job = []
						angular.forEach(run.outputs, function (output) {
							if (output.outputReference) {
								job.push(output.outputReference);
							}
						});

						var inputList = [];
						angular.forEach(run.inputs, function (inputData, key) {
							if (inputData.properties) {
								inputList.push({ key: key, value: inputData.properties });
							}
						});

						run["inputList"] = inputList;
						run["jobNumberList"] = job;
					})
				}
			);
		}

		init();
	}
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.smartFlow")
        .controller(
            "JobFlowInsightsJobDetailsController",
            JobFlowInsightsJobDetailsController
        );

    /* @ngInject */
    function JobFlowInsightsJobDetailsController($mdDialog, JobFlow, data) {
        var vm = this;
        vm.loadingData = true;

        vm.clear = function () {
            $mdDialog.hide();
        };

        function init() {
            JobFlow.getJobDetail(
                {
                    query: "jobNumber==" + data,
                },
                function (result) {
                    vm.loadingData = false;
                    vm.jobList = [
                        {
                            id: data,
                            airform: result[0].airformRef.name,
                            team: result[0].team ? result[0].team.name : "",
                            assignedTo: result[0].owner
                                ? result[0].owner.fullName
                                : "",
                        },
                    ];
                }
            );
        }

        init();
    }
})();
;
(function () {
	"use strict";

	angular
		.module("atheer.smartFlow")
		.controller("JobFlowInsightsInputDetailsController", JobFlowInsightsInputDetailsController);

	/* @ngInject */
	function JobFlowInsightsInputDetailsController(
		$mdDialog,
		inputId,
		data
	) {
		var vm = this;
		vm.loadingData = false;

		vm.clear = function () {
			$mdDialog.hide();
		};

		function init() {
			vm.headerList = [];
			vm.inputList = [];

			vm.headerList.push("atheer.smartFlow.insights.inputId");
			vm.inputList.push(inputId);

			angular.forEach(data, function (input, key) {
				vm.headerList.push(key);
				vm.inputList.push(input);
			})
		}

		init();
	}
})();
;
(function () {
	"use strict";

	angular
		.module("atheer.smartFlow")
		.controller("JobFlowInsightsErrorDetailsController", JobFlowInsightsErrorDetailsController);

	/* @ngInject */
	function JobFlowInsightsErrorDetailsController(
		$mdDialog,
		JobFlow,
		data
	) {
		var vm = this;
		vm.error = data.errors;
		vm.loadingData = true;

		vm.clear = function () {
			$mdDialog.hide();
		};

		function init() {
			vm.headerList = ["atheer.smartFlow.name", "atheer.smartFlow.detail.startDate", "atheer.smartFlow.detail.endDate", "atheer.smartFlow.insights.batchId", "atheer.smartFlow.status"];
			vm.errorList = [];

			JobFlow.getExecutionDetail(
				{
					id: data.executionId
				},
				function (result) {
					vm.loadingData = false;
					angular.forEach(result.activityLogs, function (log) {
						vm.errorList.push([log.activityName, log.startDate, log.endDate, log.batchId, log.status])
					})
				}
			);
		}

		init();
	}
})();
;
(function () {

    'use strict';

    angular
        .module('atheer.smartFlow')
        .service('JobFlowBuilder', JobFlowBuilder);

    function JobFlowBuilder($http) {
        var jobStencil = {};
        jobStencil.config = {};
        jobStencil.config.stencil = {};
        jobStencil.config.stencil.shapes = {};
        joint.shapes.smartflow = {};

        joint.shapes.smartflow.Base = joint.shapes.basic.Generic.extend({
            markup: '<g class="rotatable"><g class="scalable"><image/></g><text/></g>',
            defaults: joint.util.deepSupplement({
                type: 'smartflow.Base',
                size: {
                    width: 50,
                    height: 50
                },
                attrs: {
                    image: {
                        width: 45,
                        height: 45
                    },
                    text: {
                        text: '',
                        'text-anchor': 'middle',
                        'ref-x': .5,
                        'ref-dy': 15,
                        'font-family': 'RobotoDraft, Roboto, Helvetica Neue, sans-serif',
                        'font-weight': 'Normal',
                        'font-size': 14,
                        display: '',
                        stroke: '#000',
                        'stroke-width': 0,
                        'fill': '#222138'
                    }
                }
            }, joint.shapes.basic.Generic.prototype.defaults),
            updateSetting: function (setting) {
                //do nothing
                this.prop('setting', setting);
                var title = this.prop('setting/title');
                if (title) {
                    this.updateTitle(title);
                    setting.isConfigured = true;
                } else {
                    // this.updateTitle(title);
                }
            },
            validate: function () {
                //do nothing
                var setting = this.prop('setting');
                if (Object.keys(setting.properties).length == 0) {
                    return false;
                } else {
                    return true;
                }
            },
            updateTitle: function (title) {
                var wrapText = joint.util.breakText(title, {
                    width: 100
                });
                var lines = wrapText.split(/\r\n|\r|\n/).length;
                this.attr('text', { text: wrapText, 'data-tooltip': title });
            }
        });

        var service = {
            getCategories: getCategories,
            buildStencil: buildStencil
        }

        return service;

        function getCategories() {
            return $http.get('/i18n/en/jobflow-builder.json');
        }

        function buildMoleculeObject(molecule) {
            var molObj = {};
            molObj.type = (molecule.type) ? molecule.type : '';
            molObj.typeId = (molecule.typeId) ? molecule.typeId : '';
            molObj.pageId = (molecule.pageId) ? molecule.pageId : '';
            molObj.attrs = {};
            molObj.attrs.image = {};
            molObj.attrs.text = {};
            molObj.attrs.image['xlink:href'] = (molecule.icon) ? molecule.icon : '';
            molObj.attrs.text.text = (molecule.text) ? molecule.text : '';
            molObj.active = (molecule.isActive) ? molecule.isActive : null;
            molObj.setting = {};
            molObj.setting.properties = {};
            molObj.slices = (molecule.type == 'smartflow.End') ? null : {};
            molObj.isAllowedTitleChange = (molecule.isAllowedTitleChange) ? molecule.isAllowedTitleChange : false;
            molObj.isValidationRequired = (molecule.isValidationRequired) ? molecule.isValidationRequired : false;
            molObj.smartFlowStencilType = (molecule.smartFlowStencilType) ? molecule.smartFlowStencilType : '';
            if (molecule.data) {
                molObj.setting.data = molecule.data;
            }
            if (molecule.isConfigured) {
                molObj.setting.isConfigured = molecule.isConfigured;
            }

            if (molecule.title) {
                molObj.setting.title = molecule.title;
            }
            if (molecule.objectType) {
                molObj.setting.properties.objectType = molecule.objectType;
            }

            if (molObj.slices != null && molecule.color) {
                molObj.slices.color = molecule.color;
            }

            return molObj;
        }

        function extendMoleculeObject(group, molecule, moleculeObject) {
            joint.shapes.smartflow[molecule.name] = joint.shapes.smartflow[group.name].extend({
                defaults: joint.util.deepSupplement(moleculeObject, joint.shapes.smartflow.Base.prototype.defaults)
            });

            if (moleculeObject.isAllowedTitleChange) {
                joint.shapes.smartflow[molecule.name].updateSetting = function (setting) {
                    this.prop('setting', setting);
                    var title = this.prop('setting/title');
                    if (title) {
                        this.updateTitle(title);
                        setting.isConfigured = true;
                    } else {
                        this.updateTitle(title);
                    }
                }
            }

            if (moleculeObject.isValidationRequired) {
                joint.shapes.smartflow[molecule.name].validate = function () {
                    var setting = this.prop('setting');
                    if (setting.data.length == 0) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        }

        function buildStencil(data, type) {
            jobStencil.config.stencil.groups = {};

            jobStencil.getPaperCell = function (cell) {
                return cell.clone();
            }

            angular.forEach(data.groups, function (group) {
                if (type === "JOB_EVENT" && group.id === "handlers") {
                    return;
                }

                var molecules = group.molecules;

                joint.shapes.smartflow[group.name] = joint.shapes.smartflow.Base.extend({
                    defaults: joint.util.deepSupplement({}, joint.shapes.smartflow.Base.defaults)
                });

                jobStencil.config.stencil.groups[group.id] = {
                    index: group.index,
                    label: group.label
                };

                jobStencil.config.stencil.shapes[group.id] = [];

                angular.forEach(molecules, function (molecule) {
                    if (molecule.type === 'smartflow.JobScope' && type !== "JOB_EVENT") {
                        return;
                    }

                    var moleculeType = {
                        type: molecule.type
                    };
                    jobStencil.config.stencil.shapes[group.id].push(moleculeType);

                    var moleculeObject = buildMoleculeObject(molecule);
                    extendMoleculeObject(group, molecule, moleculeObject);
                });
            });
            return jobStencil;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .service('SessionsService', SessionsService);

    /* @ngInject */
    function SessionsService($mdDialog, $state, deviceDetector) {
        var annotationImage;

        var service = {
            startInstantSession: startInstantSession,
            startSession: startSession,
            joinSession: joinSession,
            exportSessionsReport: exportSessionsReport
        };
        return service;

        function startInstantSession() {
            $mdDialog
                .show({
                    templateUrl: 'modules/session/session-start-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: 'SessionStartController',
                    controllerAs: 'vm',
                    locals: {
                        filter: null,
                        conversation: null,
                        isMobileBrowser: deviceDetector.isMobile()
                    }
                })
                .then(function (result) { });
        };

        function joinSession() {
            $mdDialog
                .show({
                    templateUrl: 'modules/session/session-join-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: 'SessionJoinController',
                    controllerAs: 'vm',
                    locals: {
                        sessionNo: null,
                        isMobileBrowser: deviceDetector.isMobile()
                    }
                })
                .then(function (result) { });
        };

        function startSession() {
            $state.go('storm.sessions.player', {
                session_no: entity.session_no
            });
        };

        function exportSessionsReport() {
            $mdDialog.show({
                templateUrl: 'modules/session/session-summary-report.tmpl.html',
                clickOutsideToClose: true,
                controller: "sessionSummaryReportController",
                controllerAs: "vm",
            }).then(function (result) {

            });

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsUpcomingController', SessionsUpcomingController);

    /* @ngInject */
    function SessionsUpcomingController(
        $scope,
        $state,
        $q,
        $filter,
        Report,
        Principal,
        CONTENT_META,
        Pubnub,
        Session,
        ParseLinks,
        pagingParams,
        paginationConstants,
        AlertService,
        $mdDialog,
        $mdToast,
        $stateParams,
        Feature,
        Setting,
        User,
        triSettings,
        triTheming,
        $rootScope,
        ToastService,
        PermissionService,
        SessionsService
    ) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;
        vm.scheduleSession = Feature.isActive('feature_airsession_schedule_session');
        vm.templateSession = Feature.isActive('feature_airsession_session_template');
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.uId = Principal.getUser().id;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.removeFilter = removeFilter;
        vm.loadData = loadData;
        vm.color = triSettings.getSkinModel().primary_color_hex;
        vm.personalSession = null;
        vm.backgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value
        );

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };
        vm.filter.show = false;

        vm.illustartionEmptyScreenId = PermissionService.hasAccess('create-session') ?
            vm.scheduleSession ?
            'session_upcoming' :
            'upcoming_no_scheduled_session' :
            'upcoming_no_session';
        vm.illustartionEmptyScreenText = 'There are no sessions yet';

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session',
            manage: 'manage-session'
        };

        vm.isHost = function(session) {
            if (session.owner == vm.uId) {
                return true;
            }
            for (var i = 0; i < session.session_users.length; i++) {
                if (session.session_users[i].user_id == vm.uId) {
                    if (session.session_users[i].role == 'HOST') {
                        return true;
                    }
                }
            }
            return false;
        };

        vm.isParticipant = function (session) {
            for (var i = 0; i < session.session_users.length; i++) {
                if (session.session_users[i].user_id == vm.uId) {
                    if (session.session_users[i].role == "PARTICIPANT") {
                        return true;
                    }
                }
            }
            return false;
        };

        vm.isUserHostOrScheduler = function (session) {
            // if scheduler is present then check if current user is scheduler
            // if scheduler is not present then check if current user is owner
            return angular.isDefined(session.scheduler) &&
                angular.isDefined(session.scheduler.id)
                ? session.scheduler.id === vm.uId
                : session.owner === vm.uId;
        };

        vm.startSession = function(entity) {
            $state.go('storm.sessions.player', {
                session_no: entity.session_no
            });
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.saveAsTemplate = function(entity) {
            var template = angular.copy(entity);
            template.id = null;
            template.type = 'TEMPLATE';
            Session.save(template, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                ToastService.displayToast(
                    $filter('translate')('atheer.session.upcomingSessions.templateCreated'),
                    3000
                );
            }

            function onSaveError() {
                vm.isSaving = false;
            }
        };

        vm.copyInvitation = function (session) {
            $mdDialog.show({
                templateUrl: 'modules/session/session-copy-invitation-dialog.tmpl.html',
                controller: 'SessionCopyInvitationDialogController',
                clickOutsideToClose: true,
                controllerAs: 'vm',
                locals: {
                    session: session
                }
            }).then(function (result) {

            });
        };

        vm.startInstantSession = function() {
            SessionsService.startInstantSession();
        };

        vm.joinSession = function() {
            SessionsService.joinSession();
        };

        vm.scheduleSession = function() {
            $state.go('storm.sessions.upcoming-detail');
        };

        vm.endSession = function (session) {
            session.status = 'CLOSED';
            session.duration = 1;
            Session.update(session, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                ToastService.displayToast($filter('translate')('atheer.session.endSessionSuccess'), 3000);
                loadData();
            };

            function onSaveError() {
                ToastService.displayToast($filter('translate')('atheer.session.endSessionError'), 3000);
            };
        };

        vm.refresh = function() {
            loadData();
        };

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Session.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                scheduled: true
            }).$promise;

            function sort() {
                var result = [getSortOrder()];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }
        }

        function createObject() {
            $state.go('storm.sessions.upcoming-detail');
        }

        function editObject(objectId) {
            $state.go('storm.sessions.upcoming-detail', {
                id: objectId
            });
        }

        function deleteObject(entity) {
            var confirm = $mdDialog
                .confirm()
                .title($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ariaLabel($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Session.delete({
                        id: entity.id
                    },
                    function() {
                        resetModal();
                    }
                );
            });
        }

        function resetModal() {
            loadData();
            AlertService.displayToast($mdToast);
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function getQueryString() {
            var query = '';
            if (vm.query.filter.length > 0) {
                query = query + '(text_search=' + vm.query.filter + ')';
            }
            return query;
        }

        function loadData() {
            vm.loadingData = true;
            if ($rootScope.isStartSession) {
                vm.startInstantSession();
                $rootScope.isStartSession = false;
            } else if ($rootScope.isJoinSession) {
                vm.joinSession();
                $rootScope.isJoinSession = false;
            }
            Session.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    query: getQueryString(),
                    scheduled: true
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
                $q.all([
                        User.getPersonalSession().$promise
                    ])
                    .then(function(results) {
                        vm.personalSession = results[0];
                        vm.loadingData = false;
                    });
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        var refreshSessionListener = $rootScope.$on('refreshSessions', function(event, filter) {
            vm.query.filter = filter;
            loadData();
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSessionListener();
        });

        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsUpcomingToolbarController', SessionsUpcomingToolbarController);

    /* @ngInject */
    function SessionsUpcomingToolbarController($rootScope, $scope, $state, $mdDialog, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService, SessionsService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.refreshAll = function() {
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.removeFilter = function() {
            vm.filter.show = false;
            vm.query.filter = '';
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.startInstantSession = function() {
            SessionsService.startInstantSession();
        };

        vm.joinSession = function() {
            SessionsService.joinSession();
        };

        vm.scheduleSession = function() {
            $state.go('storm.sessions.upcoming-detail');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsPastController', SessionsPastController);

    /* @ngInject */
    function SessionsPastController($rootScope, $scope, $state, $q, $filter, $mdSidenav, $location, Report, Media, CONTENT_META, Pubnub, Session, ParseLinks, pagingParams, paginationConstants, AlertService, $mdDialog, $mdToast, $stateParams, Feature, Experience) {
        var vm = this;

        vm.loadingData = false;
        vm.scheduleSession = Feature.isActive('feature_airsession_schedule_session');
        vm.sessionActivity = null;
        vm.sessionModel = null;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.panelToShow = null;
        vm.illustartionEmptyScreenId = "session_past";
        vm.illustartionEmptyScreenText = "There are no sessions yet";
        vm.removeFilter = removeFilter;
        vm.loadData = loadData;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };
        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.createObject = function() {
            $state.go('storm.sessions.upcoming-detail');
        };

        vm.deleteObject = function(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ariaLabel($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Session.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

       vm.editObject = function(entity) {
            $mdDialog.show({
                templateUrl: 'modules/session/session-past-edit.tmpl.html',
                clickOutsideToClose: true,
                controller: "SessionPastEditController",
                controllerAs: "vm",
                 locals: {
                       filter: entity.id
                    }
            }).then(function(result) {
                resetModal();
            });
        };

        function resetModal() {
            loadData();
            AlertService.displayToast($mdToast);
        };

        vm.togglePanel = function(componentId, session) {
            vm.sessionModel = null;
            if (session) {
                vm.sessionModel = session;
            }
            if(componentId == 'insightsPanel') {
                vm.panelToShow = 'insightsPanel';
            } else if (componentId == 'annotationsPanel') {
                vm.panelToShow = 'annotationsPanel';
            } else if (componentId == 'recordingsPanel'){
                vm.panelToShow = 'recordingsPanel';
            } else if (componentId == 'conversationPanel') {
                vm.panelToShow = 'conversationPanel';
            }

            $mdSidenav(componentId).toggle()
                .then(function() {

                });
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        }

        vm.refresh = function() {
            loadData();
        };

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Session.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                previous: true
            }).$promise;

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('id')) {
                return vm.predicate + ',' + 'desc';
            }

            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function getQueryString() {
            var query = '';
            if (vm.query.filter.length > 0) {
                query = query + '(text_search=' + vm.query.filter + ')';
            }
            return query;
        };

        function loadData() {
            vm.loadingData = true;
            Session.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                previous: true
            }, onSuccess, onError);

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        var refreshSessionListener = $rootScope.$on('refreshSessions', function(event, filter) {
            vm.query.filter = filter;
            loadData();
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSessionListener();
        });

        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsPastToolbarController', SessionsPastToolbarController);

    /* @ngInject */
    function SessionsPastToolbarController($rootScope, $scope, $state, $mdDialog, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService, SessionsService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.refreshAll = function() {
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.removeFilter = function() {
            vm.filter.show = false;
            vm.query.filter = '';
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.startInstantSession = function() {
            SessionsService.startInstantSession();
        };

        vm.joinSession = function() {
            SessionsService.joinSession();
        };

        vm.scheduleSession = function() {
            $state.go('storm.sessions.upcoming-detail');
        };

        vm.goBack = function() {
            $state.go('storm.sessions.upcoming');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsAllController', SessionsAllController);

    /* @ngInject */
    function SessionsAllController($rootScope, $scope, $state, $q, $filter, $mdSidenav, Report, CONTENT_META, Pubnub, Session, ParseLinks, pagingParams, paginationConstants, AlertService, $mdDialog, $mdToast, $stateParams, Feature, Experience, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.scheduleSession = Feature.isActive('feature_airsession_schedule_session');
        vm.sessionModel = null;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.panelToShow = null;
        vm.illustartionEmptyScreenId = "session_all";
        vm.illustartionEmptyScreenText = "There are no sessions yet";
        vm.removeFilter = removeFilter;
        vm.loadData = loadData;
        vm.deleteObject = deleteObject;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };
        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.joinSession = function() {
            $mdDialog.show({
                templateUrl: 'modules/session/session-join-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "SessionJoinController",
                controllerAs: "vm",
                locals: {
                    sessionNo: null
                }
            }).then(function(result) {

            });
        };

        vm.createObject = function() {
            $state.go('storm.sessions.upcoming-detail');
        };

        vm.togglePanel = function(componentId, session) {
            if (session) {
                vm.sessionModel = session;
            }

            if(componentId == 'insightsPanel') {
                vm.panelToShow = 'insightsPanel';
            } else if (componentId == 'annotationsPanel') {
                vm.panelToShow = 'annotationsPanel';
            } else if (componentId == 'recordingsPanel'){
                vm.panelToShow = 'recordingsPanel';
            } else if (componentId == 'conversationPanel') {
                vm.panelToShow = 'conversationPanel';
            }

            $mdSidenav(componentId).toggle()
                .then(function() {

                });
        };

        vm.endSession = function (session) {
            session.status = 'CLOSED';
            session.duration = 1;
            Session.update(session, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                ToastService.displayToast($filter('translate')('atheer.session.endSessionSuccess'), 3000);
                loadData();
            };

            function onSaveError() {
                ToastService.displayToast($filter('translate')('atheer.session.endSessionError'), 3000);
            };
        };

        vm.refresh = function() {
            loadData();
        };

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Session.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                all: true
            }).$promise;

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
            });
        };

        vm.editObject = function(entity) {
            $mdDialog.show({
                templateUrl: 'modules/session/session-past-edit.tmpl.html',
                clickOutsideToClose: true,
                controller: "SessionPastEditController",
                controllerAs: "vm",
                 locals: {
                       filter: entity.id
                    }
            }).then(function(result) {
                vm.refresh();
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('id')) {
                return vm.predicate + ',' + 'desc';
            }

            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function getQueryString() {
            var query = '';
            if (vm.query.filter.length > 0) {
                query = query + '(text_search=' + vm.query.filter + ')';
            }
            return query;
        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ariaLabel($filter('translate')('atheer.session.upcomingSessions.deleteSession'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Session.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadData();
            AlertService.displayToast($mdToast);
        };

        function loadData() {
            vm.loadingData = true;
            Session.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                all: true
            }, onSuccess, onError);

            function sort() {
                var result = [getSortOrder()];

                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        var refreshSessionListener = $rootScope.$on('refreshSessions', function(event, filter) {
            vm.query.filter = filter;
            loadData();
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSessionListener();
        });

        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsAllToolbarController', SessionsAllToolbarController);

    /* @ngInject */
    function SessionsAllToolbarController($rootScope, $scope, $state, $mdDialog, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService, SessionsService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.refreshAll = function() {
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.removeFilter = function() {
            vm.filter.show = false;
            vm.query.filter = '';
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.exportSessionsReport = function() {
            SessionsService.exportSessionsReport();
        };

        vm.goBack = function() {
            $state.go('storm.sessions.upcoming');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, triMenuProvider) {

        $stateProvider
            .state('storm.sessions', {
                url: '/sessions',
                abstract: true,
                templateUrl: 'modules/session/session.tmpl.html',
                controller: 'SessionController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true
                    }
                }
            })
            .state('storm.sessions.player', {
                url: '/player/:session_no',
                templateUrl: 'modules/session/session-player.tmpl.html',
                controller: 'SessionPlayerController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.session.home.live',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                        sideMenuSize: 'hidden'
                    }
                },
                resolve: {
                    session_no: function($stateParams) {
                        return $stateParams.session_no;
                    }
                }
            })
            .state('storm.sessions.upcoming', {
                url: '/upcoming',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/sessions-upcoming.tmpl.html',
                        controller: 'SessionsUpcomingController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/sessions-upcoming-toolbar.tmpl.html',
                        controller: 'SessionsUpcomingToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.upcoming',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'active_session,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.sessions.upcoming-detail', {
                url: '/upcoming/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/session-detail.tmpl.html',
                        controller: 'SessionDetailController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/session-detail-toolbar.tmpl.html',
                        controller: 'SessionsDetailToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.template',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    sessionType: function($stateParams) {
                        return 'SCHEDULED';
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.sessions.past', {
                url: '/past',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/sessions-past.tmpl.html',
                        controller: 'SessionsPastController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/sessions-past-toolbar.tmpl.html',
                        controller: 'SessionsPastToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.past',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.sessions.past-recording', {
                url: '/past/:session_no',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/sessions-past.tmpl.html',
                        controller: 'SessionsPastController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/sessions-past-toolbar.tmpl.html',
                        controller: 'SessionsPastToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.past',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.sessions.personal', {
                url: '/personal',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/session-detail.tmpl.html',
                        controller: 'SessionDetailController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/session-detail-toolbar.tmpl.html',
                        controller: 'SessionsDetailToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.personal',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    sessionType: function($stateParams) {
                        return 'PERSONAL';
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.sessions.all', {
                url: '/all',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/sessions-all.tmpl.html',
                        controller: 'SessionsAllController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/sessions-all-toolbar.tmpl.html',
                        controller: 'SessionsAllToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.all',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.sessions.templates', {
                url: '/templates',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/session-templates.tmpl.html',
                        controller: 'SessionTemplatesContoller',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/session-templates-toolbar.tmpl.html',
                        controller: 'SessionTemplatesToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.template',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.sessions.template-detail', {
                url: '/templates/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/session/session-detail.tmpl.html',
                        controller: 'SessionDetailController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/session/session-detail-toolbar.tmpl.html',
                        controller: 'SessionsDetailToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    pageTitle: 'atheer.session.home.template',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        showToolbar: false,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    sessionType: function($stateParams) {
                        return 'TEMPLATE';
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionController', SessionController);

    /* @ngInject */
    function SessionController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;
        };

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionZoomPosition', sessionZoomPosition);

    function sessionZoomPosition() {
        var directive = {
            scope: {
                zoom: '=',
                onPositionChange: '=',
                onPositionRelease: '='
            },
            bindToController: true,
            controller: sessionZoomPositionController,
            controllerAs: 'vm',
            template: '<div style="position: absolute; height: 160px; width: 240px; right: 30px; bottom: 6px; z-index: 40; border: 1px solid gray">\n' +
                '            <div class="small-box" style="position: absolute; cursor: move;\n' +
                '             width: 50%; height: 50%;border:1px solid #000; background-color: #9999993d;"></div>\n' +
                '            <div ng-click="vm.onClick($event)" style="position: absolute; height: 160px; width: 240px; z-index: -1;">\n' +
                '            </div>\n' +
                '        </div>',
            restrict: 'E',
        };
        return directive;
    };

    /* @ngInject */
    function sessionZoomPositionController($scope, $element) {
        var vm = this;
        vm.boxWidth = 120;
        vm.boxHeight = 80;
        vm.largeBoxWidth = $element[0].children[0].clientWidth;
        vm.largeBoxHeight = $element[0].children[0].clientHeight;

        var smallBox = $element[0].querySelector('.small-box');
        dragElement(smallBox);

        $scope.$watch('vm.zoom', function (zoom) {
            if (zoom) {
                var zoomPercent = 100 / zoom;
                smallBox.style.width = zoomPercent + '%';
                smallBox.style.height = zoomPercent + '%';
                var width = zoomPercent * vm.largeBoxWidth;
                var height = zoomPercent * vm.largeBoxHeight;
                vm.boxWidth = width / 100;
                vm.boxHeight = height / 100;
                limitBorders((vm.largeBoxWidth - vm.boxWidth)/2, (vm.largeBoxHeight - vm.boxHeight)/2);
                vm.onPositionRelease();
            }
        });

        function limitBorders(x, y) {
            if (x >= vm.largeBoxWidth / (2 * vm.zoom)) {
                x = Math.min(x, vm.largeBoxWidth - vm.boxWidth);
            } else {
                x = Math.max(x, 0);
            }

            if (y >= vm.largeBoxHeight / (2 * vm.zoom)) {
                y = Math.min(y, vm.largeBoxHeight - vm.boxHeight);
            } else {
                y = Math.max(y, 0);
            }

            if (x + vm.boxWidth > vm.largeBoxWidth) {
                x = vm.largeBoxWidth - vm.boxWidth;
            }

            if (y + vm.boxHeight > vm.largeBoxHeight) {
                y = vm.largeBoxHeight - vm.boxHeight;
            }

            smallBox.style.left = x + 'px';
            smallBox.style.top = y + 'px';
            vm.onPositionChange((x + (vm.boxWidth / 2)) / vm.largeBoxWidth, (y + (vm.boxHeight / 2)) / vm.largeBoxHeight);
        };

        vm.onClick = function (event) {
            // 2 is to get half-width or half-height of the small box
            limitBorders(event.offsetX - (vm.boxWidth / 2), event.offsetY - (vm.boxHeight / 2));
        };

        function dragElement(element) {
            var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
            element.onmousedown = dragMouseDown;

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                document.onmousemove = elementDrag;
            };

            function elementDrag(e) {
                e = e || window.event;
                e.preventDefault();
                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;
                limitBorders(element.offsetLeft - pos1, element.offsetTop - pos2);
            };

            function closeDragElement() {
                vm.onPositionRelease();
                document.onmouseup = null;
                document.onmousemove = null;
            };
        };
    };
})();;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionUserInviteController', SessionUserInviteController);

    /* @ngInject */
    function SessionUserInviteController($scope, $state, System, User, triSettings, allowMultiSelect, filter, userslist, ParseLinks, AlertService, $mdDialog, Principal, Feature, isAdmin, isSession, isScheduledSession, isConversationSession, isSmartScan, paginationConstants, schedulerUserInfo, isSessionSingleUserInvite, autoCompleteModel, selectedItemIds) {
        var vm = this;

        vm.loadingData = false;
        vm.view = "USERS";
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.changeSort = changeSort;
        vm.allowMultiSelect = allowMultiSelect;
        vm.userInviteFilter = angular.isDefined(selectedItemIds) && !selectedItemIds.length ? [] : selectedItemIds;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "";
        vm.page = 1;
        vm.reverse = true;
        vm.userFilter = userslist.length == 0 ? [] : userslist;
        vm.isSession = isSession;
        vm.isAdmin = isAdmin;
        vm.isConversationSession = isConversationSession;
        vm.isSmartScan = isSmartScan;
        vm.illustartionEmptyScreenId = "no_users_session";
        vm.isInviteByEmail = false;
        vm.isInviteByPhone = false;
        vm.isInviteByDeviceId = false;
        vm.email = '';
        vm.code = '';
        vm.phoneNumber = '';
        vm.deviceId = '';
        vm.guestUsers = [];
        vm.phoneNumberPattern = /\b\d{5,20}\b/;
        vm.deviceIdPattern = /[a-zA-Z0-9]{1,10}/;
        vm.hasError = false;
        vm.promise;
        vm.countryCodes = [];
        vm.selectedCountryCode = '';
        vm.defaultCountryCode = {};
        vm.isScheduledSession = isScheduledSession;
        vm.isValidating = false;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.isGuestFeature = Feature.isActive('feature_airsession_invite_guest_user') && !isSessionSingleUserInvite;
        vm.isSmsFeatureEnabled = Feature.isActive('feature_airsession_enable_sms_invite');
        vm.isEmailFeatureEnabled = Feature.isActive('feature_airsession_enable_email_invite');
        vm.isEmailGuestEnabled = Feature.isActive('feature_airsession_enable_email_invite');
        vm.isSmsGuestEnabled = Feature.isActive('feature_airsession_enable_sms_invite');
        vm.totalItems = null;
        vm.isSessionSingleUserInvite = isSessionSingleUserInvite;
        vm.isGuestButtonVisible = true;
        // For multi-select it will be array and for single select it will be object
        vm.currentSelectedUsers = autoCompleteModel
            ? Array.isArray(autoCompleteModel)
                ? angular.copy(autoCompleteModel)
                : [autoCompleteModel]
            : [];

        vm.isAddButtonDisabled = function() {
            if(vm.isSessionSingleUserInvite) {
                return vm.currentSelectedUsers.length <= 0    
            }
            return vm.currentSelectedUsers.length <= 0 && !vm.userInviteFilter.length
        }

        vm.languages = [
            { name: 'english_us', displayName: 'English (US)', value: 'en_US', serverKey: 'en_US' },
            { name: 'english_uk', displayName: 'English (UK)', value: 'en_GB', serverKey: 'en_GB' },
            { name: 'french', displayName: 'French', value: 'fr_FR', serverKey: 'fr_FR' },
            { name: 'german', displayName: 'German', value: 'de_DE', serverKey: 'de_DE' },
            { name: 'greek', displayName: 'Greek', value: 'el_GR', serverKey: 'el_GR' },
            { name: 'italian', displayName: 'Italian', value: 'it_IT', serverKey: 'it_IT' },
            { name: 'japanese', displayName: 'Japanese', value: 'ja_JP', serverKey: 'ja_JP' },
            { name: 'portuguese', displayName: 'Portuguese', value: 'pt_BR', serverKey: 'pt_BR' },
            { name: 'spanish', displayName: 'Spanish', value: 'es_CL', serverKey: 'es_CL' },
            { name: 'chinese', displayName: 'Chinese (Traditional)', value: 'zh_TW', serverKey: 'zh_TW' },
            { name: 'chinese_cn', displayName: 'Chinese (Simplified)', value: 'zh_CN', serverKey: 'zh_CN' },
            { name: 'dutch', displayName: 'Dutch', value: 'nl_NL', serverKey: 'nl_NL' },
            { name: 'danish', displayName: 'Danish (Denmark)', value: 'da_DK', serverKey: 'da_DK' },
            { name: 'norwegian', displayName: 'Norwegian', value: 'no_NO', serverKey: 'no_NO' },
            { name: 'polish', displayName: 'Polish (Poland)', value: 'pl_PL', serverKey: 'pl_PL' },
            { name: 'russian', displayName: 'Russian', value: 'ru_RU', serverKey: 'ru_RU' },
            { name: 'swedish', displayName: 'Swedish (Sweden)', value: 'sv_SE', serverKey: 'sv_SE' },
            { name: 'turkish', displayName: 'Turkish (Turkey)', value: 'tr_TR', serverKey: 'tr_TR' }
        ];

        vm.languages.sort(function (a, b) {
            if (a['displayName'] > b['displayName']) {
                return 1;
            } else if (a['displayName'] < b['displayName']) {
                return -1;
            }
            return 0;
        });

        vm.selectedLanguage = "en_US";

        if (isScheduledSession) {
            vm.isGuestButtonVisible = vm.isEmailGuestEnabled || vm.isSmsGuestEnabled;
        }

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-first_name',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.handleInviteByEmail = function () {
            vm.isInviteByDeviceId = false;
            vm.isInviteByEmail = true;
            vm.isInviteByPhone = false;
            reset();
        };

        vm.handleInviteByPhone = function () {
            vm.isInviteByDeviceId = false;
            vm.isInviteByEmail = false;
            vm.isInviteByPhone = true;
            reset();
        };

        vm.handleInviteByDeviceId = function () {
            vm.isInviteByDeviceId = true;
            vm.isInviteByEmail = false;
            vm.isInviteByPhone = false;
            reset();
        };

        vm.addGuestUser = function () {
            if (vm.isInviteByEmail) {
                if(!vm.currentSelectedUsers.find(function (user) { return user.guest_invite_value === vm.email})) {
                    vm.currentSelectedUsers.push({
                        is_guest: true,
                        guest_invite_type: 'EMAIL',
                        guest_invite_value: vm.email,
                        guest_invite_language: vm.selectedLanguage
                    });
                }
                vm.email = '';
            } else if (vm.isInviteByPhone) {
                var phone_no = vm.code + ' ' + vm.phoneNumber;
                if(!vm.currentSelectedUsers.find(function (user) { return user.guest_invite_value === phone_no})) {
                    vm.currentSelectedUsers.push({
                        is_guest: true,
                        guest_invite_type: 'PHONE',
                        guest_invite_value: phone_no,
                        guest_invite_language: vm.selectedLanguage
                    });
                }
                vm.code = vm.defaultCountryCode.code;
                vm.phoneNumber = '';
            } else if (vm.isInviteByDeviceId) {
                vm.hasError = false;
                vm.isValidating = true;
                User.validateDeviceId({ deviceId: vm.deviceId }, function (result) {
                    vm.currentSelectedUsers.push({
                        is_guest: true,
                        guest_invite_type: 'DEVICE_ID',
                        guest_invite_value: result.username,
                        guest_invite_language: vm.selectedLanguage
                    });
                    vm.deviceId = '';
                    vm.isValidating = false;
                }, function () {
                    vm.hasError = true;
                    vm.isValidating = false;
                });
            };
        };

        vm.updateParentObject = function () {
            $mdDialog.hide(vm.currentSelectedUsers);
        };

        vm.onSelectUser = function (user) {
            if(!allowMultiSelect) {
                vm.currentSelectedUsers = [user]
                return;
            }
            if(!vm.currentSelectedUsers.includes(user))
                vm.currentSelectedUsers.push(user);
        };

        vm.onDeselectUser = function (user) {
            var updatedSelectedUsers = vm.currentSelectedUsers.filter(function (value) {
                return value.id != user.id || value.guest_invite_value != user.guest_invite_value;
            });

            vm.currentSelectedUsers = updatedSelectedUsers;
        };

        vm.close = function () {
            $mdDialog.cancel();
        };

        function formQuery() {
            if (!vm.query.filter) {
                return;
            };

            var queryArr = vm.query.filter.split(" ");
            var searchQuery = "(";

            searchQuery += 'first_name=re="' + vm.query.filter + '"';
            searchQuery += ',last_name=re="' + vm.query.filter + '"';
            searchQuery += ',email=re="' + vm.query.filter + '"';

            searchQuery += ")";

            return searchQuery
        };

        function isMasterSchedulerPresent() {
            return schedulerUserInfo && schedulerUserInfo.hasOwnProperty('id');
        }

        function loadAll() {
            vm.loadingData = true;
            var query = null;
            if (vm.userFilter.length != 0) {
                query = 'id=out=(' + vm.userFilter.toString() + ')';
            } else if(vm.userInviteFilter.length) {                
                var usersList =
                    vm.userInviteFilter && vm.userInviteFilter.length
                        ? vm.userInviteFilter.toString() + ","
                        : "";
                query = 'id=out=(' + usersList + (isMasterSchedulerPresent() ? schedulerUserInfo.id : Principal.getUserId()) + ')';
            } else {
                if (!isSmartScan) {
                    query = 'id=out=(' + (isMasterSchedulerPresent() ? schedulerUserInfo.id : Principal.getUserId() ) + ')';
                }
            }

            if (vm.query.filter.length != 0) {
                if (query == null) {
                    query = formQuery();
                } else {
                    query = formQuery() + (!!query ? ';' + query : '');
                }
            }
            User.query({
                query: query,
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                check_admin: vm.isAdmin
            }, onSuccess, onError);

            vm.promise = System.getCountryCodes().$promise;

            vm.promise.then(function (result) {
                if (vm.isEmailFeatureEnabled) {
                    vm.handleInviteByEmail();
                } else if (vm.isSmsFeatureEnabled) {
                    vm.handleInviteByPhone();
                } else if (!vm.isEmailFeatureEnabled && !vm.isSmsFeatureEnabled) {
                    vm.handleInviteByDeviceId();
                }
                vm.countryCodes = result;
                setOrUpdateCountryCode();
            });

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'first_name') {
                    result = ['first_name,' + (vm.reverse ? 'asc' : 'desc')];
                    vm.predicate = 'first_name';
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.users = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function changeSort(newSort) {
            if (vm.predicate == newSort) {
                vm.reverse = !vm.reverse;
            } else {
                vm.reverse = true;
                vm.predicate = newSort;
            }
            transition();
        }

        function transition() {
            var query = null;
            if (vm.userFilter.length != 0) {
                query = 'id=out=(' + vm.userFilter.toString() + ')';
            } else if(vm.userInviteFilter.length) {
                var usersList =
                    vm.userInviteFilter && vm.userInviteFilter.length
                        ? vm.userInviteFilter.toString() + "," 
                        : "";
                query = 'id=out=(' + usersList + (isMasterSchedulerPresent() ? schedulerUserInfo.id : Principal.getUserId()) + ')';
            } else {
                if (!isSmartScan) {
                    query = 'id=out=(' + (isMasterSchedulerPresent() ? schedulerUserInfo.id : Principal.getUserId() ) + ')';
                }
            }

            if (vm.query.filter.length != 0) {
                if (query == null) {
                    query = formQuery();
                } else {
                    query = formQuery() + (!!query ? ';' + query : '');
                }
            }

            vm.promise = User.query({
                query: query,
                page: vm.page - 1,
                size: vm.query.limit,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                check_admin: vm.isAdmin
            }).$promise;

            vm.promise.then(function (data, headers) {
                vm.queryCount = vm.totalItems;
                vm.users = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            loadAll();

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        function setOrUpdateCountryCode() {
            angular.forEach(vm.countryCodes, function (countryCode) {
                countryCode.flag = getCountryFlag(countryCode.c_code);
                if (countryCode.code == '+1' && countryCode.name == 'United States') {
                    vm.defaultCountryCode = countryCode;
                }
            });
        };

        function getCountryFlag(cc) {
            return convertCharToRegionalIndicator(cc[0]) + convertCharToRegionalIndicator(cc[1]);
        };

        // Converts char to Regional Indicator Symbol
        function convertCharToRegionalIndicator(chr) {
            return String.fromCodePoint(0x1F1E6 - 65 + chr.toUpperCase().charCodeAt(0));
        }

        function reset() {
            vm.hasError = false;
            vm.email = '';
            vm.code = '';
            vm.phoneNumber = '';
            vm.deviceId = '';
        };

        function resetModal() {
            loadAll();
        };
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionTemplatesContoller', SessionTemplatesContoller);

    /* @ngInject */
    function SessionTemplatesContoller($rootScope, $scope, $q, $state, $filter, Report, CONTENT_META, Pubnub, Session, ParseLinks, pagingParams, paginationConstants, AlertService, $mdDialog, $mdToast, $stateParams) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.illustartionEmptyScreenId = "session_template";
        vm.illustartionEmptyScreenText = "There are no sessions yet";

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.refresh = function() {
            loadData();
        };

        function editObject(objectId) {
            $state.go('storm.sessions.template-detail', {
                'id': objectId
            });
        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.session.template.delete'))
                .ariaLabel($filter('translate')('atheer.session.template.delete'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Session.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadData();
            AlertService.displayToast($mdToast);
        };

        function getQueryString() {
            var query = 'type==' + 'TEMPLATE';
            return query;
        };

        function loadData() {
            vm.loadingData = true;
            Session.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                template: true
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        var refreshSessionListener = $rootScope.$on('refreshSessions', function(event, filter) {
            loadData();
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSessionListener();
        });

        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionTemplatesToolbarController', SessionTemplatesToolbarController);

    /* @ngInject */
    function SessionTemplatesToolbarController($rootScope, $scope, $state, $mdDialog, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService, SessionsService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.refreshAll = function() {
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.removeFilter = function() {
            vm.filter.show = false;
            vm.query.filter = '';
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.startInstantSession = function() {
            SessionsService.startInstantSession();
        };

        vm.joinSession = function() {
            SessionsService.joinSession();
        };

        vm.scheduleSession = function() {
            $state.go('storm.sessions.upcoming-detail');
        };

        vm.goBack = function() {
            $state.go('storm.sessions.upcoming');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionSurveyController', SessionSurveyController);

    /* @ngInject */
    function SessionSurveyController($scope, $state, $q, $sce, $filter, Report, externalUrl, ParseLinks, AlertService, $mdDialog, $mdToast, $stateParams) {
        var vm = this;

        vm.externalUrl = $sce.trustAsResourceUrl(externalUrl);;

        vm.close = function() {
            $mdDialog.cancel();
        };
    };
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('sessionSummaryReportController', sessionSummaryReportController);

    /* @ngInject */
    function sessionSummaryReportController($scope, $state, $q, $mdDialog, $mdToast, $filter, Session, Principal, toastConstants) {
        var vm = this;
        vm.loadData = true;
        vm.ownerHasEmail = false;

        Principal.identity().then(function(user) {
            vm.owner = user;
            vm.loadData = false;
            if(vm.owner.email != null && vm.owner.email.length > 0) {
                vm.ownerHasEmail = true;
            }
        });

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.EmailReport = function() {
            Session.getSessionSummaryReport({
            }, onSuccess, onError);

            function onSuccess(result) {
                $mdDialog.cancel();
                displayToast("Summary will be sent to: " + vm.owner.email);
            }

            function onError(error) {
                displayToast("Failed to send Summary.")
            }
        };

        function displayToast(message) {
             $mdToast.show({
                    template: '<md-toast><span flex>' + message + '</span></md-toast>',
                    position: toastConstants.position,
                    hideDelay: 3000
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionStartController', SessionStartController);

    /* @ngInject */
    function SessionStartController($state, $q, $filter, Feature, Session, $mdDialog, filter, conversation, isMobileBrowser, SessionPlayerService, Setting, Principal, User) {
        var vm = this;

        vm.loadingData = false;
        vm.usePersonalSession = window.location.href.includes('conversations') ? true : false;
        vm.personalSessionModel = null;
        vm.sessionSetting = [];

        vm.groupConversation = filter;
        vm.conversation = conversation;
        vm.isMobileBrowser = isMobileBrowser
        vm.createPersonalSession = Feature.isActive('feature_airsession_personal_session');

        vm.sessionModel = {
            id: null,
            topic: null,
            agenda: null,
            session_no: null,
            passcode: null,
            url: null,
            duration: null,
            timezone: null,
            start_time: new Date(),
            type: 'INSTANT',
            status: 'OPEN',
            owner: null,
            settings: {
                host_video: false,
                participant_video: false,
                mute_upon_entry: false
            },
            recurring_settings: null,
            session_users: [],
            created_by: null,
            created_on: null,
            last_modified_by: null,
            last_modified_on: null
        };

        vm.close = function () {
            sessionStorage.removeItem('context');
            $mdDialog.cancel();
        };

        vm.startSession = function () {
            if (vm.groupConversation != null && vm.conversation != null) {
                if(vm.groupConversation == "private_conversation") { 
                    for (var i = 0; i < vm.conversation.users.length; i++) {
                        if (vm.conversation.users[i].user_id != Principal.getUserId()) {
                            var obj = {
                                is_guest: false,
                                user_id: vm.conversation.users[i].user_id,
                                role: 'PARTICIPANT'
                               };
                               vm.sessionModel.session_users.push(obj);
                           }
                       };
                    if(vm.personalSessionModel.settings) {
                        vm.sessionModel.settings = vm.personalSessionModel.settings
                    }
                    Session.save(vm.sessionModel, function (result) {
                        vm.sessionModel = result;
                        startSessionPlayer();
                    }, onSaveError);
                }
                else {
                    $q.all([
                        Session.get({
                            id: vm.conversation.session_no,
                            is_session_no: true,
                            for_launch: true,
                            add_user: true
                        }).$promise
                    ])
                        .then(function (results) {
                            vm.sessionModel = results[0];
                            startSessionPlayer();
                        })
                }
            } else if (vm.usePersonalSession) {
                $q.all([
                    Session.get({
                        id: vm.personalSessionModel.session_no,
                        is_session_no: true,
                        for_launch: true,
                        is_web: true
                    }).$promise
                ])
                    .then(function (results) {
                        vm.sessionResult = results[0];
                        if (vm.sessionResult.topic != vm.sessionModel.topic) {
                            vm.sessionResult.topic = vm.sessionModel.topic;
                            Session.updateScheduled(vm.sessionResult, function (result) {
                                startSessionPlayer();
                            }, onSaveError);
                        } else {
                            startSessionPlayer();
                        }

                    })
            } else {
                Session.save(vm.sessionModel, function (result) {
                    vm.sessionModel = result;
                    startSessionPlayer();
                }, onSaveError);
            };
        };

        vm.updateTopic = function () {
            setTopic();
        };

        function startSessionPlayer() {
            $mdDialog.hide();
            var sessionNo = null;
            var sessionSettings = null;

            if (vm.groupConversation != null && vm.conversation != null) {
                sessionNo = vm.sessionModel.session_no;
                sessionSettings = vm.sessionModel.settings
            } else if (vm.usePersonalSession) {
                sessionNo = vm.personalSessionModel.session_no;
                sessionSettings = {
                    host_video: vm.sessionModel.settings.host_video
                };
            } else {
                sessionNo = vm.sessionModel.session_no;
                sessionSettings = null;
            };

            SessionPlayerService.setSessionSettings(sessionSettings);

            $state.go('storm.sessions.player', {
                'session_no': sessionNo
            });
        };

        function onSaveError() {
            vm.isSaving = false;
        };

        function loadData() {
            vm.loadingData = true;

            $q.all([
                Setting.getSystemTimezones({
                    size: 100
                }).$promise,
                Setting.getSessionSettings().$promise,
                User.getPersonalSession().$promise
            ])
                .then(function (results) {
                    vm.timezones = results[0];
                    setSettingSessionModel(results[1]);
                    vm.personalSessionModel = results[2];
                    setTopic();
                    vm.loadingData = false;

                    if(vm.groupConversation) {
                        vm.startSession();
                    }
                });
        };

        function setSettingSessionModel(settings) {
            angular.forEach(settings, function (setting) {
                if (setting.category == 'session_setting') {
                    vm.sessionSetting = setting;

                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'host_video' && settingField.value == 'true') {
                            vm.sessionModel.settings.host_video = true;
                        } else if (settingField.name == 'participant_video' && settingField.value == 'true') {
                            vm.sessionModel.settings.participant_video = true;
                        } else if (settingField.name == 'join_before_host' && settingField.value == 'true') {
                            vm.sessionModel.settings.join_before_host = true;
                        } else if (settingField.name == 'mute_upon_entry' && settingField.value == 'true') {
                            vm.sessionModel.settings.mute_upon_entry = true;
                        } else if (settingField.name == 'sign_in_required' && settingField.value == 'true') {
                            vm.sessionModel.settings.sign_in_required = true;
                        } else if (settingField.name == 'enable_waiting_room' && settingField.value == 'true') {
                            vm.sessionModel.settings.enable_waiting_room = true;
                        } else if (settingField.name == 'record_session' && settingField.value == 'true') {
                            vm.sessionModel.settings.record_session = true;
                        } else if (settingField.name == 'recurring_Session' && settingField.value == 'true') {
                            vm.sessionModel.settings.recurring_Session = true;
                        } else if (settingField.name == 'timezone_id') {
                            vm.sessionModel.timezone = settingField.value;
                        };
                    });
                }
            });
        };

        function setTopic() {
            if(vm.personalSessionModel.settings) {
                vm.sessionModel.settings.host_video = vm.personalSessionModel.settings.host_video;
            }
            if(vm.groupConversation) {
                if(vm.groupConversation === "private_conversation") {
                    vm.sessionModel.topic = Principal.getUserInfo().first_name + $filter('translate')('atheer.session.startSession.airsession');
                }
            }
            else {
                if (vm.usePersonalSession) {
                    vm.sessionModel.topic = Principal.getUserInfo().first_name + $filter('translate')('atheer.session.startSession.personal');
                } else {
                    vm.sessionModel.topic = Principal.getUserInfo().first_name + $filter('translate')('atheer.session.startSession.airsession');
                }
            }
        };

        loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('SessionPlayerSharedZoomController', SessionPlayerSharedZoomController);

    /* @ngInject */
    function SessionPlayerSharedZoomController($mdDialog, $filter, isSharedZoomDisabled, triSettings) {
        var vm = this;

        vm.zoomtitle = null;
        vm.zoomcontent = null;
        vm.iconSrc = null;
        vm.iconColor = triSettings.getSkinModel().primary_color_hex;

        function onLoad() {
            if (isSharedZoomDisabled) {
                vm.iconSrc = "/assets/images/card/shared-zoom-disabled.svg";
                vm.zoomtitle = $filter('translate')('atheer.session.sessionPlayer.sharedZoom.disabled.title');
                vm.zoomcontent = $filter('translate')('atheer.session.sessionPlayer.sharedZoom.disabled.description');
            } else {
                vm.iconSrc = "/assets/images/card/shared-zoom-enabled.svg";
                vm.zoomtitle = $filter('translate')('atheer.session.sessionPlayer.sharedZoom.enabled.title');
                vm.zoomcontent = $filter('translate')('atheer.session.sessionPlayer.sharedZoom.enabled.description');
            }
        };

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.continue = function () {
            $mdDialog.hide(!isSharedZoomDisabled);
        }

        onLoad();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionRecordings', sessionRecordings);

    function sessionRecordings() {
        var directive = {
            scope: {
                sessionModel: '='
            },
            bindToController: true,
            controller: sessionRecordingsController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-recordings.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionRecordingsController($scope, $mdDialog, $http, $window, $mdSidenav, $mdToast, $document, $mdPanel, $state, $timeout, $q, $filter, ParseLinks, Principal, Session, Experience, AlertService) {
        var vm = this;

        vm.loadingData = false;
        vm.transition = transition;
        vm.pageSize = 10;
        vm.sessionActivities = null;
        vm.sessionRecorings = [];

        vm.togglePanel = function() {
            $mdSidenav('recordingsPanel').toggle()
                .then(function() {

                });
        };

        function transition() {
            vm.promise = Experience.getSessionActivities({
                page: vm.page - 1,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
            });
        };

        function sort() {
            return 'id,asc';
        };

        function getQueryString() {
            var queryString = "action_type==RECORDING_SAVED;object_id==" + vm.sessionModel.id;
            return queryString;
        };

        vm.download = function(mediaUrl, mediaFileName, id) {

            $http.get(mediaUrl, {
              responseType: "arraybuffer"
            })
            .success(function(data) {
              var anchorTag = angular.element('<a/>');
              var blob = new Blob([data]);
              var extension = mediaFileName.split('.')[1];
              var fileName = 'airsession-' + vm.sessionModel.session_no + '-recording-' + (id+1) + '.' + extension;
              anchorTag.attr({
                href: $window.URL.createObjectURL(blob),
                target: '_blank',
                download: fileName
              })[0].click();
            });
        };

        function loadData() {
            if (!vm.sessionModel) {
                return;
            }

            vm.loadingData = true;
            vm.sessionRecorings = [];

            Experience.getSessionActivities({
                page: 0,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                vm.page = 1;

                var i = 1;

                angular.forEach(vm.sessionActivities, function(sessionActivity) {
                    var folderName = sessionActivity.properties.media_id;

                    vm.sessionRecorings.push({
                        id: sessionActivity.id,
                        player_id: 'atheer-player-' + Math.floor(Math.random() * (100000 - 1000 + 1)) + 1000,
                        title: $filter('translate')('atheer.session.recordings.recording') + i++ ,
                        media_file_name: sessionActivity.properties.media_file_name,
                        media_url: '/media/session-recordings/' + folderName + '/' + sessionActivity.properties.media_file_name,
                        videoSettings: {
                            playlist: [{
                                file: '/media/session-recordings/' + folderName + '/' + sessionActivity.properties.media_file_name
                            }],
                            autostart: false,
                            aspectratio: "16:9",
                            skin: {
                                name: "atheer"
                            },
                            playbackRateControls: true,
                            playbackRates: [0.25, 0.75, 1, 1.25, 1.5, 2, 3, 4]
                        }
                    });
                });
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        $scope.$watch('vm.sessionModel', function(newValue) {
            if (angular.isDefined(vm.sessionModel) && vm.sessionModel != null) {
                loadData();
            }
        });
    };
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('SessionPlayerRecordingMessageController', SessionPlayerRecordingMessageController);

    /* @ngInject */
    function SessionPlayerRecordingMessageController($mdDialog, mainData) {
        var vm = this;
        vm.mainData = mainData;

        vm.close = function () {
            $mdDialog.hide(true);
        };

        vm.leaveAirSession = function () {
            $mdDialog.hide(false);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionPlayerController', SessionPlayerController);

    /* @ngInject */
    function SessionPlayerController($scope, $state, $q, $filter, Report, session_no, SessionPlayerService, $cookies) {
        var vm = this;
        vm.sessionNo = session_no;
        vm.isGuest = $cookies.get('isGuest');
    };
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionPlayerUnsupportedBrowserController', SessionPlayerUnsupportedBrowserController);

    /* @ngInject */
    function SessionPlayerUnsupportedBrowserController($scope, $state, $q, $timeout, $filter, Report, sessionModel, $mdDialog, $mdToast, $stateParams) {
        var vm = this;

        vm.validPasscode = false;
        vm.sessionModel = sessionModel;

        vm.close = function() {
            $mdDialog.cancel();
            $state.go('storm.sessions.upcoming');
        }

        vm.downloadApp = function() {
            $mdDialog.cancel();
            $state.go('storm.lens-apps');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionPlayerPasscodeController', SessionPlayerPasscodeController);

    /* @ngInject */
    function SessionPlayerPasscodeController($scope, $state, $q, $timeout, $filter, Report, Session, sessionModel, $mdDialog, $translate, ToastService, $stateParams) {
        var vm = this;

        vm.validPasscode = false;

        vm.passcode1 = null;
        vm.passcode2 = null;
        vm.passcode3 = null;
        vm.passcode4 = null;
        vm.passcode5 = null;
        vm.passcode6 = null;

        vm.sessionModel = sessionModel;

        vm.checkPasscode = function(modelVal, code) {
            if (modelVal != '' && modelVal != null && code < 6) {
                $timeout(function() {
                    var nextInput = '[ng-model="vm.passcode' + (code + 1) + '"]';
                    angular.element(nextInput).focus();
                });
            } else {
                var confirmationCode = vm.passcode1 + vm.passcode2 + vm.passcode3 + vm.passcode4 + vm.passcode5 + vm.passcode6;

                vm.validPasscode = false;

                if (confirmationCode && confirmationCode.length == 6) {
                    vm.validPasscode = true;
                }

            };
        };

        vm.onNumberInputKeydown = function (e) {
            if (
                ![
                    "1", "2", "3", "4", "5", "6", "7","8", "9", "0",
                    "Backspace",
                    "Tab",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowUp",
                    "ArrowDown",
                ].includes(e.key)
            ) {
                e.stopPropagation();
                e.preventDefault();
            }
        };

        vm.joinSession = function() {
            var confirmationCode = vm.passcode1 + vm.passcode2 + vm.passcode3 + vm.passcode4 + vm.passcode5 + vm.passcode6;
            Session.validatePasscode({
                id: vm.sessionModel.id,
                passcode: confirmationCode
            }, onSuccessValidatePasscode, onErrorValidatePasscode)
        }

        function onSuccessValidatePasscode() {
            $mdDialog.hide(true);
        };

        function onErrorValidatePasscode() {
            ToastService.displayToast($translate.instant('atheer.session.detail.invalidPasscode'), 3000);
        };

        vm.closeAirSession = function() {
            $state.go('storm.sessions.upcoming');
            $mdDialog.hide(true);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionPlayerMakeAlternateHostController', SessionPlayerMakeAlternateHostController);

    /* @ngInject */
    function SessionPlayerMakeAlternateHostController(userId, userName, $mdDialog, isMobileBrowser) {
        var vm = this;
        vm.userId = userId;
        vm.userName = userName;
        vm.isMobileBrowser = isMobileBrowser;

        vm.close = function() {
            $mdDialog.cancel();
        };
        vm.changeHost = function() {
            $mdDialog.hide(userId);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionPlayerImagesController', SessionPlayerImagesController);

    /* @ngInject */
    function SessionPlayerImagesController($scope, $state, $http, $window, $location, $q, $timeout, $filter, Report, sessionModel, userId, Experience, ParseLinks, $mdDialog, $mdToast, $stateParams, isMobileBrowser, hasRecording) {
        var vm = this;

        vm.loadingData = false;
        vm.transition = transition;
        vm.pageSize = 100;
        vm.mediaPathAnnotation = "/media/images/";
        vm.sessionModel = sessionModel;

        vm.togglePanel = function () {
            $mdSidenav('annotationsPanel').toggle()
                .then(function () {

                });
        };

        vm.getMediaUrl = function (sessionActivity) {
            if ($location.host().endsWith('atheer.my')) {
                return 'https://' + $location.host() + ':' + $location.port() + vm.mediaPathAnnotation + sessionActivity.properties.media_file_name;
            } else {
                return vm.mediaPathAnnotation + sessionActivity.properties.media_file_name;
            }
        }

        vm.download = function (sessionActivity, id) {
            var url = vm.getMediaUrl(sessionActivity);
            var downloadFileName = null;

            if (sessionActivity.properties.file_name) {
                downloadFileName = sessionActivity.properties.file_name;
            } else {
                downloadFileName = sessionActivity.properties.media_file_name;
            }

            $http.get(url, {
                responseType: "arraybuffer"
            })
                .success(function (data) {
                    var anchorTag = angular.element('<a/>');
                    var blob = new Blob([data]);

                    anchorTag.attr({
                        href: $window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: downloadFileName
                    })[0].click();
                });
        }

        vm.downloadZip = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-annotation-zip.tmpl.html',
                clickOutsideToClose: true,
                controller: "SessionAnnotationZipController",
                controllerAs: "vm",
                locals: {
                    sessionModel: vm.sessionModel
                },
            }).then(function (result) {

            });
        }

        vm.fullScreen = function (sessionActivity) {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/session/session-annotation-fullscreen.tmpl.html',
                controller: 'sessionAnnotationFullscreenController',
                controllerAs: 'vm',
                hasBackdrop: true,
                backdrop: 'static',
                locals: {
                    sessionActivity: sessionActivity
                },
                size: 'lg'
            }).then(function () {

            });
        };

        vm.close = function () {
            $mdDialog.cancel();
        };

        function closeDialog() {
            var sessionActivities = null;
            if (vm.provideFeedback) {
                sessionActivities = {
                    user_id: vm.userId,
                    activity_type: "FEEDBACK",
                    object: vm.sessionModel,
                    properties: {
                        rating: vm.rating,
                        feedback: vm.ratingFeedback
                    }
                };
            }
            $mdDialog.hide(sessionActivities);
        };

        function transition() {
            vm.loadingData = true;
            vm.promise = Experience.getSessionActivities({
                page: vm.page - 1,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onTSuccess, onTError);

            function onTSuccess(data, headers) {
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                vm.loadingData = false;
            }

            function onTError(error) {
                AlertService.error(error.data.message);
            }
        };

        function sort() {
            return 'id,asc';
        };

        function getQueryString() {
            var queryString = "action_type==ANNOTATION_SAVED;object_id==" + vm.sessionModel.id;
            return queryString;
        };

        function loadData() {
            if (!vm.sessionModel) {
                return;
            }

            vm.loadingData = true;

            Experience.getSessionActivities({
                page: 0,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        $scope.$watch('vm.sessionModel', function (newValue) {
            if (angular.isDefined(vm.sessionModel) && vm.sessionModel != null) {
                loadData();
            }
        });


    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionPlayerCloseController', SessionPlayerCloseController);

    /* @ngInject */
    function SessionPlayerCloseController($scope, $state, $q, $timeout, $filter, Report, sessionModel, userId, isEnd, Experience, $mdDialog, $mdToast, $stateParams, isMobileBrowser, hasRecording) {
        var vm = this;

        vm.loadingData = false;
        vm.sessionNo = null;
        vm.sessionModel = sessionModel;
        vm.isEnd = isEnd;
        vm.userId = userId;
        vm.provideFeedback = false;
        vm.rating = null;
        vm.ratingFeedback = null;
        vm.isMobileBrowser = isMobileBrowser;
        vm.hasRecording = hasRecording;

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.closeSession = function() {
            if (vm.hasRecording) {
                vm.loadingData = true;
                $timeout(function() {
                    vm.loadingData = false;
                    closeDialog();
                }, 5000);
            } else {
                closeDialog();
            };
        };

        function closeDialog() {
            var sessionActivities = null;
            if (vm.provideFeedback) {
                sessionActivities = {
                    user_id: vm.userId,
                    activity_type: "FEEDBACK",
                    object: vm.sessionModel,
                    properties: {
                        rating: vm.rating,
                        feedback: vm.ratingFeedback
                    }
                };
            }
            $mdDialog.hide(sessionActivities);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionPastEditController', SessionPastEditController);

    /* @ngInject */
    function SessionPastEditController($scope, $state, $q, $filter, Report, Feature, Pubnub, Session, $mdDialog, $mdToast, $stateParams, filter, Principal, User) {
        var vm = this;

        vm.loadingData = false;
        vm.session = null;
        vm.sessionId = filter;
        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.updateSession = function() {
            Session.update(vm.session, function(result) {
                onSaveSuccess();
            });
        };

        function onSaveSuccess() {
            vm.isEnd = true;
            $mdDialog.hide();
        };


        function loadData() {
            vm.loadingData = true;
            $q.all([
                            Session.get({
                                id: vm.sessionId
                            }).$promise,
                        ])
                        .then(function(results) {
                            vm.session = results[0];
                            vm.loadingData = false;
                        });
        }

        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('sessionNotifierController', sessionNotifierController);

    /* @ngInject */
    function sessionNotifierController($scope, $state, $q, $filter, notification, $mdDialog, Session, $mdToast, $stateParams, $cookies, Guest, Auth, deviceDetector, Principal, $location, $rootScope, $window, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.instantSession = false;
        vm.scheduleSession = false;
        vm.groupSession = false;
        vm.notification = notification;
        vm.workspace = null;

        vm.close = function() {
            $mdToast
                .hide()
                .then(function() {});
        };

        vm.closeSession = function() {
            $mdToast
                .hide()
                .then(function() {});
        };

        vm.joinAirSession = function() {
            if($cookies.get('isGuest')) {
                $rootScope.$broadcast('show-loader', true);
                Guest.validateWorkspaceCode(vm.sessionObj.code, 'guest').then(function(result) {
                    vm.workspace = result.data.api_url.split('.')[0].split(':')[1].split('/')[2];
                    var host = $location.host();
                    //for localhost
                    //host = (host == 'localhost') ? 'demo.atheer.dev' : host;
                    if (host.split('.')[0] !== vm.workspace) {
                        var hostUrl = result.data.api_url;
                        var firstName = $cookies.get('firstName') ? $cookies.get('firstName') : deviceDetector.browser;
                        var lastName = $cookies.get('lastName') ? $cookies.get('lastName') : deviceDetector.os;

                        var url = hostUrl.replace('api', 'airsessions/player/' + vm.sessionObj.session_no + '/guest/' + vm.sessionObj.code + '/firstName/' + firstName + '/lastName/' + lastName);
                        $window.location.href = url;
                        return;
                    }
                    var token = Guest.getBearerToken();
                    Auth.loginWithToken(token).then(function (response) {
                        updateGuestUser();
                    });
                }).catch(function(err) {
                    displayToast('notification.session.sessionExpired');
                });
            } else {
                vm.joinSession();
            }
        };

        vm.joinSession = function() {
            Session.get({
                id: vm.sessionObj.session_no,
                for_launch: true,
                is_session_no: true,
                add_user: true,
                is_web: true
            }, onSuccess, onError);

            function onSuccess(result) {
                if($cookies.get('isGuest')) {
                    $rootScope.$broadcast('show-loader', false);
                }
                if (!result.id && result.result && result.result === "NOT_FOUND") {
                    displayToast("notification.session.sessionAlreadyExpired");
                    vm.loadingData = false;

                } else {
                    vm.sessionModel = result;
                    vm.loadingData = false;
                    $mdDialog.cancel();
                    $mdToast.hide();
                    $state.go('storm.sessions.player', {
                        'session_no': vm.sessionObj.session_no
                    });
                }
            }

            function onError(error) {
                if($cookies.get('isGuest')) {
                    $rootScope.$broadcast('show-loader', false);
                }
                displayToast("notification.session.sessionAlreadyExpired")
            }
        }

        vm.loadData = function() {
            vm.loadingData = true;
            if (notification.type == "instant_session_invite") {
                vm.instantSession = true;
            }
            if (notification.type == "scheduled_session_invite") {
                vm.scheduleSession = true;
            }
            if (notification.type == "group_session_invite") {
                vm.groupSession = true;
            }

            vm.sessionObj = JSON.parse(vm.notification.body);
            //vm.joinSession();

            vm.loadingData = false;
        }

        function updateGuestUser() {
            var data = {
                first_name: $cookies.get('firstName') ? $cookies.get('firstName') : deviceDetector.browser,
                last_name: $cookies.get('lastName') ? $cookies.get('lastName') : deviceDetector.os
            };
            var guestUserId = Guest.getGuestUserId();
            Guest.updateGuestUser(guestUserId, vm.workspace, data).then(function(response) {
                var host = $location.host();
                var domainParts = host.split('.');
                var parentDomain = domainParts[1] + '.' + domainParts[2];
                $cookies.put('firstName', data.first_name, { domain: parentDomain });
                $cookies.put('lastName', data.last_name, { domain: parentDomain });
                Principal.identity().then(function(user) {
                    getSessionDetails(guestUserId);
                });
            }).catch(function(error) {
                displayToast("notification.session.unableToUpdate")
            });
        };

        function getSessionDetails(guestUserId) {
            Guest.getSessionDetails(guestUserId, vm.sessionObj.session_no, vm.workspace).then(function(result) {
                vm.joinSession();
            }).catch(function(err) {
                displayToast("notification.session.sessionDoesntExists");
            });
        }

        function displayToast(message) {
            ToastService.displayToast($filter('triTranslate')(message), 3000);
        }

        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.user')
        .controller('SessionPlayerMergeRealityController', SessionPlayerMergeRealityController);

    /* @ngInject */
    function SessionPlayerMergeRealityController($mdDialog, mainData, message) {
        var vm = this;
        vm.mainData = mainData;
        vm.requestedUserName = getUserNameByJitsiId(message.data.overlayId)
        vm.close = function () {
            $mdDialog.hide(message);
        };

        function getUserNameByJitsiId(id) {
            var userInfo = vm.mainData.sessionUsers.filter(function (value, index, arr) {
                return value.jitsiUserId == id;
            })[0];
            return userInfo && userInfo.firstName ? userInfo.firstName + ' ' + userInfo.lastName : userInfo.lastName;
        };
    }
})();;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionJoinController', SessionJoinController);

    /* @ngInject */
    function SessionJoinController($state, $filter, Session, $mdDialog, sessionNo, isMobileBrowser, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.sessionNo = sessionNo ? sessionNo : null;
        vm.sessionModel = null;
        vm.isMobileBrowser = isMobileBrowser;

        vm.close = function () {
            sessionStorage.removeItem('context');
            $mdDialog.cancel();
        }

        vm.joinSession = function () {
            vm.loadingData = true;

            Session.get({
                id: vm.sessionNo,
                for_launch: true,
                is_session_no: true,
                add_user: true,
                is_web: true
            }, onSuccess, onError);

            function onSuccess(result) {
                if (!result.id && result.result && result.result === "NOT_FOUND") {
                    ToastService.displayToast($filter('triTranslate')('atheer.session.joinSession.expired'), 3000);
                    vm.loadingData = false;

                } else {
                    vm.sessionModel = result;
                    vm.loadingData = false;
                    $mdDialog.cancel();
                    $state.go('storm.sessions.player', {
                        'session_no': vm.sessionModel.session_no
                    });
                }
            }

            function onError(error) {
                ToastService.displayToast($filter('triTranslate')('atheer.session.joinSession.expired'), 3000);
                vm.loadingData = false;
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .service('SessionPlayerService', SessionPlayerService);

    /* @ngInject */
    function SessionPlayerService($mdDialog, $filter, $mdToast, Feature) {

        var jitsiInterfaceConfig = {
            SHOW_JITSI_WATERMARK: false,
            SHOW_WATERMARK_FOR_GUESTS: false,
            TOOLBAR_BUTTONS: [],
            DISPLAY_WELCOME_PAGE_CONTENT: false,
            VIDEO_QUALITY_LABEL_DISABLED: true,
            CONNECTION_INDICATOR_DISABLED: false,
            CONNECTION_INDICATOR_AUTO_HIDE_ENABLED: true,
            SETTINGS_SECTIONS: ['devices'],
            LANG_DETECTION: false
        };

        var jitsiApi;
        var sessionSettings;

        var service = {
            init: init,
            destroy: destroy,
            getInterfaceConfig: getInterfaceConfig,
            setDisplayName: setDisplayName,
            setSubject: setSubject,
            toggleShareScreen: toggleShareScreen,
            toggleAudio: toggleAudio,
            toggleVideo: toggleVideo,
            showSettings: showSettings,
            showVideoQuality: showVideoQuality,
            showKeyboardShortcuts: showKeyboardShortcuts,
            applyZoom: applyZoom,
            hangup: hangup,
            annotate: annotate,
            annotateAR: annotateAR,
            lockArAnnotation: lockArAnnotation,
            startRecording: startRecording,
            stopRecording: stopRecording,
            toggleTileView: toggleTileView,
            toggleFilmStrip: toggleFilmStrip,
            addEventListener: addEventListener,
            addEventListeners: addEventListeners,
            getSessionSettings: getSessionSettings,
            setSessionSettings: setSessionSettings,
            getConferenceTimestatmp: getConferenceTimestatmp,
            hideThumbnails: hideThumbnails,
            setDisplayPicture: setDisplayPicture,
            captureScreenShot: captureScreenShot,
            toggleCamera: toggleCamera,
            setTileView: setTileView,
            setNotifications: setNotifications,
            pinParticipant: pinParticipant,
            setSharedZoom: setSharedZoom,
            requestRemoteControl: requestRemoteControl,
            stopRemoteControl: stopRemoteControl,
            grantHostPermission: grantHostPermission,
            setFollowme: setFollowme,
            setAnnotationMode: setAnnotationMode,
            enableMergeReality: enableMergeReality,
            disableMergeReality: disableMergeReality

        };
        return service;

        function getInterfaceConfig(sessionModel) {
            return jitsiInterfaceConfig;
        };

        function init(api, isRemoteContolEnabled) {
            jitsiApi = api;
            if (window.isDesktop && isRemoteContolEnabled) {
                window.nodeAPI.enableRemoteControlFeature(api);
            }
        };

        function destroy() {
            jitsiApi.dispose();
            jitsiApi = null;
        };

        function setDisplayName(displayName) {
            jitsiApi.executeCommand('displayName', displayName);
        };

        function setSubject(subject) {
            jitsiApi.executeCommand('subject', subject);
        };

        function setTileView(enableTileView) {
            jitsiApi.executeCommand('setTileView', enableTileView);
        };

        function setNotifications(enableNotifications) {
            jitsiApi.executeCommand('setNotifications', enableNotifications);
        };

        function setDisplayPicture(displayPictureURL) {
            jitsiApi.executeCommand('avatarUrl', displayPictureURL);
        };

        function toggleShareScreen() {
            jitsiApi.executeCommand('toggleShareScreen');
        };

        function hangup() {
            jitsiApi.executeCommand('hangup');
        };

        function toggleAudio() {
            jitsiApi.executeCommand('toggleAudio');
        };

        function toggleVideo() {
            jitsiApi.executeCommand('toggleVideo');
        };

        function showSettings() {
            jitsiApi.executeCommand('showSettings');
        };

        function showVideoQuality() {
            jitsiApi.executeCommand('showVideoQuality');
        };

        function showKeyboardShortcuts() {
            jitsiApi.executeCommand('showKeyboardShortcuts');
        };

        function applyZoom(xValue, yValue, zValue, id) {
            jitsiApi.executeCommand('applyZoom', {
                xValue: xValue,
                yValue: yValue,
                zValue: zValue,
                id: id
            })
        };

        function enableMergeReality(enable, expertId, techId) {
            jitsiApi.executeCommand('mergeReality', {
                enable: enable,
                baseId: techId,
                overlayId: expertId
            });
        }

        function disableMergeReality() {
            jitsiApi.executeCommand('mergeReality', {
                enable: false
            });
        }

        function setSharedZoom(isEnabled) {
            jitsiApi.executeCommand('setPrivateZoom', isEnabled);
        };

        function startRecording() {
            jitsiApi.executeCommand('startRecording', {
                mode: 'file',
                dropboxToken: null,
                shouldShare: false,
                rtmpStreamKey: null,
                rtmpBroadcastID: null,
                youtubeStreamKey: null,
                youtubeBroadcastID: null
            });
        };

        function stopRecording() {
            jitsiApi.executeCommand('stopRecording', 'file');
        };

        function toggleTileView() {
            jitsiApi.executeCommand('toggleTileView');
        };

        function toggleFilmStrip() {
            jitsiApi.executeCommand('toggleFilmStrip');
        };

        function annotate(isClassicAnnotation) {
            captureScreenShot(isClassicAnnotation)
        };

        function annotateAR() {
            jitsiApi.executeCommand('getVideoDimensions');
        };

        function lockArAnnotation(targetUserId, isArLocked) {
            jitsiApi.executeCommand('lockArAnnotation', {
                participantId: targetUserId,
                isLocked: isArLocked
            });
        };

        function hideThumbnails(isHide) {
            jitsiApi.executeCommand('hideThumbnails', isHide);
        };

        function captureScreenShot(isClassicAnnotation) {
            jitsiApi.executeCommand('captureScreenShot', isClassicAnnotation);
        };

        function requestRemoteControl(userId) {
            jitsiApi.executeCommand('requestRemoteControl', userId);
        }

        function stopRemoteControl() {
            jitsiApi.executeCommand('stopRemoteControl');
        }

        function toggleCamera() {
            jitsiApi.executeCommand('toggleCamera');
        };

        function pinParticipant(participantId) {
            jitsiApi.executeCommand('pinParticipant', participantId);
        };

        function grantHostPermission(participantId) {
            jitsiApi.executeCommand('grantHostPermission', participantId);
        }

        function setFollowme(status) {
            jitsiApi.executeCommand('setFollowMe', status);
        }

        function setAnnotationMode(status) {
            jitsiApi.executeCommand('setAnnotationMode', status);
        }

        function addEventListener(event, listener) {
            jitsiApi.addEventListener(event, listener);
        };

        function addEventListeners(eventListeners) {
            jitsiApi.addEventListeners(eventListeners);
        };

        function getConferenceTimestatmp() {
            return jitsiApi.getConferenceTimestamp();
        };

        function getSessionSettings() {
            return sessionSettings;
        };

        function setSessionSettings(localSessionSettings) {
            sessionSettings = localSessionSettings;
        };

        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        function detectIE() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return true;
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                return true;
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                return true;
            }

            var edg = ua.indexOf('Edg/');
            if (edg > 0) {
                return true;
            }

            // other browser
            return false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionJitsiPlayer', sessionJitsiPlayer);

    function sessionJitsiPlayer() {
        var directive = {
            scope: {
                sessionNo: '@',
                isGuest: '@'
            },
            bindToController: true,
            controller: sessionJitsiPlayerController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-jitsi-player.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionJitsiPlayerController($rootScope, $scope, $element, $mdDialog, $mdToast, $document, $mdPanel, $state, $timeout, $q, $filter, Report, ConversationModelService, Principal, Session, Conversation, Setting, SessionPlayerService, PubNubService, Experience, SessionAnnotationService, Feature, SessionConfigService, Auth, $cookies, triSettings, $location, $window, deviceDetector, NotificationHandleService, ToastService) {
        var vm = this;
        var annotationTypeEnum = {
            classic: 'CLASSIC',
            live: 'LIVE',
            ar: 'AR'
        };

        var closeAnnotationListener = null;
        var imageLoadedListener = null;
        var annotationImageSavedListener = null;
        var saveAnnotationImageListener = null;
        var freezeFrameListener = null;
        var pubNubSessionListener = null;
        var sessionMessagesCount = null;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.isFullScreen = false;
        vm.audioStatus = true;
        vm.videoStatus = true;
        vm.shareScreenLocked = false;
        vm.showPlayer = false;
        vm.showParticipants = false;
        vm.showConversation = false;
        vm.sessionModel = null;
        vm.jitsiUserId = null;
        vm.isHost = false;
        vm.waitingForHost = false;
        vm.userId = null;
        vm.userShortName = null;
        vm.userInfo = null;
        vm.sessionUsers = [];
        vm.sessionSettingOverwrite = null;
        vm.invitedUserIds = [];
        vm.jitsiRecorderStatus = null;
        vm.recordingStatus = false;
        vm.loadingRecorder = false;
        vm.convMessageBody = null;
        vm.messages = [];
        vm.convChannelName = null;
        vm.annotationLocked = false;
        vm.screenShotSrc = null;
        vm.isAnnotating = false;
        vm.annotationData = null;
        vm.isAnnotationView = false;
        vm.isAnnotationSaved = false;
        vm.isImageLoaded = false;
        vm.zoomMax = 2;
        vm.zoomMin = 1;
        vm.zoom = 1;
        vm.zoomStep = 0.01;
        vm.zoomX = 0.5;
        vm.zoomY = 0.5;
        vm.zoomSlider = 100;
        vm.enableZoom = false;
        vm.zoomValue = 100;
        vm.selectedUserJitsiId = null;
        vm.isZoomEnabled = true;
        vm.annotationType = annotationTypeEnum.classic;
        vm.isArAnnotating = false;
        vm.defaultSwitchUserId = null;
        vm.defaultAnnotationType = null;
        vm.canAnnotate = true;
        vm.emptyIllustration = "session-conv";
        vm.recordingFeature = Feature.isActive('feature_airsession_recording');
        vm.recordingContentFeature = Feature.isActive('feature_airsession_enable_recording_consent');
        vm.recordingContentDialogOpen = false;
        vm.isScheduledTimer = false;
        vm.isARLoaderRequired = true;
        vm.isARSupported = false;
        vm.isOpenAnnotationOptions = false;
        vm.hasSlam = false;
        vm.isLiveAnnotationFeatureEnabled = Feature.isActive('feature_airsession_live_annotation');
        vm.userName = null;
        vm.defaultZoom = 1;
        vm.isScreenSharing = false;
        vm.isCapturingScreenshot = false;
        //As per discussion, added by default true, because in future this featureflag removed from DB.
        vm.isNativeImageCaptureFeature = true; //Feature.isActive('feature_airsession_native_image_capture');
        vm.isRemoteControlEnabled = Feature.isActive('feature_airsession_enable_remote_control_support');
        vm.isCapturing = false;
        vm.isGuestWaitingForHost = false;
        vm.isMobileBrowser = deviceDetector.isMobile();
        vm.recordingTimer = null;
        vm.isTileView = false;
        vm.hasRecording = false;

        vm.messagesCount = 0;
        vm.isSharedZoomDisabled = false;
        vm.isZoomToolsEnabled = true;
        vm.isSharedZoomDisabledFeature = Feature.isActive('feature_airsession_enable_zoom_preference');
        vm.userHasRemoteControlSupport = false;
        vm.remoteControlAccessMap = {};
        vm.isRemoteControlPermissionRequested = false;
        vm.isRemoteControlPermissionGranted = false;
        vm.remoteControlledUser = null;
        vm.remoteRequestedUser = null;
        vm.isRemoteControlActive = false;
        vm.stream = null;
        vm.imageCapture = null;
        vm.isFakeParticipantOnStage = false;
        vm.isMergeRealityEnabled = Feature.isActive('feature_airsession_enable_mr_feature');
        vm.isMergeRealityCallInProgress = false;
        vm.baseFeedId = null;
        vm.overlayId = null;
        vm.isWaitingForOtherUserFeed = false;
        vm.permissions = {
            start_mr: 'start_mr_session-session',
            create: 'create-session'
        }

        vm.requestRemoteControl = function (participantId) {
            vm.isRemoteControlActive = true;
            vm.remoteControlledUser = getUserIdByJitsiId(participantId);
            vm.remoteRequestedUser = vm.userId;
            var remoteControlRequestMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: 'REMOTE_CONTROL_REQUESTED',
                data: {
                    toUserId: vm.remoteControlledUser,
                    fromUserId: vm.userId
                }
            }
            publishMessage(remoteControlRequestMessage);
            createSessionActivity('REMOTE_CONTROL_ACCESS_REQUESTED', null);
            vm.isRemoteControlPermissionRequested = true;
            SessionPlayerService.requestRemoteControl(participantId);
        }

        vm.stopRemoteControl = function () {
            vm.remoteControlledUser = null;
            SessionPlayerService.stopRemoteControl();
        }

        vm.showSharedZoomDialog = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-shared-zoom-dialog.tmpl.html',
                controller: 'SessionPlayerSharedZoomController',
                clickOutsideToClose: true,
                controllerAs: 'vm',
                locals: {
                    isSharedZoomDisabled: vm.isSharedZoomDisabled
                }
            }).then(function (result) {
                vm.isSharedZoomDisabled = result;
                SessionPlayerService.setSharedZoom(vm.isSharedZoomDisabled);

                publishSharedZoomDisabled();
                resetZoom();

                if (result) {
                    createSessionActivity('PRIVATE_ZOOM_DISABLED', null);
                } else {
                    createSessionActivity('PRIVATE_ZOOM_ENABLED', null);
                }
            });
        };

        //used in NON-Angular Async process
        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== '$apply' && phase !== '$digest') {
                return $scope.$apply(fn);
            }
        };

        vm.toggleAudioOfUser = function (userId, publish, report) {
            if (userId == vm.userId) {
                vm.audioStatus = !vm.audioStatus;
                SessionPlayerService.toggleAudio();
                updateAudioStatus(userId, vm.audioStatus);
                if (publish) {
                    var toggleAudioUserMessage = {
                        subject: 'SESSION',
                        action: 'BROADCAST',
                        type: 'AUDIO_STATUS',
                        data: {
                            audioStatus: vm.audioStatus
                        }
                    };
                    publishMessage(toggleAudioUserMessage);
                };
                if (vm.isMobileBrowser) {
                    if (vm.audioStatus) {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.microphoneOn'), 3000);
                    } else {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.microphoneOff'), 3000);
                    }
                }
            } else {
                var toggleAudioUserMessage = {
                    subject: 'SESSION',
                    action: 'USER',
                    type: 'AUDIO_STATUS',
                    data: {
                        userId: userId
                    }
                };
                publishMessage(toggleAudioUserMessage);
            };

            if (report) {
                if (vm.audioStatus == true) {
                    createSessionActivity('AUDIO_ON', null);
                } else {
                    createSessionActivity('AUDIO_OFF', null);
                };
            };
        };

        vm.toggleAudioAll = function (audioStatus) {
            var muteAllMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: 'TOGGLE_AUDIO_ALL',
                data: {
                    audioStatus: audioStatus
                }
            };
            publishMessage(muteAllMessage);
        };

        vm.toggleVideoOfUser = function (userId, publish, report) {
            if (userId == vm.userId) {
                vm.videoStatus = !vm.videoStatus;
                SessionPlayerService.toggleVideo();
                updateVideoStatus(userId, vm.videoStatus);
                if (publish) {
                    var toggleVideoUserMessage = {
                        subject: 'SESSION',
                        action: 'BROADCAST',
                        type: 'VIDEO_STATUS',
                        data: {
                            videoStatus: vm.videoStatus
                        }
                    };
                    publishMessage(toggleVideoUserMessage);
                };
                if (vm.isMobileBrowser) {
                    if (vm.videoStatus) {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.videoIsOn'), 3000);
                    } else {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.videoIsOff'), 3000);
                    }
                }
            } else {
                var toggleVideoUserMessage = {
                    subject: 'SESSION',
                    action: 'USER',
                    type: 'VIDEO_STATUS',
                    data: {
                        userId: userId
                    }
                };
                publishMessage(toggleVideoUserMessage);
            };

            if (report) {
                if (vm.videoStatus == true) {
                    createSessionActivity('VIDEO_ON', null);
                } else {
                    createSessionActivity('VIDEO_OFF', null);
                };
            };
        };

        vm.toggleFlashOfUser = function (userId) {
            var toggleFlashUserMessage = {
                subject: 'SESSION',
                action: 'USER',
                type: 'FLASH_LIGHT_STATUS',
                data: {
                    userId: userId
                }
            };
            publishMessage(toggleFlashUserMessage);
        };

        vm.toggleTileView = function () {
            SessionPlayerService.toggleTileView();
        };

        vm.zoomIn = function () {
            createSessionActivity('ZOOM_IN', null);
            vm.zoom += vm.zoomStep;
            vm.zoom = vm.zoom >= vm.zoomMax ? vm.zoomMax : vm.zoom;
            if (vm.zoom > 1) {
                vm.enableZoom = !vm.isSharedZoomDisabled ? true : (vm.userId == getUserId() ? true : false);
            }
            vm.zoomSlider = vm.zoom * 100;
        };

        vm.zoomOut = function () {
            createSessionActivity('ZOOM_OUT', null);
            vm.zoom -= vm.zoomStep;
            vm.zoom = vm.zoom <= vm.zoomMin ? vm.zoomMin : vm.zoom;
            vm.zoomSlider = vm.zoom * 100;
        };

        vm.setZoomValue = function (x, y, z) {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (vm.selectedUserJitsiId == sessionUser.jitsiUserId) {
                    sessionUser.tx = x;
                    sessionUser.ty = y;
                    sessionUser.scale = z;
                }
            });
        };

        vm.sendZoomPositiontoJitsi = function (x, y) {
            SessionPlayerService.applyZoom(x, y, vm.zoom, vm.selectedUserJitsiId);
            vm.setZoomValue(x, y, vm.zoom);
            vm.zoomValue = Math.floor(vm.zoom * 100);
            if (vm.zoom == 1) {
                vm.enableZoom = false;
            }
        };

        vm.sendZoomPosition = function () {
            publishParticipantZoomData();
        }

        vm.toggleRecording = function () {
            if (!vm.recordingStatus) {
                vm.loadingRecorder = true;
                SessionPlayerService.startRecording();

                vm.recordingTimer = $timeout(function () {
                    resetRecordingState()
                }, 240000);

            } else {
                SessionPlayerService.stopRecording();
            }
        };

        vm.toggleConversation = function () {
            if (vm.showParticipants) {
                vm.toggleUsers();
            };
            vm.showConversation = !vm.showConversation;

            if (vm.showConversation) {
                getReadMessagesCount();
            }
        };

        vm.toggleUsers = function (componentId) {
            if (vm.showConversation) {
                vm.toggleConversation();
            };

            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (sessionUser.userId == vm.userId) {
                    vm.sessionUsers.splice(vm.sessionUsers.indexOf(sessionUser), 1);
                    vm.sessionUsers.unshift(sessionUser);
                };
            });

            vm.showParticipants = !vm.showParticipants;
        };

        vm.toggleShareScreen = function () {
            SessionPlayerService.toggleShareScreen();
        };

        vm.showCapturedImages = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-player-images-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'SessionPlayerImagesController',
                controllerAs: 'vm',
                locals: {
                    sessionModel: vm.sessionModel,
                    userId: vm.userId,
                    isMobileBrowser: vm.isMobileBrowser,
                    hasRecording: vm.hasRecording
                }
            }).then(function () {

            });
        }

        vm.finalizeSession = function (isEnd) {
            if (isEnd && vm.recordingStatus) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($filter('translate')('atheer.session.sessionPlayer.recordingIsOn'))
                        .textContent($filter('translate')('atheer.session.sessionPlayer.stopIt'))
                        .ariaLabel($filter('translate')('atheer.session.sessionPlayer.stopIt'))
                        .ok($filter('translate')('atheer.session.sessionPlayer.gotIt'))
                );
            } else if (vm.isAnnotating && vm.isAnnotationView && !vm.isAnnotationSaved) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($filter('translate')('atheer.session.sessionPlayer.annotationIsOn'))
                        .textContent($filter('translate')('atheer.session.sessionPlayer.saveAnnotation'))
                        .ariaLabel($filter('translate')('atheer.session.sessionPlayer.saveAnnotation'))
                        .ok($filter('translate')('atheer.session.sessionPlayer.gotIt'))
                );
            } else if (vm.isArAnnotating && vm.annotationType !== annotationTypeEnum.classic) {
                if (vm.annotationLocked) {
                    closeSession(isEnd);
                } else {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title($filter('translate')('atheer.session.sessionPlayer.annotationIsOn'))
                            .textContent($filter('translate')('atheer.session.sessionPlayer.closeAnnotation'))
                            .ariaLabel($filter('translate')('atheer.session.sessionPlayer.closeAnnotation'))
                            .ok($filter('translate')('atheer.session.sessionPlayer.gotIt'))
                    );
                }
            } else {
                closeSession(isEnd);
            };

            function closeSession(isEnd) {
                $mdDialog.show({
                    templateUrl: 'modules/session/session-player-close-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: 'SessionPlayerCloseController',
                    controllerAs: 'vm',
                    locals: {
                        sessionModel: vm.sessionModel,
                        userId: vm.userId,
                        isEnd: isEnd,
                        isMobileBrowser: vm.isMobileBrowser,
                        hasRecording: vm.hasRecording
                    }
                }).then(function (sessionActivities) {
                    if (sessionActivities != null) {
                        Experience.createSessionActivity(sessionActivities);
                    }

                    if (isEnd) {
                        checkForGuestUsers();

                        var sessionEndMessage = {
                            subject: 'SESSION',
                            action: 'BROADCAST',
                            type: 'END'
                        };

                        vm.sessionModel.status = 'CLOSED';
                        Session.update(vm.sessionModel, function (result) {
                            publishMessage(sessionEndMessage);
                            closeSessionPlayer();
                        });
                        Conversation.archive({
                            id: vm.sessionModel.conversation_info.id
                        });
                    } else {
                        createSessionActivity('PARTICIPANT_LEFT', null);
                        closeSessionPlayer();
                    };
                });
            }
        };

        vm.showSessionInfo = function (ev) {
            var orientation = window.innerWidth > window.innerHeight ? 'Landscape' : 'Portrait';
            var position = $mdPanel.newPanelPosition()
                .relativeTo('#session-player-toolbar')
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ABOVE);

            var config = {
                attachTo: angular.element(document.body),
                controller: 'SessionInfoPanelController',
                controllerAs: 'vm',
                templateUrl: 'modules/session/session-info-panel.tmpl.html',
                position: position,
                locals: {
                    sessionModel: vm.sessionModel,
                    workspaceCode: Principal.getWorkspaceCode()
                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2,
                onCloseSuccess: function (panelRef, reason) {

                }
            };
            $mdPanel.open(config);
        };

        vm.showSessionInfoDialog = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-info-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'SessionInfoDialogController',
                controllerAs: 'vm',
                locals: {
                    sessionModel: vm.sessionModel,
                    workspaceCode: Principal.getWorkspaceCode(),
                    isMobileBrowser: vm.isMobileBrowser
                }
            }).then(function () {

            });
        };

        vm.toggleFullScreen = function () {
            vm.isFullScreen = !vm.isFullScreen;
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        };

        vm.showShortCuts = function () {
            SessionPlayerService.showKeyboardShortcuts();
        };

        vm.captureFeeback = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-feedback-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'SessionFeedbackController',
                controllerAs: 'vm',
                locals: {
                    sessionModel: vm.sessionModel,
                    userId: vm.userId,
                    isMobileBrowser: vm.isMobileBrowser
                }
            }).then(function (result) {

            });
        };

        vm.changeSettings = function () {
            SessionPlayerService.showSettings();
        };

        vm.changeVideoQuality = function () {
            SessionPlayerService.showVideoQuality();
        };

        vm.toggleCamera = function () {
            SessionPlayerService.toggleCamera();
        };

        vm.inviteUsers = function () {
            var isConversation = false;
            if (vm.sessionModel.type == 'GROUP_CONVERSATION_INSTANCE') {
                isConversation = true;
            }
            $mdDialog.show({
                templateUrl: 'modules/session/session-user-invite.tmpl.html',
                controller: 'SessionUserInviteController',
                controllerAs: 'vm',
                locals: {
                    filter: [],
                    allowMultiSelect: true,
                    userslist: [],
                    isSession: true,
                    isScheduledSession: false,
                    isAdmin: false,
                    isConversationSession: isConversation,
                    isSmartScan: false,
                    selectedItemIds: [],
                    schedulerUserInfo: null,
                    isSessionSingleUserInvite: false,
                    autoCompleteModel: []
                }
            })
                .then(function (selectedItems) {
                    inviteUsers(selectedItems);
                });
        };

        vm.annotate = function (annotationType) {
            if (annotationType == annotationTypeEnum.classic && vm.isNativeImageCaptureFeature) {
                vm.sendAnnotationLockMessage();
                if (vm.userId === getUserId() || vm.isFreezeFrame) {
                    SessionPlayerService.annotate(true);
                    vm.isCapturing = true;
                }
            } else if (annotationType == annotationTypeEnum.classic && !vm.isNativeImageCaptureFeature) {
                vm.sendAnnotationLockMessage();
                SessionPlayerService.annotate(true);
                vm.isCapturing = true;
            } else {
                vm.annotationType = vm.hasSlam ? annotationTypeEnum.ar : annotationTypeEnum.live;
                SessionPlayerService.annotateAR();
            }
            vm.isOpenAnnotationOptions = false;
        };

        vm.openAnnotationOption = function () {
            vm.isOpenAnnotationOptions = !vm.isOpenAnnotationOptions;
        };

        vm.captureScreenShot = function () {
            vm.isCapturingScreenshot = true;
            if (vm.isNativeImageCaptureFeature && vm.userId !== getUserId()) {
                var screenshotCaptureData = {
                    userId: vm.userId,
                    targetUserId: getUserId()
                };
                publishCaptureMessage('CAPTURE_SCREEN_SHOT', screenshotCaptureData);
            } else {
                SessionPlayerService.captureScreenShot(false);
            }

        };

        vm.toggleMergeReality = function () {
            vm.isMergeRealityCallInProgress = !vm.isMergeRealityCallInProgress;
            if (vm.isMergeRealityCallInProgress) {
                var remoteUser = vm.sessionUsers.filter(function (value) {
                    return value.jitsiUserId != vm.jitsiUserId;
                })[0];

                if (!remoteUser.videoStatus) {
                    vm.isWaitingForOtherUserFeed = true;
                }
                vm.overlayId = vm.jitsiUserId;
                vm.baseId = remoteUser.jitsiUserId;
                SessionPlayerService.enableMergeReality(vm.isMergeRealityCallInProgress, vm.jitsiUserId, remoteUser.jitsiUserId);
                createSessionActivity('MR_STARTED', null);
            } else {
                vm.overlayId = null;
                vm.baseId = null;
                SessionPlayerService.disableMergeReality();
                createSessionActivity('MR_ENDED', null);
            }
        }

        vm.onGoBack = function () {
            //for localhost
            // if (!$location.host().startsWith('app') && !$location.host().startsWith('localhost')) {
            if (!$location.host().startsWith('app')) {
                var hostUrl = $location.absUrl();
                var path = $location.path();
                var domain = $window.location.host.split('.')[0];

                var url = hostUrl.replace(domain, "app").replace(path, "/signin");
                $window.location.href = url;
            } else {
                $rootScope.isAppWorkspace = true;
                $state.go('account.signin');
            }
        };

        vm.showAnnotationModeDialog = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-annotation-mode-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'SessionAnnotationModeDialogController',
                controllerAs: 'vm',
                locals: { mainData: vm },
                bindToController: true,
            }).then(function (result) {
                return result;
            });
        };

        vm.sendAnnotationLockMessage = function () {
            if (!vm.isFreezeFrame) {
                var annotationData = {
                    lockState: true,
                    targetAspectRatio: 1.0,
                    type: 'CLASSIC',
                    targetUser: getUserId(),
                };

                var annotationLockMessage = {
                    subject: 'SESSION',
                    action: 'BROADCAST',
                    type: 'ANNOTATION_LOCK',
                    data: annotationData
                };
                publishMessage(annotationLockMessage);
                createSessionActivity('ANNOTATION_STARTED', null);
                vm.annotationType = annotationTypeEnum.classic;
                vm.isAnnotationView = true;
                vm.isAnnotationSaved = false;
            }
        };

        function updateAnnotationStatus(event, isSaved) {
            vm.isAnnotationSaved = !isSaved;
        };

        function saveAnnotation(event, data) {
            vm.isAnnotationSaved = data.isAnnotationSaved;
            var annotationCaptureData = {
                userId: vm.userId
            };
            publishCaptureMessage('ANNOTATION_CAPTURED', annotationCaptureData);
            var saveAnnotationProperties = {
                file_name: data.annotationImageData.data.name,
                media_file_name: data.annotationImageData.data.properties.file_name,
                media_id: data.annotationImageData.data.id
            }
            createSessionActivity('ANNOTATION_SAVED', saveAnnotationProperties);
        };

        function imageLoaded(event, isLoaded) {
            vm.isImageLoaded = isLoaded;
        };

        function closeAnnotation(event, isSaved) {
            var closeAnnotationMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                data: {
                    lockState: false
                }
            };
            if (vm.annotationType == 'CLASSIC' && vm.isArAnnotating) {
                closeAnnotationMessage.type = 'FREEZE_FRAME_LOCK';
                if (vm.isEditEnabled) {
                    SessionPlayerService.annotateAR();
                } else {
                    SessionPlayerService.lockArAnnotation(vm.selectedUserJitsiId, true);
                }
                vm.annotationType = vm.defaultAnnotationType;
            } else {
                closeAnnotationMessage.type = 'ANNOTATION_LOCK';
                if (!vm.isMobileBrowser) {
                    SessionPlayerService.hideThumbnails(false);
                }
                SessionPlayerService.setAnnotationMode(false);
                vm.isARLoaderRequired = true;
            }
            resetVariables();
            publishMessage(closeAnnotationMessage);
            createSessionActivity('ANNOTATION_ENDED', null);
        };

        function onFreezeFrame(event) {
            if (vm.annotationType == annotationTypeEnum.ar) {
                vm.isCapturingScreenshot = true;
                var screenshotCaptureData = {
                    userId: vm.userId,
                    targetUserId: getUserId()
                };
                publishCaptureMessage('CAPTURE_AR_SCREEN_SHOT', screenshotCaptureData);
            } else {
                $scope.$broadcast('show-loader', true);
                vm.isFreezeFrame = true;
                vm.annotate(annotationTypeEnum.classic);
            }

        }

        function inviteUsers(invitingUsers) {
            var sessionId = vm.sessionModel.id;
            var sessionInviteObject = {
                user_ids: [],
                guest_users: []
            };

            for (var i = 0; i < invitingUsers.length; i++) {
                if (invitingUsers[i].is_guest) {
                    sessionInviteObject.guest_users.push(invitingUsers[i]);
                    vm.invitedUserIds.push(invitingUsers[i].guest_invite_value);
                } else {
                    sessionInviteObject.user_ids.push(invitingUsers[i].id);
                    vm.invitedUserIds.push(invitingUsers[i].id);
                }
            }
            Session.invite({
                id: vm.sessionModel.id,
            }, sessionInviteObject, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                for (var i = 0; i < invitingUsers.length; i++) {
                    if (!invitingUsers[i].is_guest) {
                        var obj = {
                            user_id: invitingUsers[i].id,
                            role: 'PARTICIPANT'
                        };

                        vm.sessionModel.session_users.push(obj);
                    }
                }
                displayToast($filter('translate')('atheer.session.sessionPlayer.participantsInvited'), 3000);
            };

            function onSaveError() {
                AlertService.displayToast($mdToast);
            };
        };

        function loadData() {
            vm.loadingData = true;
            vm.userId = Principal.getUserId();
            vm.userInfo = Principal.getUserInfo();
            vm.userShortName = Principal.getUserShortName();
            //to set theme for guest join loader
            setTimeout(function () {
                var spinners = document.getElementsByClassName("spinner");
                angular.forEach(spinners, function (spinner) {
                    spinner.style.backgroundColor = triSettings.getSkinModel().primary_color_hex;
                });
            }, 200);
            $q.all([
                Session.get({
                    id: vm.sessionNo,
                    is_session_no: true,
                    for_launch: true,
                    is_web: true
                }).$promise,
                Setting.getSessionSettings().$promise
            ])
                .then(function (results) {
                    if (!results[0].id && results[0].result === 'NOT_FOUND') {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.sessionExpired'), 3000);
                        navigateBack();
                    } else {

                        vm.sessionModel = results[0];
                        if (!vm.sessionModel.settings) {
                            vm.sessionModel.settings = {};
                            setSettingSessionModel(results[1]);
                        }

                        setSettingsForSurvey(results[1]);

                        for (var i = 0; i < vm.sessionModel.session_users.length; i++) {
                            vm.invitedUserIds.push(vm.sessionModel.session_users[i].user_id);
                        }
                        if (vm.sessionModel.guest_users) {
                            for (var i = 0; i < vm.sessionModel.guest_users.length; i++) {
                                vm.invitedUserIds.push(vm.sessionModel.guest_users[i].guest_id);
                            }
                        }
                        vm.invitedUserIds.push(vm.sessionModel.owner);
                        if (vm.sessionModel.type == "SCHEDULED") {
                            vm.isScheduledTimer = true;
                        }
                        vm.loadingData = false;
                        initSessionPlayer();
                        initFullScreenHandler();
                        getUnReadMessageCount();
                    }
                });
        };

        function setSettingSessionModel(settings) {
            angular.forEach(settings, function (setting) {
                if (setting.category == 'session_setting') {
                    vm.sessionSetting = setting;

                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'host_video') {
                            vm.sessionModel.settings.host_video = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'participant_video') {
                            vm.sessionModel.settings.participant_video = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'join_before_host') {
                            vm.sessionModel.settings.join_before_host = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'mute_upon_entry') {
                            vm.sessionModel.settings.mute_upon_entry = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'sign_in_required') {
                            vm.sessionModel.settings.sign_in_required = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'enable_waiting_room') {
                            vm.sessionModel.settings.enable_waiting_room = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'record_session') {
                            vm.sessionModel.settings.record_session = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'recurring_Session') {
                            vm.sessionModel.settings.recurring_Session = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'timezone_id') {
                            vm.sessionModel.settings.timezone = settingField.value;
                        } else if (settingField.name == 'enable_external_survey') {
                            vm.sessionModel.settings.enable_external_survey = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'external_survey_url') {
                            vm.sessionModel.settings.external_survey_url = settingField.value;
                        };
                    });
                }
            });
        };

        function setSettingsForSurvey(settings) {
            angular.forEach(settings, function (setting) {
                if (setting.category == 'session_setting') {
                    vm.sessionSetting = setting;

                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'enable_external_survey') {
                            vm.sessionModel.settings.enable_external_survey = settingField.value == 'true' ? true : false;
                        } else if (settingField.name == 'external_survey_url') {
                            vm.sessionModel.settings.external_survey_url = settingField.value;
                        };
                    });
                }
            });
        };

        function initSessionPlayer() {
            updateSessionSettingsFromOverwrite();
            vm.isHost = isUserHost();

            if (vm.isHost) {
                vm.videoStatus = vm.sessionModel.settings.host_video;
            } else {
                vm.videoStatus = vm.sessionModel.settings.participant_video;
                vm.audioStatus = !vm.sessionModel.settings.mute_upon_entry;
            };

            vm.isZoomEnabled = vm.videoStatus ? true : false;
            vm.canAnnotate = vm.videoStatus ? true : false;

            if (!isBrowserSupported()) {
                $mdDialog.show({
                    templateUrl: 'modules/session/session-player-unsupported-browser.tmpl.html',
                    clickOutsideToClose: false,
                    controller: 'SessionPlayerUnsupportedBrowserController',
                    controllerAs: 'vm',
                    locals: {
                        sessionModel: vm.sessionModel
                    }
                }).then(function (launchPlayer) {
                    if (launchPlayer) {
                        startSessionPlayer();
                    } else {
                        navigateBack();
                    };
                });
            } else {
                if (!vm.isHost && vm.sessionModel.use_passcode) {
                    $mdDialog.show({
                        templateUrl: 'modules/session/session-player-passcode-dialog.tmpl.html',
                        clickOutsideToClose: false,
                        controller: 'SessionPlayerPasscodeController',
                        controllerAs: 'vm',
                        locals: {
                            sessionModel: vm.sessionModel
                        }
                    }).then(function (launchPlayer) {
                        if (launchPlayer) {
                            startSessionPlayer();
                        } else {
                            navigateBack();
                        };
                    });
                } else {
                    startSessionPlayer();
                };
            }

        };

        function startSessionPlayer() {
            initPubNubHandler();
            $rootScope.isSessionStarted = true;
            if (vm.isHost) {
                vm.updateWaitingForHost = false;
            } else {
                if (!vm.sessionModel.settings.join_before_host && vm.sessionModel.type == 'SCHEDULED') {
                    vm.waitingForHost = true;
                    vm.isGuestWaitingForHost = vm.isGuest ? true : false;
                } else {
                    vm.waitingForHost = false;
                };
            };
            startJitsiPlayer();
        };

        function startJitsiPlayer() {
            var defaultLanguage = getDefaultLanaguage();
            var configOverWrite = {
                startWithVideoMuted: !vm.videoStatus,
                startWithAudioMuted: !vm.audioStatus,
                defaultLanguage: defaultLanguage
            };

            var options = {
                roomName: vm.sessionModel.jitsi_room_no,
                width: '100%',
                height: '100%',
                parentNode: document.querySelector('#jitsi-session-player'),
                onload: jitsiOnLoad,
                configOverwrite: configOverWrite,
                interfaceConfigOverwrite: SessionPlayerService.getInterfaceConfig(vm.sessionModel),
                jwt: vm.sessionModel.jwt_token
            };

            var api = new JitsiMeetExternalAPI(SessionConfigService.getDomain(), options);

            var eventListeners = {
                videoConferenceJoined: onVideoConferenceJoined,
                videoConferenceLeft: onVideoConferenceLeft,
                participantJoined: onParticipantJoined,
                participantLeft: onParticipantLeft,
                screenSharingStatusChanged: screenSharingStatusChanged,
                recorderStatusChanged: recorderStatusChanged,
                screenShotReady: screenShotReady,
                videoDimensionsReady: videoDimensionsReady,
                onStageParticipantChanged: onStageParticipantChanged,
                arAnnotationReady: arAnnotationReady,
                resizeVideoDimentions: resizeVideoDimentions,
                videoMuteStatusChanged: onVideoMuteStatusChanged,
                userSupportsRemoteControl: onUserSupportsRemoteControl,
                remoteControlPermissionUpdate: onRemoteControlPermissionUpdate,
                remoteControlStopped: onRemoteControlStopped,
                tileViewChanged: onTileViewChanged,
                audioMuteStatusChanged: onAudioMuteStatusChanged,
                mergeRealityLock: onMergeRealityLock
            };

            var displayName = generateUserDisplayName();
            var displayPictureURL = generateDisplayPictureURL();
            var subject = vm.sessionModel.topic + " - " + vm.sessionModel.session_no;

            SessionPlayerService.init(api, vm.isRemoteControlEnabled);
            SessionPlayerService.addEventListeners(eventListeners);
            SessionPlayerService.setDisplayName(displayName);
            SessionPlayerService.setSubject(subject);
            SessionPlayerService.setNotifications(false);
            SessionPlayerService.setDisplayPicture(displayPictureURL);
            SessionPlayerService.setSharedZoom(false);
            if (vm.isMobileBrowser) {
                SessionPlayerService.hideThumbnails(true);
            }

            if (vm.isHost) {
                createSessionActivity('SESSION_STARTED', null);
            } else {
                createSessionActivity('PARTICIPANT_JOINED', null);
            };
        };

        function onMergeRealityLock(message) {
            if (message.data.enable && (vm.isMobileBrowser || !vm.videoStatus)) {
                showMergeRealityDialog(message);
            } else {
                updateMergeReality(message)
            }
        }

        function showMergeRealityDialog(message) {
            $mdDialog.show({
                templateUrl: 'modules/session/session-merge-reality-dialog.tmpl.html',
                controller: 'SessionPlayerMergeRealityController',
                clickOutsideToClose: false,
                controllerAs: 'vm',
                locals: { mainData: vm, message: message },
                bindToController: true,
            }).then(function (result) {
                updateMergeReality(result);
                if (!vm.videoStatus) {
                    vm.toggleVideoOfUser(vm.userId, true, true);
                }

            });
        }

        function updateMergeReality(message) {
            vm.isMergeRealityCallInProgress = message.data.enable;
            vm.baseFeedId = vm.isMergeRealityCallInProgress ? message.data.baseId : null;
            vm.overlayId = vm.isMergeRealityCallInProgress ? message.data.overlayId : null;
            scopeApply();
        }

        function onAudioMuteStatusChanged(data) {
            if (vm.audioStatus === data.muted) {
                vm.audioStatus = !data.muted;
                updateAudioStatus(vm.userId, !data.muted);
                scopeApply()
                var toggleAudioUserMessage = {
                    subject: 'SESSION',
                    action: 'BROADCAST',
                    type: 'AUDIO_STATUS',
                    data: {
                        audioStatus: vm.audioStatus
                    }
                };
                publishMessage(toggleAudioUserMessage);
            }
        }

        function initFullScreenHandler() {
            $document.bind('fullscreenchange', handleFullScreenEvent);
            $document.bind('mozfullscreenchange', handleFullScreenEvent);
            $document.bind('webkitfullscreenchange', handleFullScreenEvent);
        };

        function initPubNubHandler() {
            vm.convChannelName = 'conversation-' + vm.sessionModel.conversation_info.id;
            PubNubService.subscribe([vm.sessionModel.id, vm.convChannelName], false);
        };

        function updateSessionSettingsFromOverwrite() {
            var sessionSettingOverwrite = SessionPlayerService.getSessionSettings();

            if (sessionSettingOverwrite != null) {
                vm.sessionModel.settings.host_video = sessionSettingOverwrite.host_video;
            };
        };

        function isBrowserSupported() {
            if (deviceDetector.browser == 'ie') {
                return false
            } else {
                return true;
            }
        };

        function jitsiOnLoad() {
            $scope.$apply(function () {
                vm.showPlayer = true;
            });
        };

        function handleFullScreenEvent() {
            var doc = $document[0];
            $scope.$apply(function () {
                vm.isFullScreen = !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || doc.msFullscreenElement);
            });
        };

        function handleMessage(message) {
            if (message.message.type == 'PARTICIPANT_INFO') {
                addOrUpdateSessionUser(message.message.data.sessionUser);
                updateWaitingForHost();
                vm.isGuestWaitingForHost = false;
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'END') {
                createSessionActivity('PARTICIPANT_LEFT', null);
                closeSessionPlayer();
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'SCREEN_SHARE_LOCK') {
                onScreenShareChange(message.message.data.locked)

            } else if (message.message.action == 'BROADCAST' && message.message.type == 'TOGGLE_AUDIO_ALL') {
                if (vm.audioStatus != message.message.data.audioStatus) {
                    vm.toggleAudioOfUser(vm.userId, true, false);
                };
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'AUDIO_STATUS') {
                updateAudioStatus(message.publisher, message.message.data.audioStatus);
            } else if (message.message.action == 'USER' && message.message.type == 'AUDIO_STATUS') {
                if (message.message.data.userId == vm.userId && vm.audioStatus) {
                    vm.toggleAudioOfUser(vm.userId, true, false);
                };
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'VIDEO_STATUS') {
                updateVideoStatus(message.publisher, message.message.data.videoStatus);
            } else if (message.message.action == 'USER' && message.message.type == 'VIDEO_STATUS') {
                if (message.message.data.userId == vm.userId && vm.videoStatus) {
                    vm.toggleVideoOfUser(vm.userId, true, false);
                };
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'FLASH_LIGHT_ENABLED') {
                updateFlashLightEnabled(message.publisher, message.message.data.flashLightEnabled);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'FLASH_LIGHT_STATUS') {
                updateFlashLightStatus(message.publisher, message.message.data.flashLightStatus);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'ANNOTATION_LOCK') {
                onAnnotationLock(message.message.data);
            } else if ((message.message.action == 'ANNOTATION_CLASSIC' || message.message.action == 'ANNOTATION_FREEZE_FRAME') && message.message.type == 'SCREENSHOT_READY') {
                vm.annotationType = 'CLASSIC';
                if (vm.isCapturing) {
                    startClassicAnnotation(message.message.data, false, message.message.action);
                } else {
                    startClassicAnnotation(message.message.data, true, message.message.action);
                }
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'FREEZE_FRAME_LOCK') {
                onFreezeFrameLock(message.message.data);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'SCENE_READY') {
                sceneReady();
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'CAPTURE_SCREEN_SHOT') {
                handleCaptureScreenShot(message);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'SCREEN_SHOT_CAPTURED') {
                handleScreenshotSuccess(message);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'AR_SCREEN_SHOT_SUCCESS') {
                handleARScreenshotSuccess(message);
            } else if (message.message.action == 'BROADCAST' && (message.message.type == 'SCREEN_SHOT_FAILED' || message.message.type == 'AR_SCREEN_SHOT_FAILED')) {
                if (vm.userId === message.message.data.userId) {
                    displayToast($filter('translate')('atheer.session.sessionPlayer.screenshotFailed'), 3000);
                    vm.isCapturingScreenshot = false;
                }
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'ANNOTATION_CAPTURED') {
                displayToast(getUserName(message.message.data.userId) + ' ' + $filter('translate')('atheer.session.sessionPlayer.annotationCapture'), 3000);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'PRIVATE_ZOOM') {
                onSharedZoom(message.message.data);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'PARTICIPANT_ZOOM') {
                onParticipantZoom(message.message.data);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'REMOTE_CONTROL_REQUESTED') {
                onRemoteControlRequest(message.message.data);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'REMOTE_CONTROL_REQUEST_ACCEPTED') {
                onRemoteControlRequestAccepted(message.message.data);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'REMOTE_CONTROL_REQUEST_REJECTED') {
                onRemoteControlRequestRejected(message.message.data);
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'REMOTE_CONTROL_STOPPED') {
                handleRemoteControlStop();
            } else if (message.message.action == 'BROADCAST' && message.message.type == 'HOST_CHANGED') {
                handleHostChange();
            };
        };

        function handleARScreenshotSuccess(message) {
            if (vm.userId === message.message.data.userId) {
                logScreenshotData(message);
                displayToast($filter('translate')('atheer.session.sessionPlayer.annotationSaved'), 3000);
            } else {
                displayToast(getUserName(message.message.data.userId) + ' ' + $filter('translate')('atheer.session.sessionPlayer.annotationCapture'), 3000);
            }
        }

        function handleScreenshotSuccess(message) {
            if (vm.userId === message.message.data.userId) {
                logScreenshotData(message);
                displayToast($filter('translate')('atheer.session.sessionPlayer.screenCaptured'), 3000);
            } else {
                displayToast(getUserName(message.message.data.userId) + ' ' + $filter('translate')('atheer.session.sessionPlayer.captured') +
                    getUserName(message.message.data.targetUserId) + $filter('translate')('atheer.session.sessionPlayer.screen'), 3000);
            }
        }

        function logScreenshotData(message) {
            vm.isCapturingScreenshot = false;
            var saveAnnotationProperties = {
                file_name: message.message.data.fileName,
                media_file_name: message.message.data.mediaFileName,
                media_id: message.message.data.mediaId
            };
            createSessionActivity('ANNOTATION_SAVED', saveAnnotationProperties);
        }

        function handleHostChange() {
            $q.all([
                Session.get({
                    id: vm.sessionNo,
                    is_session_no: true,
                    for_launch: true,
                    is_web: true
                }).$promise,
                Setting.getSessionSettings().$promise
            ])
                .then(function (results) {
                    if (!results[0].id && results[0].result === 'NOT_FOUND') {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.sessionExpired'), 3000);
                        navigateBack();
                    } else {
                        vm.sessionModel = results[0];
                        if (!vm.sessionModel.settings) {
                            vm.sessionModel.settings = {};
                            setSettingSessionModel(results[1]);
                        }
                        setSettingsForSurvey(results[1]);
                        vm.changeHostInSessionUsers();
                        updateSessionSettingsFromOverwrite();
                        vm.isHost = isUserHost();
                        if (vm.isHost) {
                            displayToast($filter('translate')('atheer.session.sessionPlayer.toastMessageForHost'), 2000);
                        } else {
                            var txtContent = vm.sessionModel.owner_info.first_name + ' ' + $filter('translate')('atheer.session.sessionPlayer.toastMessageForNonHost');
                            displayToast(txtContent, 2000);
                        };
                        vm.isZoomEnabled = vm.videoStatus ? true : false;
                        vm.canAnnotate = vm.videoStatus ? true : false;
                        if (vm.recordingStatus && vm.isHost) {
                            SessionPlayerService.setFollowme(true);
                        }
                    }
                });
        }

        function uploadLocalPhoto(blob, message) {
            SessionAnnotationService.uploadScreenShotBlob(vm.sessionNo, blob).then(
                function (response) {
                    var screenshotCaptureData = {
                        userId: message.message.data.userId,
                        targetUserId: message.message.data.targetUserId,
                        fileName: response.data.name,
                        mediaFileName: response.data.properties.file_name,
                        mediaId: response.data.id
                    };
                    publishCaptureMessage('SCREEN_SHOT_CAPTURED', screenshotCaptureData);
                    displayToast(getUserName(screenshotCaptureData.userId) + ' ' + $filter('translate')('atheer.session.sessionPlayer.captured') +
                        getUserName(screenshotCaptureData.targetUserId) + $filter('translate')('atheer.session.sessionPlayer.screen'), 3000);
                }
            )
        }

        function handleScreenShotError(message) {
            publishCaptureMessage('SCREEN_SHOT_FAILED', {
                userId: message.message.data.userId,
                targetUserId: message.message.data.targetUserId
            })
        }

        function onTileViewChanged(object) {
            vm.isTileView = object.enabled;
            if (vm.isTileView) {
                vm.userName = null;
            } else {
                var sessionUserId = getUserIdByJitsiId(vm.selectedUserJitsiId)
                vm.userName = vm.userId != sessionUserId ? getUserNameByJitsiId(vm.selectedUserJitsiId) : null;
            }
            scopeApply();
        }

        function generateImageFromCanvas(message) {
            var video = document.createElement('video');
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            video.addEventListener('loadeddata', function () {
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                try {
                    video.play();
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob(function (blob) {
                        uploadLocalPhoto(blob, message);
                        video.remove();
                        canvas.remove();
                    }, 'image/png');

                } catch (error) {
                    handleScreenShotError(message);
                    video.remove();
                    canvas.remove();
                }
            });
            video.srcObject = vm.stream;
        }

        function initializeCamera(message) {
            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia(
                    {
                        video: true,
                        audio: false
                    }).then(function (localMediaStream) {
                        vm.stream = localMediaStream;
                        if ('ImageCapture' in window) {
                            var mediaStreamTrack = localMediaStream.getVideoTracks()[0];
                            vm.imageCapture = new ImageCapture(mediaStreamTrack);
                            handleCaptureScreenShot(message)
                        } else {
                            generateImageFromCanvas(message)
                        }
                    });
            }
        }

        function handleCaptureScreenShot(message) {
            if (message.message.data.targetUserId === vm.userId) {
                if (vm.stream) {
                    if (vm.imageCapture) {
                        vm.imageCapture.takePhoto()
                            .then(function (blob) {
                                uploadLocalPhoto(blob, message);
                            })
                            .catch(function (error) {
                                handleScreenShotError(message);
                            });
                    } else {
                        if ('ImageCapture' in window) {
                            handleScreenShotError(message);
                        } else {
                            generateImageFromCanvas(message);
                        }
                    }
                } else {
                    initializeCamera(message);
                }
            }

        }

        function onRemoteControlRequest(data) {
            if (!vm.jitsiUserId) return;
            vm.isRemoteControlActive = true;
            if (data.toUserId === vm.userId) {
                vm.remoteControlledUser = vm.userId;
                vm.remoteRequestedUser = data.fromUserId;
            }
            if (data.fromUserId !== vm.userId && data.toUserId !== vm.userId) {
                var fromUserName = getUserName(data.fromUserId);
                var toUserName = getUserName(data.toUserId);
                displayToast($filter('translate')('atheer.session.sessionPlayer.remoteControlRequested', { fromUserName: fromUserName, toUserName: toUserName }), 3000);
            }
        }

        function onRemoteControlRequestAccepted(data) {
            if (data.userId !== vm.userId) {
                var userName = getUserName(data.userId);
                displayToast($filter('translate')('atheer.session.sessionPlayer.remoteControlRequestAccepted', { userName: userName }), 3000);
            }
        }

        function onRemoteControlRequestRejected(data) {
            vm.isRemoteControlActive = false;
            if (data.userId !== vm.userId) {
                var userName = getUserName(data.userId);
                displayToast($filter('translate')('atheer.session.sessionPlayer.remoteControlRequestRejected', { userName: userName }), 3000);
            } else {
                createSessionActivity('REMOTE_CONTROL_ACCESS_DENIED', null)
            }
        }

        function onScreenShareChange(locked) {
            vm.shareScreenLocked = locked;
        }

        function handleRemoteControlStop() {
            vm.isRemoteControlActive = false;
            vm.shareScreenLocked = false;
            displayToast($filter('translate')('atheer.session.sessionPlayer.remoteControlStopped', 3000));
        }

        function getUserName(id) {
            var userInfo = vm.sessionUsers.filter(function (value, index, arr) {
                return value.userId == id;
            })[0];

            return userInfo ? (userInfo.firstName ? userInfo.firstName : userInfo.lastName) : '';
        };

        function getUserNameByJitsiId(id) {
            var userInfo = vm.sessionUsers.filter(function (value, index, arr) {
                return value.jitsiUserId == id;
            })[0];

            return userInfo ? (userInfo.firstName ? userInfo.firstName + ' ' + userInfo.lastName : userInfo.lastName) : '';
        };

        function sceneReady() {
            $scope.$broadcast('scene-ready', true);
            vm.isARLoaderRequired = false;
        };

        function onFreezeFrameLock(data) {
            if (data && !data.lockState) {
                vm.isImageLoaded = false;
                vm.isArAnnotating = false;
                SessionPlayerService.annotateAR();
                vm.annotationType = vm.defaultAnnotationType;
            } else {
                vm.defaultAnnotationType = vm.annotationType;
            }
        };

        function onAnnotationLock(data) {
            vm.annotationLocked = data.lockState;
            if (!data.lockState) {
                resetVariables();
                if (data.type !== annotationTypeEnum.classic) {
                    SessionPlayerService.lockArAnnotation(vm.defaultSwitchUserId, false);
                    if (!vm.isMobileBrowser) {
                        SessionPlayerService.hideThumbnails(false);
                    }
                    vm.isARLoaderRequired = true;
                }
            } else {
                var jitsiId;
                angular.forEach(vm.sessionUsers, function (sessionUser) {
                    if (sessionUser.userId === data.targetUser) {
                        jitsiId = sessionUser.jitsiUserId;
                    }
                });
                if (data.type !== annotationTypeEnum.classic) {
                    //switch the user video to target user
                    vm.defaultSwitchUserId = vm.selectedUserJitsiId;
                    SessionPlayerService.lockArAnnotation(jitsiId, true);
                    vm.annotationType = data.type;
                } else {
                    if (vm.userId === data.targetUser && vm.isNativeImageCaptureFeature) {
                        SessionPlayerService.pinParticipant(jitsiId);
                        $timeout(function () {
                            SessionPlayerService.annotate(true);
                        }, 1000);
                        vm.isCapturing = false;
                    } else {
                        vm.isCapturing = true;
                    }
                }

            }
        };

        function startClassicAnnotation(data, isEditEnabled, actionType) {
            var videoFullFrame = $element.find('.fp-iframe-player')[0];
            vm.annotationData = {
                screenShot: data.url,
                originalImageWidth: data.width,
                originalImageHeight: data.height,
                currentImageWidth: videoFullFrame.clientWidth,
                currentImageHeight: videoFullFrame.clientHeight,
                allowAnnotationEdit: isEditEnabled,
                action: actionType
            };
            vm.isAnnotating = true;
            vm.isZoomEnabled = false;
            vm.zoomValue = 100;
            vm.enableZoom = false;
            scopeApply();
        };

        function startARAnnotation(data, isEditEnabled) {
            vm.annotationData = {
                videoWidth: data.width,
                videoHeight: data.height,
                allowAnnotationEdit: isEditEnabled,
                type: vm.annotationType
            };
            vm.isArAnnotating = true;
            vm.isZoomEnabled = false;
            vm.zoomValue = 100;
            vm.isEditEnabled = isEditEnabled;
            SessionPlayerService.hideThumbnails(true);
            if (!vm.isARLoaderRequired) {
                vm.annotationData.annotationFrom = 'FREEZE_FRAME'
            }
            vm.defaultZoom = vm.zoom;
            vm.zoom = 1;
            vm.enableZoom = false;
            SessionPlayerService.applyZoom(0.5, 0.5, 1, vm.selectedUserJitsiId);
            scopeApply();
        };

        function closeSessionPlayer() {
            SessionPlayerService.hangup();
            SessionPlayerService.destroy();
            PubNubService.unsubscribe([vm.sessionModel.id]);
            PubNubService.unsubscribe([vm.convChannelName]);
            $rootScope.selectedLeftNavMenu = 'airsessions';
            if (!vm.isGuest) {
                if (vm.sessionModel.settings.enable_external_survey) {
                    $mdDialog.show({
                        templateUrl: 'modules/session/session-survey-dialog.tmpl.html',
                        clickOutsideToClose: true,
                        controller: 'SessionSurveyController',
                        controllerAs: 'vm',
                        onRemoving: closeSurvey,
                        locals: {
                            externalUrl: vm.sessionModel.settings.external_survey_url
                        }
                    });
                } else {
                    navigateBack();
                }
            } else {

                Auth.logout();
                $cookies.remove('isGuest');
                navigateBack()

            }
        };

        function closeSurvey() {
            navigateBack();
        };

        function navigateBack() {
            var context = sessionStorage.getItem('context');
            if (context === 'home') {
                sessionStorage.removeItem('context');
                var homeState = Auth.isPublicUser() ? 'public.home' : 'storm.home';
                $state.go(homeState)
            } else {
                var state = vm.isGuest ? 'account.guest-join' : 'storm.sessions.upcoming';
                $state.go(state);
            }
        }

        function publishMessage(message) {
            PubNubService.publish(vm.sessionModel.id, message);
        };

        function createSessionActivity(activityType, properties) {
            Experience.createSessionActivity({
                object: vm.sessionModel,
                user_id: Principal.getUserId(),
                activity_type: activityType,
                properties: properties
            }, function (result) {

            });
        };

        function updateSessionConversation() {
            Conversation.get({
                id: vm.sessionModel.conversation_info.id,
            }, onGetSuccess, onGetError);

            function onGetSuccess(result) {
                vm.sessionModel.conversation_info = result

            };

            function onGetError() {

            };
        };

        function onVideoConferenceJoined(object) {
            vm.userName = null;
            vm.jitsiUserId = object.id;
            vm.selectedUserJitsiId = object.id;
            addOrUpdateSessionUser(getLocalSessionUser(object.id));
            SessionPlayerService.setTileView(false);
        };

        function onVideoConferenceLeft(object) {
            removeSessionUser(object.id);
        };

        function onParticipantJoined(object) {
            addOrUpdateSessionUser(getSessionUser(object.id, object.displayName));
            updateSessionConversation();
            $timeout(function () {
                publishLocalUserInfo();
            }, 2000);
        };

        function onParticipantLeft(object) {
            var participant = getUserIdByJitsiId(object.id);
            if (vm.isRemoteControlPermissionRequested && participant === vm.remoteControlledUser) {
                onRemoteControlStopped();
            } else if (vm.isRemoteControlActive && participant === vm.remoteRequestedUser && vm.remoteControlledUser === vm.userId) {
                SessionPlayerService.toggleShareScreen();
                onRemoteControlStopped();
            }



            removeSessionUser(object.id);
            if (vm.isArAnnotating && vm.annotationType !== annotationTypeEnum.classic) {
                vm.isArAnnotating = false;
                SessionPlayerService.lockArAnnotation(vm.defaultSwitchUserId, false);
                if (!vm.isMobileBrowser) {
                    SessionPlayerService.hideThumbnails(false);
                }
            }
        };

        function screenSharingStatusChanged(object) {
            var shareScreenMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: 'SCREEN_SHARE_LOCK',
                data: {
                    locked: object.on
                }
            };
            publishMessage(shareScreenMessage);

            if (object.on) {
                createSessionActivity('SCREEN_SHARE_STARTED', null);
            } else {
                createSessionActivity('SCREEN_SHARE_ENDED', null);
            };
            vm.isScreenSharing = object.on ? true : false;
        };

        function resetRecordingState() {
            vm.recordingStatus = false;
            vm.loadingRecorder = false;

            displayToast($filter('translate')('atheer.session.sessionPlayer.recordingDidntStart'), 3000);

            SessionPlayerService.stopRecording();
        }

        function recorderStatusChanged(object) {
            if (vm.jitsiRecorderStatus == null) {
                vm.jitsiRecorderStatus = object.sessionData.status;
            } else if (vm.jitsiRecorderStatus == object.sessionData.status) {
                return;
            };

            vm.jitsiRecorderStatus = object.sessionData.status;

            if (object.sessionData.status == 'on') {
                if (!vm.recordingStatus) {
                    //cancel recording state timer
                    if (vm.recordingTimer) {
                        $timeout.cancel(vm.recordingTimer);
                    }
                    vm.recordingStatus = true;
                    vm.loadingRecorder = false;
                    vm.hasRecording = true;

                    var sessionActivityProperties = {
                        jitsi_id: object.sessionData.id,
                        status: object.sessionData.status
                    };
                    if (vm.isHost) {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.recordingHasStarted'), 2000);
                    }
                    else {
                        dispalyRecordingMessagePrivacy(sessionActivityProperties);
                    }

                    if (vm.isHost) {
                        createSessionActivity('RECORDING_STARTED', sessionActivityProperties);
                    }
                    if (isMergeRealityCallInProgress) {
                        SessionPlayerService.disableMergeReality();
                    }
                }
            } else if (object.sessionData.status == 'off') {
                if (vm.recordingStatus) {
                    //cancel recording state timer
                    if (vm.recordingTimer) {
                        $timeout.cancel(vm.recordingTimer);
                    }
                    vm.recordingStatus = false;
                    vm.loadingRecorder = false;

                    displayToast($filter('translate')('atheer.session.sessionPlayer.recordingHasStopped'), 2000);
                    if (vm.recordingContentDialogOpen) {
                        $mdDialog.cancel();
                        vm.recordingContentDialogOpen = false;
                    }
                    var sessionActivityProperties = {
                        jitsi_id: object.sessionData.id,
                        status: object.sessionData.status,
                    };
                    if (vm.isHost) {
                        createSessionActivity('RECORDING_ENDED', sessionActivityProperties);
                    }
                }
            } else if (object.sessionData.status == 'pending') {
                vm.recordingStatus = vm.recordingStatus;
                vm.loadingRecorder = vm.loadingRecorder;

                displayToast($filter('translate')('atheer.session.sessionPlayer.preparingToStart'), 2000);
            };
        };

        function dispalyRecordingMessagePrivacy(sessionActivityProperties) {
            if (vm.recordingContentFeature) {
                vm.recordingContentDialogOpen = true;
                $mdDialog.show({
                    templateUrl: 'modules/session/session-recording-message-privacy.tmpl.html',
                    controller: 'SessionPlayerRecordingMessageController',
                    clickOutsideToClose: false,
                    controllerAs: 'vm',
                    locals: { mainData: vm },
                    bindToController: true,
                }).then(function (result) {
                    vm.recordingContentDialogOpen = false;
                    if (result) {
                        createSessionActivity('RECORDING_CONSENTED', sessionActivityProperties);
                    }
                    else {
                        createSessionActivity('RECORDING_DECLINED', sessionActivityProperties);
                        createSessionActivity('PARTICIPANT_LEFT', null);
                        closeSessionPlayer();
                    }
                });
            }
        }

        function publishLocalUserInfo() {
            var scale = 1, tx = 0.5, ty = 0.5;
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (vm.userId == sessionUser.userId) {
                    scale = sessionUser.scale;
                    tx = sessionUser.tx;
                    ty = sessionUser.ty;
                }
            });
            var sessionUser = {
                jitsiUserId: vm.jitsiUserId,
                userId: vm.userId,
                isHost: vm.isHost,
                firstName: vm.userInfo.first_name,
                lastName: vm.userInfo.last_name,
                shortName: vm.userShortName,
                audioStatus: vm.audioStatus,
                videoStatus: vm.videoStatus,
                hasFlashLight: false,
                flashLightStatus: false,
                hasSlam: false,
                isBrowser: true,
                isGuest: vm.isGuest ? true : false,
                pictureId: vm.userInfo.picture_id,
                aspectRatio: 1,
                scale: scale,
                tx: tx,
                ty: ty,
                isSharedZoomDisabled: vm.isSharedZoomDisabled,
                isGlasses: false,
                isRemoteControlActive: vm.isRemoteControlActive
            };

            var userJoinedMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: 'PARTICIPANT_INFO',
                data: {
                    sessionUser: sessionUser
                }
            };
            publishMessage(userJoinedMessage);
        };

        function updateAudioStatus(userId, audioStatus) {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (userId == sessionUser.userId) {
                    sessionUser.audioStatus = audioStatus;
                };
            });
        };

        function updateAudioOfAllUsers(audioStatus) {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (vm.userId != sessionUser.userId) {
                    sessionUser.audioStatus = audioStatus;
                };
            });
        };

        function updateVideoStatus(userId, videoStatus) {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (userId == sessionUser.userId) {
                    sessionUser.videoStatus = videoStatus;

                    if (videoStatus && sessionUser.jitsiUserId === vm.baseId) {
                        vm.isWaitingForOtherUserFeed = false;
                    }

                    if (sessionUser.jitsiUserId == vm.selectedUserJitsiId) {
                        vm.canAnnotate = videoStatus ? true : false;
                        vm.isZoomEnabled = !vm.isZoomEnabled;
                        if (!vm.isZoomEnabled) {
                            vm.enableZoom = false;
                            vm.zoomValue = 100;
                        }
                        if (vm.isZoomEnabled) {
                            vm.enableZoom = true;
                        }
                    };
                };
            });
            if (vm.sessionUsers.length === 0) {
                vm.isZoomEnabled = videoStatus ? true : false;
                vm.canAnnotate = videoStatus ? true : false;
            }
        };

        function updateFlashLightEnabled(userId, flashLightEnabled) {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (userId == sessionUser.userId) {
                    sessionUser.hasFlashLight = flashLightEnabled;
                };
            });
        };

        function updateFlashLightStatus(userId, flashLightStatus) {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (userId == sessionUser.userId) {
                    sessionUser.flashLightStatus = flashLightStatus;
                };
            });
        };

        function addOrUpdateSessionUser(sessionUser) {
            if (sessionUser.isSharedZoomDisabled) {
                vm.isSharedZoomDisabled = sessionUser.isSharedZoomDisabled;
            }

            if (sessionUser.isRemoteControlActive) {
                vm.isRemoteControlActive = sessionUser.isRemoteControlActive;
            }

            //vm.isSharedZoomDisabled = sessionUser.isSharedZoomDisabled;
            var updatedSessionUsers = vm.sessionUsers.filter(function (value, index, arr) {
                return value.userId != sessionUser.userId;
            });
            updatedSessionUsers.push(sessionUser);
            vm.sessionUsers = updatedSessionUsers;

            //to set zoom for newly added participant
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (vm.isSharedZoomDisabled) {
                    SessionPlayerService.applyZoom(sessionUser.tx, sessionUser.ty, sessionUser.scale, sessionUser.jitsiUserId)
                }
            });

            if (vm.isSharedZoomDisabled) {
                SessionPlayerService.setSharedZoom(vm.isSharedZoomDisabled);
                vm.isZoomToolsEnabled = vm.userId == getUserId() || getUserId() == undefined ? true : false;
            }

            var userExist = false;

            if (vm.sessionModel.owner == sessionUser.userId) {
                userExist = true;
            };

            if (!userExist) {
                angular.forEach(vm.sessionModel.session_users, function (sessionUserTemp) {
                    if (sessionUserTemp.user_id == sessionUser.userId) {
                        userExist = true;
                    };
                });
            };

            if (!userExist) {
                var newUser = null;
                if (sessionUser.isHost) {
                    newUser = {
                        user_id: sessionUser.userId,
                        role: "HOST",
                        is_guest: sessionUser.isGuest
                    }
                } else {
                    newUser = {
                        user_id: sessionUser.userId,
                        role: "PARTICIPANT",
                        is_guest: sessionUser.isGuest
                    }
                }
                vm.sessionModel.session_users.push(newUser);
            }
        };

        function removeSessionUser(jitsiUserId) {
            var updatedSessionUsers = vm.sessionUsers.filter(function (value, index, arr) {
                return value.jitsiUserId != jitsiUserId;
            });
            vm.sessionUsers = updatedSessionUsers;
            scopeApply();
        };

        function isUserHost() {
            var isUserHost = false;
            if (vm.sessionModel.owner == vm.userId) {
                isUserHost = true;
            } else {
                if (vm.sessionModel.session_users && vm.sessionModel.session_users != null) {
                    angular.forEach(vm.sessionModel.session_users, function (sessionUser) {
                        if (sessionUser.user_id == vm.userId && sessionUser.role == 'HOST') {
                            isUserHost = true;
                        };
                    });
                };
            };
            return isUserHost;
        };

        function updateWaitingForHost() {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (sessionUser.isHost) {
                    vm.waitingForHost = false;
                    return;
                };
            });
        };

        function screenShotReady(screenShotData) {
            SessionAnnotationService.uploadScreenShot(vm.sessionNo, screenShotData.imageData).then(function (response) {
                if (screenShotData.isClassicAnnotation) {
                    var data = {
                        url: response.data.properties.file_name,
                        width: screenShotData.imageData.width,
                        height: screenShotData.imageData.height
                    };
                    if (!vm.isFreezeFrame) {
                        var action = vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC';
                        if (vm.isCapturing) {
                            startClassicAnnotation(data, true, action);
                        } else {
                            startClassicAnnotation(data, false, action);
                        }
                        var receiveAnnotation = {
                            subject: 'SESSION',
                            action: action,
                            type: 'SCREENSHOT_READY',
                            data: data
                        };
                        publishMessage(receiveAnnotation);
                    }
                    vm.isFreezeFrame = false;
                    if (vm.isArAnnotating) {
                        var annotationCaptureData = {
                            userId: vm.userId
                        };
                        publishCaptureMessage('ANNOTATION_CAPTURED', annotationCaptureData);
                        saveImageInSessionActivity('ANNOTATION_SAVED', response);
                        $scope.$broadcast('show-loader', false);
                        displayToast($filter('translate')('atheer.session.sessionPlayer.annotationSaved'), 3000);
                    }
                } else {
                    var screenshotCaptureData = {
                        userId: vm.userId,
                        targetUserId: getUserId()
                    };
                    publishCaptureMessage('SCREEN_SHOT_CAPTURED', screenshotCaptureData);
                    saveImageInSessionActivity('ANNOTATION_SAVED', response);
                    displayToast($filter('translate')('atheer.session.sessionPlayer.screenCaptured'), 3000);
                    vm.isCapturingScreenshot = false;
                }
            }).catch(function (err) {
                displayToast($filter('translate')('atheer.session.sessionPlayer.screenshotFailed'), 3000);
                var closeAnnotationMessage = {
                    subject: 'SESSION',
                    action: 'BROADCAST',
                    type: 'ANNOTATION_LOCK',
                    data: {
                        lockState: false
                    }
                };
                resetVariables();
                publishMessage(closeAnnotationMessage);
                createSessionActivity('ANNOTATION_ENDED', null);
            });
        };

        function publishCaptureMessage(type, data) {
            var screenshotCaptureMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: type,
                data: data
            };
            publishMessage(screenshotCaptureMessage);
        };

        function saveImageInSessionActivity(activityName, response) {
            var saveAnnotationProperties = {
                file_name: response.data.name,
                media_file_name: response.data.properties.file_name,
                media_id: response.data.id
            };

            createSessionActivity(activityName, saveAnnotationProperties);
        };

        function resetVariables() {
            vm.isArAnnotating = false;
            vm.isAnnotating = false;
            vm.isAnnotationSaved = false;
            vm.isAnnotationView = false;
            vm.isImageLoaded = false;
            vm.isZoomEnabled = true;
            vm.isFreezeFrame = false;
            vm.zoom = (vm.defaultZoom > 1) ? vm.defaultZoom : vm.zoom;
            vm.enableZoom = (vm.zoom > 1 || vm.defaultZoom > 1) ? true : false;
            vm.defaultZoom = 1;
            vm.isCapturing = false;
            vm.isCapturingScreenshot = false;
        };

        function videoDimensionsReady(videoData) {
            var annotationData = {
                lockState: true,
                targetAspectRatio: 1,
                type: vm.annotationType,
                targetUser: getUserId(),
            };

            var annotationLockMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: 'ANNOTATION_LOCK',
                data: annotationData
            };
            publishMessage(annotationLockMessage);
            SessionPlayerService.setAnnotationMode(true);
            startARAnnotation(videoData.data, true);
            createSessionActivity('ANNOTATION_STARTED', null);
        };

        function onStageParticipantChanged(user) {
            vm.selectedUserJitsiId = user.id;
            //handling virtual screeshare participant
            if (vm.selectedUserJitsiId && vm.selectedUserJitsiId.indexOf("-") !== -1) {
                SessionPlayerService.applyZoom(0.5, 0.5, 1, vm.selectedUserJitsiId);
                vm.zoom = 1;
                vm.isZoomEnabled = false;
                vm.enableZoom = false;
                vm.zoomValue = 100;
                vm.canAnnotate = false;
                vm.isFakeParticipantOnStage = true;
                vm.isARSupported = false;
                vm.hasSlam = false;
                vm.userHasRemoteControlSupport = false;
                vm.isZoomToolsEnabled = false;
                scopeApply();
                return;
            }


            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (vm.selectedUserJitsiId === sessionUser.jitsiUserId) {
                    if (sessionUser.videoStatus) {
                        if (!vm.isSharedZoomDisabled || (vm.isSharedZoomDisabled && sessionUser.scale <= 1)) {
                            sessionUser.scale = 1;
                            SessionPlayerService.applyZoom(0.5, 0.5, sessionUser.scale, vm.selectedUserJitsiId)
                        } else if (vm.isSharedZoomDisabled && sessionUser.scale > 1) {
                            SessionPlayerService.applyZoom(sessionUser.tx, sessionUser.ty, sessionUser.scale, vm.selectedUserJitsiId);
                        }
                        vm.enableZoom = !vm.isSharedZoomDisabled ? false : (vm.userId == sessionUser.userId ? true : false);
                        vm.zoom = sessionUser.scale;
                        vm.zoomValue = Math.floor(sessionUser.scale * 100);
                        vm.isZoomEnabled = true;
                        vm.zoomSlider = vm.zoom * 100;
                    } else {
                        vm.zoom = 1;
                        sessionUser.scale = 1;
                        vm.isZoomEnabled = false;
                        vm.enableZoom = false;
                        vm.zoomValue = 100;
                    }

                    vm.hasSlam = sessionUser.hasSlam ? true : false;
                    vm.canAnnotate = (!sessionUser.videoStatus) ? false : true;
                    vm.isARSupported = (!sessionUser.isBrowser && vm.isLiveAnnotationFeatureEnabled) ? true : false;
                    vm.userName = vm.userId != sessionUser.userId ? sessionUser.firstName + " " + sessionUser.lastName : null;
                    vm.isZoomToolsEnabled = !vm.isSharedZoomDisabled ? true : (vm.userId == sessionUser.userId ? true : false);
                    vm.userHasRemoteControlSupport = vm.remoteControlAccessMap[vm.selectedUserJitsiId];
                    vm.isFakeParticipantOnStage = false;


                    scopeApply();
                }
            });
        };

        function arAnnotationReady(videoData) {
            startARAnnotation(videoData.data, false);
        };

        function resizeVideoDimentions(data) {
            $scope.$broadcast('resize-video', data);
        };

        function onUserSupportsRemoteControl(msg) {
            var data = msg.data;
            vm.remoteControlAccessMap[data.id] = data.supportsRemoteControl;
            scopeApply();
        }

        function onRemoteControlPermissionUpdate(msg) {
            var data = msg.data;
            var remoteControlMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: (data.permisson) ? 'REMOTE_CONTROL_REQUEST_ACCEPTED' : 'REMOTE_CONTROL_REQUEST_REJECTED',
                data: {
                    userId: vm.remoteControlledUser
                }
            }

            var userName = getUserName(vm.remoteControlledUser);
            if (!data.permisson) {
                vm.remoteControlledUser = null;
                vm.isRemoteControlActive = false;
                if (vm.isRemoteControlPermissionRequested) {
                    publishMessage(remoteControlMessage);
                    displayToast($filter('translate')('atheer.session.sessionPlayer.remoteControlRequestRejected', { userName: userName }), 3000);
                }
            } else {
                createSessionActivity('REMOTE_CONTROL_STARTED', null);
                publishMessage(remoteControlMessage);
                displayToast($filter('translate')('atheer.session.sessionPlayer.remoteControlRequestAccepted', { userName: userName }), 3000);
            }
            vm.isRemoteControlPermissionRequested = false;
            vm.isRemoteControlPermissionGranted = data.permisson;
            scopeApply();
        }

        function onRemoteControlStopped() {
            var remoteControlMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: 'REMOTE_CONTROL_STOPPED'
            }
            createSessionActivity('REMOTE_CONTROL_ENDED', null);
            publishMessage(remoteControlMessage);
            vm.isRemoteControlPermissionGranted = false;
            vm.remoteControlledUser = null;
            vm.remoteRequestedUser = null;
            vm.isRemoteControlActive = false;
            vm.shareScreenLocked = false;
            scopeApply();
        }

        function getUserId() {
            var userId = getUserIdByJitsiId(vm.selectedUserJitsiId);
            return userId;
        };

        function getUserIdByJitsiId(jitsiId) {
            var userId;

            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (sessionUser.jitsiUserId === jitsiId) {
                    userId = sessionUser.userId;
                }
            });
            return userId;
        };

        function getLocalSessionUser(jitsiUserId) {
            var sessionUser = {
                jitsiUserId: jitsiUserId,
                userId: vm.userId,
                firstName: vm.userInfo.first_name,
                lastName: vm.userInfo.last_name,
                shortName: vm.userShortName,
                isHost: vm.isHost,
                audioStatus: vm.audioStatus,
                videoStatus: vm.videoStatus,
                hasFlashLight: false,
                flashLightStatus: false,
                hasSlam: false,
                isBrowser: true,
                isGuest: vm.isGuest ? true : false,
                aspectRatio: 1,
                scale: 1,
                tx: 0.5,
                ty: 0.5,
                isSharedZoomDisabled: vm.isSharedZoomDisabled,
                pictureId: vm.userInfo.picture_id
            };
            return sessionUser;
        };

        function getSessionUser(jitsiUserId, jitsiDisplayName) {
            var userStatusInfo = jitsiDisplayName.split(':');

            var userId = userStatusInfo[0];
            var userInfo = userStatusInfo[1];
            var shortName = userStatusInfo[2];
            var fullName = userStatusInfo[3];
            var firstName = fullName.split(' ')[0];
            var lastName = fullName.split(' ')[1];

            var isHost = vm.sessionModel.owner === userId; //userInfo.charAt(0) == '1';
            var audioStatus = userInfo.charAt(1) == '1';
            var videoStatus = userInfo.charAt(2) == '1';
            var hasFlashLight = userInfo.charAt(3) == '1';
            var flashLightStatus = userInfo.charAt(4) == '1';
            var hasSlam = userInfo.charAt(5) == '1';
            var isBrowser = userInfo.charAt(6) == '1';
            var isGuest = userInfo.charAt(7) == '1';
            var aspectRatio = parseInt(userInfo.charAt(8));
            var scale = parseInt(userInfo.charAt(9));
            var tx = userInfo.charAt(10) == '1' ? 0.5 : 0;
            var ty = userInfo.charAt(11) == '1' ? 0.5 : 0;
            var isSharedZoomDisabled = userInfo.charAt(12) == '1';

            var sessionUser = {
                jitsiUserId: jitsiUserId,
                userId: userId,
                firstName: firstName,
                lastName: lastName,
                shortName: shortName,
                isHost: isHost,
                audioStatus: audioStatus,
                videoStatus: videoStatus,
                hasFlashLight: hasFlashLight,
                flashLightStatus: flashLightStatus,
                hasSlam: hasSlam,
                isBrowser: isBrowser,
                isGuest: isGuest,
                aspectRatio: aspectRatio,
                scale: scale,
                tx: tx,
                ty: ty,
                isSharedZoomDisabled: isSharedZoomDisabled
            };
            return sessionUser;
        };

        function getLocalUserStatusInfo() {
            var userInfo = '0000000000000';

            //host
            if (vm.isHost) {
                userInfo = replaceAt(userInfo, 0, 1);
            };

            //audio status
            if (vm.audioStatus) {
                userInfo = replaceAt(userInfo, 1, 1);
            };

            //video status
            if (vm.videoStatus) {
                userInfo = replaceAt(userInfo, 2, 1);
            };

            //has flash light
            userInfo = replaceAt(userInfo, 3, 0);

            //flash light status
            userInfo = replaceAt(userInfo, 4, 0);

            //has slam
            userInfo = replaceAt(userInfo, 5, 0);

            //is browser
            userInfo = replaceAt(userInfo, 6, 1);

            //is Guest
            if (vm.isGuest) {
                userInfo = replaceAt(userInfo, 7, 1);
            }

            //aspect ratio
            userInfo = replaceAt(userInfo, 8, 1);

            //zoom
            userInfo = replaceAt(userInfo, 9, 1);

            //tx
            userInfo = replaceAt(userInfo, 10, 1);

            //ty
            userInfo = replaceAt(userInfo, 11, 1);

            //is private zoom disabled
            userInfo = replaceAt(userInfo, 12, 0);

            return userInfo;
        };

        function replaceAt(str, index, chr) {
            if (index > str.length - 1) {
                return str;
            }
            return str.substring(0, index) + chr + str.substring(index + 1);
        };

        function generateUserDisplayName() {
            var displayName = vm.userId;
            displayName = displayName + ':' + getLocalUserStatusInfo();
            displayName = displayName + ':' + vm.userShortName;

            if (vm.userInfo.first_name) {
                displayName = displayName + ':' + vm.userInfo.first_name;
            }

            if (vm.userInfo.last_name) {
                displayName = displayName + ' ' + vm.userInfo.last_name;
            } else {
                displayName = displayName + ' ' + '.';
            }
            return displayName;
        };

        function generateDisplayPictureURL() {
            if (vm.userInfo.picture_id) {
                return 'https://' + window.location.host + '/media/pictures/' + vm.userInfo.picture_id;
            }
            return '';
        };

        function checkForGuestUsers() {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (sessionUser.isGuest) {
                    addOrUpdateGuestUser(sessionUser);
                }
            });
        };

        function addOrUpdateGuestUser(sessionUser) {
            angular.forEach(vm.sessionModel.session_users, function (sessionUserTemp) {
                if (sessionUserTemp.user_id == sessionUser.userId) {
                    sessionUserTemp.is_guest = sessionUser.isGuest;
                }
            });
        };

        function displayToast(textContent, delay) {
            ToastService.displayToast(textContent, delay);
        };

        function onVideoMuteStatusChanged(data) {
            if (data.muted === vm.videoStatus) {
                vm.videoStatus = !data.muted;
                updateVideoStatus(vm.userId, !data.muted)
                scopeApply();
                var toggleVideoUserMessage = {
                    subject: 'SESSION',
                    action: 'BROADCAST',
                    type: 'VIDEO_STATUS',
                    data: {
                        videoStatus: vm.videoStatus
                    }
                };
                publishMessage(toggleVideoUserMessage);
            }

        };

        function getReadMessagesCount() {
            Experience.getReadMessages({
                userId: vm.userId,
                conversationId: vm.sessionModel.conversation_info.id
            }, function (readMessage) {
                if (readMessage && readMessage.object && readMessage.object.id == vm.sessionModel.conversation_info.id) {
                    vm.messagesCount = readMessage.properties.count;
                }
            });
        };

        function setMessagesCount(event, message) {
            // var messageAlert = new Audio('/assets/audio/message-received-sound.mp3');
            if (vm.showConversation) {
                getReadMessagesCount();
                // messageAlert.play();
            } else {
                if (message.message.data.conversation_id == vm.sessionModel.conversation_info.id) {
                    vm.messagesCount = vm.messagesCount + 1;
                    // messageAlert.play();
                } else {
                    NotificationHandleService.onNotification(message);
                }
            }
        };

        function getUnReadMessageCount() {
            Experience.getUnReadMessageCount({
                id: vm.userId
            }, function (unReadMessages) {
                angular.forEach(unReadMessages, function (unReadMessage) {
                    if (unReadMessage && unReadMessage.object && unReadMessage.object.id == vm.sessionModel.conversation_info.id) {
                        vm.messagesCount = unReadMessage.properties.count;
                    }
                });
            });
        };

        function getDefaultLanaguage() {
            var jitsiSupportedLanguageCodes = [
                { stormCode: "en_US", jitsiCode: "en" },
                { stormCode: "en_GB", jitsiCode: "enGB" },
                { stormCode: "fr_FR", jitsiCode: "fr" },
                { stormCode: "de_DE", jitsiCode: "de" },
                { stormCode: "el_GR", jitsiCode: "el" },
                { stormCode: "it_IT", jitsiCode: "it" },
                { stormCode: "ja_JP", jitsiCode: "ja" },
                { stormCode: "pt_BR", jitsiCode: "ptBR" },
                { stormCode: "es_CL", jitsiCode: "es" },
                { stormCode: "zh_TW", jitsiCode: "zhTW" },
                { stormCode: "zh_CN", jitsiCode: "zhCN" },
                { stormCode: "nl_NL", jitsiCode: 'nl' },
                { stormCode: "da_DK", jitsiCode: 'da' },
                { stormCode: "no_NO", jitsiCode: 'en' },//JITSI Doesnt support Norwegein
                { stormCode: "pl_PL", jitsiCode: 'pl' },
                { stormCode: "ru_RU", jitsiCode: 'ru' },
                { stormCode: "sv_SE", jitsiCode: 'sv' },
                { stormCode: "tr_TR", jitsiCode: 'tr' }
            ];
            var language = $cookies.getObject('NG_TRANSLATE_LANG_KEY');
            var defaultLanguage = jitsiSupportedLanguageCodes.filter(function (lang) {
                return lang.stormCode == language;
            })[0];

            return defaultLanguage.jitsiCode;
        };

        function publishSharedZoomDisabled() {
            var privateZoomEnabledMessage = {
                subject: 'SESSION',
                action: 'BROADCAST',
                type: 'PRIVATE_ZOOM',
                data: {
                    userId: getUserId(),
                    disable: vm.isSharedZoomDisabled
                }
            };
            publishMessage(privateZoomEnabledMessage);
        };

        function publishParticipantZoomData() {
            if (vm.isSharedZoomDisabled && vm.userId == getUserId()) {
                var scale, tx, ty;
                angular.forEach(vm.sessionUsers, function (sessionUser) {
                    if (vm.userId == sessionUser.userId) {
                        scale = sessionUser.scale;
                        tx = sessionUser.tx;
                        ty = sessionUser.ty;
                    }
                });
                var participantZoomMessage = {
                    subject: 'SESSION',
                    action: 'BROADCAST',
                    type: 'PARTICIPANT_ZOOM',
                    data: {
                        userId: vm.userId,
                        scale: scale,
                        tx: tx,
                        ty: ty
                    }
                };
                publishMessage(participantZoomMessage);
            }
        };

        function resetZoom() {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                sessionUser.scale = 1;
                sessionUser.tx = 0.5;
                sessionUser.ty = 0.5;
                SessionPlayerService.applyZoom(0.5, 0.5, 1, sessionUser.jitsiUserId);
                if (vm.selectedUserJitsiId == sessionUser.jitsiUserId) {
                    vm.enableZoom = vm.userId == sessionUser.userId ? true : false;
                    vm.zoom = sessionUser.scale;
                    vm.zoomValue = Math.floor(sessionUser.scale * 100);
                    vm.zoomSlider = vm.zoom * 100;
                }
            });
            vm.isZoomToolsEnabled = !vm.isSharedZoomDisabled ? true : (vm.userId == getUserId() ? true : false);
        };

        function onParticipantZoom(data) {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (sessionUser.userId === data.userId) {
                    sessionUser.scale = data.scale;
                    sessionUser.tx = data.tx;
                    sessionUser.ty = data.ty;
                    SessionPlayerService.applyZoom(data.tx, data.ty, data.scale, sessionUser.jitsiUserId);
                }
            });
        };

        function onSharedZoom(data) {
            vm.isSharedZoomDisabled = data.disable;
            SessionPlayerService.setSharedZoom(data.disable);
            var message = data.disable ? $filter('translate')('atheer.session.sessionPlayer.sharedZoom.disabledToastMessage') : $filter('translate')('atheer.session.sessionPlayer.sharedZoom.enabledToastMessage');
            vm.isZoomToolsEnabled = !vm.isSharedZoomDisabled ? true : (vm.userId == getUserId() ? true : false);
            displayToast(message);
            resetZoom();
        };

        function updateRolesforSessionUsers(upcomingHostData) {
            var users = vm.sessionModel.session_users;
            for (var i = 0; i < users.length; i++) {
                if (users[i].user_id === upcomingHostData.userId) {
                    vm.sessionModel.session_users.splice(i, 1);
                    break;
                }
            }

            var user = {
                user_id: vm.userId,
                role: "PARTICIPANT",
                is_guest: vm.isGuest ? true : false
            }
            vm.sessionModel.session_users.push(user);
            vm.sessionModel.owner = upcomingHostData.userId;
        }

        vm.startLocalImageShareAnnotation = function (data) {
            startClassicAnnotation(data, true, "ANNOTATION_CLASSIC");
            var receiveAnnotation = {
                subject: 'SESSION',
                action: 'ANNOTATION_CLASSIC',
                type: 'SCREENSHOT_READY',
                data: data
            };
            publishMessage(receiveAnnotation);
        };

        vm.sendAnnotationLockMessageForLocalImage = function () {
            if (!vm.isFreezeFrame) {
                var annotationData = {
                    lockState: true,
                    targetAspectRatio: 1.0,
                    type: 'CLASSIC',
                    targetUser: vm.userId,
                };

                var annotationLockMessage = {
                    subject: 'SESSION',
                    action: 'BROADCAST',
                    type: 'ANNOTATION_LOCK',
                    data: annotationData
                };
                publishMessage(annotationLockMessage);
                createSessionActivity('ANNOTATION_STARTED', null);
                vm.annotationType = annotationTypeEnum.classic;
                vm.isAnnotationView = true;
                vm.isAnnotationSaved = false;
            }
        };

        vm.makeAlternateUserHost = function (userData) {
            $mdDialog.show({
                templateUrl: 'modules/session/session-player-make-alternate-host-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'SessionPlayerMakeAlternateHostController',
                controllerAs: 'vm',
                locals: {
                    userId: userData.userId,
                    userName: userData.firstName,
                    isMobileBrowser: vm.isMobileBrowser,
                }
            }).then(function (stat) {
                vm.updateHostAndInitiatePubnum(userData);
            });
        };

        vm.updateHostAndInitiatePubnum = function (userData) {
            updateRolesforSessionUsers(userData);
            Session.update(vm.sessionModel, function (result) {
                if (!result.id && result.result === 'NOT_FOUND') {
                    displayToast($filter('translate')('atheer.session.sessionPlayer.sessionExpired'), 3000);
                    // $state.go('storm.sessions.upcoming');
                    navigateBack();
                } else {
                    SessionPlayerService.grantHostPermission(userData.jitsiUserId);
                    var alternateHostMessage = {
                        subject: 'SESSION',
                        action: 'BROADCAST',
                        type: 'HOST_CHANGED',
                        data: result
                    };
                    publishMessage(alternateHostMessage);
                    Session.get({
                        id: vm.sessionNo,
                        is_session_no: true,
                        for_launch: true,
                        is_web: true
                    },function(response) {
                        vm.sessionModel = response;
                    }, function(error) {
                        vm.sessionModel = result;
                        console.error(error);
                    })
                    if (!vm.sessionModel.settings) {
                        vm.sessionModel.settings = {};
                        setSettingSessionModel(result);
                    }
                    setSettingsForSurvey(result);
                    vm.changeHostInSessionUsers();
                    updateSessionSettingsFromOverwrite();
                    vm.isHost = isUserHost();
                    if (vm.isHost) {
                        displayToast($filter('translate')('atheer.session.sessionPlayer.toastMessageForHost'), 2000);
                    } else {
                        var txtContent = vm.sessionModel.owner_info.first_name + ' ' + $filter('translate')('atheer.session.sessionPlayer.toastMessageForNonHost');
                        displayToast(txtContent, 2000);
                    };
                    vm.isZoomEnabled = vm.videoStatus ? true : false;
                    vm.canAnnotate = vm.videoStatus ? true : false;
                }
            });
        }

        vm.changeHostInSessionUsers = function () {
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (sessionUser.isHost) {
                    sessionUser.isHost = false;
                }
            });
            angular.forEach(vm.sessionUsers, function (sessionUser) {
                if (sessionUser.userId === vm.sessionModel.owner) {
                    sessionUser.isHost = true;
                }
            });
        }

        closeAnnotationListener = $scope.$on('close-annotation', closeAnnotation);
        imageLoadedListener = $scope.$on('image-loaded', imageLoaded);
        annotationImageSavedListener = $scope.$on('annotation-image-saved', saveAnnotation);
        saveAnnotationImageListener = $scope.$on('save-annotation-image', updateAnnotationStatus);
        freezeFrameListener = $scope.$on('freeze-frame', onFreezeFrame);
        sessionMessagesCount = $scope.$on('unReadMessages', setMessagesCount);

        $scope.$watch('vm.zoomSlider', function (zoomSliderValue) {
            vm.zoom = zoomSliderValue / 100;
            if (vm.zoom > 1) {
                vm.enableZoom = !vm.isSharedZoomDisabled ? true : (vm.userId == getUserId() ? true : false);
            }
        });

        $scope.$on('$destroy', function () {
            closeAnnotationListener = null;
            imageLoadedListener = null;
            annotationImageSavedListener = null;
            saveAnnotationImageListener = null;
            freezeFrameListener = null;
            pubNubSessionListener = null;
            sessionMessagesCount = null;

            if (vm.isGuest) {
                Auth.logout();
            }

            $rootScope.isSessionStarted = false;
            if (vm.stream) {
                var tracks = vm.stream.getTracks();

                angular.forEach(tracks, function (track) {
                    track.stop();
                });
                vm.stream = null;
            }
            vm.imageCapture = null;
        });

        pubNubSessionListener = $scope.$on('sessionMessagePubNub', function (event, message) {
            $scope.$apply(function () {
                if (message.message.subject == 'SESSION' && message.publisher != vm.userId) {
                    handleMessage(message);
                };
            });
        });

        loadData();
    };
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionInsights', sessionInsights);

    function sessionInsights() {
        var directive = {
            scope: {
                sessionModel: '='
            },
            bindToController: true,
            controller: sessionInsightsController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-insights.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionInsightsController($scope, $mdDialog, $mdSidenav, triTheming, triSettings, $mdToast, $document, $location, $mdPanel, $state, $timeout, $q, $filter, ParseLinks, Principal, Session, Experience, AlertService, paginationConstants, $http) {
        var vm = this;

        vm.loadingData = false;
        vm.transition = transition;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.sessionActivities = null;
        vm.session_activities = [];
        vm.participantsList = [];
        vm.guestList = [];
        vm.loadingActivities = false;

        vm.feedbackPage = 0;
        vm.ratingAndCommentsActivities = [];
        vm.feedbackActivities = [];
        vm.feedbackPageSize = paginationConstants.itemsPerPage;
        vm.loadingFeedbackActivities = false;
        vm.isLoadingFeedback = false;
        vm.backgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value
        );

        vm.togglePanel = function () {
            $mdSidenav('insightsPanel').toggle()
                .then(function () {

                });
        };

        vm.downloadReport = function () {
            var url = '/api/sessions/pdf/' + vm.sessionModel.id;

            $http.get(url, { responseType: 'blob' }).then(function (response) {
                var objectUrl = URL.createObjectURL(response.data);
                var link = document.createElement('a');
                link.download = vm.sessionModel.session_no,
                    link.href = objectUrl;
                link.click();
            })

        }

        function transition() {
            vm.loadingActivities = true;
            Experience.getSessionActivities({
                page: vm.page - 1,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onTSuccess, onTError);

            function onTSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                getSessionActivities();
                getLineHeight();
                vm.loadingActivities = false;
            }

            function onTError(error) {
                AlertService.error(error.data.message);
            }
        };

        function sort() {
            return 'id,asc';
        };

        function getQueryString() {
            var queryString = "object_id==" + vm.sessionModel.id;
            return queryString;
        };

        function loadData() {
            if (!vm.sessionModel) {
                return;
            }

            vm.loadingData = true;
            vm.isLoadingFeedback = true;

            Experience.getSessionActivities({
                page: 0,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                vm.page = 1;
                vm.loadingData = false;
                getSessionActivities();
                getLineHeight();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            getParticipantsList();
            getRatingsAndComments();
        };

        function getRatingsAndComments() {
            Experience.getSessionRatingAndComments({
                page: 0,
                size: vm.feedbackPageSize,
                sort: sort(),
                query: getRatingAndCommentsQueryString(),
                user_info: true
            }, onSuccess, onError);

            function onSuccess(result, headers) {
                vm.feedbackLinks = ParseLinks.parse(headers('link'));
                vm.feedbackQueryCount = headers('X-Total-Count');
                vm.ratingAndCommentsActivities = result;
                vm.feedbackPage = 1;
                vm.isLoadingFeedback = false;

                getFeedbackDetails();
            };

            function onError(error) {
                AlertService.error(error.data.message);
            };
        };

        function getRatingAndCommentsQueryString() {
            return "action_type==FEEDBACK;object_id==" + vm.sessionModel.id;
        };

        function getFeedbackDetails() {
            vm.feedbackActivities = [];
            angular.forEach(vm.ratingAndCommentsActivities, function (ratingAndCommentActivity) {
                if (ratingAndCommentActivity.activity_type == 'FEEDBACK') {
                    vm.feedbackActivities.push(ratingAndCommentActivity);
                }
            });
        };

        function getLineHeight() {
            setTimeout(function () {
                angular.forEach(vm.session_activities, function (session_activity, index) {
                    var line = document.getElementById('activity-line-' + index);
                    line.style.height = (session_activity.activities.length == 1 ? 59 : 76 * session_activity.activities.length - 17) + 'px';
                })
            }, 500);
        };

        function getSessionActivities() {
            vm.session_activities = [];
            angular.forEach(vm.sessionActivities, function (sessionActivity) {
                var created_on_1 = moment(sessionActivity.created_on).format('LT');
                var exists = false;
                var full_name = sessionActivity.user_info.first_name + " " + sessionActivity.user_info.last_name;
                angular.forEach(vm.session_activities, function (session_activity) {
                    var created_on_2 = session_activity.created_on;
                    if (angular.equals(created_on_1, created_on_2)) {
                        exists = true;
                        var obj = {
                            activity: sessionActivity.activity_type,
                            activator: full_name,
                            user_info: sessionActivity.user_info
                        };
                        session_activity.activities.push(obj);
                    }
                });
                if (!exists && sessionActivity.id != "") {
                    var obj = {
                        created_on: created_on_1,
                        activities: [
                            {
                                activity: sessionActivity.activity_type,
                                activator: full_name,
                                user_info: sessionActivity.user_info
                            }
                        ]
                    };
                    vm.session_activities.push(obj);
                }
            });
        };

        vm.getProfilePicture = function (user_info) {
            return user_info.picture_id ? '/media/pictures/' + user_info.picture_id : 'assets/images/avatars/user-avatar.png';
        };

        vm.feedbackTransition = function () {
            vm.loadingFeedbackActivities = true;
            Experience.getSessionRatingAndComments({
                page: vm.feedbackPage - 1,
                size: vm.feedbackPageSize,
                sort: sort(),
                query: getRatingAndCommentsQueryString(),
                user_info: true
            }, onTSuccess, onTError);

            function onTSuccess(result, headers) {
                vm.feedbackLinks = ParseLinks.parse(headers('link'));
                vm.feedbackQueryCount = headers('X-Total-Count');
                vm.ratingAndCommentsActivities = result;
                getFeedbackDetails();
                vm.loadingFeedbackActivities = false;
            };

            function onTError(error) {
                AlertService.error(error.data.message);
            };
        };

        function getParticipantsList() {
            vm.participantsList = [];
            vm.guestList = [];
            if (vm.sessionModel.owner_info) {
                var obj = {
                    user_id: vm.sessionModel.owner_info.id,
                    first_name: vm.sessionModel.owner_info.first_name,
                    last_name: vm.sessionModel.owner_info.last_name,
                    picture_id: vm.sessionModel.owner_info.picture_id,
                    joined: false,
                };

                vm.participantsList.push(obj);
            }

            if (vm.sessionModel.session_users_info) {
                angular.forEach(vm.sessionModel.session_users, function (sessionUser) {
                    angular.forEach(vm.sessionModel.session_users_info, function (sessionUserInfo) {
                        var obj = {
                            user_id: sessionUserInfo.id,
                            first_name: sessionUserInfo.first_name,
                            last_name: sessionUserInfo.last_name,
                            picture_id: sessionUserInfo.picture_id,
                            joined: false,
                        }
                        if (!sessionUser.is_guest) {
                            if (sessionUser.user_id == sessionUserInfo.id) {
                                vm.participantsList.push(obj);
                            }
                        } else {
                            if (sessionUser.user_id == sessionUserInfo.id) {
                                vm.guestList.push(obj);
                            }
                        }
                    });
                });
            }

            angular.forEach(vm.sessionModel.session_joined_users_info, function (sessionJoinedUserInfo) {
                angular.forEach(vm.participantsList, function (participant) {
                    var joined = false;
                    if (participant.user_id == sessionJoinedUserInfo.id) {
                        participant.joined = true;
                    }
                });
                angular.forEach(vm.guestList, function (participant) {
                    var joined = false;
                    if (participant.user_id == sessionJoinedUserInfo.id) {
                        participant.joined = true;
                    }
                });
            });
        };

        function getParticipantDetails(sessionUser) {

        }

        $scope.$watch('vm.sessionModel', function (newValue) {
            if (angular.isDefined(vm.sessionModel) && vm.sessionModel != null) {
                loadData();
            }
        });
    };
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionInfoPanelController', SessionInfoPanelController);

    /* @ngInject */
    function SessionInfoPanelController(mdPanelRef, $scope, $state, $location, $mdDialog, $q, $filter, Principal, $mdPanel, sessionModel, FIELD_CONDITION_CONSTANT, workspaceCode, deviceDetector, ToastService) {
        var vm = this;

        vm.sessionModel = sessionModel;
        vm.sessionUrl = "https://demo.atheer.my:3000/sessions/player" + vm.sessionModel.session_no;
        vm.code = workspaceCode;
        vm.isMobileBrowser = deviceDetector.isMobile();

        if ($location.host().endsWith("atheer.my")) {
            vm.sessionUrl = 'https://' + $location.host() + ":" + $location.port() + '/sessions/player/' + vm.sessionModel.session_no;
        } else {
            vm.sessionUrl = 'https://' + $location.host() + '/sessions/player/' + vm.sessionModel.session_no;
        };

        vm.onCopySuccess = function() {
            ToastService.displayToast($filter('translate')('atheer.session.info.copied'), 2000);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionInfoDialogController', SessionInfoDialogController);

    /* @ngInject */
    function SessionInfoDialogController($location, $mdDialog, $filter, sessionModel, workspaceCode, deviceDetector, ToastService) {
        var vm = this;

        vm.sessionModel = sessionModel;
        vm.sessionUrl = "https://demo.atheer.my:3000/sessions/player" + vm.sessionModel.session_no;
        vm.code = workspaceCode;
        vm.isMobileBrowser = deviceDetector.isMobile();

        if ($location.host().endsWith("atheer.my")) {
            vm.sessionUrl = 'https://' + $location.host() + ":" + $location.port() + '/sessions/player/' + vm.sessionModel.session_no;
        } else {
            vm.sessionUrl = 'https://' + $location.host() + '/sessions/player/' + vm.sessionModel.session_no;
        };

        vm.onCopySuccess = function() {
            ToastService.displayToast($filter('translate')('atheer.session.info.copied'), 2000);
        };

        vm.close = function() {
            $mdDialog.cancel();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionFeedbackController', SessionFeedbackController);

    /* @ngInject */
    function SessionFeedbackController($scope, $state, $q, $filter, Report, sessionModel, userId, ParseLinks, AlertService, $mdDialog, $stateParams, Experience, isMobileBrowser, ToastService) {
        var vm = this;

        vm.sessionModel = sessionModel;
        vm.userId = userId;
        vm.rating = null;
        vm.ratingFeedback = null;
        vm.isMobileBrowser = isMobileBrowser;

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.submit = function() {
            Experience.createSessionActivity({
                object: vm.sessionModel,
                user_id: vm.userId,
                activity_type: "FEEDBACK",
                properties: {
                    rating: vm.rating,
                    feedback: vm.ratingFeedback
                }
            }, function(result) {
                ToastService.displayToast($filter('translate')('atheer.session.feedback.submitted'), 3000);
                $mdDialog.hide();
            });

        };
    };
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionDetailController', SessionDetailController)

    /* @ngInject */
    function SessionDetailController($rootScope, $mdDialog, $q, $scope, $filter, $location, $timeout, $sce, ParseLinks, $state, pagingParams, paginationConstants, Experience, AlertService, ContentAction, $mdToast, $mdSidenav, Principal, Session, Setting, User, id, sessionType, Feature, Auth, ToastService, PermissionService) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.timezones = [];
        vm.templates = [];
        vm.hrs = [];
        vm.minutes = [0, 15, 30, 45];
        vm.repeats = [];
        vm.possible_recurring_session = ['Daily', 'Weekly', 'Monthly', 'No Fixed Time'];
        vm.timeslots = [];

        $scope.$watch("vm.sessionDetailForm", function () {
            $rootScope.sessionDetailForm = vm.sessionDetailForm;
        });

        // TODO :: check create/edit mode in next ticket
        vm.userHasSchedulerPermission = PermissionService.hasAccess(
            "master_scheduler_session-session"
        );
        vm.host = vm.userHasSchedulerPermission
            ? Principal.getUserInfo()
            : null;

        vm.days = [{
            name: 'Sun',
            isSelected: false
        },
        {
            name: 'Mon',
            isSelected: false
        },
        {
            name: 'Tue',
            isSelected: false
        },
        {
            name: 'Wed',
            isSelected: false
        },
        {
            name: 'Thu',
            isSelected: false
        },
        {
            name: 'Fri',
            isSelected: false
        },
        {
            name: 'Sat',
            isSelected: false
        }
        ];
        vm.weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        vm.frequencyDays = ['First', 'Second', 'Third', 'Fourth', 'Last'];
        vm.AMPM = ['AM', 'PM'];
        vm.sessionSetting = [];
        vm.numOfdays = [];
        vm.video_host = false;
        vm.video_participant = false;
        vm.audio_host = false;
        vm.audio_participant = false;
        vm.personalSessionType = false;
        vm.recurring_session = false;
        vm.daily = false;
        vm.nonEditmode = false;
        vm.sessionType = sessionType;
        vm.personalSessionNumber = null;
        vm.personalSessionId = null;
        vm.recurrsionSessionOn = false;
        vm.enableWaitingRoom = false;
        vm.recurringSessionFeature = Feature.isActive('feature_airsession_recurring_session');
        vm.sessionTemplate = Feature.isActive('feature_airsession_session_template');
        vm.isInsightsLoaded = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.goBackAfterSave = false;
        var alreadyExist = [];

        vm.querySessionActivity = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1,
            filters: {
                folder: vm.defaultFolder,
                metaType: 'all',
                featured: false,
                status: null,
            }
        };

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.sessionModel = {
            id: null,
            topic: null,
            agenda: null,
            session_no: null,
            use_passcode: false,
            passcode: null,
            url: null,
            timezone_id: null,
            hrs: 1,
            minutes: 0,
            date: new Date(),
            host_video: false,
            participant_video: false,
            join_before_host: false,
            mute_upon_entry: false,
            record_session: false,
            enable_waiting_room: false,
            sign_in_required: false,
            owner: null,
            sessionType: null,
            created_by: null,
            created_on: null,
            last_modified_by: null,
            last_modified_on: null,
            type: null,
            status: 'OPEN',
            alternate_hosts: [],
            session_users: [],
            guest_users: [],
            templates: [],
            recurring_settings: {
                recurring_type: null,
                repeat: 0,
                end_date: null,
                weekly_occurs: null,
                monthly_occurs: null
            },
            monthlyFreq: null,
            monthly_occurs: {
                type: null,
                day_nth_of_month: 1,
                nth_week_day: 'First',
                day_of_week: 'Monday'
            }
        };

        vm.sessionObject = {
            id: null,
            created_by: null,
            created_on: null,
            last_modified_by: null,
            last_modified_on: null,
            topic: null,
            session_no: null,
            passcode: null,
            url: null,
            duration: null,
            timezone: null,
            start_time: null,
            type: null,
            status: null,
            owner: null,
            settings: {
                host_video: false,
                participant_video: false,
                join_before_host: false,
                mute_upon_entry: false,
                sign_in_required: false,
                enable_waiting_room: false,
                record_session: false
            },
            recurring_settings: {
                recurring_type: null,
                repeat: 0,
                end_date: null,
                weekly_occurs: null,
                monthly_occurs: {
                    type: null,
                    day_nth_of_month: 0,
                    nth_week_day: null,
                    day_of_week: null
                }
            },
            session_users: [],
            guest_users: []
        }

        vm.onSaveSuccess = function (result) {
            setSessionModel(result);
            vm.isSaving = false;
            AlertService.displayToast($mdToast);
            if (vm.goBackAfterSave) {
                vm.goToSessions();
            }
        };

        vm.getHost = function () {
            return vm.host;
        };

        vm.isSchedulerVisible = function () {
            return (
                vm.sessionType != "PERSONAL" &&
                vm.sessionType != "TEMPLATE" &&
                vm.userHasSchedulerPermission
            );
        };

        $scope.isHostUpdated = function (host) {
            vm.host = host;
            var hostAsParticipantIndex =
                vm.sessionModel.session_users &&
                vm.sessionModel.session_users.length
                    ? vm.sessionModel.session_users.findIndex(function (user) {
                          return user.id === host.id;
                      })
                    : -1;
            if (hostAsParticipantIndex != -1) {
                vm.sessionModel.session_users.splice(hostAsParticipantIndex, 1);
            }
        };

        vm.onSaveError = function () {
            vm.isSaving = false;
        };

        vm.isNotInHost = function (result) {
            var dups = [];
            vm.sessionModel.alternate_hosts.forEach(function (item1) {
                result.forEach(function (item2) {
                    if (item1.id == item2.id) {
                        dups.push(item2);
                    }
                });
            });

            dups.forEach(function (item) {
                result.splice(result.indexOf(item), 1);
            });

            return result;
        }

        vm.isNotInParticipant = function (result) {
            var dups = [];
            vm.sessionModel.session_users.forEach(function (item1) {
                result.forEach(function (item2) {
                    if (item2.is_guest) {
                        if (item1.guest_invite_value == item2.guest_invite_value) {
                            dups.push(item2);
                        }
                    } else {
                        if (item1.id == item2.id) {
                            dups.push(item2);
                        } else if ((vm.userHasSchedulerPermission && vm.host.id === item2.id) ||
                            (!vm.userHasSchedulerPermission && vm.sessionModel.owner == item2.id)
                        ) {
                            ToastService.displayToast($filter('triTranslate')('atheer.session.detail.alreadyOwner'), 3000);
                            dups.push(item2);
                        }
                    }
                });
            });

            dups.forEach(function (item) {
                result.splice(result.indexOf(item), 1);
            });

            return result;
        }

        vm.save = function () {
            vm.isSaving = true;
            vm.sessionObject.id = vm.sessionModel.id;
            vm.sessionObject.topic = vm.sessionModel.topic;
            vm.sessionObject.agenda = vm.sessionModel.agenda;

            if (vm.personalSessionType) {
                vm.sessionObject.session_no = vm.personalSessionNumber;
            } else {
                vm.sessionObject.session_no = vm.sessionModel.session_no;
            }

            vm.sessionObject.use_passcode = vm.sessionModel.use_passcode;
            if (vm.sessionModel.use_passcode) {
                vm.sessionObject.passcode = vm.passcode1 + vm.passcode2 + vm.passcode3 + vm.passcode4 + vm.passcode5 + vm.passcode6;
                if (!vm.passcode1 || !vm.passcode2 || !vm.passcode3 || !vm.passcode4 || !vm.passcode5 || !vm.passcode6) {
                    ToastService.displayToast($filter('triTranslate')('atheer.session.detail.invalidPasscode'), 3000);
                    return;
                }
            }

            vm.sessionObject.duration = vm.sessionModel.hrs * 60 + vm.sessionModel.minutes;
            vm.sessionObject.timezone = vm.sessionModel.timezone_id;
            vm.sessionObject.status = vm.sessionModel.status;
            vm.sessionObject.settings.host_video = vm.sessionModel.host_video;
            vm.sessionObject.settings.participant_video = vm.sessionModel.participant_video;
            vm.sessionObject.settings.join_before_host = vm.sessionModel.join_before_host;
            vm.sessionObject.settings.mute_upon_entry = vm.sessionModel.mute_upon_entry;
            vm.sessionObject.settings.sign_in_required = vm.sessionModel.sign_in_required;
            vm.sessionObject.settings.enable_waiting_room = vm.sessionModel.enable_waiting_room;
            vm.sessionObject.settings.record_session = vm.sessionModel.record_session;
            vm.sessionObject.owner = vm.userHasSchedulerPermission ? vm.host.id : vm.sessionModel.owner;
            vm.sessionObject.created_by = vm.sessionModel.created_by;
            vm.sessionObject.created_on = vm.sessionModel.created_on;
            vm.sessionObject.last_modified_by = vm.sessionModel.last_modified_by;
            vm.sessionObject.last_modified_on = vm.sessionModel.last_modified_on;
            var currentUser = Principal.getUserInfo();
            delete vm.sessionObject.scheduler;
            if (vm.userHasSchedulerPermission && currentUser && vm.host && currentUser.id !== vm.host.id) {
                vm.sessionObject.scheduler = {
                    id: currentUser.id,
                    first_name: currentUser.first_name,
                    last_name: currentUser.last_name,
                };
            }
            if (sessionType == 'SCHEDULED') {
                vm.sessionObject.type = 'SCHEDULED';
            } else if (sessionType == 'TEMPLATE') {
                vm.sessionObject.type = 'TEMPLATE';
            } else if (sessionType == 'PERSONAL') {
                vm.sessionObject.type = 'PERSONAL';
            }

            if (vm.sessionModel.session_users != null) {
                vm.sessionObject.guest_users = checkForUpdatedGuestUsers();
                
                if (vm.userHasSchedulerPermission) {
                    // remove extra participant present in sessionObject but not present in sessionModel
                    if (!vm.sessionModel.session_users.length) {
                        vm.sessionObject.session_users = [];
                    } else {
                        vm.sessionObject.session_users.map(function (user) {
                            var userIndex =
                                vm.sessionModel.session_users.findIndex(
                                    function (u) { return user.user_id === u.id; }
                                );
                            if (userIndex === -1) {
                                vm.sessionObject.session_users.splice(userIndex, 1);
                            }
                        });
                    }
                }
                for (var i = 0; i < vm.sessionModel.session_users.length; i++) {
                    var isExist = false;
                    for (var j = 0; j < alreadyExist.length; j++) {
                        if (vm.sessionModel.session_users[i].id == alreadyExist[j]) {
                            isExist = true;
                        } else if (vm.sessionModel.session_users[i].guest_invite_value == alreadyExist[j]) {
                            isExist = true;
                        }
                    }
                    if (!isExist) {
                        if (vm.sessionModel.session_users[i].is_guest) {
                            var obj = {
                                guest_id: vm.sessionModel.session_users[i].guest_invite_value,
                                guest_invite_type: vm.sessionModel.session_users[i].guest_invite_type,
                                guest_language: vm.sessionModel.session_users[i].guest_invite_language
                            }
                            vm.sessionObject.guest_users.push(obj);
                            alreadyExist.push(vm.sessionModel.session_users[i].guest_invite_value);
                        } else {
                            var obj = {
                                user_id: vm.sessionModel.session_users[i].id,
                                role: 'PARTICIPANT'
                            };
                            vm.sessionObject.session_users.push(obj);
                            alreadyExist.push(vm.sessionModel.session_users[i].id);
                        }
                    }
                }
            }

            if (vm.sessionModel.alternate_hosts != null) {
                for (var i = 0; i < vm.sessionModel.alternate_hosts.length; i++) {
                    var obj = {
                        user_id: vm.sessionModel.alternate_hosts[i].id,
                        role: 'HOST'
                    };

                    vm.sessionObject.session_users.push(obj);
                }
            }

            vm.sessionObject.start_time = vm.sessionModel.date;

            if (vm.sessionModel.recurring_settings.recurring_type) {
                vm.sessionObject.recurring_settings.recurring_type = vm.sessionModel.recurring_settings.recurring_type;
                vm.sessionObject.recurring_settings.repeat = vm.sessionModel.recurring_settings.repeat;

                if (vm.sessionModel.recurring_settings.recurring_type == 'Weekly') {
                    var selectedDays = [];
                    angular.forEach(vm.days, function (sDay) {
                        if (sDay.isSelected) {
                            selectedDays.push(sDay.name);
                        }
                    });

                    vm.sessionObject.recurring_settings.weekly_occurs = selectedDays;
                }

                if (vm.sessionModel.recurring_settings.recurring_type == 'Monthly' && vm.sessionModel.monthlyFreq) {
                    if (vm.sessionModel.monthlyFreq == 'monthlyWithNumOfDays') {
                        vm.sessionObject.recurring_settings.monthly_occurs.type = 'monthlyWithNumOfDays';
                        vm.sessionObject.recurring_settings.monthly_occurs.day_nth_of_month = vm.sessionModel.monthly_occurs.day_nth_of_month;
                    }

                    if (vm.sessionModel.monthlyFreq == 'nthDaysFreq') {
                        vm.sessionObject.recurring_settings.monthly_occurs.type = 'nthDaysFreq';
                        vm.sessionObject.recurring_settings.monthly_occurs.nth_week_day = vm.sessionModel.monthly_occurs.nth_week_day;
                        vm.sessionObject.recurring_settings.monthly_occurs.day_of_week = vm.sessionModel.monthly_occurs.day_of_week;
                    }
                }

                if (vm.sessionModel.recurring_settings.end_date) {
                    vm.sessionObject.recurring_settings.end_date = vm.sessionModel.recurring_settings.end_date.getTime() / 1000;
                }

            }

            if (vm.sessionModel.id) {
                vm.goBackAfterSave = false;
                Session.updateScheduled(vm.sessionObject, vm.onSaveSuccess, vm.onSaveError);
            } else {
                vm.goBackAfterSave = true;
                Session.save(vm.sessionObject, vm.onSaveSuccess, vm.onSaveError);
            }
        };

        vm.goToSessions = function () {
            $state.go('storm.sessions.upcoming');
        };

        vm.isNew = function () {
            if (vm.sessionModel == undefined || vm.sessionModel.id == null) {
                return true;
            } else {
                return false;
            }
        };

        vm.filterTemplate = function () {
            if (vm.sessionModel.templates) {
                if (vm.sessionModel.templates.duration) {
                    vm.sessionModel.hrs = parseInt(vm.sessionModel.templates.duration / 60);
                    vm.sessionModel.minutes = vm.sessionModel.templates.duration % 60;
                }

                vm.sessionModel.timezone_id = vm.sessionModel.templates.timezone;
                vm.sessionModel.host_video = vm.sessionModel.templates.settings.host_video;
                vm.sessionModel.participant_video = vm.sessionModel.templates.settings.participant_video;
                vm.sessionModel.join_before_host = vm.sessionModel.templates.settings.join_before_host;
                vm.sessionModel.mute_upon_entry = vm.sessionModel.templates.settings.mute_upon_entry;
                vm.sessionModel.enable_waiting_room = vm.sessionModel.templates.settings.enable_waiting_room;
                vm.sessionModel.record_session = vm.sessionModel.templates.settings.record_session;
            }
        };

        vm.toggleTemplate = function () {
            if (!vm.sessionModel.use_template) {
                vm.sessionModel.templates = null;
            }
        }

        vm.checkPasscode = function (modelVal, code) {
            if (modelVal != '' && modelVal != null && code < 6) {
                $timeout(function () {
                    var nextInput = '[ng-model="vm.passcode' + (code + 1) + '"]';
                    angular.element(nextInput).focus();
                });
            };
        };

        vm.onNumberInputKeydown = function (e) {
            if (
                ![
                    "1", "2", "3", "4", "5", "6", "7","8", "9", "0",
                    "Backspace",
                    "Tab",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowUp",
                    "ArrowDown",
                ].includes(e.key)
            ) {
                e.stopPropagation();
                e.preventDefault();
            }
        };

        vm.copyInvitation = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-copy-invitation-dialog.tmpl.html',
                controller: 'SessionCopyInvitationDialogController',
                clickOutsideToClose: true,
                controllerAs: 'vm',
                locals: {
                    session: vm.sessionModel
                }
            }).then(function (result) {

            });
        };

        var startPersonalSession = $rootScope.$on('startPersonalSession', function (event) {
            $state.go('storm.sessions.player', {
                'session_no': vm.sessionModel.session_no
            });
        });

        var editPersonalSession = $rootScope.$on('editPersonalSession', function (event) {
        });

        var updatePersonalSession = $rootScope.$on('updatePersonalSession', function (event) {
            vm.save();
        });

        var cancelUpdatePersonalSession = $rootScope.$on('cancelUpdatePersonalSession', function (event) {
        });

        var saveSession = $rootScope.$on('saveSession', function (event) {
            vm.save();
        });

        var saveAsTemplate = $rootScope.$on('saveAsTemplate', function (event) {
            var template = angular.copy(vm.sessionModel);
            template.id = null;
            template.type = "TEMPLATE";
            Session.save(template, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                ToastService.displayToast($filter('translate')('atheer.session.upcomingSessions.templateCreated'), 3000);
            };

            function onSaveError() {
                vm.isSaving = false;
            };
        });

        // Unregister
        $scope.$on('$destroy', function () {
            startPersonalSession();
            editPersonalSession();
            updatePersonalSession();
            saveSession();
            saveAsTemplate();
        });

        function loadData() {
            vm.loadingData = true;
            if (sessionType == 'PERSONAL') {
                $q.all([
                    Setting.getSystemTimezones({
                        size: 100
                    }).$promise,
                    User.getPersonalSession().$promise,
                    Setting.getSessionSettings().$promise
                ])
                    .then(function (results) {
                        vm.timezones = results[0];
                        setSettingSessionModel(results[2]);
                        setSessionModel(results[1]);
                        setDefaultTimeZone(results[1]);
                        vm.personalSessionId = results[1].id;
                        vm.loadingData = false;
                    });
            } else if (sessionType == 'SCHEDULED' || sessionType == 'TEMPLATE') {
                if (id) {
                    $q.all([
                        Setting.getSystemTimezones({
                            size: 100
                        }).$promise,
                        Session.get({
                            id: id
                        }).$promise,
                        User.getPersonalSession().$promise,
                        Session.query({
                            query: getTemplateQueryString()
                        }).$promise
                    ])
                        .then(function (results) {
                            vm.timezones = results[0];
                            vm.sessionModel.timezone_id = vm.timezones[0].timezone_no;
                            vm.personalSessionNumber = results[2].session_no;
                            setSessionModel(results[1]);
                            vm.templates = results[3];
                            vm.loadingData = false;
                        });
                } else {
                    $q.all([
                        Setting.getSystemTimezones({
                            size: 100
                        }).$promise,
                        User.getPersonalSession().$promise,
                        Session.query({
                            query: getTemplateQueryString()
                        }).$promise,
                        Setting.getSessionSettings().$promise
                    ])
                        .then(function (results) {
                            vm.timezones = results[0];
                            setDefaultTimeZone(results[1]);
                            vm.personalSessionNumber = results[1].session_no;
                            setDefaultDate();
                            vm.templates = results[2];
                            setSettingSessionModel(results[3]);
                            generateDefualtPasscode();
                            vm.loadingData = false;
                            setSessionModel(results[1]);                      
                        });
                }
            };

            for (var i = 0; i < 25; i++) {
                vm.hrs.push(i);
            }

            for (var i = 1; i < 15; i++) {
                vm.repeats.push(i);
            }

            for (var i = 1; i <= 31; i++) {
                vm.numOfdays.push(i);
            }

            var x = 30;
            var tt = 0;

            for (var i = 0; tt < 12 * 60; i++) {
                var hh = Math.floor(tt / 60);
                var mm = (tt % 60);
                if (('0' + (hh % 12)).slice(-2) == '00') {
                    vm.timeslots.push('12:' + ('0' + mm).slice(-2));
                } else {
                    vm.timeslots.push(('0' + (hh % 12)).slice(-2) + ':' + ('0' + mm).slice(-2));
                }
                tt = tt + x;
            }
        };

        function setDefaultTimeZone(userSettings) {
            if (userSettings && userSettings.owner_info && userSettings.owner_info.timezone_id) {
                vm.sessionModel.timezone_id = userSettings.owner_info.timezone_id;
            } else {
                //for localhost
                // var workspace = $location.host() == 'localhost' ? 'demo' : $location.host().split('.')[0];
                var workspace = $location.host().split('.')[0];
                Auth.validateWorkspaceName(workspace).then(function (result) {
                    vm.sessionModel.timezone_id = result.data.timezone_id;
                });
            }
        };

        function setSettingSessionModel(settings) {
            angular.forEach(settings, function (setting) {
                if (setting.category == 'session_setting') {
                    vm.sessionSetting = setting;

                    angular.forEach(setting.fields, function (settingField) {
                        if (settingField.name == 'host_video' && settingField.value == 'true') {
                            vm.sessionModel.host_video = true;
                        } else if (settingField.name == 'participant_video' && settingField.value == 'true') {
                            vm.sessionModel.participant_video = true;
                        } else if (settingField.name == 'join_before_host' && settingField.value == 'true') {
                            vm.sessionModel.join_before_host = true;
                        } else if (settingField.name == 'mute_upon_entry' && settingField.value == 'true') {
                            vm.sessionModel.mute_upon_entry = true;
                        } else if (settingField.name == 'sign_in_required' && settingField.value == 'true') {
                            vm.sessionModel.sign_in_required = true;
                        } else if (settingField.name == 'enable_waiting_room' && settingField.value == 'true') {
                            vm.sessionModel.enable_waiting_room = true;
                        } else if (settingField.name == 'record_session' && settingField.value == 'true') {
                            vm.sessionModel.record_session = true;
                        } else if (settingField.name == 'recurring_Session' && settingField.value == 'true') {
                            vm.sessionModel.recurring_Session = true;
                        };
                    });
                }
            });
        }

        function setSessionModel(sessionObj) {
            vm.sessionModel.id = sessionObj.id;
            vm.sessionModel.topic = sessionObj.topic;
            vm.sessionModel.agenda = sessionObj.agenda;
            vm.sessionModel.session_no = sessionObj.session_no;
            vm.sessionModel.use_passcode = sessionObj.use_passcode;

            if (
                angular.isDefined(sessionObj.scheduler) &&
                angular.isDefined(sessionObj.scheduler.id)
            ) {
                vm.host = sessionObj.owner_info;
                vm.sessionModel.scheduler = sessionObj.scheduler;
            }
            if (vm.sessionModel.use_passcode) {
                vm.sessionModel.passcode = sessionObj.passcode;
                vm.passcode1 = sessionObj.passcode.charAt(0);
                vm.passcode2 = sessionObj.passcode.charAt(1);
                vm.passcode3 = sessionObj.passcode.charAt(2);
                vm.passcode4 = sessionObj.passcode.charAt(3);
                vm.passcode5 = sessionObj.passcode.charAt(4);
                vm.passcode6 = sessionObj.passcode.charAt(5);
            } else {
                generateDefualtPasscode();
            }

            if ($location.host().endsWith('atheer.my')) {
                vm.sessionModel.url = 'https://' + $location.host() + ':' + $location.port() + '/sessions/player/' + sessionObj.session_no;
            } else {
                vm.sessionModel.url = 'https://' + $location.host() + '/sessions/player/' + sessionObj.session_no;
            }

            vm.sessionModel.owner = sessionObj.owner;
            vm.sessionModel.created_by = sessionObj.created_by;
            vm.sessionModel.created_on = sessionObj.created_on;
            vm.sessionModel.last_modified_by = sessionObj.last_modified_by;
            vm.sessionModel.last_modified_on = sessionObj.last_modified_on;
            vm.sessionModel.type = sessionObj.type;
            vm.sessionModel.timezone_id = sessionObj.timezone;
            vm.sessionModel.status = sessionObj.status;

            if (sessionObj.session_no == vm.personalSessionNumber) {
                vm.personalSessionType = true;
            }

            if (sessionObj.duration) {
                vm.sessionModel.hrs = parseInt(sessionObj.duration / 60);
                vm.sessionModel.minutes = sessionObj.duration % 60;
            }

            if (sessionObj.start_time) {
                resolveDateAndTime(sessionObj.start_time);
            }

            vm.sessionModel.repeats = vm.repeats;
            vm.sessionModel.days = vm.days;
            vm.sessionModel.numOfdays = vm.numOfdays;
            vm.sessionModel.frequencyDays = vm.frequencyDays;
            vm.sessionModel.weekDays = vm.weekDays;

            if (sessionObj.settings) {
                vm.sessionModel.host_video = sessionObj.settings.host_video;
                vm.sessionModel.participant_video = sessionObj.settings.participant_video;
                vm.sessionModel.join_before_host = sessionObj.settings.join_before_host;
                vm.sessionModel.mute_upon_entry = sessionObj.settings.mute_upon_entry;
                vm.sessionModel.sign_in_required = sessionObj.settings.sign_in_required;
                vm.sessionModel.enable_waiting_room = sessionObj.settings.enable_waiting_room;
                vm.sessionModel.record_session = sessionObj.settings.record_session;
            }

            if (sessionType != 'PERSONAL' && sessionType != 'TEMPLATE') {
                if (sessionObj.session_users) {
                    if (sessionObj.session_users.length != 0) {
                        vm.sessionModel.session_users = [];
                        vm.sessionModel.alternate_hosts = [];
                        resolvePartcipants(sessionObj.session_users);
                    }
                }
                if (sessionObj.guest_users) {
                    if (sessionObj.guest_users.length != 0) {
                        vm.sessionModel.guest_users = [];
                        resolveGuestUsers(sessionObj.guest_users);
                    }
                }
            }

            if (sessionObj.recurring_settings) {
                vm.recurring_session = true;
                vm.sessionModel.recurring_settings.recurring_type = sessionObj.recurring_settings.recurring_type;
                vm.sessionModel.recurring_settings.repeat = sessionObj.recurring_settings.repeat;

                if (sessionObj.recurring_settings.recurring_type == 'Weekly') {
                    angular.forEach(vm.days, function (sDay) {
                        if (sessionObj.recurring_settings.weekly_occurs.includes(sDay.name)) {
                            sDay.isSelected = true;
                        }
                    });
                }

                if (sessionObj.recurring_settings.recurring_type == 'Monthly') {
                    if (sessionObj.recurring_settings.monthly_occurs.type == 'monthlyWithNumOfDays') {
                        vm.sessionModel.monthlyFreq = 'monthlyWithNumOfDays';
                        vm.sessionModel.monthly_occurs.day_nth_of_month = sessionObj.recurring_settings.monthly_occurs.day_nth_of_month;
                    }

                    if (sessionObj.recurring_settings.monthly_occurs.type == 'nthDaysFreq') {
                        vm.sessionModel.monthlyFreq = 'nthDaysFreq';
                        vm.sessionModel.monthly_occurs.nth_week_day = sessionObj.recurring_settings.monthly_occurs.nth_week_day;
                        vm.sessionModel.monthly_occurs.day_of_week = sessionObj.recurring_settings.monthly_occurs.day_of_week;
                    }
                }


                if (sessionObj.recurring_settings.end_date) {
                    vm.sessionModel.recurring_settings.end_date = new Date(sessionObj.recurring_settings.end_date);
                }

            }
        };

        function resolveDateAndTime(session_start_time) {
            vm.sessionModel.date = new Date(session_start_time);
        };

        function resolvePartcipants(session_users) {
            var participantIds = [];
            var hostIds = [];

            angular.forEach(session_users, function (session_user) {
                if (session_user.role == 'PARTICIPANT') {
                    participantIds.push(session_user.user_id);
                } else if (session_user.role == 'HOST') {
                    hostIds.push(session_user.user_id);
                }

            });

            getSessionUsers(participantIds, 'PARTICIPANT');
            getSessionUsers(hostIds, 'HOST');
        };

        function getSessionUsers(user_ids, user_type) {
            if (!user_ids.length) return;
            User.query({
                query: 'id=in=(' + user_ids + ')',
            }, function (response, headers) {
                response.forEach(function (item) {
                    if (user_type == 'PARTICIPANT') {
                        vm.sessionModel.session_users.push(item);
                    } else if (user_type == 'HOST') {
                        vm.sessionModel.alternate_hosts.push(item);
                    }
                })
            });
        }

        function setDefaultDate() {
            vm.sessionModel.date = new Date();

            var hrsValue = vm.sessionModel.date.getHours();

            if (vm.sessionModel.date.getMinutes() > 30) {
                hrsValue = hrsValue + 1;
                if (hrsValue >= 12) {
                    if (hrsValue == 24) vm.sessionModel.ampm = 'AM';
                    else vm.sessionModel.ampm = 'PM';
                    if (hrsValue > 12) {
                        hrsValue = hrsValue - 12;
                    }
                }
                if (hrsValue == 0) hrsValue = 12;
                if (hrsValue < 10) {
                    hrsValue = '0' + hrsValue + ':00';
                } else {
                    hrsValue = hrsValue + ':00'
                }
            } else {
                if (hrsValue >= 12) {
                    vm.sessionModel.ampm = 'PM';
                    hrsValue = hrsValue - 12;
                }
                if (hrsValue == 0) hrsValue = 12;
                if (hrsValue < 10) {
                    hrsValue = '0' + (hrsValue) + ':30';
                } else {
                    hrsValue = (hrsValue) + ':30';
                }
            }
            vm.sessionModel.timeslots = hrsValue;
        };

        function generateDefualtPasscode() {
            var randomString = '';
            var chars = '0123456789';
            for (var i = 6; i > 0; i--) {
                randomString +=
                    chars[Math.floor(Math.random() * chars.length)];
            }

            vm.passcode1 = randomString.charAt(0);
            vm.passcode2 = randomString.charAt(1);
            vm.passcode3 = randomString.charAt(2);
            vm.passcode4 = randomString.charAt(3);
            vm.passcode5 = randomString.charAt(4);
            vm.passcode6 = randomString.charAt(5);
        }

        function getTemplateQueryString() {
            var query = 'type==' + 'TEMPLATE';

            return query;
        };

        function resolveGuestUsers(guest_users) {
            angular.forEach(guest_users, function (guest_user) {
                
                if (guest_user.guest_id) {
                    guest_user.is_guest = true;
                    guest_user.guest_invite_value = guest_user.guest_id;

                    //to avoid duplicates
                    var isExist = false;
                    angular.forEach(alreadyExist, function (ele) {
                        if (guest_user.guest_id == ele) {
                            isExist = true;
                        }
                    });

                    if (!isExist) {
                        vm.sessionModel.session_users.push(guest_user);
                    }
                    
                    if(!!id && isExist) {
                        vm.sessionModel.session_users.push(guest_user);
                    }
                }
            });
        };

        function checkForUpdatedGuestUsers() {
            var updatedGuestUsers = [];
            angular.forEach(vm.sessionModel.session_users, function (sessionUser) {
                angular.forEach(vm.sessionObject.guest_users, function (guestUser) {
                    if (guestUser.guest_id == sessionUser.guest_invite_value) {
                        updatedGuestUsers.push(guestUser);
                    }
                })
            });
            return updatedGuestUsers;
        }
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionsDetailToolbarController', SessionsDetailToolbarController);

    /* @ngInject */
    function SessionsDetailToolbarController($rootScope, $scope, $state, $mdDialog, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, sessionType, Feature, ToastService, SessionsService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.sessionType = sessionType;
        vm.nonEditmode = false;

        $scope.$watch("sessionDetailForm", function () {
            vm.sessionDetailForm = $rootScope.sessionDetailForm;            
        });

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.filter.show = false;

        vm.permissions = {
            create: 'create-session',
            update: 'update-session',
            delete: 'delete-session',
            updatePersonalSession: 'update-personal-session'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.refreshAll = function() {
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.removeFilter = function() {
            vm.filter.show = false;
            vm.query.filter = '';
            $scope.$emit('refreshSessions', vm.query.filter);
        };

        vm.startInstantSession = function() {
            SessionsService.startInstantSession();
        };

        vm.joinSession = function() {
            SessionsService.joinSession();
        };

        vm.scheduleSession = function() {
            $state.go('storm.sessions.upcoming-detail');
        };

        vm.goToSessions = function() {
            $state.go('storm.sessions.upcoming');
        };

        vm.updatePersonalSession = function() {
            $scope.$emit('updatePersonalSession');
        };

        vm.cancelSaveSession = function() {
            if(vm.sessionType == 'PERSONAL') {
                $scope.$emit('cancelUpdatePersonalSession');
            } else {
                $state.go('storm.sessions.upcoming');
            }
        };

        vm.saveSession = function() {
            $scope.$emit('saveSession');
        };

        vm.saveAsTemplate = function() {
            $scope.$emit('saveAsTemplate');
        };

        vm.editPersonalSession = function() {
            $scope.$emit('editPersonalSession');
        };

        vm.startPersonalSession = function() {
            $scope.$emit('startPersonalSession');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionCopyInvitationDialogController', SessionCopyInvitationDialogController);

    /* @ngInject */
    function SessionCopyInvitationDialogController($mdDialog, $q, ToastService, $filter, $location, Principal, Setting, session, SessionPlayerService) {
        var vm = this;
        vm.session = session;
        vm.loadData = false;
        vm.userFullName = Principal.getUserFullName();
        vm.timezoneName = null;
        vm.sessionJoinUrl = null;
        vm.invitationText = null;

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.onCopySuccess = function() {
            ToastService.displayToast($filter('translate')('atheer.session.info.copied'), 2000);
        };

        function loadData() {
            vm.loadingData = true;

            if ($location.host().endsWith('atheer.my')) {
                vm.sessionJoinUrl = 'https://' + $location.host() + ':' + $location.port() + '/sessions/player/' + vm.session.session_no;
            } else {
                vm.sessionJoinUrl = 'https://' + $location.host() + '/sessions/player/' + vm.session.session_no;
            };

            $q.all([
                    Setting.getSystemTimezones({
                        size: 100
                    }).$promise,
                ])
                .then(function(results) {
                    vm.timezones = results[0];

                    for (var i = 0, len = vm.timezones.length; i < len; i++) {
                        if (vm.timezones[i].timezone_no == vm.session.timezone) {
                            vm.timezoneName = vm.timezones[i].display_name;
                            break;
                        }
                    }

                    vm.invitationText = $filter('translate')('atheer.session.topic') + ": " + vm.session.topic + "\n";
                    vm.invitationText = vm.invitationText + $filter('translate')('atheer.session.copyStartTime') + ": " + moment(vm.session.start_time).format('MMM D, YYYY hh:mm A') + " - " + vm.timezoneName + "\n\n";
                    vm.invitationText = vm.invitationText + $filter('translate')('atheer.session.upcomingSessions.joinAirSession') + "\n";
                    vm.invitationText = vm.invitationText + vm.sessionJoinUrl + "\n\n";
                    vm.invitationText = vm.invitationText + $filter('translate')('atheer.session.sessionNo') + ": " + vm.session.session_no + "\n";

                    if(vm.session.use_passcode) {
                        vm.invitationText = vm.invitationText + $filter('translate')('atheer.session.detail.passcode') + ": " + vm.session.passcode + "\n";
                    }

                    vm.loadingData = false;
                });
        };

        loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionAnnotations', sessionAnnotations);

    function sessionAnnotations() {
        var directive = {
            scope: {
                sessionModel: '='
            },
            bindToController: true,
            controller: sessionAnnotationsController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-annotations.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionAnnotationsController($scope, $mdDialog, $http, $mdSidenav, $window, $location, $mdToast, $document, $mdPanel, $state, $timeout, $q, $filter, ParseLinks, Principal, poller, Session, Experience, AlertService) {
        var vm = this;

        vm.loadingData = false;
        vm.transition = transition;
        vm.pageSize = 100;
        vm.mediaPathAnnotation = "/media/images/";

        vm.togglePanel = function () {
            $mdSidenav('annotationsPanel').toggle()
                .then(function () {

                });
        };

        vm.getMediaUrl = function (sessionActivity) {
            if ($location.host().endsWith('atheer.my')) {
                return 'https://' + $location.host() + ':' + $location.port() + vm.mediaPathAnnotation + sessionActivity.properties.media_file_name;
            } else {
                return vm.mediaPathAnnotation + sessionActivity.properties.media_file_name;
            }
        }

        vm.download = function (sessionActivity, id) {
            var url = vm.getMediaUrl(sessionActivity);
            var downloadFileName = null;

            if (sessionActivity.properties.file_name) {
                downloadFileName = sessionActivity.properties.file_name;
            } else {
                downloadFileName = sessionActivity.properties.media_file_name;
            }

            $http.get(url, {
                responseType: "arraybuffer"
            })
                .success(function (data) {
                    var anchorTag = angular.element('<a/>');
                    var blob = new Blob([data]);

                    anchorTag.attr({
                        href: $window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: downloadFileName
                    })[0].click();
                });
        }

        vm.downloadZip = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-annotation-zip.tmpl.html',
                clickOutsideToClose: true,
                controller: "SessionAnnotationZipController",
                controllerAs: "vm",
                locals: {
                    sessionModel: vm.sessionModel
                },
            }).then(function (result) {

            });
        }

        vm.fullScreen = function (sessionActivity) {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/session/session-annotation-fullscreen.tmpl.html',
                controller: 'sessionAnnotationFullscreenController',
                controllerAs: 'vm',
                hasBackdrop: true,
                backdrop: 'static',
                locals: {
                    sessionActivity: sessionActivity
                },
                size: 'lg'
            }).then(function () {

            });
        }

        function transition() {
            vm.loadingData = true;
            vm.promise = Experience.getSessionActivities({
                page: vm.page - 1,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onTSuccess, onTError);

            function onTSuccess(data, headers) {
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                vm.loadingData = false;
            }

            function onTError(error) {
                AlertService.error(error.data.message);
            }
        };

        function sort() {
            return 'id,asc';
        };

        function getQueryString() {
            var queryString = "action_type==ANNOTATION_SAVED;object_id==" + vm.sessionModel.id;
            return queryString;
        };

        function loadData() {
            if (!vm.sessionModel) {
                return;
            }

            vm.loadingData = true;

            Experience.getSessionActivities({
                page: 0,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        $scope.$watch('vm.sessionModel', function (newValue) {
            if (angular.isDefined(vm.sessionModel) && vm.sessionModel != null) {
                loadData();
            }
        });
    };
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .service('SessionAnnotationService', SessionAnnotationService);

    /* @ngInject */
    function SessionAnnotationService(Upload, $filter) {
        var annotationImage;
        var service = {
            uploadScreenShot: uploadScreenShot,
            setAnnotationImage: setAnnotationImage,
            saveAnnotation: saveAnnotation,
            getPercentage: getPercentage,
            uploadScreenShotBlob: uploadScreenShotBlob
        };
        return service;

        function uploadScreenShot(sessionNo, screenShotData) {
            var image = convertdataURItoBlob(screenShotData.dataURI);
            image.name = sessionNo + "-screenshot-" + moment().format('YYYYMMDDHHmmss') + '.jpg';
            return upload(image, 'image', false, null);
        };

        function uploadScreenShotBlob(sessionNo, screenShotBlob) {
            screenShotBlob.name = sessionNo + "-screenshot-" + moment().format('YYYYMMDDHHmmss') + '.jpg';
            return upload(screenShotBlob, 'image', false, null);
        }

        function saveAnnotation(fileName, sessionId) {
            var image = convertdataURItoBlob(annotationImage);
            image.name = fileName;
            return upload(image, 'image', true, sessionId);
        };

        function upload(file, type, is_annotation, sessionId) {
            return Upload.upload({
                url: 'api/media/upload',
                data: {
                    'file': file,
                    'type': type,
                    'is_annotation': is_annotation,
                    'session_id': sessionId
                }
            });
        };

        function convertdataURItoBlob(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }

            return new Blob([new Uint8Array(array)], {
                type: dataURI.split(',')[0]
            });
        };

        function setAnnotationImage(image) {
            annotationImage = image;
        };

        function getPercentage(a, b) {
            return Math.round((a / b) * 1000) / 1000;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionAnnotationZipController', SessionAnnotationZipController);

    /* @ngInject */
    function SessionAnnotationZipController($scope, $state, $q, $filter, $window, $http, $location, Report, Session, poller, ParseLinks, AlertService, $mdDialog, $mdToast, $stateParams, sessionModel) {
        var vm = this;

        vm.loadingData = false;
        vm.sessionModel = sessionModel;
        vm.jobStatus = 'idle';
        vm.jobResult = null;
        vm.imagefolder = "/media/images/";

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.load = function() {
            Session.getAnnotationZip({
                id: vm.sessionModel.id,
            }, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                vm.jobResult = result;
                vm.getImportJobStatus();
            };

            function onSaveError() {
                AlertService.displayToast($mdToast);
            };
        }

        vm.getImportJobStatus = function() {
            // Get poller.
            var jobStreamStatusPoller = poller.get(Session, {
                action: 'getImportStatus',
                delay: 3000,
                argumentsArray: [{
                    id: vm.jobResult.job_id
                }],
                smart: true
            });

            jobStreamStatusPoller.promise.then(null, null, function(result) {
                vm.jobStream = result;
                vm.jobStreamId = vm.jobResult.job_id;
                vm.jobData = vm.jobStream.job_data;
                if (result.status == 'COMPLETED') {
                    poller.stopAll();
                    vm.jobStatus = 'complete';
                }

            });
        };

        vm.getMediaUrl = function(sessionActivity) {
            if ($location.host().endsWith('atheer.my')) {
                return 'https://' + $location.host() + ':' + $location.port() + vm.imagefolder + vm.jobResult.path;
            } else {
                return vm.imagefolder + vm.jobResult.path;
            }
        }

        vm.download = function(sessionActivity, id) {
            var url = vm.getMediaUrl(sessionActivity);
            var downloadFileName = "AiRSession-Annotations-" + vm.sessionModel.session_no + ".zip";
            $http.get(url, {
                    responseType: "arraybuffer"
                })
                .success(function(data) {
                    var anchorTag = angular.element('<a/>');
                    var blob = new Blob([data]);

                    anchorTag.attr({
                        href: $window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: downloadFileName
                    })[0].click();
                    $mdDialog.cancel();
                });
        }
        vm.load();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionAnnotationTools', sessionAnnotationTools);

    function sessionAnnotationTools() {
        var directive = {
            scope: {
                sessionNo: '=',
                annotationType: '=',
                freezeFrame: '='
            },
            bindToController: true,
            controller: sessionAnnotationToolsController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-annotation-tools.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionAnnotationToolsController($scope, $mdDialog, $filter) {
        var vm = this;

        var annotationColor = {
            red: 'E41E1E',
            darkYellow: 'FFB800',
            yellow: 'FFF500',
            green: '07E36C',
            blue: '0094FF',
            violet: '8000FF',
            pink: 'FF0099',
            black: '000000',
            white: 'FFFFFF'
        };

        vm.isAnnotationSaved = false;
        vm.brushColor = "#" + annotationColor.darkYellow;
        vm.previousTool = '';
        vm.isDefault = true;
        vm.openColorPalette = false;

        $scope.$on('is-drawing', updateAnnotationStatus);

        function updateAnnotationStatus(event, isSaved) {
            vm.isAnnotationSaved = isSaved;
        }

        $scope.$on('destory', function() {
            $scope.$off('is-drawing',updateAnnotationStatus);
        });

        vm.updateTool = function (tool) {
            var element;
            vm.isDefault = false;
            if(tool === 'FREEZE_FRAME') {
                $scope.$emit('freeze-frame', {});
            } else {
                if(tool == 'PENCIL') {
                    element = document.getElementById('annotation-pencil');
                    vm.setOrUpdateActiveTool(element);
                } else if(tool == 'LASER') {
                    element = document.getElementById('annotation-laser');
                    vm.setOrUpdateActiveTool(element);
                } else if(tool == 'ARROW') {
                    element = document.getElementById('annotation-arrow');
                    vm.setOrUpdateActiveTool(element);
                } else if(tool == 'TEXT') {
                    element = document.getElementById('annotation-text');
                    vm.setOrUpdateActiveTool(element);
                }
                $scope.$emit('tool-change', { tool: tool });
            }
        };

        vm.updateColor = function () {
            vm.openColorPalette = !vm.openColorPalette;
        };

        vm.setColorPaletteColor = function (color) {
            var colorPalette = document.getElementById('colorPalette');
            vm.previousTool.style.color = "#" + color;
            colorPalette.style.backgroundColor = "#" + color;
        }

        vm.setOrUpdateColor = function (color) {
            if(vm.previousTool == '' && vm.annotationType !== 'LIVE') {
                vm.previousTool = document.getElementById('annotation-pencil');
                vm.isDefault = false;
            } else if(vm.previousTool == '' && vm.annotationType === 'LIVE') {
                vm.previousTool = document.getElementById('annotation-laser');
                vm.isDefault = false;
            }
            if(color == 'RED') {
                vm.brushColor = annotationColor.red;
                vm.setColorPaletteColor(annotationColor.red);
            } else if(color == 'DARK_YELLOW') {
                vm.brushColor = annotationColor.darkYellow;
                vm.setColorPaletteColor(annotationColor.darkYellow);
            } else if(color == 'YELLOW') {
                vm.brushColor = annotationColor.yellow;
                vm.setColorPaletteColor(annotationColor.yellow);
            } else if(color == 'GREEN') {
                vm.brushColor = annotationColor.green;
                vm.setColorPaletteColor(annotationColor.green);
            } else if(color == 'BLUE') {
                vm.brushColor = annotationColor.blue;
                vm.setColorPaletteColor(annotationColor.blue);
            } else if(color == 'VIOLET') {
                vm.brushColor = annotationColor.violet;
                vm.setColorPaletteColor(annotationColor.violet);
            } else if(color == 'PINK') {
                vm.brushColor = annotationColor.pink;
                vm.setColorPaletteColor(annotationColor.pink);
            } else if(color == 'WHITE') {
                vm.brushColor = annotationColor.white;
                vm.setColorPaletteColor(annotationColor.white);
            } else if(color == 'BLACK') {
                vm.brushColor = annotationColor.black;
                vm.setColorPaletteColor(annotationColor.black);
            }

            $scope.$emit('set-brush-color', vm.brushColor);

            vm.brushColor = "#" + vm.brushColor;
            vm.openColorPalette = !vm.openColorPalette;
        };

        vm.setOrUpdateActiveTool = function (element) {
            if(vm.previousTool) {
                vm.previousTool.style.color = 'white';
            }
            element.style.color = vm.brushColor;
            vm.previousTool = element;
        }

        vm.saveAnnotation = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-annotation-save.tmpl.html',
                controller: 'SessionSaveAnnotationController',
                controllerAs: 'vm',
                locals: {
                    sessionNo: vm.sessionNo,
                    isAnnotationSaved: vm.isAnnotationSaved
                }
            }).then(function () {
                
            });
        }

        vm.close = function () {
            if(vm.annotationType === 'LIVE' || vm.annotationType === 'AR' ) {
                $scope.$emit('close-annotation', true);
            } else {
                if (vm.isAnnotationSaved) {
                    $scope.$emit('close-annotation', true);
                } else {
                    var confirmAnnotationSave = $mdDialog.confirm()
                        .title($filter('translate')('atheer.session.saveAnnotation.save.title'))
                        .textContent($filter('translate')('atheer.session.saveAnnotation.save.content'))
                        .ariaLabel($filter('translate')('atheer.session.saveAnnotation.save.content'))
                        .ok($filter('translate')('entity.action.save'))
                        .cancel($filter('translate')('entity.action.cancel'));
    
                    $mdDialog.show(confirmAnnotationSave).then(function () {
                        vm.saveAnnotation();
                    }, function () {
                        vm.isAnnotationSaved = true;
                        $scope.$emit('close-annotation', true);
                    });
                }
            }
        }
    };
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionSaveAnnotationController', SessionSaveAnnotationController);

    /* @ngInject */
    function SessionSaveAnnotationController($mdDialog, $rootScope, sessionNo, isAnnotationSaved, SessionAnnotationService, $filter, ToastService) {
        var vm = this;

        vm.onLoad = onLoad;

        vm.annotationTitle = null;
        vm.isError = false;
        vm.isValidating = false;

        function onLoad() {
            vm.annotationTitle = $filter('translate')('atheer.session.saveAnnotation.annotationTitle') + moment().format('YYYYMMDDhhmmss')  + '.jpg';
        };

        vm.save = function() {
            if(!vm.annotationTitle.endsWith('.jpg') && !vm.annotationTitle.endsWith('.png') && !vm.annotationTitle.endsWith('.jpeg'))
                vm.annotationTitle += '.jpg';
            vm.isValidating = true;
            $rootScope.$broadcast('generate-annotation-image', { event: event });
            SessionAnnotationService.saveAnnotation(vm.annotationTitle, sessionNo).then(function (response) {
                vm.isValidating = false;
                $rootScope.$broadcast('annotation-image-saved',{
                    isAnnotationSaved: isAnnotationSaved,
                    annotationImageData: response
                });
                ToastService.displayToast($filter('translate')('atheer.session.saveAnnotation.saved'), 3000);
                $mdDialog.hide();
            }).catch(function(err) {
                vm.isError = true;
                vm.isValidating = false;
            });
        }

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.onLoad();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionAnnotationModeDialogController', SessionAnnotationModeDialogController);

    /* @ngInject */
    function SessionAnnotationModeDialogController($mdDialog,mainData,SessionPlayerService) {
        var vm = this;
        vm.mainData = mainData;
        vm.close = function() {
            $mdDialog.cancel();
        };
        vm.classicAnnotationMode = function() {
            vm.mainData.annotate('CLASSIC');
            vm.close();
        };
        vm.annotateArMode = function(){
            vm.mainData.annotate('AR');
            vm.close();
        }
        vm.shareLocalImage = function (id) {
            $mdDialog.show({
                templateUrl: 'modules/conversation/conversation-local-content-picker.tmpl.html',
                controller: 'ConversationLocalContentPicker',
                controllerAs: 'vm',
                locals: { annotationMode: true },
            })
            .then(function(content) {
                mainData.sendAnnotationLockMessageForLocalImage();
                vm.isOpenAnnotationOptions = false;
                getImageSize(content.data.source_media.properties.file_name);
            });
        }

        vm.shareContent = function() {
            $mdDialog.show({
                    templateUrl: 'modules/content/content-picker.html',
                    controller: 'ContentPickerController',
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals: {
                        filter: 'embedded==false;type=out=(SERIES,EMAIL_LAYOUT);meta_type==DISCOVERABLE;status!=ARCHIVED;enabled==true;type==IMAGE',
                        allowMultiSelect: false,
                        isWeb: false,
                        isNotFilter: false
                    }
                })
                .then(function(content) {
                    mainData.sendAnnotationLockMessageForLocalImage();
                    vm.isOpenAnnotationOptions = false;
                    getImageSize(content[0].data.source_media.properties.file_name);
                });
        }

        function getImageSize(url) {
            var image = new Image();
            image.src = "/media/images/"+url;
            image.onload = function() {
                var annotationData =  {
                    height: this.height,
                    url: url,
                    width: this.width
                }
                vm.mainData.startLocalImageShareAnnotation(annotationData)
              };
          }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('sessionAnnotationFullscreenController', sessionAnnotationFullscreenController);

    /* @ngInject */
    function sessionAnnotationFullscreenController($scope, $stateParams, $mdDialog, $mdToast, $filter, sessionActivity, UserInvitation, $location) {
        var vm = this;
        vm.sessionActivity = sessionActivity;
        vm.mediaPathAnnotation = "/media/images/";

        vm.clear = function() {
            $mdDialog.hide();
        };

        vm.getMediaUrl = function() {
            if ($location.host().endsWith('atheer.my')) {
                return 'https://' + $location.host() + ':' + $location.port() + vm.mediaPathAnnotation + vm.sessionActivity.properties.media_file_name;
            } else {
                return vm.mediaPathAnnotation + vm.sessionActivity.properties.media_file_name;
            }
        }

    }
})();

;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionAnnotationBuilder', sessionAnnotationBuilder);

    function sessionAnnotationBuilder() {
        var directive = {
            scope: {
                annotationData: '=',
                sessionId: '=',
                userId: '='
            },
            bindToController: true,
            controller: sessionAnnotationBuilderController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-annotation-builder.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionAnnotationBuilderController($rootScope, $scope, $element, $window, PubNubService, SessionAnnotationService) {
        var vm = this;

        var annotationToolEnum = {
            pencil: "PENCIL",
            arrow: "ARROW",
            text: "TEXT",
            undo: "UNDO",
            clear: "CLEAR"
        }
        var colorPrefix = '#';
        var canvasWidth = vm.annotationData.currentImageWidth;
        var canvasHeight = vm.annotationData.currentImageHeight;
        var imageWidth = vm.annotationData.originalImageWidth;
        var imageHeight = vm.annotationData.originalImageHeight;
        var textParam = {
            width: 200,
            size: 48,
            text: ''
        };
        var pencilUpdateData = [];

        var toolChangeListener = null;
        var generateAnnotationImageListener = null;
        var setBrushColorListener = null;
        var pubNubSessionListener = null;

        vm.selectedTool = annotationToolEnum.pencil;
        vm.isPencilUpdate = false;
        vm.isArrowUpdate = false;
        vm.annotationCanvas = null;
        vm.arrow = null;
        vm.arrowThickness = 2.5;
        vm.brushColor = 'FFB800';
        vm.brushWidth = 2.5;
        vm.showCanvas = false;
        vm.showLoader = true;
        vm.isAnnotationEditAllowed = vm.annotationData.allowAnnotationEdit;
        vm.isFreezeFrame = vm.annotationData.action === 'ANNOTATION_FREEZE_FRAME' ? true : false;
        vm.previousSelectedTool = null;

        function onLoad() {
            $window.addEventListener('resize', onResize);
            vm.annotationCanvas = new fabric.Canvas('annotation-canvas', { isDrawingMode: true });
            setDimentions(canvasWidth, canvasHeight);
            var scaleFactor = getScaleFactor();
            fabric.Object.prototype.selectable = false;
            vm.annotationCanvas.isDrawingMode = vm.annotationData.allowAnnotationEdit;
            vm.annotationCanvas.setZoom(1);
            vm.annotationCanvas.freeDrawingBrush.width = vm.brushWidth;
            vm.annotationCanvas.freeDrawingBrush.color = colorPrefix + vm.brushColor;
            vm.arrow = new Arrow(vm.annotationCanvas, vm.arrowThickness);

            var filePath = '/media/images/' + vm.annotationData.screenShot;
            fabric.Image.fromURL(filePath, function (img) {
                img.set({ width: img.width, height: img.height, scaleX: scaleFactor, scaleY: scaleFactor, originX: 'left', originY: 'top' });
                vm.annotationCanvas.setBackgroundImage(img, vm.annotationCanvas.renderAll.bind(vm.annotationCanvas));
                vm.showCanvas = true;
                vm.showLoader = false;
                $scope.$emit('image-loaded', vm.showCanvas);
                $scope.$apply();
            });

            if (vm.annotationData.allowAnnotationEdit) {
                vm.annotationCanvas.on('mouse:down', vm.startDraw);
                vm.annotationCanvas.on('mouse:move', vm.updateDraw);
                vm.annotationCanvas.on('mouse:up', vm.endDraw);
                vm.annotationCanvas.on('text:editing:exited', vm.onTextAdd);
            };

            toolChangeListener = $scope.$on('tool-change', vm.updateTool);
            generateAnnotationImageListener = $scope.$on('generate-annotation-image', generateAnnotationImage);
            setBrushColorListener = $scope.$on('set-brush-color', setBrushColor);
        };

        function updateAnnotationStatus(isSaved) {
            $scope.$broadcast('is-drawing', isSaved);
            $scope.$emit('save-annotation-image', !isSaved);
        }

        function setBrushColor(event, color) {
            vm.brushColor = color;
            vm.annotationCanvas.freeDrawingBrush.color = colorPrefix + vm.brushColor;
        }

        function generateAnnotationImage(event) {
            var image = vm.annotationCanvas.toDataURL({ format: 'jpeg', quality: 1 });
            SessionAnnotationService.setAnnotationImage(image);
            updateAnnotationStatus(true);
        };

        vm.startDraw = function (event) {
            var x = event.pointer.x;
            var y = event.pointer.y;
            var tx = SessionAnnotationService.getPercentage(x, vm.annotationCanvas.width);
            var ty = SessionAnnotationService.getPercentage(y, vm.annotationCanvas.height);
            var createdata = {
                x: tx,
                y: ty,
                color: vm.brushColor
            };
            var createMessage = {
                subject: 'SESSION',
                action: vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC',
                data: createdata
            };
            if (vm.annotationCanvas.isDrawingMode) {
                vm.isPencilUpdate = true;
                createMessage.type = 'PENCIL_CREATE';
            } else if (vm.selectedTool === annotationToolEnum.arrow) {
                vm.isArrowUpdate = true;
                createMessage.type = 'ARROW_CREATE';
                vm.arrow.onMouseDown(event);
            }
            publishMessage(createMessage);
            updateAnnotationStatus(false);
        };

        vm.updateDraw = function (event) {
            if (vm.isPencilUpdate || vm.isArrowUpdate) {
                var x = event.pointer.x;
                var y = event.pointer.y;
                var tx = SessionAnnotationService.getPercentage(x, vm.annotationCanvas.width);
                var ty = SessionAnnotationService.getPercentage(y, vm.annotationCanvas.height);
                var updateData = {
                    x: tx,
                    y: ty
                };
                var updateMessage = {
                    subject: 'SESSION',
                    action: vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC',
                };
                if (vm.annotationCanvas.isDrawingMode) {
                    if(pencilUpdateData.length == 100) {
                        updateMessage.type = 'PENCIL_UPDATE';
                        updateMessage.data = {
                            points: pencilUpdateData
                        };
                        pencilUpdateData = [];
                        publishMessage(updateMessage);
                    } else {
                        pencilUpdateData.push(updateData);
                    }
                } else if (vm.selectedTool === annotationToolEnum.arrow) {
                    vm.arrow.onMouseMove(event);
                }
            }
        };

        vm.endDraw = function (event) {
            if (vm.annotationCanvas.isDrawingMode) {
                vm.isPencilUpdate = false;
                var confirmMessage = {
                    subject: 'SESSION',
                    action: vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC',
                    type: 'PENCIL_CONFIRM'
                };
                confirmMessage.data = {
                    points: pencilUpdateData
                };
                pencilUpdateData = [];
                publishMessage(confirmMessage);
            } else if (vm.selectedTool === annotationToolEnum.arrow) {
                if (vm.isArrowUpdate) {
                    var x = event.pointer.x;
                    var y = event.pointer.y;
                    var tx = SessionAnnotationService.getPercentage(x, vm.annotationCanvas.width);
                    var ty = SessionAnnotationService.getPercentage(y, vm.annotationCanvas.height);
                    var updateData = {
                        x: tx,
                        y: ty
                    };
                    var updateMessage = {
                        subject: 'SESSION',
                        action: vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC',
                        data: updateData
                    };
                    vm.isArrowUpdate = false;
                    vm.arrow.onMouseMove(event);
                    vm.arrow.onMouseUp();
                    vm.annotationCanvas.discardActiveObject();
                    updateMessage.type = 'ARROW_UPDATE';
                    publishMessage(updateMessage);
                }
            } else {
                createText(event.pointer);
            }
        };

        vm.onTextAdd = function (event) {
            var objects = vm.annotationCanvas.getObjects();
            var textObj = objects[objects.length - 1];
            if (textObj.text !== '') {
                var textData = {
                    x1: SessionAnnotationService.getPercentage(textObj.aCoords.tl.x, vm.annotationCanvas.width),
                    x2: SessionAnnotationService.getPercentage(textObj.aCoords.br.x, vm.annotationCanvas.width),
                    y1: SessionAnnotationService.getPercentage(textObj.aCoords.tl.y, vm.annotationCanvas.height),
                    y2: SessionAnnotationService.getPercentage(textObj.aCoords.br.y, vm.annotationCanvas.height),
                    lines: textObj.textLines,
                    color: vm.brushColor
                };
                var textMessage = {
                    subject: 'SESSION',
                    action: vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC',
                    type: 'TEXT_CREATE',
                    data: textData
                };
                publishMessage(textMessage);
                updateAnnotationStatus(false);
            }
        };

        vm.updateTool = function (event, data) {
            endText();
            vm.previousSelectedTool = vm.selectedTool;
            vm.selectedTool = data.tool;
            if (data.tool === annotationToolEnum.pencil) {
                vm.annotationCanvas.isDrawingMode = true;
            } else if (data.tool === annotationToolEnum.arrow) {
                vm.annotationCanvas.isDrawingMode = false;
                vm.annotationCanvas.selection = false;
            } else if (data.tool === annotationToolEnum.undo) {
                vm.onUndoClick();
                vm.selectedTool = vm.previousSelectedTool;
            } else if (data.tool === annotationToolEnum.clear) {
                vm.onClearClick();
                vm.selectedTool = vm.previousSelectedTool;
            } else {
                vm.annotationCanvas.isDrawingMode = false;
            }
        }

        vm.onUndoClick = function () {
            var undoMessage = {
                subject: 'SESSION',
                action: vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC',
                type: 'UNDO'
            }
            undoLastStep();
            publishMessage(undoMessage);
            updateAnnotationStatus(false);
        };

        vm.onClearClick = function () {
            var clearMessage = {
                subject: 'SESSION',
                action: vm.isFreezeFrame ? 'ANNOTATION_FREEZE_FRAME' : 'ANNOTATION_CLASSIC',
                type: 'CLEAR'
            }
            clearCanvas();
            publishMessage(clearMessage);
            updateAnnotationStatus(false);
        };

        function clearCanvas() {
            if(vm.isPencilUpdate) {
                endPathDraw();
            }
            for (var i = vm.annotationCanvas._objects.length - 1; i >= 0; i--) {
                vm.annotationCanvas.remove(vm.annotationCanvas._objects[i]);
            }
        };

        function undoLastStep() {
            if(vm.isPencilUpdate) {
                endPathDraw();
            }
            endText();
            vm.annotationCanvas.discardActiveObject();
            var objects = vm.annotationCanvas.getObjects();
            vm.annotationCanvas.remove(objects[objects.length - 1]);
            vm.annotationCanvas.renderAll();
        };

        function createText(point) {
            endText();
            addText('', true, point, textParam.width, textParam.height, textParam.size);
        };

        function addText(text, isEditable, point, width, height, fontSize) {
            var textBox = new fabric.Textbox(text, {
                fontFamily: 'Roboto',
                left: point.x,
                top: point.y,
                fill: colorPrefix + vm.brushColor,
                fontSize: fontSize,
                textAlign: 'left',
                editable: isEditable,
                width: width,
                height: height,
                padding: 20
            });
            vm.annotationCanvas.add(textBox);
            if (isEditable) {
                vm.annotationCanvas.setActiveObject(textBox);
                textBox.enterEditing();
            } else {
                textBox.setCoords();
                vm.annotationCanvas.renderAll();
            }
        };

        function endText() {
            var obj = vm.annotationCanvas.getActiveObject();
            if (obj instanceof fabric.Textbox && obj.isEditing) {
                obj.exitEditing();
                vm.annotationCanvas.discardActiveObject();
                if (obj.text === '') {
                    var objects = vm.annotationCanvas.getObjects();
                    vm.annotationCanvas.remove(objects[objects.length - 1]);
                    vm.annotationCanvas.renderAll();
                }
            }
        };

        function publishMessage(message) {
            PubNubService.publish(vm.sessionId, message);
        };

        function cleanUp() {
            vm.annotationCanvas.off('mouse:down', vm.startDraw);
            vm.annotationCanvas.off('mouse:move', vm.updateDraw);
            vm.annotationCanvas.off('mouse:up', vm.endDraw);
            vm.annotationCanvas.off('text:editing:exited', vm.onTextAdd);
            toolChangeListener = null;
            generateAnnotationImageListener = null;
            setBrushColorListener = null;
        };

        function handleMessage(message) {
            if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'PENCIL_CREATE') {
                beginPathDraw(message.message.data);
            } else if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'PENCIL_UPDATE') {
                updatePathDraw(message.message.data);
            } else if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'PENCIL_CONFIRM') {
                endPathDraw(message.message.data);
            } else if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'ARROW_CREATE') {
                startArrow(message.message.data);
            } else if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'ARROW_UPDATE') {
                updateArrow(message.message.data);
            } else if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'TEXT_CREATE') {
                drawText(message.message.data);
            } else if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'UNDO') {
                undoLastStep();
            } else if ((message.message.action === 'ANNOTATION_CLASSIC' || message.message.action === 'ANNOTATION_FREEZE_FRAME') && message.message.type === 'CLEAR') {
                clearCanvas();
            }
        };

        function beginPathDraw(data) {
            vm.isPencilUpdate = true;
            vm.annotationCanvas.freeDrawingBrush.color = colorPrefix + data.color;
            var rX = data.x * vm.annotationCanvas.width;
            var rY = data.y * vm.annotationCanvas.height;

            var pointer = {
                x: rX,
                y: rY
            };
            var options = {
                e: { isPrimary: true },
                pointer: pointer
            };
            vm.annotationCanvas.freeDrawingBrush.onMouseDown(pointer, options);
        };


        function updatePathDraw(updateData) {
            angular.forEach(updateData.points, function(data){
                var rX = data.x * vm.annotationCanvas.width;
                var rY = data.y * vm.annotationCanvas.height;

                var pointer = {
                    x: rX,
                    y: rY
                };
                var options = {
                    e: { isPrimary: true },
                    pointer: pointer
                };
                vm.annotationCanvas.freeDrawingBrush.onMouseMove(pointer, options);
            });
        };

        function endPathDraw(data) {
            if(data && data.points.length > 0) {
                updatePathDraw(data);
            }
            vm.isPencilUpdate = false;
            var options = {
                e: { isPrimary: true },
                pointer: null
            };
            vm.annotationCanvas.freeDrawingBrush.onMouseUp(options);
        };

        function startArrow(data) {
            vm.annotationCanvas.freeDrawingBrush.color = colorPrefix + data.color;
            var rX = data.x * vm.annotationCanvas.width;
            var rY = data.y * vm.annotationCanvas.height;
            var event = {
                pointer: {
                    x: rX,
                    y: rY
                }
            };
            vm.arrow.onMouseDown(event);
        };

        function updateArrow(data) {
            var rX = data.x * vm.annotationCanvas.width;
            var rY = data.y * vm.annotationCanvas.height;
            var event = {
                pointer: {
                    x: rX,
                    y: rY
                }
            };
            vm.arrow.onMouseMove(event);
        };

        function drawText(data) {
            vm.brushColor = data.color;
            var rX1 = data.x1 * vm.annotationCanvas.width;
            var rY1 = data.y1 * vm.annotationCanvas.height;
            var rX2 = data.x2 * vm.annotationCanvas.width;
            var rY2 = data.y2 * vm.annotationCanvas.height;
            var width = rX2 - rX1;
            var height = rY2 - rY1;
            var content = data.lines.join('\n');
            var point = { x: rX1, y: rY1 };
            var xScaleFactor;
            if (imageWidth > imageHeight) {
                xScaleFactor = vm.annotationCanvas.width / imageWidth;
            } else {
                xScaleFactor = imageWidth / imageHeight;
            }
            var size = textParam.size * xScaleFactor;
            addText(content, false, point, width, height, size);
        };

        function getScaleFactor() {
            var scaleFactor;
            if (imageWidth > imageHeight) {
                scaleFactor = vm.annotationCanvas.width / imageWidth;
            } else {
                scaleFactor = vm.annotationCanvas.height / imageHeight;
            }
            return scaleFactor;
        };

        function setDimentions(width, height) {
            var aspectRatio;
            var finalHeight;
            var finalWidth;
            if (imageWidth > imageHeight) {
                aspectRatio = imageWidth / imageHeight;
                finalWidth = width;
                finalHeight = width / aspectRatio;
                if (height < finalHeight) {
                    finalHeight = height;
                    finalWidth = height * aspectRatio;
                }
            } else {
                aspectRatio = imageHeight / imageWidth;
                finalHeight = height;
                finalWidth = height / aspectRatio;
                if (width < finalWidth) {
                    finalWidth = width;
                    finalHeight = width * aspectRatio;
                }
            }
            vm.annotationCanvas.setWidth(finalWidth);
            vm.annotationCanvas.setHeight(finalHeight);
        }

        function onResize() {
            var canvas = vm.annotationCanvas;
            var newWidth = $element.width();
            var newHeight = $element.height();
            var oldWidth = canvas.width;
            var oldHeight = canvas.height;
            if (newWidth !== oldWidth || newHeight !== oldHeight) {
                setDimentions(newWidth, newHeight);
                var scaleFactor = getScaleFactor();
                var objects = vm.annotationCanvas.getObjects();
                for (var i in objects) {
                    objects[i].scaleX = objects[i].scaleX * (vm.annotationCanvas.width / oldWidth);
                    objects[i].scaleY = objects[i].scaleY * (vm.annotationCanvas.height / oldHeight);
                    objects[i].left = objects[i].left * (vm.annotationCanvas.width / oldWidth);
                    objects[i].top = objects[i].top * (vm.annotationCanvas.height / oldHeight);
                    objects[i].setCoords();
                }
                var image = vm.annotationCanvas.backgroundImage;
                if (image) {
                    image.scaleX = scaleFactor;
                    image.scaleY = scaleFactor;
                }
                vm.annotationCanvas.renderAll();
                vm.annotationCanvas.calcOffset();
            }
        };

        $scope.$on('$destroy', function() {
            console.log("Studio-Session-ANNOTATION-CLASSIC-Destroy");
            pubNubSessionListener = null;
            cleanUp();
        });

        pubNubSessionListener = $scope.$on('sessionMessagePubNub', function(event, message) {
            $scope.$apply(function() {
                if (message.message.subject == 'SESSION' && message.publisher != vm.userId) {
                    console.log("Studio-Session-Pubnub-Message", message.publisher, vm.userId, message);
                    handleMessage(message);
                };
            });
        });

        onLoad();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.session')
        .directive('sessionAnnotationArBuilder', sessionAnnotationArBuilder);

    function sessionAnnotationArBuilder() {
        var directive = {
            scope: {
                annotationData: '=',
                sessionId: '=',
                userId: '='
            },
            bindToController: true,
            controller: sessionAnnotationArBuilderController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-annotation-ar-builder.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionAnnotationArBuilderController($rootScope, $scope, PubNubService, SessionAnnotationService) {
        var vm = this;

        var annotationToolEnum = {
            pencil: "PENCIL",
            laser: "LASER",
            arrow: "ARROW",
            text: "TEXT",
            undo: "UNDO",
            clear: "CLEAR"
        };
        var colorPrefix = '#';
        var textParams = {
            width: 200,
            size: 20,
            text: '',
            height: 30
        };

        var toolChangeListener = null;
        var setBrushColorListener = null;
        var resizeVideoListener = null;
        var sceneReadyListener = null;
        var showLoaderListener = null;
        var pubNubSessionListener = null;

        vm.selectedTool = vm.annotationData.type == 'LIVE' ? annotationToolEnum.laser : annotationToolEnum.pencil;
        vm.arCanvas = null;
        vm.brushColor = 'FFB800';
        vm.brushWidth = 2.5;
        vm.isAnnotationEditAllowed = vm.annotationData.allowAnnotationEdit;
        vm.isLaserUpdate = false;
        vm.laserPreviousPoint = null;
        vm.isArrowUpdate = false;
        vm.isPencilUpdate = false;
        vm.annotationType  = vm.annotationData.type;
        vm.isFreezeFrame = !vm.annotationData.allowAnnotationEdit ? true : false;
        vm.isTextBox = false;
        vm.text = null;
        vm.textPointer = null;
        vm.previousSelectedTool = null;
        vm.laserPoints = [];

        if(vm.annotationData.annotationFrom !== 'FREEZE_FRAME'){
            vm.showLoader = vm.annotationType == 'AR' ? true : false;
        }

        function onLoad() {
            vm.arCanvas = new fabric.Canvas('annotation-ar-canvas', { isDrawingMode: false });
            vm.arCanvas.setWidth(vm.annotationData.videoWidth);
            vm.arCanvas.setHeight(vm.annotationData.videoHeight);
            fabric.Object.prototype.selectable = false;
            vm.arCanvas.setZoom(1);
            vm.arCanvas.selection = false;
            vm.arCanvas.freeDrawingBrush.width = vm.brushWidth;
            vm.arCanvas.freeDrawingBrush.color = colorPrefix + vm.brushColor;
            vm.laserBrush = new fabric.LaserBrush(vm.arCanvas);
            vm.arrow = new Arrow(vm.arCanvas, vm.brushWidth, true);

            vm.arCanvas.on('mouse:down', vm.startDraw);
            vm.arCanvas.on('mouse:move', vm.updateDraw);
            vm.arCanvas.on('mouse:up', vm.endDraw);

            toolChangeListener = $scope.$on('tool-change', vm.updateTool);
            setBrushColorListener = $scope.$on('set-brush-color', setOrUpdateBrushColor);
            resizeVideoListener = $scope.$on('resize-video', onResizeVideo);
            sceneReadyListener = $scope.$on('scene-ready', sceneReady);
            showLoaderListener = $scope.$on('show-loader', showLoader);
        }

        vm.updateTool = function (event, tool) {
            vm.previousSelectedTool = vm.selectedTool;
            vm.selectedTool = tool.tool;
            if (tool.tool === annotationToolEnum.undo) {
                vm.onUndoClick();
                vm.selectedTool = vm.previousSelectedTool;
            } else if (tool.tool === annotationToolEnum.clear) {
                vm.onClearClick();
                vm.selectedTool = vm.previousSelectedTool;
            }
        };

        vm.startDraw = function (event) {
            var tx = SessionAnnotationService.getPercentage(event.pointer.x, vm.arCanvas.width);
            var ty = SessionAnnotationService.getPercentage(event.pointer.y, vm.arCanvas.height);

            var createLaserData = {
                x: tx,
                y: ty,
                color: vm.brushColor
            };
            var createMessage = {
                subject: 'SESSION',
                action: vm.annotationType === 'LIVE' ? 'ANNOTATION_LIVE' : 'ANNOTATION_AR',
                data: createLaserData
            };
            vm.arCanvas.freeDrawingBrush.color = colorPrefix + vm.brushColor;
            if (vm.selectedTool === annotationToolEnum.laser) {
                vm.isLaserUpdate = true;
                vm.laserPreviousPoint = event.pointer;
                createMessage.type = 'LASER_CREATE';
            } else if (vm.selectedTool === annotationToolEnum.arrow && vm.annotationType === 'LIVE') {
                vm.isArrowUpdate = true;
                vm.arrow.onMouseDown(event);
                createMessage.type = 'ARROW_CREATE';
            } else if (vm.selectedTool === annotationToolEnum.pencil) {
                vm.isPencilUpdate = true;
                createMessage.type = 'PENCIL_CREATE';
            } else if (vm.selectedTool === annotationToolEnum.arrow && vm.annotationType === 'AR') {
                createMessage.type = 'ARROW_CREATE';
            } else if (vm.selectedTool === annotationToolEnum.text) {
                vm.isTextBox = true;
                vm.text = null;
                vm.textPointer = event.pointer;
                createMessage.type = 'AR_TEXT_CREATE';
            }
            publishMessage(createMessage);
        };

        vm.updateDraw = function (event) {
            var tx = SessionAnnotationService.getPercentage(event.pointer.x, vm.arCanvas.width);
            var ty = SessionAnnotationService.getPercentage(event.pointer.y, vm.arCanvas.height);
            var updateData = {
                x: tx,
                y: ty
            };

            var updateMessage = {
                subject: 'SESSION',
                action: vm.annotationType === 'LIVE' ? 'ANNOTATION_LIVE' : 'ANNOTATION_AR',
                data: updateData
            }
            if (vm.selectedTool === annotationToolEnum.laser && vm.isLaserUpdate) {
                var points = [vm.laserPreviousPoint, event.pointer];
                if(vm.laserPoints.length == 25) {
                    updateMessage.type = 'LASER_UPDATE';
                    updateMessage.data = {
                        points: vm.laserPoints
                    };
                    publishMessage(updateMessage);
                    vm.laserPoints = [];
                }
                vm.laserPoints.push(updateData);
                vm.laserBrush.onMouseMove(points);
                vm.laserPreviousPoint = event.pointer;
            } else if (vm.selectedTool === annotationToolEnum.arrow && vm.isArrowUpdate && vm.annotationType === 'LIVE') {
                vm.arrow.onMouseMove(event);
            } else if (vm.selectedTool === annotationToolEnum.pencil && vm.isPencilUpdate) {
                updateMessage.type = 'PENCIL_UPDATE';
                publishMessage(updateMessage);
            }
        };
        vm.endDraw = function (event) {
            var tx = SessionAnnotationService.getPercentage(event.pointer.x, vm.arCanvas.width);
            var ty = SessionAnnotationService.getPercentage(event.pointer.y, vm.arCanvas.height);
            var confirmData = {
                x: tx,
                y: ty
            };
            var confirmMessage = {
                subject: 'SESSION',
                action: vm.annotationType === 'LIVE' ? 'ANNOTATION_LIVE' : 'ANNOTATION_AR'
            };
            if (vm.selectedTool === annotationToolEnum.laser) {
                vm.laserPreviousPoint = null;
                vm.isLaserUpdate = false;
                confirmMessage.type = 'LASER_UPDATE';
                confirmMessage.data = {
                    points: vm.laserPoints
                };
                vm.laserPoints = [];
                publishMessage(confirmMessage);
            } else if (vm.selectedTool === annotationToolEnum.arrow && vm.annotationType === 'LIVE') {
                vm.isArrowUpdate = false;
                confirmMessage.type = 'ARROW_CONFIRM';
                confirmMessage.data = confirmData;
                publishMessage(confirmMessage);
                vm.arrow.onMouseUp();
            } else if (vm.selectedTool === annotationToolEnum.pencil) {
                vm.isPencilUpdate = false;
                confirmMessage.type = 'PENCIL_CONFIRM';
                publishMessage(confirmMessage);
            }
        };

        vm.onUndoClick = function () {
            var undoMessage = {
                subject: 'SESSION',
                action: 'ANNOTATION_AR',
                type: 'UNDO'
            };

            publishMessage(undoMessage);
        };

        vm.onClearClick = function () {
            var clearMessage = {
                subject: 'SESSION',
                action: 'ANNOTATION_AR',
                type: 'CLEAR'
            };

            publishMessage(clearMessage);
        };

        vm.addText = function () {
            vm.isTextBox = false;
            if(vm.text !== null) {

                addText(vm.text, vm.textPointer, textParams.width, textParams.height, textParams.size);
                vm.onTextAdd();

                var objects = vm.arCanvas.getObjects();
                var textObj = objects[objects.length - 1];

                vm.arCanvas.remove(textObj);
            }
        }

        vm.onTextAdd = function () {
            var objects = vm.arCanvas.getObjects();
            var textObj = objects[objects.length - 1];
            if (textObj.text !== '') {
                var textData = {
                    width: textObj.aCoords.br.x - textObj.aCoords.tl.x,
                    height: textObj.aCoords.br.y - textObj.aCoords.tl.y,
                    lines: textObj.textLines
                };
                var textMessage = {
                    subject: 'SESSION',
                    action: 'ANNOTATION_AR',
                    type: 'AR_TEXT_UPDATE',
                    data: textData
                };
                publishMessage(textMessage);
            }
        };

        function addText(text, point, width, height, fontSize) {
            var textBox = new fabric.Textbox(text, {
                fontFamily: 'Roboto',
                left: point.x,
                top: point.y,
                fill: colorPrefix + vm.brushColor,
                fontSize: fontSize,
                textAlign: 'left',
                editable: false,
                width: width,
                height: height
            });
            vm.arCanvas.add(textBox);
            vm.arCanvas.setActiveObject(textBox);
            textBox.enterEditing();
        };

        function onResizeVideo(event, data) {
            var videoWidth = data.data.width;
            var videoHeight = data.data.height;
            var width, height;
            var videoContainer = document.getElementById('annotationARContainer');
            width = videoWidth < videoContainer.clientWidth ? videoWidth : videoContainer.clientWidth;
            height = videoHeight < videoContainer.clientHeight ? videoHeight : videoContainer.clientHeight;
            vm.arCanvas.setWidth(width);
            vm.arCanvas.setHeight(height);
        };

        function setOrUpdateBrushColor(event, color) {
            vm.brushColor = color;
            vm.arCanvas.freeDrawingBrush.color = colorPrefix + color;
        };

        function sceneReady(event, isSceneReady) {
            vm.showLoader = !isSceneReady;
        }

        function showLoader(event, isLoader) {
            vm.showLoader = isLoader;
        }

        function publishMessage(message) {
            PubNubService.publish(vm.sessionId, message);
        };

        function cleanUp() {
            vm.arCanvas.off('mouse:down', vm.startDraw);
            vm.arCanvas.off('mouse:move', vm.updateDraw);
            vm.arCanvas.off('mouse:up', vm.endDraw);
            toolChangeListener = null;
            setBrushColorListener = null;
            resizeVideoListener = null;
            sceneReadyListener = null;
            showLoaderListener = null;
        };

        function handleMessage(message) {
            if ((message.message.action === 'ANNOTATION_LIVE' || message.message.action === 'ANNOTATION_AR') && message.message.type === 'LASER_CREATE') {
                beginLaserPathDraw(message.message.data);
            } else if ((message.message.action === 'ANNOTATION_LIVE' || message.message.action === 'ANNOTATION_AR') && message.message.type === 'LASER_UPDATE') {
                updateLaserPathDraw(message.message.data);
            } else if (message.message.action === 'ANNOTATION_LIVE' && message.message.type === 'ARROW_CREATE') {
                beginArrow(message.message.data);
            } else if (message.message.action === 'ANNOTATION_LIVE' && message.message.type === 'ARROW_UPDATE') {
                updateArrow(message.message.data);
            } else if (message.message.action === 'ANNOTATION_LIVE' && message.message.type === 'ARROW_CONFIRM') {
                endArrow(message.message.data);
            }
        };

        function beginLaserPathDraw(data) {
            var rx = data.x * vm.arCanvas.width;
            var ry = data.y * vm.arCanvas.height;
            vm.arCanvas.freeDrawingBrush.color = colorPrefix + data.color;

            var pointer = {
                x: rx,
                y: ry
            };

            vm.laserPreviousPoint = pointer;
        };

        function updateLaserPathDraw(laserPathData) {
            angular.forEach(laserPathData.points, function(data){
                var rx = data.x * vm.arCanvas.width;
                var ry = data.y * vm.arCanvas.height;
                var pointer = {
                    x: rx,
                    y: ry
                };
                var points = [vm.laserPreviousPoint, pointer];
                vm.laserBrush.onMouseMove(points);
                vm.laserPreviousPoint = pointer;
            });
        };

        function beginArrow(data) {
            var rx = data.x * vm.arCanvas.width;
            var ry = data.y * vm.arCanvas.height;
            vm.arCanvas.freeDrawingBrush.color = colorPrefix + data.color;
            var event = {
                pointer: {
                    x: rx,
                    y: ry
                }
            };
            vm.arrow.onMouseDown(event);
        };

        function updateArrow(data) {
            var rx = data.x * vm.arCanvas.width;
            var ry = data.y * vm.arCanvas.height;
            var event = {
                pointer: {
                    x: rx,
                    y: ry
                }
            };
            vm.arrow.onMouseMove(event);
        };

        function endArrow(data) {
            updateArrow(data);
            vm.arrow.onMouseUp();
        };

        $scope.$on('$destroy', function() {
            console.log("Studio-Session-ANNOTATION-AR-Destroy");
            pubNubSessionListener = null;
            cleanUp();
        });

        pubNubSessionListener = $scope.$on('sessionMessagePubNub', function(event, message) {
            $scope.$apply(function() {
                if (message.message.subject == 'SESSION' && message.publisher != vm.userId) {
                    console.log("Studio-Session-Pubnub-Message", message.publisher, vm.userId, message);
                    handleMessage(message);
                };
            });
        });

        onLoad();
    }

})();
;
(function () {
    'use strict';

    angular
        .module('atheer.public', [

        ]);
})();;
(function () {
    'use strict';

    angular.module('atheer.public').config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('public', {
                abstract: true,
                views: {
                    'root': {
                        templateUrl: 'modules/public/public.tmpl.html'
                    }
                }
            })
            .state('public.home', {
                url: '/public/home',
                templateUrl: 'modules/home/home.tmpl.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'global.menu.home'
                }
            })
            .state('public.topics', {
                url: '/public/topics',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'PublicController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'global.menu.home'
                }
            })
            .state('public.topics-detail', {
                url: '/public/topics/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'PublicController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.topic.home.title'
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('public.content-detail', {
                url: '/public/contents/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'PublicController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.content.home.title'
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('public.unified-search', {
                url: '/public/home/search/:id',
                templateUrl: 'modules/home/home.tmpl.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.content.home.title'
                }
            })
            .state('public.job-execute', {
                url: '/public/jobs/execute/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.job.home.title',
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('public.job-detail', {
                url: '/public/jobs/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.job.home.title',
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
    }
})();;
(function () {
    "use strict";

    angular
        .module("atheer.public")
        .controller("PublicController", PublicController);

    /* @ngInject */
    function PublicController($scope, $window, $state, $sce, $location) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.isIFrameDataLoaded = false;

        function setNgxPageUrl() {
            var ngxUrl = null;
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            var path = $location.path();

            if ($state.current.name == "public.home") {
                ngxUrl = hostUrl + "/ngx/home";
            } else if ($state.current.name == "public.topics") {
                ngxUrl = hostUrl + "/ngx/topics";
            } else if ($state.current.name == "public.topics-detail") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/topics/" + id;
            } else if ($state.current.name == "public.content-detail") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/contents/" + id;
            } else if ($state.current.name == "public.unified-search") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/home/search?" + id;
            } else if ($state.current.name == 'public.job-execute') {
                var id = path.split('/').pop();
                ngxUrl = hostUrl + '/ngx/job/execute/' + id;
            } else if ($state.current.name == 'public.job-detail') {
                var id = path.split('/').pop();
                ngxUrl = hostUrl + '/ngx/jobs/' + id;
            }
            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
        }

        function handleNgxEvent(event) {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;
                var queryParams = event.data.ngxLocationChanged.queryParams;
                id = id ? id : queryParams;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                if (id == null && queryParams == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                } else {
                    $state.transitionTo(
                        ngState,
                        {
                            id: id
                        },
                        {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        }
                    );
                }
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        $window.addEventListener("message", handleNgxEvent, false);

        // Unregister
        $scope.$on("$destroy", function () {
            window.removeEventListener("message", handleNgxEvent, false);
        });

        setNgxPageUrl();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.job', [

        ]);
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.job')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, CONTENT_INSIGHT_META) {
        $stateProvider
            .state('storm.jobs', {
                url: '/jobs',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'JobController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.job.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.job-execute', {
                url: '/jobs/execute/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'JobController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.job.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                },
            })
            .state('storm.job-detail', {
                url: '/jobs/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'JobController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.job.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.new-job', {
                url: '/job/new',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'JobController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.job.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.edit-job', {
                url: '/jobs/edit/:id',
                templateUrl: 'modules/ngx-frame.html',
                controller: 'JobController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.job.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    }
                }
            });
    }
})();
;
(function () {
	'use strict';

	angular.module('atheer.job').controller('JobController', JobController);

	/* @ngInject */
	function JobController(
		$rootScope,
		$state,
		$scope,
		$sce,
		$cookies,
		BuildLanguages,
		$location,
		$window
	) {
		var vm = this;
		vm.ngxUrlTrusted = null;
		vm.isIFrameDataLoaded = false;

		function setNgxPageUrl() {
			var ngxUrl = null;
			var path = $location.path();
			var hostUrl =
				location.hostname === 'localhost'
					? 'https://' + location.hostname + ':4200'
					: location.origin;

			if ($state.current.name == 'storm.jobs') {
				ngxUrl = hostUrl + '/ngx/jobs';
			} else if ($state.current.name == 'storm.job-detail') {
				var id = path.split('/').pop();
				if ($location.search().action) {
					ngxUrl = hostUrl + '/ngx/jobs/' + id + '?action=' + $location.search().action;
				}else {
					ngxUrl = hostUrl + '/ngx/jobs/' + id;
				}
			} else if ($state.current.name == 'storm.job-execute') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/job/execute/' + id;
			} else if ($state.current.name == 'storm.new-job') {
				ngxUrl = hostUrl + '/ngx/jobs/new';
			} else if ($state.current.name == 'storm.edit-job') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/jobs/edit/' + id;
			} else {
				ngxUrl = ngxUrl = hostUrl + '/ngx/jobs';
			}

			vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
			$rootScope.selectedLeftNavMenu = 'jobs';
		}

		function handleNgxEvent(event) {
			var hostUrl =
				location.hostname === 'localhost'
					? 'https://' + location.hostname + ':4200'
					: location.origin;
			if (event.origin !== hostUrl) return;
			if (event.data.ngxLocationChanged) {
				var ngState = event.data.ngxLocationChanged.ngState;
				var id = event.data.ngxLocationChanged.id;
				vm.isIFrameDataLoaded = true;
				scopeApply();

				if (id == null) {
					$state.transitionTo(ngState, null, {
						location: true,
						inherit: true,
						relative: $state.$current,
						notify: false
					});
				} else {
					$state.transitionTo(
						ngState,
						{
							id: id
						},
						{
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: false
						}
					);
				}
			}
		}

		var scopeApply = function (fn) {
			var phase = $scope.$root.$$phase;
			if (phase !== "$apply" && phase !== "$digest") {
				return $scope.$apply(fn);
			}
		};

		$window.addEventListener('message', handleNgxEvent, false);

		// Unregister
		$scope.$on('$destroy', function () {
			window.removeEventListener('message', handleNgxEvent, false);
		});

		setNgxPageUrl();
	}
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights', [

        ]);
})();;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, triMenuProvider) {

        $stateProvider
            .state('storm.insights', {
                url: '/insights',
                abstract: true,
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights.tmpl.html',
                        controller: 'InsightsController',
                        controllerAs: 'vm',
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/insights/insights-menu.tmpl.html',
                        controller: 'InsightsMenuController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insights-toolbar.tmpl.html',
                        controller: 'InsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    workspaceId: function($stateParams) {
                        return $stateParams.id;
                    },
                    dashboardId: function($stateParams) {
                        return $stateParams.dashboardId;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: true
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'dashboard_no,asc',
                        squash: true
                    },
                    search: null
                }
            })
            .state('storm.insights.workspace-summary', {
                url: '/workspace-summary/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-summary.tmpl.html',
                        controller: 'InsightsSummaryController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                params: {
                    launchMode: true
                }
            })
            .state('storm.insights.conversations', {
                url: '/conversations/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-conversation.tmpl.html',
                        controller: 'InsightsConversationController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.conversations.title',
                    }
                },
                params: {
                    launchMode: true
                }
            })
            .state('storm.insights.contents', {
                url: '/content/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-content.tmpl.html',
                        controller: 'InsightsContentController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.content.title',
                    }
                },
                params: {
                    launchMode: true
                }
            })
            .state('storm.insights.topics', {
                url: '/topics/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-topic.tmpl.html',
                        controller: 'InsightsTopicController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.topics.title',
                    }
                },
                params: {
                    launchMode: true
                }
            })
            .state('storm.insights.sessions', {
                url: '/sessions/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-session.tmpl.html',
                        controller: 'InsightsSessionController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.airSessions.title'
                    }
                },
                params: {
                    launchMode: true
                }
            })
            .state('storm.insights.airforms', {
                url: '/airforms/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-airform.tmpl.html',
                        controller: 'InsightsAirformController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.airForms.title',
                    }
                },
                params: {
                    launchMode: true
                }
            })
            .state('storm.insights.users', {
                url: '/users/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-user.tmpl.html',
                        controller: 'InsightsUserController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.users.title',
                    }
                },
                params: {
                    launchMode: true
                }
            })
            .state('storm.insights.adv-dashboards', {
                url: '/dashboards',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-dashboards.tmpl.html',
                        controller: 'InsightsDashboardsController',
                        controllerAs: 'vm',
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/insights/insights-dashboards-menu.tmpl.html',
                        controller: 'InsightsDashboardsMenuController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insights-dashboards-toolbar.tmpl.html',
                        controller: 'InsightsDashboardsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.dashboards',
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        sideNavMenuPosition: 'left',
                        showToolbar: true,
                        sideNavMenuSize: 15
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'dashboard_no,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    workspaceId: function($stateParams) {
                        return $stateParams.id;
                    },
                    dashboardId: function($stateParams) {
                        return $stateParams.dashboardId;
                    }
                }
            })
            .state('storm.insights.adv-analyze', {
                url: '/analyze',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-analyze.tmpl.html',
                        controller: 'InsightsAnalyzeController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insights-toolbar.tmpl.html',
                        controller: 'InsightsToolbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.analyze',
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: true,
                        sideNavMenuSize: 15
                    }
                }
            })
            .state('storm.insights.dashboard-view', {
                url: '/dashboard/:id/:workspaceId/:dashboardId/:dashboardmode',
                views: {
                    '@storm': {
                        templateUrl: 'modules/insights/insights-dashboard-view.tmpl.html',
                        controller: 'InsightsDashboardViewController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/insights/insight-dashboard-detail-toolbar.tmpl.html',
                        controller: 'InsightDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    layout: {
                        pageTitle: 'atheer.insights.dashboard.objectLabel',
                        showSideNavMenu: false
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    launchMode: function($stateParams) {
                        return $stateParams.launchMode;
                    },
                    dashboardId: function($stateParams) {
                        return $stateParams.dashboardId;
                    },
                    dashboardmode: function($stateParams) {
                        return $stateParams.dashboardmode;
                    }
                },
                params: {
                    launchMode: true,
                    fromHomeTile: function($stateParams) {
                        return $stateParams.fromHomeTile;
                    }
                }
            }).state('storm.insights.dashboard-detail', {
                url: '/dashboards/:id',
                templateUrl: 'modules/insights/insight-dashboard-detail.tmpl.html',
                controller: 'InsightDashboardDetailController',
                controllerAs: 'vm',
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsController', InsightsController);

    /* @ngInject */
    function InsightsController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsUserController', InsightsUserController);

    /* @ngInject */
    function InsightsUserController($scope, $q, $filter, $translate, Report, Workspace, workspaceId, triSettings) {
        var vm = this;

        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        vm.loadingData = false;
        vm.dashboardModel = null;
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.topUsersByCreatedCount = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.users.usersCreatedByCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.noOfUsers')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.users.title'),
                color: vm.primaryColor,
                data: []
            },
            {
                name: $translate.instant('atheer.insights.users.guestUsers'),
                color: vm.secondaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            angular.forEach(vm.dashboardModel.users_created_by_date_count, function(topUsersByCreatedCount) {
                vm.topUsersByCreatedCount.xAxis.categories.push(topUsersByCreatedCount.name);
                if (topUsersByCreatedCount.label == 'User') {
                    vm.topUsersByCreatedCount.series[0].data.push(topUsersByCreatedCount.count);
                }
                if (topUsersByCreatedCount.label == 'Guest') {
                    vm.topUsersByCreatedCount.series[1].data.push(topUsersByCreatedCount.count);
                }
            });
        
            vm.loadingData = false;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            var resource = angular.isDefined(workspaceId) ? Workspace.getUserDashboard({
                id: workspaceId
            }).$promise : Report.getUserDashboard().$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess()
                });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsTopicController', InsightsTopicController);

    /* @ngInject */
    function InsightsTopicController($scope, $q, $translate, $filter, Report, CONTENT_META, triSettings, Workspace, workspaceId) {
        var vm = this;

        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        vm.loadingData = false;
        vm.dashboardModel = null;
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.topTopicByScanCount = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.topics.topTopicByScanCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.topics.NoOfScans')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.topics.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.topics.title'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.topUsersByScanCount = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.topics.topUsersByScan')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.topics.NoOfScans')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.topics.scans'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.topicScansByDay = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.topics.scansPerDay')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.topics.NoOfScans')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.dates'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            angular.forEach(vm.dashboardModel.top_topic_by_scan_count, function(topTopicByScanCount) {
                vm.topTopicByScanCount.xAxis.categories.push(topTopicByScanCount.name);
                vm.topTopicByScanCount.series[0].data.push(topTopicByScanCount.count);
            });

            angular.forEach(vm.dashboardModel.top_users_by_scan_count, function(topUsersByScanCount) {
                vm.topUsersByScanCount.xAxis.categories.push(topUsersByScanCount.name);
                vm.topUsersByScanCount.series[0].data.push(topUsersByScanCount.count);
            });

            angular.forEach(vm.dashboardModel.topic_scan_by_day, function(topicScansByDay) {
                vm.topicScansByDay.xAxis.categories.push(topicScansByDay.name);
                vm.topicScansByDay.series[0].data.push(topicScansByDay.count);
            });

            vm.loadingData = false;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            var resource = angular.isDefined(workspaceId) ? Workspace.getTopicDashboard({
                id: workspaceId
            }).$promise : Report.getTopicDashboard().$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess();
                });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsToolbarController', InsightsToolbarController);

    /* @ngInject */
    function InsightsToolbarController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        var lessThan3Day = new Date();
        lessThan3Day.setDate(lessThan3Day.getDate() - 2);
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.customTemplates = [{
            name: 'Last 3 Days',
            dateStart: lessThan3Day,
            dateEnd: new Date(),
        }];

        vm.pickerModel = {
            selectedTemplate: 'Last 3 Days'
        };

        vm.loadingData = true;

        vm.loadAll = loadAll;
        function loadAll() {
            vm.loadingData = false;
        };

        vm.goToDashboards = function() {
            if($stateParams.isDeeplink) {
                $window.history.go(-2);
            } else {
                // $window.history.back();
                $state.go('storm.insights.adv-dashboards');
            }
        };

        vm.loadAll();
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.insights")
        .controller("InsightsSummaryController", InsightsSummaryController);

    /* @ngInject */
    function InsightsSummaryController(
        $rootScope,
        $scope,
        $state,
        $mdDialog,
        AlertService,
        Workspace,
        workspaceId,
        pagingParams,
        paginationConstants,
        ParseLinks,
        $q,
        $mdToast,
        $filter,
        Report,
        CONTENT_META
    ) {
        var vm = this;

        vm.loadingData = false;
        vm.dashboard = null;

        vm.getCount = function (activityName) {
            for (
                var i = 0;
                i < vm.dashboard.contents_summary.metrics.length;
                i++
            ) {
                if (
                    vm.dashboard.contents_summary.metrics[i].name ===
                    activityName
                ) {
                    return vm.dashboard.contents_summary.metrics[i].count;
                }
            }
            return 0;
        };

        vm.loadData = function () {
            vm.loadingData = true;

            var resource = angular.isDefined(workspaceId)
                ? Workspace.getDashboard({
                      id: workspaceId,
                  }).$promise
                : Report.getDashboard().$promise;

            $q.all([
                resource
            ]).then(function (results) {
                vm.dashboard = results[0];
                vm.dashboard.conversations_summary.avg_messages_per_conversation = Math.ceil(
                    vm.dashboard.conversations_summary
                        .avg_messages_per_conversation
                );
                vm.dashboard.smartflows_summary = {
                    total_smartflows: 0,
                    total_executions: 0,
                    total_active: 0,
                    total_draft: 0,
                };

                vm.loadingData = false;
            });
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsSessionController', InsightsSessionController);

    /* @ngInject */
    function InsightsSessionController($scope, $q, $translate, $filter, Report, CONTENT_META, triSettings, Workspace, workspaceId) {
        var vm = this;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.loadingData = false;
        vm.dashboardModel = null;
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.topUsersBySessionCount = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.airSessions.topUsersAirSessionCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.airSessions.noOfAirSessions')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.airSessions.title'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.topUsersBySessionDuration = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.airSessions.topUsersByDuration')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.minutes')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.minutes'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.usageBySessionCount = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.airSessions.sessionUsageByCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.airSessions.noOfAirSessions')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.minutes'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.usageBySessionDuration = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.airSessions.sessionUsageByMinutes')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.minutes')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.dates'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() { 
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            angular.forEach(vm.dashboardModel.top_users_by_session_count, function(topUsersBySessionCount) {
                vm.topUsersBySessionCount.xAxis.categories.push(topUsersBySessionCount.name);
                vm.topUsersBySessionCount.series[0].data.push(topUsersBySessionCount.count);
            });

            angular.forEach(vm.dashboardModel.top_users_by_session_duration, function(topUsersBySessionDuration) {
                vm.topUsersBySessionDuration.xAxis.categories.push(topUsersBySessionDuration.name);
                vm.topUsersBySessionDuration.series[0].data.push(topUsersBySessionDuration.count);
            });

            angular.forEach(vm.dashboardModel.session_usage_by_count, function(usageBySessionCount) {
                vm.usageBySessionCount.xAxis.categories.push(usageBySessionCount.name);
                vm.usageBySessionCount.series[0].data.push(usageBySessionCount.count);
            });

            angular.forEach(vm.dashboardModel.session_usage_by_duration, function(usageBySessionDuration) {
                vm.usageBySessionDuration.xAxis.categories.push(usageBySessionDuration.name);
                vm.usageBySessionDuration.series[0].data.push(usageBySessionDuration.count);
            });

            vm.loadingData = false;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            var resource = angular.isDefined(workspaceId) ? Workspace.getSessionDashboard({
                id: workspaceId
            }).$promise : Report.getSessionDashboard().$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess();
                });
        }

        vm.getCount = function(metricsName) {
            if (metricsName == 'avg_rating') {
                return vm.dashboardModel.avg_rating;
            } else {
                return 5;
            }

        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsSessionToolbarController', InsightsSessionToolbarController);

    /* @ngInject */
    function InsightsSessionToolbarController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        var lessThan3Day = new Date();
        lessThan3Day.setDate(lessThan3Day.getDate() - 2);
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.customTemplates = [{
            name: 'Last 3 Days',
            dateStart: lessThan3Day,
            dateEnd: new Date(),
        }];

        vm.pickerModel = {
            selectedTemplate: 'Last 3 Days'
        };

        vm.loadingData = true;

        vm.loadAll = loadAll;
        function loadAll() {
            vm.loadingData = false;
        };

        vm.toggleSideMenu = function() {
            $scope.$emit('toggleSideMenu', 'toggle');
        };

        vm.emailSessionSummaryReport = function() {
            $mdDialog.show({
                templateUrl: 'modules/session/session-summary-report.tmpl.html',
                clickOutsideToClose: true,
                controller: "sessionSummaryReportController",
                controllerAs: "vm",
            }).then(function(result) {

            });
        }
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsMetricsController', InsightsMetricsController);

    /* @ngInject */
    function InsightsMetricsController($scope, $q, $translate, $filter, Report, CONTENT_META, triSettings, Workspace, workspaceId) {
        var vm = this;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.loadingData = false;
        vm.dashboardModel = null;
        vm.illustartionEmptyScreenId = "insight_graph";


        vm.loadData = function() {
            vm.loadingData = false;
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsMenuController', InsightsMenuController);

    /* @ngInject */
    function InsightsMenuController($scope, $state, $mdDialog, $mdPanel, Team, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature) {
        var vm = this;

        vm.loadingData = true;
        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.activeLink = $state.current.name;

        vm.goToWorkspaces = function() {
            $state.go("storm.admin-workspaces");
        };

        function loadAll() {
            vm.loadingData = false;
        };
        vm.loadAll();

        $scope.$on('$destroy', function() {
            $scope.$emit('toggleSideMenu', 'reset');
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsDataController', InsightsDataController);

    /* @ngInject */
    function InsightsDataController($scope, $q, $translate, $filter, Report, CONTENT_META, triSettings, Workspace, workspaceId) {
        var vm = this;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.loadingData = false;
        vm.dashboardModel = null;
        vm.illustartionEmptyScreenId = "insight_graph";


        vm.loadData = function() {
            vm.loadingData = false;
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsDashboardsController', InsightsDashboardsController);

    /* @ngInject */
    function InsightsDashboardsController($rootScope, $scope, triTheming, triSettings, $window, $state, 
        Dashboard, ParseLinks, AlertService, pagingParams, paginationConstants, $mdDialog, $mdToast, 
        $stateParams, Feature, $filter, ToastService, workspaceId, Workspace, Principal) {
        var vm = this;

        vm.workspaceId = workspaceId;
        vm.loadingData = false;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.getQueryString = getQueryString;
        vm.insightSettings = Workspace.getInsightSettings();

        vm.createObject = createObject;
        vm.editObject = editObject;
        vm.deleteObject = deleteObject;
        vm.launchDashboard = launchDashboard;
        vm.canLaunchDashboard = canLaunchDashboard;
        vm.isLegacyDashboard = isLegacyDashboard;
        vm.primaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value
        );
        vm.secondaryBackgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().secondary_color, '500').value
        );

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.reOrder = reOrder;
        vm.illustartionEmptyScreenId = "dashboard";

        vm.permissions = {
            create: 'create-dashboard',
            update: 'update-dashboard',
            delete: 'delete-dashboard',
            manage: 'manage-dashboard'
        };

        vm.query = {
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1,
            filters: {
                searchText: '',
                system: true,
                createdByMe: true,
                enabled: true
            }
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        function loadAll() {
            vm.loadingData = true;
            Dashboard.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder(),
                query: getQueryString()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.loadingData = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dashboards = data;
                vm.page = pagingParams.page;

                processData();
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function processData() {
            angular.forEach(vm.dashboards, function(dashboard) {
                if (dashboard.status == 'DRAFT') {
                    dashboard.active = false;
                } else {
                    dashboard.active = true;
                }
            });
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.reverse = !vm.reverse;
            vm.transition();
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function transition() {
            vm.promise = Dashboard.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.dashboards = data;
                processData();
            });
        };

        function getQueryString() {
            var query = "deleted==false";
            if(vm.query.filters.searchText.length > 0) {
                query = query + ";name=re=" + vm.query.filters.searchText;
            }

            if(vm.query.filters.system || vm.query.filters.createdByMe || vm.query.filters.enabled) {
                var typeQuery = "(";

                if(vm.query.filters.system) {
                    typeQuery = typeQuery + "type==System";
                }

                if(typeQuery.length > 1 && vm.query.filters.createdByMe) {
                    typeQuery = typeQuery + ",";
                }

                if(vm.query.filters.createdByMe) {
                    typeQuery = typeQuery + "created_by==" + Principal.getUserLogin();
                }

                if(typeQuery.length > 1 && vm.query.filters.enabled) {
                    typeQuery = typeQuery + ",";
                }

                if(vm.query.filters.enabled) {
                    typeQuery = typeQuery + "enabled==" + vm.query.filters.enabled;
                }

                typeQuery = typeQuery + ")";

                if(query.length > 0) {
                    query = query + ";" + typeQuery;
                } else {
                    return typeQuery;
                }
            }

            return query;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        };

        vm.getDefaultBackground = function() {
            return '#bdbec0';
        };

        vm.back = function() {
            $window.history.back();
        };

        function createObject() {
            $mdDialog.show({
                animation: true,
                templateUrl: 'modules/insights/insights-dashboard-detail-dialog.html',
                controller: 'InsightsDashboardDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            name: null
                        };
                    }
                }
            }).then(function() {
                resetModal();
            });
        };

        function editObject(dashboardId) {
            $state.go("storm.insights.dashboard-detail", {
                'id': dashboardId
            });
        }

        function isLegacyDashboard(dashboard) {
            return (dashboard.type == 'System' && dashboard.dashboard_no < 10000);
        }

        function canLaunchDashboard(dashboard) {
            return (isLegacyDashboard(dashboard) || (dashboard.insights && dashboard.insights.length > 0));
        }

        function launchDashboard(dashboard, mode) {
            if(isLegacyDashboard(dashboard)) {
                if(dashboard.dashboard_no == 1000) {
                    $state.go("storm.insights.workspace-summary",{
                        id: dashboard.id
                    });    
                } else if(dashboard.dashboard_no == 1001) {
                    $state.go("storm.insights.conversations",{
                        id: dashboard.id
                    });    
                } else if(dashboard.dashboard_no == 1002) {
                    $state.go("storm.insights.contents",{
                        id: dashboard.id
                    });    
                } else if(dashboard.dashboard_no == 1003) {
                    $state.go("storm.insights.topics",{
                        id: dashboard.id
                    });    
                } else if(dashboard.dashboard_no == 1004) {
                    $state.go("storm.insights.sessions",{
                        id: dashboard.id
                    });    
                } else if(dashboard.dashboard_no == 1005) {
                    $state.go("storm.insights.airforms",{
                        id: dashboard.id
                    });    
                } else if(dashboard.dashboard_no == 1006) {
                    $state.go("storm.insights.users",{
                        id: dashboard.id
                    });    
                }
            } else {
                //console.log('Edit dashboard: ' + dashboard.dashboard_id + ', workspace: ' + vm.insightSettings.workspaceId + ', mode: ' + mode);
                $state.go("storm.insights.dashboard-view", {
                    'dashboardId': dashboard.dashboard_id,
                    'workspaceId': vm.insightSettings.workspaceId,
                    'id': dashboard.id,
                    'dashboardmode': mode
                });
            }
        }

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.insights.dashboard.delete.question'))
                .ariaLabel($filter('translate')('atheer.insights.dashboard.delete.question'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Dashboard.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                },function(error) {
                    var errorMessage;
                    if(error.data.description && error.data.description != '') {
                        errorMessage = error.data.description;
                    } else {
                        errorMessage = $filter('translate')('atheer.insights.dashboard.errorDeletingDashboard');
                    }
                    var errorWindow = $mdDialog.alert()
                        .title(errorMessage)
                        .ok('Close');
                    $mdDialog.show(errorWindow);
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        var refreshDashboardListener = $rootScope.$on('refreshDashboards', function(event, filter) {
            if(filter.hasOwnProperty("searchText")) {
                vm.query.filters.searchText = filter.searchText;
            }

            if(filter.hasOwnProperty("system")) {
                vm.query.filters.system = filter.system;
            }

            if(filter.hasOwnProperty("createdByMe")) {
                vm.query.filters.createdByMe = filter.createdByMe;
            }

            if(filter.hasOwnProperty("enabled")) {
                vm.query.filters.enabled = filter.enabled;
            }
            
            loadAll();
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshDashboardListener();
        });

        loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsDashboardsToolbarController', InsightsDashboardsToolbarController);

    /* @ngInject */
    function InsightsDashboardsToolbarController($rootScope, $scope, $state, $mdDialog, Dashboard, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.showNewDashboardMenu = false;
        vm.advInsightsDashboardEnabled = isAdvInsightsEnabled;

        vm.query = {
            searchText: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;

        vm.permissions = {
            create: 'create-dashboard',
            update: 'update-dashboard',
            delete: 'delete-dashboard',
            manage: 'manage-dashboard'
        };

        function isAdvInsightsEnabled() {
            var isActive = Feature.isActive('feature_adv-insights_enabled');
            console.log('vm.advInsightsDashboardEnabled = ' + isActive);
            return isActive;
        }

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        function refreshAll() {
            $scope.$emit('refreshDashboards', vm.query);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.searchText = '';
            $scope.$emit('refreshDashboards', vm.query);
        };

        vm.createDashboard = function() {
            $state.go("storm.insights.dashboard-detail");
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsDashboardsMenuController', InsightsDashboardsMenuController);

    /* @ngInject */
    function InsightsDashboardsMenuController($scope, $state, $mdDialog, $mdPanel, Team, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature) {
        var vm = this;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.advInsightsDashboardEnabled = Feature.isActive('feature_adv-insights_enabled');

        vm.permissions = {
            create: 'create-dashboard',
            update: 'update-dashboard',
            delete: 'delete-dashboard',
            manage: 'manage-dashboard',
            system: "system-dashboard"
        };

        vm.filters = {
            system: true,
            createdByMe: true,
            enabled: true
        };

        vm.updateFilters = function() {
            $scope.$emit('refreshDashboards', vm.filters);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsDashboardViewController', InsightsDashboardViewController);

    /* @ngInject */
    function InsightsDashboardViewController($scope, $q, $filter, $translate, Report, Workspace, triSettings,
        $window, $stateParams, BuildLanguages, $location, $sce, Setting, AlertService, Insight, triLoaderService) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.advInsights = null;
            //console.log('Loading insights viewer with state: ' + JSON.stringify($stateParams))
        var dashboardId = $stateParams.dashboardId;
        var dashboardMode = $stateParams.dashboardmode;
        var apiKey = null;

        function setNgxPageUrl() {
            $q.all([
                Workspace.getInsightSettings().$promise
            ]).then(function(results) {
                vm.advInsights = results[0];
                //console.log('Insight settings: ' + JSON.stringify(vm.advInsights));
                var ngxUrl = null;
                var regexSubdomainPattern = /\.atheer\.my$/ig;
                var hostUrl = vm.advInsights.hostUri;
                var workspaceId = vm.advInsights.workspaceId;
                apiKey = dashboardMode == 'view' ? vm.advInsights.viewApiKey : vm.advInsights.manageApiKey;
                var hideControls = dashboardMode == 'view' ? '[deleteButton,saveAsButton]' : '[deleteButton,saveAsButton,shareButton]';

                ngxUrl = hostUrl + '/dashboards/embedded/#/workspace/' + workspaceId 
                    + '/dashboard/' + dashboardId 
                    + '?showNavigation=false'
                    + '&showEmbedButton=false'
                    + '&apiTokenAuthentication=true'
                    + '&hideControl=' + hideControls
                //console.log('setNgxPageUrl 2: ' + ngxUrl);
                
                vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
                triLoaderService.setLoaderActive(false);
            }).catch(function(data) {}).finally(function() {});

        }

        function handleNgxEvent(event) {
            //console.log('Loading dashboard view with: ' + JSON.stringify(event));
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;

                if (id == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                } else {
                    $state.transitionTo(
                        ngState, {
                            id: id
                        }, {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        }
                    );
                }
            } else if(event.data.navigate) {
                $state.transitionTo(
                    ngState, {
                        id: event.data.navigate.toState
                    },{
                        id: event.data.navigate.id, 
                        workspaceId: event.data.navigate.workspaceId, 
                        dashboardId: event.data.navigate.dashboardId,
                        dashboardmode: 'view'
                    }
                );
            }
        }

        function handleApiTokenRequest(event) {
            //console.log("Post message received", JSON.stringify(event));
            if (event.data.gdc && event.data.gdc.event.name === "listeningForApiToken") {
                const postMessageStructure = {
                    gdc: {
                        product: "dashboard",
                        event: {
                            name: "setApiToken",
                            data: {
                                token: apiKey
                            }
                        }
                    }
                };
                //console.log("Sending token to embedded window: " + JSON.stringify(postMessageStructure));
                const origin = "*";
                const iframe = document.getElementById("insight-view-frame").contentWindow;
                iframe.postMessage(postMessageStructure, origin);
            }

            if(event.data.gdc && event.data.gdc.product === 'analyticalDesigner' && event.data.gdc.event.name === 'visualizationSaved') {
                Insight.syncAllInsights();
            }

            if(event.data.navigate) {
                handleNgxEvent(event);
            }
        }

        window.addEventListener("message", handleApiTokenRequest,false);

        setNgxPageUrl();

        

        $scope.$on('$destroy', function() {
            window.removeEventListener('message', handleApiTokenRequest, false);
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsDashboardDetailDialogController', InsightsDashboardDetailDialogController);

    /* @ngInject */
    function InsightsDashboardDetailDialogController($scope, $stateParams,Feature, $mdDialog, entity, Dashboard) {
        var vm = this;
        vm.dashboard = entity;
        vm.isSavingError = false;
        vm.errorMessage = '';

        var onSaveSuccess = function(result) {
            $scope.$emit('updateDashboardList', result);
            $mdDialog.hide(result);
            vm.isSaving = false;
        };

        var onSaveError = function(err) {
            vm.isSaving = false;
            vm.isSavingError = true;
            if(err) {
                var obj = err.headers();
                vm.errorMessage = obj['x-atheer-error-message'];
            }
        };

        vm.save = function() {
            vm.isSaving = true;
            Dashboard.save(vm.dashboard, onSaveSuccess, onSaveError);
        };

        vm.clear = function() {
            $mdDialog.hide();
        };

        vm.dynamicTitle = null !== vm.dashboard.id ? 'atheer.insights.dashboard.editLabel' : 'atheer.insights.dashboard.createLabel';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsConversationController', InsightsConversationController);

    /* @ngInject */
    function InsightsConversationController($scope, $q, $translate, $filter, Report, CONTENT_META, triSettings, Workspace, workspaceId) {
        var vm = this;

        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        vm.loadingData = false;
        vm.dashboardModel = null;
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.topUsersByConversationCount = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.conversations.topUsersByConversationCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.conversations.noOfConversations')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.conversations.title'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.topUsersByMessageCount = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.conversations.topUsersByMessagCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.conversations.noOfMessages')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.conversations.messages'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.messageUsageByDay = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.conversations.messagesPerDay')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.conversations.noOfMessages')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.dates'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            vm.dashboardModel.avg_messages_per_conversation = Math.ceil(vm.dashboardModel.avg_messages_per_conversation);
            angular.forEach(vm.dashboardModel.top_users_by_conversation_count, function(topUsersByConversationCount) {
                vm.topUsersByConversationCount.xAxis.categories.push(topUsersByConversationCount.name);
                vm.topUsersByConversationCount.series[0].data.push(topUsersByConversationCount.count);
            });

            angular.forEach(vm.dashboardModel.top_users_by_message_count, function(topUsersByMessageCount) {
                vm.topUsersByMessageCount.xAxis.categories.push(topUsersByMessageCount.name);
                vm.topUsersByMessageCount.series[0].data.push(topUsersByMessageCount.count);
            });

            angular.forEach(vm.dashboardModel.message_usage_by_day, function(messageUsageByDay) {
                vm.messageUsageByDay.xAxis.categories.push(messageUsageByDay.name);
                vm.messageUsageByDay.series[0].data.push(messageUsageByDay.count);
            });

            vm.loadingData = false;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            var resource = angular.isDefined(workspaceId) ? Workspace.getConversationDashboard({
                id: workspaceId
            }).$promise : Report.getConversationDashboard().$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess();
                });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsContentController', InsightsContentController);

    /* @ngInject */
    function InsightsContentController($scope, $q, $filter, $translate, Report, CONTENT_META, triSettings, Workspace, workspaceId) {
        var vm = this;

        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        vm.contentDashboard = null;
        vm.loadingData = false;
        vm.illustartionEmptyScreenId = "insight_graph";
        vm.getContentMeta = function(content_type) {
            var contentMeta = angular.copy($filter('filter')(CONTENT_META, {
                type: content_type.toLowerCase().replace(/_/g, '-')
            })[0]);

            return contentMeta;
        }

        vm.contentViewsChartData = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.content.views')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.content.noOfViews')
                }
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.dates')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.content.views'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> ' + $translate.instant('atheer.insights.content.views') + ' : ' + this.y;
                }
            }
        };

        vm.contentCreatedChartData = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.content.contentCreated')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.content.noOfContent')
                }
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.dates'),
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.content.contentCreated'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> ' + $translate.instant('atheer.insights.content.created') + ' : ' + this.y;
                }
            }
        };

        vm.contentTimeSpentChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $translate.instant('atheer.insights.content.timeSpent')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.minutes')
                },
                labels: {
                    formatter: function() {
                        var seconds = (this.value / 1000).toFixed(0);
                        var minutes = (seconds / 60).toFixed(2);
                        return minutes;
                    }
                }

            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.dates')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.content.avgTimeSpent'),
                data: [],
                color: '#82B1FF'
            }, {
                name: $translate.instant('atheer.insights.content.totalTimeSpent'),
                data: [],
                color: vm.primaryColor,
            }],
            tooltip: {
                formatter: function() {
                    var seconds = (this.y / 1000).toFixed(0);
                    var minutes = (seconds / 60).toFixed(2);
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> ' + $translate.instant('atheer.insights.content.timeSpent') + ' : ' + minutes + ' minutes';
                }
            }
        };

        vm.contentTypeBarChartData = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.content.contentType')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.content.noOfContent')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: false
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{ 
                name: $translate.instant('atheer.insights.content.total'),
                color: vm.primaryColor,
                data: []
            }, {
                name: $translate.instant('atheer.insights.content.featured'),
                color: "#d62728",
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.data = {
            "device_types_metrics": {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: 0,
                    plotShadow: false
                },
                title: {
                    text: 'Content View by Devices'
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                    pie: {
                        dataLabels: {
                            enabled: true,
                            distance: -50,
                            style: {
                                fontWeight: 'bold',
                                color: 'white'
                            }
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    type: 'pie',
                    name: 'Device usage',
                    innerSize: '50%',
                    data: []
                }]
            },
            "content_table_data": [{
                label: "Top Rated",
                data: []
            }, {
                label: "Most Viewed",
                data: []
            }, {
                label: "Most Liked",
                data: []
            }, {
                label: "Most Pinned",
                data: []
            }, {
                label: "Most Recommended",
                data: []
            }]
        }

        vm.getCount = function(activityName) {
            for (var i = 0; i < vm.contentDashboard.metrics.length; i++) {
                if (vm.contentDashboard.metrics[i].name === activityName) {
                    return vm.contentDashboard.metrics[i].count;
                }
            }
            return 0;
        }

        function getDateFromItem(item) {
            return item.x;
        }

        function performDataProcess() {
            //Msot Pinned/Popular/Liked/Viewed Data Process
            vm.data.content_table_data[0].data = vm.contentDashboard.top_rated;
            vm.data.content_table_data[1].data = vm.contentDashboard.most_liked;
            vm.data.content_table_data[2].data = vm.contentDashboard.most_pinned;
            vm.data.content_table_data[3].data = vm.contentDashboard.most_viewed;
            vm.data.content_table_data[3].data = vm.contentDashboard.most_recommended;

            //Content Created Line Char Data Process
            angular.forEach(vm.contentDashboard.history.content_created, function(contentCreatedObj) {
                vm.contentCreatedChartData.xAxis.categories.push(contentCreatedObj.name);
                vm.contentCreatedChartData.series[0].data.push(contentCreatedObj.count);
            });

            //Content Created Line Char Data Process
            angular.forEach(vm.contentDashboard.history.view, function(contentview) {
                vm.contentViewsChartData.xAxis.categories.push(contentview.name);
                vm.contentViewsChartData.series[0].data.push(contentview.count);
            });

            //set average time spent Data
            angular.forEach(vm.contentDashboard.history.avg_time_spent, function(timeSpentObj) {
                vm.contentTimeSpentChartData.xAxis.categories.push(timeSpentObj.name);
                vm.contentTimeSpentChartData.series[0].data.push(timeSpentObj.count);
            });

            //set total time spent Data
            angular.forEach(vm.contentDashboard.history.total_time_spent, function(timeSpentObj) {
                vm.contentTimeSpentChartData.xAxis.categories.push(timeSpentObj.name);
                vm.contentTimeSpentChartData.series[1].data.push(timeSpentObj.count);
            });

            //Content Bar Chart Data Process
            angular.forEach(vm.contentDashboard.type_metrics, function(contentTypeObj) {
                var featureObj = $filter('filter')(vm.contentDashboard.featured_metrics, {
                    name: contentTypeObj.name
                })[0];

                var contentMeta = vm.getContentMeta(contentTypeObj.name);

                vm.contentTypeBarChartData.xAxis.categories.push($translate.instant(contentMeta.label));
                vm.contentTypeBarChartData.series[0].data.push(contentTypeObj.count);
                vm.contentTypeBarChartData.series[1].data.push(featureObj ? featureObj.count : 0);

            });

            //device metrics
            var browserCount = $filter('filter')(vm.contentDashboard.device_metrics, {
                    name: 'browser'
                })[0],
                mobileCount = $filter('filter')(vm.contentDashboard.device_metrics, {
                    name: 'mobile'
                })[0],
                tabletCount = $filter('filter')(vm.contentDashboard.device_metrics, {
                    name: 'tablet'
                })[0]

            vm.data.device_types_metrics.showDeviceChart = browserCount || tabletCount || mobileCount;

            browserCount ? vm.data.device_types_metrics.series[0].data.push({
                name: 'Browser',
                y: browserCount.count,
                color: '#82B1FF'
            }) : angular.noop();
            tabletCount ? vm.data.device_types_metrics.series[0].data.push({
                name: 'Tablet',
                y: tabletCount.count,
                color: '#d62728'
            }) : angular.noop();
            mobileCount ? vm.data.device_types_metrics.series[0].data.push({
                name: 'Mobile',
                y: mobileCount.count,
                color: '#1f77b4'
            }) : angular.noop();

        }

        vm.loadData = function() {
            vm.loadingData = true;

            var resource = angular.isDefined(workspaceId) ? Workspace.getContentDashboard({
                id: workspaceId
            }).$promise : Report.getContentDashboard().$promise;

            $q.all([
                resource
            ]).then(function(data) {
                vm.contentDashboard = data[0];
                performDataProcess();
                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});
        }
        vm.loadData();
    }
})();;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsAnalyzeController', InsightsAnalyzeController);

    /* @ngInject */
    function InsightsAnalyzeController($scope, $q, $translate, $filter, $sce, Report, CONTENT_META, triSettings, Workspace, workspaceId, Insight) {
        var vm = this;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.ngxUrlTrusted = null;
        vm.insightsSettings = null;
        var apiKey = null;

        function setNgxPageUrl() {
            $q.all([
                Workspace.getInsightSettings({
                    id: workspaceId
                }).$promise
            ]).then(function(results) {
                vm.insightsSettings = results[0];
                //console.log('Insight settings: ' + JSON.stringify(vm.insightsSettings));
                var ngxUrl = null;
                var regexSubdomainPattern = /\.atheer\.my$/ig;
                var hostUrl = vm.insightsSettings.hostUri;
                apiKey = vm.insightsSettings.manageApiKey;

                ngxUrl = hostUrl + '/analyze/embedded/#/' + vm.insightsSettings.workspaceId + '/reportId/edit?apiTokenAuthentication=true';
                vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
            }).catch(function(data) {}).finally(function() {});
        }

        function handleApiTokenRequest(event) {
            //console.log("Post message received", JSON.stringify(event));
            if (event.data.gdc && event.data.gdc.event.name === "listeningForApiToken") {
                const postMessageStructure = {
                    gdc: {
                        product: "analyticalDesigner",
                        event: {
                            name: "setApiToken",
                            data: {
                                token: apiKey
                            }
                        }
                    }
                };
                //console.log("Sending token to embedded window");
                const origin = "*";
                const iframe = document.getElementById("insight-analyze-frame").contentWindow;
                iframe.postMessage(postMessageStructure, origin);
            }

            if(event.data.gdc && event.data.gdc.product === 'analyticalDesigner' && event.data.gdc.event.name === 'visualizationSaved') {
                Insight.syncAllInsights();
            }
        }

        setNgxPageUrl();

        window.addEventListener("message", handleApiTokenRequest,false);

        $scope.$on('$destroy', function() {
            window.removeEventListener('message', handleApiTokenRequest, false);
        });
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.insights")
        .controller("InsightsAirformController", InsightsAirformController);

    /* @ngInject */
    function InsightsAirformController(
        $scope,
        $q,
        $filter,
        Report,
        CONTENT_META,
        Workspace,
        workspaceId,
        $translate
    ) {
        var vm = this;
        vm.loadingData = false;

        vm.dashboardModel = [
            {
                columns: [
                    {
                        name: "total_active_airforms",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalActiveAirForms'),
                    },
                    {
                        name: "total_scheduled_airforms",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalScheduledAirForms'),
                    },
                    {
                        name: "total_draft_airforms",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalDraftAirforms'),
                    },
                    {
                        name: "total_archived_airforms",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalArchivedAirForms'),
                    },
                ],
            },
            {
                columns: [
                    {
                        name: "total_jobs_completed_in_last_30_days",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalJobs30Days'),
                    },
                    {
                        name: "total_jobs_completed_in_last_7_days",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalJobs7Days'),
                    },
                    {
                        name: "total_jobs_in_progress",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalJobsInProgress'),
                    },
                    {
                        name: "total_jobs_aborted_in_last_30_days",
                        count: 0,
                        title: $translate.instant('atheer.insights.airForms.totalJobsAborted'),
                    },
                ],
            },
        ];

        function performDataProcess() {
            vm.loadingData = false;
        }

        vm.getCount = function (columnName) {
            for (var k = 0; k < vm.dashboardModel.length; k++) {
                for (var l = 0; l < vm.dashboardModel[k].columns.length; l++) {
                    if (vm.dashboardModel[k].columns[l].name === columnName) {
                        return vm.dashboardModel[k].columns[l].count;
                    }
                }
            }
        };

        vm.setModel = function (result) {
            for (var i = 0; i < vm.dashboardModel.length; i++) {
                for (var j = 0; j < vm.dashboardModel[i].columns.length; j++) {
                    for (var key in result) {
                        if (key == vm.dashboardModel[i].columns[j].name) {
                            vm.dashboardModel[i].columns[j].count = result[key];
                            break;
                        }
                    }
                }
            }
        };
        vm.loadData = function () {
            vm.loadingData = true;
            var resource = angular.isDefined(workspaceId)
                ? Workspace.getAirformDashboard({
                      id: workspaceId,
                  }).$promise
                : Report.getAirformDashboard().$promise;

            $q.all([resource]).then(function (results) {
                vm.setModel(results[0]);
                performDataProcess();
            });
        };
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightPickerController', InsightPickerController);

    /* @ngInject */
    function InsightPickerController($scope, $state, triSettings, $mdDialog, Dashboard, Feature, Folder, ParseLinks, AlertService, ContentAction, $mdToast, $filter, CONTENT_META, filter, selectedInsights, allowMultiSelect, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.pageTitleKey = $filter('translate')('autoComplete.contentPicker.content');
        vm.predicate = "name";
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.showFolders = false;
        vm.selected = [];
        vm.allowMultiSelect = allowMultiSelect;
        vm.currentSelectedCards = selectedInsights;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.getQueryString = getQueryString;

        vm.defaultFolder = {
            id: "default",
            name: "Default",
            description: "Default"
        };

        vm.selectedFolder = vm.defaultFolder;


        function loadAll() {
            vm.loadingData = true;
            //console.log('selected insights: ' + vm.currentSelectedCards);
            Dashboard.insights({
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                query: getQueryString(),
                is_web: vm.isWeb,
                is_not_filter: vm.isNotFilter
            }, onSuccess, onError);

            function sort() {
                return ['name' + ',' + 'asc'];
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                vm.loadingData = false;
                AlertService.error(error.data.message);
            }
        }

        vm.getMediaUrl = function(mediaUrl){
            return $filter('mediaUrl')(mediaUrl);
        }

        vm.selectFolder = function(folder) {
            vm.updateObject = false;
            vm.selectedFolder = folder;
            vm.loadAll();
        }

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        }

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        }

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        }

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
            if (vm.filter.show) {
                vm.showFolders = false;
            }
        }

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedCards);
        }

        vm.close = function() {
            //console.log('vm.currentSelectedCards ' + vm.currentSelectedCards);
            $mdDialog.cancel();
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Dashboard.insights({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: getSortOrder(),
                query: getQueryString(),
                is_web: vm.isWeb,
                is_not_filter: vm.isNotFilter
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.contents = data;
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            var contentQuery = filter;
            if (vm.query.filter.length <= 0) {
                vm.query.filter = '';
            }

            var quoteEscapedStr = String(vm.query.filter).replace(/([\\"])/g, '\\$1');
                return 'name=re="' + quoteEscapedStr + '"';

            return contentQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function resetModal() {
            loadAll();
            vm.showFolders = false;
            AlertService.displayToast($mdToast);
        };
        vm.loadAll();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightDashboardDetailController', InsightDashboardDetailController)

    /* @ngInject */
    function InsightDashboardDetailController($scope, $mdDialog, $filter, $q, id, MetaData, Dashboard, ContentAction, 
        CONTENT_META, $state, AlertService, $mdToast, $mdSidenav, Content, Team, AirForm, User, ParseLinks, $timeout, 
        pagingParams, paginationConstants, $stateParams, $window, ToastService, launchMode) {
        var vm = this;

        var FORMLY_ATHEER_DATA_TYPE_MAPPING = {
            'BOOLEAN': 'boolean-switch',
            'STRING': 'input',
            'LIST': 'custom-select',
            'DATE': 'custom-datepicker',
            'DATETIME': 'datepicker',
            'NUMBER': 'input',
            'DECIMAL': 'input',
            'OBJECT': 'objectpicker',
            'ARRAY': 'custom-chips'
        };

        var FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING = {
            'STRING': 'text',
            'NUMBER': 'number',
            'DECIMAL': 'number'
        };

        vm.loadingData = false;
        vm.loadingInsights = false;
        vm.insights = [];
        vm.dashboardDataModel = null;
        vm.audiences = [];
        vm.owner = null;
        vm.isHovered = false;
        vm.topicMeta = null;
        vm.topicMetaFields = [];
        vm.show_scheduling = true;
        vm.show_audiences = true;
        vm.tabView = 'insights';
        vm.insightsPage = [];
        vm.insightsQueryCount = 0;

        vm.dashboardDataModel = {
            name: '',
            description: '',
        };
        vm.getDataModel = function() {
            return vm.dashboardDataModel;
        }

        if (angular.isDefined($stateParams.topicType) && $stateParams.topicType != null) {
            vm.topicType = $stateParams.topicType;
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            page: 1
        };

        vm.isFormValid = function () {
            return (
                vm.dashboardDataModel.name !== undefined &&
                vm.dashboardDataModel.description !== undefined &&
                vm.dashboardDataModel.name.trim() !== ""
            );
        };

        vm.getQueryString = function (criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'name=re=' + criteria;
            }
        };

        vm.loadTeams = function (dashboard) {
            if (dashboard.audiences && dashboard.audiences.length > 0) {
                Team.query({
                    query: 'id=in=(' + dashboard.audiences.toString() + ')',
                }, function (response, headers) {
                    vm.audiences = response;
                });
            }
        };

        vm.goToDashboards = function () {
            if($stateParams.fromHomeTile) {
                $state.go("storm.home");
            } else {
                $state.go("storm.insights.adv-dashboards");
            }
        };

        vm.openInsightPicker = function () {
            $mdDialog.show({
                templateUrl: 'modules/insights/insight-picker.html',
                controller: 'InsightPickerController',
                controllerAs: 'vm',
                locals: {
                    filter: 'embedded==false;type=out=(SERIES,EMAIL_LAYOUT);meta_type==DISCOVERABLE;status!=ARCHIVED',
                    allowMultiSelect: true,
                    selectedInsights: vm.dashboardDataModel.insights
                }
            })
                .then(function (selectedItems) {
                    Dashboard.update(vm.dashboardDataModel, onSaveSuccess, onSaveError);

                    function onSaveSuccess(result) {
                        vm.loadInsights(vm.dashboardDataModel.id);
                        ToastService.displayToast($filter('translate')('atheer.insights.dashboard.addInsightConfirmation'), 3000);
                    };

                    function onSaveError() {

                    };
                });
        };

        vm.removeInsight = function (insightId) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.insights.dashboard.removeInsight'))
                .ariaLabel($filter('translate')('atheer.insights.dashboard.removeInsight'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.insights = vm.insights.filter(function(insight) {return insight.id != insightId});
                //console.log('Remove insight: ' + insightId + ', filtered list: ' + JSON.stringify(vm.insights));
                
                var insightIds = [];
                angular.forEach(vm.insights, function(value, key) {
                    insightIds.push(value.id);
                });
                vm.dashboardDataModel.insights = insightIds;
                
                Dashboard.update(vm.dashboardDataModel, onSaveSuccess, onSaveError);

                function onSaveSuccess(result) {
                    vm.loadAll();
                    ToastService.displayToast($filter('translate')('atheer.insights.dashboard.removeInsightConfirmation'), 3000);
                };

                function onSaveError() {

                };

            }).finally(function () { });
        };

        vm.loadInsights = function (dashboardId) {
            vm.loadingInsights = true;
            Dashboard.getDashboardInsights({
                id: dashboardId
            }, function (result, headers) {
                vm.insights = result;
                vm.loadingInsights = false;
                vm.insightsPage = pagingParams.page;
                vm.insightsQueryCount = headers('X-Total-Count');
            });
        };

        vm.loadAll = function () {

            vm.loadingData = true;

            MetaData.get({
                id: 'topic',
                is_name: true
            }, function (result, headers) {
                angular.forEach(result.field_groups, function (field_group) {
                    if (field_group.name == 'base') {
                        vm.topicMeta = field_group;
                    }
                });
                //console.log('dashboard detail loadAll: ' + JSON.stringify($stateParams));
                if (id) {                    
                    Dashboard.get({
                        id: id
                    }, function (result, headers) {
                        //console.log('Dashboard.get: ' + JSON.stringify(result));
                        vm.dashboardDataModel = result;
                        if(!vm.dashboardDataModel.insights || vm.dashboardDataModel.insights.length == 0) {
                            vm.dashboardDataModel.insights = [];
                        }
                        
                        if (vm.dashboardDataModel.available_from) {
                            vm.dashboardDataModel.available_from = new Date(vm.dashboardDataModel.available_from)
                        }
                        if (vm.dashboardDataModel.discontinue_from) {
                            vm.dashboardDataModel.discontinue_from = new Date(vm.dashboardDataModel.discontinue_from)
                        };

                        vm.loadTeams(vm.dashboardDataModel);
                        vm.loadInsights(id);

                        vm.loadingData = false;
                    });
                    
                } else {
                    vm.loadingData = false;
                }
            });


        };

        vm.save = function () {
            if (vm.audiences && vm.audiences.length > 0) {
                var audienceIds = [];
                angular.forEach(vm.audiences, function (audience) {
                    audienceIds.push(audience.id);
                });
                vm.dashboardDataModel.audiences = audienceIds;
            } else {
                vm.dashboardDataModel.audiences = null;
            }

            if(!vm.dashboardDataModel.type) {
                vm.dashboardDataModel.type = 'Custom';
            }

            if (vm.dashboardDataModel.id) {
                Dashboard.update(vm.dashboardDataModel, onSaveSuccess);
            } else {
                Dashboard.save(vm.dashboardDataModel, onSaveSuccess);
            }

            function onSaveSuccess(result) {
                id = result.id;
                vm.dashboardDataModel = result;
                console.log('onSaveSuccess::vm.dashboardDataModel: ' + JSON.stringify(vm.dashboardDataModel));
                if(!vm.dashboardDataModel.insights || vm.dashboardDataModel.insights.length == 0) {
                    vm.dashboardDataModel.insights = [];
                }
                vm.isSaving = false;
                AlertService.displayToast($mdToast);
            }
        };

        vm.isNew = function () {
            if (vm.dashboardDataModel.id) {
                return false;
            } else {
                return true;
            }
        };

        vm.isSystem = function () {
            if (vm.dashboardDataModel.id && (vm.dashboardDataModel.dashboard_no < 10000 || vm.dashboardDataModel.type == 'System')) {
                return true;
            }
            return false;
        };

        vm.isLaunchMode = function () {
            return launchMode;
        }

        vm.togglePanel = function (componentId) {
            $mdSidenav(componentId).toggle();
        };

        vm.getDefaultBackground = function () {
            return '#bdbec0';
        };

        vm.hideInfo = function () {
            $timeout(function () {
                if (vm.isHovered) {
                    vm.isHovered = false;
                }
            }, 1000);
        };

        function getFormlyField(atheerfield) {
            var formlytype = FORMLY_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyTemplateType = FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyField = {
                type: formlytype ? formlytype : 'input',
                key: atheerfield.name,
                templateOptions: {
                    label: atheerfield.label,
                    required: atheerfield.required
                }
            };
            if (formlytype == "datepicker") {
                formlyField.templateOptions['placeholder'] = $filter('translate')('atheer.about.selectDate');
            }
            if (formlyTemplateType) {
                formlyField.templateOptions['type'] = formlyTemplateType;
            }

            if (atheerfield.data_type == 'DATETIME') {
                formlyField.templateOptions['datepickerPopup'] = "HH:MM";
            }

            if (atheerfield.data_type == 'ARRAY') {
                formlyField.templateOptions['labelProp'] = "label";
                formlyField.defaultValue = [];
            }

            if (atheerfield.data_type == 'LIST') {
                formlyField.templateOptions['labelProp'] = "label";
                formlyField.templateOptions['valueProp'] = "option_id";
                formlyField.templateOptions['options'] = atheerfield.list_options;
            }

            if (atheerfield.data_type == 'OBJECT') {
                if (atheerfield.ref_object == 'Content') {
                    formlyField.templateOptions['objectName'] = 'Content';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'title',
                        operator: '=re='
                    }];
                } else if (atheerfield.ref_object == 'User') {
                    formlyField.templateOptions['objectName'] = 'User';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'text_search',
                        operator: '=ts='
                    }];
                }
            }
            return formlyField;
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('NoAccessController', NoAccessController);

    /* @ngInject */
    function NoAccessController($mdDialog, content, title, isDeeplink) {
        var vm = this;

        vm.content = content;
        vm.title = title;
        vm.isDeeplink = isDeeplink;
        vm.close = function() {
            $mdDialog.cancel();
            if (vm.isDeeplink) {
                window.history.back();
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.home', [
            'ui.carousel'
        ]);
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.home')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.home', {
                url: '/home',
                templateUrl: 'modules/home/home.tmpl.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'global.menu.home',
                    layout: {
                        showSideNavMenu: false,
                        contentClass: 'layout-column',
                        showToolbar: false,
                        footer: false
                    }
                }
            })
            .state('storm.unified-search', {
                url: '/home/search/:id',
                templateUrl: 'modules/home/home.tmpl.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.content.home.title'
                }
            })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.home')
        .controller('HomeController', HomeController);

    /* @ngInject */
    function HomeController(triSettings, Home, Principal, $filter, Session, $state, triTheming, User, $mdDialog, $rootScope, PermissionService, Feature, deviceDetector, Experience, SessionsService, Auth, AuthServerProvider, $sce, $window, $scope, $location, ToastService) {
        var vm = this;

        vm.isLoading = false;
        vm.isIFrameDataLoaded = true;
        vm.userInfo = {};
        vm.homeData = {};
        vm.welcomeMsg = "";
        vm.formattedDate = "";
        vm.upcomingSessions = [];
        vm.jobs = [];
        vm.isSessionsLoading = false;
        vm.isJobsLoading = false;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        vm.backgroundColor = triTheming.rgba(triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value);
        vm.isMobileBrowser = deviceDetector.isMobile();
        vm.isConfigurableHomeEnabled = Feature.isActive('feature_system_enable_configurable_home_page');
        vm.isPublicUser = false;
        vm.triSettings = triSettings;
        vm.deviceUserPermissions = {};
        vm.pageName = 'Home';


        vm.sessionQuery = {
            page: 0,
            size: 3
        };

        vm.jobquery = {
            page: 0,
            size: 3
        };

        function loadData() {
            vm.isLoading = true;
            vm.isPublicUser = Auth.isPublicUser();
            if (vm.isPublicUser) {
                if (!sessionStorage.getItem('Authorization')) {
                    AuthServerProvider.getPublicUserToken().then(function () {
                        Principal.identity(true).then(function () {
                            getHomePageData();
                        })

                    })
                } else {
                    Principal.identity(true).then(function () {
                        getHomePageData();
                    })
                }
            } else {
                getHomePageData();
            }

        };

        function getHomePageData() {
            Home.query({
                query: "web==true"
            }, function (res) {
                handleHomePageData(res);
            }, function (err) {
            })
        }

        function handleHomePageData(res) {
            if ($rootScope.showAlertMessageFor) {
                var content = $rootScope.showAlertMessageFor == 'session' ? 'home.noAccessForSessions' :
                    ($rootScope.showAlertMessageFor == 'jobs' ? 'home.noAccessForJobs' : 'home.noAccessForConversation');
                $rootScope.showAlertMessageFor = '';
                $mdDialog.show({
                    templateUrl: 'modules/home/no-access-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: 'NoAccessController',
                    controllerAs: 'vm',
                    locals: {
                        content: content,
                        title: 'home.permissionError'
                    }
                });
            }
            vm.homeData = res;
            setPermissionsAndFeatures();
            var date = new Date();
            vm.userInfo = Principal.getUserInfo();
            vm.welcomeMsg = $filter('translate')('home.hello') + vm.userInfo.first_name;
            vm.formattedDate = getFormattedDate(date);
            document.documentElement.style.setProperty('--primary-color', triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value);
            document.documentElement.style.setProperty('--secondary-color', triTheming.getPaletteColor(triSettings.getSkinModel().secondary_color, '500').value);

            vm.homeData.home_screen_tiles = getSortedHomeScreenTiles(res);
            vm.homeData.carouselData = getCarouselData(res);

            if (vm.isPublicUser) {

            } else {
                vm.upcomingSessions = res.home_screen_tiles[0].tile_data_elements[0].sessions;
                vm.jobs = res.home_screen_tiles[1].tile_data_elements[0].jobs;

                vm.sessionQuery.page = res.home_screen_tiles[0].tile_data_elements[0].page_number;
                vm.sessionQuery.size = res.home_screen_tiles[0].tile_data_elements[0].page_size;

                vm.jobquery.page = res.home_screen_tiles[1].tile_data_elements[0].page_number;
                vm.jobquery.size = res.home_screen_tiles[1].tile_data_elements[0].page_size;
            }



            getDay();
            vm.isLoading = false;
        }

        function getCarouselData(data) {
            var carouselData = [];
            if (data.announcements_count > 0 && Feature.isActive('feature_content_announcement')) {
                angular.forEach(data.announcements, function (announcement) {
                    announcement.dismiss = function () {
                        Experience.markViewed({
                            object: {
                                id: announcement.id
                            },
                            user_id: vm.userInfo.id
                        }, function (res) {
                            var updatedCarouselData = vm.homeData.carouselData.filter(function (value) {
                                return value.id != res.object.id;
                            });
                            vm.homeData.carouselData = updatedCarouselData;
                        }, function (err) {
                        });
                    };
                    announcement.getImageSrc = function (data) {
                        return data.show_media ? '/media/images/' + data.media_id : 'assets/images/card/announcement.svg';
                    };
                    announcement.getTitleHeight = function (data) {
                        const title = document.getElementById('fp-announcement-title-' + data.id);
                        return title && title.clientHeight;
                    };
                    announcement.isAnnouncement = true;
                    carouselData.push(announcement);
                });
            }
            if (Feature.isActive('feature_content_did_you_know') && data.did_you_know) {
                data.did_you_know.data.content = '<p>' + data.did_you_know.data.content + '</p>';
                data.did_you_know.isAnnouncement = false;
                data.did_you_know.getImageSrc = function (data) {
                    return data.show_media ? '/media/images/' + data.media_id : 'assets/images/card/announcement.svg';
                };
                data.did_you_know.getTitleHeight = function (data) {
                    const title = document.getElementById('fp-announcement-title-' + data.id);
                    return title && title.clientHeight;
                };
                carouselData.push(data.did_you_know);
            }
            return carouselData;
        };

        function getSortedHomeScreenTiles(data) {
            var sortedHomeScreenTiles = [];
            angular.forEach(data.home_screen_tiles, function (tile) {
                if (tile.name == 'air_sessions') {
                    sortedHomeScreenTiles[0] = tile;
                } else if (tile.name == 'conversations') {
                    sortedHomeScreenTiles[2] = tile;
                } else if (tile.name == 'jobs') {
                    sortedHomeScreenTiles[1] = tile;
                } else if (tile.name == 'access') {
                    sortedHomeScreenTiles[0] = tile;
                }
            });

            return sortedHomeScreenTiles;
        }

        function getDay() {
            angular.forEach(vm.upcomingSessions, function (session) {
                session.formattedDay = getFormattedDay(session.start_time)
            });
        }

        function getFormattedDate(date) {
            var dt = date.getDate();
            var months = [$filter('translate')('home.months.january'), $filter('translate')('home.months.february'),
            $filter('translate')('home.months.march'), $filter('translate')('home.months.april'),
            $filter('translate')('home.months.may'), $filter('translate')('home.months.june'),
            $filter('translate')('home.months.july'), $filter('translate')('home.months.august'),
            $filter('translate')('home.months.september'), $filter('translate')('home.months.october'),
            $filter('translate')('home.months.november'), $filter('translate')('home.months.december')];
            if (dt == 1 || dt == 21 || dt == 31) {
                return dt + 'st ' + months[date.getMonth()];
            } else if (dt == 2 || dt == 22) {
                return dt + 'nd ' + months[date.getMonth()];
            } else if (dt == 3 || dt == 23) {
                return dt + 'rd ' + months[date.getMonth()];
            } else {
                return dt + 'th ' + months[date.getMonth()];
            }
        };

        function getFormattedDay(date) {
            var date1 = new Date();
            var date2 = new Date($filter('date')(date))
            var days = [$filter('translate')('home.days.sunday'), $filter('translate')('home.days.monday'), $filter('translate')('home.days.tuesday'), $filter('translate')('home.days.wednesday'), $filter('translate')('home.days.thursday'), $filter('translate')('home.days.friday'), $filter('translate')('home.days.saturday')];
            if (date2.getDate() == date1.getDate()) {
                return $filter('translate')('home.day');
            } else {
                return days[date2.getDay()];
            }
        }

        function getUpcomingSessions() {
            vm.isSessionsLoading = true;
            Session.query({
                page: vm.sessionQuery.page,
                size: vm.sessionQuery.size,
                scheduled: true
            }, function (res) {
                vm.upcomingSessions = res;
                getDay();
                vm.isSessionsLoading = false;
            });
        };

        function getJobs() {
            vm.isJobsLoading = true;
            User.getJobs({
                id: vm.userInfo.id,
                page: vm.jobquery.page,
                size: vm.jobquery.size
            }, function (res) {
                vm.jobs = res;
                vm.isJobsLoading = false;
            })
        };

        function generateDeviceAccessPermissions() {
            var device = deviceDetector.isDesktop() ? 'Desktop' : 'Handheld';
            var user = Auth.isPublicUser() ? 'Guest' : 'SignedIn';
            var permissions = Feature.getCurrentDeviceAccessPermissions(device, user);
            angular.forEach(permissions, function (permission) {
                vm.deviceUserPermissions[permission.object + '_' + permission.action] = {
                    effect: permission.effect,
                    recommendation: permission.recommendation
                };
            })
        }

        function setPermissionsAndFeatures() {
            generateDeviceAccessPermissions();
            angular.forEach(vm.homeData.home_screen_tiles, function (homeTile) {
                if (homeTile.name == 'air_sessions') {
                    homeTile.permission = 'access-session';
                    homeTile.features = ['feature_airsession_enable', 'feature_studio-settings_home_airsessions'];
                    angular.forEach(homeTile.quick_actions, function (action) {
                        if (action.name == 'start_session') {
                            action.permission = 'create-session';
                            action.devicePermission = vm.deviceUserPermissions['AiRSession_Create'];
                        }
                        if (action.name == 'schedule_session') {
                            action.permission = 'create-session';
                            action.feature = 'feature_airsession_schedule_session';
                            action.devicePermission = vm.deviceUserPermissions['AiRSession_Schedule'];
                        }

                        if (action.name == 'join_session') {
                            action.devicePermission = vm.deviceUserPermissions['AiRSession_Attend'];
                        }
                    });
                } else if (homeTile.name == 'conversations') {
                    homeTile.permission = 'access-conversation';
                    homeTile.features = ['feature_conversation_enable', 'feature_studio-settings_home_conversations'];
                    angular.forEach(homeTile.quick_actions, function (action) {
                        action.devicePermission = vm.deviceUserPermissions['Conversation_Create'];
                        if (action.name == 'conv_one_one') {
                            action.permission = 'create-1-1-conversation';
                        } else if (action.name == 'conv_group' || action.name == 'conv_join') {
                            action.permission = 'create-group-conversation';
                            action.feature = 'feature_conversation_group_conversation';
                        }
                    });
                } else if (homeTile.name == 'jobs') {
                    homeTile.permission = 'access-job';
                    homeTile.features = ['feature_airform_enable', 'feature_studio-settings_home_airforms'];
                    angular.forEach(homeTile.quick_actions, function (action) {
                        if (action.name === 'job_start') {
                            action.devicePermission = vm.deviceUserPermissions['Job_Create'];
                        } else {
                            action.devicePermission = vm.deviceUserPermissions['JobBoard_View'];
                        }
                    });
                };
            });
        };

        function displayToast(textContent, delay) {
            ToastService.displayToast(textContent, delay);
        };

        function redirect(state, name) {
            $state.go(state);
            $rootScope.selectedLeftNavMenu = name;
        };

        function handleNgxAction(event) {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.doAction) {
                var action = event.data.doAction.action;
                var props = event.data.doAction.properties
                vm.onIconClick(action, props)
            } else if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;
                var queryParams = event.data.ngxLocationChanged.queryParams;
                id = id ? id : queryParams;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                if (id == null && queryParams == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                } else {
                    $state.transitionTo(
                        ngState,
                        {
                            id: id
                        },
                        {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        }
                    );
                }
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        vm.joinSession = function (session) {
            var permission = vm.deviceUserPermissions['AiRSession_Attend'];
            if (permission && permission.effect === 'Deny') {
                displayToast($filter('translate')('atheer.devicePermission.' + permission.recommendation), 3000);
                return;
            }
            $state.go('storm.sessions.player', {
                'session_no': session.session_no
            });
        };

        vm.getCardBackgroundColor = function (index) {
            return index !== 1 ? vm.primaryColor : vm.secondaryColor;
        };

        vm.getLogo = function (url) {
            if (url == 'job_action1' || url == 'job_action2') {
                return '/assets/images/card/job_action.svg';
            } else if (url == 'join_session') {
                return '/assets/images/card/join_session.svg';
            } else if (url == 'schedule_session') {
                return '/assets/images/card/schedule_session.svg';
            } else if (url == 'conv_one_one') {
                return '/assets/images/card/conv_one_one.svg';
            } else if (url == 'conv_join') {
                return '/assets/images/card/conv_join.svg';
            } else if (url == 'conv_group') {
                return '/assets/images/card/conv_group.svg';
            } else if (url == 'job_start') {
                return '/assets/images/card/job_start.svg';
            } else if (url == 'start_session') {
                return '/assets/images/card/start_session.svg';
            } else if (url == 'join_guest') {
                return '/assets/images/card/join_guest.svg';
            } else if (url === 'topic_search') {
                return '/assets/images/card/topic_search.svg';
            }

            return '/assets/images/card/' + url + '.svg'
        };

        vm.onIconClick = function (name, properties, permission, description) {
            if (permission && permission.effect === 'Deny') {
                displayToast($filter('translate')('atheer.devicePermission.' + permission.recommendation), 3000);
                return;
            }
            if (name == 'start_session') {
                sessionStorage.setItem('context', 'home');
                SessionsService.startInstantSession();
            } else if (name == 'join_session') {
                sessionStorage.setItem('context', 'home');
                SessionsService.joinSession();
            } else if (name == 'schedule_session') {
                redirect('storm.sessions.upcoming-detail', 'airsessions');
            } else if (name == 'conv_one_one') {
                $rootScope.isPersonalConv = true;
                redirect('storm.conversations', 'conversations');
            } else if (name == 'conv_group') {
                $rootScope.isGroupConv = true;
                redirect('storm.conversations', 'conversations');
            } else if (name == 'conv_join') {
                $rootScope.isJoinConv = true;
                redirect('storm.conversations', 'conversations');
            } else if (name == 'job_start') {
                sessionStorage.setItem('appletDataId', properties.appletId);
                redirect('storm.new-job', 'jobs');
            } else if (name == 'job_action1' || name == 'job_action2') {
                sessionStorage.setItem('jobBoardId', properties.job_board_id);
                redirect('storm.jobs', 'jobs');
            } else if (name == 'join_guest') {
                sessionStorage.setItem('context', 'home');
                sessionStorage.removeItem('Authorization');
                Principal.logout(null);
                redirect('account.guest-join', 'airsessions');
            } else if (name == 'topic_search') {
                var tile = {
                    name: name,
                    properties: properties,
                    title: description
                }
                sessionStorage.setItem('selectedTile', JSON.stringify(tile));
                redirect('public.topics', 'home')
            }
        };

        vm.getDisable = function (action) {
            if (action && action.feature && !vm.isFeatureActive(action.feature)) {
                return true;
            } else if (action && action.permission && !PermissionService.hasAccess(action.permission)) {
                return true;
            }

            return false;
        };

        vm.isFeatureActive = function (feature) {
            return Feature.isActive(feature);
        };

        vm.isFeaturesActive = function (features) {
            return Feature.isAllActive(features);
        };

        vm.gotoPage = function (name) {
            if (name == 'air_sessions') {
                var permission = vm.deviceUserPermissions['AiRSession_View'];
                if (permission && permission.effect === 'Deny') {
                    displayToast($filter('translate')('atheer.devicePermission.' + permission.recommendation), 3000);
                    return;
                }
                redirect('storm.sessions.upcoming', 'airsessions')
            } else if (name == 'jobs') {
                var permission = vm.deviceUserPermissions['JobBoard_View'];
                if (permission && permission.effect === 'Deny') {
                    displayToast($filter('translate')('atheer.devicePermission.' + permission.recommendation), 3000);
                    return;
                }
                redirect('storm.jobs', 'jobs');
            }
        };

        vm.executeJob = function (applet) {
            var permission = vm.deviceUserPermissions['Job_Create'];
            if (permission && permission.effect === 'Deny') {
                displayToast($filter('translate')('atheer.devicePermission.' + permission.recommendation), 3000);
                return;
            }
            sessionStorage.setItem('appletDataId', applet.id);
            redirect('storm.new-job', 'jobs');
        };

        vm.refresh = function () {
            getUpcomingSessions();
            getJobs();
        };

        if (!vm.isConfigurableHomeEnabled) {
            loadData();
        } else {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            var ngxUrl = hostUrl;
            var path = $location.path();
            vm.isIFrameDataLoaded = false;

            if ($state.current.name == "storm.home" || $state.current.name === 'public.home') {
                ngxUrl = hostUrl + "/ngx/home";
            } else if ($state.current.name == "storm.unified-search" || $state.current.name === 'public.unified-search') {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/home/search?" + id;
            }

            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
            $rootScope.selectedLeftNavMenu = 'home';


            $window.addEventListener("message", handleNgxAction, false);

            $scope.$on("$destroy", function () {
                window.removeEventListener("message", handleNgxAction, false);
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.doc', [

        ]);
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.doc')
        .controller('ProductDocumentationController', ProductDocumentationController);

    /* @ngInject */
    function ProductDocumentationController($rootScope, $scope, $sce, $cookies, $q, Setting, $mdToast, $filter, $mdDialog, Feature) {
        var vm = this;

        vm.hostUrl = $sce.trustAsResourceUrl("https://atheer.gitbook.io/product-docs/LOPpaLR4RiH0bDQ9ukeX/");
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.doc')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, CONTENT_INSIGHT_META) {
        $stateProvider
            .state('storm.product-doc', {
                url: '/documentation/',
                templateUrl: 'modules/doc/product-doc.tmpl.html',
                controller: 'ProductDocumentationController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.applet.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.copilot', [

        ]);
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.copilot')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.copilot', {
                url: '/copilot',
                templateUrl: 'modules/copilot/copilot.tmpl.html',
                controller: 'CopilotController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.copilot.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                }
            });
    }
})();
;
(function () {
	'use strict';

	angular.module('atheer.copilot').controller('CopilotController', CopilotController);

	/* @ngInject */
	function CopilotController(
		$rootScope,
		$state,
		$scope,
		$sce,
		$cookies,
		BuildLanguages,
		$location,
		$window
	) {
		var vm = this;
		vm.ngxUrlTrusted = null;

		function setNgxPageUrl() {
			
			var buildLanguage = BuildLanguages.getBuildLanguage();
			var path = $location.path();
			var hostUrl =
				location.hostname === 'localhost'
					? 'http://' + location.hostname + ':3005'
					: 'https://airpilot.atheer.dev';
			
			var ngxUrl = hostUrl;
			vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
		}

		function handleNgxEvent(event) {
			var hostUrl =
				location.hostname === 'localhost'
					? 'http://' + location.hostname + ':3005'
					: location.origin;
			if(event.origin !== hostUrl) return;
			if (event.data.ngxLocationChanged) {
				var ngState = event.data.ngxLocationChanged.ngState;
				var id = event.data.ngxLocationChanged.id;

				if (id == null) {
					$state.transitionTo(ngState, null, {
						location: true,
						inherit: true,
						relative: $state.$current,
						notify: false
					});
				} else {
					$state.transitionTo(
						ngState,
						{
							id: id
						},
						{
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: false
						}
					);
				}
			}
		}

		$window.addEventListener('message', handleNgxEvent, false);

		// Unregister
		$scope.$on('$destroy', function () {
			window.removeEventListener('message', handleNgxEvent, false);
		});

		setNgxPageUrl();
	}
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationsController', ConversationsController);

    /* @ngInject */
    function ConversationsController($scope, $http, $state, Setting, $q, ToastService, $filter, AlertService, Message, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService, User, Conversation, ConversationModelService) {
        var vm = this;

        vm.illustartionEmptyScreenId = "conversation";
        vm.loadingData = false;
        vm.userId = Principal.getUserId();

        vm.newConverationModel = {
            conversation_no: null,
            name: null,
            purpose: null,
            topic: null,
            status: 'OPEN',
            type: 'PRIVATE_USER',
            users: null
        };

        function loadData() {
            vm.loadingData = true;

            User.getConversations({
                query: getOpenConversationQuery(),
                page: 0,
                size: 100
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                if (data.length > 0) {
                    $state.go('storm.conversations-detail', {
                        'id': data[0].id
                    });
                } else {
                    vm.loadingData = false;
                }
            };

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            };
        };

        function getOpenConversationQuery() {
            return "status==OPEN"
        }

        function createPersonalConversation(users) {
            var conversation = angular.copy(vm.newConverationModel);
            var conversationUsers = [];

            conversationUsers.push({
                user_id: vm.userId,
                role: 'OWNER'
            });

            angular.forEach(users, function(user) {
                conversationUsers.push({
                    user_id: user.id,
                    role: 'OWNER'
                })
            });

            conversation.users = conversationUsers;
            createConversation(conversation);
        };

        function createGroupConversation(conversation) {
            createConversation(conversation);
        };

        function createConversation(conversation) {
            Conversation.save(conversation, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                //publish conversation to users
                ConversationModelService.publishNewConversation(vm.userId, result, 'REFRESH_CONVERSATION');

                ToastService.displayToast($filter('translate')('atheer.conversation.conversationCreated'), 3000);

                $state.go('storm.conversations-detail', {
                    'id': result.id
                });
            };

            function onSaveError() {

            };
        };

        function joinCoversastion(conversation) {
            Conversation.join({
                id: conversation.id,
            }, onJoinSuccess, onJoinError);

            function onJoinSuccess(result) {
                //publish conversation to users
                ConversationModelService.publishNewConversation(vm.userId, result, 'REFRESH_CONVERSATION');

                ToastService.displayToast($filter('translate')('atheer.conversation.conversationJoined'), 3000);

                $state.go('storm.conversations-detail', {
                    'id': result.id
                });
            };

            function onJoinError() {

            };
        };

        vm.startPeronsalConversation = function() {
            $mdDialog.show({
                    templateUrl: 'modules/user/user-picker.tmpl.html',
                    controller: 'UserPickerController',
                    controllerAs: 'vm',
                    locals: {
                        filter: vm.invitedUserIds,
                        allowMultiSelect: false,
                        userslist: [],
                        isSession: false,
                        isAdmin: false,
                        isScheduledSession: false,
                        isConversationSession: false,
                        isSmartScan: false
                    }
                })
                .then(function(selectedItems) {
                    createPersonalConversation(selectedItems);
                });
        };

        vm.startGroupConversation = function() {
            $mdDialog.show({
                templateUrl: 'modules/conversation/conversation-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "ConversationGroupController",
                controllerAs: "vm",
                locals: {
                    filter: null
                }
            }).then(function(conversation) {
                createGroupConversation(conversation);
            }).finally(function() {});
        }

        vm.joinGroupConversation = function() {
            $mdDialog.show({
                    templateUrl: 'modules/conversation/conversation-group-picker.tmpl.html',
                    controller: 'ConversationGroupPickerController',
                    controllerAs: 'vm',
                    locals: {
                        filter: null,
                        allowMultiSelect: false
                    }
                })
                .then(function(conversations) {
                    joinCoversastion(conversations[0]);
                });
        }
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.conversations', {
                url: '/conversations',
                templateUrl: 'modules/conversation/conversations.tmpl.html',
                controller: 'ConversationsController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.conversation.home.title',
                    layout: {
                        showSideNavMenu: false,
                        contentClass: 'layout-column',
                        showToolbar: false,
                        footer: false
                    }
                }
            })
            .state('storm.conversations-detail', {
                url: '/conversations/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/conversation/conversation-detail.html',
                        controller: 'ConversationDetailController',
                        controllerAs: 'vm',
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/conversation/conversation-list.tmpl.html',
                        controller: 'ConversationListController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.conversation.home.title',
                    layout: {
                        showSideNavMenu: true,
                        sideNavMenuSize: 20,
                        contentClass: 'layout-column',
                        showToolbar: false,
                        footer: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('fpConvMessageUrl', fpConvMessageUrl);

    function fpConvMessageUrl() {
        var directive = {
            restrict: 'E',
            controller: fpConvMessageUrlController,
            scope: {
                message: '=',
                userId: '=',
                primaryColor: '=',
                sender: '='
            },
            templateUrl: 'modules/conversation/conversation-url-message.tmpl.html',
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    /* @ngInject */
    function fpConvMessageUrlController($window) {
        var vm = this;

        var showDownConverter = new showdown.Converter();
        showDownConverter.setOption('emoji', true);

        vm.metaData = {};
        if(vm.message && vm.message.url_meta_info) {
            var urlInfo = vm.message.url_meta_info.split(',[Date:')[0];
            urlInfo = urlInfo.replace('<200,', '');

            vm.metaData = angular.fromJson(urlInfo);
        };

        if(vm.message && vm.message.body) {
            var pos = vm.message.body.indexOf('www') !== -1 ? vm.message.body.indexOf('www') : vm.message.body.indexOf('http');
            var url = vm.metaData && vm.metaData.url ? vm.metaData.url : vm.message.body;

            //for multiline check
            if(url.indexOf('<br>') != -1) {
                var msgParts = url.split('<br>');
                var isMsg = false;
                angular.forEach(msgParts, function(msgPart) {
                    if(!isMsg && (msgPart.indexOf('http') != -1 || msgPart.indexOf('www') != -1)) {
                       isMsg = true;
                       msgPart = showDownConverter.makeHtml(msgPart);
                       msgPart = msgPart.replace('<p>', '').replace('</p>', '');
                       url = msgPart;
                    }
                });
            }

            if(!url.startsWith('http')) {
                url = 'http://' + url;
            }
            var formatMsgBody = [vm.message.body.slice(0, pos), '<a href='+ url + ' target="_blank">', vm.message.body.slice(pos)].join('') + '</a>';

            vm.message.formattedMsgBody = formatMsgBody;
        } else {
            vm.message.formattedMsgBody = vm.message.formattedBody;
        }

        vm.getImageUrl = function() {
            if(vm.metaData && vm.metaData.images && vm.metaData.images.length > 0) {
                return vm.metaData.images[0].url;
            }
            return vm.metaData.favicon_url;
        };

        vm.redirectToUrl = function() {
            var url = vm.metaData && vm.metaData.url ? vm.metaData.url : vm.message.body;
            $window.open(url, '_blank');
        };
    }
})();;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .service('ConversationTypingService', ConversationTypingService);

    /* @ngInject */
    function ConversationTypingService($rootScope, Pubnub, $filter, Principal, Feature) {

        var usersTyping = [];
        var channel = null;
        var isCurrentUserTyping = false;
        var typingListener = null;
        var currentUser = Principal.getUserInfo();

        var service = {
            init: init,
            destroy: destroy,
            getUsersTyping: getUsersTyping,
            startTyping: startTyping,
            stopTyping: stopTyping,
            isCurrentUserTyping: isCurrentUserTyping
        };

        return service;

        function init(conversation) {
            channel = 'conversation-' + conversation.id;
            isCurrentUserTyping = false;
            usersTyping = [];
            typingListener = $rootScope.$on(Pubnub.getPresenceEventNameFor(channel), function(ngEvent, presenceEvent) {
                updateTypingUserList(presenceEvent);
            });
        };

        function destroy() {
            channel = null;
            typingListener = null;
        };

        function updateTypingUserList(event) {
            // We don't want to receive our own presence events
            if (event['uuid'] === currentUser.id) return;

            // Add people typing
            if (event['action'] === 'state-change' && event['state']['isTyping']) {
                
                // Check if not already in the array
                if (!_.find(usersTyping, {
                        uuid: event['uuid']
                    }))
                    usersTyping.push({
                        uuid: event['uuid'],
                        userInfo: event['state']['userInfo']
                    });

            } else if ((event['action'] === 'state-change' && event['state']['isTyping'] === false) ||
                event['action'] === 'timeout' ||
                event['action'] === 'leave') {

                _.remove(usersTyping, function(user) {
                    return user['uuid'] === event['uuid'];
                });
            }

            // firing an event downwards
            $rootScope.$broadcast('conversationUserTypingList', usersTyping);
        };

        function getUsersTyping(uuid) {
            return usersTyping;
        };

        function setTypingState(isTyping) {
            isCurrentUserTyping = isTyping;
            Pubnub.setState({
                channels: [channel],
                uuid: currentUser.id,
                state: {
                    isTyping: isCurrentUserTyping,
                    userInfo: currentUser.first_name
                }
            });
        };

        function startTyping() {
            if (Feature.isActive('feature_conversation_typing_indicator')) {
                setTypingState(true)
            }

        };

        function stopTyping() {
            if (isCurrentUserTyping && Feature.isActive('feature_conversation_typing_indicator')) {
                setTypingState(false)
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .directive('conversationTypingIndicator', conversationTypingIndicator);

    /* @ngInject */
    function conversationTypingIndicator() {
        var directive = {
            scope: {
                conversationModel: '='
            },
            restrict: "E",
            replace: true,
            templateUrl: 'modules/conversation/conversation-typing-indicator.html',
            bindToController: true,
            controller: conversationTypingIndicatorController,
            controllerAs: 'vm',
        };
        return directive;

        /* @ngInject */
        function conversationTypingIndicatorController($rootScope, $scope, PubNubService, Feature) {
            var vm = this;

            vm.usersTyping = [];
            vm.userStatus = '';

            $rootScope.$on('conversationUserTypingList', function(event, usersTyping) {
                $scope.$apply(function() {
                    if(vm.conversationModel.type == 'PRIVATE_USER') {
                        vm.usersTyping = usersTyping;
                    } else {
                        var userTyping = [];
                        angular.forEach(usersTyping, function(typing) {
                            angular.forEach(vm.conversationModel.users_info, function(userInfo) {
                                if(userInfo.id == typing.uuid) {
                                    userTyping.push(typing);
                                }
                            })
                        });
                        vm.usersTyping = userTyping;
                    }
                });
            });

            $scope.$on('refreshUserStatus', function(event, userId) {
                $scope.$apply(function() {
                    generateStatus();
                });
            });

            $scope.$watch('vm.conversationModel', function(newVal) {
                generateStatus();
            });

            function generateStatus() {
                if (vm.conversationModel.type == 'PRIVATE_USER') {
                    var pubNubState = PubNubService.getUserState(vm.conversationModel.user_info.id);
                    if (pubNubState != undefined && pubNubState != null) {
                        vm.userStatus = 'Active';
                    } else {
                        vm.userStatus = 'Away';
                    }
                } else {
                    vm.userStatus = '';
                    var userNames = [];
                    var len = 0;
                    vm.userInfo = []
                    var currentIds = [];
                    for (var i = 0; i < vm.conversationModel.users_info.length; i++) {
                        for (var j = 0; j < vm.conversationModel.users.length; j++) {
                            if (vm.conversationModel.users[j].user_id ==  vm.conversationModel.users_info[i].id && !vm.conversationModel.users[j].left) {
                                var exist = false;
                                for (var k = 0; k < currentIds.length; k++) {
                                    if (currentIds[k] == vm.conversationModel.users_info[i].id) {
                                        exist = true;
                                        break;
                                    }
                                }
                                if (!exist) {
                                    vm.userInfo.push(vm.conversationModel.users_info[i])
                                    currentIds.push(vm.conversationModel.users_info[i].id)
                                }
                            }
                        }
                    }

                    for (var i = 0; i < vm.userInfo.length; i++) {
                        if (i > 2) {
                            userNames.push((vm.userInfo.length - i) + " others");
                            break;
                        } else {
                            userNames.push(vm.userInfo[i].first_name);
                        }
                    };

                    vm.userStatus = userNames.join(', ');
                };
            }
            generateStatus();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('fpTypeTracking', fpTypeTracking);

    /* @ngInject */
    function fpTypeTracking(ConversationTypingService, Feature) {
        var directive = {
            link: link,
            controller: fpTypeTrackingController,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs) {
            $scope.$watch(attrs['ngModel'], function(input) {
                // When to start Typing ?
                // Content is not empty and was not typing before
                if (!_.isEmpty(input) && !ConversationTypingService.isCurrentUserTyping) {
                    ConversationTypingService.startTyping();
                    $scope.stopTypingScheduler();
                } else if (!_.isEmpty(input) && ConversationTypingService.isCurrentUserTyping) {
                    $scope.stopTypingScheduler();
                } else if (_.isEmpty(input) && ConversationTypingService.isCurrentUserTyping) {
                    $scope.stopTypingScheduler();
                } else {
                    // When user send the message, we need to immediately send stop typing signal
                    ConversationTypingService.stopTyping();
                }
            });
        };

        /* @ngInject */
        function fpTypeTrackingController($scope) {
            // Time before the stop typing event is fired after stopping to type.
            $scope.stopTypingTime = 5000

            // Scheduler that trigger stopTyping if the function has not been invoced after stopTypingTime
            $scope.stopTypingScheduler = _.debounce(ConversationTypingService.stopTyping, $scope.stopTypingTime)
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .service('ConversationModelService', ConversationModelService);

    /* @ngInject */
    function ConversationModelService($rootScope, $mdPanel, $mdDialog, $filter, $mdToast, PubNubService, Message, AlertService) {

        var initialized = false;
        var conversations = null;
        var sessionSettings;

        var service = {
            init: init,
            destroy: destroy,
            isInitialized: isInitialized,
            getConversations: getConversations,
            deleteMessage: deleteMessage,
            pinMessage: pinMessage,
            unPinMessage: unPinMessage,
            addMessageReaction: addMessageReaction,
            addOrRemoveMessageReaction: addOrRemoveMessageReaction,
            publishNewConversation: publishNewConversation,
            subscribe: subscribe,
            unSubscribe: unSubscribe,
            publishConvMessage: publishConvMessage
        };

        return service;

        function init(conversationsList) {
            conversations = conversationsList;
            initialized = true;
        };

        function destroy() {
            initialized = null;
            conversations = null;
        };

        function isInitialized() {
            return initialized;
        };

        function getConversations() {
            return conversations;
        };

        function deleteMessage(message) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.conversation.deleteMessage'))
                .ariaLabel($filter('translate')('atheer.conversation.deleteMessage'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Message.delete({
                    id: message.id
                }, function() {

                    $rootScope.$broadcast('conversationMessageInternal', {
                        type: 'MESSAGE_DELETED',
                        message: message
                    });

                    publishConvMessage(message.conversation_id, 'MESSAGE_DELETED', message);
                    AlertService.displayToast($mdToast);
                });
            });
        };

        function pinMessage(message) {
            Message.pin({
                id: message.id
            }, function(updatedMessage) {

                transformMessage(message, updatedMessage);

                $rootScope.$broadcast('conversationMessageInternal', {
                    type: 'MESSAGE_UPDATED',
                    message: updatedMessage
                });

                publishConvMessage(updatedMessage.conversation_id, 'MESSAGE_UPDATED', updatedMessage);
            });
        };

        function unPinMessage(message) {
            Message.pin({
                id: message.id
            }, function(updatedMessage) {

                transformMessage(message, updatedMessage);

                $rootScope.$broadcast('conversationMessageInternal', {
                    type: 'MESSAGE_UPDATED',
                    message: updatedMessage
                });

                publishConvMessage(updatedMessage.conversation_id, 'MESSAGE_UPDATED', updatedMessage);
            });
        };

        function addMessageReaction(ev, message) {
            var position = $mdPanel.newPanelPosition()
                .relativeTo('#msg-' + message.id)
                .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: 'ConversationMessageReactionPanelController',
                controllerAs: 'vm',
                templateUrl: 'modules/conversation/conversation-message-reaction-panel.tmpl.html',
                position: position,
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 999,
                onCloseSuccess: function(panelRef, reason) {
                    window.removeEventListener('message', panelRef.listenerFn, false);
                    if (panelRef.emoji) {
                        Message.reaction({
                            id: message.id,
                            type: panelRef.emoji.native,
                            unified: panelRef.emoji.unified
                        }, function(updatedMessage) {

                            transformMessage(message, updatedMessage);

                            $rootScope.$broadcast('conversationMessageInternal', {
                                type: 'MESSAGE_UPDATED',
                                message: updatedMessage
                            });

                            publishConvMessage(updatedMessage.conversation_id, 'MESSAGE_UPDATED', updatedMessage);
                        });
                    }
                }
            };
            $mdPanel.open(config);
        };

        function addOrRemoveMessageReaction(message, reactionType, unified) {
            Message.reaction({
                id: message.id,
                type: reactionType,
                unified: unified
            }, function(updatedMessage) {

                transformMessage(message, updatedMessage);


                $rootScope.$broadcast('conversationMessageInternal', {
                    type: 'MESSAGE_UPDATED',
                    message: updatedMessage
                });

                publishConvMessage(updatedMessage.conversation_id, 'MESSAGE_UPDATED', updatedMessage);
            });
        }

        function publishConvMessage(conversationId, type, message) {
            var channelName = 'conversation-' + conversationId;

            var pubNubMessage = {
                subject: 'CONVERSATION',
                action: 'BROADCAST',
                type: type,
                data: message
            };
            PubNubService.publish(channelName, pubNubMessage);
        };

        function publishNewConversation(userId, conversation, type) {
            if (conversation.users && conversation.users.length > 0) {
                var message = {
                    id: conversation.id
                };

                angular.forEach(conversation.users, function(user) {

                    var channelName = 'user-' + user.user_id;

                    var pubNubMessage = {
                        subject: 'CONVERSATION',
                        action: 'BROADCAST',
                        type: type,
                        data: message
                    };
                    PubNubService.publish(channelName, pubNubMessage);

                });
            }
        };

        function subscribe(conversation) {
            var channelName = 'conversation-' + conversation.id;
            PubNubService.subscribe([channelName], true);
        };

        function unSubscribe(conversation) {
            var channelName = 'conversation-' + conversation.id;
            PubNubService.unsubscribe([channelName]);
        };

        function transformMessage(message, updatedMessage) {
            if(message.type == 'CONTENT') {
                updatedMessage.content = message.content;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .directive('conversationMessage', conversationMessage);

    /* @ngInject */
    function conversationMessage() {
        var directive = {
            scope: {
                conversation: '=',
                message: '=',
                index: '=',
                isReadOnly: '='
            },
            restrict: "E",
            replace: true,
            templateUrl: 'modules/conversation/conversation-message.html',
            bindToController: true,
            controller: conversationMessageController,
            controllerAs: 'vm',
        };
        return directive;

        /* @ngInject */
        function conversationMessageController($rootScope, $timeout, $scope, PubNubService, Content, $mdToast, $mdDialog, Message, $mdPanel, ConversationModelService, AlertService, Principal, triSettings) {
            var vm = this;

            vm.userId = Principal.getUserId();
            vm.primaryColor = triSettings.getSkinModel().primary_color_hex;

            vm.showMessageActions = function($event, message, xPosition) {
                var position = $mdPanel.newPanelPosition()
                    .relativeTo('#message-menu')
                    .addPanelPosition(xPosition == 'END' ? $mdPanel.xPosition.ALIGN_START : $mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.ALIGN_TOPS);

                var config = {
                    attachTo: angular.element(document.body),
                    controller: 'ConversationMessageMenuController',
                    controllerAs: 'vm',
                    templateUrl: 'modules/conversation/conversation-message-menu.html',
                    position: position,
                    locals: {
                        messageModel: message,
                        conversationModel: vm.conversation
                    },
                    openFrom: $event,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: false,
                    zIndex: 2,
                    onCloseSuccess: function(panelRef, reason) {

                    }
                };
                $mdPanel.open(config);
            };

            vm.addReaction = function(ev) {
                ConversationModelService.addMessageReaction(ev, vm.message);
            };

            vm.addOrRemoveReaction = function(reactionType, unified) {
                ConversationModelService.addOrRemoveMessageReaction(vm.message, reactionType, unified);
            };

            vm.unPinMessage = function() {
                ConversationModelService.unPinMessage(vm.message);
            };
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationMessageReactionPanelController', ConversationMessageReactionPanelController);

    /* @ngInject */
    function ConversationMessageReactionPanelController(mdPanelRef, $scope, $state, $location, $mdDialog, $q, $filter, $mdToast, AlertService, ConversationModelService, Principal, Message, $mdPanel) {
        var vm = this;

        function handleEmoji(event) {
            if (event.data.emojiSelected) {
                mdPanelRef.emoji = event.data.emoji;
                mdPanelRef.close();
            }
        };

        window.addEventListener('message', handleEmoji, false);

        mdPanelRef.listenerFn = handleEmoji;

        // Unregister
        $scope.$on('$destroy', function() {
            window.removeEventListener('message', handleEmoji, false);
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('conversationMessageNotifier', conversationMessageNotifier);

    /* @ngInject */
    function conversationMessageNotifier($state, $filter, notification, $rootScope) {
        var vm = this;

        vm.loadingData = true;
        vm.notification = notification;
        vm.avatarData = {};
        vm.conversationMessage = "";

        vm.viewMessage = function() {
            $rootScope.selectedLeftNavMenu = 'conversations';
            $state.go('storm.conversations-detail', {
                'id': vm.notification.data.conversation_id
            });
        };

         // Function to truncate messages
        function truncateMessage(message, limit) {
            return message.length > limit ? message.substring(0, limit) + '...' : message;
        }

        vm.loadData = function() {
            vm.avatarData = {
                firstName: vm.notification.data.user_info.first_name,
                lastName: vm.notification.data.user_info.last_name,
                id: vm.notification.data.user_info.id,
                pictureId: vm.notification.data.user_info.picture_id
            };
            if ( vm.notification.data.content ) {
                switch(vm.notification.data.content.data.type.toLowerCase()){
                    case 'image':
                        vm.conversationMessage = $filter('translate')('notification.conversation.imageShared');
                        break;
                    case 'video':
                        vm.conversationMessage = $filter('translate')('notification.conversation.videoShared');
                        break;
                    case 'audio':
                        vm.conversationMessage = $filter('translate')('notification.conversation.audioShared');
                        break;
                    case 'text':
                        vm.conversationMessage = truncateMessage(vm.conversationMessage, 24);
                        break;
                    default:
                        vm.conversationMessage = $filter('translate')('notification.conversation.contentShared');
                }
            } else if ( vm.notification.data.type === 'AUDIO') {
                vm.conversationMessage = $filter('translate')('notification.conversation.audioShared');
            }
            else {
                vm.conversationMessage = truncateMessage(vm.notification.data.body, 24);
            }

            $rootScope.$broadcast('messageCount', 1);

            vm.loadingData = false;
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('ConversationMessageMenuController', ConversationMessageMenuController);

    /* @ngInject */
    function ConversationMessageMenuController(mdPanelRef, $rootScope, $scope, PubNubService, $state, $location, $mdDialog, $q, $filter, $mdToast, Principal, $mdPanel, messageModel, conversationModel, Message, ConversationModelService, AlertService) {
        var vm = this;

        vm.message = messageModel;
        vm.conversation = conversationModel;
        vm.userId = Principal.getUserId();
        vm.isPinned = false;

        vm.deleteMessage = function() {
            mdPanelRef.close();
            ConversationModelService.deleteMessage(vm.message);
        };

        vm.pinMessage = function() {
            mdPanelRef.close();
            ConversationModelService.pinMessage(vm.message);
        };

        vm.unPinMessage = function() {
            mdPanelRef.close();
            ConversationModelService.unPinMessage(vm.message);
        };

        vm.addReaction = function(ev) {
            mdPanelRef.close();
            ConversationModelService.addMessageReaction(ev, vm.message);;
        };

        function loadData() {
            vm.isPinned = false;

            if (vm.message && vm.message.is_pinned) {
                vm.isPinned = true;
            }
        };
        loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.conversation')
        .directive('conversationMessageList', conversationMessageList);

    function conversationMessageList() {
        var directive = {
            scope: {
                conversation: '=',
                conversationId: '=',
                emptyIllustration: '=',
                isReadOnly: '=',
                sessionModel: '='
            },
            bindToController: true,
            controller: conversationMessageListController,
            controllerAs: 'vm',
            templateUrl: 'modules/conversation/conversation-message-list.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function conversationMessageListController($rootScope, $scope, $sce, $mdDialog, $mdToast, $state, $timeout, $q, $filter, $anchorScroll, Content, Message, $mdPanel, Principal, Conversation, ConversationModelService, AlertService, triSettings, Feature, $mdSidenav, Experience) {
        var vm = this;

        vm.togglePanel = function () {
            $mdSidenav('conversationPanel').toggle()
                .then(function () {

                });
        };

        vm.illustartionEmptyScreenId = "conversation";
        if (vm.conversationId) {
            vm.illustartionEmptyScreenId = "message";
        }


        if (vm.emptyIllustration == "session-conv") {
            vm.illustartionEmptyScreenId = "session_chat";
        }

        var converter = new showdown.Converter();
        converter.setOption('emoji', true);

        var conversationMessageInternalListener = null;
        var refreshConversationListener = null;
        var pubNubConversationListener = null;

        vm.loadingData = false;
        vm.reachedTop = false;
        vm.userId = Principal.getUserId();
        vm.currentDate = null;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.contentLoading = false;
        vm.isTyping = false;
        vm.messages = [];
        vm.contentMessageIds = [];
        vm.contentMessages = [];
        vm.messageGroupingThreshold = 24 * 60 * 60 * 1000 // 1 day threshold

        vm.currentMessage = null;

        vm.page = 0;
        vm.size = 20;

        vm.dateFormats = {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'dddd',
            lastDay: '[Yesterday]',
            lastWeek: 'dddd',
            sameElse: 'MMMM DD, YYYY'
        };

        vm.status = {
            loading: false,
            loaded: false
        };

        vm.isLoader = false;

        vm.loadMoreMessages = function () {
            if (!vm.status.loading && !vm.reachedTop) {
                vm.status.loading = true;
                vm.currentMessage = 'message-' + vm.messages[vm.messages.length - 1].id
                $q.all([
                    Message.get({
                        query: "conversationId==" + vm.conversationId,
                        sort: "created_on,desc",
                        page: vm.page,
                        size: vm.size,
                    }).$promise
                ])
                    .then(function (results) {
                        angular.forEach(results[0], function (message) {
                            vm.messages.push(transformMessage(message));
                        });

                        groupMessages();

                        if (results[0].length != vm.size) {
                            vm.reachedTop = true;
                            vm.messages[vm.messages.length - 1].is_top = true
                        }

                        vm.page = vm.page + 1;
                        $timeout(function () {
                            vm.status.loading = false;
                        }, 500);

                        $timeout(function () {
                            $anchorScroll(vm.currentMessage);
                        }, 0);

                        vm.status.loaded = (vm.messages.length > 0);
                    });
            }
        };

        conversationMessageInternalListener = $rootScope.$on('conversationMessageInternal', function (event, messageInfo) {
            if (messageInfo.type == 'MESSAGE_CREATED') {
                addMessage(transformMessage(messageInfo.message));
            } else if (messageInfo.type == 'MESSAGE_CREATED_Id') {
                updateMessageId(messageInfo.message);
            } else if (messageInfo.type == 'MESSAGE_UPDATED') {
                updateMessage(transformMessage(messageInfo.message));
                groupMessages();
            } else if (messageInfo.type == 'MESSAGE_DELETED') {
                if (messageInfo.message.id == vm.messages[0].id) {
                    messageInfo.message.body = '';
                    $rootScope.$broadcast('conversationMessageInternal', {
                        type: 'UPDATE_LAST_MESSAGE',
                        message: vm.messages.length > 1 ? vm.messages[vm.messages.length - 1] : messageInfo.message
                    });
                }
                _.remove(vm.messages, function (item) {
                    return item.id === messageInfo.message.id;
                });
            } else if (messageInfo.type == 'CONTENT_CREATED' || messageInfo.type == 'AUDIO_CREATED') {
                vm.isLoader = true;
            };
        });

        refreshConversationListener = $rootScope.$on('refreshConversation', function (event, conversation) {
            vm.conversation = conversation;
            vm.conversationId = vm.conversation != null ? vm.conversation.id : null;
            loadMessages();
        });

        pubNubConversationListener = $scope.$on('conversationMessagePubNub', function (event, message) {
            $scope.$apply(function () {
                if (message.message.subject == 'CONVERSATION') {
                    handleMessage(message);
                };
            });
        });

        // Unregister
        $scope.$on('$destroy', function () {
            conversationMessageInternalListener = null;
            refreshConversationListener = null;
            pubNubConversationListener = null;
        });

        function addMessage(message, fromRealTime) {
            if (message.type == 'CONTENT') {
                vm.contentLoading = true;
            }

            $timeout(function () {
                vm.scrollToBottom = false;
            }, 0);

            if (message.type == 'TEXT' && !fromRealTime) {
                vm.isLoader = true;
            } else {
                vm.messages.unshift(formatMessageBody(message));
                vm.isLoader = false;
            }

            groupMessages();

            $rootScope.$broadcast('conversationMessageInternal', {
                type: 'UPDATE_LAST_MESSAGE',
                message: message
            });
            $timeout(function () {
                vm.scrollToBottom = true;
            }, 0);
        };

        function updateMessage(updatedMessage) {
            var messageIndex = vm.messages.findIndex(function (message) {
                return message.id === updatedMessage.id;
            });
            if (messageIndex >= 0) {
                vm.messages[messageIndex] = updatedMessage;
            };
        };

        function updateMessageId(updatedMessage) {
            vm.messages.unshift(formatMessageBody(updatedMessage));

            groupMessages();

            $rootScope.$broadcast('conversationMessageInternal', {
                type: 'UPDATE_LAST_MESSAGE',
                message: updatedMessage
            });

            $timeout(function () {
                vm.scrollToBottom = true;
            }, 0);

            vm.isLoader = false;
        };

        function handleMessage(pubNubMessage) {
            if (pubNubMessage.message.type == 'MESSAGE_CREATED') {
                if (pubNubMessage.message.data.conversation_id == vm.conversationId) {
                    if ($state.current.url != '/player/:session_no') {
                        Experience.getReadMessages({
                            userId: vm.userId,
                            conversationId: vm.conversationId
                        }, function (readMessage) {
                        });
                    }
                    var messageIndex = vm.messages.findIndex(function (message) {
                        return message.id === pubNubMessage.message.data.id;
                    });
                    if (messageIndex <= 0) {
                        addMessage(transformMessage(pubNubMessage.message.data), true);
                    }
                } else {
                    $rootScope.$broadcast('conversationMessageInternal', {
                        type: 'UPDATE_LAST_MESSAGE',
                        message: pubNubMessage.message.data
                    });
                }
                if ($state.current.url == '/player/:session_no') {
                    $rootScope.$broadcast('unReadMessages', pubNubMessage);
                }
            } else if (pubNubMessage.message.type == 'MESSAGE_UPDATED') {
                var messageIndex = vm.messages.findIndex(function (message) {
                    return message.id === pubNubMessage.message.data.id;
                });

                if (messageIndex >= 0) {
                    updateMessage(transformMessage(pubNubMessage.message.data));
                }
            } else if (pubNubMessage.message.type == 'MESSAGE_DELETED') {
                var messageIndex = vm.messages.findIndex(function (message) {
                    return message.id === pubNubMessage.message.data.id;
                });

                if (messageIndex == 0) {
                    var singleMessage = vm.messages[0];
                    if (vm.messages.length <= 1) {
                        singleMessage.body = '';
                    }
                    vm.messages.shift();
                    $rootScope.$broadcast('conversationMessageInternal', {
                        type: 'UPDATE_LAST_MESSAGE',
                        message: vm.messages.length >= 1 ? vm.messages[0] : singleMessage
                    });

                } else if (messageIndex > 0) {
                    vm.messages.splice(messageIndex, 1);
                }
            };
        };

        function formatMessageBody(message) {
            message.formattedBody = converter.makeHtml(message.body.replaceAll("\n", "<br>")).replaceAll(/&lt;br\s*\/?\&gt;/g, "<br>")
            return message;
        };

        function groupMessages() {
            for (var i = 0; i < vm.messages.length - 1; i++) {
                var currentMessage = vm.messages[i];
                var nextMessage = vm.messages[i + 1];

                nextMessage.group_end = false;

                // If next messages is from different users, mark this as the end of the group
                if (currentMessage.publisher_id != nextMessage.publisher_id) {
                    nextMessage.group_end = true;
                }

                // If next message and current message are send more than X seconds apart, mark this as the end
                var currentDate = new Date(currentMessage.created_on);
                var nextDate = new Date(nextMessage.created_on);
                if (Math.abs(currentDate.getTime() - nextDate.getTime()) > vm.messageGroupingThreshold) {
                    nextMessage.group_end = true;
                }

                // If next message and current message are from differet days, mark this as the end
                // Also put the time separator on current message
                if (currentDate.getFullYear() != nextDate.getFullYear() ||
                    currentDate.getMonth() != nextDate.getMonth() ||
                    currentDate.getDay() != nextDate.getDay()) {
                    nextMessage.group_end = true;
                    currentMessage.time_separate = true;
                }
            }

            // Last message is always end of a group
            if (vm.messages.length > 0) {
                vm.messages[0].group_end = true;
            }
        }

        /*
            Function to convert reaction unifid to html entity
            Ex. 1f486-200d-2642-fe0f -> &#x1F486;&#x200D;&#x2642;&#xFE0F;
        */
        function convertReactionToHtmlEntities(input) {
            var parts = input.split("-");
            var htmlEntities = parts.map(function (part) {
                return "&#x" + part.toUpperCase() + ";";
            });
            return htmlEntities.join("");
        }

        function transformMessage(message) {
            if (vm.conversation.type == 'PRIVATE_USER') {
                if (message.publisher_id == vm.userId) {
                    message.user_info = {
                        id: Principal.getUserInfo().id,
                        first_name: Principal.getUserInfo().first_name,
                        last_name: Principal.getUserInfo().last_name,
                        picture_id: Principal.getUserInfo().picture_id
                    };
                }
            } else {
                var userInfo = $filter('filter')(vm.conversation.users_info, {
                    id: message.publisher_id
                })[0];
                message.user_info = {
                    id: userInfo.id,
                    first_name: userInfo.first_name,
                    last_name: userInfo.last_name,
                    picture_id: userInfo.picture_id
                };
            };

            message.reaction_summary = {
                pinned: false,
                reaction_info: []
            };

            if (message.reactions && message.reactions.length > 0) {
                var messageIndex = message.is_pinned;

                if (messageIndex) {
                    message.reaction_summary.pinned = true;
                };

                angular.forEach(message.reactions, function (reaction) {
                    if (reaction.type != 'PINNED') {
                        var reactByMe = false;
                        var reactionSummary = message.reaction_summary.reaction_info.find(function (reactionInfo) {
                            return reactionInfo.type == reaction.type;
                        });

                        if (reaction.user_id === vm.userId) {
                            reactByMe = true;
                        }

                        if (reactionSummary != null) {
                            reactionSummary.count += 1;
                            if (reactByMe) {
                                reactionSummary.reactByMe = true;
                            }
                        } else {
                            var reactionSummary = {
                                type: reaction.type,
                                unified: reaction.unified,
                                webInfo: $sce.trustAsHtml(
                                    convertReactionToHtmlEntities(reaction.unified)
                                ),
                                count: 1,
                                reactByMe: reactByMe
                            }
                            message.reaction_summary.reaction_info.push(reactionSummary);
                        }
                    }
                })
            };

            function getReactionSummary(reactionType) {
                var reactionSummary = null;
                reactionSummary = message.reaction_summary.reaction_info.find(function (reactionInfo) {
                    return reactionInfo.type == reactionType;
                });
                return reactionSummary;
            };

            message = formatMessageBody(message);
            return message;
        };

        function addMessageStyle() {
            var style = "<style>" + ".mine .message.last:before{background:" + vm.primaryColor + "}</style>";
            angular.element("head").append(style);
        }

        function loadMessages() {
            vm.messages = [];
            vm.reachedTop = false;

            vm.page = 0;
            if (vm.conversationId && vm.conversationId != null) {
                vm.loadingData = true;
                $q.all([
                    Conversation.get({
                        id: vm.conversationId
                    }).$promise,
                    Message.get({
                        query: "conversationId==" + vm.conversationId,
                        sort: "created_on,desc",
                        page: vm.page,
                        size: vm.size,
                    }).$promise
                ])
                    .then(function (results) {
                        vm.conversation = results[0];

                        angular.forEach(results[1], function (message) {
                            vm.messages.push(transformMessage(message));
                        });

                        groupMessages();

                        if (vm.messages.length > 0) {
                            vm.currentMessage = "message-" + vm.messages[vm.messages.length - 1].id;
                        }

                        if (vm.conversation.type != 'PRIVATE_USER') {
                            vm.illustartionMessageName = vm.conversation.name;
                        } else {
                            vm.illustartionMessageName = vm.conversation.user_info.first_name;
                        }

                        vm.page = vm.page + 1;
                        vm.loadingData = false;
                        vm.scrollToBottom = true;
                    });
            } else {
                vm.messages = [];
                vm.loadingData = false;
            };
        };

        $rootScope.$on('conversationUserTypingList', function (event, usersTyping) {
            $scope.$apply(function () {
                vm.usersTyping = usersTyping;
                if (vm.usersTyping.length > 0 && vm.conversation.type == 'PRIVATE_USER') {
                    vm.isTyping = true;
                } else {
                    vm.isTyping = false;
                }
            });
        });

        if (!vm.sessionModel) {
            loadMessages();
        }
        addMessageStyle();

        $scope.$watch('vm.sessionModel', function (newValue) {
            if (angular.isDefined(vm.sessionModel) && vm.sessionModel != null) {
                loadMessages();
            }
        });
    };
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.core')
        .directive('conversationMessageEditor', conversationMessageEditor);

    /* @ngInject */
    function conversationMessageEditor() {
        var directive = {
            scope: {
                conversationModel: '=',
                isGuest: '='
            },
            restrict: "E",
            replace: true,
            templateUrl: 'modules/conversation/conversation-message-editor.html',
            bindToController: true,
            controller: conversationMessageEditorController,
            controllerAs: 'vm',
        };
        return directive;

        /* @ngInject */
        function conversationMessageEditorController($rootScope, $scope, $mdPanel, PubNubService, Principal, $mdDialog, Message, ConversationModelService, $timeout, deviceDetector, $filter) {
            var vm = this;

            var froalaEditor = null;

            var showDownConverter = new showdown.Converter();
            showDownConverter.setOption('emoji', true);

            vm.convMessageBody = null;

            // Define popup template.
            Object.assign(FroalaEditor.POPUP_TEMPLATES, {
                'emojiPlugin.popup': '[_CUSTOM_LAYER_]'
            });

            // The custom popup is defined inside a plugin (new or existing).
            FroalaEditor.PLUGINS.emojiPlugin = function (editor) {
                // Create custom popup.
                function initPopup() {
                    // Load popup template.
                    var template = FroalaEditor.POPUP_TEMPLATES.customPopup;
                    if (typeof template == 'function') template = template.apply(editor);

                    var template = {
                        custom_layer: '<div><iframe border=0 name=iframe src="third-party/emoji/index.html" width="338" height="420" scrolling="no" noresize frameborder="0"></iframe></div>'
                    };

                    window.addEventListener('message', handleMessage, false);

                    // Create popup.
                    var $popup = editor.popups.create('emojiPlugin.popup', template);

                    return $popup;
                };

                function handleMessage(event) {
                    if (event.origin !== location.origin) return;
                    if (editor.popups.isVisible('emojiPlugin.popup') && event.data.emojiSelected) {
                        handleEmoji(event.data.emoji);
                    }
                }

                function handleEmoji(emoji) {
                    editor.html.insert(emoji.native);
                    editor.events.trigger('contentChanged', [], true);
                    hidePopup();
                };

                // Show the popup
                function showPopup() {
                    // Get the popup object defined above.
                    var $popup = editor.popups.get('emojiPlugin.popup');

                    // If popup doesn't exist then create it.
                    // To improve performance it is best to create the popup when it is first needed
                    // and not when the editor is initialized.
                    if (!$popup) $popup = initPopup();

                    // Set the editor toolbar as the popup's container.
                    editor.popups.setContainer('emojiPlugin.popup', editor.$tb);

                    // If the editor is not displayed when a toolbar button is pressed, then set BODY as the popup's container.
                    // editor.popups.setContainer('emojiPlugin.popup', $('body'));

                    // Trigger refresh for the popup.
                    // editor.popups.refresh('emojiPlugin.popup');

                    // This custom popup is opened by pressing a button from the editor's toolbar.
                    // Get the button's object in order to place the popup relative to it.
                    var $btn = editor.$tb.find('.fr-command[data-cmd="emoji"]');

                    // Compute the popup's position.
                    var left = $btn.offset().left + $btn.outerWidth() / 2 - 20;
                    var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 5);

                    // Show the custom popup.
                    // The button's outerHeight is required in case the popup needs to be displayed above it.
                    editor.popups.show('emojiPlugin.popup', left, top, $btn.outerHeight());
                }

                // Hide the custom popup.
                function hidePopup() {
                    editor.popups.hide('emojiPlugin.popup');
                }

                // Methods visible outside the plugin.
                return {
                    showPopup: showPopup,
                    hidePopup: hidePopup
                }
            };

            // Define an icon and command for the button that opens the custom popup.
            FroalaEditor.DefineIcon('emoji', {
                NAME: 'smile-o',
                FA5NAME: 'smile',
                SVG_KEY: 'smile'
            });

            FroalaEditor.RegisterCommand('emoji', {
                title: $filter('translate')('atheer.message.emoji'),
                icon: 'emoji',
                undo: false,
                focus: false,
                popup: true,
                // Buttons which are included in the editor toolbar should have the plugin property set.
                plugin: 'emojiPlugin',
                callback: function () {
                    if (!this.popups.isVisible('emojiPlugin.popup')) {
                        this.emojiPlugin.showPopup();
                    } else {
                        if (this.$el.find('.fr-marker')) {
                            this.events.disableBlur();
                            this.selection.restore();
                        }
                        this.popups.hide('emojiPlugin.popup');
                    }
                }
            });

            // Define a text icon called textIcon.
            FroalaEditor.DefineIcon('sendIcon', {
                NAME: $filter('translate')('entity.action.send'),
                template: 'text'
            });

            FroalaEditor.RegisterCommand('sendButton', {
                title: 'Send',
                icon: 'sendIcon',
                callback: function () {
                    vm.submitTextMessage();
                },
                refresh: function ($btn) {
                    if (this.charCounter.count() > 0) {
                        $btn[0].disabled = false;
                    } else {
                        $btn[0].disabled = true;
                    };
                }
            });

            // Define a font icon called smartphoneIcon that uses the Material Design font.
            // You should also make sure that you include the Material Design Iconic font in your <head>:
            // <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.1.2/css/material-design-iconic-font.min.css" />
            FroalaEditor.DefineIconTemplate('iconTemplate', '<i class="fa fa-[NAME]" aria-hidden="true"></i>');

            FroalaEditor.DefineIcon('microphoneIcon', {
                NAME: 'microphone',
                template: 'iconTemplate'
            });

            FroalaEditor.RegisterCommand('microphoneButton', {
                title: $filter('translate')('atheer.message.audio'),
                icon: 'microphoneIcon',
                callback: function () {
                    vm.recordAudio(this.id);
                },
            });

            FroalaEditor.DefineIconTemplate('contentTemplate', '<i class="zmdi zmdi-[NAME]" aria-hidden="true"></i>');

            FroalaEditor.DefineIcon('contentIcon', {
                NAME: 'library',
                template: 'contentTemplate'
            });

            if (!vm.isGuest) {
                FroalaEditor.RegisterCommand('contentButton', {
                    title: $filter('translate')('atheer.message.content'),
                    icon: 'contentIcon',
                    callback: function () {
                        vm.shareContent(this.id);
                    },
                });
            }

            FroalaEditor.DefineIconTemplate('localContentTemplate', '<i class="fa fa-[NAME]" aria-hidden="true"></i>');

            FroalaEditor.DefineIcon('localContentIcon', {
                NAME: 'arrow-circle-o-up',
                template: 'localContentTemplate'
            });

            if (!vm.isGuest) {
                FroalaEditor.RegisterCommand('localContentButton', {
                    title: $filter('translate')('atheer.message.local'),
                    icon: 'localContentIcon',
                    callback: function () {
                        vm.shareLocalContent(this.id);
                    }
                });
            }

            vm.froalaOptions = {
                pluginsEnabled: ['align', 'charCounter', 'emojiPlugin', 'entities', 'inlineStyle', 'lineBreaker', 'lists', 'quote'],
                toolbarButtons: {
                    'moreText': {
                        'buttons': ['emoji', 'microphoneButton', 'contentButton', 'localContentButton'],
                        'buttonsVisible': 10
                    },
                    'moreMisc': {
                        'buttons': ['sendButton'],
                        'align': 'right',
                        'buttonsVisible': 3
                    }
                },
                toolbarButtonsMD: {
                    'moreText': {
                        'buttons': ['emoji', 'microphoneButton', 'contentButton', 'localContentButton'],
                        'buttonsVisible': 10
                    },
                    'moreMisc': {
                        'buttons': ['sendButton'],
                        'align': 'right',
                        'buttonsVisible': 3
                    }
                },
                toolbarButtonsSM: {
                    'moreText': {
                        'buttons': ['emoji', 'microphoneButton', 'contentButton', 'localContentButton'],
                        'buttonsVisible': 10
                    },
                    'moreMisc': {
                        'buttons': ['sendButton'],
                        'align': 'right',
                        'buttonsVisible': 3
                    }
                },
                toolbarButtonsXS: {
                    'moreText': {
                        'buttons': ['emoji', 'microphoneButton', 'contentButton', 'localContentButton'],
                        'buttonsVisible': 10
                    },
                    'moreMisc': {
                        'buttons': ['sendButton'],
                        'align': 'right',
                        'buttonsVisible': 3
                    }
                },
                enter: FroalaEditor.ENTER_P,
                toolbarInline: false,
                charCounterCount: false,
                toolbarBottom: true,
                heightMin: 10,
                zIndex: 0,
                multiLine: true,
                placeholderText: $filter('translate')('atheer.conversation.typeMessagePlaceholder'),
                emoticonsUseImage: true,
                listAdvancedTypes: false,
                events: {
                    'initialized': function () {
                        var elements = document.querySelectorAll("[data-cmd='sendButton']");
                        var sendButton = angular.element(elements[0]);
                        sendButton.removeClass('fr-btn');
                        sendButton.addClass('md-primary md-raised md-button md-primary-theme-theme md-ink-ripple');
                        sendButton[0].disabled = true;

                        if (deviceDetector.browser == 'safari') {
                            var microphoneButton = angular.element(document.querySelectorAll("[data-cmd='microphoneButton']")[0]);
                            microphoneButton.addClass('fr-disabled');
                            microphoneButton[0].style.opacity = 1;
                        }
                    },
                    'keydown': function (keypressEvent) {
                        if (keypressEvent.keyCode == 13 && !keypressEvent.shiftKey) {
                            vm.submitTextMessage();
                        }
                    },
                    'destroy': function () { }
                }
            };

            vm.shareContent = function (id) {
                $mdDialog.show({
                    templateUrl: 'modules/content/content-picker.html',
                    controller: 'ContentPickerController',
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals: {
                        filter: 'embedded==false;type=out=(SERIES,EMAIL_LAYOUT,ANNOUNCEMENT,DID_YOU_KNOW);meta_type==DISCOVERABLE;status!=ARCHIVED;enabled==true',
                        allowMultiSelect: false,
                        isWeb: false,
                        isNotFilter: false
                    }
                })
                    .then(function (content) {
                        vm.submitContentMessage(content[0]);
                    });
            }

            vm.recordAudio = function (id) {
                if (deviceDetector.isMobile()) {
                    $mdDialog.show({
                        templateUrl: 'modules/conversation/conversation-audio-record-dialog.tmpl.html',
                        clickOutsideToClose: true,
                        controller: 'ConversationAudioRecordDialogController',
                        controllerAs: 'vm',
                    }).then(function (media) {
                        if (media.isSend) {
                            vm.submitAudioMessage(media.media);
                        }
                    });
                } else {
                    var position = $mdPanel.newPanelPosition()
                        .relativeTo('#microphoneButton-' + id)
                        .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW)
                        .withOffsetY(-50);

                    var config = {
                        attachTo: angular.element(document.body),
                        controller: 'ConversationAudioRecordController',
                        controllerAs: 'vm',
                        templateUrl: 'modules/conversation/conversation-audio-record-panel.tmpl.html',
                        panelClass: 'fp-conv-audio-panel',
                        position: position,
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        focusOnOpen: false,
                        zIndex: 2,
                        onCloseSuccess: function (panelRef, reason) {
                            if (panelRef.send) {
                                vm.submitAudioMessage(panelRef.media);
                            }
                        }
                    };
                    $mdPanel.open(config);
                }
            };

            vm.submitAudioMessage = function (media) {
                var convMessage = {
                    conversation_id: vm.conversationModel.id,
                    subject: 'subject',
                    body: media.properties.file_name,
                    sent_on: new Date() / 1000,
                    publisher_id: Principal.getUserInfo().id,
                    type: 'AUDIO',
                    status: []
                };

                vm.submitMessage(convMessage);
            };

            vm.submitContentMessage = function (content) {
                var convMessage = {
                    conversation_id: vm.conversationModel.id,
                    subject: 'subject',
                    body: content.id, //JSON.stringify(media),//media.data.source_media.properties.file_name,
                    sent_on: new Date() / 1000,
                    publisher_id: Principal.getUserInfo().id,
                    type: 'CONTENT',
                    status: [],
                    content: content
                };
                vm.submitMessage(convMessage);
            };

            // it seems froala has a delay between user input and vm.convMessageBody, add a retry logic here
            vm.submitTextMessage = function () {
                vm.convMessageBody = froalaEditor.html.get();

                if (vm.convMessageBody != null) {

                    while (vm.convMessageBody.indexOf("<br></p>") != -1) {
                        vm.convMessageBody = vm.convMessageBody.replaceAll("<br></p>", "</p>");
                    }
                    // remove additional <p></p> at the end of the string
                    if (vm.convMessageBody.trim().length > 0 && vm.convMessageBody.endsWith("<p></p>")) {
                        vm.convMessageBody = vm.convMessageBody.split("<p></p>")[0]
                    }
                    if (vm.convMessageBody.trim().length <= 0 || vm.convMessageBody.endsWith("<p></p><p></p>")) {
                        return;
                    }

                }

                var finalConvMessageBody = showDownConverter.makeMarkdown(vm.convMessageBody)

                // remove additional \n\n at the end of the string
                if(finalConvMessageBody.endsWith("\n\n")) {
                    finalConvMessageBody = finalConvMessageBody.slice(0, -2)
                }

                var convMessage = {
                    conversation_id: vm.conversationModel.id,
                    subject: 'subject',
                    body: finalConvMessageBody.replaceAll("<br>\n", ""),
                    sent_on: new Date() / 1000,
                    publisher_id: Principal.getUserInfo().id,
                    type: 'TEXT',
                    status: []
                };

                vm.convMessageBody = null;
                vm.submitMessage(convMessage);
                froalaEditor.html.set(null);
            };

            vm.initializeEditor = function (initControls) {
                initControls.initialize();
                froalaEditor = initControls.getEditor();
            };

            vm.submitMessage = function (convMessage) {
                if (vm.conversationModel.users && vm.conversationModel.users.length > 0) {
                    vm.conversationModel.users.forEach(function (user) {
                        if (user.user_id != vm.userId) {
                            var receiver = {
                                user_id: user.user_id,
                                read: "false",
                                read_at: null
                            };
                            convMessage.status.push(receiver);
                        }
                    });
                };

                // Removed the Text message rendering directly to avoid XSS attacks - specified in the PEN TEST - FOS-11716

                if (convMessage.type == 'TEXT') {
                    $scope.$emit('conversationMessageInternal', {
                        type: 'MESSAGE_CREATED',
                        message: convMessage
                    });
                }

                if (convMessage.type == 'CONTENT') {
                    $scope.$emit('conversationMessageInternal', {
                        type: 'CONTENT_CREATED',
                        message: convMessage
                    });
                }

                if (convMessage.type == 'AUDIO') {
                    $scope.$emit('conversationMessageInternal', {
                        type: 'AUDIO_CREATED'
                    });
                }

                Message.save(convMessage, onSaveSuccess, onSaveError);

                function onSaveSuccess(message) {
                    message.user_info = {
                        id: Principal.getUserInfo().id,
                        first_name: Principal.getUserInfo().first_name,
                        last_name: Principal.getUserInfo().last_name,
                        picture_id: Principal.getUserInfo().picture_id
                    };

                    if (message.type == 'CONTENT') {
                        message.content = convMessage.content;
                    };

                    if (message.type != 'TEXT') {
                        $scope.$emit('conversationMessageInternal', {
                            type: 'MESSAGE_CREATED',
                            message: message
                        });
                    }

                    if (message.type == 'TEXT') {
                        $scope.$emit('conversationMessageInternal', {
                            type: 'MESSAGE_CREATED_Id',
                            message: message
                        });
                    }

                    ConversationModelService.publishConvMessage(vm.conversationModel.id, 'MESSAGE_CREATED', message);
                };

                function onSaveError() {

                };
            };

            vm.shareLocalContent = function (id) {
                $mdDialog.show({
                    templateUrl: 'modules/conversation/conversation-local-content-picker.tmpl.html',
                    controller: 'ConversationLocalContentPicker',
                    controllerAs: 'vm',
                    locals: { annotationMode: false }
                })
                    .then(function (content) {
                        vm.submitContentMessage(content);
                    });
            };

            $scope.$watch('vm.conversationModel', function (newValue) {
                vm.convMessageBody = null;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.core')
        .controller('ConversationLocalContentPicker', ConversationLocalContentPicker);

    /* @ngInject */
    function ConversationLocalContentPicker($scope, $mdDialog, Content, Upload, $timeout, $filter, ToastService, annotationMode, $q) {
        var vm = this;

        vm.uploadPercentage = 0.0;
        vm.uploadStatus = 'idle';
        vm.processStatus = 'idle';
        vm.uploadEvt = [];

        vm.files = [];
        vm.fileType = '';
        vm.filterText = '';
        vm.tempFiles = [];

        vm.filePattern = "image/*,video/*,audio/*,application/pdf,application/zip,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/x-tar,application/gzip,.rar,text/plain,text/csv,application/rtf,.gzip";
        vm.acceptPattern = ".jpg, .png, .jpeg, .gif, .tiff, .avif, .bmp, .webp, .mp4, .mov, .webm, .avi, .wmv, .mp3, .wav, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .rtf, .txt, .csv, .zip, .tar, .gz, .rar, .gzip";
        vm.fileMaxSizes = {
            "audio": "524288000",
            "video": "524288000",
            "image": "524288000",
            "zip": "524288000",
            "pdf": "524288000",
            "doc": "524288000",      
            "docx": "524288000",
            "xls": "524288000",
            "xlsx": "524288000",
            "ppt": "524288000",
            "pptx": "524288000",
            "x-tar": "524288000",  
            "gzip": "524288000",
            "x-rar-compressed": "524288000",
            "text": "524288000",
            "csv": "524288000",
            "rtf": "524288000"
        };

        vm.upload = function(files, file, newFiles, duplicateFiles, invalidFiles) {
            if(invalidFiles && invalidFiles.length > 0) {
                if (invalidFiles[0].$error == 'pattern') {
                    displayToast(invalidFiles[0].name + $filter('triTranslate')('localContent.invalidPattern'));
                }
            } else if (files && files.length > 0){
                vm.files = files;
                const fileType = files[0].type.split("/");
                if (fileType[0] === "application" || fileType[0] === "text") {
                    if (
                        [
                            "pdf",
                            "msword",
                            "vnd.openxmlformats-officedocument.wordprocessingml.document",
                            "vnd.ms-excel",
                            "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            "vnd.ms-powerpoint",
                            "vnd.openxmlformats-officedocument.presentationml.presentation",
                            "rtf",
                            "plain",
                            "csv",
                        ].includes(fileType[1])
                    ) {
                        vm.fileType = "document";
                    } else if (
                        ["zip", "x-tar", "gzip", "vnd.rar"].includes(
                            fileType[1]
                        )
                    ) {
                        vm.fileType = "zip";
                    }
                } else {
                    vm.fileType = fileType[0];
                }

                if (vm.fileType === "" || vm.fileType === "application/octet-stream") {
                    const fileName = files[0].name;
                    const extension = fileName.split('.').pop().toLowerCase();
                    if (["gz", "gzip", "rar"].includes(extension)) {
                        vm.fileType = "zip";
                    }
                }

                if(annotationMode && vm.fileType != 'image') {
                    displayToast(files[0].name + 'is not an image type');
                    return;
                }
                if(files[0].size > vm.fileMaxSizes[vm.fileType]) {
                    displayToast(files[0].name + $filter('triTranslate')('localContent.tooBig' ));
                } else {
                    var canceler = $q.defer();
                    vm.uploadStatus = 'uploading';
                    vm.files[0].cancelEvt = canceler;
                    Upload.upload({
                        url: 'api/media/upload',
                        data: {
                            'file': files[0],
                            'type': vm.fileType
                        },
                        timeout: canceler.promise
                    }).then(function(resp) {
                        if(vm.uploadStatus != 'stop') {
                            vm.uploadStatus = 'complete';
                            vm.processStatus = 'uploading';
                            uploadContent(resp.data, vm.fileType);
                        }
                    }, function(err) {
                        if (err && err.status !== -1) {
                            vm.uploadStatus = 'error'
                        }
                    }, function(evt) {
                        vm.files[0].uploadEvt = evt;
                        vm.uploadStatus = 'uploading';
                        vm.uploadPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    });
                }
            }
        };

        vm.stopUploading = function(file) {
            file.cancelEvt.resolve();
            vm.uploadStatus = 'idle';
            vm.processStatus = 'idle';
        };

        vm.uploadMore = function() {
            vm.uploadStatus = 'idle';
            vm.processStatus = 'idle';
        };

        vm.onChange = function() {
            if(vm.tempFiles.length == 0) {
                vm.tempFiles = vm.files;
                vm.files = vm.filterText ? vm.files.filter(function(file) {
                    return file.name.indexOf(vm.filterText) >= 0;
                }): vm.files;
            } else {
                vm.files = vm.filterText ? vm.tempFiles.filter(function(file) {
                    return file.name.indexOf(vm.filterText) >= 0;
                }): vm.tempFiles;
            }
        }

        vm.close = function() {
            $mdDialog.cancel();
        };

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        };

        function displayToast(message) {
            ToastService.displayToast(message, 3000);
        };

        function uploadContent(content, type) {
            var uploadContent = {
                title: content.name,
                description: content.name,
                status: 'PRIVATE',
                data: {
                    type: type == 'audio' ? 'podcast' : type,
                    source_media: content
                }
            }
            Content.localContentShare({}, uploadContent, function(result) {
                vm.processStatus = 'complete';
                $timeout(function() {
                    $mdDialog.hide(result);
                }, 3000);
            }, function(err) {
                vm.processStatus = 'error';
                $timeout(function() {
                    $mdDialog.cancel();
                }, 3000);
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationListController', ConversationListController);

    /* @ngInject */
    function ConversationListController($rootScope, $scope, moment, $location, $state, Setting, PubNubService, AlertService, $mdDialog, ParseLinks, pagingParams, paginationConstants, $stateParams, Principal, Feature, PermissionService, User, Conversation, id, ConversationModelService, triSettings, $filter, NotificationHandleService, Experience, ToastService) {
        var vm = this;

        var showDownConverter = new showdown.Converter();
        showDownConverter.setOption('emoji', true);

        var conversationMessageInternalListener = null;
        vm.pinnedIndex = 0;

        vm.dateFormats = {
            sameDay: 'hh:mm A',
            nextDay: '[Tomorrow]',
            nextWeek: 'dddd',
            lastDay: '[Yesterday]',
            lastWeek: 'dddd',
            sameElse: 'MMMM DD, YYYY'
        };

        vm.permissions = {
            create1on1: 'create-1-1-conversation',
            createGroup: 'create-group-conversation',
            update: 'update-conversation',
            delete: 'delete-conversation'
        };

        vm.loadingData = true;
        vm.maxDisplayLen = 15;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.conversations = [];
        vm.pinnedConversations = [];
        vm.userId = Principal.getUserId();
        vm.selectedConversationId = id;
        vm.groupConversationFeature = Feature.isActive('feature_conversation_group_conversation');
        vm.invitedUserIds = [];
        vm.hasPermission = PermissionService.hasAccess(vm.permissions.create1on1) || PermissionService.hasAccess(vm.permissions.createGroup);
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;

        vm.newConverationModel = {
            conversation_no: null,
            name: null,
            purpose: null,
            topic: null,
            status: 'OPEN',
            type: 'PRIVATE_USER',
            users: null

        };

        vm.messagesCount = 0;

        vm.startPeronsalConversation = function() {
            $mdDialog.show({
                    templateUrl: 'modules/user/user-picker.tmpl.html',
                    controller: 'UserPickerController',
                    controllerAs: 'vm',
                    locals: {
                        filter: vm.invitedUserIds,
                        allowMultiSelect: false,
                        userslist: [],
                        isSession: false,
                        isAdmin: false,
                        isScheduledSession: false,
                        isConversationSession: false,
                        isSmartScan: false
                    }
                })
                .then(function(selectedItems) {
                    createPersonalConversation(selectedItems);
                });
        };

        vm.startGroupConversation = function() {
            $mdDialog.show({
                templateUrl: 'modules/conversation/conversation-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "ConversationGroupController",
                controllerAs: "vm",
                locals: {
                    filter: null
                }
            }).then(function(conversation) {
                createGroupConversation(conversation);
            }).finally(function() {});
        }

        vm.joinGroupConversation = function() {
            $mdDialog.show({
                    templateUrl: 'modules/conversation/conversation-group-picker.tmpl.html',
                    controller: 'ConversationGroupPickerController',
                    controllerAs: 'vm',
                    locals: {
                        filter: null,
                        allowMultiSelect: false
                    }
                })
                .then(function(conversations) {
                    joinCoversastion(conversations[0]);
                });
        }

        vm.getConverstionImageUrl = function(conversation) {
            if (conversation.type == 'PRIVATE_USER') {
                return conversation.user_info.picture_id ? '/media/pictures/' + conversation.user_info.picture_id : 'assets/images/avatars/user-avatar.png';
            } else if (conversation.type == 'PRIVATE_GROUP') {
                return conversation.picture_id ? '/media/pictures/' + conversation.picture_id : 'assets/images/avatars/group-avatar.png';
            } else if (conversation.type == 'PUBLIC_GROUP') {
                return conversation.picture_id ? '/media/pictures/' + conversation.picture_id : 'assets/images/avatars/group-avatar.png';
            } else if (conversation.type == 'PRIVATE_AUDIENCE') {
                return conversation.picture_id ? '/media/pictures/' + conversation.picture_id : 'assets/images/avatars/group-avatar.png';
            };
        };

        vm.getUserInitials = function(conversation) {
            var firstName = conversation.user_info.first_name;
            var lastName = conversation.user_info.last_name;
            return firstName.charAt(0) + lastName.charAt(0);
        };

        vm.getConverstionTitle = function(conversation) {
            var title = null;
            if (conversation.type == 'PRIVATE_USER') {
                title = conversation.user_info.first_name + ' ' + conversation.user_info.last_name;
            } else {
                title = conversation.name;
            }

            if (title != null) {
                var len = Math.min(vm.maxDisplayLen, title.length);
                var ans = title.substring(0, len);
                if (title.length > len) {
                    ans = ans + "...";
                }

                return ans;
            }

            return "";
        };

        vm.getConverstionLastMessage = function(conversation) {
            if (conversation && conversation.last_message) {
                if(conversation.last_message.type == 'TEXT') {
                    var lastmsg = conversation.last_message.body.replaceAll(/&lt;br\s*\/?\&gt;/g, "<br>");
                    if (lastmsg.length > 15) {
                        if(lastmsg.indexOf('<br>') != -1) {
                            var indexOf = lastmsg.indexOf('<br>') > 15 ? 15 : lastmsg.indexOf('<br>');
                            lastmsg = lastmsg.substring(0, indexOf) + '...'
                        } else {
                            lastmsg = lastmsg.substring(0,15) + "..."
                        }
                    }
                    return showDownConverter.makeHtml(lastmsg);
                } else if(conversation.last_message.type == 'AUDIO') {
                    return  'Audio Message';
                } else if(conversation.last_message.type == 'CONTENT') {
                    return  'Content Shared';
                } else {
                    if(conversation.last_message.type == 'URL') {
                        var last_message = conversation.last_message.body;
                        if(last_message.indexOf('<br>') != -1) {
                            last_message = last_message.substring(0, last_message.indexOf('<br>')) + '...';
                        }
                        return showDownConverter.makeHtml(last_message);
                    }
                    return showDownConverter.makeHtml(conversation.last_message.body);
                }
            }
        };

        vm.selectConversation = function(conversationId) {
            if (vm.selectedConversationId != conversationId) {
                vm.selectedConversationId = conversationId;

                $state.transitionTo('storm.conversations-detail', {
                    id: vm.selectedConversationId
                }, {
                    location: true,
                    inherit: true,
                    relative: $state.$current,
                    notify: false
                });

                var conversationToRefresh = null;
                if (conversationId != null) {
                    conversationToRefresh = vm.conversations.find(function(conversation) {
                        return conversation.id === conversationId;
                    });
                }

                // firing an event downwards
                $rootScope.$broadcast('refreshConversation', conversationToRefresh);

                getReadMessages();
            }
        };

        vm.isPinned = function(conversation) {
            if (conversation && conversation.users.length > 0) {
                for (var i = 0; i < conversation.users.length; i++) {
                    if (conversation.users[i].user_id == vm.userId && conversation.users[i].pinned) {
                        return true;
                    }
                };
            }

            return false;
        }

        vm.addUsersforPrivateGroup = function(conversation) {
            vm.invitedUserIds.push(conversation.user_info.id);
        }

        vm.removeUsersforPrivateGroupDelete = function(conversation) {
            var userIndex = vm.invitedUserIds.findIndex(function(id) {
                    return conversation.user_info.id === id;
                });

            vm.invitedUserIds.splice(userIndex, 1);
        }

        conversationMessageInternalListener = $rootScope.$on('conversationMessageInternal', function(event, messageInfo) {
            if (messageInfo.type == 'UPDATE_LAST_MESSAGE') {

                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id === messageInfo.message.conversation_id;
                });

                if (conversationIndex == 0) {
                    vm.conversations[0].last_message = messageInfo.message;

                } else {
                    var conversation = vm.conversations[conversationIndex];
                    conversation.last_message = messageInfo.message;
                    vm.conversations.splice(conversationIndex, 1);
                    if (vm.isPinned(conversation)) {
                        vm.conversations.unshift(conversation);
                    } else {
                        vm.conversations.splice(vm.pinnedIndex, 0, conversation);
                    }
                }
            } else if (messageInfo.type == 'CONVERSATION_DELETED' || messageInfo.type == 'CONVERSATION_ARCHIVED' || messageInfo.type == 'CONVERSATION_USER_LEFT') {
                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id === messageInfo.id;
                });

                if (vm.conversations.length <= 0) {
                    $state.go('storm.conversations');
                } else {
                    if (vm.isPinned(vm.conversations[conversationIndex])) {
                        vm.pinnedIndex--;
                    }

                    if (vm.conversations[conversationIndex].type == 'PRIVATE_USER') {
                        vm.removeUsersforPrivateGroupDelete(vm.conversations[conversationIndex]);
                    }

                    if (conversationIndex == 0) {
                        vm.conversations.shift();
                        if (vm.conversations.length > 0) {
                            vm.selectConversation(vm.conversations[0].id);
                        } else {
                            $state.go('storm.conversations');
                        }

                    } else if (conversationIndex > 0) {
                        vm.conversations.splice(conversationIndex, 1);
                        if (vm.selectedConversationId == messageInfo.id) {
                            if (vm.conversations.length > 0) {
                                vm.selectConversation(vm.conversations[0].id);
                            } else {
                                $state.go('storm.conversations');
                            }
                        }
                    }
                    var convChannelName = 'conversation-' + messageInfo.id;
                    PubNubService.unsubscribe([convChannelName]);
                }

            } else if (messageInfo.type == 'CONVERSATION_UPDATED') {
                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id === messageInfo.conversation.id;
                });

                vm.conversations[conversationIndex] = messageInfo.conversation;
            } else if (messageInfo.type == 'CONVERSATION_PINNED') {
                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id === messageInfo.id;
                });

                if (conversationIndex >= 0) {
                    var result = vm.conversations[conversationIndex];
                    for (var i = 0; i < result.users.length; i++) {
                        if (result.users[i].user_id == vm.userId) {
                            result.users[i].pinned = true;
                        }
                    };
                    vm.conversations.splice(conversationIndex, 1);
                    vm.conversations.splice(vm.pinnedIndex++, 0, result);
                    if (conversationIndex == 0) {
                        vm.selectConversation(result.id);
                    }
                }
            } else if (messageInfo.type == 'CONVERSATION_UNPINNED') {
                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id === messageInfo.id;
                });

                if (conversationIndex >= 0) {
                    var result = vm.conversations[conversationIndex];
                    for (var i = 0; i < result.users.length; i++) {
                        if (result.users[i].user_id == vm.userId) {
                            result.users[i].pinned = false;
                        }
                    };
                    vm.conversations.splice(conversationIndex, 1);
                    vm.pinnedIndex--;
                    vm.conversations.splice(vm.pinnedIndex, 0, result);
                    if (conversationIndex == 0) {
                        vm.selectConversation(result.id);
                    }
                }
            }
        });

        // Unregister
        $scope.$on('$destroy', function() {
            conversationMessageInternalListener = null;
        });

        $scope.$on('conversationMessagePubNub', function(event, message) {
            $scope.$apply(function() {
                if (message.message.subject == 'CONVERSATION') {
                    handleMessage(message);
                };
            });
        });

        function handleMessage(message) {
            if (message.message.type == 'REFRESH_CONVERSATION' || message.message.type == 'CONVERSATION_USER_LEFT') {
                var conversationId = message.message.data.id;

                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id == conversationId;
                });

                if (conversationIndex == -1) {
                    loadConversation(message.message.data.id);
                } else {
                    updateConversation(message.message.data.id, true);
                }
            } else if (message.message.type == 'CONVERSATION_DELETED' || message.message.type == 'CONVERSATION_ARCHIVED') {
                var conversationId = message.message.data.id;

                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id == conversationId;
                });

                if (vm.isPinned(vm.conversations[conversationIndex])) {
                    vm.pinnedIndex--;
                }

                if (vm.conversations[conversationIndex].type == 'PRIVATE_USER') {
                    vm.removeUsersforPrivateGroupDelete(vm.conversations[conversationIndex]);
                }

                if (conversationIndex == 0) {
                    vm.conversations.shift();
                    vm.selectConversation(vm.conversations[0].id);
                } else if (conversationIndex > 0) {
                    vm.conversations.splice(conversationIndex, 1);
                    if (vm.selectedConversationId == conversationId) {
                        vm.selectConversation(vm.conversations[0].id);
                    }
                }
            } else if (message.message.type == 'CONVERSATION_PINNED' || message.message.type == 'CONVERSATION_UNPINNED') {
                var conversationId = message.message.data.id;

                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id == conversationId;
                });

                updateConversation(message.message.data.id, false);

            } else if (message.message.type == 'MESSAGE_CREATED') {
                if(vm.selectedConversationId != message.message.data.conversation_id) {
                    NotificationHandleService.onNotification(message);
                    angular.forEach(vm.conversations, function(conversation) {
                        if(conversation.id == message.message.data.conversation_id) {
                            vm.messagesCount = vm.messagesCount + 1;
                            conversation.unread_message_count = conversation.unread_message_count + 1;

                            $rootScope.$broadcast('messageCount', vm.messagesCount);
                        }
                    });
                }
            }
        };

        function createPersonalConversation(users) {
            var conversation = angular.copy(vm.newConverationModel);
            var conversationUsers = [];

            conversationUsers.push({
                user_id: vm.userId,
                role: 'OWNER'
            });

            angular.forEach(users, function(user) {
                conversationUsers.push({
                    user_id: user.id,
                    role: 'OWNER'
                })
            });

            conversation.users = conversationUsers;
            createCoversastion(conversation);
        };

        function createGroupConversation(conversation) {
            createCoversastion(conversation);
        };

        function createCoversastion(conversation) {
            Conversation.save(conversation, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                vm.conversations.splice(vm.pinnedIndex, 0, result);
                vm.selectConversation(result.id);

                //subscribe to channel
                ConversationModelService.subscribe(result);

                //publish conversation to users
                ConversationModelService.publishNewConversation(vm.userId, result, 'REFRESH_CONVERSATION');

                ToastService.displayToast($filter('translate')('atheer.conversation.conversationCreated'), 3000);

                if (result.type == 'PRIVATE_USER') {
                    vm.addUsersforPrivateGroup(result);
                }
            };

            function onSaveError() {

            };
        };

        function joinCoversastion(conversation) {
            var conversationIndex = -1;
            conversationIndex = vm.conversations.findIndex(function(conversationExist) {
                    return conversationExist.id == conversation.id;
            });
             if(conversationIndex != -1) {
                if (vm.selectedConversationId == conversation.id) {
                    var conversationToRefresh = vm.conversations[conversationIndex];
                    vm.selectConversation(conversation.id);
                        // firing an event downwards
                    $rootScope.$broadcast('refreshConversation', conversationToRefresh);
                }
                vm.selectConversation(conversation.id);
            } else {
                Conversation.join({
                    id: conversation.id,
                }, onJoinSuccess, onJoinError);

                function onJoinSuccess(result) {
                    vm.conversations.splice(vm.pinnedIndex, 0, result);
                    vm.selectConversation(result.id);

                    //subscribe to channel
                    ConversationModelService.subscribe(result);

                    //publish conversation to users
                    ConversationModelService.publishNewConversation(vm.userId, result, 'REFRESH_CONVERSATION');

                    ToastService.displayToast($filter('translate')('atheer.conversation.conversationJoined'), 3000);
                };

                function onJoinError() {

                };
            }
        };

        function loadConversation(conversationId) {
            Conversation.get({
                id: conversationId,
            }, onGetSuccess, onGetError);

            function onGetSuccess(result) {
                if (vm.isPinned(result)) {
                    vm.conversations.unshift(result);
                } else {
                    vm.conversations.splice(vm.pinnedIndex, 0, result);
                }
                vm.selectConversation(result.id);

                //subscribe to channel
                ConversationModelService.subscribe(result);
                if (result.type == 'PRIVATE_USER') {
                    vm.addUsersforPrivateGroup(result);
                }

            };

            function onGetError() {

            };
        };

        function updateConversation(conversationId, select) {
            Conversation.get({
                id: conversationId,
            }, onGetSuccess, onGetError);

            function onGetSuccess(result) {
                var conversationIndex = vm.conversations.findIndex(function(conversation) {
                    return conversation.id == result.id;
                });
                vm.conversations[conversationIndex] = result;

                if (select) {
                    if (vm.selectedConversationId == result.id) {
                        var conversationToRefresh = vm.conversations[conversationIndex];

                        // firing an event downwards
                        $rootScope.$broadcast('refreshConversation', conversationToRefresh);
                    }
                }
            };

            function onGetError() {

            };
        }

        function filterConversations(conversations) {
            if(id != null) {
                vm.selectConversation(id);
            }
            vm.isReadingMessages = true;
            getUnReadMessageCount();
            angular.forEach(conversations, function(conversation) {

                var isPinned = false;
                for (var i = 0; i < conversation.users.length; i++) {
                    if (conversation.users[i].user_id == vm.userId && conversation.users[i].pinned) {
                        isPinned = true;
                        break;
                    }
                };

                if (isPinned) {
                    vm.conversations.splice(vm.pinnedIndex, 0, conversation);
                    vm.pinnedIndex++;
                } else {
                    if(conversation.type != 'PRIVATE_USER' && !vm.groupConversationFeature) {
                        return ;
                    }
                    vm.conversations.push(conversation);
                }

                if (conversation.type == 'PRIVATE_USER') {
                    vm.addUsersforPrivateGroup(conversation);
                }
            });
        }

        function loadData() {
            if(vm.selectedConversationId == null || vm.selectedConversationId.length == 0) {
                $state.go('storm.conversations');
            };

            vm.loadingData = true;

            if ($rootScope.isPersonalConv) {
                vm.startPeronsalConversation();
                $rootScope.isPersonalConv = false;
            } else if ($rootScope.isGroupConv) {
                vm.startGroupConversation();
                $rootScope.isGroupConv = false;
            } else if ($rootScope.isJoinConv) {
                vm.joinGroupConversation();
                $rootScope.isJoinConv = false;
            }

            User.getConversations({
                query: getOpenConversationQuery(),
                page: 0,
                size: 100
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                ConversationModelService.init(data);
                filterConversations(data);
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        function getOpenConversationQuery() {
            return "status==OPEN"
        };

        function getUnReadMessageCount() {
            vm.messagesCount = 0;
            Experience.getUnReadMessageCount({
                id: vm.userId
            }, function(unreadMessagesList) {
                angular.forEach(unreadMessagesList, function(unreadMessage) {
                    angular.forEach(vm.conversations, function(conversation) {
                        if(unreadMessage && unreadMessage.object && conversation.id == unreadMessage.object.id) {
                            conversation.unread_message_count = unreadMessage.properties.count;
                            vm.messagesCount = vm.messagesCount + unreadMessage.properties.count;
                            $rootScope.$broadcast('messageCount', vm.messagesCount);
                        }
                    });
                });
                if(vm.isReadingMessages) {
                    vm.isReadingMessages = false;
                    getReadMessages();
                }
            });
        };

        function getReadMessages() {
            Experience.getReadMessages({
                userId: vm.userId,
                conversationId: vm.selectedConversationId
            }, function(readMessage) {
                angular.forEach(vm.conversations, function(conversation) {
                    if(conversation.id == readMessage.object.id) {
                        vm.messagesCount = vm.messagesCount - conversation.unread_message_count;

                        conversation.unread_message_count = readMessage.properties.count;
                        $rootScope.$broadcast('messageCount', vm.messagesCount);
                    }
                })
            });
        };
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .directive('conversationInfo', conversationInfo);

    function conversationInfo() {
        var directive = {
            scope: {
                conversationModel: '='
            },
            bindToController: true,
            controller: conversationInfoController,
            controllerAs: 'vm',
            templateUrl: 'modules/conversation/conversation-info.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function conversationInfoController($scope, $mdDialog, $mdSidenav, $location, $mdToast, Message, Content, $document, $mdPanel, $state, $timeout, $q, $filter, ParseLinks, Principal, Conversation, AlertService, triSettings) {
        var vm = this;

        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;

        vm.loadingData = false;
        vm.showConversationDetail = true;
        vm.showPinned = false;
        vm.showSharedContent = false;
        vm.showSharedFiles = false;
        vm.showMembers = false;
        vm.groupName = null;
        vm.purpose = null;
        vm.pinnedMessages = [];
        vm.contentMessageIds = [];
        vm.contentMessages = [];
        vm.userInfo = [];
        vm.conversationId = vm.conversationModel.id;

        vm.getUserImageUrl = function(user_info) {
            return user_info.picture_id ? '/media/pictures/' + user_info.picture_id : 'assets/images/avatars/user-avatar.png';
        };

        vm.close = function() {
            // firing an event downwards
            $scope.$emit('conversationMessageInternal', {
                type: 'CLOSE_CONVERSATION_INFO'
            });
        };

        vm.checkForUpdate = function() {
            if (vm.conversationId != vm.conversationModel.id) {
                vm.conversationId = vm.conversationModel.id;
                vm.groupName = null;
                vm.purpose = null;
                vm.pinnedMessages = [];
                vm.contentMessageIds = [];
                vm.contentMessages = [];
                vm.userInfo = [];
                loadData();
            }

            return true;
        }

        vm.editConversation = function() {
            // firing an event downwards
            $scope.$emit('conversationMessageInternal', {
                type: 'EDIT_CONVERSATION'
            });
        };

        vm.inviteUsersToConversation = function() {
            // firing an event downwards
            $scope.$emit('conversationMessageInternal', {
                type: 'CONVERSATION_ADD_USERS'
            });
        };

        function transformMessage(message) {
            if (vm.conversationModel.type == 'PRIVATE_USER') {
                if (message.publisher_id == vm.userId) {
                    message.user_info = {
                        publisher_name: Principal.getUserInfo().first_name + ' ' + Principal.getUserInfo().last_name
                    };
                } else {
                    message.user_info = {
                        publisher_name: vm.conversationModel.user_info.first_name + ' ' + vm.conversationModel.user_info.last_name
                    };
                }
            } else {
                var userInfo = $filter('filter')(vm.conversationModel.users_info, {
                    id: message.publisher_id
                })[0];
                message.user_info = {
                    publisher_name: userInfo.first_name + ' ' + userInfo.last_name
                };
            }

            return message;
        };

        function updateContentMessages() {
            if (vm.contentMessageIds.length > 0) {
                Content.getConversationContents({
                    query: 'id=in=(' + vm.contentMessageIds + ')',
                }, function(response, headers) {
                    response.forEach(function(item) {
                        vm.contentMessages.push(item);
                    })
                })
            }
        };

        function updateUserInfo() {
            if (vm.conversationModel.type != "PRIVATE_USER") {
                var currentIds = [];
                for (var i = 0; i < vm.conversationModel.users_info.length; i++) {
                    for (var j = 0; j < vm.conversationModel.users.length; j++) {
                        if (vm.conversationModel.users[j].user_id ==  vm.conversationModel.users_info[i].id && !vm.conversationModel.users[j].left) {
                            var exist = false;
                            for (var k = 0; k < currentIds.length; k++) {
                                if (currentIds[k] == vm.conversationModel.users_info[i].id) {
                                    exist = true;
                                    break;
                                }
                            }
                            if (!exist) {
                                vm.userInfo.push(vm.conversationModel.users_info[i])
                                currentIds.push(vm.conversationModel.users_info[i].id)
                            }
                        }
                    }
                }
            }
        }

        function loadData() {
            vm.loadingData = true;
            $q.all([
                    Message.getPinned({
                        query: "conversationId==" + vm.conversationModel.id,
                        sort: "created_on,desc",
                    }).$promise,
                    Message.get({
                        query: "conversationId==" + vm.conversationModel.id + ";type==CONTENT",
                        sort: "created_on,desc",
                    }).$promise
                ])
                .then(function(results) {
                    angular.forEach(results[0], function(message) {
                        vm.pinnedMessages.push(transformMessage(message));
                    });
                    angular.forEach(results[1], function(message) {
                        vm.contentMessageIds.push(message.body);
                    });
                    angular.forEach(vm.pinnedMessages, function(message) {
                        angular.forEach(results[1], function(contentMessage) {
                            if(message.id === contentMessage.id) {
                                message.content = contentMessage.content;
                            }
                        });
                    });
                    updateContentMessages();
                    updateUserInfo();
                    vm.loadingData = false;
                });
        };

        loadData();
    };
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationGroupPickerController', ConversationGroupPickerController);

    /* @ngInject */
    function ConversationGroupPickerController($scope, $state, User, allowMultiSelect, filter, Conversation, ParseLinks, AlertService, $mdDialog, Principal, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.allowMultiSelect = allowMultiSelect;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "id";
        vm.page = 1;

        vm.totalItems = null;
        vm.currentSelectedGroups = [];
        vm.illustartionEmptyScreenId = "group_conv";


        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.getGroupImageUrl = function(group) {
            return group.picture_id ? '/media/pictures/' + group.picture_id : 'assets/images/avatars/group-avatar.png';
        }

        vm.getUsers = function(group) {
            var userInfo = [];
            angular.forEach(group.users_info, function(user_info) {
                userInfo.push(" " + user_info.first_name + " " + user_info.last_name)
            });

            return userInfo.join();
        }

        function loadAll() {
            Conversation.query({
                query: "status==OPEN;type==PUBLIC_GROUP",
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                public_group: true
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groups = data;
                vm.page = 1;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            vm.promise = Conversation.query({
                query: "status==OPEN;type==PUBLIC_GROUP",
                page: vm.page - 1,
                size: vm.query.limit,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                public_group: true,
                search: vm.currentSearch
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.groups = data;
            });
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';

            if (vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedGroups);
        }

        function resetModal() {
            loadAll();
        };

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationGroupController', ConversationGroupController);

    /* @ngInject */
    function ConversationGroupController($scope, $state, $mdDialog, $q, filter, $mdToast, User, Experience, Team, Principal, triSettings, $filter) {
        var vm = this;

        vm.filter = filter;
        vm.asyncUsers = [];
        vm.privateConversation = true;
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;

        vm.froalaOptions = {
            placeholderText: $filter('translate')('global.enterTextHerePlaceholder')
        }

        vm.converationModel = {
            conversation_no: null,
            name: null,
            purpose: null,
            topic: null,
            status: 'OPEN',
            type: 'PRVIATE_GROUP',
            users: [],
            picture_id: null
        };

        vm.converationModel = filter == null ? vm.converationModel : angular.copy(filter);
        if (vm.converationModel.type == 'PRIVATE_GROUP') {
            vm.privateConversation = true;
        } else {
            vm.privateConversation = false;
        };


        vm.getGroupProfileImageUrl = function() {
            return vm.loadingData ? 'assets/images/avatars/group-avatar.png' : vm.converationModel.picture_id ? '/media/pictures/' + vm.converationModel.picture_id : 'assets/images/avatars/group-avatar.png';
        }

        vm.updateGroupProfileImage = function(mediaId, responseObj) {
            vm.converationModel.picture_id = mediaId;
        }

        vm.removeGroupProfileImage = function() {
            vm.converationModel.picture_id = undefined;
        }

        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.submit = function() {
            if (vm.privateConversation) {
                vm.converationModel.type = 'PRIVATE_GROUP';
            } else {
                vm.converationModel.type = 'PUBLIC_GROUP';
            };

            vm.converationModel.users.push({
                user_id: Principal.getUserId(),
                role: 'OWNER'
            });

            angular.forEach(vm.asyncUsers, function(user) {
                vm.converationModel.users.push({
                    user_id: user.id,
                    role: 'MEMBER'
                });
            });

            $mdDialog.hide(vm.converationModel);
        };
    };
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationDetailController', ConversationDetailController);

    /* @ngInject */
    function ConversationDetailController($rootScope, $scope, $state, $q, $filter, Principal, Conversation, AlertService, $mdDialog, $mdToast, id, ConversationModelService, ConversationTypingService, triSettings, ToastService, deviceDetector) {
        var vm = this;

        vm.permissions = {
            create1on1: 'create-1-on-1-conversation',
            createGroup: 'create-group-conversation',
            update: 'update-conversation',
        };

        var refreshConversationListener = null;
        var conversationMessageInternalListener = null;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.userId = Principal.getUserId();
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.conversation = null;
        vm.conversationId = id;

        vm.invitedUserIds = [];
        vm.showConversationInfo = false;

        vm.getConverstionImageUrl = function (conversation) {
            if (conversation.type == 'PRIVATE_USER') {
                return conversation.user_info.picture_id ? '/media/pictures/' + conversation.user_info.picture_id : 'assets/images/avatars/user-avatar.png';
            } else if (conversation.type == 'PRIVATE_GROUP') {
                return conversation.picture_id ? '/media/pictures/' + conversation.picture_id : 'assets/images/avatars/group-avatar.png';
            } else if (conversation.type == 'PUBLIC_GROUP') {
                return conversation.picture_id ? '/media/pictures/' + conversation.picture_id : 'assets/images/avatars/group-avatar.png';
            } else if (conversation.type == 'PRIVATE_AUDIENCE') {
                return conversation.picture_id ? '/media/pictures/' + conversation.picture_id : 'assets/images/avatars/group-avatar.png';
            };
        };

        vm.getUserInfoMessage = function (message) {
            var user = Principal.getUserInfo();
            return user.first_name + ' ' + user.last_name;
        };

        vm.getConverstionTitle = function (conversation) {
            if (conversation.type == 'PRIVATE_USER') {
                return conversation.user_info.first_name + ' ' + conversation.user_info.last_name;
            } else if (conversation.type == 'PRIVATE_GROUP') {
                return conversation.name;
            } else if (conversation.type == 'PUBLIC_GROUP') {
                return conversation.name;
            } else if (conversation.type == 'PRIVATE_AUDIENCE') {
                return conversation.name;
            };
        };

        vm.getConverstionLastMessage = function (conversation) {
            if (conversation && conversation.last_message) {
                return conversation.last_message.body;
            }
        };

        vm.inviteUsersToConversation = function () {
            vm.invitedUserIds = [];
            if (vm.invitedUserIds.length == 0 && vm.conversation && vm.conversation.users) {
                for (var i = 0; i < vm.conversation.users.length; i++) {
                    if (vm.conversation.users[i].left == false) {
                        vm.invitedUserIds.push(vm.conversation.users[i].user_id);
                    }
                }
            }

            $mdDialog.show({
                templateUrl: 'modules/user/user-picker.tmpl.html',
                controller: 'UserPickerController',
                controllerAs: 'vm',
                locals: {
                    filter: vm.invitedUserIds,
                    allowMultiSelect: true,
                    userslist: [],
                    isSession: false,
                    isAdmin: false,
                    isScheduledSession: false,
                    isConversationSession: false,
                    isSmartScan: false
                }
            })
                .then(function (selectedItems) {
                    var invitingUsers = [];
                    for (var i = 0; i < selectedItems.length; i++) {
                        vm.invitedUserIds.push(selectedItems[i].id);
                        invitingUsers.push(selectedItems[i].id);
                    }
                    inviteGroupConversationUsers(invitingUsers)
                });
        };

        vm.deleteConversation = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.conversation.deleteThisConversation'))
                .ariaLabel($filter('translate')('atheer.conversation.deleteThisConversation'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                Conversation.delete({
                    id: vm.conversation.id
                }, function () {
                    var message = {
                        id: vm.conversation.id
                    };

                    ConversationModelService.publishConvMessage(vm.conversationId, 'CONVERSATION_DELETED', message);

                    //unsubscribe to channel
                    ConversationModelService.unSubscribe(vm.conversation);

                    $scope.$emit('conversationMessageInternal', {
                        type: 'CONVERSATION_DELETED',
                        id: vm.conversation.id
                    });

                    AlertService.displayToast($mdToast);
                });
            });
        };

        vm.archiveConversation = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.conversation.archiveThisConversation'))
                .ariaLabel($filter('translate')('atheer.conversation.archiveThisConversation'))
                .ok($filter('translate')('entity.action.archive'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                Conversation.archive({
                    id: vm.conversation.id
                }, function () {
                    var message = {
                        id: vm.conversation.id
                    };

                    ConversationModelService.publishConvMessage(vm.conversationId, 'CONVERSATION_ARCHIVED', message);

                    $scope.$emit('conversationMessageInternal', {
                        type: 'CONVERSATION_ARCHIVED',
                        id: vm.conversation.id
                    });
                });
            });
        };

        vm.isPinned = function () {
            if (vm.conversation && vm.conversation.users.length > 0) {
                for (var i = 0; i < vm.conversation.users.length; i++) {
                    if (vm.conversation.users[i].user_id == vm.userId && vm.conversation.users[i].pinned) {
                        return true;
                    }
                };
            }

            return false;
        }

        vm.pinConversation = function () {
            Conversation.pin({
                id: vm.conversation.id
            }, function () {
                ToastService.displayToast($filter('translate')('atheer.conversation.conversationPinned'), 3000);

                var message = {
                    id: vm.conversation.id
                };

                ConversationModelService.publishConvMessage(vm.conversationId, 'CONVERSATION_PINNED', message);

                $scope.$emit('conversationMessageInternal', {
                    type: 'CONVERSATION_PINNED',
                    id: vm.conversation.id
                });
            });
        }

        vm.startSession = function () {
            $mdDialog.show({
                templateUrl: 'modules/session/session-start-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "SessionStartController",
                controllerAs: "vm",
                locals: {
                    filter: vm.conversation.type == 'PRIVATE_USER' ? "private_conversation" : "group_conversation",
                    conversation: vm.conversation,
                    isMobileBrowser: deviceDetector.isMobile()
                }
            }).then(function (result) {

            });
        };

        vm.unPinConversation = function () {
            Conversation.unpin({
                id: vm.conversation.id
            }, function () {
                ToastService.displayToast($filter('translate')('atheer.conversation.conversationUnpinned'), 3000);

                var message = {
                    id: vm.conversation.id
                };

                ConversationModelService.publishConvMessage(vm.conversationId, 'CONVERSATION_UNPINNED', message);

                $scope.$emit('conversationMessageInternal', {
                    type: 'CONVERSATION_UNPINNED',
                    id: vm.conversation.id
                });
            });
        }

        vm.leaveConversation = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.conversation.leaveThisConversation'))
                .ariaLabel($filter('translate')('atheer.conversation.leaveThisConversation'))
                .ok($filter('translate')('entity.action.leave'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                var userIDs = [vm.userId];
                Conversation.leave({
                    id: vm.conversation.id,
                    users: userIDs
                }, function () {
                    var message = {
                        id: vm.conversation.id
                    };

                    ConversationModelService.publishConvMessage(vm.conversationId, 'CONVERSATION_USER_LEFT', message);

                    $scope.$emit('conversationMessageInternal', {
                        type: 'CONVERSATION_USER_LEFT',
                        id: vm.conversation.id
                    });
                });
            });
        };

        vm.editGroupConversation = function () {
            $mdDialog.show({
                templateUrl: 'modules/conversation/conversation-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "ConversationGroupController",
                controllerAs: "vm",
                locals: {
                    filter: vm.conversation
                }
            }).then(function (conversation) {
                vm.conversation = conversation;
                updateGroupConversation(conversation);
            }).finally(function () { });
        };

        // watches
        //calls when hit menu on sidebar to open sub menus in side bar
        refreshConversationListener = $rootScope.$on('refreshConversation', function (event, conversation) {
            vm.conversation = conversation;
            vm.conversationId = vm.conversation != null ? vm.conversation.id : null;
            if (vm.conversation != null) {
                initTypingSevice();
            }
        });

        conversationMessageInternalListener = $rootScope.$on('conversationMessageInternal', function (event, messageInfo) {
            if (messageInfo.type == 'CLOSE_CONVERSATION_INFO') {
                vm.showConversationInfo = false;
            } else if (messageInfo.type == 'CONVERSATION_ADD_USERS') {
                vm.inviteUsersToConversation();
            } else if (messageInfo.type == 'EDIT_CONVERSATION') {
                vm.editGroupConversation();
            };
        });

        // Unregister
        $scope.$on('$destroy', function () {
            refreshConversationListener = null;
            conversationMessageInternalListener = null;
            ConversationModelService.destroy();
        });

        function updateGroupConversation(conversation) {
            Conversation.update(conversation, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                ConversationModelService.publishNewConversation(vm.userId, result, 'REFRESH_CONVERSATION');

                ToastService.displayToast($filter('translate')('atheer.conversation.conversationUpdated'), 3000);

                $scope.$emit('conversationMessageInternal', {
                    type: 'CONVERSATION_UPDATED',
                    conversation: vm.conversation
                });
            };

            function onSaveError() {

            };
        };

        function inviteGroupConversationUsers(userIds) {
            Conversation.invite({
                id: vm.conversation.id,
                users: userIds
            }, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                ConversationModelService.publishNewConversation(vm.userId, result, 'REFRESH_CONVERSATION');

                ToastService.displayToast(userIds.length + $filter('translate')('atheer.conversation.participantsInvited'), 3000);

                vm.conversation = result;
                $scope.$emit('conversationMessageInternal', {
                    type: 'CONVERSATION_UPDATED',
                    conversation: result
                });
            };

            function onSaveError() {
                AlertService.displayToast($mdToast);
            };
        };

        function initTypingSevice() {
            ConversationTypingService.init(vm.conversation);
        };

        function loadData() {
            if (ConversationModelService.isInitialized()) {
                vm.conversation = ConversationModelService.getConversations()[0];
                if (vm.conversation != null) {
                    initTypingSevice();
                }
            } else {
                if (id) {
                    vm.loadingData = true;
                    $q.all([
                        Conversation.get({
                            id: id
                        }).$promise,
                    ])
                        .then(function (results) {
                            vm.conversation = results[0];
                            initTypingSevice();
                            vm.loadingData = false;
                        });
                } else {
                    vm.conversation = null;
                    vm.loadingData = false;
                };
            }
        };
        loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationAudioRecordController', ConversationAudioRecordController);

    /* @ngInject */
    function ConversationAudioRecordController(mdPanelRef, $state, $timeout, Upload, recorderService) {
        var vm = this;

        vm.recordedAudio = null;
        vm.audioStatus = 'RECORD';
        vm.processStatus = 'IDLE';
        vm.uploadPercentage = 0;
        vm.media = null;

        vm.close = function() {
            recorderService.refresh();
            mdPanelRef.close();
        };

        vm.save = function() {
            vm.audioFile = vm.recordedAudio;
            vm.audioFile.name = 'audio_recording_' + generateUuid() + ".wav";
            vm.audioStatus = 'PROCESS';
            vm.processStatus = 'PROCESSING';

            Upload.upload({
                url: 'api/media/upload',
                data: {
                    'file': vm.audioFile,
                    'type': 'audio'
                },
                arrayKey: ''
            }).then(function(resp) {
                vm.media = resp.data;
                mdPanelRef.media = vm.media;
                mdPanelRef.send = true;
                mdPanelRef.close();
                vm.processStatus = 'COMPLETE';
            }, function(resp) {
                vm.processStatus = 'FAILED';
            }, function(evt) {
                vm.uploadPercentage = parseInt(100.0 * evt.loaded / evt.total);
            });
        }

        function generateUuid() {
            function _p8(s) {
                var p = (Math.random().toString(16) + "000000000").substr(2, 8);
                return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
            }

            return _p8() + _p8(true) + _p8(true) + _p8();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationAudioRecordDialogController', ConversationAudioRecordDialogController);

    /* @ngInject */
    function ConversationAudioRecordDialogController($mdDialog, $state, $timeout, Upload, recorderService) {
        var vm = this;

        vm.recordedAudio = null;
        vm.audioStatus = 'RECORD';
        vm.processStatus = 'IDLE';
        vm.uploadPercentage = 0;
        vm.media = null;

        vm.close = function() {
            recorderService.refresh();
            $mdDialog.cancel();
        };

        vm.save = function() {
            vm.audioFile = vm.recordedAudio;
            vm.audioFile.name = 'audio_recording_' + generateUuid() + ".wav";
            vm.audioStatus = 'PROCESS';
            vm.processStatus = 'PROCESSING';

            Upload.upload({
                url: 'api/media/upload',
                data: {
                    'file': vm.audioFile,
                    'type': 'audio'
                },
                arrayKey: ''
            }).then(function(resp) {
                vm.media = {
                    media: resp.data,
                    isSend: true
                }
                $mdDialog.hide(vm.media);
                vm.processStatus = 'COMPLETE';
            }, function(resp) {
                vm.processStatus = 'FAILED';
            }, function(evt) {
                vm.uploadPercentage = parseInt(100.0 * evt.loaded / evt.total);
            });
        }

        function generateUuid() {
            function _p8(s) {
                var p = (Math.random().toString(16) + "000000000").substr(2, 8);
                return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
            }

            return _p8() + _p8(true) + _p8(true) + _p8();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer')
        .directive('fpConvMessageAudioPlayer', fpConvMessageAudioPlayer);

    function fpConvMessageAudioPlayer() {
        var directive = {
            restrict: 'E',
            controller: fpConvMessageAudioPlayerController,
            scope: {
                audioId: '=',
                mine: '=',
                isPinned: '='
            },
            templateUrl: 'modules/conversation/conversation-audio-message.tmpl.html',
            link: function($scope, $element, $attrs) {
                $element.css('display', 'block');
            }
        };
        return directive;
    }

    /* @ngInject */
    function fpConvMessageAudioPlayerController($scope, $timeout, $attrs, $injector, $filter, $q, $mdDialog, triSettings) {
        $scope.wavesurfer = null;
        $scope.playing = false;

        var secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        var waveColor = '#D9DCFF';
        if (!$scope.mine) {
            waveColor = '#1F1C2C';
        }

        var containerId = $scope.isPinned ? '#aud-' + $scope.audioId + '-pinned' : '#aud-' + $scope.audioId;

        var options = {
            container: containerId,
            waveColor: waveColor,
            progressColor: secondaryColor,
            cursorColor: secondaryColor,
            barWidth: 3,
            barHeight: 2,
            barRadius: 3,
            cursorWidth: 1,
            height: 30,
            barGap: 3,
        };

        $scope.play = function() {
            $scope.wavesurfer.play();
            $scope.playing = true;
        };

        $scope.pause = function() {
            $scope.wavesurfer.pause();
            $scope.playing = false;
        };

        $timeout(function() {
            $scope.wavesurfer = WaveSurfer.create(options);

            if ($attrs.url) {
                $scope.wavesurfer.load($attrs.url, $attrs.data || null);
            }
            $scope.$emit('wavesurferInit', $scope.wavesurfer);

            $scope.wavesurfer.on('finish', function() {
                $scope.playing = false;
                $scope.wavesurfer.seekTo(0);
                $scope.$apply();
            });

        }, 100);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('VideoDetailController', VideoDetailController)
        .controller('VideoViewController', VideoViewController)
        .controller('VideoFeedbackController', VideoFeedbackController)

    /* @ngInject */
    function VideoFeedbackController($scope, $mdBottomSheet) {

    }

    /* @ngInject */
    function VideoViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.player_id = 'atheer-player-' + Math.floor(Math.random() * (100000 - 1000 + 1)) + 1000;

        if (!$scope.data.data.external_video) {
            $scope.videoSettings = {
                playlist: [{
                    file: '/media/videos/' + $scope.data.data.source_media.id + '/' + $scope.data.data.source_media.properties.file_name
                }],
                autostart: false,
                width: "100%",
                aspectratio: "16:9",
                skin: {
                    name: "atheer"
                },
                playbackRateControls: true,
                playbackRates: [0.25, 0.75, 1, 1.25, 1.5, 2, 3, 4]
            }
        }

        $scope.showFeedback = function(firstTime) {
            $mdBottomSheet.show({
                templateUrl: 'modules/content/video-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'VideoFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }
    }

    /* @ngInject */
    function VideoDetailController($scope, $timeout, $controller, id, Content, $sce, poller, $resource) {

        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "video"
        });
        angular.extend(this, basectrl);

        var vm = this;

        vm.uploadStatus = 'idle';
        vm.selectVideoProviders = false;
        vm.extractStatus = 'IDLE';
        vm.processStatus = 'IDLE';
        vm.isExternalVideo = false;
        vm.fileMaxSize = 500 * 1024 * 1024;

        vm.createVideo = function(mediaId, responseObj) {
            vm.processStatus = 'UPLOADED';

            vm.contentModel.title = responseObj.name;
            vm.contentModel.data.source_media = responseObj;
            vm.contentModel.data.video_status = 'UPLOADED';
            vm.contentModel.external_id = responseObj.external_id;

            vm.save();

            vm.checkVideoStatus();
        }

        $scope.$watch('vm.contentModel', function(newVal) {
            if (!vm.isNew()) {
                vm.checkVideoStatus();
            }
        });

        vm.checkVideoStatus = function() {
            if ((vm.contentModel.data.video_status == 'UPLOADED' || vm.contentModel.data.video_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.video_status;

                // Get poller.
                var videoStatusPoller = poller.get(Content, {
                    action: 'get',
                    delay: 3000,
                    argumentsArray: [{
                        id: vm.contentModel.id
                    }],
                    smart: true
                });

                videoStatusPoller.promise.then(null, null, function(result) {
                    if (result.data.video_status == 'READY') {
                        poller.stopAll();
                        vm.processStatus = 'COMPLETE';
                        $timeout(function() {
                            vm.processStatus = 'READY';
                            vm.contentModel = result;
                        }, 2000);
                    }
                    if (result.data.video_status == 'FAILED') {
                        poller.stopAll();
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.video_status;
            }
        }

        vm.extractVideoDetails = function() {
            vm.isExternalVideo = true;
            vm.extractStatus = 'EXTRACTING';

            $timeout(function() {
                vm.extractVideoData();
            }, 2000);
        }

        vm.extractVideoData = function() {
            vm.promise = Content.oembed({
                url: vm.contentModel.data.source_url
            }).$promise;

            vm.promise.then(function(result, headers) {
                if (angular.isDefined(result.title) && result.title != null && result.title.length > 0) {
                    vm.contentMetaData.show_tags = true;

                    vm.contentModel.title = result.title;
                    vm.contentModel.description = result.description;
                    vm.contentModel.data.external_video = true;
                    vm.contentModel.data.oembed_id = result.id;
                    vm.contentModel.data.extract_id = result.extract_id;
                    vm.contentModel.data.provider = result.provider;
                    vm.contentModel.tags = result.tags;
                    vm.contentModel.data.use_custom_thumbnail = true;
                    vm.contentModel.data.video_status = "READY";
                    vm.contentModel.data.progress = 100;
                    vm.contentModel.data.thumbnail_url = result.thumbnail_url;
                    //strip width and height to make it responsive
                    vm.contentModel.data.embed_code = result.html.replace(/width=\"[0-9]+\"/g, '').replace(/height=\"[0-9]+\"/g, '');
                    vm.extractStatus = 'COMPLETE';

                    $timeout(function() {
                        vm.save();
                        vm.extractStatus = 'READY';
                    }, 2000);

                } else {
                    vm.extractStatus = 'INCOMPLETE';

                    $timeout(function() {
                        vm.extractStatus = 'READY';
                    }, 2000);
                }
            }, function(error) {
                vm.extractStatus = 'ERROR';

                $timeout(function() {
                    vm.extractStatus = 'READY';
                }, 2000);
            });
        }

        vm.useEmbedCode = function() {
            vm.isExternalVideo = true;
            vm.extractStatus = 'EXTRACTING';

            $timeout(function() {
                vm.extractEmbedData();
            }, 1000);
        }

        vm.extractEmbedData = function() {
            vm.contentMetaData.show_tags = true;

            vm.contentModel.title = "Untitled";
            vm.contentModel.description = null;
            vm.contentModel.data.external_video = true;
            vm.contentModel.data.oembed_id = null;
            vm.contentModel.data.extract_id = null;
            vm.contentModel.data.provider = null;
            vm.contentModel.tags = null;
            vm.contentModel.data.use_custom_thumbnail = true;
            vm.contentModel.data.video_status = "READY";
            vm.contentModel.data.progress = 100;
            vm.contentModel.data.thumbnail_url = null;
            //strip width and height to make it responsive
            vm.contentModel.data.embed_code = vm.contentModel.data.embed_code.replace(/width=\"[0-9]+\"/g, '').replace(/height=\"[0-9]+\"/g, '');

            vm.extractStatus = 'COMPLETE';

            $timeout(function() {
                vm.save();
                vm.extractStatus = 'READY';
            }, 1000);
        }

        vm.disableEmbedSubmit = function() {
            if (vm.contentModel.data.embed_code == null || vm.contentModel.data.embed_code.length <= 0) {
                return true;
            } else {
                return false;
            }
        }

        vm.disableVideoProviderSubmit = function() {
            if (vm.contentModel.data.source_url == null || vm.contentModel.data.source_url.length <= 0) {
                return true;
            } else {
                return false;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('SmartPageDetailController', SmartPageDetailController)
        .controller('SmartPageViewController', SmartPageViewController)
        .controller('SmartPageFeedbackController', SmartPageFeedbackController)

    /* @ngInject */
    function SmartPageFeedbackController($scope, $mdBottomSheet) {

    }

    /* @ngInject */
    function SmartPageViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.showFeedback = function(firstTime) {
            $mdBottomSheet.show({
                templateUrl: 'modules/content/smart-page-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'SmartPageFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }

    }

    /* @ngInject */
    function SmartPageDetailController($scope, $controller, id, $mdDialog, Feature, ContentAction, $filter, $stateParams, $state) {
        this.isFroalaOptionsSet = false;
        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "smart-page"
        });
        angular.extend(this, basectrl);

        var vm = this;

        vm.showSettings = true;

        vm.previewContent = function() {
            ContentAction.previewContent(vm.contentModel);
        };

        vm.froalaOptions = {
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quote', 'save', 'table', 'url', 'video'],
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'quote', 'insertHR', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html', 'applyFormat', 'removeFormat', 'fullscreen', 'print', 'help'],
            toolbarButtonsMD: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'quote', 'insertHR', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html', 'applyFormat', 'removeFormat', 'fullscreen', 'print', 'help'],
            toolbarButtonsSM: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'quote', 'insertHR', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html', 'applyFormat', 'removeFormat', 'fullscreen', 'print', 'help'],
            toolbarButtonsXS: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'quote', 'insertHR', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html', 'applyFormat', 'removeFormat', 'fullscreen', 'print', 'help'],
            charCounterMax: -1,
            heightMin: 625,
            heightMax: 625,
            pastePlain: true,
            placeholderText: $filter('translate')('global.enterTextHerePlaceholder')
        }

        if(Feature.isActive('feature_system_adv_image_edit')) {
            vm.froalaOptions.pluginsEnabled.push('imageAviary');
        }
        vm.isFroalaOptionsSet = true;

        vm.goBack = function() {
            if($stateParams.isDeeplink) {
                window.history.go(-2);
            } else {
                $state.go('storm.admin-contents');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('SessionRecordingDetailController', SessionRecordingDetailController)
        .controller('SessionRecordingViewController', SessionRecordingViewController)
        .controller('SessionRecordingFeedbackController', SessionRecordingFeedbackController)

    /* @ngInject */
    function SessionRecordingFeedbackController($scope, $mdBottomSheet) {
    }

    /* @ngInject */
    function SessionRecordingViewController($scope, $timeout, $controller, $mdBottomSheet) {
        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.player_id = 'atheer-player-' + Math.floor(Math.random() * (100000 - 1000 + 1)) + 1000;
        $scope.isLoaded = false;

        $timeout(function() {
            $scope.videoSettings = {
                playlist: [{
                    file: '/media/session-recordings/' + $scope.data.data.source_media.id + '/' + $scope.data.data.source_media.properties.file_name
                }],
                autostart: false,
                width: "100%",
                aspectratio: "16:9",
                skin: {
                    name: "atheer"
                },
                playbackRateControls: true,
                playbackRates: [0.25, 0.75, 1, 1.25, 1.5, 2, 3, 4]
            }
            $scope.isLoaded = true;
        }, 1000);

        $scope.showFeedback = function(firstTime) {
            $mdBottomSheet.show({
                templateUrl: 'modules/content/session-recording-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'SessionRecordingFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }
    }

    /* @ngInject */
    function SessionRecordingDetailController($scope, $timeout, $controller, $interval, id, Content, poller, $resource) {
        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "session-recording"
        });
        angular.extend(this, basectrl);

        var vm = this;
        vm.uploadStatus = 'idle';
        vm.processStatus = 'IDLE';
        vm.extractStatus = 'IDLE';
        vm.isExternalSessionRecording = false;
        vm.fileMaxSize = 500 * 1024 * 1024;



    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('PodcastFeedbackController', PodcastFeedbackController)

    function PodcastFeedbackController($scope, $mdBottomSheet) {

    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('PodcastDetailController', PodcastDetailController)
        .controller('PodcastViewController', PodcastViewController)
        .controller('PodcastFeedbackController', PodcastFeedbackController)

    /* @ngInject */
    function PodcastFeedbackController($scope, $mdBottomSheet) {

    }

    /* @ngInject */
    function PodcastViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.player_id = 'atheer-player-' + Math.floor(Math.random() * (100000 - 1000 + 1)) + 1000;

        $scope.podcastSettings = null;

        if(!$scope.data.data.external_podcast) {
          $scope.podcastSettings = {
              playlist: [{
                  file: '/media/audios/' + $scope.data.data.source_media.properties.file_name
              }],
              height: 40,
              autostart: false,
              skin: {
                  name: "atheer"
              }
          }
        };

        if($scope.data.tags === undefined) {
            $scope.data.tags = [];
        };

        $scope.showFeedback = function(firstTime) {
            $mdBottomSheet.show({
                templateUrl: 'modules/content/podcast-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'PodcastFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }
    }

    /* @ngInject */
    function PodcastDetailController($scope, $timeout, $controller, id, Content, $sce, poller, $resource) {

        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "podcast"
        });
        angular.extend(this, basectrl);

        var vm = this;

        vm.uploadStatus = 'idle';
        vm.processStatus = 'IDLE';
        vm.extractStatus = 'IDLE';
        vm.isExternalDocument = false;
        vm.fileMaxSize = 500 * 1024 * 1024;

        vm.createPodcast = function(mediaId, responseObj) {
            vm.processStatus = 'UPLOADED';

            vm.contentModel.title = responseObj.name;
            vm.contentModel.description = responseObj.description;
            vm.contentModel.data.source_media = responseObj;
            vm.contentModel.data.podcast_status = 'UPLOADED';
            vm.contentModel.external_id = responseObj.external_id;

            vm.save();

            vm.checkPodcastStatus();
        }

        $scope.$watch('vm.contentModel', function(newVal) {
            if (!vm.isNew()) {
                vm.checkPodcastStatus();
            }
        });

        vm.checkPodcastStatus = function() {
            if ((vm.contentModel.data.podcast_status == 'UPLOADED' || vm.contentModel.data.podcast_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.podcast_status;

                // Get poller.
                var podcastStatusPoller = poller.get(Content, {
                    action: 'get',
                    delay: 3000,
                    argumentsArray: [{
                        id: vm.contentModel.id
                    }],
                    smart: true
                });

                podcastStatusPoller.promise.then(null, null, function(result) {
                    if (result.data.podcast_status == 'READY') {
                        poller.stopAll();
                        vm.processStatus = 'COMPLETE';
                        $timeout(function() {
                            vm.processStatus = 'READY';
                            vm.contentModel = result;
                        }, 2000);
                    }
                    if (result.data.podcast_status == 'FAILED') {
                        poller.stopAll();
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.podcast_status;
            }
        }

        vm.useEmbedCode = function() {
            vm.isExternalPodcast = true;
            vm.extractStatus = 'EXTRACTING';

            $timeout(function() {
                vm.extractEmbedData();
            }, 1000);
        }

        vm.extractEmbedData = function() {
            vm.contentMetaData.show_tags = true;

            vm.contentModel.title = "Untitled";
            vm.contentModel.description = null;
            vm.contentModel.data.external_podcast = true;
            vm.contentModel.tags = null;
            vm.contentModel.data.use_custom_thumbnail = true;
            vm.contentModel.data.podcast_status = "READY";
            vm.contentModel.data.thumbnail_url = null;
            //strip width and height to make it responsive
            vm.contentModel.data.embed_code = vm.contentModel.data.embed_code.replace(/width=\"[0-9]+\"/g, '').replace(/height=\"[0-9]+\"/g, '');

            vm.extractStatus = 'COMPLETE';

            $timeout(function() {
                vm.save();
                vm.extractStatus = 'READY';
            }, 1000);
        }

        vm.disableEmbedSubmit = function() {
            if(vm.contentModel.data.embed_code == null || vm.contentModel.data.embed_code.length <= 0) {
                return true;
            } else {
                return false;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('LinkDetailController', LinkDetailController)
        .controller('LinkViewController', LinkViewController)
        .controller('LinkFeedbackController', LinkFeedbackController)

    /* @ngInject */
    function LinkFeedbackController($scope) {

    }

    /* @ngInject */
    function LinkViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.showFeedback = function(firstTime) {
            $mdBottomSheet.show({
                templateUrl: 'modules/content/link-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'LinkFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }

        $scope.getSpacerHeight = function(id) {
            var element = angular.element(document.querySelector('#fp-content-description-' + id));
            if (element && element[0]) {
                var height = element[0].offsetHeight + ($scope.data.data.thumbnail_url ? 100 : 0);
                if (height > 100) {
                    return 0;
                } else {
                    return 100 - height;
                }
                return height;
            } else {
                return 100;
            }
        }
    }

    /* @ngInject */
    function LinkDetailController($scope, $timeout, $controller, id, Content) {

        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "link"
        });
        angular.extend(this, basectrl);

        var vm = this;

        vm.extractStatus = 'idle';

        vm.isURLInvalid = function() {
            var URL_REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([a-z0-9\-&]*\.)+([a-z]{2,}).*$/i;
            return !URL_REGEX.test(vm.contentModel.data.source_url);
        };

        vm.extractLinkDetails = function() {
            vm.extractStatus = 'extracting';
            if(vm.isURLInvalid())
                return;
            
            $timeout(function() {
                vm.extractLinkData();
            }, 1000);
        };

        vm.extractLinkData = function() {
            vm.promise = Content.extract({
                url: vm.contentModel.data.source_url
            }).$promise;

            vm.promise.then(function(result, headers) {
                if (angular.isDefined(result.title) && result.title != null && result.title.length > 0) {
                    vm.contentMetaData.show_tags = true;

                    vm.contentModel.title = result.title;
                    vm.contentModel.description = result.description;
                    vm.contentModel.external_id = result.external_id;
                    if (result.authors && result.authors.length > 0) {
                        vm.contentModel.data.author = result.authors[0].name;
                    }

                    if (result.images && result.images.length > 0) {
                        vm.contentModel.data.thumbnail_url = result.images[0].url;
                    }

                    vm.contentModel.data.use_custom_thumbnail = true;
                    vm.contentModel.data.provider = result.provider;
                    vm.contentModel.data.link_type = result.type;
                    vm.contentModel.tags = result.tags;
                    vm.contentModel.data.extract_id = result.id;
                    vm.extractStatus = 'complete';

                    $timeout(function() {
                        vm.extractStatus = 'ready';
                        vm.save();
                    }, 2000);

                } else {
                    vm.extractStatus = 'incomplete';

                    $timeout(function() {
                        vm.extractStatus = 'ready';
                    }, 2000);
                }
            }, function(error) {
                vm.extractStatus = 'error';

                $timeout(function() {
                    vm.extractStatus = 'ready';
                }, 2000);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, triMenuProvider) {
        $stateProvider
            .state('storm.launcher', {
                url: '/launcher/:id',
                templateUrl: 'modules/content/launcher.tmpl.html',
                controller: 'LauncherController',
                controllerAs: 'vm',
                data: {
                    layout: {
                        sideMenuSize: 'hidden',
                        footer: false,
                        showToolbar: false,
                        contentClass: 'layout-column'
                    }
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('LauncherController', LauncherController);

    /* @ngInject */
    function LauncherController($rootScope, $scope, $document, $state, $q, Content, Launcher, ContentAction, id, triLoaderService, Principal, $window, deviceDetector, Experience) {
        var vm = this;

        vm.loadingData = true;
        vm.contentId = id;
        vm.contentType;
        vm.contentData;
        vm.assignmentId;
        vm.assignmentData;
        vm.loadingData = false;
        vm.isFullScreen = false;
        vm.fullScreenIcon = 'zmdi zmdi-fullscreen';
        vm.mode = 'play';
        vm.viewData;
        vm.launchTime = new Date();

        vm.device = {
            os: deviceDetector.os,
            device: 'browser',
            browser: deviceDetector.browser,
            os_version: deviceDetector.os_version,
            browser_version: deviceDetector.browser_version
        };

        vm.finishCallBack = function() {
            vm.close();
            $rootScope.$emit("content-player-closed");
        }

        vm.close = function() {
            updateContentViewed();
            window.parent.postMessage({
                closeContent: true
            }, "*");
        };

        vm.toggleFullScreen = function() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit' : 'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
            $scope.$broadcast('toggleFullScreen', vm.isFullScreen);
        }

        function updateAssigment() {
            if (vm.assignmentData != null && vm.assignmentData.status != 'IN_PROGRESS') {
                vm.assignmentData.status = 'IN_PROGRESS';
                vm.assignmentData.started_on = new Date();

                Experience.updateAssignment({
                    id: vm.assignmentData.id
                }, vm.assignmentData, function(result) {
                    vm.assignmentData = result;
                });
            }
        };

        function markContentViewed() {
            Experience.markViewed({
                object: vm.contentData,
                user_id: Principal.getUserId(),
                time_spent: 0,
                device_properties: vm.device
            }, function(result) {
                vm.viewData = result;
            });
        };

        function updateContentViewed() {
            var closeTime = new Date();
            vm.viewData.time_spent = (closeTime - vm.launchTime);
            Experience.updateViewed({
                id: vm.viewData.id
            }, vm.viewData);
        }

        function init() {
            vm.loadingData = true;

            Launcher.getAssignment({
                id: vm.contentId
            }, function(result) {
                vm.contentType = result.object.data.type;
                vm.contentItem = result.object;
                vm.contentData = result.object;
                vm.assignmentId = null;
                vm.assignmentData = result;

                if (result.status != 'COMPLETED') {
                    vm.assignmentId = result.id;
                };

                markContentViewed();
                vm.loadingData = false;
            });
        };
        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ImageDetailController', ImageDetailController)
        .controller('ImageViewController', ImageViewController)
        .controller('ImageFeedbackController', ImageFeedbackController)

    /* @ngInject */
    function ImageFeedbackController($scope, $mdBottomSheet) {
    }

    /* @ngInject */
    function ImageViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.showFeedback = function(firstTime) {

            $mdBottomSheet.show({
                templateUrl: 'modules/content/image-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'ImageFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }
    }

    /* @ngInject */
    function ImageDetailController($scope, $timeout, $controller, $interval, id, Content, poller, $resource) {
        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "image"
        });
        angular.extend(this, basectrl);

        var vm = this;

        vm.uploadStatus = 'idle';
        vm.processStatus = 'IDLE';
        vm.extractStatus = 'IDLE';
        vm.fileMaxSize = 500 * 1024 * 1024;

        vm.createImage = function(mediaId, responseObj) {
            vm.processStatus = 'UPLOADED';

            vm.contentModel.title = responseObj.name;
            vm.contentModel.description = responseObj.description;
            vm.contentModel.data.source_media = responseObj;
            vm.contentModel.data.image_status = 'UPLOADED';
            vm.contentModel.external_id = responseObj.external_id;

            vm.save();

            vm.checkImageStatus();
        }

        $scope.$watch('vm.contentModel', function(newVal) {
            if (!vm.isNew()) {
                vm.checkImageStatus();
            }
        });

        vm.checkImageStatus = function() {
            if ((vm.contentModel.data.image_status == 'UPLOADED' || vm.contentModel.data.image_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.image_status;

                // Get poller.
                var imageStatusPoller = poller.get(Content, {
                    action: 'get',
                    delay: 3000,
                    argumentsArray: [{
                        id: vm.contentModel.id
                    }],
                    smart: true
                });

                imageStatusPoller.promise.then(null, null, function(result) {
                    if (result.data.image_status == 'READY') {
                        poller.stopAll();
                        vm.processStatus = 'COMPLETE';
                        $timeout(function() {
                            vm.processStatus = 'READY';
                            vm.contentModel = result;
                        }, 2000);
                    }
                    if (result.data.image_status == 'FAILED') {
                        poller.stopAll();
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.image_status;
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.content')
        .controller('DocumentDetailController', DocumentDetailController)
        .controller('DocumentViewController', DocumentViewController)
        .controller('DocumentFeedbackController', DocumentFeedbackController)

    /* @ngInject */
    function DocumentFeedbackController($scope, $mdBottomSheet) {
    }

    /* @ngInject */
    function DocumentViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.showFeedback = function (firstTime) {

            $mdBottomSheet.show({
                templateUrl: 'modules/content/document-feedback.tmpl.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'DocumentFeedbackController',
                scope: $scope,
                preserveScope: true,
                parent: '#fp-content-view-' + $scope.data.id + '-' + $scope.context,
                disableParentScroll: true,
                locals: {
                    firstTime: firstTime
                }
            });
        }
    }

    /* @ngInject */
    function DocumentDetailController($scope, $timeout, $controller, $interval, id, Content, poller, $resource, triLoaderService) {
        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "document"
        });
        angular.extend(this, basectrl);

        var vm = this;

        vm.uploadStatus = 'idle';
        vm.processStatus = 'IDLE';
        vm.extractStatus = 'IDLE';
        vm.isDocumentForAI = false;

        vm.isExternalDocument = false;
        vm.fileMaxSize = 500 * 1024 * 1024;
        triLoaderService.setLoaderActive(false);


        vm.createDocument = function (mediaId, responseObj, isRequiredForProcessing, documentTags) {
            vm.processStatus = 'UPLOADED';

            vm.contentModel.title = responseObj.name;
            vm.contentModel.description = responseObj.description;
            vm.contentModel.data.source_media = responseObj;
            vm.contentModel.data.doc_status = 'UPLOADED';
            vm.contentModel.external_id = responseObj.external_id;
            vm.contentModel.process_document = isRequiredForProcessing;
            vm.isDocumentForAI = isRequiredForProcessing;
            vm.contentModel.tags = documentTags;
            vm.save();

            vm.checkDocumentStatus();
        }

        $scope.$watch('vm.contentModel', function (newVal) {
            if (!vm.isNew()) {
                vm.checkDocumentStatus();
            }
        });

        vm.checkDocumentStatus = function () {
            if ((vm.contentModel.data.doc_status == 'UPLOADED' || vm.contentModel.data.doc_status == 'PROCESSING') && vm.contentModel.id) {
                vm.processStatus = vm.contentModel.data.doc_status;

                // Get poller.
                var documentStatusPoller = poller.get(Content, {
                    action: 'get',
                    delay: 3000,
                    argumentsArray: [{
                        id: vm.contentModel.id
                    }],
                    smart: true
                });

                documentStatusPoller.promise.then(null, null, function (result) {
                    if (result.data.doc_status == 'READY') {
                        poller.stopAll();
                        vm.processStatus = 'COMPLETE';
                        
                        $timeout(function () {
                            vm.processStatus = 'READY';
                            vm.contentModel = result;
                            if (vm.isDocumentForAI) {
                                var payload = {
                                    tags: [],
                                    content_ids: [vm.contentModel.id]
                                };
                                Content.processDocument(payload);
                            }
                        }, 2000);
                    }
                    if (result.data.doc_status == 'FAILED') {
                        poller.stopAll();
                        vm.processStatus = 'FAILED';
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.doc_status;
            }
        }

        vm.useEmbedCode = function () {
            vm.isExternalDocument = true;
            vm.extractStatus = 'EXTRACTING';

            $timeout(function () {
                vm.extractEmbedData();
            }, 1000);
        }

        vm.extractEmbedData = function () {
            vm.contentMetaData.show_tags = true;

            vm.contentModel.title = "Untitled";
            vm.contentModel.description = null;
            vm.contentModel.data.external_document = true;
            vm.contentModel.tags = null;
            vm.contentModel.data.use_custom_thumbnail = true;
            vm.contentModel.data.doc_status = "READY";
            vm.contentModel.data.thumbnail_url = null;
            //strip width and height to make it responsive
            vm.contentModel.data.embed_code = vm.contentModel.data.embed_code.replace(/width=\"[0-9]+\"/g, '').replace(/height=\"[0-9]+\"/g, '');

            vm.extractStatus = 'COMPLETE';

            $timeout(function () {
                vm.save();
                vm.extractStatus = 'READY';
            }, 1000);
        }

        vm.disableEmbedSubmit = function () {
            if (vm.contentModel.data.embed_code == null || vm.contentModel.data.embed_code.length <= 0) {
                return true;
            } else {
                return false;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('DidYouKnowDetailController', DidYouKnowDetailController)
        .controller('DidYouKnowViewController', DidYouKnowViewController)

    /* @ngInject */
    function DidYouKnowViewController($scope, $controller, $mdBottomSheet) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.getImageSrc = function() {
            return $scope.showMedia() && $scope.data.media_id ? '/media/images/' + $scope.data.media_id : 'assets/images/card/announcement.svg';
        }

        $scope.getTitleHeight = function() {
            return document.getElementsByClassName('title')[0].clientHeight;
        }

        $scope.getTitleColor = function() {
            if ($scope.data.data.title_color && $scope.data.data.title_color != null) {
                return $scope.data.data.title_color;
            } else {
                return '#343A3A';
            }
        };

        $scope.getContentColor = function() {
            if ($scope.data.data.content_color && $scope.data.data.content_color != null) {
                return $scope.data.data.content_color;
            } else {
                return '#343A3A';
            }
        };
    }

    /* @ngInject */
    function DidYouKnowDetailController($scope, $controller, id, $filter) {

        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id: id,
            content_type: "did-you-know"
        });
        angular.extend(this, basectrl);

        var vm = this;

        $scope.descriptionLimitExceed = false;

        vm.froalaOptions = {
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quote', 'save', 'table', 'url', 'video'],
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            toolbarButtonsMD: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            toolbarButtonsSM: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            toolbarButtonsXS: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            charCounterMax: 255,
            placeholderText: $filter('translate')('atheer.content.announcementsView.content'),
            events: {
                "charCounter.update": function (e) {
                    if (this.el.textContent.length > 255) {
                        $scope.descriptionLimitExceed = true;
                    } else {
                        $scope.descriptionLimitExceed = false;
                    }
                    $scope.$apply();
                },
                "paste.before": function (e) {
                    var pastedPlainData = e.clipboardData.getData("text/plain");
                    this.html.insert(pastedPlainData);
                    this.undo.saveStep();
                    $scope.$apply();
                    return false;
                },
            },
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.content')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, CONTENT_INSIGHT_META, CONTENT_RECOGNITION_META) {
        $stateProvider
            .state('storm.content-view', {
                url: '/content/view/:id',
                views: {
                    '@storm': {
                        templateUrl: 'modules/ngx-frame.html',
                        controller: 'ContentViewController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.content.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 20
                    }
                }
            })
            .state('storm.admin-contents', {
                url: '/content?page&sort&search',
                views: {
                    '@storm': {
                        templateUrl: 'modules/content/content.html',
                        controller: 'ContentController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/content/content-toolbar.tmpl.html',
                        controller: 'ContentToolbarController',
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/content/content-menu.tmpl.html',
                        controller: 'ContentMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.content.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 20
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_on,desc',
                        squash: true
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.content-documents', {
                url: '/content-document?page&sort&search',
                views: {
                    '@storm': {
                        templateUrl: 'modules/ngx-frame.html',
                        controller: 'ContentViewController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.content.documents.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: false,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 20
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-content-detail', {
                url: '/content/:contentType/:id',
                templateUrl: function ($stateParams) {
                    return 'modules/content/' + $stateParams.contentType.replace(/_/g, '-') + '-detail.tmpl.html';
                },
                controllerProvider: function ($stateParams) {
                    var returnStr = $stateParams.contentType.replace(/_/g, '-').replace(/-/g, ' ');
                    returnStr = returnStr.replace(/\w\S*/g, function (txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    });
                    returnStr = returnStr.replace(/ /g, '');
                    return returnStr + 'DetailController as vm';
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    contentType: function ($stateParams) {
                        return $stateParams.contentType;
                    }
                },
                params: {
                    activeTab: null,
                    copy: false,
                    isDeeplink: false
                }
            })
            .state('storm.admin-content-detail-recognition', {
                url: '/content/:contentType/:id/recognition',
                templateUrl: function ($stateParams) {
                    return 'modules/content/content-detail-recognition.tmpl.html';
                },
                controller: 'ContentDetailRecognitionController as vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                abstract: true,
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    content_type: function ($stateParams) {
                        return $stateParams.contentType;
                    }
                }
            })
            .state('storm.admin-content-detail-recognition.section', {
                url: '/:section',
                templateUrl: function ($stateParams) {
                    return CONTENT_RECOGNITION_META[$stateParams.contentType].sections[$stateParams.section || 'qrcode'].template;
                },
                controllerProvider: function ($stateParams) {
                    return CONTENT_RECOGNITION_META[$stateParams.contentType].sections[$stateParams.section || 'qrcode'].controller;
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    content_type: function ($stateParams) {
                        return $stateParams.contentType;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-content-detail-insights', {
                url: '/content/:contentType/:id/insights',
                templateUrl: function ($stateParams) {
                    return 'modules/content/content-detail-insights.tmpl.html';
                },
                controller: 'ContentDetailInsightController as vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                abstract: true,
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    content_type: function ($stateParams) {
                        return $stateParams.contentType;
                    }
                }
            })
            .state('storm.admin-content-detail-insights.section', {
                url: '/:section',
                templateUrl: function ($stateParams) {
                    return CONTENT_INSIGHT_META[$stateParams.contentType].sections[$stateParams.section || 'overview'].template;
                },
                controllerProvider: function ($stateParams) {
                    return CONTENT_INSIGHT_META[$stateParams.contentType].sections[$stateParams.section || 'overview'].controller;
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function ($stateParams) {
                        return $stateParams.id;
                    },
                    content_type: function ($stateParams) {
                        return $stateParams.contentType;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-content-fields', {
                url: '/content/meta-data',
                templateUrl: 'modules/content/content-metadata.tmpl.html',
                // set the controller to load for this page
                controller: 'ContentMetaDataController',
                controllerAs: 'vm',
                // layout-column class added to make footer move to
                // bottom of the page on short pages
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    id: function ($stateParams) {
                        return 'content';
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentController', ContentController);

    /* @ngInject */
    function ContentController($rootScope, $scope, $state, $mdDialog, Content, Folder, ParseLinks, AlertService, ContentAction, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, CONTENT_META, $translate, Feature, ToastService) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.selectMenu = selectMenu;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate =
            !pagingParams.ascending && pagingParams.predicate
                ? "-" + pagingParams.predicate
                : pagingParams.predicate;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.showFolders = true;
        vm.currentSelectedCards = [];
        vm.showBulkAssignAction = false;
        vm.showBulkSendAction = false;
        vm.updateContentListListener = null;
        vm.illustartionEmptyScreenId = "content";
        vm.illustartionEmptyScreenText = "There are no contents yet";

        vm.defaultFolder = {
            id: "default",
            name: "Default",
            description: "Default"
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-created_on',
            page: 1,
            filters: {
                folder: vm.defaultFolder,
                metaType: 'all',
                status: null,
            }
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.deleteObject = deleteObject;
        vm.archiveObject = archiveObject;
        vm.editObject = editObject;
        vm.createObject = createObject;
        vm.getQueryString = getQueryString;

        vm.permissions = {
            create: 'create-content',
            update: 'update-content',
            delete: 'delete-content',
            manage: 'manage-content',
            createFolder: 'manage-folder-content',
            updateFolder: 'manage-folder-content',
            deleteFolder: 'manage-folder-content',
            manageFolder: 'manage-folder-content',
            manageTopic: 'manage-topic-content',
            manageBadge: 'manage-badge-system'
        };

        vm.createMenu = true;
        vm.createMenuOptions = $filter('filter')($filter('orderBy')(CONTENT_META, 'display_order'), {
            category: 'main',
            dispay_in_options: true,
            type: '!session-recording'
        });

        //vm.createMenuOptions = $filter('filter')($filter('orderBy')(vm.createMenuOptions, 'display_order'), {
        //    type: '!session-recording'
        //});

        vm.launchContentPreview = function(content) {
            ContentAction.previewContent(content);
        };

        vm.openBulkEditDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                $mdDialog.show({
                    templateUrl: 'modules/content/content-bulk-edit-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "ContentBulkEditController",
                    controllerAs: "vm",
                    size: 'lg',
                    locals: {
                        contents: vm.currentSelectedCards
                    }
                }).then(function(result) {
                    vm.currentSelectedCards = [];
                });
            }
        }

        vm.openBulkAssignDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                var currentSelectedCardsIds = [];
                angular.forEach(vm.currentSelectedCards, function(currentSelectedCard) {
                    currentSelectedCardsIds.push(currentSelectedCard.id)
                })
                ContentAction.openAssignModal(currentSelectedCardsIds, false, false, function() {
                    vm.currentSelectedCards = [];
                });
            }
        }

        vm.openBulkAssignRemoveDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                var currentSelectedCardsIds = [];
                angular.forEach(vm.currentSelectedCards, function(currentSelectedCard) {
                    currentSelectedCardsIds.push(currentSelectedCard.id)
                })
                ContentAction.openAssignModal(currentSelectedCardsIds, false, true, function() {
                    vm.currentSelectedCards = [];
                });
            }
        }

        vm.getMediaUrl = function(mediaUrl) {
            return $filter('mediaUrl')(mediaUrl);
        }

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        }

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        }

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        }

        vm.convertTypeForBackend = function(type) {
            return type.replace(/-/g, '_')
        }

        vm.copyContent = function(contentId, contentType) {
            $state.go("storm.admin-content-detail", {
                'contentType': contentType.replace(/-/g, '_'),
                'id': contentId,
                'copy': true
            });
        };

        vm.getPredicate = function () {
            if (vm.predicate.startsWith("-")) {
                if (
                    vm.predicate.endsWith(",desc") ||
                    vm.predicate.endsWith(",asc")
                ) {
                    return vm.predicate.substr(1);
                }
                return vm.predicate.substr(1) + ",desc";
            } else {
                if (
                    vm.predicate.endsWith(",desc") ||
                    vm.predicate.endsWith(",asc")
                ) {
                    return vm.predicate;
                } else {
                    return vm.predicate + ",asc";
                }
            }
        };

        function loadAll() {
            vm.loadingData = true;
            var savedQuery = getSavedFilters();
            if ( savedQuery ) {
                vm.query = savedQuery;
            }
            vm.page = vm.query.page;
            Content.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.getPredicate(),
                query: getQueryString(),
                is_web: true,
                is_not_filter: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                //vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Content.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.getPredicate(),
                query: getQueryString(),
                is_web: true,
                is_not_filter: true
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.contents = data;
            });
            vm.query.page = vm.page;
            saveFilters(vm.query);
            vm.query.sort = vm.predicate;
        }

        function getQueryString() {
            var contentQuery = 'embedded==false;type=out=(SMART_CONTENT,EMAIL_LAYOUT);status!=ARCHIVED;';
            var metaTypeStr = vm.query.filters.metaType == 'all' ? '' : ';' + vm.query.filters.metaType;

            contentQuery = contentQuery + 'meta_type!=INFO_CARD' + metaTypeStr;

            if (vm.query.filters.topicId) {
                contentQuery = contentQuery + ';topics=in=' + vm.query.filters.topicId;
            }

            if (vm.query.filters.disabled) {
                contentQuery = contentQuery + ';enabled==false';
            }

            if (vm.query.filter.length > 0) {
                var qs = vm.query.filter;
                var reEscapedStr = String(qs).replace(/([.*+?=^!:${}()|[\]\/\\])/g, '\\$1');
                var reAndQuoteEscapedStr = String(reEscapedStr).replace(/([\\"])/g, '\\$1');
                var quoteEscapedStr = String(qs).replace(/([\\"])/g, '\\$1');
                contentQuery = contentQuery + ';(title=re="' + reAndQuoteEscapedStr + '",description=re="' + quoteEscapedStr + '",tags=re="' + quoteEscapedStr + '")';
            }
            return contentQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function createObject() {
            $state.go("storm.admin-applet-detail");
        }

        function editObject(contentId, contentType) {
            $state.go("storm.admin-content-detail", {
                'contentType': contentType.replace(/-/g, '_'),
                'id': contentId
            });
        }

        function archiveObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.content.archiveObject'))
                .ariaLabel($filter('translate')('atheer.content.archiveObject'))
                .ok($filter('translate')('entity.action.archive'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                entity.status = 'ARCHIVED';

                Content.update(entity, function() {
                    resetModal();
                });
            });
        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.content.deleteObject'))
                .ariaLabel($filter('translate')('atheer.content.deleteObject'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Content.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.openAddFolderModal = function(contentObj) {
            $mdDialog.show({
                templateUrl: 'modules/content/content-folder-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "ContentFolderController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    content: contentObj
                }
            }).then(function() {
                vm.loadAll();
            });
        }

        vm.removeContentFolder = function(contentObj) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.content.removeContentFolder') + vm.selectedFolder.name + '?')
                .ariaLabel($filter('translate')('atheer.content.deleteContentFolder'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Folder.delete({
                    id: folder.id
                }, function() {
                    ToastService.displayToast($filter('triTranslate')('atheer.content.removedSuccessfully'), 3000);
                });
            });
        }

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedCards);
        }

        vm.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        vm.showCopyAction = function(card) {
            return vm.getCardMeta(card).show_copy_action;
        };

        vm.allowInsights = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData.enable_insights;
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
            if (vm.filter.show) {
                vm.showFolders = false;
            }
        };

        vm.clearSelection = function() {
            vm.currentSelectedCards = [];
        };

        vm.seeInsights = function(contentId, contentType) {
            $state.go("storm.admin-content-detail-insights.section", {
                'contentType': contentType,
                'id': contentId,
                'section': 'overview'
            });
        };

        function selectMenu(item) {
            $state.go('storm.admin-content-detail', {
                'contentType': item.type.replace(/-/g, '_')
            });
        }

        function saveFilters(filterData) {
            sessionStorage.setItem('objectFilters', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectFilters'));
        };


        $scope.$watchCollection('vm.currentSelectedCards', function(newVal) {
            vm.showBulkAssignAction = false;
            vm.showBulkSendAction = false;

            angular.forEach(newVal, function(content) {
                if (content.data.type == 'email_template') {
                    vm.showBulkSendAction = true;
                } else {
                    vm.showBulkAssignAction = true;
                }
            });

            $scope.$emit('refreshSelectedCardsToolbar', vm.currentSelectedCards);
        });

        var refreshContentListener = $rootScope.$on('refreshContent', function(event, filter) {
            vm.query.filter = filter;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.query.sort = vm.predicate;
            vm.loadAll();
        });

        //calls when hit menu on sidebar to open sub menus in side bar
        var updateContentListListener = $rootScope.$on('updateContentList', function(event, filters) {
            vm.illustartionEmptyScreenId = "no_content";
            vm.query.filters = filters;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.loadAll();
        });

        var refreshSelectedCardsListing = $rootScope.$on('refreshSelectedCardsListing', function(event, currentSelectedCards) {
            vm.currentSelectedCards = currentSelectedCards;
        });

        // Unregister
        $scope.$on('$destroy', function() {
            updateContentListListener();
            refreshContentListener();
            refreshSelectedCardsListing();
        });

        vm.loadAll();
    }
})();
;
(function () {
    "use strict";

    angular
        .module("atheer.content")
        .controller("ContentViewController", ContentViewController);

    /* @ngInject */
    function ContentViewController($scope, $window, $state, $sce, $location, $rootScope) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.isIFrameDataLoaded = false;

        function setNgxPageUrl() {
            var ngxUrl = null;
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            var path = $location.path();
            $rootScope.selectedLeftNavMenu = 'home';

            if ($state.current.name === "storm.content-documents") {
                $rootScope.selectedLeftNavMenu = 'library';
                const queryParams = JSON.parse(sessionStorage.getItem('DocumentListingQueryParams'));
                var query = []
                if(queryParams && queryParams.hasOwnProperty('page')) {
                    query.push('page='+queryParams.page)
                } 
                if (queryParams && queryParams.hasOwnProperty('size')) {
                    query.push('size='+queryParams.size)
                }
                if (queryParams && queryParams.hasOwnProperty('search')) {
                    query.push('search='+queryParams.search)
                } 
                sessionStorage.removeItem('DocumentListingQueryParams')
                ngxUrl = hostUrl + "/ngx/contents/content-documents?" + query.join('&');
            }
            if ($state.current.name === "storm.content-view") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/contents/" + id;
            }
            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
        }

        function handleNgxEvent(event) {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                if(ngState === "storm.content-view")
                    return;

                if (id == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false,
                    });
                } else {
                    $state.transitionTo(
                        ngState,
                        {
                            id: id,
                        },
                        {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false,
                        }
                    );
                }
            }
            else if(event.data.navigate) {
                var ngState = event.data.navigate.toState;
                var stateParams = event.data.navigate.params;
                sessionStorage.setItem('DocumentListingQueryParams', JSON.stringify(event.data.navigate.params))
                if (stateParams) {
                    if (stateParams.id) {
                        $state.go(ngState, { id: stateParams.id, contentType: 'document' });
                    } else {
                        $state.go(ngState, { contentType: 'document' });
                    }
                }
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        $window.addEventListener("message", handleNgxEvent, false);

        // Unregister
        $scope.$on("$destroy", function () {
            window.removeEventListener("message", handleNgxEvent, false);
        });
        setNgxPageUrl();
    }
})();
;
(function() {
    'use strict';
    angular
        .module('atheer.content')
        .directive('fpContentView', fpContentView);

    function fpContentView($sce, $controller) {
        return {
            template: '<ng-include src="getTemplateUrl()" include-replace/>',
            scope: {
                data: '=?',
                mode: '=',
                context: '=?',
                contextId: '=?',
                contentType: '@',
                templateUrl: '=',
                assignmentId: '=?',
                parentPlayerEvents: "@?",
                doneCallBack: "&?",
                currentResponseData: "=?"
            },
            replace: "true",
            restrict: 'E',
            link: function(scope, element, attrs) {
                var contentTypeReceived = scope.contentType.replace(/_/g, '-').replace(/-/g, ' ');

                function getContentViewControllerName() {
                    var returnStr = contentTypeReceived.replace(/\w\S*/g, function(txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    });
                    returnStr = returnStr.replace(/ /g, '');
                    return returnStr + 'ViewController as vm';
                }

                //If no assignmentId and mode is play then update the mode to be hybrid mode
                //If the content is loaded from smart content then take the mode from the scope as marked in smart content
                if ((!scope.assignmentId || scope.assignmentId == '') && scope.context != 'smart-content' && scope.mode == 'play') {
                    scope.mode = 'hybrid';
                }

                var locals = {
                    $scope: scope,
                    $element: element,
                    $attrs: attrs
                };
                element.data('$Controller', $controller(scope.$eval("'" + getContentViewControllerName() + "'"), locals));
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentToolbarController', ContentToolbarController);

    /* @ngInject */
    function ContentToolbarController($rootScope, $scope, $state, $mdDialog, Content, ContentAction, CONTENT_META, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.currentSelectedCards = [];
        vm.showBulkAssignAction = false;
        vm.showBulkSendAction = false;

        vm.permissions = {
            create: 'create-content',
            update: 'update-content',
            delete: 'delete-content',
            manage: 'manage-content',
            createFolder: 'manage-folder-content',
            updateFolder: 'manage-folder-content',
            deleteFolder: 'manage-folder-content',
            manageFolder: 'manage-folder-content',
            manageTopic: 'manage-topic-content',
            manageBadge: 'manage-badge-system'
        };

        vm.createMenu = true;
        vm.createMenuOptions = $filter('filter')($filter('orderBy')(CONTENT_META, 'display_order'), {
            category: 'main',
            dispay_in_options: true,
            type: '!session-recording'
        });

        vm.query = {
            filter: ''
        };

        if ( getSavedFilters() ) {
            vm.query = getSavedFilters();
        }

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = vm.query.filter.length > 0 ? true : false;
        vm.createObject = createObject;

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        vm.selectMenu = function(item) {
            $state.go('storm.admin-content-detail', {
                'contentType': item.type.replace(/-/g, '_')
            });
        };

        vm.clearSelection = function() {
            vm.currentSelectedCards = [];
            $scope.$emit('refreshSelectedCardsListing', vm.currentSelectedCards);
        };

        vm.openBulkSendDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                var currentSelectedCardsIds = [];
                angular.forEach(vm.currentSelectedCards, function(currentSelectedCard) {
                    currentSelectedCardsIds.push(currentSelectedCard.id)
                })
                ContentAction.openSendModal(currentSelectedCardsIds, function() {
                    vm.currentSelectedCards = [];
                    $scope.$emit('refreshSelectedCardsListing', vm.currentSelectedCards);
                });
            }
        };

        vm.openBulkShareDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                var currentSelectedCardsIds = [];
                angular.forEach(vm.currentSelectedCards, function(currentSelectedCard) {
                    currentSelectedCardsIds.push(currentSelectedCard.id)
                })
                ContentAction.openShareDialog(currentSelectedCardsIds, function() {
                    vm.currentSelectedCards = [];
                    $scope.$emit('refreshSelectedCardsListing', vm.currentSelectedCards);
                });
            }
        };

        var refreshSelectedCardsToolbar = $rootScope.$on('refreshSelectedCardsToolbar', function(event, currentSelectedCards) {
            vm.currentSelectedCards = currentSelectedCards;

            vm.showBulkAssignAction = false;
            vm.showBulkSendAction = false;

            angular.forEach(vm.currentSelectedCards, function(content) {
                if (content.data.type == 'email_template') {
                    vm.showBulkSendAction = true;
                } else {
                    vm.showBulkAssignAction = true;
                }
            });
        });

        // Unregister
        $scope.$on('$destroy', function() {
            refreshSelectedCardsToolbar();
        });

        function refreshAll() {
            saveFilters(vm.query);
            $scope.$emit('refreshContent', vm.query.filter);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            saveFilters(vm.query);
            $scope.$emit('refreshContent', vm.query.filter);
        };

        function createObject() {
            $state.go("storm.admin-content-detail");
        };

        function saveFilters(filterData) {
            sessionStorage.setItem('objectHeader', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectHeader'));
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentShareController', ContentShareController);

    /* @ngInject */
    function ContentShareController($scope, $state, $mdDialog, $q, $filter, $mdToast, User, contents, Experience, Team, Principal) {
        var vm = this;

        vm.asyncUsers = [];
        vm.asyncTeams = [];
        vm.contents = contents;

        vm.shareProgress = 'idle';
        vm.shareSuccess = 0;

        vm.contentShareModel = {
            note: null
        }

        vm.froalaOptions = {
            placeholderText: $filter('translate')('global.enterTextHerePlaceholder')
        }

        vm.close = function() {
            if (vm.shareProgress !== 'idle') {
                $mdDialog.hide();
            } else {
                $mdDialog.cancel();
            }
        }

        vm.submit = function() {
            vm.shareProgress = 'started';

            Experience.bulkShare({
                users: vm.asyncUsers,
                audiences: vm.asyncTeams,
                content_ids: vm.contents,
                note: vm.contentShareModel.note
            }, function(result) {
                vm.shareProgress = 'complete';
                vm.shareSuccess = result.success;
            });
        }

        vm.disableSubmit = function() {
            if (vm.asyncUsers.length <= 0 && vm.asyncTeams.length <= 0) {
                return true;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentSelectorDialogController', ContentSelectorDialogController);

    /* @ngInject */
    function ContentSelectorDialogController($scope, $state, action, $mdDialog) {
        var vm = this;
        vm.action = action;

        if (action == 'Recommend') {
            vm.data = {
                contents: [],
                note: null
            };
        }
        else
        {
            vm.data = {
                contents: [],
                required: false,
                is_due_date_relative: 'true',
                relative_period: 'DAYS',
                relative_value: 5,
                due_on: moment().add(5, 'd').toDate(),
                type: 'TODO',
                note: null
            };
        }


        vm.close = function() {
            $mdDialog.cancel();
        }

        vm.submit = function() {
            $mdDialog.hide(vm.data);
        }
        vm.queryFilter = {
            'Assign': [{ fieldName: 'title', operator: '=re=' }, { fieldName: 'meta_type', operator: '==', value: 'DISCOVERABLE' }],
            'Ask': [{ fieldName: 'title', operator: '=re=' }, { fieldName: 'meta_type', operator: '==', value: 'QUESTION' }],
            'Recommend': [{ fieldName: 'title', operator: '=re=' }, { fieldName: 'meta_type', operator: '==', value: 'DISCOVERABLE' }]
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .filter('contentResponseLabel', contentResponseLabel);

    function contentResponseLabel($filter) {
        return contentResponseLabel;

        function contentResponseLabel(input) {
            if (input.contentModel.data.type == 'yes_no_question') {

                if (input.choice) {
                    return 'Yes';
                } else {
                    return 'No';
                }
            } else if (input.contentModel.data.type == 'true_false_question') {
                if (input.choice) {
                    return 'True';
                } else {
                    return 'False';
                }
            } else if (input.contentModel.data.type == 'legal_question') {
                if (input.choice) {
                    return 'Accepted';
                } else {
                    return 'Not Accepted';
                }
            } else {
                var returnStr = '';
                if (input.choices) {
                    angular.forEach(input.choices, function(choice, index) {
                        if (index != 0) {
                            returnStr += ',';
                        }
                        returnStr += ' ' + ($filter('filter')(input.contentModel.data.choices, {
                            choice_id: choice
                        })[0]).label;
                    })
                } else {
                    returnStr = input.choice;
                }
                return returnStr;
            }
        }
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.content')
        .constant('CONTENT_RECOGNITION_META', {
            'document': {
                'sections': {
                    'qrcode': {
                        label: 'atheer.content.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailRecognitionQRCodeController',
                        template: 'modules/content/content-detail-recognition-qrcode.tmpl.html'
                    }
                }
            },
            'image': {
                'sections': {
                    'qrcode': {
                        label: 'atheer.content.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailRecognitionQRCodeController',
                        template: 'modules/content/content-detail-recognition-qrcode.tmpl.html'
                    }
                }
            },
            'smart_page': {
                'sections': {
                    'qrcode': {
                        label: 'atheer.content.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailRecognitionQRCodeController',
                        template: 'modules/content/content-detail-recognition-qrcode.tmpl.html'
                    }
                }
            },
            'podcast': {
                'sections': {
                    'qrcode': {
                        label: 'atheer.content.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailRecognitionQRCodeController',
                        template: 'modules/content/content-detail-recognition-qrcode.tmpl.html'
                    }
                }
            },
            'video': {
                'sections': {
                    'qrcode': {
                        label: 'atheer.content.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailRecognitionQRCodeController',
                        template: 'modules/content/content-detail-recognition-qrcode.tmpl.html'
                    }
                }
            },
            'link': {
                'sections': {
                    'qrcode': {
                        label: 'atheer.content.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailRecognitionQRCodeController',
                        template: 'modules/content/content-detail-recognition-qrcode.tmpl.html'
                    }
                }
            },
            'session_recording': {
                'sections': {
                    'qrcode': {
                        label: 'atheer.content.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailRecognitionQRCodeController',
                        template: 'modules/content/content-detail-recognition-qrcode.tmpl.html'
                    }
                }
            },
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentRatingController', ContentRatingController)

    /* @ngInject */
    function ContentRatingController($scope, $filter, $mdBottomSheet, Experience, Principal, ToastService) {

        $scope.ratingFeedback = {
            object: $scope.data,
            user_id: Principal.getUserId()
        };

        $scope.submitContentRatingForm = function() {
            if ($scope.isPlayMode) {
                Experience.rate($scope.ratingFeedback, function(result) {
                    ToastService.displayToast($filter('triTranslate')('atheer.content.weReceivedYourFeedback'), 3000);
                    $scope.isContentRatingDone = true;
                    $mdBottomSheet.hide();
                    $scope.performEndAction(false, false, false);
                });
            } else {
                $scope.isContentRatingDone = true;
                $mdBottomSheet.hide();
                $scope.performEndAction(false, false, false);
            }
        }

        $scope.notNowAction = function() {
            $scope.isContentRatingDone = false;
            $mdBottomSheet.hide();
            $scope.performEndAction(false, false, false);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentPlayerController', ContentPlayerController);

    /* @ngInject */
    function ContentPlayerController($rootScope, $scope, $document, $mdDialog, $mdToast, $mdBottomSheet, $filter, dataToPass, mode, Principal, Experience) {
        $scope.contentData = dataToPass;
        $scope.assignmentId = null;
        $scope.assignmentData = null;
        $scope.mode = mode;
        $scope.loadingData = false;
        $scope.isFullScreen = false;
        $scope.fullScreenIcon = 'zmdi zmdi-fullscreen';

        $scope.finishCallBack = function() {
            $scope.close();
            $rootScope.$emit("content-player-closed");
        }

        $scope.close = function() {
            $mdDialog.hide();
            $mdBottomSheet.hide();
        };

        $scope.toggleFullScreen = function() {
            $scope.isFullScreen = !$scope.isFullScreen;
            $scope.fullScreenIcon = $scope.isFullScreen ? 'zmdi zmdi-fullscreen-exit' : 'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
            $scope.$broadcast('toggleFullScreen', $scope.isFullScreen);
        }

        function init() {
            if (mode == 'play') {
                $scope.loadingData = true;
                Experience.getAssignments({
                    query: "object_id==" + $scope.contentData.id + ";status!=COMPLETED;user_id==" + Principal.getUserId()
                }, function(result) {
                    if (result.length > 0) {
                        $scope.assignmentId = result[0].id;
                        $scope.assignmentData = result[0];
                        updateAssigment();
                    } else {
                        $scope.loadingData = false;
                    }

                });
            }
        }

        function updateAssigment() {
            if ($scope.assignmentData != null && $scope.assignmentData.status != 'IN_PROGRESS') {
                $scope.assignmentData.status = 'IN_PROGRESS';
                $scope.assignmentData.started_on = new Date();

                Experience.updateAssignment({
                    id: $scope.assignmentData.id
                }, $scope.assignmentData, function(result) {
                    $scope.assignmentData = result;
                    $scope.loadingData = false;
                });
            } else {
                $scope.loadingData = false;
            }
        }
        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentPickerController', ContentPickerController);

    /* @ngInject */
    function ContentPickerController($scope, $state, triSettings, $mdDialog, Content, Feature, Folder, ParseLinks, AlertService, ContentAction, $mdToast, $filter, CONTENT_META, filter, isWeb, isNotFilter, allowMultiSelect, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.pageTitleKey = $filter('translate')('autoComplete.contentPicker.content');
        vm.predicate = "id";
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.showFolders = false;
        vm.selected = [];
        vm.allowMultiSelect = allowMultiSelect;
        vm.isWeb = isWeb;
        vm.isNotFilter = isNotFilter;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.currentSelectedCards = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.getQueryString = getQueryString;

        vm.defaultFolder = {
            id: "default",
            name: "Default",
            description: "Default"
        };

        vm.selectedFolder = vm.defaultFolder;


        function loadAll() {
            vm.loadingData = true;
            Content.query({
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                query: getQueryString(),
                is_web: vm.isWeb,
                is_not_filter: vm.isNotFilter
            }, onSuccess, onError);

            function sort() {
                var result = ['id' + ',' + 'asc'];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                vm.loadingData = false;
                AlertService.error(error.data.message);
            }
        }

        vm.getMediaUrl = function(mediaUrl){
            return $filter('mediaUrl')(mediaUrl);
        }

        vm.selectFolder = function(folder) {
            vm.updateObject = false;
            vm.selectedFolder = folder;
            vm.loadAll();
        }

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        }

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        }

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        }

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
            if (vm.filter.show) {
                vm.showFolders = false;
            }
        }

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedCards);
        }

        vm.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        }

        vm.close = function() {
            $mdDialog.cancel();
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Content.query({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: getSortOrder(),
                query: getQueryString(),
                is_web: vm.isWeb,
                is_not_filter: vm.isNotFilter
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.contents = data;
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            var contentQuery = filter;
            if (vm.query.filter.length <= 0) {
                contentQuery = contentQuery + ';folders=ex=false,folders=size=0;enabled==true';
            } else {
                var quoteEscapedStr = String(vm.query.filter).replace(/([\\"])/g, '\\$1');
                return contentQuery + ';(title=re="' + quoteEscapedStr + '",description=re="' + quoteEscapedStr + '",tags=re="' + quoteEscapedStr + '");enabled==true';
            }

            return contentQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function resetModal() {
            loadAll();
            vm.showFolders = false;
            AlertService.displayToast($mdToast);
        };
        vm.loadAll();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentMetaDataController', ContentMetaDataController)

    /* @ngInject */
    function ContentMetaDataController($state, $scope, $window, $mdSidenav, MetaData, AlertService, $mdDialog, $filter, id, ToastService) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.updateObject = false;
        vm.metaDataObject;
        vm.selectedFieldGroup;
        vm.loadingData = true;

        vm.loadAll();

        function loadAll() {
            MetaData.get({
                id: id,
                is_name: true,
                add_default_properties: true
            }, function (result) {
                vm.metaDataObject = result;
                vm.updateObject = false;
                if (vm.metaDataObject.field_groups && vm.metaDataObject.field_groups.length > 0) {
                    vm.selectedFieldGroup = vm.metaDataObject.field_groups[0];
                }
                vm.loadingData = false;
            });
        };

        vm.selectFieldGroup = function (fieldGroup) {
            vm.updateObject = false;
            angular.forEach(vm.metaDataObject.field_groups, function (tempFieldGroup) {
                if (tempFieldGroup.name == fieldGroup.name) {
                    vm.selectedFieldGroup = tempFieldGroup;
                }
            });
        };

        vm.addFieldGroup = function (fieldGroup) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: {
                        name: null,
                        label: null,
                        description: null,
                        is_many: true,
                        fields: null,
                    },
                    isAdd: true
                }
            }).then(function (fieldGroup) {
                if (!vm.metaDataObject.field_groups) {
                    vm.metaDataObject.field_groups = [];
                }
                vm.metaDataObject.field_groups.push(fieldGroup);
                vm.updateObject = false;
                vm.selectedFieldGroup = fieldGroup;
                updateMetaData('atheer.contentFields.fieldGroupAdded', fieldGroup);
            });
        }

        vm.editFieldGroup = function (fieldGroup, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: angular.copy(fieldGroup),
                    isAdd: false
                }
            }).then(function (fieldGroup) {
                vm.metaDataObject.field_groups[index] = fieldGroup;
                updateMetaData('atheer.contentFields.fieldGroupUpdated');
            });
        }

        vm.deleteFieldGroup = function (fieldGroup, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.metaDataObject.field_groups.splice(index, 1);
                updateMetaData('atheer.contentFields.fieldGroupDeleted', vm.metaDataObject.field_groups[index == 0 ? 0 : index - 1]);
            });
        }

        vm.addField = function () {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: {
                        name: null,
                        description: null,
                        label: null,
                        data_type: 'STRING',
                        type: 'FLEX',
                        required: false,
                        enabled: true,
                        search_enabled: true
                    },
                    isAdd: true
                }
            }).then(function (field) {
                vm.updateObject = false;
                if (!vm.selectedFieldGroup.fields) {
                    vm.selectedFieldGroup.fields = [];
                };
                vm.selectedFieldGroup.fields.push(field);
                updateMetaData('atheer.contentFields.fieldAdded');
            });
        }

        vm.editField = function (field, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: angular.copy(field),
                    isAdd: false
                }
            }).then(function (field) {
                vm.updateObject = false;
                vm.selectedFieldGroup.fields[index] = field;
                updateMetaData('atheer.contentFields.fieldUpdated');
            });
        }

        vm.copyField = function (field, index) {
            var newField = angular.copy(field);
            newField.name = "Copy of " + newField.name;
            vm.updateObject = false;
            vm.selectedFieldGroup.fields.push(newField);
            updateMetaData('atheer.contentFields.fieldCopied');
        }

        vm.deleteField = function (field, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.updateObject = false;
                vm.selectedFieldGroup.fields.splice(index, 1);
                updateMetaData('atheer.contentFields.fieldDeleted');
            });
        }

        vm.back = function () {
            $window.history.back();
        };

        function updateMetaData(successMessage, fieldGroupToSelect) {
            vm.loadingData = true;
            MetaData.update({
                id: id
            }, vm.metaDataObject, onSaveSuccess);

            function onSaveSuccess(result) {
                vm.metaDataObject = result;
                if (fieldGroupToSelect != null) {
                    vm.selectFieldGroup(fieldGroupToSelect);
                } else {
                    vm.selectedFieldGroup = vm.metaDataObject.field_groups[0];
                }
                ToastService.displayToast($filter('triTranslate')(successMessage), 3000);
                vm.loadingData = false;
            };
        }
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.content')
        .constant('CONTENT_META', [{
            type: 'announcement',
            meta_type: 'ANNOUNCEMENT',
            label: 'atheer.content.menu.announcement',
            feature_name: 'feature_content_announcement',
            dispay_in_options: true,
            display_order: 7,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: false,
            show_in_smart_content: false,
            icon: 'fa fa-bullhorn',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: false,
            enable_tags: true,
            enable_audio: false,
            enable_media: true,
            enable_media_layout: false,
            media_label: 'atheer.content.thumbnailImage',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: false,
            enable_duration: false,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: false,
            description_label: 'atheer.content.announcementText',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: false,
            enable_insights: true,
            default_model: {
                title: 'atheer.content.title',
                description: null,
                show_title: true,
                show_description: false,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                show_audio: false,
                audio_id: null,
                media_id: null,
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'announcement',
                    show_title: true,
                    title_color: '#343A3A',
                    show_content: true,
                    content_color: '#343A3A',
                    content: null,
                    available_from: new Date(),
                    discontinue_from: null
                }
            }
        }, {
            type: 'document',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.document',
            feature_name: 'feature_content_document',
            dispay_in_options: true,
            display_order: 5,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: true,
            icon: 'zmdi zmdi-file-text',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.image',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: true,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/document.png',
                defaultIcon: 'assets/images/card/document_tn.png',
                launchIcon: 'assets/images/card/play_tn.png',
                defaultBackground: '#bdbec0',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'document',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    source_media: null,
                    doc_type: null,
                    doc_status: null,
                    request_rating: false,
                    properties: null
                }
            }
        }, {
            type: 'image',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.image',
            feature_name: 'feature_content_document',
            dispay_in_options: true,
            display_order: 5,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: true,
            icon: 'zmdi zmdi-image',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.image',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: true,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/document.png',
                defaultIcon: 'assets/images/card/document_tn.png',
                launchIcon: 'assets/images/card/play_tn.png',
                defaultBackground: '#bdbec0',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'image',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    source_media: null,
                    image_type: null,
                    image_status: null,
                    request_rating: false,
                    properties: null
                }
            }
        }, {
            type: 'session-recording',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.airSessionRecording',
            feature_name: 'feature_content_airsession_recording',
            dispay_in_options: true,
            display_order: 5,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: true,
            icon: 'zmdi zmdi-comment-video',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.image',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: true,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/document.png',
                defaultIcon: 'assets/images/card/document_tn.png',
                launchIcon: 'assets/images/card/play_tn.png',
                defaultBackground: '#bdbec0',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'session_recording',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    source_media: null,
                    image_type: null,
                    image_status: null,
                    request_rating: false,
                    properties: null
                }
            }
        }, {
            type: 'did-you-know',
            meta_type: 'DID_YOU_KNOW',
            label: 'atheer.content.menu.didYouKnow',
            feature_name: 'feature_content_did_you_know',
            dispay_in_options: true,
            display_order: 8,
            category: 'main',
            show_copy_action: false,
            show_assign_action: false,
            show_ask_action: false,
            show_recommend_action: false,
            show_in_smart_content: false,
            icon: 'fa fa-lightbulb-o',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: false,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: false,
            enable_tags: true,
            enable_audio: false,
            enable_media: true,
            enable_media_layout: false,
            media_label: 'atheer.content.thumbnailImage',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: false,
            enable_duration: false,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: false,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: false,
            enable_insights: false,
            default_model: {
                title: 'atheer.content.title',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                show_audio: false,
                audio_id: null,
                media_id: null,
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'did_you_know',
                    show_title: true,
                    title_color: '#343A3A',
                    show_content: true,
                    content_color: '#343A3A',
                    content: null,
                    available_from: new Date(),
                    discontinue_from: null
                }
            }
        }, {
            type: 'smart-page',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.article',
            feature_name: 'feature_content_page',
            dispay_in_options: true,
            display_order: 5,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: false,
            icon: 'zmdi zmdi-file',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.image',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: false,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/smart_page.png',
                defaultIcon: 'assets/images/card/smart_page_tn.png',
                launchIcon: 'assets/images/card/play_tn.png',
                defaultBackground: '#A97C50',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                show_audio: false,
                audio_id: null,
                media_id: null,
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'smart_page',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    content: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    request_rating: false,
                    properties: null
                }
            }
        }, {
            type: 'podcast',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.podcast',
            feature_name: 'feature_content_podcast',
            dispay_in_options: true,
            display_order: 4,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: true,
            icon: 'zmdi zmdi-headset-mic',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.image',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: true,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/excourse.png',
                defaultIcon: 'assets/images/card/listen_tn.png',
                launchIcon: 'assets/images/card/play_tn.png',
                defaultBackground: '#806193',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                show_audio: false,
                audio_id: null,
                media_id: null,
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'podcast',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    request_rating: false,
                    properties: null
                }
            }
        }, {
            type: 'video',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.video',
            feature_name: 'feature_content_video',
            dispay_in_options: true,
            display_order: 3,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: true,
            icon: 'zmdi zmdi-collection-video',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.image',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: true,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/video.png',
                defaultIcon: 'assets/images/card/play_tn.png',
                launchIcon: 'assets/images/card/play_tn.png',
                defaultBackground: '#faaf40',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                show_audio: false,
                audio_id: null,
                media_id: null,
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'video',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    request_rating: false,
                    external_video: false,
                    source_url: null,
                    embed_code: null,
                    extract_id: null,
                    oembed_id: null,
                    provider: null,
                    progress: 0,
                    show_audio: false,
                    audio_id: null,
                    media_id: null,
                    video_status: 'UPLOADED',
                    properties: null
                }
            }
        }, {
            type: 'zip',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.zip',
            feature_name: 'feature_content_zip',
            dispay_in_options: true,
            display_order: 5,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: true,
            icon: 'assets/images/card/zipfolder.svg',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.zip',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: true,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/zipfolder.svg',
                defaultIcon: 'assets/images/card/zipfolder.svg',
                launchIcon: 'assets/images/card/zipfolder.svg',
                defaultBackground: '#bdbec0',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'zip',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    source_media: null,
                    doc_type: null,
                    doc_status: null,
                    request_rating: false,
                    properties: null
                }
            }
        },, {
            type: 'link',
            meta_type: 'DISCOVERABLE',
            label: 'atheer.content.menu.post',
            feature_name: 'feature_content_link',
            dispay_in_options: true,
            display_order: 6,
            category: 'main',
            show_copy_action: false,
            show_assign_action: true,
            show_ask_action: false,
            show_recommend_action: true,
            show_in_smart_content: true,
            icon: 'zmdi zmdi-link',
            show_audiences: false,
            show_scheduling: false,
            show_folders: false,
            show_topics: false,
            show_tags: false,
            enable_audiences: true,
            enable_scheduling: true,
            enable_folders: true,
            enable_topics: true,
            enable_tags: true,
            enable_audio: false,
            enable_media: false,
            enable_media_layout: false,
            media_label: 'atheer.content.menu.image',
            title_label: 'atheer.content.title',
            externalId_label: 'atheer.content.externalId',
            enable_thumbnail: true,
            enable_duration: true,
            enable_level: false,
            enable_required: false,
            enable_title_alignment: false,
            enable_title: false,
            enable_description: true,
            description_label: 'atheer.content.description',
            enable_request_rating: false,
            enable_points: false,
            enable_feedback: true,
            enable_insights: true,
            card_properties: {
                actions: [],
                smallIcon: 'assets/images/card/link.png',
                defaultIcon: 'assets/images/card/link_tn.png',
                launchIcon: 'assets/images/card/play_tn.png',
                defaultBackground: '#2880ba',
                template: 'content-card.tmpl.html'
            },
            default_model: {
                title: 'Untitled',
                description: null,
                show_title: true,
                show_description: true,
                title_alignment: 'CENTER',
                show_media: false,
                media_shape: 'SQUARE',
                media_size: 'MEDIUM',
                media_position: 'BELOW_TITLE',
                media_alignment: 'CENTER',
                show_audio: false,
                audio_id: null,
                media_id: null,
                status: 'DRAFT',
                enabled: true,
                points: 0,
                embedded: false,
                tags: [],
                data: {
                    type: 'link',
                    duration: 5,
                    level: 'ALL',
                    use_custom_thumbnail: false,
                    thumbnail_url: null,
                    available_from: new Date(),
                    discontinue_from: null,
                    request_rating: false,
                    source_url: null,
                    author: null,
                    extract_id: null,
                    provider: null,
                    properties: null
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .directive('fpContentMessageFeed', fpContentMessageFeed);

    function fpContentMessageFeed() {
        var directive = {
            restrict: 'E',
            scope: {
                'contents': '=',
                'embedMode': '@?',
                'enableAddToBoard': '@?',
                'enableLike': '@?',
                'enableRecommend': '@?',
                'enableFlagInappropiate': '@?',
                'enableReportProblem': '@?',
                'enableRemove': '@?',
                'removeCallback': '&?',
                'loadMoreEnabled': '@?',
                'fromSeries': '@?',
                'seriesEnrolled': '=?'
            },
            transclude: true,
            controller: contentMessageDirectiveController,
            templateUrl: 'modules/content/content-message.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function contentMessageDirectiveController($rootScope, $scope, $state, CONTENT_META, $q, Principal, Experience, $filter, ContentAction, Feature, $mdDialog, Launcher) {

        $scope.currentContentLikeData = {};
        $scope.enableAddToBoard = $scope.enableAddToBoard == 'true';
        $scope.enableLike = $scope.enableLike == 'true';
        $scope.enableRecommend = $scope.enableRecommend == 'true';
        $scope.enableFlagInappropiate = $scope.enableFlagInappropiate == 'true';
        $scope.enableReportProblem = $scope.enableReportProblem == 'true';
        $scope.embedMode = $scope.embedMode == 'true';
        $scope.loadMoreEnabled = $scope.loadMoreEnabled == 'true';
        $scope.fromSeries = $scope.fromSeries == 'true';

        $scope.limitToIndex = $scope.loadMoreEnabled && $scope.contents.length > 5 ? 5 : $scope.contents.length;

        $scope.loadMore = function(type) {
            var diff = $scope.contents.length - $scope.limitToIndex;
            $scope.limitToIndex += diff > 5 ? 5 : diff;
        };

        function init() {
            angular.forEach($scope.contents, function(content) {
                $q.all([
                    Experience.getLikes({
                        query: "object_id==" + content.id + ";user_id==" + Principal.getUserId()
                    }).$promise
                ]).then(function(result) {
                    if (result[0].length > 0) {
                        $scope.currentContentLikeData[content.id] = result[0][0];
                    }
                });
            })
        };

        $scope.isActive = function(feature) {
            return Feature.isActive(feature);
        };

        $scope.openBoardDialog = function(content) {
            ContentAction.openBoardDialog(content);
        };

        $scope.getMediaUrl = function(mediaUrl) {
            return $filter('mediaUrl')(mediaUrl);
        };

        $scope.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        };

        $scope.getDefaultBackground = function(type) {
            var card_properties = $scope.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        };

        $scope.getDefaultIcon = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData != undefined ? contentMetaData.icon : '';
        };

        $scope.launchContent = function(content) {
            if ($scope.fromSeries && $scope.seriesEnrolled) {
                Launcher.getAssignment({
                    id: content.id
                }, function(result) {
                    ContentAction.launchContent(content);
                });
            } else if ($scope.fromSeries && !$scope.seriesEnrolled) {
                ContentAction.previewContent(content);
            } else {
                ContentAction.launchContent(content);
            };
        };

        $scope.openContentDetail = function(content) {
            $state.go('storm.content-details', {
                'id': content.id
            });
        };

        $scope.openRecommendDialog = function(content) {
            var contents = [];
            contents.push(content.id);
            ContentAction.openRecommendDialog(content);
        };

        $scope.isCompleted = function(contentId) {
            if ($rootScope.userActivities.completion_ids.indexOf(contentId) >= 0) {
                return true;
            } else {
                return false;
            }
        };

        $scope.openFeedbackDialog = function(reactionType, content) {
            ContentAction.openFeedbackDialog(reactionType, content);
        };
        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentMenuController', ContentMenuController);

    /* @ngInject */
    function ContentMenuController($scope, $state, $mdDialog, $timeout, $mdPanel, Content, Topic, ParseLinks, AlertService, ContentAction, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, CONTENT_META, $translate, Feature) {
        var vm = this;

        vm.loadingTime = 1500;
        vm.loadingData = true;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.topics = null;
        vm.sequenceNumber = 0;
        vm.selectedNode = '';

        vm.createMenuOptions = $filter('filter')($filter('orderBy')(CONTENT_META, 'display_order'), {
            category: 'main',
            dispay_in_options: true
        });

        vm.filters = {
            metaType: 'all',
            disabled: false,
            status: null,
            topicId: null
        };

        if ( getSavedFilters() ) {
            vm.filters = getSavedFilters();
        }

        vm.permissions = {
            manageTopic: 'manager-topic'
        };

        vm.updateFilters = function() {
            saveFilters(vm.filters);
            $scope.$emit('updateContentList', vm.filters);
        }

        vm.convertTypeForBackend = function(type) {
            return type.replace(/-/g, '_')
        }

        vm.loadAll = function() {
            vm.loadingData = true;
            Topic.query({
                page: pagingParams.page - 1,
                size: 1000,
                sort: sort(),
                query: getQueryString()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.topics = data.filter(function(topic) {
                    if (topic.parent_topics == null || topic.sub_topics != null) {
                        topic.id = vm.sequenceNumber++ +'::'+ topic.id;
                        if ( topic.id.includes(vm.filters.topicId) ) {
                            vm.selectedNode = topic;
                        }
                        return topic;
                    }
                });
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        vm.treeOptions = {
            nodeChildren: "children",
            dirSelectable: true,
            injectClasses: {
                ul: "a1",
                li: "a2",
                liSelected: "a7",
                iExpanded: "a3",
                iCollapsed: "a4",
                iLeaf: "a5",
                label: "a6",
                labelSelected: "a8"
            }
        };

        vm.topicSelected = function(node, selected) {
            if (selected) {
                vm.filters.topicId = node.id.split('::')[1];
            } else {
                vm.filters.topicId = null;
            };
            saveFilters(vm.filters);
            $scope.$emit('updateContentList', vm.filters);
        };

        vm.fetchChildNodes = function(node, expanded) {
            
            function doFetch(node) {
                Topic.query({
                    page: pagingParams.page - 1,
                    size: 1000,
                    sort: sort(),
                    query: getChildQueryString(node)
                }, onSuccess, onError);

                function sort() {
                    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                    if (vm.predicate !== 'id') {
                        result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    node.children = data;
                    node.children = data.filter(function(topic) {
                        topic.id = vm.sequenceNumber++ +'::'+ topic.id;
                        return topic;
                    });
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
            if ( node.sub_topics != null && node.sub_topics.length > 0 ) {
                doFetch(node);
            }
        };

        function getQueryString() {
            return null;
        };

        function getChildQueryString(topic) {
            return 'id=in=(' + topic.sub_topics.toString() +')';
            
        };

        function saveFilters(filterData) {
            sessionStorage.setItem('objectMenu', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectMenu'));
        };

        vm.loadAll();
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.content')
        .constant('CONTENT_INSIGHT_META', {
            'document': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightOverviewController',
                          template: 'modules/content/content-detail-insight-overview.tmpl.html'
                    },
                    'ratings': {
                        label: 'atheer.content.ratings',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightRatingsSummaryController',
                        template: 'modules/content/content-detail-insight-ratings-summary.tmpl.html'
                    },
                    'problems': {
                        label: 'atheer.content.problems',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightProblemsSummaryController',
                        template: 'modules/content/content-detail-insight-problems-summary.tmpl.html'
                    }
                }
            },
            'image': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightOverviewController',
                        template: 'modules/content/content-detail-insight-overview.tmpl.html'
                    },
                    'ratings': {
                        label: 'atheer.content.ratings',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightRatingsSummaryController',
                        template: 'modules/content/content-detail-insight-ratings-summary.tmpl.html'
                    },
                    'problems': {
                        label: 'atheer.content.problems',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightProblemsSummaryController',
                        template: 'modules/content/content-detail-insight-problems-summary.tmpl.html'
                    }
                }
            },
            'smart_page': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightOverviewController',
                        template: 'modules/content/content-detail-insight-overview.tmpl.html'
                    },
                    'ratings': {
                        label: 'atheer.content.ratings',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightRatingsSummaryController',
                        template: 'modules/content/content-detail-insight-ratings-summary.tmpl.html'
                    },
                    'problems': {
                        label: 'atheer.content.problems',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightProblemsSummaryController',
                        template: 'modules/content/content-detail-insight-problems-summary.tmpl.html'
                    }
                }
            },
            'podcast': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightOverviewController',
                        template: 'modules/content/content-detail-insight-overview.tmpl.html'
                    },
                    'ratings': {
                        label: 'atheer.content.ratings',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightRatingsSummaryController',
                        template: 'modules/content/content-detail-insight-ratings-summary.tmpl.html'
                    },
                    'problems': {
                        label: 'atheer.content.problems',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightProblemsSummaryController',
                        template: 'modules/content/content-detail-insight-problems-summary.tmpl.html'
                    }
                }
            },
            'video': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightOverviewController',
                        template: 'modules/content/content-detail-insight-overview.tmpl.html'
                    },
                    'ratings': {
                        label: 'atheer.content.ratings',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightRatingsSummaryController',
                        template: 'modules/content/content-detail-insight-ratings-summary.tmpl.html'
                    },
                    'problems': {
                        label: 'atheer.content.problems',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightProblemsSummaryController',
                        template: 'modules/content/content-detail-insight-problems-summary.tmpl.html'
                    }
                }
            },
            'announcement': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'AnnouncementInsightOverviewController',
                        template: 'modules/content/announcement-insight-overview.tmpl.html'
                    }
                }
            },
            'link': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightOverviewController',
                        template: 'modules/content/content-detail-insight-overview.tmpl.html'
                    },
                    'ratings': {
                        label: 'atheer.content.ratings',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightRatingsSummaryController',
                        template: 'modules/content/content-detail-insight-ratings-summary.tmpl.html'
                    },
                    'problems': {
                        label: 'atheer.content.problems',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightProblemsSummaryController',
                        template: 'modules/content/content-detail-insight-problems-summary.tmpl.html'
                    }
                }
            },
            'session_recording': {
                'sections': {
                    'overview': {
                        label: 'atheer.content.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightOverviewController',
                          template: 'modules/content/content-detail-insight-overview.tmpl.html'
                    },
                    'ratings': {
                        label: 'atheer.content.ratings',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightRatingsSummaryController',
                        template: 'modules/content/content-detail-insight-ratings-summary.tmpl.html'
                    },
                    'problems': {
                        label: 'atheer.content.problems',
                        icon: 'zmdi zmdi-account',
                        controller: 'ContentDetailInsightProblemsSummaryController',
                        template: 'modules/content/content-detail-insight-problems-summary.tmpl.html'
                    }
                }
            },
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentFeedbackController', ContentFeedbackController);

    /* @ngInject */
    function ContentFeedbackController($scope, $state, $mdDialog, $filter, content, type, Experience,Principal, ToastService) {
        var vm = this;
        vm.type = type;

        vm.contentFeedbackModel = {
            object: content,
            comment: '',
            user_id: Principal.getUserId()
        }

        vm.close = function() {
            $mdDialog.hide();
        }

        vm.submit = function() {
            if (type == "FLAG") {
                Experience.raiseFlag(vm.contentFeedbackModel, function(result) {
                    vm.flagData = result;

                    ToastService.displayToast($filter('triTranslate')('atheer.content.receivedYourFeedback'), 3000);
                    vm.close();
                });
            } else if (type == "PROBLEM") {
                Experience.reportProblem(vm.contentFeedbackModel, function(result) {
                    vm.flagData = result;

                    ToastService.displayToast($filter('triTranslate')('atheer.content.receivedYourFeedback'), 3000);
                    vm.close();
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .directive('fpContentFeedList', fpContentFeedList);

    function fpContentFeedList() {
        var directive = {
            restrict: 'E',
            scope: {
                'contents': '=',
                'enableRemove': '@?',
                'removeCallback': '&?',
                'loadMoreEnabled': '@?'
            },
            transclude: true,
            controller: contentListViewDirectiveController,
            templateUrl: 'modules/content/content-feed-list.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function contentListViewDirectiveController($rootScope, $scope, $state, CONTENT_META, $q, Principal, Experience, $filter, ContentAction, Feature, $mdDialog, Launcher) {

        $scope.loadMoreEnabled = $scope.loadMoreEnabled == 'true';

        $scope.limitToIndex = $scope.loadMoreEnabled && $scope.contents.length > 5 ? 5 : $scope.contents.length;

        $scope.loadMore = function(type) {
            var diff = $scope.contents.length - $scope.limitToIndex;
            $scope.limitToIndex += diff > 5 ? 5 : diff;
        };

        function init() {

        };

        $scope.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        $scope.launchContent = function(content) {
            if ($scope.fromSeries && !$scope.seriesEnrolled) {
                ContentAction.previewContent(content);
            } else {
                ContentAction.launchContent(content);
            };
        };

        init();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.content')
        .directive('fpContentFeedItem', fpContentFeedItem);

    function fpContentFeedItem() {
        var directive = {
            restrict: 'E',
            scope: {
                'content': '=',
                'type': '=',
                'publisher': '=',
                'enableRemove': '@?',
                'showDescription': '@?',
                'showDuration': '@?',
                'removeCallback': '&?',
                'messageView': '@?',
            },
            transclude: true,
            controller: contentListItemViewDirectiveController,
            templateUrl: 'modules/content/content-feed-item.tmpl.html'
        };
        return directive;
    }

    /* @ngInject */
    function contentListItemViewDirectiveController($rootScope, $scope, $state, CONTENT_META, $q, Principal, Experience, $filter, ContentAction, Feature, $mdDialog, Launcher) {

        $scope.userId = Principal.getUserId();
        $scope.showDescription = $scope.showDescription == 'true';
        $scope.showDuration = $scope.showDuration == 'true';
        $scope.messageView = $scope.messageView == 'false';

        $scope.contentMetaData = [];

        function init() {
            angular.forEach(CONTENT_META, function (metaData) {
                var iconData = {
                    type: metaData.default_model.data.type,
                    icon: metaData.icon
                }
                $scope.contentMetaData.push(iconData);
            });
        };

        $scope.isActive = function (feature) {
            return Feature.isActive(feature);
        };

        $scope.getMediaUrl = function (mediaUrl) {
            return $filter('mediaUrl')(mediaUrl);
        };

        $scope.getCardProperty = function (type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        };

        $scope.getDefaultBackground = function (type) {
            var card_properties = $scope.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        };

        $scope.getDefaultIcon = function (type) {
            var card_properties = $scope.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        };

        $scope.isLiked = function (content) {
            return $scope.currentContentLikeData[content.id] ? true : false;
        };

        $scope.getCardMeta = function (card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        $scope.launchContent = function (content) {
            if ($scope.fromSeries && $scope.seriesEnrolled) {
                Launcher.getAssignment({
                    id: content.id
                }, function (result) {
                    ContentAction.launchContent(content);
                });
            } else if ($scope.fromSeries && !$scope.seriesEnrolled) {
                ContentAction.previewContent(content);
            } else {
                ContentAction.launchContent(content);
            };
        };

        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailRecognitionController', ContentDetailRecognitionController);

    /* @ngInject */
    function ContentDetailRecognitionController($scope, $filter, $state, CONTENT_META, CONTENT_INSIGHT_META, Content, content_type, id, CONTENT_RECOGNITION_META) {

        var vm = this;

        vm.loadingData = true;

        vm.contentMetaData = angular.copy($filter('filter')(CONTENT_META, {
            type: content_type.replace(/_/g, '-')
        })[0]);

        vm.insightSections = angular.copy(CONTENT_RECOGNITION_META[content_type].sections);

        vm.contentModel = null;

        vm.hasInsights = function() {
            return CONTENT_INSIGHT_META[content_type] != undefined;
        }

        vm.hasRecognition = function() {
            return CONTENT_RECOGNITION_META[content_type] != undefined;
        }

        vm.loadData = function() {
            if (id) {
                Content.get({
                    id: id
                }, function(result) {
                    vm.contentModel = result;
                    vm.loadingData = false;
                });
            }
        }
        vm.loadData();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailRecognitionQRCodeController', ContentDetailRecognitionQRCodeController)

    /* @ngInject */
    function ContentDetailRecognitionQRCodeController($scope, $timeout, $q, $filter, content_type, id, Content, $http) {
        var vm = this;

        vm.loadingData = false;
        vm.contentModel = $scope.$parent.vm.contentModel;
        vm.showActions = false;
        vm.qrCodeImage;

        vm.loadData = function () {
            if (id) {
                vm.loadingData = true;
                $timeout(function () {
                    vm.showActions = true;
                    vm.qrCodeLink = '/api/contents/' + id + '/qrcode';
                    $http.get(vm.qrCodeLink, { responseType: 'blob' }).then(function (response) {
                        vm.qrCodeImage = URL.createObjectURL(response.data);
                        vm.loadingData = false;
                    })
                }, 1000);
            };
        };

        vm.downloadQR = function () {
            var link = document.createElement('a');
            link.download = 'QR-Code',
                link.href = vm.qrCodeImage;
            link.click();
        };

        vm.printQR = function () {
            var printWin = window.open();
            printWin.document.open();
            printWin.document.write(ImagetoPrint());
            printWin.document.close();
        };

        function ImagetoPrint() {
            return "<html><head><script>function step1(){\n" +
                "setTimeout('step2()', 10);}\n" +
                "function step2(){window.print();window.close()}\n" +
                "</script></head><body onload='step1()'>\n" +
                "<img src='" + vm.qrCodeImage + "' /></body></html>";
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailInsightController', ContentDetailInsightController);

    /* @ngInject */
    function ContentDetailInsightController($scope, $filter, $state, CONTENT_META, CONTENT_INSIGHT_META, Content, content_type, id, CONTENT_RECOGNITION_META) {

        var vm = this;

        vm.loadingData = true;

        vm.contentMetaData = angular.copy($filter('filter')(CONTENT_META, {
            type: content_type.replace(/_/g, '-')
        })[0]);

        vm.insightSections = angular.copy(CONTENT_INSIGHT_META[content_type].sections);

        vm.contentModel = null;

        vm.hasInsights = function() {
            return CONTENT_INSIGHT_META[content_type] != undefined;
        }

        vm.hasRecognition = function() {
            return CONTENT_RECOGNITION_META[content_type] != undefined;
        }

        vm.handleBackClick = function() {
            if(!!sessionStorage.getItem('DocumentListingQueryParams')) {
                $state.go('storm.content-documents', JSON.parse(sessionStorage.getItem('DocumentListingQueryParams')));
            } else {
                $state.go('storm.admin-contents');
            }
        }

        vm.loadData = function() {
            if (id) {
                Content.get({
                    id: id
                }, function(result) {
                    vm.contentModel = result;
                    vm.loadingData = false;
                });
            }
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailInsightUserSummaryController', ContentDetailInsightUserSummaryController)

    /* @ngInject */
    function ContentDetailInsightUserSummaryController($scope, $mdDialog, content_type, id, ParseLinks, pagingParams, paginationConstants, Experience) {
        var vm = this;

        vm.loadingData = false;
        vm.contentType = content_type;
        vm.contentModel = $scope.$parent.vm.contentModel;
        vm.contentMetaData = $scope.$parent.vm.contentMetaData;

        if (vm.contentType == 'course') {
            vm.scoringEnabled = true;
        } else {
            vm.scoringEnabled = vm.contentModel.data.enable_scoring;
        }

        if (vm.contentType == 'smart_content' || vm.contentType == 'series') {
            vm.showCardSummary = true;
        } else {
            vm.showCardSummary = false;
        }

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.assignments = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getAssignments({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, function(response, headers) {
                vm.assignments = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                vm.loadingData = false;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "object_id==" + id;
            return queryString;
        }

        vm.deleteObject = function(entity) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this Assignment?')
                .ariaLabel('Are you sure you want to delete this Assignment?')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                Experience.deleteAssignment({
                    id: entity.id
                }, function() {
                    vm.loadData();
                });
            });
        };

        vm.transition = function() {
            vm.promise = Experience.getAssignments({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.assignments = response;
                vm.queryCount = vm.totalItems;
            });
        }

        vm.launchUserCardSummary = function(userId) {
            if (vm.contentType == 'smart_content') {
                $mdDialog.show({
                    templateUrl: 'modules/content/smart-content-insight-user-card-summary.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "SmartContentDetailInsightUserCardSummaryController",
                    controllerAs: "vm",
                    locals: {
                        content: vm.contentModel,
                        userId: userId,
                        title: 'User Card Summary'
                    }
                });
            } else if (vm.contentType == 'series') {
                $mdDialog.show({
                    templateUrl: 'modules/content/series-insight-module-user-summary.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "SeriesInsightModuleUserSummaryController",
                    controllerAs: "vm",
                    locals: {
                        userId: userId,
                        content: vm.contentModel,
                        title: 'User Module Summary'
                    }
                });
            }
        }

        vm.markComplete = function(assignment) {
            var responseData = {
                object: assignment.object,
                response: {
                    type: assignment.object.data.type,
                    choice: undefined,
                    correct: true,
                    points: 0
                },
                user_id: assignment.user_info.id,
                assignment_id: assignment.id,
                context_id: null
            }

            Experience.createResponse(responseData, function(result) {
                vm.loadData();
            });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailInsightRatingsSummaryController', ContentDetailInsightRatingsSummaryController)

    /* @ngInject */
    function ContentDetailInsightRatingsSummaryController($scope, content_type, id, ParseLinks, pagingParams, paginationConstants, Experience) {
        var vm = this;

        vm.loadingData = false;
        vm.contentType = content_type;
        vm.contentModel = $scope.$parent.vm.contentModel;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.illustartionEmptyScreenId = "no_rating";

        vm.ratings = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getRatings({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, function(response, headers) {
                vm.ratings = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                vm.loadingData = false;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "object_id==" + id;
            return queryString;
        }

        vm.getUserProfileImageUrl = function(pictureId) {
            return pictureId ? '/media/pictures/' + pictureId : 'assets/images/avatars/user-avatar.png';
        }

        vm.transition = function() {
            vm.promise = Experience.getRatings({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.ratings = response;
                vm.queryCount = vm.totalItems;
            });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailInsightProblemsSummaryController', ContentDetailInsightProblemsSummaryController)

    /* @ngInject */
    function ContentDetailInsightProblemsSummaryController($scope, content_type, id, ParseLinks, pagingParams, paginationConstants, Experience) {
        var vm = this;

        vm.loadingData = false;
        vm.contentType = content_type;
        vm.contentModel = $scope.$parent.vm.contentModel;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.illustartionEmptyScreenId = "no_Problem";

        vm.problems = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getProblems({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, function(response, headers) {
                vm.problems = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                vm.loadingData = false;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "object_id==" + id;
            return queryString;
        }

        vm.getUserProfileImageUrl = function(pictureId) {
            return pictureId ? '/media/pictures/' + pictureId : 'assets/images/avatars/user-avatar.png';
        }

        vm.transition = function() {
            vm.promise = Experience.getProblems({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.problems = response;
                vm.queryCount = vm.totalItems;
            });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailInsightOverviewController', ContentDetailInsightOverviewController)

    /* @ngInject */
    function ContentDetailInsightOverviewController($scope, $q, $filter, content_type, id, Report) {
        var vm = this;

        vm.loadingData = false;
        vm.contentModel = $scope.$parent.vm.contentModel;

        vm.contentCompletionChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.content.completions')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.content.noOfCompletions')
                }
            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.content.dates')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }

            },
            series: [{
                name: $filter('translate')('atheer.content.completions'),
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> Completions : ' + this.y;
                }
            }
        };

        vm.contentViewsChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.content.views')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.content.noOfViews')
                }
            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.content.dates')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }

            },
            series: [{
                name: $filter('translate')('atheer.content.views'),
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> Views : ' + this.y;
                }
            }
        };

        vm.contentTimeSpentChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.content.timeSpent')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.content.minutes')
                },
                labels: {
                    formatter: function() {
                        var seconds = (this.value / 1000).toFixed(0);
                        var minutes = (seconds / 60).toFixed(2);
                        return minutes;
                    }
                }

            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.content.dates')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }
            },
            series: [{
                name: $filter('translate')('atheer.content.avgTimeSpent'),
                data: []
            }, {
                name: $filter('translate')('atheer.content.totalTimeSpent'),
                data: []
            }],
            tooltip: {
                formatter: function() {
                    var seconds = (this.y / 1000).toFixed(0);
                    var minutes = (seconds / 60).toFixed(2);
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> Time Spent : ' + minutes + ' minutes';
                }
            }
        };

        vm.multibarChartResponseData = {
            chart: {
                type: 'column',
            },
            title: {
                text: $filter('translate')('atheer.content.responses')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.content.noOfContents')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: []
            },
            series: [{
                'name': $filter('translate')('atheer.content.responseForChoice'),
                "color": "#1f77b4",
                'data': []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.x + '</b> : ' + this.y;
                }
            }
        };

        vm.lineChartResponseData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.content.responses')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.content.noOfResponses')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.content.dates')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }
            },
            series: [{
                'name': $filter('translate')('atheer.content.responses'),
                "color": "#1f77b4",
                'data': []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> Responses : ' + this.y;
                }
            }
        };

        vm.pointLineChartData = {
            chart: {
                type: 'line',
            },
            title: {
                text: $filter('translate')('atheer.content.points')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.content.points')
                }
            },
            xAxis: {
                title: {
                    text: $filter('translate')('atheer.content.dates')
                },
                type: 'datetime',
                labels: {
                    format: '{value:%e - %b - %Y}'
                }
            },
            series: [{
                name: $filter('translate')('atheer.content.avgPoints'),
                data: []
            }, {
                name: $filter('translate')('atheer.content.totalPoints'),
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</b><br/> ' + this.series.name + ' : ' + this.y;
                }
            }
        };

        function processHistoryData() {

            function getDateFromItem(item) {
                return item.x;
            }

            //set completions Data
            angular.forEach(vm.overviewSummary.history.completion, function(completionObj) {
                vm.contentCompletionChartData.series[0].data.push({ x: new Date(completionObj.name), y: completionObj.count })
            });
            vm.contentCompletionChartData.series[0].data = $filter('orderBy')(vm.contentCompletionChartData.series[0].data, getDateFromItem);

            //set views Data
            angular.forEach(vm.overviewSummary.history.view, function(viewObj) {
                vm.contentViewsChartData.series[0].data.push({ x: new Date(viewObj.name), y: viewObj.count })
            });
            vm.contentViewsChartData.series[0].data = $filter('orderBy')(vm.contentViewsChartData.series[0].data, getDateFromItem);

            //set average points Data
            angular.forEach(vm.overviewSummary.history.avg_points, function(pointObj) {
                vm.pointLineChartData.series[0].data.push({ x: new Date(pointObj.name), y: pointObj.count });
            });
            vm.pointLineChartData.series[0].data.values = $filter('orderBy')(vm.pointLineChartData.series[0].data, getDateFromItem);

            //set total points Data
            angular.forEach(vm.overviewSummary.history.total_points, function(pointObj) {
                vm.pointLineChartData.series[1].data.push({ x: new Date(pointObj.name), y: pointObj.count });
            });
            vm.pointLineChartData.series[0].data = $filter('orderBy')(vm.pointLineChartData.series[1].data, getDateFromItem);

            //set average time spent Data
            angular.forEach(vm.overviewSummary.history.avg_time_spent, function(timeSpentObj) {
                vm.contentTimeSpentChartData.series[0].data.push({ x: new Date(timeSpentObj.name), y: timeSpentObj.count });
            });
            vm.contentTimeSpentChartData.series[0].data = $filter('orderBy')(vm.contentTimeSpentChartData.series[0].data, getDateFromItem);

            //set total time spent Data
            angular.forEach(vm.overviewSummary.history.total_time_spent, function(timeSpentObj) {
                vm.contentTimeSpentChartData.series[1].data.push({ x: new Date(timeSpentObj.name), y: timeSpentObj.count });
            });
            vm.contentTimeSpentChartData.series[1].data = $filter('orderBy')(vm.contentTimeSpentChartData.series[1].data, getDateFromItem);


            //set total time spent Data
            angular.forEach(vm.overviewSummary.history.response, function(responseObj) {
                vm.lineChartResponseData.series[0].data.push({ x: new Date(responseObj.name), y: responseObj.count });
            });
            vm.lineChartResponseData.series[0].data = $filter('orderBy')(vm.lineChartResponseData.series[0].data, getDateFromItem);


            //Response For Each Choice
            if (vm.contentModel.data.type == 'yes_no_question') {

                var trueChoiceCount = $filter('filter')(vm.overviewSummary.choices, { name: true })[0];
                var falseChoiceCount = $filter('filter')(vm.overviewSummary.choices, { name: false })[0];

                vm.multibarChartResponseData.xAxis.categories.push('Yes');
                vm.multibarChartResponseData.series[0].data.push(trueChoiceCount ? trueChoiceCount.count : 0);

                vm.multibarChartResponseData.xAxis.categories.push('No');
                vm.multibarChartResponseData.series[0].data.push(falseChoiceCount ? falseChoiceCount.count : 0);

            } else if (vm.contentModel.data.type == 'true_false_question') {

                var trueChoiceCount = $filter('filter')(vm.overviewSummary.choices, { name: true })[0];
                var falseChoiceCount = $filter('filter')(vm.overviewSummary.choices, { name: false })[0];

                vm.multibarChartResponseData.xAxis.categories.push('True');
                vm.multibarChartResponseData.series[0].data.push(trueChoiceCount ? trueChoiceCount.count : 0);

                vm.multibarChartResponseData.xAxis.categories.push('False');
                vm.multibarChartResponseData.series[0].data.push(falseChoiceCount ? falseChoiceCount.count : 0)

            } else if (vm.contentModel.data.type == 'legal_question') {

                var trueChoiceCount = $filter('filter')(vm.overviewSummary.choices, { name: true })[0];
                var falseChoiceCount = $filter('filter')(vm.overviewSummary.choices, { name: false })[0];

                vm.multibarChartResponseData.xAxis.categories.push('Accepted');
                vm.multibarChartResponseData.series[0].data.push(trueChoiceCount ? trueChoiceCount.count : 0)

                vm.multibarChartResponseData.xAxis.categories.push('Not Accepted');
                vm.multibarChartResponseData.series[0].data.push(falseChoiceCount ? falseChoiceCount.count : 0)

            } else {
                angular.forEach(vm.contentModel.data.choices, function(choice, index) {
                    var choiceObjectCount = $filter('filter')(vm.overviewSummary.choices, { name: choice.choice_id })[0];

                    vm.multibarChartResponseData.xAxis.categories.push(choice.label);
                    vm.multibarChartResponseData.series[0].data.push(choiceObjectCount ? choiceObjectCount.count : 0)
                });
            }
        }

        vm.getCount = function(activityName) {
            for (var i = 0; i < vm.overviewSummary.metrics.length; i++) {
                if (vm.overviewSummary.metrics[i].name === activityName) {
                    return vm.overviewSummary.metrics[i].count;
                }
            }
            return 0;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            $q.all([
                Report.getContentOverviewSummary({
                    id: id
                }).$promise
            ]).then(function(data) {
                vm.overviewSummary = data[0];
                processHistoryData();
                vm.loadingData = false;

            }).catch(function(data) {}).finally(function() {});
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentDetailInsightFlagsSummaryController', ContentDetailInsightFlagsSummaryController)

    /* @ngInject */
    function ContentDetailInsightFlagsSummaryController($scope, content_type, id, ParseLinks, pagingParams, paginationConstants, Experience) {
        var vm = this;

        vm.loadingData = false;
        vm.contentType = content_type;
        vm.contentModel = $scope.$parent.vm.contentModel;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.illustartionEmptyScreenId = "no_Problem";

        vm.flags = [];

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.loadData = function() {
            vm.loadingData = true;
            //fetch pins data
            Experience.getFlags({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, function(response, headers) {
                vm.flags = response;
                vm.page = pagingParams.page;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                vm.loadingData = false;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function getQueryString() {
            var queryString = "object_id==" + id;
            return queryString;
        }

        vm.getUserProfileImageUrl = function(pictureId) {
            return pictureId ? '/media/pictures/' + pictureId : 'assets/images/avatars/user-avatar.png';
        }

        vm.transition = function() {
            vm.promise = Experience.getProblems({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString()
            }).$promise;

            vm.promise.then(function(response, headers) {
                vm.flags = response;
                vm.queryCount = vm.totalItems;
            });
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentBulkEditController', ContentBulkEditController);

    /* @ngInject */
    function ContentBulkEditController($scope, $state, $mdDialog, $q, $filter, $mdToast, User, contents, Experience, Team, Principal) {
        var vm = this;

        vm.topics = [];
        vm.folders = [];
        vm.audiences = [];
        vm.owner = null;
        vm.contents = contents;

        vm.updateProgress = 'idle';

        Principal.identity().then(function(user) {
            vm.owner = user;
            vm.loadingData = false;
        })

        vm.contentBulkEditModel = {
            tags: [],
            owner_id: null,
            available_from: new Date(),
            discontinue_from: new Date(),
            topics: [],
            audiences: [],
            folders: [],
        };

        vm.close = function() {
            if (vm.updateProgress !== 'idle') {
                $mdDialog.hide();
            } else {
                $mdDialog.cancel();
            }
        }

        function getUniqueArray(array) {
            var returnArray = [];
            return returnArray;
        }

        vm.submit = function() {
            vm.updateProgress = 'started';

            if (vm.owner) {
                vm.contentBulkEditModel.owner_id = vm.owner.id
            } else {
                vm.contentBulkEditModel.owner_id = null;
            }
            if (vm.topics && vm.topics.length > 0) {
                var topicIds = [];
                angular.forEach(vm.topics, function(topic) {
                    topicIds.push(topic.id);
                });
                vm.contentBulkEditModel.topics = topicIds;
            } else {
                vm.contentBulkEditModel.topics = null;
            }

            if (vm.audiences && vm.audiences.length > 0) {
                var audienceIds = [];
                angular.forEach(vm.audiences, function(audience) {
                    audienceIds.push(audience.id);
                });
                vm.contentBulkEditModel.audiences = audienceIds;
            }
            if (vm.folders && vm.folders.length > 0) {
                var folderIds = [];
                angular.forEach(vm.folders, function(folder) {
                    folderIds.push(folder.id);
                });
                vm.contentBulkEditModel.folders = folderIds;
            }

            angular.forEach(vm.contents, function(content) {
                if (vm.contentBulkEditModel.topics) {
                    if (content.data.topics) {
                        content.data.topics = content.data.topics.concat(vm.contentBulkEditModel.topics);
                    } else {
                        content.data.topics = vm.contentBulkEditModel.topics
                    }
                }

                if (vm.contentBulkEditModel.audiences) {
                    if (content.data.audiences) {

                        content.data.audiences = content.data.audiences.concat(vm.contentBulkEditModel.audiences);
                    } else {
                        content.data.audiences = vm.contentBulkEditModel.audiences
                    }
                }

                if (vm.contentBulkEditModel.folders) {
                    if (content.folders) {

                        content.folders = content.folders.concat(vm.contentBulkEditModel.folders);
                    } else {
                        content.folders = vm.contentBulkEditModel.folders
                    }
                }
                content.owner_id = vm.contentBulkEditModel.owner_id;
                content.tags = vm.contentBulkEditModel.tags;
                content.available_from = vm.contentBulkEditModel.available_from;
                content.discontinue_from = vm.contentBulkEditModel.discontinue_from;
            });

            //Call the Save Here
            vm.updateProgress = 'complete';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentAudioRecordController', ContentAudioRecordController);

    /* @ngInject */
    function ContentAudioRecordController($mdDialog, $state, $timeout, Upload) {
        var vm = this;

        vm.recordedAudio = null;
        vm.audioStatus = 'RECORD';
        vm.processStatus = 'IDLE';
        vm.uploadPercentage = 0;

        vm.close = function() {
            $mdDialog.cancel();
        };
        
        vm.save = function() {
            vm.audioFile = vm.recordedAudio;
            vm.audioFile.name = 'audio_recording_' + generateUuid() + ".wav";
            vm.audioStatus = 'PROCESS';
            vm.processStatus = 'PROCESSING';

            Upload.upload({
                url: 'api/media/upload',
                data: {
                    'file': vm.audioFile,
                    'type': 'audio'
                },
                arrayKey: ''
            }).then(function(resp) {
                var media = resp.data;
                vm.processStatus = 'COMPLETE';
                $timeout(function() {
                    $mdDialog.hide(media);
                }, 2000);
            }, function(resp) {
                vm.processStatus = 'FAILED';
            }, function(evt) {
                vm.uploadPercentage = parseInt(100.0 * evt.loaded / evt.total);
            });
        }

        function generateUuid() {
            function _p8(s) {
                var p = (Math.random().toString(16) + "000000000").substr(2, 8);
                return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
            }

            return _p8() + _p8(true) + _p8(true) + _p8();
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('atheer.content')
        .factory('ContentAction', ContentAction);

    /* @ngInject */
    function ContentAction($window, $rootScope, $location, deviceDetector, Experience, Principal, $mdDialog, $q, Content, Scorm, Base64, ToastService, $filter, $http) {
        return {
            launchContent: function (feed, assignmentId) {
                var contentType = feed.data.type;
                var contentItem = feed;

                this.playContent(contentType, contentItem, this.markContentViewed, assignmentId);
            },
            markContentViewed: function (contentItem) {
                var device = {
                    os: deviceDetector.os,
                    device: 'browser',
                    browser: deviceDetector.browser,
                    os_version: deviceDetector.os_version,
                    browser_version: deviceDetector.browser_version
                };

                Experience.markViewed({
                    object: contentItem,
                    user_id: Principal.getUserId(),
                    time_spent: 0,
                    device_properties: device
                }, function (result) {
                });
            },
            getContentUrl: function (contentItem) {
                var contenturl = '/media';
                var sourceMediaId = contentItem.data.source_media.id;
                var sourceMediaFileName = contentItem.data.source_media.properties.file_name;
                switch (contentItem.data.type) {
                    case 'session_recording':
                        contenturl = contenturl + '/session-recordings/' + sourceMediaId + '/' + sourceMediaFileName;
                        break;

                    case 'video':
                        contenturl = contenturl + '/videos/' + sourceMediaId + '/' + sourceMediaFileName;
                        break;

                    case 'document':
                        contenturl = contenturl + '/documents/' + sourceMediaFileName;
                        break;

                    case 'image':
                        contenturl = contenturl + '/images/' + sourceMediaFileName;
                        break;

                    case 'podcast':
                        contenturl = contenturl + '/audios/' + sourceMediaFileName;
                        break;

                    case 'zip':
                        contenturl = contenturl + '/zips/' + sourceMediaFileName;
                        break;
                }

                return contenturl;

            },
            playContent: function (contentType, contentItem, callback, assignmentId) {
                if (contentItem.data.type === 'link') {
                    $window.open(contentItem.data.source_url, "_blank");
                    this.markContentViewed(contentItem);
                    return;
                }

                if (contentItem.data.type === 'smart_page') {
                    var newWindow = $window.open();
                    newWindow.document.write(contentItem.data.content);
                    this.markContentViewed(contentItem);
                    return;
                }

                if (contentItem.data.type === 'video' && contentItem.data.source_url) {
                    $window.open(contentItem.data.source_url);
                    this.markContentViewed(contentItem);
                    return;
                }

                if (contentItem.data.type === 'video' && contentItem.data.embed_code) {
                    var newWindow = $window.open();
                    newWindow.document.write(contentItem.data.embed_code);
                    this.markContentViewed(contentItem);
                    return;
                }

                if (contentItem.data.type === 'podcast' && contentItem.data.embed_code) {
                    var newWindow = $window.open();
                    newWindow.document.write(contentItem.data.embed_code);
                    this.markContentViewed(contentItem);
                    return;
                }

                if (contentItem.data.type === 'document' && contentItem.data.embed_code) {
                    var newWindow = $window.open();
                    newWindow.document.write(contentItem.data.embed_code);
                    this.markContentViewed(contentItem);
                    return;
                }

                contentItem.loading = true;
                var contentUrl = this.getContentUrl(contentItem);
                $http
                    .get(contentUrl, {
                        responseType: "blob",
                    })
                    .success(function (data) {
                        if (callback) {
                            callback(contentItem);
                        }
                        var contentBlobUrl = $window.URL.createObjectURL(data);
                        $window.open(contentBlobUrl);
                        contentItem.loading = false;

                    });
            },
            previewContent: function (contentItem) {
                var contentType = contentItem.data.type;

                if (contentType == 'series') {
                    $mdDialog.show({
                        templateUrl: 'modules/content/detail/content-detail-dialog.tmpl.html',
                        clickOutsideToClose: true,
                        fullscreen: true,
                        controller: 'ContentDetailController',
                        controllerAs: "vm",
                        locals: {
                            id: contentItem.id,
                            preview: true
                        }
                    });
                } else if (contentType === 'course') {
                    if (contentItem.data.launch_mode == 'MODAL_WINDOW') {
                        Scorm.getCoursePreviewUrl({
                            id: contentItem.id,
                            appURL: 'closer'
                        }, function (result) {
                            $mdDialog.show({
                                templateUrl: 'modules/content/course-player.tmpl.html',
                                clickOutsideToClose: true,
                                fullscreen: true,
                                controller: 'CoursePlayerController',
                                locals: {
                                    dataToPass: contentItem,
                                    mode: 'preview',
                                    assignmentId: null,
                                    courseUrl: result.url
                                }
                            });
                        });
                    } else {
                        Scorm.getCoursePreviewUrl({
                            id: contentItem.id,
                            appURL: encodeURIComponent($location.absUrl())
                        }, function (result) {
                            $window.location.href = result.url;
                        });
                    }
                } else {
                    Content.get({
                        id: contentItem.id
                    }, function (result) {
                        $mdDialog.show({
                            templateUrl: 'modules/content/content-player.tmpl.html',
                            clickOutsideToClose: true,
                            fullscreen: true,
                            controller: 'ContentPlayerController',
                            locals: {
                                dataToPass: result,
                                mode: 'preview'
                            }
                        });
                    });
                }
            },
            openShareDialog: function (contents, callback) {
                $mdDialog.show({
                    templateUrl: 'modules/content/content-share-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "ContentShareController",
                    controllerAs: "vm",
                    locals: {
                        contents: contents
                    }
                }).then(function (result) {
                    if (callback) {
                        callback();
                    }
                }).finally(function () {
                });
            },
            openFeedbackDialog: function (reactionType, content) {
                if (reactionType == "FLAG" || reactionType == "PROBLEM") {
                    $mdDialog.show({
                        templateUrl: 'modules/content/content-feedback-dialog.tmpl.html',
                        clickOutsideToClose: true,
                        controller: "ContentFeedbackController",
                        controllerAs: "vm",
                        locals: {
                            content: content,
                            type: reactionType
                        }
                    }).finally(function () {
                    });
                }
            },
            openFlagDialog: function (content) {
                $mdDialog.show({
                    templateUrl: 'modules/content/content-feedback-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "ContentFeedbackController",
                    controllerAs: "vm",
                    locals: {
                        content: content,
                        type: "FLAG"
                    }
                }).finally(function () {
                });
            },
            openProblemDialog: function (content) {
                $mdDialog.show({
                    templateUrl: 'modules/content/content-feedback-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "ContentFeedbackController",
                    controllerAs: "vm",
                    locals: {
                        content: content,
                        type: "PROBLEM"
                    }
                }).finally(function () {
                });
            },
            bookmarkOrRemoveBookmarkContent: function (content, bookmarkData) {
                var deferred = $q.defer();

                var bookmarkContent = function () {
                    Experience.bookmark({
                        object: content,
                        user_id: Principal.getUserId()
                    }, function (result) {
                        deferred.resolve(result);
                    }, function (result) {
                        deferred.reject(pinData);
                    });
                }

                var removeBookmarkContent = function () {
                    Experience.removeBookmark({
                        id: pinData.id
                    }, function (result) {
                        deferred.resolve(result);
                    }, function (result) {
                        deferred.reject(likeData);
                    });
                }

                if (angular.isDefined(bookmarkData)) {
                    removeBookmarkContent();
                } else {
                    bookmarkContent();
                }
                return deferred.promise;
            },
            likeOrUnlikeContent: function (content, likeData) {
                var deferred = $q.defer();

                var likeContent = function () {
                    Experience.like({
                        object: content,
                        user_id: Principal.getUserId(),
                        reaction_type: 'LIKE'
                    }, function (result) {
                        deferred.resolve(result);
                    }, function (result) {
                        deferred.reject(likeData);
                    });
                }

                var unlikeContent = function () {
                    Experience.unlike({
                        id: likeData.id
                    }, function (result) {
                        deferred.resolve(result);
                    }, function (result) {
                        deferred.reject(likeData);
                    });
                }

                if (angular.isDefined(likeData)) {
                    unlikeContent();
                } else {
                    likeContent();
                }
                return deferred.promise;
            },
            getLikeData: function (content) {
                var deferred = $q.defer();
                Experience.getLikes({
                    query: "object_id==" + content.id + ";user_id==" + Principal.getUserId()
                }, function (result) {
                    var likeData = undefined;
                    if (result.length > 0) {
                        likeData = result[0];
                    }
                    deferred.resolve(likeData);
                }, function (result) {
                    deferred.reject(undefined);
                });
                return deferred.promise;
            },
            launchUserCardSummary: function (userId, content) {
                $mdDialog.show({
                    templateUrl: 'modules/content/smart-content-insight-user-card-summary.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "SmartContentInsightUserCardSummaryController",
                    controllerAs: "vm",
                    locals: {
                        content: content,
                        userId: userId,
                        title: content.title + ' Summary'
                    }
                }).finally(function () {
                });
            },
            openMyUploadDialog: function (ev, callback) {
                $mdDialog.show({
                    templateUrl: 'modules/user/upload/upload-dialog.tmpl.html',
                    targetEvent: ev,
                    controller: 'MyUploadDialogController',
                    controllerAs: 'vm',
                    clickOutsideToClose: true
                }).then(function (result) {
                    if (callback) {
                        callback();
                    }
                }).finally(function () {
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('BaseContentViewController', BaseContentViewController)

    /* @ngInject */
    function BaseContentViewController($scope, $sce, $filter, $mdBottomSheet, Principal, Experience, CONTENT_META) {

        $scope.completionData = undefined;
        $scope.isCompleted = false;

        $scope.isPreviewMode = false; // This is used where no view and no response is submitted
        $scope.isPlayMode = false; // This is used where view is submitted and response is submitted based on the HybridMode Value
        $scope.isHybridMode = false; // This is used as sub state of play, if true does not submit response for the content launched

        $scope.hasResponse = false;
        $scope.isContentRatingDone = false;

        $scope.responseData = angular.copy($scope.currentResponseData);

        $scope.needAnswer = ($scope.data.data.answer_data != null && $scope.data.data.answer_data != undefined) || $scope.data.data.required;

        if ($scope.mode == 'preview') {
            $scope.isPreviewMode = true;
            $scope.isPlayMode = false;
        } else if ($scope.mode == 'play') {
            $scope.isPreviewMode = false;
            $scope.isPlayMode = true;

            if ($scope.context != 'attention') {
                Experience.getResponses({
                    query: "object_id==" + $scope.data.id + ";user_id==" + Principal.getUserId() + ";assignment_id==" + $scope.assignment_id
                }, function(data) {
                    $scope.responseData = (data instanceof Array) ? data[0] : data;

                    if ($scope.responseData) {
                        $scope.hasResponse = true;
                        $scope.needAnswer = false;
                    } else {
                        // If specific responsedata on individual content type
                        if ($scope.setResponseToScope) {
                            $scope.setResponseToScope();
                        } else {
                            $scope.responseData = {
                                object: $scope.data,
                                response: {
                                    type: $scope.data.data.type,
                                    choice: undefined,
                                    correct: undefined,
                                    points: 0
                                },
                                user_id: Principal.getUserId(),
                                assignment_id: $scope.assignmentId,
                                context_id: $scope.contextId
                            };
                        }
                    }
                });
            }
        } else if ($scope.mode == 'hybrid') {
            $scope.isPreviewMode = false;
            $scope.isPlayMode = true;
            $scope.isHybridMode = true;
        }

        if ($scope.responseData) {
            $scope.hasResponse = true;
            $scope.needAnswer = false;
            if ($scope.setResponseToScope) {
                $scope.setResponseToScope();
            }
        } else {
            // If specific responsedata on individual content type
            if ($scope.setResponseToScope) {
                $scope.setResponseToScope();
            } else {
                $scope.responseData = {
                    object: $scope.data,
                    response: {
                        type: $scope.data.data.type,
                        choice: undefined,
                        correct: undefined,
                        points: 0
                    },
                    user_id: Principal.getUserId(),
                    assignment_id: $scope.assignmentId,
                    context_id: $scope.contextId
                };
            }
        }

        //If in play mode we get the completion data, based on which we show the completion mark on the content view
        if ($scope.isPlayMode) {
            if ($scope.context && $scope.context != 'smart-content') {
                Experience.getCompletions({
                    query: "object_id==" + $scope.data.id + ";user_id==" + Principal.getUserId() + ";assignment_id==" + $scope.assignmentId
                }, function(result) {
                    if (result.length > 0) {
                        $scope.completionData = result[0];
                        $scope.isCompleted = true;
                    }
                });
            }
        }

        //for all content other than smart content if we have any parent event either from parent as smart content or
        //attention player event emit required events on actions
        if ($scope.contentType.replace(/_/g, '-') !== "smart-content" && $scope.parentPlayerEvents) {
            $scope.moveNext = function() {
                $scope.$emit($scope.parentPlayerEvents + "PreserveState", {
                    preserveState: false
                });
            }

            $scope.$on($scope.contentType + "_smart_content_validate_" + $scope.data.id, function(event, data) {
                $scope.$emit($scope.parentPlayerEvents + "PreserveState", {
                    preserveState: $scope.needAnswer
                });
            });

            $scope.$on($scope.contentType + "_smart_content_updates_" + $scope.data.id, function(event, data) {
                $scope.$emit($scope.parentPlayerEvents + "UpdateState", $scope.getSmartContentUpdates());
            });
        }

        //this is function which is overridden at child contents where the bottomsheed feed back is to be shown
        $scope.showFeedback = function(firstTime) {
            angular.noop;
        }

        $scope.showExistingFeedback = function() {
            $mdBottomSheet.hide();
            if ($scope.hasResponse && $scope.hasFeedback()) {
                $scope.showFeedback(false);
            }
        }

        $scope.setFinalResponseObject = function() {
            angular.noop;
        }

        $scope.hasFeedback = function() {
            var cardMeta = $scope.getCardMeta();
            if (cardMeta.enable_feedback) {
                return true;
            } else {
                return false;
            }
        }

        // Create response for the content only if its in playmode and not in hybrid mode
        $scope.createResponse = function() {
            if ($scope.isPlayMode && !$scope.isHybridMode) {
                $scope.setFinalResponseObject();

                //fix this
                $scope.responseData.time_spent = 0;

                Experience.createResponse($scope.responseData, function(result) {
                    $scope.responseData = result;
                    $scope.handleResponse();

                    if ($scope.contentType.replace(/_/g, '-') !== "smart-content" && $scope.parentPlayerEvents) {
                        $scope.$emit("SmartContentUpdateResponse", { responseData: $scope.responseData });
                    }
                });
            } else {
                $scope.setFinalResponseObject();
                $scope.handleResponse();
                if ($scope.contentType.replace(/_/g, '-') !== "smart-content" && $scope.parentPlayerEvents) {
                    $scope.$emit("SmartContentUpdateResponse", { responseData: $scope.responseData });
                }
            }
        }

        $scope.handleResponse = function() {
            if ($scope.contextId != undefined && $scope.contextId != null) {
                $scope.needAnswer = false;
                $scope.hasResponse = true;
            }
            if ($scope.data.data.type !== 'smart_content') {
                $scope.performEndAction(false, true, false);
            }
        }

        $scope.getSmartContentUpdates = function() {
            $scope.showExistingFeedback();

            if ($scope.hasResponse && $scope.hasFeedback()) {
                return {
                    showNext: true,
                    showPrevious: true
                };
            } else {
                return {
                    showNext: !$scope.needAnswer,
                    showPrevious: true
                };
            }
        }

        $scope.getTemplateUrl = function() {
            return "modules/content/" + $scope.contentType.replace(/_/g, '-') + "-view.tmpl.html";
        }

        $scope.trustAsHtml = function(html) {
            return $sce.trustAsHtml(html);
        }

        $scope.getDocPreviewUrl = function(url) {
            var previewUrl = url.replace("cdn.filestackcontent.com", "www.filestackapi.com/api/preview");
            return $sce.trustAsResourceUrl(previewUrl);
        }

        $scope.getDocFileUrl = function(url) {
            return $sce.trustAsResourceUrl(url);
        }

        $scope.getAtheerDocPreviewUrl = function(mediaId, fileName) {
            const fileExt = fileName.includes(".PDF") ? ".PDF" : ".pdf";
            var previewUrl = "third-party/docviewer/viewer.html?file=/media/documents/" + mediaId + fileExt;
            return $sce.trustAsResourceUrl(previewUrl);
        }

        $scope.getLinkUrl = function(url) {
            return $sce.trustAsResourceUrl(url);
        }

        $scope.getTitleAlignment = function() {
            if ($scope.data == undefined) return;
            if ($scope.data.title_alignment === 'CENTER') {
                return "center";
            } else if ($scope.data.title_alignment === 'RIGHT') {
                return "end";
            } else {
                return "start";
            }
        }

        $scope.getMediaAlignment = function() {
            if ($scope.data == undefined) return;
            if ($scope.data.media_alignment === 'CENTER') {
                return "center";
            } else if ($scope.data.media_alignment === 'RIGHT') {
                return "end";
            } else {
                return "start";
            }
        }

        $scope.getMediaPosition = function() {
            if ($scope.data == undefined) return;
            if ($scope.data.media_position === 'BELOW_TITLE') {
                return "below";
            } else if ($scope.data.media_position === 'ABOVE_TITLE') {
                return "above";
            } else {
                return "below";
            }
        }

        $scope.getMediaShape = function() {
            if ($scope.data == undefined) return;
            if ($scope.data.media_shape === 'ROUND') {
                return "round";
            } else if ($scope.data.media_shape === 'SQUARE') {
                return "square";
            } else {
                return "square";
            }
        }

        $scope.getMediaSize = function() {
            if ($scope.data == undefined) return 'sm';
            if ($scope.data.media_size === 'LARGE') {
                return "lg";
            } else if ($scope.data.media_size === 'MEDIUM') {
                return "md";
            } else {
                return "sm";
            }
        }

        $scope.showMedia = function() {
            if ($scope.data == undefined) return;
            if ($scope.data.show_media && $scope.data.media_id !== null) {
                return true;
            } else {
                return false;
            }
        }

        $scope.getSpacerHeight = function(id) {
            var element = angular.element(document.querySelector('#fp-content-description-' + id));
            if (element && element[0]) {
                var height = element[0].offsetHeight + ($scope.showMedia() ? 100 : 0);
                if (height > 100) {
                    return 0;
                } else {
                    return 100 - height;
                }
                return height;
            } else {
                return 100;
            }
        }

        $scope.getCardMeta = function() {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: $scope.data.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        }


        //Main function which is called on done action done from the content views and then called in forward action
        // like after create response > show Feedback > show Ratings if required > call the done callback defined
        $scope.performEndAction = function(createResponse, showFeedback, showRating) {
            if (createResponse) {
                if (!$scope.hasResponse) {
                    $scope.createResponse();
                } else {
                    $scope.performEndAction(false, true, false);
                }
            } else if (showRating) {
                if ($scope.data.data.request_rating && !$scope.isContentRatingDone) {
                    var parentId = $scope.data.data.type === 'smart_content' ? $scope.data.data.cards[$scope.data.data.cards.length - 1].id + '-smart-content' : $scope.data.id;

                    $mdBottomSheet.show({
                        templateUrl: 'modules/content/content-rating.tmpl.html',
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        controller: 'ContentRatingController',
                        scope: $scope,
                        preserveScope: true,
                        parent: '#fp-content-view-' + parentId,
                        disableParentScroll: true
                    });
                } else {
                    $scope.performEndAction(false, false, false);
                }

            } else if (showFeedback) {
                if ($scope.hasFeedback()) {
                    $scope.showFeedback(true);
                } else {
                    $scope.performEndAction(false, false, true);
                }
            } else {
                if (typeof($scope.doneCallBack) == 'function') {
                    $scope.doneCallBack();
                    $scope.$emit($scope.parentPlayerEvents + "UpdateState", $scope.getSmartContentUpdates());
                } else {
                    angular.noop;
                }
            }

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('atheer.content')
        .controller('BaseContentDetailController', BaseContentDetailController)

    /* @ngInject */
    function BaseContentDetailController($mdDialog, Principal, User, $stateParams, Feature, $scope, $filter, $sce, $state, $q, AlertService, $mdToast, $mdSidenav, CONTENT_META, Content, ContentAction, Team, Topic, Folder, content_type, id, CONTENT_INSIGHT_META, CONTENT_RECOGNITION_META, MetaData, ToastService, DeeplinkService) {

        this.topics = [];
        this.audiences = [];
        this.folders = [];
        this.searchTopics = searchTopics;
        this.searchTeams = searchTeams;
        this.searchFolders = searchFolders;
        this.loadingData = true;
        this.metaFields = [];
        this.owner = null;
        this.id = id;
        this.allowContentOwner = Feature.isActive('feature_content_allow_owner');
        this.isCopied = false;
        this.downloadVideoShow = false;
        this.downloadVideoDisabled = false;
        $scope.descriptionLimitExceeded = false;

        var FORMLY_ATHEER_DATA_TYPE_MAPPING = {
            'BOOLEAN': 'boolean-switch',
            'STRING': 'input',
            'LIST': 'custom-select',
            'DATE': 'custom-datepicker',
            'DATETIME': 'custom-datepicker',
            'NUMBER': 'input',
            'DECIMAL': 'input',
            'ARRAY': 'custom-chips'
        };

        var FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING = {
            'STRING': 'text',
            'NUMBER': 'number',
            'DECIMAL': 'number'
        };

        this.contentMetaData = angular.copy($filter('filter')(CONTENT_META, {
            type: content_type
        })[0]);

        this.contentMetaData.default_model.title = $filter('translate')(this.contentMetaData.default_model.title);

        this.contentModel = this.contentMetaData.default_model;

        if ($state.params.contentType != undefined && $state.params.contentType.replace(/_/g, '-') === 'smart-content') {
            if (content_type === "smart-content") {
                this.showToolbar = true;
            } else {
                this.showToolbar = false
            }
        } else {
            this.showToolbar = true;
        }

        MetaData.get({
            id: 'content',
            is_name: true
        }, function (result) {
            if (result.field_groups && result.field_groups.length > 0 && result.field_groups[0].fields && result.field_groups[0].fields.length > 0) {
                angular.forEach(result.field_groups[0].fields, function (field) {
                    $scope.vm.metaFields.push(getFormlyField(field));
                });
            }
        });

        function getFormlyField(atheerfield) {
            var formlytype = FORMLY_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyTemplateType = FORMLY_TEMPLATE_TYPE_ATHEER_DATA_TYPE_MAPPING[atheerfield.data_type];
            var formlyField = {
                type: formlytype ? formlytype : 'input',
                key: atheerfield.name,
                templateOptions: {
                    label: atheerfield.label,
                    required: atheerfield.required
                }
            };

            if (formlyTemplateType) {
                formlyField.templateOptions['type'] = formlyTemplateType;
            }

            if (atheerfield.data_type == 'DATETIME') {
                formlyField.templateOptions['datepickerPopup'] = "HH:MM"
            }

            if (atheerfield.data_type == 'ARRAY') {
                formlyField.templateOptions['labelProp'] = "label"
                formlyField.defaultValue = [];
            }

            if (atheerfield.data_type == 'LIST') {
                formlyField.templateOptions['labelProp'] = "label";
                formlyField.templateOptions['valueProp'] = "option_id";
                formlyField.templateOptions['options'] = atheerfield.list_options;
            }

            if (atheerfield.data_type == 'OBJECT') {
                if (atheerfield.ref_object == 'Content') {
                    formlyField.templateOptions['objectName'] = 'Content';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'title',
                        operator: '=re='
                    }];
                } else if (atheerfield.ref_object == 'User') {
                    formlyField.templateOptions['objectName'] = 'User';
                    formlyField.templateOptions['queryObject'] = [{
                        fieldName: 'text_search',
                        operator: '=ts='
                    }];
                }
            }
            return formlyField;
        }

        if (this.showToolbar) {
            this.loadingData = true;
            if (id) {
                if ($stateParams.isDeeplink) {
                    var data = DeeplinkService.getContentData();
                    if (data) {
                        setTimeout(function () {
                            setContentData(data);
                        }, 2000)
                        DeeplinkService.setContentData({});
                    } else {
                        Content.get({
                            id: id
                        }, function (result) {
                            setContentData(result);
                        });
                    }
                } else {
                    Content.get({
                        id: id
                    }, function (result) {
                        setContentData(result);
                    });
                }
            } else {
                if (!this.allowContentOwner && Principal.getPrimaryTeam() != null) {
                    this.owner = Principal.getPrimaryTeam();
                    this.contentModel.owner_id = this.owner.id;
                }
                checkForDownload();
                this.loadingData = false;
            }
        }

        $scope.$watch('contentModel', function (newVal) {
            $scope.previewModel = newVal;
        })

        function setContentData(result) {
            $scope.vm.contentModel = result;

            var queue = [
                Topic.query({
                    query: 'id=in=(' + ($scope.vm.contentModel.data.topics ? $scope.vm.contentModel.data.topics.toString() : 'dummy') + ')'
                }).$promise,
                Team.query({
                    query: 'id=in=(' + ($scope.vm.contentModel.data.audiences ? $scope.vm.contentModel.data.audiences.toString() : 'dummy') + ')'
                }).$promise
            ];

            if ($scope.vm.contentModel.owner_id) {
                queue.push(Team.get({
                    id: $scope.vm.contentModel.owner_id
                }).$promise)
            }

            $q.all(queue).then(function (data) {
                $scope.vm.topics = data[0];
                $scope.vm.audiences = data[1];
                if ($scope.vm.contentModel.owner_id) {
                    $scope.vm.owner = data[2];
                }
                if ($stateParams.copy) {
                    $scope.vm.copyContent();
                    $stateParams.copy = false;
                }
                $scope.vm.loadingData = false;
                checkForDownload();
                if (!$scope.vm.contentModel.hasOwnProperty('tags')) {
                    $scope.vm.contentModel.tags = [];
                }
            });
        }

        function checkForDownload() {
            if ($scope.vm && $scope.vm.contentModel && $scope.vm.contentModel.data) {
                var contentData = $scope.vm.contentModel.data;
                if (contentData.type == 'image' || contentData.type == 'podcast' || contentData.type == 'video') {
                    $scope.vm.downloadVideoShow = true;
                    if (contentData.source_media) {
                        $scope.vm.downloadVideoDisabled = false;
                    }
                    else {
                        $scope.vm.downloadVideoDisabled = true;
                    }
                }
                else {
                    $scope.vm.downloadVideoShow = false;
                }
            }
        }

        this.downloadOnClick = function () {
            var href = ''
            switch (this.contentModel.data.type) {
                case 'image':
                    href = '/media/images/' + this.contentModel.data.source_media.properties.file_name;
                    break;

                case 'video':
                    href = '/media/videos/' + this.contentModel.data.source_media.id + '/' + this.contentModel.data.source_media.properties.file_name;
                    break;

                case 'podcast':
                    href = '/media/audios/' + this.contentModel.data.source_media.properties.file_name;
                    break;
            }
            var link = document.createElement('a');
            link.href = href;
            link.download = this.contentModel.data.source_media.id;
            link.target = '_blank';
            link.click();
        }

        this.showSaveShareButton = function () {
            switch (this.contentModel.data.type) {
                case "image":
                case "video":
                case "podcast":
                case "document":
                    return this.processStatus === "READY";
                case "link":
                    var urlExtractStatus = 'ready';
                    if(this.id !== '' ) {
                        urlExtractStatus = 'idle';
                    }                    
                    return (
                        !this.isURLInvalid() &&
                        (this.extractStatus === urlExtractStatus)
                    );
                default:
                    return true;
            }
        };

        this.onSaveSuccess = function (result) {
            $scope.vm.contentModel = result;

            AlertService.displayToast($mdToast);

            if (!$scope.vm.showToolbar) {
                $scope.$parent.vm.contentModel.data.cards[$scope.$parent.vm.currentSelectedCardIndex] = result;
                $scope.$parent.vm.save();
            }
        };

        this.onSaveSuccessNoAlert = function (result) {
            $scope.vm.contentModel = result;

            if (!$scope.vm.showToolbar) {
                $scope.$parent.vm.contentModel.data.cards[$scope.$parent.vm.currentSelectedCardIndex] = result;
                $scope.$parent.vm.save();
            }
        };

        this.onSaveError = function () {
            $scope.vm.isSaving = false;
        };

        this.onSaveErrorShow = function (error) {
            var error = error.data.$$state.value.description;
            $scope.vm.isSaving = false;
            ToastService.displayToast($filter('translate')('atheer.content.saveFailed', { reason: error }));
        };

        this.save = function () {
            this.updateContentModel();

            if (this.contentModel.id) {
                Content.update(this.contentModel, this.onSaveSuccess, this.onSaveErrorShow);
            } else {
                Content.save(this.contentModel, this.onSaveSuccess, this.onSaveErrorShow);
            }
        };

        this.saveOnAction = function () {
            this.updateContentModel();

            if (this.contentModel.id) {
                Content.update(this.contentModel, this.onSaveSuccessAction, this.onSaveError);
            } else {
                Content.save(this.contentModel, this.onSaveSuccessAction, this.onSaveError);
            }
        };

        this.saveNoAlert = function () {
            this.updateContentModel();

            if (this.contentModel.id) {
                Content.update(this.contentModel, this.onSaveSuccessNoAlert, this.onSaveError);
            } else {
                Content.save(this.contentModel, this.onSaveSuccessNoAlert, this.onSaveError);
            }
        };

        this.updateContentModel = function () {
            //update owner,topics and audiences
            if (this.owner) {
                this.contentModel.owner_id = this.owner.id
            } else {
                this.contentModel.owner_id = null;
            }
            if (this.topics && this.topics.length > 0) {
                var topicIds = [];
                angular.forEach(this.topics, function (topic) {
                    topicIds.push(topic.id);
                });
                this.contentModel.data.topics = topicIds;
            } else {
                this.contentModel.data.topics = null;
            }

            if (this.audiences && this.audiences.length > 0) {
                var audienceIds = [];
                angular.forEach(this.audiences, function (audience) {
                    audienceIds.push(audience.id);
                });
                this.contentModel.data.audiences = audienceIds;
            } else {
                this.contentModel.data.audiences = null;
            }

            if (this.folders && this.folders.length > 0) {
                var folderIds = [];
                angular.forEach(this.folders, function (folder) {
                    folderIds.push(folder.id);
                });
                this.contentModel.folders = folderIds;
            } else {
                this.contentModel.folders = null;
            }

            // article content - set the html entry for consistent rendering on all browsers
            if ( this.contentModel.data.type === "smart_page" ) {
                this.contentModel.data.content = "<head> <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" /> </head>" + this.contentModel.data.content;
            }
        }

        this.goToContent = function () {
            $state.go("storm.admin-contents");
        };

        this.togglePanel = function (componentId) {
            $mdSidenav(componentId).toggle();
        };

        this.isNew = function () {
            if (this.contentModel == undefined) return;
            if (this.contentModel.id == null && !this.isCopied && !$stateParams.id) {
                return true;
            } else {
                return false;
            }
        }

        this.copyContent = function () {
            delete this.contentModel['id'];
            this.contentModel.title = 'Copy of ' + this.contentModel.title;
            this.isCopied = true;

            ToastService.displayToast($filter('triTranslate')('atheer.content.contentCopied'), 3000)
        }

        this.transformChip = function (chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
        }

        this.openAssignModal = function () {
            ContentAction.openAssignModal([this.contentModel.id], this.contentModel.data.type == 'announcement', false);
        }

        this.openSendModal = function () {
            ContentAction.openSendModal([this.contentModel]);
        }

        this.openShareDialog = function () {
            ContentAction.openShareDialog([this.contentModel.id]);
        }

        this.showAssignAction = function (card) {
            return this.contentMetaData.show_assign_action;
        }

        this.showSendAction = function (card) {
            return this.contentMetaData.type == 'email-template';
        }

        this.showAskAction = function (card) {
            return this.contentMetaData.show_ask_action;
        }

        this.showRecommendAction = function (card) {
            return this.contentMetaData.show_recommend_action;
        }

        this.hasInsights = function () {
            return CONTENT_INSIGHT_META[this.contentModel.data.type] != undefined;
        }

        this.hasRecognition = function () {
            return CONTENT_RECOGNITION_META[this.contentModel.data.type] != undefined;
        }

        this.goBack = function () {
            if ($stateParams.isDeeplink) {
                window.history.go(-2);
            } else if(!!sessionStorage.getItem('DocumentListingQueryParams')) {
                $state.go('storm.content-documents', JSON.parse(sessionStorage.getItem('DocumentListingQueryParams')));
            } else {
                $state.go('storm.admin-contents');
            }
        }

        this.recordAudio = function () {
            $mdDialog.show({
                templateUrl: 'modules/content/content-audio-record-dialog.tmpl.html',
                controller: 'ContentAudioRecordController',
                controllerAs: 'vm',
                clickOutsideToClose: true
            })
                .then(function (media) {
                    $scope.vm.contentModel.audio_id = media.properties.file_name;

                    if (!$scope.vm.showToolbar) {
                        $scope.$parent.vm.saveOnAction();
                    }
                });
        }

        this.clearAudio = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.content.clearAudio'))
                .ariaLabel($filter('translate')('atheer.content.clearAudio'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                $scope.vm.contentModel.audio_id = null;
                if (!$scope.vm.showToolbar) {
                    $scope.$parent.vm.saveOnAction();
                }
            });
        }

        this.froalaOptions = {
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quote', 'save', 'table', 'url', 'video'],
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'insertImage', 'fullscreen'],
            toolbarButtonsMD: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'insertImage', 'fullscreen'],
            toolbarButtonsSM: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'insertImage', 'fullscreen'],
            toolbarButtonsXS: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'insertImage', 'fullscreen'],
            charCounterMax: 255,
            placeholderText: $filter('translate')('global.enterTextHerePlaceholder'),
            events: {
                "charCounter.update": function (e) {
                    if (this.el.textContent.length > 255) {
                        $scope.descriptionLimitExceeded = true;
                    } else {
                        $scope.descriptionLimitExceeded = false;
                    }
                    $scope.$apply();
                },
                "paste.before": function (e) {
                    var pastedPlainData = e.clipboardData.getData("text/plain");
                    this.html.insert(pastedPlainData);
                    this.undo.saveStep();
                    $scope.$apply();
                    return false;
                },
            },
        }

        function getQueryString(criteria) {
            if (criteria.length <= 0) {
                return null;
            } else {
                return 'name=re=' + criteria;
            }
        }

        function searchTopics(criteria) {
            var d = $q.defer();
            var result = Topic.query({
                query: getQueryString(criteria)
            }, function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function searchTeams(criteria) {
            var d = $q.defer();
            var result = Team.query({
                query: getQueryString(criteria)
            }, function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function searchFolders(criteria) {
            var d = $q.defer();
            var result = Folder.query({
                query: getQueryString(criteria)
            }, function (result) {
                d.resolve(result);
            });
            return d.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('AnnouncementInsightOverviewController', AnnouncementInsightOverviewController)

    /* @ngInject */
    function AnnouncementInsightOverviewController($scope, $q, $state, $filter, content_type, id, Report, Experience, ParseLinks, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadingData = false;
        vm.contentModel = $scope.$parent.vm.contentModel;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.illustartionEmptyScreenId = "insight_graph";

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Experience.getViews({
                    query: "object_id==" + id,
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    user_info: true
                }).$promise;

            function sort() {
                var result = [getSortOrder()];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        };

        vm.loadData = function() {
           vm.loadingData = true;
           Experience.getViews({
                    query: "object_id==" + id,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    user_info: true
                }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('AnnouncementDetailController', AnnouncementDetailController)
        .controller('AnnouncementViewController', AnnouncementViewController)

    /* @ngInject */
    function AnnouncementViewController($scope, $controller) {

        var basectrl = $controller('BaseContentViewController as vm', {
            $scope: $scope
        });
        angular.extend(this, basectrl);

        $scope.getImageSrc = function() {
            return $scope.showMedia() && $scope.data.media_id ? '/media/images/' + $scope.data.media_id : 'assets/images/card/announcement.svg';
        }

        $scope.getTitleHeight = function() {
            return document.getElementsByClassName('title')[0].clientHeight;
        }

        $scope.getTitleColor = function() {
            if($scope.data.data.title_color && $scope.data.data.title_color != null) {
                return $scope.data.data.title_color;
            } else {
                return '#343A3A';
            }
        };

        $scope.getContentColor = function() {
            if($scope.data.data.content_color && $scope.data.data.content_color != null) {
                return $scope.data.data.content_color;
            } else {
                return '#343A3A';
            }
        };
    }

    /* @ngInject */
    function AnnouncementDetailController($scope, $controller, id, $filter) {

        var basectrl = $controller('BaseContentDetailController as vm', {
            $scope: $scope,
            id:id,
            content_type: "announcement"
        });
        angular.extend(this, basectrl);

        var vm = this;

        $scope.descriptionLimitExceed = false;

        vm.froalaOptions = {
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quote', 'save', 'table', 'url', 'video'],
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            toolbarButtonsMD: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            toolbarButtonsSM: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            toolbarButtonsXS: ['bold', 'italic', 'underline', 'strikeThrough', 'insertLink'],
            charCounterMax: 255,
            placeholderText: $filter('translate')('atheer.content.announcementsView.content'),
            events: {
                "charCounter.update": function (e) {
                    if (this.el.textContent.length > 255) {
                        $scope.descriptionLimitExceed = true;
                    } else {
                        $scope.descriptionLimitExceed = false;
                    }
                    $scope.$apply();
                },
                "paste.before": function (e) {
                    var pastedPlainData = e.clipboardData.getData("text/plain");
                    this.html.insert(pastedPlainData);
                    this.undo.saveStep();
                    $scope.$apply();
                    return false;
                },
            },
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('AnnouncementAssignController', AnnouncementAssignController);

    /* @ngInject */
    function AnnouncementAssignController($scope, $state, $mdDialog, $q, $filter, $mdToast, User, content, Experience, Team, Principal) {
        var vm = this;

        vm.asyncUsers = [];
        vm.asyncTeams = [];
        vm.content = content;

        vm.assignProgress = 'idle';
        vm.assignSuccess = 0;

        vm.contentAssignModel = {
            required: false,
            is_due_date_relative: 'true',
            relative_period: 'DAYS',
            relative_value: 5,
            due_on: moment().add(5, 'd').toDate(),
            type: 'TODO',
            object: content
        }

        vm.close = function() {
            if (vm.assignProgress !== 'idle') {
                $mdDialog.hide();
            } else {
                $mdDialog.cancel();
            }
        }

        vm.submit = function() {
            vm.assignProgress = 'started';

            Experience.bulkAssign({
                required: vm.contentAssignModel.required,
                is_date_date_relative: vm.contentAssignModel.is_due_date_relative,
                relative_period: vm.contentAssignModel.relative_period,
                relative_value: vm.contentAssignModel.relative_value,
                users: vm.asyncUsers,
                audiences: vm.asyncTeams,
                assigned_by: Principal.getUserId(),
                due_on: vm.contentAssignModel.due_on,
                content_ids: vm.content
            }, function(result) {
                vm.assignProgress = 'complete';
                vm.assignSuccess = result.success;
            });
        }

        vm.disableSubmit = function() {
            if (vm.asyncUsers.length <= 0 && vm.asyncTeams.length <= 0) {
                return true;
            } else {
                if (vm.contentAssignModel.required) {
                    if (vm.contentAssignModel.is_due_date_relative == 0) {
                        if (vm.contentAssignModel.due_on == null) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (vm.contentAssignModel.is_due_date_relative == 1) {
                        if (vm.contentAssignModel.relative_value == null || vm.contentAssignModel.relative_value == '') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.cloud-admin', {
                url: '/cloud',
                abstract: true,
                views: {
                    '@storm': {
                        templateUrl: 'modules/cloud/cloud.tmpl.html',
                        controller: 'CloudController',
                        controllerAs: 'vm',
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/cloud/cloud-menu.tmpl.html',
                        controller: 'CloudMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.setting.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: false
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('CloudController', CloudController);

    /* @ngInject */
    function CloudController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.cloud')
        .controller('CloudMenuController', CloudMenuController);

    /* @ngInject */
    function CloudMenuController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.settings = [];
        vm.activeLink = $state.current.name;

        vm.settingsConfig = [{
            state: 'storm.cloud-admin.job-streams',
            icon: 'fa fa-tasks',
            label: 'atheer.cloud.jobs',
            adminOnly: false,
        },  {
            state: 'storm.cloud-admin.logs',
            icon: 'zmdi zmdi-storage',
            label: 'atheer.cloud.logs',
            adminOnly: false,
        }];


        function loadAll() {
            vm.loadingData = false;

            angular.forEach(vm.settingsConfig, function(setting) {
                var featureActive = true;
                var hasPermission = true;

                if (angular.isDefined(setting.feature)) {
                    featureActive = Feature.isActive(setting.feature);
                };

                if (angular.isDefined(setting.permission)) {
                    hasPermission = PermissionService.hasAccess(setting.permission);
                };

                if (setting.adminOnly && Principal.isWorkspaceAdmin()) {
                    vm.settings.push(setting);
                } else if (!setting.adminOnly && featureActive && hasPermission) {
                    vm.settings.push(setting);
                };
            });
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor', [

        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, ANCHOR_INSIGHT_META, ANCHOR_RECOGNITION_META) {
        $stateProvider
            .state('storm.admin-anchors', {
                url: '/anchors?page&sort&search',
                views: {
                    '@storm': {
                        templateUrl: 'modules/anchor/anchor.tmpl.html',
                        controller: 'AnchorController',
                        controllerAs: 'vm',
                    },
                    'toolbar@storm': {
                        templateUrl: 'modules/anchor/anchor-toolbar.tmpl.html',
                        controller: 'AnchorToolbarController',
                        controllerAs: 'vm'
                    },
                    'sideMenu@storm': {
                        templateUrl: 'modules/anchor/anchor-menu.tmpl.html',
                        controller: 'AnchorMenuController',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    pageTitle: 'atheer.anchor.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showSideNavMenu: true,
                        sideNavMenuPosition: 'left',
                        showToolbar: false,
                        sideNavMenuSize: 15
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-anchor-detail', {
                url: '/anchors/:id',
                templateUrl: 'modules/anchor/anchor-detail.tmpl.html',
                controller: 'AnchorDetailController as vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                }
            })
            .state('storm.admin-anchor-detail-recognition', {
                url: '/anchors/:id/recognition',
                templateUrl: 'modules/anchor/anchor-detail-recoginition.tmpl.html',
                controller: 'AnchorDetailRecognitionController as vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.admin-anchor-detail-recognition.section', {
                url: '/:section',
                templateUrl: function($stateParams) {
                    return ANCHOR_RECOGNITION_META['anchor'].sections[$stateParams.section || 'overview'].template;
                },
                controllerProvider: function($stateParams) {
                    return ANCHOR_RECOGNITION_META['anchor'].sections[$stateParams.section || 'overview'].controller;
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-anchor-detail-insights', {
                url: '/anchors/:id/insights',
                templateUrl: 'modules/anchor/anchor-detail-insights.tmpl.html',
                controller: 'AnchorDetailInsightsController as vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    id: function($stateParams) {
                        return $stateParams.id;
                    }
                }
            })
            .state('storm.admin-anchor-detail-insights.section', {
                url: '/:section',
                templateUrl: function($stateParams) {
                    return ANCHOR_INSIGHT_META['anchor'].sections[$stateParams.section || 'overview'].template;
                },
                controllerProvider: function($stateParams) {
                    return ANCHOR_INSIGHT_META['anchor'].sections[$stateParams.section || 'overview'].controller;
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    id: function($stateParams) {
                        return $stateParams.id;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorController', AnchorController);

    /* @ngInject */
    function AnchorController($rootScope, $scope, $state, $mdDialog, Anchor, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.illustartionEmptyScreenId = "anchor";

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1,
            filters: {
                folder: vm.defaultFolder,
                metaType: 'all',
                enabled: false,
                externalId: false
            }
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.deleteObject = deleteObject;
        vm.archiveObject = archiveObject;
        vm.editObject = editObject;
        vm.createObject = createObject;

        vm.permissions = {
            create: 'create-anchor',
            update: 'update-anchor',
            delete: 'delete-anchor',
            manage: 'manage-anchor'
        };

        vm.getMediaUrl = function(mediaUrl) {
            return $filter('mediaUrl')(mediaUrl);
        }

        vm.copyAnchor = function(contentId, contentType) {
            $state.go("storm.admin-content-detail", {
                'contentType': contentType.replace(/-/g, '_'),
                'id': contentId,
                'copy': true
            });
        }

        vm.onEnableChange = function(anchor) {
            Anchor.update(anchor, function() {
                ToastService.displayToast(anchor.name + ' ' + $filter('translate')('atheer.content.enableUpdateSuccess'), 3000);
            }, function() {
                ToastService.displayToast($filter('translate')('atheer.content.enableUpdateError'), 3000)
            });
        }

        function loadAll() {
            vm.loadingData = true;
            var savedQuery = getSavedFilters();
            if ( savedQuery ) {
                vm.query = savedQuery;
            }
            vm.page = vm.query.page;

            Anchor.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                query: getQueryString(),
                is_external_id: vm.query.filters.externalId
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (pagingParams.ascending ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.anchors = data;
                //vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Anchor.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: getSortOrder(),
                query: getQueryString(),
                is_external_id: vm.query.filters.externalId
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.anchors = data;
            });
            vm.query.page = vm.page;
            saveFilters(vm.query);
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            var anchorQuery = vm.query.filters.metaType == 'all' ? '' : ';' + vm.query.filters.metaType;

            if (vm.query.filters.enabled) {
                if (anchorQuery === "") {
                    anchorQuery = 'enable==true';
                } else {
                    anchorQuery = anchorQuery + ';enable==true';
                }
            }

            if (vm.query.filters.enabled) {
                if (vm.query.filter.length > 0) {
                    anchorQuery = anchorQuery + ";" + 'name=re=' + vm.query.filter;
                }
            } else {
                if (vm.query.filter.length > 0) {
                    anchorQuery = 'name=re=' + vm.query.filter;
                }
            }

            return anchorQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function createObject() {
            $state.go("storm.admin-anchor-detail");
        }

        function editObject(anchorId) {
            $state.go("storm.admin-anchor-detail", {
                'id': anchorId
            });
        }

        function archiveObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.anchor.archiveAnchor'))
                .ariaLabel($filter('translate')('atheer.anchor.archiveAnchor'))
                .ok($filter('translate')('entity.action.archive'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                entity.status = 'ARCHIVED';

                Anchor.update(entity, function() {
                    resetModal();
                });
            });
        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.anchor.deleteAnchor'))
                .ariaLabel($filter('translate')('atheer.anchor.deleteAnchor'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Anchor.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
            if (vm.filter.show) {
                vm.showFolders = false;
            }
        }

        vm.seeInsights = function(anchorId) {
            $state.go("storm.admin-anchor-detail-insights.section", {
                'id': anchorId,
                'section': 'overview'
            });
        };

        var refreshAnchorListener = $rootScope.$on('refreshAnchors', function(event, filter) {
            vm.query.filter = filter;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.loadAll();
        });

        var updateAnchorListener = $rootScope.$on('updateSmartscanList', function(event, filters) {
            if (filters.externalId || filters.enabled) {
                vm.illustartionEmptyScreenId = "no_anchor";
            } else {
                vm.illustartionEmptyScreenId = "anchor";
            }
            vm.query.filters = filters;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.loadAll();
        });

        function saveFilters(filterData) {
            sessionStorage.setItem('objectFilters', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectFilters'));
        };

        // Unregister
        $scope.$on('$destroy', function() {
            refreshAnchorListener();
            updateAnchorListener();
        });

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorToolbarController', AnchorToolbarController);

    /* @ngInject */
    function AnchorToolbarController($rootScope, $scope, $state, $mdDialog, Anchor, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        if ( getSavedFilters() ) {
            vm.query = getSavedFilters();
        }

        vm.removeFilter = removeFilter;
        vm.filter.show = vm.query.filter.length > 0 ? true : false;
        vm.createEnabled = false;
        vm.createObject = createObject;

        vm.permissions = {
            create: 'create-anchor',
            update: 'update-anchor',
            delete: 'delete-anchor',
            manage: 'manage-anchor'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        function refreshAll() {
            saveFilters(vm.query);
            $scope.$emit('refreshAnchors', vm.query.filter);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            saveFilters(vm.query);
            $scope.$emit('refreshAnchors', vm.query.filter);
        };

        function createObject() {
            $state.go("storm.admin-anchor-detail");
        };

        function saveFilters(filterData) {
            sessionStorage.setItem('objectHeader', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectHeader'));
        };
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.anchor')
        .constant('ANCHOR_RECOGNITION_META', {
            anchor: {
                sections: {
                    qr_code: {
                        label: 'atheer.anchor.qrCode',
                        icon: 'zmdi zmdi-account',
                        controller: 'AnchorDetailQRCodeController',
                        template: 'modules/anchor/anchor-detail-qrcode.tmpl.html'
                    }
                }
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorMenuController', AnchorMenuController);

    /* @ngInject */
    function AnchorMenuController($scope, $state, $mdDialog, $mdPanel, Anchor, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, CONTENT_META, $translate, Feature) {
        var vm = this;

        vm.loadingData = true;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;

        vm.filters = {
            metaType: 'all',
            enabled: false,
            externalId: false,
            status: null,
        };

        if ( getSavedFilters() ) {
            vm.filters = getSavedFilters();
        }

        vm.updateFilters = function() {
            saveFilters(vm.filters);
            $scope.$emit('updateSmartscanList', vm.filters);
        }

        vm.loadAll = function() {
            vm.loadingData = false;
        }

        function saveFilters(filterData) {
            sessionStorage.setItem('objectMenu', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectMenu'));
        };
        
        vm.loadAll();
    }
})();
;
(function() {

    'use strict';
    angular
        .module('atheer.anchor')
        .constant('ANCHOR_INSIGHT_META', {
            anchor: {
                sections: {
                    overview: {
                        label: 'atheer.anchor.overview',
                        icon: 'zmdi zmdi-account',
                        controller: 'AnchorInsightOverviewController',
                        template: 'modules/anchor/anchor-insight-overview.tmpl.html'
                    },
                    scan_history: {
                        label: 'atheer.anchor.scanHistory',
                        icon: 'zmdi zmdi-account',
                        controller: 'AnchorInsightScanHistoryController',
                        template: 'modules/anchor/anchor-insight-scan-history.tmpl.html'
                    }
                }
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorInsightScanHistoryController', AnchorInsightScanHistoryController)

    /* @ngInject */
    function AnchorInsightScanHistoryController($scope, $q, $state, $filter, id, Report, Experience, ParseLinks, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadingData = false;
        vm.contentModel = $scope.$parent.vm.contentModel;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.pageSize = paginationConstants.itemsPerPage;

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Experience.getScans({
                    query: "object_id==" + id,
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    user_info: true
                }).$promise;

            function sort() {
                var result = [getSortOrder()];
                
                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('id')) {
                return vm.predicate + ',' + 'desc';
            }

            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }
        };

        vm.loadData = function() {
           vm.loadingData = true;
           Experience.getScans({
                    query: "object_id==" + id,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    user_info: true
                }, onSuccess, onError);

            function sort() {
                var result = [getSortOrder()];
                
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        vm.loadData();
    }
})();

;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorInsightOverviewController', AnchorInsightOverviewController)

    /* @ngInject */
    function AnchorInsightOverviewController($scope, $q, $filter, id, Report) {
        var vm = this;

        vm.loadingData = false;

        vm.anchorScansByDay = {
            chart: {
                type: 'column',
            },
            title: {
                text: $filter('translate')('atheer.anchor.scanPerDay')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.anchor.noOfScans')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $filter('translate')('atheer.anchor.dates'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            angular.forEach(vm.dashboardModel.anchor_scan_by_day, function(anchorScansByDay) {
                vm.anchorScansByDay.xAxis.categories.push(anchorScansByDay.name);
                vm.anchorScansByDay.series[0].data.push(anchorScansByDay.count);
            });

            vm.loadingData = false;
        }
        
        vm.loadData = function() {
           vm.loadingData = true;

            var resource = Report.getAnchorSummary({
                id : id
            }).$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess();
                });
        }

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorDetailController', AnchorDetailController)

    /* @ngInject */
    function AnchorDetailController($mdDialog, $scope, $filter, $sce, $q, ParseLinks, pagingParams, paginationConstants, $state, Team, AlertService, $mdToast, $mdSidenav, Principal, AirForm, Anchor, Content, ContentAction, CONTENT_META, User, id, $timeout) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.anchorModel = null;
        vm.view = "CONTENT";
        vm.content = [];
        vm.airForms = [];
        vm.users = [];
        vm.loadingContent = false;
        vm.loadingAirForms = false;
        vm.loadingUsers = false;
        vm.show_settings = false;
        vm.enable_scheduling = false;
        vm.show_audiences = false;
        vm.owner = null;
        vm.audiences = [];
        vm.illustrationEmptyScreenIdContent = "no_content_anchor";
        vm.illustrationEmptyScreenIdAnchor = "no_airform_anchor";
        vm.illustrationEmptyScreenIdUser = "no_user_anchor";

        vm.isHovered = false;

        vm.query = {
            filter: '',
            limit: '10',
            order: '-id',
            page: 1
        };

        vm.loadData = function() {

            if (id) {
                vm.loadingData = true;
                Anchor.get({
                    id: id
                }, function(result) {
                    vm.anchorModel = result;
                    vm.loadContent();
                    vm.loadAirForms();
                    vm.loadUsers();

                    var queue = [
                        Team.query({
                            query: 'id=in=(' + ((vm.anchorModel.audiences && vm.anchorModel.audiences.length != 0) ? vm.anchorModel.audiences.toString() : 'dummy') + ')'
                        }).$promise
                    ];

                    if (vm.anchorModel.owner_id) {
                        queue.push(Team.get({
                            id: vm.anchorModel.owner_id
                        }).$promise)
                    }

                    $q.all(queue).then(function(data) {
                        vm.audiences = data[0];
                        if (vm.anchorModel.owner_id) {
                            vm.owner = data[1];
                        }
                    });

                    if (vm.anchorModel.available_from) {
                        vm.anchorModel.available_from = new Date(vm.anchorModel.available_from)
                    }
                    if (vm.anchorModel.discontinue_from) {
                        vm.anchorModel.discontinue_from = new Date(vm.anchorModel.discontinue_from)
                    }

                    vm.loadingData = false;
                });
            } else {
                vm.anchorModel = {
                    name: null,
                    description: null,
                    status: 'PENDING',
                    enable: false,
                    external_id: null,
                    available_from: new Date(),
                    discontinue_from: new Date(),
                    owner_id: null,
                    audiences: []
                }
            };
        }

        vm.loadContent = function() {
            vm.loadingContent = true;
            if (angular.isDefined(vm.anchorModel.content) && vm.anchorModel.content.length > 0) {
                Content.getUnfilteredContents({
                    page: 0,
                    size: 50,
                    sort: 'title,asc',
                    query: 'id=in=(' + vm.anchorModel.content + ')'
                }, function(data, headers) {
                    vm.content = data;
                    vm.loadingContent = false;
                });
            } else {
                vm.content = [];
                vm.loadingContent = false;
            };
        };

        vm.loadAirForms = function() {
            vm.loadingAirForms = true;
            if (angular.isDefined(vm.anchorModel.air_forms) && vm.anchorModel.air_forms.length > 0) {
                AirForm.query({
                    page: 0,
                    size: 50,
                    sort: 'name,asc',
                    query: 'id=in=(' + vm.anchorModel.air_forms + ');status==ACTIVE'
                }, function(data, headers) {
                    vm.airForms = data;
                    vm.loadingAirForms = false;
                });
            } else {
                vm.airForms = [];
                vm.loadingAirForms = false;
            };
        };

        vm.loadUsers = function() {
            vm.loadingUsers = true;
            if (angular.isDefined(vm.anchorModel.users) && vm.anchorModel.users.length > 0) {
                User.query({
                    page: 0,
                    size: 50,
                    sort: 'first_name,asc',
                    query: 'id=in=(' + vm.anchorModel.users + ')'
                }, function(data, headers) {
                    vm.users = data;
                    vm.loadingUsers = false;
                });
            } else {
                vm.users = [];
                vm.loadingUsers = false;
            };
        };

        vm.onSaveSuccess = function(result) {
            vm.anchorModel = result;
            vm.isSaving = false;
            if (vm.anchorModel.available_from) {
                vm.anchorModel.available_from = new Date(vm.anchorModel.available_from)
            }
            if (vm.anchorModel.discontinue_from) {
                vm.anchorModel.discontinue_from = new Date(vm.anchorModel.discontinue_from)
            }
            AlertService.displayToast($mdToast);
        };

        vm.onSaveError = function() {
            vm.isSaving = false;
        };

        vm.save = function() {
            if (vm.owner) {
                vm.anchorModel.owner_id = vm.owner.id
            }

            if (vm.audiences && vm.audiences.length > 0) {
                var audienceIds = [];
                angular.forEach(vm.audiences, function(audience) {
                    audienceIds.push(audience.id);
                });
                vm.anchorModel.audiences = audienceIds;
            }

            if (vm.anchorModel.id) {
                Anchor.update(vm.anchorModel, vm.onSaveSuccess, vm.onSaveError);
            } else {
                Anchor.save(vm.anchorModel, vm.onSaveSuccess, vm.onSaveError);
            }
        };

        vm.goToAnchors = function() {
            $state.go('storm.admin-anchors');
        };

        vm.isNew = function() {
            if (vm.anchorModel == undefined || vm.anchorModel.id == null) {
                return true;
            } else {
                return false;
            }
        };

        vm.copyAnchor = function() {
            delete vm.anchorModel['id'];
        };

        vm.togglePanel = function(componentId) {
            $mdSidenav(componentId).toggle();
        };

        vm.openContentPicker = function() {
            var filterQuery = 'embedded==false;type!=SERIES;meta_type==DISCOVERABLE;enabled==true;status!=ARCHIVED';
            if (!angular.isUndefined(vm.anchorModel.content) && vm.anchorModel.content.length != 0) {
                filterQuery = filterQuery + ';id=out=(' + vm.anchorModel.content.toString()+')'
            }
            $mdDialog.show({
                    templateUrl: 'modules/content/content-picker.html',
                    controller: 'ContentPickerController',
                    controllerAs: 'vm',
                    clickOutsideToClose: true,
                    locals: {
                        filter: filterQuery,
                        allowMultiSelect: true,
                        isWeb: true,
                        isNotFilter: true
                    }
                })
                .then(function(selectedItems) {
                    var contentIds = [];
                    angular.forEach(selectedItems, function(content) {
                        contentIds.push(content.id);
                    });

                    if (angular.isUndefined(vm.anchorModel.content)) {
                        vm.anchorModel.content = contentIds;
                    } else {
                        angular.forEach(contentIds, function(contentId) {
                            if (vm.anchorModel.content.indexOf(contentId) == -1) {
                                vm.anchorModel.content.push(contentId);
                            }
                        });
                    };
                    vm.save();
                    vm.loadContent();
                });
        };

        vm.openAirFormPicker = function() {
            var filterQuery = 'status==ACTIVE';
            if (!angular.isUndefined(vm.anchorModel.air_forms) && vm.anchorModel.air_forms.length != 0) {
                filterQuery = filterQuery + ';id=out=(' + vm.anchorModel.air_forms.toString()+')'
            }
            $mdDialog.show({
                    controller: 'AirFormPickerController',
                    templateUrl: 'modules/airform/airform-picker.tmpl.html',
                    controllerAs: 'vm',
                    locals: {
                        filter: filterQuery,
                        allowMultiSelect: true
                    }
                })
                .then(function(selectedItems) {
                    var airformIds = [];
                    angular.forEach(selectedItems, function(airform) {
                        airformIds.push(airform.id);
                    });

                    if (angular.isUndefined(vm.anchorModel.air_forms)) {
                        vm.anchorModel.air_forms = airformIds;
                    } else {
                        angular.forEach(airformIds, function(airformId) {
                            if (vm.anchorModel.air_forms.indexOf(airformId) == -1) {
                                vm.anchorModel.air_forms.push(airformId);
                            }
                        });
                    };

                    vm.save();
                    vm.loadAirForms();
                });
        };

        vm.openUserPicker = function() {
            $mdDialog.show({
                    templateUrl: 'modules/user/user-picker.tmpl.html',
                    controller: 'UserPickerController',
                    controllerAs: 'vm',
                    locals: {
                        filter: vm.anchorModel.users,
                        allowMultiSelect: true,
                        userslist: [],
                        isSession: false,
                        isScheduledSession: false,
                        isAdmin: true,
                        isConversationSession: false,
                        isSmartScan: false
                    }
                })
                .then(function(selectedItems) {
                    var userIds = [];
                    angular.forEach(selectedItems, function(user) {
                        userIds.push(user.id);
                    });

                    if (angular.isUndefined(vm.anchorModel.users)) {
                        vm.anchorModel.users = userIds;
                    } else {
                        angular.forEach(userIds, function(userId) {
                            if (vm.anchorModel.users.indexOf(userId) == -1) {
                                vm.anchorModel.users.push(userId);
                            }
                        });
                    };
                    vm.save();
                    vm.loadUsers();
                });
        };

        vm.removeContent = function(content) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.anchor.removeContent'))
                .ariaLabel($filter('translate')('atheer.anchor.removeContent'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                var index = vm.anchorModel.content.indexOf(content.id);
                vm.anchorModel.content.splice(index, 1);
                vm.save();
                vm.loadContent();
            }).finally(function() {});
        };

        vm.removeAirForm = function(airform) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.anchor.removeAirForm'))
                .ariaLabel($filter('translate')('atheer.anchor.removeAirForm'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                var index = vm.anchorModel.air_forms.indexOf(airform.id);
                vm.anchorModel.air_forms.splice(index, 1);
                vm.save();
                vm.loadAirForms();
            }).finally(function() {});
        };

        vm.removeUser = function(user) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.anchor.removeUser'))
                .ariaLabel($filter('translate')('atheer.anchor.removeUser'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                var index = vm.anchorModel.users.indexOf(user.id);
                vm.anchorModel.users.splice(index, 1);
                vm.save();
                vm.loadUsers();
            }).finally(function() {});
        };

        vm.getContentMeta = function(content) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: content.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        vm.launchContentPreview = function(content) {
            ContentAction.previewContent(content);
        };

        vm.hideInfo = function() {
            $timeout(function() {
                if(vm.isHovered) {
                    vm.isHovered = false;
                }
            }, 3000);
        };

        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorDetailInsightsController', AnchorDetailInsightsController)

    /* @ngInject */
    function AnchorDetailInsightsController($mdDialog, $scope, $filter, $sce, $q, ParseLinks, pagingParams, paginationConstants, $state, Team, AlertService, $mdToast, $mdSidenav, ANCHOR_INSIGHT_META, Principal, Anchor, ContentAction, User, id) {

        var vm = this;

        vm.loadingData = true;

        vm.insightSections = angular.copy(ANCHOR_INSIGHT_META['anchor'].sections);

        vm.anchorModel = null;

        vm.loadData = function() {
            if (id) {
                Anchor.get({
                    id: id
                }, function(result) {
                    vm.anchorModel = result;
                    vm.loadingData = false;
                });
            }
        }
        vm.loadData();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.airform', [

        ]);
})();
;
(function () {
	'use strict';

	angular.module('atheer.airform').config(stateConfig);

	/* @ngInject */
	function stateConfig($stateProvider, CONTENT_INSIGHT_META) {
		$stateProvider
			.state('storm.admin-job-templates', {
				url: '/airforms/settings/job-templates',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-job-template-detail-card', {
				url: '/airforms/settings/job-templates/:id/card',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-job-template-detail-board', {
				url: '/airforms/settings/job-templates/:id/board',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-job-template-detail-definition', {
				url: '/airforms/settings/job-templates/:id/definition',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-job-template-detail', {
				url: '/airforms/settings/job-templates/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-data-exports', {
				url: '/airforms/settings/data-exports',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-data-export-detail', {
				url: '/airforms/settings/data-exports/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-scheduler-list', {
				url: '/airforms/settings/scheduler-list',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-scheduler-detail', {
				url: '/airforms/settings/scheduler/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-airforms-preview', {
				url: '/airforms-preview/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-step-templates', {
				url: '/airforms/settings/step-templates',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-step-template-detail', {
				url: '/airforms/settings/step-templates/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-datasets', {
				url: '/airforms/settings/datasets',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-dataset-detail', {
				url: '/airforms/settings/datasets/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-categories', {
				url: '/airforms/settings/categories',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-notification-templates', {
				url: '/airforms/settings/notification-templates',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-airform-review-flows', {
				url: '/airforms/settings/reviewflows',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-airform-review-flow', {
				url: '/airforms/settings/reviewflow',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-airform-review-flow-detail', {
				url: '/airforms/settings/reviewflow/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-airforms', {
				url: '/airforms',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				}
			})
			.state('storm.admin-airform-detail', {
				url: '/airforms/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
			.state('storm.admin-airform-dashboard', {
				url: '/airforms/insights/:id',
				templateUrl: 'modules/ngx-frame.html',
				controller: 'AirFormController',
				controllerAs: 'vm',
				data: {
					pageTitle: 'atheer.applet.home.title',
					layout: {
						contentClass: 'layout-column',
						footer: false,
						showSideNavMenu: false,
						sideNavMenuPosition: 'left',
						showToolbar: false,
						sideNavMenuSize: 15
					}
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id;
					}
				}
			})
	}
})();
;
(function () {
	'use strict';

	angular.module('atheer.airform').controller('AirFormController', AirFormController);

	/* @ngInject */
	function AirFormController(
		$state,
		$scope,
		$sce,
		BuildLanguages,
		$location,
		$window,
		$rootScope
	) {
		var vm = this;
		vm.ngxUrlTrusted = null;
		vm.isIFrameDataLoaded = false;

		function setNgxPageUrl() {
			var ngxUrl = null;
			var buildLanguage = BuildLanguages.getBuildLanguage();
			var path = $location.path();
			var hostUrl =
				location.hostname === 'localhost'
					? 'https://' + location.hostname + ':4200'
					: location.origin;

			if ($state.current.name == 'storm.admin-airforms') {
				ngxUrl = hostUrl + '/ngx/airform';
			} else if ($state.current.name == 'storm.admin-airform-detail') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/airform/' + id;
			} else if ($state.current.name == 'storm.admin-airform-dashboard') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/airform/insights/' + id;
			} else if ($state.current.name == 'storm.admin-job-templates') {
				ngxUrl = hostUrl + '/ngx/config/template';
			} else if ($state.current.name == 'storm.admin-job-template-detail') {
				var id = path.split('/')[path.split('/').length - 1];
				ngxUrl = hostUrl + '/ngx/config/activityTemplate/'+id+'/definition';
			} else if($state.current.name == 'storm.admin-job-template-detail-definition') {
				var id = path.split('/')[path.split('/').length - 2];
                ngxUrl = hostUrl + '/ngx/config/activityTemplate/'+id+'/definition';
			} else if ($state.current.name == 'storm.admin-job-template-detail-card') {
				var id = path.split('/')[path.split('/').length - 2];
				ngxUrl = hostUrl + '/ngx/config/activityTemplate/'+id+'/card';
			} else if ($state.current.name == 'storm.admin-job-template-detail-board') {
				var id = path.split('/')[path.split('/').length - 2];
				ngxUrl = hostUrl + '/ngx/config/activityTemplate/'+id+'/board';
			} else if ($state.current.name == 'storm.admin-data-exports') {
				ngxUrl = hostUrl + '/ngx/config/template/dataexport';
			} else if ($state.current.name == 'storm.admin-data-export-detail') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/config/template/dataexport/' + id;
			} else if ($state.current.name == 'storm.admin-step-templates') {
				ngxUrl = hostUrl + '/ngx/config/template/step';
			} else if ($state.current.name == 'storm.admin-step-template-detail') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/config/template/step/' + id;
			} else if ($state.current.name == 'storm.admin-datasets') {
				ngxUrl = hostUrl + '/ngx/config/template/dataset';
			} else if ($state.current.name == 'storm.admin-dataset-detail') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/config/template/dataset/' + id;
			} else if ($state.current.name == 'storm.admin-categories') {
				ngxUrl = hostUrl + '/ngx/config/template/categories';
			} else if ($state.current.name == 'storm.admin-notification-templates') {
				ngxUrl = hostUrl + '/ngx/config/template/notification';
			} else if ($state.current.name == 'storm.admin-scheduler-list') {
				ngxUrl = hostUrl + '/ngx/config/template/job-scheduler-list';
			} else if ($state.current.name == 'storm.admin-airform-review-flows') {
				ngxUrl = hostUrl + '/ngx/config/template/reviewflows';
			} else if ($state.current.name == 'storm.admin-airform-review-flow') {
				ngxUrl = hostUrl + '/ngx/config/template/reviewflow';
			} else if ($state.current.name == 'storm.admin-airform-review-flow-detail') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/config/template/reviewflow/' + id;
			} else if ($state.current.name == 'storm.admin-scheduler-detail') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/config/template/job-scheduler/' + id + '/details';
			} else if ($state.current.name == 'storm.admin-airforms-preview') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/airforms-preview/' + id;
			} else {
				ngxUrl = ngxUrl = hostUrl + '/ngx/airform';
			}

			vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
			$rootScope.selectedLeftNavMenu = 'airforms';
		}

		function handleNgxEvent(event) {
			var hostUrl =
				location.hostname === 'localhost'
					? 'https://' + location.hostname + ':4200'
					: location.origin;
			if (event.origin !== hostUrl) return;
			if (event.data.ngxLocationChanged) {
				var ngState = event.data.ngxLocationChanged.ngState;
				var id = event.data.ngxLocationChanged.id;
				vm.isIFrameDataLoaded = true;
				scopeApply();

				if (id == null) {
					$state.transitionTo(ngState, null, {
						location: true,
						inherit: true,
						relative: $state.$current,
						notify: false
					});
				} else {
					$state.transitionTo(
						ngState,
						{
							id: id
						},
						{
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: false
						}
					);
				}
			}
		}

		var scopeApply = function (fn) {
			var phase = $scope.$root.$$phase;
			if (phase !== "$apply" && phase !== "$digest") {
				return $scope.$apply(fn);
			}
		};

		$window.addEventListener('message', handleNgxEvent, false);

		// Unregister
		$scope.$on('$destroy', function () {
			window.removeEventListener('message', handleNgxEvent, false);
		});

		setNgxPageUrl();
	}
})();
;
(function() {
    'use strict';

    angular
        .module('atheer.airform')
        .controller('AirFormPickerController', AirFormPickerController);

    /* @ngInject */
    function AirFormPickerController($scope, $state, triSettings, AirForm, allowMultiSelect, filter, ParseLinks, AlertService, $mdDialog, Principal, paginationConstants) {
        var vm = this;

        vm.loadingData = false;
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.removeFilter = removeFilter;
        vm.allowMultiSelect = allowMultiSelect;
        vm.airformFilter = filter;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = "id";
        vm.page = 1;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.totalItems = null;
        vm.currentSelectedAirForms = [];
        vm.airformFilter = [];
        vm.illustartionEmptyScreenId = "no_airforms";

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            show: false,
            options: {
                debounce: 500
            }
        };

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedAirForms);
        };

        vm.close = function() {
            $mdDialog.cancel();
        };

        function loadAll() {
            var query = null;
            query = getQueryString();
            vm.loadingData = true;
            AirForm.getActiveAirform({
                query: query,
                page: 0,
                size: vm.query.limit,
                sort: sort(),
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.airforms = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                vm.loadingData = false;
                AlertService.error(error.data.message);
            }
        };

        function transition() {
            var query = null;
            query = getQueryString();
            vm.promise = AirForm.getActiveAirform({
                query: query,
                page: vm.page - 1,
                size: vm.query.limit,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.airforms = data;
            });
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        };

        function getQueryString() {
            var airformQuery =  '(status==ACTIVE)';
            if (filter.length != 0) {
                airformQuery = filter;
            }
            if (vm.query.filter.length != 0) {
               airformQuery = airformQuery + ';(name=re="' + vm.query.filter + '")';
            }
            return airformQuery;
        };

        function resetModal() {
            loadAll();
        };
        vm.loadAll();
    }
})();
;
(function () {
  'use strict';

  angular.module('atheer').config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, triMenuProvider) {
    triMenuProvider.addMenu({
      id: 'home',
      name: 'global.menu.home',
      icon: 'zmdi zmdi-home',
      type: 'link',
      state: 'storm.home',
      url: '/home',
      active: false,
      priority: 0.1,
    });

    triMenuProvider.addMenu({
      id: 'conversations',
      name: 'global.menu.conversations',
      icon: 'fa fa-comments',
      type: 'link',
      state: 'storm.conversations',
      permission: 'access-conversation',
      feature: 'feature_conversation_enable',
      url: '/conversations',
      active: false,
      priority: 0.11,
    });

    triMenuProvider.addMenu({
      id: 'airsessions',
      name: 'global.menu.airSession',
      icon: 'zmdi zmdi-comment-video',
      type: 'link',
      state: 'storm.sessions.upcoming',
      permission: 'access-session',
      feature: 'feature_airsession_enable',
      url: '/sessions/upcoming',
      active: false,
      priority: 0.12,
    });

    triMenuProvider.addMenu({
      id: 'jobs',
      name: 'global.menu.jobs',
      icon: 'zmdi zmdi-assignment',
      state: 'storm.jobs',
      permission: 'access-job',
      feature: 'feature_airform_enable',
      url: '/jobs',
      type: 'link',
      active: true,
      priority: 0.13,
    });

    triMenuProvider.addMenu({
      id: 'tickets',
      name: 'global.menu.tickets',
      icon: 'flp ath-tickets',
      state: 'storm.tickets',
      feature: 'feature_ticket_enable_ticket',
      url: '/tickets',
      type: 'link',
      active: true,
      priority: 0.13,
    });

    triMenuProvider.addMenu({
      id: 'airforms',
      name: 'global.menu.airForms',
      icon: 'flp ath-smart-content',
      state: 'storm.admin-airforms',
      permission: 'view-applet',
      feature: 'feature_airform_enable',
      url: '/airforms',
      type: 'link',
      active: true,
      priority: 0.14,
    });

    triMenuProvider.addMenu({
      id: 'library',
      name: 'global.menu.content',
      icon: 'zmdi zmdi-library',
      type: 'menu',
      state: 'storm.admin-contents',
      permission: 'manage-content',
      feature: 'feature_content_enable',
      url: '/content',
      active: true,
      priority: 0.15,
      children: [
        {
          id: 'library-content-all',
          name: 'global.menu.allContent',
          type: 'link',
          state: 'storm.admin-contents',
          permission: 'manage-content',
          active: true,
          priority: 0.22,
        },
        {
          id: 'library-content-documents',
          name: 'global.menu.document',
          type: 'link',
          state: 'storm.content-documents',
          permission: 'manage-content',
          active: true,
          priority: 0.22,
        },
      ],
    });

    triMenuProvider.addMenu({
      id: 'topics',
      name: 'global.menu.topics',
      icon: 'zmdi zmdi-widgets',
      state: 'storm.admin-topics',
      feature: 'feature_topic_enable',
      permission: 'manage-topic-content',
      url: '/topics',
      type: 'link',
      active: true,
      priority: 0.16,
    });

    triMenuProvider.addMenu({
      id: 'anchors',
      name: 'global.menu.anchors',
      icon: 'zmdi zmdi-flare',
      state: 'storm.admin-anchors',
      permission: 'manage-anchor',
      feature: 'feature_anchor_enable',
      url: '/anchors',
      type: 'link',
      active: true,
      priority: 0.18,
    });

    triMenuProvider.addMenu({
      id: 'smartflows',
      name: 'global.menu.smartflows',
      icon: 'zmdi zmdi-device-hub',
      state: 'storm.admin-smartflows',
      feature: 'feature_smartflow_enable',
      permission: 'manage-workflow',
      url: '/smartflows',
      type: 'link',
      active: true,
      priority: 0.19,
    });

    triMenuProvider.addMenu({
      id: 'users',
      name: 'global.menu.users',
      icon: 'zmdi zmdi-accounts-list',
      type: 'menu',
      state: 'storm.admin-users',
      permission: 'manage-user',
      url: '/users',
      active: true,
      priority: 0.2,
      children: [
        {
          id: 'users-users',
          name: 'global.menu.users',
          type: 'link',
          state: 'storm.admin-users',
          permission: 'manage-user',
          active: true,
          priority: 0.22,
        },
        {
          id: 'users-teams',
          name: 'global.menu.teams',
          type: 'link',
          state: 'storm.admin-teams',
          permission: 'manage-user',
          active: true,
          priority: 0.22,
        },
      ],
    });

    triMenuProvider.addMenu({
      id: 'insights',
      name: 'global.menu.insights',
      icon: 'zmdi zmdi-chart',
      type: 'menu',
      state: 'storm.insights',
      permission: 'view-report',
      url: '/insights/dashboards',
      active: true,
      priority: 0.21,
      children: [
        {
          id: 'insights-adv-dashboards',
          name: 'atheer.insights.title',
          type: 'link',
          state: 'storm.insights.adv-dashboards',
          permission: 'view-report',
          active: true,
          priority: 0.22,
        },
        {
          id: 'insights-analyze',
          name: 'atheer.insights.analyze',
          type: 'link',
          state: 'storm.insights.adv-analyze',
          feature: 'feature_adv-insights_designer',
          permission: 'manage_adv_insights-report',
          active: true,
          priority: 0.22,
        },
      ],
    });

    triMenuProvider.addMenu({
      id: 'airsdk',
      name: 'global.menu.airSdk',
      icon: 'zmdi zmdi-code-setting',
      type: 'menu',
      state: 'storm.admin-airsdk-data-export',
      feature: 'feature_airsdk_enable',
      permission: 'manage-airsdk',
      url: '/sdk/api-reference',
      active: true,
      priority: 0.22,
      children: [
        {
          id: 'airsdk-data-export',
          name: 'atheer.airSdk.dataExport',
          type: 'link',
          state: 'storm.admin-airsdk-data-export',
          feature: 'feature_airsdk_data_export',
          permission: 'manage-webhooks-airsdk',
          url: '/sdk/api-reference',
          active: true,
          priority: 0.22,
        },
        {
          id: 'airsdk-webhooks',
          name: 'atheer.airSdk.webHooks',
          type: 'link',
          state: 'storm.admin-airsdk-web-hooks',
          feature: 'feature_airsdk_webhooks',
          permission: 'manage-data-export-airsdk',
          url: '/sdk/api-reference',
          active: true,
          priority: 0.22,
        },
        {
          id: 'airsdk-api-reference',
          name: 'atheer.airSdk.apiDoc',
          type: 'link',
          state: 'storm.admin-airsdk-api-doc',
          feature: 'feature_airsdk_api',
          permission: 'access-api-airsdk',
          url: '/sdk/api-reference',
          active: true,
          priority: 0.22,
        },
        {
          id: 'airsdk-api-key',
          name: 'atheer.airSdk.apiKey',
          type: 'link',
          state: 'storm.admin-airsdk-api-key',
          feature: 'feature_airsdk_api',
          permission: 'access-api-airsdk',
          url: '/sdk/api-reference',
          active: true,
          priority: 0.22,
        },
      ],
    });

    triMenuProvider.addMenu({
      id: 'settings',
      name: 'global.menu.settings',
      icon: 'zmdi zmdi-settings',
      type: 'menu',
      state: 'storm.admin-setting.workspace-info',
      permission: 'manage-setting-system',
      url: '/settings/workspace',
      active: true,
      priority: 0.23,
      children: [
        {
          id: 'settings-workspace-info',
          name: 'atheer.setting.workspaceInfo',
          icon: 'fa fa-building',
          type: 'link',
          state: 'storm.admin-setting.workspace-info',
          permission: 'manage-setting-system',
          active: true,
          priority: 0.22,
        },
        {
          id: 'settings-logo-color',
          icon: 'zmdi zmdi-brush',
          name: 'atheer.setting.logoAndColor',
          state: 'storm.admin-setting.skin',
        },
        {
          id: 'settings-dictionary',
          icon: 'zmdi zmdi-font',
          name: 'atheer.setting.dictionary.mainTitle',
          state: 'storm.admin-setting.dictionary',
          feature: 'feature_system_label_dictionary',
        },
        {
          id: 'settings-user-signup',
          icon: 'zmdi zmdi-account-add',
          name: 'atheer.setting.signup',
          state: 'storm.admin-setting.user-signup',
          feature: 'feature_user_signup',
        },
        {
          id: 'settings-security-roles',
          icon: 'zmdi zmdi-shield-security',
          name: 'atheer.setting.securityRoles',
          state: 'storm.admin-setting.security-roles',
          permission: 'manage-security-role-system',
          feature: 'feature_security_role_enable',
        },
        {
          id: 'settings-authentication-set-up',
          icon: 'zmdi zmdi-lock-outline',
          name: 'atheer.setting.authentication',
          state: 'storm.admin-setting.authentication.studio',
        },
        {
          id: 'settings-notifications',
          icon: 'zmdi zmdi-notifications',
          name: 'atheer.setting.notifications',
          state: 'storm.admin-setting.notifications',
          permission: 'manage-notification-system',
          feature: 'feature_system_notification_edit',
        },
        {
          id: 'settings-session',
          icon: 'zmdi zmdi-comment-video',
          name: 'atheer.setting.session',
          state: 'storm.admin-setting.session',
          feature: 'feature_airsession_enable',
        },
        {
          id: 'settings-airform',
          icon: 'flp ath-smart-content',
          name: 'atheer.setting.airform',
          state: 'storm.admin-setting.airform',
          feature: 'feature_airform_enable',
        },
        {
          id: 'settings-lens-camera',
          icon: 'zmdi zmdi-camera',
          name: 'atheer.setting.camera',
          state: 'storm.admin-setting.camera'
        },
        {
          id: 'settings-features',
          icon: 'zmdi zmdi-view-quilt',
          name: 'atheer.setting.features',
          state: 'storm.admin-setting.features',
          feature: 'feature_studio-settings_manage_features',
        },
        {
          id: 'settings-homepageconfig',
          icon: 'flp ath-home-config',
          name: 'atheer.setting.homepageconfig',
          state: 'storm.admin-setting.homepageconfig',
        },
        {
          id: 'settings-jobpdfconfig',
          icon: 'flp ath-jobpdf-config',
          name: 'atheer.setting.pdfconfig',
          state: 'storm.admin-setting.jobpdfconfig',
        },
        {
          id: 'settings-jobfileextconfig',
          icon: 'flp ath-jobfileext-config',
          name: 'atheer.setting.fileExtConfig',
          state: 'storm.admin-setting.jobfileextconfig',
        },
      ],
    });

    triMenuProvider.addMenu({
      id: 'sys-admin',
      name: 'global.menu.systemAdmin',
      icon: 'zmdi zmdi-developer-board',
      type: 'menu',
      state: 'storm.system-admin.dashboard',
      permission: 'manage-admin-cloud',
      url: '/system/dashboard',
      active: true,
      priority: 0.24,
      children: [
        {
          id: 'sys-admin-dashboard',
          icon: 'zmdi zmdi-chart',
          name: 'atheer.system.dashboard',
          type: 'link',
          state: 'storm.system-admin.dashboard',
        },
        {
          id: 'sys-admin-locales',
          icon: 'fa fa-globe',
          name: 'atheer.system.locales',
          type: 'link',
          state: 'storm.system-admin.locales',
        },
        {
          id: 'sys-admin-languages',
          icon: 'zmdi zmdi-globe-alt',
          name: 'atheer.system.languages',
          type: 'link',
          state: 'storm.system-admin.languages',
        },
        {
          id: 'sys-admin-timezones',
          icon: 'fa fa-clock-o',
          name: 'atheer.system.timezones',
          type: 'link',
          state: 'storm.system-admin.timezones',
        },
      ],
    });

    triMenuProvider.addMenu({
      id: 'workspaces',
      name: 'global.menu.workspaces',
      icon: 'fa fa-building',
      type: 'link',
      state: 'storm.admin-workspaces',
      permission: 'manage-admin-cloud',
      active: true,
      priority: 0.25,
    });

    triMenuProvider.addMenu({
      id: 'ops-admin',
      name: 'global.menu.operationsAdmin',
      icon: 'zmdi zmdi-cloud',
      type: 'link',
      state: 'storm.cloud-admin.job-streams',
      permission: 'manage-admin-cloud',
      active: true,
      priority: 0.26,
    });

  }
})();
;(function(){angular.module('atheer').run(['$templateCache', function($templateCache) {$templateCache.put('404.html','<!doctype html><html lang="en"><head><meta charset="utf-8"><title>Page Not Found</title><meta name="viewport" content="width=device-width,initial-scale=1"></head><body><div style="display: flex;flex-direction: column; align-items: center; justify-content: center;height: 100vh; font-family: sans-serif;"><h1 style="font-weight: 400; margin: 0 0 0.5em;">Page Not Found</h1><p style="margin: 0 auto;">Looks like you entered an incorrect URL or Website</p></div></body></html><!-- IE needs 512+ bytes: http://blogs.msdn.com/b/ieinternals/archive/2010/08/19/http-error-pages-in-internet-explorer.aspx -->');
$templateCache.put('content_iframe.html','<html><head><title>Content</title><style>body {\n            font-family: Arial, sans-serif;\n            font-size: 14px;\n            margin: 0;\n            padding: 0;\n        }\n        .content {\n            padding: 20px;\n        }</style></head><body><div class="content"><h1>Content</h1><iframe width="100%" height="100%" src="https://demoone.atheer.io/ngx/public" noresize="" frameborder="0" allow="camera; microphone"></iframe></div></body></html>');
$templateCache.put('embed_site.html','<html><head><title>Content</title><style>body {\n                font-family: Arial, sans-serif;\n                font-size: 14px;\n                margin: 0;\n                padding: 0;\n            }\n            .content {\n                padding: 20px;\n            }</style><script src="https://app.atheer.dev/embed/embed_copilot.js" data-atheerdomain="https://cgs.atheer.dev" data-iconurl="https://i.ibb.co/ZfWMD0m/Vector.png" data-themecolor="#f9153d"></script></head><body><div class="content"><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><h1>Content Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque consequatur quasi sint, magni ducimus libero, totam minus architecto explicabo harum exercitationem laborum officiis corporis recusandae quas eaque omnis sunt dignissimos.</h1><!-- <div\n                style="\n                    position: fixed;\n                    box-shadow: 0px 2px 12px 0px rgba(0, 67, 206, 0.1);\n                    right: 0;\n                    bottom: 0;\n                    height: 90px;\n                    width: 90px;\n                    z-index: 9999999;\n                "\n                id="iframeDiv"\n            >\n               <script>\n                    const iframeDiv = document.getElementById("iframeDiv");\n                    iframeDiv.style.display = "none";\n                    window.addEventListener("message", (event) => {\n                        if (event.data === "open") {\n                            iframeDiv.style.width = "450px";\n                            iframeDiv.style.height = "100%";\n                        } else if (event.data === "close") {\n                            iframeDiv.style.width = "90px";\n                            iframeDiv.style.height = "90px";\n                        } else if (event.data === "load") {\n                            iframeDiv.style.display = "block";\n                        }\n                    });\n                </script>\n                <iframe\n                    width="100%"\n                    height="100%"\n                    src="https://localhost:4200/ngx/home/copilot?domain=https://localhost:3000"\n                    noresize=""\n                    frameborder="0"\n                    allow="camera; microphone"\n                    allowTransparency="true"\n                ></iframe>--></div></body></html>');
$templateCache.put('lens-airsession.html','<html><head><script>function navigateToStudio() {\n            var getUrl = window.location;\n            var host = getUrl.host;\n            var env = host.startsWith(\'localhost\') ? \'my\' : host.split(\'.\')[2];\n            var baseUrl = getUrl.protocol + "//" + host;\n            var pathParam = getPathParam();\n            if (pathParam == null) {\n                baseUrl = baseUrl + "/join";\n            } else {\n                baseUrl = baseUrl + pathParam;\n            }\n            window.location.href = baseUrl;\n        };\n\n        function getPathParam() {\n          let params = (new URL(document.location)).searchParams;\n          let name = params.get("path");\n          return name;\n        };\n        \n        function downloadApp() {\n            var userAgent = navigator.userAgent || navigator.vendor || window.opera;\n            if (/android/i.test(userAgent)) {\n                window.open("https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.atheer.lens", "_blank");\n            }\n\n            // iOS detection from: http://stackoverflow.com/a/9039885/177710\n            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {\n                window.open("https://apps.apple.com/us/app/atheer-lens/id1484396234", "_blank");\n            }\n        }</script></head><body style="display: flex; justify-content: center; align-items: center;"><div><div th:fragment="body"><div style="text-align: center;"><div class="bodycopy mktEditable" id="content-intro"><img src="/assets/images/Atheer-logo-green.png" height="70"></div><br></div></div><table class="content" align="center" cellpadding="0" cellspacing="0" border="0" style="width: 100%; max-width: 600px; margin-bottom:30px"><tr><td class="footer" bgcolor="#F2F6FA"><table width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family: Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">YOU\'RE TRYING TO JOIN AN AIRSESSION</span><br></td></tr><tr><td align="center" style="background: #ffffff; padding: 50px;">&nbsp;<br><img src="/assets/images/card/Conversations1_web.png" height="300"><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="downloadApp()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">DOWNLOAD APP</button><br></td></tr><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">OR</span><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="navigateToStudio()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">LAUNCH IN BROWSER</button><br></td></tr><tr><td align="center" class="bodycopy" style="background:#ffffff; font-family: Roboto, Helvetica Neue, sans-serif; font-size: 16px; color: #545E6B; line-height: 1.5; padding-top: 30px;"><p align="center" style="color:#9CA9B9"><font face="Roboto, Helvetica Neue, sans-serif" color="#27C7A6" size="2">4601 Lafayette Street, P.O.BOX 4903, Santa Clara, CA 95056</font><br><font face="Roboto, Helvetica Neue, sans-serif" size="2">&copy; Copyright 2023. Atheer Inc. All rights reserved.</font></p></td></tr></table></td></tr></table></div></body></html>');
$templateCache.put('lens-dev-airsession.html','<html><head><script>function navigateToStudio() {\n            var getUrl = window.location;\n            var host = getUrl.host;\n            var env = host.startsWith(\'localhost\') ? \'my\' : host.split(\'.\')[2];\n            var baseUrl = getUrl.protocol + "//" + host;\n            var pathParam = getPathParam();\n            if (pathParam == null) {\n                baseUrl = baseUrl + "/join";\n            } else {\n                baseUrl = baseUrl + pathParam;\n            }\n            window.location.href = baseUrl;\n        };\n\n        function getPathParam() {\n          let params = (new URL(document.location)).searchParams;\n          let name = params.get("path");\n          return name;\n        };\n\n        function downloadApp() {\n            var userAgent = navigator.userAgent || navigator.vendor || window.opera;\n            if (/android/i.test(userAgent)) {\n                window.open("https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.atheer.lens.dev", "_blank");\n            }\n\n            // iOS detection from: http://stackoverflow.com/a/9039885/177710\n            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {\n                window.open("https://testflight.apple.com/v1/app/1474720416", "_blank");\n            }\n        }</script></head><body style="display: flex; justify-content: center; align-items: center;"><div><div th:fragment="body"><div style="text-align: center;"><div class="bodycopy mktEditable" id="content-intro"><img src="/assets/images/Atheer-logo-green.png" height="70"></div><br></div></div><table class="content" align="center" cellpadding="0" cellspacing="0" border="0" style="width: 100%; max-width: 600px; margin-bottom:30px"><tr><td class="footer" bgcolor="#F2F6FA"><table width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family: Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">YOU\'RE TRYING TO JOIN AN AIRSESSION</span><br></td></tr><tr><td align="center" style="background: #ffffff; padding: 50px;">&nbsp;<br><img src="/assets/images/card/Conversations1_web.png" height="300"><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="downloadApp()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">DOWNLOAD APP</button><br></td></tr><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">OR</span><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="navigateToStudio()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">LAUNCH IN BROWSER</button><br></td></tr><tr><td align="center" class="bodycopy" style="background:#ffffff; font-family: Roboto, Helvetica Neue, sans-serif; font-size: 16px; color: #545E6B; line-height: 1.5; padding-top: 30px;"><p align="center" style="color:#9CA9B9"><font face="Roboto, Helvetica Neue, sans-serif" color="#27C7A6" size="2">24601 Lafayette Street, P.O.BOX 4903, Santa Clara, CA 95056</font><br><font face="Roboto, Helvetica Neue, sans-serif" size="2">&copy; Copyright 2023. Atheer Inc. All rights reserved.</font></p></td></tr></table></td></tr></table></div></body></html>');
$templateCache.put('lens-qa-airsession.html','<html><head><script>function navigateToStudio() {\n            var getUrl = window.location;\n            var host = getUrl.host;\n            var env = host.startsWith(\'localhost\') ? \'my\' : host.split(\'.\')[2];\n            var baseUrl = getUrl.protocol + "//" + host;\n            var pathParam = getPathParam();\n            if (pathParam == null) {\n                baseUrl = baseUrl + "/join";\n            } else {\n                baseUrl = baseUrl + pathParam;\n            }\n            window.location.href = baseUrl;\n        };\n\n        function getPathParam() {\n          let params = (new URL(document.location)).searchParams;\n          let name = params.get("path");\n          return name;\n        };\n\n        function downloadApp() {\n            var userAgent = navigator.userAgent || navigator.vendor || window.opera;\n            if (/android/i.test(userAgent)) {\n                window.open("https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.atheer.lens.qa", "_blank");\n            }\n\n            // iOS detection from: http://stackoverflow.com/a/9039885/177710\n            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {\n                window.open("https://testflight.apple.com/v1/app/1474879127", "_blank");\n            }\n        }</script></head><body style="display: flex; justify-content: center; align-items: center;"><div><div th:fragment="body"><div style="text-align: center;"><div class="bodycopy mktEditable" id="content-intro"><img src="/assets/images/Atheer-logo-green.png" height="70"></div><br></div></div><table class="content" align="center" cellpadding="0" cellspacing="0" border="0" style="width: 100%; max-width: 600px; margin-bottom:30px"><tr><td class="footer" bgcolor="#F2F6FA"><table width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family: Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">YOU\'RE TRYING TO JOIN AN AIRSESSION</span><br></td></tr><tr><td align="center" style="background: #ffffff; padding: 50px;">&nbsp;<br><img src="/assets/images/card/Conversations1_web.png" height="300"><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="downloadApp()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">DOWNLOAD APP</button><br></td></tr><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">OR</span><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="navigateToStudio()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">LAUNCH IN BROWSER</button><br></td></tr><tr><td align="center" class="bodycopy" style="background:#ffffff; font-family: Roboto, Helvetica Neue, sans-serif; font-size: 16px; color: #545E6B; line-height: 1.5; padding-top: 30px;"><p align="center" style="color:#9CA9B9"><font face="Roboto, Helvetica Neue, sans-serif" color="#27C7A6" size="2">4601 Lafayette Street, P.O.BOX 4903, Santa Clara, CA 95056</font><br><font face="Roboto, Helvetica Neue, sans-serif" size="2">&copy; Copyright 2023. Atheer Inc. All rights reserved.</font></p></td></tr></table></td></tr></table></div></body></html>');
$templateCache.put('lens-si-airsession.html','<html><head><script>function navigateToStudio() {\n            var getUrl = window.location;\n            var host = getUrl.host;\n            var env = host.startsWith(\'localhost\') ? \'my\' : host.split(\'.\')[2];\n            var baseUrl = getUrl.protocol + "//" + host;\n            var pathParam = getPathParam();\n            if (pathParam == null) {\n                baseUrl = baseUrl + "/join";\n            } else {\n                baseUrl = baseUrl + pathParam;\n            }\n            window.location.href = baseUrl;\n        };\n\n        function getPathParam() {\n          let params = (new URL(document.location)).searchParams;\n          let name = params.get("path");\n          return name;\n        };\n\n        function downloadApp() {\n            var userAgent = navigator.userAgent || navigator.vendor || window.opera;\n            if (/android/i.test(userAgent)) {\n                window.open("https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.atheer.lens.si", "_blank");\n            }\n\n            // iOS detection from: http://stackoverflow.com/a/9039885/177710\n            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {\n                window.open("https://testflight.apple.com/v1/app/1508637647", "_blank");\n            }\n        }</script></head><body style="display: flex; justify-content: center; align-items: center;"><div><div th:fragment="body"><div style="text-align: center;"><div class="bodycopy mktEditable" id="content-intro"><img src="/assets/images/Atheer-logo-green.png" height="70"></div><br></div></div><table class="content" align="center" cellpadding="0" cellspacing="0" border="0" style="width: 100%; max-width: 600px; margin-bottom:30px"><tr><td class="footer" bgcolor="#F2F6FA"><table width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family: Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">YOU\'RE TRYING TO JOIN AN AIRSESSION</span><br></td></tr><tr><td align="center" style="background: #ffffff; padding: 50px;">&nbsp;<br><img src="/assets/images/card/Conversations1_web.png" height="300"><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="downloadApp()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">DOWNLOAD APP</button><br></td></tr><tr><td align="center" style="width:200px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 10px 0; line-height:150%;">&nbsp;<br><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;">OR</span><br></td></tr><tr><td align="center" style="width:650px; background:#ffffff; color:#1e4483; font-family:Roboto, Helvetica Neue, sans-serif; font-size:14px; padding:0 0 20px 0; line-height:150%;">&nbsp;<br><button type="button" onclick="navigateToStudio()" style="border: none; color: white; background-color: #27C7A6; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank">LAUNCH IN BROWSER</button><br></td></tr><tr><td align="center" class="bodycopy" style="background:#ffffff; font-family: Roboto, Helvetica Neue, sans-serif; font-size: 16px; color: #545E6B; line-height: 1.5; padding-top: 30px;"><p align="center" style="color:#9CA9B9"><font face="Roboto, Helvetica Neue, sans-serif" color="#27C7A6" size="2">4601 Lafayette Street, P.O.BOX 4903, Santa Clara, CA 95056</font><br><font face="Roboto, Helvetica Neue, sans-serif" size="2">&copy; Copyright 2023. Atheer Inc. All rights reserved.</font></p></td></tr></table></td></tr></table></div></body></html>');
$templateCache.put('core/blank.tmpl.html','<div class="padded-content-page"><div layout="row" layout-align="center center"><p>Your content here</p></div></div>');
$templateCache.put('modules/ngx-frame.html','<div flex layout-fill layout-align="center center" class="frameLoader" ng-if="!vm.isIFrameDataLoaded"><wave-spinner></wave-spinner></div><iframe id="ngxFrame" ng-src="{{vm.ngxUrlTrusted}}" height="100%" width="100%" noresize="noresize" frameborder="0" allow="camera; microphone">');
$templateCache.put('core/layouts/core.tmpl.html','<!-- left sidebar --><md-sidenav md-colors="{ background: \'primary\' }" class="storm-sidenav-left md-sidenav-left md-whiteframe-z2" ng-if="layout.sideMenuSize !== \'off\'" md-component-id="left" md-is-locked-open="layout.sideMenuSize !== \'hidden\' && $mdMedia(\'gt-sm\')" ui-view="sidebarLeft" ng-class="{ \'admin-sidebar-collapsed\': !sideBarOpen}"></md-sidenav><div flex layout="column"><div ui-view="toolbar"></div><!-- main content --><div class="storm-toolbar-and-content" layout="row" flex layout-align="center"><div hide-sm hide-xs ng-if="layout.showSideNavMenu && showSideNavMenu && layout.sideNavMenuPosition == \'left\' && !isJobExecutionActive" flex="{{layout.sideNavMenuSize}}" ui-view="sideMenu" layout="column" ng-style="{\'background-color\': \'#f2f4f7\'}"></div><div flex layout="column"><!-- top toolbar --><div ui-view="aboveContent"></div><!-- scrollable content --><md-content class="storm-content" ng-class="layout.contentClass" flex ui-view></md-content><div ui-view="belowContent"></div><div class="storm-loader" ng-show="stateController.showLoader" layout="column" ui-view="loader"></div></div><div hide-sm hide-xs ng-if="layout.showSideNavMenu && showSideNavMenu && layout.sideNavMenuPosition == \'right\' && !isJobExecutionActive" flex="{{layout.sideNavMenuSize}}" ui-view="sideMenu" layout="column" ng-style="{\'background-color\': \'#f2f4f7\'}"></div></div></div><!-- notifications sidebar --><md-sidenav layout layout-fill class="storm-sidenav-right md-sidenav-right md-whiteframe-z2" md-component-id="notifications" ui-view="sidebarNotifications"></md-sidenav>');
$templateCache.put('core/layouts/default-content.tmpl.html','<div id="admin-panel-content-view" class="{{layout.innerContentClass}}" flex ui-view></div>');
$templateCache.put('modules/airform/airform-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="autoComplete.airFormPicker.title">Select AiRForms</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container class="search-input-theme" ng-style="{ \'color\': secondaryColor }" ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button layout-align="center center" ng-if="vm.airforms.length > 0" class="md-raised select-button" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedAirForms.length <= 0">Select</md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content ng-if="vm.loadingData" flex class="md-dialog-content margin-top-100 margin-bottom-100"><wave-spinner></wave-spinner></md-dialog-content><md-dialog-content ng-if="!vm.loadingData" class="md-dialog-content" flex><div ng-if="vm.airforms.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><div class="md-padding" ng-if="vm.airforms.length > 0"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedAirForms" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th md-column><span translate="autoComplete.airFormPicker.table.name">Name</span></th><th md-column><span translate="autoComplete.airFormPicker.table.createdOn">Created On</span></th></tr></thead><tbody md-body><tr ng-repeat="airform in vm.airforms track by airform.id" md-row md-select="airform" md-select-id="id" md-auto-select><td md-cell>{{airform.name}}</td><td md-cell am-time-ago="airform.created_on"></td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/cloud/cloud-menu.tmpl.html','<div class="toolbar-default md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="atheer.cloud.title">Cloud</h2><span flex></span></div></div><div flex layout="column" class="fp-page-sidemenu" flex-xs="100" class="md-whiteframe-z1"><div ng-repeat="setting in vm.settings"><md-button ui-sref="{{setting.state}}" ng-click="vm.activeLink = setting.state" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == setting.state}"><md-icon md-font-icon="{{setting.icon}}"></md-icon><span class="md-body-1" translate="{{setting.label}}">{{setting.label}}</span></md-button><md-divider></md-divider></div></div>');
$templateCache.put('modules/cloud/cloud.tmpl.html','<div flex ui-view></div>');
$templateCache.put('modules/anchor/anchor-detail-insights.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout-fill layout="column" flex><div class="toolbar-default md-whiteframe-z1" ng-style="{\'margin-bottom\': \'10\' + \'px\'}"><div class="md-toolbar-tools md-accent"><md-button ui-sref="storm.admin-anchors" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span>{{vm.anchorModel.name}}</span><div flex><md-tabs md-center-tabs><md-tab ui-sref="storm.admin-anchor-detail({id: \'{{vm.anchorModel.id}}\'})"><md-tab-label><span translate="atheer.anchor.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-anchor-detail-recognition.section({id: \'{{vm.anchorModel.id}}\', section : \'qr_code\'})"><md-tab-label><span translate="atheer.anchor.recognition">Recognition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-anchor-detail-insights.section({id: \'{{vm.anchorModel.id}}\', section : \'overview\'})" md-active="true"><md-tab-label><span translate="atheer.anchor.insights">Insights</span></md-tab-label></md-tab></md-tabs></div></div></div><div flex layout="column"><md-tabs class="padding-left-10" md-center-tabs="true"><md-tab ui-sref="storm.admin-anchor-detail-insights.section({section:\'{{sectionKey}}\'})" ng-repeat="(sectionKey, section) in vm.insightSections"><md-tab-label><span translate>{{section.label}}</span></md-tab-label></md-tab></md-tabs><div flex layout="column" ui-view></div></div></div>');
$templateCache.put('modules/anchor/anchor-detail-toolbar.tmpl.html','<div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToAnchors()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.anchorModel.name}}</span></h2><div flex><md-tabs ng-if="!vm.isNew()" md-center-tabs><md-tab ui-sref="storm.admin-anchor-detail({id: \'{{vm.anchorModel.id}}\'})" md-active="true"><md-tab-label><span translate="atheer.anchor.settings">Settings</span></md-tab-label></md-tab><!--\n                <md-tab ui-sref="storm.admin-anchor-detail-insights.section({id: \'{{vm.anchorModel.id}}\', section : \'overview\'})">\n                    <md-tab-label>\n                        <span translate="atheer.anchor.insights">Insights</span>\n                    </md-tab-label>\n                </md-tab>\n                --></md-tabs></div><div layout="row"><md-button ng-if="!vm.anchorModel.locked" type="submit" class="md-primary md-raised" ng-disabled="anchorDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></div></div>');
$templateCache.put('modules/anchor/anchor-detail.tmpl.html','<ng-include src="\'modules/anchor/anchor-detail-toolbar.tmpl.html\'"></ng-include><div class="margin-top-10 fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="35" flex-xl="25" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><div ng-form="anchorDetailForm"><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.anchor.anchorNo" for="field_anchorNo">AnchorNo</label> <input type="number" class="form-control" name="note_id" id="field_anchorNo" ng-model="vm.anchorModel.note_id" required ng-disabled="true"><div ng-messages="anchorDetailForm.anchorNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.anchor.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.anchorModel.name" required ng-disabled="vm.anchorModel.locked"><div ng-messages="anchorDetailForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.anchor.description" for="field_description">Description</label> <textarea name="description" ng-model="vm.anchorModel.description" id="field_description" ng-disabled="vm.anchorModel.locked" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-clock-o"></md-icon><span flex translate="atheer.anchor.scheduling">Scheduling</span><md-button ng-click="vm.show_scheduling = !vm.show_scheduling" class="md-icon-button"><md-icon ng-if="!vm.show_scheduling" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_scheduling" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.show_scheduling" class="margin-bottom-20"><div layout="row" layout-align="space-between center"><span translate="atheer.anchor.availableFrom">Available From</span><md-datepicker md-max-date="vm.anchorModel.discontinue_from" ng-model="vm.anchorModel.available_from" md-placeholder="Select date"></md-datepicker></div><div layout="row" layout-align="space-between center"><span translate="atheer.anchor.discontinueFrom">Discontinue From</span><md-datepicker md-min-date="vm.anchorModel.available_from" ng-model="vm.anchorModel.discontinue_from" md-placeholder="Select date"></md-datepicker></div></div><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-sliders"></md-icon><span flex translate="atheer.anchor.settings">Settings</span><md-button ng-click="vm.show_settings = !vm.show_settings" class="md-icon-button"><fp-tooltip><span translate="atheer.anchor.seeMore">See More</span></fp-tooltip><md-icon ng-show="!vm.show_settings" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-show="vm.show_settings" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.show_settings" layout="row" layout-align="space-between center"><span translate="atheer.anchor.enable">Enable</span><md-switch name="enabled" ng-model="vm.anchorModel.enable"></md-switch></div><div ng-if="vm.show_settings" layout="column"><span class="md-subhead" translate="atheer.anchor.owner">Owner</span><div flex><fp-auto-complete no-label="true" auto-complete-model="vm.owner" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div></div><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-group"></md-icon><span flex class="md-body-2" translate="atheer.anchor.visibleTo">Visible To</span><md-button ng-click="vm.show_audiences = !vm.show_audiences" class="md-icon-button"><md-icon ng-if="!vm.show_audiences" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_audiences" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.show_audiences" class="margin-bottom-20"><fp-auto-complete no-label="true" auto-complete-model="vm.audiences" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div><md-divider></md-divider></div></md-content></div></div><div flex layout="column"><div layout="row"><div flex="80"><md-tabs ng-if="!vm.isNew()" md-selected="selectedTabIndex"><md-tab ng-click="vm.view = \'CONTENT\'"><md-tab-label><span translate="atheer.anchor.content">Content</span></md-tab-label></md-tab><md-tab ng-click="vm.view = \'USERS\'"><md-tab-label><span translate="atheer.anchor.users">People</span></md-tab-label></md-tab><md-tab ng-click="vm.view = \'AIRFORMS\'"><md-tab-label><span translate="atheer.anchor.airForms">AiRForms</span></md-tab-label></md-tab></md-tabs></div><span flex></span><md-button ng-if="!vm.isNew() && vm.view == \'CONTENT\'" class="md-icon-button" ng-click="vm.openContentPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.addContent">Add Content</span></fp-tooltip></md-button><md-button ng-if="!vm.isNew() && vm.view == \'AIRFORMS\'" class="md-icon-button" ng-click="vm.openAirFormPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.addAirForm">Add AiRForm</span></fp-tooltip></md-button><md-button ng-if="!vm.isNew() && vm.view == \'USERS\'" class="md-icon-button" ng-click="vm.openUserPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.addUsers">Add Users</span></fp-tooltip></md-button></div><div layout="center center" flex><div ng-if="vm.isNew()" flex layout-align="center center" layout="row"><div flex="75" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.anchor.additionalInfo">Please save the Anchor to add additional information.</span></div></div></div><div layout="column" flex flex ng-if="!vm.isNew() && vm.view == \'CONTENT\'"><div ng-if="vm.loadingContent" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingContent && vm.content.length == 0" class="fp-no-data" layout-align="center center"><illustration-empty-screen id="vm.illustrationEmptyScreenIdContent"></illustration-empty-screen></div><md-table-container ng-if="!vm.loadingContent && vm.content.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.anchor.type">Type</span></th><th md-column><span translate="atheer.anchor.title">Title</span></th><th md-column><span translate="atheer.anchor.createdOn">Created On</span></th></tr></thead><tbody md-body><tr ng-repeat="content in vm.content track by content.id"><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.launchContentPreview(content)"><md-icon md-font-icon="{{vm.getContentMeta(content).icon}}"><fp-tooltip>{{vm.getContentMeta(content).label}}</fp-tooltip></md-icon></md-button></td><td md-cell>{{content.title}}</td><td md-cell am-time-ago="content.created_on"></td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeContent(content, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.anchors.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUserAnchors"></md-table-pagination></div><div layout="column" flex flex ng-if="!vm.isNew() && vm.view == \'AIRFORMS\'"><div ng-if="vm.loadingAirForms" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingAirForms && vm.airForms.length == 0" class="fp-no-data" layout-align="center center"><illustration-empty-screen id="vm.illustrationEmptyScreenIdAnchor"></illustration-empty-screen></div><md-table-container ng-if="!vm.loadingAirForms && vm.airForms.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.anchor.name">Name</span></th><th md-column><span translate="atheer.anchor.createdOn">Created On</span></th></tr></thead><tbody md-body><tr ng-repeat="airform in vm.airForms track by airform.id"><td md-cell>{{airform.name}}</td><td md-cell>{{airform.created_on | date:\'MM/dd/yyyy\'}}</td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeAirForm(airform, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.anchors.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUserAnchors"></md-table-pagination></div><div layout="column" flex flex ng-if="!vm.isNew() && vm.view == \'USERS\'"><div ng-if="vm.loadingUsers" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingUsers && vm.users.length == 0" class="fp-no-data" layout-align="center center"><illustration-empty-screen id="vm.illustrationEmptyScreenIdUser"></illustration-empty-screen></div><md-table-container ng-if="!vm.loadingUsers && vm.users.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.anchor.firstName">First Name</span></th><th md-column><span translate="atheer.anchor.lastName">Last Name</span></th><th md-column><span translate="atheer.anchor.email">Email</span></th></tr></thead><tbody md-body><tr ng-repeat="user in vm.users track by user.id"><td md-cell>{{user.first_name}}</td><td md-cell>{{user.last_name}}</td><td md-cell>{{user.email}}</td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeUser(user, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.anchors.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUserAnchors"></md-table-pagination></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include></div></div></div>');
$templateCache.put('modules/anchor/anchor-insight-overview.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.anchorScansByDay.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.anchor.anchorUsage">Smartscan Usage</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/completions-overview.png"><div class="margin-top-10 main" translate="atheer.anchor.notEnoughActivity">Not Enough Activity Yet!</div></div></div></md-card><md-card layout-padding flex ng-if="vm.anchorScansByDay.series[0].data.length > 0"><highchart id="usage-session-count" option="vm.anchorScansByDay.chart" config="vm.anchorScansByDay" series="vm.anchorScansByDay.series"></highchart></md-card></div></div>');
$templateCache.put('modules/anchor/anchor-insight-scan-history.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><md-content flex ng-if="!vm.loadingData"><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.anchor.firstName">First Name</span></th><th md-column><span translate="atheer.anchor.lastName">Last Name</span></th><th md-column md-order-by="created_on"><span translate="atheer.anchor.scannedOn">Scanned On</span></th></tr></thead><tbody md-body><tr ng-repeat="view in vm.viewData track by view.id"><td md-cell>{{view.user_info.first_name}}</td><td md-cell>{{view.user_info.last_name}}</td><td md-cell>{{view.created_on | amCalendar:referenceTime:formats}}</td></tr></tbody></table></md-table-container></md-content></div><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.viewData.length > 0"></md-table-pagination>');
$templateCache.put('modules/anchor/anchor-menu.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="column" layout-fill><div flex layout="column" class="fp-folder-builder"><div layout="column" layout-padding class="margin-top-10"><md-input-container class="md-block"><md-checkbox ng-model="vm.filters.enabled" aria-label="Enabled" ng-change="vm.updateFilters()"><span translate="atheer.anchor.enabled">Enabled</span></md-checkbox><md-checkbox ng-model="vm.filters.externalId" aria-label="Disabled" ng-change="vm.updateFilters()"><span translate="atheer.anchor.hasExternalId">Has External ID</span></md-checkbox></md-input-container></div></div></div>');
$templateCache.put('modules/anchor/anchor-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2><span translate="atheer.anchor.home.title">Anchors</span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.anchor.enterSearchPlaceholder\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.search">Search</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-accent" ng-show="vm.createEnabled" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><fp-help key="content-list-guide"></fp-help></div></md-toolbar>');
$templateCache.put('modules/anchor/anchor.tmpl.html','<div flex layout="row" layout-fill><div flex layout="column"><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="row"><div ng-if="!vm.loadingData && vm.anchors.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-table-container flex ng-if="!vm.loadingData && vm.anchors.length > 0" class="fp-anchor-list"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.anchor.anchorNo">No</span></th><th md-column md-order-by="name"><span translate="atheer.anchor.name">Name</span></th><th md-column md-order-by="name"><span translate="atheer.anchor.enabled">Enabled</span></th><th md-column><span translate="atheer.anchor.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="anchor in vm.anchors track by anchor.id" md-row md-select="content" md-select-id="id"><td md-cell>{{anchor.note_id}}</td><td md-cell>{{anchor.name}}</td><td md-cell><md-switch name="enabled" ng-model="anchor.enable" ng-change="vm.onEnableChange(anchor)"></md-switch></td><td md-cell am-time-ago="anchor.created_on"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.editObject(anchor.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><fp-tooltip><span translate="atheer.anchor.edit">Edit</span></fp-tooltip></md-button><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.seeInsights(anchor.id)"><md-icon class="zmdi zmdi-chart icon-size"></md-icon><fp-tooltip><span translate="atheer.anchor.seeInsights">See Insights</span></fp-tooltip></md-button></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.anchors.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/copilot/copilot.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2>AiRPilot - Your Personal Service Expert</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.anchor.enterSearchPlaceholder\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.search">Search</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-accent" ng-show="vm.createEnabled" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><fp-help key="content-list-guide"></fp-help></div></md-toolbar><iframe id="ngxFrame" ng-src="{{vm.ngxUrlTrusted}}" height="100%" width="100%" noresize="noresize" frameborder="0" allow="camera; microphone">');
$templateCache.put('modules/conversation/conversation-audio-message.tmpl.html','<div flex layout="row" class="fp-conv-audio-player"><div ng-if="!playing" style="box-shadow: none; outline: none;" class="fp-conv-audio-button" aria-label="Use Android" ng-click="play()"><md-icon md-font-icon="zmdi zmdi-play" class="fp-conv-audio-icon"></md-icon></div><div ng-if="playing" style="box-shadow: none;  outline: none;" class="fp-conv-audio-button" aria-label="Use Android" ng-click="pause()"><md-icon md-font-icon="zmdi zmdi-pause" class="fp-conv-audio-icon"></md-icon></div><div ng-if="!isPinned" flex="85" id="aud-{{audioId}}"></div><div ng-if="isPinned" flex="85" id="aud-{{audioId}}-pinned"></div></div>');
$templateCache.put('modules/conversation/conversation-audio-record-dialog.tmpl.html','<md-dialog flex="100" class="md-whiteframe-z1" ng-style="{\'background-color\': \'white\', \'height\': \'100%\'}"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.message.audioRecord.title">Record Audio</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.message.audioRecord.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div layout layout-align="center center" ng-style="{\'height\': \'100%\'}"><div ng-if="vm.audioStatus == \'PROCESS\'"><div ng-if="vm.processStatus === \'PROCESSING\'" layout="row" layout-align="center center" ng-cloak><div class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.message.audioRecord.audioStatus.processing" translate-values="{uploadPercentage: \'{{vm.uploadPercentage}}\'}">Processing Audio...{{vm.uploadPercentage}}%.</span></div><div layout="row" layout-align="center"><md-progress-linear md-mode="determinate" value="{{vm.uploadPercentage}}"></md-progress-linear></div></div></div></div></div><div ng-if="vm.processStatus === \'COMPLETE\'" layout="row" layout-align="center center" ng-cloak><div class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.message.audioRecord.audioStatus.complete">Processing Complete.</span></div></div></div></div></div><div ng-if="vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" ng-cloak><div class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.message.audioRecord.audioStatus.failed">Error Processing Audio. Try Again.</span></div></div></div></div></div></div><ng-audio-recorder id="audioInput" ng-if="vm.audioStatus == \'RECORD\'" audio-model="vm.recordedAudio" on-save-complete="vm.save()" time-limit="60"><div ng-if="!recorder.isAvailable" translate="atheer.message.audioRecord.notPossible">Message for users when recording is not possible.</div><div class="web-recorder-section"><div class="web-recorder-wrapper"><div class="web-recorder-centered-content"><div class="top-section"><div ng-if="!recorder.status.isPlaying && !recorder.status.isPaused" class="playback-count">{{recorder.elapsedTimeString}}</div><div ng-if="recorder.status.isPlaying || recorder.status.isPaused" class="playback-count">{{recorder.playBackTimeString}}</div></div><div class="middle-section"><div ng-click="recorder.startRecord()" ng-if="!recorder.audioModel && !recorder.status.isRecording" class="record-button"></div><div ng-click="recorder.stopRecord()" ng-if="recorder.status.isRecording" class="stop-record-button"></div><div ng-click="recorder.playbackRecording()" ng-if="recorder.audioModel && !recorder.status.isPlaying" class="play-button large"></div><div ng-click="recorder.playbackPause()" ng-if="recorder.status.isPlaying" class="pause-button large"></div></div></div></div><div layout="row" ng-if="!recorder.audioModel" layout-align="center" class="margin-top-40"></div><div layout="row" ng-show="!recorder.status.isRecording && !recorder.audioModel" class="padding-20" layout-align="center center"><span class="md-subhead" translate="atheer.message.audioRecord.clickToStart">Click record to start the recording.</span></div><div layout="row" ng-if="recorder.audioModel" layout-align="center" class="margin-top-40"><md-button ng-click="recorder.discard()" layout-align="center center" class="md-primary" aria-label="primary button" ng-disabled="recorder.status.isPlaying" translate="entity.action.discard">Discard</md-button><md-button ng-click="recorder.save()" layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-disabled="recorder.status.isPlaying || recorder.status.isRecording || !recorder.audioModel" translate="entity.action.send">Send</md-button></div><ng-audio-recorder-analyzer ng-show="recorder.status.isRecording"></ng-audio-recorder-analyzer></div><!-- End controls--></ng-audio-recorder></div></md-dialog>');
$templateCache.put('modules/conversation/conversation-audio-record-panel.tmpl.html','<div class="fp-conv-audio-record md-whiteframe-z1"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.message.audioRecord.title">Record Audio</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.message.audioRecord.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div ng-if="vm.audioStatus == \'PROCESS\'"><div ng-if="vm.processStatus === \'PROCESSING\'" layout="row" layout-align="center center" ng-cloak><div class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.message.audioRecord.audioStatus.processing" translate-values="{uploadPercentage: \'{{vm.uploadPercentage}}\'}">Processing Audio...{{vm.uploadPercentage}}%.</span></div><div layout="row" layout-align="center"><md-progress-linear md-mode="determinate" value="{{vm.uploadPercentage}}"></md-progress-linear></div></div></div></div></div><div ng-if="vm.processStatus === \'COMPLETE\'" layout="row" layout-align="center center" ng-cloak><div class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.message.audioRecord.audioStatus.complete">Processing Complete.</span></div></div></div></div></div><div ng-if="vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" ng-cloak><div class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.message.audioRecord.audioStatus.failed">Error Processing Audio. Try Again.</span></div></div></div></div></div></div><ng-audio-recorder id="audioInput" ng-if="vm.audioStatus == \'RECORD\'" audio-model="vm.recordedAudio" on-save-complete="vm.save()" time-limit="60"><div ng-if="!recorder.isAvailable" translate="atheer.message.audioRecord.notPossible">Message for users when recording is not possible.</div><div class="web-recorder-section"><div class="web-recorder-wrapper"><div class="web-recorder-centered-content"><div class="top-section"><div ng-if="!recorder.status.isPlaying && !recorder.status.isPaused" class="playback-count">{{recorder.elapsedTimeString}}</div><div ng-if="recorder.status.isPlaying || recorder.status.isPaused" class="playback-count">{{recorder.playBackTimeString}}</div></div><div class="middle-section"><div ng-click="recorder.startRecord()" ng-if="!recorder.audioModel && !recorder.status.isRecording" class="record-button"></div><div ng-click="recorder.stopRecord()" ng-if="recorder.status.isRecording" class="stop-record-button"></div><div ng-click="recorder.playbackRecording()" ng-if="recorder.audioModel && !recorder.status.isPlaying" class="play-button large"></div><div ng-click="recorder.playbackPause()" ng-if="recorder.status.isPlaying" class="pause-button large"></div></div></div></div><div layout="row" ng-if="!recorder.audioModel" layout-align="center" class="margin-top-40"></div><div layout="row" ng-show="!recorder.status.isRecording && !recorder.audioModel" class="padding-20" layout-align="center center"><span class="md-subhead" translate="atheer.message.audioRecord.clickToStart">Click record to start the recording.</span></div><div layout="row" ng-if="recorder.audioModel" layout-align="center" class="margin-top-40"><md-button ng-click="recorder.discard()" layout-align="center center" class="md-primary" aria-label="primary button" ng-disabled="recorder.status.isPlaying" translate="entity.action.discard">Discard</md-button><md-button ng-click="recorder.save()" layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-disabled="recorder.status.isPlaying || recorder.status.isRecording || !recorder.audioModel" translate="entity.action.send">Send</md-button></div><ng-audio-recorder-analyzer ng-show="recorder.status.isRecording"></ng-audio-recorder-analyzer></div><!-- End controls--></ng-audio-recorder></div>');
$templateCache.put('modules/conversation/conversation-detail.html','<div flex layout="row" layout-fill><div flex layout="column" class="md-whiteframe-z1"><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-list-item ng-if="vm.conversation == null && vm.loadingData" class="md-2-line"><img src="/assets/images/avatars/user-avatar.png" class="md-avatar"><div class="md-list-item-text" layout="column"><h3><span ng-style="{\'font-weight\': 500}" translate="atheer.conversation.loading">Loading ...</span></h3><h4 translate="atheer.conversation.loading">Loading ...</h4></div></md-list-item><md-list-item ng-if="vm.conversation != null" class="md-2-line"><img ng-if="vm.conversation.type != \'PRIVATE_USER\' && vm.conversation.picture_id" ng-src="{{vm.getConverstionImageUrl(vm.conversation)}}" width="45px" height="45px" ng-style="{ \'margin-top\': \'15px\', \'border-radius\' : \'45px\'}" alt="{{::vm.getConverstionTitle(vm.conversation)}}"><div ng-if="vm.conversation.type != \'PRIVATE_USER\' && !vm.conversation.picture_id" ng-style="{ \'margin-top\': \'15px\'}"><fp-group-avatar box-size="\'45px\'" icon-size="\'25px\'" color="vm.primaryColor"></fp-group-avatar></div><div ng-if="vm.conversation.type == \'PRIVATE_USER\'" ng-style="{ \'margin-top\': \'15px\'}"><fp-avatar user="vm.conversation.user_info" presence="true" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true"></fp-avatar></div><div ng-if="vm.conversation != null" class="md-list-item-text margin-left-10" layout="column"><h3><span ng-style="{\'font-weight\': 500}">{{vm.getConverstionTitle(vm.conversation)}}</span></h3><conversation-typing-indicator conversation-model="vm.conversation"></conversation-typing-indicator></div></md-list-item><span flex></span><div ng-if="vm.conversation != null"><md-button permission permission-only="atheer_features.airsession.enable" class="md-icon-button" aria-label="primary button" ng-click="vm.startSession()"><md-icon md-font-icon="zmdi zmdi-comment-video"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.startAirSession">Start AiRSession</span></fp-tooltip></md-button><md-menu md-offset="0 60"><md-button class="md-icon-button" ng-click="$mdMenu.open()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-settings"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.settings">Settings</span></fp-tooltip></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="$mdCloseMenu;vm.showConversationInfo = !vm.showConversationInfo"><md-icon md-font-icon="zmdi zmdi-info"></md-icon><span translate="atheer.conversation.viewConversationDetails">View Conversation Details</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.update" ng-if="vm.conversation.type != \'PRIVATE_USER\' && vm.conversation.type != \'PRIVATE_AUDIENCE\'"><md-button ng-click="$mdCloseMenu;vm.editGroupConversation()"><md-icon md-font-icon="zmdi zmdi-edit"></md-icon><span translate="atheer.conversation.editConversationDetails">Edit Conversation Details</span></md-button></md-menu-item><md-menu-item ng-if="vm.conversation.type != \'PRIVATE_USER\' && vm.conversation.type != \'PRIVATE_AUDIENCE\'"><md-button ng-click="$mdCloseMenu;vm.inviteUsersToConversation()"><md-icon md-font-icon="zmdi zmdi-account-add"></md-icon><span translate="atheer.conversation.addUsers">Add Users to Conversation</span></md-button></md-menu-item><md-divider></md-divider><md-menu-item ng-if="!vm.isPinned()"><md-button ng-click="$mdCloseMenu;vm.pinConversation()"><md-icon md-font-icon="fa fa-thumb-tack"></md-icon><span translate="atheer.conversation.pinConversation">Pin this Conversation</span></md-button></md-menu-item><md-menu-item ng-if="vm.isPinned()"><md-button ng-click="$mdCloseMenu;vm.unPinConversation()"><md-icon md-font-icon="fa fa-thumb-tack"></md-icon><span translate="atheer.conversation.unpinConversation">Unpin this Conversation</span></md-button></md-menu-item><md-menu-item ng-if="vm.conversation.type != \'PRIVATE_AUDIENCE\'"><md-button ng-click="$mdCloseMenu;vm.archiveConversation()"><md-icon md-font-icon="zmdi zmdi-archive"></md-icon><span translate="atheer.conversation.archiveConversation">Archive this Conversation</span></md-button></md-menu-item><md-menu-item ng-if="vm.conversation.type != \'PRIVATE_AUDIENCE\'" permission permission-only="vm.permissions.delete"><md-button ng-click="$mdCloseMenu;vm.deleteConversation()"><md-icon md-font-icon="zmdi zmdi-delete"></md-icon><span translate="atheer.conversation.deleteConversation">Delete this Conversation</span></md-button></md-menu-item><md-divider ng-if="vm.conversation.type != \'PRIVATE_USER\' && vm.conversation.type != \'PRIVATE_AUDIENCE\'"></md-divider><md-menu-item ng-if="vm.conversation.type != \'PRIVATE_USER\' && vm.conversation.type != \'PRIVATE_AUDIENCE\'"><md-button ng-click="$mdCloseMenu;vm.leaveConversation()"><md-icon md-font-icon="fa fa-sign-out"></md-icon><span translate="atheer.conversation.leaveConversation">Leave this Conversation</span></md-button></md-menu-item></md-menu-content></md-menu></div><fp-help key="conversation"></fp-help></div></md-toolbar><conversation-message-list flex layout="column" conversation="vm.conversation" conversation-id="vm.conversationId"></conversation-message-list><conversation-message-editor ng-if="vm.conversation != null" conversation-model="vm.conversation"></conversation-message-editor></div><div ng-if="vm.showConversationInfo" layout="column" flex="30" class="md-whiteframe-z1"><conversation-info flex layout="column" conversation-model="vm.conversation"></conversation-info></div></div>');
$templateCache.put('modules/conversation/conversation-group-dialog.tmpl.html','<md-dialog flex="50" flex-xs="100" flex-md="50" flex-lg="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span ng-if="!vm.filter" flex translate="atheer.conversation.group.title">Start Group Conversation</span> <span ng-if="vm.filter" flex translate="atheer.conversation.editConversationDetails">Edit Conversation details</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.group.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div flex layout="row" ng-form="groupForm"><div flex="20" class="fp-group-image-container" ng-mouseenter="image.showEditProfileImage = true;" ng-mouseleave="image.showEditProfileImage = false;"><img ng-if="vm.converationModel.picture_id" ng-src="{{vm.getGroupProfileImageUrl()}}" alt="girl-avatar" class="make-round" width="100" height="100"><fp-group-avatar ng-if="!vm.converationModel.picture_id" box-size="\'100px\'" icon-size="\'50px\'" color="vm.primaryColor"></fp-group-avatar><div class="fp-group-image-edit-overlay" layout-align="center center" layout="row" ng-style="image.showEditProfileImage ? { \'top\':\'0\' } : {\'top\' : \'100%\'}"><fp-upload fp-content-type="picture" fp-ng-model="vm.converationModel.picture_id" fp-multiple="true" fp-upload-icon-class="zmdi zmdi-edit icon-size" fp-add-model-fn="vm.updateGroupProfileImage(mediaId, responseObj)" fp-pattern="image/*" fp-max-size="2000000" fp-upload-type="basic" fp-enable-preview="false" fp-all-button-color-class=""></fp-upload><md-button ng-if="vm.converationModel.picture_id && vm.converationModel.picture_id != null" ng-click="vm.removeGroupProfileImage()" class="md-icon-button" aria-label="primary button"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></div></div><md-input-container flex class="md-block"><label class="md-required" for="field_name" translate="atheer.conversation.group.name">Group Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.converationModel.name" required><div ng-messages="groupForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div class="margin-top-20"><span flex translate="atheer.conversation.group.purpose">Purpose</span></div><md-input-container class="md-block"><textarea name="note" froala="vm.froalaOptions" ng-model="vm.converationModel.purpose"></textarea></md-input-container><div layout="column" ng-if="!vm.filter"><span class="md-subhead" translate="atheer.conversation.group.users">Users *</span><div class="fp-user-chips" flex><fp-auto-complete no-label="true" auto-complete-model="vm.asyncUsers" component="User" multiple="true"></fp-auto-complete></div></div><div flex layout="column"><div flex layout="row"><div flex="60" class="padding-top-20"><span translate="atheer.conversation.group.makeItPrivate">Make it Private</span></div><div layout="row" flex><div flex layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.privateConversation"></md-switch></div></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" ng-click="vm.submit()" type="submit" ng-disabled="!vm.filter && (groupForm.$invalid || vm.asyncUsers.length === 0)"><span ng-if="!vm.filter" translate="entity.action.start">Start</span><span ng-if="vm.filter" translate="entity.action.update">Update</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/conversation/conversation-group-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex>{{vm.allowMultiSelect ? \'atheer.conversation.groupPicker.selectGroups\' : \'atheer.conversation.groupPicker.selectGroup\' | translate}}</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'atheer.conversation.groupPicker.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.groupPicker.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.groupPicker.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.groupPicker.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.groupPicker.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.groups.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><div class="md-padding" ng-if="vm.groups.length > 0"><div layout="row" layout-align="end center"><md-button layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedGroups.length <= 0" translate="entity.action.select">Select</md-button></div><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedGroups" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th md-column><span translate="atheer.conversation.groupPicker.table.userAvatar">User Avatar</span></th><th md-column md-order-by="name"><span translate="atheer.conversation.groupPicker.table.name">Name</span></th><th md-column><span translate="atheer.conversation.groupPicker.table.purpose">Purpose</span></th><th md-column><span translate="atheer.conversation.groupPicker.table.members">Members</span></th></tr></thead><tbody md-body><tr ng-repeat="group in vm.groups track by group.id" md-row md-select="group" md-select-id="id" md-auto-select><td md-cell><img ng-src="{{vm.getGroupImageUrl(group)}}" width="40px"></td><td md-cell>{{group.name}}</td><td md-cell><span froala-view="group.purpose"></span></td><td md-cell>{{group.users.length}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/conversation/conversation-info.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="white-theme"><div class="md-toolbar-tools md-accent"><span translate="atheer.conversation.info.title">About this Conversation</span><div flex></div><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.info.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-content ng-if="vm.loadingData" flex layout="column" class="md-whiteframe-z1" layout-align="center center" layout-fill><wave-spinner></wave-spinner></md-content><md-content ng-if="!vm.loadingData && vm.checkForUpdate()" layout="column" class="md-whiteframe-z1 padding-left-10 padding-right-10"><div layout="row" layout-align="space-between center" class="fp-conv-info-section"><md-icon md-font-icon="zmdi zmdi-info"></md-icon><span flex class="md-body-2" translate="atheer.conversation.info.conversationDetails">Conversation Details</span><md-button ng-click="vm.showConversationDetail = !vm.showConversationDetail" class="md-icon-button"><md-icon ng-if="!vm.showConversationDetail" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.showConversationDetail" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.showConversationDetail && vm.conversationModel.type == \'PRIVATE_USER\'" class="fp-conv-info-section-detail"><div flex layout="column" class="fp-conv-info-section-detail" layout-align="center center"><div layout-align="center center"><fp-avatar user="vm.conversationModel.user_info" presence="false" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="100"></fp-avatar></div><div layout-align="center center" class="margin-top-20"><span class="md-title">{{vm.conversationModel.user_info.first_name}} {{vm.conversationModel.user_info.last_name}}</span></div></div></div><div ng-if="vm.showConversationDetail && vm.conversationModel.type != \'PRIVATE_USER\'" class="fp-conv-info-section-detail"><div flex layout="column" class="fp-conv-info-section-detail"><div layout-align="start center"><span class="md-body-1" translate="atheer.conversation.info.name">Name</span></div><div layout-align="start center" class="margin-bottom-10"><span class="md-body-2">{{vm.conversationModel.name}}</span></div></div><div flex layout="column"><div layout-align="start center"><span class="md-body-1" translate="atheer.conversation.info.purpose">Purpose</span></div><div layout-align="start center"><span froala-view="vm.conversationModel.purpose" class="md-body-2"></span></div></div><div flex layout="column" layout-align="center center" ng-if="vm.conversationModel.type != \'PRIVATE_AUDIENCE\'"><md-button class="md-primary" ng-click="vm.editConversation()" type="submit"><span translate="entity.action.edit">Edit</span></md-button></div></div><md-divider></md-divider><div layout="row" layout-align="space-between center" class="fp-conv-info-section"><md-icon md-font-icon="fa fa-thumb-tack"></md-icon><span flex class="md-body-2" translate="atheer.conversation.info.pinnedMessages">Pinned Messages</span><md-button ng-click="vm.showPinned = !vm.showPinned" class="md-icon-button"><md-icon ng-if="!vm.showPinned" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.showPinned" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.showPinned" class="fp-conv-info-section-detail"><div ng-if="vm.pinnedMessages.length == 0" flex layout="column" layout-align="start center" layout-fill><div class="margin-top-10 main" translate="atheer.conversation.info.noPinned">No items have been pinned yet! Open the context menu on important messages or files and choose Pin to this conversation to stick them here.</div></div><div ng-if="vm.pinnedMessages.length != 0" flex layout="column" layout-align="start start" layout-fill><div flex layout="column" ng-repeat="message in vm.pinnedMessages | orderBy:\'+\':true track by $index" class="fp-conv-message-container" ng-init="message.showActions = false" ng-mouseover="message.showActions = true" ng-mouseleave="message.showActions = false"><div layout="row" layout-align="start center"><div layout="column"><span class="md-body-1"><span ng-if="message.type == \'TEXT\' || message.type == \'URL\' " froala-view="message.body" class="md-body-6"></span> <span ng-if="message.type == \'AUDIO\' " class="message audio-pinned-message" ng-style="{ \'background\': vm.primaryColor }"><fp-conv-message-audio-player is-pinned="true" mine="true" audio-id="message.id" url="/media/audios/{{message.body}}"></fp-conv-message-audio-player></span><span ng-if="message.type == \'CONTENT\' " class="message content-pinned-message" ng-style="{ \'background\': vm.primaryColor }"><fp-content-feed-item content="message.content" show-duration="false" show-description="false" message-view="true"></fp-content-feed-item></span></span><md-divider></md-divider></div></div></div></div></div><md-divider></md-divider><div ng-if="vm.conversationModel.type != \'PRIVATE_USER\'" layout="row" layout-align="space-between center" class="fp-conv-info-section"><md-icon md-font-icon="zmdi zmdi-accounts-alt"></md-icon><span flex class="md-body-2" translate="atheer.conversation.info.members" translate-values="{userInfoLength: \'{{vm.userInfo.length}}\'}">{{vm.userInfo.length}} Members</span><md-button ng-click="vm.showMembers = !vm.showMembers" class="md-icon-button"><md-icon ng-if="!vm.showMembers" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.showMembers" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.showMembers && vm.conversationModel.type != \'PRIVATE_USER\'" class="fp-conv-info-section-detail"><div ng-if="!vm.conversationModel.users || vm.conversationModel.users.length == 0 || vm.userInfo.length == 0" flex layout="column" layout-align="center center" layout-fill><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.conversation.info.noMembersYet">No members yet</div></div><md-list ng-if="vm.conversationModel.users || vm.conversationModel.users.length != 0 || vm.userInfo.length != 0"><md-list-item ng-repeat="user_info in vm.userInfo"><fp-avatar user="user_info" presence="true" auto-color="true" class="md-avatar" bind="true" font-weight="400" font-scale="100" round-shape="true" width="30"></fp-avatar><div class="md-list-item-text margin-left-10" layout="column"><span class="md-body-2">{{user_info.first_name}} {{user_info.last_name}}</span></div><md-divider></md-divider></md-list-item></md-list><div flex layout="column" layout-align="center center" ng-if="vm.conversationModel.type != \'PRIVATE_AUDIENCE\'"><md-button class="md-primary" ng-click="vm.inviteUsersToConversation()" type="submit"><span translate="atheer.conversation.info.addMembers">Add Members</span></md-button></div></div><md-divider ng-if="vm.conversationModel.type != \'PRIVATE_USER\'"></md-divider><div layout="row" layout-align="space-between center" class="fp-conv-info-section"><md-icon md-font-icon="zmdi zmdi-library"></md-icon><span flex class="md-body-2" translate="atheer.conversation.info.sharedContent">Shared Content</span><md-button ng-click="vm.showSharedContent = !vm.showSharedContent" class="md-icon-button"><md-icon ng-if="!vm.showSharedContent" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.showSharedContent" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.showSharedContent" class="fp-conv-info-section-detail"><div flex layout="column" layout-align="center center" ng-if="vm.contentMessages.length == 0" layout-fill><div class="margin-top-10 main" translate="atheer.conversation.info.NoSharedContent">No shared content</div></div><div ng-if="vm.contentMessages.length != 0" flex layout="column" layout-align="start start" layout-fill><fp-content-message-feed contents="vm.contentMessages"></fp-content-message-feed></div></div></md-content>');
$templateCache.put('modules/conversation/conversation-list.tmpl.html','<div flex layout="column" layout-fill><div class="toolbar-default md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="atheer.conversation.list.title">Conversations</span></h2><span flex></span><md-menu ng-if="vm.hasPermission" md-offset="50 0"><md-button class="md-fab md-mini md-accent" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="fa fa-edit"></md-icon></md-button><md-menu-content width="4"><md-menu-item permission permission-only="vm.permissions.create1on1"><md-button ng-click="$mdCloseMenu;vm.startPeronsalConversation()"><md-icon md-font-icon="zmdi zmdi-account"></md-icon><span translate="atheer.conversation.list.menu.oneToOne">Start a 1:1 Conversation</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.createGroup" ng-if="vm.groupConversationFeature"><md-button ng-click="$mdCloseMenu;vm.startGroupConversation()"><md-icon md-font-icon="zmdi zmdi-accounts-alt"></md-icon><span translate="atheer.conversation.list.menu.group">Start a Group Conversation</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.createGroup" ng-if="vm.groupConversationFeature"><md-button ng-click="$mdCloseMenu;vm.joinGroupConversation()"><md-icon md-font-icon="zmdi zmdi-accounts-add"></md-icon><span translate="atheer.conversation.list.menu.joinGroup">Join a Group Conversation</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div flex ng-if="!vm.loadingData" layout="column" class="fp-conv-list md-whiteframe-z1"><div layout="row" class="padding-10" ng-repeat="conversation in vm.conversations" ng-click="vm.selectConversation(conversation.id)" ng-class="conversation.id == vm.selectedConversationId ? \'fp-conv-item-selected\' : \'fp-conv-item\'"><img ng-if="conversation.type != \'PRIVATE_USER\' && conversation.picture_id" ng-src="{{vm.getConverstionImageUrl(conversation)}}" ng-style="{\'border-radius\' : \'45px\'}" width="45" height="45" alt="{{::vm.getConverstionTitle(conversation)}}"><fp-group-avatar ng-if="conversation.type != \'PRIVATE_USER\' && !conversation.picture_id" box-size="\'45px\'" icon-size="\'25px\'" color="vm.primaryColor"></fp-group-avatar><div ng-if="conversation.type == \'PRIVATE_USER\'"><fp-avatar user="conversation.user_info" presence="true" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="45"></fp-avatar></div><div flex layout="column" class="margin-left-10"><div flex layout="row" layout-align="space-between center"><span class="md-subhead" ng-style="{\'font-weight\': 500, \'white-space\': \'nowrap\', \'text-overflow\': \'ellipsis\', \'overflow\': \'hidden\'}">{{::vm.getConverstionTitle(conversation)}}</span> <span class="md-caption">{{conversation.last_message.created_on | amCalendar:referenceTime:vm.dateFormats}}</span></div><div flex layout="row" layout-align="space-between center"><span class="fp-conv-item-message md-caption" ng-class="{\'fp-conv-unread-message\': conversation.unread_message_count > 0}" froala-view="vm.getConverstionLastMessage(conversation)"></span><div><md-icon ng-if="vm.isPinned(conversation)" ng-style="{\'font-size\': \'12px\', height: \'12px\'}" md-font-icon="fa fa-thumb-tack"></md-icon><div ng-if="conversation.unread_message_count > 0" class="fp-message-unread-count">{{conversation.unread_message_count}}</div></div></div></div></div></div></div>');
$templateCache.put('modules/conversation/conversation-local-content-picker.tmpl.html','<md-dialog flex="80" class="local-content-dialog" ng-class="{\'content-dialog\': vm.processStatus == \'idle\'}"><md-dialog-content class="" flex><div ng-if="vm.processStatus == \'idle\' " flex layout="row" class="local-content-wrapper"><md-button class="md-icon-button close-btn" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button><div flex="10" layout="column" layout-align="center center" class="local-content" ng-class="{\'local-content-uploading\': vm.uploadStatus == \'uploading\'}"><div md-font-icon class="zmdi zmdi-laptop-mac content-icon"></div><div class="content-side-nav"></div></div><div ng-if=" vm.uploadStatus == \'idle\' " flex layout="column" layout-align="center center" class="local-content"><div md-font-icon class="zmdi zmdi-laptop-mac content-icon"></div><div layout="row" class="content-file-upload-wrapper" layout-align="center center"><div class="content-file-upload-container fp-drop-box" layout="column" layout-align="center center" ngf-drop="vm.upload($files, $file, $newFiles, $duplicateFiles, $invalidFiles)" ngf-multiple="false" ngf-ignore-invalid="\'pattern maxSize\'" ngf-pattern="{{vm.filePattern}}" ngf-accept="\'{{vm.acceptPattern}}\'" aria-label="upload" ngf-drag-over-class="{accept:\'dragover\', reject:\'dragover-err\'}" ngf-select="vm.upload($files, $file, $newFiles, $duplicateFiles, $invalidFiles)"><div class="zmdi zmdi-file-plus file-upload-icon" ngf-select="vm.upload($files, $file, $newFiles, $duplicateFiles, $invalidFiles)" ngf-pattern="{{vm.filePattern}}" ngf-multiple="false" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"></div><div class="heading" translate="localContent.select">Select Files to Upload</div><p class="sub-heading" translate="localContent.dragAndDrag">or Drag and Drop, Copy and Paste Files</p></div></div></div><div ng-if=" vm.uploadStatus != \'idle\' " flex layout="column" class="local-content"><div layout layout-align="center center" class="padding-10"><span ng-if="vm.uploadStatus == \'uploading\'" translate="localContent.uploaded" translate-values="{length: \'{{vm.files.length}}\'}">Uploaded 0/{{vm.files.length}}</span> <span ng-if="vm.uploadStatus == \'stop\' " translate="localContent.selectedFiles">Selected Files</span> <span ng-if="vm.uploadStatus == \'error\'" translate="localContent.failed">Failed</span></div><div layout layout-align="end end" class="padding-10"><!-- <input type="text" placeholder="{{\'localContent.filter\' | translate}}" ng-model="vm.filterText" ng-change="vm.onChange()"  /> --></div><md-divider ng-style="{\'border-color\': \'#e0e0e0\'}"></md-divider><div ng-if="vm.uploadStatus == \'uploading\'" class="padding-10 uploading-text" translate="localContent.uploading">Uploading</div><div ng-if="vm.uploadStatus == \'uploading\'" layout="row" class="uploading-content-info" ng-repeat="file in vm.files"><div flex="10" layout="column"><img ngf-src="file" ng-if="vm.fileType == \'image\'" alt="file.name"><div ng-if="vm.fileType != \'image\' " class="other-docs"><div md-font-icon class="zmdi zmdi-file"></div></div></div><div flex="80" layout="column" ng-style="{\'padding\': \'5px 0px\'}"><div ng-style="{\'font-size\': \'14px\'}">{{file.name}}</div><div ng-style="{\'font-size\': \'12px\', \'color\': \'#222\'}">{{file.uploadEvt.loaded}}/{{file.uploadEvt.total}}</div><md-progress-linear class="local-content-progress-linear" md-mode="determinate" value="{{vm.uploadPercentage}}"></md-progress-linear></div><div flex layout><md-button class="md-icon-button close-btn" ng-click="vm.stopUploading(file)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon></md-button></div></div><md-divider ng-if="vm.uploadStatus == \'stop\'" class="stop-divider" ng-style="{\'border-color\': \'#e0e0e0\'}"></md-divider><div ng-if="vm.uploadStatus == \'error\'" class="height-100" layout layout-align="center center"><b translate="localContent.uploadError">Couldn\'t upload file try again</b></div><div ng-if="vm.uploadStatus == \'stop\' || vm.uploadStatus == \'error\'" class="stop-action-container" layout="row" layout-align="end end"><md-button class="md-primary" ng-click="vm.uploadMore()"><span translate="localContent.uploadMore">upload more</span></md-button></div></div></div><div layout layout-align="center center" layout-padding ng-if="vm.processStatus === \'uploading\'"><div layout="column" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-headline" translate="localContent.loading">Uploading Please wait ...</span><div layout="row" layout-align="center" class="margin-top-40"><md-progress-linear md-mode="indeterminate"></md-progress-linear></div></div></div><div layout layout-align="center center" layout-padding ng-if="vm.processStatus == \'complete\'"><div layout="column" layout-align="center center" class="margin-top-40 margin-bottom-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><span class="md-headline" ng-if="vm.fileType == \'document\'" translate="localContent.documentComplete">Document Upload Complete.</span> <span class="md-headline" ng-if="vm.fileType == \'image\'" translate="localContent.imageComplete">Image Upload Complete.</span> <span class="md-headline" ng-if="vm.fileType == \'video\'" translate="localContent.videoComplete">Video Upload Complete.</span> <span class="md-headline" ng-if="vm.fileType == \'audio\'" translate="localContent.audioComplete">Audio Upload Complete.</span></div></div><div layout-align="center center" layout layout-padding ng-if="vm.processStatus ==\'error\'" class="margin-top-40 margin-bottom-40"><div layout="column" layout-align="center center"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><span class="md-headline" ng-if="vm.fileType == \'document\'" translate="localContent.documentError">Document Upload Failed.</span> <span class="md-headline" ng-if="vm.fileType == \'image\'" translate="localContent.imageError">Image Upload Failed.</span> <span class="md-headline" ng-if="vm.fileType == \'video\'" translate="localContent.videoError">Video Upload Failed.</span> <span class="md-headline" ng-if="vm.fileType == \'audio\'" translate="localContent.audioError">Audio Upload Failed.</span></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/conversation/conversation-message-editor.html','<div class="fp-conv-editor"><div froala="vm.froalaOptions" ng-model="vm.convMessageBody" froala-init="vm.initializeEditor(initControls)" fp-type-tracking></div></div>');
$templateCache.put('modules/conversation/conversation-message-list.tmpl.html','<md-toolbar class="default margin-bottom-0" ng-if="vm.isReadOnly && vm.sessionModel"><div class="md-toolbar-tools md-accent"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'annotationPanel\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><span translate="atheer.messageList.chat">Chat</span><div flex></div></div></md-toolbar><md-content ng-if="vm.loadingData" flex layout="row" layout-align="center center"><wave-spinner></wave-spinner></md-content><md-content flex layout="row" ng-if="!vm.loadingData && vm.messages.length == 0" class="fp-conv-container"><div ng-if="!vm.isReadOnly" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId" name="vm.illustartionMessageName"></illustration-empty-screen></div><div ng-if="vm.isReadOnly" flex layout="column" layout-align="center center"><img ng-src="/assets/images/card/NoMessages.png" class="fp-illustration-empty-screen"><div class="margin-top-10 main" translate="atheer.messageList.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.messageList.noChat">There is no session chat yet.</div></div></md-content><md-content id="message_list" flex ng-if="!vm.loadingData && vm.messages.length > 0" class="fp-conv-container" when-scrolled-no-timeout="vm.loadMoreMessages()" scroll-to-bottom="vm.scrollToBottom" ng-class="vm.conversation.type != \'PRIVATE_USER\' ? \'fp-conv-container-group\' : \'fp-conv-container-user\'" ng-style="vm.isReadOnly && {\'padding\': \'20px\'}"><div ng-if="vm.isReadOnly && vm.sessionModel" layout="row" layout-align="space-between center" class="padding-bottom-20"><div class="conv-topic">{{vm.sessionModel.topic}}</div><div class="conv-createdBy">{{vm.sessionModel.created_on | date: "fullDate"}}</div></div><div flex layout="column" ng-repeat="message in vm.messages | orderBy:\'+\':true track by $index" class="fp-conv-message-list" ng-init="message.showActions = false" ng-mouseover="message.showActions = true" ng-mouseleave="message.showActions = false"><div ng-if="(message.time_separate || message.is_top) && !vm.isReadOnly" class="fp-conv-time"><span>{{message.created_on | amCalendar:referenceTime:vm.dateFormats}}</span></div><conversation-message id="message-{{message.id}}" conversation="vm.conversation" message="message" index="$index" is-read-only="vm.isReadOnly"></conversation-message></div><div ng-if="vm.isLoader" ng-style="{\'float\': \'right\'}"><md-icon md-font-icon class="fa fa-spinner fa-pulse"></md-icon></div><div ng-if="vm.isReadOnly && vm.sessionModel" layout="row" layout-align="center center" class="conv-view-date" translate="atheer.messageList.viewingFrom" translate-values=\'{date : "{{vm.sessionModel.created_on | date: "MMMM dd"}}"}\'>You\'re viewing a past chat from {{vm.sessionModel.created_on | date: "MMMM dd"}}</div><div ng-if="!vm.isReadOnly" ng-style="!vm.isTyping && {\'visibility\':\'hidden\'}" class="fp-typing-indicator"><span></span> <span></span> <span></span></div></md-content>');
$templateCache.put('modules/conversation/conversation-message-menu.html','<div layout="column" layout-align="center start" class="fp-conv-message-menu" md-whiteframe="4"><md-button ng-click="$mdCloseMenu;vm.addReaction()"><md-icon md-font-icon="fa fa-smile-o"></md-icon><span translate="atheer.message.menu.addReaction">Add Reaction</span></md-button><md-button ng-if="!vm.isPinned" ng-click="$mdCloseMenu;vm.pinMessage()"><md-icon md-font-icon="fa fa-thumb-tack"></md-icon><span translate="atheer.message.menu.pinMessage">Pin this message</span></md-button><md-button ng-if="vm.isPinned" ng-click="$mdCloseMenu;vm.unPinMessage()"><md-icon md-font-icon="fa fa-thumb-tack"></md-icon><span translate="atheer.message.menu.unpinMessage">UnPin this message</span></md-button><md-button ng-click="$mdCloseMenu;vm.deleteMessage()"><md-icon md-font-icon="zmdi zmdi-delete"></md-icon><span translate="atheer.message.menu.deleteMessage">Delete this message</span></md-button></div>');
$templateCache.put('modules/conversation/conversation-message-notifier.tmpl.html','<md-toast><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar fp-notification-height" layout="row"><fp-avatar user="vm.avatarData" auto-color="true" bind="true" _camel_case="true" font-weight="400" font-scale="100" round-shape="true" width="35"></fp-avatar><h6 class="notification-text-background" translate="notification.conversation.messageCreated" translate-values="{firstName: \'{{vm.notification.data.user_info.first_name}}\', lastName: \'{{vm.notification.data.user_info.last_name}}\'}">{{vm.notification.data.user_info.first_name}} {{vm.notification.data.user_info.last_name}} has sent you a message.</h6></div><br><h3 class="notification-text-background" translate="notification.conversation.messageTxt" translate-values="{message: \'{{vm.conversationMessage}}\'}">{{vm.conversationMessage}}</h3></div><md-dialog-actions ng-if="!vm.loadingData" layout="row"><span flex></span><md-button ng-click="vm.viewMessage()" class="md-raised md-primary"><span translate="entity.action.view">View</span></md-button></md-dialog-actions></md-toast>');
$templateCache.put('modules/conversation/conversation-message-reaction-panel.tmpl.html','<div id="spinner"></div><iframe border="0" name="iframe" src="third-party/emoji/index.html" width="338" height="425" scrolling="no" noresize="noresize" frameborder="0" onload="document.getElementById(\'spinner\').style.display=\'none\';"></iframe>');
$templateCache.put('modules/conversation/conversation-message.html','<div layout="row" layout-align="{{vm.message.publisher_id != vm.userId ? \'start end\' : \'end end\'}}" class="fp-conv-message-container"><div ng-if="vm.conversation.type != \'PRIVATE_USER\' && vm.message.publisher_id != vm.userId" class="fp-conv-message-avatar"><fp-avatar ng-if="vm.message.group_end" user="vm.message.user_info" width="25" auto-color="true" class="md-avatar" bind="true" font-weight="400" font-scale="100" round-shape="true"></fp-avatar><div ng-if="!vm.message.group_end" class="fb-message-group-no-avatar"></div></div><div layout="column" class="fp-conv-message" ng-class="vm.message.publisher_id != vm.userId ? \'yours\' : \'mine\'"><div layout="row" class="fb-message-container" ng-class="{\'fp-session-content-message\' : vm.conversation.type == \'SESSION_CONVERSATION\' && vm.message.type == \'CONTENT\'}"><div ng-if="vm.message.showActions && vm.message.publisher_id == vm.userId && !vm.isReadOnly" class="fp-conv-message-action"><md-button id="message-menu" class="md-icon-button" ng-click="vm.showMessageActions($event, vm.message, \'START\')"><md-icon md-font-icon="zmdi zmdi-more"></md-icon></md-button></div><div id="msg-{{vm.message.id}}" ng-if="vm.message.type == \'TEXT\'" froala-view="vm.message.formattedBody" class="message" ng-class="{\'last\': vm.message.group_end && !vm.message.is_pinned, \'last-pinned\': vm.message.group_end && vm.message.is_pinned, \'pinned\': vm.message.is_pinned, \'session-message\': vm.conversation.type == \'SESSION_CONVERSATION\'}" ng-style="vm.message.publisher_id == vm.userId && !vm.message.is_pinned && { \'background\': vm.primaryColor} || vm.message.is_pinned && { \'background\': \'rgba(255, 200, 0, 1)\'}"></div><div id="msg-{{vm.message.id}}" ng-if="vm.message.type == \'AUDIO\'" ng-class="{\'last\': vm.message.group_end && !vm.message.is_pinned, \'last-pinned\': vm.message.group_end && vm.message.is_pinned}" class="message audio" ng-style="vm.message.publisher_id == vm.userId && !vm.message.is_pinned && { \'background\': vm.primaryColor} || vm.message.is_pinned && { \'background\': \'rgba(255, 200, 0, 1)\'}"><fp-conv-message-audio-player layout=" row" audio-id="vm.message.id" mine="vm.message.publisher_id == vm.userId" url="/media/audios/{{vm.message.body}}"></fp-conv-message-audio-player></div><div id="msg-{{vm.message.id}}" ng-if="vm.message.type == \'CONTENT\'" ng-class="{\'last\': vm.message.group_end && !vm.message.is_pinned, \'last-pinned\': vm.message.group_end && vm.message.is_pinned, \'session-content-message\': vm.conversation.type == \'SESSION_CONVERSATION\'}" class="message" ng-style="vm.message.publisher_id == vm.userId && !vm.message.is_pinned && { \'background\': vm.primaryColor} || vm.message.is_pinned && { \'background\': \'rgba(255, 200, 0, 1)\'}"><fp-content-feed-item content="vm.message.content" publisher="vm.message.publisher_id" show-duration="false" show-description="false" message-view="true" type="vm.conversation.type"></fp-content-feed-item></div><div id="msg-{{vm.message.id}}" ng-if="vm.message.type == \'URL\'" class="message url-message"><fp-conv-message-url message="vm.message" user-id="vm.userId" primary-color="vm.primaryColor" sender="vm.message.publisher_id != vm.userId ? \'yours\' : \'mine\'"></fp-conv-message-url></div><div ng-if="vm.message.showActions && vm.message.publisher_id != vm.userId && !vm.isReadOnly" class="fp-conv-message-action"><md-button id="message-menu" class="md-icon-button" ng-click="vm.showMessageActions($event, vm.message, \'END\')" ng-class="vm.message.reactions.length > 0 ? \'with-reaction\' : \'with-no-reaction\'"><md-icon md-font-icon="zmdi zmdi-more"></md-icon></md-button></div></div><div ng-if="vm.message.reactions.length > 0 || vm.message.is_pinned" class="fp-reaction-container" flex layout="row" layout-align="center center" ng-class="{\'reaction-info-yours\': vm.message.publisher_id != vm.userId, \'reaction-info-mine\': vm.message.publisher_id == vm.userId, \'reaction-no-group-end\': !vm.message.group_end}"><div ng-if="vm.message.is_pinned" class="fp-reaction-pin reaction-selected-pinned" layout-align="center center" ng-click="vm.unPinMessage()"><md-icon md-font-icon="fa fa-thumb-tack" class="reaction-pinned" ng-style="{\'font-size\': \'13px\', height: \'13px\'}"></md-icon></div><div class="reaction-wrapper"><div class="reaction-container"><div ng-repeat="reaction in vm.message.reaction_summary.reaction_info" layout-align="center center" class="fp-reaction-detail reaction-selected" ng-class="reaction.reactByMe ? \'reaction-selected\' : \'reaction-unselected\'" ng-click="vm.addOrRemoveReaction(reaction.type, reaction.unified)"><span ng-style="{\'font-size\': \'13px\', height: \'13px\'}" ng-bind-html="reaction.webInfo"></span> <span class="reaction-number" ng-style="{\'font-size\': \'13px\', height: \'13px\'}">{{reaction.count}}</span></div></div><div class="fp-reaction-add" layout-align="center center" ng-click="vm.addReaction()"><md-icon class="icon" md-font-icon="fa fa-plus" ng-style="{\'font-size\': \'13px\', height: \'13px\'}"></md-icon></div></div></div><span flex layout-align="center center" ng-if="vm.message.group_end" ng-class="vm.message.publisher_id != vm.userId ? \'message-info-yours\' : \'message-info-mine\'">{{vm.conversation.type != \'PRIVATE_USER\' && vm.message.publisher_id != vm.userId ? vm.message.user_info.first_name + \' - \' : \'\'}} {{vm.message.created_on | amDateFormat:\'hh:mm a\'}}</span></div></div>');
$templateCache.put('modules/conversation/conversation-typing-indicator.html','<div layout="row" class="fp-conv-typing-indicator" layout-align="start center"><div ng-if="vm.usersTyping.length > 0 && vm.conversationModel.type != \'PRIVATE_USER\'" ng-repeat="userTyping in vm.usersTyping track by userTyping.uuid"><h4 translate="atheer.conversation.userTyping" translate-values="{userInfo: \'{{userTyping.userInfo}}\'}">{{userTyping.userInfo}} is typing...</h4></div><div ng-if="vm.usersTyping.length > 0 && vm.conversationModel.type == \'PRIVATE_USER\'" ng-repeat="userTyping in vm.usersTyping track by userTyping.uuid"><h4 translate="atheer.conversation.typing">typing...</h4></div><div ng-if="vm.usersTyping.length == 0"><h4>{{vm.userStatus}}</h4></div></div>');
$templateCache.put('modules/conversation/conversation-url-message.tmpl.html','<div class="fp-conv-url-message"><div class="body" ng-style="vm.message.publisher_id == vm.userId && !vm.message.is_pinned && { \'background\': vm.primaryColor} || vm.message.is_pinned && { \'background\': \'rgba(255, 200, 0, 1)\'}"><!-- <a href="{{vm.metaData.url}}" target="_blank" ng-class="{\'yours-url\': vm.sender == \'yours\'}" ng-bind-html="vm.message.formattedMsgBody">{{vm.message.body}}</a> --><div ng-class="{\'yours-url\': vm.sender == \'yours\'}" ng-bind-html="vm.message.formattedMsgBody"></div></div><div ng-click="vm.redirectToUrl()" class="preview-wrapper"><div ng-if="vm.metaData.images.length > 0 || vm.metaData.favicon_url"><img ng-src="{{vm.getImageUrl()}}" alt="{{vm.metaData.title}}"></div><div class="preview" ng-if="vm.metaData.title || vm.metaData.description || vm.metaData.provider_display"><div class="preview-title" ng-if="vm.metaData.title">{{vm.metaData.title}}</div><div class="preview-description" ng-if="vm.metaData.description">{{vm.metaData.description}}</div><div class="preview-site" ng-if="vm.metaData.provider_display">{{vm.metaData.provider_display}}</div></div></div></div>');
$templateCache.put('modules/conversation/conversations.tmpl.html','<div flex layout="column" layout-fill><div class="toolbar-default md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="atheer.conversation.list.title">Conversations</span></h2><span flex></span></div></div><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="row" layout-align="center center" class="margin-top-20"><div flex="10" layout="column" layout-align="center center" class="fp-session-action-box margin-right-20" ng-click="vm.startPeronsalConversation()"><md-button class="md-icon-button quick-actions md-primary margin-bottom-10" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.onIconClick(action.name, action.properties)"><md-icon md-svg-src="/assets/images/card/conv_one_one.svg"></md-icon></md-button><span class="md-title" translate="home.conv_one_one">New 1:1</span></div><div flex="10" layout="column" layout-align="center center" class="fp-session-action-box margin-right-20" ng-click="vm.startGroupConversation()"><md-button class="md-icon-button quick-actions md-primary margin-bottom-10" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.onIconClick(action.name, action.properties)"><md-icon md-svg-src="/assets/images/card/conv_group.svg"></md-icon></md-button><span class="md-title" translate="home.conv_group">New Group</span></div><div flex="10" layout="column" layout-align="center center" class="fp-session-action-box margin-right-20" ng-click="vm.joinGroupConversation()"><md-button class="md-icon-button quick-actions md-primary margin-bottom-10" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.onIconClick(action.name, action.properties)"><md-icon md-svg-src="/assets/images/card/conv_join.svg"></md-icon></md-button><span class="md-title" translate="home.conv_join">Join Group</span></div></div><div ng-if="!vm.loadingData" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div>');
$templateCache.put('modules/doc/product-doc.tmpl.html','<div flex layout="column" layout-fill><div flex layout="row" class="margin-top-5"><iframe id="ngxFrame" ng-src="{{vm.hostUrl}}" height="100%" width="100%" noresize="noresize" frameborder="0" allow="camera; microphone"></div></div>');
$templateCache.put('modules/home/home.tmpl.html','<div flex layout-fill><div layout="column" class="fp-home-page-wrapper" layout-fill ng-if="!vm.isConfigurableHomeEnabled"><div ng-if="vm.isLoading" flex layout="column" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.isLoading"><div flex layout="column"><fp-header is-public-user="vm.isPublicUser" page-name="vm.pageName" user-info="vm.userInfo"></fp-header><div layout="row" layout-align="space-between start" class="fp-home-greeting-container" ng-style="$root.isLightTheme && {\'background-color\': \'{{vm.primaryColor}}\', \'color\': \'white\'}" ng-if="!vm.isPublicUser"><span class="md-title">{{vm.welcomeMsg}}</span><div class="fp-date-container"><md-button class="md-icon-button" ng-click="vm.refresh()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh" ng-style="$root.isLightTheme && {\'color\': \'#FAFAFA\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.upcomingSessions.refresh">Refresh</span></fp-tooltip></md-button><div hide-sm hide-xs><span class="md-title" translate="home.today" ng-style="$root.isLightTheme && {\'color\': \'rgba(255, 255, 255, 0.7)\', \'font-size\': \'18px\'}">Today, </span>{{vm.formattedDate}}</div></div></div></div><div class="fp-panel" layout="column"><div style="margin-bottom: 14px" ng-if="vm.homeData.carouselData.length > 0" ng-class="{\'fp-single-annnouncements\': vm.homeData.carouselData.length == 1 || vm.homeData.carouselData.length == 2}"><ui-carousel slides="vm.homeData.carouselData" dots="true" arrows="false" slides-to-show="(vm.isMobileBrowser || vm.homeData.carouselData.length == 1) ? 1 : 2" slides-to-scroll="(vm.isMobileBrowser || vm.homeData.carouselData.length == 1) ? 1 : 2"><carousel-item><div style="margin: 0px 10px"><md-card class="fp-announcement-container"><md-card-content class="fp-announcement-content-container" layout="row" layout-align="center center"><div layout="column" class="left-side-container"><img ng-src="{{item.getImageSrc(item)}}"></div><div layout="column" class="right-side-container"><div style="height: 92px"><div ng-show="item.show_title"><div class="title" id="fp-announcement-title-{{item.id}}" ng-style="item.data.title_color ? {\'color\': item.data.title_color} : {\'color\': \'#343A3A\'}"><span>{{item.title}}</span></div></div><div ng-show="item.data.show_content"><div ng-show="item.data.content" class="description"><span froala-view="item.data.content" ng-style="item.data.content_color ? {\'color\': item.data.content_color} : {\'color\': \'#343A3A\'}" ng-class="item.getTitleHeight(item) > 26 ? \'line-2\' : \'line-3\'"></span></div></div></div><md-card-actions layout="row" layout-align="end end" ng-show="item.isAnnouncement"><button ng-click="item.dismiss()" class="md-button dismiss-btn" translate="home.dismiss" ng-style="item.data.title_color ? {\'color\': item.data.title_color} : {\'color\': \'#343A3A\'}">Dismiss</button></md-card-actions></div></md-card-content></md-card></div></carousel-item></ui-carousel></div><md-card ng-repeat="tile in vm.homeData.home_screen_tiles" class="fp-home-screen-tiles" permission permission-only="tile.permission" ng-if="vm.isFeaturesActive(tile.features)"><md-card-content layout="row" layout-sm="column" layout-xs="column" layout-align="start start" class="fp-home-screen-tiles-wrapper"><div class="left-side" layout="column" layout-align="space-between start"><div translate="home.{{tile.name}}" class="md-title fp-tile-heading"></div><div translate="home.{{tile.name}}_description" class="md-body-1"></div><div layout="row" class="fp-quick-actions-container"><div ng-repeat="action in tile.quick_actions" layout="column" layout-align="space-between center" class="actions-wrapper"><md-button ng-disabled="vm.getDisable(action)" class="md-icon-button quick-actions md-primary" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.onIconClick(action.name, action.properties, action.devicePermission, action.description)"><md-icon md-svg-src="{{vm.getLogo(action.name)}}"></md-icon></md-button><div ng-if=" action.name != \'job_action1\' && action.name != \'job_action2\' " class="icon-label" translate="home.{{action.name}}" layout="row"></div><div ng-if=" action.name == \'job_action1\' || action.name == \'job_action2\' " class="icon-label" layout="row">{{action.description}}</div></div></div></div><md-divider hide-sm hide-xs></md-divider><hr hide-md hide-lg hide-xl><div class="right-side" layout="row" layout-align="space-between start"><div class="full-width no-container" ng-if="tile.name == \'conversations\'" layout="row" layout-sm="column" layout-xs="column" layout-align="center ccenter"><md-icon md-svg-icon="/assets/images/card/no_conversations.svg"></md-icon><div class="description-container" layout="column" layout-align="center center"><div class="md-sub-head" translate="home.conversationsDescription">Seamlessly collaborate with colleagues and company experts</div></div></div><div ng-repeat="tileData in tile.tile_data_elements" class="tiles-container"><div ng-if="tile.name == \'air_sessions\'" layout="row" layout-sm="column" layout-xs="column"><div ng-if="vm.upcomingSessions.length == 0" layout="row" layout-sm="column" layout-xs="column" layout-align="center center" class="full-width no-container"><md-icon md-svg-icon="/assets/images/card/no_upcoming_sessions.svg"></md-icon><div class="description-container" layout="column" layout-align="center center"><div class="md-sub-head" translate="home.noSessiondescription">You have no Upcoming AiRSessions</div></div></div><div ng-if="vm.upcomingSessions.length > 0" class="full-width" layout="column"><div layout="row" layout-align="space-between center"><div class="md-subhead" translate="home.{{tileData.name}}"></div><div ng-if="tile.tile_data_elements.length > 0" layout="row" layout-align="center center"><div class="fp-see-all" translate="home.seeAll">see all</div><md-button class="md-icon-button fp-see-all-btn" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.gotoPage(tile.name)"><md-icon md-font-icon="zmdi zmdi-long-arrow-right"></md-icon></md-button></div></div><div style="padding-top: 5px" layout="row" layout-sm="column" layout-xs="column"><div ng-if="vm.isSessionsLoading" flex layout="column" layout-align="center center"><wave-spinner></wave-spinner></div><md-card ng-if="!vm.isSessionsLoading" ng-repeat="session in vm.upcomingSessions" class="upcoming-sessions-container"><md-card-content><span ng-if="session.active_session" class="fp-active-session" md-colors="{background: \'primary-500-0.3\'}" ng-style="{\'color\': \'{{vm.primaryColor}}\'}" translate="atheer.session.upcomingSessions.active">Active</span><div class="fp-session-title">{{session.topic}}</div><div class="fp-session-time">{{session.formattedDay}} | {{session.start_time | date: \'hh:mm a\'}}</div></md-card-content><md-card-actions layout-align="center center" layout="column"><md-button class="md-raised md-primary" translate="entity.action.join" ng-click="vm.joinSession(session)">Join</md-button></md-card-actions></md-card></div></div></div><div ng-if="tile.name == \'jobs\'" layout="row" layout="column" layout-sm="column" layout-xs="column"><div ng-if="vm.jobs.length == 0" layout="row" layout-sm="column" layout-xs="column" layout-align="center center" class="full-width no-container"><md-icon md-svg-icon="/assets/images/card/no_recently_used_jobs.svg"></md-icon><div class="description-container" layout="column" layout-align="center center"><div class="md-sub-head" translate="home.noJobs">No Jobs have been created yet</div></div></div><div ng-if="vm.jobs.length > 0" class="full-width" layout="column"><div layout="row" layout-align="space-between center"><div class="md-subhead" translate="home.{{tileData.name}}"></div><div ng-if="tile.tile_data_elements.length > 0" layout="row" layout-align="center center"><div class="fp-see-all" translate="home.seeAll">see all</div><md-button class="md-icon-button fp-see-all-btn" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.gotoPage(tile.name)"><md-icon md-font-icon="zmdi zmdi-long-arrow-right"></md-icon></md-button></div></div><div style="padding-top: 20px" layout="row" layout-sm="column" layout-xs="column"><div ng-if="vm.isJobsLoading" flex layout="column" layout-align="center center"><wave-spinner></wave-spinner></div><md-card class="fp-jobs-container" ng-if="!vm.isJobsLoading" layout="column" layout-align="center start" ng-repeat="job in vm.jobs track by $index" ng-style="{\'background-color\': vm.getCardBackgroundColor($index)}" ng-click="vm.executeJob(job)"><md-card-content layout="row" layout-align="center center"><div class="fp-job-title">{{job.name}}</div></md-card-content></md-card></div></div></div></div></div></md-card-content></md-card></div></div></div><div layout-fill class="v3-home" ng-if="vm.isConfigurableHomeEnabled"><div flex layout-fill layout-align="center center" class="frameLoader" ng-if="!vm.isIFrameDataLoaded"><wave-spinner></wave-spinner></div><iframe id="ngxFrame" ng-src="{{vm.ngxUrlTrusted}}" height="100%" width="100%" noresize="noresize" frameborder="0" allow="camera; microphone"></div></div>');
$templateCache.put('modules/home/no-access-dialog.tmpl.html','<md-dialog flex="50" aria-label="" class="no-access-dialog-container"><div layout="row"><h3 hide-xs flex translate="{{vm.title}}"></h3><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon></md-button></div><div><p translate="{{vm.content}}"></p></div><div ng-if="vm.isDeeplink" layout="row" layout-align="end center"><md-button ng-click="vm.close()" translate="entity.action.ok">ok</md-button></div></md-dialog>');
$templateCache.put('modules/content/announcement-assign-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex>Assign to User or Team</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Close</fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><form ng-if="vm.assignProgress == \'idle\'" name="contentAssignForm"><div layout="column"><span class="md-subhead">Users</span><div class="fp-user-chips" flex><fp-auto-complete no-label="true" auto-complete-model="vm.asyncUsers" component="User" multiple="true" query-objs="[{fieldName:\'text_search\', operator:\'=ts=\'}]"></fp-auto-complete></div><span class="md-subhead margin-top-20">Teams</span><div class="fp-user-chips" flex><fp-auto-complete no-label="true" auto-complete-model="vm.asyncTeams" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div></div><div layout="row" layout-align="start center" class="margin-top-20"><span>Dismiss</span></div><md-radio-group layout="column" ng-model="vm.contentAssignModel.is_due_date_relative" class="margin-top-20"><div flex layout="row"><div layout-align="start center" layout="row"><md-radio-button value="true" class="md-primary">In</md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.contentAssignModel.is_due_date_relative == \'true\'"><md-input-container layout-align="center center" layout="row"><label>Period</label><md-select ng-model="vm.contentAssignModel.relative_period"><md-option value="DAYS">Days</md-option><md-option value="WEEKS">Weeks</md-option></md-select></md-input-container><md-input-container layout-align="center center" layout="row"><label>Value</label> <input type="number" step="1" ng-model="vm.contentAssignModel.relative_value"></md-input-container></div></div><div flex layout="row" layout-align="start center"><div layout-align="start center" layout="row"><md-radio-button value="false" class="md-primary">Fixed Date</md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.contentAssignModel.is_due_date_relative == \'false\'"><md-datepicker ng-model="vm.contentAssignModel.due_on" md-placeholder="Select date"></md-datepicker></div></div></md-radio-group></form><div ng-if="vm.assignProgress == \'started\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-subhead">Assigning. Please wait...</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div><div ng-if="vm.assignProgress == \'complete\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon></div><div layout="row" layout-align="center" class="margin-top-20 margin-bottom-20"><span class="md-subhead">Successfully assigned to {{vm.assignSuccess}} Users...</span></div></div></md-dialog-content><md-dialog-actions ng-if="vm.assignProgress == \'idle\'" layout="row"><span flex></span><md-button ng-click="vm.close()"><span>Cancel</span></md-button><md-button class="md-primary md-raised" ng-click="vm.submit()" type="submit" ng-disabled="vm.disableSubmit()" class="md-primary"><span>Assign</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/content/announcement-detail.tmpl.html','<div flex ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div class="fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><div layout="row" layout-align="start center"><span translate="atheer.content.announcementDetail">Announcement Detail</span></div><textarea name="description" froala="vm.froalaOptions" ng-model="vm.contentModel.data.content"></textarea> <span class="about-error-message" ng-if="descriptionLimitExceed" translate="entity.validation.maxlength" translate-values="{max: 255}">This field cannot be longer than 255 characters.</span><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include><div flex layout="column"><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-brush"></md-icon><span flex translate="atheer.content.designOptions">Design Options</span><md-button ng-click="vm.contentMetaData.show_layout = !vm.contentMetaData.show_layout" class="md-icon-button"><md-icon ng-show="!vm.contentMetaData.show_layout" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-show="vm.contentMetaData.show_layout" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.contentMetaData.show_layout" layout="row" layout-align="space-between center"><span translate="atheer.content.displayTitle" translate-values="{colorOptions: \'{{vm.colorOptions}}\'}">Display Title {{vm.colorOptions}}</span><md-switch name="enabled" ng-model="vm.contentModel.data.show_title"></md-switch></div><div ng-if="vm.contentMetaData.show_layout && vm.contentModel.data.show_title" flex layout="row" layout-align="space-between center" ng-cloak><div flex md-color-picker ng-model="vm.contentModel.data.title_color" label="Title Text color" md-color-alpha-channel="false" md-color-sliders="false" md-color-rgb="false" md-color-hsl="false" md-color-history="false"></div></div><div ng-if="vm.contentMetaData.show_layout" layout="row" layout-align="space-between center"><span translate="atheer.content.displayContent">Display Content</span><md-switch name="featured" ng-model="vm.contentModel.data.show_content"></md-switch></div><div ng-if="vm.contentMetaData.show_layout && vm.contentModel.data.show_content" flex layout="row" layout-align="space-between center" ng-cloak><div flex md-color-picker ng-model="vm.contentModel.data.content_color" label="Content Text color" md-color-alpha-channel="false" md-color-sliders="false" md-color-rgb="false" md-color-hsl="false" md-color-history="false"></div></div><md-divider></md-divider></div></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/announcement-preview.tmpl.html\'"></ng-include></div></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include></div>');
$templateCache.put('modules/content/announcement-insight-overview.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex layout="column"><md-content ng-if="!vm.loadingData"><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="first_name"><span translate="atheer.content.firstName">First Name</span></th><th md-column md-order-by="last_name"><span translate="atheer.content.lastName">Last Name</span></th><th md-column md-order-by="created_on"><span translate="atheer.content.dismissedOn">Dismissed On</span></th></tr></thead><tbody md-body><tr ng-repeat="view in vm.viewData track by view.id"><td md-cell>{{view.user_info.first_name}}</td><td md-cell>{{view.user_info.last_name}}</td><td md-cell>{{view.created_on | amCalendar:referenceTime:formats}}</td></tr></tbody></table></md-table-container></md-content><div ng-if="!vm.loadingData && vm.viewData.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.viewData.length >= 0"></md-table-pagination>');
$templateCache.put('modules/content/announcement-preview.tmpl.html','<div layout-fill layout="row" layout-align="center center" layout-padding class="fp-content-preview-mode"><div flex class="fp-announcement-preview"><fp-content-view mode="\'preview\'" context="vm.contentModel.data.type" data="vm.contentModel" content-type="{{vm.contentModel.data.type}}" layout-fill></fp-content-view></div></div>');
$templateCache.put('modules/content/announcement-view.tmpl.html','<md-card class="fp-content-announcement-view"><md-card-content layout="row"><div layout="column" class="left-side-container"><img ng-src="{{getImageSrc()}}"></div><div layout="column" class="right-side-container"><div ng-if="data.data.show_title"><div class="title" ng-style="{\'color\': getTitleColor()}"><span translate="{{data.title}}"></span></div></div><div ng-if="data.data.show_content" style="height: 100%; padding: 10px 0px;"><div class="description" ng-if="!data.data.content && !data.id" translate="atheer.content.announcementsView.content">Content</div><div ng-if="data.data.content" class="description" id="fp-content-description-{{data.id}}"><span froala-view="data.data.content" ng-style="{\'color\': getContentColor()}" ng-class="getTitleHeight() > 26 ? \'line-2\' : \'line-3\'"></span></div></div><div class="action" layout="row" layout-align="end end" translate="atheer.content.announcementsView.dismiss" ng-style="{\'color\': getTitleColor()}">Dismiss</div></div></md-card-content></md-card>');
$templateCache.put('modules/content/base-card-footer-detail.tmpl.html','<div ng-if="vm.contentMetaData.enable_audiences && vm.showToolbar" layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-group"></md-icon><span flex class="md-body-2" translate="atheer.content.visibleTo">Visible To</span><md-button ng-click="vm.contentMetaData.show_audiences = !vm.contentMetaData.show_audiences" class="md-icon-button"><md-icon ng-if="!vm.contentMetaData.show_audiences" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.contentMetaData.show_audiences" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.contentMetaData.show_audiences && vm.showToolbar" class="margin-bottom-20"><fp-auto-complete no-label="true" auto-complete-model="vm.audiences" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div><md-divider ng-if="vm.contentMetaData.enable_audiences"></md-divider><div ng-if="vm.contentMetaData.enable_tags && vm.showToolbar" layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-tags"><fp-tooltip placement="bottom"><span translate="atheer.topic.externalIdTooltip"></span></fp-tooltip></md-icon><span class="md-body-2" translate="atheer.content.tags">Tags</span><md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.enterTagText"></span></fp-tooltip></md-button><span flex></span><md-button ng-click="vm.contentMetaData.show_tags = !vm.contentMetaData.show_tags" class="md-icon-button"><md-icon ng-if="!vm.contentMetaData.show_tags" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.contentMetaData.show_tags" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.contentMetaData.show_tags && vm.showToolbar" layout="row" flex><md-chips flex ng-model="vm.contentModel.tags" md-enable-chip-edit="true" md-removable="true" placeholder="{{\'atheer.content.enterTag\' | translate}}" delete-button-label="Remove Tag" delete-hint="Press delete to remove tag" secondary-placeholder="{{\'atheer.content.tag\' | translate}}"></md-chips></div><md-divider ng-if="vm.contentMetaData.enable_tags"></md-divider><div permission permission-only="atheer_features.topic.enable"><div ng-if="vm.contentMetaData.enable_topics && vm.showToolbar" layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-playlist-plus"></md-icon><span flex class="md-body-2" translate="atheer.content.topics">Topics</span><md-button ng-click="vm.contentMetaData.show_topics = !vm.contentMetaData.show_topics" class="md-icon-button"><md-icon ng-if="!vm.contentMetaData.show_topics" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.contentMetaData.show_topics" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.contentMetaData.show_topics && vm.showToolbar" class="margin-bottom-20"><fp-auto-complete no-label="true" auto-complete-model="vm.topics" component="Topic" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}]"></fp-auto-complete></div><md-divider ng-if="vm.contentMetaData.enable_topics"></md-divider></div><div ng-if="vm.contentMetaData.enable_thumbnail && vm.showToolbar" layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex translate="atheer.content.thumbnail">Thumbnail</span><md-switch name="show_thumbnail" ng-model="vm.contentModel.data.use_custom_thumbnail" aria-label="Image"></md-switch></div><div ng-if="vm.contentModel.data.use_custom_thumbnail && vm.showToolbar" layout="row" layout-align="center center"><div flex="50"><fp-upload fp-content-type="image" fp-ng-model="vm.contentModel.data.thumbnail_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div><md-divider ng-if="vm.contentMetaData.enable_audio"></md-divider><div ng-if="vm.contentMetaData.enable_audio" layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-mic-setting"></md-icon><span flex translate="atheer.content.audio">Audio</span><md-switch name="show_audio" ng-model="vm.contentModel.show_audio" aria-label="Audio"></md-switch></div><div ng-if="vm.contentModel.show_audio && vm.contentModel.audio_id == null" layout="row" layout-align="center center" class="margin-bottom-20"><md-button class="md-primary" aria-label="Record" ng-click="vm.recordAudio()" translate="entity.action.record">Record</md-button></div><div ng-if="vm.contentModel.show_audio && vm.contentModel.audio_id != null" layout="row" layout-align="center center"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'48\' + \'px\', height: \'48\' + \'px\'}"></md-icon></div><div ng-if="vm.contentModel.show_audio && vm.contentModel.audio_id != null" layout="row" layout-align="center center" class="margin-bottom-20"><md-button class="md-primary" aria-label="Record" ng-click="vm.clearAudio()" translate="entity.action.discard">Discard</md-button><md-button class="md-primary" aria-label="Record" ng-click="vm.recordAudio()" translate="entity.action.change">Change</md-button></div><md-divider></md-divider><div permission permission-only="atheer_features.content.extended_fields"><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-settings-square"></md-icon><span flex translate="atheer.topic.extendedFields">Extended Fields</span><md-button ng-click="vm.show_custom_fields = !vm.show_custom_fields" class="md-icon-button"><md-icon ng-if="!vm.show_custom_fields" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_custom_fields" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-show="vm.show_custom_fields" class="margin-bottom-20 fp-profile-event-form"><formly-form fields="vm.metaFields" form="vm.contentCustomForm" model="vm.contentModel.custom_attributes"></formly-form></div></div><md-divider></md-divider>');
$templateCache.put('modules/content/base-card-header-detail.tmpl.html','<md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" for="field_badgeNo" translate="atheer.content.contentNo">Content No</label> <input type="number" class="form-control" name="contentNo" id="field_contentNo" ng-model="vm.contentModel.content_no" required ng-disabled="true"><div ng-messages="contentDetailForm.contentNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block content-title-input"><label>{{vm.contentMetaData.title_label | translate}}</label> <input type="text" name="title" ng-model="vm.contentModel.title" md-select-on-focus required><div ng-if="contentDetailForm.title.$dirty" ng-messages="contentDetailForm.title.$error"><div ng-message="required" when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div ng-if="vm.contentMetaData.enable_media" layout="row" layout-align="space-between center" class="margin-top-10"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex>{{vm.contentMetaData.media_label | translate}}</span><md-switch name="show_media" ng-model="vm.contentModel.show_media" aria-label="Image"></md-switch></div><div layout="row" layout-align="space-around center" ng-if="vm.contentModel.show_media" class="margin-bottom-20"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.contentModel.media_id" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div><div ng-if="vm.contentMetaData.enable_title" layout="row" layout-align="space-between center"><span translate="atheer.content.showTitle">Show Title</span><md-switch name="show_title" ng-model="vm.contentModel.show_title" aria-label="Show Title"></md-switch></div><div ng-if="vm.contentMetaData.enable_description" layout="row" layout-align="space-between center"><span>{{vm.contentMetaData.description_label | translate}}</span><md-switch name="show_description" ng-model="vm.contentModel.show_description" aria-label="Description"></md-switch></div><md-input-container ng-if="vm.contentMetaData.enable_description && vm.contentModel.show_description" class="md-block"><textarea name="description" froala="vm.froalaOptions" ng-model="vm.contentModel.description"></textarea> <span class="about-error-message" ng-if="descriptionLimitExceeded" translate="entity.validation.maxlength" translate-values="{max: 255}">This field cannot be longer than 255 characters.</span></md-input-container><md-input-container class="md-block margin-bottom-40"><label>{{vm.contentMetaData.externalId_label | translate}}</label> <input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.contentModel.external_id" md-no-resize md-maxlength="100"><md-button class="fp-info-tooltip-icon md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.externalIdTooltip"></span></fp-tooltip></md-button></md-input-container>');
$templateCache.put('modules/content/base-card-view.tmpl.html','<div layout="row" layout-align="{{getMediaAlignment()}}" ng-show="showMedia() && getMediaPosition() === \'above\'" class="margin-top-20 margin-bottom-20"><div ng-if="data.media_id != null"><img ng-class="getMediaShape() === \'round\' ? \'fp-content-media-view-round-\'+getMediaSize() : \'fp-content-media-view-square-\'+getMediaSize()" ng-src="/media/images/{{data.media_id}}" id="fp-content-image-{{data.id}}"></div></div><div layout="row" layout-align="{{getTitleAlignment()}}"><span class="md-title">{{data.title}}</span><span class="asterisk" ng-show="data.data.required">*</span></div><div layout="row" layout-align="{{getMediaAlignment()}}" ng-show="showMedia() && getMediaPosition() === \'below\'" class="margin-top-20"><div ng-if="data.media_id != null"><img ng-class="getMediaShape() === \'round\' ? \'fp-content-media-view-round-\'+getMediaSize() : \'fp-content-media-view-square-\'+getMediaSize()" ng-src="/media/images/{{data.media_id}}" id="fp-content-image-{{data.id}}"></div></div><div class="margin-top-20 margin-bottom-20" ng-show="data.show_description" id="fp-content-description-{{data.id}}" froala-view="data.description"></div><div ng-style="{ \'margin-top\': getSpacerHeight(data.id)}"></div>');
$templateCache.put('modules/content/content-analytics.tmpl.html','<md-sidenav class="md-sidenav-right audience-sidenav audience-detail" md-component-id="chartPanel" md-whiteframe="4"><md-toolbar class="md-theme-indigo"><div class="md-toolbar-tools"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'chartPanel\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><h1>Insights</h1></div></md-toolbar><md-content><div layout="column" layout-margin layout-padding></div></md-content></md-sidenav>');
$templateCache.put('modules/content/content-audio-record-dialog.tmpl.html','<md-dialog ng-cloak flex="50" flex-xs="100" flex-xl="40"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.content.recordAudio">Record Audio</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content ng-if="vm.audioStatus == \'PROCESS\'" class="md-dialog-content"><div ng-if="vm.processStatus === \'PROCESSING\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50" class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.processingAudio" translate-values="{uploadPercentage: \'{{vm.uploadPercentage}}\'}">Processing Audio...{{vm.uploadPercentage}}%.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-linear md-mode="determinate" value="{{vm.uploadPercentage}}"></md-progress-linear></div></div></div></md-card></div><div ng-if="vm.processStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50" class="margin-top-100 margin-bottom-100"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-headline" translate="atheer.content.processStatus.processingAudioComplete">Processing Complete.</span></div></div></div></md-card></div><div ng-if="vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50" class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.errorProcessingAudio">Error Processing Audio. Try Again.</span></div></div></div></md-card></div></md-dialog-content><md-dialog-content ng-if="vm.audioStatus == \'RECORD\'" class="md-dialog-content"><ng-audio-recorder id="audioInput" audio-model="vm.recordedAudio" on-save-complete="vm.save()"><div ng-if="!recorder.isAvailable" translate="atheer.content.messageForUserWhileRecording">Message for users when recording is not possible.</div><div class="web-recorder-section"><div class="web-recorder-wrapper"><div class="web-recorder-centered-content"><div class="top-section"><div ng-if="!recorder.status.isPlaying && !recorder.status.isPaused" class="playback-count">{{recorder.elapsedTimeString}}</div><div ng-if="recorder.status.isPlaying || recorder.status.isPaused" class="playback-count">{{recorder.playBackTimeString}}</div></div><div class="middle-section"><div ng-click="recorder.startRecord()" ng-if="!recorder.audioModel && !recorder.status.isRecording" class="record-button"></div><div ng-click="recorder.stopRecord()" ng-if="recorder.status.isRecording" class="stop-record-button"></div><div ng-click="recorder.playbackRecording()" ng-if="recorder.audioModel && !recorder.status.isPlaying" class="play-button large"></div><div ng-click="recorder.playbackPause()" ng-if="recorder.status.isPlaying" class="pause-button large"></div></div></div></div><div layout="row" ng-if="!recorder.audioModel" layout-align="center" class="margin-top-40"></div><div layout="row" ng-if="recorder.audioModel" layout-align="center" class="margin-top-40"><md-button ng-click="recorder.discard()" layout-align="center center" class="md-primary" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="recorder.status.isPlaying" translate="entity.action.discard">Discard</md-button><md-button ng-click="recorder.save()" layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="recorder.status.isPlaying || recorder.status.isRecording || !recorder.audioModel" translate="entity.action.upload">Upload</md-button></div></div><ng-audio-recorder-analyzer ng-show="recorder.status.isRecording"></ng-audio-recorder-analyzer><!-- End controls--></ng-audio-recorder></md-dialog-content></md-dialog>');
$templateCache.put('modules/content/content-bulk-edit-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.content.contentBulkEditTitle" translate-values="{contentsLength: \'{{vm.contents.length}}\'}">Edit {{vm.contents.length}} Content(s)</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><form ng-if="vm.updateProgress == \'idle\'" name="contentBulkEditForm"><div layout="row" layout-align="space-between center" class="margin-bottom-20"><span translate="atheer.content.availableFrom">Available From</span><md-datepicker md-max-date="vm.contentBulkEditModel.discontinue_from" ng-model="vm.contentBulkEditModel.available_from" md-placeholder="{{\'atheer.content.selectDate\' | translate}}"></md-datepicker></div><div layout="row" layout-align="space-between center" class="margin-bottom-20"><span translate="atheer.content.discontinueFrom">Discontinue From</span><md-datepicker md-min-date="vm.contentBulkEditModel.available_from" ng-model="vm.contentBulkEditModel.discontinue_from" md-placeholder="{{\'atheer.content.selectDate\' | translate}}"></md-datepicker></div><div class="margin-bottom-20"><span class="md-subhead" translate="atheer.content.owner">Owner</span><div class="fp-user-chips" flex><fp-auto-complete no-label="true" auto-complete-model="vm.owner" component="User" multiple="false" query-objs="[{fieldName:\'text_search\', operator:\'=ts=\'}]"></fp-auto-complete></div></div><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-tags"></md-icon><span flex class="md-body-2" translate="atheer.content.tags">Tags</span></div><div layout="row" flex class="margin-bottom-20"><md-chips flex ng-model="vm.contentBulkEditModel.tags" md-enable-chip-edit="true" md-removable="true" placeholder="{{\'atheer.content.enterTag\' | translate}}" delete-button-label="Remove Tag" delete-hint="Press delete to remove tag" secondary-placeholder="{{\'atheer.content.tag\' | translate}}"></md-chips></div><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-playlist-plus"></md-icon><span flex class="md-body-2" translate="atheer.content.topics">Topics</span></div><div class="margin-bottom-20"><fp-auto-complete no-label="true" auto-complete-model="vm.topics" component="Topic" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}]"></fp-auto-complete></div><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-group"></md-icon><span flex class="md-body-2" translate="atheer.content.visibleTo">Visible To</span></div><div class="margin-bottom-20"><fp-auto-complete no-label="true" auto-complete-model="vm.audiences" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div></form><div ng-if="vm.updateProgress == \'started\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-subhead" translate="atheer.content.updatingContents">Updating Contents. Please wait...</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div><div ng-if="vm.updateProgress == \'complete\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon></div><div layout="row" layout-align="center" class="margin-top-20 margin-bottom-20"><span class="md-subhead" translate="atheer.content.updatedSuccessfully">Contents Updated Successfully...</span></div></div></md-dialog-content><md-dialog-actions ng-if="vm.updateProgress == \'idle\'" layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" ng-click="vm.submit()" type="submit" ng-disabled="vm.disableSubmit()" class="md-primary"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/content/content-card.tmpl.html','<md-card class="fp-content-card" ng-class="{activeContent_downArrow:feed == vm.currentFeed}" ng-init="vm.cardOver = false" ng-mouseover="feed.cardOver = true" ng-mouseleave="feed.cardOver = false" ng-if="feed"><div class="content-card-image md-card-image" ng-style="::feed.data.use_custom_thumbnail && feed.data.thumbnail_url && feed.data.thumbnail_url != null ? { \'background-image\':\'url(\'+vm.getMediaUrl(feed.data.thumbnail_url)+\')\', \'background-size\':\'cover\' } : { \'background-color\': \'\'+ vm.getDefaultBackground(feed.data.type) +\'\',\'background-image\':\'url(\'+ vm.getDefaultIcon(feed.data.type)+ \')\',\'background-position\': \'center\',\'background-repeat\':\'no-repeat\',\'background-size\': \'70px 70px\' }"><md-icon ng-click="vm.openPlayer(feed)" md-font-icon="zmdi zmdi-play-circle-outline content-play-icon" ng-if="feed.cardOver == true"></md-icon></div><div ng-click="vm.openContentDetail(feed)"><md-card-title class="action-card-title"><md-card-title-text flex="100"><div flex layout="row" layout-align="start start" class="content-card-info"><md-icon md-font-icon="{{::vm.getContentIconClass(feed.data.type)}}" aria-hidden="true"></md-icon><div class="action-card-title-text" froala-view="::feed.title" ng-bind="::feed.title" data-ellipsis></div><div flex></div></div><div class="action-card-title-subtext" layout="row" layout-sm="column"><div flex layout="row" layout-align="start center"><span><i class="fa fa-clock-o" aria-hidden="true"></i> {{::feed.data.duration}} min</span><div flex></div><span ng-if="::vm.isCompleted(feed.id)"><i class="fa fa-check-square-o margin-right-10" aria-hidden="true" ng-style="{\'color\':\'rgb(0, 230, 118)\'}"></i></span></div></div></md-card-title-text></md-card-title></div><div class="card-action-bar" ng-class="{\'card-action-bar-active\': feed == vm.currentFeed}" layout="row"><md-card-actions layout="row" flex><div flex="25" layout-align="start center" class="action-card-button" layout="row"><md-icon class="action-card-font" md-font-icon="fa fa fa-eye" ng-style="feed == vm.currentFeed && {\'color\' : \'white\'}"><span>{{::feed.stats.views}}</span></md-icon></div><div flex class="drawer_open_icon" layout-align="center center" layout="row"><md-button class="md-icon-button action-card-button" aria-label="Mark Complete" ng-click="vm.selection = indexX;vm.expandImage(feed)"><img ng-src="/assets/images/card/arrow_selected.png" ng-show="feed == vm.currentFeed"> <img ng-src="/assets/images/card/arrow_hover.png" ng-show="feed != vm.currentFeed && feed.cardOver == true"></md-button></div><div flex="25" layout-align="end center" class="action-card-button" layout="row"><md-icon class="action-card-font" md-font-icon="fa fa fa-heart" ng-style="feed == vm.currentFeed && {\'color\' : \'white\'}"><span>{{::feed.stats.reactions}}</span></md-icon></div></md-card-actions></div></md-card>');
$templateCache.put('modules/content/content-detail-footer.tmpl.html','<ng-include src="\'modules/system/admin/admin-detail-analytics.tmpl.html\'"></ng-include><ng-include src="\'modules/system/admin/admin-detail-history.tmpl.html\'"></ng-include><ng-include src="\'modules/system/admin/admin-detail-help.tmpl.html\'"></ng-include>');
$templateCache.put('modules/content/content-detail-header.tmpl.html','<div class="toolbar-default md-whiteframe-z1" ng-style="{\'margin-bottom\': \'1\' + \'px\'}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goBack()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><md-icon md-font-icon="{{vm.contentMetaData.icon}}"></md-icon><div flex="25" class="text-overflow-hidden"><span flex="25" data-ellipsis ng-bind="vm.contentModel.title"></span><fp-tooltip class="tooltip-word-break"><span ng-bind="vm.contentModel.title"></span></fp-tooltip></div><div ng-if="vm.showToolbar" layout-align="center center" flex><md-tabs ng-if="!vm.isNew()" md-center-tabs><md-tab ui-sref="storm.admin-content-detail({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.id}}\'})" md-active="true"><md-tab-label><span translate="atheer.content.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-content-detail-recognition.section({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.id}}\', section : \'qrcode\'})" ng-if="vm.id && vm.hasRecognition()"><md-tab-label><span translate="atheer.content.recognition">Recogition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-content-detail-insights.section({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.id}}\', section : \'overview\'})" ng-if="vm.id && vm.hasInsights()"><md-tab-label><span translate="atheer.content.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div layout="row" layout-align="end center"><md-button ng-if="!vm.isNew() && vm.contentMetaData.type == \'series\'" class="md-primary md-raised" ng-click="vm.previewContent()"><span translate="entity.action.preview">Preview</span></md-button><md-button ng-if="vm.downloadVideoShow" ng-disabled="downloadVideoDisalebed" class="md-icon-button" ng-click="vm.downloadOnClick()" aria-label="primary button"><md-icon md-font-icon="fa fa-download"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.anchor.download">Download</span></fp-tooltip></md-button><md-button type="submit" class="md-primary md-raised" ng-if="vm.showSaveShareButton()" ng-disabled="contentDetailForm.$invalid || vm.contentCustomForm.$invalid || descriptionLimitExceed || descriptionLimitExceeded" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><md-button ng-if="vm.contentMetaData.type != \'did-you-know\' && vm.showSaveShareButton()" class="md-icon-button" ng-click="vm.openShareDialog(content)" aria-label="primary button"><md-icon md-font-icon="fa fa-share-square"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.share">Share</span></fp-tooltip></md-button><fp-help></fp-help></div></div></div>');
$templateCache.put('modules/content/content-detail-insight-flags-summary.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center" class="margin-top-200 margin-bottom-200"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.flags.length == 0" layout-padding><div flex layout="column" layout-align="center center" class="margin-top-200 margin-bottom-200"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div><div flex ng-if="!vm.loadingData && vm.flags.length > 0"><div class="md-padding"><md-list flex class="fp-feedback-summary"><md-list-item class="md-3-line" ng-repeat="flag in vm.flags"><img ng-src="{{vm.getUserProfileImageUrl(flag.user_info.picture_id)}}" class="md-avatar" alt="{{flag.user_info.first_name}} {{flag.user_info.last_name}}"><div class="md-list-item-text" layout="column"><h3>{{flag.user_info.first_name}} {{flag.user_info.last_name}}</h3><p froala-view="flag.comment"></p><h4>Reported On {{flag.created_on | date:\'MM/dd/yyyy\'}}</h4></div><md-divider></md-divider></md-list-item></md-list><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/content/content-detail-insight-overview.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div class="overlay-5"><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0">{{vm.getCount(\'avg_time_spent\') | milisecondToTime}}</p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.content.avgTimeSpent">Avg. Time Spent</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'share\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.content.totalShares">Total Shares</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'view\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.content.totalViews">Total Views</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'reaction\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.content.totalLikes">Total Likes</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'bookmark\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.content.totalBookmarks">Total Bookmarks</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding class="fp-rating-summary"><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0"></p><div fp-rating read-only="true" rating="vm.getCount(\'avg_rating\')" color="\'orange\'" shape-type="star" max-rating="5"></div><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.content.avgRating">Avg. Rating</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0"></p><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'rating\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.content.totalRating">Total Rating</p></tri-widget></div><div layout="row" layout-margin><md-card class="fp-insights-no-data-card" flex layout-padding ng-if="!vm.overviewSummary.history.total_time_spent || vm.overviewSummary.history.total_time_spent.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.content.timeSpent">Time Spent</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/completions-overview.png"><div class="margin-top-10 main" translate="atheer.content.notEnoughActivityYet">Not Enough Activity Yet!</div></div></div></md-card><md-card layout-padding flex ng-if="vm.overviewSummary.history.total_time_spent.length > 0"><highchart id="content-time-spent-line-chart" option="vm.contentTimeSpentChartData.chart" config="vm.contentTimeSpentChartData" series="vm.contentTimeSpentChartData.series"></highchart></md-card></div><div layout="row" layout-margin><md-card class="fp-insights-no-data-card" flex layout-padding ng-if="!vm.overviewSummary.history.view || vm.overviewSummary.history.view.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.content.views">Views</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/completions-overview.png"><div class="margin-top-10 main" translate="atheer.content.notEnoughActivityYet">Not Enough Activity Yet!</div></div></div></md-card><md-card layout-padding flex ng-if="vm.overviewSummary.history.view.length > 0"><highchart id="content-views-line-chart" option="vm.contentViewsChartData.chart" config="vm.contentViewsChartData" series="vm.contentViewsChartData.series"></highchart></md-card></div></div></div>');
$templateCache.put('modules/content/content-detail-insight-problems-summary.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center" class="margin-top-200 margin-bottom-200"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.problems.length == 0" layout-padding><div flex layout="column" layout-align="center center" class="margin-top-200 margin-bottom-200"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div><div flex ng-if="!vm.loadingData && vm.problems.length > 0"><div class="md-padding"><md-list flex class="fp-feedback-summary"><md-list-item class="md-3-line" ng-repeat="problem in vm.problems"><img ng-src="{{vm.getUserProfileImageUrl(problem.user_info.picture_id)}}" class="md-avatar" alt="{{problem.user_info.first_name}} {{problem.user_info.last_name}}"><div class="md-list-item-text" layout="column"><h3>{{problem.user_info.first_name}} {{problem.user_info.last_name}}</h3><p froala-view="problem.comment"></p><h4>{{\'atheer.content.reportedOn\' | translate}} {{problem.created_on | date:\'MM/dd/yyyy\'}}</h4></div><md-divider></md-divider></md-list-item></md-list><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/content/content-detail-insight-ratings-summary.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center" class="margin-top-200 margin-bottom-200"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.ratings.length == 0" layout-padding><div flex layout="column" layout-align="center center" class="margin-top-200 margin-bottom-200"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.content.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.content.noDataYet">There\'s no data to report yet.</div></div></div><div flex ng-if="!vm.loadingData && vm.ratings.length > 0"><div class="md-padding"><md-list flex class="fp-feedback-summary"><md-list-item class="md-3-line" ng-repeat="rating in vm.ratings"><img ng-src="{{vm.getUserProfileImageUrl(rating.user_info.picture_id)}}" class="md-avatar" alt="{{rating.user_info.first_name}} {{rating.user_info.last_name}}"><div class="md-list-item-text" layout="column"><div fp-rating read-only="true" rating="rating.rating" color="\'orange\'" shape-type="star" max-rating="5"></div><p>{{rating.comment}}</p><h4>By {{rating.user_info.first_name}} {{rating.user_info.last_name}} on {{rating.created_on | date:\'MM/dd/yyyy\'}}</h4></div><md-divider></md-divider></md-list-item></md-list><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/content/content-detail-insight-user-summary.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center" class="margin-top-200 margin-bottom-200"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.assignments.length == 0" layout-padding><div flex layout="column" layout-align="center center" ng-if="vm.assignments.length == 0" class="margin-top-200 margin-bottom-200"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main">Uh!</div><div class="margin-top-10 base">There\'s no data to report yet.</div></div></div><div flex layout="column" ng-if="!vm.loadingData && vm.assignments.length > 0"><md-content flex class="md-padding" ng-if="vm.assignments.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th md-column><span>Name</span></th><th md-column><span>Assigned On</span></th><th md-column><span>Due On</span></th><th md-column><span>Completed On</span></th><th ng-if="vm.contentMetaData.meta_type != \'QUESTION\' && vm.contentMetaData.type != \'series\'" md-column><span>{{vm.contentMetaData.type}}</span></th><th ng-if="vm.contentMetaData.type == \'series\'" md-column><span>Progress</span></th><th ng-if="vm.scoringEnabled" md-column><span>Score</span></th><th ng-if="vm.scoringEnabled" md-column><span>Pass / Fail</span></th><th md-column><span>Status</span></th><th ng-if="vm.showCardSummary" md-column></th><th></th></tr></thead><tbody md-body><tr ng-repeat="assignment in vm.assignments track by assignment.id"><td md-cell>{{assignment.user_info.first_name}} {{assignment.user_info.last_name}}</td><td md-cell>{{assignment.assigned_on | date:\'MM/dd/yyyy\'}}</td><td md-cell>{{assignment.due_on | date:\'MM/dd/yyyy\'}}</td><td md-cell>{{assignment.completed_on | date:\'MM/dd/yyyy\'}}</td><td ng-if="vm.contentMetaData.meta_type != \'QUESTION\' && vm.contentMetaData.type != \'series\'" md-cell>{{assignment.time_spent | milisecondToTime}}</td><td ng-if="vm.contentMetaData.type == \'series\'" md-cell>{{assignment.progress}}%</td><td ng-if="vm.scoringEnabled" md-cell>{{assignment.points}}</td><td ng-if="vm.scoringEnabled" md-cell>{{assignment.pass}}</td><td md-cell>{{assignment.status}}</td><td ng-if="vm.showCardSummary" class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.launchUserCardSummary(assignment.user_info.id)"><md-icon class="zmdi zmdi-eye icon-size"></md-icon></md-button></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteObject(assignment)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon>Delete</md-button></md-menu-item><md-menu-item ng-if="assignment.status != \'COMPLETED\'"><md-button aria-label="primary button" ng-click="vm.markComplete(assignment)"><md-icon class="zmdi zmdi-assignment-check icon-size"></md-icon>Mark Complete</md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.assignments.length > 0"></md-table-pagination></div>');
$templateCache.put('modules/content/content-detail-insights.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout-fill layout="column" flex><div class="toolbar-default md-whiteframe-z1" ng-style="{\'margin-bottom\': \'10\' + \'px\'}"><div class="md-toolbar-tools md-accent"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.handleBackClick()"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><md-icon md-font-icon="{{vm.contentMetaData.icon}}"></md-icon><span>{{vm.contentModel.title}}</span><div flex><md-tabs md-center-tabs><md-tab ui-sref="storm.admin-content-detail({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\' , activeTab:\'MAIN\'})" ng-if="vm.contentModel.data.type !== \'smart_content\'"><md-tab-label><span translate="atheer.content.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-content-detail-recognition.section({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\', section : \'qrcode\'})" ng-if="vm.hasRecognition()"><md-tab-label><span translate="atheer.content.recognition">Regogition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-content-detail-insights.section({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\', section : \'overview\'})" md-active="true"><md-tab-label><span translate="atheer.content.insights">Insights</span></md-tab-label></md-tab></md-tabs></div></div></div><div flex layout="column"><md-tabs class="padding-left-10" md-center-tabs="true"><md-tab ui-sref="storm.admin-content-detail-insights.section({section:\'{{sectionKey}}\'})" ng-repeat="(sectionKey, section) in vm.insightSections"><md-tab-label><span>{{section.label | translate}}</span></md-tab-label></md-tab></md-tabs><div flex layout="column" ui-view></div></div></div>');
$templateCache.put('modules/content/content-detail-recognition-qrcode.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="row" layout-fill flex layout-align="center center"><div layout="column" layout-align="center center"><h4 hide-xs flex><span translate="atheer.content.useQrCode">Use this QR Code to scan on Atheer Lens</span></h4><div class="margin-top-20"><img ng-src="{{vm.qrCodeImage}}" border="0" width="400"></div><div ng-if="vm.showActions" layout="row"><md-button type="submit" class="md-primary md-raised" ng-click="vm.printQR()"><span translate="atheer.content.print">Print</span></md-button><md-button type="submit" class="md-primary md-raised" ng-click="vm.downloadQR()"><span translate="atheer.content.download">Download</span></md-button></div></div></div>');
$templateCache.put('modules/content/content-detail-recognition.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout-fill layout="column" flex><div class="toolbar-default md-whiteframe-z1" ng-style="{\'margin-bottom\': \'10\' + \'px\'}"><div class="md-toolbar-tools md-accent"><md-button ui-sref="storm.admin-contents" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><md-icon md-font-icon="{{vm.contentMetaData.icon}}"></md-icon><span>{{vm.contentModel.title}}</span><div flex><md-tabs md-center-tabs><md-tab ui-sref="storm.admin-content-detail({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\' , activeTab:\'MAIN\'})" ng-if="vm.contentModel.data.type !== \'smart_content\'"><md-tab-label><span translate="atheer.content.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-content-detail-recognition.section({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\', section : \'qrcode\'})" md-active="true"><md-tab-label><span translate="atheer.content.recognition">Regogition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-content-detail-insights.section({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\', section : \'overview\'})" ng-if="vm.hasInsights()"><md-tab-label><span translate="atheer.content.insights">Insights</span></md-tab-label></md-tab></md-tabs></div></div></div><div flex layout="column"><md-tabs class="padding-left-10" md-center-tabs="true"><md-tab ui-sref="storm.admin-content-detail-recognition.section({section:\'{{sectionKey}}\'})" ng-repeat="(sectionKey, section) in vm.insightSections"><md-tab-label><span>{{section.label | translate}}</span></md-tab-label></md-tab></md-tabs><div flex layout="column" ui-view></div></div></div>');
$templateCache.put('modules/content/content-feed-item.tmpl.html','<div layout="row" class="content-data" ng-click="launchContent(content)"><md-icon ng-repeat="metaData in contentMetaData" md-font-icon="{{metaData.icon}}" ng-if="content.data.type == metaData.type && metaData.type !== \'zip\'" class="content-icon"></md-icon><md-icon ng-repeat="metaData in contentMetaData" md-svg-src="{{metaData.icon}}" ng-if="content.data.type == metaData.type && metaData.type === \'zip\'" class="content-icon-zip"></md-icon><div ng-if="messageView == \'false\'" layout-align="start center" class="content-thumbnail" ng-class="{\'default\' : !content.data.use_custom_thumbnail}" ng-style="content.data.use_custom_thumbnail ? { \'background-image\':\'url(\'+getMediaUrl(content.data.thumbnail_url)+\')\' } : { \'background-color\': \'\'+ getDefaultBackground(content.data.type) +\'\',\'background-image\':\'url(\'+ getDefaultIcon(content.data.type)+ \')\',\'background-position\': \'center\',\'background-repeat\':\'no-repeat\'}"><md-icon ng-click="launchContent(content)" md-font-icon="zmdi zmdi-play-circle-outline content-play-icon"></md-icon></div><div flex layout="column" class="content-detail-container margin-left-10"><div flex layout="row" layout-align="start center"><span ng-if="messageView == \'true\'" ng-class="{\'session-content-message\' : type == \'SESSION_CONVERSATION\'}" style="padding-right:10px" data-ellipsis>{{content.title}}</span><md-progress-circular ng-if="content.loading" class="md-primary" ng-class="{\'md-accent\': publisher == userId }" md-diameter="20px"></md-progress-circular></div><span ng-if="messageView == \'false\'" class="md-title" data-ellipsis>{{content.title}}</span><div flex ng-show="showDescription == \'true\'" class="description" data-ellipsis ng-bind-html="content.description"></div><div flex ng-show="showDuration == \'true\'" layout="row" layout-align="center center" class="content-bottom-container"><div><i class="fa fa-clock-o" aria-hidden="true"></i> <span translate="global.contentDuration" translate-values="{contentDuration: \'{{::content.data.duration}}\'}">{{::content.data.duration}} min</span></div><div flex></div></div></div></div>');
$templateCache.put('modules/content/content-feed-list.tmpl.html','<div class="contents-data" layout-padding><md-table-container flex ng-if="contents.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column md-order-by="title"><span translate="atheer.content.title">Title</span></th><th md-column md-order-by="created_on"><span translate="atheer.content.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="content in contents track by $index" md-row><td md-cell><div><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();launchContent(content)"><md-icon md-font-icon="{{getCardMeta(content).icon}}"><fp-tooltip>{{getCardMeta(content).label | translate}}</fp-tooltip></md-icon></md-button>{{content.title}}</div></td><td md-cell am-time-ago="content.created_on"></td></tr></tbody></table></md-table-container></div>');
$templateCache.put('modules/content/content-feedback-dialog.tmpl.html','<md-dialog aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span ng-if="vm.type==\'FLAG\'" flex translate="atheer.content.reportContent">Report Inappropriate Content</span> <span ng-if="vm.type==\'PROBLEM\'" flex translate="atheer.content.reportProblem">Report a Problem</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div><span ng-if="vm.type==\'FLAG\'" flex translate="atheer.content.tellUsWhyThisContent">Tell us why this content is inappropriate </span><span ng-if="vm.type==\'PROBLEM\'" flex translate="atheer.content.tellUsProblem">Tell us the problem you\'re having</span></div><form name="contentFeedbackForm"><md-input-container class="md-block"><textarea name="comment" froala ng-model="vm.contentFeedbackModel.comment"></textarea></md-input-container></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="contentFeedbackForm.$invalid" class="md-primary"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/content/content-menu.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex layout="column" layout-fill><div flex layout="column" class="fp-folder-builder"><div layout="column" class="margin-top-30 padding-left-20 padding-right-20"><md-input-container class="margin-bottom-20"><label translate="atheer.content.contentType">Content Type</label><md-select ng-model="vm.filters.metaType" ng-change="vm.updateFilters()"><md-option value="all" translate="atheer.content.all">All</md-option><md-option ng-repeat="item in vm.createMenuOptions" value="meta_type=={{item.meta_type}}{{(item.meta_type == \'DISCOVERABLE\' ? \';type==\' + vm.convertTypeForBackend(item.type).toUpperCase() : \'\')}}" permission permission-only="item.feature_name">{{item.label | translate}}</md-option></md-select></md-input-container></div><div layout="column" class="padding-left-20 padding-right-20"><md-input-container class="md-block"><md-checkbox ng-model="vm.filters.disabled" aria-label="Disabled" ng-change="vm.updateFilters()"><span translate="atheer.content.disabled">Disabled</span></md-checkbox></md-input-container></div><div layout="column"><md-divider></md-divider><span class="md-body-1 margin-top-20 margin-bottom-10 padding-left-20">Topics</span><treecontrol class="tree-classic" tree-model="vm.topics" on-selection="vm.topicSelected(node, selected)" on-node-toggle="vm.fetchChildNodes(node, expanded)" options="vm.treeOptions" on-selection="vm.showSelected(node)" selected-node="vm.selectedNode">{{node.name}}</treecontrol></div></div></div>');
$templateCache.put('modules/content/content-message.tmpl.html','<div class="contents-data" ng-class="{\'embeded\' : embedMode}"><div ng-repeat="content in contents | limitTo:limitToIndex track by $index"><div layout="row" layout-padding class="content-data"><div layout-align="start center" class="content-message-thumbnail" ng-class="{\'default\' : !content.data.use_custom_thumbnail}" ng-style="content.data.use_custom_thumbnail ? { \'background-image\':\'url(\'+getMediaUrl(content.data.thumbnail_url)+\')\' } : {} "><div ng-if="!content.data.use_custom_thumbnail"><md-icon ng-click="launchContent(content)" md-font-icon="{{getDefaultIcon(content.data.type)}}" class="content-icon"></md-icon></div><div ng-if="content.data.type != \'series\' && content.data.use_custom_thumbnail"><md-icon ng-click="launchContent(content)" md-font-icon="zmdi zmdi-play-circle-outline content-play-icon"></md-icon></div><div ng-if="content.data.type == \'series\' && content.data.use_custom_thumbnail"><md-icon ng-click="openContentDetail(content)" md-font-icon="zmdi zmdi-play-circle-outline content-play-icon"></md-icon></div></div><div flex layout="column" ng-class="{\'content-detail-container\': content.data.use_custom_thumbnail}"><div flex layout="row"><div ng-click="openContentDetail(content)" class="md-title-1 content-title" data-ellipsis ng-bind-html="content.title"></div><div flex></div></div></div></div><md-divider ng-if="$index != limitToIndex-1"></md-divider></div><div layout="row" layout-align="center center" ng-if="loadMoreEnabled"><md-button ng-click="loadMore()" ng-if="limitToIndex !== contents.length" class="md-primary" translate="entity.action.loadMore">Load More</md-button></div></div>');
$templateCache.put('modules/content/content-metadata.tmpl.html','<div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-toolbar ng-if="!vm.loadingData" class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.back()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span translate="atheer.contentFields.title">Content Fields</span> <span flex></span><fp-help></fp-help></div></md-toolbar><div flex layout="row" ng-if="!vm.loadingData"><div flex="25" layout="column" class="fp-field-group-detail"><md-list><md-list-item ng-repeat="fieldGroup in vm.metaDataObject.field_groups track by $index" ng-click="vm.selectFieldGroup(fieldGroup, $index)" ng-show="fieldGroup.locked == false || fieldGroup.name == \'base\'" ng-class="{\'fp-field-group-active\': vm.selectedFieldGroup == fieldGroup}"><div layout="row"><h4 flex>{{fieldGroup.name == \'base\' ? \'atheer.contentFields.title\' : (fieldGroup.is_many ? fieldGroup.plural_label : fieldGroup.label) | translate }}</h4><md-menu ng-if="fieldGroup == vm.selectedFieldGroup && fieldGroup.name != \'base\'" class="md-secondary"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.editFieldGroup(fieldGroup, $index)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><span translate="entity.action.edit">Edit</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteFieldGroup(fieldGroup, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-divider></md-divider></md-list-item></md-list></div><div flex="75" layout="row" ng-if="!vm.metaDataObject.field_groups || vm.metaDataObject.field_groups.length <= 0" layout-align="center center"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.contentFields.addFieldGroup">Please add Field Group to add Fields to it.</span></div></div><div flex="75" ng-if="vm.selectedFieldGroup" flex layout="column"><div md-theme="{{triSkin.elements.toolbar}}" class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span>{{vm.selectedFieldGroup.name == \'base\' ? \'\' : vm.selectedFieldGroup.label}} {{vm.selectedFieldGroup.name == \'base\' ? \'atheer.contentFields.fields\' : \'atheer.contentFields.fields\' | translate}}</span> <span flex></span><md-button class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.contentFields.addField">Add Field</span></fp-tooltip></md-button></div></div><md-content flex class="md-padding"><div ng-if="!vm.selectedFieldGroup.fields || vm.selectedFieldGroup.fields.length <= 0" layout-align="center center" layout="column"><div flex class="margin-left-20 margin-top-200"><span class="md-title" translate="atheer.contentFields.noFields">No Fields.</span></div></div><div ng-if="vm.selectedFieldGroup.fields && vm.selectedFieldGroup.fields.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row><th md-column><span translate="atheer.contentFields.label">Label</span></th><th md-column><span translate="atheer.contentFields.name">Name</span></th><th md-column><span translate="atheer.contentFields.type">Type</span></th><th></th></tr></thead><tbody md-body dragula=\'"user-group-fields"\' dragula-model="vm.selectedFieldGroup.fields"><tr ng-repeat="field in vm.selectedFieldGroup.fields track by $index"><td md-cell>{{field.label}}</td><td md-cell>{{field.name}}</td><td md-cell>{{field.data_type}}</td><td class="text-right"><md-icon ng-if="field.locked" md-font-icon="zmdi zmdi-lock" class="margin-right-10"></md-icon><md-button ng-if="!field.locked" class="md-icon-button" aria-label="primary button" ng-click="vm.editField(field, $index)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu ng-if="!field.locked"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.copyField(field, $index)"><md-icon class="zmdi zmdi-copy icon-size"></md-icon><span translate="entity.action.copy">Copy</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteField(field, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></div></md-content></div></div>');
$templateCache.put('modules/content/content-picker.html','<md-dialog flex="90" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="autoComplete.contentPicker.title">Select Content</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container class="search-input-theme" ng-style="{ \'color\': secondaryColor }" ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button layout-align="center center" ng-if="vm.contents.length > 0" class="md-raised select-button" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedCards.length <= 0" translate="entity.action.select">Select</md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content ng-if="vm.loadingData" flex class="md-dialog-content margin-top-100 margin-bottom-100"><wave-spinner></wave-spinner></md-dialog-content><md-dialog-content ng-if="!vm.loadingData" class="md-dialog-content" flex><div flex layout="row"><div ng-if="vm.showFolders" flex="20" layout="column"><md-toolbar md-theme="{{triSkin.elements.toolbar}}" class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span translate="autoComplete.contentPicker.folders">Folders</span> <span flex></span></div></md-toolbar><div flex layout="column" class="md-whiteframe-z1"><div ng-if="vm.folders.length <= 0" layout-align="center center" layout="column"><div flex class="margin-left-20 margin-top-200"><span class="md-subhead" translate="autoComplete.contentPicker.noFolders">No Folders</span></div></div><md-content ng-if="vm.folders.length > 0" flex><md-list><md-list-item ng-repeat="folder in vm.folders track by $index " ng-click="vm.selectFolder(folder)" ng-class="{\'fp-field-group-active\': vm.selectedFolder == folder}"><div layout="row"><md-icon md-font-icon="zmdi zmdi-folder-outline"></md-icon><h5 flex>{{folder.name | truncate:true:20:\' ...\'}}</h5></div><md-divider></md-divider></md-list-item></md-list></md-content></div></div><div ng-if="vm.contents.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="autoComplete.uh">Uh!</div><div class="margin-top-10 base">{{\'autoComplete.contentPicker.thereIsNo\' | translate}} <span translate="{{vm.pageTitleKey | lowercase}}"></span> {{\'autoComplete.contentPicker.yet\' | translate}}</div></div><div class="md-padding" flex ng-if="vm.contents.length > 0" class="md-whiteframe-z1"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedCards" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="autoComplete.contentPicker.table.type">Type</span></th><th md-column md-order-by="title"><span translate="autoComplete.contentPicker.table.title">Title</span></th><th md-column><span translate="autoComplete.contentPicker.table.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="content in vm.contents track by content.id" md-row md-select="content" md-select-id="id" md-auto-select><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.launchContentPreview(content)"><md-icon md-font-icon="{{vm.getCardMeta(content).icon}}"><fp-tooltip>{{vm.getCardMeta(content).label}}</fp-tooltip></md-icon></md-button></td><td md-cell>{{content.title}}</td><td md-cell am-time-ago="content.created_on"></td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/content/content-player.tmpl.html','<md-dialog class="fp-content-player-dialog"><div layout="row" class="margin-top-10"><div flex></div><md-button class="md-icon-button toolbar-button" ng-click="toggleFullScreen()" aria-label="toggle fullscreen"><md-icon class="zmdi-hc-2x white-font" ng-class="fullScreenIcon"></md-icon></md-button><md-button class="md-icon-button" ng-click="close()"><md-icon class="zmdi zmdi-close zmdi-hc-2x white-font"></md-icon></md-button></div><md-dialog-content layout="row" flex><div flex="5" layout-align="start start"></div><div ng-if="!loadingData" flex layout="row"><div flex class="fp-content-player" layout="row"><fp-content-view mode="mode" context="contentData.data.type" done-call-back="finishCallBack()" current-response-data="responseData" assignment-id="assignmentId" data="contentData" content-type="{{contentData.data.type}}"></fp-content-view></div></div><div flex="5" layout-align="start start"></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/content/content-preview.tmpl.html','<div layout-fill layout="row" layout-align="center center" layout-padding class="fp-content-preview-mode"><div flex class="fp-content-preview"><fp-content-view mode="\'preview\'" context="vm.contentModel.data.type" data="vm.contentModel" content-type="{{vm.contentModel.data.type}}" layout-fill></fp-content-view></div></div>');
$templateCache.put('modules/content/content-rating.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding layout-align="center center"><div class="md-title">Please provide feedback for the content</div><div layout="row" layout-align="center center"><div layout="column"><div fp-rating rating="ratingFeedback.rating" color="\'orange\'" shape-type="star" max-rating="5"></div><div flex layout="row" layout-align="space-between center"><md-input-container flex class="md-block"><textarea ng-model="ratingFeedback.comment" class="form-control" rows="4" cols="40" name="msg" placeholder="{{\'atheer.content.comments\' | translate}}"></textarea></md-input-container></div></div></div><div flex layout="row" layout-align="center end" class="margin-bottom-100"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="submitContentRatingForm()" translate="entity.action.submit">Submit</md-button><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="notNowAction()" translate="entity.action.notNow">Not Now</md-button></div></md-bottom-sheet>');
$templateCache.put('modules/content/content-scheduling.tmpl.html','<div ng-if="vm.contentMetaData.enable_scheduling && vm.showToolbar" layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-clock-o"></md-icon><span flex class="md-body-2" translate="atheer.content.scheduling">Scheduling</span><md-button ng-click="vm.contentMetaData.show_scheduling = !vm.contentMetaData.show_scheduling" class="md-icon-button"><md-icon ng-if="!vm.contentMetaData.show_scheduling" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.contentMetaData.show_scheduling" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.contentMetaData.show_scheduling && vm.showToolbar" class="margin-bottom-20"><div layout="row" layout-align="space-between center"><span translate="atheer.content.availableFrom">Available From</span><md-datepicker md-max-date="vm.contentModel.data.discontinue_from" ng-model="vm.contentModel.data.available_from" md-placeholder="{{\'atheer.content.selectDate\' | translate}}"></md-datepicker></div><div layout="row" layout-align="space-between center"><span translate="atheer.content.discontinueFrom">Discontinue From</span><md-datepicker md-min-date="vm.contentModel.data.available_from" ng-model="vm.contentModel.data.discontinue_from" md-placeholder="{{\'atheer.content.selectDate\' | translate}}"></md-datepicker></div></div>');
$templateCache.put('modules/content/content-selector-dialog.tmpl.html','<md-dialog flex="60" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex ng-if="vm.action != \'Ask\'">{{vm.action}} Content(s)</span> <span flex ng-if="vm.action == \'Ask\'">Ask Question(s)</span></div></md-toolbar><md-dialog-content class="md-dialog-content"><div flex ng-form="settingForm" layout="column" class="fp-content-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'}, {fieldName:\'meta_type\', operator:\'=in=\', value:\'(DISCOVERABLE,TASK_LIST,TASK)\'}]" auto-complete-model="vm.data.contents" component="Content" multiple="true" ng-if="vm.action == \'Assign\' || vm.action == \'Recommend\'"></fp-auto-complete><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'}, {fieldName:\'meta_type\', operator:\'=in=\', value:\'(QUESTION)\'}]" auto-complete-model="vm.data.contents" component="Content" multiple="true" ng-if="vm.action == \'Ask\'"></fp-auto-complete><div layout="row" layout-align="space-between center" ng-if="vm.action != \'Recommend\'"><span>Is required?</span><md-switch name="required" ng-model="vm.contentAssignModel.required"></md-switch></div><div ng-if="vm.contentAssignModel.required" layout="row" layout-align="start center"><span>When would you like to get this completed?</span></div><div ng-if="vm.contentAssignModel.required"><md-radio-group layout="column" ng-model="vm.contentAssignModel.is_due_date_relative" class="margin-top-20"><div flex layout="row"><div layout-align="start center" layout="row"><md-radio-button value="true" class="md-primary">Complete In</md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.contentAssignModel.is_due_date_relative == \'true\'"><md-input-container layout-align="center center" layout="row"><label>Period</label><md-select ng-model="vm.contentAssignModel.relative_period"><md-option value="DAYS">Days</md-option><md-option value="WEEKS">Weeks</md-option></md-select></md-input-container><md-input-container layout-align="center center" layout="row"><label>Value</label> <input type="number" step="1" ng-model="vm.contentAssignModel.relative_value"></md-input-container></div></div><div flex layout="row" layout-align="start center"><div layout-align="start center" layout="row"><md-radio-button value="false" class="md-primary">Fixed Date</md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.contentAssignModel.is_due_date_relative == \'false\'"><md-datepicker ng-model="vm.contentAssignModel.due_on" md-placeholder="Select date"></md-datepicker></div></div></md-radio-group></div><div><div class="margin-top-20"><span flex>Add a note on why you are {{vm.action == \'Recommend\' ? "recommending" : "assigning"}} this</span></div><md-input-container class="md-block"><textarea name="note" froala ng-model="vm.contentAssignModel.note"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span>Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid" class="md-primary"><span>{{vm.action}}</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/content/content-settings-footer.tmpl.html','<div ng-if="vm.contentMetaData.show_settings" layout="row" layout-align="space-between center"><span translate="atheer.content.enabled">Enabled</span><md-switch name="enabled" ng-model="vm.contentModel.enabled"></md-switch></div><div ng-if="vm.contentMetaData.show_settings && vm.contentMetaData.enable_required && vm.contentModel.embedded" layout="row" layout-align="space-between center"><span translate="atheer.content.required">Required</span><md-switch name="featured" ng-model="vm.contentModel.data.required"></md-switch></div><div ng-if="vm.contentMetaData.show_settings && vm.contentMetaData.enable_request_rating && vm.showToolbar" layout="row" layout-align="space-between center"><span translate="atheer.content.requestRatingAndFeedback">Request Rating and Feedback</span><md-switch name="request_rating" ng-model="vm.contentModel.data.request_rating"></md-switch></div><div ng-if="vm.contentMetaData.show_settings && vm.contentMetaData.enable_duration" flex layout="column"><span translate="atheer.content.duration">Duration (in Mins.)</span><div flex layout="row"><md-slider-container flex><md-slider flex min="1" max="100" ng-model="vm.contentModel.data.duration" md-discrete aria-label="Duration"></md-slider><md-input-container><input flex type="number" name="duration" id="field_duration" ng-model="vm.contentModel.data.duration" aria-label="Duration" min="1" max="100" md-select-on-focus required></md-input-container></md-slider-container></div></div><div ng-if="vm.contentMetaData.show_settings && vm.showToolbar && vm.allowContentOwner" layout="column"><span class="md-subhead" translate="atheer.content.owner">Owner</span><div flex><fp-auto-complete no-label="true" auto-complete-model="vm.owner" component="Team" multiple="false" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div></div><div ng-if="vm.contentMetaData.show_settings && vm.contentMetaData.type == \'course\'"><md-input-container class="md-block margin-top-20"><label for="launch_mode" translate="atheer.content.launchMode">Launch Mode</label><md-select name="launch_mode" ng-model="vm.contentModel.data.launch_mode" id="launch_mode" required><md-option value="MODAL_WINDOW" translate="atheer.content.launchModeOptions.modalWindow">MODAL WINDOW</md-option><md-option value="NEW_WINDOW" translate="atheer.content.launchModeOptions.newWindow">NEW WINDOW</md-option><md-option value="SAME_WINDOW" translate="atheer.content.launchModeOptions.sameWindow">SAME WINDOW</md-option></md-select><div ng-messages="contentDetailForm.launch_mode.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="vm.contentMetaData.show_settings && vm.contentMetaData.enable_level" layout="row" layout-align="space-between center"><span translate="atheer.content.level">Level</span><md-select ng-model="vm.contentModel.data.level" class="md-no-underline"><md-option value="BEGINNER" translate="atheer.content.levelOptions.beginner">Beginner</md-option><md-option value="INTERMIDIATE" translate="atheer.content.levelOptions.intermidiate">Intermidiate</md-option><md-option value="ADVANCED" translate="atheer.content.levelOptions.advanced">Advanced</md-option><md-option value="EXPERT" translate="atheer.content.levelOptions.expert">Expert</md-option><md-option value="ALL" translate="atheer.content.levelOptions.all">All</md-option></md-select></div><md-divider></md-divider>');
$templateCache.put('modules/content/content-settings-header.tmpl.html','<md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-sliders"></md-icon><span flex translate="atheer.content.settings">Settings</span><md-button ng-click="vm.contentMetaData.show_settings = !vm.contentMetaData.show_settings" class="md-icon-button"><fp-tooltip><span translate="atheer.content.seeMore">See More</span></fp-tooltip><md-icon ng-show="!vm.contentMetaData.show_settings" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-show="vm.contentMetaData.show_settings" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div>');
$templateCache.put('modules/content/content-share-dialog.tmpl.html','<md-dialog flex="50" flex-xs="100" flex-md="50" flex-lg="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.content.contentShareTitle" translate-values="{contentsLength: \'{{vm.contents.length}}\'}">Share {{vm.contents.length}} Content(s)</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><form ng-if="vm.shareProgress == \'idle\'" name="contentShareForm" ng-submit="vm.performContentFeedback(vm.audience.id)"><div layout="column"><span class="md-subhead" translate="atheer.content.users">Users</span><div class="fp-user-chips" flex><fp-auto-complete no-label="true" auto-complete-model="vm.asyncUsers" component="User" multiple="true"></fp-auto-complete></div><span class="md-subhead margin-top-20" translate="atheer.content.teams">Teams</span><div class="fp-user-chips" flex><fp-auto-complete no-label="true" auto-complete-model="vm.asyncTeams" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div></div><div class="margin-top-20"><span flex translate="atheer.content.addANote">Add a note on why you are sharing this</span></div><md-input-container class="md-block"><textarea name="note" froala="vm.froalaOptions" ng-model="vm.contentShareModel.note"></textarea></md-input-container></form><div ng-if="vm.shareProgress == \'started\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-subhead" translate="atheer.content.sharing">Sharing. Please wait...</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div><div ng-if="vm.shareProgress == \'complete\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon></div><div layout="row" layout-align="center" class="margin-top-20 margin-bottom-20"><span class="md-subhead" translate="atheer.content.sharedSuccessfully" translate-values="{shareSuccess: \'{{vm.shareSuccess}}\'}">Successfully shared with {{vm.shareSuccess}} Users...</span></div></div></md-dialog-content><md-dialog-actions ng-if="vm.shareProgress == \'idle\'" layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" ng-click="vm.submit()" type="submit" ng-disabled="vm.disableSubmit()"><span translate="entity.action.share">Share</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/content/content-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div ng-if="vm.currentSelectedCards.length == 0" class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="atheer.content.homeTitle">Content</span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.content.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.search">Search</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.refresh">Refresh</span></fp-tooltip></md-button><md-menu md-offset="0 60" permission permission-only="vm.permissions.create" ng-if="vm.createMenu && !vm.isPickerView"><md-button class="md-accent md-raised" ng-click="$mdMenu.open()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><md-menu-content width="4"><md-menu-item ng-repeat="item in vm.createMenuOptions" permission permission-only="item.feature_name"><md-button ng-click="$mdCloseMenu;vm.selectMenu(item)"><md-icon md-font-icon="{{item.icon}}"></md-icon>{{item.label | translate}}</md-button></md-menu-item></md-menu-content></md-menu><div permission permission-only="atheer_features.content.extended_fields"><md-button class="md-icon-button" aria-label="primary button" ui-sref="storm.admin-content-fields"><md-icon md-font-icon="zmdi zmdi-settings"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.contentFields.title">Content Fields</span></fp-tooltip></md-button></div><fp-help key="content-list-guide"></fp-help></div><div ng-if="vm.currentSelectedCards.length > 0" class="md-toolbar-tools md-accent fp-admin-toolbar"><h2><span translate="atheer.content.itemsSelected" translate-values="{currentSelectedCardsLength: \'{{vm.currentSelectedCards.length}}\'}">{{vm.currentSelectedCards.length}} items selected</span></h2><md-button class="md-icon-button" ng-click="vm.clearSelection()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.clearSelection">Clear Selection</span></fp-tooltip></md-button><span flex></span><div ng-if="vm.showBulkAssignAction && !vm.showBulkSendAction"><md-button class="md-icon-button" ng-click="vm.openBulkShareDialog()" aria-label="primary button"><md-icon md-font-icon="fa fa-share-square"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.share">Share</span></fp-tooltip></md-button></div><div ng-if="vm.showBulkSendAction && !vm.showBulkAssignAction"><md-button class="md-icon-button" ng-click="vm.openBulkSendDialog()" aria-label="primary button"><md-icon md-font-icon="fa fa-send"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.send">Send</span></fp-tooltip></md-button></div><fp-help key="content-list-guide"></fp-help></div></md-toolbar>');
$templateCache.put('modules/content/content.html','<div flex layout="row" layout-fill><div flex layout="column"><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="row"><div ng-if="!vm.loadingData && vm.contents.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-table-container flex ng-if="!vm.loadingData && vm.contents.length > 0"><table multiple="true" md-row-select="true" ng-model="vm.currentSelectedCards" md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="title"><span class="content-title-label" translate="atheer.content.title">Title</span></th><th md-column md-order-by="created_on"><span translate="atheer.content.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="content in vm.contents track by content.id" md-row md-select="content" md-select-id="id"><td md-cell><div class="content-title"><md-button class="md-icon-button content-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.launchContentPreview(content)"><md-icon md-font-icon="{{vm.getCardMeta(content).icon}}"><fp-tooltip>{{vm.getCardMeta(content).label | translate}}</fp-tooltip></md-icon></md-button><span class="content-title-text">{{content.title}}</span></div></td><td md-cell am-time-ago="content.created_on"></td><td class="text-right"><div class="btn-group flex-btn-group-container" ng-if="vm.currentSelectedCards.length == 0"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.editObject(content.id, content.data.type)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><fp-tooltip><span translate="atheer.content.edit">Edit</span></fp-tooltip></md-button><md-button ng-if="vm.allowInsights(content)" permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.seeInsights(content.id, content.data.type)"><md-icon class="zmdi zmdi-chart icon-size"></md-icon><fp-tooltip><span translate="atheer.content.seeInsights">See Insights</span></fp-tooltip></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$event.stopPropagation();$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.create"><md-button aria-label="primary button" ng-click="$event.stopPropagation();vm.copyContent(content.id,content.data.type)"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><span translate="entity.action.copy">Copy</span></md-button></md-menu-item><md-menu-item ng-if="vm.showAskAction(content)"><md-button aria-label="primary button" ng-click="vm.openAssignModal(content.id,content.data.type)"><md-icon md-font-icon="zmdi zmdi-assignment"></md-icon><span translate="entity.action.ask">Ask</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.archiveObject(content)"><md-icon md-font-icon="zmdi zmdi-archive"></md-icon><span translate="entity.action.archive">Archive</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.contents.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/content/did-you-know-detail.tmpl.html','<div flex ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div class="fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><div layout="row" layout-align="start center"><span translate>{{vm.contentMetaData.description_label}}</span></div><textarea name="description" froala="vm.froalaOptions" ng-model="vm.contentModel.data.content"></textarea> <span class="about-error-message" ng-if="descriptionLimitExceed" translate="entity.validation.maxlength" translate-values="{max: 255}">This field cannot be longer than 255 characters.</span><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include><div flex layout="column"><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-brush"></md-icon><span flex translate="atheer.content.designOptions">Design Options</span><md-button ng-click="vm.contentMetaData.show_layout = !vm.contentMetaData.show_layout" class="md-icon-button"><md-icon ng-show="!vm.contentMetaData.show_layout" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-show="vm.contentMetaData.show_layout" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.contentMetaData.show_layout" layout="row" layout-align="space-between center"><span translate="atheer.content.displayTitle" translate-values="{colorOptions: \'{{vm.colorOptions}}\'}">Display Title {{vm.colorOptions}}</span><md-switch name="enabled" ng-model="vm.contentModel.data.show_title"></md-switch></div><div ng-if="vm.contentMetaData.show_layout && vm.contentModel.data.show_title" flex layout="row" layout-align="space-between center" ng-cloak><div flex md-color-picker ng-model="vm.contentModel.data.title_color" label="Title Text color" md-color-alpha-channel="false" md-color-sliders="false" md-color-rgb="false" md-color-hsl="false" md-color-history="false"></div></div><div ng-if="vm.contentMetaData.show_layout" layout="row" layout-align="space-between center"><span translate="atheer.content.displayContent">Display Content</span><md-switch name="featured" ng-model="vm.contentModel.data.show_content"></md-switch></div><div ng-if="vm.contentMetaData.show_layout && vm.contentModel.data.show_content" flex layout="row" layout-align="space-between center" ng-cloak><div flex md-color-picker ng-model="vm.contentModel.data.content_color" label="Content Text color" md-color-alpha-channel="false" md-color-sliders="false" md-color-history="false"></div></div><md-divider></md-divider></div></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/did-you-know-preview.tmpl.html\'"></ng-include></div></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include></div>');
$templateCache.put('modules/content/did-you-know-preview.tmpl.html','<div layout-fill layout="row" layout-align="center center" layout-padding class="fp-content-preview-mode"><div flex class="fp-did-you-know-preview"><fp-content-view mode="\'preview\'" context="vm.contentModel.data.type" data="vm.contentModel" content-type="{{vm.contentModel.data.type}}" layout-fill></fp-content-view></div></div>');
$templateCache.put('modules/content/did-you-know-view.tmpl.html','<md-card class="fp-content-didyouknow-view"><md-card-content layout="row"><div layout="column" class="left-side-container"><img ng-src="{{getImageSrc()}}"></div><div layout="column" class="right-side-container"><div ng-if="data.data.show_title"><div class="title" ng-style="{\'color\': getTitleColor()}"><span translate="{{data.title}}"></span></div></div><div ng-if="data.data.show_content" style="height: 100%; padding: 10px 0px;"><div class="description" ng-if="!data.data.content && !data.id" translate="atheer.content.announcementsView.content">Content</div><div ng-if="data.data.content" class="description" id="fp-content-description-{{data.id}}"><span froala-view="data.data.content" ng-style="{\'color\': getContentColor()}" ng-class="getTitleHeight() > 26 ? \'line-2\' : \'line-3\'"></span></div></div></div></md-card-content></md-card>');
$templateCache.put('modules/content/document-detail.tmpl.html','<div ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div ng-if="!vm.isNew() && (vm.extractStatus === \'READY\' || vm.processStatus === \'READY\')" class="fp-content-detail-form" layout="row" layout-fill flex ng-cloak><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><md-input-container class="md-block"><label translate="atheer.content.author">Author</label> <input type="text" name="author" ng-model="vm.contentModel.data.author" md-select-on-focus></md-input-container><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/content-preview.tmpl.html\'"></ng-include></div></div></div><div ng-if="!vm.isNew() && vm.processStatus === \'PROCESSING\' || vm.processStatus === \'UPLOADED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.processingDocument">Processing Document. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-headline" translate="atheer.content.processStatus.processingComplete">Processing Complete. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.errorProcessingDocument">Error Processing Document. Try Again.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalDocument == true && vm.extractStatus === \'EXTRACTING\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.gatheringMoreInfo">Gathering More information about this URL. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalDocument == true && vm.extractStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-subhead" translate="atheer.content.extractStatus.configureAdditionalDetails">Got the details about the URL. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalDocument == true && (vm.extractStatus === \'ERROR\' || vm.extractStatus === \'INCOMPLETE\')" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.addMoreDetails">Was not able to get details about this URL. Let\'s add more details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.extractStatus !== \'READY\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="!vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'" flex layout="column"><div layout="row" layout-align="center"><fp-upload flex fp-content-type="document" fp-max-size="{{vm.fileMaxSize}}" fp-upload-status="vm.uploadStatus" fp-smart-upload-icon="{{vm.contentMetaData.icon}}" fp-smart-upload-label="{{vm.contentMetaData.label | translate}}" fp-ng-model="vm.contentModel.data.source_media" fp-bind-full-obj="true" fp-add-model-fn="vm.createDocument(mediaId, responseObj, isRequiredForProcessing, documentTags)" fp-upload-type="smart" fp-pattern="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" fp-supported-file-types="pdf, doc" fp-process-document="true"></fp-upload></div></div><md-divider></md-divider><div ng-if="!vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useUseEmbedCode">Use Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Video Providers" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useEmbedCode">Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Embed Code" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" ng-form="videoEmbedForm" layout="row" layout-align="center"><md-input-container flex="70" layout-align="center center" layout="column" class="md-block"><label translate="atheer.content.embedCode">Embed Code</label> <textarea md-no-autogrow ng-model="vm.contentModel.data.embed_code" rows="5" md-select-on-focus required></textarea><div ng-messages="videoEmbedForm.embed_code.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" layout-align="center" class="margin-bottom-40"><md-button class="md-primary" layout-align="center center" layout="column" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode;vm.contentModel.data.embed_code = null"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" layout-align="center center" layout="column" ng-disabled="vm.disableEmbedSubmit() || vm.extractStatus !== \'IDLE\'" ng-click="vm.useEmbedCode()"><span translate="entity.action.letsGo">Let\'s Go</span></md-button></div></md-card></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/content/document-feedback.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding><div layout="column" layout-align="center center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div class="md-title margin-bottom-30" translate="atheer.content.successfullyMarked">Succesfully Marked Complete.</div><md-button class="md-primary md-raised" ng-click="performEndAction(false,false,true)" translate="entity.action.close">Close</md-button></div><div layout="row" layout-align="center center" ng-cloak class="margin-top-80"></div></md-bottom-sheet>');
$templateCache.put('modules/content/document-view.tmpl.html','<md-card flex id="fp-content-view-{{data.id}}-{{context}}" class="fp-content-view" layout="column"><md-content><div ng-if="!data.data.external_document" class="fp-document-viewer"><iframe ng-src="{{getAtheerDocPreviewUrl(data.data.source_media.id, data.data.source_media.source_file_name)}}" width="100%" height="100%"></iframe></div><div ng-if="data.data.external_document" flex layout-align="center center" layout="row"><div class="fp-document-embed" layout="row" flex><div ng-bind-html="trustAsHtml(data.data.embed_code)"></div></div></div></md-content><md-card-actions layout="row" ng-if="assignmentId != null && context != \'smart-content\'" layout-align="center center"><div ng-if="!isCompleted"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="performEndAction(true,false,false)" ng-disabled="isPreviewMode" translate="entity.action.done">Done</md-button></div></md-card-actions></md-card>');
$templateCache.put('modules/content/image-detail.tmpl.html','<div ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div ng-if="!vm.isNew() && (vm.extractStatus === \'READY\' || vm.processStatus === \'READY\')" class="fp-content-detail-form" layout="row" layout-fill flex ng-cloak><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><md-input-container class="md-block"><label translate="atheer.content.author">Author</label> <input type="text" name="author" ng-model="vm.contentModel.data.author" md-select-on-focus></md-input-container><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/content-preview.tmpl.html\'"></ng-include></div></div></div><div ng-if="vm.isNew() && vm.extractStatus !== \'READY\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="!vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'" flex layout="column"><div layout="row" layout-align="center"><fp-upload flex fp-content-type="image" fp-max-size="{{vm.fileMaxSize}}" fp-upload-status="vm.uploadStatus" fp-smart-upload-icon="{{vm.contentMetaData.icon}}" fp-smart-upload-label="{{vm.contentMetaData.label | translate}}" fp-ng-model="vm.contentModel.data.source_media" fp-bind-full-obj="true" fp-add-model-fn="vm.createImage(mediaId, responseObj)" fp-upload-type="smart" fp-pattern="image/gif,image/jpeg,image/png" fp-supported-file-types="jpg, png, gif"></fp-upload></div></div></md-card></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/content/image-feedback.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding><div layout="column" layout-align="center center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div class="md-title margin-bottom-30" translate="atheer.content.successfullyMarked">Succesfully Marked Complete.</div><md-button class="md-primary md-raised" ng-click="performEndAction(false,false,true)" translate="entity.action.close">Close</md-button></div><div layout="row" layout-align="center center" ng-cloak class="margin-top-80"></div></md-bottom-sheet>');
$templateCache.put('modules/content/image-view.tmpl.html','<md-card flex id="fp-content-view-{{data.id}}-{{context}}" class="fp-content-view" layout="column" layout-align="center center"><div class="fp-content-image-wrapper"><img ng-src="/media/images/{{data.data.source_media.properties.file_name}}"></div><md-card-actions layout="row" ng-if="assignmentId != null && context != \'smart-content\'" layout-align="center center"><div ng-if="!isCompleted"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="performEndAction(true,false,false)" ng-disabled="isPreviewMode" translate="entity.action.done">Done</md-button></div></md-card-actions></md-card>');
$templateCache.put('modules/content/launcher.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><md-content ng-if="!vm.loadingData" class="fp-content-player-view"><div layout="row" class="margin-top-10"><div flex></div><!--\n        <div layout-align="center center" class="margin-top-10">\n            <md-icon md-font-icon="zmdi zmdi-check-circle zmdi-hc-2x" ng-style="{\'color\': \'rgb(89, 226, 168)\'}"></md-icon>\n        </div>\n        --><md-button class="md-icon-button toolbar-button" ng-click="vm.toggleFullScreen()" aria-label="toggle fullscreen"><md-icon class="zmdi-hc-2x white-font" ng-class="vm.fullScreenIcon"></md-icon></md-button><md-button class="md-icon-button" ng-click="vm.close()"><md-icon class="zmdi zmdi-close zmdi-hc-2x white-font"></md-icon></md-button></div><div layout="row" class="content-window" flex><div flex="5" layout-align="start start"></div><div ng-if="!vm.loadingData" flex layout="row"><div flex class="fp-content-player" layout="row"><fp-content-view mode="vm.mode" context="vm.contentData.data.type" done-call-back="vm.finishCallBack()" current-response-data="responseData" assignment-id="vm.assignmentId" data="vm.contentData" content-type="{{vm.contentData.data.type}}"></fp-content-view></div></div><div flex="5" layout-align="start start"></div></div></md-content>');
$templateCache.put('modules/content/link-detail.tmpl.html','<div ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div ng-if="!vm.isNew() || vm.extractStatus === \'ready\'" class="fp-content-detail-form" layout="row" layout-fill flex ng-cloak><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><md-input-container class="md-block content-title-input"><label translate="atheer.content.url">URL</label> <input type="url" name="source_url" ng-model="vm.contentModel.data.source_url" md-select-on-focus required><div ng-messages="contentDetailForm.source_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.content.linkButtonText">Link Button Text</label> <input type="text" name="link_text" id="field_link_text" ng-init="vm.contentModel.data.link_text = (vm.contentModel.data.link_text == null ?  \'Read More On\' : vm.contentModel.data.link_text)" ng-model="vm.contentModel.data.link_text" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.content.author">Author</label> <input type="text" name="author" ng-model="vm.contentModel.data.author" md-select-on-focus></md-input-container><fp-auto-complete auto-complete-model="vm.contentModel.data.provider" component="Provider" query-objs="[{fieldName:\'name\', operator:\'=re=\'}]" placeholder="{{\'atheer.content.selectProvider\' | translate}"></fp-auto-complete><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/content-preview.tmpl.html\'"></ng-include></div></div></div><div ng-if="vm.isNew() && vm.extractStatus !== \'ready\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="row" layout-padding><div flex="100" layout="column" ng-form="linkExtractForm"><div ng-if="vm.extractStatus === \'idle\'" layout="row" layout-align="center" layout-padding><span class="md-headline" translate="atheer.content.extractStatus.provideLinkBelow">Provide link below to start with</span></div><div ng-if="vm.extractStatus === \'idle\'" layout="row" layout-align="center"><md-input-container flex="70" layout-align="center center" layout="column" class="md-block"><label translate="atheer.content.url">URL</label> <input type="url" name="source_url" ng-model="vm.contentModel.data.source_url" md-select-on-focus required><div ng-if="linkExtractForm.source_url.$dirty" ng-messages="linkExtractForm.source_url.$error"><div ng-message="required"><span translate="entity.validation.required">This field is required.</span></div><div class="md-input-message-animation" ng-if="!linkExtractForm.source_url.$error.required && vm.isURLInvalid()"><span translate="entity.validation.invalidURL">Please enter valid URL.</span></div></div></md-input-container></div><div ng-if="vm.extractStatus === \'extracting\'" layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.extractStatus.gatheringMoreInfo">Gathering More information about this URL. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div><div ng-if="vm.extractStatus === \'complete\'" layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.extractStatus.configureAdditionalDetails">Got the details about the URL. Let\'s configure additional details.</span></div></div><div ng-if="vm.extractStatus === \'error\' || vm.extractStatus === \'incomplete\'" layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#F47020\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.extractStatus.addMoreDetails">Was not able to get details about this URL. Let\'s add more details.</span></div></div><div layout="row" layout-align="center"><md-button class="md-primary md-raised" layout-align="center center" layout="column" ng-disabled="linkExtractForm.$invalid || vm.isURLInvalid() || vm.extractStatus !== \'idle\'" ng-click="vm.extractLinkDetails()"><span translate="entity.action.letsGo">Let\'s Go</span></md-button></div></div></div></md-card></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/content/link-feedback.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding><div layout="column" layout-align="center center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div class="md-title margin-bottom-30" translate="atheer.content.successfullyMarked">Succesfully Marked Complete.</div><md-button class="md-primary md-raised" ng-click="performEndAction(false,false,true)" translate="entity.action.close">Close</md-button></div><div layout="row" layout-align="center center" ng-cloak class="margin-top-80"></div></md-bottom-sheet>');
$templateCache.put('modules/content/link-view.tmpl.html','<md-card flex id="fp-content-view-{{data.id}}-{{context}}" class="fp-content-view" layout="column"><div layout-align="start start" class="margin-20"><span class="md-title">{{data.title}}</span></div><md-content class="margin-bottom-20"><div layout-padding><div ng-if="data.data.thumbnail_url" layout-align="center center" layout="row"><img ng-src="{{data.data.thumbnail_url | mediaUrl}}" class="md-card-image fp-link-image" alt="Washed Out"></div><div ng-show="data.show_description" class="margin-top-20 margin-bottom-20" id="fp-content-description-{{data.id}}" froala-view="data.description"></div><div ng-style="{ \'margin-top\': getSpacerHeight(data.id)}"></div><div layout-align="center center" layout="row"><md-button class="md-primary" ng-href="{{data.data.source_url}}" target="_blank">{{data.data.link_text ? data.data.link_text : \'Read More On\'}}</md-button></div></div></md-content><md-card-actions ng-if="assignmentId != null && context != \'smart-content\'" layout="row" layout-align="center end"><div ng-if="!isCompleted"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="performEndAction(true,false,false)" ng-disabled="isPreviewMode" translate="entity.action.done">Done</md-button></div></md-card-actions></md-card>');
$templateCache.put('modules/content/podcast-detail.tmpl.html','<div ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div ng-if="!vm.isNew() && (vm.extractStatus === \'READY\' || vm.processStatus === \'READY\')" class="fp-content-detail-form" layout="row" layout-fill flex ng-cloak><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><md-input-container ng-if="vm.contentModel.data.external_video" class="md-block"><label translate="atheer.content.author">Author</label> <input type="text" name="author" ng-model="vm.contentModel.data.author" md-select-on-focus></md-input-container><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/content-preview.tmpl.html\'"></ng-include></div></div></div><div ng-if="!vm.isNew() && vm.processStatus === \'PROCESSING\' || vm.processStatus === \'UPLOADED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.processingAudioConfigure">Processing Audio. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-headline" translate="atheer.content.processStatus.processingComplete">Processing Complete. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.errorProcessingDocument">Error Processing Document. Try Again.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalPodcast == true && vm.extractStatus === \'EXTRACTING\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.gatheringMoreInfo">Gathering More information about this URL. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalPodcast == true && vm.extractStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-subhead" translate="atheer.content.extractStatus.configureAdditionalDetails">Got the details about the URL. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalPodcast == true && (vm.extractStatus === \'ERROR\' || vm.extractStatus === \'INCOMPLETE\')" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.addMoreDetails">Was not able to get details about this URL. Let\'s add more details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && (vm.processStatus !== \'READY\')" layout="row" layout-align="center center" class="fp_full_background" layout-fill><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="!vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'" flex layout="column"><fp-upload fp-content-type="audio" fp-max-size="{{vm.fileMaxSize}}" fp-smart-upload-icon="{{vm.contentMetaData.icon}}" fp-upload-status="vm.uploadStatus" fp-smart-upload-label="{{vm.contentMetaData.label | translate}}" fp-add-model-fn="vm.createPodcast(mediaId, responseObj)" fp-upload-type="smart" fp-pattern="audio/*"></fp-upload></div><md-divider></md-divider><div ng-if="!vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useUseEmbedCode">Use Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Video Providers" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useEmbedCode">Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Embed Code" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" ng-form="videoEmbedForm" layout="row" layout-align="center"><md-input-container flex="70" layout-align="center center" layout="column" class="md-block"><label translate="atheer.content.embedCode">Embed Code</label> <textarea md-no-autogrow ng-model="vm.contentModel.data.embed_code" rows="5" md-select-on-focus required></textarea><div ng-messages="videoEmbedForm.embed_code.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" layout-align="center" class="margin-bottom-40"><md-button class="md-primary" layout-align="center center" layout="column" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode;vm.contentModel.data.embed_code = null"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" layout-align="center center" layout="column" ng-disabled="vm.disableEmbedSubmit() || vm.extractStatus !== \'IDLE\'" ng-click="vm.useEmbedCode()"><span translate="entity.action.letsGo">Let\'s Go</span></md-button></div></md-card></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/content/podcast-feedback.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding><div layout="column" layout-align="center center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div class="md-title margin-bottom-30" translate="atheer.content.successfullyMarked">Succesfully Marked Complete.</div><md-button class="md-primary md-raised" ng-click="performEndAction(false,false,true)" translate="entity.action.close">Close</md-button></div><div layout="row" layout-align="center center" ng-cloak class="margin-top-80"></div></md-bottom-sheet>');
$templateCache.put('modules/content/podcast-view.tmpl.html','<md-card flex id="fp-content-view-{{data.id}}-{{context}}" class="fp-content-view" layout="column"><md-card-content class="margin-bottom-20"><div layout="row" class="margin-bottom-20"><div ng-if="data.data.provider" layout-align="center center" layout="column" class="margin-right-20"><img class="fp-provider-image" ng-src="{{data.data.provider.favicon_url}}"></div><div layout="column" layout-align="center start"><span class="md-title">{{data.title}}</span> <span class="md-subhead">{{data.data.provider.name}}</span></div><div flex></div><div ng-if="isCompleted" layout-align="center center" class="margin-top-10"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'48\' + \'px\', height: \'48\' + \'px\'}"></md-icon></div></div><div ng-if="!data.data.external_podcast && data.data.use_custom_thumbnail" layout-align="center center" layout="row"><img ng-src="/media/images/{{data.data.thumbnail_url}}" class="md-card-image fp-link-image" alt="Washed Out"></div><div ng-if="!data.data.use_custom_thumbnail" class="margin-top-200"></div><div ng-if="!data.data.external_podcast" flex layout="row" layout-align="center center" class="margin-top-20"><jwplayer player-options="podcastSettings" player-id="{{player_id}}" id="fp-jwplayer"></jwplayer></div><div ng-if="data.data.external_podcast" flex layout-align="center center" layout="row"><div flex="80"><div class="fp-podcast-embed" layout="row" flex><div ng-bind-html="trustAsHtml(data.data.embed_code)"></div></div></div></div><div ng-show="data.show_description" froala-view="data.description" id="fp-content-description-{{data.id}}"></div></md-card-content><div flex></div><md-card-actions ng-if="assignmentId != null && context != \'smart-content\'" layout="row" layout-align="center end"><div ng-if="!isCompleted"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="performEndAction(true,false,false)" ng-disabled="isPreviewMode" translate="entity.action.done">Done</md-button></div></md-card-actions></md-card>');
$templateCache.put('modules/content/session-recording-detail.tmpl.html','<div ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div ng-if="!vm.isNew()" class="fp-content-detail-form" layout="row" layout-fill flex ng-cloak><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><md-input-container class="md-block"><label translate="atheer.content.author">Author</label> <input type="text" name="author" ng-model="vm.contentModel.data.author" md-select-on-focus></md-input-container><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/content-preview.tmpl.html\'"></ng-include></div></div></div><div ng-if="!vm.isNew() && vm.processStatus === \'PROCESSING\' || vm.processStatus === \'UPLOADED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.processingDocument">Processing Document. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-headline" translate="atheer.content.processStatus.processingComplete">Processing Complete. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.errorProcessingDocument">Error Processing Document. Try Again.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalDocument == true && vm.extractStatus === \'EXTRACTING\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.gatheringMoreInfo">Gathering More information about this URL. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalDocument == true && vm.extractStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-subhead" translate="atheer.content.extractStatus.configureAdditionalDetails">Got the details about the URL. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalDocument == true && (vm.extractStatus === \'ERROR\' || vm.extractStatus === \'INCOMPLETE\')" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.addMoreDetails">Was not able to get details about this URL. Let\'s add more details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.extractStatus !== \'READY\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="!vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'" flex layout="column"><div layout="row" layout-align="center"><fp-upload flex fp-content-type="image" fp-max-size="{{vm.fileMaxSize}}" fp-upload-status="vm.uploadStatus" fp-smart-upload-icon="{{vm.contentMetaData.icon}}" fp-smart-upload-label="{{vm.contentMetaData.label | translate}}" fp-ng-model="vm.contentModel.data.source_media" fp-bind-full-obj="true" fp-add-model-fn="vm.createDocument(mediaId, responseObj)" fp-upload-type="smart" fp-pattern="application/msword,application/vnd.openxmlformats-officeimage.wordprocessingml.image,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officeimage.presentationml.presentation,application/vnd.ms-excel,application/vnd.openxmlformats-officeimage.spreadsheetml.sheet"></fp-upload></div></div><md-divider></md-divider><div ng-if="!vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useUseEmbedCode">Use Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Video Providers" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useEmbedCode">Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Embed Code" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" ng-form="videoEmbedForm" layout="row" layout-align="center"><md-input-container flex="70" layout-align="center center" layout="column" class="md-block"><label translate="atheer.content.embedCode">Embed Code</label> <textarea ng-model="vm.contentModel.data.embed_code" rows="5" md-select-on-focus required></textarea><div ng-messages="videoEmbedForm.embed_code.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="vm.selectEmbedCode && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\' && vm.uploadStatus === \'idle\'" layout="row" layout-align="center" class="margin-bottom-40"><md-button class="md-primary" layout-align="center center" layout="column" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode;vm.contentModel.data.embed_code = null"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" layout-align="center center" layout="column" ng-disabled="vm.disableEmbedSubmit() || vm.extractStatus !== \'IDLE\'" ng-click="vm.useEmbedCode()"><span translate="entity.action.letsGo">Let\'s Go</span></md-button></div></md-card></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/content/session-recording-feedback.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding><div layout="column" layout-align="center center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div class="md-title margin-bottom-30" translate="atheer.content.successfullyMarked">Succesfully Marked Complete.</div><md-button class="md-primary md-raised" ng-click="performEndAction(false,false,true)" translate="entity.action.close">Close</md-button></div><div layout="row" layout-align="center center" ng-cloak class="margin-top-80"></div></md-bottom-sheet>');
$templateCache.put('modules/content/session-recording-view.tmpl.html','<md-card flex id="fp-content-view-{{data.id}}-{{context}}" class="fp-content-view" layout="column"><md-card-content flex layout="column" class="margin-bottom-30"><div layout="column" layout-align="start start" class="margin-bottom-20"><span class="md-title">{{data.title}}</span></div><div ng-if="isLoaded" layout="row" flex="50" layout-align="center start"><jwplayer flex="80" player-options="videoSettings" player-id="{{player_id}}"></jwplayer></div></md-card-content><md-card-actions ng-if="assignmentId != null && context != \'smart-content\'" layout="row" layout-align="center end"><div ng-if="!isCompleted"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="performEndAction(true,false,false)" ng-disabled="isPreviewMode" translate="entity.action.done">Done</md-button></div></md-card-actions></md-card>');
$templateCache.put('modules/content/smart-page-detail-header.tmpl.html','<div class="toolbar-default md-whiteframe-z1" ng-style="{\'margin-bottom\': \'1\' + \'px\'}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goBack()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><md-icon md-font-icon="{{vm.contentMetaData.icon}}"></md-icon><span flex="30" data-ellipsis ng-bind="vm.contentModel.title"></span><div ng-if="vm.showToolbar" flex><md-tabs ng-if="!vm.isNew()" md-center-tabs><md-tab ui-sref="storm.admin-content-detail({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\'})" md-active="true"><md-tab-label><span translate="atheer.content.settings">Settings</span></md-tab-label></md-tab><md-tab ng-if="vm.hasInsights()" ui-sref="storm.admin-content-detail-insights.section({contentType: \'{{vm.contentModel.data.type}}\', id: \'{{vm.contentModel.id}}\', section : \'overview\'})"><md-tab-label><span translate="atheer.content.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div layout="row" layout-align="end center"><md-button ng-if="!vm.isNew()" class="md-primary md-raised" ng-click="vm.previewContent()"><span translate="entity.action.preview">Preview</span></md-button><md-button type="submit" class="md-primary md-raised" ng-disabled="contentDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><md-button ng-if="vm.contentMetaData.type != \'did-you-know\'" class="md-icon-button" ng-click="vm.openShareDialog(content)" aria-label="primary button"><md-icon md-font-icon="fa fa-share-square"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.share">Share</span></fp-tooltip></md-button><md-button ng-if="!vm.isNew() && vm.contentMetaData.show_copy_action" class="md-icon-button" ng-click="vm.copyContent()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><fp-tooltip placement="bottom"><span translate="entity.action.copy">Copy</span></fp-tooltip></md-button><fp-help></fp-help></div></div></div>');
$templateCache.put('modules/content/smart-page-detail.tmpl.html','<div ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div class="fp-content-detail-form" layout="row" layout-fill flex><div ng-if="!vm.showSettings" layout="column" class="md-whiteframe-z1"><div flex layout="column"><div layout="row" layout-align="center center"><md-button class="md-icon-button" ng-click="vm.showSettings = !vm.showSettings" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.content.showSettings">Show Settings</span></fp-tooltip></md-button></div></div></div><div ng-if="vm.showSettings" layout="column" flex="25" flex-xs="100" flex-sm="100" flex-md="50" flex-lg="35" flex-xl="25" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><md-input-container ng-if="vm.contentModel.data.external_video" class="md-block"><label translate="atheer.content.author">Author</label> <input type="text" name="author" ng-model="vm.contentModel.data.author" md-select-on-focus></md-input-container><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include></md-content></div></div><div flex layout="column" layout-fill><div ng-if="vm.isFroalaOptionsSet"><textarea name="content" froala="vm.froalaOptions" ng-model="vm.contentModel.data.content"></textarea></div></div></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include></div>');
$templateCache.put('modules/content/smart-page-feedback.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding><div layout="column" layout-align="center center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div class="md-title margin-bottom-30" translate="atheer.content.successfullyMarked">Succesfully Marked Complete.</div><md-button class="md-primary md-raised" ng-click="performEndAction(false,false,true)" translate="entity.action.close">Close</md-button></div><div layout="row" layout-align="center center" ng-cloak class="margin-top-80"></div></md-bottom-sheet>');
$templateCache.put('modules/content/smart-page-view.tmpl.html','<md-card flex id="fp-content-view-{{data.id}}-{{context}}" layout="column" class="fp-content-view"><div layout-align="start start" class="margin-20"><span class="md-title">{{data.title}}</span></div><md-content class="margin-bottom-30"><div layout-padding class="margin-top-20 margin-bottom-20" froala-view="data.data.content"></div></md-content><md-card-actions ng-if="assignmentId != null && context != \'smart-content\'" layout="row" layout-align="center end"><div ng-if="!isCompleted"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="performEndAction(true,false,false)" ng-disabled="isPreviewMode" translate="entity.action.done">Done</md-button></div></md-card-actions></md-card>');
$templateCache.put('modules/content/video-detail.tmpl.html','<div ng-form="contentDetailForm"><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-header.tmpl.html\'"></ng-include><div ng-if="!vm.isNew() && (vm.extractStatus === \'READY\' || vm.processStatus === \'READY\')" class="fp-content-detail-form" layout="row" layout-fill flex ng-cloak><div layout="column" flex="40" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><ng-include src="\'modules/content/base-card-header-detail.tmpl.html\'"></ng-include><md-input-container ng-if="vm.contentModel.data.external_video" class="md-block content-title-input"><label translate="atheer.content.url">URL</label> <input type="url" name="source_url" ng-model="vm.contentModel.data.source_url" md-select-on-focus required><div ng-messages="contentDetailForm.source_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container ng-if="vm.contentModel.data.external_video" class="md-block"><label translate="atheer.content.author">Author</label> <input type="text" name="author" ng-model="vm.contentModel.data.author" md-select-on-focus></md-input-container><div ng-if="vm.contentModel.data.external_video"><fp-auto-complete auto-complete-model="vm.contentModel.data.provider" component="Provider" query-objs="[{fieldName:\'name\', operator:\'=re=\'}]"></fp-auto-complete></div><ng-include src="\'modules/content/content-scheduling.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-header.tmpl.html\'"></ng-include><ng-include src="\'modules/content/content-settings-footer.tmpl.html\'"></ng-include><ng-include src="\'modules/content/base-card-footer-detail.tmpl.html\'"></ng-include></md-content></div></div><div ng-show="vm.showToolbar" flex><ng-include src="\'modules/content/content-preview.tmpl.html\'"></ng-include></div></div></div><div ng-if="!vm.isNew() && vm.processStatus === \'PROCESSING\' || vm.processStatus === \'UPLOADED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.processingVideo">Processing Video. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-headline" translate="atheer.content.processStatus.processingComplete">Processing Complete. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="!vm.isNew() && vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.content.processStatus.errorProcessingVideo">Error Processing Video. Try Again.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalVideo == true && vm.extractStatus === \'EXTRACTING\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.gatheringMoreInfo">Gathering More information about this URL. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalVideo == true && vm.extractStatus === \'COMPLETE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-bottom-40"><span class="md-subhead" translate="atheer.content.extractStatus.configureAdditionalDetails">Got the details about the URL. Let\'s configure additional details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && vm.isExternalVideo == true && (vm.extractStatus === \'ERROR\' || vm.extractStatus === \'INCOMPLETE\')" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.content.extractStatus.addMoreDetails">Was not able to get details about this URL. Let\'s add more details.</span></div></div></div></md-card></div><div ng-if="vm.isNew() && (vm.extractStatus !== \'READY\' || vm.processStatus !== \'READY\')" layout="row" layout-align="center center" class="fp_full_background" layout-fill><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="!vm.selectEmbedCode && !vm.selectVideoProviders && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'"><fp-upload fp-content-type="video" fp-max-size="{{vm.fileMaxSize}}" fp-smart-upload-icon="{{vm.contentMetaData.icon}}" fp-upload-status="vm.uploadStatus" fp-smart-upload-label="{{vm.contentMetaData.label | translate}}" fp-add-model-fn="vm.createVideo(mediaId, responseObj)" fp-upload-type="smart" fp-pattern="video/*" fp-supported-file-types="mp4, avi"></fp-upload></div><md-divider></md-divider><div ng-if="!vm.selectEmbedCode && !vm.selectVideoProviders && vm.uploadStatus === \'idle\' && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectVideoProviders" class="md-subhead" translate="atheer.content.orUseExistingUrlFrom">Or Use Existing URL from</span> <span ng-if="vm.selectVideoProviders" class="md-headline" translate="atheer.content.useExistingUrlFrom">Use Existing URL from</span> <img src="assets/images/app/video-providers.png" height="100px" alt="Video Providers" ng-click="vm.selectVideoProviders = !vm.selectVideoProviders"></div><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useUseEmbedCode">Use Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Video Providers" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectVideoProviders && vm.uploadStatus === \'idle\' && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectVideoProviders" class="md-subhead" translate="atheer.content.orUseExistingUrlFrom">Or Use Existing URL from</span> <span ng-if="vm.selectVideoProviders" class="md-headline" translate="atheer.content.useExistingUrlFrom">Use Existing URL from</span> <img src="assets/images/app/video-providers.png" height="100px" alt="Video Providers" ng-click="vm.selectVideoProviders = !vm.selectVideoProviders"></div></div><div ng-if="vm.selectEmbedCode && vm.uploadStatus === \'idle\' && vm.extractStatus === \'IDLE\' && vm.processStatus === \'IDLE\'" layout="row" class="fp-smart-link-extract" layout-align="space-around center"><div layout="column" layout-align="center center" layout-padding><span ng-if="!vm.selectEmbedCode" class="md-subhead" translate="atheer.content.orUseEmbedCode">Or Use Embed Code</span> <span ng-if="vm.selectEmbedCode" class="md-headline" translate="atheer.content.useEmbedCode">Use Embed Code</span> <img src="assets/images/app/embed-code.png" height="100px" alt="Embed Code" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode"></div></div><div ng-if="vm.selectVideoProviders && vm.extractStatus !== \'READY\' && vm.processStatus !== \'READY\'" ng-form="videoExtractForm" layout="row" layout-align="center"><md-input-container flex="70" layout-align="center center" layout="column" class="md-block"><label translate="atheer.content.videoUrl">Video URL</label> <input type="url" name="source_url" ng-model="vm.contentModel.data.source_url" md-select-on-focus required><div ng-messages="videoExtractForm.source_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="vm.selectEmbedCode && vm.extractStatus !== \'READY\' && vm.processStatus !== \'READY\'" ng-form="videoEmbedForm" layout="row" layout-align="center"><md-input-container flex="70" layout-align="center center" layout="column" class="md-block"><label translate="atheer.content.embedCode">Embed Code</label> <textarea md-no-autogrow ng-model="vm.contentModel.data.embed_code" rows="5" md-select-on-focus required></textarea><div ng-messages="videoEmbedForm.embed_code.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="vm.selectVideoProviders && vm.uploadStatus === \'idle\'" layout="row" layout-align="center" class="margin-bottom-40"><md-button class="md-primary" layout-align="center center" layout="column" ng-disabled="vm.extractStatus !== \'IDLE\'" ng-click="vm.selectVideoProviders = !vm.selectVideoProviders; vm.contentModel.data.source_url = null"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" layout-align="center center" layout="column" ng-disabled="vm.disableVideoProviderSubmit() || vm.extractStatus !== \'IDLE\'" ng-click="vm.extractVideoDetails()"><span translate="entity.action.letsGo">Let\'s Go</span></md-button></div><div ng-if="vm.selectEmbedCode && vm.uploadStatus === \'idle\'" layout="row" layout-align="center" class="margin-bottom-40"><md-button class="md-primary" layout-align="center center" layout="column" ng-disabled="vm.extractStatus !== \'IDLE\'" ng-click="vm.selectEmbedCode = !vm.selectEmbedCode;vm.contentModel.data.embed_code = null"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" layout-align="center center" layout="column" ng-disabled="vm.disableEmbedSubmit() || vm.extractStatus !== \'IDLE\'" ng-click="vm.useEmbedCode()"><span translate="entity.action.letsGo">Let\'s Go</span></md-button></div></md-card></div><ng-include ng-show="vm.showToolbar" src="\'modules/content/content-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/content/video-feedback.tmpl.html','<md-bottom-sheet class="md-list" layout="column" layout-padding><div layout="column" layout-align="center center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div class="md-title margin-bottom-30" translate="atheer.content.successfullyMarked">Succesfully Marked Complete.</div><md-button class="md-primary md-raised" ng-click="performEndAction(false,false,true)" translate="entity.action.close">Close</md-button></div><div layout="row" layout-align="center center" ng-cloak class="margin-top-80"></div></md-bottom-sheet>');
$templateCache.put('modules/content/video-view.tmpl.html','<md-card flex id="fp-content-view-{{data.id}}-{{context}}" class="fp-content-view" layout="column"><md-card-content flex layout="column" class="margin-bottom-30"><div layout="column" layout-align="start start" class="margin-bottom-20"><span class="md-title">{{data.title}}</span></div><div ng-if="!data.data.external_video" layout="row" flex="50" layout-align="center start"><jwplayer flex="80" player-options="videoSettings" player-id="{{player_id}}"></jwplayer></div><div ng-if="data.data.external_video" flex layout-align="center center" layout="row"><div flex="80"><div class="fp-video-embed" layout="row" flex><div ng-bind-html="trustAsHtml(data.data.embed_code)"></div></div></div></div><div ng-if="data.data.external_video && data.data.source_url != null" layout-align="center center" layout="row"><md-button class="md-primary" ng-href="{{data.data.source_url}}" target="_blank" translate="atheer.content.watchItOn" translate-values="{dataProviderDisplay: \'{{data.data.provider.display}}\'}">Watch it On {{data.data.provider.display}}</md-button></div></md-card-content><md-card-actions ng-if="assignmentId != null && context != \'smart-content\'" layout="row" layout-align="center end"><div ng-if="!isCompleted"><md-button class="md-primary md-raised" aria-label="Mark Complete" ng-click="performEndAction(true,false,false)" ng-disabled="isPreviewMode" translate="entity.action.done">Done</md-button></div></md-card-actions></md-card>');
$templateCache.put('modules/sdk/sdk-data-export.tmpl.html','<div flex layout="column" layout-fill><div class="toolbar-default margin-bottom-0 md-whiteframe-z1" ng-if="vm.showToolbar"><div class="md-toolbar-tools md-accent"><h2><span translate="atheer.airSdk.title">AiRSDK</span> - <span translate="atheer.airSdk.dataExport">Data Export</span></h2><span flex></span><div layout="row"><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.refresh">Refresh</span></fp-tooltip></md-button><div><md-button class="md-primary md-raised" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button></div><fp-help></fp-help></div></div></div><div flex layout="row" class="margin-top-5"><iframe id="ngxFrame" ng-src="{{vm.ngxUrlTrusted}}" height="100%" width="100%" noresize="noresize" frameborder="0" allow="camera; microphone"></div></div>');
$templateCache.put('modules/sdk/sdk-doc.tmpl.html','<div flex layout="column" layout-fill><div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><h2><span translate="atheer.airSdk.title">AiRSDK</span> - <span translate="atheer.airSdk.apiDoc">API Reference</span></h2><span flex></span><div layout="row"><fp-help></fp-help></div></div></div><div flex layout="row" class="margin-top-5"><iframe id="ngxFrame" ng-src="{{vm.hostUrl}}" height="100%" width="100%" noresize="noresize" frameborder="0" allow="camera; microphone"></div></div>');
$templateCache.put('modules/sdk/sdk-key.tmpl.html','<div flex layout="column" layout-fill><div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><h2><span translate="atheer.airSdk.title">AiRSDK</span> - <span translate="atheer.airSdk.apiKey">API Key</span></h2><span flex></span><div layout="row"><fp-help></fp-help></div></div></div><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="row" ng-if="!vm.loadingData" layout-align="center start"><div flex="60" layout="column" class="padded-content-page margin-top-40"><div layout="column"><p class="md-subhead" translate="atheer.airsdk.welcomeAirnow">Welcome to AiRNow! It gives you access to APIs / SDKs that power Atheer.</p><p class="md-subhead" translate="atheer.airsdk.atheerApi">Your Atheer API key provides access to your Atheer portal, so do not freely distribute it. Each key is specific to a portal, not a user. We currently allow for only one key at a time. If needed, you may deactivate your Atheer API key and generate a new one.</p></div><div ng-if="vm.apiKey == null" layout="row" layout-align="start center"><md-button class="md-raised md-primary margin-left-0" ng-click="vm.generateAPIKeySettings()" translate="atheer.airsdk.generateNewKey">Generate new key</md-button></div><div ng-if="vm.apiKey != null" layout="row" class="margin-top-40"><div flex="70"><md-input-container class="md-block" flex-gt-xs><label class="md-title" translate="atheer.airsdk.apiKey">Atheer API Key</label> <input ng-model="vm.apiKey" disabled="disabled"></md-input-container></div><div flex layout="row" layout-align="end start"><md-button class="md-raised md-warn margin-left-0" ng-click="vm.deactivateAPIKeySettings()" translate="atheer.airsdk.deactivateKey">Deactivate key</md-button></div></div><div ng-if="vm.apiKey != null" layout="row"><label class="md-subhead" translate="atheer.airsdk.apiKeyGeneratedOn"></label> <label>: {{vm.createdOn | amDateFormat:\'MM/DD/YYYY\'}}</label></div><div ng-if="vm.apiKey != null" layout="row"><label class="md-subhead" translate="atheer.airsdk.apiKeyExpiresOn">API Key expires on</label> <label>: {{vm.expiresOn | amDateFormat:\'MM/DD/YYYY\'}}</label></div></div></div></div>');
$templateCache.put('modules/sdk/sdk-mobile-sdk.tmpl.html','<div flex layout="column" layout-fill><div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><h2><span translate="atheer.airSdk.title">AiRSDK</span> - <span translate="atheer.airSdk.mobileSdk">Mobile SDK</span></h2><div flex layout="row"><fp-help></fp-help></div></div></div><div flex layout="row" class="margin-top-5"></div></div>');
$templateCache.put('modules/sdk/sdk-webhook-detail-log-info.tmpl.html','<md-dialog flex="70" flex-xs="100" flex-md="70" flex-lg="70" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.webHook.executionDetail">Webhook Execution Log</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.group.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content" layout="column" layout-padding><div layout="row" layout-align="start center"><span class="md-body-2" translate="atheer.webHook.executionNo">Execution No : </span><span>&nbsp;:&nbsp;{{vm.webHookExecution.web_hook_execution_no}}</span></div><div layout="row" layout-align="start center"><span class="md-body-2" translate="atheer.webHook.status">Status : </span><span>&nbsp;:&nbsp;{{vm.webHookExecution.status}}</span></div><div layout="row" layout-align="start center"><span class="md-body-2" translate="atheer.webHook.createdOn">Created On : </span><span>&nbsp;:&nbsp;{{vm.webHookExecution.created_on}}</span></div><div layout="row" layout-align="start center"><span class="md-body-2" translate="atheer.webHook.triggeredOn">Triggered On : </span><span>&nbsp;:&nbsp;{{vm.webHookExecution.triggered_on}}</span></div><div layout="row" layout-align="start center"><span class="md-body-2" translate="atheer.webHook.responseCode">Response Code : </span><span>&nbsp;:&nbsp;{{vm.webHookExecution.response_code}}</span></div><md-tabs md-center-tabs><md-tab label="Request Payload"><div><p>{{vm.webHookExecution.request_payload}}</p></div></md-tab><md-tab label="Response Payload" class="margin-top-20"><div><pre>{{vm.webHookExecution.response_payload}}</pre></div></md-tab></md-tabs></md-dialog-content></md-dialog>');
$templateCache.put('modules/sdk/sdk-webhook-detail-logs.tmpl.html','<div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToWebHooks()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.webHookModel.name}}</span></h2><div flex><md-tabs ng-if="!vm.isNew()" md-center-tabs><md-tab ui-sref="storm.admin-airsdk-web-hook-detail({id: \'{{vm.webHookId}}\'})"><md-tab-label><span translate="atheer.webHook.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-airsdk-web-hook-detail-logs({id: \'{{vm.webHookId}}\'})" md-active="true"><md-tab-label><span translate="atheer.webHook.logs">Logs</span></md-tab-label></md-tab></md-tabs></div><div layout="row"><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></div></div><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.webHookExecutions.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content flex ng-if="!vm.loadingData && vm.webHookExecutions.length > 0" class="margin-top-10"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="web_hook_execution_no"><span translate="atheer.webHook.executionNo">Execution No</span></th><th md-column md-order-by="status"><span translate="atheer.webHook.status">Status</span></th><th md-column md-order-by="retry_count"><span translate="atheer.webHook.retryCount">Retry Count</span></th><th md-column md-order-by="created_on"><span translate="atheer.webHook.createdOn">Created On</span></th><th md-column md-order-by="triggered_on"><span translate="atheer.webHook.triggeredOn">Triggered On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="webHookExecution in vm.webHookExecutions track by webHookExecution.id"><td md-cell>{{webHookExecution.web_hook_execution_no}}</td><td md-cell>{{webHookExecution.status}}</td><td md-cell>{{webHookExecution.retry_count}}</td><td md-cell am-time-ago="webHookExecution.created_on"></td><td md-cell am-time-ago="webHookExecution.triggered_on"></td><td class="text-right"><div flex class="btn-group margin-right-10"><md-button ng-if="webHookExecution.status == \'FAILED\'" class="md-icon-button" aria-label="primary button" ng-click="vm.executeRun(webHookExecution)"><md-icon class="fa fa-send icon-size"></md-icon><fp-tooltip><span translate="atheer.webHook.executeRun">Run</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.showInfo(webHookExecution)"><md-icon class="zmdi zmdi-eye icon-size"></md-icon><fp-tooltip><span translate="atheer.webHook.showInfo">Show details</span></fp-tooltip></md-button></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.webHookExecutions.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination>');
$templateCache.put('modules/sdk/sdk-webhook-detail.tmpl.html','<div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToWebHooks()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.webHookModel.name}}</span></h2><div flex><md-tabs ng-if="!vm.isNew()" md-center-tabs><md-tab ui-sref="storm.admin-airsdk-web-hook-detail({id: \'{{vm.webHookModel.id}}\'})" md-active="true"><md-tab-label><span translate="atheer.webHook.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-airsdk-web-hook-detail-logs({id: \'{{vm.webHookModel.id}}\'})"><md-tab-label><span translate="atheer.webHook.logs">Logs</span></md-tab-label></md-tab></md-tabs></div><div layout="row"><md-button ng-if="!vm.isNew()" type="submit" class="md-primary md-raised" ng-disabled="editForm.$invalid" ng-click="vm.testWebHook()"><span translate="atheer.webHook.test">Test</span></md-button><md-button type="submit" class="md-primary md-raised" ng-disabled="editForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></div></div><div ng-if="!vm.loadingData" flex layout="column" class="padded-content-page"><div layout="row" layout-align="center center"><div flex="50" layout="column" ng-form="webHookDetailForm"><div><input type="hidden" id="id" name="id" ng-model="vm.webHookModel.id" readonly="readonly"></div><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.webHook.webHookNo" for="field_webHookNo">WebHookNo</label> <input type="number" class="form-control" name="webHookNo" id="field_webHookNo" ng-model="vm.webHookModel.web_hook_no" required ng-disabled="true"><div ng-messages="editForm.webHookNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.webHook.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.webHookModel.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.webHook.description" for="field_description">Description</label> <textarea name="description" ng-model="vm.webHookModel.description" id="field_description" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><div layout="row" layout-align="space-between center" class="margin-bottom-20"><span translate="atheer.webHook.events">Events</span></div><div layout="row" layout-wrap flex><div flex="50" ng-repeat="eventSupported in vm.eventsSupported"><md-checkbox ng-checked="vm.existsEvent(eventSupported.name, vm.webHookModel.events)" ng-click="vm.toggleEvent(eventSupported.name, vm.webHookModel.events)"><span translate="atheer.webHook.{{eventSupported.label}}"></span></md-checkbox></div></div><md-input-container class="md-block margin-top-40"><label class="md-required" translate="atheer.webHook.url" for="field_url">Url</label> <input type="url" class="form-control" name="url" id="field_url" ng-model="vm.webHookModel.url" required><div ng-messages="editForm.url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout="row" layout-align="space-between center" class="margin-top-20 margin-bottom-20"><span translate="atheer.webHook.authenticationType">Authentication</span><md-radio-group layout="row" ng-model="vm.webHookModel.auth_type"><md-radio-button value="NONE">None</md-radio-button><md-radio-button value="BEARER_TOKEN">Bearer Token</md-radio-button><md-radio-button value="BASIC">Basic</md-radio-button></md-radio-group></div><md-input-container ng-if="vm.webHookModel.auth_type == \'BEARER_TOKEN\'" class="md-block"><label class="md-required" translate="atheer.webHook.bearer_token_key" for="field_name">Bearer token key</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.webHookModel.auth_header_key" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container ng-if="vm.webHookModel.auth_type == \'BEARER_TOKEN\'" class="md-block"><label class="md-required" translate="atheer.webHook.secret" for="field_name">Secret</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.webHookModel.secret" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container ng-if="vm.webHookModel.auth_type == \'BASIC\'" class="md-block"><label class="md-required" translate="atheer.webHook.username" for="field_name">Username</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.webHookModel.username" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container ng-if="vm.webHookModel.auth_type == \'BASIC\'" class="md-block"><label class="md-required" translate="atheer.webHook.password" for="field_name">Password</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.webHookModel.password" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout="row" layout-align="space-between center" class="margin-bottom-20"><span translate="atheer.webHook.enable">Enable</span><md-switch name="enable" ng-model="vm.webHookModel.enable"></md-switch></div><md-divider></md-divider><div layout="row" layout-align="space-between center" class="margin-top-20"><span translate="atheer.webHook.requestHeader">Request Headers</span><md-button class="md-primary" ng-click="vm.addHeader()"><span translate="atheer.webHook.requestHeaderAdd">Add</span></md-button></div><div layout="row" ng-repeat="requestHeader in vm.webHookModel.headers track by $index"><md-input-container flex="50" class="md-block"><label translate="atheer.webHook.requestHeaderName">Name</label> <input type="text" name="label" ng-model="requestHeader.name"></md-input-container><md-input-container flex="50" class="md-block"><label translate="atheer.webHook.requestHeaderValue">Value</label> <input type="text" name="description" ng-model="requestHeader.value"></md-input-container><div flex="10" layout="row" layout-align="end center" class="request-header-actions"><md-button ng-click="vm.copyHeader(requestHeader)" class="md-icon-button"><fp-tooltip><span translate="atheer.webHook.requestHeaderCopy">Copy</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-copy"></md-icon></md-button><md-button ng-click="vm.removeHeader($index)" class="md-icon-button"><fp-tooltip><span translate="atheer.webHook.requestHeaderRemove">Remove</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-close"></md-icon></md-button></div></div></div></div></div>');
$templateCache.put('modules/sdk/sdk-webhook-test.tmpl.html','<md-dialog flex="70" flex-xs="100" flex-md="70" flex-lg="70" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.webHook.executionDetail">Webhook Execution Log</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.conversation.group.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content" layout="column" layout-padding><div ng-if="vm.testPending" flex class="fp-loading-panel margin-top-80 margin-bottom-80" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.testPending" flex layout="column"><div layout="row" layout-align="start center"><span class="md-body-2" translate="atheer.webHook.status">Status : </span><span>&nbsp;:&nbsp;{{vm.webHookExecution.status}}</span></div><div layout="row" layout-align="start center"><span class="md-body-2" translate="atheer.webHook.responseCode">Response Code : </span><span>&nbsp;:&nbsp;{{vm.webHookExecution.response_code}}</span></div><md-tabs md-center-tabs><md-tab label="Request Payload"><div><p>{{vm.webHookExecution.request_payload}}</p></div></md-tab><md-tab label="Response Payload" class="margin-top-20"><div><pre>{{vm.webHookExecution.response_payload}}</pre></div></md-tab></md-tabs></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/sdk/sdk-webhooks.tmpl.html','<div flex layout="column" layout-fill><div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><h2><span translate="atheer.airSdk.title">AiRSDK</span> - <span translate="atheer.airSdk.webHooks">Webhooks</span></h2><span flex></span><div layout="row"><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.refresh">Refresh</span></fp-tooltip></md-button><div><md-button class="md-primary md-raised" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button></div><fp-help></fp-help></div></div></div><div ng-if="!vm.loadingData && vm.webHooks.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="!vm.loadingData && vm.webHooks.length > 0" class="margin-top-10"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="webHookNo"><span translate="atheer.webHook.webHookNo">WebHookNo</span></th><th md-column md-order-by="name"><span translate="atheer.webHook.name">Name</span></th><th md-column md-order-by="description"><span translate="atheer.webHook.description">Description</span></th><th md-column md-order-by="enabled"><span translate="atheer.webHook.enabled">Enabled</span></th><th md-column md-order-by="created_on"><span translate="atheer.webHook.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="webHook in vm.webHooks track by webHook.id"><td md-cell>{{webHook.web_hook_no}}</td><td md-cell>{{webHook.name}}</td><td md-cell>{{webHook.description}}</td><td md-cell><md-switch name="enabled" ng-model="webHook.enable" ng-change="vm.onEnableChange(webHook)"></md-switch></td><td md-cell am-time-ago="webHook.created_on"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(webHook.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.showWebHookLogs(webHook)"><md-icon class="zmdi zmdi-eye icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteObject(webHook)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.webHooks.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/public/public.tmpl.html','<div ui-view flex></div>');
$templateCache.put('modules/session/session-annotation-ar-builder.tmpl.html','<div id="annotationARContainer" class="annotation-container" flex layout="column" layout-fill><canvas ng-show="!vm.showLoader" id="annotation-ar-canvas" class="annotation-sketch"></canvas><session-annotation-tools ng-if="!vm.showLoader" class="annotation-tools" session-no="vm.sessionId" annotation-type="vm.annotationType" freeze-frame="vm.isFreezeFrame"></session-annotation-tools><div ng-if="vm.isTextBox" flex layout="row" layout-align="center center"><div flex="50" class="ar-textbox-container" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50"><textarea placeholder="{{\'atheer.session.annotations.enterTextPlaceholder\' | translate}}" id="arTextbox" ng-model="vm.text" autofocus></textarea><md-button class="md-icon-button ar-check-button" ng-click="vm.addText()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-check-circle" class="md-icon-green"></md-icon></md-button></div></div><div ng-if="vm.showLoader" flex layout="column" layout-align="center center" class="annotation-spinner h-100"><wave-spinner></wave-spinner></div></div>');
$templateCache.put('modules/session/session-annotation-builder.tmpl.html','<div id="annotationContainer" class="annotation-container" ng-class="{\'annotation-image-loaded\': vm.showCanvas}" flex layout="column" layout-fill><canvas ng-show="vm.showCanvas" id="annotation-canvas" class="annotation-sketch"></canvas><session-annotation-tools annotation-type="\'CLASSIC\'" class="annotation-tools" session-no="vm.sessionId" ng-if="vm.isAnnotationEditAllowed && vm.showCanvas"></session-annotation-tools><div ng-if="vm.showLoader" flex layout="column" layout-align="center center" class="annotation-spinner"><wave-spinner></wave-spinner></div></div>');
$templateCache.put('modules/session/session-annotation-fullscreen.tmpl.html','<md-dialog flex class="fp-annotation-fullscreen-dialog"><md-toolbar md-theme="default"><div class="md-toolbar-tools"><div flex></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div class="md-dialog-content" layout="column"><img ng-src="{{::vm.getMediaUrl()}}"></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/session/session-annotation-mode-dialog.tmpl.html','<md-dialog flex="30"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.sessionPlayer.selectMode">Select annotation mode</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div flex layout="row" class="layout-padding"><div flex layout-align="center center" class="annotation-options"><h5 ng-if="!vm.mainData.isMobileBrowser" hide-xs class="annotation-dialog-sub-header" translate="atheer.session.sessionPlayer.imageMode.title">Image Mode</h5><div flex layout="row" class="annotation-option"><div flex="15" layout="column"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.classicAnnotationMode()" ng-disabled="(vm.mainData.annotationLocked || vm.mainData.isAnnotationView || vm.mainData.isArAnnotating || !vm.mainData.canAnnotate || vm.mainData.isScreenSharing || (vm.mainData.isARSupported && vm.mainData.isMobileBrowser))"><md-icon md-font-icon="zmdi zmdi-center-focus-weak"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.currentVideoFeed">Current Video Feed</span></fp-tooltip></md-button></div><div flex="85" ng-click="vm.classicAnnotationMode()"><p class="heading" translate="atheer.session.sessionPlayer.currentVideoFeed">Current Video Feed</p><p class="sub-heading" translate="atheer.session.sessionPlayer.currentVideoFeedTxt">Annotate on a capture of the video feed you\u2019re looking at right now</p></div></div><div flex layout="row" class="annotation-option"><div flex="15" layout="column"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.shareLocalImage()"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.localImage">Local Image</span></fp-tooltip></md-button></div><div flex="85" ng-click="vm.shareLocalImage()"><p class="heading" translate="atheer.session.sessionPlayer.localImage">Local Image</p><p class="sub-heading" translate="atheer.session.sessionPlayer.localImageTxt">Bring in local images from your device</p></div></div><div flex layout="row" class="annotation-option" ng-if="vm.mainData.isGuest != true"><div flex="15" layout="column"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.shareContent()"><md-icon md-font-icon="zmdi zmdi-collection-image"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.contentLibrary">Content Library</span></fp-tooltip></md-button></div><div flex="85" ng-click="vm.shareContent()"><p class="heading" translate="atheer.session.sessionPlayer.contentLibrary">Content Library</p><p class="sub-heading" translate="atheer.session.sessionPlayer.contentLibraryTxt">Bring in local images from your device</p></div></div><h5 ng-if="vm.mainData.isARSupported && !vm.mainData.isMobileBrowser" hide-xs class="annotation-dialog-sub-header" translate="atheer.session.sessionPlayer.liveMode.title">Live Mode</h5><div ng-if="vm.mainData.isARSupported && !vm.mainData.isMobileBrowser" flex layout="row" class="annotation-option"><div flex="15" layout="column"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.annotateArMode()" ng-disabled="vm.mainData.annotationLocked || vm.mainData.isAnnotationView || vm.mainData.isArAnnotating || !vm.mainData.canAnnotate || vm.mainData.isScreenSharing || (!vm.mainData.isARSupported && vm.mainData.isMobileBrowser)"><md-icon md-font-icon="zmdi zmdi-center-focus-strong"></md-icon><fp-tooltip ng-if="vm.mainData.hasSlam" placement="bottom"><span translate="atheer.session.sessionPlayer.arMode.title">AR Mode</span><fp-tooltip ng-if="!vm.mainData.hasSlam" placement="bottom"><span translate="atheer.session.sessionPlayer.liveMode.title">Live Mode</span></fp-tooltip></fp-tooltip></md-button></div><div flex="85" layout="column" ng-click="vm.annotateArMode()"><div ng-if="vm.mainData.hasSlam"><p class="heading"><span translate="atheer.session.sessionPlayer.arMode.title">AR mode</span></p><p class="sub-heading" translate="atheer.session.sessionPlayer.arMode.description">In this mode, you will annotate on a live camera feed.</p></div><div ng-if="!vm.mainData.hasSlam"><p class="heading"><span translate="atheer.session.sessionPlayer.liveMode.title">Live mode</span></p><p class="sub-heading" translate="atheer.session.sessionPlayer.arMode.description">In this mode, you will annotate on a live camera feed.</p></div></div></div></div></div></md-dialog>');
$templateCache.put('modules/session/session-annotation-save.tmpl.html','<md-dialog flex="60"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 translate="atheer.session.saveAnnotation.title">Save Annotation</h2><md-button class="md-icon-button close-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.saveAnnotation.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div flex layout="row" ng-form="sessionAnnotationToolsSaveForm"><md-input-container flex="95" layout="column" class="md-block"><label id="annotationFileName" ng-class="{ \'label-error\': vm.isError }" class="md-required" translate="atheer.session.saveAnnotation.fileName">File name</label> <input ng-class="{ \'input-error\': vm.isError }" type="text" name="contextNo" id="field_file" ng-model="vm.annotationTitle" required><div ng-messages="sessionAnnotationToolsSaveForm.contextNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div><div ng-if="vm.isError" class="error-msg"><span translate="atheer.session.saveAnnotation.alreadyExists">File Name Already Exist.</span></div></md-input-container><fading-circle-spinner class="validation-spinner margin-auto padding-left-20" layout="column" ng-if="vm.isValidating"></fading-circle-spinner></div><div layout="row" layout-align="end center"><md-button class="md-primary" ng-click="vm.close()" aria-label="primary button" translate="entity.action.cancel">Cancel</md-button><md-button class="md-raised md-primary" ng-click="vm.save()" aria-label="primary button" translate="entity.action.save">Save</md-button></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/session/session-annotation-tools.tmpl.html','<div flex layout="row"><div flex="30" layout="row" layout-align="start center"></div><div flex="40" layout="row" layout-align="center center" class="annotation-tools-container" ng-class="{\'tools-container\': vm.annotationType === \'LIVE\'}"><md-button ng-if="vm.annotationType !== \'LIVE\'" class="md-icon-button" ng-click="vm.updateTool(\'PENCIL\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-edit" class="md-icon-white" ng-class="{\'toolbar-active\': vm.isDefault}" id="annotation-pencil"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.pencil">Pencil</span></md-tooltip></md-button><md-button ng-if="vm.annotationType === \'LIVE\' || vm.annotationType === \'AR\'" class="md-icon-button" ng-click="vm.updateTool(\'LASER\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-flare" class="md-icon-white" id="annotation-laser" ng-class="{\'toolbar-active\': vm.isDefault && vm.annotationType === \'LIVE\'}"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.laser">Laser</span></md-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.updateTool(\'ARROW\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-right-top" class="md-icon-white" id="annotation-arrow"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.arrow">Arrow</span></md-tooltip></md-button><md-button id="colorPalette" class="color-palette" ng-click="vm.updateColor()"><md-tooltip md-direction="bottom" style="margin-top: 16px;"><span translate="atheer.session.annotationTools.color">Color</span></md-tooltip></md-button><!-- color palette starts here --><div flex layout="row" layout-align="center center" ng-if="vm.openColorPalette" class="color-container"><md-button id="colorRed" class="color-palette" ng-click="vm.setOrUpdateColor(\'RED\')"></md-button><md-button id="colorDarkYellow" class="color-palette" ng-click="vm.setOrUpdateColor(\'DARK_YELLOW\')"></md-button><md-button id="colorYellow" class="color-palette" ng-click="vm.setOrUpdateColor(\'YELLOW\')"></md-button><md-button id="colorGreen" class="color-palette" ng-click="vm.setOrUpdateColor(\'GREEN\')"></md-button><md-button id="colorBlue" class="color-palette" ng-click="vm.setOrUpdateColor(\'BLUE\')"></md-button><md-button id="colorViolet" class="color-palette" ng-click="vm.setOrUpdateColor(\'VIOLET\')"></md-button><md-button id="colorPink" class="color-palette" ng-click="vm.setOrUpdateColor(\'PINK\')"></md-button><md-button id="colorWhite" class="color-palette" ng-click="vm.setOrUpdateColor(\'WHITE\')"></md-button><md-button id="colorBlack" class="color-palette" ng-click="vm.setOrUpdateColor(\'BLACK\')"></md-button></div><!-- color palette ends here --><md-button ng-if="vm.annotationType !== \'LIVE\'" class="md-icon-button" ng-click="vm.updateTool(\'TEXT\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-text-format" class="md-icon-white" id="annotation-text"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.text">Text</span></md-tooltip></md-button><md-button ng-if="vm.annotationType !== \'LIVE\'" class="md-icon-button" ng-click="vm.updateTool(\'UNDO\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-undo" class="md-icon-white"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.undo">Undo</span></md-tooltip></md-button><md-button ng-if="vm.annotationType !== \'LIVE\'" class="md-icon-button" ng-click="vm.updateTool(\'CLEAR\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-replay" class="md-icon-white"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.clear">Clear</span></md-tooltip></md-button><md-button ng-if="vm.annotationType !== \'LIVE\' && vm.annotationType !==\'AR\'" class="md-icon-button" aria-label="primary button" ng-click="vm.saveAnnotation()"><md-icon md-font-icon="zmdi zmdi-file-plus" class="md-icon-white"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.save">Save Annotation</span></md-tooltip></md-button><md-button ng-if="vm.annotationType === \'LIVE\' || vm.annotationType === \'AR\'" class="md-icon-button" ng-click="vm.updateTool(\'FREEZE_FRAME\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-center-focus-weak" class="md-icon-white"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.freezeFrame">Freeze Frame</span></md-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" ng-if="!vm.freezeFrame" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close" class="md-icon-white"></md-icon><md-tooltip md-direction="bottom" style="margin-top: 6px;"><span translate="atheer.session.annotationTools.close">Close</span></md-tooltip></md-button></div><div flex="30" layout="row" layout-align="end center"></div></div>');
$templateCache.put('modules/session/session-annotation-zip.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.annotations.download">Download All AiRSession Annotations</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span>Close</span></fp-tooltip></md-button></div></md-toolbar><md-content flex layout="row"><div flex ng-if="vm.jobStatus !== \'complete\'" layout="row" layout-align="center center" class="margin-bottom-20"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-padding layout-align="center" class="margin-top-40" layout-align="center"><div layout="row" layout-align="center"><md-progress-circular class="md-hue-2" md-mode="indeterminate"></md-progress-circular></div><div layout="row" layout-align="center" class="margin-top-40"><span class="md-subhead" translate="atheer.session.annotations.zipping">Preparing Zip File. Please wait...</span></div></div></div></div><div ng-if="vm.jobStatus === \'complete\'" flex layout="row" layout-align="center center"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><md-button class="md-primary md-raised" ng-click="vm.download()" translate="entity.action.downloadAnnotations">Click here to Download</md-button></div></div></div></md-content></md-dialog>');
$templateCache.put('modules/session/session-annotations.tmpl.html','<md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'annotationPanel\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><span translate="atheer.session.annotations.title" translate-values="{sessionNo: \'{{vm.sessionModel.session_no}}\'}">AiRSession Annotations - {{vm.sessionModel.session_no}}</span><div flex></div><md-button ng-if="!vm.loadingData && vm.sessionActivities.length > 0" class="md-icon-button" aria-label="primary button" ng-click="vm.downloadZip()"><md-icon class="fa fa-download icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.insights.downloadAll">Download All</span></fp-tooltip></md-button></div></md-toolbar><div ng-if="vm.loadingData" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessionActivities.length == 0" flex layout="column" layout-align="center center" layout-fill><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.session.annotations.noAnnotations">There are no annotations yet for this session.</div></div><div ng-if="!vm.loadingData && vm.sessionActivities.length > 0" layout="row" layout-wrap layout-align="start center" class="padding-top-20 padding-left-10 padding-right-10"><div div flex="50" ng-repeat="sessionActivity in vm.sessionActivities track by $index"><md-card><md-card-header><md-card-header-text><span class="md-title">{{sessionActivity.properties.file_name}}</span></md-card-header-text></md-card-header><img ng-src="{{::vm.getMediaUrl(sessionActivity)}}"><md-card-actions layout="row" layout-align="end center"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.download(sessionActivity, $index)"><md-icon class="zmdi zmdi-download"></md-icon></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.fullScreen(sessionActivity)"><md-icon class="zmdi zmdi-fullscreen"></md-icon></md-button></md-card-actions></md-card></div></div><md-table-pagination class="session-annotation-pagination" flex="100" md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessionActivities.length > 0"></md-table-pagination>');
$templateCache.put('modules/session/session-copy-invitation-dialog.tmpl.html','<md-dialog flex="40"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.copyInvitation">Cop</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div ng-if="vm.loadingData" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><md-dialog-content ng-if="!vm.loadingData" class="md-dialog-content"><div flex layout="column" class="fp-session-copy-box"><span class="md-subhead margin-bottom-20">{{vm.userFullName}} <span translate="atheer.session.copyInvitationText">is inviting you to a AiRSession.</span></span> <span class="md-subhead"><span translate="atheer.session.topic">Topic</span>: {{vm.session.topic}}</span> <span class="md-subhead margin-bottom-20"><span translate="atheer.session.copyStartTime">Start Time</span>: {{vm.session.start_time | date: \'MMM dd, y hh:mm a\'}} - {{vm.timezoneName}}</span> <span class="md-subhead" translate="atheer.session.upcomingSessions.joinAirSession">Join AiRSession</span> <span class="md-subhead margin-bottom-20">{{vm.sessionJoinUrl}}</span> <span class="md-subhead"><span translate="atheer.session.sessionNo">AiRSession No</span>: {{vm.session.session_no}}</span> <span ng-if="vm.session.use_passcode" class="md-subhead"><span translate="atheer.session.detail.passcode">Passcode</span>: {{vm.session.passcode}}</span></div></md-dialog-content><md-dialog-actions ng-if="!vm.loadingData" layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button class="md-primary md-raised" ngclipboard data-clipboard-text="{{vm.invitationText}}" ngclipboard-success="vm.onCopySuccess(e)"><span translate="atheer.session.info.copy">Copy</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/session/session-detail-toolbar.tmpl.html','<md-toolbar ng-if="vm.sessionType == \'PERSONAL\'" class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToSessions()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="atheer.session.home.personal">AiRSessions</span></h2><span flex></span><md-button permission permission-only="vm.permissions.create" class="md-accent md-raised" ng-if="vm.nonEditmode" ng-click="vm.startPersonalSession()" aria-label="primary button"><span translate="entity.action.start">Start</span></md-button><md-button ng-if="vm.nonEditmode" class="md-icon-button" ng-click="vm.editPersonalSession()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-edit"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.detail.edit">Edit Details</span></fp-tooltip></md-button><md-button ng-if="!vm.nonEditmode" type="submit" class="md-accent md-raised" ng-disabled="vm.sessionDetailForm.$invalid || vm.isSaving" ng-click="vm.updatePersonalSession()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><md-toolbar ng-if="vm.sessionType == \'SCHEDULED\' || vm.sessionType == \'TEMPLATE\'" class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToSessions()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span flex translate="atheer.session.detail.airSessionDetail">AiRSession Detail</span><md-button type="submit" class="md-accent" ng-click="vm.cancelSaveSession()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" class="md-accent md-raised" type="submit" ng-disabled="vm.sessionDetailForm.$invalid || vm.isSaving" ng-click="vm.saveSession()"><span translate="entity.action.save">Save</span></md-button><md-menu ng-if="vm.sessionType == \'SCHEDULED\'"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" type="submit" ng-disabled="vm.sessionDetailForm.$invalid" ng-click="vm.saveAsTemplate()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><span translate="atheer.session.upcomingSessions.saveAs">Save as Template</span></md-button></md-menu-item></md-menu-content></md-menu><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/session/session-detail.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="column" ng-if="!vm.loadingData" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="50" layout="column" ng-form="vm.sessionDetailForm"><md-input-container ng-if="!vm.isNew()" class="md-block"><label ng-if="vm.sessionType != \'PERSONAL\'" class="md-required" translate="atheer.session.sessionNo" for="field_sessionNo">No</label> <label ng-if="vm.sessionType == \'PERSONAL\'" class="md-required" translate="atheer.session.detail.personalRoom">You Personal Room No</label> <input type="number" class="form-control" name="contextNo" id="field_contextNo" ng-model="vm.sessionModel.session_no" required ng-disabled="true"><div ng-messages="vm.sessionDetailForm.sessionNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.session.topic">Topic</label> <input type="text" name="topic" ng-model="vm.sessionModel.topic" md-select-on-focus required ng-disabled="vm.sessionType == \'PERSONAL\' && vm.nonEditmode"><div ng-messages="vm.sessionDetailForm.topic.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container ng-if="vm.sessionType != \'TEMPLATE\'" class="md-block"><label translate="atheer.session.agenda">Agenda</label> <input type="text" name="agenda" ng-model="vm.sessionModel.agenda" md-select-on-focus ng-disabled="vm.sessionType == \'PERSONAL\' && vm.nonEditmode"></md-input-container><div flex layout="column" class="margin-align-md-input" ng-if="vm.sessionType != \'PERSONAL\' && vm.sessionType != \'TEMPLATE\' && vm.templates.length != 0 && vm.sessionModel.id == null && vm.sessionTemplate"><div flex layout="row"><div flex="60" class="padding-top-20"><span translate="atheer.session.detail.useTemplate">Use Template</span></div><div layout="row" flex><div flex layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.use_template" ng-change="vm.toggleTemplate()"></md-switch></div></div></div><md-input-container class="md-block" ng-if="vm.sessionModel.use_template"><label translate="atheer.session.detail.template">choose a template</label><md-select ng-model="vm.sessionModel.templates" class="md-no-underline" ng-change="vm.filterTemplate()" style="margin-bottom: 0px !important;"><md-option ng-repeat="template in vm.templates" ng-value="template">{{template.topic}}</md-option></md-select></md-input-container></div><md-divider ng-if="vm.sessionType != \'PERSONAL\' && vm.sessionType != \'TEMPLATE\' && vm.templates.length != 0 && vm.sessionModel.id == null && vm.sessionTemplate" class="margin-bottom-20 margin-align-md-input"></md-divider><div flex layout="column" class="margin-align-md-input" ng-if="vm.sessionType != \'PERSONAL\' && vm.sessionType != \'TEMPLATE\'"><div flex layout="row"><div flex="60" class="padding-top-20"><span translate="atheer.session.detail.passcode">Use Passcode</span></div><div layout="row" flex><div flex layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.use_passcode"></md-switch></div></div></div></div><div ng-if="vm.sessionModel.use_passcode && vm.sessionType != \'PERSONAL\' && vm.sessionType != \'TEMPLATE\'" layout="row" layout-align="center center" class="confirm_input margin-bottom-20 margin-align-md-input"><div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.passcode1" class="inline_input" maxlength="1" ng-change="vm.checkPasscode(vm.passcode1, 1)" ng-keydown="vm.onNumberInputKeydown($event)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.passcode2" class="inline_input" maxlength="1" ng-change="vm.checkPasscode(vm.passcode2, 2)" ng-keydown="vm.onNumberInputKeydown($event)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.passcode3" class="inline_input" maxlength="1" ng-change="vm.checkPasscode(vm.passcode3, 3)" ng-keydown="vm.onNumberInputKeydown($event)"></div></div><div class="confirmation_code_span_cell">&#45;</div><div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.passcode4" class="inline_input" maxlength="1" ng-change="vm.checkPasscode(vm.passcode4, 4)" ng-keydown="vm.onNumberInputKeydown($event)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.passcode5" class="inline_input" maxlength="1" ng-change="vm.checkPasscode(vm.passcode5, 5)" ng-keydown="vm.onNumberInputKeydown($event)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.passcode6" class="inline_input" maxlength="1" ng-change="vm.checkPasscode(vm.passcode6, 6)" ng-keydown="vm.onNumberInputKeydown($event)"></div></div></div><md-divider ng-if="vm.sessionType != \'PERSONAL\' && vm.sessionType != \'TEMPLATE\'" class="margin-bottom-20 margin-align-md-input"></md-divider><div flex ng-if="!vm.isNew() && vm.sessionType != \'TEMPLATE\'" layout="row" layout-align="space-between center"><div flex="80" layout-align="start center" class="padding-top-10"><md-input-container class="md-block"><label translate="atheer.session.detail.url">Join URL</label> <input type="text" name="url" ng-model="vm.sessionModel.url" md-select-on-focus required ng-disabled="true"><div ng-messages="vm.sessionDetailForm.website_url.$error"><div ng-message when="required"><span translate="entity.action.required">This field is required.</span></div></div></md-input-container></div><div flex layout-align="center end"><md-button type="submit" ng-click="vm.copyInvitation()"><span translate="atheer.session.copyInvitation">Copy Invitation</span></md-button></div></div><div flex layout="row" ng-if="vm.sessionType != \'PERSONAL\' && vm.sessionType != \'TEMPLATE\'"><div flex="20" class="padding-top-10"><span translate="atheer.session.detail.start">Start</span></div><div flex="40" class="padding-top-10"><md-datepicker ng-model="vm.sessionModel.date" md-placeholder="{{\'atheer.session.detail.selectDate\' | translate}}"></md-datepicker></div><div flex><md-time-picker ng-model="vm.sessionModel.date" message="vm.testTimeMessage"></md-time-picker></div></div><div flex layout="row" class="margin-align-md-input" ng-if="vm.sessionType != \'PERSONAL\'"><div flex="20" class="padding-top-20"><span translate="atheer.session.duration">Duration</span></div><div layout="column" class="margin-right-20"><md-select ng-model="vm.sessionModel.hrs" class="md-no-underline"><md-option ng-repeat="hr in vm.hrs" md-placeholder="hr" ng-value="hr">{{hr}}</md-option></md-select></div><div class="padding-top-20 margin-right-20"><span translate="atheer.session.detail.hr">hr</span></div><div layout="column" class="margin-right-20"><md-select ng-model="vm.sessionModel.minutes" class="md-no-underline"><md-option ng-repeat="minute in vm.minutes" ng-value="minute" md-placeholder="min">{{minute}}</md-option></md-select></div><div class="padding-top-20 margin-right-20"><span translate="atheer.session.detail.min">min</span></div></div><md-input-container class="md-block" ng-if="vm.sessionType != \'PERSONAL\'"><div flex="20" class="padding-top-10"><span translate="atheer.session.detail.timezone">Timezone</span></div><md-select ng-model="vm.sessionModel.timezone_id" class="md-no-underline"><md-option ng-repeat="timezone in vm.timezones" ng-value="timezone.timezone_no">{{timezone.display_name}}</md-option></md-select></md-input-container><md-divider ng-if="vm.sessionType != \'PERSONAL\'"></md-divider><div ng-if="vm.isSchedulerVisible()"><div flex="30" class="padding-top-20 margin-align-md-input"><span translate="atheer.session.detail.host">Host</span></div><div class="fp-user-chips" flex><fp-auto-complete is-session="true" input-form-field-name="host" error-modal="vm.sessionDetailForm.host" is-scheduled-session="true" no-label="true" auto-complete-model="vm.host" component="SessionSingleUserInvite" multiple="false" required="\'true\'" scheduler-user-info="vm.host"></fp-auto-complete></div></div><div ng-if="vm.sessionType != \'PERSONAL\' && vm.sessionType != \'TEMPLATE\'"><div flex="30" class="padding-top-20 margin-align-md-input"><span translate="atheer.session.detail.participants">Participants</span></div><div class="fp-user-chips" flex><fp-auto-complete is-session="true" is-scheduled-session="true" no-label="true" special-filter="vm.isNotInParticipant(result)" auto-complete-model="vm.sessionModel.session_users" component="UserInvite" multiple="true" scheduler-user-info="vm.getHost()"></fp-auto-complete></div></div><div class="margin-bottom-40"></div><div class="margin-align-md-input" ng-if="vm.recurrsionSessionOn" flex layout="column" ng-if="vm.sessionType != \'PERSONAL\' && vm.recurringSessionFeature"><div flex layout="row"><div flex="30" class="padding-top-20"><span translate="atheer.session.detail.recurring">Recurring</span></div><div layout="row" flex><div flex layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.recurring_session"></md-switch></div></div></div><div ng-if="vm.recurring_session" flex="80" layout="column"><div flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.detail.recurrence">Recurrence</div><div flex="20" layout="column" layout-align="center end"><md-select ng-model="vm.sessionModel.recurring_settings.recurring_type" class="md-no-underline"><md-option ng-repeat="recur in vm.possible_recurring_session" ng-value="recur" md-placeholder="recur">{{recur}}</md-option></md-select></div></div></div><div flex layout="row" ng-if="vm.sessionModel.recurring_settings.recurring_type!=\'No Fixed Time\'"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.detail.repeatEvery">Repeat Every</div><div flex="40" layout="column" layout-align="center end"><md-select ng-model="vm.sessionModel.recurring_settings.repeat" class="md-no-underline"><md-option ng-repeat="repeat in vm.repeats" ng-value="repeat" md-placeholder="repeat">{{repeat}}</md-option></md-select></div><div flex="20" layout="column" layout-align="center end" ng-if="vm.sessionModel.recurring_settings.recurring_type==\'Daily\'" translate="atheer.session.detail.day">day</div><div flex="20" layout="column" layout-align="center end" ng-if="vm.sessionModel.recurring_settings.recurring_type==\'Weekly\'" translate="atheer.session.detail.week">week</div><div flex="20" layout="column" layout-align="center end" ng-if="vm.sessionModel.recurring_settings.recurring_type==\'Monthly\'" translate="atheer.session.detail.month">month</div></div></div><div flex layout="row" ng-if="vm.sessionModel.recurring_settings.recurring_type==\'Weekly\' || vm.sessionModel.recurring_settings.recurring_type==\'Monthly\'"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.detail.occursOn">Occurs On</div><div flex="80" layout="column" layout-align="center end"><div ng-if="vm.sessionModel.recurring_settings.recurring_type==\'Weekly\'" class="margin-right-20"><label ng-repeat="day in vm.days" ng-value="day"><md-checkbox ng-model="day.isSelected">{{day.name}}</md-checkbox></label></div><md-radio-group class="md-block margin-bottom-20" layout="row" layout-align="space-around center" ng-model="vm.sessionModel.monthlyFreq"><md-radio-button ng-if="vm.sessionModel.recurring_settings.recurring_type==\'Monthly\'" layout="row" class="margin-right-20" value="monthlyWithNumOfDays"><span translate="atheer.session.detail.day">Day</span></md-radio-button><md-select ng-model="vm.sessionModel.monthly_occurs.day_nth_of_month" class="md-no-underline"><md-option ng-repeat="num in vm.numOfdays" ng-value="num" md-placeholder="num">{{num}}</md-option></md-select><span translate="atheer.session.detail.ofTheMonth">of the month</span><md-radio-button ng-if="vm.sessionModel.recurring_settings.recurring_type==\'Monthly\'" layout="row" class="margin-right-20" value="nthDaysFreq"></md-radio-button><md-select ng-model="vm.sessionModel.monthly_occurs.nth_week_day" class="md-no-underline"><md-option ng-repeat="fDay in vm.frequencyDays" ng-value="fDay" md-placeholder="fDay">{{fDay}}</md-option></md-select><md-select ng-model="vm.sessionModel.monthly_occurs.day_of_week" class="md-no-underline"><md-option ng-repeat="wDay in vm.weekDays" ng-value="wDay" md-placeholder="wDay">{{wDay}}</md-option></md-select><span translate="atheer.session.detail.ofTheMonth">of the month</span></md-radio-group></div></div></div><div flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.detail.endDate">End Date</div><div flex="20" layout="column" layout-align="center end"><md-datepicker ng-model="vm.sessionModel.recurring_settings.end_date" md-placeholder="{{\'atheer.session.detail.selectDate\' | translate}}"></md-datepicker></div></div></div></div></div><!--md-divider ng-if="vm.sessionType != \'PERSONAL\'"></md-divider--><div class="margin-align-md-input" flex layout="column"><div flex layout="row"><div flex="30" class="padding-top-20"><span translate="atheer.session.personalSession.video.video">Video</span></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.personalSession.video.host">Host</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.host_video" ng-disabled="vm.sessionType == \'PERSONAL\' && vm.nonEditmode"></md-switch></div></div></div><div flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.personalSession.video.participant">Participant</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.participant_video" ng-disabled="vm.sessionType == \'PERSONAL\' && vm.nonEditmode"></md-switch></div></div></div></div><md-divider></md-divider><div class="margin-align-md-input" flex layout="column"><div flex layout="row"><div flex="30" class="padding-top-20"><span translate="atheer.session.personalSession.sessionOptions">AiRSession Options</span></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.personalSession.enableJoin">Enable join before host</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.join_before_host" ng-disabled="vm.sessionType == \'PERSONAL\' && vm.nonEditmode"></md-switch></div></div></div><div flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.personalSession.muteParticipants">Mute participants upon entry</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.mute_upon_entry" ng-disabled="vm.sessionType == \'PERSONAL\' && vm.nonEditmode"></md-switch></div></div></div><div ng-if="vm.enableWaitingRoom" flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.personalSession.enableWaiting">Enable waiting room</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.enable_waiting_room" ng-disabled="vm.sessionType == \'PERSONAL\' && vm.nonEditmode"></md-switch></div></div></div></div></div></div></md-content></div>');
$templateCache.put('modules/session/session-feedback-dialog.tmpl.html','<md-dialog flex="{{!vm.isMobileBrowser ? 50 : 100}}" aria-label="" ng-class="{\'fp-mobile-dialog\': vm.isMobileBrowser}"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.feedback.rate">Rate your session experience</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div layout="column" layout-align="center center" class="fp-mobile-dialog"><md-dialog-content class="md-dialog-content full-width"><div layout="row" layout-align="center center"><div layout="column"><div layout-align="center center" fp-rating rating="vm.rating" color="\'orange\'" shape-type="STAR" max-rating="5"></div><div flex layout="row" layout-align="space-between center"><div class="md-caption" translate="atheer.session.close.veryBad">Very Bad</div><div class="md-caption"></div><div class="md-caption" translate="atheer.session.close.veryGood">Very Good</div></div></div></div><div flex layout="row" layout-align="center center" class="margin-top-20"><md-input-container flex="80" class="md-block"><label for="field_feedback" translate="atheer.session.feedback.feedback">Please provide your feedback here:</label> <textarea name="description" ng-model="vm.ratingFeedback" id="field_feedback" md-no-resize maxlength="255" md-maxlength="255" rows="3"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" class="full-width"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" class="md-primary"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></div></md-dialog>');
$templateCache.put('modules/session/session-info-dialog.tmpl.html','<md-dialog flex="100" aria-label="" ng-class="{\'fp-mobile-dialog\': vm.isMobileBrowser}"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.sessionPlayer.info">AiRSession Information</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content fp-mobile-dialog"><div layout="column" layout-align="center center" class="fp-mobile-dialog"><div layout="row" layout-align="center center" class="full-width"><div class="padding-20 full-width" layout="column" layout-align="start start"><span class="md-title">{{vm.sessionModel.topic}}</span></div></div><div layout="row" layout-align="center center" class="full-width"><div flex class="padding-left-20 padding-bottom-20" layout="column"><div flex layout="row"><div flex="20" layout-align="start center"><span class="md-body-1" ng-class="{\'text-overflow\': vm.isMobileBrowser}" translate="atheer.session.info.sessionNo">Session No</span></div><div flex layout-align="start center"><span class="md-body-2">{{vm.sessionModel.session_no}}</span></div></div><div flex layout="row" class="margin-top-10"><div flex="20" layout-align="start center"><span class="md-body-1" translate="atheer.session.info.code">Code</span></div><div flex layout-align="start center"><span class="md-body-2">{{vm.code}}</span></div></div><div flex layout="row" class="margin-top-10"><div flex="20" layout-align="start center"><span class="md-body-1" translate="atheer.session.info.host">Host</span></div><div flex="70" layout-align="start center"><span class="md-body-2">{{vm.sessionModel.owner_info.first_name}} {{vm.sessionModel.owner_info.last_name}}</span></div><div flex layout-align="start center"></div></div><div flex layout="row" class="margin-top-10"><div flex="20" layout-align="start center" class="margin-auto"><span class="md-body-1" translate="atheer.session.info.url">URL</span></div><div flex="80" layout-align="start center" layout="row"><span class="md-body-2" ng-class="{\'text-overflow\': vm.isMobileBrowser}">{{vm.sessionUrl}}</span><md-button ngclipboard data-clipboard-text="{{vm.sessionUrl}}" class="md-icon-button" ngclipboard-success="vm.onCopySuccess(e)" ng-click="vm.copyTopic()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.info.copy">Copy</span></fp-tooltip></md-button></div></div></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/session/session-info-panel.tmpl.html','<div class="fp-session-info-panel" layout="column" ng-class="{\'fp-session-info-panel-mobile-browser\' : vm.isMobileBrowser}"><div class="padding-20" layout="column" layout-align="start start"><span class="md-title">{{vm.sessionModel.topic}}</span></div><div flex class="padding-left-20 padding-bottom-20" layout="column"><div flex layout="row"><div flex="20" layout-align="start center"><span class="md-body-1" ng-class="{\'text-overflow\': vm.isMobileBrowser}" translate="atheer.session.info.sessionNo">Session No</span></div><div flex layout-align="start center"><span class="md-body-2">{{vm.sessionModel.session_no}}</span></div></div><div flex layout="row" class="margin-top-10"><div flex="20" layout-align="start center"><span class="md-body-1" translate="atheer.session.info.code">Code</span></div><div flex layout-align="start center"><span class="md-body-2">{{vm.code}}</span></div></div><div flex layout="row" class="margin-top-10"><div flex="20" layout-align="start center"><span class="md-body-1" translate="atheer.session.info.host">Host</span></div><div flex="70" layout-align="start center"><span class="md-body-2">{{vm.sessionModel.owner_info.first_name}} {{vm.sessionModel.owner_info.last_name}}</span></div><div flex layout-align="start center"></div></div><div flex layout="row" class="margin-top-10"><div flex="20" layout-align="start center" class="margin-auto"><span class="md-body-1" translate="atheer.session.info.url">URL</span></div><div flex="80" layout-align="start center" layout="row"><span class="md-body-2" ng-class="{\'text-overflow\': vm.isMobileBrowser}">{{vm.sessionUrl}}</span><md-button ngclipboard data-clipboard-text="{{vm.sessionUrl}}" class="md-icon-button" ngclipboard-success="vm.onCopySuccess(e)" ng-click="vm.copyTopic()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.info.copy">Copy</span></fp-tooltip></md-button></div></div></div></div>');
$templateCache.put('modules/session/session-insights.tmpl.html','<md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel()"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><span translate="atheer.session.insights.title" translate-values="{sessionNo: \'{{vm.sessionModel.session_no}}\'}">AiRSession Insights - {{vm.sessionModel.session_no}}</span><div flex></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.downloadReport()"><md-icon class="fa fa-download icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.insights.downloadReport">Download Report</span></fp-tooltip></md-button></div></md-toolbar><div ng-if="vm.loadingData || vm.isLoadingFeedback" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && !vm.isLoadingFeedback" layout="row" layout-margin><div flex="30" layout="column" class="margin-0 padding-10"><tri-widget content-layout="column" content-layout-align="space-around start" content-padding class="margin-10 insight-widgets"><p class="md-body-2 margin-top-0 margin-bottom-0" translate="atheer.session.insights.timeDuration">Time duration</p><div layout="row"><p class="time-duration margin-top-0 margin-bottom-0" countupto="vm.sessionModel.session_stats.duration" duration="1.5" decimals="0"></p><span class="time-duration-mins" translate="atheer.session.insights.mins">mins</span></div></tri-widget><tri-widget content-layout="column" content-layout-align="space-around start" content-padding class="fp-rating-summary margin-10 insight-widgets"><p class="md-body-2 margin-top-0 margin-bottom-0" translate="atheer.session.insights.avgRating">Average rating</p><div fp-rating read-only="true" rating="vm.sessionModel.session_stats.avg_rating" color="\'orange\'" shape-type="star" max-rating="5"></div></tri-widget><div class="insight-widgets margin-10 h-300 scroll"><div class="padding-10"><div class="participant-title" translate="atheer.session.insights.participants">Participants</div><div class="participants-count">{{vm.participantsList.length}}</div><div layout="row" class="participants-list" ng-repeat="participant in vm.participantsList"><img layout="column" ng-src="{{vm.getProfilePicture(participant)}}" alt="avatar" class="make-round" width="22" height="22"><div class="participant-name text-overflow" layout="row">{{participant.first_name}} {{participant.last_name}}</div><div ng-if="participant.joined" class="participant-joined" ng-style="{\'background-color\': \'{{vm.backgroundColor}}\'}" translate="atheer.session.insights.joined">Joined</div></div><!--for guest--><div class="participant-title" translate="atheer.session.insights.guest">Guest</div><div class="participants-count">{{vm.guestList.length}}</div><div layout="row" class="participants-list" ng-repeat="guest in vm.guestList"><img layout="column" ng-src="{{vm.getProfilePicture(guest)}}" alt="avatar" class="make-round" width="22" height="22"><div class="participant-name text-overflow" layout="column">{{guest.first_name}} {{guest.last_name}}</div><div ng-if="guest.joined" class="participant-joined" ng-style="{\'background-color\': \'{{vm.backgroundColor}}\'}" translate="atheer.session.insights.joined">Joined</div></div></div></div></div><div flex="70" flex-xs="100" layout="column" class="margin-0 padding-10"><div class="insight-widgets margin-10 widget-height"><md-tabs class="session-insights-tab"><md-tab md-active="true"><md-tab-label><span translate="atheer.session.insights.activityLog">Activity Log</span></md-tab-label><md-tab-body><div class="p-30 session-insight-date-wrapper text-overflow">{{vm.sessionModel.start_time | date: "fullDate"}}</div><div ng-if="vm.sessionActivities.length == 0" flex layout="column" layout-align="center center" class="padding-30"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.session.insights.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.session.insights.noActivities">There are no session activities yet.</div></div><div ng-if="vm.sessionActivities.length > 0" class="session-activities-wrapper"><div class="p-15"><div layout="row"><div layout="column" class="w-30 insights-description-title" translate="atheer.session.insights.time">Time</div><div layout="column" class="w-70"><div layout="row"><div layout="column" class="w-50 insights-description-title" translate="atheer.session.insights.activity">Activity</div><div layout="column" class="w-50 insights-description-title" translate="atheer.session.insights.activator">Activator</div></div></div></div><hr class="divider"></div><div ng-if="vm.loadingActivities" class="activities-height" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div class="activities-height p-15 scroll" ng-if="!vm.loadingActivities"><div class="session-activities" layout="row" ng-repeat="sessionActivity in vm.session_activities track by $index"><div layout="column" class="w-30"><div layout="row"><div layout="column" class="w-80 session-activity-createdOn text-overflow">{{ sessionActivity.created_on }}</div><div layout="column" class="w-20 p-t-5"><div layout="row" ng-class="{\'upper-line\': !$first}"></div><div layout="row" class="session-activity-dot"></div><div layout="row" class="session-activity-line" id="activity-line-{{$index}}"></div></div></div></div><div layout="column" class="w-70"><div layout="row" class="session-activity" ng-repeat="activity in sessionActivity.activities"><div ng-if="activity.activity!=\'ANNOTATION_SAVED\'" layout="column" class="w-50 session-activity-activityType text-overflow">{{activity.activity}}<md-tooltip md-direction="top">{{activity.activity}}</md-tooltip></div><div ng-if="activity.activity==\'ANNOTATION_SAVED\'" layout="column" class="w-50 session-activity-activityType text-overflow">SCREENSHOT_SAVED</div><div layout="column" class="w-50"><div layout="row"><img layout="column" ng-src="{{vm.getProfilePicture(activity.user_info)}}" alt="avatar" class="make-round" width="22" height="22"><div layout="column" class="session-activity-createdBy text-overflow">{{activity.activator}}</div></div></div></div></div></div></div></div><md-table-pagination class="session-insights-pagination" flex="100" md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessionActivities.length > 0"></md-table-pagination></md-tab-body></md-tab><md-tab md-active="false"><md-tab-label><span>{{\'atheer.session.insights.ratingsAndComments\' | translate}}<span class="feedback-count">{{vm.feedbackQueryCount}}</span></span></md-tab-label><md-tab-body><div class="padding-30 session-insight-date-wrapper">{{vm.sessionModel.created_on | date: "fullDate"}}</div><div class="ratings-and-comments-wrapper" layout="column" ng-if="vm.ratingAndCommentsActivities.length == 0" layout-align="center center"><img src="/assets/images/card/NoRatingsAndComments.svg"><div class="margin-top-10 base" translate="atheer.session.insights.noComments">No comments were provided in this AiRSession</div></div><div class="ratings-and-comments-wrapper scroll" layout="column" ng-if="vm.ratingAndCommentsActivities.length > 0" class="p-30"><div ng-if="vm.loadingFeedbackActivities" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingFeedbackActivities" class="padding-right-30 padding-left-30 padding-bottom-30" ng-repeat="feedback in vm.feedbackActivities"><div layout="row" layout-align="space-between center"><div layout="column"><div layout="row"><img layout="column" ng-src="{{vm.getProfilePicture(feedback.user_info)}}" alt="avatar" class="make-round" width="24" height="24"><div class="participant-name line-height-16 text-overflow" layout="column">{{feedback.user_info.first_name}} {{feedback.user_info.last_name}}</div></div></div><div layout="column"><tri-widget ng-if="feedback.properties.rating" content-layout="column" content-layout-align="space-around center" content-padding class="feedback-summary-rating"><div fp-rating read-only="true" rating="feedback.properties.rating" color="\'orange\'" shape-type="star" max-rating="5"></div></tri-widget></div></div><div layout="row" class="feedback-summary-content">{{feedback.properties.feedback}}</div></div></div><md-table-pagination class="session-insights-pagination" flex="100" md-limit="vm.feedbackPageSize" md-total="{{vm.feedbackQueryCount}}" md-boundary-links="true" md-page="vm.feedbackPage" md-on-paginate="vm.feedbackTransition" ng-if="vm.ratingAndCommentsActivities.length > 0"></md-table-pagination></md-tab-body></md-tab></md-tabs></div></div></div>');
$templateCache.put('modules/session/session-jitsi-player-conversation.tmpl.html','<div layout="column" layout-fill><md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span translate="atheer.session.sessionPlayer.conversation">Conversation</span><div flex></div><md-button class="md-icon-button" ng-click="vm.toggleConversation()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><conversation-message-list ng-if="!vm.loadingData" flex layout="column" conversation="vm.sessionModel.conversation_info" empty-illustration="vm.emptyIllustration" conversation-id="vm.sessionModel.conversation_info.id"></conversation-message-list><conversation-message-editor is-guest="vm.isGuest" ng-if="!vm.loadingData && vm.sessionModel.conversation_info != null" conversation-model="vm.sessionModel.conversation_info"></conversation-message-editor></div>');
$templateCache.put('modules/session/session-jitsi-player-users.tmpl.html','<div layout="column" layout-fill><md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span translate="atheer.session.sessionPlayer.users">Users</span><div flex></div><md-button class="md-icon-button" ng-click="vm.toggleUsers()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div flex><md-list><md-list-item ng-repeat="sessionUser in vm.sessionUsers"><fp-avatar user="sessionUser" presence="false" camel-case="true" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="25"></fp-avatar><p style="margin:0;padding:10px;">{{sessionUser.firstName}} {{sessionUser.lastName}} <span ng-if="!sessionUser.isHost && vm.userId === sessionUser.userId" translate="atheer.session.sessionPlayer.isMe">(Me)</span> <span ng-if="sessionUser.isHost && vm.userId === sessionUser.userId" translate="atheer.session.sessionPlayer.isHostMe">(Host,Me)</span> <span ng-if="sessionUser.isHost && vm.userId != sessionUser.userId" translate="atheer.session.sessionPlayer.isHost">(Host)</span> <span ng-if="sessionUser.isGuest" class="display-block session-guest-text" translate="atheer.session.sessionPlayer.guest">GUEST</span></p><md-button class="md-icon-button remote-button" ng-if="vm.isRemoteControlEnabled && vm.remoteControlAccessMap[sessionUser.jitsiUserId] && !vm.isMobileBrowser && vm.remoteControlledUser !== sessionUser.userId" ng-click="vm.requestRemoteControl(sessionUser.jitsiUserId)" aria-label="primary button" ng-disabled="vm.isRemoteControlActive || vm.annotationLocked || vm.isAnnotationView || vm.isArAnnotating || vm.loadingRecorder || vm.recordingStatus || vm.isSharedZoomDisabled || vm.shareScreenLocked"><md-icon class="remote-icon" md-svg-icon="/assets/images/card/remote_control.svg"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.requestRemoteControl">Remote Control</span></fp-tooltip></md-button><md-button ng-if="vm.isRemoteControlPermissionRequested && vm.remoteControlledUser === sessionUser.userId" ng-disabled="true" class="md-icon-button" aria-label="primary button"><md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.waitingRemoteAccess">Waiting For Remote Access</span></fp-tooltip></md-button><md-button class="md-icon-button md-primary" ng-if="vm.isRemoteControlPermissionGranted && vm.remoteControlledUser === sessionUser.userId" aria-label="primary button" ng-click="vm.stopRemoteControl()"><md-icon md-svg-icon="/assets/images/card/remote_control.svg"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.stopRemoteControl">Stop Remote Control</span></fp-tooltip></md-button><md-button ng-if="sessionUser.audioStatus" class="md-icon-button" ng-click="vm.toggleAudioOfUser(sessionUser.userId, true, false)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-mic"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.audioOff">Turn Audio Off</span></fp-tooltip></md-button><md-button ng-if="!sessionUser.audioStatus" class="md-icon-button" ng-click="vm.toggleAudioOfUser(sessionUser.userId, true, false)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-mic-off" ng-style="{\'color\': \'rgb(244, 67, 54)\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.audioOn">Turn Audio On</span></fp-tooltip></md-button><md-button ng-if="sessionUser.videoStatus" class="md-icon-button" ng-click="vm.toggleVideoOfUser(sessionUser.userId, true, false)" aria-label="primary button" ng-disabled="vm.isMergeRealityCallInProgress"><md-icon md-font-icon="zmdi zmdi-videocam"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.videoOff">Turn Video Off</span></fp-tooltip></md-button><md-button ng-if="!sessionUser.videoStatus" class="md-icon-button" ng-click="vm.toggleVideoOfUser(sessionUser.userId, true, false)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-videocam-off" ng-style="{\'color\': \'rgb(244, 67, 54)\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.videoOn">Turn Video On</span></fp-tooltip></md-button><div ng-if="sessionUser.hasFlashLight"><md-button ng-if="sessionUser.flashLightStatus" class="md-icon-button" ng-click="vm.toggleFlashOfUser(sessionUser.userId)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-flash"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.flashOff">Turn Flash Off</span></fp-tooltip></md-button><md-button ng-if="!sessionUser.flashLightStatus" class="md-icon-button" ng-click="vm.toggleFlashOfUser(sessionUser.userId)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-flash-off" ng-style="{\'color\': \'rgb(244, 67, 54)\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.flashOn">Turn Flash On</span></fp-tooltip></md-button></div><md-menu ng-if="vm.isHost && !sessionUser.isHost && !sessionUser.isGuest && !sessionUser.isGlasses" md-offset="250 50"><md-button class="md-icon-button" aria-label="open menu" ng-click="$event.stopPropagation();$mdMenu.open()" ng-disabled="vm.isMergeRealityCallInProgress"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="1" class="md-dense"><md-menu-item><md-button aria-label="primary button" ng-click="vm.makeAlternateUserHost(sessionUser)" ng-disabled="vm.isRemoteControlActive"><span translate="atheer.session.sessionPlayer.makeHost">Make Host</span></md-button></md-menu-item></md-menu-content></md-menu><md-divider></md-divider></md-list-item></md-list></div><div ng-if="vm.isHost" class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><div flex layout="row" layout-align="space-around center"><md-button class="md-raised md-primary" ng-click="vm.toggleAudioAll(false)" translate="atheer.session.sessionPlayer.muteAll">Mute All</md-button></div></div></div></div>');
$templateCache.put('modules/session/session-jitsi-player.tmpl.html','<!-- Basic iframe of Jitsi --><div flex layout="row"><div flex layout="column" layout-fill><div ng-if="(!vm.showPlayer && !vm.isGuest) || vm.isCapturingScreenshot" ng-class="{\'annotation-spinner\': vm.isFreezeFrame || vm.isCapturingScreenshot}" flex layout="column" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="vm.showPlayer && vm.waitingForHost && !vm.isGuest" flex layout="column" layout-align="center center"><span class="md-headline" translate="atheer.session.sessionPlayer.waitingForHost">Waiting for Host to join</span><wave-spinner></wave-spinner></div><div ng-if="(vm.isGuest && !vm.showPlayer) || (vm.showPlayer && vm.isGuestWaitingForHost && vm.isGuest)" flex layout="column" layout-align="center center"><div layout="row" layout-fill><div flex layout="column" layout-padding class="guest-join-right-side-menu overflow-auto" ng-style="vm.isMobileBrowser && {\'background\': \'white\'}"><div layout="row" flex layout-fill layout-align="center center"><div flex="70" flex-xs="100" flex-gt-xs="100" flex-md="90" flex-gt-md="90" flex-lg="70" flex-xl="70"><div ng-if="!vm.showPlayer" flex layout-fill layout="column" layout-align="center center"><wave-spinner></wave-spinner><span class="md-headline" translate="atheer.guestJoin.connecting">Please wait...</span></div><div ng-if="vm.showPlayer && vm.isGuestWaitingForHost"><p translate="atheer.session.sessionPlayer.waitingToStart">Waiting for host to start this AiRSession</p><span translate="atheer.session.sessionPlayer.automaticJoin">You will automatically join this AiRSession when the host starts it.</span></div></div></div></div></div></div><div id="jitsi-session-player" class="fp-iframe-player jitsi-session-player" ng-show="vm.showPlayer && !vm.waitingForHost && !vm.isImageLoaded" flex layout="column"></div><session-annotation-builder ng-if="vm.isAnnotating && vm.annotationType === \'CLASSIC\'" user-id="vm.userId" session-id="vm.sessionModel.id" annotation-data="vm.annotationData"></session-annotation-builder><session-annotation-ar-builder class="annotation-ar-wrapper" ng-if="vm.isArAnnotating && vm.annotationType != \'CLASSIC\'" user-id="vm.userId" session-id="vm.sessionModel.id" annotation-data="vm.annotationData"></session-annotation-ar-builder><session-zoom-position class="session-zoom" ng-if="vm.enableZoom && !vm.isAnnotating && !vm.isArAnnotating" zoom="vm.zoom" on-position-change="vm.sendZoomPositiontoJitsi" on-position-release="vm.sendZoomPosition"></session-zoom-position><div ng-if="vm.recordingStatus" class="fp-session-recorder" layout="row"><md-icon class="md-blink" md-font-icon="zmdi zmdi-dot-circle" ng-style="{\'color\': \'rgb(244, 67, 54)\'}"></md-icon><span class="md-body-2" ng-style="{\'color\': \'rgb(255,255,255)\'}" translate="atheer.session.sessionPlayer.recording">Recording</span></div><div ng-show="vm.sessionUsers.length < 2 && vm.isHost && vm.showPlayer && !vm.isMergeRealityCallInProgress" flex layout="column" layout-align="center center" class="fp-session-invite-user"><span class="md-primary md-raised" ng-style="{\'color\': \'rgb(255,255,255)\'}" layout-align="center center" translate="atheer.session.sessionPlayer.onlyOne">You are the only one in AiRSession</span><div layout="row"><md-button class="md-primary md-raised" aria-label="primary button" md-ripple-size="full" aria-label="ripple half" ng-click="vm.inviteUsers()" layout-align="center center" translate="entity.action.invite">Invite</md-button></div></div><div ng-show="vm.userName != null && !vm.isAnnotating && !vm.isMergeRealityCallInProgress" flex layout="column" layout-align="center center" class="fp-session-display-remote-username" ng-style="((vm.showParticipants || vm.showConversation) && vm.isMobileBrowser) && {\'display\': \'none\' }"><div class="fp-session-user-name-wrapper"><span translate="atheer.session.sessionPlayer.viewing">Viewing</span><span class="fp-session-user-name"> {{vm.userName}}</span></div></div><div id="session-player-toolbar" flex layout="row" ng-show="vm.showPlayer && !vm.isGuestWaitingForHost" class="toolbar-default md-toolbar-tools md-accent margin-bottom-0 md-whiteframe-z1 session-player-toolbar" ng-class="{\'display-none\': vm.isMobileBrowser && (vm.showParticipants || vm.showConversation)}"><div flex="20" layout="row" layout-align="start center" ng-if="!vm.isTileView && !vm.isMobileBrowser && vm.isZoomToolsEnabled && !vm.isMergeRealityCallInProgress"><span class="md-body-1">{{vm.zoomValue}}%</span><md-button ng-disabled="!vm.isZoomEnabled" class="md-icon-button" ng-click="vm.zoomOut()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-zoom-out"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.zoomOut">Zoom Out</span></fp-tooltip></md-button><md-slider flex ng-disabled="!vm.isZoomEnabled" class="md-primary" md-discrete ng-model="vm.zoomSlider" step="1" min="100" max="200" aria-label="md-primary"></md-slider><md-button ng-disabled="!vm.isZoomEnabled" class="md-icon-button" ng-click="vm.zoomIn()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-zoom-in"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.zoomIn">Zoom In</span></fp-tooltip></md-button><span flex></span></div><div flex="20" layout="row" ng-if="!vm.isMobileBrowser && (!vm.isZoomToolsEnabled || vm.isMergeRealityCallInProgress || vm.isTileView)"></div><div flex="15" ng-if="!vm.isMobileBrowser"></div><div flex="{{!vm.isMobileBrowser ? 35 : 70}}" layout="row" layout-align="center center"><md-button ng-if="vm.audioStatus" class="md-icon-button" ng-click="vm.toggleAudioOfUser(vm.userId, true, true)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-mic"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.audioOff">Turn Audio Off</span></fp-tooltip></md-button><md-button ng-if="!vm.audioStatus" class="md-icon-button" ng-click="vm.toggleAudioOfUser(vm.userId, true, true)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-mic-off" ng-style="{\'color\': \'rgb(244, 67, 54)\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.audioOn">Turn Audio On</span></fp-tooltip></md-button><md-button ng-if="vm.videoStatus" class="md-icon-button" ng-disabled="vm.isMergeRealityCallInProgress" ng-click="vm.toggleVideoOfUser(vm.userId, true, true)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-videocam"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.videoOff">Turn Video Off</span></fp-tooltip></md-button><md-button ng-if="!vm.videoStatus" class="md-icon-button" ng-disabled="vm.isMergeRealityCallInProgress" ng-click="vm.toggleVideoOfUser(vm.userId, true, true)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-videocam-off" ng-style="{\'color\': \'rgb(244, 67, 54)\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.videoOn">Turn Video On</span></fp-tooltip></md-button><md-button permission permission-only="vm.permissions.start_mr" ng-if="!vm.isMobileBrowser && vm.isMergeRealityEnabled && !vm.isMergeRealityCallInProgress" class="md-icon-button" aria-label="primary button" ng-click="vm.toggleMergeReality()" ng-disabled="!vm.videoStatus || vm.isTileView || vm.annotationLocked || vm.isAnnotationView || vm.isArAnnotating || vm.isScreenSharing || vm.isRemoteControlActive || (vm.overlayId && vm.overlayId !== vm.jitsiUserId) ||  vm.sessionUsers.length !== 2 || vm.recordingStatus || vm.loadingRecorder"><md-icon md-svg-icon="/assets/images/card/merge_reality.svg"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.startMergeReality">Start Merge Reality</span></fp-tooltip></md-button><md-button ng-if="vm.isWaitingForOtherUserFeed" ng-disabled="true" class="md-icon-button" aria-label="primary button"><md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.waitingForCameraFeed">Waiting For Other User to turn on Camera</span></fp-tooltip></md-button><md-button permission permission-only="vm.permissions.start_mr" ng-if="!vm.isMobileBrowser && vm.isMergeRealityEnabled && vm.isMergeRealityCallInProgress && !vm.isWaitingForOtherUserFeed" class="md-icon-button md-primary" aria-label="primary button" ng-click="vm.toggleMergeReality()" ng-disabled="vm.overlayId !== vm.jitsiUserId"><md-icon md-svg-icon="/assets/images/card/merge_reality.svg"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.stopMergeReality">Stop Merge Reality</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.showAnnotationModeDialog()" ng-disabled="vm.isTileView || vm.annotationLocked || vm.isAnnotationView || vm.isArAnnotating || vm.isScreenSharing || vm.isRemoteControlActive || vm.isFakeParticipantOnStage || vm.isMergeRealityCallInProgress"><md-icon md-font-icon="zmdi zmdi-edit"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.annotate">Annotate</span></fp-tooltip></md-button><md-button ng-if="vm.isSharedZoomDisabledFeature" class="md-icon-button" aria-label="primary button" ng-click="vm.showSharedZoomDialog()" ng-disabled="vm.isTileView || vm.isRemoteControlActive || vm.isFakeParticipantOnStage || vm.isMergeRealityCallInProgress"><md-icon ng-if="!vm.isSharedZoomDisabled" class="session-icon" md-svg-icon="/assets/images/card/shared-zoom-enabled.svg"></md-icon><md-icon ng-if="vm.isSharedZoomDisabled" class="session-icon" md-svg-icon="/assets/images/card/shared-zoom-disabled.svg"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.sharedZoom.title">Shared Zoom</span></fp-tooltip></md-button><md-button ng-disabled="vm.isTileView || vm.isFakeParticipantOnStage || !vm.canAnnotate || vm.isMergeRealityCallInProgress || (vm.annotationType === \'CLASSIC\' && (vm.annotationLocked || vm.isAnnotationView)) || vm.isArAnnotating" class="md-icon-button" ng-click="vm.captureScreenShot()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-center-focus-weak"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.screenshot">Screenshot</span></fp-tooltip></md-button><md-button ng-if="!vm.isMobileBrowser" class="md-icon-button" ng-click="vm.toggleShareScreen()" ng-disabled="vm.shareScreenLocked || vm.userName != null || vm.isRemoteControlActive || vm.isMergeRealityCallInProgress" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-open-in-browser"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.shareScreen">Share Screen</span></fp-tooltip></md-button><md-button ng-if="!vm.isMobileBrowser" class="md-icon-button" ng-click="vm.toggleTileView()" aria-label="primary button" ng-disabled="vm.annotationLocked || vm.isAnnotationView || vm.isArAnnotating || vm.isMergeRealityCallInProgress"><md-icon md-font-icon="fa fa-th-large"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.toggleTileView">Toggle Gallery View</span></fp-tooltip></md-button><md-button ng-if="!vm.isMobileBrowser" class="md-icon-button" ng-click="vm.showCapturedImages()" aria-label="primary button" ng-disabled="vm.annotationLocked || vm.isAnnotationView || vm.isArAnnotating"><md-icon md-font-icon="zmdi zmdi-collection-image"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.seeCapturedImages">See Captured Images</span></fp-tooltip></md-button><md-button ng-if="!vm.recordingStatus && !vm.loadingRecorder && vm.isHost && vm.recordingFeature" class="md-icon-button" ng-click="vm.toggleRecording()" aria-label="primary button" ng-disabled="vm.isRemoteControlActive || vm.isMergeRealityCallInProgress"><md-icon md-font-icon="zmdi zmdi-dot-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.startRecording">Start Recording</span></fp-tooltip></md-button><md-button ng-if="!vm.recordingStatus && vm.loadingRecorder && vm.isHost" ng-disabled="true" class="md-icon-button" aria-label="primary button"><md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.startingRecording">Starting Recording</span></fp-tooltip></md-button><md-button ng-if="vm.recordingStatus && !vm.loadingRecorder && vm.isHost" class="md-icon-button" ng-click="vm.toggleRecording()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-dot-circle" ng-style="{\'color\': \'rgb(244, 67, 54)\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.stopRecording">Stop Recording</span></fp-tooltip></md-button><md-button class="md-icon-button remote-button" ng-if="!vm.isMobileBrowser && vm.isRemoteControlEnabled && !vm.isRemoteControlPermissionRequested && !vm.isRemoteControlPermissionGranted" aria-label="primary button" ng-click="vm.requestRemoteControl(vm.selectedUserJitsiId)" ng-disabled="!vm.userHasRemoteControlSupport || vm.annotationLocked || vm.isAnnotationView || vm.isArAnnotating || vm.loadingRecorder || vm.recordingStatus || vm.isSharedZoomDisabled || vm.shareScreenLocked || vm.isRemoteControlActive || vm.isMergeRealityCallInProgress"><md-icon class="remote-icon" md-svg-icon="/assets/images/card/remote_control.svg"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.requestRemoteControl">Request Remote Control</span></fp-tooltip></md-button><md-button ng-if="vm.isRemoteControlPermissionRequested" ng-disabled="true" class="md-icon-button" aria-label="primary button"><md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.waitingRemoteAccess">Waiting For Remote Access</span></fp-tooltip></md-button><md-button class="md-icon-button md-primary" ng-if="vm.isRemoteControlPermissionGranted" aria-label="primary button" ng-click="vm.stopRemoteControl()" ng-disabled="vm.isTileView || !vm.userHasRemoteControlSupport"><md-icon md-svg-icon="/assets/images/card/remote_control.svg"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.stopRemoteControl">Stop Remote Control</span></fp-tooltip></md-button><md-menu md-offset="{{!vm.isMobileBrowser ? 0 -150 : 0 -50}}"><md-button class="md-icon-button" aria-label="open menu" ng-click="$event.stopPropagation();$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5" class="md-dense"><md-menu-item ng-if="vm.isMobileBrowser"><md-button id="session-info" ng-click="vm.showSessionInfoDialog()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-info"></md-icon><span translate="atheer.session.sessionPlayer.info">AiRSession Information</span></md-button></md-menu-item><md-menu-item ng-if="vm.isMobileBrowser"><md-button ng-click="vm.toggleUsers()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-accounts"></md-icon><span translate="atheer.session.sessionPlayer.viewUsers">View Users</span></md-button></md-menu-item><md-menu-item ng-if="vm.isMobileBrowser"><md-button ng-click="vm.toggleConversation()" aria-label="primary button"><md-icon md-font-icon="fa fa-comments"></md-icon><span translate="atheer.session.sessionPlayer.chat">Chat</span><md-icon ng-if="vm.messagesCount > 0" md-font-icon="zmdi zmdi-circle" class="fp-message-badge"></md-icon></md-button></md-menu-item><md-menu-item ng-if="vm.isMobileBrowser"><md-button aria-label="primary button" ng-click="vm.toggleCamera()"><md-icon md-font-icon="zmdi zmdi-camera-switch"></md-icon><span translate="atheer.session.sessionPlayer.toggleCamera">Toggle Camera</span></md-button></md-menu-item><md-menu-item ng-if="!vm.isMobileBrowser"><md-button ng-if="!vm.isFullScreen" aria-label="primary button" ng-click="vm.toggleFullScreen()"><md-icon md-font-icon="zmdi zmdi-fullscreen"></md-icon><span translate="atheer.session.sessionPlayer.viewFullScreen">View Full Screen</span></md-button><md-button ng-if="vm.isFullScreen" aria-label="primary button" ng-click="vm.toggleFullScreen()"><md-icon md-font-icon="zmdi zmdi-fullscreen-exit"></md-icon><span translate="atheer.session.sessionPlayer.exitFullScreen">Exit Full Screen</span></md-button></md-menu-item><md-menu-item ng-if="!vm.isMobileBrowser"><md-button aria-label="primary button" ng-click="vm.changeVideoQuality()"><md-icon md-font-icon="fa fa-camera"></md-icon><span translate="atheer.session.sessionPlayer.manage">Manage Video Quality</span></md-button></md-menu-item><md-menu-item ng-if="!vm.isMobileBrowser"><md-button aria-label="primary button" ng-click="vm.changeSettings()"><md-icon md-font-icon="zmdi zmdi-settings"></md-icon><span translate="atheer.session.sessionPlayer.settings">Settings</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.captureFeeback()"><md-icon md-font-icon="zmdi zmdi-thumb-up"></md-icon><span translate="atheer.session.sessionPlayer.feedback">Leave Feedback</span></md-button></md-menu-item></md-menu-content></md-menu></div><div flex="30" layout="row" layout-align="end center"><span flex></span><md-button id="session-info" class="md-icon-button" ng-click="vm.showSessionInfo()" aria-label="primary button" ng-if="!vm.isMobileBrowser"><md-icon md-font-icon="zmdi zmdi-info"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.details">AiRSession Details</span></fp-tooltip></md-button><md-button ng-if="!vm.isHost" class="md-primary md-raised" aria-label="primary button" ng-click="vm.finalizeSession(false)"><span ng-if="!vm.isMobileBrowser" translate="atheer.session.sessionPlayer.leave">Leave</span> <span ng-if="vm.isMobileBrowser" translate="atheer.session.close.leaveButton">Leave</span></md-button><md-button ng-if="vm.isHost" ng-disabled="vm.isMergeRealityCallInProgress" permission permission-only="vm.permissions.create" class="md-icon-button" ng-click="vm.inviteUsers()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-account-add"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.inviteUser">Invite User</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.toggleUsers()" aria-label="primary button" ng-if="!vm.isMobileBrowser"><md-icon md-font-icon="zmdi zmdi-accounts"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.users">Users</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.toggleConversation()" aria-label="primary button" ng-if="!vm.isMobileBrowser"><md-icon md-font-icon="fa fa-comments"></md-icon><md-icon ng-if="vm.messagesCount > 0" md-font-icon="zmdi zmdi-circle" ng-style="{\'font-size\': \'10px\', height: \'10px\', color: \'#EA4253\', \'position\': \'absolute\', \'left\': \'14px\', \'top\': \'3px\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.conversation">Conversation</span></fp-tooltip></md-button><md-button ng-if="vm.isHost" class="md-primary md-raised" aria-label="primary button" ng-click="vm.finalizeSession(true)" translate="atheer.session.sessionPlayer.end">End</md-button></div></div></div><ng-include flex="{{!vm.isMobileBrowser ? 25 : 100}}" ng-show="vm.showConversation" src="\'modules/session/session-jitsi-player-conversation.tmpl.html\'"></ng-include><ng-include flex="{{!vm.isMobileBrowser ? 25 : 100}}" ng-show="vm.showParticipants" src="\'modules/session/session-jitsi-player-users.tmpl.html\'"></ng-include></div>');
$templateCache.put('modules/session/session-join-dialog.tmpl.html','<md-dialog flex="{{!vm.isMobileBrowser ? 50 : 90}}" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.joinSession.title">Join AiRSession</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-content flex layout="row"><div flex layout="column" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="{{!vm.isMobileBrowser ? 50 : 80}}" layout="column" ng-form="joinSessionForm"><md-input-container class="md-block"><label translate="atheer.session.joinSession.sessionNo">Enter AiRSession No here</label> <input type="text" name="sessionNo" ng-model="vm.sessionNo" md-select-on-focus required><div ng-messages="joinSessionForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></div><div layout="row" layout-align="center center"><div flex="50" layout="column" ng-form="joinSessionForm"><md-button class="md-primary md-raised" md-ripple-size="full" aria-label="ripple full" ng-click="vm.joinSession()" translate="entity.action.join">Join</md-button></div></div></div></md-content></md-dialog>');
$templateCache.put('modules/session/session-merge-reality-dialog.tmpl.html','<md-dialog class="merge-reality-dialog-container"><div class="dialog-content" flex layout="row"><md-dialog-content class="dialog-content-container"><div ng-if="!vm.mainData.videoStatus" class="merge-reality-display-title" layout="row"><span translate="atheer.session.sessionPlayer.mergeRealityMessage.title">Merge Reality</span></div><div ng-if="!vm.mainData.videoStatus" class="merge-reality-display-content" layout="row"><span translate="atheer.session.sessionPlayer.mergeRealityMessage.camereOnMessage" translate-values="{userName: \'{{vm.requestedUserName}}\'}">{{userName}} requested for merge reality. You need to turn on the camera.</span></div><div class="merge-reality-display-content" layout="row"><span translate="atheer.session.sessionPlayer.mergeRealityMessage.content">If you are using device, you will get better experience when view in the landscape mode. Please keep your device in landscape mode</span></div><div layout-align="center" layout="row" class="button-container"><md-button ng-if="!vm.mainData.videoStatus" class="md-primary md-raised" translate="atheer.session.sessionPlayer.turnOnCamera" ng-click="vm.close()">Turn on Camera</md-button><md-button ng-if="vm.mainData.videoStatus" class="md-primary md-raised" translate="atheer.session.sessionPlayer.gotIt" ng-click="vm.close()">Got it!</md-button></div></md-dialog-content></div></md-dialog>');
$templateCache.put('modules/session/session-notifier.tmpl.html','<md-toast><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-toolbar ng-if="!vm.loadingData" class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar" layout="row"><fp-avatar user="vm.notification.userInfo" auto-color="true" bind="true" _camel_case="true" font-weight="400" font-scale="100" round-shape="true" width="35"></fp-avatar><h2 ng-if="vm.instantSession" hide-xs translate="notification.session.instantSession" translate-values="{firstName: \'{{vm.notification.userInfo.firstName}}\', lastName: \'{{vm.notification.userInfo.lastName}}\'}">{{vm.notification.userInfo.firstName}} {{vm.notification.userInfo.lastName}}<br>You have been invited to an AiRSession in progress.</h2><h2 ng-if="vm.groupSession" hide-xs translate="notification.session.groupSession" translate-values="{firstName: \'{{vm.notification.userInfo.firstName}}\', lastName: \'{{vm.notification.userInfo.lastName}}\'}">{{vm.notification.userInfo.firstName}} {{vm.notification.userInfo.lastName}}<br>You have been invited to a Group AiRSession in progress.</h2><h2 ng-if="vm.scheduleSession" hide-xs translate="notification.session.scheduled" translate-values="{sessionNo: \'{{vm.sessionObj.session_no}}\'}">AiRSession Scheduled (Session Number - {{vm.sessionObj.session_no}})</h2></div></md-toolbar><md-dialog-actions ng-if="!vm.loadingDatan && vm.instantSession || vm.groupSession" layout="row"><span flex></span><md-button ng-click="vm.joinAirSession()" class="md-raised md-primary"><span translate="entity.action.join">Join</span></md-button><md-button ng-click="vm.close()" class="md-raised md-primary"><span translate="entity.action.cancel">Cancel</span></md-button></md-dialog-actions></md-toast>');
$templateCache.put('modules/session/session-past-edit.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.home.past">Past AiRSession</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div flex layout="column" class="padding-40" ng-form="vm.sessionDetailForm"><div flex layout="column"><md-input-container class="md-block"><label translate="atheer.session.topic">Topic</label> <input type="text" name="topic" ng-model="vm.session.topic" md-select-on-focus required><div ng-messages="vm.sessionDetailForm.topic.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div layout="row" layout-align="center center"><div flex="50" layout="column"><md-button class="md-primary md-raised" md-ripple-size="full" aria-label="ripple full" ng-click="vm.updateSession()" ng-disabled="vm.sessionDetailForm.$invalid" translate="entity.action.save">Save</md-button></div></div></div></md-dialog>');
$templateCache.put('modules/session/session-player-close-dialog.tmpl.html','<md-dialog flex="{{!vm.isMobileBrowser ? 50 : 100}}" aria-label="" ng-class="{\'fp-mobile-dialog\': vm.isMobileBrowser}"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 ng-if="vm.isEnd" hide-xs translate="atheer.session.close.end">End AiRSession</h2><h2 ng-if="!vm.isEnd" hide-xs translate="atheer.session.close.leave">Leave AiRSession</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div ng-if="vm.loadingData" flex layout="column" layout-align="center center" layout-fill class="padding-80"><span class="md-title margin-bottom-20" translate="atheer.session.endingSessionWait">Ending AiRSession. Please wait...</span><md-progress-linear md-mode="indeterminate"></md-progress-linear></div><div ng-if="!vm.loadingData" layout="column" layout-align="center center" class="fp-mobile-dialog"><md-dialog-content class="md-dialog-content full-width"><div flex layout="column"><span ng-if="vm.isEnd" class="md-headline" translate="atheer.session.close.endAirSession">Are you sure you want to end this AiRSession?</span> <span ng-if="!vm.isEnd" class="md-headline" translate="atheer.session.close.leaveAirSession">Are you sure you want to leave this AiRSession?</span><div layout="row" layout-align="start center" class="margin-top-20"><md-checkbox ng-model="vm.provideFeedback" aria-label="Provide Feeddback"><span translate="atheer.session.close.rate">I\'d like to rate this AiRSession</span></md-checkbox></div><div ng-if="vm.provideFeedback" layout="row" layout-align="center center" class="margin-top-20"><div layout="column"><div layout-align="center center" fp-rating rating="vm.rating" color="\'orange\'" shape-type="STAR" max-rating="5"></div><div flex layout="row" layout-align="space-between center"><div class="md-caption" translate="atheer.session.close.veryBad">Very Bad</div><div class="md-caption"></div><div class="md-caption" translate="atheer.session.close.veryGood">Very Good</div></div></div></div><div ng-if="vm.provideFeedback" flex layout="row" layout-align="center center" class="margin-top-20"><md-input-container flex="80" class="md-block"><label for="field_feedback" translate="atheer.session.close.comments">Please provide any comments here:</label> <textarea name="description" ng-model="vm.ratingFeedback" id="field_feedback" md-no-resize maxlength="255" md-maxlength="255" rows="3"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" class="full-width"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-if="!vm.isEnd" ng-click="vm.closeSession()" type="submit" class="md-primary md-raised"><span translate="atheer.session.close.leaveButton">Leave</span></md-button><md-button ng-if="vm.isEnd" ng-click="vm.closeSession()" type="submit" class="md-primary md-raised"><span translate="atheer.session.close.endButton">End</span></md-button></md-dialog-actions></div></md-dialog>');
$templateCache.put('modules/session/session-player-images-dialog.tmpl.html','<md-dialog flex aria-label=""><md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span translate="atheer.session.annotations.title" translate-values="{sessionNo: \'{{vm.sessionModel.session_no}}\'}">AiRSession Annotations - {{vm.sessionModel.session_no}}</span><div flex></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.close()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon></md-button></div></md-toolbar><div ng-if="vm.loadingData" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessionActivities.length == 0" flex layout="column" layout-align="center center" class="padding-top-40 padding-bottom-40"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.session.annotations.noAnnotations">There are no annotations yet for this session.</div></div><div ng-if="!vm.loadingData && vm.sessionActivities.length > 0" layout="row" layout-wrap layout-align="start center" class="padding-top-20 padding-left-10 padding-right-10"><div div flex="50" ng-repeat="sessionActivity in vm.sessionActivities track by $index"><md-card><md-card-header><md-card-header-text><span class="md-title">{{sessionActivity.properties.file_name}}</span></md-card-header-text></md-card-header><img ng-src="{{::vm.getMediaUrl(sessionActivity)}}"><md-card-actions layout="row" layout-align="end center"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.download(sessionActivity, $index)"><md-icon class="zmdi zmdi-download"></md-icon></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.fullScreen(sessionActivity)"><md-icon class="zmdi zmdi-fullscreen"></md-icon></md-button></md-card-actions></md-card></div></div><md-table-pagination class="session-annotation-pagination" flex="100" md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessionActivities.length > 0"></md-table-pagination></md-dialog>');
$templateCache.put('modules/session/session-player-make-alternate-host-dialog.tmpl.html','<md-dialog flex="{{!vm.isMobileBrowser ? 50 : 100}}" aria-label="" ng-class="{\'fp-mobile-dialog\': vm.isMobileBrowser}"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.sessionPlayer.changeHost">Change Host</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div layout="column" layout-align="center center" class="fp-mobile-dialog"><md-dialog-content class="md-dialog-content full-width"><div flex layout="column"><span class="md-headline" translate="atheer.session.sessionPlayer.changeHostText" translate-values="{vm.userName: \'{{userName}}\'}">Make {{ vm.userName }} the meeting host ?</span></div></md-dialog-content><md-dialog-actions layout="row" class="full-width"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.changeHost()" type="submit" class="md-primary md-raised"><span translate="atheer.session.sessionPlayer.change">Change</span></md-button></md-dialog-actions></div></md-dialog>');
$templateCache.put('modules/session/session-player-passcode-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 translate="atheer.session.passcode.enterPasscode">Please enter session passcode</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.closeAirSession()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-content flex layout="row"><div flex layout="column" class="padded-content-page margin-top-20"><div flex layout="row" layout-xs="column" layout-align="center center" class="confirm_input" layout-wrap><div><div class="confirm_input_item input_wrapper"><input md-colors="{background: \'primary-500-0.1\'}" type="text" ng-model="vm.passcode1" maxlength="1" ng-change="vm.checkPasscode(vm.passcode1, 1)" ng-keydown="vm.onNumberInputKeydown($event)" class="inline_input guest-session-input guest-session-first-input" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input_wrapper"><input md-colors="{background: \'primary-500-0.1\'}" type="text" ng-model="vm.passcode2" maxlength="1" ng-change="vm.checkPasscode(vm.passcode2, 2)" ng-keydown="vm.onNumberInputKeydown($event)" class="inline_input guest-session-input guest-session-first-input" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input_wrapper"><input md-colors="{background: \'primary-500-0.1\'}" type="text" ng-model="vm.passcode3" maxlength="1" ng-change="vm.checkPasscode(vm.passcode3, 3)" ng-keydown="vm.onNumberInputKeydown($event)" class="inline_input guest-session-input guest-session-first-input" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div></div><div class="confirmation_code_span_cell">&#45;</div><div><div class="confirm_input_item input_wrapper"><input md-colors="{background: \'primary-500-0.1\'}" type="text" ng-model="vm.passcode4" maxlength="1" ng-change="vm.checkPasscode(vm.passcode4, 4)" ng-keydown="vm.onNumberInputKeydown($event)" class="inline_input guest-session-input guest-session-first-input" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input_wrapper"><input md-colors="{background: \'primary-500-0.1\'}" type="text" ng-model="vm.passcode5" maxlength="1" ng-change="vm.checkPasscode(vm.passcode5, 5)" ng-keydown="vm.onNumberInputKeydown($event)" class="inline_input guest-session-input guest-session-first-input" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input_wrapper"><input md-colors="{background: \'primary-500-0.1\'}" type="text" ng-model="vm.passcode6" maxlength="1" ng-change="vm.checkPasscode(vm.passcode6, 6)" ng-keydown="vm.onNumberInputKeydown($event)" class="inline_input guest-session-input guest-session-first-input" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div></div></div><div layout="row" layout-align="center center" class="margin-top-40"><div flex="50" layout="column" ng-form="sessionPlayerPasscodeForm"><md-button class="md-primary md-raised" md-ripple-size="full" aria-label="ripple full" ng-click="vm.joinSession()" ng-disabled="!vm.validPasscode" translate="atheer.session.passcode.join">Join</md-button></div></div></div></md-content></md-dialog>');
$templateCache.put('modules/session/session-player-unsupported-browser.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.unsupportedBrowserTitle">This browser is not supported</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-content flex layout="row"><div flex layout="column" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center" class="confirm_input"><h4 hide-xs translate="atheer.session.unsupportedBrowserText">Text for unsupported browser</h4></div><div layout="row" layout-align="center center" class="margin-top-40"><div flex="50" layout="column"><md-button class="md-primary md-raised" md-ripple-size="full" aria-label="ripple full" ng-click="vm.downloadApp()" translate="global.menu.downloadApps">Download App</md-button></div></div></div></md-content></md-dialog>');
$templateCache.put('modules/session/session-player.tmpl.html','<div flex layout="column" layout-fill><session-jitsi-player flex layout="column" session-no="{{vm.sessionNo}}" is-guest="{{vm.isGuest}}"></session-jitsi-player></div>');
$templateCache.put('modules/session/session-recording-message-privacy.tmpl.html','<md-dialog class="recording-dialog-container"><div layout="row" layout-align="end end"><md-button class="recording-dialog-icon-button text-left" ng-click="vm.close()" aria-label="primary button"><md-icon classm="font-icon-button" md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div><div class="dialog-content" flex layout="row"><md-dialog-content class="dialog-content-container"><div class="session-recording-display-title" layout="row"><span translate="atheer.session.sessionPlayer.recordingMessage.title">This AiRSession is being recorded by the host</span></div><div class="session-recording-display-content" layout="row"><span translate="atheer.session.sessionPlayer.recordingMessage.content">By staying in this AiRSession, you conscent to being recorded.</span></div><div layout-align="center" layout="row" class="button-container"><md-button class="md-primary md-raised" translate="atheer.session.sessionPlayer.recordingMessage.leaveAirSession" ng-click="vm.leaveAirSession()">Leave AiRSession</md-button><md-button class="md-primary md-raised" translate="atheer.session.sessionPlayer.gotIt" ng-click="vm.close()">Got it</md-button></div></md-dialog-content></div></md-dialog>');
$templateCache.put('modules/session/session-recordings.tmpl.html','<md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'annotationPanel\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><span translate="atheer.session.recordings.title" translate-values=\'{sessionNo: "{{vm.sessionModel.session_no}}"}\'>AiRSession Recordings - {{vm.sessionModel.session_no}}</span><div flex></div></div></md-toolbar><div ng-if="vm.loadingData" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessionRecorings.length == 0" flex layout="column" layout-align="center center" layout-fill><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.session.recordings.noRecordings">There are no recordings yet for this session.</div></div><div ng-if="!vm.loadingData && vm.sessionRecorings.length > 0" layout="row" layout-wrap layout-align="start center" class="padding-top-20 padding-left-10 padding-right-10"><div flex="50" ng-repeat="sessionRecording in vm.sessionRecorings track by $index"><md-card><md-card-header><md-card-header-text><span class="md-title">{{sessionRecording.title}}</span></md-card-header-text></md-card-header><div flex layout-align="center center"><jwplayer player-options="sessionRecording.videoSettings" player-id="{{sessionRecording.player_id}}"></jwplayer></div><md-card-actions layout="row" layout-align="end center"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.download(sessionRecording.media_url, sessionRecording.media_file_name, $index)"><md-icon class="zmdi zmdi-download"></md-icon></md-button></md-card-actions></md-card></div></div>');
$templateCache.put('modules/session/session-shared-zoom-dialog.tmpl.html','<md-dialog class="main-dialog-container"><div layout="row" layout-align="end end"><md-button class="dialog-icon-button text-left" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close-circle-o"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div><div class="dialog-content" flex layout="row" layout-align="center center"><md-dialog-content class="dialog-content-container"><div class="dialog-image-icon" layout="row" layout-align="center center"><md-icon ng-style="{\'color\': vm.iconColor}" class="seesion-dialog-image" md-svg-icon="{{vm.iconSrc}}"></md-icon></div><div class="session-display-title" layout="row" layout-align="center center">{{ vm.zoomtitle }}</div><div class="session-display-content" layout="row" layout-align="center center">{{ vm.zoomcontent }}</div><div layout-align="space-around center" layout="row"><md-button class="md-primary" translate="entity.action.cancel" ng-click="vm.close()">Cancel</md-button><md-button class="md-primary md-raised" translate="entity.action.continue" ng-click="vm.continue()">Continue</md-button></div></md-dialog-content></div></md-dialog>');
$templateCache.put('modules/session/session-start-dialog.tmpl.html','<md-dialog flex="{{!vm.isMobileBrowser ? 50 : 90}}" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div ng-if="vm.groupConversation==null" class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.startSession.title">Start AiRSession</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.startSession.close">Close</span></fp-tooltip></md-button></div><div ng-if="vm.groupConversation!=null" class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.startSession.startingSession">Starting AiRSession</h2></div></md-toolbar><div ng-if="vm.groupConversation==null" flex layout="column" class="padding-40" ng-form="vm.sessionDetailForm"><div flex layout="column"><md-input-container class="md-block"><label translate="atheer.session.startSession.topic">Topic</label> <input type="text" name="topic" ng-model="vm.sessionModel.topic" md-select-on-focus required><div ng-messages="vm.sessionDetailForm.topic.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div ng-if="vm.groupConversation==null && vm.createPersonalSession" flex layout="row"><div flex="70" class="padding-top-20"><span translate="atheer.session.startSession.usePersonalRoom">Use Personal Room</span></div><div layout="row" flex><div flex layout="column" layout-align="center end"><md-switch name="usePersonalSession" ng-model="vm.usePersonalSession" ng-change="vm.updateTopic()"></md-switch></div></div></div><div flex layout="row"><div flex="70" class="padding-top-20"><span translate="atheer.session.startSession.video">Video</span></div><div layout="row" flex><div flex layout="column" layout-align="center end"><md-switch name="hostVideo" ng-model="vm.sessionModel.settings.host_video"></md-switch></div></div></div></div><div layout="row" layout-align="center center"><div flex="50" layout="column"><md-button class="md-primary md-raised" md-ripple-size="full" aria-label="ripple full" ng-click="vm.startSession()" ng-disabled="vm.sessionDetailForm.$invalid" translate="entity.action.start">Start</md-button></div></div></div><div ng-if="vm.groupConversation!=null" flex layout-align="center center"><wave-spinner></wave-spinner></div></md-dialog>');
$templateCache.put('modules/session/session-summary-report.tmpl.html','<md-dialog><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.exportSummary">Export AiRSession Summary</h2><span flex></span></div></md-toolbar><div ng-if="!vm.loadData" class="margin-bottom-0 padding-20"><div ng-if="vm.ownerHasEmail"><div class="md-toolbar-tools md-accent fp-admin-toolbar fp-notification-height" layout="row"><h2 translate="atheer.session.exportSummaryDesc">Are you sure you want to send a summary of all AiRSession data to</h2><h2>&nbsp;{{vm.owner.email}}</h2></div><div class="md-toolbar-tools md-accent fp-admin-toolbar fp-notification-height" layout="row"><h4 class="md-subhead" ng-style="{\'font-weight\': 200}" translate="atheer.session.exportSummaryDesc1">*Note: this file may be large and take a few minutes to appear in your inbox.</h4></div></div><div ng-if="!vm.ownerHasEmail"><div class="md-toolbar-tools md-accent fp-admin-toolbar fp-notification-height" layout="row"><h2 translate="atheer.session.exportSummaryDescNoEmail">Email is missing. Please add email to your profile or contact your system administrator.</h2></div></div></div><md-dialog-actions ng-if="!vm.loadData" layout="row" class="padding-20"><span flex></span><md-button ng-click="vm.close()" class="md-primary"><span>Cancel</span></md-button><md-button ng-click="vm.EmailReport()" ng-if="vm.ownerHasEmail" class="md-raised md-primary"><span>Export</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/session/session-summary.tmpl.html','<md-sidenav flex layout="column" layout-fill class="md-sidenav-right fp-session-sidenav audience-detail" md-component-id="insightsPanel" md-whiteframe="4"><session-insights ng-if="vm.panelToShow == \'insightsPanel\'" flex layout="column" session-model="vm.sessionModel"></session-insights></md-sidenav><md-sidenav flex layout="column" layout-fill class="md-sidenav-right fp-session-sidenav audience-detail" md-component-id="annotationsPanel" md-whiteframe="4"><session-annotations ng-if="vm.panelToShow == \'annotationsPanel\'" flex layout="column" session-model="vm.sessionModel"></session-annotations></md-sidenav><md-sidenav flex layout="column" layout-fill class="md-sidenav-right fp-session-sidenav audience-detail" md-component-id="recordingsPanel" md-whiteframe="4"><session-recordings ng-if="vm.panelToShow == \'recordingsPanel\'" flex layout="column" session-model="vm.sessionModel"></session-recordings></md-sidenav><md-sidenav flex layout="column" layout-fill class="md-sidenav-right fp-session-sidenav audience-detail" md-component-id="conversationPanel" md-whiteframe="4"><conversation-message-list ng-if="vm.panelToShow == \'conversationPanel\'" flex layout="column" conversation="vm.sessionModel.conversation_info" conversation-id="vm.sessionModel.conversation_info.id" is-read-only="true" session-model="vm.sessionModel"></conversation-message-list></md-sidenav>');
$templateCache.put('modules/session/session-survey-dialog.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.session.sessionPlayer.surveyFeedback">Please provide your feedback by completing this survey</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.sessionPlayer.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div flex layout="column" class="padding-40"><div flex layout="row" layout-padding><iframe ng-src="{{vm.externalUrl}}" width="100%" height="700px" noresize="noresize" frameborder="0"></iframe></div></div></md-dialog>');
$templateCache.put('modules/session/session-templates-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goBack()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="atheer.session.home.title">AiRSessions</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.upcomingSessions.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/session/session-templates.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessions.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content flex ng-if="!vm.loadingData && vm.sessions.length > 0"><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="topic"><span translate="atheer.session.topic">Topic</span></th><th md-column md-order-by="agenda"><span translate="atheer.session.agenda">Agenda</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="session in vm.sessions track by session.id"><td md-cell>{{session.topic}}</td><td md-cell>{{session.agenda}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(session.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(session)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessions.length > 0"></md-table-pagination></div>');
$templateCache.put('modules/session/session-user-invite.tmpl.html','<md-dialog flex="85" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 ng-if="!vm.isScheduledSession" hide-xs flex translate="atheer.session.sessionPlayer.inviteUsers">Invite Users</h2><h2 ng-if="vm.isScheduledSession && !vm.isSessionSingleUserInvite" hide-xs flex translate="atheer.session.sessionPlayer.addUsers">Add Users</h2><h2 ng-if="vm.isScheduledSession && vm.isSessionSingleUserInvite" hide-xs flex translate="autoComplete.placeholder.sessionsingleuserinvite">Select Host</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content ng-if="vm.loadingData" class="md-dialog-content"><div flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div></md-dialog-content><md-dialog-content ng-if="!vm.loadingData" class="md-dialog-content"><md-tabs md-selected="selectedTabIndex" md-center-tabs="true"><md-tab ng-click="vm.view = \'USERS\'"><md-tab-label><span>Users</span></md-tab-label></md-tab><md-tab ng-if="vm.isGuestFeature" ng-click="vm.view = \'GUEST_USERS\'"><md-tab-label><span>Guest Users</span></md-tab-label></md-tab></md-tabs><div ng-if="vm.currentSelectedUsers.length > 0" layout="row" layout-align="start center" class="selected-users-wrapper"><div ng-repeat="user in vm.currentSelectedUsers"><div layout="row" class="user-wrapper"><div layout="column" ng-if="user.id" layout-align="center center"><fp-avatar user="user" presence="true" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="30"></fp-avatar></div><div layout="column" ng-if="user.id" layout-align="center center" class="user-name">{{user.first_name}} {{user.last_name}}</div><div layout="column" ng-if="!user.id" layout-align="center center" class="user-name">{{user.guest_invite_value}}</div><md-button class="md-icon-button" ng-click="vm.onDeselectUser(user)"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button></div></div></div><div ng-if="vm.view == \'USERS\'" flex layout="row" layout-align="center center"><div flex="50" layout="row"><md-icon md-font-icon="zmdi zmdi-search" class="fp-invite-user-search-icon"></md-icon><md-input-container flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.transition()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container></div></div><div ng-if="vm.users.length > 0 && vm.view == \'USERS\'" class="fp-user-invite-list"><md-content class="md-padding autocomplete" layout="column"><md-list class="fp-user-list-fixed-rows"><md-list-item class="md-2-line contact-item" ng-repeat="user in vm.users track by user.id" ng-click="vm.onSelectUser(user)"><div class="padding-top-10"><fp-avatar user="user" presence="true" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="45"></fp-avatar></div><div class="md-list-item-text compact"><h3>{{user.first_name}} {{user.last_name}}</h3><p>{{user.email}}</p></div></md-list-item></md-list></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div><div ng-if="vm.view == \'GUEST_USERS\'" class="md-padding guest-invite-main"><div flex layout="row" layout-align="start start" class="guest-invite-main"><div flex="20" layout="column" layout-align="start center"><div ng-if="vm.isEmailFeatureEnabled" id="inviteByEmailOption" class="invite-options margin-top-0" ng-class="{\'active-invite-option\': vm.isInviteByEmail}" ng-click="vm.handleInviteByEmail()"><md-icon class="invite-option-icon margin-top-20 md-primary" md-font-icon="zmdi zmdi-email" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\'}"></md-icon><span translate="atheer.invite.email">Email</span></div><div ng-if="vm.isSmsFeatureEnabled" id="inviteByPhoneOption" class="invite-options" ng-class="{\'active-invite-option\': vm.isInviteByPhone}" ng-click="vm.handleInviteByPhone()"><md-icon class="invite-option-icon margin-top-20 md-primary" md-font-icon="zmdi zmdi-phone-msg" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\'}"></md-icon><span translate="atheer.invite.phoneNo">Phone number</span></div><div ng-if="!vm.isScheduledSession" id="inviteByDeviceIdOption" class="invite-options" ng-class="{\'active-invite-option\': vm.isInviteByDeviceId}" ng-click="vm.handleInviteByDeviceId()"><md-icon class="invite-option-icon margin-top-20 md-primary" md-font-icon="zmdi zmdi-devices" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\'}"></md-icon><span translate="atheer.invite.deviceId">Device ID</span></div></div><div flex="80" layout="column" layout-align="start center" class="invite-details-wrapper"><div layout="row" class="invite-input-container" ng-form="guestInviteForm"><div ng-if="vm.loadingData" flex layout="column" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="vm.isInviteByEmail && !vm.loadingData"><div layout="row" layout-align="start center"><input layout="column" type="email" name="email" ng-model="vm.email" placeholder="{{\'atheer.invite.email\' | translate}}"><md-input-container class="md-block margin-left-20"><md-select ng-model="vm.selectedLanguage" class="md-no-underline"><md-option ng-repeat="language in vm.languages" ng-value="language.value">{{language.displayName}}</md-option></md-select></md-input-container><md-button layout="column" type="submit" class="md-primary md-raised add-guest-btn" aria-label="primary button" ng-click="vm.addGuestUser()" ng-disabled="!vm.email"><span translate="entity.action.add">ADD</span></md-button></div><span ng-if="vm.hasError" class="error-msg" layout="row" layout-align="start center" translate="atheer.invite.invalidEmail">Invalid email</span></div><div ng-if="vm.isInviteByPhone && !vm.loadingData"><div layout="row" layout-align="start center"><md-autocomplete class="country-code" md-search-text="vm.code" md-items="item in vm.querySearch(vm.code)" md-item-text="item.code" placeholder="{{\'atheer.invite.codePlaceholder\' | translate}}" md-selected-item="vm.defaultCountryCode"><md-item-template><span layout="row"><span layout="column" flex="75" layout-align="start start"><span layout="row"><span class="flag">{{item.flag}}</span> <span class="padding-left-10 guest-country-name" md-highlight-text="ctrl.code">{{item.name}}</span> </span></span><span layout="column" flex="25" layout-align="end end">{{item.code}}</span></span></md-item-template></md-autocomplete><input class="phone-number" type="text" name="phoneNumber" layout="column" ng-model="vm.phoneNumber" placeholder="{{\'atheer.invite.phoneNo\' | translate}}" ng-pattern="vm.phoneNumberPattern" maxlength="20" required><md-input-container class="md-block margin-left-20"><md-select ng-model="vm.selectedLanguage" class="md-no-underline"><md-option ng-repeat="language in vm.languages" ng-value="language.value">{{language.displayName}}</md-option></md-select></md-input-container><md-button layout="column" type="submit" class="md-primary md-raised add-guest-btn" aria-label="primary button" ng-click="vm.addGuestUser()" ng-disabled="!vm.code || !vm.phoneNumber"><span translate="entity.action.add">ADD</span></md-button></div><span ng-if="hasError" class="error-msg phone-number-error" layout="row" layout-align="start center" translate="atheer.invite.invalidNo">Invalid phone number</span></div><div ng-if="vm.isInviteByDeviceId && !vm.loadingData"><div layout="row" layout-align="start center"><input layout="column" type="text" name="deviceId" ng-model="vm.deviceId" placeholder="{{\'atheer.invite.deviceId\' | translate}}" ng-pattern="vm.deviceIdPattern" maxlength="10"><md-input-container class="md-block margin-left-20"><md-select ng-model="vm.selectedLanguage" class="md-no-underline"><md-option ng-repeat="language in vm.languages" ng-value="language.value">{{language.displayName}}</md-option></md-select></md-input-container><md-button layout="column" type="submit" class="md-primary md-raised add-guest-btn" aria-label="primary button" ng-click="vm.addGuestUser()" ng-disabled="!vm.deviceId"><span translate="entity.action.add">ADD</span></md-button><fading-circle-spinner class="validation-spinner" layout="column" ng-if="vm.isValidating"></fading-circle-spinner></div><span ng-if="vm.hasError" class="error-msg" layout="row" layout-align="start center" translate="atheer.invite.invalidDeviceId">Invalid device number</span></div></div></div></div></div></md-dialog-content><md-dialog-actions layout="row" ng-if="!vm.loadingData && vm.users.length > 0"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-if="!vm.isScheduledSession" layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedUsers.length <= 0" translate="entity.action.invite">Invite</md-button><md-button ng-if="vm.isScheduledSession" layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.isAddButtonDisabled()" translate="entity.action.add">Add</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/session/session.tmpl.html','<div flex ui-view></div>');
$templateCache.put('modules/session/sessions-all-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ng-click="vm.goBack()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="atheer.session.home.title">AiRSessions</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.session.enterSearchPlaceholder\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.search">Search</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.upcomingSessions.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.exportSessionsReport()"><md-icon class="fa fa-download icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.insights.emailReport">Export AiRSession Summary</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/session/sessions-all.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessions.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content flex ng-if="!vm.loadingData && vm.sessions.length > 0"><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th style="width: 15%;" md-column><span translate="atheer.session.sessionNo">No</span></th><th style="width: 30%;" md-column md-order-by="topic"><span translate="atheer.session.topic">Topic</span></th><th style="width: 25%;" md-column md-order-by="start_time"><span translate="atheer.session.startTime">Start Time</span></th><th style="width: 15%;" md-column md-order-by="owner"><span translate="atheer.session.owner">Owner</span></th><th style="width: 15%;"></th></tr></thead><tbody md-body><tr ng-repeat="session in vm.sessions track by session.id"><td md-cell>{{session.session_no}}</td><td md-cell>{{session.topic}}</td><td md-cell>{{session.start_time | date: \'MMM dd, y hh:mm a\'}}</td><td md-cell>Admin</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button ng-if="session.session_stats.has_annotation" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'annotationsPanel\', session)"><md-icon class="zmdi zmdi-collection-image icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeAnnotations">See Annotations</span></fp-tooltip></md-button><md-button ng-if="session.conversation_info.last_message" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'conversationPanel\', session)"><md-icon class="fa fa-comments icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeSessionChat">See Session Chat</span></fp-tooltip></md-button><md-button ng-if="session.session_stats.has_recording" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'recordingsPanel\', session)"><md-icon class="fa fa-youtube-play icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeRecordings">See Recordings</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'insightsPanel\', session)"><md-icon class="zmdi zmdi-chart icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeInsights">See Insights</span></fp-tooltip></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.update"><md-button aria-label="primary button" ng-click="vm.editObject(session)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><span translate="entity.action.edit">Edit</span></md-button></md-menu-item><md-menu-item ng-if="session.status == \'OPEN\'"><md-button aria-label="primary button" ng-click="vm.endSession(session)"><md-icon md-font-icon="fa fa-times-circle"></md-icon><span translate="atheer.session.sessionPlayer.end">End</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(session)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessions.length > 0"></md-table-pagination></div><ng-include src="\'modules/session/session-summary.tmpl.html\'"></ng-include>');
$templateCache.put('modules/session/sessions-past-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ng-click="vm.goBack()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="atheer.session.home.title">AiRSessions</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.session.enterSearchPlaceholder\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.search">Search</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.upcomingSessions.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/session/sessions-past.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessions.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content flex ng-if="!vm.loadingData && vm.sessions.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th style="width: 15%;" md-column><span translate="atheer.session.sessionNo">No</span></th><th style="width: 25%;" md-column md-order-by="topic"><span translate="atheer.session.topic">Topic</span></th><th style="width: 20%;" md-column md-order-by="start_time"><span translate="atheer.session.startTime">Start Time</span></th><th style="width: 10%;" md-column><span translate="atheer.session.duration">Duration</span></th><th style="width: 15%;"></th></tr></thead><tbody md-body><tr ng-repeat="session in vm.sessions track by session.id"><td md-cell>{{session.session_no}}</td><td md-cell>{{session.topic}}</td><td md-cell>{{session.start_time | date: \'MMM dd, y hh:mm a\'}}</td><td md-cell>{{session.session_stats.duration + \' min\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button ng-if="session.session_stats.has_annotation" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'annotationsPanel\', session)"><md-icon class="zmdi zmdi-collection-image icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeAnnotations">See Annotations</span></fp-tooltip></md-button><md-button ng-if="session.conversation_info.last_message" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'conversationPanel\', session)"><md-icon class="fa fa-comments icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeSessionChat">See Session Chat</span></fp-tooltip></md-button><md-button ng-if="session.session_stats.has_recording" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'recordingsPanel\', session)"><md-icon class="fa fa-youtube-play icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeRecordings">See Recordings</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'insightsPanel\', session)"><md-icon class="zmdi zmdi-chart icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeInsights">See Insights</span></fp-tooltip></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.update"><md-button aria-label="primary button" ng-click="vm.editObject(session)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><span translate="entity.action.edit">Edit</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(session)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessions.length > 0"></md-table-pagination></div><ng-include src="\'modules/session/session-summary.tmpl.html\'"></ng-include>');
$templateCache.put('modules/session/sessions-upcoming-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="atheer.session.home.title">AiRSessions</span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.upcomingSessions.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/session/sessions-upcoming.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="row" layout-align="center center" class="margin-top-20"><div flex="10" layout="column" layout-align="center center" class="fp-session-action-box margin-right-20" ng-click="vm.startInstantSession()"><md-button class="md-icon-button quick-actions md-primary margin-bottom-10" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.onIconClick(action.name, action.properties)"><md-icon md-svg-src="/assets/images/card/start_session.svg"></md-icon></md-button><span class="md-title" translate="entity.action.start">Start</span></div><div flex="10" layout="column" layout-align="center center" class="fp-session-action-box margin-right-20" ng-click="vm.joinSession()"><md-button class="md-icon-button quick-actions md-primary margin-bottom-10" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.onIconClick(action.name, action.properties)"><md-icon md-svg-src="/assets/images/card/join_session.svg"></md-icon></md-button><span class="md-title" translate="entity.action.join">Join</span></div><div flex="10" layout="column" layout-align="center center" class="fp-session-action-box margin-right-20" ng-click="vm.scheduleSession()"><md-button class="md-icon-button quick-actions md-primary margin-bottom-10" layout-align="center center" layout="column" aria-label="primary button" ng-click="vm.onIconClick(action.name, action.properties)"><md-icon md-svg-src="/assets/images/card/schedule_session.svg"></md-icon></md-button><span class="md-title" translate="atheer.session.upcomingSessions.schedule">Schedule</span></div></div><div ng-if="!vm.loadingData" layout="row" layout-align="center center" class="margin-top-30 margin-bottom-20"><div layout="row" layout-align="center center"><div class="fp-session-action-border"><span class="md-title" translate="atheer.session.home.personal">Your personal room</span><span class="md-title"> : {{vm.personalSession.session_no}}</span><md-button class="margin-left-20 md-icon-button" ng-click="vm.copyInvitation(vm.personalSession)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-copy" ng-style="{\'margin-top\': \'-5\' + \'px\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.copyInvitation">Copy Invitation</span></fp-tooltip></md-button><md-button class="md-icon-button margin-right-20" ui-sref="storm.sessions.personal" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-settings" ng-style="{\'margin-top\': \'-3\' + \'px\'}"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.home.editPersonalRoom">Edit personal room settings</span></fp-tooltip></md-button></div><div class="fp-session-action-border"><md-button md-no-ink class="md-primary" ui-sref="storm.sessions.templates"><span translate="atheer.session.home.template">Templates</span></md-button></div><div class="fp-session-action-border"><md-button md-no-ink class="md-primary" ui-sref="storm.sessions.past"><span translate="atheer.session.home.pastSessions">Past</span></md-button></div><div><md-button md-no-ink class="md-primary" ui-sref="storm.sessions.all" permission permission-only="vm.permissions.manage"><span translate="atheer.session.home.allSessions">All Sessions</span></md-button></div></div></div><div ng-if="!vm.loadingData && vm.sessions.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content flex ng-if="!vm.loadingData && vm.sessions.length > 0"><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th style="width: 15%;" md-column><span translate="atheer.session.sessionNo">No</span></th><th style="width: 40%;" md-column md-order-by="topic"><span translate="atheer.session.topic">Topic</span></th><th style="width: 30%;" md-column md-order-by="start_time"><span translate="atheer.session.startTime">Start Time</span></th><th style="width: 15%;"></th></tr></thead><tbody md-body><tr ng-repeat="session in vm.sessions track by session.id"><td md-cell>{{session.session_no}}</td><td md-cell><span class="margin-right-10">{{session.topic}}</span><div ng-if="session.active_session" class="fp-active-badge" md-colors="{background: \'primary-500-0.3\'}" ng-style="{\'color\': \'{{vm.color}}\'}" translate="atheer.session.upcomingSessions.active">Active</div></td><td md-cell>{{session.start_time | date: \'MMM dd, y hh:mm a\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button ng-if="vm.isHost(session)" class="md-primary md-raised" ng-click="vm.startSession(session)" aria-label="primary button"><span translate="entity.action.start">Start</span><fp-tooltip placement="bottom"><span translate="entity.action.start">Start</span></fp-tooltip></md-button><md-button ng-if="!vm.isHost(session) && vm.isParticipant(session)" class="md-primary md-raised" ng-click="vm.startSession(session)" aria-label="primary button"><span translate="entity.action.join">Join</span><fp-tooltip placement="bottom"><span translate="entity.action.join">Join</span></fp-tooltip></md-button><md-button ng-if="vm.isHost(session)" class="md-icon-button" ng-click="vm.copyInvitation(session)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.copyInvitation">Copy Invitation</span></fp-tooltip></md-button><md-button ng-if="vm.isUserHostOrScheduler(session)" permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(session.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item ng-if="vm.templateSession"><md-button aria-label="primary button" ng-click="vm.saveAsTemplate(session)"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><span translate="atheer.session.upcomingSessions.saveAs">Save as Template</span></md-button></md-menu-item><md-menu-item ng-if="vm.isHost(session)"><md-button aria-label="primary button" ng-click="vm.endSession(session)"><md-icon md-font-icon="fa fa-times-circle"></md-icon><span translate="atheer.session.sessionPlayer.end">End</span></md-button></md-menu-item><md-menu-item ng-if="vm.isUserHostOrScheduler(session)" permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(session)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessions.length > 0"></md-table-pagination></div>');
$templateCache.put('modules/smartflow/jobflow-insights-error-detail.tmpl.html','<md-dialog aria-label="User Detail" flex="80" flex-gt-md="80"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><h2 translate="atheer.smartFlow.insights.errorDetails">Error Details</h2><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><div class="alert alert-danger" translate="atheer.smartFlow.insights.error" translate-values="{error: \'{{vm.error}}\'}">Error: {{ vm.error }}</div><hr><div ng-if="vm.loadingData" flex class="md-dialog-content" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="vm.errorList.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column ng-repeat="header in vm.headerList track by $index"><span translate>{{header}}</span></th></tr></thead><tbody md-body><tr ng-repeat="error in vm.errorList track by $index"><td md-cell ng-repeat="data in error track by $index">{{data}}</td></tr></tbody></table></md-table-container></md-content></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()" translate="entity.action.close">Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-insights-input-detail.tmpl.html','<md-dialog aria-label="User Detail" flex="80" flex-gt-md="80"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><h2 translate="atheer.smartFlow.insights.inputDetails">Input Details</h2><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" flex class="md-dialog-content" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="vm.inputList.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column ng-repeat="header in vm.headerList track by $index"><span translate>{{header}}</span></th></tr></thead><tbody md-body><tr><td md-cell ng-repeat="input in vm.inputList track by $index">{{input}}</td></tr></tbody></table></md-table-container></md-content></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()" translate="entity.action.close">Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-insights-job-detail.tmpl.html','<md-dialog aria-label="User Detail" flex="80" flex-gt-md="60"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><h2 translate="atheer.smartFlow.insights.jobDetails">Job Details</h2><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" flex class="md-dialog-content" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="vm.jobList.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="name"><span translate="atheer.smartFlow.insights.jobId">Job Id</span></th><th md-column md-order-by="name"><span translate="atheer.smartFlow.insights.airForm">AiRForm</span></th><th md-column><span translate="atheer.smartFlow.insights.team">Team</span></th><th md-column><span translate="atheer.smartFlow.insights.assignedTo">Assigned To</span></th></tr></thead><tbody md-body><tr ng-repeat="job in vm.jobList track by job.id"><td md-cell>{{job.id}}</td><td md-cell>{{job.airform}}</td><td md-cell>{{job.team}}</td><td md-cell>{{job.assignedTo}}</td></tr></tbody></table></md-table-container></md-content></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()" translate="entity.action.close">Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-insights-overview.tmpl.html','<ng-include src="\'modules/smartflow/smartflow-detail-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="vm.runList.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.smartFlow.insights.runDate">Run Date</span></th><th md-column><span translate="atheer.smartFlow.insights.requestObject">Request Object</span></th><th md-column><span translate="atheer.smartFlow.insights.jobNumber">Job Number</span></th><th md-column><span translate="atheer.smartFlow.status">Status</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="run in vm.runList track by run.executionId"><td md-cell>{{run.startDate | date:\'MM/dd/yyyy HH:mm:ss a\'}}</td><td md-cell flex><div layout="row" layout-wrap><div ng-repeat="inputData in run.inputList track by $index"><a href="" ng-click="vm.openInputDetails(inputData.value, inputData.key)">{{inputData.key}}</a>&nbsp;</div></div></td><td md-cell flex><div layout="row" layout-wrap><div ng-repeat="jobNumber in run.jobNumberList track by $index"><a href="" ng-click="vm.openJobDetails(jobNumber)">{{jobNumber}}</a>&nbsp;</div></div></td><td md-cell ng-if="run.status === \'FAILED\'"><a href="" ng-click="vm.openErrorDetails(run)">{{run.status}}</a></td><td md-cell ng-if="run.status !== \'FAILED\'">{{run.status}}</td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.runList.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.query.page" md-on-paginate="vm.init"></md-table-pagination>');
$templateCache.put('modules/smartflow/jobflow-molecules-airform-resolver.tmpl.html','<md-dialog flex="80" flex-gt-md="60" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.aiRFormResolver">AiRForm Resolver</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="resolverForm" layout="column" class="fp-smartflow-builder-setting-form"><div><md-input-container class="md-block"><label for="title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="title" ng-model="vm.setting[\'title\']" placeholder="{{\'atheer.smartFlow.builder.title\' | translate}}" required><div ng-messages="resolverForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div><div layout="row" layout-align="space-between center"><label translate="atheer.smartFlow.builder.resolverType">Resolver Type</label><md-radio-group class="md-primary" layout="row" ng-model="vm.setting.properties.resolverType" ng-change="vm.onResolverTypeChange()"><md-radio-button ng-repeat="resolverType in vm.resolverTypeList" ng-value="resolverType.value">{{ resolverType.name }}</md-radio-button></md-radio-group></div><br><md-input-container ng-if="vm.setting.properties.resolverType === \'STATIC\' && vm.isStaticObjectLoaded" class="md-block"><label for="staticResult" translate="atheer.smartFlow.builder.result">Result</label><md-select name="staticResult" ng-model="vm.setting.properties[\'staticResult\']" id="staticResult" required><md-option ng-value="option.id" ng-repeat="option in vm.staticObject">{{option.name}}</md-option></md-select></md-input-container><div ng-if="vm.setting.properties.resolverType === \'DATASET\' && vm.isDynamicObjectLoaded"><md-input-container flex="100" layout="row"><label for="dataSetId" translate="atheer.smartFlow.builder.datasets">Datasets</label><md-select layout="row" flex="100" name="dataSetId" id="dataSetId" ng-model="vm.setting.properties.dataSetQueryCriteria.dataSetId" required ng-change="vm.onSelectDataset()"><md-option ng-value="option.id" ng-repeat="option in vm.datasetObject">{{option.label}}</md-option></md-select></md-input-container><br><div flex="100" layout="row"><div flex="30" layout="column"><md-input-container class="md-block" ng-class="{ \'disable-select\': vm.object.dataSetId == \'\'}"><label for="dataModelPropertyName" translate="atheer.smartFlow.builder.dataModel">DataModel</label><md-select name="dataModelPropertyName" id="dataModelPropertyName" ng-model="vm.setting.properties.dataSetQueryCriteria.dataModelPropertyName" required><md-option ng-value="option.name" ng-repeat="option in vm.dataModels">{{option.name}}</md-option></md-select></md-input-container></div><div flex="30" layout="column"><md-input-container class="md-block" ng-class="{ \'disable-select\': vm.object.dataSetId == \'\'}"><label for="dataSetColumnId" translate="atheer.smartFlow.builder.datasetsColumns">Datasets Columns</label><md-select name="dataSetColumnId" id="dataSetColumnId" ng-model="vm.setting.properties.dataSetQueryCriteria.dataSetColumnId" required><md-option ng-value="column.id" ng-repeat="column in vm.datasetColumnsObject">{{column.title}}</md-option></md-select></md-input-container></div><div flex="30" layout="column"><md-input-container class="md-block" ng-class="{ \'disable-select\': vm.object.dataSetId == \'\'}"><label for="outputColumnId" translate="atheer.smartFlow.builder.output">Output</label><md-select name="outputColumnId" id="outputColumnId" ng-model="vm.setting.properties.dataSetQueryCriteria.outputColumnId" required><md-option ng-value="column.id" ng-repeat="column in vm.datasetColumnsObject">{{column.title}}</md-option></md-select></md-input-container></div></div></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="resolverForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-audience-resolver.tmpl.html','<md-dialog flex="80" flex-gt-md="60" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.teamResolver">Team Resolver</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="resolverForm" layout="column" class="fp-smartflow-builder-setting-form"><div><md-input-container class="md-block"><label for="title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="title" ng-model="vm.setting[\'title\']" placeholder="{{\'atheer.smartFlow.builder.title\' | translate}}" required><div ng-messages="resolverForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div><div layout="row" layout-align="space-between center"><label translate="atheer.smartFlow.builder.resolverType">Resolver Type</label><md-radio-group class="md-primary" layout="row" ng-model="vm.setting.properties.resolverType" ng-change="vm.onResolverTypeChange()"><md-radio-button ng-repeat="resolverType in vm.resolverTypeList" ng-value="resolverType.value">{{ resolverType.name }}</md-radio-button></md-radio-group></div><br><md-input-container ng-if="vm.setting.properties.resolverType === \'STATIC\' && vm.isStaticObjectLoaded" class="md-block"><label for="staticResult" translate="atheer.smartFlow.builder.result">Result</label><md-select name="staticResult" ng-model="vm.setting.properties[\'staticResult\']" id="staticResult" required><md-option ng-value="option.id" ng-repeat="option in vm.staticObject">{{option.name}}</md-option></md-select></md-input-container><div ng-if="vm.setting.properties.resolverType === \'QUERY\' && vm.isDynamicObjectLoaded" layout="row" ng-repeat="object in vm.objects track by $index"><div flex="50" layout="column"><div layout="row"><div flex="80" layout="column"><md-input-container class="md-block"><label for="{{object.data_model_name}}" translate="atheer.smartFlow.builder.dataModel">Data Model</label> <input type="text" class="form-control" name="{{object.data_model_name}}" id="{{object.data_model_name}}" ng-model="object.data_model_value" placeholder="{{object.data_model_name}}" required></md-input-container></div><md-button flex="20" layout="column" class="md-icon-button fp-search-button" ng-click="vm.showProperties(object, $index)" aria-label="primary button"><md-icon class="fa fa-search-plus icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.searchProperties">search properties</span></fp-tooltip></md-button></div></div><div flex layout="column"><md-input-container class="md-block"><label for="{{object.search_key_name}}" translate="atheer.smartFlow.builder.searchKeys">Search Keys</label><md-select name="{{object.search_key_name}}" ng-model="vm.setting.properties.searchCriteria.searchKeys[object.data_model_value]" id="{{object.search_key_name}}" required><md-option ng-value="option.value" ng-repeat="option in vm.dynamicObject">{{option.label}}</md-option></md-select></md-input-container></div><div flex="15" layout="column"><div flex layout="row" class="pos-rlt"><md-button flex="50" layout="column" ng-if="$last" class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" ng-if="vm.objects.length > 1" layout="column" class="md-icon-button fp-remove-field-button" ng-click="vm.removeField($index, object)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></div></div><div ng-if="vm.setting.properties.resolverType === \'LOOKUP\'" class="md-block"><label for="resolveUsing" translate="atheer.smartFlow.builder.resolveUsing">Resolve Using</label><md-select multiple="multiple" name="resolveUsing" ng-model="vm.resolverList" id="resolveUsing" required ng-change="vm.onResolveTypeChnage(true)"><md-option ng-value="option.name" ng-repeat="option in vm.dataModelProperties">{{option.name}}</md-option></md-select><br><md-table-container ng-if="vm.resolverList.length > 0"><table md-table class="md-data-table"><thead md-head><tr md-row><th md-column ng-repeat="header in vm.resolverList"><span>{{header}}</span></th><th md-column><span>{{vm.setting.properties[\'objectType\']}}</span></th><th><span translate="atheer.smartFlow.builder.action">Action</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="lookUpRow in vm.lookUpData track by $index"><td class="first-cell" md-cell ng-repeat="data in vm.resolverList"><span><input type="text" class="form-control" name="{{lookUpRow[data]}}" ng-model="lookUpRow[data]" placeholder="{{lookUpRow[data]}}" required></span></td><td><md-select name="lookupResult" id="lookupResult" ng-model="lookUpRow[\'onSuccessResult\']"><md-option ng-value="option.id" ng-repeat="option in vm.staticObject">{{option.name}}</md-option></md-select></td><td width="60px"><div layout="row"><md-button flex="50" class="md-icon-button" ng-click="vm.addRow($index)" ng-if="$last" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" class="md-icon-button" ng-click="vm.deleteRow($index)" ng-if="vm.lookUpData.length > 1" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></td></tr></tbody></table></md-table-container></div><div ng-if="vm.setting.properties.resolverType === \'DATAMODEL\'" class="md-block"><label for="datamodelResult" translate="atheer.smartFlow.builder.result">Result</label><md-select name="datamodelResult" ng-model="vm.setting.properties[\'dataModelCriteria\'].dataModelId" id="datamodelResult" required><md-option ng-value="option.name" ng-repeat="option in vm.dataModelProperties" ng-click="vm.onDataModelChange(option)">{{option.name}}</md-option></md-select></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="resolverForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-data-mapper.tmpl.html','<md-dialog flex="80" flex-gt-md="60" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.dataMapper">Data Mapper</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="jobFlowSettingForm" layout="column" class="fp-smartflow-builder-setting-form"><div><md-input-container class="md-block"><label for="title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="title" ng-model="vm.setting[\'title\']" placeholder="{{\'atheer.smartFlow.builder.title\' | translate}}" required><div ng-messages="jobFlowSettingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div><div flex layout="row"><div flex layout="column" ng-hide="vm.smartflowCategory === \'JOB_EVENT\'"><div flex layout="row"><span class="fp-label" flex layout="column" translate="atheer.smartFlow.builder.uploadSampleFile">Upload Sample File</span><md-button class="fp-upload-button md-icon-button" flex layout="column" ngf-select="vm.uploadDataMapper()" ng-model="vm.file" accept=".csv" ngf-max-size="2MB" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-upload"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.uploadFile">Upload File</span></fp-tooltip></md-button></div></div><div flex layout="column"><md-input-container class="md-block"><label for="dataModel" translate="atheer.smartFlow.builder.dataModel">Data Model</label><md-select name="dataModel" ng-change="vm.onDataModelChange()" ng-model="vm.setting.dataModel" id="dataModel" required><md-option ng-value="dataModel.id" ng-repeat="dataModel in vm.dataModels">{{dataModel.displayName}}</md-option></md-select></md-input-container></div></div><div ng-if="vm.isUploaded && vm.setting.dataModel"><hr><div flex layout="row"><h3 translate="atheer.smartFlow.builder.mapDataModel">Map your Data Model</h3></div><div flex layout="row" ng-repeat="object in vm.object"><div flex="40" layout="column"><md-input-container class="md-block"><label for="{{object.header_name}}" translate="atheer.smartFlow.builder.headers">Headers</label><md-select name="{{object.header_name}}" ng-model="object.header_value" id="{{object.header_name}}" required ng-if="vm.smartflowCategory !== \'JOB_EVENT\'"><md-option ng-value="option" ng-repeat="option in vm.setting.headers">{{option}}</md-option></md-select><md-select name="{{object.header_name}}" ng-model="object.header_value" id="{{object.header_name}}" required ng-if="vm.smartflowCategory === \'JOB_EVENT\'"><md-option ng-value="option.name" ng-repeat="option in vm.setting.headers">{{option.label}}</md-option></md-select></md-input-container></div><div flex="40" layout="column"><md-input-container ng-class="{ \'disable-select\': object.header_value == \'\'}" class="md-block"><label for="{{object.data_model_name}}" translate="atheer.smartFlow.builder.dataModelName" translate-values="{displayName: \'{{vm.dataModel.displayName}}\'}">{{vm.dataModel.displayName}} Data Model</label><md-select name="{{object.data_model_name}}" ng-model="vm.setting.properties.mapping[object.header_value].name" id="{{object.data_model_name}}" required><md-option ng-value="model.name" ng-repeat="model in vm.dataModel.properties">{{model.name}}</md-option></md-select></md-input-container></div><div flex="20" layout="column"><div flex layout="row" class="pos-rlt"><md-button flex="50" layout="column" ng-if="$last" class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" ng-if="vm.object.length > 1" layout="column" class="md-icon-button fp-remove-field-button" ng-click="vm.removeField($index, object)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></div></div></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="jobFlowSettingForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-job-scope.tmpl.html','<md-dialog flex="60" flex-gt-md="40" aria-label="" ng-form="jobFlowSettingForm"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.jobScope">Job Scope</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex layout="column" class="fp-smartflow-builder-setting-form"><md-input-container class="md-block"><label translate="atheer.smartFlow.builder.event">Event</label><md-select ng-model="vm.jobScopeType" required><md-option value="Completed" translate="atheer.smartFlow.builder.jobCompleted">Job Completed</md-option></md-select></md-input-container><md-input-container class="md-block"><label translate="atheer.smartFlow.builder.selectAirForms">Select AiRForms</label><md-select ng-model="vm.selectedAirFormList" multiple="multiple" required><md-option ng-repeat="airForm in vm.airFormList" ng-value="airForm.id">{{airForm.name}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="jobFlowSettingForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-job-seed.tmpl.html','<md-dialog flex="60" flex-gt-md="40" aria-label="" ng-form="jobFlowSettingForm"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.jobSeed">Job Seed</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData || vm.loadingDataModel || vm.loadingAirForm" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && !vm.loadingDataModel && !vm.loadingAirForm" flex layout="column" class="fp-smartflow-builder-setting-form"><md-input-container class="md-block"><label for="title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="title" ng-model="vm.setting[\'title\']" placeholder="{{\'atheer.smartFlow.builder.title\' | translate}}" required><div ng-messages="jobFlowSettingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-checkbox ng-model="vm.isAiRFormMapper" ng-if="!vm.hasJobUpdate" ng-change="vm.onAiRFormMapperChange()"><span translate="atheer.smartFlow.builder.airFormMapper">AiRForm mapper</span></md-checkbox><div layout="row" ng-if="vm.isAiRFormMapper && !vm.hasJobUpdate" ng-repeat="object in vm.objectList track by $index"><div flex="40" layout="column"><md-input-container class="md-block"><label for="{{object.data_mapper_key}}" translate="atheer.smartFlow.builder.dataMapper">Data Mapper</label><md-select name="{{object.data_mapper_key}}" id="{{object.data_mapper_key}}" ng-model="object.data_mapper_value" required><md-option ng-value="option.name" ng-repeat="option in vm.dataModelProperties">{{option.name}}</md-option></md-select></md-input-container></div><div flex="40" layout="column"><md-input-container class="md-block"><label for="{{object.airForm_key}}" translate="atheer.smartFlow.builder.jobObjectAttribute">Job Object Attributes</label><md-select name="{{object.airForm_key}}" id="{{object.airForm_key}}" ng-model="object.airForm_value" required><md-option ng-value="option.key" ng-repeat="option in vm.responseList">{{option.value}}</md-option></md-select></md-input-container></div><div flex="20" layout="column"><div flex layout="row" class="pos-rlt"><md-button flex="50" layout="column" ng-if="$last" class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" ng-if="vm.objectList.length > 1" layout="column" class="md-icon-button fp-remove-field-button" ng-click="vm.removeField($index, object)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></div></div><md-checkbox ng-model="vm.isJobMapper" ng-change="vm.onJobMapperChange()"><span translate="atheer.smartFlow.builder.jobMapper">Job mapper</span></md-checkbox><div layout="row" ng-if="vm.isJobMapper" ng-repeat="object in vm.jobObjectList track by $index"><div flex="40" layout="column"><md-input-container class="md-block"><label for="{{object.data_mapper_key}}" translate="atheer.smartFlow.builder.dataMapper">Data Mapper</label><md-select name="{{object.data_mapper_key}}" id="{{object.data_mapper_key}}" ng-model="object.data_mapper_value" required><md-option ng-value="option.name" ng-repeat="option in vm.dataModelProperties">{{option.name}}</md-option></md-select></md-input-container></div><div flex="40" layout="column"><md-input-container class="md-block"><label for="{{object.jobAttribute_key}}" translate="atheer.smartFlow.builder.jobObjectAttribute">Job Object Attributes</label><md-select name="{{object.jobAttribute_key}}" id="{{object.jobAttribute_key}}" ng-model="object.jobAttribute_value" required><md-option ng-value="option.key" ng-repeat="option in vm.jobAttributeList">{{option.value}}</md-option></md-select></md-input-container></div><div flex="20" layout="column"><div flex layout="row" class="pos-rlt"><md-button flex="50" layout="column" ng-if="$last" class="md-icon-button" ng-click="vm.addJobField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" ng-if="vm.jobObjectList.length > 1" layout="column" class="md-icon-button fp-remove-field-button" ng-click="vm.removeJobField($index, object)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="jobFlowSettingForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-properties.tmpl.html','<md-dialog flex="60" flex-gt-md="40" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.objectProperties" translate-values="{title: \'{{vm.title}}\'}">Object {{vm.title}} Properties</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="jobFlowSettingForm" layout="column" class="fp-smartflow-builder-setting-form"><md-table-container><table md-table class="md-data-table"><thead md-head><tr md-row><th class="first-cell" md-column><span></span></th><th md-column><span translate="atheer.smartFlow.name">Name</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="data in vm.dataModelProperties | orderBy: vm.tableQuery.order | limitTo: vm.tableQuery.limit : (vm.tableQuery.page -1) * vm.tableQuery.limit"><td class="first-cell" md-cell><span><md-radio-group ng-model="vm.isSelected" ng-change="vm.onObjectSelection(data)"><md-radio-button class="table-radio-button" value="{{data.name}}"></md-radio-button></md-radio-group></span></td><td md-cell><span>{{data.name}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.tableQuery.limit" md-page="vm.tableQuery.page" md-total="{{vm.dataModelProperties.length}}" md-page-select md-boundary-links="true"></md-table-pagination></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="jobFlowSettingForm.$invalid" class="md-primary md-raised"><span translate="entity.action.select">Select</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-resolver.tmpl.html','<md-dialog flex="60" flex-gt-md="40" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.resolverTitle">Resolver</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="resolverForm" layout="column" class="fp-smartflow-builder-setting-form"><div><md-input-container class="md-block"><label for="title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="title" ng-model="vm.setting[\'title\']" placeholder="{{\'atheer.smartFlow.builder.title\' | translate}}" required><div ng-messages="resolverForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div><md-input-container class="md-block"><label for="objectType" translate="atheer.smartFlow.builder.objectType">Object Type</label><md-select name="objectType" ng-model="vm.setting.properties[\'objectType\']" id="objectType" required ng-change="vm.onObjectTypeChange()"><md-option ng-value="option.label" ng-repeat="option in vm.listItems">{{option.label}}</md-option></md-select></md-input-container><br><div layout="row" layout-align="space-between center"><label translate="atheer.smartFlow.builder.resolverType">Resolver Type</label><md-radio-group class="md-primary" layout="row" ng-model="vm.setting.properties.resolverType" ng-change="vm.onResolverTypeChange()"><md-radio-button ng-repeat="resolverType in vm.resolverTypeList" ng-value="resolverType.value" ng-disabled="vm.setting.properties[\'objectType\'] === \'AiRForm\' && resolverType.value !== \'static\'">{{ resolverType.name }}</md-radio-button></md-radio-group></div><br><md-input-container ng-if="vm.setting.properties.resolverType === \'STATIC\' && vm.isStaticObjectLoaded" class="md-block"><label for="staticResult" translate="atheer.smartFlow.builder.result">Result</label><md-select name="staticResult" ng-model="vm.setting.properties[\'staticResult\']" id="staticResult" required><md-option ng-value="option.id" ng-repeat="option in vm.staticObject">{{option.name}}</md-option></md-select></md-input-container><div ng-if="vm.setting.properties.resolverType === \'QUERY\' && vm.isDynamicObjectLoaded" layout="row" ng-repeat="object in vm.objects track by $index"><div flex layout="column"><md-input-container class="md-block"><label for="{{object.search_key_name}}" translate="atheer.smartFlow.builder.searchKeys">Search Keys</label><md-select name="{{object.search_key_name}}" ng-model="object.search_key_value" id="{{object.search_key_name}}" required><md-option ng-value="option.value" ng-repeat="option in vm.dynamicObject">{{option.label}}</md-option></md-select></md-input-container></div><div flex="40" layout="column"><div layout="row"><div flex="80" layout="column"><md-input-container class="md-block"><label for="{{object.data_model_name}}" translate="atheer.smartFlow.builder.dataModel">Data Model</label> <input type="text" class="form-control" name="{{object.data_model_name}}" id="{{object.data_model_name}}" ng-model="vm.setting.properties.searchCriteria.searchKeys[object.search_key_value]" placeholder="{{object.data_model_name}}" required></md-input-container></div><md-button flex="20" layout="column" class="md-icon-button fp-search-button" ng-click="vm.showProperties(object)" aria-label="primary button"><md-icon class="fa fa-search-plus icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.searchProperties">search properties</span></fp-tooltip></md-button></div></div><div flex="20" layout="column"><div flex layout="row" class="pos-rlt"><md-button flex="50" layout="column" ng-if="$last" class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" ng-if="vm.objects.length > 1" layout="column" class="md-icon-button fp-remove-field-button" ng-click="vm.removeField($index, object)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></div></div><div ng-if="vm.setting.properties.resolverType === \'LOOKUP\'" class="md-block"><label for="resolveUsing" translate="atheer.smartFlow.builder.resolveUsing">Resolve Using</label><md-select multiple="multiple" name="resolveUsing" ng-model="vm.resolverList" id="resolveUsing" required ng-change="vm.onResolveTypeChnage(true)"><md-option ng-value="option.name" ng-repeat="option in vm.dataModelProperties">{{option.name}}</md-option></md-select><br><md-table-container ng-if="vm.resolverList.length > 0"><table md-table class="md-data-table"><thead md-head><tr md-row><th md-column ng-repeat="header in vm.resolverList"><span>{{header}}</span></th><th md-column><span>{{vm.setting.properties[\'objectType\']}}</span></th><th><span translate="atheer.smartFlow.builder.action">Action</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="lookUpRow in vm.lookUpData track by $index"><td class="first-cell" md-cell ng-repeat="data in vm.resolverList"><span><input type="text" class="form-control" name="{{lookUpRow[data]}}" ng-model="lookUpRow[data]" placeholder="{{lookUpRow[data]}}" required></span></td><td><md-select name="lookupResult" id="lookupResult" ng-model="lookUpRow[\'onSuccessResult\']"><md-option ng-value="option.id" ng-repeat="option in vm.staticObject">{{option.name}}</md-option></md-select></td><td><div flex layout="row"><md-button class="md-icon-button" ng-click="vm.addRow($index)" ng-if="$last" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.deleteRow($index)" ng-if="vm.lookUpData.length > 1" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></td></tr></tbody></table></md-table-container></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="resolverForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-settings.tmpl.html','<md-dialog flex="60" flex-gt-md="40" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex>{{vm.title}}</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="jobFlowSettingForm" layout="column" class="fp-smartflow-builder-setting-form"><div><md-input-container class="md-block"><label for="title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="title" ng-model="vm.setting[\'title\']" placeholder="{{\'atheer.smartFlow.builder.title\' | translate}}" required><div ng-messages="jobFlowSettingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-repeat="field in vm.settingFields"><div ng-if="field.type == \'URL\' || field.type == \'INTEGER\' || field.type == \'STRING\'"><md-input-container class="md-block"><label for="{{field.name}}">{{field.label}}</label> <input type="text" class="form-control" name="{{field.name}}" id="{{field.name}}" ng-model="vm.setting.properties[field.name]" placeholder="{{field.description}}" required="{{field.required}}"><div ng-messages="jobFlowSettingForm[field.name].$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="field.type == \'BOOLEAN\'" layout="row" layout-align="space-between center"><label for="{{field.name}}">{{field.label}}</label><md-switch ng-model="vm.setting.properties[field.name]"></md-switch></div><div ng-if="field.type == \'LIST\'"><md-input-container class="md-block"><label for="{{field.name}}">{{field.label}}</label><md-select name="{{field.name}}" ng-model="vm.setting.properties[field.name]" id="{{field.name}}" ng-required="{{field.required}}"><md-option ng-value="option.label" ng-repeat="option in field.list">{{option.label}}</md-option></md-select><div ng-messages="jobFlowSettingForm[field.name].$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div ng-if="field.type == \'OBJECT\' || field.type == \'OBJECT_LIST\'"><div>{{field.label}}</div><job-flow-object-builder type="field.type" setting="vm.setting.properties[field.name]"></job-flow-object-builder></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="jobFlowSettingForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-molecules-user-resolver.tmpl.html','<md-dialog flex="80" flex-gt-md="60" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.userResolver">User Resolver</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="resolverForm" layout="column" class="fp-smartflow-builder-setting-form"><div><md-input-container class="md-block"><label for="title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="title" ng-model="vm.setting[\'title\']" placeholder="{{\'atheer.smartFlow.builder.title\' | translate}}" required><div ng-messages="resolverForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div><div layout="row" layout-align="space-between center"><label translate="atheer.smartFlow.builder.resolverType">Resolver Type</label><md-radio-group class="md-primary" layout="row" ng-model="vm.setting.properties.resolverType" ng-change="vm.onResolverTypeChange()"><md-radio-button ng-repeat="resolverType in vm.resolverTypeList" ng-value="resolverType.value">{{ resolverType.name }}</md-radio-button></md-radio-group></div><br><md-input-container ng-if="vm.setting.properties.resolverType === \'STATIC\' && vm.isStaticObjectLoaded" class="md-block"><label for="staticResult" translate="atheer.smartFlow.builder.result">Result</label><md-select name="staticResult" ng-model="vm.setting.properties[\'staticResult\']" id="staticResult" required><md-option ng-value="option.id" ng-repeat="option in vm.staticObject">{{option.name}}</md-option></md-select></md-input-container><div ng-if="vm.setting.properties.resolverType === \'QUERY\' && vm.isDynamicObjectLoaded" layout="row" ng-repeat="object in vm.objects track by $index"><div flex="50" layout="column"><div layout="row"><div flex="80" layout="column"><md-input-container class="md-block"><label for="{{object.data_model_name}}" translate="atheer.smartFlow.builder.dataModel">Data Model</label> <input type="text" class="form-control" name="{{object.data_model_name}}" id="{{object.data_model_name}}" ng-model="object.data_model_value" placeholder="{{object.data_model_name}}" required></md-input-container></div><md-button flex="20" layout="column" class="md-icon-button fp-search-button" ng-click="vm.showProperties(object, $index)" aria-label="primary button"><md-icon class="fa fa-search-plus icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.searchProperties">search properties</span></fp-tooltip></md-button></div></div><div flex layout="column"><md-input-container class="md-block"><label for="{{object.search_key_name}}" translate="atheer.smartFlow.builder.searchKeys">Search Keys</label><md-select name="{{object.search_key_name}}" ng-model="vm.setting.properties.searchCriteria.searchKeys[object.data_model_value]" id="{{object.search_key_name}}" required><md-option ng-value="option.value" ng-repeat="option in vm.dynamicObject">{{option.label}}</md-option></md-select></md-input-container></div><div flex="15" layout="column"><div flex layout="row" class="pos-rlt"><md-button flex="50" layout="column" ng-if="$last" class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" ng-if="vm.objects.length > 1" layout="column" class="md-icon-button fp-remove-field-button" ng-click="vm.removeField($index, object)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></div></div><div ng-if="vm.setting.properties.resolverType === \'LOOKUP\'" class="md-block"><label for="resolveUsing" translate="atheer.smartFlow.builder.resolveUsing">Resolve Using</label><md-select multiple="multiple" name="resolveUsing" ng-model="vm.resolverList" id="resolveUsing" required ng-change="vm.onResolveTypeChnage(true)"><md-option ng-value="option.name" ng-repeat="option in vm.dataModelProperties">{{option.name}}</md-option></md-select><br><md-table-container ng-if="vm.resolverList.length > 0"><table md-table class="md-data-table"><thead md-head><tr md-row><th md-column ng-repeat="header in vm.resolverList"><span>{{header}}</span></th><th md-column><span>{{vm.setting.properties[\'objectType\']}}</span></th><th><span translate="atheer.smartFlow.builder.action">Action</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="lookUpRow in vm.lookUpData track by $index"><td class="first-cell" md-cell ng-repeat="data in vm.resolverList"><span><input type="text" class="form-control" name="{{lookUpRow[data]}}" ng-model="lookUpRow[data]" placeholder="{{lookUpRow[data]}}" required></span></td><td><md-select name="lookupResult" id="lookupResult" ng-model="lookUpRow[\'onSuccessResult\']"><md-option ng-value="option.id" ng-repeat="option in vm.staticObject">{{option.name}}</md-option></md-select></td><td width="60px"><div flex layout="row"><md-button class="md-icon-button" ng-click="vm.addRow($index)" ng-if="$last" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.deleteRow($index)" ng-if="vm.lookUpData.length > 1" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></td></tr></tbody></table></md-table-container></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="resolverForm.$invalid" class="md-primary md-raised"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/jobflow-object-builder.tmpl.html','<div><div flex layout="row" ng-repeat="object in vm.object track by $index"><div flex="40" layout="column"><md-input-container class="md-block"><label for="{{object.key_name}}">{{object.key_label}}</label> <input type="text" class="form-control" name="{{object.key_name}}" id="{{object.key_name}}" ng-model="object.key_value" placeholder="{{object.key_description}}" required ng-keydown="vm.onkeydown($event, object)" autocomplete="off"></md-input-container></div><div flex="40" layout="column" ng-if="vm.type == \'OBJECT\'"><md-input-container class="md-block"><label for="{{object.value_name}}">{{object.value_label}}</label> <input type="text" class="form-control" name="{{object.value_name}}" id="{{object.value_name}}" ng-model="vm.setting[object.key_value]" placeholder="{{object.value_description}}" required></md-input-container></div><div flex="40" layout="column" ng-if="vm.type == \'OBJECT_LIST\'"><md-chips class="object-list" ng-model="vm.setting[object.key_value]" md-enable-chip-edit="true" md-removable="true" placeholder="{{\'atheer.smartFlow.builder.enterValue\' | translate}}" delete-button-label="Remove Value" delete-hint="Press delete to remove value" secondary-placeholder="{{\'atheer.smartFlow.builder.addValue\' | translate}}"></md-chips></div><div flex="20" layout="column"><div flex layout="row" class="pos-rlt"><md-button flex="50" layout="column" ng-if="$last" class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-circle"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.addRow">Add Row</span></fp-tooltip></md-button><md-button flex="50" ng-if="vm.object.length > 1" layout="column" class="md-icon-button fp-remove-field-button" ng-click="vm.removeField($index, object)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-minus-circle-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.deleteRow">Delete Row</span></fp-tooltip></md-button></div></div></div></div>');
$templateCache.put('modules/smartflow/smartflow-add-users.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.detail.addUsers">Add Users</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.assignProgress == \'idle\'" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete auto-complete-model="vm.users" component="User" multiple="true"></fp-auto-complete></div><div ng-if="vm.assignProgress == \'started\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-subhead" translate="atheer.smartFlow.detail.assigning">Assigning. Please wait...</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div><div ng-if="vm.assignProgress == \'complete\'" flex layout="column"><div layout="row" layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon></div><div layout="row" layout-align="center" class="margin-top-20 margin-bottom-20"><span class="md-subhead" translate="atheer.smartFlow.detail.assignedSuccess" translate-values="{assignSuccess: \'{{vm.assignSuccess}}\'}">Successfully assigned to {{vm.assignSuccess}} Users...</span></div></div></md-dialog-content><md-dialog-actions ng-if="vm.assignProgress == \'idle\'" layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-insights-overview.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><md-tabs ng-if="!vm.loadingData" class="padding-left-10" md-center-tabs="true"><md-tab md-active="true"><md-tab-label><span translate="atheer.smartFlow.insights.overview">Overview</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'user\'})"><md-tab-label><span translate="atheer.smartFlow.insights.userSummary">User Summary</span></md-tab-label></md-tab></md-tabs><div ng-if="!vm.loadingData" flex><div class="overlay-5"><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'user\'})" style="cursor:pointer;"><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'STARTED\') + vm.getCount(\'IN_PROGRESS\') + vm.getCount(\'COMPLETED\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.smartFlow.insights.usersEntered">Users Entered</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'user\'})" style="cursor:pointer;"><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'IN_PROGRESS\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.smartFlow.insights.usersInProgress">Users In-Progress</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'user\'})" style="cursor:pointer;"><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'COMPLETED\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.smartFlow.insights.usersCompleted">Users Completed</p></tri-widget></div><div layout="row" layout-margin><md-card class="fp-insights-no-data-card" flex layout-padding ng-if="!vm.overviewSummary.history || vm.overviewSummary.history.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><div flex class="md-title"><span translate="atheer.smartFlow.insights.usersEntered">Users Entered</span></div></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/completions-overview.png"><div class="margin-top-10 main" translate="atheer.smartFlow.insights.notEnoughActivity">Not Enough Activity Yet!</div></div></div></md-card><md-card layout-padding flex ng-if="vm.overviewSummary.history.length > 0"><highchart id="user-entered-line-chart" option="vm.userEnteredChartData.chart" config="vm.userEnteredChartData" series="vm.userEnteredChartData.series"></highchart></md-card></div><div layout="row" layout-margin><md-card ng-if="vm.activitySummary.length == 0 && !vm.loadingData" layout-padding><div flex layout="column" layout-align="center center" class="margin-top-200 margin-bottom-200"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.smartFlow.insights.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.smartFlow.insights.noActivities">There are no activities to report yet</div></div></md-card><md-card flex class="md-padding" ng-if="vm.activitySummary.length > 0 && !vm.loadingData"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><div flex class="md-title"><span translate="atheer.smartFlow.insights.activitySummary">Activity Summary</span></div></div><md-table-container><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.smartFlow.insights.title">Title</span></th><th md-column><span translate="atheer.smartFlow.type">Type</span></th><th md-column><span translate="atheer.smartFlow.insights.started">Started</span></th><th md-column><span translate="atheer.smartFlow.insights.completed">Completed</span></th><th md-column><span translate="atheer.smartFlow.insights.avgDuration">Avg. Duration</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="activitySummary in vm.activitySummary track by activitySummary.id"><td md-cell>{{activitySummary.title}}</td><td md-cell>{{activitySummary.type_label}}</td><td md-cell>{{activitySummary.startedCount}}</td><td md-cell>{{activitySummary.completeCount}}</td><td md-cell>{{activitySummary.avgDuration}}</td></tr></tbody></table></md-table-container></md-card></div></div></div>');
$templateCache.put('modules/smartflow/smartflow-builder-insights-user-activity.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.insights.userActivitySummary">User Activity Summary</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><md-card ng-if="vm.activitySummary.length == 0 && !vm.loadingData" layout-padding><div flex layout="column" layout-align="center center" class="margin-top-200 margin-bottom-200"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.smartFlow.insights.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.smartFlow.insights.noActivities">There are no activities to report yet</div></div></md-card><div class="md-padding" ng-if="vm.activitySummary.length > 0 && !vm.loadingData"><md-table-container><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.smartFlow.insights.title">Title</span></th><th md-column><span translate="atheer.smartFlow.type">Type</span></th><th md-column><span translate="atheer.smartFlow.detail.startDate">Start Date</span></th><th md-column><span translate="atheer.smartFlow.detail.endDate">End Date</span></th><th md-column><span translate="atheer.smartFlow.insights.duration">Duration</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="activitySummary in vm.activitySummary track by activitySummary.id"><td md-cell>{{activitySummary.title}}</td><td md-cell>{{activitySummary.type_label}}</td><td md-cell>{{activitySummary.startDate | date:\'MM/dd/yyyy\'}}</td><td md-cell>{{activitySummary.endDate | date:\'MM/dd/yyyy\'}}</td><td md-cell>{{activitySummary.duration}}</td></tr></tbody></table></md-table-container></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-insights-user.tmpl.html','<div ng-if="!vm.dataLoaded" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><md-tabs ng-if="!vm.loadingData" class="padding-left-10" md-center-tabs="true"><md-tab ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'overview\'})"><md-tab-label><span translate="atheer.smartFlow.insights.overview">Overview</span></md-tab-label></md-tab><md-tab md-active="true"><md-tab-label><span translate="atheer.smartFlow.insights.userSummary">User Summary</span></md-tab-label></md-tab></md-tabs><md-card ng-if="vm.smartFlows.length == 0 && vm.dataLoaded" layout-padding><div flex layout="column" layout-align="center center" class="margin-top-200 margin-bottom-200"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.smartFlow.insights.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.smartFlow.insights.noUser">There are no User for given criteria</div></div></md-card><div class="md-padding" ng-if="vm.smartFlows.length > 0 && vm.dataLoaded"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th md-column md-order-by="first_name"><span translate="atheer.smartFlow.name">Name</span></th><th md-column md-order-by="status"><span translate="atheer.smartFlow.status">Status</span></th><th md-column md-order-by="started_on"><span translate="atheer.smartFlow.insights.startedOn">Started On</span></th><th md-column md-order-by="completed_on"><span translate="atheer.smartFlow.insights.completedOn">Completed On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="smartFlow in vm.smartFlows track by smartFlow.id"><td md-cell>{{smartFlow.user_info.first_name}} {{smartFlow.user_info.last_name}}</td><td md-cell>{{smartFlow.status}}</td><td md-cell>{{smartFlow.started_on | date:\'MM/dd/yyyy\'}}</td><td md-cell>{{smartFlow.completed_on | date:\'MM/dd/yyyy\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.launchUserActivitySummary(smartFlow)"><md-icon class="zmdi zmdi-eye icon-size"></md-icon></md-button></div></td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/smartflow/smartflow-builder-insights.tmpl.html','<ng-include src="\'modules/smartflow/smartflow-detail-toolbar.tmpl.html\'" ng-if="vm.dataLoaded == true"></ng-include><!-- <div flex layout="column" ng-if="vm.dataLoaded == true">\n    <md-tabs class="padding-left-10" md-center-tabs="true">\n        <md-tab ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'overview\'})">\n            <md-tab-label>\n                <span translate="atheer.smartFlow.insights.overview">Overview</span>\n            </md-tab-label>\n        </md-tab>\n        <md-tab ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'user\'})" md-active="vm.viewType == \'user\'">\n            <md-tab-label>\n                <span translate="atheer.smartFlow.insights.userSummary">User Summary</span>\n            </md-tab-label>\n        </md-tab>\n    </md-tabs>\n    <div flex ui-view>\n    </div>\n</div> --><div flex layout="column" ng-if="vm.dataLoaded == true"><div flex ui-view></div></div>');
$templateCache.put('modules/smartflow/smartflow-builder-preview.tmpl.html','<div class="fp-smartflow-builder-preview"><div class="paper-container md-whiteframe-z1"></div><div class="navigator-container"></div></div>');
$templateCache.put('modules/smartflow/smartflow-builder-read-only.tmpl.html','<div class="fp-smartflow-builder-read-only"><div class="paper-container md-whiteframe-z1"></div><div class="navigator-container"></div></div>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-announcement-assign.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.assignAnnouncement">Assign Announcement</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'},{fieldName:\'meta_type\', operator:\'==\', value:\'ANNOUNCEMENT\'}]" auto-complete-model="vm.setting.data" placeholder="Select Announcement" special-filter="vm.autoCompleteCallBack(result)" component="Content" multiple="true"></fp-auto-complete><div layout="row" layout-align="start center" class="margin-top-20"><span translate="atheer.smartFlow.builder.dismiss">Dismiss</span></div><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-radio-group layout="column" ng-model="vm.setting.isDueDateRelative" class="margin-top-20"><div flex layout="row"><div layout-align="start center" layout="row"><md-radio-button value="1" class="md-primary md-raised"><span translate="atheer.smartFlow.builder.in">In</span></md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.setting.isDueDateRelative==1"><md-input-container><label translate="atheer.smartFlow.builder.period">Period</label><md-select ng-model="vm.setting.relativeDate.period"><md-option value="days" translate="atheer.smartFlow.builder.days">Days</md-option><md-option value="weeks" translate="atheer.smartFlow.builder.weeks">Weeks</md-option></md-select></md-input-container><md-input-container><label translate="atheer.smartFlow.builder.value">Value</label> <input ng-model="vm.setting.relativeDate.value"></md-input-container></div></div><div flex layout="row" layout-align="start center"><div layout-align="start center" layout="row"><md-radio-button value="0" class="md-primary md-raised"><span translate="atheer.smartFlow.builder.fixedDate">Fixed Date</span></md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.setting.isDueDateRelative==0"><md-datepicker ng-model="vm.setting.absoluteDate" md-placeholder="{{\'atheer.smartFlow.selectDate\' | translate}}"></md-datepicker></div></div></md-radio-group></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-audience-assign.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.assignTeam">Assign Team</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Team" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-audience-check.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.checkTeam">Check Team</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Team" multiple="true"><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-audience-remove.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.removeTeam">Remove Team</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Team" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-audience-trigger.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.audienceTrigger">Team Trigger</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Team" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-badge-assign.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.assignBadge">Assign Badge</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Badge" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-badge-remove.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.removeBadge">Remove Badge</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Badge" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-content-assign.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.assignContent">Assign Content</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'}, {fieldName:\'meta_type\', operator:\'=in=\', value:\'(DISCOVERABLE,TASK_LIST,TASK,QUESTION)\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Content" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout="row" layout-align="space-between center"><span translate="atheer.smartFlow.builder.required">Is this required?</span><md-switch name="required" ng-model="vm.setting.required"></md-switch></div><div ng-if="vm.setting.required" layout="row" layout-align="start center"><span translate="atheer.smartFlow.builder.wouldYouLikeToComplete">When would you like to get this completed?</span></div><div ng-if="vm.setting.required"><md-radio-group layout="column" ng-model="vm.setting.isDueDateRelative" class="margin-top-20"><div flex layout="row"><div layout-align="start center" layout="row"><md-radio-button value="1" class="md-primary md-raised"><span translate="atheer.smartFlow.builder.completeIn">Complete In</span></md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.setting.isDueDateRelative==1"><md-input-container><label translate="atheer.smartFlow.builder.period">Period</label><md-select ng-model="vm.setting.relativeDate.period"><md-option value="days" translate="atheer.smartFlow.builder.days">Days</md-option><md-option value="weeks" translate="atheer.smartFlow.builder.weeks">Weeks</md-option></md-select></md-input-container><md-input-container><label translate="atheer.smartFlow.builder.value">Value</label> <input ng-model="vm.setting.relativeDate.value"></md-input-container></div></div><div flex layout="row" layout-align="start center"><div layout-align="start center" layout="row"><md-radio-button value="0" class="md-primary md-raised"><span translate="atheer.smartFlow.builder.fixedDate">Fixed Date</span></md-radio-button></div><div flex layout-align="end center" layout="row" ng-if="vm.setting.isDueDateRelative==0"><md-datepicker ng-model="vm.setting.absoluteDate" md-placeholder="{{\'atheer.smartFlow.selectDate\' | translate }}"></md-datepicker></div></div></md-radio-group></div><div class="margin-top-20"><span flex translate="atheer.smartFlow.builder.addNote">Add a note on why you are assigning this</span></div><md-input-container class="md-block"><textarea name="note" froala ng-model="vm.setting.note"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-content-check.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.assignmentCheck">Check Assignment Status</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'},{fieldName:\'meta_type\', operator:\'==\', value:\'DISCOVERABLE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Content" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container><label translate="atheer.smartFlow.builder.assignmentStatus">Assignment Status</label><md-select ng-model="vm.setting.status"><md-option value="ASSIGNED" translate="atheer.smartFlow.builder.assignmentStatusOptions.assigned">Assigned</md-option><md-option value="OVERDUE" translate="atheer.smartFlow.builder.assignmentStatusOptions.overdue">Overdue</md-option><md-option value="COMPLETED" translate="atheer.smartFlow.builder.assignmentStatusOptions.completed">Completed</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-content-recommend.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.recommendContent">Recommend Content</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'},{fieldName:\'meta_type\', operator:\'==\', value:\'DISCOVERABLE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Content" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div class="margin-top-20"><span flex translate="atheer.smartFlow.builder.recommendNote">Add a note on why you are recommending this</span></div><md-input-container class="md-block"><textarea name="note" froala ng-model="vm.setting.note"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-content-remove.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.removeContent">Remove Content</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'name\', operator:\'=re=\'},{fieldName:\'meta_type\', operator:\'==\', value:\'DISCOVERABLE\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" component="Content" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-email-send.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.sendEmail">Send E-Mail</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'}, {fieldName:\'meta_type\', operator:\'=in=\', value:\'(EMAIL_TEMPLATE)\'}]" special-filter="vm.autoCompleteCallBack(result)" placeholder="Select Email" auto-complete-model="vm.setting.data" component="Content" multiple="true"></fp-auto-complete></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-push-notification-send.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.pushNotification">Push Notification</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><md-input-container class="md-block"><label class="md-required" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span>This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.smartFlow.builder.message">Message</label> <textarea name="message" ng-model="vm.setting.message" id="field_message"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-question-check.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.checkQuestionResponse">Check Question Response</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><fp-auto-complete query-objs="[{fieldName:\'title\', operator:\'=re=\'},{fieldName:\'meta_type\', operator:\'==\', value:\'QUESTION\'}]" special-filter="vm.autoCompleteCallBack(result)" auto-complete-model="vm.setting.data" placeholder="{{\'atheer.smartFlow.builder.selectQuestion\' | translate}}" component="Content" multiple="true"></fp-auto-complete><md-input-container class="md-block"><label class="md-required" for="field_title" translate="atheer.smartFlow.builder.title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.setting.title" required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container ng-if="vm.setting.content != null"><label translate="atheer.smartFlow.builder.questionStatus">Question Status</label><md-select ng-model="vm.setting.status"><md-option value="ASSIGNED" translate="atheer.smartFlow.builder.questionStatusOptions.assigned">Assigned</md-option><md-option value="COMPLETED" translate="atheer.smartFlow.builder.questionStatusOptions.answered">Answered</md-option></md-select></md-input-container></div><div ng-if="!vm.loadingData" layout="row" layout-align="space-between center" ng-if="vm.setting.content.data.correct_answer != null && vm.setting.status == \'COMPLETED\'"><span translate="atheer.smartFlow.builder.answerCorrectly">Answer Correctly</span><md-switch name="required" ng-model="vm.setting.pass"></md-switch></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-slack-message-send.tmpl.html','<md-dialog flex="80" flex-gt-md="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.sendSlackMessage">Send Slack Message</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><md-input-container flex="100"><label translate="atheer.smartFlow.builder.title">Title</label> <input name="title" ng-model="vm.setting.title" md-select-on-focus required><div ng-messages="settingForm.title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-user-field-check.tmpl.html','<md-dialog flex="80" flex-gt-md="60" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.checkUserField">Check User Field</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><fp-criteria-builder fp-criteria-form-is-valid="vm.criteriaIsValid" fp-criteria="vm.setting.criteria"></fp-criteria-builder></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || !vm.criteriaIsValid || vm.previewMode" class="md-primary md-raised"><span translate="{{vm.criteriaIsValid ? \'atheer.smartFlow.builder.submitTrue\' : \'atheer.smartFlow.builder.submitFalse\'}}">Submit - {{vm.criteriaIsValid}}</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-user-field-trigger.tmpl.html','<md-dialog flex="80" flex-gt-md="60" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.userField">User Field Trigger</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form fp-criteria-builder"><div layout="row" layout-align="start center" ng-if="vm.dataIsLoaded" class="field-group-container"><md-input-container flex><label translate="atheer.smartFlow.builder.fieldGroup">Field Group</label><md-select ng-model="vm.tmp_field" placeholder="Select Field" md-on-close="fieldSearchText = \'\'" data-md-container-class="fp-filter-select-container" ng-init="vm.initFieldDropDownSearch()" ng-change="vm.conditionChange();" required><md-select-header class="fp-filter-select-header"><input ng-model="fieldSearchText" type="search" class="fp-filter-select-text-box md-text"></md-select-header><md-optgroup label="{{metaFieldGroup.label}}" ng-if="(metaFieldGroup.fields|filter:fieldSearchText).length > 0" ng-repeat="(metaFieldGroupIndex, metaFieldGroup) in vm.field_groups | filter: vm.filterFieldGroup"><md-option ng-value="{field_group_name : metaFieldGroup.name,field_name : metaField.name, data_type: metaField.data_type}" ng-repeat="metaField in metaFieldGroup.fields|filter:fieldSearchText" ng-selected="{{vm.setting.criteria.field_group_name == metaFieldGroup.name && vm.setting.criteria.field_name == metaField.name ? \'true\' : \'false\'}}">{{metaField.label}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex ng-if="vm.hasCondition(vm.setting.criteria.field_group_name, vm.setting.criteria.field_name)"><label translate="atheer.smartFlow.builder.operator">Operator</label><md-select ng-model="vm.setting.criteria.operator" placeholder="Select Condition" required><md-option ng-model-options="{ trackBy: \'$value.name\' }" ng-value="operator.value" ng-repeat="operator in vm.getFieldOperators(vm.setting.criteria.field_group_name, vm.setting.criteria.field_name)">{{operator.label}}</md-option></md-select></md-input-container><md-input-container flex><fp-criteria-builder-field fp-field-operator="vm.setting.criteria.operator" fp-field-model="vm.setting.criteria.value" fp-field-meta="((vm.field_groups|filter:{name :vm.setting.criteria.field_group_name})[0].fields|filter:{name:vm.setting.criteria.field_name})[0]" fp-time-zone-data="timezones" fp-language-data="languages"></fp-criteria-builder-field></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.setTitle(); vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder-setting-wait.tmpl.html','<md-dialog flex="35" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.smartFlow.builder.wait">Wait</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.builder.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.loadingData" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex ng-form="settingForm" layout="column" class="fp-smartflow-builder-setting-form"><div flex layout="row"><div layout-align="start center" layout="row"><span translate="atheer.smartFlow.builder.waitTime">Wait Time</span></div><div flex layout-align="end center" layout="row"><md-input-container><label translate="atheer.smartFlow.builder.period">Period</label><md-select ng-model="vm.setting.period"><md-option value="T" translate="atheer.smartFlow.builder.minutes">Minutes</md-option><md-option value="H" translate="atheer.smartFlow.builder.hours">Hours</md-option><md-option value="D" translate="atheer.smartFlow.builder.days">Days</md-option><md-option value="W" translate="atheer.smartFlow.builder.weeks">Weeks</md-option><md-option value="M" translate="atheer.smartFlow.builder.months">Months</md-option></md-select></md-input-container><md-input-container><label translate="atheer.smartFlow.builder.value">Value</label> <input ng-model="vm.setting.value"></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="settingForm.$invalid || vm.previewMode" class="md-primary md-raised"><span translate="entity.action.submit">Submit</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-builder.tmpl.html','<div flex layout="column"><div class="fp-smartflow-builder"><div class="stencil-container md-padding md-whiteframe-z1"></div><div class="paper-container md-whiteframe-z1"><div layout-align="center center" layout="row"><div layout="row"><md-button id="btn-undo" class="md-icon-button" aria-label="Undo" ng-click="vm.undo()"><fp-tooltip placement="top"><span translate="atheer.smartFlow.builder.undo">Undo</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-undo"></md-icon></md-button><md-button id="btn-redo" class="md-icon-button" aria-label="Redo" ng-click="vm.redo()"><fp-tooltip placement="top"><span translate="atheer.smartFlow.builder.redo">Redo</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-redo"></md-icon></md-button></div><md-button id="btn-center" class="md-icon-button" aria-label="Center" ng-click="vm.centerAndFit()"><fp-tooltip placement="top"><span translate="atheer.smartFlow.builder.center">Center</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-center-focus-weak"></md-icon></md-button></div></div><div class="navigator-container"></div><div class="statusbar-container"></div></div></div>');
$templateCache.put('modules/smartflow/smartflow-detail-history.tmpl.html','<md-sidenav class="md-sidenav-right fp-content-detail-sidenav" md-component-id="content-detail-history" md-whiteframe="4"><md-toolbar><div class="md-toolbar-tools"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'content-detail-history\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><h1>History</h1></div></md-toolbar><md-content><div layout="column" layout-margin layout-padding></div></md-content></md-sidenav>');
$templateCache.put('modules/smartflow/smartflow-detail-toolbar.tmpl.html','<div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><div><md-button ng-click="vm.goToSmartFlows()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button></div><span>{{vm.smartFlowModel.name}}</span><div flex><md-tabs ng-if="!vm.isNew()" md-selected="selectedTabIndex" md-center-tabs><md-tab ng-if="vm.viewType !== \'insights\'" ng-click="vm.showBuildView()" md-active="vm.viewType == \'build\'"><md-tab-label><span translate="atheer.smartFlow.detail.build">Build</span></md-tab-label></md-tab><md-tab ng-if="vm.viewType !== \'insights\'" md-on-select="vm.showSettingsView()" md-active="vm.viewType == \'settings\'"><md-tab-label><span translate="atheer.smartFlow.detail.settings">Settings</span></md-tab-label></md-tab><md-tab ng-if="vm.smartFlowModel.status != \'DRAFT\' && vm.viewType !== \'insights\' && !vm.isJobFlow" ui-sref="storm.admin-smartflow-insights.section({id: \'{{vm.smartFlowModel.id}}\', section:\'overview\'})" md-active="vm.viewType == \'insights\'"><md-tab-label><span translate="atheer.smartFlow.detail.insights">Insights</span></md-tab-label></md-tab><md-tab ng-if="vm.smartFlowModel.status != \'DRAFT\' && vm.viewType !== \'insights\' && vm.isJobFlow" ng-click="vm.showJobInsightsView()" md-active="vm.viewType == \'insights\'"><md-tab-label><span translate="atheer.smartFlow.detail.insights">Insights</span></md-tab-label></md-tab><md-tab ng-if="vm.viewType == \'insights\'" ui-sref="storm.admin-smartflow-detail({id: \'{{vm.smartFlowModel.id}}\' , viewType: \'build\'})"><md-tab-label><span translate="atheer.smartFlow.detail.build">Build</span></md-tab-label></md-tab><md-tab ng-if="vm.viewType == \'insights\'" ui-sref="storm.admin-smartflow-detail({id: \'{{vm.smartFlowModel.id}}\', viewType: \'settings\'})"><md-tab-label><span translate="atheer.smartFlow.detail.settings">Settings</span></md-tab-label></md-tab><md-tab md-active="vm.viewType == \'insights\'" ng-if="vm.viewType == \'insights\'" md-active="true"><md-tab-label><span translate="atheer.smartFlow.detail.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div *ngif="!vm.isJobFlow && vm.viewType != \'insights\'"><md-button class="md-primary md-raised" ng-if="!vm.isEnded()" ng-disabled="smartFlowDetailForm.$invalid || !vm.smartFlowModel.name" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><md-button class="md-primary md-raised" ng-if="!vm.isNew() && vm.isDraft()" ng-disabled="smartFlowDetailForm.$invalid || !vm.smartFlowModel.name" ng-click="vm.publish()"><span translate="atheer.smartFlow.detail.publish">Publish</span></md-button><md-button class="md-primary md-raised" ng-if="vm.isLive() && !vm.isJobFlow" ng-disabled="smartFlowDetailForm.$invalid" ng-click="vm.pause()"><span translate="atheer.smartFlow.detail.pause">Pause</span></md-button><md-button class="md-primary md-raised" ng-if="vm.isPaused() && !vm.isJobFlow" ng-disabled="smartFlowDetailForm.$invalid" ng-click="vm.resume()"><span translate="atheer.smartFlow.detail.resume">Resume</span></md-button><md-menu ng-if="!vm.isNew()"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button ng-click="vm.copySmartFlow()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><span translate="entity.action.copy">Copy</span></md-button></md-menu-item><md-menu-item ng-if="vm.isLive()"><md-button aria-label="primary button" ng-click="vm.addUsers()"><md-icon md-font-icon="zmdi zmdi-accounts-list"></md-icon><span translate="atheer.smartFlow.detail.addUsers">Add Users</span></md-button></md-menu-item><md-menu-item ng-if="vm.isPaused() || vm.isLive()"><md-button aria-label="primary button" ng-click="vm.end()"><md-icon md-font-icon="fa fa-power-off"></md-icon><span translate="atheer.smartFlow.detail.end">End</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.togglePanel(\'admin-detail-help\')"><md-icon md-font-icon="zmdi zmdi-help-outline"></md-icon><span translate="entity.action.help">Help</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div>');
$templateCache.put('modules/smartflow/smartflow-detail.tmpl.html','<ng-include src="\'modules/smartflow/smartflow-detail-toolbar.tmpl.html\'" ng-if="vm.dataLoaded == true"></ng-include><div ng-if="vm.viewType == \'build\' && vm.dataLoaded == true && vm.isReadOnly"><smart-flow-builder-read-only type="vm.smartFlowModel.type" canvas-data="vm.smartFlowModel.canvas_data" is-job-flow="vm.smartFlowModel.newSmartFlow"></smart-flow-builder-read-only></div><div ng-if="vm.viewType == \'build\' && vm.dataLoaded == true && !vm.isReadOnly"><smart-flow-builder type="vm.smartFlowModel.type" canvas-data="vm.smartFlowModel.canvas_data" trigger-data="vm.smartFlowModel.trigger_info" is-job-flow="vm.smartFlowModel.newSmartFlow"></smart-flow-builder></div><div ng-if="vm.viewType == \'settings\' && vm.dataLoaded == true"><ng-include src="\'modules/smartflow/smartflow-settings.tmpl.html\'"></ng-include></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/smartflow/smartflow-menu.tmpl.html','<div flex layout="column" layout-fill><div flex layout="column" layout-padding><md-input-container class="md-block margin-top-20"><label translate="atheer.smartFlow.status">Status</label><md-select ng-model="vm.filters.status" ng-change="vm.updateFilters()"><md-option value="ALL" translate="atheer.smartFlow.statusOptions.all">All</md-option><md-option value="DRAFT" translate="atheer.smartFlow.statusOptions.draft">Draft</md-option><md-option value="LIVE" translate="atheer.smartFlow.statusOptions.live">Live</md-option><md-option value="ENDED" translate="atheer.smartFlow.statusOptions.ended">Ended</md-option><md-option value="PAUSED" translate="atheer.smartFlow.statusOptions.paused">Paused</md-option></md-select></md-input-container><md-input-container class="md-block margin-top-20"><label translate="atheer.smartFlow.type">Type</label><md-select ng-model="vm.filters.type" ng-change="vm.updateFilters()"><md-option value="ALL" translate="atheer.smartFlow.typeOptions.all">All</md-option><md-option value="ONE_TIME" translate="atheer.smartFlow.typeOptions.oneTime">One Time</md-option><md-option value="ON_GOING" translate="atheer.smartFlow.typeOptions.onGoing">On-Going</md-option><md-option value="TIME_BASED" translate="atheer.smartFlow.typeOptions.recurring">Recurring</md-option></md-select></md-input-container></div></div>');
$templateCache.put('modules/smartflow/smartflow-options-dialog.tmpl.html','<md-dialog flex="40" flex-xl="25"><md-dialog-content class="md-dialog-content fp-smartflow-options" layout="row" layout-fill layout-padding><div flex="50" class="md-button" layout="column" layout-align="center center" layout-padding ng-click="vm.launchSmartFlowTemplateSelector()"><div flex></div><div flex layout-align="end center"><md-icon md-font-icon="zmdi zmdi-copy" class="options-icon"></md-icon></div><div layout-align="center"><md-button class="md-primary md-raised">Start With Template</md-button></div></div><div flex="50" layout="column" class="md-button" layout-align="center center" layout-padding ng-click="vm.launchSmartFlowBuilder()"><div flex></div><div flex layout-align="end center"><md-icon md-font-icon="zmdi zmdi-plus" class="options-icon"></md-icon></div><div layout-align="center"><md-button class="md-primary md-raised">Create From Scratch</md-button></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-settings.tmpl.html','<div layout="row" layout-fill flex layout-align="center start"><div flex="50"><md-card flex layout="column"><md-card-content class="margin-bottom-20"><div flex ng-form="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><div><input type="hidden" id="id" name="id" ng-model="vm.smartFlowModel.id" readonly="readonly"></div><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.smartFlow.smartFlowNo" for="field_smartFlowNo">SmartFlow No</label> <input type="number" class="form-control" name="smartFlowNo" id="field_smartFlowNo" ng-model="vm.smartFlowModel.workflow_no" required ng-disabled="true"><div ng-messages="editForm.smartFlowNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.smartFlow.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.smartFlowModel.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.smartFlow.description" for="field_description">Description</label> <textarea name="description" ng-model="vm.smartFlowModel.description" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><md-radio-group class="md-block margin-bottom-20" ng-model="vm.smartFlowModel.type" layout="row" layout-align="space-around center" ng-change="vm.changeType()" ng-disabled="vm.disableType()"><md-radio-button value="ON_GOING"><span translate="atheer.smartFlow.typeOptions.going">Ongoing</span></md-radio-button><md-radio-button value="TIME_BASED"><span translate="atheer.smartFlow.typeOptions.recurring">Recurring</span></md-radio-button><md-radio-button value="ONE_TIME"><span translate="atheer.smartFlow.typeOptions.oneTime">One Time</span></md-radio-button><md-radio-button value="JOB_EVENT"><span translate="atheer.smartFlow.typeOptions.jobEvent">Job Event</span></md-radio-button><fp-help key="fdsfsdf"></fp-help></md-radio-group><!-- <div ng-if="vm.smartFlowModel.type == \'TIME_BASED\'" layout="row" layout-align="space-between center">\n\t\t\t\t\t\t\t<span translate="atheer.smartFlow.detail.allowReEntry">Allow entry of users with previous smart flow\n\t\t\t\t\t\t\t\tcompletion</span>\n\t\t\t\t\t\t\t<md-switch name="allow_reentry" ng-model="vm.smartFlowModel.allow_reentry"\n\t\t\t\t\t\t\t\tng-disabled="vm.disableReEntry()">\n\t\t\t\t\t\t\t</md-switch>\n\t\t\t\t\t\t</div> --><div layout="row" layout-align="space-between center" ng-if="vm.smartFlowModel.type === \'ONE_TIME\'"><span translate="atheer.smartFlow.detail.startDate">Start Date</span><md-datepicker ng-model="vm.smartFlowModel.start_date" md-placeholder="{{\'atheer.smartFlow.selectDate\' | translate}}" ng-disabled="vm.disableStartDate()" md-min-date="vm.minDate"></md-datepicker></div><div layout="row" layout-align="space-between center" ng-if="vm.smartFlowModel.type !== \'JOB_EVENT\' && vm.smartFlowModel.type !== \'ONE_TIME\'"><span translate="atheer.smartFlow.detail.startDate">Start Date</span><md-datepicker ng-model="vm.smartFlowModel.start_date" md-placeholder="{{\'atheer.smartFlow.selectDate\' | translate}}" ng-disabled="vm.disableStartDate()"></md-datepicker></div><div ng-if="vm.smartFlowModel.type != \'ONE_TIME\' && vm.smartFlowModel.type !== \'JOB_EVENT\'" layout="row" layout-align="space-between center"><span translate="atheer.smartFlow.detail.endDate">End Date</span><md-datepicker ng-model="vm.smartFlowModel.end_date" md-placeholder="{{\'atheer.smartFlow.selectDate\' | translate}}" ng-disabled="vm.disableEndDate()"></md-datepicker></div><div ng-if="vm.smartFlowModel.type == \'TIME_BASED\'"><cron-selection ng-model="vm.smartFlowModel.schedule_info" config="vm.scheduleConfig"></cron-selection></div></div></div></md-card-content></md-card></div></div>');
$templateCache.put('modules/smartflow/smartflow-template-options-dialog.tmpl.html','<md-dialog flex="40" flex-xl="25"><md-dialog-content class="md-dialog-content fp-smartflow-options" layout="row" layout-fill layout-padding><div flex layout="row" layout-align="space-between center"><div flex translate="atheer.smartFlow.template.useTemplateWithSettings">Use Template with settings</div><md-switch flex name="show_media" ng-model="vm.useSetting" aria-label="Image"></md-switch><md-button class="md-primary md-raised" ng-click="vm.useThisSmartFlow()"><span translate="entity.action.ok">OK</span></md-button></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/smartflow/smartflow-template.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent"><md-button ui-sref="storm.admin-smartflows" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span translate="atheer.smartFlow.template.title">SmartFlow Template Gallery</span> <span flex></span><md-button class="md-raised" ng-disabled="!vm.smartFlowTemplate" ng-click="vm.openTemplateOptionDialog()" aria-label="flat button" translate="atheer.smartFlow.template.useThisTemplate">Use This Template</md-button><md-button ui-sref="storm.admin-smartflows" class="md-raised" aria-label="flat button" translate="entity.action.cancel">Cancel</md-button></div></md-toolbar><div flex layout="row"><div layout="column" class="fp-smartflow-template-list"><div flex layout="column" class="md-whiteframe-z1"><md-content flex layout-padding><div layout="row" layout-wrap><div flex="50" ng-repeat="smartFlowTemplate in vm.smartFlowTemplates" layout-align="center center"><md-card flex layout-align="center center" class="fp-smartflow-template-card card" ng-class="{active : vm.smartFlowTemplate.id == smartFlowTemplate.id}" ng-click="vm.previewSmartFlowTemplate(smartFlowTemplate)"><h4>{{smartFlowTemplate.name}}</h4></md-card></div></div></md-content></div><!--\n        <div layout="row" layout-align="space-around center" class="md-whiteframe-z1">\n            <md-button class="md-raised" ng-click="vm.goToSmartFlowDetail()" aria-label="flat button" translate="atheer.smartFlow.template.startFromScratch">Start from Scratch</md-button>\n            <md-button class="md-primary md-raised" ng-disabled="!vm.smartFlowTemplate" ng-click="vm.useThisSmartFlow()" aria-label="flat button" translate="atheer.smartFlow.template.useThisTemplate">Use This Template</md-button>\n        </div>\n        --></div><div flex layout="column"><div ng-if="vm.smartFlowTemplate"><smart-flow-builder-preview canvas-data="vm.smartFlowTemplate.canvas_data"></smart-flow-builder-preview></div><div ng-if="!vm.smartFlowTemplate" flex layout-align="center center" layout="row"><div flex="50" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.smartFlow.template.previewTemplate">Click on a Thumbnail to preview a Template</span></div></div></div></div></div>');
$templateCache.put('modules/smartflow/smartflow-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 translate="atheer.smartFlow.home.title">SmartFlows</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.smartFlow.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-accent md-raised" permission permission-only="vm.permissions.create" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><md-button class="md-icon-button" ui-sref="storm.admin-datamodel" aria-label="primary button"><img src="/assets/images/flowbot/data-model.svg"><fp-tooltip placement="bottom"><span translate="atheer.smartFlow.dataModel">Data Model</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/smartflow/smartflows.html','<div flex layout="column"><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.smartFlows.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content flex class="md-padding" ng-if="!vm.loadingData && vm.smartFlows.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column md-order-by="smartFlowNo"><span translate="atheer.smartFlow.smartFlowNo">SmartFlow No</span></th><th md-column md-order-by="name"><span translate="atheer.smartFlow.name">Name</span></th><th md-column md-order-by="status"><span translate="atheer.smartFlow.status">Status</span></th><th md-column md-order-by="type"><span translate="atheer.smartFlow.type">Type</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="smartFlow in vm.smartFlows track by smartFlow.id"><td md-cell>{{smartFlow.workflow_no}}</td><td md-cell>{{smartFlow.name}}</td><td md-cell translate="{{\'atheer.smartFlowStatus.\' + (smartFlow.status | lowercase)}}">{{smartFlow.status}}</td><td md-cell translate="{{\'atheer.smartFlowType.\' + smartFlow.type}}">{{smartFlow.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(smartFlow.id, smartFlow.newSmartFlow)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu permission permission-only="vm.permissions.delete"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.create"><md-button aria-label="primary button" ng-click="vm.copyObject(smartFlow.id, smartFlow.newSmartFlow)"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><span translate="entity.action.copy">Copy</span></md-button></md-menu-item><md-menu-item ng-if="smartFlow.status == \'DRAFT\'"><md-button aria-label="primary button" ng-click="vm.deleteObject(smartFlow)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item><md-menu-item ng-if="smartFlow.status !== \'DRAFT\' && smartFlow.newSmartFlow && smartFlow.type !== \'JOB_EVENT\'"><md-button aria-label="primary button" ng-click="vm.executeNow(smartFlow)"><md-icon class="zmdi zmdi-run icon-size"></md-icon><span translate="atheer.smartFlow.executeNow">Execute Now</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.smartFlows.length > 0"></md-table-pagination></div>');
$templateCache.put('modules/system/setting-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/system/settings.tmpl.html','<div flex ui-view></div>');
$templateCache.put('modules/system/system-menu.tmpl.html','<div class="toolbar-default md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="atheer.system.title">System</h2><span flex></span></div></div><div flex layout="column" class="fp-page-sidemenu" flex-xs="100" class="md-whiteframe-z1"><div ng-repeat="setting in vm.settings"><md-button ui-sref="{{setting.state}}" ng-click="vm.activeLink = setting.state" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == setting.state}"><md-icon md-font-icon="{{setting.icon}}"></md-icon><span class="md-body-1" translate>{{setting.label}}</span></md-button><md-divider></md-divider></div></div>');
$templateCache.put('modules/system/system.tmpl.html','<div flex ui-view></div>');
$templateCache.put('modules/team/team-assign-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span ng-if="!vm.fromProfilePage" flex translate="assignTeam.addMembers">Add Members</span> <span ng-if="vm.fromProfilePage" flex translate="assignTeam.addTeams">Add Teams</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="assignTeam.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><form name="assignForm"><div ng-if="!vm.fromProfilePage" class="fp-user-chips"><fp-auto-complete no-label="true" auto-complete-model="vm.asyncUsers" component="User" multiple="true" query-objs="[{fieldName:\'text_search\', operator:\'=ts=\'}]"></fp-auto-complete></div><div ng-if="vm.fromProfilePage" class="fp-user-chips"><fp-auto-complete no-label="true" auto-complete-model="vm.asyncTeams" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}, {fieldName:\'type\', operator:\'==\', value:\'STATIC\'}, {fieldName:\'audienceNo\', operator:\'!=\', value:\'1001\'}]"></fp-auto-complete></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="assignForm.$invalid" class="md-primary"><span translate="entity.action.assign">Assign</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/team/team-builder.tmpl.html','<div ng-if="loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-show="!loadingData" flex layout="column" class="fp-filter-builder padding-top-20"><span class="md-body-1 padding-left-20" translate="atheer.team.home.title">Teams</span><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-input-container flex md-no-float><md-select md-container-class="fp-user-teams-dropdown" ng-model="selectedTeam" ng-change="refreshTeam()"><md-option ng-value="team" ng-repeat="team in teams | filter: teamFilter"><md-icon ng-if="team.picture_id == null" md-font-icon="{{team.type == \'SMART\' ? \'zmdi zmdi-chart-donut\' : \'zmdi zmdi-accounts-list\'}}"></md-icon><img ng-if="team.picture_id != null" class="team-list-avatar" ng-src="{{getUserProfilePicture(team.picture_id)}}"> <span class="view-name margin-left-10">{{team.name}}</span></md-option></md-select></md-input-container></div><div ng-if="teamDetail.type == \'STATIC\' && !isDefaultTeam(teamDetail)"><div layout="column" class="condition-groups"><div flex layout="row" class="condition-group-box"><div layout="row" class="padding-10"><span class="md-body-1"><span translate="atheer.teamBuilder.fixedTeamCreatedBy" translate-values="{createdBy: \'{{teamDetail.created_by}}\'}">Fixed Team created by {{teamDetail.created_by}}</span> <span am-time-ago="teamDetail.created_on"></span></span></div></div><div class="condition-separator"></div><div flex layout="row" class="condition-group-box"><div layout="row" class="padding-10" ng-init="conditionFocus = false"><span class="md-body-1"><span translate="atheer.teamBuilder.lastUpdated">Last updated </span><span am-time-ago="teamDetail.last_modified_on"></span></span></div></div></div></div><div ng-if="teamDetail.type != \'STATIC\' || isDefaultTeam(teamDetail)"><div layout="column" class="margin-left-10 margin-right-10 margin-top-10" permission permission-only="permissions.manageTeam" ng-if="showSave(teamDetail)" ng-click="saveDynamicTeam(teamDetail)"><md-button flex class="md-raised md-primary"><md-icon md-font-icon="zmdi zmdi-chart-donut"></md-icon><span translate="atheer.teamBuilder.saveDynamicTeam">Save Dynamic Team</span></md-button></div><div layout="column" class="margin-left-10 margin-right-10" ng-if="showReset(teamDetail)" ng-click="resetFilter()"><div layout="row" flex="50"><md-button class="md-primary"><span translate="atheer.teamBuilder.resetFilter">Reset Filter</span></md-button></div></div><div layout="column" class="condition-groups"><div id="match-type" flex layout="row" class="match-type" ng-click="showMatchType()" ng-style="matchSelected ? {\'background-color\': primaryColor} : {\'background-color\': \'white\'}"><div layout="row" class="padding-10"><md-icon md-font-icon="zmdi zmdi-accounts"></md-icon><span class="md-body-1">{{teamDetail.criteria.match_all ? \'atheer.teamBuilder.thatMatchAllFilters\': \'atheer.teamBuilder.thatMatchAnyFilters\' | translate }}</span></div></div><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div class="connection"></div><div ng-if="teamDetail.criteria.condition_groups.length > 0" class="connection"></div></div></div><div dragula=\'"condition-groups"\' dragula-model="teamDetail.criteria.condition_groups"><div flex ng-repeat="(groupIndex, conditionGroup) in teamDetail.criteria.condition_groups" layout="column"><div ng-if="groupIndex > 0" layour="row" class="and-condition"><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div class="connection"></div><div class="operator-type">{{teamDetail.criteria.match_all ? \'atheer.teamBuilder.and\' : \'atheer.teamBuilder.or\' | translate }}</div><div class="connection"></div></div></div></div><div layout="row" class="condition-group-box"><div flex="10" class="left-action" layout="row" layout-align="center center"><md-button class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button></div><div flex layou="row"><div flex layout="column" class="condition-group" flex id="{{condition.field_group_name + \'-\' + condition.field_name}}" ng-repeat="(conditionIndex, condition) in conditionGroup.conditions"><div flex layout="row" ng-if="conditionIndex > 0" class="margin-top-10"><div flex class="horizontal-connection"></div><span class="md-caption" translate="atheeer.audieneBuilder.or">OR</span><div flex class="horizontal-connection"></div></div><div layout="column" flex ng-click="showFieldSettting(condition)" class="padding-10 condition" ng-init="conditionFocus = false" ng-mouseover="conditionFocus = true" ng-mouseleave="conditionFocus = false" ng-style="{\'background-color\': getConditionBackgroundColor(condition, conditionFocus)}"><div flex layout="row"><span flex="90" class="md-body-1" flex>{{getFieldLabel(condition)}}</span><md-icon flex="10" ng-if="conditionFocus || selectedCondition == condition" md-font-icon="zmdi zmdi-delete" ng-click="removeField(groupIndex, conditionIndex);$event.stopPropagation();"></md-icon></div></div></div></div></div></div></div><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div ng-if="teamDetail.criteria.condition_groups.length > 0" class="connection"></div><div class="connection"></div></div></div><div layout="row" id="add-filter" flex class="add-filter" ng-click="showFields()"><div layout="row" class="padding-10 condition"><md-icon md-font-icon="zmdi zmdi-filter-list"></md-icon><span class="md-body-1" translate="atheer.teamBuilder.addFilter">Add Filter</span></div></div></div></div></div>');
$templateCache.put('modules/team/team-detail-builder-horizontal.tmpl.html','<div ng-if="loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div flex ng-if="!vm.loadingData" layout="column" class="fp-filter-builder"><div ng-if="vm.teamModel.type == \'SMART\'"><div layout="column" class="margin-left-10 margin-right-10" ng-if="vm.showReset()" ng-click="vm.resetFilter()"><div layout="row" flex="50"><md-button class="md-primary"><span translate="atheer.teamBuilder.resetFilter">Reset Filter</span></md-button></div></div><div layout="row" class="condition-groups" layout-wrap=""><div flex="30" class="margin-bottom-10" layout="row" ng-repeat="(groupIndex, conditionGroup) in vm.teamModel.criteria.condition_groups"><div ng-if="groupIndex > 0" layout="row" layout-align="center center" class="margin-left-10 margin-right-10"><div>{{vm.teamModel.criteria.match_all ? \'atheer.teamBuilder.and\' : \'atheer.teamBuilder.or\' | translate }}</div></div><div flex layout="row" class="condition-group-box"><div flex layou="row"><div flex layout="column" class="condition-group" flex id="{{condition.field_group_name + \'-\' + condition.field_name}}" ng-repeat="(conditionIndex, condition) in conditionGroup.conditions"><div flex layout="row" ng-if="conditionIndex > 0" class="margin-top-10"><div flex class="horizontal-connection"></div><span class="md-caption" translate="atheeer.audieneBuilder.or">OR</span><div flex class="horizontal-connection"></div></div><div layout="column" flex ng-click="vm.showFieldSettting(condition)" class="padding-10 condition" ng-init="vm.conditionFocus = false" ng-mouseover="vm.conditionFocus = true" ng-mouseleave="vm.conditionFocus = false" ng-style="{\'background-color\': vm.getConditionBackgroundColor(condition, conditionFocus)}"><div flex layout="row"><span flex="90" class="md-body-1" flex>{{vm.getFieldLabel(condition)}}</span><md-icon flex="10" ng-if="vm.conditionFocus || vm.selectedCondition == condition" md-font-icon="zmdi zmdi-delete" ng-click="vm.removeField(groupIndex, conditionIndex);$event.stopPropagation();"></md-icon></div></div></div></div></div></div></div><div flex="15" layout="row" id="add-filter" class="margin-left-10"><md-button class="md-primary" ng-click="vm.showFields()"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><span translate="atheer.teamBuilder.addFilter">Add Filter</span></md-button></div></div></div>');
$templateCache.put('modules/team/team-detail-builder.tmpl.html','<div ng-if="loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div flex ng-if="!vm.loadingData" layout="column" class="fp-filter-builder"><div ng-if="vm.teamModel.type == \'SMART\'"><div layout="column" class="margin-left-10 margin-right-10" ng-if="vm.showReset" ng-click="vm.resetFilter()"><div layout="row" flex="50"><md-button class="md-primary"><span translate="atheer.teamBuilder.resetFilter">Reset Filter</span></md-button></div></div><div layout="column" class="condition-groups"><div id="match-type" flex layout="row" class="match-type" ng-click="vm.showMatchType()" ng-style="vm.matchSelected ? {\'background-color\': primaryColor} : {\'background-color\': \'white\'}"><div layout="row" class="padding-10"><md-icon md-font-icon="zmdi zmdi-accounts"></md-icon><span class="md-body-1">{{vm.teamModel.criteria.match_all ? \'atheer.teamBuilder.thatMatchAllFilters\': \'atheer.teamBuilder.thatMatchAnyFilters\' | translate }}</span></div></div><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div class="connection"></div><div ng-if="vm.teamModel.criteria.condition_groups.length > 0" class="connection"></div></div></div><div dragula=\'"condition-groups"\' dragula-model="vm.teamModel.criteria.condition_groups"><div flex ng-repeat="(groupIndex, conditionGroup) in vm.teamModel.criteria.condition_groups" layout="column"><div ng-if="groupIndex > 0" layour="row" class="and-condition"><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div class="connection"></div><div class="operator-type">{{vm.teamModel.criteria.match_all ? \'atheer.teamBuilder.and\' : \'atheer.teamBuilder.or\' | translate }}</div><div class="connection"></div></div></div></div><div layout="row" class="condition-group-box"><div flex="10" class="left-action" layout="row" layout-align="center center"><md-button class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button></div><div flex layou="row"><div flex layout="column" class="condition-group" flex id="{{condition.field_group_name + \'-\' + condition.field_name}}" ng-repeat="(conditionIndex, condition) in conditionGroup.conditions"><div flex layout="row" ng-if="conditionIndex > 0" class="margin-top-10"><div flex class="horizontal-connection"></div><span class="md-caption" translate="atheeer.audieneBuilder.or">OR</span><div flex class="horizontal-connection"></div></div><div layout="column" flex ng-click="vm.showFieldSettting(condition)" class="padding-10 condition" ng-init="vm.conditionFocus = false" ng-mouseover="vm.conditionFocus = true" ng-mouseleave="vm.conditionFocus = false" ng-style="{\'background-color\': vm.getConditionBackgroundColor(condition, conditionFocus)}"><div flex layout="row"><span flex="90" class="md-body-1" flex>{{vm.getFieldLabel(condition)}}</span><md-icon flex="10" ng-if="vm.conditionFocus || vm.selectedCondition == condition" md-font-icon="zmdi zmdi-delete" ng-click="vm.removeField(groupIndex, conditionIndex);$event.stopPropagation();"></md-icon></div></div></div></div></div></div></div><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div ng-if="vm.teamModel.criteria.condition_groups.length > 0" class="connection"></div><div class="connection"></div></div></div><div layout="row" id="add-filter" flex class="add-filter" ng-click="vm.showFields()"><div layout="row" class="padding-10 condition"><md-icon md-font-icon="zmdi zmdi-filter-list"></md-icon><span class="md-body-1" translate="atheer.teamBuilder.addFilter">Add Filter</span></div></div></div></div></div>');
$templateCache.put('modules/team/team-detail-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span ng-if="vm.mode == \'UPDATE\'" flex translate="atheer.team.updateTeam">Update Team</span> <span ng-if="vm.mode == \'DYNAMIC\'" flex translate="atheer.team.saveDynamicTeam">Save Dynamic Team</span> <span ng-if="vm.mode == \'STATIC\'" flex translate="atheer.team.saveFixedTeam">Save Fixed Team</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.mode == \'UPDATE\'" flex layout="column" class="padded-content-page content-properties-container" ng-form="teamDetailForm"><div flex layout="row"><div flex="20" class="fp-group-image-container" ng-mouseenter="image.showEditProfileImage = true;" ng-mouseleave="image.showEditProfileImage = false;"><img ng-src="{{vm.getTeamProfileImageUrl()}}" alt="girl-avatar" class="make-round team-avatar"><md-icon md-font-icon ng-if="vm.statusCheck===\'uploading\'" class="fa fa-spinner fa-pulse" style="position: absolute; top: 40px; right: 40px"></md-icon><div class="fp-group-image-edit-overlay" layout-align="center center" layout="row" ng-style="image.showEditProfileImage ? { \'top\':\'0\' } : {\'top\' : \'100%\'}"><fp-upload fp-upload-size-error="vm.fileSizeErrorMsg" fp-upload-status="vm.statusCheck" fp-accepted-type="\'image/*\'" fp-content-type="picture" fp-ng-model="vm.converationModel.picture_id" fp-multiple="true" fp-upload-icon-class="zmdi zmdi-edit icon-size" fp-add-model-fn="vm.updateTeamProfileImage(mediaId, responseObj)" fp-pattern="image/*" fp-upload-type="basic" fp-enable-preview="false" fp-all-button-color-class=""></fp-upload><md-button ng-if="vm.teamModel.picture_id && vm.teamModel.picture_id != null" ng-click="vm.removeTeamProfileImage()" class="md-icon-button" aria-label="primary button"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></div></div><md-input-container flex class="md-block"><label class="md-required" translate="atheer.team.name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.teamModel.name" required ng-disabled="vm.teamModel.locked"><div ng-messages="teamDetailForm.name.$error"><div ng-message when="required"><span translate="atheer.team.nameRequired">This field is required.</span></div></div></md-input-container></div><p ng-if="vm.fileSizeErrorMsg" class="error-msg" translate="atheer.team.maxFileSize">Maximum file size supported is 1MB.</p><md-input-container class="md-block"><label translate="atheer.team.description">Description</label> <textarea name="description" ng-model="vm.teamModel.description" id="field_description" ng-disabled="vm.teamModel.locked" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><div layout="row" layout-align="space-between center"><span translate="atheer.team.activate">Activate</span><md-switch name="activate" ng-model="vm.teamModel.status" ng-true-value="\'ACTIVE\'" ng-false-value="\'DRAFT\'"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.enableConversation">Enable Conversation</span><md-switch name="activate" ng-model="vm.teamModel.use_conversation"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.functionalTeam">Functional Team</span><md-switch name="activate" ng-model="vm.teamModel.functional_team"></md-switch></div></div><div ng-if="vm.mode == \'DYNAMIC\'" flex layout="column" class="padded-content-page content-properties-container" ng-form="teamDetailForm"><div flex layout="row"><div flex="20" class="fp-group-image-container" ng-mouseenter="image.showEditProfileImage = true;" ng-mouseleave="image.showEditProfileImage = false;"><img ng-src="{{vm.getTeamProfileImageUrl()}}" alt="girl-avatar" class="make-round team-avatar"><md-icon md-font-icon ng-if="vm.statusCheck===\'uploading\'" class="fa fa-spinner fa-pulse" style="position: absolute; top: 40px; right: 40px"></md-icon><div class="fp-group-image-edit-overlay" layout-align="center center" layout="row" ng-style="image.showEditProfileImage ? { \'top\':\'0\' } : {\'top\' : \'100%\'}"><fp-upload fp-upload-size-error="vm.fileSizeErrorMsg" fp-upload-status="vm.statusCheck" fp-accepted-type="\'image/*\'" fp-content-type="picture" fp-ng-model="vm.converationModel.picture_id" fp-multiple="true" fp-upload-icon-class="zmdi zmdi-edit icon-size" fp-add-model-fn="vm.updateTeamProfileImage(mediaId, responseObj)" fp-pattern="image/*" fp-upload-type="basic" fp-enable-preview="false" fp-all-button-color-class=""></fp-upload><md-button ng-if="vm.teamModel.picture_id && vm.teamModel.picture_id != null" ng-click="vm.removeTeamProfileImage()" class="md-icon-button" aria-label="primary button"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></div></div><md-input-container flex class="md-block"><label class="md-required" translate="atheer.team.name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.teamModel.name" required ng-disabled="vm.teamModel.locked"><div ng-messages="teamDetailForm.name.$error"><div ng-message when="required"><span translate="atheer.team.nameRequired">This field is required.</span></div></div></md-input-container></div><p ng-if="vm.fileSizeErrorMsg" class="error-msg" translate="atheer.team.maxFileSize">Maximum file size supported is 1MB.</p><md-input-container class="md-block"><label translate="atheer.team.description">Description</label> <textarea name="description" ng-model="vm.teamModel.description" id="field_description" ng-disabled="vm.teamModel.locked" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><div layout="row" layout-align="space-between center"><span translate="atheer.team.activate">Activate</span><md-switch name="activate" ng-model="vm.teamModel.status" ng-true-value="\'ACTIVE\'" ng-false-value="\'DRAFT\'"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.enableConversation">Enable Conversation</span><md-switch name="activate" ng-model="vm.teamModel.use_conversation"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.functionalTeam">Functional Team</span><md-switch name="activate" ng-model="vm.teamModel.functional_team"></md-switch></div></div><div ng-if="vm.mode == \'STATIC\'" flex layout="column" class="padded-content-page content-properties-container" ng-form="teamDetailForm"><div flex layout="row" layout-align="space-between center"><md-radio-group ng-model="vm.createNewTeam" ng-change="vm.toggleMode(\'create\')"><md-radio-button value="true"><span translate="atheer.team.createNewFixedTeam">Create a new static team</span></md-radio-button></md-radio-group><md-radio-group ng-model="vm.addToExistingTeam" ng-change="vm.toggleMode(\'add\')"><md-radio-button value="true"><span translate="atheer.team.addToFixedTeam">Add to existing status team</span></md-radio-button></md-radio-group></div><div ng-if="vm.addToExistingTeam == \'false\'"><div flex layout="row"><div flex="20" class="fp-group-image-container" ng-mouseenter="image.showEditProfileImage = true;" ng-mouseleave="image.showEditProfileImage = false;"><img ng-src="{{vm.getTeamProfileImageUrl()}}" alt="girl-avatar" class="make-round team-avatar"><md-icon md-font-icon ng-if="vm.statusCheck===\'uploading\'" class="fa fa-spinner fa-pulse" style="position: absolute; top: 40px; right: 40px"></md-icon><div class="fp-group-image-edit-overlay" layout-align="center center" layout="row" ng-style="image.showEditProfileImage ? { \'top\':\'0\' } : {\'top\' : \'100%\'}"><fp-upload fp-upload-size-error="vm.fileSizeErrorMsg" fp-upload-status="vm.statusCheck" fp-accepted-type="\'image/*\'" fp-content-type="picture" fp-ng-model="vm.teamModel.picture_id" fp-multiple="true" fp-upload-icon-class="zmdi zmdi-edit icon-size" fp-add-model-fn="vm.updateTeamProfileImage(mediaId, responseObj)" fp-pattern="image/*" fp-upload-type="basic" fp-enable-preview="false" fp-all-button-color-class=""></fp-upload><md-button ng-if="vm.teamModel.picture_id && vm.converationModel.picture_id != null" ng-click="vm.removeTeamProfileImage()" class="md-icon-button" aria-label="primary button"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></div></div><md-input-container flex class="md-block"><label class="md-required" translate="atheer.team.name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.teamModel.name" required ng-disabled="vm.teamModel.locked || vm.createNewTeam == \'false\'"><div ng-messages="teamDetailForm.name.$error"><div ng-message when="required"><span translate="atheer.team.nameRequired">This field is required.</span></div></div></md-input-container></div><p ng-if="vm.fileSizeErrorMsg" class="error-msg" translate="atheer.team.maxFileSize">Maximum file size supported is 1MB.</p><div layout="row" layout-align="space-between center"><span translate="atheer.team.activate">Activate</span><md-switch name="activate" ng-model="vm.teamModel.status" ng-true-value="\'ACTIVE\'" ng-false-value="\'DRAFT\'"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.enableConversation">Enable Conversation</span><md-switch name="activate" ng-model="vm.teamModel.use_conversation"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.functionalTeam">Functional Team</span><md-switch name="activate" ng-model="vm.teamModel.functional_team"></md-switch></div><md-input-container class="md-block"><label translate="atheer.team.description">Description</label> <textarea name="description" ng-model="vm.teamModel.description" id="field_description" ng-disabled="vm.teamModel.locked || vm.createNewTeam == \'false\'" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container></div><div ng-if="vm.addToExistingTeam == \'true\'" flex ng-form="teamDetailForm" layout="row"><md-input-container flex md-no-float><md-select ng-model="vm.selectedTeam" ng-disabled="vm.addToExistingTeam == \'false\'"><md-option ng-value="team" ng-repeat="team in vm.teams"><span class="view-name margin-left-10">{{team.name}}</span></md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><div ng-if="vm.mode == \'UPDATE\'"><md-button ng-click="vm.submit()" type="submit" ng-disabled="teamDetailForm.$invalid" class="md-raised md-primary"><span translate="atheer.team.updateExistingTeam">Update</span></md-button></div><div ng-if="vm.mode == \'DYNAMIC\' || (vm.mode == \'STATIC\' && vm.createNewTeam == \'true\')"><md-button ng-click="vm.submit()" type="submit" ng-disabled="teamDetailForm.$invalid" class="md-raised md-primary"><span translate="atheer.team.createNewTeam">Create</span></md-button></div><div ng-if="vm.addToExistingTeam == \'true\'"><md-button ng-click="vm.submit()" type="submit" ng-disabled="teamDetailForm.$invalid" class="md-raised md-primary"><span translate="atheer.team.addToTeam">Add</span></md-button></div></md-dialog-actions></md-dialog>');
$templateCache.put('modules/team/team-detail-save-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.team.saveTeam">Save Team</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div flex layout="column" class="padded-content-page content-properties-container" ng-form="teamDetailForm"><div flex ng-if="vm.jobResult != null && vm.jobStatus !== \'complete\'" layout="row" layout-align="center center" class="margin-bottom-20"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-padding layout-align="center" class="margin-top-40" layout-align="center"><div layout="row" layout-align="center"><md-progress-circular class="md-hue-2" md-mode="indeterminate"></md-progress-circular></div><div layout="row" layout-align="center" class="margin-40"><span class="md-title" translate="atheer.team.savingTeam">Saving Team. Please wait...</span></div></div></div></div><div ng-if="vm.jobStatus === \'complete\'" flex layout="row" layout-align="center center"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center" class="margin-top-20 margin-bottom-40"><span class="md-title" translate="atheer.team.saveComplete">Save complete.</span></div><md-button ng-click="vm.saveClose()" class="md-raised md-primary"><span translate="entity.action.close">Close</span></md-button></div></div><div flex ng-if="vm.jobResult == null" layout="column" layout-align="center center"><div layout="row" layout-align="center" class="margin-top-40"><span class="md-title" translate="atheer.team.saveMessage">Save Message.</span></div><div layout="row" layout-align="center" class="margin-20"><span class="md-subhead" translate="atheer.team.saveDescription">Save Message.</span></div><md-button ng-click="vm.saveTeam()" class="md-raised md-primary"><span translate="entity.action.save">Save</span></md-button></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/team/team-detail-toolbar.tmpl.html','<div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToTeams()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.teamDataModel.name}}</span></h2><div hide-xs layout-align="center center" class="margin-left-20 fp-team-type" ng-style="vm.teamDataModel.type == \'STATIC\' ? {\'background-color\': \'{{vm.primaryBackgroundColor}}\'} : {\'background-color\': \'{{vm.secondaryBackgroundColor}}\'}">{{vm.teamDataModel.type == \'STATIC\' ? \'atheer.team.typeFixed\' : \'atheer.team.typeDynamic\' | translate}}</div><span flex></span><div layout="row"><md-button type="submit" class="md-primary md-raised" ng-disabled="teamDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></div></div><ng-include src="\'modules/team/team-history.tmpl.html\'"></ng-include><ng-include src="\'modules/team/team-insights.tmpl.html\'"></ng-include>');
$templateCache.put('modules/team/team-detail.tmpl.html','<ng-include src="\'modules/team/team-detail-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="margin-top-10 fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="35" flex-xl="25" class="md-whiteframe-z1"><md-content flex class="padded-content-page content-properties-container"><div layout="row" layout-align="space-between center" ng-cloak ng-if="!vm.isNew() && vm.teamDataModel.type == \'SMART\'"><span flex translate="atheer.team.teamDetail">Team Detail</span><md-button ng-click="vm.showTeamDetails = !vm.showTeamDetails" class="md-icon-button"><fp-tooltip><span translate="atheer.team.seeMore">See More</span></fp-tooltip><md-icon ng-show="!vm.showTeamDetails" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-show="vm.showTeamDetails" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><md-divider ng-if="!vm.showTeamDetails && vm.teamDataModel.type == \'SMART\'"></md-divider><div ng-if="vm.showTeamDetails" ng-form="teamDetailForm"><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.team.teamNo" for="field_teamNo">Team No</label> <input type="number" class="form-control" name="teamNo" id="field_teamNo" ng-model="vm.teamDataModel.audience_no" required ng-disabled="true"><div ng-messages="teamDetailForm.teamNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><p ng-if="vm.fileSizeErrorMsg" class="error-msg" translate="atheer.team.maxFileSize">Maximum file size supported is 1MB.</p><md-input-container class="md-block"><label translate="atheer.team.name">Team Name</label> <input type="text" name="title" ng-model="vm.teamDataModel.name" md-select-on-focus required><div ng-messages="teamDetailForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.team.description">Description</label> <textarea name="description" ng-model="vm.teamDataModel.description" id="field_description" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><md-input-container class="md-block margin-bottom-40"><label translate="atheer.team.externalId" for="field_externalId">External ID</label> <input type="text" class="form-control" name="externalId" id="field_description" ng-model="vm.teamDataModel.external_id" ng-disabled="vm.teamDataModel.locked" md-no-resize md-maxlength="100"></md-input-container><div layout="row" layout-align="space-between center" class="margin-bottom-20"><span translate="atheer.team.type">Type</span><div hide-xs layout-align="center center" class="margin-left-20 fp-team-type" ng-style="vm.teamDataModel.type == \'STATIC\' ? {\'background-color\': \'{{vm.primaryBackgroundColor}}\'} : {\'background-color\': \'{{vm.secondaryBackgroundColor}}\'}">{{vm.teamDataModel.type == \'STATIC\' ? \'atheer.team.typeFixed\' : \'atheer.team.typeDynamic\' | translate}}</div></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.activate">Activate</span><md-switch name="activate" ng-model="vm.teamDataModel.status" ng-true-value="\'ACTIVE\'" ng-false-value="\'DRAFT\'"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.team.enableConversation">Enable Conversation</span><md-switch name="activate" ng-model="vm.teamDataModel.use_conversation"></md-switch></div><div layout="row" layout-align="space-between center" class="margin-bottom-20"><span translate="atheer.team.functionalTeam">Functional Team</span><md-switch name="activate" ng-model="vm.teamDataModel.functional_team"></md-switch></div><md-divider></md-divider><div layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex translate="atheer.team.thumbnail">Thumbnail</span><md-switch name="show_thumbnail" ng-model="vm.teamDataModel.use_custom_thumbnail" aria-label="Image"></md-switch></div><div ng-if="vm.teamDataModel.use_custom_thumbnail" class="margin-bottom-20" ng-if="" layout="row" layout-align="center center"><div flex="50"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.teamDataModel.thumbnail_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div><div layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex translate="atheer.team.banner">Banner</span><md-switch name="show_thumbnail" ng-model="vm.teamDataModel.use_custom_banner" aria-label="Image"></md-switch></div><div ng-if="vm.teamDataModel.use_custom_banner" class="margin-bottom-20" ng-if="" layout="row" layout-align="center center"><div flex="50"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.teamDataModel.banner_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div><md-divider></md-divider></div><div layout="row" layout-align="space-between center" ng-cloak ng-if="!vm.isNew() && vm.teamDataModel.type == \'SMART\'"><span flex>Filters</span><md-button ng-click="vm.showTeamFilters = !vm.showTeamFilters" class="md-icon-button"><fp-tooltip><span translate="atheer.team.seeMore">See More</span></fp-tooltip><md-icon ng-show="!vm.showTeamFilters" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-show="vm.showTeamFilters" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><md-divider ng-if="!vm.showTeamFilters && vm.teamDataModel.type == \'SMART\'"></md-divider><div flex layout="column" ng-show="!vm.isNew() && !vm.loadingData && vm.showTeamFilters && vm.teamDataModel.type == \'SMART\'"><div layout="row" layout-align="space-between center"><span translate="atheer.team.showUsersUsingFilters">Show users using filters</span><md-switch name="showUsersUsingFilters" ng-disabled="vm.teamDataModel.status == \'DRAFT\'" ng-model="vm.showUsersUsingFilters" ng-change="vm.togglerShowUsersFilter()"></md-switch></div><fp-team-detail-builder flex layout="column" team-model="vm.teamDataModel" class="padding-left-20 padding-right-20"></fp-team-detail-builder></div><md-divider ng-if="!vm.showTeamFilters && vm.teamDataModel.type == \'SMART\'"></md-divider></md-content></div><div flex layout="column"><div layout="row" ng-if="!vm.isNew()"><div class="md-toolbar-tools md-accent"><h2 hide-xs ng-if="vm.showUsersUsingFilters"><span translate="atheer.teamBuilder.usersUsingFilters">Users</span></h2><h2 hide-xs ng-if="!vm.showUsersUsingFilters"><span translate="atheer.teamBuilder.usersUsingSystem">Users</span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.refreshUsers()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.togglePanel(\'teamInsightsPanel\')" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-chart"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.teamBuilder.insights">Insights</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.togglePanel(\'teamHistoryPanel\')" aria-label="primary button"><md-icon md-font-icon="fa fa-history"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.teamBuilder.history">History</span></fp-tooltip></md-button><md-button ng-if="!vm.isNew() && vm.teamDataModel.type == \'STATIC\'" class="md-icon-button" ng-click="vm.openUserPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.addUsers">Add Users</span></fp-tooltip></md-button></div></div><div layout="center center" flex><div ng-if="vm.isNew()" flex layout-align="center center" layout="row"><div flex="75" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.team.saveTeam">Please save the Team to add Users to it.</span></div></div></div><div layout="column" flex ng-if="!vm.isNew()"><div ng-if="vm.loadingUsers" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingUsers && vm.users.length == 0" class="fp-no-data" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenIdUser"></illustration-empty-screen></div><md-table-container ng-if="!vm.loadingUsers && vm.users.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.userManagement.userAvatar">User Avatar</span></th><th md-column md-order-by="user_no"><span translate="atheer.userManagement.userNo">User No.</span></th><th md-column><span translate="atheer.userManagement.firstName">First Name</span></th><th md-column><span translate="atheer.userManagement.lastName">Last Name</span></th><th md-column><span translate="atheer.userManagement.email">Email</span></th><th md-column ng-if="!vm.showUsersUsingFilters"><span translate="atheer.team.assignedOn">Assigned On</span></th></tr></thead><tbody md-body><tr ng-repeat="user in vm.users track by user.id"><td md-cell><fp-avatar user="user" presence="false" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="35"></fp-avatar></td><td md-cell>{{user.user_no}}</td><td md-cell>{{user.first_name}}</td><td md-cell>{{user.last_name}}</td><td md-cell>{{user.email}}</td><td md-cell ng-if="!vm.showUsersUsingFilters">{{user.assigned_on | amDateFormat:\'MM/DD/YYYY\'}}</td><td ng-if="vm.teamDataModel.type == \'STATIC\'" md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeUser(user, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.users.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUsers"></md-table-pagination></div></div></div></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/team/team-history.tmpl.html','<md-sidenav class="md-sidenav-right fp-team-sidenav team-detail" md-component-id="teamHistoryPanel" md-whiteframe="4"><md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'teamHistoryPanel\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><span translate="atheer.team.teamHistory">Team History</span><div flex></div></div></md-toolbar><div ng-if="!vm.isUserHistoryLoaded" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div ng-if="vm.userHistory.length == 0 && vm.isUserHistoryLoaded" flex layout="column" layout-align="center center" class="margin-top-200"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.teamHistory.noHistory.title">Uh!</div><div class="margin-top-10 base" translate="atheer.teamHistory.noHistory.description">No history yet.</div></div><div class="md-padding" ng-if="vm.userHistory.length > 0 && vm.isUserHistoryLoaded"><md-table-container><table md-table class="md-primary md-data-table" md-progress="promise"><thead md-head md-order="predicate" md-on-reorder="reOrder"><tr md-row><th md-column><span translate="atheer.teamHistory.userNo">User No.</span></th><th md-column><span translate="atheer.teamHistory.firstName">First Name</span></th><th md-column><span translate="atheer.teamHistory.lastName">Last Name</span></th><th md-column md-order-by="action_type"><span translate="atheer.teamHistory.status">Status</span></th></tr></thead><tbody md-body><tr ng-repeat="userHistory in vm.userHistory track by userHistory.id"><td md-cell>{{userHistory.user_info.user_no}}</td><td md-cell>{{userHistory.user_info.first_name}}</td><td md-cell>{{userHistory.user_info.last_name}}</td><td md-cell>{{userHistory.action_type}}</td></tr></tbody></table></md-table-container></div><md-table-pagination md-limit="vm.userHistoryQueryLimit" md-total="{{vm.userHistoryQueryCount}}" md-page-select md-boundary-links="true" md-page="vm.userHistoryPage" md-on-paginate="vm.userHistoryTransition" ng-if="vm.userHistory.length > 0"></md-table-pagination></md-sidenav>');
$templateCache.put('modules/team/team-insights.tmpl.html','<md-sidenav class="md-sidenav-right fp-team-sidenav team-detail" md-component-id="teamInsightsPanel" md-whiteframe="4"><md-toolbar class="default margin-bottom-0"><div class="md-toolbar-tools md-accent"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'teamInsightsPanel\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><span translate="atheer.team.teamInsights">Team Insights</span><div flex></div></div></md-toolbar><div layout="row" layout-xs="column" layout-margin><md-card class="fp-content-feed" content-padding flex="100" ng-if="!vm.teamMemberCountHistory || vm.teamMemberCountHistory.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.teamInsights.members">Members</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/completions-overview.png"><div class="margin-top-10 main" translate="atheer.teamInsights.notEnough">Not Enough Activity Yet!</div></div></div></md-card><md-card layout-padding flex="100" ng-if="vm.teamMemberCountHistory.length > 0"><highchart id="team-user-line-chart" option="vm.teamUserChartData.chart" config="vm.teamUserChartData" series="vm.teamUserChartData.series"></highchart></md-card></div></md-sidenav>');
$templateCache.put('modules/team/team-menu.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="column" layout-fill><div flex layout="column" class="fp-folder-builder"><div layout="column" layout-padding class="margin-top-10"><div layout="column"><span class="md-body-1 margin-top-20 margin-bottom-10" translate="atheer.team.type">Type</span><md-checkbox ng-model="vm.filters.static" aria-label="Featured" ng-change="vm.updateFilters()"><span translate="atheer.team.typeFixed">Fixed</span></md-checkbox><md-checkbox ng-model="vm.filters.dynamic" aria-label="Disabled" ng-change="vm.updateFilters()"><span translate="atheer.team.typeDynamic">Dynamic</span></md-checkbox></div><md-divider></md-divider><md-input-container class="md-block"><md-checkbox ng-model="vm.filters.functionalTeam" aria-label="Featured" ng-change="vm.updateFilters()"><span translate="atheer.team.functionalTeam">Functional Team</span></md-checkbox><md-checkbox ng-model="vm.filters.externalId" aria-label="Disabled" ng-change="vm.updateFilters()"><span translate="atheer.team.hasExternalId">Has External ID</span></md-checkbox><md-checkbox ng-model="vm.filters.active" aria-label="Disabled" ng-change="vm.updateFilters()"><span translate="atheer.team.active">Active</span></md-checkbox></md-input-container></div></div></div>');
$templateCache.put('modules/team/team-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="autoComplete.teamPicker.title">Select Team</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container class="search-input-theme" ng-style="{ \'color\': secondaryColor }" ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button ng-if="vm.teams.length > 0" layout-align="center center" class="md-raised select-button" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedItems.length <= 0" translate="entity.action.select">Select</md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.teams.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="autoComplete.uh">Uh!</div><div class="margin-top-10 base" translate="autoComplete.teamPicker.noTeam">There are no team yet.</div></div><div class="md-padding" ng-if="vm.teams.length > 0"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedItems" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="name"><span translate="autoComplete.teamPicker.table.title">Title</span></th><th md-column md-order-by="memberCount"><span translate="autoComplete.teamPicker.table.members">Members</span></th></tr></thead><tbody md-body><tr ng-repeat="team in vm.teams track by team.id" md-row md-select="team" md-select-id="id" md-auto-select><td md-cell>{{team.name}}</td><td md-cell>{{team.member_count}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/team/team-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2><span translate="atheer.team.home.title">Teams</span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.team.enterSearchPlaceholder\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.team.refresh">Refresh</span></fp-tooltip></md-button><md-menu md-offset="0 60" permission permission-only="vm.permissions.create"><md-button class="md-accent md-raised" ng-click="$mdMenu.open()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.create"><md-button ng-click="$mdCloseMenu;vm.createStaticTeam()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-accounts-list"></md-icon><span translate="atheer.team.newStaticTeam">New Fixed Team</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.create"><md-button ng-click="$mdCloseMenu;vm.createSmartTeam()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-chart-donut"></md-icon><span translate="atheer.team.newSmartTeam">New Dynamic Team</span></md-button></md-menu-item></md-menu-content></md-menu><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/team/teams.html','<div flex layout="row" layout-fill><div flex layout="column"><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="row"><div ng-if="!vm.loadingData && vm.teams.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-table-container flex ng-if="!vm.loadingData && vm.teams.length > 0" class="fp-team-list"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="audience_no"><span translate="atheer.team.teamNo">Team No</span></th><th md-column md-order-by="name"><span translate="atheer.team.name">Name</span></th><th md-column md-order-by="type"><span translate="atheer.team.type">Type</span></th><th md-column md-order-by="status"><span translate="atheer.team.active">Active</span></th><th md-column md-order-by="member_count"><span translate="atheer.team.memberCount">Member Count</span></th><th md-column md-order-by="created_on"><span translate="atheer.team.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="team in vm.teams track by team.id" class="fp-team-list"><td md-cell><div flex class="fp-team-number-wrapper" layout="row" layout-align="start center"><div ng-if="team.thumbnail_url && team.use_custom_thumbnail"><img class="fp-team-thumbnail" ng-src="{{team.thumbnail_url  | mediaUrl}}"></div><div ng-if="!team.thumbnail_url || !team.use_custom_thumbnail"><div class="fp-default-team-icon"><md-icon class="fp-mat-icon" md-font-icon="zmdi zmdi-accounts"></md-icon></div></div><div>{{team.audience_no}}</div></div></td><td md-cell>{{team.name}}</td><td md-cell><div layout-align="center center" class="fp-team-type" ng-style="team.type == \'STATIC\' ? {\'background-color\': \'{{vm.primaryBackgroundColor}}\'} : {\'background-color\': \'{{vm.secondaryBackgroundColor}}\'}">{{team.type == \'STATIC\' ? \'atheer.team.typeFixed\' : \'atheer.team.typeDynamic\' | translate}}</div></td><td md-cell><md-switch name="enabled" ng-model="team.active" ng-disabled="true"></md-switch></td><td md-cell>{{team.member_count}}</td><td md-cell am-time-ago="team.created_on"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(team.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu permission permission-only="vm.permissions.create" ng-if="vm.createMenu && !vm.isPickerView"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon></md-button><md-menu-content width="5"><md-menu-item ng-repeat="item in vm.createSubTeamMenuOptions"><md-button ng-click="$mdCloseMenu;vm.selectMenu(item, team)"><md-icon md-font-icon="{{item.icon}}"></md-icon><span translate>{{item.label}}</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(team)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.teams.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/topic/topic-detail-images.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="row" layout-fill flex layout-align="center center"><div layout="column" layout-align="center center" class="margin-top-40"><span class="md-display-1" translate="atheer.topic.comingSoon">Coming Soon</span></div></div>');
$templateCache.put('modules/topic/topic-detail-insights.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout-fill layout="column" flex><div class="toolbar-default md-whiteframe-z1" ng-style="{\'margin-bottom\': \'10\' + \'px\'}"><div class="md-toolbar-tools md-accent"><md-button ui-sref="storm.admin-topics" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.topicModel.name}}</span></h2><div flex><md-tabs md-center-tabs><md-tab ui-sref="storm.admin-topic-detail({id: \'{{vm.topicModel.id}}\'})"><md-tab-label><span translate="atheer.topic.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-recognition.section({id: \'{{vm.topicModel.id}}\', section : \'qr_code\'})"><md-tab-label><span translate="atheer.topic.recognition">Recognition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-insights.section({id: \'{{vm.topicModel.id}}\', section : \'overview\'})" md-active="true"><md-tab-label><span translate="atheer.topic.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div layout="row"><fp-help></fp-help></div></div></div><div flex layout="column"><md-tabs class="padding-left-10" md-center-tabs="true"><md-tab ui-sref="storm.admin-topic-detail-insights.section({section:\'{{sectionKey}}\'})" ng-repeat="(sectionKey, section) in vm.insightSections"><md-tab-label><span translate>{{section.label}}</span></md-tab-label></md-tab></md-tabs><div flex layout="column" ui-view></div></div></div>');
$templateCache.put('modules/topic/topic-detail-qrcode.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="row" layout-fill flex layout-align="center center"><div layout="column" layout-align="center center"><h4 hide-xs flex><span translate="atheer.topic.useQrCode">Use this QR Code to scan on Atheer Lens</span></h4><div class="margin-top-20"><img ng-src="{{vm.qrCodeImage}}" border="0" width="400"></div><div ng-if="vm.showActions" layout="row"><md-button type="submit" class="md-primary md-raised" ng-click="vm.printQR()"><span translate="atheer.topic.print">Print</span></md-button><md-button type="submit" class="md-primary md-raised" ng-click="vm.downloadQR()"><span translate="atheer.topic.download">Download</span></md-button></div></div></div>');
$templateCache.put('modules/topic/topic-detail-recoginition.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout-fill layout="column" flex><div class="toolbar-default md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ui-sref="storm.admin-topics" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.topicModel.name}}</span></h2><div flex><md-tabs md-center-tabs><md-tab ui-sref="storm.admin-topic-detail({id: \'{{vm.topicModel.id}}\'})"><md-tab-label><span translate="atheer.topic.settings">Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-recognition.section({id: \'{{vm.topicModel.id}}\', section : \'qr_code\'})" md-active="true"><md-tab-label><span translate="atheer.topic.recognition">Recognition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-insights.section({id: \'{{vm.topicModel.id}}\', section : \'overview\'})"><md-tab-label><span translate="atheer.topic.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div layout="row"><fp-help></fp-help></div></div></div><div flex layout="column"><md-tabs class="padding-left-10" md-center-tabs="true"><md-tab ui-sref="storm.admin-smartscan-detail-recognition.section({section:\'{{sectionKey}}\'})" ng-repeat="(sectionKey, section) in vm.recognitionSections"><md-tab-label><span translate>{{section.label}}</span></md-tab-label></md-tab></md-tabs><div flex layout="column" ui-view></div></div></div>');
$templateCache.put('modules/topic/topic-detail-toolbar.tmpl.html','<div ng-if="!vm.loadingData" class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.backButtonClickHandler()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><div flex="25" class="text-overflow-hidden"><span flex="25" data-ellipsis ng-bind="vm.topicDataModel.name"></span><fp-tooltip class="tooltip-word-break"><span ng-bind="vm.topicDataModel.name"></span></fp-tooltip></div><div ng-if="!vm.loadingData" flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="white-theme"><md-tab ui-sref="storm.admin-topic-detail({id: \'{{vm.topicDataModel.id}}\'})" md-active="true"><md-tab-label><span>Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-recognition.section({id: \'{{vm.topicDataModel.id}}\', section : \'qr_code\'})"><md-tab-label><span translate="atheer.topic.recognition">Recognition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-insights.section({id: \'{{vm.topicDataModel.id}}\', section : \'overview\'})"><md-tab-label><span translate="atheer.topic.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div layout="row"><md-button type="submit" class="md-primary md-raised" ng-disabled="topicDetailForm.$invalid || vm.topicCustomForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><md-button ng-if="!!vm.topicDataModel.id" class="md-icon-button" ng-click="vm.copyTopic()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.copy">Copy</span></fp-tooltip></md-button><fp-help></fp-help></div></div></div>');
$templateCache.put('modules/topic/topic-detail.tmpl.html','<div ng-form="topicDetailForm"><ng-include src="\'modules/topic/topic-detail-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="margin-top-10 fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="35" flex-xl="25" class="md-whiteframe-z1"><md-content flex class="padded-content-page content-properties-container"><form flex name="vm.topic" novalidate><div ng-form="topicDetailForm"><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.topic.topicNo" for="field_topicNo">Topic No</label> <input type="number" class="form-control" name="topicNo" id="field_topicNo" ng-model="vm.topicDataModel.topic_no" required ng-disabled="true"><div ng-messages="topicDetailForm.topicNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.topic.topicName">Topic Name</label> <input type="text" name="title" ng-model="vm.topicDataModel.name" md-select-on-focus required ng-maxlength="50"><div ng-messages="topicDetailForm.title.$error" ng-if="topicDetailForm.title.$dirty"><div ng-message="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message="maxlength"><span translate="atheer.topic.messages.topicMaxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.topic.description">Description</label> <textarea name="description" ng-model="vm.topicDataModel.description" id="field_description" md-no-resize ng-maxlength="255" md-maxlength="255" rows="3"></textarea><div ng-messages="topicDetailForm.description.$error" ng-if="topicDetailForm.description.$dirty"><div ng-message="maxlength"><span translate="atheer.topic.messages.descriptionMaxLength">This field cannot be longer than 255 characters.</span></div></div></md-input-container><md-input-container class="md-block margin-bottom-40"><label translate="atheer.topic.externalId" for="field_externalId">External ID</label> <input type="text" class="form-control" name="externalId" id="field_description" ng-model="vm.topicDataModel.external_id" ng-disabled="vm.topicDataModel.locked" md-no-resize ng-maxlength="100" md-maxlength="100"><div ng-messages="topicDetailForm.externalId.$error" ng-if="topicDetailForm.externalId.$dirty"><div ng-message="maxlength"><span translate="atheer.topic.messages.externalIdMaxlength">This field cannot be longer than 100 characters.</span></div></div><md-button class="fp-info-tooltip-icon md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.externalIdTooltip"></span></fp-tooltip></md-button></md-input-container><div layout="row" layout-align="space-between center"><span translate="atheer.topic.enabled">Allow users to exlore</span><md-switch name="enabled" ng-model="vm.topicDataModel.enabled"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="atheer.topic.allowScan">Allow users to scan</span><md-switch name="enabled" ng-model="vm.topicDataModel.allow_scan"></md-switch></div><div class="margin-top-20" layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-eye"></md-icon><span flex class="md-body-2" translate="atheer.topic.owner">Owner</span></div><div><fp-auto-complete no-label="true" auto-complete-model="vm.owner" component="Team" multiple="false" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-clock-o"></md-icon><span flex translate="atheer.topic.scheduling">Scheduling</span><md-button ng-click="vm.show_scheduling = !vm.show_scheduling" class="md-icon-button"><md-icon ng-if="!vm.show_scheduling" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_scheduling" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.show_scheduling" class="margin-bottom-20"><div layout="row" layout-align="space-between center"><span translate="atheer.topic.availableFrom">Available From</span><md-datepicker md-max-date="vm.topicDataModel.discontinue_from" ng-model="vm.topicDataModel.available_from" md-placeholder="Select date"></md-datepicker></div><div layout="row" layout-align="space-between center"><span translate="atheer.topic.discontinueFrom">Discontinue From</span><md-datepicker md-min-date="vm.topicDataModel.available_from" ng-model="vm.topicDataModel.discontinue_from" md-placeholder="Select date"></md-datepicker></div></div><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-group"></md-icon><span flex class="md-body-2" translate="atheer.topic.visibleTo">Visible To</span><md-button ng-click="vm.show_audiences = !vm.show_audiences" class="md-icon-button"><md-icon ng-if="!vm.show_audiences" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_audiences" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.show_audiences" class="margin-bottom-20"><fp-auto-complete no-label="true" auto-complete-model="vm.audiences" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-sliders"></md-icon><span flex translate="atheer.topic.settings">Settings</span><md-button ng-click="vm.show_settings = !vm.show_settings" class="md-icon-button"><fp-tooltip><span translate="atheer.topic.seeMore">See More</span></fp-tooltip><md-icon ng-show="!vm.show_settings" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-show="vm.show_settings" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><md-divider ng-if="vm.show_settings"></md-divider><div ng-if="vm.show_settings" layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex translate="atheer.topic.thumbnail">Thumbnail</span><md-switch name="show_thumbnail" ng-model="vm.topicDataModel.use_custom_thumbnail" aria-label="Image"></md-switch></div><div ng-if="vm.show_settings" class="margin-bottom-20" ng-if="vm.topicDataModel.use_custom_thumbnail" layout="row" layout-align="center center"><div flex="50"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.topicDataModel.thumbnail_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div><md-divider ng-if="vm.show_settings"></md-divider><div ng-if="vm.show_settings" layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex translate="atheer.topic.banner">Banner</span><md-switch name="show_thumbnail" ng-model="vm.topicDataModel.use_custom_banner" aria-label="Image"></md-switch></div><div ng-if="vm.show_settings" class="margin-bottom-20" ng-if="vm.topicDataModel.use_custom_banner" layout="row" layout-align="center center"><div flex="50"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.topicDataModel.banner_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div><md-divider></md-divider><div permission permission-only="atheer_features.topic.extended_fields"><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-settings-square"></md-icon><span flex translate="atheer.topic.extendedFields">Extended Fields</span><md-button ng-click="vm.show_custom_fields = !vm.show_custom_fields" class="md-icon-button"><md-icon ng-if="!vm.show_custom_fields" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_custom_fields" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-show="vm.show_custom_fields" class="margin-bottom-20 fp-profile-event-form"><formly-form fields="vm.topicMetaFields" form="vm.topicCustomForm" model="vm.topicDataModel.custom_attributes"></formly-form></div></div><md-divider></md-divider></div></form></md-content></div><div flex layout="column"><div layout="row"><div flex="50"><md-tabs class="padding-left-10"><md-tab ng-if="!vm.isSubTopic || vm.isNew()" ng-click="vm.tabView = \'SUB-TOPIC\'" md-active="vm.tabView == \'SUB-TOPIC\'"><md-tab-label><span translate="atheer.topic.subTopics">Sub Topics</span></md-tab-label></md-tab><md-tab ng-if="!vm.isNew()" ng-click="vm.tabView = \'CONTENTS\'"><md-tab-label><span translate="atheer.topic.content">Content</span></md-tab-label></md-tab><md-tab ng-if="!vm.isNew()" ng-click="vm.tabView = \'USERS\'"><md-tab-label><span translate="atheer.topic.users">People</span></md-tab-label></md-tab><md-tab ng-if="!vm.isNew()" ng-click="vm.tabView = \'AIRFORMS\'"><md-tab-label><span translate="atheer.topic.airForms">AiRForms</span></md-tab-label></md-tab></md-tabs></div><div class="md-toolbar-tools md-accent"><span flex></span><md-button class="md-icon-button" ng-click="vm.refresh()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.refresh">Refresh</span></fp-tooltip></md-button><md-button ng-if="vm.tabView == \'SUB-TOPIC\'" class="md-icon-button" ng-click="vm.openTopicPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.addSubTopic">Add Sub Topic</span></fp-tooltip></md-button><md-button ng-if="!vm.isNew() && vm.tabView == \'CONTENTS\'" class="md-icon-button" ng-click="vm.openContentPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.addContent">Add Content</span></fp-tooltip></md-button><md-button ng-if="!vm.isNew() && vm.tabView == \'AIRFORMS\'" class="md-icon-button" ng-click="vm.openAirFormPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.addAirForm">Add AiRForm</span></fp-tooltip></md-button><md-button ng-if="!vm.isNew() && vm.tabView == \'USERS\'" class="md-icon-button" ng-click="vm.openUserPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.addUsers">Add Users</span></fp-tooltip></md-button></div></div><div layout="center center" flex layout-padding><div ng-if="vm.isNew()" flex layout-align="center center" layout="row"><div flex="75" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.topic.saveSubTopic">Please save the topic to add Sub topics to it.</span></div></div></div><div layout="column" flex ng-if="!vm.isNew() && vm.tabView == \'SUB-TOPIC\' && !isSubTopic"><div class="full-height" layout layout-align="center center" ng-if="vm.loadingSubTopics"><wave-spinner></wave-spinner></div><div ng-if="vm.subTopics.length == 0 && !vm.loadingSubTopics" class="full-height" layout="column" layout-align="center center"><div layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"></div><div class="margin-top-10 main" translate="atheer.topic.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.topic.noSubTopics">No Sub Topics yet.</div></div><md-table-container ng-if="vm.subTopics.length > 0 && !vm.loadingSubTopics" layout="row" layout-wrap><div flex="30" flex-xs="100" flex-sm="50" flex-lg="30" flex-md="30" ng-repeat="topic in vm.subTopics"><md-card class="fp-topic-card-list-view fp-topic-thumbnail" ng-style="vm.getTopicThumbnail(topic)" ng-click="vm.getSubTopic(topic.id)"><md-card-actions layout="row" layout-align="end center"><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.removeSubTopic(topic)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.deleteSubTopic">Delete</span></fp-tooltip></md-button></md-card-actions></md-card><span class="follow-card-title-text" ng-style="{\'margin\': \'20px 10px 10px\', \'font-size\': \'18px\', \'line-height\': \'16px\', \'display\': \'inline-block\', \'width\': \'88%\', \'text-overflow\': \'ellipsis\', \'overflow\': \'hidden\', \'white-space\': \'nowrap\'}" ng-bind="topic.name"></span></div></md-table-container><div flex></div><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.subTopicsQueryCount}}" md-page-select md-boundary-links="true" md-page="vm.subTopicsPage" md-on-paginate="vm.transitionSubTopics" ng-if="vm.subTopics.length > 0"></md-table-pagination></div><div layout="column" flex ng-if="!vm.isNew() && vm.tabView == \'CONTENTS\'"><div class="full-height" layout layout-align="center center" ng-if="vm.loadingContent"><wave-spinner></wave-spinner></div><div ng-if="vm.contents.length == 0 && !vm.loadingContent" class="full-height" layout="column" layout-align="center center"><div layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"></div><div class="margin-top-10 main" translate="atheer.topic.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.topic.noContent">No Contents available.</div></div><md-table-container ng-if="vm.contents.length > 0 && !vm.loadingContent" layout="row" layout-wrap><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.topic.type">Type</span></th><th md-column><span translate="atheer.topic.title">Title</span></th><th md-column><span translate="atheer.topic.createdOn">Created On</span></th></tr></thead><tbody md-body><tr ng-repeat="content in vm.contents track by content.id"><td md-cell><md-icon md-font-icon="{{vm.getCardMeta(content).icon}}"><fp-tooltip>{{vm.getCardMeta(content).label | translate}}</fp-tooltip></md-icon></td><td md-cell style="font-size: 18px;">{{content.title}}</td><td md-cell am-time-ago="content.created_on" style="font-size: 16px;"></td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeContent(content, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.contentsQueryCount}}" md-page-select md-boundary-links="true" md-page="vm.contentsPage" md-on-paginate="vm.transitionContents" ng-if="vm.contents.length > 0"></md-table-pagination></div><div layout="column" flex flex ng-if="!vm.isNew() && vm.tabView == \'AIRFORMS\'"><div ng-if="vm.loadingAirForms" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingAirForms && vm.airForms.length == 0" class="fp-no-data" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenIdSmartScan"></illustration-empty-screen></div><md-table-container ng-if="!vm.loadingAirForms && vm.airForms.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.topic.name">Name</span></th><th md-column><span translate="atheer.topic.createdOn">Created On</span></th></tr></thead><tbody md-body><tr ng-repeat="airform in vm.airForms track by airform.id"><td md-cell>{{airform.name}}</td><td md-cell>{{airform.created_on | date:\'MM/dd/yyyy\'}}</td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeAirForm(airform, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.smartScans.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUserSmartScans"></md-table-pagination></div><div layout="column" flex flex ng-if="!vm.isNew() && vm.tabView == \'USERS\'"><div ng-if="vm.loadingUsers" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingUsers && vm.users.length == 0" class="fp-no-data" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenIdUser"></illustration-empty-screen></div><md-table-container ng-if="!vm.loadingUsers && vm.users.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.topic.firstName">First Name</span></th><th md-column><span translate="atheer.topic.lastName">Last Name</span></th><th md-column><span translate="atheer.topic.email">Email</span></th></tr></thead><tbody md-body><tr ng-repeat="user in vm.users track by user.id"><td md-cell>{{user.first_name}}</td><td md-cell>{{user.last_name}}</td><td md-cell>{{user.email}}</td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeUser(user, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.smartScans.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUserSmartScans"></md-table-pagination></div></div></div></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include></div>');
$templateCache.put('modules/topic/topic-insight-overview.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topicScansByDay.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.topic.topicUsage">Topic Usage</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/completions-overview.png"><div class="margin-top-10 main" translate="atheer.topic.notEnoughActivity">Not Enough Activity Yet!</div></div></div></md-card><md-card layout-padding flex ng-if="vm.topicScansByDay.series[0].data.length > 0"><highchart id="usage-session-count" option="vm.topicScansByDay.chart" config="vm.topicScansByDay" series="vm.topicScansByDay.series"></highchart></md-card></div></div>');
$templateCache.put('modules/topic/topic-insight-scan-history.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><md-content flex ng-if="!vm.loadingData"><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.topic.firstName">First Name</span></th><th md-column><span translate="atheer.topic.lastName">Last Name</span></th><th md-column md-order-by="created_on"><span translate="atheer.topic.scannedOn">Scanned On</span></th></tr></thead><tbody md-body><tr ng-repeat="view in vm.viewData track by view.id"><td md-cell>{{view.user_info.first_name}}</td><td md-cell>{{view.user_info.last_name}}</td><td md-cell>{{view.created_on | amCalendar:referenceTime:formats}}</td></tr></tbody></table></md-table-container></md-content></div><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.viewData.length > 0"></md-table-pagination>');
$templateCache.put('modules/topic/topic-menu.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="column" layout-fill><div flex layout="column" class="fp-folder-builder"><div layout="column" layout-padding class="margin-top-10"><md-input-container class="md-block"><md-checkbox ng-model="vm.filters.enabled" aria-label="Featured" ng-change="vm.updateFilters()"><span translate="atheer.topic.allowFilterExplore">Allow explore</span></md-checkbox><md-checkbox ng-model="vm.filters.allowScan" aria-label="Featured" ng-change="vm.updateFilters()"><span translate="atheer.topic.allowFilterScan">Allow scan</span></md-checkbox><md-checkbox ng-model="vm.filters.externalId" aria-label="Disabled" ng-change="vm.updateFilters()"><span translate="atheer.topic.hasExternalId">Has External ID</span></md-checkbox></md-input-container></div></div></div>');
$templateCache.put('modules/topic/topic-metadata.tmpl.html','<div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-toolbar ng-if="!vm.loadingData" class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.back()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span translate="atheer.topicFields.title">Topic Fields</span> <span flex></span><fp-help></fp-help></div></md-toolbar><div flex layout="row" ng-if="!vm.loadingData"><div flex="25" layout="column" class="fp-field-group-detail"><md-list><md-list-item ng-repeat="fieldGroup in vm.metaDataObject.field_groups track by $index" ng-click="vm.selectFieldGroup(fieldGroup, $index)" ng-show="fieldGroup.locked == false || fieldGroup.name == \'base\'" ng-class="{\'fp-field-group-active\': vm.selectedFieldGroup == fieldGroup && !vm.showDisplayOrderPage}"><div layout="row"><h4 flex>{{fieldGroup.name == \'base\' ? \'atheer.topicFields.title\' : (fieldGroup.is_many ? fieldGroup.plural_label : fieldGroup.label) | translate }}</h4><md-menu ng-if="fieldGroup == vm.selectedFieldGroup && fieldGroup.name != \'base\'" class="md-secondary"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.editFieldGroup(fieldGroup, $index)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><span translate="entity.action.edit">Edit</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteFieldGroup(fieldGroup, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-divider></md-divider></md-list-item><md-list-item ng-click="vm.showDisplayOrder()" ng-class="{\'fp-field-group-active\': vm.showDisplayOrderPage}"><div layout="row"><h4 flex>{{\'atheer.topic.metadata.topicDisplayOrder\' | translate }}</h4></div></md-list-item></md-list></div><div flex="75" layout="row" ng-if="(!vm.metaDataObject.field_groups || vm.metaDataObject.field_groups.length <= 0) && !vm.showDisplayOrderPage" layout-align="center center"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.topicFields.addFieldGroup">Please add Field Group to add Fields to it.</span></div></div><div flex="75" ng-if="vm.selectedFieldGroup && !vm.showDisplayOrderPage" flex layout="column"><div md-theme="{{triSkin.elements.toolbar}}" class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span>{{vm.selectedFieldGroup.name == \'base\' ? \'\' : vm.selectedFieldGroup.label}} {{vm.selectedFieldGroup.name == \'base\' ? \'atheer.topicFields.fields\' : \'atheer.topicFields.fields\' | translate}}</span> <span flex></span><md-button class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topicFields.addField">Add Field</span></fp-tooltip></md-button></div></div><md-content flex class="md-padding"><div ng-if="!vm.selectedFieldGroup.fields || vm.selectedFieldGroup.fields.length <= 0" layout-align="center center" layout="column"><div flex class="margin-left-20 margin-top-200"><span class="md-title" translate="atheer.topicFields.noFields">No Fields.</span></div></div><div ng-if="vm.selectedFieldGroup.fields && vm.selectedFieldGroup.fields.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row><th md-column><span translate="atheer.topicFields.label">Label</span></th><th md-column><span translate="atheer.topicFields.name">Name</span></th><th md-column><span translate="atheer.topicFields.type">Type</span></th><th></th></tr></thead><tbody md-body dragula=\'"user-group-fields"\' dragula-model="vm.selectedFieldGroup.fields"><tr ng-repeat="field in vm.selectedFieldGroup.fields track by $index"><td md-cell>{{field.label}}</td><td md-cell>{{field.name}}</td><td md-cell>{{field.data_type}}</td><td class="text-right"><md-icon ng-if="field.locked" md-font-icon="zmdi zmdi-lock" class="margin-right-10"></md-icon><md-button ng-if="!field.locked" class="md-icon-button" aria-label="primary button" ng-click="vm.editField(field, $index)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu ng-if="!field.locked"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.copyField(field, $index)"><md-icon class="zmdi zmdi-copy icon-size"></md-icon><span translate="entity.action.copy">Copy</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteField(field, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></div></md-content></div><div flex="75" ng-if="vm.showDisplayOrderPage" flex layout="column"><div md-theme="{{triSkin.elements.toolbar}}" class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span class="displayOrderTitle" translate="atheer.topic.metadata.displayOrder">Display Order</span></div></div><div class="displayOrder"><div class="displyOrderDiv" flex><div class="drag-drop-row cursor-no-drop"><div class="drag-icon"></div><div class="drag-label">Sub-Topics</div></div><div class="drag-drop" dragula=\'"vm.topicDisplayOrder"\' dragula-model="vm.topicDisplayOrder"><div class="drag-drop-row" ng-repeat="userField in vm.topicDisplayOrder track by userField.name"><div class="drag-icon"><i class="zmdi zmdi-menu" aria-hidden="true"></i></div><div class="drag-label">{{userField.name}}</div></div></div><div class="margin-top-30" flex layout="row" layout-align="center center"><md-button ng-click="vm.saveDisplayOrder()" class="md-raised md-primary" ng-click="vm.saveDisplayOrder()" aria-label="primary button"><span translate="entity.action.save">Save</span></md-button></div></div></div></div></div>');
$templateCache.put('modules/topic/topic-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="autoComplete.topicPicker.title">Select Topic</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container class="search-input-theme" ng-show="vm.filter.show" flex ng-style="{ \'color\': secondaryColor }"><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button layout-align="center center" class="md-raised select-button" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedItems.length <= 0" translate="entity.action.select" ng-if="vm.topics.length > 0">Select</md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.topics.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="autoComplete.uh">Uh!</div><div class="margin-top-10 base" translate="autoComplete.topicPicker.noTopic">There are no topic yet.</div></div><div class="md-padding" ng-if="vm.topics.length > 0"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedItems" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="name"><span translate="autoComplete.topicPicker.table.title">Title</span></th></tr></thead><tbody md-body><tr ng-repeat="topic in vm.topics track by topic.id" md-row md-select="topic" md-select-id="id" md-auto-select><td md-cell>{{topic.name}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/topic/topic-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2><span translate="atheer.topic.home.title">Topics</span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.topic.enterSearchPlaceholder\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.refresh">Refresh</span></fp-tooltip></md-button><md-button permission permission-only="vm.permissions.create" class="md-accent md-raised" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><div permission permission-only="atheer_features.topic.extended_fields"><md-button class="md-icon-button" aria-label="primary button" ui-sref="storm.admin-topic-fields"><md-icon md-font-icon="zmdi zmdi-settings"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topicFields.title">Topic Fields</span></fp-tooltip></md-button></div><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/topic/topics.html','<div flex layout="row" layout-fill><div flex layout="column"><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="row"><div ng-if="!vm.loadingData && vm.topics.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-table-container flex ng-if="!vm.loadingData && vm.topics.length > 0" class="fp-topic-list"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.topic.topicIcon">Topic Icon</span></th><th md-column md-order-by="topicNo"><span translate="atheer.topic.topicNo">Topic No</span></th><th md-column md-order-by="name"><span translate="atheer.topic.name">Name</span></th><th md-column><span translate="atheer.topic.allowFilterExplore">Allow Explore</span></th><th md-column><span translate="atheer.topic.allowFilterScan">Allow Scan</span></th><th md-column md-order-by="created_on"><span translate="atheer.topic.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="topic in vm.topics track by topic.id" class="fp-topic-list"><td md-cell><div flex class="fp-topic-number-wrapper" layout="row" layout-align="start center"><div ng-if="!!topic.thumbnail_url"><img class="fp-topic-thumbnail" ng-src="{{topic.thumbnail_url  | mediaUrl}}"></div><div ng-if="!topic.thumbnail_url"><div class="fp-default-topic-icon"><md-icon class="fp-mat-icon" md-font-icon="zmdi zmdi-widgets"></md-icon></div></div></div></td><td md-cell>{{topic.topic_no}}</td><td md-cell class="topic-name">{{topic.name}}</td><td md-cell><md-switch name="enabled" ng-model="topic.enabled" ng-change="vm.onPublishChange(topic)"></md-switch></td><td md-cell><md-switch name="allow_scan" ng-model="topic.allow_scan" ng-change="vm.onPublishChange(topic)"></md-switch></td><td md-cell am-time-ago="topic.created_on"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(topic.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu permission permission-only="vm.permissions.create" ng-if="vm.createMenu && !vm.isPickerView"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon></md-button><md-menu-content width="5"><md-menu-item ng-repeat="item in vm.createSubTopicMenuOptions"><md-button ng-click="$mdCloseMenu;vm.selectMenu(item, topic)"><md-icon md-font-icon="{{item.icon}}"></md-icon><span translate>{{item.label}}</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(topic)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.topics.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/user/user-account.tmpl.html','<div ui-view flex></div>');
$templateCache.put('modules/user/user-detail-dialog.html','<md-dialog aria-label="User Detail" flex="50" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><h2 id="myUserLabel">{{vm.dynamicTitle | translate}}</h2><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><div ng-if="!vm.isSavingError"><form name="vm.profileForm" role="form" novalidate ng-submit="vm.save()" show-validation><div><md-input-container class="md-block"><label for="login" translate="atheer.userManagement.login">Login</label> <input id="login" type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-maxlength="50" ng-keyup="vm.checkLogin()"><div ng-messages="vm.profileForm.login.$error" md-auto-hide="false" ng-show="vm.profileForm.login.$touched"><div ng-message when="required"><span translate="atheer.userManagement.messages.login.required">Please enter your login.</span></div></div><div ng-messages="vm.profileForm.login.$error" md-auto-hide="false" ng-show="vm.profileForm.login.$touched"><div ng-message when="maxlength"><span translate="atheer.userManagement.messages.login.maxLength">This field cannot be longer than 50 characters.</span></div></div><div ng-messages="vm.profileForm.login.$error" md-auto-hide="false" ng-show="vm.profileForm.login.$touched"><div ng-message when="loginWhiteSpaceError"><span translate="atheer.userManagement.messages.login.whiteSpace">This field cannot contain space.</span></div></div></md-input-container><md-input-container class="md-block"><label for="first_name" translate="atheer.userManagement.firstName">First Name</label> <input id="first_name" type="text" class="form-control" name="first_name" ng-model="vm.user.first_name" required ng-maxlength="50"><div ng-messages="vm.profileForm.first_name.$error" md-auto-hide="false" ng-show="vm.profileForm.first_name.$touched"><div ng-message when="required"><span translate="atheer.userManagement.messages.firstName.required">Please enter your first name.</span></div></div><div ng-messages="vm.profileForm.first_name.$error" md-auto-hide="false" ng-show="vm.profileForm.first_name.$touched"><div ng-message when="maxlength"><span translate="atheer.userManagement.messages.firstName.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="last_name" translate="atheer.userManagement.lastName">Last Name</label> <input id="last_name" type="text" class="form-control" name="last_name" ng-model="vm.user.last_name" required ng-maxlength="50"><div ng-messages="vm.profileForm.last_name.$error" md-auto-hide="false" ng-show="vm.profileForm.last_name.$touched"><div ng-message when="required"><span translate="atheer.userManagement.messages.lastName.required">Please enter your last name.</span></div></div><div ng-messages="vm.profileForm.last_name.$error" md-auto-hide="false" ng-show="vm.profileForm.last_name.$touched"><div ng-message when="maxlength"><span translate="atheer.userManagement.messages.lastName.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="email" translate="atheer.userManagement.email">E-Mail</label> <input id="email" type="email" class="form-control" name="email" ng-model="vm.user.email" ng-maxlength="50"><div ng-messages="vm.profileForm.email.$error" md-auto-hide="false" ng-show="vm.profileForm.email.$touched"><div ng-message when="required"><span translate="atheer.userManagement.messages.email.required">Please enter your last name.</span></div></div><div ng-messages="vm.profileForm.email.$error" md-auto-hide="false" ng-show="vm.profileForm.email.$touched"><div ng-message when="maxlength"><span translate="atheer.userManagement.messages.email.maxLength">This field cannot be longer than 50 characters.</span></div></div><div ng-messages="vm.profileForm.email.$error" md-auto-hide="false" ng-show="vm.profileForm.email.$touched"><div ng-message when="email"><span translate="atheer.userManagement.messages.email.invalid">E-mail is invalid.</span></div></div></md-input-container><md-input-container class="md-block"><label for="password" translate="atheer.userManagement.password">Password</label><div class="password-field"><div class="input-field"><input id="password" label="password" name="password" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-model="vm.user.password" ng-maxlength="50" required ng-keyup="vm.checkPassword()"><div ng-messages="vm.profileForm.password.$error" md-auto-hide="false" ng-show="vm.profileForm.password.$touched"><div ng-message when="required"><span translate="atheer.userManagement.messages.password.required">Please enter a password.</span></div></div><div ng-messages="vm.profileForm.password.$error" md-auto-hide="false" ng-show="vm.profileForm.password.$touched"><div ng-message when="maxlength"><span translate="atheer.userManagement.messages.password.maxLength">This field cannot be longer than 50 characters.</span></div></div><div ng-messages="vm.profileForm.password.$error" md-auto-hide="false" ng-show="vm.profileForm.password.$touched"><div ng-message when="passwordPolicyErr"><span translate="atheer.userManagement.messages.password.policy">Password must contain 8-12 characters, must include one uppercase, one lowercase, one special case character and one number.</span></div></div></div><div class="cursor-pointer"><img src="./assets/images/app/show_password.svg" ng-if="vm.showPassword" ng-click="vm.showPassword = !vm.showPassword"> <img src="./assets/images/app/hide_password.svg" ng-if="!vm.showPassword" ng-click="vm.showPassword = !vm.showPassword"></div></div></md-input-container><md-input-container class="md-block"><label for="confirm_password" translate="atheer.userManagement.confirmPassword">Confirm Password</label><div class="password-field"><div class="input-field"><input id="confirm_password" label="password" name="confirm_password" ng-attr-type="{{ vm.showConfirmPassword ? \'text\' : \'password\' }}" ng-model="vm.confirm_password" ng-maxlength="50" required ng-keyup="vm.checkPassword()"><div ng-messages="vm.profileForm.confirm_password.$error" md-auto-hide="false"><div ng-message when="required"><span translate="atheer.userManagement.messages.confirmPassword.required">Please confirm password.</span></div></div><div ng-messages="vm.profileForm.confirm_password.$error" md-auto-hide="false" ng-show="vm.profileForm.confirm_password.$touched"><div ng-message when="passwordNoMatchErr"><span translate="atheer.userManagement.messages.confirmPassword.dontMatch">Passwords do not match</span></div></div><div ng-messages="vm.profileForm.confirm_password.$error" md-auto-hide="false" ng-show="vm.profileForm.confirm_password.$touched"><div ng-message when="maxlength"><span translate="atheer.userManagement.messages.confirmPassword.maxLength">This field cannot be longer than 50 characters.</span></div></div></div><div class="cursor-pointer"><img src="./assets/images/app/show_password.svg" ng-if="vm.showConfirmPassword" ng-click="vm.showConfirmPassword = !vm.showConfirmPassword"> <img src="./assets/images/app/hide_password.svg" ng-if="!vm.showConfirmPassword" ng-click="vm.showConfirmPassword = !vm.showConfirmPassword"></div></div></md-input-container><div layout="row" layout-align="space-between center"><span flex translate="atheer.userManagement.sendNotification">Send Notification</span><md-switch name="notify_user" ng-model="vm.user.notify_user" ng-change="vm.forcePasswordToggle()" aria-label="Notify User"></md-switch></div><div ng-if="vm.featureForcedPassword" layout="row" layout-align="space-between center"><span flex translate="atheer.userManagement.forcedPasswordChangeOnInitialUserLogin">Force password change on initial user login</span><md-switch name="forced_password_enabled" ng-model="vm.user.forced_password_enabled" ng-disabled="vm.user.notify_user" aria-label="Notify User"></md-switch></div></div></form></div><div flex layout="row" layout-align="center" layout-padding class="margin-top-100 margin-bottom-100" ng-if="vm.isSavingError"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon></div><div layout="row" layout-align="center"><span class="md-headline">{{vm.errorMessage}}</span></div></div></div></md-dialog-content><md-dialog-actions layout="row" ng-if="!vm.isSavingError"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="vm.profileForm.$invalid || vm.isSaving || vm.isSavingError" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions><md-dialog-actions layout="row" ng-if="vm.isSavingError"><span flex></span><md-button class="md-primary md-raised" ng-click="vm.clear()" translate="entity.action.close">Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/user/user-detail-menu.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" flex layout="column" layout-fill><div class="toolbar-default md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ng-if="vm.isAdminMode" ng-click="vm.goToUsers()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h3 hide-xs flex><span translate="atheer.userDetail.menuTitle" translate-values="{userFirstName: \'{{vm.user.first_name}}\'}">{{vm.user.first_name}}\'s Profile</span></h3></div></div><div flex layout="column" class="margin-top-10 fp-page-sidemenu" flex-xs="100" class="md-whiteframe-z1" ng-style="{\'overflow\': \'scroll\'}"><div ng-repeat="setting in vm.settings"><md-button ui-sref="{{setting.state}}" ng-click="vm.activeLink = setting.state" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == setting.state}"><span ng-class="vm.activeLink == setting.state ? \'md-body-2\' : \'md-body-1\'" translate>{{setting.label}}</span></md-button><md-divider></md-divider></div><div ng-if="vm.isAdminMode" ng-repeat="profileEvent in vm.profileEvents"><div ng-if="profileEvent.enabled"><md-button ui-sref="storm.profile.event({eventName: \'{{profileEvent.name}}\', eventMeta: \'{{profileEvent}}\'})" ng-if="!profileEvent.locked" ng-click="vm.activeLink = profileEvent.name" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == profileEvent.name}"><span ng-class="vm.activeLink == setting.state ? \'md-body-2\' : \'md-body-1\'">{{profileEvent.label}}</span></md-button><md-divider ng-if="!profileEvent.locked"></md-divider></div></div></div></div>');
$templateCache.put('modules/user/user-detail-summary.tmpl.html','<md-card layout="row" layout-xs="column"><div flex layout="column" layout-align="center center" class="padding-30"><div class="fp-profile-image-container" ng-mouseenter="image.showEditProfileImage = true;" ng-mouseleave="image.showEditProfileImage = false;"><img ng-src="{{vm.getUserProfileImageUrl()}}" alt="girl-avatar" class="make-round" width="100" height="100"><div class="fp-profile-image-edit-overlay" layout-align="center center" layout="row" ng-style="image.showEditProfileImage ? { \'top\':\'0\' } : {\'top\' : \'100%\'}"><fp-upload fp-content-type="picture" fp-ng-model="vm.user.picture_id" fp-multiple="true" fp-upload-icon-class="zmdi zmdi-edit icon-size" fp-add-model-fn="vm.updateUserProfileImage(mediaId, responseObj)" fp-pattern="image/*" fp-max-size="2000000" fp-upload-type="basic" fp-enable-preview="false" fp-all-button-color-class=""></fp-upload><md-button ng-if="vm.user.picture_id && vm.user.picture_id != null" ng-click="vm.removeUserProfileImage()" class="md-icon-button" aria-label="primary button"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></div></div><div><h3 class="font-weight-600 margin-bottom-0">{{::vm.user.first_name}} {{::vm.user.last_name}}</h3><!--\n                <p class="font-weight-300 margin-top-0 margin-bottom-0">Store Asso., Walnut Creek, CA</p>\n                <p class="margin-top-0">213-265-0785</p>\n                --></div></div></md-card>');
$templateCache.put('modules/user/user-detail-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div ng-if="vm.isAdminMode" class="md-toolbar-tools md-accent"><span flex>{{::vm.user.first_name}} {{::vm.user.last_name}}\'s Profile</span></div><div ng-if="!vm.isAdminMode" class="md-toolbar-tools md-accent"><span flex>My Profile</span><div></div></div></md-toolbar>');
$templateCache.put('modules/user/user-detail.tmpl.html','<div flex ui-view></div>');
$templateCache.put('modules/user/user-menu.tmpl.html','<fp-team-builder flex layout="column"></fp-team-builder>');
$templateCache.put('modules/user/user-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate>{{vm.allowMultiSelect ? \'autoComplete.userPicker.selectUsers\' : \'autoComplete.userPicker.selectUser\'}}</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container class="search-input-theme" ng-style="{ \'color\': secondaryColor }" ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button layout-align="center center" ng-if="vm.users.length > 0" class="md-raised select-button" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedUsers.length <= 0" translate="entity.action.select">Select</md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content ng-if="vm.loadingData" class="md-dialog-content"><div flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div></md-dialog-content><md-dialog-content ng-if="!vm.loadingData" class="md-dialog-content"><div ng-if="vm.users.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><div class="md-padding" ng-if="vm.users.length > 0"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedUsers" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th md-column><span translate="autoComplete.userPicker.table.userAvatar">User Avatar</span></th><th md-column md-order-by="first_name" ng-click="vm.changeSort(\'first_name\')"><span translate="autoComplete.userPicker.table.firstName">First Name</span></th><th md-column md-order-by="last_name" ng-click="vm.changeSort(\'last_name\')"><span translate="autoComplete.userPicker.table.lastName">Last Name</span></th><th md-column md-order-by="email" ng-click="vm.changeSort(\'email\')"><span translate="autoComplete.userPicker.table.email">Email</span></th></tr></thead><tbody md-body><tr ng-repeat="user in vm.users track by user.id" md-row md-select="user" md-select-id="id" md-auto-select><td md-cell><fp-avatar user="user" presence="true" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="35"></fp-avatar></td><td md-cell>{{user.first_name}}</td><td md-cell>{{user.last_name}}</td><td md-cell>{{user.email}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/user/user-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div ng-if="vm.selectedUsers.length == 0" class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="atheer.userManagement.home.title">Users</span></h2><span flex></span><div ng-if="vm.selectedTeam.audience_no == 1000"><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.refreshAll()" placeholder="{{\'atheer.userManagement.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userManagement.search">Search</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userManagement.cancel">Cancel</span></fp-tooltip></md-button></div><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userManagement.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-accent md-raised" ng-if="isMasterWorkspace" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><md-button class="md-accent md-raised" permission permission-only="vm.permissions.create" ng-if="!vm.showNewUserMenu && !vm.isPickerView && !isMasterWorkspace" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><md-menu md-offset="0 60" permission permission-only="vm.permissions.create" ng-if="vm.showNewUserMenu && !isMasterWorkspace"><md-button class="md-accent md-raised" ng-click="$mdMenu.open()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.create"><md-button ng-click="$mdCloseMenu;vm.createObject()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><span translate="entity.action.createNew">Create New</span></md-button></md-menu-item><md-menu-item permission permission-only="atheer_features.user.invitation"><md-button permission permission-only="vm.permissions.invite" aria-label="primary button" ui-sref="storm.admin-user-invitation"><md-icon md-font-icon="fa fa-send-o"></md-icon><span translate="entity.action.invite">Invite</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.import"><md-button ng-click="$mdCloseMenu;" aria-label="primary button" ui-sref="storm.admin-users-import"><md-icon md-font-icon="zmdi zmdi-upload"></md-icon><span translate="entity.action.upload">Upload</span></md-button></md-menu-item></md-menu-content></md-menu><div permission permission-only="atheer_features.user.extended_fields"><md-button permission permission-only="vm.permissions.user_field" class="md-icon-button" aria-label="primary button" ui-sref="storm.admin-user-fields"><md-icon md-font-icon="zmdi zmdi-settings"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userManagement.userFields">User Fields</span></fp-tooltip></md-button></div><fp-help></fp-help></div><div ng-if="vm.selectedUsers.length > 0" class="md-toolbar-tools md-accent fp-admin-toolbar"><h2><span translate="atheer.userManagement.usersSelected" translate-values="{selectedUsersLength: \'{{ vm.selectedUsers.length }}\'}">{{vm.selectedUsers.length}} users selected</span></h2><md-button class="md-icon-button" ng-click="vm.clearSelection()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userManagement.clearSelection">Clear Selection</span></fp-tooltip></md-button><span flex></span><md-button class="md-raised md-accent" aria-label="primary button" ng-click="vm.openCreateDialog()"><span translate="atheer.userManagement.addToTeam">Add to Team</span></md-button><md-button class="md-raised md-accent" permission permission-only="vm.permissions.team" ng-if="vm.selectedTeam != null && vm.selectedTeam.type == \'STATIC\' && vm.selectedTeam.locked == false" aria-label="primary button" ng-click="vm.removeUsersFromList()"><span translate="atheer.userManagement.removeFromTeam">Remove fromt Team</span></md-button><md-button class="md-raised md-accent" permission permission-only="vm.permissions.delete" aria-label="primary button" ng-click="vm.removeBulkUsers()"><span translate="entity.action.delete">Delete</span></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/user/users.tmpl.html','<div flex layout="column"><div ng-if="vm.loadingData" flex layout="column" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.users.length == 0 && vm.selectedTeam == null" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><div ng-if="!vm.loadingData && vm.users.length == 0 && vm.selectedTeam != null" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content ng-if="!vm.loadingData" class="md-padding"><md-table-container ng-if="vm.users.length > 0"><table multiple="true" md-row-select="vm.teamEnabled && !isMasterWorkspace" ng-model="vm.selectedUsers" md-table class="md-primary md-data-table users-container" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder" ng-if="vm.selectedTeam == null || vm.selectedTeam.audience_no == 1000 || vm.selectedTeam.type !== \'STATIC\'"><tr md-row><th md-column md-order-by="user_no"><span translate="atheer.userManagement.userNo">User No.</span></th><th md-column md-order-by="first_name"><span translate="atheer.userManagement.firstName">First Name</span></th><th md-column md-order-by="last_name"><span translate="atheer.userManagement.lastName">Last Name</span></th><th md-column md-order-by="login"><span translate="atheer.userManagement.login">Login</span></th><th md-column md-order-by="email"><span translate="atheer.userManagement.email">Email</span></th><th></th></tr></thead><thead md-head ng-if="vm.selectedTeam !== null && vm.selectedTeam.audience_no !== 1000 && vm.selectedTeam.type == \'STATIC\'"><tr md-row><th md-column><span translate="atheer.userManagement.userNo">User No.</span></th><th md-column><span translate="atheer.userManagement.firstName">First Name</span></th><th md-column><span translate="atheer.userManagement.lastName">Last Name</span></th><th md-column><span translate="atheer.userManagement.login">Login</span></th><th md-column><span translate="atheer.userManagement.email">Email</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="user in vm.users track by user.id" md-row md-select="user" md-select-id="id"><td md-cell><div layout="row"><fp-avatar user="user" presence="false" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" width="35"></fp-avatar><span class="fp-user-list-user-no">{{user.user_no}}</span></div></td><td md-cell>{{user.first_name}}</td><td md-cell>{{user.last_name}}</td><td md-cell>{{user.login}}</td><td md-cell>{{user.email}}</td><td class="text-right" ng-if="vm.selectedUsers.length <= 0"><div class="btn-group"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ui-sref="storm.profile.overview({id: \'{{user.id}}\'})"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(user)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content></div><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.users.length > 0"></md-table-pagination>');
$templateCache.put('modules/workspace/workspace-account.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div class="animate-wrapper" flex layout="column"><div flex layout="column" ui-view layout-align="center center"></div></div></div>');
$templateCache.put('modules/workspace/workspace-detail-adv-insights.tmpl.html','<div flex layout="column" layout-fill><div class="md-toolbar-tools md-accent margin-bottom-0 md-whiteframe-z1"><div ng-if="!vm.loadingData" class="md-toolbar-tools md-accent"><h2 hide-xs><span>{{vm.workspace.workspace_no}} - {{vm.workspace.name}}</span></h2><div flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="primary-theme"><md-tab ui-sref="storm.admin-workspace-detail.info({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.features({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Features</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.insights.dashboard({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Insights</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.adv-insights({id: \'{{vm.workspace.id}}\'})" md-active="true"><md-tab-label><span>Advanced Insights</span></md-tab-label></md-tab></md-tabs></div><fp-help></fp-help></div></div><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="margin-top-10 fp-content-detail-form" layout="row" layout-fill flex><md-content flex layout="row" layout-align="start center"><div flex layout="column" layout-align="center center"><div layout="column" layout-align="center center" class="margin-bottom-40"><span class="md-title">Create dashboards and visualizations in the Atheer Studio</span> <span class="md-title">by using drag and drop and without touching any code.</span></div><div layout="row" flex="80" layout-align="center center"><video height="360" autoplay="" muted="" playsinline="" loop="" preload="none"><source src="https://www.gooddata.com/videos/pages/embedded-analytics/lowcodenocode.mp4" type="video/mp4">Your browser does not support the video tag.</video></div><div ng-if="vm.currentStep == \'default\'" layout="row" layout-align="center" class="margin-top-40"><md-button class="md-primary md-raised" ng-click="vm.save()">Activate Advanced Insights</md-button></div><div ng-if="vm.currentStep == \'provisioning\'" flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-padding layout-align="center" class="margin-top-40" layout-align="center"><div layout="row" layout-align="center"><md-progress-circular class="md-hue-2" md-mode="indeterminate"></md-progress-circular></div><div layout="row" layout-align="center" class="margin-top-40"><span class="md-subhead">Provisioning Advanced Insights. Please wait ...</span></div></div></div><div ng-if="vm.currentStep == \'provisioned\'" layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-subhead">Advanced Insights provisioned. Please login to workspace and create dashboards</span></div></div></div></md-content></div></div>');
$templateCache.put('modules/workspace/workspace-detail-dialog.tmpl.html','<md-dialog aria-label="User Detail" flex="50" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><h2>Create new workspace</h2><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.close()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><div ng-if="!vm.isSaving && !vm.successSave && !vm.errorSaving" ng-form="editForm"><md-input-container class="md-block"><label class="md-required" translate="atheer.workspace.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.workspace.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspace.description" for="field_description">Description</label> <textarea name="description" id="field_description" ng-model="vm.workspace.description" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.workspace.subDomain" for="field_subDomain">SubDomain</label> <input type="text" ng-pattern="/^[a-z]*$/" class="form-control" name="subDomain" id="field_subDomain" ng-model="vm.workspace.sub_domain" required><div ng-messages="editForm.subDomain.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="pattern"><span>Only (a-z) characters are allowed.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">First Name</label> <input type="text" class="form-control" name="admin_fname" id="field_admin_fname" ng-model="vm.workspace.admin_fname" required><div ng-messages="editForm.admin_fname.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">Last Name</label> <input type="text" class="form-control" name="admin_fname" id="field_admin_lname" ng-model="vm.workspace.admin_lname" required><div ng-messages="editForm.admin_lname.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">E-Mail</label> <input type="email" class="form-control" name="admin_email" id="field_admin_email" ng-model="vm.workspace.admin_email" required><div ng-messages="editForm.admin_email.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">Password</label><div class="password-container"><input type="{{ vm.passwordVisible ? \'text\' : \'password\' }}" class="form-control" name="admin_password" id="field_admin_password" ng-model="vm.workspace.admin_password" required> <button type="button" class="eye-icon" ng-click="vm.togglePasswordVisibility()"><md-icon class="{{ vm.passwordVisible ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div><div ng-messages="editForm.admin_password.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">Website URL</label> <input type="url" class="form-control" name="website_url" id="field_website_url" ng-model="vm.workspace.website_url" required><div ng-messages="editForm.website_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.workspace.emailDomain" for="field_emailDomain">EmailDomain</label> <input type="text" class="form-control" name="emailDomain" id="field_emailDomain" ng-model="vm.workspace.email_domain" required><div ng-messages="editForm.emailDomain.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspace.status" for="field_status">Status</label><md-select name="status" ng-model="vm.workspace.status" id="field_status" required><md-option value="ACTIVE" translate="atheer.WorkspaceStatus.ACTIVE">ACTIVE</md-option><md-option value="INACTIVE" translate="atheer.WorkspaceStatus.INACTIVE">INACTIVE</md-option></md-select><div ng-messages="editForm.status.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout="row"><span flex>Start Date</span><md-datepicker md-max-date="vm.workspace.end_date" id="field_startDate" name="startDate" ng-model="vm.workspace.start_date" md-placeholder="Select date" required></md-datepicker><div ng-messages="editForm.startDate.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></div><div layout="row"><span flex>End Date</span><md-datepicker md-min-date="vm.workspace.start_date" id="field_endDate" name="endDate" ng-model="vm.workspace.end_date" md-placeholder="Select date"></md-datepicker></div></div><div flex layout="row" layout-align="center" layout-padding ng-if="vm.isSaving" class="margin-top-100 margin-bottom-100"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline">Provisioning Workspace. Hang in there.</span></div><div layout="row" layout-align="center" class="margin-top-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div><div flex layout="row" layout-align="center" layout-padding ng-if="vm.successSave" class="margin-top-100 margin-bottom-100"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon></div><div layout="row" layout-align="center"><span class="md-headline">Provisioning Complete.</span></div></div></div><div flex layout="row" layout-align="center" layout-padding ng-if="vm.errorSaving" class="margin-top-100 margin-bottom-100"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon></div><div layout="row" layout-align="center" ng-if="vm.duplicateDomainError == \'\' || vm.duplicateDomainError == undefined"><span class="md-headline">Error Provisioning Workspace. Please contact engineering.</span></div><div layout="row" layout-align="center" ng-if="vm.duplicateDomainError != \'\'"><span class="md-headline">{{vm.duplicateDomainError}}</span></div></div></div></md-dialog-content><md-dialog-actions layout="row" ng-if="!vm.isSaving && !vm.successSave && !vm.errorSaving"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid" class="md-primary" ng-click="vm.save()">Create</md-button></md-dialog-actions><md-dialog-actions layout="row" ng-if="!vm.isSaving && vm.successSave && !vm.errorSaving"><span flex></span><md-button class="md-primary md-raised" ng-click="vm.checkDetail()">See Details</md-button></md-dialog-actions><md-dialog-actions layout="row" ng-if="!vm.isSaving && !vm.successSave && vm.errorSaving"><span flex></span><md-button class="md-primary md-raised" ng-click="vm.close()">Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/workspace/workspace-detail-features.tmpl.html','<div flex layout="column" layout-fill><div class="md-toolbar-tools md-accent margin-bottom-0 md-whiteframe-z1"><div ng-if="!vm.loadingData" class="md-toolbar-tools md-accent"><h2 hide-xs><span>{{vm.workspace.workspace_no}} - {{vm.workspace.name}}</span></h2><div flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="primary-theme"><md-tab ui-sref="storm.admin-workspace-detail.info({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.features({id: \'{{vm.workspace.id}}\'})" md-active="true"><md-tab-label><span>Features</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.insights.dashboard({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Insights</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.adv-insights({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Advanced Insights</span></md-tab-label></md-tab></md-tabs></div><md-button type="submit" class="md-primary md-raised" ng-disabled="companyInfoForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></div><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="margin-top-10 fp-content-detail-form" layout="row" layout-fill flex><md-content layout="column" flex class="padding-top-20" layout-padding><md-content flex layout="column" ng-if="!vm.loadingData"><ang-accordion icon-position="right" close-icon-class="fa fa-chevron-right" open-icon-class="fa fa-chevron-down"><collapsible-item ng-repeat="(key, value) in vm.features track by $index" item-title="{{value.label}}" initially-open="true"><div layout="row" flex="100" ng-repeat="subFeature in value.settings"><div flex="80" layout="column" layout-align="center start">{{subFeature.label}}</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="subFeature.value"></md-switch></div></div></collapsible-item></ang-accordion></md-content></md-content></div></div>');
$templateCache.put('modules/workspace/workspace-detail-info.tmpl.html','<div flex layout="column" layout-fill><div class="md-toolbar-tools md-accent margin-bottom-0 md-whiteframe-z1"><div ng-if="!vm.loadingData" class="md-toolbar-tools md-accent"><h2 hide-xs><span>{{vm.workspace.workspace_no}} - {{vm.workspace.name}}</span></h2><div flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="primary-theme"><md-tab ui-sref="storm.admin-workspace-detail.info({id: \'{{vm.workspace.id}}\'})" md-active="true"><md-tab-label><span>Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.features({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Features</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.insights.dashboard({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Insights</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.adv-insights({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Advanced Insights</span></md-tab-label></md-tab></md-tabs></div><md-button type="submit" class="md-primary md-raised" ng-disabled="companyInfoForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></div><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="margin-top-10 fp-content-detail-form" layout="row" layout-fill flex><md-content layout="column" flex class="padding-top-20" layout-padding><div layout="row" layout-align="center center"><div flex="50" layout="column" ng-form="editForm"><div><input type="hidden" id="id" name="id" ng-model="vm.workspace.id" readonly="readonly"></div><md-input-container class="md-block"><label class="md-required" translate="atheer.workspace.workspaceNo" for="field_workspaceNo">WorkspaceNo</label> <input type="number" class="form-control" name="workspaceNo" id="field_workspaceNo" ng-model="vm.workspace.workspace_no" required ng-disabled="true"><div ng-messages="editForm.workspaceNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.workspace.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.workspace.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspace.description" for="field_description">Description</label> <textarea name="description" id="field_description" ng-model="vm.workspace.description" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.workspace.subDomain" for="field_subDomain">SubDomain</label> <input type="text" class="form-control" name="subDomain" id="field_subDomain" ng-model="vm.workspace.sub_domain" required><div ng-messages="editForm.subDomain.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">First Name</label> <input type="text" class="form-control" name="admin_fname" id="field_admin_fname" ng-model="vm.workspace.admin_fname" required><div ng-messages="editForm.admin_fname.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">Last Name</label> <input type="text" class="form-control" name="admin_fname" id="field_admin_lname" ng-model="vm.workspace.admin_lname" required><div ng-messages="editForm.admin_lname.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">E-Mail</label> <input type="email" class="form-control" name="admin_email" id="field_admin_email" ng-model="vm.workspace.admin_email" required><div ng-messages="editForm.admin_email.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required">Website URL</label> <input type="url" class="form-control" name="website_url" id="field_website_url" ng-model="vm.workspace.website_url" required><div ng-messages="editForm.website_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.workspace.emailDomain" for="field_emailDomain">EmailDomain</label> <input type="text" class="form-control" name="emailDomain" id="field_emailDomain" ng-model="vm.workspace.email_domain" required><div ng-messages="editForm.emailDomain.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspace.status" for="field_status">Status</label><md-select name="status" ng-model="vm.workspace.status" id="field_status" required><md-option value="ACTIVE" translate="atheer.WorkspaceStatus.ACTIVE">ACTIVE</md-option><md-option value="INACTIVE" translate="atheer.WorkspaceStatus.INACTIVE">INACTIVE</md-option></md-select><div ng-messages="editForm.status.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout="row"><span flex>Start Date</span><md-datepicker md-max-date="vm.workspace.end_date" id="field_startDate" name="startDate" ng-model="vm.workspace.start_date" md-placeholder="Select date" required></md-datepicker><div ng-messages="editForm.startDate.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></div><div layout="row"><span flex>End Date</span><md-datepicker md-min-date="vm.workspace.start_date" id="field_endDate" name="endDate" ng-model="vm.workspace.end_date" md-placeholder="Select date"></md-datepicker></div></div></div></md-content></div></div>');
$templateCache.put('modules/workspace/workspace-detail-insights-toolbar.tmpl.html','<div flex class="margin-bottom-10 fp-content-detail-form" layout="column" layout-fill><div class="md-toolbar-tools md-accent margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><h2 hide-xs><span>{{vm.workspace.workspace_no}} - {{vm.workspace.name}}</span></h2><div ng-if="!vm.loadingData" flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="primary-theme" md-selected="3"><md-tab ui-sref="storm.admin-workspace-detail.info({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.features({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Features</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.insights.dashboard({id: \'{{vm.workspace.id}}\'})" md-active="true"><md-tab-label><span>Insights</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-workspace-detail.adv-insights({id: \'{{vm.workspace.id}}\'})"><md-tab-label><span>Advanced Insights</span></md-tab-label></md-tab></md-tabs></div><fp-help></fp-help></div></div></div>');
$templateCache.put('modules/workspace/workspace-detail-insights.tmpl.html','<div layout="row" layout-fill flex ui-view></div>');
$templateCache.put('modules/workspace/workspace-detail-toolbar.tmpl.html','<div class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div ng-if="!vm.loadingData" class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToTopics()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.workspace.workspace_no}} - {{vm.workspace.name}}</span></h2><div flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="white-theme"><md-tab ui-sref="storm.admin-workspace-detail.info({id: \'{{vm.workspace.id}}\'})" md-active="true"><md-tab-label><span>Settings</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-recognition.section({id: \'{{vm.topicDataModel.id}}\', section : \'qr_code\'})"><md-tab-label><span translate="atheer.topic.recognition">Recognition</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-topic-detail-insights.section({id: \'{{vm.topicDataModel.id}}\', section : \'overview\'})"><md-tab-label><span translate="atheer.topic.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div layout="row"><md-button type="submit" class="md-primary md-raised" ng-disabled="topicDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><md-button class="md-icon-button" ng-click="vm.copyTopic()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.topic.copy">Copy</span></fp-tooltip></md-button><fp-help></fp-help></div></div></div>');
$templateCache.put('modules/workspace/workspace-detail.tmpl.html','<div flex ui-view></div>');
$templateCache.put('modules/workspace/workspace-menu.tmpl.html','<div class="toolbar-default md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span>Workspaces</span></h2><span flex></span></div></div><div flex layout="column" class="margin-top-10 fp-page-sidemenu" flex-xs="100" class="md-whiteframe-z1"></div>');
$templateCache.put('modules/workspace/workspace-setup-company.tmpl.html','<div layout="row" flex layout-padding layout-fill layout-align="center center"><div layout="column" flex="45" flex-lg="45" flex-md="65" flex-xs="100"><md-card layout="column"><md-toolbar class="padding-20"><div layout="row" layout-align="center center" class="margin-20"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}" height="50"></div></md-toolbar><div class="md-padding"><div layout="row" layout-align="center center"><h1 class="md-headline">Tell us about your team</h1></div><form name="form" role="form" novalidate show-validation class="margin-top-40"><md-input-container class="md-block"><label class="control-label" for="email">Company Name</label> <input type="text" class="form-control" id="company-name" name="company-name" placeholder="Company, Inc" ng-model="vm.workspace.company_name" required><div ng-messages="form.company-name.$error"><div ng-message when="required"><span>Your Company name is required.</span></div></div></md-input-container><md-input-container class="md-block margin-bottom-40"><label>What kind of company is it?</label><md-select ng-model="vm.workspace.company_type" placeholder="What kind of company is it?"><md-option value="consumer">Consumer Goods</md-option><md-option value="financial">Financial Services</md-option><md-option value="government">Goverment</md-option><md-option value="healthcare">Healthcare/Pharmaceutical</md-option><md-option value="media">Media</md-option><md-option value="retail">Retail</md-option><md-option value="technology">Technology</md-option><md-option value="other">Other</md-option></md-select></md-input-container><md-input-container class="md-block margin-bottom-40"><label>How big is the company?</label><md-select ng-model="vm.workspace.company_size" placeholder="Select company size"><md-option value="1-10">1-10 employees</md-option><md-option value="11-50">11-50 employees</md-option><md-option value="51-100">51-100 employees</md-option><md-option value="101-250">101-250 employees</md-option><md-option value="251-500">251-500 employees</md-option><md-option value="501-1000">501-1000 employees</md-option><md-option value="1001-4000">1001-4000 employees</md-option><md-option value="4000-more">4000 or more employees</md-option></md-select></md-input-container><md-input-container class="md-block margin-bottom-40"><label>What\'s your role there?</label><md-select ng-model="vm.workspace.user_role" placeholder="Select your role"><md-option value="administrative">Administrative/Facilities</md-option><md-option value="accounting">Accounting/Finance</md-option><md-option value="business-development">Business Development</md-option><md-option value="business-owner">Business Owner</md-option><md-option value="cusomer-support">Customer Suppport</md-option><md-option value="design">Design</md-option><md-option value="engineering">Engineering</md-option><md-option value="sales">Sales</md-option><md-option value="marketing">Marketing</md-option><md-option value="media">Media/Communications</md-option><md-option value="operations">Operations</md-option><md-option value="project-management">Project Management</md-option><md-option value="product-management">Product Management</md-option><md-option value="field-operations">Field Operations</md-option><md-option value="other">Other</md-option></md-select></md-input-container><div layout="row" layout-align="center center" class="margin-40"><md-button class="md-raised md-primary" ng-click="vm.next()" ng-disabled="form.$invalid">Continue to workspace Name &rarr;</md-button></div></form></div></md-card></div></div>');
$templateCache.put('modules/workspace/workspace-setup-url.tmpl.html','<div layout="row" flex layout-padding layout-fill layout-align="center center"><div layout="column" flex="45" flex-lg="45" flex-md="65" flex-xs="100"><md-card layout="column"><md-toolbar class="padding-20"><div layout="row" layout-align="center center" class="margin-20"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}" height="50"></div></md-toolbar><div ng-if="vm.activating" layout="column" layout-padding layout-align="center" class="margin-top-40 margin-bottom-60"><div layout="row" layout-align="center"><span class="md-subhead">Gathering More information about this URL. Soon you will be able to configure.</span></div><div layout="row" layout-align="center" class="margin-top-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div><div ng-if="!vm.activating" class="padding-60"><div layout="row" layout-align="center center"><div class="md-headline">What Name do you want for your Atheer workspace?</div></div><form name="form" role="form" novalidate show-validation class="margin-top-40"><div layout="row" layout-align="center center"><span class="md-subhead">This is where you will access your new account. Make sure to bookmark it once you\u2019re inside.</span></div><div flex layout="row" class="margin-top-40"><md-input-container class="md-block" flex="75"><label class="control-label" for="email">Your workspace name</label> <input type="text" class="form-control" id="team-name" name="team-name" ng-model="vm.workspace.name" ng-model-options="{debounce: 500}" ng-change="vm.checkIsDomainAvailable(vm.workspace.name)" required><div ng-messages="form.team-name.$error"><div ng-message when="required"><span>Your Workspace name is required.</span></div></div></md-input-container><md-input-container class="md-block" flex><span class="md-subhead">.{{vm.domain}}</span></md-input-container><md-icon class="zmdi zmdi-check-circle workspace-green-font" ng-if="vm.isDomainAvailable && vm.workspace.name.length > 0 && !vm.isCheckingDomainAvailability"></md-icon><md-icon class="zmdi zmdi-close-circle workspace-red-font" ng-if="!vm.isDomainAvailable && vm.workspace.name.length > 0 && !vm.isCheckingDomainAvailability"></md-icon></div><div flex layout="column" ng-if="!vm.isDomainAvailable && vm.workspace.name.length > 0 && !vm.isCheckingDomainAvailability"><span class="md-subhead"><i>{{vm.workspace.name}}.{{vm.domain}} is already taken, how about...</i></span><div ng-repeat="suggestion in vm.workspaceInfo.suggestions"><span class="sub-domain-suggestion">{{suggestion}}</span> <span class="md-subhead">.{{vm.domain}}</span></div></div><div flex layout="row" layout-align="center center" class="margin-top-20 margin-bottom-20"><span class="md-subhead">By creating a Atheer workspace, you agree to the <a href="https://www.atheer.ai/legal/user-terms-of-service" class="md-cyan-theme">Terms of Use</a> and <a href="https://www.atheer.ai/legal/privacy-policy" class="md-cyan-theme">Privacy Policy</a>.</span></div><div flex layout="row" layout-align="center center"><md-button class="md-raised md-primary" ng-click="vm.activate()" ng-disabled="!vm.isDomainAvailable">Create Workspace</md-button></div></form></div></md-card></div></div>');
$templateCache.put('modules/workspace/workspace-setup-user-info.tmpl.html','<div layout="row" flex layout-padding layout-fill layout-align="center center"><div layout="column" flex="45" flex-lg="45" flex-md="65" flex-xs="100"><md-card layout="column"><md-toolbar class="padding-20"><div layout="row" layout-align="center center" class="margin-20"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}" height="50"></div></md-toolbar><div class="md-padding"><div layout="row" layout-align="center center"><h1 class="md-headline">Tell us about you</h1></div><form name="form" role="form" novalidate show-validation class="margin-top-40"><div layout="row" flex><md-input-container flex="50" class="md-block"><label class="control-label" for="first-name">First Name</label> <input type="text" class="form-control" id="first-name" name="first-name" placeholder="e.g Hikaru" ng-model="vm.user.first_name" required><div ng-messages="form.first-name.$error"><div ng-message when="required"><span>Your First name is required.</span></div></div></md-input-container><md-input-container flex="50" class="md-block"><label class="control-label" for="last-name">Last Name</label> <input type="text" class="form-control" id="full-name" name="last-name" placeholder="e.g Sulu" ng-model="vm.user.last_name" required><div ng-messages="form.last-name.$error"><div ng-message when="required"><span>Your Last name is required.</span></div></div></md-input-container></div><md-input-container class="md-block"><label class="control-label" for="password">Password</label> <input type="password" class="form-control" id="password" name="password" ng-model="vm.user.password" ng-minlength="5" ng-maxlength="50" required><fp-password-strength fp-password-value="vm.user.password" strength="passStrength"><div ng-messages="form.password.$error"><div ng-message when="required" ng-show="form.password.$error.required"><span>Your password is required.</span></div><div ng-message when="minlength" ng-show="form.password.$error.minlength"><span>Your password is required to be at least 5 characters.</span></div><div ng-message when="maxlength" ng-show="form.password.$error.maxlength"><span>Your password cannot be longer than 50 characters.</span></div></div></md-input-container><div layout="row" layout-align="center center" class="margin-40"><md-button class="md-raised md-primary" ng-click="vm.next()" ng-disabled="form.$invalid">Continue to workspace &rarr;</md-button></div></form></div></md-card></div></div>');
$templateCache.put('modules/workspace/workspace-signup-confirm.tmpl.html','<div layout="row" flex layout-padding layout-fill layout-align="center center"><div flex="40" flex-lg="40" flex-md="65" flex-xs="100"><md-card><md-toolbar class="padding-20"><div layout="row" layout-align="center center" class="margin-20"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}" height="50"></div></md-toolbar><md-content class="md-padding"><div layout="row" layout-align="center center" class="margin-top-20 margin-bottom-20"><span class="md-title">Check your email</span></div><div layout="row" layout-align="center center"><img src="assets/images/app/placeholder-email.png" height="50"></div><div layout="row" layout-align="center center" class="margin-top-40 margin-bottom-40"><span class="md-subhead">We&#39;ve sent a six-digit confirmation code to <strong>{{vm.workspace.email}}</strong>. It will expire shortly, so enter your code soon.</span></div><div layout="row" layout-align="center center" class="margin-bottom-20"><label><span class="md-body-2">Your confirmation code</span></label></div><div layout="row" layout-align="center center" class="confirm_input"><div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.confirmCode1" class="inline_input" maxlength="1" ng-change="vm.checkConfirmationCode(1)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.confirmCode2" class="inline_input" maxlength="1" ng-change="vm.checkConfirmationCode(2)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.confirmCode3" class="inline_input" maxlength="1" ng-change="vm.checkConfirmationCode(3)"></div></div><div class="confirmation_code_span_cell">&#45;</div><div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.confirmCode4" class="inline_input" maxlength="1" ng-change="vm.checkConfirmationCode(4)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.confirmCode5" class="inline_input" maxlength="1" ng-change="vm.checkConfirmationCode(5)"></div><div class="confirm_input_item input_wrapper"><input type="text" ng-model="vm.confirmCode6" class="inline_input" maxlength="1" ng-change="vm.checkConfirmationCode(6)"></div></div></div><div ng-if="vm.firstTime && !vm.checkingCode"><div layout="row" layout-align="center center" class="margin-top-40 margin-bottom-40"><span class="md-body-1">Keep this window open while checking for your code.</span></div><div layout="row" layout-align="center center" class="margin-top-40 margin-bottom-40"><span class="md-body-1">If you can&#39;t see an email from us in your inbox, check your junk mail or spam folder. If it was sent to the wrong email address, click the back button and enter your correct email address.</span></div></div><div ng-if="vm.checkingCode" layout="row" layout-align="center" class="margin-top-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div><div ng-if="vm.checkingCode" layout="row" layout-align="center center" class="margin-bottom-60"><span class="md-title">Checking your confirmation code.</span></div><div ng-if="!vm.firstTime && !vm.validCode && !vm.checkingCode" layout="row" layout-align="center center" class="margin-top-40"><md-icon md-colors="{color:\'warn\'}" md-font-icon="zmdi zmdi-alert-circle-o" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\'}"></md-icon></div><div ng-if="!vm.firstTime && !vm.validCode && !vm.checkingCode" layout="row" layout-align="center center" class="margin-bottom-60"><span md-colors="{color:\'warn\'}" class="md-title">The code wasn&#39;t valid. Give it another go!</span></div></md-content></md-card></div></div>');
$templateCache.put('modules/workspace/workspace-signup.tmpl.html','<div layout="row" flex layout-padding layout-fill layout-align="center center"><div layout="column" flex="45" flex-lg="45" flex-md="65" flex-xs="100"><md-card layout="column"><md-toolbar class="padding-20"><div layout="row" layout-align="center center" class="margin-20"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}" height="50"></div></md-toolbar><div class="md-padding"><div layout="row" layout-align="center center"><h1 class="md-headline">Let\'s get you up and running on Atheer</h1></div><form name="form" role="form" novalidate show-validation class="margin-top-40"><md-input-container class="md-block"><label class="control-label" for="email">Your work e-mail address</label> <input type="email" class="form-control" id="email" name="email" placeholder="work@mailaddress.com" ng-model="vm.workspace.email" ng-minlength="5" ng-maxlength="100" required><div ng-messages="form.email.$error"><div ng-message when="required"><span>Your e-mail is required.</span></div><div ng-message when="email" ng-show="form.email.$error.email"><span>Your e-mail is invalid.</span></div><div ng-message when="minlength" ng-show="form.email.$error.minlength"><span>Your e-mail is required to be at least 5 characters.</span></div><div ng-message when="maxlength" ng-show="form.email.$error.maxlength"><span>Your e-mail cannot be longer than 100 characters.</span></div></div></md-input-container><div layout="row" layout-align="center center"><span class="md-subhead">By creating a Atheer account, you agree to the <a href="https://www.atheer.ai/legal/user-terms-of-service" class="md-cyan-theme">Terms of Use</a> and <a href="https://www.atheer.ai/legal/privacy-policy" class="md-cyan-theme">Privacy Policy</a>.</span></div><div layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-raised md-primary" ng-click="vm.signup()" ng-disabled="form.$invalid">Next &rarr;</md-button></div></form></div></md-card></div></div>');
$templateCache.put('modules/workspace/workspaces.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="enter search" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom">Filter</fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Cancel</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">Refresh</fp-tooltip></md-button><md-button permission permission-only="vm.permissions.create" class="md-icon-button" ng-if="!vm.createMenu && !vm.isPickerView" ng-click="vm.createObject()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom">Add New</fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="!vm.loadingData && vm.workspaces.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column><span translate="atheer.workspace.workspaceNo">Workspace No</span></th><th md-column><span translate="atheer.workspace.name">Name</span></th><th md-column><span translate="atheer.workspace.subDomain">SubDomain</span></th><th md-column><span translate="atheer.workspace.emailDomain">EmailDomain</span></th><th md-column><span translate="atheer.workspace.enabled">Enabled</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="workspace in vm.workspaces | filter: { name: \'!master\' } track by workspace.id"><td md-cell>{{workspace.workspace_no}}</td><td md-cell>{{workspace.name}}</td><td md-cell>{{workspace.sub_domain}}</td><td md-cell>{{workspace.email_domain}}</td><td md-cell>{{workspace.status == \'ACTIVE\' ? true : false}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(workspace.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-button class="md-icon-button" aria-label="warn button" ng-click="vm.deleteObject(workspace)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/insights/insight-dashboard-detail-toolbar.tmpl.html','<div ng-if="!vm.loadingData" class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToDashboards()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 ng-if="!vm.isNew()" hide-xs><span>{{vm.getDataModel().name}}</span></h2><h2 ng-if="vm.isNew()" hide-xs><span><label class="md-required" translate="atheer.insights.dashboard.createLabel">Create Dashboard</label></span></h2><div ng-if="!vm.loadingData" flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="white-theme"></md-tabs></div><div layout="row"><md-button type="submit" class="md-primary md-raised" ng-if="!vm.isLaunchMode() && vm.isFormValid()" ng-disabled="dashboardDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></div></div></div>');
$templateCache.put('modules/insights/insight-dashboard-detail.tmpl.html','<ng-include src="\'modules/insights/insight-dashboard-detail-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="margin-top-10 fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="35" flex-xl="25" class="md-whiteframe-z1"><md-content flex class="padded-content-page content-properties-container"><form flex name="dashboardDetailForm" novalidate><div ng-form="dashboardDetailForm"><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.insights.dashboard.number" for="field_dashboardNo">Dashboard Number</label> <input type="number" class="form-control" name="dashboard_no" id="field_dashboardNo" ng-model="vm.getDataModel().dashboard_no" required ng-disabled="true"><div ng-messages="dashboardDetailForm.topicNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.insights.dashboard.name">Dashboard Name</label> <input type="text" name="name" ng-model="vm.getDataModel().name" md-select-on-focus required><div ng-messages="dashboardDetailForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.insights.dashboard.description">Description</label> <textarea name="description" ng-model="vm.dashboardDataModel.description" id="field_description" md-no-resize md-maxlength="255" rows="3"></textarea><div ng-messages="dashboardDetailForm.description.$error" ng-if="dashboardDetailForm.description.$dirty"><div ng-message="md-maxlength" when="md-maxlength"><span translate="entity.validation.maxlength" translate-values="{max: 255}">This field cannot be longer than 255 characters.</span></div></div></md-input-container><div layout="row" layout-align="space-between center"><span translate="atheer.insights.dashboard.enabled">Enabled</span><md-switch name="enabled" ng-model="vm.dashboardDataModel.enabled"></md-switch></div><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-clock-o"></md-icon><span flex translate="atheer.insights.dashboard.scheduling">Scheduling</span><md-button ng-click="vm.show_scheduling = !vm.show_scheduling" class="md-icon-button"><md-icon ng-if="!vm.show_scheduling" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_scheduling" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.show_scheduling" class="margin-bottom-20"><div layout="row" layout-align="space-between center"><span translate="atheer.insights.dashboard.availableFrom">Available From</span><md-datepicker md-max-date="vm.dashboardDataModel.discontinue_from" ng-model="vm.dashboardDataModel.available_from" md-placeholder="Select date"></md-datepicker></div><div layout="row" layout-align="space-between center"><span translate="atheer.insights.dashboard.discontinueFrom">Discontinue From</span><md-datepicker md-min-date="vm.dashboardDataModel.available_from" ng-model="vm.dashboardDataModel.discontinue_from" md-placeholder="Select date"></md-datepicker></div></div><md-divider></md-divider><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-group"></md-icon><span flex class="md-body-2" translate="atheer.insights.dashboard.visibleTo">Visible To</span><md-button ng-click="vm.show_audiences = !vm.show_audiences" class="md-icon-button"><md-icon ng-if="!vm.show_audiences" md-font-icon="zmdi zmdi-chevron-right"></md-icon><md-icon ng-if="vm.show_audiences" md-font-icon="zmdi zmdi-chevron-down"></md-icon></md-button></div><div ng-if="vm.show_audiences" class="margin-bottom-20"><fp-auto-complete no-label="true" auto-complete-model="vm.audiences" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div></div></form></md-content></div><div flex layout="column"><div layout="row"><div flex="50"><md-tabs class="padding-left-10"><md-tab ng-if="!vm.isNew()" ng-click="vm.tabView = \'insights\'" md-active="vm.tabView == \'insights\'"><md-tab-label><span translate="atheer.insights.dashboard.insights">Insights</span></md-tab-label></md-tab></md-tabs></div><div class="md-toolbar-tools md-accent"><span flex></span><md-button ng-if="!vm.isNew() && vm.tabView == \'insights\' && !vm.isSystem()" class="md-icon-button" ng-click="vm.openInsightPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.insights.dashboard.addInsights">Add Insights</span></fp-tooltip></md-button></div></div><div layout="center center" flex layout-padding><div layout="column" flex ng-if="!vm.isNew() && vm.tabView == \'insights\'"><md-table-container ng-if="vm.insights.length > 0 && !vm.loadingInsights" layout="row"><table md-table class="md-primary md-data-table"><tbody md-body><tr ng-repeat="insight in vm.insights track by insight.id"><td md-cell>{{insight.name}}</td><td md-cel class="text-right"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeInsight(insight.id, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.insights.dashboard.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div></div></div></div></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/insights/insight-picker.html','<md-dialog flex="90" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="autoComplete.insightPicker.title">Select Insights</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container class="search-input-theme" ng-style="{ \'color\': secondaryColor }" ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button layout-align="center center" class="md-raised select-button" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedCards.length <= 0" translate="entity.action.select" ng-if="vm.contents.length > 0">Select</md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content ng-if="vm.loadingData" flex class="md-dialog-content margin-top-100 margin-bottom-100"><wave-spinner></wave-spinner></md-dialog-content><md-dialog-content ng-if="!vm.loadingData" class="md-dialog-content" flex><div flex layout="row"><div ng-if="vm.contents.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="autoComplete.uh">Uh!</div><div class="margin-top-10 base">{{\'autoComplete.insightPicker.noInsights\' | translate}}</div></div><div class="md-padding" flex ng-if="vm.contents.length > 0" class="md-whiteframe-z1"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedCards" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="title"><span translate="autoComplete.insightPicker.table.title">Title</span></th><th md-column><span translate="autoComplete.insightPicker.table.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="content in vm.contents track by content.id" md-row md-select="content.id" md-select-id="id" md-auto-select><td md-cell>{{content.name}}</td><td md-cell am-time-ago="content.created_on"></td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/insights/insights-airform.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin ng-repeat="row in vm.dashboardModel"><tri-widget content-layout="column" content-layout-align="space-between center" content-padding ng-repeat="column in row.columns"><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(column.name)" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate>{{column.title}}</p></tri-widget></div></div>');
$templateCache.put('modules/insights/insights-analyze.tmpl.html','<div id="adv-insights-analyze" flex layout="row" layout-fill layout-align="center start"><div flex="100" layout="row" layout-fill class="padded-content-page"><div flex layout="column" layout-fill><div layout="row" flex="100" layout-fill flex="100"><!-- iframe id="insight-analyze-frame" ng-src="http://localhost:3000/dashboards/embedded/#/workspace/ath-insight-master/new-dashboard?apiTokenAuthentication=true" height="100%" width="100%" noresize frameborder="0" /--><iframe id="insight-analyze-frame" ng-src="{{vm.ngxUrlTrusted}}" height="100%" width="100%" noresize="noresize" frameborder="0"></div></div></div></div>');
$templateCache.put('modules/insights/insights-content.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'total_content\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.content.totalNoCount">Total No. Content</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'featured\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.content.totalFeatured">Total Featured</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0">{{vm.getCount(\'avg_time_spent\')| milisecondToTime}}</p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.content.avgTimeSpent">Avg. Time Spent</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'view\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.content.totalViews">Total Views</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'reaction\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.content.totalLikes">Total Likes</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'bookmark\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.content.totalBookMarked">Total Bookmarked</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.getCount(\'share\')" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.content.totalShared">Total Shared</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.contentTypeBarChartData.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.content.contentType">Content Type</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.contentTypeBarChartData.series[0].data.length > 0"><highchart id="content-type-bar-chart" option="vm.contentTypeBarChartData.chart" config="vm.contentTypeBarChartData" series="vm.contentTypeBarChartData.series"></highchart></md-card></div><div layout="row" layout-margin><md-card class="fp-insights-no-data-card" flex layout-padding ng-if="vm.contentViewsChartData.series[0].data.length <= 0 "><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.content.views">Views</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.contentViewsChartData.series[0].data.length > 0"><highchart id="content-views-line-chart" option="vm.contentViewsChartData.chart" config="vm.contentViewsChartData" series="vm.contentViewsChartData.series"></highchart></md-card></div><div layout="row" layout-margin><md-card class="fp-insights-no-data-card" flex layout-padding ng-if="vm.contentTimeSpentChartData.series[0].data.length <= 2 "><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.content.timeSpent">Time Spent</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.contentTimeSpentChartData.series[0].data.length > 2"><highchart id="content-views-line-chart" option="vm.contentTimeSpentChartData.chart" config="vm.contentTimeSpentChartData" series="vm.contentTimeSpentChartData.series"></highchart></md-card></div><div layout="row" layout-margin><md-card class="fp-insights-no-data-card" flex layout-padding ng-if="vm.contentCreatedChartData.series[0].data.length <= 2 "><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.content.contentCreated">Content Created</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.contentCreatedChartData.series[0].data.length > 2"><highchart id="content-views-line-chart" option="vm.contentCreatedChartData.chart" config="vm.contentCreatedChartData" series="vm.contentCreatedChartData.series"></highchart></md-card></div></div>');
$templateCache.put('modules/insights/insights-conversation.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_conversations" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.totalConversations">Total Conversations</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_messages" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.totalMessages">Total Messages</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.archived_conversations" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.archievedConversations">Archived Conversations</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_1_to_1_conversations" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.totalOnetoOneConversations">Total One to One Conversations</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_group_conversations" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.totalGroupConversations">Total Group Conversations</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_audience_conversations" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.totalTeamConversations">Total Teams Conversations</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_session_conversations" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.totalSessionConversations">Total AiRSession Conversations</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0">{{vm.dashboardModel.avg_messages_per_conversation}}</p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.conversations.avgMessagesPerConversation">Avg Messages per Conversation</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topUsersByConversationCount.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.conversations.topUsersByConversationCount">Top Users by Conversation Count</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topUsersByConversationCount.series[0].data.length > 0"><highchart id="top-user-session-count-type-bar-chart" option="vm.topUsersByConversationCount.chart" config="vm.topUsersByConversationCount" series="vm.topUsersByConversationCount.series"></highchart></md-card><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topUsersByMessageCount.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.conversations.topUsersByMessagCount">Top Users by Message Count</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topUsersByMessageCount.series[0].data.length > 0"><highchart id="top-user-session-duration-type-bar-chart" option="vm.topUsersByMessageCount.chart" config="vm.topUsersByMessageCount" series="vm.topUsersByMessageCount.series"></highchart></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.messageUsageByDay.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.conversations.airSessionsByUsageCount">AiRSession Usage by Count</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.messageUsageByDay.series[0].data.length > 0"><highchart id="usage-session-count" option="vm.messageUsageByDay.chart" config="vm.messageUsageByDay" series="vm.messageUsageByDay.series"></highchart></md-card></div></div>');
$templateCache.put('modules/insights/insights-dashboard-detail-dialog.html','<md-dialog aria-label="User Detail" flex="50" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><h2 id="myUserLabel">{{vm.dynamicTitle | translate}}</h2><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><div ng-if="!vm.isSavingError"><form name="vm.dashboardForm" role="form" novalidate ng-submit="vm.save()" show-validation><div><md-input-container class="md-block"><label for="name" translate="atheer.userManagement.firstName">Name</label> <input id="name" type="text" class="form-control" name="name" ng-model="vm.dashboard.name" required ng-maxlength="50"><div ng-messages="vm.dashboardForm.name.$error" md-auto-hide="false" ng-show="vm.dashboardForm.first_name.$touched"><div ng-message when="required"><span translate="atheer.userManagement.messages.firstName.required">Please enter your first name.</span></div></div><div ng-messages="vm.dashboardForm.name.$error" md-auto-hide="false" ng-show="vm.dashboardForm.first_name.$touched"><div ng-message when="maxlength"><span translate="atheer.userManagement.messages.firstName.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container></div></form></div></md-dialog-content><md-dialog-actions layout="row" ng-if="!vm.isSavingError"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" class="md-primary md-raised" ng-disabled="vm.dashboardForm.$invalid || vm.isSaving || vm.isSavingError" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions><md-dialog-actions layout="row" ng-if="vm.isSavingError"><span flex></span><md-button class="md-primary md-raised" ng-click="vm.clear()" translate="entity.action.close">Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/insights/insights-dashboard-view.tmpl.html','<div id="adv-insights-page" flex layout="row" layout-fill layout-align="center start"><!-- <div flex="100" layout="row" layout-fill class="padded-content-page"> --><div flex layout="column" layout-fill><!-- <div layout="row" flex="100" layout-fill flex="100"> --><iframe id="insight-view-frame" ng-src="{{vm.ngxUrlTrusted}}" height="100%" width="100%" frameborder="0" style="overflow:hidden"><!-- </div> --></div><!-- </div> --></div>');
$templateCache.put('modules/insights/insights-dashboards-menu.tmpl.html','<div flex layout="column" layout-fill><div flex layout="column" class="fp-folder-builder"><div layout="column" layout-padding class="margin-top-10"><div layout="column"><span class="md-body-1 margin-top-20 margin-bottom-10" translate="atheer.insights.dashboard.filters.label">Filter By</span><md-checkbox ng-if="vm.advInsightsDashboardEnabled" ng-model="vm.filters.system" aria-label="Featured" ng-change="vm.updateFilters()"><span translate="atheer.insights.dashboard.filters.system">System</span></md-checkbox><md-checkbox ng-if="vm.advInsightsDashboardEnabled" ng-model="vm.filters.createdByMe" aria-label="Disabled" ng-change="vm.updateFilters()" permission permission-only="vm.permissions.create"><span translate="atheer.insights.dashboard.filters.createdByMe">Created by me</span></md-checkbox><md-checkbox ng-model="vm.filters.enabled" aria-label="Disabled" ng-change="vm.updateFilters()" permission permission-only="vm.permissions.update"><span translate="atheer.insights.dashboard.filters.enabled">Enabled dashboards</span></md-checkbox></div></div></div></div>');
$templateCache.put('modules/insights/insights-dashboards-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2><span translate="atheer.insights.dashboards">Dashboard</span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.searchText" ng-change="vm.refreshAll()" placeholder="{{\'atheer.insights.dashboard.enterSearchPlaceholder\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.insights.dashboard.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.insights.dashboard.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.refreshAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.insights.dashboard.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-accent md-raised" ng-if="vm.advInsightsDashboardEnabled()" ng-click="vm.createDashboard()" aria-label="primary button" permission permission-only="vm.permissions.create"><span translate="entity.action.new">New</span></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/insights/insights-dashboards.tmpl.html','<div flex layout="row" layout-fill><div flex layout="column"><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="row"><div ng-if="!vm.loadingData && vm.dashboards.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-table-container flex ng-if="!vm.loadingData && vm.dashboards.length > 0" class="fp-dashboard-list"><table md-table class="md-primary md-data-table dashboards-table-container" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="audience_no"><span translate="atheer.insights.dashboard.number">Dashboard No</span></th><th md-column md-order-by="name"><span translate="atheer.insights.dashboard.name">Name</span></th><th md-column md-order-by="created_by"><span translate="atheer.insights.dashboard.createdBy">Created By</span></th><th md-column md-order-by="created_on"><span translate="atheer.insights.dashboard.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="dashboard in vm.dashboards track by dashboard.id" class="fp-dashboard-list"><td md-cell>{{dashboard.dashboard_no}}</td><td md-cell>{{dashboard.name}}</td><td md-cell>{{dashboard.created_by}}</td><td md-cell>{{dashboard.created_on | date:\'MM/dd/yyyy\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.manage" class="md-icon-button" aria-label="primary button" ng-disabled="!vm.canLaunchDashboard(dashboard)" ng-click="vm.launchDashboard(dashboard, \'view\')"><md-icon class="zmdi zmdi-chart icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.update"><md-button aria-label="primary button" ng-click="vm.editObject(dashboard.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><span translate="entity.action.edit">Edit</span></md-button></md-menu-item><md-menu-item permission-only="vm.permissions.update" ng-if="!vm.isLegacyDashboard(dashboard)" ng-click="vm.launchDashboard(dashboard, \'edit\')"><md-button aria-label="primary button" ng-click="vm.Object(dashboard)"><md-icon class="zmdi zmdi-view-dashboard icon-size"></md-icon><span translate="atheer.insights.dashboard.builder">Builder</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(dashboard)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.dashboards.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></div>');
$templateCache.put('modules/insights/insights-data.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div></div>');
$templateCache.put('modules/insights/insights-detail-toolbar.tmpl.html','<div ng-if="!vm.loadingData" class="toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToTopics()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs><span>{{vm.dashboardDataModel.name}}</span></h2><div ng-if="!vm.loadingData" flex><md-tabs ng-if="!vm.isNew()" md-center-tabs md-theme="white-theme"></md-tabs></div><div layout="row"><md-button type="submit" class="md-primary md-raised" ng-disabled="dashboardDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></div></div>');
$templateCache.put('modules/insights/insights-menu.tmpl.html','<div flex layout="column" layout-fill><div flex layout="column" class="margin-top-10 fp-page-sidemenu" flex-xs="100" class="md-whiteframe-z1"><md-button ui-sref="storm.insights.workspace-summary" ng-click="vm.activeLink = \'storm.insights.workspace-summary\'" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == \'storm.insights.workspace-summary\'}"><span ng-class="vm.activeLink == \'storm.insights.workspace-summary\' ? \'md-body-2\' : \'md-body-1\'">Workspace Summary</span></md-button><md-divider></md-divider><md-button ui-sref="storm.insights.conversations" ng-click="vm.activeLink = \'storm.insights.conversations\'" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == \'storm.insights.conversations\'}"><span ng-class="vm.activeLink == \'storm.insights.conversations\' ? \'md-body-2\' : \'md-body-1\'">Conversations</span></md-button><md-divider></md-divider><md-button ui-sref="storm.insights.sessions" ng-click="vm.activeLink = \'storm.insights.sessions\'" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == \'storm.insights.sessions\'}"><span ng-class="vm.activeLink == \'storm.insights.sessions\' ? \'md-body-2\' : \'md-body-1\'">AiRSessions</span></md-button><md-divider></md-divider><md-button ui-sref="storm.insights.contents" ng-click="vm.activeLink = \'storm.insights.contents\'" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == \'storm.insights.contents\'}"><span ng-class="vm.activeLink == \'storm.insights.contents\' ? \'md-body-2\' : \'md-body-1\'">Content</span></md-button><md-divider></md-divider><md-button ui-sref="storm.insights.topics" ng-click="vm.activeLink = \'storm.insights.topics\'" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == \'storm.insights.topics\'}"><span ng-class="vm.activeLink == \'storm.insights.topics\' ? \'md-body-2\' : \'md-body-1\'">Topics</span></md-button><md-divider></md-divider><md-button ui-sref="storm.insights.airforms" ng-click="vm.activeLink = \'storm.insights.airforms\'" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == \'storm.insights.airforms\'}"><span ng-class="vm.activeLink == \'storm.insights.airforms\' ? \'md-body-2\' : \'md-body-1\'">AiRForms</span></md-button><md-divider></md-divider><md-button ui-sref="storm.insights.users" ng-click="vm.activeLink = \'storm.insights.users\'" class="side-menu-link" ng-class="{ \'md-primary\': vm.activeLink == \'storm.insights.users\'}"><span ng-class="vm.activeLink == \'storm.insights.users\' ? \'md-body-2\' : \'md-body-1\'">Users</span></md-button><md-divider></md-divider><md-divider></md-divider></div></div>');
$templateCache.put('modules/insights/insights-metrics.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div></div>');
$templateCache.put('modules/insights/insights-session-toolbar.tmpl.html','<md-toolbar ng-if="layout.showToolbar" class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="atheer.insights.title">Insights</span><span> - </span><span translate="{{layout.pageTitle}}"></span></h2><span flex></span><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.emailSessionSummaryReport()"><md-icon class="fa fa-download icon-size"></md-icon><fp-tooltip placement="bottom">Export AiRSession Summary</fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/insights/insights-session.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_sessions" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.totalAirSessions">Total AiRSessions</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_minutes" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.totalMinutes">Total Minutes</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0">{{vm.dashboardModel.avg_duration.toFixed(2)}}</p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.avgDuration">Avg. Duration(min)</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding class="fp-rating-summary"><div fp-rating read-only="true" rating="vm.dashboardModel.avg_rating" color="\'orange\'" shape-type="star" max-rating="5"></div><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.avgRating">Avg. Rating</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_participants" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.totalParticipantsWithGuestCount" translate-values="{guestCount: \'{{vm.dashboardModel.total_guest_participants}}\'}">Total Participants({{vm.dashboardModel.total_guest_participants}} guests)</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_recordings" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.totalRecordings">Total Recordings</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_annotations" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.totalAnnotations">Total Annotations</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.avg_participants" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.airSessions.avgParticipants">Avg. Participants</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topUsersBySessionCount.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.airSessions.topUsersAirSessionCount">Top Users by AiRSession Count</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topUsersBySessionCount.series[0].data.length > 0"><highchart id="top-user-session-count-type-bar-chart" option="vm.topUsersBySessionCount.chart" config="vm.topUsersBySessionCount" series="vm.topUsersBySessionCount.series"></highchart></md-card><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topUsersBySessionDuration.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.airSessions.topUsersByDuration">Top Users by AiRSession Duration</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topUsersBySessionDuration.series[0].data.length > 0"><highchart id="top-user-session-duration-type-bar-chart" option="vm.topUsersBySessionDuration.chart" config="vm.topUsersBySessionDuration" series="vm.topUsersBySessionDuration.series"></highchart></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.usageBySessionCount.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.airSessions.sessionUsageByCount">AiRSession Usage by Count</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.usageBySessionCount.series[0].data.length > 0"><highchart id="usage-session-count" option="vm.usageBySessionCount.chart" config="vm.usageBySessionCount" series="vm.usageBySessionCount.series"></highchart></md-card><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.usageBySessionDuration.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.airSessions.sessionUsageByMinutes">AiRSession Usage by Minutes</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.usageBySessionDuration.series[0].data.length > 0"><highchart id="usage-session-duration" option="vm.usageBySessionDuration.chart" config="vm.usageBySessionDuration" series="vm.usageBySessionDuration.series"></highchart></md-card></div></div>');
$templateCache.put('modules/insights/insights-summary.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div permission permission-only="atheer_features.conversation.enable" layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools fp-admin-toolbar padding-bottom-10" md-colors="{background: \'green-500\', color: \'white\'}"><md-icon md-font-icon="fa fa-comments margin-right-10"></md-icon><h2 flex><span translate="atheer.insights.conversations.title">Conversations</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_conversations}}</span> <span class="md-body-1" translate="atheer.insights.conversations.totalConversations">Total Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_messages}}</span> <span class="md-body-1" translate="atheer.insights.conversations.totalMessages">Total Messages</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.archived_conversations}}</span> <span class="md-body-1" translate="atheer.insights.conversations.archievedConversations">Archived Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.conversations_summary.avg_messages_per_conversation}}</span> <span class="md-body-1" translate="atheer.insights.conversations.averageMessages">Avg. Message/Conversation</span></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_1_to_1_conversations}}</span> <span class="md-body-1" translate="atheer.insights.conversations.totalOneConversations">Total 1:1 Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_group_conversations}}</span> <span class="md-body-1" translate="atheer.insights.conversations.totalGroupConversations">Total Group Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_session_conversations}}</span> <span class="md-body-1" translate="atheer.insights.conversations.totalSessionConversations">Total AiRSession Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_audience_conversations}}</span> <span class="md-body-1" translate="atheer.insights.conversations.totalTeamConversations">Total Team Conversations</span></div></div></md-card></div><div permission permission-only="atheer_features.airsession.enable" layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'orange-400\', color: \'white\'}"><md-icon md-font-icon="fa zmdi zmdi-comment-video margin-right-10"></md-icon><h2 flex><span translate="atheer.insights.airSessions.title">AiRSessions</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_sessions}}</span> <span class="md-body-1" translate="atheer.insights.airSessions.totalAirSessions">Total AiRSessions</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_minutes}}</span> <span class="md-body-1" translate="atheer.insights.airSessions.totalMinutes">Total Minutes</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.avg_duration.toFixed(2)}}</span> <span class="md-body-1" translate="atheer.insights.airSessions.avgDuration">Avg. Duration(min)</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><div fp-rating read-only="true" rating="vm.dashboard.sessions_summary.avg_rating" color="\'orange\'" shape-type="star" max-rating="5"></div><p class="md-body-1" translate="atheer.insights.airSessions.avgRating">Avg. Rating</p></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_recordings}}</span> <span class="md-body-1" translate="atheer.insights.airSessions.totalRecordings">Total Recordings</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_screen_shares}}</span> <span class="md-body-1" translate="atheer.insights.airSessions.totalScreenShares">Total Screenshares</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_annotations}}</span> <span class="md-body-1" translate="atheer.insights.airSessions.totalAnnotations">Total Annotations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.sessions_summary.avg_participants}}</span> <span class="md-body-1" translate="atheer.insights.airSessions.avgParticipants">Avg. Participants</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'deep-purple-400\', color: \'white\'}"><md-icon md-font-icon="zmdi zmdi-library margin-right-10"></md-icon><h2 flex><span translate="atheer.insights.content.title">Content</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'total_content\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.insights.content.totalContent">Total Content</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'featured\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.insights.content.totalFeatured">Total Featured</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.getCount(\'avg_time_spent\')| milisecondToTime}}</span> <span class="md-body-1" translate="atheer.insights.content.avgTimeSpent">Avg. Time Spent</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2" countupto="vm.getCount(\'view\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.insights.content.totalViews">Total Views</span></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'bookmark\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.insights.content.totalBookMarks">Total Bookmarks</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'share\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.insights.content.totalShares">Total Shares</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'reaction\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.insights.content.totalLikes">Total Likes</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2" countupto="vm.getCount(\'archived\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.insights.content.totalArchieved">Total Archived</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'light-blue-400\', color: \'white\'}"><md-icon md-font-icon="flp ath-smart-content margin-right-10"></md-icon><h2 flex><span translate="atheer.insights.airForms.title">AiRForms</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.airforms_summary.total_active_airforms}}</span> <span class="md-body-1" translate="atheer.insights.airForms.totalActiveAirForms">Total Active AiRForms</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.airforms_summary.total_scheduled_airforms}}</span> <span class="md-body-1" translate="atheer.insights.airForms.totalScheduledAirForms">Total Scheduled Airforms</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.airforms_summary.total_jobs_completed_in_last_30_days}}</span> <span class="md-body-1" translate="atheer.insights.airForms.totalJobsCompleted">Total Jobs completed in last 30 days</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.airforms_summary.total_jobs_in_progress}}</span> <span class="md-body-1" translate="atheer.insights.airForms.totalJobsInProgress">Total Jobs in progress</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'grey-400\', color: \'white\'}"><md-icon md-font-icon="zmdi zmdi-device-hub margin-right-10"></md-icon><h2 flex><span translate="atheer.insights.smartFlows.title">SmartFlows</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_smartflows}}</span> <span class="md-body-1" translate="atheer.insights.smartFlows.totalSmartFlows">Total SmartFlows</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_executions}}</span> <span class="md-body-1" translate="atheer.insights.smartFlows.totalExecutions">Total Executions</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_active}}</span> <span class="md-body-1" translate="atheer.insights.smartFlows.totalActive">Total Active</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_draft}}</span> <span class="md-body-1" translate="atheer.insights.smartFlows.totalDraft">Total Draft</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'blue-grey-400\', color: \'white\'}"><md-icon md-font-icon="zmdi zmdi-accounts-list margin-right-10"></md-icon><h2 flex><span translate="atheer.insights.users.title">Users</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_users}}</span> <span class="md-body-1" translate="atheer.insights.users.totalUsers">Total Users</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_logins}}</span> <span class="md-body-1" translate="atheer.insights.users.totalLogins">Total Logins</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_active_users}}</span> <span class="md-body-1" translate="atheer.insights.users.totalActiveUsers">Total Active Users</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.users_summary.total_inactive_users}}</span> <span class="md-body-1" translate="atheer.insights.users.totalInactiveUsers">Total Inactive Users</span></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_guest_users}}</span> <span class="md-body-1" translate="atheer.insights.users.totalGuestUsers">Total Guest Users</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_audiences}}</span> <span class="md-body-1" translate="atheer.insights.users.totalTeam">Total Teams</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_static_audiences}}</span> <span class="md-body-1" translate="atheer.insights.users.totalFixedTeam">Total Fixed Teams</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.users_summary.total_dynamic_audiences}}</span> <span class="md-body-1" translate="atheer.insights.users.totalDynamicTeam">Total Dynamic Teams</span></div></div></md-card></div></div>');
$templateCache.put('modules/insights/insights-toolbar.tmpl.html','<md-toolbar ng-if="layout.showToolbar" class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ng-click="vm.goToDashboards()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="atheer.insights.title">Insights</span><span> - </span><span translate="{{layout.pageTitle}}"></span></h2><span flex></span><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/insights/insights-topic.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_topic" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.topics.totalTopics">Total Topics</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_enable" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.topics.totalEnabled">Total Enabled</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_scans" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.topics.totalScans">Total Scans</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topTopicByScanCount.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.topics.topTopicByScanCount"></span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topTopicByScanCount.series[0].data.length > 0"><highchart id="top-user-session-count-type-bar-chart" option="vm.topTopicByScanCount.chart" config="vm.topTopicByScanCount" series="vm.topTopicByScanCount.series"></highchart></md-card><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topUsersByScanCount.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.topics.topUsersByScan"></span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topUsersByScanCount.series[0].data.length > 0"><highchart id="top-user-session-duration-type-bar-chart" option="vm.topUsersByScanCount.chart" config="vm.topUsersByScanCount" series="vm.topUsersByScanCount.series"></highchart></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topicScansByDay.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.topics.scansPerDay"></span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topicScansByDay.series[0].data.length > 0"><highchart id="usage-session-count" option="vm.topicScansByDay.chart" config="vm.topicScansByDay" series="vm.topicScansByDay.series"></highchart></md-card></div></div>');
$templateCache.put('modules/insights/insights-user.tmpl.html','<div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_users" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalUsers">Total Users</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_logins" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalLogins">Total Logins</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_active_users" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalActiveUsers">Total Active Users</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_inactive_users" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalInactiveUsers">Total Inactive Users</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_guest_users" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalGuestUsers">Total Guest Users</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_audiences" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalTeam">Total Teams</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0" countupto="vm.dashboardModel.total_static_audiences" duration="1.5" decimals="0"></p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalFixedTeam">Total Fixed Teams</p></tri-widget><tri-widget content-layout="column" content-layout-align="space-between center" content-padding><p class="md-display-2 font-weight-200 margin-top-10 margin-bottom-0">{{vm.dashboardModel.total_dynamic_audiences}}</p><p class="md-body-2 opacity-60 margin-top-0 margin-bottom-10" translate="atheer.insights.users.totalDynamicTeam">Total Dynamic Teams</p></tri-widget></div><div layout="row" layout-xs="column" layout-margin><md-card class="fp-insights-content-type-no-data-card" flex layout-padding ng-if="vm.topUsersByCreatedCount.series[0].data.length <= 0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 flex><span translate="atheer.insights.users.totalDynamicTeam">User Created by Count</span></h2></div><div flex layout="row" layout-align="center center"><div class="fp-profile-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div></div></md-card><md-card layout-padding flex ng-if="vm.topUsersByCreatedCount.series[0].data.length > 0"><highchart id="top-user-session-count-type-bar-chart" option="vm.topUsersByCreatedCount.chart" config="vm.topUsersByCreatedCount" series="vm.topUsersByCreatedCount.series"></highchart></md-card></div></div>');
$templateCache.put('modules/insights/insights.tmpl.html','<div flex layout-fill ui-view></div>');
$templateCache.put('core/components/accordion/accordion-expander.tmpl.html','<md-item-list class="fpAccordionExpander"><div layout="row"><md-icon md-font-icon="zmdi zmdi-more-vert" style="cursor:pointer"></md-icon><h5 flex ng-click="handleToggle();  $event.stopImmediatePropagation();" style="cursor:pointer">{{title}}</h5><md-button ng-if="showCopy()" ng-click="copy(); $event.stopImmediatePropagation()" class="md-icon-button"><fp-tooltip><span>Copy</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-copy"></md-icon></md-button><md-button ng-if="showRemove()" ng-click="remove(); $event.stopImmediatePropagation()" class="md-icon-button"><fp-tooltip><span>Remove</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-close"></md-icon></md-button></div><md-card layout-padding ng-show="isVisible" style="cursor:default"><div ng-transclude></div><div flex layout="row" layout-align="end center" ng-if="showDone()"><md-button class="md-primary" ng-click="handleToggle();  $event.stopImmediatePropagation();"><span>Done</span></md-button></div></md-card></md-item-list>,');
$templateCache.put('core/components/accordion/accordion.tmpl.html','<div class="fp-accordion-choices"><md-list dragula="accordion_items" dragula-model="accordionModel" ng-transclude></md-list><div ng-if="showAdd()" flex layout="row" layout-align="center center"><md-button class="md-primary" ng-click="add()"><span>Add New</span></md-button></div><div></div></div>');
$templateCache.put('core/components/autocomplete/autocomplete-directive.tmpl.html','<div layout="row"><div style="position:relative" flex="100" ng-if="!allowMultiSelect"><md-autocomplete ng-required="required" md-input-name="{{inputFieldName}}" flex md-items="item in querySearch(searchText)" md-no-cache="isCacheEnabled()" ng-blur="onBlur()" md-search-text="searchText" md-item-text="item.display || item.name || item.title || item.first_name + \' \' + item.last_name" md-min-length="3" md-selected-item="autoCompleteModel" md-selected-item-change="itemChanged(item)" md-floating-label="{{\'autoComplete.placeholder.\' + (component | lowercase) | translate }}"><md-item-template><span md-highlight-text="searchText" md-highlight-flags="^i">{{item.display || item.name || item.title || item.first_name + \' \' + item.last_name}}</span></md-item-template><div ng-show="errorModal.$dirty" ng-messages="errorModal.$error"><div ng-message="required"><span translate="entity.validation.required">This field is required.</span></div></div><md-not-found><span translate="autoComplete.noStatesFound" translate-values="{searchText: \'{{searchText}}\'}">No states matching "{{searchText}}" were found.</span></md-not-found></md-autocomplete><button type="button" ng-if="!isCancelDisabled()" aria-label="Clear Input" tabindex="-1" class="md-button autocomplete-clear-btn" ng-click="clear($event)" ng-if="autoCompleteModel"><md-icon md-svg-src="data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=" class="md-primary-theme-theme" aria-hidden="true"><svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><g><path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"></path></g></svg></md-icon></button></div><md-chips flex="100" ng-model="autoCompleteModel" md-autocomplete-snap="" md-transform-chip="transformChip($chip)" md-require-match="true" ng-if="allowMultiSelect"><md-autocomplete ng-required="required" md-min-length="3" md-no-cache="isCacheEnabled()" md-search-text="multiSearchText" md-items="item in querySearch(multiSearchText)" md-item-text="item.display || item.name || item.title || item.first_name + \' \' + item.last_name" placeholder="{{\'autoComplete.placeholder.\' + (component | lowercase) | translate }}"><span md-highlight-text="multiSearchText">{{item.display || item.name || item.title || item.first_name + \' \' + item.last_name}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.guest_invite_value || $chip.display || $chip.name || $chip.title || $chip.first_name + \' \' + $chip.last_name}}</strong></span></md-chip-template></md-chips><md-button class="md-icon-button margin-top-10 auto-complete-picker-button" layout-align="center center" layout="column" aria-label="primary button" ng-click="openPickerDialog()"><md-icon class="fa fa-search-plus icon-size"></md-icon></md-button></div>');
$templateCache.put('core/components/avatar/group-avatar.tmpl.html','<div style="width:{{boxSize}}; height:{{boxSize}}; border-radius:{{boxSize}}; position: relative; background-color: {{color + \'20\'}}"><svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); width: {{iconSize}}; height: {{iconSize}}"><g id="icon-group-avatar" filter="url(#filter0_d)"><path d="M2.22951 21.2295C2.22951 22.0164 1 22.0164 1 21.2295C1 18.7705 2.52459 16.6557 4.63934 15.8197C3.85246 15.1803 3.36066 14.1967 3.36066 13.0656C3.36066 11.1475 4.88525 9.57377 6.85246 9.57377C7.39344 9.57377 7.93443 9.72131 8.42623 9.96721C9.06557 9.22951 9.85246 8.59016 10.8361 8.19672C10 7.55738 9.5082 6.57377 9.5082 5.4918C9.5082 3.57377 11.082 2 13 2C14.918 2 16.4918 3.57377 16.4918 5.4918C16.4918 6.57377 15.9508 7.55738 15.1639 8.19672C16.0984 8.59016 16.9344 9.22951 17.5738 9.96721C18.0164 9.72131 18.5574 9.57377 19.1475 9.57377C21.0656 9.57377 22.6393 11.1475 22.6393 13.0656C22.6393 14.1967 22.1475 15.1803 21.3607 15.8197C23.4754 16.6557 25 18.7705 25 21.2295C25 22.0164 23.7213 22.0164 23.7213 21.2295C23.7213 18.6721 21.7049 16.6066 19.1475 16.6066C16.6393 16.6066 14.5738 18.6721 14.5738 21.2295C14.5738 22.0164 13.3443 22.0164 13.3443 21.2295C13.3443 18.7705 14.8197 16.6557 16.9836 15.8197C16.1967 15.1803 15.6557 14.1967 15.6557 13.0656C15.6557 12.1803 16 11.3443 16.5902 10.7541C15.7541 9.72131 14.4262 9.03279 13 9.03279C11.5246 9.03279 10.2459 9.72131 9.40983 10.7541C9.95082 11.3934 10.2951 12.1803 10.2951 13.0656C10.2951 14.1967 9.80328 15.1803 9.01639 15.8197C11.1311 16.6557 12.6557 18.7705 12.6557 21.2295C12.6557 22.0164 11.4262 22.0164 11.4262 21.2295C11.4262 18.6721 9.36065 16.6066 6.85246 16.6066C4.29508 16.6066 2.22951 18.6721 2.22951 21.2295ZM13 3.22951C11.7705 3.22951 10.7377 4.26229 10.7377 5.4918C10.7377 6.72131 11.7705 7.70492 13 7.70492C14.2295 7.70492 15.2131 6.72131 15.2131 5.4918C15.2131 4.26229 14.2295 3.22951 13 3.22951ZM19.1475 10.8525C17.918 10.8525 16.9344 11.8361 16.9344 13.0656C16.9344 14.3443 17.918 15.3279 19.1475 15.3279C20.377 15.3279 21.4098 14.3443 21.4098 13.0656C21.4098 11.8361 20.377 10.8525 19.1475 10.8525ZM6.85246 10.8525C5.57377 10.8525 4.59016 11.8361 4.59016 13.0656C4.59016 14.3443 5.57377 15.3279 6.85246 15.3279C8.08197 15.3279 9.06557 14.3443 9.06557 13.0656C9.06557 11.8361 8.08197 10.8525 6.85246 10.8525Z" fill="{{color}}"/></g><defs><filter id="filter0_d" x="0.573684" y="-0.426316" width="25.4211" height="25.4211" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dx="0.284211" dy="0.284211"/><feGaussianBlur stdDeviation="0.355263"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>');
$templateCache.put('core/components/color-picker/mdColorPicker.tpl.html','<div class="md-color-picker-input-container" layout="row"><div class="md-color-picker-preview md-color-picker-checkered-bg" ng-click="showColorPicker($event)" ng-if="mdColorPreview"><div class="md-color-picker-result" ng-style="{background: value}"></div></div><md-input-container flex><label><md-icon ng-if="icon">{{icon}}</md-icon>{{label}}</label> <input type="input" ng-model="value" class="md-color-picker-input" ng-mousedown="(openOnInput || !mdColorPreview) && showColorPicker($event)"></md-input-container><md-button class="md-icon-button md-color-picker-clear" ng-if="mdColorClearButton && value" ng-click="clearValue();" aria-label="Clear Color"><md-icon md-svg-icon="clear.svg"></md-icon></md-button></div>');
$templateCache.put('core/components/color-picker/mdColorPickerContainer.tpl.html','<div class="md-color-picker-container in" layout="column"><div class="md-color-picker-arrow" ng-style="{\'border-bottom-color\': color.toRgbString() }"></div><div class="md-color-picker-preview md-color-picker-checkered-bg" ng-class="{\'dark\': !color.isDark() || color.getAlpha() < .45}" flex="1" layout="column"><div class="md-color-picker-result" ng-style="{\'background\': color.toRgbString()}" flex="100" layout="column" layout-fill layout-align="center center" ng-click="focusPreviewInput( $event )"><!--<span flex  layout="column" layout-align="center center">{{value}}</span>--><div flex layout="row" layout-align="center center"><input class="md-color-picker-preview-input" type="text" ng-model="value" ng-focus="previewFocus($event);" ng-blur="previewBlur()" ng-change="changeValue()" ng-keypress="previewKeyDown($event)" layout-fill></div><div class="md-color-picker-tabs" style="width: 100%"><md-tabs md-selected="type" md-stretch-tabs="always" md-no-bar md-no-ink md-no-pagination="true"><md-tab ng-if="mdColorHex" label="Hex" ng-disabled="color.getAlpha() !== 1" md-ink-ripple="#ffffff"></md-tab><md-tab ng-if="mdColorRgb" label="RGB"></md-tab><md-tab ng-if="mdColorHsl" label="HSL"></md-tab><!--<md-tab label="HSV"></md-tab>\n\t\t\t\t\t<md-tab label="VEC"></md-tab>--></md-tabs></div></div></div><div class="md-color-picker-tabs md-color-picker-colors"><md-tabs md-stretch-tabs="always" md-align-tabs="bottom" md-selected="whichPane" md-no-pagination><md-tab ng-if="mdColorSpectrum"><md-tab-label><md-icon md-svg-icon="gradient.svg"></md-icon></md-tab-label><md-tab-body><div layout="row" layout-align="space-between" style="height: 255px"><div md-color-picker-spectrum></div><div md-color-picker-hue ng-class="{\'md-color-picker-wide\': !mdColorAlphaChannel}"></div><div md-color-picker-alpha class="md-color-picker-checkered-bg" ng-if="mdColorAlphaChannel"></div></div></md-tab-body></md-tab><md-tab ng-if="mdColorSliders"><md-tab-label><md-icon md-svg-icon="tune.svg"></md-icon></md-tab-label><md-tab-body><div layout="column" flex="100" layout-fill layout-align="space-between start center" class="md-color-picker-sliders"><div layout="row" layout-align="start center" layout-wrap flex layout-fill><div flex="10" layout layout-align="center center"><span class="md-body-1">R</span></div><md-slider flex="65" min="0" max="255" ng-model="color._r" aria-label="red" class="red-slider"></md-slider><span flex></span><div flex="20" layout layout-align="center center"><input style="width: 100%;" min="0" max="255" type="number" ng-model="color._r" aria-label="red" aria-controls="red-slider"></div></div><div layout="row" layout-align="start center" layout-wrap flex layout-fill><div flex="10" layout layout-align="center center"><span class="md-body-1">G</span></div><md-slider flex="65" min="0" max="255" ng-model="color._g" aria-label="green" class="green-slider"></md-slider><span flex></span><div flex="20" layout layout-align="center center"><input style="width: 100%;" min="0" max="255" type="number" ng-model="color._g" aria-label="green" aria-controls="green-slider"></div></div><div layout="row" layout-align="start center" layout-wrap flex layout-fill><div flex="10" layout layout-align="center center"><span class="md-body-1">B</span></div><md-slider flex="65" min="0" max="255" ng-model="color._b" aria-label="blue" class="blue-slider"></md-slider><span flex></span><div flex="20" layout layout-align="center center"><input style="width: 100%;" min="0" max="255" type="number" ng-model="color._b" aria-label="blue" aria-controls="blue-slider"></div></div><div layout="row" layout-align="start center" layout-wrap flex layout-fill ng-if="!mdColorAlphaChannel"><div flex="10" layout layout-align="center center"><span class="md-body-1">A</span></div><md-slider flex="65" min="0" max="1" step=".01" ng-model="color._a" aria-label="alpha" class="md-primary"></md-slider><span flex></span><div flex="20" layout layout-align="center center"><input style="width: 100%;" min="0" max="1" step=".01" type="number" ng-model="color._a" aria-label="alpha" aria-controls="alpha-slider"></div></div></div></md-tab-body></md-tab><md-tab ng-if="mdColorGenericPalette"><md-tab-label><md-icon md-svg-icon="view_module.svg"></md-icon></md-tab-label><md-tab-body><div layout="column" layout-align="space-between start center" flex class="md-color-picker-palette"></div></md-tab-body></md-tab><md-tab ng-if="mdColorMaterialPalette"><md-tab-label><md-icon md-svg-icon="view_headline.svg"></md-icon></md-tab-label><md-tab-body><div layout="column" layout-fill flex class="md-color-picker-material-palette"></div></md-tab-body></md-tab><md-tab ng-if="mdColorHistory"><md-tab-label><md-icon md-svg-icon="history.svg"></md-icon></md-tab-label><md-tab-body layout="row" layout-fill><div layout="column" flex layout-align="space-between start" layout-wrap layout-fill class="md-color-picker-history"><div layout="row" flex="80" layout-align="space-between start start" layout-wrap layout-fill><div flex="10" ng-repeat="historyColor in history.get() track by $index"><div ng-style="{\'background\': historyColor.toRgbString()}" ng-click="setPaletteColor($event)"></div></div></div><md-button flex-end ng-click="history.reset()" class="md-mini" aria-label="Clear History"><md-icon md-svg-icon="clear_all.svg"></md-icon></md-button></div></md-tab-body></md-tab></md-tabs></div></div>');
$templateCache.put('core/components/color-picker/mdColorPickerDialog.tpl.html','<md-dialog class="md-color-picker-dialog"><div md-color-picker-container value="value" default="{{defaultValue}}" random="{{random}}" ok="ok" md-color-alpha-channel="mdColorAlphaChannel" md-color-spectrum="mdColorSpectrum" md-color-sliders="mdColorSliders" md-color-generic-palette="mdColorGenericPalette" md-color-material-palette="mdColorMaterialPalette" md-color-history="mdColorHistory" md-color-hex="mdColorHex" md-color-rgb="mdColorRgb" md-color-hsl="mdColorHsl" md-color-default-tab="mdColorDefaultTab"></div><md-actions layout="row"><md-button class="md-mini" ng-click="close()" style="width: 50%;">Cancel</md-button><md-button class="md-mini" ng-click="ok()" style="width: 50%;">Select</md-button></md-actions></md-dialog>');
$templateCache.put('core/components/counter/counter-widget.tmpl.html','<md-card flex md-colors="::{ background: vm.background, color: vm.color }"><md-card-content layout="row" layout-align="space-between"><md-icon class="font-size-5 margin-left-10 inherit-color" md-font-icon="{{vm.icon}}"></md-icon><div layout="column"><p class="md-display-3 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis" countupto="vm.count" decimals="0" duration="0"></p><p class="md-body-2 margin-top-0 margin-bottom-0" translate>{{vm.title}}</p></div></md-card-content></md-card>');
$templateCache.put('core/components/cron/cron-widget.tmpl.html','<div><div layout="row" layout-align="space-between center"><span translate="cronWidget.repeatEvery">Repeat Every</span><md-select ng-model="myFrequency.base"><md-option ng-repeat="item in frequency" ng-value="item.value">{{item.label}}</md-option></md-select></div><div layout="row" layout-align="space-around center"><span ng-show="myFrequency.base == 4" translate="cronWidget.on">on</span><div ng-show="myFrequency.base == 4"><md-select ng-if="allowMultiple" ng-model="myFrequency.dayValues" multiple="multiple"><md-option ng-repeat="value in dayValues" ng-value="value">{{value | cronDayName: cronStyle}}</md-option></md-select><md-select ng-if="!allowMultiple" ng-model="myFrequency.dayValues"><md-option ng-repeat="value in dayValues" ng-value="value">{{value | cronDayName: cronStyle}}</md-option></md-select></div><span ng-show="myFrequency.base >= 5" translate="cronWidget.onThe">on the</span><div ng-show="myFrequency.base >= 5"><md-select ng-if="allowMultiple" ng-model="myFrequency.dayOfMonthValues" multiple="multiple"><md-option ng-repeat="value in dayOfMonthValues" ng-value="value">{{value | cronNumeral}}</md-option></md-select><md-select ng-if="!allowMultiple" ng-model="myFrequency.dayOfMonthValues"><md-option ng-repeat="value in dayOfMonthValues" ng-value="value">{{value | cronNumeral}}</md-option></md-select></div><span ng-show="myFrequency.base == 6" translate="cronWidget.of">of</span><div ng-show="myFrequency.base == 6"><md-select ng-if="allowMultiple" ng-model="myFrequency.monthValues" multiple="multiple"><md-option ng-repeat="value in monthValues" ng-value="value">{{value | cronMonthName}}</md-option></md-select><md-select ng-if="!allowMultiple" ng-model="myFrequency.monthValues"><md-option ng-repeat="value in monthValues" ng-value="value">{{value | cronMonthName}}</md-option></md-select></div><span ng-show="myFrequency.base >= 2" translate="cronWidget.at">at </span><!-- If Multiple is Enabled --><div ng-show="myFrequency.base >= 3"><md-select ng-if="allowMultiple" ng-model="myFrequency.hourValues" multiple="multiple"><md-option ng-repeat="value in hourValues" ng-value="value">{{value}}</md-option></md-select><md-select ng-if="!allowMultiple" ng-model="myFrequency.hourValues"><md-option ng-repeat="value in hourValues" ng-value="value">{{value}}</md-option></md-select></div><span ng-show="myFrequency.base >= 3">:</span><div ng-show="myFrequency.base >= 2"><md-select ng-if="allowMultiple" ng-model="myFrequency.minuteValues" multiple="multiple"><md-option ng-repeat="value in minuteValues" ng-value="value">{{value}}</md-option></md-select><md-select ng-if="!allowMultiple" ng-model="myFrequency.minuteValues"><md-option ng-repeat="value in minuteValues" ng-value="value">{{value}}</md-option></md-select></div><span ng-show="myFrequency.base == 2" translate="cronWidget.pastTheHour">past the hour</span></div></div>');
$templateCache.put('core/components/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="atheer.error.title">Error Page!</h1><div class="alert alert-danger" translate="atheer.error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('core/components/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="atheer.error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('core/components/filter/criteria-builder-fields.tmpl.html','<div ng-switch="fpFieldMeta.data_type" class="fp-criteria-builder-input-container"><md-input-container ng-switch-when="STRING"><input type="text" ng-model="$parent.fpFieldModel" required></md-input-container><md-input-container ng-switch-when="NUMBER"><input type="number" ng-model="$parent.fpFieldModel" required></md-input-container><div ng-switch-when="DATE"><div ng-if="fpFieldOperator != \'IS\' && fpFieldOperator != \'BETWEEN\' && fpFieldOperator != null"><md-input-container><md-datepicker ng-init="tmp_date = getDate();setDate(tmp_date)" ng-model="tmp_date" ng-change="setDate(tmp_date)" required></md-datepicker></md-input-container></div><div ng-if="fpFieldOperator == \'IS\' && fpFieldOperator != null" layout="row" layout-align="start top"><md-input-container><md-select ng-init="tmp_date_option = getInitDateOption()" ng-model="tmp_date_option" placeholder="{{\'criteriaBuilder.selectValue\' | translate}}" ng-change="setDateFieldModel(tmp_date_option)" required><md-option value="TODAY" translate="criteriaBuilder.today">Today</md-option><md-option value="YESTERDAY" translate="criteriaBuilder.yesterday">Yesterday</md-option><md-option value="DAYS_BEFORE" translate="criteriaBuilder.daysBefore">Days Before</md-option><md-option value="DAYS_AFTER" translate="criteriaBuilder.daysAfter">Days After</md-option><md-option value="START_OF_WEEK" translate="criteriaBuilder.startOfWeek">Start Of Week</md-option><md-option value="END_OF_WEEK" translate="criteriaBuilder.endOfWeek">End Of Week</md-option><md-option value="START_OF_MONTH" translate="criteriaBuilder.startOfMonth">Start Of Month</md-option><md-option value="END_OF_MONTH" translate="criteriaBuilder.endOfMonth">End Of Month</md-option></md-select></md-input-container><md-input-container class="margin-left-20" ng-if="fpFieldModel.option"><input type="number" ng-model="fpFieldModel.days" placeholder="{{\'criteriaBuilder.days\' | translate}}" required></md-input-container></div><div ng-if="fpFieldOperator == \'BETWEEN\' && fpFieldOperator != null" layout="row" layout-align="start top"><md-input-container><md-datepicker ng-init="tmp_from_date = getFromDate(); setFromDateField(tmp_from_date)" ng-model="tmp_from_date" ng-change="setFromDateField(tmp_from_date)" md-placeholder="{{\'criteriaBuilder.fromDate\' | translate}}" md-min-date="today" required></md-datepicker></md-input-container><md-input-container><md-datepicker ng-init="tmp_to_date = getToDate(); setToDateField(tmp_to_date)" ng-model="tmp_to_date" ng-change="setToDateField(tmp_to_date)" md-placeholder="{{\'criteriaBuilder.toDate\' | translate}}" md-min-date="today" required></md-datepicker></md-input-container><div><span>{{fpFieldModel.toDate}} {{fpFieldModel.fromDate}}</span></div></div></div><md-input-container ng-switch-when="BOOLEAN"><md-select ng-model="$parent.fpFieldModel" placeholder="{{\'criteriaBuilder.selectValue\' | translate}}" required><md-option ng-value="true" translate="criteriaBuilder.true">True</md-option><md-option ng-value="false" translate="criteriaBuilder.false">False</md-option></md-select></md-input-container><md-input-container ng-switch-when="OBJECT" ng-if="fpFieldMeta.ref_object == \'User\'"><fp-auto-complete required="true" special-filter="formatToMetaObject(result)" no-label="true" auto-complete-model="$parent.$parent.fpFieldModel" component="{{fpFieldMeta.ref_object|fpCapitalizeWord}}" query-objs="[{fieldName:\'text_search\', operator:\'=ts=\'}]"></fp-auto-complete></md-input-container><md-input-container ng-switch-when="OBJECT" ng-if="fpFieldMeta.ref_object != \'User\'"><fp-auto-complete required="true" special-filter="formatToMetaObject(result)" no-label="true" auto-complete-model="$parent.$parent.fpFieldModel" component="{{fpFieldMeta.ref_object|fpCapitalizeWord}}" query-objs="[{fieldName:\'title\', operator:\'=re=\'}]"></fp-auto-complete></md-input-container><md-input-container ng-switch-when="LIST"><md-select ng-model="$parent.fpFieldModel" placeholder="{{\'criteriaBuilder.selectValue\' | translate}}" required><md-option ng-repeat="optionObj in fpFieldMeta.list_options" ng-value="optionObj.option_id">{{optionObj.label}}</md-option></md-select></md-input-container><md-input-container ng-switch-when="TIMEZONE"><md-select ng-model="$parent.fpFieldModel" placeholder="{{\'criteriaBuilder.selectValue\' | translate}}" required><md-option ng-repeat="timezone in fpTimeZoneData" ng-value="timezone.timezone_no">{{timezone.display_name}}</md-option></md-select></md-input-container><md-input-container ng-switch-when="LANGUAGE"><md-select ng-model="$parent.fpFieldModel" placeholder="{{\'criteriaBuilder.selectValue\' | translate}}" required><md-option ng-repeat="language in fpLanguageData" ng-value="language.name">{{language.description}}</md-option></md-select></md-input-container></div>');
$templateCache.put('core/components/filter/criteria-builder.tmpl.html','<div flex layout="column" class="margin-bottom-20" ng-if="isDataLoaded"><span class="md-subhead" translate="criteriaBuilder.addNewFilter">To add a new filter, select one below and click \'Add Filter\'</span></div><div ng-form="criteriaBuilderForm"><div dragula=\'"smart-content-cards"\' dragula-model="fpCriteria.condition_groups" ng-if="isDataLoaded"><div layout="column" class="fp-criteria-builder" ng-repeat="(condition_group_index, condition_group) in fpCriteria.condition_groups"><div ng-if="condition_group_index > 0" layour="row" class="and-condition"><div flex="5" class="left-condition" layout="column" layout-align="center center"><div class="connection"></div><div class="and-condition md-primary" aria-label="primary button" translate="criteriaBuilder.and">And</div><div class="connection"></div></div><div flex></div></div><div layout="row" class="field-group"><div flex="5" class="left-action" layout="row" layout-align="center center"><md-button class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button></div><div flex layout="column" class="right-action"><div layout="column" ng-repeat="(condition_index, condition) in condition_group.conditions"><div ng-if="condition_index >0" layout="row" class="or-condition" layout-align="center center"><div flex class="horizontal-connection"></div><div translate="criteriaBuilder.or">OR</div><div flex class="horizontal-connection"></div></div><div flex layout="row" layout-align="start center"><div layout="row" class="fp-criteria-builder-input-container" layout-align="start center"><div layout="row" ng-if="condition.field_group_name"><span class="md-body-2">{{((metaFieldGroups|filter:{name :condition.field_group_name})[0].fields|filter:{name:condition.field_name})[0].label}}</span><fp-criteria-builder-field ng-if="!hasCondition(condition.field_group_name, condition.field_name)" fp-field-operator="condition.operator" fp-field-model="condition.value" fp-field-meta="((metaFieldGroups|filter:{name :condition.field_group_name})[0].fields|filter:{name:condition.field_name})[0]" fp-time-zone-data="timezones" fp-language-data="languages"></fp-criteria-builder-field></div><div ng-if="!condition.field_group_name" layout="row" layout="center center" class="new-filter-text"><md-icon class="zmdi zmdi-filter-list"></md-icon><span translate="criteriaBuilder.addFilter">Add Filter</span></div><div flex class="fp-criteria-builder-input-container" ng-if="!condition.field_group_name"><md-input-container><md-select ng-model="condition_group.conditions[condition_index]" md-on-close="fieldSearchText_or = \'\'" data-md-container-class="fp-filter-select-container" ng-init="initFieldDropDownSearch()" placeholder="{{\'criteriaBuilder.selectField\' | translate}}" required><md-select-header class="fp-filter-select-header"><input ng-model="fieldSearchText_or" type="search" class="fp-filter-select-text-box md-text"></md-select-header><md-optgroup label="{{metaFieldGroup.label}}" ng-if="(metaFieldGroup.fields|filter:fieldSearchText_or).length > 0" ng-repeat="metaFieldGroup in metaFieldGroups"><md-option ng-value="{field_group_name : metaFieldGroup.name, field_name : metaField.name, data_type: metaField.data_type, operator: metaField.data_type == \'BOOLEAN\' ? \'EQUAL\' : null}" ng-repeat="metaField in metaFieldGroup.fields|filter:fieldSearchText_or">{{metaField.label}}</md-option></md-optgroup></md-select></md-input-container></div></div><div layout="row" ng-if="condition.field_group_name && hasCondition(condition.field_group_name, condition.field_name)" class="fp-criteria-builder-input-container" layout-align="center center"><md-input-container><md-select ng-model="condition.operator" placeholder="{{\'criteriaBuilder.selectCondition\' | translate}}" required><md-option ng-model-options="{ trackBy: \'$value.name\' }" ng-value="operator.value" ng-repeat="operator in getFieldOperators(condition.field_group_name, condition.field_name)">{{operator.label}}</md-option></md-select></md-input-container><fp-criteria-builder-field fp-field-model="condition.value" fp-field-operator="condition.operator" fp-field-meta="((metaFieldGroups|filter:{name :condition.field_group_name})[0].fields|filter:{name:condition.field_name})[0]" fp-time-zone-data="timezones" fp-language-data="languages"></fp-criteria-builder-field></div><span flex></span><div layout="row" layout-align="center center"><md-button ng-click="addField(condition_group_index, condition_index)" layout="row" layout-align="center center" class="md-primary" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus-square"></md-icon><span translate="criteriaBuilder.or">OR</span></md-button><md-button ng-click="removeField(condition_group_index, condition_index)" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon></md-button></div></div></div></div></div></div></div></div><div layout="column" class="fp-criteria-builder"><div ng-if="fpCriteria.condition_groups.length >0" layour="row" class="and-condition"><div flex="5" class="left-condition" layout="column" layout-align="center center"><div class="connection"></div><div class="and-condition md-primary" aria-label="primary button" translate="criteriaBuilder.and">And</div><div class="connection"></div></div><div flex></div></div><div layout="row" class="field-group"><div flex layout="row" layout-align="start center" class="right-action padding-right-10 padding-top-10 padding-bottom-10"><div layout="row" layout="center center" class="new-filter-text"><md-icon class="zmdi zmdi-filter-list"></md-icon><span translate="criteriaBuilder.addFilter">Add Filter</span></div><div flex="50" class="fp-criteria-builder-input-container"><md-input-container md-no-float><md-select ng-change="addFieldGroup()" ng-model="newFieldMeta" placeholder="{{\'criteriaBuilder.selectField\' | translate}}" md-on-close="fieldSearchText = \'\'" data-md-container-class="fp-filter-select-container" ng-init="initFieldDropDownSearch()"><md-select-header class="fp-filter-select-header"><input ng-model="fieldSearchText" type="search" class="fp-filter-select-text-box md-text"></md-select-header><md-optgroup label="{{metaFieldGroup.label}}" ng-if="(metaFieldGroup.fields|filter:fieldSearchText).length > 0" ng-repeat="(metaFieldGroupIndex, metaFieldGroup) in metaFieldGroups"><md-option ng-value="{field_group_name : metaFieldGroup.name,field_name : metaField.name, data_type: metaField.data_type}" ng-repeat="metaField in metaFieldGroup.fields|filter:fieldSearchText">{{metaField.label}}</md-option></md-optgroup></md-select></md-input-container></div></div></div></div>');
$templateCache.put('core/components/filter/field-selection-panel.tmpl.html','<div class="fp-field-selection-md-panel" aria-label="Eat me!" layout="column" layout-align="center center"><md-toolbar class="md-toolbar-tools md-whiteframe-z1" md-theme="white-theme"><div flex class="fp-global-search-input" layout="row" layout-align="center center"><md-input-container class="md-block" md-no-float><md-icon class="search-icon" md-font-icon="zmdi zmdi-search"></md-icon><input ng-model="vm.searchText" label="search" placeholder="{{\'global.form.searchPlaceholder\' | translate}}" type="text" ng-change="vm.search()" ng-model-options="{debounce: 500}"></md-input-container></div></md-toolbar><md-content class="fp-field-selection-dialog-content margin-top-10" ng-style="{\'background-color\': \'white\'}"><md-list><div ng-repeat="metaFieldGroup in vm.metaFieldGroups"><md-subheader ng-if="(metaFieldGroup.fields|filter:vm.searchText).length > 0" class="md-primary"><span translate>{{metaFieldGroup.label}}</span></md-subheader><md-list-item ng-repeat="field in metaFieldGroup.fields|filter:vm.searchText" layout="row" layout-align="space-around center" ng-click="vm.selectField(metaFieldGroup, field)"><p translate>{{field.label}}</p></md-list-item></div></md-list></md-content></div>');
$templateCache.put('core/components/filter/field-setting-panel.tmpl.html','<div class="fp-field-setting-md-panel" aria-label="Eat me!" layout="column" layout-align="center center"><div class="fp-field-setting-dialog-content padding-top-20"><div ng-switch="vm.condition.data_type"><div ng-switch-when="STRING"><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)" ng-repeat="operator in vm.conditionOperators | filter:vm.checkFilterOptions"><div layout="column"><md-radio-button value="{{operator.value}}">{{operator.label | translate}}</md-radio-button><md-input-container ng-if="vm.condition.operator == operator.value && vm.showInput(vm.condition.operator)"><input type="text" ng-model="vm.condition.value"></md-input-container></div></md-radio-group><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)"><div layout="column"><md-radio-button value="IN"><span translate="fieldSettingPanel.in">In</span></md-radio-button><div layout="column" layout-align="space-around center" ng-if="vm.condition.operator == \'IN\'"><md-input-container flex="50"><input type="text" ng-model="vm.stringChoices"></md-input-container><span class="md-body-1" translate="fieldSettingPanel.choicesHint">comma separated list</span></div></div><div layout="column"><md-radio-button value="NOT_IN"><span translate="fieldSettingPanel.notIn">Not In</span></md-radio-button><div layout="column" layout-align="space-around center" ng-if="vm.condition.operator == \'NOT_IN\'"><md-input-container flex="50"><input type="text" ng-model="vm.stringChoices"></md-input-container><span class="md-body-1" translate="fieldSettingPanel.choicesHint">comma separated list</span></div></div></md-radio-group></div><div ng-switch-when="NUMBER"><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)" ng-repeat="operator in vm.conditionOperators"><div layout="column"><md-radio-button value="{{operator.value}}">{{operator.label | translate}}</md-radio-button><md-input-container ng-if="vm.condition.operator == operator.value && vm.showInput(vm.condition.operator)"><input type="number" ng-model="vm.condition.value"></md-input-container></div></md-radio-group></div><div ng-switch-when="DECIMAL"><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)" ng-repeat="operator in vm.conditionOperators"><div layout="column"><md-radio-button value="{{operator.value}}">{{operator.label | translate}}</md-radio-button><md-input-container ng-if="vm.condition.operator == operator.value && vm.showInput(vm.condition.operator)"><input type="number" ng-model="vm.condition.value"></md-input-container></div></md-radio-group></div><div layout="column" ng-switch-when="DATE"><span class="md-body-2 margin-top-10 margin-bottom-10" translate="fieldSettingPanel.relative">Relative</span><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)"><div layout="column"><md-radio-button value="GREATER_THAN"><span translate="fieldSettingPanel.moreThan">more than</span></md-radio-button><div layout="row" layout-align="space-around center" ng-if="vm.condition.operator == \'GREATER_THAN\'"><md-input-container flex="50"><input type="number" ng-model="vm.condition.value" min="0" ng-keypress="vm.disallowNegative($event)"></md-input-container><span class="md-body-1" translate="fieldSettingPanel.daysAgo">days ago</span></div></div><div layout="column"><md-radio-button value="GREATER_THAN_OR_EQUAL"><span translate="fieldSettingPanel.moreThanOrEquals">more than or equals</span></md-radio-button><div layout="row" layout-align="space-around center" ng-if="vm.condition.operator == \'GREATER_THAN_OR_EQUAL\'"><md-input-container flex="50"><input type="number" ng-model="vm.condition.value" min="0" ng-keypress="vm.disallowNegative($event)"></md-input-container><span class="md-body-1" translate="fieldSettingPanel.daysAgo">days ago</span></div></div><div layout="column"><md-radio-button value="LESS_THAN"><span translate="fieldSettingPanel.lessThan">less than</span></md-radio-button><div layout="row" layout-align="space-around center" ng-if="vm.condition.operator == \'LESS_THAN\'"><md-input-container flex="50"><input type="number" ng-model="vm.condition.value" min="0" ng-keypress="vm.disallowNegative($event)"></md-input-container><span class="md-body-1" translate="fieldSettingPanel.daysAgo">days ago</span></div></div><div layout="column"><md-radio-button value="LESS_THAN_OR_EQUAL"><span translate="fieldSettingPanel.lessThanOrEquals">less than or equals</span></md-radio-button><div layout="row" layout-align="space-around center" ng-if="vm.condition.operator == \'LESS_THAN_OR_EQUAL\'"><md-input-container flex="50"><input type="number" ng-model="vm.condition.value" min="0" ng-keypress="vm.disallowNegative($event)"></md-input-container><span class="md-body-1" translate="fieldSettingPanel.daysAgo">days ago</span></div></div><div layout="column"><md-radio-button value="WITHIN"><span translate="fieldSettingPanel.withinNext">within the next</span></md-radio-button><div layout="row" layout-align="space-around center" ng-if="vm.condition.operator == \'WITHIN\'"><md-input-container flex="50"><input type="number" ng-model="vm.condition.value" min="0" ng-keypress="vm.disallowNegative($event)"></md-input-container><span class="md-body-1" translate="fieldSettingPanel.days">days</span></div></div></md-radio-group><span class="md-body-2 margin-top-10 margin-bottom-10" translate="fieldSettingPanel.absolute">Absolute</span><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)"><div layout="column"><md-radio-button value="AFTER"><span translate="fieldSettingPanel.after">after</span></md-radio-button><md-datepicker ng-if="vm.condition.operator == \'AFTER\'" ng-init="vm.tmp_date = vm.getDate(vm.condition.value)" ng-model="vm.tmp_date" ng-change="vm.condition.value = vm.tmp_date" md-placeholder="{{\'fieldSettingPanel.enterDate\' | translate}}"></md-datepicker></div><div layout="column"><md-radio-button value="ON"><span translate="fieldSettingPanel.on">on</span></md-radio-button><md-datepicker ng-if="vm.condition.operator == \'ON\'" ng-init="vm.tmp_date = vm.getDate(vm.condition.value)" ng-model="vm.tmp_date" ng-change="vm.condition.value = vm.tmp_date" md-placeholder="{{\'fieldSettingPanel.enterDate\' | translate}}"></md-datepicker></div><div layout="column"><md-radio-button value="BEFORE"><span translate="fieldSettingPanel.before">before</span></md-radio-button><md-datepicker ng-if="vm.condition.operator == \'BEFORE\'" ng-init="vm.tmp_date = vm.getDate(vm.condition.value)" ng-model="vm.tmp_date" ng-change="vm.condition.value = vm.tmp_date" md-placeholder="{{\'fieldSettingPanel.enterDate\' | translate}}"></md-datepicker></div><div layout="column"><md-radio-button value="BETWEEN"><span translate="fieldSettingPanel.between">between</span></md-radio-button><div ng-if="vm.condition.operator == \'BETWEEN\'" layout="column"><md-datepicker ng-init="vm.tmp_from_date = vm.getDate(vm.condition.value.from_date)" ng-model="vm.tmp_from_date" ng-change="vm.condition.value.from_date = vm.tmp_from_date" md-placeholder="{{\'fieldSettingPanel.enterDate\' | translate}}"></md-datepicker><md-datepicker ng-init="vm.tmp_to_date = vm.getDate(vm.condition.value.to_date)" ng-model="vm.tmp_to_date" ng-change="vm.condition.value.to_date = vm.tmp_to_date" md-placeholder="{{\'fieldSettingPanel.enterDate\' | translate}}"></md-datepicker></div></div></md-radio-group><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)"><div layout="column"><md-radio-button value="NOT_EXISTS"><span translate="fieldSettingPanel.isUnknown">is unknown</span></md-radio-button><md-radio-button value="EXISTS"><span translate="fieldSettingPanel.hasAnyValue">has any value</span></md-radio-button></div></md-radio-group></div><div ng-switch-when="BOOLEAN"><md-radio-group ng-model="vm.booleanTemp" ng-repeat="operator in vm.conditionOperators" ng-change="vm.updateConditionValue(vm.booleanTemp)"><div layout="column"><md-radio-button value="{{operator.defaultValue}}">{{operator.label | translate}}</md-radio-button></div></md-radio-group></div><div ng-switch-when="OBJECT" ng-if="fpFieldMeta.ref_object == \'User\'"></div><div ng-switch-when="OBJECT" ng-if="fpFieldMeta.ref_object != \'User\'"><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)" ng-repeat="operator in vm.conditionOperators"><div layout="column"><md-radio-button value="{{operator.value}}">{{operator.label | translate}}</md-radio-button><md-input-container ng-if="vm.condition.operator == operator.value && vm.showInput(vm.condition.operator)"><md-select ng-model="vm.condition.value.id" placeholder="Select Value"><md-option ng-repeat="listVal in vm.conditionListOptions" ng-value="listVal.id" ng-click="vm.updateConditionListObject(listVal)">{{listVal.name}}</md-option></md-select></md-input-container></div></md-radio-group></div><div ng-switch-when="LIST"><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)" ng-repeat="operator in vm.conditionOperators"><div layout="column"><md-radio-button value="{{operator.value}}">{{operator.label | translate}}</md-radio-button><md-input-container ng-if="vm.conditionListOptions.length > 0 && vm.condition.operator == operator.value && vm.showInput(vm.condition.operator)"><md-select ng-model="vm.condition.value" placeholder="Select Value"><md-option ng-value="listVal.option_id" ng-repeat="listVal in vm.conditionListOptions" ng-click="vm.updateConditionList(listVal.label)">{{listVal.label}}</md-option></md-select></md-input-container></div></md-radio-group></div><div ng-switch-when="TIMEZONE"><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)" ng-repeat="operator in vm.conditionOperators"><div layout="column"><md-radio-button value="{{operator.value}}">{{operator.label | translate}}</md-radio-button><md-input-container ng-if="vm.conditionListOptions.length > 0 && vm.condition.operator == operator.value && vm.showInput(vm.condition.operator)"><md-select ng-model="vm.condition.value" placeholder="Select Value"><md-option ng-value="listVal.timezone_no.toString()" ng-repeat="listVal in vm.conditionListOptions" ng-click="vm.updateConditionList(listVal.display_name)">{{listVal.display_name}}</md-option></md-select></md-input-container></div></md-radio-group></div><div ng-switch-when="LANGUAGE"><md-radio-group ng-model="vm.condition.operator" ng-change="vm.updateConditionValue(vm.condition)" ng-repeat="operator in vm.conditionOperators"><div layout="column"><md-radio-button value="{{operator.value}}">{{operator.label | translate}}</md-radio-button><md-input-container ng-if="vm.conditionListOptions.length > 0 && vm.condition.operator == operator.value && vm.showInput(vm.condition.operator)"><md-select ng-model="vm.condition.value" placeholder="Select Value"><md-option ng-value="listVal.name" ng-repeat="listVal in vm.conditionListOptions" ng-click="vm.updateConditionList(listVal.description)">{{listVal.description}}</md-option></md-select></md-input-container></div></md-radio-group></div></div></div><div layout="row" layout-align="center center" class="fp-field-setting-dialog-button"><md-button class="md-primary" ng-click="vm.done()"><span translate="entity.action.done">Done</span></md-button></div></div>');
$templateCache.put('core/components/filter/filter-builder.tmpl.html','<div ng-if="loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div ng-show="!loadingData" class="toolbar-default md-whiteframe-z1"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-input-container flex md-no-float><md-select md-container-class="fp-user-filters-dropdown" ng-model="selectedFilter" ng-change="refreshFilter()"><md-option ng-value="filter" ng-repeat="filter in filters"><span class="view-name margin-left-10">{{filter.name}}</span></md-option></md-select></md-input-container></div></div><div ng-show="!loadingData" flex layout="column " class="fp-filter-builder"><div><div layout="column" class="margin-left-10 margin-right-10 margin-top-10" ng-if="showSave(filterDetail)" ng-click="saveDynamicFilter(filterDetail)"><md-button flex class="md-raised md-primary"><span>Save Filter</span></md-button></div><div layout="column" class="margin-left-10 margin-right-10" ng-if="showReset(filterDetail)" ng-click="resetFilter()"><div layout="row" flex="50"><md-button class="md-primary"><span>Reset Filter</span></md-button></div></div><div layout="column" class="condition-groups"><div flex layout="row" class="user-type"><div layout="row" class="padding-10" ng-init="conditionFocus = false"><md-icon md-font-icon="{{icon}}"></md-icon><span class="md-body-1">{{label}}</span></div></div><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div class="connection"></div><div class="connection"></div></div></div><div id="match-type" flex layout="row" class="match-type" ng-click="showMatchType()" ng-style="matchSelected ? {\'background-color\': primaryColor} : {\'background-color\': \'white\'}"><div layout="row" class="padding-10"><md-icon md-font-icon="zmdi zmdi-chart"></md-icon><span class="md-body-1">{{filterDetail.criteria.match_all ? \'that match all filters\' : \'that match any filters\'}}</span></div></div><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div class="connection"></div><div ng-if="filterDetail.criteria.condition_groups.length > 0" class="connection"></div></div></div><div dragula=\'"condition-groups"\' dragula-model="filterDetail.criteria.condition_groups"><div flex ng-repeat="(groupIndex, conditionGroup) in filterDetail.criteria.condition_groups" layout="column"><div ng-if="groupIndex > 0" layour="row" class="and-condition"><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div class="connection"></div><div class="operator-type">{{filterDetail.criteria.match_all ? \'AND\' : \'OR\'}}</div><div class="connection"></div></div></div></div><div layout="row" class="condition-group-box"><div flex="10" class="left-action" layout="row" layout-align="center center"><md-button class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button></div><div flex layou="row"><div flex layout="column" class="condition-group" flex id="{{condition.field_group_name + \'-\' + condition.field_name}}" ng-repeat="(conditionIndex, condition) in conditionGroup.conditions"><div flex layout="row" ng-if="conditionIndex > 0" class="margin-top-10"><div flex class="horizontal-connection"></div><span class="md-caption">OR</span><div flex class="horizontal-connection"></div></div><div layout="column" flex ng-click="showFieldSettting(condition)" class="padding-10 condition" ng-init="conditionFocus = false" ng-mouseover="conditionFocus = true" ng-mouseleave="conditionFocus = false" ng-style="{\'background-color\': getConditionBackgroundColor(condition, conditionFocus)}"><div flex layout="row"><span flex="90" class="md-body-1" flex>{{getFieldLabel(condition)}}</span><md-icon flex="10" ng-if="conditionFocus || selectedCondition == condition" md-font-icon="zmdi zmdi-delete" ng-click="removeField(groupIndex, conditionIndex);$event.stopPropagation();"></md-icon></div></div></div></div></div></div></div><div layour="row" class="condition-operator"><div flex="20" layout="column" layout-align="center center"><div ng-if="filterDetail.criteria.condition_groups.length > 0" class="connection"></div><div class="connection"></div></div></div><div layout="row" id="add-filter" flex class="add-filter" ng-click="showFields()"><div layout="row" class="padding-10 condition"><md-icon md-font-icon="zmdi zmdi-filter-list"></md-icon><span class="md-body-1">Add Filter</span></div></div></div></div></div><div ng-if="!loadingData && showActions(filterDetail)" layout="row" layout-align="space-around center" class="md-toolbar-tools md-whiteframe-z1 fp-filter-bottom-bar"><md-button class="md-icon-button" ng-click="editFilter(filterDetail)" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-edit"></md-icon><fp-tooltip placement="bottom">Edit</fp-tooltip></md-button><md-button aria-label="primary button" ng-click="deleteFilter(filterDetail)"><md-icon md-font-icon="zmdi zmdi-delete"></md-icon></md-button></div>');
$templateCache.put('core/components/filter/filter-detail-dialog.tmpl.html','<md-dialog flex="35" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span ng-if="vm.mode == \'UPDATE\'" flex>Update Filter</span> <span ng-if="vm.mode == \'CREATE\'" flex>Save Filter</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Close</fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.mode == \'UPDATE\'" flex layout="column"><div flex class="padded-content-page content-properties-container"><div ng-form="filterDetailForm"><md-input-container class="md-block"><label class="md-required">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.filterModel.name" required ng-disabled="vm.filterModel.locked"><div ng-messages="filterDetailForm.name.$error"><div ng-message when="required"><span translate="atheer.filter.nameRequired">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label>Description</label> <textarea name="description" ng-model="vm.filterModel.description" id="field_description" ng-disabled="vm.filterModel.locked" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container></div></div></div><div ng-if="vm.mode == \'CREATE\'" flex layout="column"><div flex class="padded-content-page content-properties-container"><div ng-form="filterDetailForm"><md-input-container class="md-block"><label class="md-required">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.filterModel.name" required ng-disabled="vm.filterModel.locked"><div ng-messages="filterDetailForm.name.$error"><div ng-message when="required"><span translate="atheer.filter.nameRequired">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label>Description</label> <textarea name="description" ng-model="vm.filterModel.description" id="field_description" ng-disabled="vm.filterModel.locked" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span>Cancel</span></md-button><div ng-if="vm.mode == \'UPDATE\'"><md-button ng-click="vm.submit()" type="submit" ng-disabled="filterDetailForm.$invalid" class="md-raised md-primary"><span>Update Filter</span></md-button></div><div ng-if="vm.mode == \'CREATE\'"><md-button ng-click="vm.submit()" type="submit" ng-disabled="filterDetailForm.$invalid" class="md-raised md-primary"><span>Create New Filter</span></md-button></div></md-dialog-actions></md-dialog>');
$templateCache.put('core/components/filter/match-selection-panel.tmpl.html','<div class="fp-match-selection-md-panel" aria-label="Eat me!" layout="column" layout-align="center center"><div class="fp-match-selection-dialog-content margin-top-10"><div layout="column"><div class="fp-field-selection-menu-item" flex layout="row" layout-align="start center" ng-click="vm.selectMatchType(true)"><span class="md-body-1 margin-top-10 margin-bottom-10" translate="matchSelectionPanel.matchAll">that match all filters</span> <span flex></span></div><div class="fp-field-selection-menu-item" flex layout="row" layout-align="start center" ng-click="vm.selectMatchType(false)"><span class="md-body-1 margin-top-10 margin-bottom-10" translate="matchSelectionPanel.matchAny">that match any filters</span> <span flex></span></div></div></div></div>');
$templateCache.put('core/components/footer/footer.tmpl.html','<div id="sign-in-footer" flex layout="row" class="md-toolbar-tools md-accent margin-bottom-0 session-player-toolbar footer-color"><div flex="30" hide show-gt-sm><span class="md-body-1" style="font-size: 1.2rem">{{vm.buildInfoSettings.version}}#{{vm.buildInfoSettings.buildNumber}}</span></div><div flex-xs="100" flex-sm="100" class="text-align-center margin-left-10" ng-if="vm.showTermsAndPrivacy" flex="40" layout="row" layout-align="center center"><span class="md-body-1" style="font-size: 1.2rem"><span translate="atheer.signIn.bySigning">By Signing in, you agree to the </span><a target="_blank" ng-style="{\'text-decoration\': \'underline\', \'color\': \'#00BCD4\'}" ng-href="{{vm.termsLink}}" translate="atheer.signIn.terms">Terms</a><span translate="atheer.signIn.and">and </span><a target="_blank" ng-style="{\'text-decoration\': \'underline\', \'color\': \'#00BCD4\'}" ng-href="{{vm.privacyLink}}" translate="atheer.signIn.privacy">Privacy</a></span><span>.</span></div><div flex-xs="100" flex-sm="100" class="text-align-center margin-left-10" ng-if="!vm.showTermsAndPrivacy" flex="40" layout="row" layout-align="center center"></div><div hide show-gt-sm class="sign-in-powered" ng-if="vm.showPoweredBy" flex="30" layout="row" layout-align="end center"><span class="md-body-1" style="font-size: 1.2rem"><span translate="atheer.signIn.poweredBy">Powered by</span> <a ng-href="{{vm.termsLink}}" translate="atheer.signIn.atheerInc">Atheer, Inc.</a></span></div></div>');
$templateCache.put('core/components/formly/formly-custom-chips.tmpl.html','<div layout="row" layout-align="start start"><div layout="column" layout-align="start start" flex="100"><span>{{options.templateOptions.label|fpCapitalizeWord}}<sup ng-if="options.templateOptions.required">*</sup></span><md-chips class="custom-chips" flex="100" ng-model="model[options.key]" md-removable="true"></md-chips></div></div>');
$templateCache.put('core/components/formly/formly-custom-datepicker.tmpl.html','<div layout="row" layout-align="space-between center"><span>{{options.templateOptions.label|fpCapitalizeWord}}<sup ng-if="options.templateOptions.required">*</sup></span><md-datepicker ng-model="model[options.key]" md-placeholder="Select date"></md-datepicker></div>');
$templateCache.put('core/components/formly/formly-custom-object-picker.tmpl.html','<md-input-container class="fp-formly-custom"><span>{{options.templateOptions.objectName|fpCapitalizeWord}}<sup ng-if="options.templateOptions.required">*</sup></span><fp-auto-complete no-label="true" auto-complete-model="model[options.key]" component="{{options.templateOptions.objectName|fpCapitalizeWord}}" query-objs="options.templateOptions.queryObject"></fp-auto-complete></md-input-container>');
$templateCache.put('core/components/formly/formly-custom-select.tmpl.html','<div layout="row" layout-align="space-between center"><span>{{options.templateOptions.label|fpCapitalizeWord}}<sup ng-if="options.templateOptions.required">*</sup></span><md-select ng-model="model[options.key]" class="md-no-underline"><md-option value="{{optionVal[options.templateOptions.valueProp]}}" ng-repeat="optionVal in options.templateOptions.options">{{optionVal[options.templateOptions.labelProp]}}</md-option></md-select></div>');
$templateCache.put('core/components/formly/formly-custom-switch-boolean.tmpl.html','<div layout="row" layout-align="space-between center"><span>{{options.templateOptions.label|fpCapitalizeWord}}<sup ng-if="options.templateOptions.required">*</sup></span><md-switch name="request_rating" ng-model="model[options.key]"></md-switch></div>');
$templateCache.put('core/components/header/header.tmpl.html','<div layout="row" layout-align="space-between center" class="fp-header" ng-if="vm.isPublicUser || vm.isMobileBrowser" ng-style="{\'background\': bgColor}"><div class="header-left" layout="row" layout-align="start center" ng-if="vm.isPublicUser || vm.pageName=== \'Home\'"><img class="logo" ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}"></div><div class="header-left" layout="row" layout-align="start center" ng-if="!vm.isPublicUser && vm.pageName !== \'Home\'"><md-button ng-click="vm.navigateHome()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-home"></md-icon></md-button><span>{{title}}</span></div><div class="header-right" layout-align="center center" ng-if="vm.isPublicUser"><a ui-sref="account.signup" ng-if="vm.signUpEnabled" hide-xs hide-sm md-colors="{color: \'accent\'}"><span id="signup" *ng-if="signUpEnabled" translate="home.newUserSignup" class="singup-txt margin-right-24">New User? Sign up</span></a><md-button ui-sref="account.signin" id="signin" class="md-raised md-accent login-btn"><span translate="home.login">Log In</span></md-button></div><div class="header-right" layoutgap="5" layout="row" layout-align="center center" ng-if="!vm.isPublicUser"><fp-avatar user="userInfo" class="storm-md-avatar" auto-color="true" bind="true" width="30" font-weight="400" font-scale="100" round-shape="true"></fp-avatar><md-menu class="margin-left-10"><md-icon md-font-icon="fa fa-caret-down" ng-click="$mdMenu.open()"></md-icon><md-menu-content width="2" ng-mouseleave="$mdMenu.close()"><mat-menu-item><md-button class="header-menu-item" ui-sref="storm.profile.about({id: \'me\'})" aria-label="navigation"><md-icon class="nav-icon" md-font-icon="zmdi zmdi-account-circle"></md-icon><span translate="home.profile"></span></md-button></mat-menu-item><mat-menu-item><md-button class="header-menu-item" ui-sref="storm.profile.password({id: \'me\'})" aria-label="navigation"><md-icon class="nav-icon" md-font-icon="zmdi zmdi-key"></md-icon><span translate="home.changePassword"></span></md-button></mat-menu-item><mat-menu-item><md-button class="header-menu-item" ng-click="vm.logout()" aria-label="navigation"><md-icon class="nav-icon" md-font-icon="zmdi zmdi-sign-in"></md-icon><span translate="home.signout"></span></md-button></mat-menu-item></md-menu-content></md-menu></div></div>');
$templateCache.put('core/components/help/help.tmpl.html','<div ng-if="vm.showHelpCenter"><md-button id="{{vm.key}}" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-help"></md-icon><fp-tooltip placement="bottom"><span translate="help">Help</span></fp-tooltip></md-button></div>');
$templateCache.put('core/components/illustration/illustration-empty-screen.html','<div flex layout-align="center center"><img ng-if="vm.id != \'web_hooks\' && vm.id != \'web_hooks_logs\'" ng-src="{{vm.imgSrc}}" class="fp-illustration-empty-screen"><md-icon ng-if="vm.id == \'web_hooks\' || vm.id == \'web_hooks_logs\'" layout="row" layout-align="center center" md-svg-src="{{vm.imgSrc}}" class="md-primary md-raised fp-illustration-empty-screen-image"></md-icon><div flex layout="column" layout-align="center center" ng-bind-html="vm.trustedHtml"></div><div ng-if="vm.addButton" permission permission-only="vm.permission" class="margin-top-20" layout="column" layout-align="center center"><md-button ng-click="vm.goState()" class="md-primary md-raised fp-illustration-empty-screen-button">{{vm.button}}</md-button></div></div>');
$templateCache.put('core/components/leftsidenav/leftsidenav.tmpl.html','<md-toolbar class="sidebar-left-toolbar" md-theme="{{::triSkin.elements.sidebar}}" class="md-accent"><div flex layout="column" layout-align="center center"><md-button ng-click="vm.goHome()" aria-label="Home" ng-if="vm.sidebarInfo.logoRight != \'true\'"><img ng-src="{{vm.sidebarInfo.menuState == \'OPEN\' ? vm.sidebarInfo.appLogoBig : vm.sidebarInfo.appLogoSmall}}" ng-class="vm.sidebarInfo.menuState == \'OPEN\' ? \'storm-left-nav-logo-open\' : \'storm-left-nav-logo-closed\'"></md-button></div></md-toolbar><tri-menu md-theme="{{triSkin.elements.sidebar}}" flex layout="column"></tri-menu><md-toolbar class="sidebar-left-user-toolbar padding-bottom-10" md-theme="{{::triSkin.elements.sidebar}}"><!--\n    <md-button id="ath-product-doc" ng-if="!vm.isMasterWorkspace && vm.showHelpCenter" ui-sref="storm.product-doc" class="md-icon-button button-no-raduis fp-help-center" aria-label="Help">\n        <fp-tooltip placement="right"><span translate="help">Documentation</span></fp-tooltip>\n        <md-icon class="help-menu-icon" md-font-icon="fa fa-book"></md-icon>\n    </md-button>\n    --><md-button id="ath-help" ng-if="!vm.isMasterWorkspace && vm.showHelpCenter" class="md-icon-button button-no-raduis fp-help-center" aria-label="Help"><fp-tooltip placement="right"><span translate="help">Help</span></fp-tooltip><md-icon class="help-menu-icon" md-font-icon="zmdi zmdi-help"></md-icon></md-button><md-button id="signout" ng-if="isMasterWorkspace || vm.isWorkspaceAdmin" aria-label="Sign out" ng-click="vm.logOut()" class="md-icon-button button-no-raduis"><md-icon class="side-menu-icon" md-font-icon="zmdi zmdi-sign-in"></md-icon><fp-tooltip placement="right"><span translate="global.menu.account.logout">Sign out</span></fp-tooltip></md-button><md-menu id="currentuser" ng-if="!isMasterWorkspace && !vm.isWorkspaceAdmin" md-offset="{{vm.sidebarInfo.menuState == \'OPEN\' ? 180 : 50}} 0"><div layout="row" layout-align="center center" ng-click="$mdMenu.open()" ng-style="{ \'cursor\': \'pointer\'}"><fp-avatar user="vm.currentUser" class="storm-md-avatar" auto-color="true" bind="true" width="30" font-weight="400" font-scale="100" round-shape="true"></fp-avatar></div><md-menu-content width="4" ng-mouseleave="$mdMenu.close()"><md-menu-item><md-button id="displayname" ui-sref="storm.profile.overview({id: \'me\'})" ng-click="vm.toggleToolBarMenu(\'Profile\')" aria-label="side navigation"><md-icon md-font-icon="fa fa-user"></md-icon><span>{{vm.currentUser.displayName}}</span></md-button></md-menu-item><md-menu-item><md-button id="linkyourdevice" ui-sref="storm.profile.overview({id: \'me\', launchQrCode: true})" ng-click="vm.toggleToolBarMenu(\'Profile\', \'QR\')" aria-label="side navigation"><md-icon md-font-icon="fa fa-qrcode"></md-icon><span translate="global.menu.linkYourDevice">Link Your Device</span></md-button></md-menu-item><md-menu-item><md-button id="downloadapps" ui-sref="storm.lens-apps" ng-click="vm.toggleToolBarMenu(\'Profile\')" aria-label="side navigation"><md-icon md-font-icon="zmdi zmdi-download"></md-icon><span translate="global.menu.downloadApps">Download Apps</span></md-button></md-menu-item><md-menu-item><md-button id="signout" ng-click="vm.logOut()" aria-label="side navigation"><md-icon md-font-icon="zmdi zmdi-sign-in"></md-icon><span translate="global.menu.account.logout">Sign out</span></md-button></md-menu-item></md-menu-content></md-menu></md-toolbar>');
$templateCache.put('core/components/loader/loader.tmpl.html','<div flex layout="column" layout-align="center center"><wave-spinner></wave-spinner></div>');
$templateCache.put('core/components/menu/menu-item-divider.tmpl.html','<md-divider></md-divider>');
$templateCache.put('core/components/menu/menu-item.tmpl.html','<md-button ng-if="$root.isLightTheme && triMenuItem.item.type == \'link\'" ng-click="triMenuItem.openLink(triMenuItem.item)" class="md-raised side-menu-link" ng-style="triMenuItem.item.id == $root.selectedLeftNavMenu && { \'background-color\': backgroundColor, \'border-right-color\': triMenuItem.primaryColor, \'border-right-width\' : \'3px\', \'border-style\' : \'solid\'}"><fp-tooltip ng-if="!sideBarOpen" placement="right">{{triMenuItem.item.name | translate}}</fp-tooltip><div ng-if="triMenuItem.item.id != \'copilot\'"><md-icon ng-if="::(triMenuItem.item.icon !== undefined)" class="side-menu-icon" md-font-icon="{{::triMenuItem.item.icon}}" ng-style="{ \'color\' : (triMenuItem.item.id == $root.selectedLeftNavMenu) ? triMenuItem.primaryColor : \'\', \'font-size\': (triMenuItem.item.id == \'home\' && \'2rem\'), \'margin-left\': (triMenuItem.item.id == \'tickets\' && \'-2px\') }"></md-icon><md-icon ng-if="triMenuItem.item.id === \'conversations\' && triMenuItem.count > 0" md-font-icon="zmdi zmdi-circle" ng-style="{\'font-size\': \'10px\', height: \'10px\', color: \'#EA4253\', \'position\': \'absolute\', \'left\': \'26px\', \'top\': \'8px\'}"></md-icon></div><span translate>{{::triMenuItem.item.name}}</span> <small ng-if="triMenuItem.item.badge" theme-background="accent" class="side-menu-badge">{{::triMenuItem.item.badge}}</small></md-button><md-button ng-if="!$root.isLightTheme && triMenuItem.item.type == \'link\'" ng-click="triMenuItem.openLink(triMenuItem.item)" class="md-raised side-menu-link" ng-class="{ \'md-primary\': !triMenuItem.item.id != $root.selectedLeftNavMenu, \'md-hue-1\' : triMenuItem.item.id == $root.selectedLeftNavMenu }"><fp-tooltip ng-if="!sideBarOpen" placement="right">{{triMenuItem.item.name | translate}}</fp-tooltip><div ng-if="triMenuItem.item.id != \'copilot\'"><md-icon ng-if="::(triMenuItem.item.icon !== undefined)" class="side-menu-icon" md-font-icon="{{::triMenuItem.item.icon}}" ng-style="{ \'font-size\': (triMenuItem.item.id == \'home\' && \'2rem\'), \'margin-left\': (triMenuItem.item.id == \'tickets\' && \'-2px\')}"></md-icon><md-icon ng-if="triMenuItem.item.id === \'conversations\' && triMenuItem.count > 0" md-font-icon="zmdi zmdi-circle" ng-style="{\'font-size\': \'10px\', height: \'10px\', color: \'#EA4253\', \'position\': \'absolute\', \'left\': \'26px\', \'top\': \'8px\'}"></md-icon></div><span translate>{{::triMenuItem.item.name}}</span> <small ng-if="triMenuItem.item.badge" theme-background="accent" class="side-menu-badge">{{::triMenuItem.item.badge}}</small></md-button><md-menu ng-if="triMenuItem.item.type == \'menu\'" md-offset="50 0"><md-button ng-click="$mdMenu.open()" class="md-raised side-menu-link" ng-style="$root.isLightTheme && triMenuItem.item.id == $root.selectedLeftNavMenu && { \'background-color\': backgroundColor, \'border-right-color\': triMenuItem.primaryColor, \'border-right-width\' : \'3px\', \'border-style\' : \'solid\'}" ng-class="{ \'md-primary\': !triMenuItem.item.id != $root.selectedLeftNavMenu && !$root.isLightTheme, \'md-hue-1\' : triMenuItem.item.id == $root.selectedLeftNavMenu && !$root.isLightTheme}"><fp-tooltip ng-if="!sideBarOpen" placement="right">{{triMenuItem.item.name | translate}}</fp-tooltip><md-icon ng-if="::(triMenuItem.item.icon !== undefined)" class="side-menu-icon" md-font-icon="{{::triMenuItem.item.icon}}"></md-icon><span translate>{{::triMenuItem.item.name}}</span> <small ng-if="triMenuItem.item.badge" theme-background="accent" class="side-menu-badge">{{::triMenuItem.item.badge}}</small></md-button><md-menu-content width="4" class="ath-fly-menu"><md-menu-item ng-repeat="childrenMenu in triMenuItem.subMenus"><md-button ng-click="triMenuItem.subMenuOpen(childrenMenu)"><md-icon ng-if="::(childrenMenu.icon !== undefined)" md-font-icon="{{childrenMenu.icon}}"></md-icon><span class="md-body-1" translate>{{childrenMenu.name}}</span></md-button></md-menu-item></md-menu-content></md-menu>');
$templateCache.put('core/components/notification-count/notification-count-directive.tmpl.html','<div ng-if="notificationCount > 0" class="ath-embed-notification"><div class="notification-button">{{notificationCount}}</div></div>');
$templateCache.put('core/components/notifications/notifications.tmpl.html','<md-content flex layout class="admin-notifications"><md-tabs flex md-stretch-tabs="always" md-selected="vm.currentTab"><md-tab><md-tab-label><md-icon md-font-icon="fa fa-bell-o"></md-icon></md-tab-label><md-tab-body><md-content><md-list><div ng-repeat="group in ::vm.notificationGroups"><md-subheader class="md-primary">{{::group.name}}</md-subheader><md-list-item ng-repeat="notification in ::group.notifications" layout="row" layout-align="space-between center"><md-icon md-font-icon="{{::notification.icon}}" ng-style="{ color: notification.iconColor }"></md-icon><p>{{::notification.title}}</p><span class="md-caption" am-time-ago="::notification.date"></span></md-list-item></div></md-list></md-content></md-tab-body></md-tab><md-tab><md-tab-label><md-icon md-font-icon="zmdi zmdi-account"></md-icon></md-tab-label><md-tab-body><md-content><md-list><div ng-repeat="group in ::vm.settingsGroups"><md-subheader class="md-primary"><span translate>{{::group.name}}</span></md-subheader><md-list-item ng-repeat="setting in ::group.settings" layout="row" layout-align="space-around center"><md-icon md-font-icon="{{::setting.icon}}"></md-icon><p translate>{{::setting.title}}</p><md-switch class="md-secondary" ng-model="setting.enabled"></md-switch></md-list-item></div><div ng-repeat="group in ::vm.statisticsGroups"><md-subheader class="md-primary"><span translate>{{::group.name}}</span></md-subheader><md-list-item ng-repeat="stat in ::group.stats" layout="column" layout-align="space-around start"><md-progress-linear class="margin-top-20" ng-class="::stat.mdClass" md-mode="determinate" ng-value="::stat.value"></md-progress-linear><p translate>{{::stat.title}}</p></md-list-item></div></md-list></md-content></md-tab-body></md-tab></md-tabs></md-content>');
$templateCache.put('core/components/password/password-strength.tmpl.html','<div layout="column" class="fp-password-strength-wrapper"><div layout="row"><div class="fp-password-strength fp-password-strength-{{strengthObject.value > 0 ? strengthObject.class : \'\'}}"></div><div class="fp-password-strength fp-password-strength-{{strengthObject.value > 1 ? strengthObject.class : \'\'}}"></div><div class="fp-password-strength fp-password-strength-{{strengthObject.value > 2 ? strengthObject.class : \'\'}}"></div><div class="fp-password-strength fp-password-strength-{{strengthObject.value > 3 ? strengthObject.class : \'\'}}"></div></div><div layout="row" layout-align="end center" class="fp-password-strength-text fp-password-strength-{{strengthObject.class}}">{{strengthObject.class}}</div></div>');
$templateCache.put('core/components/session-timeout/session-timeout-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="global.sessionTimeout" style="color: #343A3A;">Session Timeout</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close" style="color: #343A3A;"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.session.startSession.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div flex layout="column" class="padding-40" ng-form="vm.sessionDetailForm"><div style="color: #757575; font-size: 16px; line-height: 26px;" translate="global.timeoutTitle">For security, you\'re about to be signed out.</div><div style="color: #B7B7B7; font-size: 12px; line-height: 26px;" translate="global.timeoutText" translate-values="{counter: \'{{vm.counter}}\'}">*You will be signed out in {{vm.counter}} seconds</div><div layout="row" layout-align="end end"><md-button class="md-primary" ng-click="vm.close()" translate="global.menu.account.logout">Sign out</md-button><md-button class="md-primary md-raised" ng-click="vm.continue()" translate="entity.action.continue" style="color: #343A3A;">Continue</md-button></div></div></md-dialog>');
$templateCache.put('core/components/table/table-directive.tmpl.html','<table class="md-table"><thead><tr><th ng-repeat="column in columns" ng-click="sortClick(column.field)" ng-class="headerClass(column.field)"><md-icon ng-show="showSortOrder(column.field, true)" class="zmdi-hc-rotate-90" md-font-icon="zmdi zmdi-arrow-back"></md-icon><md-icon ng-show="showSortOrder(column.field, false)" class="zmdi-hc-rotate-270" md-font-icon="zmdi zmdi-arrow-back"></md-icon><span>{{column.title | triTranslate}}</span></th></tr></thead><tbody><tr ng-repeat="content in contents | filter:filters | startFrom:page * pageSize | limitTo: pageSize"><td ng-repeat="column in columns" ng-bind-html="cellContents(column, content)" ng-class="column.field + \'-cell\'"></td></tr></tbody><tfoot><tr><td colspan="{{columns.length}}"><div class="md-table-footer" layout="row" layout-align="end center"><div class="md-table-page-select" layout="row" layout-align="center center"><span translate>Rows per page:</span><md-select ng-model="pageSize" ng-change="refresh(true)"><md-option value="5">5</md-option><md-option value="10">10</md-option><md-option value="25">25</md-option><md-option value="50">50</md-option><md-option value="100">100</md-option></md-select></div><span class="md-table-info">{{pageStart()}} - {{pageEnd()}} <span translate>of</span> {{totalItems()}}</span><div class="md-table-page-nav"><md-button ng-disabled="page == 0" ng-click="page = page - 1" aria-label="{{\'Previous Page\' | triTranslate}}" class="md-primary md-icon-button"><md-icon md-font-icon="zmdi zmdi-chevron-left"></md-icon></md-button><md-button ng-disabled="page == numberOfPages() - 1" ng-click="page = page + 1" aria-label="{{\'Next Page\' | triTranslate}}" class="md-primary md-icon-button"><md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon></md-button></div></div></td></tr></tfoot></table>');
$templateCache.put('core/components/spinkit/chasingDotsSpinner.html','<div class="chasing-dots-spinner"><div md-colors="{ background: \'primary\' }" class="dot1"></div><div md-colors="{ background: \'primary\' }" class="dot2"></div></div>');
$templateCache.put('core/components/spinkit/circleSpinner.html','<div class="spinning-dots-spinner"><div class="spinner-container container1"><div md-colors="{ background: \'primary\' }" class="circle1"></div><div md-colors="{ background: \'primary\' }" class="circle2"></div><div md-colors="{ background: \'primary\' }" class="circle3"></div><div md-colors="{ background: \'primary\' }" class="circle4"></div></div><div class="spinner-container container2"><div md-colors="{ background: \'primary\' }" class="circle1"></div><div md-colors="{ background: \'primary\' }" class="circle2"></div><div md-colors="{ background: \'primary\' }" class="circle3"></div><div md-colors="{ background: \'primary\' }" class="circle4"></div></div><div class="spinner-container container3"><div md-colors="{ background: \'primary\' }" class="circle1"></div><div md-colors="{ background: \'primary\' }" class="circle2"></div><div md-colors="{ background: \'primary\' }" class="circle3"></div><div md-colors="{ background: \'primary\' }" class="circle4"></div></div></div>');
$templateCache.put('core/components/spinkit/cubeGridSpinner.html','<div class="cube-grid-spinner"><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div><div md-colors="{ background: \'primary\' }" class="cube"></div></div>');
$templateCache.put('core/components/spinkit/doubleBounceSpinner.html','<div class="double-bounce-spinner"><div md-colors="{ background: \'primary\' }" class="double-bounce1"></div><div md-colors="{ background: \'primary\' }" class="double-bounce2"></div></div>');
$templateCache.put('core/components/spinkit/fadingCircleSpinner.html','<div class="fading-circle-spinner"><div md-colors="{ background: \'primary\' }" class="fading-circle1 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle2 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle3 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle4 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle5 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle6 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle7 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle8 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle9 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle10 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle11 fading-circle"></div><div md-colors="{ background: \'primary\' }" class="fading-circle12 fading-circle"></div></div>');
$templateCache.put('core/components/spinkit/pulseSpinner.html','<div md-colors="{ background: \'primary\' }" class="pulse-spinner"></div>');
$templateCache.put('core/components/spinkit/rotatingPlaneSpinner.html','<div md-colors="{ background: \'primary\' }" class="three-dots-row-spinner"></div>');
$templateCache.put('core/components/spinkit/threeBounceSpinner.html','<div class="three-bounce-spinner"><div md-colors="{ background: \'primary\' }" class="bounce1"></div><div md-colors="{ background: \'primary\' }" class="bounce2"></div><div md-colors="{ background: \'primary\' }" class="bounce3"></div></div>');
$templateCache.put('core/components/spinkit/wanderingCubesSpinner.html','<div md-colors="{ background: \'primary\' }" class="wandering-cubes-spinner"></div>');
$templateCache.put('core/components/spinkit/waveSpinner.html','<div class="wave-spinner"><div md-colors="{ background: \'primary\' }" class="rect1"></div><div md-colors="{ background: \'primary\' }" class="rect2"></div><div md-colors="{ background: \'primary\' }" class="rect3"></div><div md-colors="{ background: \'primary\' }" class="rect4"></div><div md-colors="{ background: \'primary\' }" class="rect5"></div></div>');
$templateCache.put('core/components/spinkit/wordPressSpinner.html','<div class="word-press-spinner"><span md-colors="{ background: \'primary\' }" class="inner-circle"></span></div>');
$templateCache.put('core/components/tabs/tabs-widget.tmpl.html','<md-card class="no-padding-card"><md-card-content><md-tabs md-dynamic-height md-border-bottom><md-tab label="language"><md-content><md-table-container><table md-table class="md-data-table"><thead md-head md-order="vm.tableQueries.languages.order"><tr md-row><th md-column md-order-by="language">Language</th><th md-column md-numeric md-order-by="sessions">Sessions</th><th md-column md-numeric md-desc md-order-by="percent">% Sessions</th></tr></thead><tbody md-body><tr md-row ng-repeat="language in vm.languages | orderBy: vm.tableQueries.languages.order | limitTo: vm.tableQueries.languages.limit : (vm.tableQueries.languages.page -1) * vm.tableQueries.languages.limit"><td md-cell>{{::language.language}}</td><td md-cell>{{::language.sessions | number}}</td><td md-cell>{{::language.percent}}%</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.tableQueries.languages.limit" md-page="vm.tableQueries.languages.page" md-total="{{vm.languages.length}}" md-page-select md-boundary-links="true"></md-table-pagination></md-content></md-tab><md-tab label="country"><md-content><md-table-container><table md-table class="md-data-table"><thead md-head md-order="vm.tableQueries.countries.order"><tr md-row><th md-column md-order-by="language">Language</th><th md-column md-numeric md-order-by="sessions">Sessions</th><th md-column md-numeric md-desc md-order-by="percent">% Sessions</th></tr></thead><tbody md-body><tr md-row ng-repeat="country in vm.countries | orderBy: vm.tableQueries.countries.order | limitTo: vm.tableQueries.countries.limit : (vm.tableQueries.countries.page -1) * vm.tableQueries.countries.limit"><td md-cell>{{::country.country}}</td><td md-cell>{{::country.sessions}}</td><td md-cell>{{::country.percent}}%</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.tableQueries.countries.limit" md-page="vm.tableQueries.countries.page" md-total="{{vm.countries.length}}" md-page-select md-boundary-links="true"></md-table-pagination></md-content></md-tab></md-tabs></md-card-content></md-card>');
$templateCache.put('core/components/toolbars/profile-menu.tmpl.html','<div ng-if="::!isMasterWorkspace && !isWorkspaceAdmin"><md-menu md-offset="0 60"><md-button aria-label="Open user menu" ng-click="$mdMenu.open()" aria-label="side navigation"><img class="toolbar-user-avatar" ng-src="{{vm.pictureUrl}}"> {{vm.currentUser.displayName}}</md-button><md-menu-content width="4" ng-mouseleave="$mdMenu.close()"><md-menu-item ng-if="::!isMasterWorkspace && !isWorkspaceAdmin"><md-button ui-sref="storm.todo" aria-label="side navigation"><md-icon md-font-icon="zmdi zmdi-assignment-check"></md-icon><span translate="To-Do"></span></md-button></md-menu-item><md-menu-item ng-if="::!isMasterWorkspace && !isWorkspaceAdmin"><md-button ui-sref="storm.boards({id: \'me\'})" ng-click="vm.toggleToolBarMenu(\'Profile\')" aria-label="side navigation"><md-icon md-font-icon="fa fa-thumb-tack"></md-icon><span translate="Boards"></span></md-button></md-menu-item><md-menu-item ng-if="::!isMasterWorkspace && !isWorkspaceAdmin"><md-button ui-sref="storm.uploads({id: \'me\'})" aria-label="side navigation"><md-icon md-font-icon="fa fa-upload"></md-icon><span translate="Uploads"></span></md-button></md-menu-item><md-divider></md-divider><md-menu-item ng-if="::!isMasterWorkspace && !isWorkspaceAdmin"><md-button ui-sref="storm.profile.overview({id: \'me\'})" ng-click="vm.toggleToolBarMenu(\'Profile\')" aria-label="side navigation"><img class="toolbar-user-avatar" ng-src="{{vm.pictureUrl}}"> <span class="margin-left-20" translate="Profile"></span></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.logout()" aria-label="side navigation"><md-icon md-font-icon="zmdi zmdi-sign-in"></md-icon><span>Sign out</span></md-button></md-menu-item></md-menu-content></md-menu></div>');
$templateCache.put('core/components/toolbars/toolbar.tmpl.html','<div ng-if="vm.isTabMenu && layout.showToolbar" layout="row" class="md-toolbar-tools md-whiteframe-z1" ng-style="{\'margin-bottom\': \'3\' + \'px\'}"><md-button class="md-icon-button" ng-if="!vm.hideMenuButton()" ng-click="vm.openSideNav(\'left\')" aria-label="side navigation"><md-icon md-font-icon="zmdi zmdi-menu"></md-icon></md-button><md-tabs flex><md-tab ng-repeat="child in vm.selectedMenu.children" ui-sref="{{child.state}}" ng-if="child.active && vm.hasMenuPermission(child) && vm.isFeatureActive(child)" md-active="vm.isActiveMenu(child.state)"><md-tab-label><md-icon ng-if="::(child.icon !== undefined)" class="side-menu-icon" md-font-icon="{{::child.icon}}"></md-icon><span>{{child.name}}</span></md-tab-label></md-tab></md-tabs></div>');
$templateCache.put('core/components/upload/upload.tmpl.html','<!-- upload using click from local drive --><div ng-if="fpUploadType === \'basic\' && !(fpEnablePreview && showImage())"><md-button class="{{fpAllButtonColorClass}}" ng-if="fpAllowMediaSelection" ng-click="openMediaSelector()"><md-icon md-font-icon class="zmdi zmdi-image"></md-icon></md-button><md-button class="md-icon-button" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><md-icon md-font-icon ng-class="{ \'{{fpUploadIconClass}}\': status == \'idle\', \'fa fa-spinner fa-pulse\': status == \'uploading\', \'zmdi zmdi-check\': status == \'complete\', \'{{fpAllButtonColorClass}}\' : true}"></md-icon></md-button></div><div ng-if="fpUploadType === \'basicCircular\' && !(fpEnablePreview && showImage())" class="circular-fpupload-container" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><div><img src="../../../assets/images/app/file-upload-icon.svg" ng-class="{ \'{{fpUploadIconClass}}\': status == \'idle\',\n             \'fa fa-spinner fa-pulse\': status == \'uploading\',\n             \'zmdi zmdi-check\': status == \'complete\', \'{{fpAllButtonColorClass}}\' : true}"></div><span class="edit-image-icon"><md-icon class="zmdi zmdi-edit"></md-icon></span></div><!-- upload using dragdrop and pickfrom local drive --><div ng-if="fpUploadType === \'dropAndPick\' && !(fpEnablePreview && showImage())" class="fp-drop-box" ngf-drop="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload" ngf-drag-over-class="{accept:\'dragover\', reject:\'dragover-err\', pattern:{{fpPattern}}}"><div layout="row" layout-align="center"><span class="md-body-2" translate="upload.pickAFile">Pick a File</span></div><div layout="row" layout-align="center"><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" ng-if="fpAllowMediaSelection" ng-click="openMediaSelector()"><md-icon md-font-icon class="zmdi zmdi-image"></md-icon></md-button><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><md-icon md-font-icon ng-class="{ \'{{fpUploadIconClass}}\': status == \'idle\', \'fa fa-spinner fa-pulse\': status == \'uploading\', \'zmdi zmdi-check\': status == \'complete\'}"></md-icon></md-button></div><div layout="row" layout-align="center"><span class="md-body-2" translate="upload.dragAndDrop">or drag and drop</span></div></div><!-- upload using drag and drop from local drive --><div ng-if="fpUploadType === \'drop\' && !(fpEnablePreview && showImage())" class="fp-drop-box" ngf-drop="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload" ngf-drag-over-class="{accept:\'dragover\', reject:\'dragover-err\', pattern:{{fpPattern}}}"><div layout="row" layout-align="center"><span class="md-body-2" translate="upload.pickAFile">Pick a File</span></div><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><md-icon md-font-icon ng-class="{ \'{{fpUploadIconClass}}\': status == \'idle\', \'fa fa-spinner fa-pulse\': status == \'uploading\', \'zmdi zmdi-check\': status == \'complete\'}"></md-icon></md-button><div layout="row" layout-align="center"><span class="md-body-2" translate="upload.dragAndDrop">or drag and drop</span></div></div><!-- upload using could upload --><div ng-if="fpUploadType === \'cloud\'"><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-icon-button" ng-click="pickFile()"><md-icon md-font-icon class="zmdi zmdi-cloud-upload"></md-icon></md-button></div><!-- upload using button click, drag and drop or cloud upload --><div ng-if="fpUploadType === \'smart\'" layout-fill layout-align="center center"><div layout-padding ng-if="status === \'idle\'"><div layout="column" ng-disabled="status != \'idle\'" aria-label="upload"><div layout="row" layout-align="center" layout-padding><span class="md-headline" translate="upload.upload" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">Upload {{fpSmartUploadLabel}}</span></div><div layout="row" layout-align="center" ng-if="fpSupportedFileTypes" class="padding-bottom-20" ng-style="{\'color\': \'#bdbdbd\'}"><span translate="upload.supportedFileTypes">Supported file types: </span><span class="text-uppercase">&nbsp;{{isChecked ? "pdf" : fpSupportedFileTypes}}</span></div><div layout="row" ng-if="fpContentType === \'document\' && fpProcessDocument === \'true\'" layout-align="center"><div layout="column" layout-align="space-between center" class="margin-bottom-20"><md-checkbox ng-model="isChecked" aria-label="process documents for copilot" class="margin-bottom-0" ng-change="updateState(event)"><span translate="atheer.content.processDocumentCopilot">Process document for Copilot</span></md-checkbox><div layout-align="start center" ng-if="isChecked" layout="row" layout-align="center" class="margin-right-10" style="max-width: 450px;"><div class="margin-right-10"><md-icon md-font-icon="fa fa-tags"></md-icon><span flex class="md-body-2" translate="atheer.content.tags">Tags</span></div><md-chips class="margin-right-10" flex ng-model="documentTags" md-enable-chip-edit="true" md-removable="true" placeholder="{{\'atheer.content.enterTag\' | translate}}" delete-button-label="Remove Tag" delete-hint="Press delete to remove tag" secondary-placeholder="{{\'atheer.content.tag\' | translate}}"></md-chips></div></div></div><div layout="row" layout-align="center" ng-class="fpSmartUploadBackground == null ? \'upload-background\' : fpSmartUploadBackground" layout-padding></div><div layout="row" layout-align="center" class="margin-bottom-0 margin-top-20"><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-raised" ng-click="pickCloudFile()" aria-label="upload"><span translate="upload.selectToUpload" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">Select {{fpSmartUploadLabel}} to Upload</span></md-button></div><div layout="row" layout-align="center" layout-padding><span class="md-body-2" translate="upload.uploadFromCloud" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">or upload {{fpSmartUploadLabel}} from the cloud</span></div><div class="cloud-upload-background margin-bottom-20" layout-align="center" ng-click="pickCloudFile()"></div></div></div><div layout-padding ng-if="status === \'uploading\' && showUploadProgress"><div layout="column" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-headline" translate="upload.uploading" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\', uploadPercentage: \'{{uploadPercentage}}\'}">{{fpSmartUploadLabel}} is uploading...{{uploadPercentage}}%.</span><div layout="row" layout-align="center" class="margin-top-40"><md-progress-linear md-mode="determinate" value="{{uploadPercentage}}"></md-progress-linear></div></div></div><div layout-padding ng-if="status === \'uploading\' && !showUploadProgress"><div layout="column" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-headline" translate="upload.uploadingPleaseWait" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">{{fpSmartUploadLabel}} is uploading. Please wait ...</span><div layout="row" layout-align="center" class="margin-top-40"><md-progress-linear md-mode="indeterminate"></md-progress-linear></div></div></div><div layout-padding ng-if="status === \'complete\'"><div layout="column" layout-align="center center" class="margin-top-40 margin-bottom-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><span class="md-headline" translate="upload.uploadComplete" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">{{fpSmartUploadLabel}} Upload Complete.</span></div></div><div layout-padding ng-if="status === \'error\'" class="margin-top-40 margin-bottom-40"><div layout="column" layout-align="center center"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><span class="md-headline" translate="upload.uploadError" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">Error Occured while uploading {{fpSmartUploadLabel}}. <a href="#" ng-click="uploadReset(); $event.preventDefault()"><span translate="upload.tryAgain">Try Again</span></a></span></div></div></div><!-- upload using button click, drag and drop or cloud upload --><div ng-if="fpUploadType === \'local\'" layout-fill layout-align="center center"><div layout-padding ng-if="status === \'idle\'"><div layout="column" ng-disabled="status != \'idle\'" aria-label="upload"><div layout="row" layout-align="center" layout-padding><span class="md-headline" translate="upload.upload" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">Upload {{fpSmartUploadLabel}}</span></div><div layout="row" layout-align="center" ng-class="fpSmartUploadBackground == null ? \'upload-background\' : fpSmartUploadBackground" layout-padding></div><div layout="row" layout-align="center" class="margin-bottom-0 margin-top-20"><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-raised" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><span translate="upload.selectToUpload" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">Select {{fpSmartUploadLabel}} to Upload</span></md-button></div></div></div><div layout-padding ng-if="status === \'uploading\' && showUploadProgress"><div layout="column" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-headline" translate="upload.uploading" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\', uploadPercentage: \'{{uploadPercentage}}\'}">{{fpSmartUploadLabel}} is uploading...{{uploadPercentage}}%.</span><div layout="row" layout-align="center" class="margin-top-40"><md-progress-linear md-mode="determinate" value="{{uploadPercentage}}"></md-progress-linear></div></div></div><div layout-padding ng-if="status === \'uploading\' && !showUploadProgress"><div layout="column" layout-align="center" class="margin-top-40 margin-bottom-40"><span class="md-headline" translate="upload.uploadingPleaseWait" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">{{fpSmartUploadLabel}} is uploading. Please wait ...</span><div layout="row" layout-align="center" class="margin-top-40"><md-progress-linear md-mode="indeterminate"></md-progress-linear></div></div></div><div layout-padding ng-if="status === \'complete\'"><div layout="column" layout-align="center center" class="margin-top-40 margin-bottom-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><span class="md-headline" translate="upload.uploadComplete" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">{{fpSmartUploadLabel}} Upload Complete.</span></div></div><div layout-padding ng-if="status === \'error\'" class="margin-top-40 margin-bottom-40"><div layout="column" layout-align="center center"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><span class="md-headline" translate="upload.uploadError" translate-values="{fpSmartUploadLabel: \'{{fpSmartUploadLabel}}\'}">Error Occured while uploading {{fpSmartUploadLabel}}. <a href="#" ng-click="uploadReset(); $event.preventDefault()"><span translate="upload.tryAgain">Try Again</span></a></span></div></div></div><!-- Image Preview --><div ng-if="fpEnablePreview && fpUploadType !== \'basicCircular\' && fpContentType !== \'file\'" layout="row" flex ng-show="showImage()" class="fp-file-upload-preview" layout-align="center center"><img class="image" ng-class="{\'{{fpPreviewImageClass}}\' : true}" height="{{previewWidth || \'150px\'}}" ng-src="{{getPreviewUrl()}}"><div class="actions" ng-if="status == \'idle\'" layout-align="space-around center" layout="row" aria-label="primary button"><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-icon-button md-raised" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><fp-tooltip placement="top"><span translate="upload.change">Change</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-edit"></md-icon></md-button><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-icon-button md-raised" ng-click="removeImage()" aria-label="remove"><fp-tooltip placement="top"><span translate="upload.remove">Remove</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-delete"></md-icon></md-button></div><md-icon ng-if="status != \'idle\'" class="uploading" md-font-icon ng-class="{\'fa fa-spinner fa-pulse\': status == \'uploading\', \'zmdi zmdi-check\': status == \'complete\'}"></md-icon></div><div ng-if="fpEnablePreview && fpUploadType === \'basicCircular\'" layout="row" flex ng-show="showImage()" class="fp-file-upload-preview circular-fpupload-container" layout-align="center center"><div><img class="image" ng-class="{\'{{fpPreviewImageClass}}\' : true}" height="{{previewWidth || \'150px\'}}" ng-src="{{getPreviewUrl()}}"><div class="actions" ng-if="status == \'idle\'" layout-align="space-around center" layout="row" aria-label="primary button"><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-icon-button md-raised" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><fp-tooltip placement="top"><span translate="upload.change">Change</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-edit"></md-icon></md-button><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-icon-button md-raised" ng-click="removeImage()" aria-label="remove"><fp-tooltip placement="top"><span translate="upload.remove">Remove</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-delete"></md-icon></md-button></div><md-icon ng-if="status != \'idle\'" class="uploading" md-font-icon ng-class="{\'fa fa-spinner fa-pulse\': status == \'uploading\', \'zmdi zmdi-check\': status == \'complete\'}"></md-icon></div></div><!-- Lens Home Page Config Preview --><div flex layout="row" layout-align="space-between center" ng-if="fpEnablePreview && fpUploadType !== \'basicCircular\' && fpContentType === \'file\'" class="fp-drop-box fp-file-container" ng-show="showImage()"><span ng-click="downloadConfigFile()"><md-icon md-colors="{fill: \'primary\'}" class="session-icon" md-svg-icon="/assets/images/card/config_attachment_icon.svg"></md-icon><span class="download-link" md-colors="{color:\'primary\'}">{{getFileName()}}</span> </span><span class="actions"><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-icon-button md-raised" ngf-select="upload($files)" ng-disabled="status != \'idle\'" ngf-multiple="{{fpMultiple}}" ngf-pattern="{{fpPattern}}" ngf-accept="{{fpAcceptedType}}" ngf-max-size="{{fpMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'" aria-label="upload"><fp-tooltip placement="top"><span translate="upload.change">Change</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-edit"></md-icon></md-button><md-button ng-class="{\'{{fpAllButtonColorClass}}\' : true}" class="md-icon-button md-raised" ng-click="removeFile()" aria-label="remove"><fp-tooltip placement="top"><span translate="upload.remove">Remove</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-delete"></md-icon></md-button></span><md-icon ng-if="status != \'idle\'" class="uploading" md-font-icon ng-class="{\'fa fa-spinner fa-pulse\': status == \'uploading\', \'zmdi zmdi-check\': status == \'complete\'}"></md-icon></div>');
$templateCache.put('core/components/widget/widget.tmpl.html','<div class="widget md-whiteframe-z2" ng-class="::{\'widget-overlay-title\': vm.overlayTitle}" flex layout="{{vm.widgetLayout}}"><div class="widget-title" ng-if="::(vm.title || vm.subtitle)" layout="row" layout-padding layout-align="start center" flex-order="{{vm.titleOrder}}"><div ng-if="::vm.avatar"><img ng-src="{{::vm.avatar}}" class="widget-avatar"></div><div flex layout="column"><h3 class="md-title" ng-if="::vm.title" translate>{{::vm.title}}</h3><p class="md-body-1" ng-if="::vm.subtitle" translate>{{::vm.subtitle}}</p></div><md-menu ng-if="::vm.menu"><md-button class="widget-button md-icon-button" ng-click="$mdMenu.open()" aria-label="open menu"><md-icon md-font-icon="{{::vm.menu.icon}}"></md-icon></md-button><md-menu-content><md-menu-item ng-repeat="item in ::vm.menu.items"><md-button ng-click="item.click($event)"><md-icon ng-if="::item.icon" md-font-icon="{{::item.icon}}"></md-icon><span translate>{{::item.title}}</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class="widget-content" layout="{{vm.contentLayout}}" layout-align="{{vm.contentLayoutAlign}}" ng-class="{\'layout-padding\': vm.contentPadding}" ng-transclude flex-order="{{vm.contentOrder}}"></div><div class="widget-loading ng-hide" ng-show="vm.loading" layout layout-fill layout-align="center center"><div class="widget-loading-inner" ng-show="vm.loading"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div>');
$templateCache.put('modules/cloud/configuration/configuration.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><fp-toggle></fp-toggle><h2 hide-xs flex><span translate="atheer.configuration.title">Configuration</span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.configuration.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><div class="md-padding"><table md-table class="md-primary md-data-table table-responsive" ng-hide="filteredConfig.length == 0"><thead md-head><tr md-row><th md-column ng-click="predicate = \'prefix\'; reverse=!reverse"><span translate="atheer.configuration.table.prefix">Prefix</span></th><th md-column><span translate="atheer.configuration.table.properties">Properties</span></th></tr></thead><tr md-row ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td md-cell><span>{{entry.prefix}}</span></td><td md-cell><div class="row" ng-repeat="(key, value) in entry.properties"><div>{{key}}</div><div><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table md-table class="md-primary md-data-table table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead md-head><tr md-row><th md-cell><span translate="atheer.configuration.table.property">Property</span></th><th md-cell><span translate="atheer.configuration.table.value">Value</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="item in filtered = (value | filter:filter)"><td md-cell>{{item.key}}</td><td md-cell><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div></md-content></div>');
$templateCache.put('modules/cloud/health/health.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><fp-toggle></fp-toggle><h2 hide-xs flex><span translate="atheer.health.homeTitle">Health</span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.health.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><div class="md-padding"><table md-table id="healthCheck" class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.health.table.service">Service Name</span></th><th md-column><span translate="atheer.health.table.status">Status</span></th><th md-column><span translate="atheer.health.details.details">Details</span></th></tr></thead><tbody md-head><tr ng-repeat="health in vm.healthData"><td md-cell>{{\'atheer.health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td md-cell><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'atheer.health.status.\' + health.status | translate}}</span></td><td md-cell><!-- <a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error">\n                          <i class="glyphicon glyphicon-eye-open"></i>\n                      </a> --><md-button class="md-icon-button md-cyan-theme icon-size hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><md-icon md-font-icon="zmdi zmdi-eye"></md-icon></md-button></td></tr></tbody></table></div></md-content></div>');
$templateCache.put('modules/cloud/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'atheer.health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="atheer.health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="atheer.health.details.name">Name</th><th class="col-md-6 text-left" translate="atheer.health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="atheer.health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()" translate="entity.action.done">Done</button></div>');
$templateCache.put('modules/cloud/job-stream/job-stream-dialog.html','<md-dialog aria-label="JobStream Detail" flex="30" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="vm.jobStream.id !== null"><h2 id="myJobStreamLabel" translate="atheer.jobStream.home.editLabel">Edit a JobStream</h2></div><div ng-if="vm.jobStream.id == null"><h2 id="myJobStreamLabel" translate="atheer.jobStream.home.createLabel">Create a JobStream</h2></div><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><div><input type="hidden" id="id" name="id" ng-model="vm.jobStream.id" readonly="readonly"></div><md-input-container class="md-block"><label class="md-required" translate="atheer.jobStream.scheduleNo" for="field_scheduleNo">ScheduleNo</label> <input type="number" class="form-control" name="scheduleNo" id="field_scheduleNo" ng-model="vm.jobStream.schedule_no" required><div ng-messages="editForm.scheduleNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.jobStream.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.jobStream.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.jobStream.type" for="field_type">Type</label> <input type="text" class="form-control" name="type" id="field_type" ng-model="vm.jobStream.type" required><div ng-messages="editForm.type.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.jobStream.status" for="field_status">Status</label><md-select name="status" ng-model="vm.jobStream.status" id="field_status" required><md-option value="ACTIVE" translate="atheer.JobStreamStatus.active">ACTIVE</md-option><md-option value="INACTIVE" translate="atheer.JobStreamStatus.inActive">INACTIVE</md-option><md-option value="DELETED" translate="atheer.JobStreamStatus.deleted">DELETED</md-option></md-select><div ng-messages="editForm.status.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-checkbox name="quartzStatus" id="field_quartzStatus" class="md-primary" ng-model="vm.jobStream.quartz_status" aria-label="Primary Checkbox"><span translate="atheer.jobStream.quartzStatus" for="field_quartzStatus" for="field_quartzStatus">QuartzStatus</span></md-checkbox><div ng-messages="editForm.quartzStatus.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div><md-input-container class="md-block"><label class="md-required" translate="atheer.jobStream.triggerInfo" for="field_triggerInfo">TriggerInfo</label> <input type="text" class="form-control" name="triggerInfo" id="field_triggerInfo" ng-model="vm.jobStream.trigger_info" required><div ng-messages="editForm.triggerInfo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.jobStream.ownerId" for="field_ownerId">OwnerId</label> <input type="text" class="form-control" name="ownerId" id="field_ownerId" ng-model="vm.jobStream.owner_id" required><div ng-messages="editForm.ownerId.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.jobStream.workspaceId" for="field_workspaceId">WorkspaceId</label> <input type="text" class="form-control" name="workspaceId" id="field_workspaceId" ng-model="vm.jobStream.workspace_id" required><div ng-messages="editForm.workspaceId.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid || isSaving" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/cloud/job-stream/job-streams.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><fp-toggle></fp-toggle><h2 hide-xs flex><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{ \'atheer.jobStream.enterSearch\' | translate }}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.jobStream.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.jobStream.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.jobStream.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column md-order-by="jobStreamNo"><span translate="atheer.jobStream.jobNo">Job No</span></th><th md-column md-order-by="type"><span translate="atheer.jobStream.type">Type</span></th><th md-column md-order-by="status"><span translate="atheer.jobStream.status">Status</span></th><th md-column md-order-by="triggerInfo"><span translate="atheer.jobStream.triggerInfo">TriggerInfo</span></th><th md-column md-order-by="ownerId"><span translate="atheer.jobStream.ownerId">OwnerId</span></th><th md-column md-order-by="workspaceId"><span translate="atheer.jobStream.workspaceId">WorkspaceId</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="jobStream in vm.jobStreams track by jobStream.id"><td md-cell>{{jobStream.job_stream_no}}</td><td md-cell>{{jobStream.type}}</td><td md-cell>{{jobStream.status}}</td><td md-cell>{{jobStream.trigger_info}}</td><td md-cell>{{jobStream.owner_id}}</td><td md-cell>{{jobStream.workspace_id}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(jobStream.id)"><md-icon class="zmdi zmdi-eye icon-size"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/cloud/logs/logs.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><fp-toggle></fp-toggle><h2 hide-xs flex><span translate="atheer.logs.homeTitle" translate-values="{loggersLength: \'{{vm.loggers.length}}\'}">Logs - There are {{ vm.loggers.length }} loggers.</span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.logs.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><div class="md-padding"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row title="click to order"><th md-column ng-click="predicate = \'name\'; reverse=!reverse"><span translate="atheer.logs.table.name">Name</span></th><th md-column ng-click="predicate = \'level\'; reverse=!reverse"><span translate="atheer.logs.table.level">Level</span></th></tr></thead><tr md-row ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td md-cell>{{logger.name | characters:140}}</td><td md-cell><md-button class="md-flat" ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'md-warn\' : \'md-primary\'" translate="entity.action.trace">TRACE</md-button><md-button class="md-flat" ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'md-warn\' : \'md-primary\'" translate="entity.action.debug">DEBUG</md-button><md-button class="md-flat" ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'md-warn\' : \'md-primary\'" translate="entity.action.info">INFO</md-button><md-button class="md-flat" ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'md-warn\' : \'md-primary\'" translate="entity.action.warn">WARN</md-button><md-button class="md-flat" ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'md-warn\' : \'md-primary\'" translate="entity.action.error">ERROR</md-button></td></tr></table></md-table-container></div></md-content></div>');
$templateCache.put('modules/cloud/metrics/metrics.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><fp-toggle></fp-toggle><h2 hide-xs flex><span translate="atheer.metrics.homeTitle">Metrics</span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.metrics.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><div class="md-padding"><h3 translate="atheer.metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div layout="column"><b translate="atheer.metrics.jvm.memory.title">Memory</b><p><span translate="atheer.metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'jvm.memory.total.used\'].value/vm.metrics.gauges[\'jvm.memory.total.max\'].value*100}}"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></md-progress-linear><p><span translate="atheer.metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value/vm.metrics.gauges[\'jvm.memory.heap.max\'].value*100}}"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value/vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></md-progress-linear><p><span translate="atheer.metrics.jvm.memory.nonHeap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value/vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value*100}}"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value/vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></md-progress-linear></div><div layout="column" class="margin-top-20"><div layout="row" layout-align="start center"><b translate="atheer.metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}})<md-button class="md-icon-button" aria-label="primary button" ng-click="vm.refreshThreadDumpData()"><md-icon md-font-icon="zmdi zmdi-eye"></md-icon></md-button></div><p><span translate="atheer.metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value}}"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></md-progress-linear><p><span translate="atheer.metrics.jvm.threads.timedWaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value}}"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></md-progress-linear><p><span translate="atheer.metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value}}"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></md-progress-linear><p><span translate="atheer.metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value }}"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></md-progress-linear></div><div layout="column" class="margin-top-20"><b translate="atheer.metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="atheer.metrics.jvm.gc.markSweepCount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="atheer.metrics.jvm.gc.markSweepTime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="atheer.metrics.jvm.gc.scavengeCount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="atheer.metrics.jvm.gc.scavengeTime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="atheer.metrics.updating">Updating...</div><h3 translate="atheer.metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="atheer.metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="atheer.metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.metrics.jvm.http.table.code">Code</span></th><th md-column><span translate="atheer.metrics.jvm.http.table.count">Count</span></th><th md-column><span translate="atheer.metrics.jvm.http.table.mean">Mean</span></th><th md-column><span translate="atheer.metrics.jvm.http.table.average">Average</span> (1 min)</th><th md-column><span translate="atheer.metrics.jvm.http.table.average">Average</span> (5 min)</th><th md-column><span translate="atheer.metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody md-head><tr md-row><td md-cell translate="atheer.metrics.jvm.http.code.ok">OK</td><td md-cell><md-progress-linear md-mode="determinate" value="{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count * 100 / vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></md-progress-linear></td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr md-row><td md-cell translate="atheer.metrics.jvm.http.code.notFound">Not Found</td><td md-cell><md-progress-linear md-mode="determinate" value="{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count * 100 / vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></md-progress-linear></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr md-row><td md-cell translate="atheer.metrics.jvm.http.code.serverError">Server error</td><td md-cell><md-progress-linear md-mode="determinate" value="{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count * 100 / vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></md-progress-linear></td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td md-cell>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="atheer.metrics.servicesStats.title">Services statistics (time in millisecond)</h3><div><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.metrics.servicesStats.table.name">Service name</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.count">Count</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.mean">Mean</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.min">Min</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.p50">p50</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.p75">p75</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.p95">p95</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.p99">p99</span></th><th md-column><span translate="atheer.metrics.servicesStats.table.max">Max</span></th></tr></thead><tbody md-head><tr md-row ng-repeat="(k, v) in vm.servicesStats"><td md-cell>{{k}}</td><td md-cell>{{v.count}}</td><td md-cell>{{v.mean * 1000 | number:0}}</td><td md-cell>{{v.min * 1000 | number:0}}</td><td md-cell>{{v.p50 * 1000 | number:0}}</td><td md-cell>{{v.p75 * 1000 | number:0}}</td><td md-cell>{{v.p95 * 1000 | number:0}}</td><td md-cell>{{v.p99 * 1000 | number:0}}</td><td md-cell>{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0" translate="atheer.metrics.dataSourceStatistics.one">DataSource 1 statistics (time in millisecond)</h3><div ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.metrics.dataSource.usage">Usage </span>({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th md-column><span translate="atheer.metrics.dataSource.count">Count</span></th><th md-column><span translate="atheer.metrics.dataSource.mean">Mean</span></th><th md-column><span translate="atheer.metrics.dataSource.min">Min</span></th><th md-column><span translate="atheer.metrics.dataSource.p50">p50</span></th><th md-column><span translate="atheer.metrics.dataSource.p75">p75</span></th><th md-column><span translate="atheer.metrics.dataSource.p95">p95</span></th><th md-column><span translate="atheer.metrics.dataSource.p99">p99</span></th><th md-column><span translate="atheer.metrics.dataSource.max">Max</span></th></tr></thead><tbody md-head><tr md-row><td md-cell><div class="progress progress-striped"><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}}"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></md-progress-linear></div></td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-2.pool.TotalConnections\'].value > 0" translate="atheer.metrics.dataSourceStatistics.two">DataSource 2 statistics (time in millisecond)</h3><div ng-show="vm.metrics.gauges[\'HikariPool-2.pool.TotalConnections\'].value > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.metrics.dataSource.usage">Usage </span>({{vm.metrics.gauges[\'HikariPool-2.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-2.pool.TotalConnections\'].value}})</th><th md-column><span translate="atheer.metrics.dataSource.count">Count</span></th><th md-column><span translate="atheer.metrics.dataSource.mean">Mean</span></th><th md-column><span translate="atheer.metrics.dataSource.min">Min</span></th><th md-column><span translate="atheer.metrics.dataSource.p50">p50</span></th><th md-column><span translate="atheer.metrics.dataSource.p75">p75</span></th><th md-column><span translate="atheer.metrics.dataSource.p95">p95</span></th><th md-column><span translate="atheer.metrics.dataSource.p99">p99</span></th><th md-column><span translate="atheer.metrics.dataSource.max">Max</span></th></tr></thead><tbody md-head><tr md-row><td md-cell><div class="progress progress-striped"><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'HikariPool-2.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-2.pool.TotalConnections\'].value}}"><span>{{vm.metrics.gauges[\'HikariPool-2.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-2.pool.TotalConnections\'].value | number:0}}%</span></md-progress-linear></div></td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].count}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].mean | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].min | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].p50 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].p75 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].p95 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].p99 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-2.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-3.pool.TotalConnections\'].value > 0" translate="atheer.metrics.dataSourceStatistics.three">DataSource 3 statistics (time in millisecond)</h3><div ng-show="vm.metrics.gauges[\'HikariPool-3.pool.TotalConnections\'].value > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.metrics.dataSource.usage">Usage </span>({{vm.metrics.gauges[\'HikariPool-3.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-3.pool.TotalConnections\'].value}})</th><th md-column><span translate="atheer.metrics.dataSource.count">Count</span></th><th md-column><span translate="atheer.metrics.dataSource.mean">Mean</span></th><th md-column><span translate="atheer.metrics.dataSource.min">Min</span></th><th md-column><span translate="atheer.metrics.dataSource.p50">p50</span></th><th md-column><span translate="atheer.metrics.dataSource.p75">p75</span></th><th md-column><span translate="atheer.metrics.dataSource.p95">p95</span></th><th md-column><span translate="atheer.metrics.dataSource.p99">p99</span></th><th md-column><span translate="atheer.metrics.dataSource.max">Max</span></th></tr></thead><tbody md-head><tr md-row><td md-cell><div class="progress progress-striped"><md-progress-linear md-mode="determinate" value="{{vm.metrics.gauges[\'HikariPool-3.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-3.pool.TotalConnections\'].value}}"><span>{{vm.metrics.gauges[\'HikariPool-3.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-3.pool.TotalConnections\'].value | number:0}}%</span></md-progress-linear></div></td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].count}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].mean | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].min | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].p50 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].p75 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].p95 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].p99 | number:2}}</td><td md-cell>{{vm.metrics.histograms[\'HikariPool-3.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></md-content></div>');
$templateCache.put('modules/cloud/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><md-dialog aria-label="App Detail" flex="80" flex-xs="100"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="atheer.metrics.modalTitle">Threads dump</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.cancel()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.metrics.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content" layout="column"><div layout="row" class="margin-bottom-40"><span class="label label-primary" ng-click="threadDumpFilter = {}"><span translate="atheer.metrics.jvm.threads.all">All</span>&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}"><span translate="atheer.metrics.jvm.threads.runnable">Runnable</span>&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}"><span translate="atheer.metrics.jvm.threads.waiting">Waiting</span>&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}"><span translate="atheer.metrics.jvm.threads.timedWaiting">Timed Waiting</span>&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}"><span translate="atheer.metrics.jvm.threads.blocked">Blocked</span>&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;</div><md-input-container flex="50"><label translate="atheer.metrics.filter">Filter</label> <input ng-model="threadDumpFilter"></md-input-container><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><div layout="row" layout-align="space-between center"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}})</h5><a ng-click="show = !show"><span ng-show="!show" translate="atheer.metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="atheer.metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></div><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.metrics.jvm.threads.dump.blockedTime">Blocked Time</span></th><th md-column><span translate="atheer.metrics.jvm.threads.dump.blockedCount">Blocked Count</span></th><th md-column><span translate="atheer.metrics.jvm.threads.dump.waitedTime">Waited Time</span></th><th md-column><span translate="atheer.metrics.jvm.threads.dump.waitedCount">Waited Count</span></th><th md-column><span translate="atheer.metrics.jvm.threads.dump.lockName">Lock Name</span></th></tr></thead><tbody md-head><tr md-row><td md-cell>{{v.blockedTime}}</td><td md-cell>{{v.blockedCount}}</td><td md-cell>{{v.waitedTime}}</td><td md-cell>{{v.waitedCount}}</td><td md-cell>{{v.lockName}}</td></tr></tbody></table></div><div layout="row" layout-align="end center"><md-button class="md-primary md-raised" md-ripple-size="auto" ng-click="vm.cancel()" translate="entity.action.done">Done</md-button></div></md-dialog-content></md-dialog>');
$templateCache.put('core/components/toggle/toggle.tmpl.html','<md-button class="md-icon-button" ng-click="toggleSideMenu()" aria-label="side navigation"><md-icon md-font-icon="{{key}}"></md-icon></md-button>');
$templateCache.put('core/components/rating/rating-directive.tmpl.html','<div style="display: inline-block; margin: 0px; padding: 3px; cursor:pointer;" ng-repeat="idx in maxRatings track by $index"><md-icon class="fp-rating-question-shape {{((hoverValue + _rating) <= $index) && ratingShape.emptyIconClass || ratingShape.fullIconClass}}" ng-style="{\'color\':color}" ng-click="isolatedClick($index + 1)" ng-mouseenter="isolatedMouseHover($index + 1)" ng-mouseleave="isolatedMouseLeave($index + 1)"></md-icon><fp-tooltip placement="bottom" ng-if="hoverTextArray && hoverTextArray.length == maxRatings">{{::hoverTextArray[$index]}}</fp-tooltip></div>');
$templateCache.put('modules/smartflow/datamodel/datamodel-create-dialog.html','<md-dialog aria-label="User Detail" flex="80" flex-gt-md="60"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><h2>{{vm.title}}</h2><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><div><md-input-container class="md-block"><label for="name">Name</label> <input type="text" class="form-control" name="name" ng-model="vm.displayName" required ng-maxlength="50"></md-input-container><div flex layout="row" ng-repeat="property in vm.propertyList track by $index"><md-input-container class="md-block" flex="40"><label for="property_name">Property Name</label> <input type="text" class="form-control" name="property_name" ng-model="property.name" required ng-maxlength="50"></md-input-container><md-input-container class="md-block" flex="40"><label for="data_type">Data Model</label><md-select name="data_type" ng-model="property.dataType" required><md-option ng-value="dataType.name" ng-repeat="dataType in vm.dataTypeList">{{dataType.name}}</md-option></md-select></md-input-container><div flex="15"><md-button class="md-icon-button margin-top-20" aria-label="primary button" ng-click="vm.add($index)"><md-icon class="zmdi zmdi-plus icon-size"></md-icon></md-button><md-button ng-hide="vm.propertyList.length == 1" class="md-icon-button margin-top-20" aria-label="primary button" ng-click="vm.remove($index)"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()">Cancel</md-button><md-button type="submit" ng-disabled="createDataModel.$invalid || isSaving" class="md-primary" ng-click="vm.save()">{{vm.isEditMode ? "Update" : "Create"}}</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/smartflow/datamodel/datamodel-detail.tmpl.html','<ng-include src="\'modules/smartflow/datamodel/datamodel-detail-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="35" flex-xl="25" class="md-whiteframe-z1"><md-content flex class="padded-content-page content-properties-container"><div ng-form="topicDetailForm"><md-input-container class="md-block content-title-input"><label>Topic Name</label> <input type="text" name="title" ng-model="vm.topicDataModel.name" md-select-on-focus required><div ng-messages="topicDetailForm.name.$error"><div ng-message when="required"><span>This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label>Description</label> <textarea name="description" ng-model="vm.topicDataModel.description" id="field_description" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><div layout="row" layout-align="space-between center"><span>Featured</span><md-switch name="featured" ng-model="vm.topicDataModel.featured"></md-switch></div><div layout="row" layout-align="space-between center"><span>Published</span><md-switch name="enabled" ng-model="vm.topicDataModel.enabled"></md-switch></div><div layout="row" layout-align="space-between center" ng-cloak ng-if="vm.topicType !== \'PAGE\'"><md-icon md-font-icon="zmdi zmdi-playlist-plus"></md-icon><span flex class="md-body-2">Parent Topic</span></div><div ng-if="vm.topicType !== \'PAGE\'"><fp-auto-complete no-label="true" auto-complete-model="vm.parentTopic" component="Topic" multiple="false" query-objs="[{fieldName:\'name\', operator:\'=re=\'}]"></fp-auto-complete></div><div ng-if="vm.topicType == \'PAGE\'"><div layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="zmdi zmdi-layers"></md-icon><span flex class="md-body-2">Page</span></div><div><fp-auto-complete no-label="true" auto-complete-model="vm.pageContent" component="Content" multiple="false" query-objs="[{fieldName:\'title\', operator:\'=re=\'}, {fieldName:\'embedded\', operator:\'==\', value:\'false\'}, {fieldName:\'enabled\', operator:\'==\', value:\'true\'}, {fieldName:\'type\', operator:\'==\', value:\'SMART_PAGE\'}]"></fp-auto-complete></div></div><md-divider></md-divider><div class="margin-top-20" layout="row" layout-align="space-between center" ng-cloak><md-icon md-font-icon="fa fa-group"></md-icon><span flex class="md-body-2">Visible To</span></div><div><fp-auto-complete no-label="true" auto-complete-model="vm.audiences" component="Team" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div><div layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex>Thumbnail</span><md-switch name="show_thumbnail" ng-model="vm.topicDataModel.use_custom_thumbnail" aria-label="Image"></md-switch></div><div ng-if="vm.topicDataModel.use_custom_thumbnail" layout="row" layout-align="center center"><div flex="50"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.topicDataModel.thumbnail_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div><md-divider></md-divider><div layout="row" layout-align="space-between center"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex>Banner</span><md-switch name="show_thumbnail" ng-model="vm.topicDataModel.use_custom_banner" aria-label="Image"></md-switch></div><div ng-if="vm.topicDataModel.use_custom_banner" layout="row" layout-align="center center"><div flex="50"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.topicDataModel.banner_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div></div></md-content></div><div ng-if="vm.topicType == \'PAGE\'" flex layout="column"><md-toolbar ng-if="!vm.isNew()" md-theme="default" class="margin-bottom-0"><div class="md-toolbar-tools md-accent"><span flex>Page Content</span></div></md-toolbar><md-card layout="center center" flex layout-padding><div ng-if="vm.pageContent == null" flex layout-align="center center" layout="row"><div flex="75" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1">Please select the page to see preview.</span></div></div></div><md-content layout="column" flex ng-if="vm.pageContent != null"><div froala-view="vm.pageContent.data.content"></div></md-content></md-card></div><div ng-if="vm.topicType == \'STATIC\'" flex layout="column"><div layout="row"><div flex="50"><md-tabs class="padding-left-10"><md-tab ng-click="vm.tabView = \'SUB-TOPIC\'" md-active="vm.tabView == \'SUB-TOPIC\'"><md-tab-label><span>Sub Topics</span></md-tab-label></md-tab></md-tabs></div><div ng-if="vm.tabView == \'SUB-TOPIC\'" class="md-toolbar-tools md-accent"><span flex></span><md-button class="md-icon-button" ng-click="vm.loadSubTopics()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">Refresh</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.openTopicPicker()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom">Add Sub Topic</fp-tooltip></md-button></div></div><md-card layout="center center" flex layout-padding><div ng-if="vm.isNew()" flex layout-align="center center" layout="row"><div flex="75" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1">Please save the topic to add Sub topics to it.</span></div></div></div><div layout="column" flex ng-if="!vm.isNew() && vm.tabView == \'SUB-TOPIC\'"><div ng-if="vm.subTopics.length == 0" class="fp-no-data" layout="column" layout-align="center center"><div layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"></div><div class="margin-top-10 main">Uh!</div><div class="margin-top-10 base">No Sub Topics yet.</div></div><md-table-container ng-if="vm.subTopics.length > 0" layout="row" layout-wrap><div flex="30" flex-xs="100" flex-sm="50" flex-lg="30" flex-md="30" ng-repeat="topic in vm.subTopics"><md-card class="fp-topic-card-list-view" style="outline: none; cursor: default;" ng-style="topic.use_custom_thumbnail ? { \'background-image\':\'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(\' + \'/media/images/\' + topic.thumbnail_url + \')\'} : { \'background-color\': \'\'+ vm.getDefaultBackground() +\'\',\'background-position\': \'center\',\'background-repeat\':\'no-repeat\',\'background-size\': \'70px 70px\' }"><md-card-title><md-card-title-text><div layout="column" layout-align="center center" class="padding-top-20 padding-bottom-20"><span class="follow-card-title-text" data-ellipsis ng-bind="topic.name"></span> <span ng-if="topic.type !== \'PAGE\'" class="follow-card-title-subtext">{{topic.stats.contents}} items</span></div></md-card-title-text></md-card-title><md-card-actions layout="row" layout-align="end center"><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.removeSubTopic(topic)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom">Delete</fp-tooltip></md-button></md-card-actions></md-card></div></md-table-container><div flex></div><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionSubTopics" ng-if="vm.subTopics.length > 0"></md-table-pagination></div></md-card></div><div ng-if="vm.topicType == \'SMART\'" flex layout="column" layout-padding><fp-dynamic-topic--builder fp-criteria="vm.topicDataModel.criteria"></fp-dynamic-topic--builder></div></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/smartflow/datamodel/datamodel-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ng-click="vm.back()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{ \'atheer.datamodel.enterSearch\' | translate }}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom">{{ \'atheer.datamodel.search\' | translate }}</fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">{{ \'atheer.datamodel.cancel\' | translate }}</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">{{ \'atheer.datamodel.refresh\' | translate }}</fp-tooltip></md-button><md-button permission permission-only="vm.permissions.create" class="md-accent md-raised" ng-click="vm.createObject()" aria-label="primary button"><span>{{ \'atheer.datamodel.new\' | translate }}</span></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/smartflow/datamodel/datamodel.html','<div flex layout="column"><ng-include src="\'modules/smartflow/datamodel/datamodel-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.topic.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-content flex ng-if="vm.datamodelList.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="name"><span translate="atheer.datamodel.name">Name</span></th><th md-column><span translate="atheer.datamodel.createdBy">Created By</span></th><th md-column><span translate="atheer.datamodel.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="datamodel in vm.datamodelList track by datamodel.id"><td md-cell>{{datamodel.displayName}}</td><td md-cell>{{datamodel.created_by}}</td><td md-cell am-time-ago="datamodel.created_on"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.createObject(datamodel)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteObject(datamodel)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="atheer.datamodel.delete.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.datamodelList.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/system/admin/admin-detail-analytics.tmpl.html','<md-sidenav class="md-sidenav-right fp-content-detail-sidenav" md-component-id="admin-detail-analytics" md-whiteframe="4"><md-toolbar><div class="md-toolbar-tools"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'admin-detail-analytics\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><h1>{{vm.labels}}</h1></div></md-toolbar><md-content><div layout="column" layout-margin layout-padding></div></md-content></md-sidenav>');
$templateCache.put('modules/system/admin/admin-detail-footer.tmpl.html','<ng-include src="\'modules/system/admin/admin-detail-analytics.tmpl.html\'"></ng-include><ng-include src="\'modules/system/admin/admin-detail-history.tmpl.html\'"></ng-include><ng-include src="\'modules/system/admin/admin-detail-help.tmpl.html\'"></ng-include>');
$templateCache.put('modules/system/admin/admin-detail-help.tmpl.html','<md-sidenav class="md-sidenav-right fp-content-detail-sidenav" md-component-id="admin-detail-help" md-whiteframe="4"><md-toolbar><div class="md-toolbar-tools"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'admin-detail-help\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><h1 translate="help">Help</h1></div></md-toolbar><md-content><div layout="column" layout-margin layout-padding></div></md-content></md-sidenav>');
$templateCache.put('modules/system/admin/admin-detail-history.tmpl.html','<md-sidenav class="md-sidenav-right fp-content-detail-sidenav" md-component-id="admin-detail-history" md-whiteframe="4"><md-toolbar><div class="md-toolbar-tools"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'admin-detail-history\')"><md-icon md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button><h1 translate="history">History</h1></div></md-toolbar><md-content><div layout="column" layout-margin layout-padding></div></md-content></md-sidenav>');
$templateCache.put('modules/system/admin/admin-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="enter search" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom">Filter</fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Cancel</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">Refresh</fp-tooltip></md-button><md-button permission permission-only="vm.permissions.create" class="md-icon-button" ng-if="!vm.createMenu && !vm.isPickerView" ng-click="vm.createObject()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom">Add New</fp-tooltip></md-button><div ng-if="vm.showCardView" layout="row" layout-align="end center"><md-button ng-click="vm.cardView = true" class="md-icon-button" aria-label="Card View" ng-class="{\'md-accent\':vm.cardView}"><md-icon md-font-icon="fa fa-th-large"></md-icon><fp-tooltip placement="bottom">Card View</fp-tooltip></md-button><md-button ng-click="vm.cardView = false" class="md-icon-button" aria-label="List View" ng-class="{\'md-accent\':!vm.cardView}"><md-icon md-font-icon="fa fa-list"></md-icon><fp-tooltip placement="bottom">List View</fp-tooltip></md-button></div><md-menu md-offset="0 60" permission permission-only="vm.permissions.create" ng-if="vm.createMenu && !vm.isPickerView"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon></md-button><md-menu-content width="5"><md-menu-item ng-repeat="item in vm.createMenuOptions"><md-button ng-click="$mdCloseMenu;vm.selectMenu(item)"><md-icon md-font-icon="{{item.icon}}"></md-icon>{{item.label}}</md-button></md-menu-item></md-menu-content></md-menu><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/system/airform/airform-setting.tmpl.html','<div ng-form="airformSettingsForm"><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button ng-disabled="airformSettingsForm.$invalid" type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div flex layout="row" ng-if="!vm.loadingData"><div flex layout="column" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="50" layout="column"><md-input-container class="md-block"><label translate="atheer.airform.imageHeader">Image Header File Size Limit (Max 5MB)</label> <input type="number" name="photo_header_max_size" min="1" max="5" ng-keydown="vm.onNumberInputKeydown($event)" ng-model="vm.airformModel.photo_header_max_size" md-select-on-focus required><div ng-if="airformSettingsForm.photo_header_max_size.$dirty" ng-messages="airformSettingsForm.photo_header_max_size.$error"><div ng-message="required" when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message="max"><span translate="entity.validation.max" translate-values="{max: 5}">This field cannot be more than 5.</span></div><div ng-message="min"><span translate="entity.validation.min" translate-values="{min: 0}">This field should be more than 0.</span></div></div></md-input-container></div></div><div layout="row" layout-align="center center"><div flex="50" layout="column"><md-input-container class="md-block"><label translate="atheer.airform.videoHeader">Video Header File Size Limit (Max 50MB)</label> <input type="number" name="video_header_max_size" min="1" max="50" ng-keydown="vm.onNumberInputKeydown($event)" ng-model="vm.airformModel.video_header_max_size" md-select-on-focus required><div ng-if="airformSettingsForm.video_header_max_size.$dirty" ng-messages="airformSettingsForm.video_header_max_size.$error"><div ng-message="required" when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message="max"><span translate="entity.validation.max" translate-values="{max: 50}">This field cannot be more than 50.</span></div><div ng-message="min"><span translate="entity.validation.min" translate-values="{min: 0}">This field should be more than 0.</span></div></div></md-input-container></div></div></div></div></div>');
$templateCache.put('modules/system/app/app-detail-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ui-sref="storm.admin-apps" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="atheer.app.detail.heading" translate-values="{appModelLabel: \'{{vm.appModel.label}}\'}">{{vm.appModel.label}} App Detail</span></h2><span flex></span><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/system/app/app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row"><div flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="column" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.comingSoon">Coming Soon</span></div><div layout="column" layout-align="center center"><md-button class="md-primary md-raised" translate="atheer.app.detail.learnMore">Learn More</md-button></div></div></div></div></md-content></div>');
$templateCache.put('modules/system/app/app-dialog.html','<md-dialog aria-label="App Detail" flex="30" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="vm.app.id !== null"><h2 id="myAppLabel" translate="atheer.app.home.editLabel">Edit a App</h2></div><div ng-if="vm.app.id == null"><h2 id="myAppLabel" translate="atheer.app.home.createLabel">Create a App</h2></div><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><div><input type="hidden" id="id" name="id" ng-model="vm.app.id" readonly="readonly"></div><md-input-container class="md-block"><label class="md-required" translate="atheer.app.appNo" for="field_appNo">AppNo</label> <input type="number" class="form-control" name="appNo" id="field_appNo" ng-model="vm.app.app_no" required><div ng-messages="editForm.appNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.app.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.app.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.app.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.app.description"></md-input-container><md-input-container class="md-block"><label translate="atheer.app.logoURL" for="field_logoURL">LogoURL</label> <input type="text" class="form-control" name="logoURL" id="field_logoURL" ng-model="vm.app.logo_url"></md-input-container><md-input-container class="md-block"><label translate="atheer.app.ppType" for="field_ppType">PpType</label><md-select name="ppType" ng-model="vm.app.pp_type" id="field_ppType" required><md-option value="SYSTEM" translate="atheer.appType.system">SYSTEM</md-option><md-option value="USER" translate="atheer.appType.user">USER</md-option></md-select><div ng-messages="editForm.ppType.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-checkbox name="enabled" id="field_enabled" class="md-primary" ng-model="vm.app.enabled" aria-label="Primary Checkbox"><span translate="atheer.app.enabled" for="field_enabled" for="field_enabled">Enabled</span></md-checkbox><md-checkbox name="configured" id="field_configured" class="md-primary" ng-model="vm.app.configured" aria-label="Primary Checkbox"><span translate="atheer.app.configured" for="field_configured" for="field_configured">Configured</span></md-checkbox><md-input-container class="md-block"><label translate="atheer.app.options" for="field_options">Options</label> <input type="text" class="form-control" name="options" id="field_options" ng-model="vm.app.options"></md-input-container></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid || isSaving" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/app/app-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.app.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/system/app/apps.tmpl.html','<div flex layout="column"><ng-include src="\'modules/system/app/app-toolbar.tmpl.html\'"></ng-include><md-content flex class="md-padding"><div flex layout="row" layout-wrap layout-align="start"><div flex="25" flex-xs="100" flex-sm="50" flex-lg="25" flex-md="25" ng-repeat="app in vm.apps"><md-card ng-click="vm.editObject(app.name)" class="app-card"><md-card-title><md-card-title-text><span class="md-headline">{{app.label}}</span></md-card-title-text><md-card-title-media ng-if="::vm.getAppMeta(app.name)"><div class="md-media-sm"><img ng-src="{{::vm.getAppMeta(app.name).logo}}"></div></md-card-title-media></md-card-title><md-card-actions layout="row" class="fp-app-cards-action-container"><div flex></div><md-icon ng-if="app.enabled" md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'24\' + \'px\', height: \'24\' + \'px\'}"></md-icon></md-card-actions></md-card></div></div></md-content></div>');
$templateCache.put('modules/system/app/box-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/box.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.box.connect">Connect Box and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.box.inviteUsers">Invite users directly from Box</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://account.box.com/api/oauth2/authorize?response_type=code&client_id=u1wknfvnblgbte5c7co8sypb6y251s26&redirect_uri=http://localhost:8080/admin/app/box\n" translate="atheer.app.detail.configure">Configure</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/dropbox-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/dropbox.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.dropbox.connect">Connect Dropbox and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.dropbox.inviteUsers">Invite users directly from dropbox</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://www.dropbox.com/oauth2/authorize?response_type=code&client_id=ts3ivoqpnah1vae&redirect_uri=http://localhost:8080/admin/app/dropbox" translate="atheer.app.detail.configure">Configure</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/google-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/google.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.googleApp.connect">Connect Google App and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.googleApp.inviteUsers">Invite users directly from Google-APP</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://accounts.google.com/o/oauth2/v2/auth?client_id=841772664113-1mjm3hcgv4agi3docqk4be9358fhriud.apps.googleusercontent.com&redirect_uri=http://localhost:8080/admin/app/google-app&response_type=code&scope=https://www.googleapis.com/auth/admin.directory.user&access_type=offline&prompt=consent&login_hint=sub\n" translate="atheer.app.detail.configure">Configure</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/google-drive-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/google-drive.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.googleDrive.connect">Connect Google Drive and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.googleDrive.reading">Reading content from Google Drive</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://accounts.google.com/o/oauth2/v2/auth?client_id=841772664113-d9dj7dbi2eh4rhd56vuci2vh27jn3c70.apps.googleusercontent.com&redirect_uri=http://localhost:8080/admin/app/google-drive&response_type=code&scope=https://www.googleapis.com/auth/drive&access_type=offline&prompt=consent\n" translate="atheer.app.detail.configure">Configure</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/microsoft-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/msft-office.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.microsoft.connect">Connect Office365 and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.microsoft.inviteUsers">Invite users directly from Office365</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://login.microsoftonline.com/common/oauth2/authorize?response_type=code&redirect_uri=http://localhost:8080/admin/app/msft-office&client_id=f464b227-b3fb-4b0b-8808-aaf53016805e&prompt=consent\n" translate="atheer.app.configured">Configured</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/onedrive-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/msft-onedrive.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.onedrive.connect">Connect OneDrive and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.onedrive.reading">Reading content from OneDrive</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://login.microsoftonline.com/common/oauth2/authorize?response_type=code&redirect_uri=http://localhost:8080/admin/app/msft-onedrive&client_id=f996a49a-a843-4c61-ba28-c35721bf776c&prompt=consent\n" translate="atheer.app.configured">Configured</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/salesforce-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/salesforce.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.salesforce.connect">Connect Salesforce and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.salesforce.inviteUsers">Invite users directly from Salesforce</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://login.salesforce.com/services/oauth2/authorize?response_type=code&client_id=3MVG9d8..z.hDcPKg0gNzcMh2Ohg51PS_MkuO8Ox9HnECDY1hAvmEx5pFr51gsUOmcfTdhn5YijZg49uAeXz_&redirect_uri=https://localhost:8080/admin/app/salesforce&immediate=false&prompt=consent\n" translate="atheer.app.detail.configure">Configure</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/scorm-cloud-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/scorm-cloud.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.scormCloud.connect">Connect Scorm Cloud and Atheer</span></div><div layout="column" layout-align="center center"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.scormCloud.deliverScorm">Deliver SCORM content created in your favourite authoring tools with the industry\u2019s leading SCORM Player.</li><li translate="atheer.app.detail.scormCloud.getStarted">To get started with you will need a SCORM Cloud account and an API key & secret.</li></ul></div><div ng-form="appForm" class="margin-top-20"><md-input-container class="md-block content-title-input"><label translate="atheer.app.detail.scormCloud.appId">Application Identifier</label> <input type="text" name="app_identifier" ng-model="vm.appIdentiFier" md-select-on-focus required><div ng-messages="appForm.app_identifier.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block content-title-input"><label translate="atheer.app.detail.scormCloud.secretKey">Secret Key</label> <input type="text" name="secret_key" ng-model="vm.secretKey" md-select-on-focus required><div ng-messages="appForm.secret_key.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" ng-click="vm.save()" translate="entity.action.save">Save</md-button><md-button ng-if="vm.appModel.enabled" class="md-primary md-raised" ng-click="vm.disable()" translate="atheer.app.detail.disable">Disable</md-button><md-button ng-if="!vm.appModel.enabled" class="md-primary md-raised" ng-click="vm.enable()" translate="atheer.app.detail.enable">Enable</md-button></div></div></div></md-content></div>');
$templateCache.put('modules/system/app/slack-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/slack.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.slack.connect">Connect Slack and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.slack.inviteUsers">Invite users directly from Slack</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://slack.com/oauth/authorize?scope=incoming-webhook,users:read&client_id=18187384672.153378831088" translate="atheer.app.detail.configure">Configure</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Cofigured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/udacity-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/udacity.png" width="100"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.udacity.connect">Connect Udacity and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.udacity.import">Import Courses directly from Udacity</li></ul></div><div layout="row" layout-align="center center" class="margin-top-40"><md-button ng-if="!vm.appModel.enabled" class="md-primary md-raised" ng-click="vm.enable()" translate="atheer.app.detail.udacity.enable">Enable</md-button></div></div></div></md-content></div>');
$templateCache.put('modules/system/app/vimeo-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/vimeo.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.vimeo.connect">Connect Vimeo and Atheer</span></div><div layout="column" layout-align="start start"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.vimeo.reading">Reading content from VImeo</li></ul></div><div ng-if="!vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" href="https://api.vimeo.com/oauth/authorize?response_type=code&redirect_uri=http://localhost:8080/admin/app/vimeo&client_id=94f653e789959c5dd766f9a3f31b0f57c9a48f6f&state=vimeo\n" translate="atheer.app.configured">Configured</md-button></div><div ng-if="vm.appModel.enabled" layout="row" layout-align="center center" class="margin-top-40" translate="atheer.app.detail.success">Successfully Configured!!!!</div></div></div></md-content></div>');
$templateCache.put('modules/system/app/watershed-app-detail.tmpl.html','<div flex><ng-include src="\'modules/system/app/app-detail-toolbar.tmpl.html\'"></ng-include><md-content flex layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="row" layout-align="center center" layout-padding><div><img src="/assets/images/integration/watershed.png" width="125"></div><div><md-icon md-font-icon="zmdi zmdi-plus" ng-style="{\'font-size\': \'25\' + \'px\', height: \'25\' + \'px\'}"></md-icon></div><div><img src="/assets/images/logo2.png" width="75"></div></div><div layout="row" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.app.detail.watershed.connect">Connect Watershed LRS and Atheer</span></div><div layout="column" layout-align="center center"><span class="md-title" translate="atheer.app.detail.benefits">Benefits</span><ul class="margin-left-40"><li translate="atheer.app.detail.watershed.explore">Explore all your learning data in one place and measure how L&D programs are impacting the organization.</li><li translate="atheer.app.detail.watershed.measure">Watershed lets you measure training effectiveness and optimize your investments in learning.</li></ul></div><div ng-form="appForm" class="margin-top-20"><md-input-container class="md-block content-title-input"><label translate="atheer.app.detail.watershed.key">Key</label> <input type="text" name="key" ng-model="vm.key" md-select-on-focus required><div ng-messages="appForm.key.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block content-title-input"><label translate="atheer.app.detail.watershed.secret">Secret</label> <input type="text" name="secret" ng-model="vm.secret" md-select-on-focus required><div ng-messages="appForm.secret.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div><div layout="row" layout-align="center center" class="margin-top-40"><md-button class="md-primary md-raised" ng-click="vm.save()" translate="entity.action.save">Save</md-button><md-button ng-if="vm.appModel.enabled" class="md-primary md-raised" ng-click="vm.disable()" translate="atheer.app.detail.disable">Disable</md-button><md-button ng-if="!vm.appModel.enabled" class="md-primary md-raised" ng-click="vm.enable()" translate="atheer.app.detail.enable">Enable</md-button></div></div></div></md-content></div>');
$templateCache.put('modules/system/audits/audits.tmpl.html','<md-card flex layout="column"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span> <span class="md-caption" translate="atheer.audits.filter.from">From</span><md-datepicker name="start" ng-model="vm.fromDate" md-placeholder="{{\'atheer.audits.selectDate\' | translate}}" ng-change="vm.loadAll()" required></md-datepicker><span class="md-caption" translate="atheer.audits.filter.to">To</span><md-datepicker name="end" ng-model="vm.toDate" md-placeholder="{{\'atheer.audits.selectDate\' | translate}}" ng-change="vm.loadAll()" required></md-datepicker><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon></md-button></div></md-toolbar><md-content flex class="md-padding"><md-table-container><table md-table class="md-primary md-data-table" ng-model="vm.selected" md-progress="vm.promise"><thead md-head><tr md-row><th md-column><span translate="atheer.audits.table.header.date">Date</span></th><th md-column><span translate="atheer.audits.table.header.principal">User</span></th><th md-column><span translate="atheer.audits.table.header.status">State</span></th><th md-column><span translate="atheer.audits.table.header.data">Extra data</span></th></tr></thead><tbody md-body><tr ng-repeat="audit in vm.audits"><td md-cell><span>{{audit.timestamp| date:\'medium\'}}</span></td><td md-cell><small>{{audit.principal}}</small></td><td md-cell>{{audit.type}}</td><td md-cell><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="atheer.audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></md-card>');
$templateCache.put('modules/system/authentication/authentication-azure-ad.tmpl.html','<div flex layout="column"><div layout="row" flex="50"><md-card flex layout="row" layout-align="center center" layout-padding><div flex layout="column"><span class="md-title" translate="atheer.authentication.azure">Microsoft Entra ID</span><md-input-container class="md-block"><label translate="atheer.authentication.setup.applicationId">Application (client) ID</label> <input type="text" name="application_id" ng-model="vm.applicationId" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.directoryId">Directory (tenant) ID</label> <input name="tenant_id" ng-model="vm.tenantId" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.discoverUri">Discover URI</label> <input name="tenant_id" ng-model="vm.discoverUri" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.authUri">Auth URI</label> <input name="auth_id" ng-model="vm.authUri" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.tokenUri">Token URI</label> <input name="token_id" ng-model="vm.tokenUri" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.logoutUri">Logout URI</label> <input name="token_id" ng-model="vm.logoutUri" md-select-on-focus></md-input-container></div></md-card></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start"></div><div flex="20" layout="column" layout-align="center end"><md-button type="submit" class="md-primary md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></div></div></div>');
$templateCache.put('modules/system/authentication/authentication-google.tmpl.html','<div flex layout="column"><div layout="row" flex="50"><md-card flex layout="row" layout-align="center center" layout-padding><div flex layout="column"><md-input-container class="md-block"><label translate="atheer.authentication.setup.key">Key</label> <input type="text" name="google_key" ng-model="vm.googleKey" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.secret">Secret</label> <input name="google_secret" ng-model="vm.googleSecret" md-select-on-focus></md-input-container></div></md-card></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start"></div><div flex="20" layout="column" layout-align="center end"><md-button type="submit" class="md-primary md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></div></div></div>');
$templateCache.put('modules/system/authentication/authentication-lens-setup.tmpl.html','<div flex layout="column"><div layout="row" flex="50"><md-card flex layout="row" layout-align="center center" layout-padding><div flex layout="column"><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.enableForgotPassword">Enable Forgot Password</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.lensEnableForgotPassword"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.enableAtheerLogin">Enable Atheer Login</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.lensEnableAtheerLogin"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.google">Google</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.lensGoogleSSO"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.azure">Microsoft Entra ID</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.lensAzureAdSSO"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.oidc">OIDC</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.oidcSSO"></md-switch></div></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.autoSignoutEnabled">Enable Automatic Sign Out</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.lensAutoSignoutEnabled"></md-switch></div></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.autoSignoutWaitMins">Sign Out Time (in Minutes)</div><div flex="20" layout="column" layout-align="center end"><md-input-container class="md-block"><input ng-disabled="!vm.lensAutoSignoutEnabled" type="number" name="lens_auto_signout_wait_time_mins" ng-model="vm.lensAutoSignoutWaitMins" md-select-on-focus required></md-input-container></div></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.autoSignoutWarning">Show Sign Out Warning</div><div flex="20" layout="column" layout-align="center end"><md-switch ng-disabled="!vm.lensAutoSignoutEnabled" name="enabled" ng-model="vm.lensAutoSignoutWarning"></md-switch></div></div></div></md-card></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start"></div><div flex="20" layout="column" layout-align="center end"><md-button type="submit" class="md-primary md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></div></div></div>');
$templateCache.put('modules/system/authentication/authentication-oidc.tmpl.html','<div flex layout="column"><div layout="row" flex="50"><md-card flex layout="row" layout-align="center center" layout-padding><div flex layout="column"><span class="md-title" translate="atheer.authentication.oidc">OIDC</span><md-input-container class="md-block"><label translate="atheer.authentication.setup.applicationId">Application (client) ID</label> <input type="text" name="application_id" ng-model="vm.applicationId" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.directoryId">Directory (tenant) ID</label> <input name="tenant_id" ng-model="vm.tenantId" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.discoverUri">Discover URI</label> <input name="tenant_id" ng-model="vm.discoverUri" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.authUri">Auth URI</label> <input name="auth_id" ng-model="vm.authUri" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.tokenUri">Token URI</label> <input name="token_id" ng-model="vm.tokenUri" md-select-on-focus></md-input-container><md-input-container class="md-block ng-hide"><label translate="atheer.authentication.setup.signInLabel">Sign In Label</label> <input name="sign_in_label" ng-model="vm.signInLabel" md-select-on-focus></md-input-container><md-input-container class="md-block"><label translate="atheer.authentication.setup.logoutUri">Logout URI</label> <input name="logout_id" ng-model="vm.logoutUri" md-select-on-focus></md-input-container></div></md-card></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start"></div><div flex="20" layout="column" layout-align="center end"><md-button type="submit" class="md-primary md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></div></div></div>');
$templateCache.put('modules/system/authentication/authentication-saml-sp-dialog.tmpl.html','<md-dialog flex="70" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs translate="atheer.authentication.setup.serviceProvider">Service Provider Metadata</h2><span flex></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.authentication.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div flex layout="row" ng-if="!vm.loadingData" layout-fill><div flex layout="column" class="padded-content-page"><div layout="row" layout-align="center center"><div flex layout="column" ng-form="emailForm"><div class="margin-bottom-40"><span class="md-subhead" translate="atheer.authentication.setup.pleaseCopyIdentityProvider">Please copy this metadata to your Identity Provider.</span></div><textarea id="sp_metadata" md-no-autogrow ngclipboard ng-model="vm.spMetadata" rows="10" md-select-on-focus></textarea></div></div><div flex layout="row" layout-align="end center"><md-button ngclipboard data-clipboard-target="#sp_metadata" class="md-raised md-primary margin-left-0" ngclipboard-success="vm.onCopySuccess(e)"><span translate="atheer.authentication.setup.copyToClipboard">Copy to Clipboard</span></md-button></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/system/authentication/authentication-saml.tmpl.html','<div flex layout="row" ng-if="!vm.loadingData" layout-fill><div flex layout="column" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex layout="column" ng-form="emailForm"><div class="margin-bottom-40"><span class="md-subhead" translate="atheer.authentication.setup.uploadProviderMeta">Upload your Identity Provider metadata here.</span></div><md-input-container flex class="md-block"><textarea md-no-autogrow ng-model="vm.samlMetaData" rows="10" md-select-on-focus></textarea></md-input-container></div></div></div></div><div layout="row" flex="100"><div flex layout="row" layout-align="end center"><md-button type="submit" class="md-primary md-raised" ng-click="vm.showSPMetaData()"><span translate="atheer.authentication.setup.serviceProvider">Service Provider Metadata</span></md-button><md-button type="submit" class="md-primary md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></div></div>');
$templateCache.put('modules/system/authentication/authentication-studio-setup.tmpl.html','<div flex layout="column"><div layout="row" flex="50"><md-card flex layout="row" layout-align="center center" layout-padding><div flex layout="column"><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.enableForgotPassword">Enable Forgot Password</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.enableForgotPassword"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.enableAtheerLogin">Enable Atheer Login</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.enableAtheerLogin"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.google">Google</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.googleSSO"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.azure">Microsoft Entra ID</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.azureAdSSO"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.saml">SAML</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.samlSSO"></md-switch></div></div><div layout="row" flex="100" ng-if="vm.hasPermission && vm.isFeatureActive"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.oidc">OIDC</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.oidcSSO"></md-switch></div></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.autoSignoutEnabled">Enable Automatic Sign Out</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.autoSignoutEnabled"></md-switch></div></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.autoSignoutWaitMins">Sign Out Time (in Minutes)</div><div flex="20" layout="column" layout-align="center end"><md-input-container class="md-block"><input ng-disabled="!vm.autoSignoutEnabled" type="number" name="auto_signout_wait_time_mins" ng-model="vm.autoSignoutWaitMins" md-select-on-focus required></md-input-container></div></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.authentication.setup.autoSignoutWarning">Show Sign Out Warning</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.autoSignoutWarning" ng-disabled="!vm.autoSignoutEnabled"></md-switch></div></div></div></md-card></div><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start"></div><div flex="20" layout="column" layout-align="center end"><md-button type="submit" class="md-primary md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></div></div></div>');
$templateCache.put('modules/system/authentication/authentication.tmpl.html','<div flex layout="column" layout-fill><md-toolbar md-theme="{{triSkin.elements.toolbar}}" class="toolbar-default md-whiteframe-z1"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="row" layout-fill layout-align="center start"><div flex="80" layout="column" class="padded-content-page"><div layout="column"><p class="md-subhead" translate="atheer.authentication.subhead">Welcome to the Atheer Authentication Set-up!.</p></div><div layout="column"><md-tabs><md-tab ui-sref="storm.admin-setting.authentication.studio" md-active="vm.isActiveTab(\'storm.admin-setting.authentication.studio\')"><md-tab-label><span translate="atheer.authentication.studio">Studio-Set-up</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-setting.authentication.lens" md-active="vm.isActiveTab(\'storm.admin-setting.authentication.lens\')"><md-tab-label><span translate="atheer.authentication.lens">Lens-Set-up</span></md-tab-label></md-tab><md-tab ng-if="vm.hasPermission && vm.isFeatureActive" ui-sref="storm.admin-setting.authentication.saml" md-active="vm.isActiveTab(\'storm.admin-setting.authentication.saml\')"><md-tab-label><span translate="atheer.authentication.saml">SAML</span></md-tab-label></md-tab><md-tab ng-if="vm.hasPermission && vm.isFeatureActive" ui-sref="storm.admin-setting.authentication.google" md-active="vm.isActiveTab(\'storm.admin-setting.authentication.google\')"><md-tab-label><span translate="atheer.authentication.google">Google</span></md-tab-label></md-tab><md-tab ng-if="vm.hasPermission && vm.isFeatureActive" ui-sref="storm.admin-setting.authentication.azureAD" md-active="vm.isActiveTab(\'storm.admin-setting.authentication.azureAD\')"><md-tab-label><span translate="atheer.authentication.azure">Microsoft Entra ID</span></md-tab-label></md-tab><md-tab ui-sref="storm.admin-setting.authentication.oidc" md-active="vm.isActiveTab(\'storm.admin-setting.authentication.oidc\')"><md-tab-label><span translate="atheer.authentication.oidc">OIDC</span></md-tab-label></md-tab></md-tabs><div flex ui-view></div></div></div></div></div>');
$templateCache.put('modules/system/badge/badge-assign-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="assignBadge.title">Assign Badge</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="assignBadge.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><form name="contentRecommendForm"><div ng-if="!vm.fromProfilePage" class="fp-user-chips"><fp-auto-complete no-label="true" auto-complete-model="vm.asyncUsers" component="User" multiple="true" query-objs="[{fieldName:\'text_search\', operator:\'=ts=\'}]"></fp-auto-complete></div><div ng-if="vm.fromProfilePage" class="fp-user-chips"><fp-auto-complete no-label="true" auto-complete-model="vm.asyncBadges" component="Badge" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}, {fieldName:\'status\', operator:\'==\', value:\'ACTIVE\'}]"></fp-auto-complete></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="contentRecommendForm.$invalid" class="md-primary"><span translate="entity.action.assign">Assign</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/badge/badge-detail-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToBadges()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span flex translate="atheer.badge.badgeDetail">Badge Detail</span><div><md-button type="submit" class="md-accent md-raised" ng-disabled="badgeDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button ng-click="vm.copyBadge()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><span translate="entity.action.copy">Copy</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.togglePanel(\'admin-detail-history\')"><md-icon md-font-icon="fa fa-history"></md-icon><span translate="atheer.badge.history">History</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.togglePanel(\'admin-detail-help\')"><md-icon md-font-icon="zmdi zmdi-help-outline"></md-icon><span translate="entity.action.help">Help</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-toolbar>');
$templateCache.put('modules/system/badge/badge-detail.tmpl.html','<ng-include src="\'modules/system/badge/badge-detail-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="35" flex-xl="25" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><div ng-form="badgeDetailForm"><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.badge.badgeNo" for="field_badgeNo">BadgeNo</label> <input type="number" class="form-control" name="badgeNo" id="field_badgeNo" ng-model="vm.badgeModel.badge_no" required ng-disabled="true"><div ng-messages="badgeDetailForm.badgeNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.badge.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.badgeModel.name" required><div ng-messages="badgeDetailForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.badge.description" for="field_description">Description</label> <textarea name="description" ng-model="vm.badgeModel.description" id="field_description" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><div layout="row" layout-align="space-between center" class="margin-top-10"><span translate="atheer.badge.active">Active</span><md-switch name="enabled" ng-model="vm.badgeModel.status" ng-true-value="\'ACTIVE\'" ng-false-value="\'DRAFT\'"></md-switch></div><div layout="row" layout-align="start"><md-icon md-font-icon="zmdi zmdi-image"></md-icon><span flex translate="atheer.badge.badgeImage">Badge Image</span></div><div layout="row" layout-align="center" class="margin-top-20"><fp-upload fp-allow-media-selection="true" flex fp-content-type="image" fp-ng-model="vm.badgeModel.badge_url" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="drop"></fp-upload></div></div></md-content></div></div><div flex layout="column"><md-toolbar ng-if="!vm.isNew()" md-theme="default" class="margin-bottom-0"><div class="md-toolbar-tools md-accent"><span flex translate="atheer.badge.users">Users</span><md-button class="md-icon-button" ng-click="vm.loadUserBadges()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.refresh">Refresh</span></fp-tooltip></md-button><md-button ng-if="vm.badgeModel.status == \'ACTIVE\'" class="md-icon-button" ng-click="vm.openAssignModal()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.assignToUsers">Assign to Users</span></fp-tooltip></md-button></div></md-toolbar><div layout="center center" flex layout-padding><div ng-if="vm.isNew()" flex layout-align="center center" layout="row"><div flex="75" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.badge.saveBadge">Please save the Badge to add Users to it.</span></div></div></div><div layout="column" flex ng-if="!vm.isNew()"><div ng-if="vm.userBadges.length == 0" class="fp-no-data" layout="column" layout-align="center center"><div layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"></div><div class="margin-top-10 main" translate="atheer.badge.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.badge.noUsers">No Users yet.</div><div ng-if="vm.badgeModel.status == \'INACTIVE\'" class="margin-top-10 base" translate="atheer.badge.activate">Please activate the Badge to add Users to it..</div></div><md-table-container ng-if="vm.userBadges.length > 0"><table md-table class="md-primary md-data-table"><thead md-head><tr md-row><th md-column><span translate="atheer.badge.firstName">First Name</span></th><th md-column><span translate="atheer.badge.lastName">Last Name</span></th><th md-column><span translate="atheer.badge.acquiredOn">Acquired On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="userBadge in vm.userBadges track by userBadge.id"><td md-cell>{{userBadge.user_info.first_name}}</td><td md-cell>{{userBadge.user_info.last_name}}</td><td md-cell>{{userBadge.acquired_on | date:\'MM/dd/yyyy\'}}</td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeUserBadge(userBadge, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.userBadges.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUserBadges"></md-table-pagination></div></div></div></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include>');
$templateCache.put('modules/system/badge/badge-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="autoComplete.badgePicker.title">Select Badge</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button layout-align="center center" ng-if="vm.badges.length > 0" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedItems.length <= 0" translate="entity.action.select">Select</md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><div ng-if="vm.badges.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="autoComplete.uh">Uh!</div><div class="margin-top-10 base" translate="autoComplete.badgePicker.noBadges">There are no badges yet.</div></div><div class="md-padding" ng-if="vm.badges.length > 0"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedItems" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="name"><span translate="autoComplete.badgePicker.table.title">Title</span></th></tr></thead><tbody md-body><tr ng-repeat="badge in vm.badges track by badge.id" md-row md-select="badge" md-select-id="id" md-auto-select><td md-cell>{{badge.name}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></md-dialog>');
$templateCache.put('modules/system/badge/badge-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'atheer.badge.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.refresh">Refresh</span></fp-tooltip></md-button><md-button permission permission-only="vm.permissions.create" class="md-icon-button" ng-if="!vm.createMenu && !vm.isPickerView" ng-click="vm.createObject()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.addNew">Add New</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/system/badge/badges.html','<div flex layout="column" layout-fill><ng-include src="\'modules/system/badge/badge-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.badges.length == 0" flex layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen><div permission permission-only="vm.permissions.create" class="margin-top-20" layout="column" layout-align="center center"><md-button ng-click="vm.createObject()" class="md-primary md-raised" translate="atheer.badge.addNow">Add Now</md-button></div></div><md-content flex ng-if="vm.badges.length > 0"><div ng-if="vm.cardView" layout="row" layout-wrap layout-align="start center" class="padding-top-20 padding-left-10 padding-right-10"><div flex="20" flex-xs="50" flex-sm="33" flex-lg="20" flex-md="20" ng-repeat="badge in vm.badges"><md-card class="fp-topic-card-list-view" ng-click="vm.editObject(badge.id)" style="outline:none;" ng-style="badge.badge_url != null ? { \'background-image\':\'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(\' + \'/media/images/\' + badge.badge_url + \')\'} : { \'background-color\': \'\'+ vm.getDefaultBackground() +\'\',\'background-position\': \'center\',\'background-repeat\':\'no-repeat\',\'background-size\': \'70px 70px\' }"><md-card-title><md-card-title-text flex="100"><div layout="column" layout-align="center center" class="padding-top-20 padding-bottom-20"><span class="follow-card-title-text" data-ellipsis ng-bind="badge.name"></span></div></md-card-title-text></md-card-title><md-card-actions layout="row" layout-align="space-between center"><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.editObject(badge.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.edit">Edit</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.openAssignModal(badge)"><md-icon class="zmdi zmdi-assignment icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.assign">Assign</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="$event.stopPropagation();vm.deleteObject(badge)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.badge.deleteBadge">Delete</span></fp-tooltip></md-button></md-card-actions></md-card></div></div><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th></th><th md-column md-order-by="name"><span translate="atheer.badge.name">Name</span></th><th md-column md-order-by="status"><span translate="atheer.badge.status">Status</span></th><th md-column><span translate="atheer.badge.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="badge in vm.badges track by badge.id"><td md-cell><img ng-src="{{badge.badge_url | mediaUrl}}"></td><td md-cell>{{badge.name}}</td><td md-cell translate="{{\'atheer.badgeStatus.\' + (badge.status | lowercase)}}">{{badge.status}}</td><td md-cell am-time-ago="badge.created_on"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(badge.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.openAssignModal(badge)"><md-icon md-font-icon="zmdi zmdi-assignment"></md-icon><span translate="atheer.badge.assign">Assign</span></md-button></md-menu-item><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(badge)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="atheer.badge.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.badges.length > 0"></md-table-pagination></div>');
$templateCache.put('modules/system/camera/camera-setting.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div flex layout="row" ng-if="!vm.loadingData"><div flex layout="column" class="padded-content-page margin-top-20"><md-input-container class="md-block"><div flex="40" class="padding-top-10"><span translate="atheer.lensCamera.photoSetting">Photo quality setting</span><md-select ng-model="vm.cameraModel.photo_setting"><md-option ng-repeat="photoSetting in vm.photo_setting_options" ng-value="photoSetting">{{photoSetting}}</md-option></md-select></div></md-input-container><md-divider></md-divider><md-input-container class="md-block"><div flex="40" class="padding-top-10"><span translate="atheer.lensCamera.videoSetting">Video quality setting</span><md-select ng-model="vm.cameraModel.video_setting"><md-option ng-repeat="videoSetting in vm.video_setting_options" ng-value="videoSetting">{{videoSetting}}</md-option></md-select></div></md-input-container></div></div>');
$templateCache.put('modules/system/dashboard/system-dashboard.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span flex></span><!--\n        <md-date-range ng-model="vm.pickerModel" custom-templates="vm.customTemplates" auto-confirm="true" show-template="true" first-day-of-week="firstDayOfWeek"></md-date-range>\n        --><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div id="education-banner" layout="row" layout-xs="column"></div><div ng-if="isMasterWorkspace" layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools fp-admin-toolbar padding-bottom-10" md-colors="{background: \'teal-500\', color: \'white\'}"><md-icon md-font-icon="fa fa-building margin-right-10"></md-icon><h2 flex><span translate="atheer.dashboard.workspaces">Workspaces</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.workspaces_summary.total_workspaces}}</span> <span class="md-body-1" translate="atheer.dashboard.totalWorkspaces">Total Workspaces</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.workspaces_summary.active_workspaces}}</span> <span class="md-body-1" translate="atheer.dashboard.active">Active</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.workspaces_summary.trial_workspaces}}</span> <span class="md-body-1" translate="atheer.dashboard.trial">Trial</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.workspaces_summary.inactive_workspaces}}</span> <span class="md-body-1" translate="atheer.dashboard.inactive">Inactive</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools fp-admin-toolbar padding-bottom-10" md-colors="{background: \'green-500\', color: \'white\'}"><md-icon md-font-icon="fa fa-comments margin-right-10"></md-icon><h2 flex><span translate="atheer.dashboard.conversations">Conversations</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_conversations}}</span> <span class="md-body-1" translate="atheer.dashboard.totalConversations">Total Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_messages}}</span> <span class="md-body-1" translate="atheer.dashboard.totalMessages">Total Messages</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.archived_conversations}}</span> <span class="md-body-1" translate="atheer.dashboard.archivedConversations">Archived Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.conversations_summary.avg_messages_per_conversation}}</span> <span class="md-body-1" translate="atheer.dashboard.avgMessage">Avg. Message/Conversation</span></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_1_to_1_conversations}}</span> <span class="md-body-1" translate="atheer.dashboard.totalOneToOne">Total 1:1 Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_group_conversations}}</span> <span class="md-body-1" translate="atheer.dashboard.totalGroup">Total Group Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_session_conversations}}</span> <span class="md-body-1" translate="atheer.dashboard.totalSession">Total AiRSession Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.conversations_summary.total_audience_conversations}}</span> <span class="md-body-1" translate="atheer.dashboard.totalTeam">Total Team Conversations</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'orange-400\', color: \'white\'}"><md-icon md-font-icon="fa zmdi zmdi-comment-video margin-right-10"></md-icon><h2 flex><span translate="atheer.dashboard.session">AiRSessions</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_sessions}}</span> <span class="md-body-1" translate="atheer.dashboard.totalAirSessions">Total AiRSessions</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_minutes}}</span> <span class="md-body-1" translate="atheer.dashboard.totalMin">Total Minutes</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.avg_duration.toFixed(2)}}</span> <span class="md-body-1" translate="atheer.dashboard.avgDuration">Avg. Duration(min)</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.sessions_summary.avg_rating}}</span> <span class="md-body-1" translate="atheer.dashboard.avgRating">Avg. Rating</span></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_recordings}}</span> <span class="md-body-1" translate="atheer.dashboard.totalRecordings">Total Recordings</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_screen_shares}}</span> <span class="md-body-1" translate="atheer.dashboard.totalScreenshares">Total Screenshares</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.sessions_summary.total_annotations}}</span> <span class="md-body-1" translate="atheer.dashboard.totalAnnotations">Total Annotations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.sessions_summary.avg_calls_day}}</span> <span class="md-body-1" translate="atheer.dashboard.avgParticipants">Avg. Participants</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'deep-purple-400\', color: \'white\'}"><md-icon md-font-icon="zmdi zmdi-library margin-right-10"></md-icon><h2 flex><span translate="atheer.dashboard.content">Content</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'total_content\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.dashboard.totalContent">Total Content</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'featured\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.dashboard.totalFeatured">Total Featured</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.getCount(\'avg_time_spent\')| milisecondToTime}}</span> <span class="md-body-1" translate="atheer.dashboard.avgTimeSpent">Avg. Time Spent</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2" countupto="vm.getCount(\'views\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.dashboard.totalViews">Total Views</span></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'bookmark\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.dashboard.totalBookmarks">Total Bookmarks</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'share\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.dashboard.totalShares">Total Shares</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2" countupto="vm.getCount(\'reaction\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.dashboard.totalLikes">Total Likes</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2" countupto="vm.getCount(\'archived\')" duration="1.5" decimals="0"></span> <span class="md-body-1" translate="atheer.dashboard.totalArchived">Total Archived</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'light-blue-400\', color: \'white\'}"><md-icon md-font-icon="flp ath-smart-content margin-right-10"></md-icon><h2 flex><span translate="atheer.dashboard.airforms">AiRForms</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.airform_summary.total_active_airforms}}</span> <span class="md-body-1" translate="atheer.dashboard.totalActiveAirforms">Total Active AiRForms</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.airform_summary.total_scheduled_airforms}}</span> <span class="md-body-1" translate="atheer.dashboard.totalScheduledAirforms">Total Scheduled AiRForms</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.airform_summary.total_jobs_completed_in_last_30_days}}</span> <span class="md-body-1" translate="atheer.dashboard.totalJobsCompleted">Total Jobs completed in last 30 days</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.airform_summary.total_jobs_in_progress}}</span> <span class="md-body-1" translate="atheer.dashboard.totalJobsInprogress">Total Jobs in progress</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'grey-400\', color: \'white\'}"><md-icon md-font-icon="zmdi zmdi-device-hub margin-right-10"></md-icon><h2 flex><span translate="atheer.dashboard.smartflows">SmartFlows</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_smartflows}}</span> <span class="md-body-1" translate="atheer.dashboard.totalSmartflows">Total SmartFlows</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_executions}}</span> <span class="md-body-1" translate="atheer.dashboard.totalExecutions">Total Executions</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_active}}</span> <span class="md-body-1" translate="atheer.dashboard.totalActive">Total Active</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.smartflows_summary.total_draft}}</span> <span class="md-body-1" translate="atheer.dashboard.totalDraft">Total Draft</span></div></div></md-card></div><div layout="row" layout-xs="column" layout-margin><md-card flex class="padding-bottom-10"><md-toolbar class="md-toolbar-tools md-accent fp-admin-toolbar padding-bottom-10" md-colors="{background: \'blue-grey-400\', color: \'white\'}"><md-icon md-font-icon="zmdi zmdi-accounts-list margin-right-10"></md-icon><h2 flex><span translate="atheer.dashboard.users">Users</span></h2></md-toolbar><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_users}}</span> <span class="md-body-1" translate="atheer.dashboard.totalUsers">Total Users</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_logins}}</span> <span class="md-body-1" translate="atheer.dashboard.totalLogins">Total Logins</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_active_users}}</span> <span class="md-body-1" translate="atheer.dashboard.totalActiveUsers">Total Active Users</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.users_summary.total_inactive_users}}</span> <span class="md-body-1" translate="atheer.dashboard.totalInactiveUsers">Total Inactive Users</span></div></div><md-divider></md-divider><div flex layout="row" class="padding-10"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_guest_users}}</span> <span class="md-body-1" translate="atheer.dashboard.totalGuestUsers">Total Guest Users</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_audiences}}</span> <span class="md-body-1" translate="atheer.dashboard.totalTeams">Total Teams</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.dashboard.users_summary.total_static_audiences}}</span> <span class="md-body-1" translate="atheer.dashboard.totalFixedTeams">Total Fixed Teams</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.dashboard.users_summary.total_dynamic_audiences}}</span> <span class="md-body-1" translate="atheer.dashboard.totalDynamicTeams">Total Dynamic Teams</span></div></div></md-card></div></div>');
$templateCache.put('modules/system/deeplink/deeplink.tmpl.html','<div layout="row" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div>');
$templateCache.put('modules/system/deeplink/session-deeplink.tmpl.html','<div ng-if="!vm.isLoading" flex layout="column" layout-align="center center" style="font-family: Roboto, Helvetica Neue, sans-serif;"><div ng-if="vm.workSpace !== \'atheer\' && vm.workSpace !== \'rigpartner\'" flex="20" layout="row" layout-align="center center"><img src="/assets/images/ath-sm-color.png" height="125"><br></div><div ng-if="vm.workSpace === \'atheer\'" flex="20" layout="row" layout-align="center center"><img src="/assets/images/icon-atheerone.png" height="125"><br></div><div ng-if="vm.workSpace === \'rigpartner\'" flex="20" layout="row" layout-align="center center"><img src="/assets/images/icon-rigquip.png" height="125"><br></div><div flex="80" layout="column" style="width: 100%; max-width: 600px;"><div ng-if="!vm.linkError" style="text-align: center; padding: 24px;"><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;" translate="deeplink.sessionLandingPageDescription">If Atheer desktop app did not launch, click on the join link below to join the event in Atheer desktop app.</span></div><div ng-if="vm.linkError" style="text-align: center; padding: 24px;"><span style="font-size: 30px; color: black; line-height: 30px; margin: 0 0;" translate="deeplink.sessionDeeplinkInvalidError">Looks like {{air_session}} invitation link got expaired/invalid.</span></div><div ng-if="!vm.linkError"><button type="button" ng-click="vm.openDesktopApp()" ng-style="{\'background-color\': vm.workSpace === \'rigpartner\' ? \'#0285c9\' : vm.workSpace === \'atheer\' ? \'#5e8ee8\' : \'#27C7A6\'}" style="border: none; color: white; padding: 15px 50px; text-align: center; text-decoration: none;font-weight: bold;display: inline-block;font-size: 16px; position: relative; margin: 10px 0px 10px;cursor: pointer; width: 100%;" target="_blank" translate="deeplink.join">Join the {{air_session}}</button></div><div ng-if="!vm.linkError" style="padding:5px 15px; background:#f3f5f6;"><h3 style="font-weight: 500;" translate="deeplink.desktopInstallationInstructions.heading">How to download &amp; install the Atheer desktop app</h3><div style="margin-bottom:32px;"><p style="font-weight: 600;">Windows</p><ol><li><span translate="deeplink.desktopInstallationInstructions.downloadInstaller">Click to download the installer</span><div style="margin: 10px 0px;"><a href="{{vm.windowsInstallerLink}}"><img src="assets/images/lens-app/microsoft-lens.png"></a></div></li><li translate="deeplink.desktopInstallationInstructions.windownloadInstruction">Atheer dekstop app installer for Windows will get downloaded, click on the file to install the Atheer desktop app</li></ol></div><div style="margin-bottom:32px;"><p style="font-weight: 600;">macOS</p><ol><li><span translate="deeplink.desktopInstallationInstructions.downloadInstaller">Click to download the installer</span><div style="margin: 10px 0px;"><a href="{{vm.macInstallerLink}}"><img src="assets/images/lens-app/mac-lens.png"></a></div></li><li translate="deeplink.desktopInstallationInstructions.macInstallerInstruction">Atheer dekstop app installer for macOS will get downloaded, click on the file to install the Atheer desktop app</li></ol></div><div style="margin-bottom:32px;"><p style="font-weight: 600;">Linux</p><ol><li><span translate="deeplink.desktopInstallationInstructions.downloadInstaller">Click to download the installer</span><div style="margin: 10px 0px;"><a href="{{vm.linuxInstallerLink}}"><img src="assets/images/lens-app/linux_x64.png"></a><a style="margin-left: 10px;" href="{{vm.linuxArmInstallerLink}}"><img src="assets/images/lens-app/linux_ARM64.png"></a></div></li><li translate="deeplink.desktopInstallationInstructions.linuxInstallerDescription">Atheer dekstop app installer for Linux will get downloaded</li><li translate="deeplink.desktopInstallationInstructions.linuxInstallerDescription1">Installing Atheer desktop app</li><li translate="deeplink.desktopInstallationInstructions.linuxInstallerDescription2" translate-values="{ appImageLauncher: vm.appImageLauncher, appImage: vm.appImage}">We need to install third-party software (AppImageLauncher) to install the AppImage files on a Linux machine</li><li translate="deeplink.desktopInstallationInstructions.openTerminal">Open terminal</li><li><span translate="deeplink.desktopInstallationInstructions.run">Run </span><code style="background-color:#e6e4e4;">sudo add-apt-repository ppa:appimagelauncher-team/stable</code></li><li><span translate="deeplink.desktopInstallationInstructions.run">Run </span><code style="background-color:#e6e4e4;">sudo apt-get update</code></li><li><span translate="deeplink.desktopInstallationInstructions.run">Run </span><code style="background-color:#e6e4e4;">sudo apt-get install appimagelauncher</code></li><li translate="deeplink.desktopInstallationInstructions.afterInstallationAppImageLauncher" translate-values="{ appImageLauncher: vm.appImageLauncher, appImage: vm.appImage}">After installation of the AppImageLanucher, double-click on the downloaded Atheer desktop AppImage</li><li translate="deeplink.desktopInstallationInstructions.integrateRun">It opens a dialog, click integrate and run from the dialog.</li><li translate="deeplink.desktopInstallationInstructions.linuxAppListed">Atheer desktop app will be listed in the apps menu</li></ol></div></div><div ng-if="vm.workSpace !== \'rigpartner\'"><p style="color:#9CA9B9; text-align: center;"><span>&copy; <span translate="deeplink.companyCopyright">Copyright 2023. Atheer Inc. All rights reserved.</span></span></p></div></div></div><div ng-if="vm.isLoading" layout="row" layout-align="center center" layout-fill><wave-spinner></wave-spinner></div>');
$templateCache.put('modules/system/email-setup/email-setting.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="column" class="padded-content-page"><div flex layout="column" class="padded-content-page margin-top-40"><div layout="row" layout-align="center center"><div flex="50" layout="column" ng-form="emailForm"><md-input-container class="md-block"><label translate="atheer.emailSetup.fromAddress">From Address</label> <input type="text" name="from_address" ng-model="vm.emailModel.from_address" md-select-on-focus required ng-disabled="true"><div ng-messages="emailForm.from_address.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.setting.name">Name</label> <input name="name" ng-model="vm.emailModel.name" md-select-on-focus required><div ng-messages="emailForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.emailSetup.url">Logo URL</label> <input type="url" name="logo_url" ng-model="vm.emailModel.logo_url" md-select-on-focus required><div ng-messages="emailForm.logo_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout="row" layout-align="start center"><div class="md-body-2" translate="atheer.emailSetup.emailLayout">Email Layout</div></div><div layout="column"><md-tabs md-selected="selectedTabIndex"><md-tab ng-click="vm.view = \'EDIT\'"><md-tab-label><span translate="atheer.emailSetup.edit">Edit</span></md-tab-label></md-tab><md-tab ng-click="vm.view = \'PREVIEW\'"><md-tab-label><span translate="atheer.emailSetup.preview">Preview</span></md-tab-label></md-tab></md-tabs><div ng-if="vm.view == \'EDIT\'" class="fp-email-layout-editor margin-top-20"><textarea name="body" rows="15" ng-model="vm.emailModel.email_layout" id="field_tooltip"></textarea></div><div ng-if="vm.view == \'PREVIEW\'" class="margin-top-20"><iframe width="100%" height="250px" srcdoc="{{vm.emailModel.email_layout}}"></iframe></div></div></div></div></div></div>');
$templateCache.put('modules/system/feature/feature-setting.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div layout="row" layout-align="end"><span class="feature-tip">*</span> <span class="feature-tip feature-label" translate="atheer.system.contactAdmin">*Contact Admin</span></div><div flex layout="row" ng-if="!vm.loadingData"><md-content layout="column" flex><div layout="row" ng-repeat="(key, value) in vm.features track by $index" class="padding-left-20 padding-right-20"><md-card flex layout="row" layout-align="center center" layout-padding><div flex layout="column"><span class="md-title padding-bottom-20">{{value.label}}</span><div layout="row" flex="100" ng-repeat="subFeature in value.settings" class="feature-row"><div layout="row" layout-align="center center" class="feature-label">{{subFeature.label}}<span ng-if="!vm.isAdmin && !subFeature.editable">*</span><md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span>{{subFeature.description}}</span></fp-tooltip></md-button></div><div flex class="feature-setting" flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="subFeature.value" ng-disabled="!vm.isAdmin && !subFeature.editable"></md-switch></div></div></div></md-card></div></md-content></div></div>');
$templateCache.put('modules/system/fileext-config/fileext-setting.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Job File extensions Configuration</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData"><div class="padded-content-page margin-top-20"><md-input-container class="md-block"><div flex="60" class="padding-top-10"><span class="md-title padding-bottom-20" translate="atheer.fileExtConfig.title">file extensions</span><md-input-container flex class="md-block"><textarea ng-model="vm.fileExtensions" rows="3" md-select-on-focus></textarea></md-input-container></div></md-input-container><div><span class="md-body-1" translate="atheer.fileExtConfig.help">help</span></div></div></div></div>');
$templateCache.put('modules/system/icons/fa-icons.tmpl.html','<div class="padded-content-page"><p class="md-subhead">Triangular comes with the <a href="http://fortawesome.github.io/Font-Awesome/">Font Awesome Icon Fontset</a> built in.</p><p>Font Awesome gives you scalable vector icons that can instantly be customized \u2014 size, color, drop shadow, and anything that can be done with the power of CSS.</p><p>Click one of the icons below to find out how to add it to triangular!</p><div class="example-code md-whiteframe-z1"><md-toolbar><div class="md-toolbar-tools"><h2>Font Awesome Icons</h2></div></md-toolbar><md-content class="md-padding"><div layout="column"><md-input-container><label>Search icons</label> <input type="text" ng-model="searchIcon"></md-input-container><div layout="row" layout-wrap><div class="ui-icons-box-icon padding-10" flex="10" layout="column" layout-align="space-around center" ng-repeat="icon in vm.icons | filter:{ name: searchIcon }" ng-click="vm.selectIcon($event, icon)"><md-icon class="font-size-4" md-font-icon="{{::icon.className}}"></md-icon><span class="md-caption margin-top-10">{{::icon.name}}</span></div></div></div></md-content></div></div>');
$templateCache.put('modules/system/icons/material-icons.tmpl.html','<div class="padded-content-page"><p class="md-subhead">Triangular comes with the <a href="http://zavoloklom.github.io/material-design-iconic-font/index.html">Material Design Iconic Font</a> built in. This font has over 740 material design icons to choose from.</p><p>Click one of the icons below to find out how to add it to triangular!</p><div class="example-code md-whiteframe-z1"><md-toolbar><div class="md-toolbar-tools"><h2>Material Icons</h2></div></md-toolbar><md-content class="md-padding"><div layout="column"><div layout="row"><md-input-container flex><label>Search icons</label> <input type="text" ng-model="searchIcon"></md-input-container></div><div layout="row" layout-wrap><div class="ui-icons-box-icon padding-10" flex="20" layout="column" layout-align="start center" ng-repeat="icon in vm.icons | filter:{ name: searchIcon }" ng-click="vm.selectIcon($event, icon.class)"><md-icon class="font-size-4" md-font-icon="{{::icon.class}}"></md-icon><span class="md-caption margin-top-10">{{::icon.name}}</span></div></div></div></md-content></div></div>');
$templateCache.put('modules/system/jobreport-config/jobpdf-setting.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Job PDF Configuration</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()" ng-disabled="vm.readOnly"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div layout="row" layout-align="end"><span class="feature-tip feature-label" translate="atheer.pdfconfig.pdfConfigHelp">*Contact Admin</span></div><div ng-if="!vm.loadingData"><div flex layout="row"><md-content layout="column" flex><div layout="row" ng-repeat="(key, value) in vm.features track by $index" class="padding-left-20 padding-right-20"><md-card flex layout="row" layout-align="center center" layout-padding><div flex layout="column"><span class="md-title padding-bottom-20">{{value.label}}</span><div layout="row" flex="100" ng-repeat="subFeature in value.fields" class="feature-row"><div layout="row" layout-align="center center" class="feature-label">{{subFeature.label}}</div><div flex class="feature-setting" flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="subFeature.show" ng-disabled="vm.readOnly"></md-switch></div></div></div></md-card></div></md-content></div><div class="padded-content-page margin-top-20"><md-divider></md-divider><md-input-container class="md-block"><div flex="60" class="padding-top-10"><span class="md-title padding-bottom-20" translate="atheer.pdfconfig.photoSetting">Photo image source</span><md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.pdfconfig.photoSettingHelp">help</span></fp-tooltip></md-button><md-select ng-model="vm.photo_setting"><md-option ng-disabled="vm.readOnly" ng-repeat="photoSetting in vm.photo_setting_options" ng-value="photoSetting">{{photoSetting}}</md-option></md-select></div></md-input-container><div layout="row" ng-if="vm.photo_setting === \'Yes\'"><div flex="60" layout="column"><md-input-container class="md-block"><span class="md-title padding-bottom-20" translate="atheer.pdfconfig.photoWidth">Photo width</span><md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.pdfconfig.photoWidthHelp">help</span></fp-tooltip></md-button><input type="number" name="photo_width" ng-disabled="vm.readOnly" ng-model="vm.photo_width" md-select-on-focus required></md-input-container></div></div><div layout="row" ng-if="vm.photo_setting === \'Yes\'"><div flex="60" layout="column"><md-input-container class="md-block"><span class="md-title padding-bottom-20" translate="atheer.pdfconfig.photoHeight">Photo height</span><md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.pdfconfig.photoHeightHelp">help</span></fp-tooltip></md-button><input type="number" name="photo_height" ng-disabled="vm.readOnly" ng-model="vm.photo_height" md-select-on-focus required></md-input-container></div></div><div layout="row"><div flex="60" layout="column"><md-input-container class="md-block"><span class="md-title padding-bottom-20" translate="atheer.pdfconfig.responseColWidthAllocation">Response table column allocation</span><md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.pdfconfig.responseColWidthAllocationHelp">help</span></fp-tooltip></md-button><input type="text" name="response_col_width_allocation" ng-disabled="vm.readOnly" ng-model="vm.response_col_width_allocation" md-select-on-focus required></md-input-container></div></div></div></div></div>');
$templateCache.put('modules/system/label-dictionary/label-dictionary.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="row" ng-if="!vm.loadingData"><md-content layout="column" flex class="padding-top-20 padding-left-60 padding-right-60"><div layout="row" class="margin-bottom-20 padding-left-60 padding-right-60" layout-align="space-between center"><div flex="60"><span class="md-subhead" translate="atheer.setting.dictionary.pageDescription">By default, Atheer sets core terms to be used throughout the Studio and Lens. However, you can override these default terms if desired.</span></div><md-input-container class="md-block"><md-select ng-model="vm.selectedLanguage" class="md-no-underline" ng-change="vm.updateDictionary()"><md-option ng-repeat="language in vm.languages" ng-value="language.value">{{language.displayName}}</md-option></md-select></md-input-container></div><md-table-container layout-padding class="padding-left-60 padding-right-60"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.setting.dictionary.title">Title</span></th><th md-column><span translate="atheer.setting.dictionary.defaultValue">Default term</span></th><th md-column><span translate="atheer.setting.dictionary.yourValue">Your term</span></th><th md-column><span translate="atheer.setting.dictionary.defaultPluralValue">Default plural text</span></th><th md-column><span translate="atheer.setting.dictionary.yourPluralValue">Your plural text</span></th></tr></thead><tbody md-body><tr ng-repeat="setting in vm.selectedDictionary.settings track by $index"><td md-cell><span class="md-body-2">{{setting.label}}</span><br><span class="md-caption">{{setting.label}}</span></td><td md-cell>{{setting.default_value}}</td><td md-cell><md-input-container class="md-block dictionary-input-container"><input type="textAngular" ng-model="setting.value"></md-input-container></td><td md-cell>{{setting.default_plural_value}}</td><td md-cell><md-input-container ng-if="setting.default_plural_value" class="md-block dictionary-input-container"><input type="textAngular" ng-model="setting.plural_value"></md-input-container></td></tr></tbody></table></md-table-container></md-content></div></div>');
$templateCache.put('modules/system/language/language-delete-dialog.html','<md-dialog aria-label="Delete Language"><md-dialog-content class="md-dialog-content"><form name="deleteForm" ng-submit="vm.confirmDelete(vm.language.id)"><md-input-container class="md-block"><p translate="atheer.language.delete.question" translate-values="{id: \'{{vm.language.id}}\'}">Are you sure you want to delete this Language?</p></md-input-container></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.confirmDelete(vm.language.id)" type="submit" ng-disabled="deleteForm.$invalid" class="md-primary"><span translate="entity.action.delete">Delete</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/language/language-dialog.html','<md-dialog aria-label="Language Detail" flex="30" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="vm.language.id !== null"><h2 id="myLanguageLabel" translate="atheer.language.home.editLabel">Edit a Language</h2></div><div ng-if="vm.language.id == null"><h2 id="myLanguageLabel" translate="atheer.language.home.createLabel">Create a Language</h2></div><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><div><input type="hidden" id="id" name="id" ng-model="vm.language.id" readonly="readonly"></div><md-input-container class="md-block"><label class="md-required" translate="atheer.language.languageNo" for="field_languageNo">LanguageNo</label> <input type="number" class="form-control" name="languageNo" id="field_languageNo" ng-model="vm.language.language_no" required><div ng-messages="editForm.languageNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.language.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.language.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.language.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.language.description"></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.language.code" for="field_code">Code</label> <input type="text" class="form-control" name="code" id="field_code" ng-model="vm.language.code" required><div ng-messages="editForm.code.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-checkbox name="enabled" id="field_enabled" class="md-primary" ng-model="vm.language.enabled" aria-label="Primary Checkbox"><span translate="atheer.language.enabled" for="field_enabled" for="field_enabled">Enabled</span></md-checkbox><div ng-messages="editForm.enabled.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div><md-checkbox name="systemProvided" id="field_systemProvided" class="md-primary" ng-model="vm.language.system_provided" aria-label="Primary Checkbox"><span translate="atheer.language.systemProvided" for="field_systemProvided" for="field_systemProvided">SystemProvided</span></md-checkbox><div ng-messages="editForm.systemProvided.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid || isSaving" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/language/languages.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="enter search" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom">Filter</fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Cancel</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">Refresh</fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column md-order-by="languageNo"><span translate="atheer.language.languageNo">LanguageNo</span></th><th md-column md-order-by="name"><span translate="atheer.language.name">Name</span></th><th md-column md-order-by="description"><span translate="atheer.language.description">Description</span></th><th md-column md-order-by="code"><span translate="atheer.language.code">Code</span></th><th md-column md-order-by="enabled"><span translate="atheer.language.enabled">Enabled</span></th><th md-column md-order-by="systemProvided"><span translate="atheer.language.systemProvided">SystemProvided</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="language in vm.languages track by language.id"><td md-cell>{{language.language_no}}</td><td md-cell>{{language.name}}</td><td md-cell>{{language.description}}</td><td md-cell>{{language.code}}</td><td md-cell>{{language.enabled}}</td><td md-cell>{{language.system_provided}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(jobStream.id)"><md-icon class="zmdi zmdi-eye icon-size"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/system/lens-app/lens-app-support-devices.html','<div flex layout="column" layout-fill class="lens-app-devices"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h3 ng-if="vm.type == \'APPLE\'" hide-xs flex translate="atheer.downloadApps.devices.apple">Supported Devices - Apple - iPhone/iPad</h3><h3 ng-if="vm.type == \'ANDROID\'" hide-xs flex translate="atheer.downloadApps.devices.android">Supported Devices - Android - Mobile/Tablet</h3><h3 ng-if="vm.type == \'GLASS\'" hide-xs flex translate="atheer.downloadApps.devices.glass">Supported Devices - Android - Glass</h3><h3 ng-if="vm.type == \'DESKTOP\'" hide-xs flex translate="atheer.downloadApps.devices.desktop">Supported Desktops</h3><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.downloadApps.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-content flex ng-if="!vm.loadingData"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><tbody md-body><tr ng-repeat="device in vm.lens.supported_devices"><td md-cell>{{device}}</td></tr></tbody></table></md-table-container></md-content></div>');
$templateCache.put('modules/system/lens-app/lens-apps.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="global.menu.downloadApps">Download Apps</span></h2><span flex></span><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="column" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><md-content ng-if="!vm.loadingData" flex layout="column" class="md-padding"><div flex layout="row" class="margin-top-100"><div flex class="lens-app-cards" ng-repeat="lensApp in vm.lensApps"><div class="lens-app-card padding-10"><div layout="column"><div ng-if="lensApp.type == \'APPLE\'" class="margin-top-40" flex layout="column" layout-align="center center" layout-padding><img src="assets/images/lens-app/apple.png" height="50px" alt="Video Providers"> <span class="md-display-1 margin-top-20">{{lensApp.name}}</span></div><div ng-if="lensApp.type == \'ANDROID\'" class="margin-top-40" flex layout="column" layout-align="center center" layout-padding><img src="assets/images/lens-app/android.png" height="50px" alt="Video Providers"> <span class="md-display-1 margin-top-20">{{lensApp.name}}</span></div><div ng-if="lensApp.type == \'GLASS\'" class="margin-top-40" flex layout="column" layout-align="center center" layout-padding><img src="assets/images/lens-app/glasses.png" height="50px" alt="Video Providers"> <span class="md-display-1 margin-top-20">{{lensApp.name}}</span></div><div ng-if="lensApp.type == \'DESKTOP\'" class="margin-top-40" flex layout="column" layout-align="center center" layout-padding><img src="assets/images/lens-app/desktop-app.png" height="50px" alt="Video Providers"> <span class="md-display-1 margin-top-20" translate="atheer.downloadApps.desktop">Desktop</span></div><md-divider></md-divider><div class="margin-top-20" flex layout="column" layout-align="center center"><span class="md-body-2" translate="atheer.downloadApps.version">Version</span> <span class="md-body-1">{{lensApp.version}}</span></div><div flex layout="column" layout-align="center center" class="margin-top-20 margin-bottom-20"><md-button id="{{lensApp.type}}" ng-click="vm.showSupoortedDevice(lensApp)" class="md-body-2" translate="atheer.downloadApps.supportedDevices">Supported Devices</md-button></div><md-divider></md-divider><div ng-if="lensApp.type == \'APPLE\'" flex layout="column" layout-align="center center" class="margin-top-40 margin-bottom-60"><a href="{{lensApp.store_link}}"><img src="assets/images/lens-app/apple-store.png"></a></div><div ng-if="lensApp.type == \'ANDROID\'" flex layout="row" layout-align="space-around center" class="margin-top-40 margin-bottom-60"><a href="{{lensApp.store_link}}"><img alt="Qries" src="assets/images/lens-app/android-store.png"> </a><a ng-if="!vm.showRigPartnerStore" href="{{lensApp.atheer_link}}"><img alt="Qries" src="assets/images/lens-app/atheer-store.png"> </a><a ng-if="!vm.showRigPartnerStore" href="{{lensApp.atheer_kiosk_link}}"><img alt="Qries" src="assets/images/lens-app/atheer-store-kiosk.png"> </a><a ng-if="vm.showRigPartnerStore" href="{{lensApp.atheer_link}}"><img alt="Qries" src="assets/images/lens-app/rigpartner-store.png"> </a><a ng-if="vm.showRigPartnerStore" href="{{lensApp.atheer_kiosk_link}}"><img alt="Qries" src="assets/images/lens-app/rigpartner-store-kiosk.png"></a></div><div ng-if="lensApp.type == \'GLASS\'" flex layout="row" layout-align="center center" gap="2" class="margin-top-40 margin-bottom-60"><a ng-if="!vm.showRigPartnerStore" href="{{lensApp.atheer_link}}"><img class="item" alt="Qries" src="assets/images/lens-app/atheer-store.png"> </a><a ng-if="!vm.showRigPartnerStore" href="{{lensApp.atheer_kiosk_link}}"><img class="item" alt="Qries" src="assets/images/lens-app/atheer-store-kiosk.png"> </a><a ng-if="vm.showRigPartnerStore" href="{{lensApp.atheer_link}}"><img class="item" alt="Qries" src="assets/images/lens-app/rigpartner-store.png"> </a><a ng-if="vm.showRigPartnerStore" href="{{lensApp.atheer_kiosk_link}}"><img class="item" alt="Qries" src="assets/images/lens-app/rigpartner-store-kiosk.png"></a></div><div ng-if="lensApp.type == \'DESKTOP\'" flex layout="row" layout-align="center center" class="margin-top-40 margin-bottom-60 desktop"><a href="{{lensApp.windows_link}}"><img class="item" src="assets/images/lens-app/microsoft-lens.png"> </a><a href="{{lensApp.mac_link}}"><img class="item" src="assets/images/lens-app/mac-lens.png"> </a><a href="{{lensApp.linux_link}}"><img class="item" src="assets/images/lens-app/linux_x64.png"> </a><a href="{{lensApp.linux_arm_link}}"><img class="item" src="assets/images/lens-app/linux_ARM64.png"></a></div></div></div></div></div></md-content></div>');
$templateCache.put('modules/system/lens-home-page-config/lens-home-page-config.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div class="padded-content-page" ng-if="!vm.loadingData"><md-tabs md-center-tabs><md-tab ng-click="vm.tabSelected(\'lens\')"><md-tab-label><span translate="atheer.homepageconfig.lens">Lens</span></md-tab-label></md-tab><md-tab ng-click="vm.tabSelected(\'studio\')"><md-tab-label><span translate="atheer.homepageconfig.studio">Studio</span></md-tab-label></md-tab><md-tab ng-click="vm.tabSelected(\'command\')"><md-tab-label><span translate="atheer.homepageconfig.aicommand">AI Commands</span></md-tab-label></md-tab><md-tab ng-click="vm.tabSelected(\'embed_copilot\')"><md-tab-label><span translate="atheer.homepageconfig.embedcopilot">Embed Copilot</span></md-tab-label></md-tab></md-tabs><div flex ui-view></div></div><div flex layout="row" layout-align="space-around start" ng-style="{\'min-height\' : vm.selectedHomeScreenConfig !== \'embed_copilot\' ? \'180px\' : \'1000px\'}" class="margin-bottom-20" ng-if="!vm.loadingData"><div flex="30" class="margin-top-40" layout="row" layout-align="space-around center"><div flex layout="column" ng-if="vm.selectedHomeScreenConfig !== \'embed_copilot\'"><div flex layout="row" layout-align="center center" class="config-subhead margin-bottom-20" translate="atheer.homepageconfig.uploadConfigFile">Upload Configuration File</div><div flex layout="row" layout-align="center space-around" class="preview-container"><div class="config-preview text-overflow"><span class="download-text" md-colors="{color:\'primary\'}" ng-if="!vm.lensHomepageConfigFile" translate="atheer.homepageconfig.noconfiguploaded">No configuration Uploaded </span><span ng-if="vm.lensHomepageConfigFile && !vm.isFileUploadInProgress" ng-click="vm.downloadConfigFile()"><md-icon md-colors="{fill: \'primary\'}" class="session-icon" md-svg-icon="/assets/images/card/config_attachment_icon.svg"></md-icon><span class="download-text download-link" md-colors="{color:\'primary\'}">{{vm.configFileName}}</span></span><md-progress-circular ng-if="vm.isFileUploadInProgress" class="md-primary" md-diameter="25px"></md-progress-circular></div></div><div class="margin-bottom-20" layout="row" layout-align="end end" ng-if="vm.selectedHomeScreenConfig !== \'command\'"><div class="sample-file" ng-click="vm.downloadSampleFile()"><md-icon class="fa fa-download md-primary download-icon"></md-icon><span class="download-text" md-colors="{color:\'primary\'}" translate="atheer.homepageconfig.sampleConfigFile">Sample Config File</span></div></div><div class="margin-top-20" flex layout="row" layout-align="center center" class="config-actions"><md-button type="button" class="md-raised config-button" ng-click="vm.setDefault()" ng-if="vm.selectedHomeScreenConfig !== \'command\'"><span translate="atheer.homepageconfig.setDefaultConfig">Set Default Config</span></md-button><span ng-if="vm.selectedHomeScreenConfig !== \'command\'">or</span><md-button type="button" class="md-primary md-raised config-button" ngf-select="vm.upload($files)" ngf-multiple="false" ngf-pattern="\'application/json\'" ngf-accept="\'application/json\'" ngf-max-size="{{vm.fileMaxSize}}" ngf-ignore-invalid="\'pattern maxSize\'"><span translate="atheer.homepageconfig.chooseFile">Choose File</span></md-button></div></div><div ng-if="vm.selectedHomeScreenConfig === \'embed_copilot\'"><div flex layout="row" layout-align="center center" class="config-subhead margin-bottom-20" translate="atheer.homepageconfig.configEmbedCopilot">Configure the Embeded Copilot</div><div flex layout="row" layout-align="center center" class="config-subhead margin-bottom-20"><mat-form-field class="full-width"><md-input-container class="md-block input-field"><label translate="atheer.homepageconfig.iconUrl">Icon URL</label> <input type="text" name="name" ng-model="vm.iconUrl" md-select-on-focus></md-input-container><md-input-container class="md-block input-field"><label class="label" translate="atheer.homepageconfig.themeColor">Theme Color</label></md-input-container><div layout="row" layout-align="space-between center" ng-cloak><div class="color-picker" flex md-color-picker ng-model="vm.themeColor" md-color-alpha-channel="false" md-color-sliders="false" md-color-rgb="false" md-color-hsl="false" md-color-history="false" md-color-clear-button="false" open-on-input="true" md-placeholder="Select theme color"></div></div><md-input-container class="md-block input-field"><label translate="atheer.homepageconfig.bottomPosition">Bottom Position</label> <input type="text" name="name" ng-model="vm.bottom" md-select-on-focus></md-input-container><md-input-container class="md-block input-field mt-35"><label translate="atheer.homepageconfig.rightPosition">rightPosition</label> <input type="text" name="name" ng-model="vm.right" md-select-on-focus></md-input-container><div layout="row" layout-align="center center"><md-button type="button" class="md-primary md-raised config-button" ng-click="vm.generateScript()"><span translate="atheer.homepageconfig.generateScript">Generate script</span></md-button></div><div class="embed-script-textarea" ng-show="!!vm.embedScript"><textarea class="embed-script" cols="42" rows="6" readonly="readonly">{{vm.embedScript}}</textarea><md-button ngclipboard data-clipboard-text="{{vm.embedScript}}" ngclipboard-success="vm.onCopySuccess(e)" class="md-icon-button copy-text"><fp-tooltip><span>Copy</span></fp-tooltip><md-icon md-font-icon="zmdi zmdi-copy"></md-icon></md-button></div></mat-form-field></div></div></div></div></div>');
$templateCache.put('modules/system/locale/locale-delete-dialog.html','<md-dialog aria-label="Delete Locale"><md-dialog-content class="md-dialog-content"><form name="deleteForm" ng-submit="vm.confirmDelete(vm.locale.id)"><md-input-container class="md-block"><p translate="atheer.locale.delete.question" translate-values="{id: \'{{vm.locale.id}}\'}">Are you sure you want to delete this Locale?</p></md-input-container></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.confirmDelete(vm.locale.id)" type="submit" ng-disabled="deleteForm.$invalid" class="md-primary"><span translate="entity.action.delete">Delete</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/locale/locale-dialog.html','<md-dialog aria-label="Locale Detail" flex="30" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="vm.locale.id !== null"><h2 id="myLocaleLabel" translate="atheer.locale.home.editLabel">Edit a Locale</h2></div><div ng-if="vm.locale.id == null"><h2 id="myLocaleLabel" translate="atheer.locale.home.createLabel">Create a Locale</h2></div><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><div><input type="hidden" id="id" name="id" ng-model="vm.locale.id" readonly="readonly"></div><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.localeNo" for="field_localeNo">LocaleNo</label> <input type="number" class="form-control" name="localeNo" id="field_localeNo" ng-model="vm.locale.locale_no" required><div ng-messages="editForm.localeNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.locale.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.locale.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.locale.description"></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.code" for="field_code">Code</label> <input type="text" class="form-control" name="code" id="field_code" ng-model="vm.locale.code" required><div ng-messages="editForm.code.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.dateFormat" for="field_dateFormat">DateFormat</label> <input type="text" class="form-control" name="dateFormat" id="field_dateFormat" ng-model="vm.locale.date_format" required><div ng-messages="editForm.dateFormat.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.timeFormat" for="field_timeFormat">TimeFormat</label> <input type="text" class="form-control" name="timeFormat" id="field_timeFormat" ng-model="vm.locale.time_format" required><div ng-messages="editForm.timeFormat.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.numberFormat" for="field_numberFormat">NumberFormat</label> <input type="text" class="form-control" name="numberFormat" id="field_numberFormat" ng-model="vm.locale.number_format" required><div ng-messages="editForm.numberFormat.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.nameFormat" for="field_nameFormat">NameFormat</label> <input type="text" class="form-control" name="nameFormat" id="field_nameFormat" ng-model="vm.locale.name_format" required><div ng-messages="editForm.nameFormat.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.textOrientation" for="field_textOrientation">TextOrientation</label> <input type="text" class="form-control" name="textOrientation" id="field_textOrientation" ng-model="vm.locale.text_orientation" required><div ng-messages="editForm.textOrientation.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.locale.addressFormat" for="field_addressFormat">AddressFormat</label> <input type="text" class="form-control" name="addressFormat" id="field_addressFormat" ng-model="vm.locale.address_format" required><div ng-messages="editForm.addressFormat.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-checkbox name="enabled" id="field_enabled" class="md-primary" ng-model="vm.locale.enabled" aria-label="Primary Checkbox"><span translate="atheer.locale.enabled" for="field_enabled" for="field_enabled">Enabled</span></md-checkbox><div ng-messages="editForm.enabled.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div><md-checkbox name="systemProvided" id="field_systemProvided" class="md-primary" ng-model="vm.locale.system_provided" aria-label="Primary Checkbox"><span translate="atheer.locale.systemProvided" for="field_systemProvided" for="field_systemProvided">SystemProvided</span></md-checkbox><div ng-messages="editForm.systemProvided.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid || isSaving" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/locale/locales.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="enter search" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom">Filter</fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Cancel</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">Refresh</fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column md-order-by="localeNo"><span translate="atheer.locale.localeNo">LocaleNo</span></th><th md-column md-order-by="name"><span translate="atheer.locale.name">Name</span></th><th md-column md-order-by="code"><span translate="atheer.locale.code">Code</span></th><th md-column md-order-by="enabled"><span translate="atheer.locale.enabled">Enabled</span></th><th md-column md-order-by="systemProvided"><span translate="atheer.locale.systemProvided">SystemProvided</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="locale in vm.locales track by locale.id"><td md-cell>{{locale.locale_no}}</td><td md-cell>{{locale.name}}</td><td md-cell>{{locale.code}}</td><td md-cell>{{locale.enabled}}</td><td md-cell>{{locale.system_provided}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(jobStream.id)"><md-icon class="zmdi zmdi-eye icon-size"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/system/media/media-dialog.html','<md-dialog aria-label="Media Detail" flex="30" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="vm.media.id"><h2 id="myMediaLabel" translate="atheer.media.home.editLabel">Edit a Media</h2></div><div ng-if="!vm.media.id"><h2 id="myMediaLabel" translate="atheer.media.home.createLabel">Create a Media</h2></div><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><div><input type="hidden" id="id" name="id" ng-model="vm.media.id" readonly="readonly"></div><md-input-container class="md-block" ng-if="vm.media.id"><label class="md-required" translate="atheer.media.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.media.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block" ng-if="vm.media.id"><label translate="atheer.media.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.media.description"></md-input-container><md-input-container class="md-block" ng-if="vm.media.id"><label translate="atheer.media.type" for="field_type">Type</label><md-select disabled="disabled" name="type" ng-model="vm.media.type" id="field_type" required><md-option value="IMAGE" translate="atheer.MediaType.IMAGE">IMAGE</md-option><md-option value="ICON" translate="atheer.MediaType.ICON">ICON</md-option><md-option value="AUDIO" translate="atheer.MediaType.AUDIO">AUDIO</md-option><md-option value="VIDEO" translate="atheer.MediaType.VIDEO">VIDEO</md-option></md-select><div ng-messages="editForm.type.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block" ng-if="vm.media.id"><label translate="atheer.media.sourceFileName" for="field_sourceFileName">File Name</label> <input disabled="disabled" type="text" class="form-control" name="fileName" id="field_sourceFileName" ng-model="vm.media.source_file_name"></md-input-container><md-input-container class="md-block" ng-if="vm.media.id"><label translate="atheer.media.sourceFileSize" for="field_fileSize">File Size</label> <input disabled="disabled" type="number" class="form-control" name="fileSize" id="field_sourceFileSize" ng-model="vm.media.source_file_size"></md-input-container><div layout="row" layout-align="space-around center" ng-if="!vm.media.id"><fp-upload flex fp-content-type="image" fp-ng-model="vm.media" fp-multiple="false" fp-bind-full-obj="true" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="dropAndPick"></fp-upload></div></div></form></md-dialog-content><md-dialog-actions layout="row" ng-if="vm.media.id"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid || isSaving" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/media/media.html','<md-card flex layout="column"><ng-include src="\'modules/system/admin/admin-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.media.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main">Uh!</div><div class="margin-top-10 base">There are no <span translate="{{vm.pageTitleKey}}"></span> yet.</div><div permission permission-only="vm.permissions.create" class="margin-top-20" layout="column" layout-align="center center"><md-button ng-click="vm.createObject()" class="md-primary md-raised">Add Now</md-button></div></div><md-content flex class="md-padding" ng-if="vm.media.length > 0"><md-table-container><table md-table multiple="{{vm.isMultiple}}" md-row-select="vm.isPickerView" ng-model="vm.currentMedia" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th></th><th md-column md-order-by="name"><span translate="atheer.media.name">Name</span></th><th md-column md-order-by="type"><span translate="atheer.media.type">Type</span></th><th md-column md-order-by="source_file_name" ng-if="!isPickerView"><span translate="atheer.media.sourceFileName">Original Name</span></th><th md-column md-order-by="source_file_size" ng-if="!isPickerView"><span translate="atheer.media.sourceFileSize">Size</span></th><th ng-if="!isPickerView"></th></tr></thead><tbody md-body><tr ng-repeat="media in vm.media track by media.id" md-row md-select="media" md-select-id="id" md-auto-select><td md-cell><img ng-src="{{vm.getUrl(media) | mediaUrl}}"></td><td md-cell>{{media.name}}</td><td md-cell translate="{{\'atheer.MediaType.\' + media.type}}">{{media.type}}</td><td md-cell ng-if="!isPickerView">{{media.source_file_name}}</td><td md-cell ng-if="!isPickerView">{{media.source_file_size}}</td><td class="text-right" ng-if="!isPickerView"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(media.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu permission permission-only="vm.permissions.delete"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteObject(media)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.media.length > 0"></md-table-pagination><div class="btn-group flex-btn-group-container" ng-if="vm.isPickerView && vm.media.length > 0"><md-button layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()">Select</md-button></div></md-card>');
$templateCache.put('modules/system/metadata/field-dialog.tmpl.html','<md-dialog aria-label="User Field  Detail" flex="50" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="!vm.isAdd"><h2 id="myAtheerFieldLabel" translate="fieldDialog.editField">Edit a Field</h2></div><div ng-if="vm.isAdd"><h2 id="myAtheerFieldLabel" translate="fieldDialog.createField">Create a Field</h2></div><div flex="" class="flex"></div><md-button class="md-icon-button" ng-click="vm.clear()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="fieldDialog.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-divider></md-divider><div ng-if="vm.field.data_type === \'LIST\'" flex><md-tabs md-center-tabs><md-tab md-active="true" ng-click="vm.showOptions=false"><md-tab-label><span translate="fieldDialog.details">Details</span></md-tab-label></md-tab><md-tab ng-click="vm.showOptions=true"><md-tab-label><span translate="fieldDialog.options">Options</span></md-tab-label></md-tab></md-tabs></div><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div ng-show="vm.field.data_type !== \'LIST\' || (vm.field.data_type === \'LIST\' && !vm.showOptions)"><md-input-container class="md-block"><label class="md-required" translate="fieldDialog.label">Label</label> <input type="text" class="form-control" name="label" id="field_label" ng-model="vm.field.label" ng-change="vm.setFieldName()" required ng-pattern="/^[a-zA-Z0-9 _@#$%!-]*$/"><div ng-messages="editForm.label.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="pattern"><span translate="entity.validation.specialCharectersNotAllowed">This field contains special characters. Only allowed special characters are - _ @ ! # $ %</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" for="field_name" translate="fieldDialog.name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.field.name" required ng-disabled="true"><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout-align="start center"><span translate="fieldDialog.description">Description</span></div><md-input-container class="md-block"><textarea name="description" ng-model="vm.field.description" id="field_description"></textarea></md-input-container><md-input-container class="md-block"><label translate="fieldDialog.type">Type</label><md-select name="dataType" ng-model="vm.field.data_type" id="field_dataType" required><md-option value="STRING" translate="fieldDialog.fieldType.text">Text</md-option><md-option value="BOOLEAN" translate="fieldDialog.fieldType.boolean">Boolean</md-option><md-option value="NUMBER" translate="fieldDialog.fieldType.number">Number</md-option><md-option value="DECIMAL" translate="fieldDialog.fieldType.decimal">Decimal</md-option><md-option value="LIST" translate="fieldDialog.fieldType.list">List</md-option><md-option value="DATE" translate="fieldDialog.fieldType.date">Date</md-option><md-option value="ARRAY" translate="fieldDialog.fieldType.array">Array</md-option><!--\n                        <md-option value="OBJECT">Object</md-option>\n                        --></md-select><div ng-messages="editForm.dataType.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block" ng-if="vm.field.data_type == \'OBJECT\'"><label translate="fieldDialog.objectType">Object Type</label><md-select name="objectType" ng-model="vm.field.ref_object" id="field_objectType" required><md-option value="Content" translate="fieldDialog.objectTypeOption.content">Content</md-option><md-option value="User" translate="fieldDialog.objectTypeOption.user">User</md-option></md-select><div ng-messages="editForm.objectType.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout="row" layout-align="space-between center"><span translate="fieldDialog.required">Required</span><md-switch id="field_required" name="required" ng-model="vm.field.required"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="fieldDialog.enabled">Enabled</span><md-switch id="field_enabled" name="enabled" ng-model="vm.field.enabled"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="fieldDialog.allowSearch">Allow Search</span><md-switch id="field_search_enabled" name="search_enabled" ng-model="vm.field.search_enabled"></md-switch></div></div><div ng-show="vm.field.data_type === \'LIST\' && vm.showOptions" class="field-options"><fp-accordion accordion-model="vm.field.list_options" add-item="vm.addNewOption()"><fp-accordion-expander ng-repeat="item in vm.field.list_options track by $index" item="item" index="$index" copy-item="vm.copyOption(itemObj)" remove-item="vm.removeOption(index)" title="vm.field.list_options[$index].label || \'Untitled Option\'"><md-input-container class="md-block"><label translate="fieldDialog.label">Label</label> <input type="text" name="label" ng-model="vm.field.list_options[$index].label"></md-input-container><md-input-container class="md-block"><label translate="fieldDialog.description">Description</label> <input type="text" name="description" ng-model="vm.field.list_options[$index].description"></md-input-container></fp-accordion-expander></fp-accordion></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid || (vm.field.data_type === \'LIST\' && !vm.field.list_options.length)" class="md-primary md-raised" ng-click="vm.add()"><span>{{vm.isAdd ? \'entity.action.add\' : \'entity.action.update\' | translate}}</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/metadata/field-group-dialog.tmpl.html','<md-dialog aria-label="User Field Group Detail" flex="30" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="!vm.isAdd"><h2 id="myAtheerFieldLabel" translate="fieldGroup.editEventGroup">Edit a Event Group</h2></div><div ng-if="vm.isAdd"><h2 id="myAtheerFieldLabel" translate="fieldGroup.createEventGroup">Create a Event Group</h2></div><div flex="" class="flex"></div></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><md-input-container class="md-block"><label class="md-required" for="field_label" translate="fieldGroup.label">Label</label> <input type="text" class="form-control" name="label" id="field_label" ng-model="vm.fieldGroup.label" ng-change="vm.setFieldGroupName()" required ng-pattern="/^[a-zA-Z0-9 _@#$%!-]*$/"><div ng-messages="editForm.label.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="pattern"><span translate="entity.validation.specialCharectersNotAllowed">This field contaains special characters. Only allowed special characters are - _ @ ! # $ %</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" for="field_plural_label" translate="fieldGroup.pluralLabel">Plural Label</label> <input type="text" class="form-control" name="plural_label" id="field_plural_label" ng-model="vm.fieldGroup.plural_label" required><div ng-messages="editForm.plural_label.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" for="field_name" translate="fieldGroup.name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.fieldGroup.name" required ng-disabled="true"><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><div layout-align="start center"><span translate="fieldGroup.description">Description</span></div><md-input-container class="md-block"><textarea name="description" ng-model="vm.fieldGroup.description" id="field_description"></textarea></md-input-container><div layout="row" layout-align="space-between center"><span translate="fieldGroup.enabled">Enabled</span><md-switch name="enabled" ng-model="vm.fieldGroup.enabled"></md-switch></div><div layout="row" layout-align="space-between center"><span translate="fieldGroup.allowSearch">Allow Search</span><md-switch name="enabled" ng-model="vm.fieldGroup.search_enabled"></md-switch></div></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid" class="md-primary md-raised" ng-click="vm.add()"><span>{{vm.isAdd ? \'entity.action.add\' : \'entity.action.update\' | translate}}</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/notification/notification-detail.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToNotifications()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span flex>{{vm.notificationModel.title}}</span><md-button ng-if="!vm.notificationModel.locked" type="submit" class="md-accent md-raised" ng-disabled="helpMetaDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div flex layout="row"><md-content layout="column" flex><div class="fp-content-detail-form" layout="row" layout-fill layout-align="center"><div layout="column" flex="70" flex-xl="90"><div flex layout="column"><md-tabs flex><md-tab flex label="{{\'atheer.notification.mail\' | translate}}"><md-tab-content flex class="padding-top-20"><div ng-form="helpMetaDetailForm"><div layout="row" flex="20" class="margin-bottom-20" layout-align="space-between center"><md-input-container class="md-block"><label class="md-required" translate="atheer.notification.language">Language</label><md-select ng-model="vm.selectedLanguage" class="md-no-underline" ng-change="vm.updateLanguage()"><md-option ng-repeat="language in vm.languages" ng-value="language.value">{{language.displayName}}</md-option></md-select></md-input-container></div><md-input-container ng-if="vm.notificationModel.name != \'header\' && vm.notificationModel.name != \'footer\'" class="md-block"><label class="md-required" translate="atheer.notification.subject">Subject</label> <input type="text" class="form-control" name="email_subject" id="field_email_subject" ng-model="vm.email_subject" required><div ng-messages="helpMetaDetailForm.email_subject.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><textarea name="body" froala="vm.froalaOptions" ng-model="vm.email_body" id="field_tooltip"></textarea></md-input-container></div></md-tab-content></md-tab><md-tab label="{{\'atheer.notification.sms\' | translate}}" ng-if="vm.notificationModel.allow_sms_enable"><md-tab-content flex class="padded-content-page content-properties-container"><div ng-form="helpMetaDetailForm"><div layout="row" flex="20" class="margin-bottom-20" layout-align="space-between center"><md-input-container class="md-block"><label class="md-required" translate="atheer.notification.language">Language</label><md-select ng-model="vm.selectedLanguage" class="md-no-underline" ng-change="vm.updateLanguage()"><md-option ng-repeat="language in vm.languages" ng-value="language.value">{{language.displayName}}</md-option></md-select></md-input-container></div><md-input-container ng-if="vm.notificationModel.name != \'header\' && vm.notificationModel.name != \'footer\'" class="md-block"><label class="md-required" translate="atheer.notification.title">Title</label> <input type="text" class="form-control" name="sms_title" id="field_sms_title" ng-model="vm.sms_title" required><div ng-messages="helpMetaDetailForm.sms_title.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><textarea name="sms_body" rows="5" md-select-on-focus ng-model="vm.sms_body" id="field_tooltip"></textarea></md-input-container></div></md-tab-content></md-tab></md-tabs></div></div></div></md-content></div></div>');
$templateCache.put('modules/system/notification/notification-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="enter search" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom">Filter</fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Cancel</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">Refresh</fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar>');
$templateCache.put('modules/system/notification/notifications.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.notification.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ui-sref="storm.admin-setting.email"><md-icon md-font-icon="zmdi zmdi-email"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.setting.setup">User Fields</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="row" ng-if="!vm.loadingData"><md-content layout="column" flex><md-table-container layout-padding><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.notification.title">Title</span></th><th md-column><span translate="atheer.notification.email">Email</span></th><th permission permission-only="[atheer_features.system.notification_edit]"></th></tr></thead><tbody md-body><tr ng-repeat="notification in vm.notifications track by notification.id" ng-if="notification.allow_edit" class="fp-notification-list"><td md-cell>{{notification.title}}</td><td><md-switch name="email_enable" ng-model="notification.email_enabled" ng-change="vm.toggleEmail(notification)" ng-disabled="!notification.allow_email_enable"></md-switch></td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="[atheer_features.system.notification_edit]" ng-if="notification.allow_edit" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(notification.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><fp-tooltip><span translate="atheer.notification.edit">Edit</span></fp-tooltip></md-button></div></td></tr></tbody></table></md-table-container></md-content></div></div>');
$templateCache.put('modules/system/security-role/security-role-assign-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="assignSecurityRole.title">Assign Security Role</span></div></md-toolbar><md-dialog-content class="md-dialog-content"><form name="assignSecurityRoleForm"><div ng-if="!vm.fromProfilePage" class="fp-user-chips"><fp-auto-complete no-label="true" is-admin="true" auto-complete-model="vm.asyncUsers" component="User" multiple="true"></fp-auto-complete></div><div ng-if="vm.fromProfilePage" class="fp-user-chips"><fp-auto-complete no-label="true" auto-complete-model="vm.asyncSecurityRoles" component="SecurityRole" multiple="true" query-objs="[{fieldName:\'name\', operator:\'=re=\'}]"></fp-auto-complete></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.submit()" type="submit" ng-disabled="assignSecurityRoleForm.$invalid" class="md-primary md-raised"><span translate="entity.action.assign">Assign</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/security-role/security-role-detail-toolbar.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.goToSecurityRoles()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span flex translate="atheer.securityRole.securityRoleDetail">Security Role Detail</span><div layout="row"><md-button ng-if="!vm.securityRoleModel.locked" type="submit" class="md-accent md-raised" ng-disabled="securityRoleDetailForm.$invalid" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><div permission permission-only="atheer_features.security_roles.custom_roles"><md-button class="md-icon-button" ng-click="vm.copySecurityRole()"><md-icon md-font-icon="zmdi zmdi-copy"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.copy">Copy</span></fp-tooltip></md-button></div><fp-help></fp-help></div></div></md-toolbar>');
$templateCache.put('modules/system/security-role/security-role-detail.tmpl.html','<ng-include src="\'modules/system/security-role/security-role-detail-toolbar.tmpl.html\'"></ng-include><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" class="fp-content-detail-form" layout="row" layout-fill flex><div layout="column" flex="35" flex-xl="25" class="md-whiteframe-z1"><div flex layout="column"><md-content flex class="padded-content-page content-properties-container"><div ng-form="securityRoleDetailForm"><md-input-container ng-if="!vm.isNew()" class="md-block"><label class="md-required" translate="atheer.securityRole.securityRoleNo" for="field_securityRoleNo">SecurityRoleNo</label> <input type="number" class="form-control" name="securityRoleNo" id="field_securityRoleNo" ng-model="vm.securityRoleModel.security_role_no" required ng-disabled="true"><div ng-messages="securityRoleDetailForm.securityRoleNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.securityRole.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.securityRoleModel.name" required ng-disabled="vm.securityRoleModel.locked"><div ng-messages="securityRoleDetailForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.securityRole.roleType" for="field_jobRole">Role Type</label><md-select id="field_jobRole" ng-model="vm.jobRole" ng-change="vm.onRoleChange()" ng-disabled="vm.securityRoleModel.locked"><md-option ng-value="\'Standard Role\'" translate="atheer.securityRole.standardRole">Standard Role</md-option></md-select><div ng-messages="securityRoleDetailForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.securityRole.description" for="field_description">Description</label> <textarea name="description" ng-model="vm.securityRoleModel.description" id="field_description" ng-disabled="vm.securityRoleModel.locked" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container></div></md-content></div></div><div flex layout="column"><md-tabs ng-if="!vm.isNew()" md-selected="selectedTabIndex"><md-tab ng-click="vm.view = \'PERMISSIONS\'"><md-tab-label><span translate="atheer.securityRole.permissions">Permissions</span></md-tab-label></md-tab><md-tab ng-click="vm.view = \'USERS\'"><md-tab-label><span translate="atheer.securityRole.users">Users</span></md-tab-label></md-tab></md-tabs><div layout="center center" flex><div ng-if="vm.isNew()" flex layout-align="center center" layout="row"><div flex="75" layout="row"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.securityRole.saveSecurityRole">Please save the Security Role to add Permission and Users to it.</span></div></div></div><md-content layout="column" flex ng-if="!vm.isNew() && vm.view == \'PERMISSIONS\'"><ang-accordion icon-position="right" close-icon-class="fa fa-chevron-right" open-icon-class="fa fa-chevron-down"><collapsible-item ng-repeat="permissionObject in vm.allMetaObjects" item-title="{{permissionObject.label}}" initially-open="true" ng-hide="vm.isJobRole(permissionObject.label)"><div flex layout="row" layout-align="start center"><md-checkbox class="md-accent" aria-label="Select All" ng-checked="vm.isAllPermissionChecked(permissionObject)" md-indeterminate="vm.isAllPermissionIndeterminate(permissionObject)" ng-click="vm.toggleAllPermissions(permissionObject)" ng-disabled="vm.securityRoleModel.locked"><span ng-if="vm.isAllPermissionChecked(permissionObject)" translate="atheer.securityRole.un">Un-</span><span translate="atheer.securityRole.selectAll">Select All</span></md-checkbox></div><div flex layout="row" layout-wrap><div flex="33" ng-repeat="permission in permissionObject.permissions"><md-checkbox class="md-accent" ng-checked="vm.permissionExist(permissionObject, permission, vm.securityRoleModel.permissions)" ng-click="vm.togglePermission(permissionObject, permission, vm.securityRoleModel.permissions)" ng-disabled="vm.securityRoleModel.locked  || vm.isJobRole(permissionObject.label)">{{permission.label}}</md-checkbox></div></div></collapsible-item></ang-accordion></md-content><div layout="column" flex ng-if="!vm.isNew() && vm.view == \'USERS\'"><div class="md-toolbar-tools md-accent"><span flex></span><md-button class="md-icon-button" ng-click="vm.loadUserSecurityRoles()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.openAssignModal()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.addUsers">Add Users</span></fp-tooltip></md-button></div><div ng-if="vm.userSecurityRoles.length == 0" class="fp-no-data" layout="column" layout-align="center center"><illustration-empty-screen id="vm.illustartionEmptyScreenId"></illustration-empty-screen></div><md-table-container ng-if="vm.userSecurityRoles.length > 0"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row><th md-column><span translate="atheer.securityRole.firstName">First Name</span></th><th md-column><span translate="atheer.securityRole.lastName">Last Name</span></th><th md-column><span translate="atheer.securityRole.assignedOn">Assigned On</span></th></tr></thead><tbody md-body><tr ng-repeat="userSecurityRole in vm.userSecurityRoles track by userSecurityRole.id"><td md-cell>{{userSecurityRole.user_info.first_name}}</td><td md-cell>{{userSecurityRole.user_info.last_name}}</td><td md-cell>{{userSecurityRole.assigned_on | date:\'MM/dd/yyyy\'}}</td><td md-cell><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeUserSecurityRole(userSecurityRole, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container><div flex></div><md-table-pagination ng-if="vm.userSecurityRoles.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transitionUserSecurityRoles"></md-table-pagination></div><ng-include src="\'modules/system/admin/admin-detail-footer.tmpl.html\'"></ng-include></div></div></div>');
$templateCache.put('modules/system/security-role/security-role-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="autoComplete.securityRolePicker.title">Select Security Role</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container class="search-input-theme" ng-style="{ \'color\': secondaryColor }" ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'autoComplete.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.filter">Filter</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.securityRoles.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="autoComplete.uh">Uh!</div><div class="margin-top-10 base" translate="autoComplete.securityRolePicker.noSecurityRole">There are no security role yet.</div></div><div class="md-padding" ng-if="vm.securityRoles.length > 0"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedItems" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="name"><span translate="autoComplete.securityRolePicker.table.title">Title</span></th></tr></thead><tbody md-body><tr ng-repeat="securityRole in vm.securityRoles track by securityRole.id" md-row md-select="securityRole" md-select-id="id" md-auto-select><td md-cell>{{securityRole.name}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedItems.length <= 0" translate="entity.action.select">Select</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/security-role/security-roles.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="{{\'atheer.securityRole.enterSearch\' | translate}}" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.toggleFilter()"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.search">Search</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.cancel">Cancel</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.refresh">Refresh</span></fp-tooltip></md-button><div permission permission-only="atheer_features.security_roles.custom_roles"><md-button permission permission-only="vm.permissions.create" class="md-accent md-raised" ng-if="!vm.createMenu && !vm.isPickerView" ng-click="vm.createObject()" aria-label="primary button"><span translate="entity.action.new">New</span></md-button></div><fp-help></fp-help></div></md-toolbar><div ng-if="vm.securityRoles.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.securityRole.noSecurityRoles.title">Uh!</div><div class="margin-top-10 base"><span translate="atheer.securityRole.noSecurityRoles.thereAreNo">There are no </span><span translate="{{vm.pageTitleKey}}"></span><span translate="atheer.securityRole.noSecurityRoles.yet"> yet.</span></div><div permission permission-only="vm.permissions.create" class="margin-top-20" layout="column" layout-align="center center"><md-button ng-click="vm.createObject()" class="md-primary md-raised" translate="atheer.securityRole.noSecurityRoles.button">Add Now</md-button></div></div><md-content flex class="md-padding" ng-if="vm.securityRoles.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column md-order-by="security_role_no"><span translate="atheer.securityRole.securityRoleNo">Securit Role No</span></th><th md-column md-order-by="name"><span translate="atheer.securityRole.name">Name</span></th><th md-column><span translate="atheer.securityRole.createdOn">Created On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="securityRole in vm.securityRoles track by securityRole.id"><td md-cell>{{securityRole.security_role_no}}</td><td md-cell>{{securityRole.name}}</td><td md-cell ng-if="securityRole.locked == false" am-time-ago="securityRole.created_on"></td><td md-cell ng-if="securityRole.locked == true">--</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button permission permission-only="vm.permissions.update" class="md-icon-button" aria-label="primary button" ng-click="vm.editObject(securityRole.id)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu ng-if="!securityRole.locked && vm.hasDeletePermission"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item ng-if="!securityRole.locked" permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(securityRole)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.securityRoles.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/system/session/session-setting.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="column" class="padded-content-page"><div flex layout="column" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="60" layout="column" ng-form="sessionSettingForm"><md-input-container class="md-block" ng-if="vm.sessionType != \'personal\'"><div flex="20" class="padding-top-10"><span translate="atheer.workspaceInfo.timezone">Timezone</span></div><md-select ng-model="vm.sessionModel.timezone_id" class="md-no-underline"><md-option ng-repeat="timezone in vm.timezones" ng-value="timezone.timezone_no">{{timezone.display_name}}</md-option></md-select></md-input-container><md-divider></md-divider><md-divider></md-divider><div flex layout="column"><div flex layout="row"><div flex="30" class="padding-top-20"><span translate="atheer.session.video">Video</span></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.host">Host</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.host_video"></md-switch></div></div></div><div flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.participant">Participant</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.participant_video"></md-switch></div></div></div></div><md-divider></md-divider><div flex layout="column"><div flex layout="row"><div flex="30" class="padding-top-20"><span translate="atheer.session.joinOptions">Join Options</span></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.enableHost">Enable join before host</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.join_before_host"></md-switch></div></div></div><div flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.muteParticipants">Mute participants upon entry</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.mute_upon_entry"></md-switch></div></div></div></div><md-divider></md-divider><div flex layout="column"><div flex layout="row"><div flex="30" class="padding-top-20"><span translate="atheer.session.surveyOptions">Survey Options</span></div><div layout="row" flex><div flex="80" layout="column" layout-align="center start" translate="atheer.session.enableExternalSurvey">Enable external survey</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.sessionModel.enable_external_survey"></md-switch></div></div></div><div ng-if="vm.sessionModel.enable_external_survey" flex layout="row"><div flex="30" class="padding-top-20"></div><div layout="column" flex><md-input-container><div flex="100" layout="row" layout-align="start start" translate="atheer.session.externalSurveyUrl">External survey url</div><input flex="100" layout="row" layout-align="start start" name="name" ng-model="vm.sessionModel.external_survey_url" md-select-on-focus required></md-input-container><md-input-container><div flex="100" layout="row" layout-align="start start" translate="atheer.session.wearableExternalSurveyUrl">External survey url for Wearable</div><input flex="100" layout="row" layout-align="start start" name="name" ng-model="vm.sessionModel.wearable_external_survey_url" md-select-on-focus required></md-input-container></div></div></div></div></div></div></div>');
$templateCache.put('modules/system/skin/skin-setting.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="row" ng-if="!vm.loadingData"><md-content layout="column" flex class="padding-top-20" layout-padding><div flex layout="row" ng-style=" { \'min-height\' : \'500px\'} "><div flex="50" layout="column" class="margin-top-20"><div layout="row" layout-align="start center" class="margin-bottom-20"><div class="md-subhead" translate="atheer.logoAndColor.sideMenu">Side Menu</div></div><md-select placeholder="Choose Mode" ng-model="vm.skinModel.side_menu"><md-option value="DARK"><div layout="row"><div class="md-title" layout-padding translate="atheer.logoAndColor.dark">Dark</div></div></md-option><md-option value="LIGHT"><div layout="row"><div class="md-title" layout-padding translate="atheer.logoAndColor.light">Light</div></div></md-option></md-select><div layout="row" layout-align="start center"><div class="md-subhead" translate="atheer.logoAndColor.primary">Primary Color</div></div><div layout="row" layout-align="space-between center" ng-cloak><div class="color-picker" flex md-color-picker ng-model="vm.skinModel.primary_color_hex" md-color-alpha-channel="false" md-color-sliders="false" md-color-rgb="false" md-color-hsl="false" md-color-history="false" md-color-clear-button="false" open-on-input="true"></div></div><div layout="row" layout-align="start center"><div class="md-subhead" translate="atheer.logoAndColor.secondary">Secondary Color</div></div><div layout="row" layout-align="space-between center" ng-cloak><div class="color-picker" flex md-color-picker ng-model="vm.skinModel.secondary_color_hex" md-color-alpha-channel="false" md-color-sliders="false" md-color-rgb="false" md-color-hsl="false" md-color-history="false" md-color-clear-button="false" open-on-input="true"></div></div></div><div flex layout="row" layout-align="center top"><div flex="80" layout="column"><div class="ui-skin-preview-window md-whiteframe-z5" layout="row"><div flex="15" layout="column" ng-if="vm.skinModel.side_menu == \'LIGHT\'" ng-style="{ \'background-color\' : \'white\' }" class="ui-skin-preview-window-sidebar"><div ng-style=" { \'height\' : \'66px\'} "><div class="ui-skin-preview-window-logo" ng-style="{ \'background-color\' : vm.elementPrimaryColors.logo }"></div></div><div class="height-50" ng-style=" {\'border-right\' : \'2px solid \' ,\'border-right-color\': vm.elementPrimaryColors.toolbar, \'background-color\' : vm.toolBarBackground }"><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : vm.elementPrimaryColors.toolbar }"></div></div><div class="height-50"><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : \'lightgrey\' }"></div></div><div class="height-50"><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : \'lightgrey\' }"></div></div><div class="height-50"><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : \'lightgrey\' }"></div></div><div class="ui-skin-preview-window-sidemenu-text" ng-style="{ \'color\' : \'gray\' }" translate="atheer.logoAndColor.mainNav">Main Navigation</div></div><div flex="15" layout="column" ng-if="vm.skinModel.side_menu == \'DARK\'" ng-style="{ \'background-color\' : vm.elementPrimaryColors.sidebar }" class="ui-skin-preview-window-sidebar"><div ng-style=" { \'height\' : \'66px\'} "><div class="ui-skin-preview-window-logo" ng-style="{ \'background-color\' : \'white\' }"></div></div><div class="height-50" ng-style=" { \'border-right\' : \'2px solid \' ,\'border-right-color\': vm.elementPrimaryColors.toolbar, \'background-color\' : vm.toolBarBackground } "><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : vm.elementPrimaryColors.toolbar }"></div></div><div class="height-50"><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : \'grey\' }"></div></div><div class="height-50"><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : \'grey\' }"></div></div><div class="height-50"><div class="ui-skin-preview-window-sidemenu" ng-style="{ \'background-color\' : \'grey\' }"></div></div><div class="ui-skin-preview-window-sidemenu-text" ng-style="{ \'color\' : \'white\' }" translate="atheer.logoAndColor.mainNav">Main Navigation</div></div><div flex="25" layout="column" class="padding-20 ui-skin-preview-window-sidebar" ng-style="{ \'background-color\' : \'#f2f4f7\' }"><div class="ui-skin-preview-window-text text-overflow padding-2" translate="atheer.logoAndColor.sidebar">Sidebar</div></div><div flex="60" layout="column" class="ui-skin-preview-window-content overflow-auto"><div layout="row" layout-align="space-between start" class="ui-skin-preview-window-content-toolbar"><div class="ui-skin-preview-window-text margin-auto-0" translate="atheer.logoAndColor.toolbar">Toolbar</div><md-button ng-style="{ \'background-color\' : vm.elementPrimaryColors.content, \'color\' : \'white\'}"><span translate="atheer.logoAndColor.button">Button</span></md-button></div><div layout="row" class="ui-skin-preview-window-content-subtab-wrapper"><div layout="column" class="ui-skin-preview-window-content-subtab" ng-style="{ \'color\' : vm.elementPrimaryColors.content, \'border-bottom\' : \'2px solid\', \'border-bottom-color\' : vm.elementSecondaryColors.content}" translate="atheer.logoAndColor.subtab">Subtab</div><div layout="column" class="ui-skin-preview-window-content-subtab" ng-style="{ \'color\' : \'gray\'}" translate="atheer.logoAndColor.subtab">Subtab</div></div><md-content flex="70" md-content layout="column" layout-align="space-between start" class="padding-20 ui-skin-preview-window-content"><div class="ui-skin-preview-window-content-line padding-20"></div><div class="ui-skin-preview-window-content-line padding-20"></div><div class="ui-skin-preview-window-content-line padding-20"></div><div class="ui-skin-preview-window-content-line padding-20"></div><md-switch class="md-secondary ui-skin-preview-window-content-switch" ng-disabled="true" id="ui-preview-switch" ng-model="vm.switchModel"></md-switch></md-content><div layout="row" layout-align="end end"><md-button ng-style="{ \'background-color\' : vm.elementPrimaryColors.content, \'color\' : \'white\'}"><span translate="atheer.logoAndColor.button">Button</span></md-button></div></div></div></div></div></div><md-divider></md-divider><div flex layout="row" layout-align="space-around center" ng-style="{\'min-height\' : \'180px\'}" class="margin-bottom-20"><div flex="30" layout="row" layout-align="space-around center"><div flex layout="column"><div class="md-body-2 margin-bottom-20" translate="atheer.logoAndColor.small">Small logo for light background</div><fp-upload fp-allow-media-selection="false" flex fp-content-type="image" fp-ng-model="vm.skinModel.logo_small" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="dropAndPick"></fp-upload></div></div><div flex="30" layout="row" layout-align="space-around center"><div flex layout="column"><div class="md-body-2 margin-bottom-20" translate="atheer.logoAndColor.big">Big logo for light background</div><fp-upload fp-allow-media-selection="false" flex fp-content-type="image" fp-ng-model="vm.skinModel.logo_big" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="dropAndPick"></fp-upload></div></div></div><md-divider></md-divider><div flex layout="row" layout-align="space-around center" ng-style="{\'min-height\' : \'180px\'}" class="margin-bottom-20"><div flex="30" layout="row" layout-align="space-around center"><div flex layout="column"><div class="md-body-2 margin-bottom-20" translate="atheer.logoAndColor.smallDark">Small logo for dark background</div><fp-upload fp-allow-media-selection="false" flex fp-content-type="image" fp-ng-model="vm.skinModel.logo_small_dark" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="dropAndPick"></fp-upload></div></div><div flex="30" layout="row" layout-align="space-around center"><div flex layout="column"><div class="md-body-2 margin-bottom-20" translate="atheer.logoAndColor.bigDark">Big logo for dark background</div><fp-upload fp-allow-media-selection="false" flex fp-content-type="image" fp-ng-model="vm.skinModel.logo_big_dark" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="dropAndPick"></fp-upload></div></div></div><md-divider></md-divider><div flex layout="row" layout-align="space-around center" ng-style="{\'min-height\' : \'180px\'}" class="margin-bottom-20"><div flex="30" layout="row" layout-align="space-around center"><div flex layout="column"><div class="md-body-2 margin-bottom-20" translate="atheer.logoAndColor.favorite">Favorite Icon</div><fp-upload fp-allow-media-selection="false" flex fp-content-type="image" fp-ng-model="vm.skinModel.favorite_icon" fp-multiple="false" fp-pattern="image/*" fp-max-size="2000000" fp-enable-preview="true" fp-upload-type="dropAndPick"></fp-upload></div></div></div><md-divider></md-divider><div flex layout="row" layout-align="space-around center" ng-style="{\'min-height\' : \'50px\'}" class="margin-bottom-20"><div flex layout="column"><div layout="row" flex="100"><div flex="80" layout="column" layout-align="center start" translate="atheer.logoAndColor.useDarkLogos">Use dark background logos</div><div flex="20" layout="column" layout-align="center end"><md-switch name="enabled" ng-model="vm.skinModel.use_dark_logos"></md-switch></div></div></div></div></md-content></div></div>');
$templateCache.put('modules/system/timezone/timezone-dialog.html','<md-dialog aria-label="Timezone Detail" flex="30" flex-xs="100"><md-toolbar md-theme="{{triSkin.elements.content}}"><div class="md-toolbar-tools"><div ng-if="vm.timezone.id !== null"><h2 id="myTimezoneLabel" translate="atheer.timezone.home.editLabel">Edit a Timezone</h2></div><div ng-if="vm.timezone.id == null"><h2 id="myTimezoneLabel" translate="atheer.timezone.home.createLabel">Create a Timezone</h2></div><div flex="" class="flex"></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class="md-dialog-content"><form name="editForm" role="form" layout="column" novalidate ng-submit="vm.save()" show-validation><div><div><input type="hidden" id="id" name="id" ng-model="vm.timezone.id" readonly="readonly"></div><md-input-container class="md-block"><label class="md-required" translate="atheer.timezone.timezoneNo" for="field_timezoneNo">TimezoneNo</label> <input type="number" class="form-control" name="timezoneNo" id="field_timezoneNo" ng-model="vm.timezone.timezone_no" required><div ng-messages="editForm.timezoneNo.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div><div ng-message when="number"><span translate="entity.validation.number">This field should be a number.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.timezone.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.timezone.name" required><div ng-messages="editForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.timezone.displayName" for="field_displayName">DisplayName</label> <input type="text" class="form-control" name="displayName" id="field_displayName" ng-model="vm.timezone.display_name" required><div ng-messages="editForm.displayName.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label class="md-required" translate="atheer.timezone.offset" for="field_offset">Offset</label> <input type="text" class="form-control" name="offset" id="field_offset" ng-model="vm.timezone.offset" required><div ng-messages="editForm.offset.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container></div></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button type="submit" ng-disabled="editForm.$invalid || isSaving" class="md-primary" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/timezone/timezones.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-input-container ng-show="vm.filter.show" flex><label>&nbsp;</label> <input ng-model="vm.query.filter" ng-change="vm.loadAll()" placeholder="enter search" ng-model-options="{debounce: 500}"></md-input-container><md-button class="md-icon-button" ng-show="!vm.filter.show" ng-click="vm.filter.show = true"><md-icon md-font-icon="zmdi zmdi-search"></md-icon><fp-tooltip placement="bottom">Filter</fp-tooltip></md-button><md-button class="md-icon-button" ng-show="vm.filter.show" ng-click="vm.removeFilter()"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom">Cancel</fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom">Refresh</fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content flex class="md-padding"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column md-order-by="timezoneNo"><span translate="atheer.timezone.timezoneNo">TimezoneNo</span></th><th md-column md-order-by="name"><span translate="atheer.timezone.name">Name</span></th><th md-column md-order-by="displayName"><span translate="atheer.timezone.displayName">DisplayName</span></th><th md-column md-order-by="offset"><span translate="atheer.timezone.offset">Offset</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="timezone in vm.timezones track by timezone.id"><td md-cell>{{timezone.timezone_no}}</td><td md-cell>{{timezone.name}}</td><td md-cell>{{timezone.display_name}}</td><td md-cell>{{timezone.offset}}</td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/system/user-signup/user-field-picker.tmpl.html','<md-dialog flex="75" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><h2 hide-xs flex translate="atheer.userSignup.pickerTitle">Select User fields</h2><span flex></span><md-icon ng-show="vm.filter.show" md-font-icon="zmdi zmdi-search"></md-icon><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.refresh">Refresh</span></fp-tooltip></md-button><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="autoComplete.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.userFields.length == 0" flex layout="column" layout-align="center center"><div class="margin-top-10 base" translate="atheer.userSignup.noUserFields">There are no user fields</div></div><div class="md-padding" ng-if="vm.userFields.length > 0"><md-table-container><table md-table multiple="{{vm.allowMultiSelect}}" md-row-select="true" ng-model="vm.currentSelectedItems" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column md-order-by="name"><span translate="atheer.userSignup.tableTitle">Name</span></th></tr></thead><tbody md-body><tr ng-repeat="userField in vm.userFields track by userField.name" md-row md-select="userField" md-select-id="name" md-auto-select><td md-cell>{{userField.label}}</td></tr></tbody></table></md-table-container><!-- <md-table-pagination md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination> --></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button layout-align="center center" class="md-primary md-raised" aria-label="primary button" ng-click="vm.updateParentObject()" ng-disabled="vm.currentSelectedItems.length <= 0" translate="entity.action.select">Select</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/system/user-signup/user-signup-setting.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData" layout="column" class="padded-content-page"><div flex layout="column" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="50" layout="column" ng-form="emailForm"><div class="margin-bottom-20"><span class="md-subhead" translate="atheer.userSignup.subhead">Choose to make your team signup process invitation only, or allow anyone with a certain email address format to sign up.</span></div><md-radio-group ng-model="vm.userSignupModel.signup_policy"><md-radio-button value="invitation_only"><span translate="atheer.userSignup.invitationOnly">Invitation Only</span></md-radio-button><md-radio-button value="allEmailAddress"><span translate="atheer.userSignup.allEmailAddress">Allow all email addresses</span></md-radio-button><md-radio-button value="specificEmailAddress"><span translate="atheer.userSignup.specificEmailAddress">Allow only specific email addresses:</span></md-radio-button></md-radio-group><div class="margin-left-30"><md-input-container flex class="md-block"><span class="md-body-1" translate="atheer.userSignup.allowedEmailAddress">Allowed email domains</span> <textarea ng-model="vm.userSignupModel.allowed_email_addresses" rows="1" md-select-on-focus ng-disabled="vm.userSignupModel.signup_policy !== \'specificEmailAddress\'"></textarea></md-input-container><md-input-container flex class="md-block"><span class="md-body-1" translate="atheer.userSignup.restrictedEmailAddress">Restricted email domains</span> <textarea ng-model="vm.userSignupModel.restricted_email_addresses" rows="1" md-select-on-focus ng-disabled="vm.userSignupModel.signup_policy !== \'specificEmailAddress\'"></textarea></md-input-container></div><div><span class="md-subhead" translate="atheer.userSignup.securityRole">Security role</span><div><fp-auto-complete no-label="true" auto-complete-model="vm.selectedSecurityRole" component="SecurityRole" multiple="false" query-objs="[{fieldName:\'name\', operator:\'=re=\'}]"></fp-auto-complete></div></div><div><span class="md-subhead" translate="atheer.userSignup.userFields">User fields for sign up</span><md-button class="margin-left-200" class="md-icon-button" ng-click="vm.openAssignModal()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userSignup.addUserFieldsbutton">Add Users</span></fp-tooltip></md-button><md-table-container><table md-table ng-model="vm.selectedUserFields" class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th md-column><span translate="atheer.userSignup.userField">Field Name</span></th></tr></thead><tbody md-body dragula=\'"vm.selectedUserFields"\' dragula-model="vm.selectedUserFields"><tr ng-repeat="userField in vm.selectedUserFields track by userField.name" md-row md-auto-select><td md-cell>{{userField.label}}</td><td md-cell><md-button class="md-icon-button" aria-label="delete" ng-if="userField.name !== \'first_name\' &&  userField.name !== \'last_name\'" ng-click="vm.deleteFieldGroup(userField, $index)"><md-icon md-font-icon="zmdi zmdi-delete"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></div></div></div>');
$templateCache.put('modules/system/workspace-info/workspace-info-setting.tmpl.html','<div flex layout="column" ng-form="companyInfoForm" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><h2 hide-xs flex><span translate="global.menu.settings">Settings</span><span> - </span><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button type="submit" class="md-accent md-raised" ng-disabled="companyInfoForm.$invalid || vm.isAnyURLInValid()" ng-click="vm.save()"><span translate="entity.action.save">Save</span></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex layout="row" layout-fill layout-align="center center"><wave-spinner></wave-spinner></div><div flex layout="row" ng-if="!vm.loadingData"><md-content layout="column" flex class="padding-top-20" layout-padding><div layout="row" layout-align="center center"><div flex="50" layout="column"><div flex layout="row" layout-align="center center" class="margin-bottom-20"><div flex="50"><span class="md-title" translate="atheer.workspaceInfo.url">Your Atheer URL</span></div><div flex layout-align="center center"><a ng-href="{{vm.companyModel.atheer_url}}" target="_blank">{{vm.companyModel.atheer_url}}</a></div></div><md-input-container class="md-block"><label translate="atheer.workspaceInfo.name">Company Name</label> <input type="text" name="name" ng-model="vm.companyModel.name" md-select-on-focus required><div ng-show="companyInfoForm.name.$dirty" ng-messages="companyInfoForm.name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.websiteUrl">Company Website URL</label> <input type="url" name="website_url" ng-model="vm.companyModel.website_url" md-select-on-focus required><div ng-show="companyInfoForm.website_url.$dirty" ng-messages="companyInfoForm.website_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div><div class="md-input-message-animation" ng-if="!companyInfoForm.website_url.$error.required && vm.isURLInvalid(vm.companyModel.website_url)"><span translate="entity.validation.invalidURL">Please enter valid URL.</span></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.number">Phone Number</label> <input type="text" name="phone_number" ng-model="vm.companyModel.phone_number" md-select-on-focus required><div ng-show="companyInfoForm.phone_number.$dirty" ng-messages="companyInfoForm.phone_number.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.ownerName">Owner Name</label> <input type="text" name="owner_name" ng-model="vm.companyModel.owner_name" md-select-on-focus required><div ng-show="companyInfoForm.owner_name.$dirty" ng-messages="companyInfoForm.owner_name.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.email">Owner Email</label> <input type="email" name="owner_email" ng-model="vm.companyModel.owner_email" md-select-on-focus required><div ng-show="companyInfoForm.owner_email.$dirty" ng-messages="companyInfoForm.owner_email.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.timezone">Timezone</label><md-select ng-model="vm.companyModel.timezone_id" class="md-no-underline"><md-option ng-repeat="timezone in vm.timezones" ng-value="timezone.timezone_no">{{timezone.display_name}}</md-option></md-select></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.language">Language</label><md-select ng-model="vm.companyModel.language_id" class="md-no-underline"><md-option ng-repeat="language in vm.languages" ng-value="language.name">{{language.description}}</md-option></md-select></md-input-container><div layout="row" layout-align="space-between center"><span flex translate="atheer.workspaceInfo.defaultLanguage">Default language</span><md-switch name="default_language" ng-model="vm.companyModel.default_language" aria-label="Notify User"></md-switch></div><md-input-container class="md-block"><label translate="atheer.workspaceInfo.pageSize">Page Size</label><md-select ng-model="vm.companyModel.default_page_size" class="md-no-underline"><md-option ng-repeat="pageSize in vm.pageSizes" ng-value="pageSize.size">{{pageSize.size}}</md-option></md-select></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.toastPosition">Toast Position</label><md-select ng-model="vm.companyModel.default_toast_position" class="md-no-underline"><md-option ng-repeat="toastPosition in vm.toastPositions" ng-value="toastPosition.value">{{toastPosition.label}}</md-option></md-select></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.boardRefreshTime">Auto Refresh Rate for Job / Ticket board</label><md-select ng-model="vm.companyModel.board_refresh_rate" class="md-no-underline"><md-option ng-repeat="refreshChoice in vm.boardRefreshTimechoices" ng-value="refreshChoice.value">{{refreshChoice.label}}</md-option></md-select></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.termsUrl">Company Terms and Condition URL</label> <input type="url" name="terms_url" ng-model="vm.companyModel.terms_url" md-select-on-focus required><div ng-show="companyInfoForm.terms_url.$dirty" ng-messages="companyInfoForm.terms_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div><div class="md-input-message-animation" ng-if="!companyInfoForm.terms_url.$error.required && vm.isURLInvalid(vm.companyModel.terms_url)"><span translate="entity.validation.invalidURL">Please enter valid URL.</span></div></md-input-container><md-input-container class="md-block"><label translate="atheer.workspaceInfo.privacyPolicyUrl">Company Privacy Policy URL</label> <input type="url" name="privacy_policy_url" ng-model="vm.companyModel.privacy_policy_url" md-select-on-focus required><div ng-show="companyInfoForm.privacy_policy_url.$dirty" ng-messages="companyInfoForm.privacy_policy_url.$error"><div ng-message when="required"><span translate="entity.validation.required">This field is required.</span></div></div><div class="md-input-message-animation" ng-if="!companyInfoForm.privacy_policy_url.$error.required && vm.isURLInvalid(vm.companyModel.privacy_policy_url)"><span translate="entity.validation.invalidURL">Please enter valid URL.</span></div></md-input-container></div></div></md-content></div></div>');
$templateCache.put('modules/user/about/about.tmpl.html','<div flex layout="column" layout-fill><md-toolbar hide-sm hide-xs class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><div ng-if="!vm.disableEdit" layout="row" layout-align="end center"><md-button class="md-raised md-accent margin-left-0" ng-disabled="vm.profile.$invalid || vm.isTerminatedDateInvalid()" translate="entity.action.update" ng-click="vm.save()"></md-button></div><fp-help></fp-help></div></md-toolbar><fp-header hide-gt-sm is-public-user="vm.isPublicUser" user-info="vm.user" title="vm.title"></fp-header><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="column" ng-if="!vm.loadingData" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" layout="column" class="md-padding"><form flex name="vm.profile" novalidate><md-input-container class="md-block"><label for="user_no" translate="atheer.about.form.userNo">User No.</label> <input id="user_no" label="user_no" name="user_no" type="text" ng-model="vm.user.user_no" ng-disabled="true"></md-input-container><md-input-container class="md-block"><label for="first_name" translate="atheer.about.form.firstName">First Name</label> <input id="first_name" label="first_name" name="first_name" type="text" ng-model="vm.user.first_name" required ng-maxlength="50" ng-disabled="vm.disableEdit" class="form-control"><div ng-messages="vm.profile.first_name.$error" md-auto-hide="false" ng-show="vm.profile.first_name.$touched"><div ng-message when="required"><span translate="atheer.about.error.firstName.required">Please enter your first name.</span></div></div><div ng-messages="vm.profile.first_name.$error" md-auto-hide="false" ng-show="vm.profile.first_name.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="last_name" translate="atheer.about.form.lastName">Last Name</label> <input id="last_name" label="last_name" name="last_name" type="text" ng-model="vm.user.last_name" required ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.last_name.$error" md-auto-hide="false" ng-show="vm.profile.last_name.$touched"><div ng-message when="required"><span translate="atheer.about.error.lastName.required">Please enter your last name.</span></div></div><div ng-messages="vm.profile.last_name.$error" md-auto-hide="false" ng-show="vm.profile.last_name.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="middle_name" translate="atheer.about.form.middleName">Middle Name</label> <input id="middle_name" label="middle_name" name="middle_name" type="text" ng-model="vm.user.middle_name" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.middle_name.$error" md-auto-hide="false" ng-show="vm.profile.middle_name.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="preferred_name" translate="atheer.about.form.preferredName">Preferred Name</label> <input id="preferred_name" label="preferred_name" name="preferred_name" type="text" ng-model="vm.user.preferred_name" ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.preferred_name.$error" md-auto-hide="false" ng-show="vm.profile.preferred_name.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="email" translate="global.form.email">email</label> <input id="email" label="email" name="email" type="email" ng-model="vm.user.email" ng-maxlength="100" ng-disabled="true"><div ng-messages="vm.profile.email.$error" md-auto-hide="false" ng-show="vm.profile.email.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.email.maxLength">This field cannot be longer than 100 characters.</span></div></div><div ng-messages="vm.profile.email.$error" md-auto-hide="false" ng-show="vm.profile.email.$touched"><div ng-message when="email"><span translate="atheer.about.error.email.invalid">E-mail is invalid.</span></div></div><md-button class="fp-info-tooltip-icon-email md-icon-button"><md-icon md-font-icon="zmdi zmdi-info-outline"></md-icon><fp-tooltip placement="right"><span translate="atheer.about.emailToolTip">Please contact support team to update email address.</span></fp-tooltip></md-button></md-input-container><md-input-container class="md-block"><label for="phone_number" translate="atheer.about.form.phoneNumber">Phone Number</label> <input id="phone_number" label="phone_number" name="phone_number" type="text" ng-model="vm.user.phone_number" ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.phone_number.$error" md-auto-hide="false" ng-show="vm.profile.phone_number.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container ng-if="!vm.disableEdit" class="md-block"><label translate="atheer.about.form.bio">Bio</label> <textarea name="bio" ng-model="vm.user.bio" md-no-resize md-maxlength="255" rows="3"></textarea></md-input-container><md-input-container class="md-block margin-bottom-20"><label translate="atheer.about.form.timezone">Timezone</label><md-select ng-model="vm.user.timezone_id" class="md-no-underline" ng-disabled="vm.disableEdit"><md-option ng-repeat="timezone in vm.timezones" ng-value="timezone.timezone_no">{{timezone.display_name}}</md-option></md-select></md-input-container><md-input-container class="md-block margin-top-40 margin-bottom-20"><label translate="atheer.about.form.language">Language</label><md-select ng-model="vm.user.language_id" class="md-no-underline" ng-disabled="vm.disableEdit"><md-option ng-repeat="language in vm.languages" ng-value="language.name">{{language.description}}</md-option></md-select></md-input-container><md-input-container class="md-block"><label for="location" translate="atheer.about.form.location">Location</label> <input id="location" label="location" name="location" type="text" ng-model="vm.user.location" ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.location.$error" md-auto-hide="false" ng-show="vm.profile.location.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><div ng-if="vm.isAdminView" class="margin-top-40"><md-input-container class="md-block"><label for="job_title" translate="atheer.about.form.jobTitle">Job Title</label> <input id="job_title" label="job_title" name="job_title" type="text" ng-model="vm.user.job_title" ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.job_title.$error" md-auto-hide="false" ng-show="vm.profile.job_title.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="job_role" translate="atheer.about.form.jobRole">Job Role</label> <input id="job_role" label="job_role" name="job_role" type="text" ng-model="vm.user.job_role" ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.job_role.$error" md-auto-hide="false" ng-show="vm.profile.job_role.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="division" translate="atheer.about.form.division">Division</label> <input id="division" label="division" name="division" type="text" ng-model="vm.user.division" ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.division.$error" md-auto-hide="false" ng-show="vm.profile.division.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><label for="department" translate="atheer.about.form.department">Department</label> <input id="department" label="department" name="department" type="text" ng-model="vm.user.department" ng-maxlength="50" ng-disabled="vm.disableEdit"><div ng-messages="vm.profile.department.$error" md-auto-hide="false" ng-show="vm.profile.department.$touched"><div ng-message when="maxlength"><span translate="atheer.about.error.maxLength">This field cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container class="md-block"><md-autocomplete class="auto-complete" md-floating-label="Manager" placehoder="Manager" md-select-on-match="true" md-item-text="vm.getLabel(item)" md-selected-item="vm.user.manager" md-min-length="0" md-delay="500" md-search-text="vm.searchText" ng-readonly="vm.user.manager" md-items="item in vm.userSearchQuery(vm.searchText)"><md-item-template><span md-highlight-text="vm.searchText">{{vm.getLabel(item)}}</span></md-item-template></md-autocomplete><md-button ng-if="vm.user.manager" class="md-icon-button auto-complete-close" aria-label="Clear" ng-click="vm.user.manager=null"><md-icon><i class="zmdi zmdi-close"></i></md-icon></md-button></md-input-container><div layout="row" layout-align="space-between center"><span translate="atheer.about.form.startDate">Start Date</span><md-datepicker ng-model="vm.user.start_date" md-placeholder="{{\'atheer.about.form.startDatePlaceholder\' | translate}}" ng-disabled="vm.disableEdit"></md-datepicker></div><div layout="row" layout-align="space-between center" class="margin-top-10"><span translate="atheer.about.form.terminatedOn">Terminated On</span><md-datepicker ng-model="vm.user.terminated_on" md-placeholder="{{\'atheer.about.form.treminatedOnPlaceholder\' | translate}}" ng-disabled="vm.disableEdit"></md-datepicker></div><span class="about-error-message" ng-if="vm.isTerminatedDateInvalid()" translate="atheer.about.error.terminatedDate.invalid">Terminated on must be on or after the Start Date.</span><div class="fp-profile-event-form"><formly-form fields="vm.profileMetaFields" form="vm.profile" model="vm.user.custom_attributes"></formly-form></div><div layout="row" layout-align="space-between center"><span flex translate="atheer.about.form.appLanguage">App language</span><md-switch name="activate_user_language" ng-model="vm.user.app_language" aria-label="Notify User"></md-switch></div></div><div ng-if="vm.disableEdit" froala-view="vm.user.bio"></div><div hide-gt-sm ng-if="!vm.disableEdit" layout="row" layout-align="center center"><md-button class="md-raised md-primary margin-left-0" ng-disabled="vm.profile.$invalid || vm.isTerminatedDateInvalid()" translate="entity.action.update" ng-click="vm.save()"></md-button></div></form></div></div></md-content></div>');
$templateCache.put('modules/user/activate/user-info.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div layout="row" flex layout-padding layout-fill layout-align="center center"><div layout="column" flex="45" flex-lg="45" flex-md="65" flex-xs="100"><md-card ng-if="vm.status == \'valid-key\'" layout="column"><div layout="row" layout-align="center center" class="margin-top-20"><h1 translate="atheer.userInfo.joinTeam" translate-values="{teamName: \'{{vm.userInvitation.team_name}}\'}">Join the {{vm.userInvitation.team_name}} team</h1></div><div ng-if="vm.step == \'user-info\'" class="md-padding"><div layout="row" layout-align="center center"><h1 class="md-headline" translate="atheer.userInfo.tellUsAboutYou">Tell us about you</h1></div><form name="form" role="form" novalidate show-validation class="margin-top-40"><div layout="row" flex><md-input-container flex="50" class="md-block"><label class="control-label" for="first-name" translate="atheer.userInfo.firstName">First Name</label> <input type="text" class="form-control" id="first-name" name="first-name" placeholder="{{\'atheer.userInfo.firstNamePlaceholder\' | translate}}" ng-model="vm.user.first_name" required><div ng-messages="form.first-name.$error"><div ng-message when="required"><span translate="atheer.userInfo.firstNameRequired">Your First name is required.</span></div></div></md-input-container><md-input-container flex="50" class="md-block"><label class="control-label" for="last-name" translate="atheer.userInfo.lastName">Last Name</label> <input type="text" class="form-control" id="full-name" name="last-name" placeholder="{{\'atheer.userInfo.lastNamePlaceholder\' | translate}}" ng-model="vm.user.last_name" required><div ng-messages="form.last-name.$error"><div ng-message when="required"><span translate="atheer.userInfo.lastNameRequired">Your Last name is required.</span></div></div></md-input-container></div><div layout="row" flex><md-input-container flex class="md-block"><label class="control-label" for="last-name" translate="atheer.userInfo.username">Username</label> <input type="text" class="form-control" id="login" name="login" placeholder="{{\'atheer.userInfo.usernamePlaceholder\' | translate}}" ng-model="vm.user.login" ng-model-options="{debounce: 500}" ng-change="vm.checkLoginAvailable(vm.user.login)" required><div ng-messages="form.login.$error"><div ng-message when="required"><span translate="atheer.userInfo.usernameRequired">Username is required.</span></div></div></md-input-container><md-icon class="zmdi zmdi-check-circle customer-green-font" ng-if="vm.isLoginAvailable && vm.user.login.length > 0 && !vm.isCheckingLoginAvailability"></md-icon><md-icon class="zmdi zmdi-close-circle customer-red-font" ng-if="!vm.isLoginAvailable && vm.user.login.length > 0 && !vm.isCheckingLoginAvailability"></md-icon></div><div layout="row" layout-align="center center" class="margin-40"><md-button class="md-raised md-primary" ng-click="vm.next()" ng-disabled="form.$invalid"><span translate="entity.action.next">Next</span> &rarr;</md-button></div></form></div><div ng-if="vm.step == \'password\'" class="md-padding"><div layout="row" layout-align="center center"><span class="md-headline" translate="atheer.userInfo.setYourPassword">Set your password</span></div><div layout="row" layout-align="start center" class="margin-top-20"><span class="md-body-1" translate="atheer.userInfo.choosePasswordForSigningIntoTeam" translate-values="{teamName: \'{{vm.userInvitation.team_name}}\'}">Choose a password for signing in to {{vm.userInvitation.team_name}}</span></div><form name="form" role="form" novalidate show-validation class="margin-top-40"><md-input-container class="password-strength-indicator"><label class="control-label" for="password" translate="atheer.userInfo.password">Password</label><div class="password-container"><input type="{{ vm.passwordVisible ? \'text\' : \'password\' }}" class="form-control" id="password" name="password" ng-model="vm.user.password" ng-minlength="5" ng-maxlength="50" required> <button type="button" class="eye-icon" style="top: 0 !important" ng-click="vm.togglePasswordVisibility()"><md-icon class="{{ vm.passwordVisible ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div><div style="margin-top: -45px"><fp-password-strength fp-password-value="vm.user.password" strength="passStrength"></div><div ng-messages="form.password.$error"><div ng-message when="required" ng-show="form.password.$error.required"><span translate="global.messages.messages.newpassword.required">Your password is required.</span></div><div ng-message when="minlength" ng-show="form.password.$error.minlength"><span translate="global.messages.messages.newpassword.minlength">Your password is required to be at least 5 characters.</span></div><div ng-message when="maxlength" ng-show="form.password.$error.maxlength"><span translate="global.messages.messages.newpassword.maxlength">Your password cannot be longer than 50 characters.</span></div></div></md-input-container><div layout="row" layout-align="center center" class="margin-40"><md-button class="md-raised md-primary" ng-click="vm.register()" ng-disabled="form.$invalid" translate="entity.action.createAccount">Create Account</md-button></div></form></div></md-card><md-card ng-if="vm.userInvitation.type == \'SELF\' && vm.status == \'user-exist\'" layout="column" class="padding-40"><div layout="column" layout-align="center center" layout-padding><h1 translate="atheer.userInfo.createAccount">Create Account</h1><span class="md-subhead" translate="atheer.userInfo.youveAlreadyCreatedAnAccount">You\'ve already created an account.</span> <span class="md-subhead">{{\'atheer.userInfo.youCan\' | translate}}<a ng-href="{{vm.baseUrl}}" target="_self" translate="atheer.userInfo.logIn">log in </a>{{\'atheer.userInfo.or\'}}<a ng-href="{{vm.baseUrl}}/forgot" target="_self" translate="atheer.userInfo.resetYourPassword">reset your password </a>{{\'atheer.userInfo.ifYouveForgottenIt\' | translate}}</span></div></md-card><md-card ng-if="vm.userInvitation.type == \'ADMIN\' && vm.status == \'user-exist\'" layout="column" class="padding-40"><div layout="column" layout-align="start start" layout-padding><h1 translate="atheer.userInfo.youreAlreadyHere">You\u2019re already here!</h1><span class="md-subhead" translate="atheer.userInfo.acceptedInvitation">It looks like you\u2019ve already accepted the invitation we sent to you.</span> <a ng-href="{{vm.baseUrl}}" target="_blank" translate="atheer.userInfo.gotoYourTeam">Go to your team</a></div></md-card><md-card ng-if="vm.status == \'invalid-key\'" layout="column" class="padding-20"><div layout="column" layout-align="start start" layout-padding><h1 translate="atheer.userInfo.oops">Oops...</h1><span class="md-subhead" translate="atheer.userInfo.urlInvalid">It looks like you\u2019re trying to accept an invitation, but the URL you followed was invalid.</span> <span class="md-subhead" translate="atheer.userInfo.tryCopyAndPasteTheEntireUrl">Try copying and pasting the entire URL from your email.</span></div></md-card></div></div></div>');
$templateCache.put('modules/user/event/event-dialog.tmpl.html','<md-dialog flex="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span ng-if="vm.isNew()" flex translate="{{vm.eventMetaCreateTitle}}" translate-values="{eventName: \'{{vm.metaFieldGroup.label}}\'}"></span> <span ng-if="!vm.isNew()" flex translate="{{vm.eventMetaUpdateTitle}}" translate-values="{eventName: \'{{vm.metaFieldGroup.label}}\'}"></span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.event.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content fp-profile-event-form"><form><formly-form fields="vm.metaFields" form="vm.profileEventForm" model="vm.userEvent.properties"></formly-form></form></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.close()"><span translate="entity.action.cancel">Cancel</span></md-button><md-button ng-click="vm.save()" type="submit" ng-disabled="vm.profileEventForm.$invalid" class="md-primary"><span>{{vm.isNew() ? \'entity.action.add\' : \'entity.action.update\' | translate }}</span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('modules/user/event/event-list.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><md-button ng-click="vm.addEvent()" class="md-icon-button" aria-label="Add Leads"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate>{{vm.eventMetaTooltip}}</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.events.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.event.noEvent.title">Uh!</div><div class="margin-top-10 base" translate="atheer.event.noEvent.description">No Data yet.</div></div><md-content class="hor-scroll" flex ng-if="!vm.loadingData && vm.events.length > 0"><md-table-container class="hor-scroll-none"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column ng-repeat="field in vm.eventMeta.fields|filter:{locked: false}">{{field.label}}</th><th></th></tr></thead><tbody md-body><tr ng-repeat="event in vm.events track by event.id"><td md-cell ng-repeat="field in vm.eventMeta.fields|filter:{locked: false}">{{field.data_type == \'LIST\' ? vm.getListValueLabel(field,event[field.name]) : vm.getFieldValue(field, event.properties[field.name])}}</td><td class="text-right"><div class="btn-group flex-btn-group-container event-button-container"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.editEvent(event)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.removeEvent(event)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.events.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/user/guest/guest-join.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div ng-if="vm.isLoading" flex layout-fill layout="column" layout-align="center center"><wave-spinner></wave-spinner><span class="md-headline" translate="atheer.guestJoin.connecting">Please wait...</span></div><div ng-if="!vm.isLoading" class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame" flex layout="column" layout-align="center center"><div class="full-width" layout="row" layout-align="space-between center"><div><md-button ng-click="vm.onGoBack()" ng-if="vm.isDesktop && !vm.isAppWorkspace" class="md-icon-button margin-0 text-left"><md-icon md-font-icon="zmdi zmdi-long-arrow-left"></md-icon><fp-tooltip><span translate="atheer.signIn.back">Back</span></fp-tooltip></md-button></div></div><div layout="row" flex layout-padding layout-fill layout-align="center center"><md-card ng-if="!vm.isAppWorkspace" flex="40" flex-xs="100" flex-gt-xs="100" flex-md="70" flex-gt-md="70" flex-lg="40" flex-xl="40" class="padding-0 overflow-auto"><md-toolbar class="padding-20" md-theme="{{!vm.useDarkBackGroundLogos ? \'white-theme\' : \'primary-theme\'}}"><div flex layout="row" layout-align="center center" class="margin-top-10"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}"></div><div flex layout="row" layout-align="center center" class="margin-top-10"><span translate="entity.action.joinAirSession">Join AiRSession</span></div></md-toolbar><div ng-form="guestJoinForm" layout-padding><div flex layout="row" layout-align="center center"><span class="md-title">Your device ID is {{vm.deviceId}}</span></div><div flex layout="row" layout-align="center center" class="guest-session-device-label"><span class="margin-top-20 body-text" translate="atheer.guestJoin.leftSidePane.content">Take a look in your invitation email or text to find the AiRSession number and passcode(if required)</span></div><div ng-class="{\'padding-bottom-20\': vm.isMobileBrowser, \'padding-bottom-20\': !vm.isMobileBrowser}"><div layout="row" layout-align="center center" class="guest-session-label" ng-class="{\'guest-session-error\': vm.isError}"><span translate="atheer.guestJoin.airSessionNo">AiRSession Number</span></div><div layout="row" layout-align="center center" layout-wrap><div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input margin-left-0" required maxlength="1" ng-model="vm.sessionCode1" ng-change="vm.checkPasscode(vm.sessionCode1, 1)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input" maxlength="1" required ng-model="vm.sessionCode2" ng-change="vm.checkPasscode(vm.sessionCode2, 2)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input" maxlength="1" required ng-model="vm.sessionCode3" ng-change="vm.checkPasscode(vm.sessionCode3, 3)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div></div><div class="confirmation_code_span_cell">&#45;</div><div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input guest-session-first-input" maxlength="1" required ng-model="vm.sessionNumber1" ng-change="vm.checkPasscode(vm.sessionNumber1, 4)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input" maxlength="1" required ng-model="vm.sessionNumber2" ng-change="vm.checkPasscode(vm.sessionNumber2, 5)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input" maxlength="1" required ng-model="vm.sessionNumber3" ng-change="vm.checkPasscode(vm.sessionNumber3, 6)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input" maxlength="1" required ng-model="vm.sessionNumber4" ng-change="vm.checkPasscode(vm.sessionNumber4, 7)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div><div class="confirm_input_item input-item input_wrapper border-none"><input md-colors="{background: \'primary-500-0.1\'}" type="text" class="inline_input guest-session-input" maxlength="1" required ng-model="vm.sessionNumber5" ng-change="vm.checkPasscode(vm.sessionNumber5, 8)" ng-keydown="vm.onNumberInputKeydown($event)" inputmode="numeric" ng-style="vm.isMobileBrowser ? {\'width\': \'38px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'} : {\'width\': \'42px\', \'outline-color\': vm.primaryColor, \'caret-color\': vm.primaryColor, color: \'#000000\'}"></div></div></div><div ng-class="{\'guest-session-error\': vm.isError}" class="display-name-sub-text" ng-if="vm.isError" translate="atheer.guestJoin.messages.invalid">Invalid SessionNo</div><div flex layout="row" layout-align="start center"><div flex class="padding-top-20"><md-input-container class="md-block guest-session-input-container"><input id="firstName" label="firstName" name="firstName" type="textAngular" ng-model="vm.firstName" placeholder="{{ \'atheer.guestJoin.firstName\' | translate }}" required></md-input-container></div></div><div flex layout="row" layout-align="start center"><div flex class="padding-top-10"><md-input-container class="md-block guest-session-input-container"><input id="lastName" label="lastName" name="lastName" type="textAngular" ng-model="vm.lastName" placeholder="{{ \'atheer.guestJoin.lastName\' | translate }}" required></md-input-container></div></div><div flex layout="row" layout-align="center center"><md-checkbox class="md-primary" ng-model="vm.termsAndPrivacy" aria-label="Terms and Condition"></md-checkbox><span class="md-body-1"><span translate="atheer.guestJoin.iAgree">I agree to the </span><a target="_blank" ng-href="{{vm.termsLink}}" translate="atheer.guestJoin.terms">Terms</a><span translate="atheer.guestJoin.and">and </span><a target="_blank" ng-href="{{vm.privacyLink}}" translate="atheer.signIn.privacy">Privacy</a></span><span>.</span></div></div><div flex layout="row" layout-align="center center"><md-button ng-disabled="guestJoinForm.$invalid || !vm.firstName || !vm.lastName || !vm.termsAndPrivacy" id="joinAirSession" ng-click="vm.joinGuestSession(true)" class="md-raised md-primary margin-bottom-10" aria-label="Join AiRSession" translate="atheer.guestJoin.join" ng-if="!vm.isLoading">Join</md-button><md-button ng-if="vm.isLoading" id="pleaseWait" class="margin-bottom-10" ng-disabled="vm.isLoading" translate="atheer.guestJoin.pleaseWait" aria-label="Please Wait">Please Wait...</md-button></div><div ng-if="!vm.isMobileBrowser" flex layout="row" layout-align="center center"><span translate="atheer.guestJoin.registeredUser">Are you a registered user? </span>&nbsp; <a class="cursor-pointer" ng-click="vm.redirectToSignin()" translate="entity.action.signIn">Sign in</a></div></div></md-card></div></div><fp-footer></fp-footer></div></div>');
$templateCache.put('modules/user/import/user-import.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ui-sref="storm.admin-users" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="atheer.userImport.title">Import Users</span></h2><span flex></span><fp-help></fp-help></div></md-toolbar><md-content flex layout="row" layout-align="start center"><div flex ng-if="vm.currentStep == \'start\'" layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="column" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.userImport.importFromFile">Import Users from File</span></div><div layout="column" layout-align="center center"><md-button class="md-primary md-raised" ng-click="vm.currentStep = \'upload\'" translate="entity.action.import">Import</md-button></div></div><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="column" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.userImport.or">Or</span></div></div><div layout="column" layout-align="center" class="margin-bottom-20"><div layout="column" layout-align="center center" layout-padding><span class="md-headline" translate="atheer.userImport.importFromApps">Import Users from Apps</span></div><div layout="column" layout-align="center center"><md-button class="md-primary md-raised" translate="entity.action.learnMore">Learn More</md-button></div></div></div></div><div flex ng-if="vm.currentStep == \'upload\'" layout="row" layout-align="center" layout-wrap="wrap"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="vm.importStatus === \'idle\'"><fp-upload fp-content-type="document" fp-max-size="500000000" fp-smart-upload-background="user-import-background" fp-upload-status="vm.uploadStatus" fp-smart-upload-label="CSV/Excel" fp-add-model-fn="vm.handleMediaUpload(mediaId, responseObj)" fp-upload-type="smart" fp-pattern="text/csv,application/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/excel"></fp-upload></div><div ng-if="vm.uploadStatus == \'idle\'" layout="row" layout-align="center"><md-button class="md-primary" translate="atheer.userImport.sampleCsvFile" ng-click="vm.downloadSample(\'CSV\')">Click Here to Download a Sample CSV File</md-button></div><div ng-if="vm.uploadStatus == \'idle\'" layout="row" layout-align="center"><md-button class="md-primary" translate="atheer.userImport.sampleExcelFile" ng-click="vm.downloadSample(\'EXCEL\')">Click Here to Download a Sample EXCEL File</md-button></div></div></div><div flex ng-if="vm.currentStep == \'validating\'" layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-padding layout-align="center" class="margin-top-40" layout-align="center"><div layout="row" layout-align="center"><md-progress-circular class="md-hue-2" md-mode="indeterminate"></md-progress-circular></div><div layout="row" layout-align="center" class="margin-top-40"><span class="md-subhead" translate="atheer.userImport.validation.validating">Validating File ...</span></div></div></div></div><div flex ng-if="vm.currentStep == \'validate\'" layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{\'color\': \'rgb(89, 226, 168)\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-subhead" translate="atheer.userImport.validation.foundRecords" translate-values="{totalRecords: \' {{vm.fileImportInfo.total_records}}\'}">Found {{vm.fileImportInfo.total_records}} Records.</span></div><div layout="row" layout-align="center"><md-button class="md-primary" ng-click="vm.currentStep = \'upload\'" translate="atheer.userImport.uploadDifferentFile">Upload a different File</md-button></div></div></div></div><div flex ng-if="vm.currentStep == \'import\'" layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="vm.importStatus === \'importing\'" layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-title" translate="atheer.userImport.validation.importing">Importing Users. Please wait...</span></div><div layout="row" layout-align="center"><span ng-if="vm.uploadType === \'CSV\'" class="md-subhead" translate="atheer.userImport.validation.completed" translate-values="{records: \'{{vm.jobData.success_records}}\'}">Completed {{vm.jobData.success_records}} Users.</span> <span ng-if="vm.uploadType === \'SPREADSHEET\'" class="md-subhead" translate="atheer.userImport.validation.completed" translate-values="{records: \'{{vm.jobStream.success_rows}}\'}">Completed {{vm.jobStream.success_rows}} Users.</span></div><div layout="row" layout-align="center" class="margin-top-40"><md-progress-linear md-mode="indeterminate"></md-progress-linear></div></div></div></div><div flex ng-if="vm.currentStep == \'import-summary\'" layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div ng-if="vm.importStatus === \'complete\'" layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><illustration-empty-screen id="vm.illustartionEmptyScreenId" name="vm.illustartionMessageName"></illustration-empty-screen></div><div layout="row" layout-align="center"><span ng-if="vm.uploadType === \'CSV\'" class="md-subhead" translate="atheer.userImport.validation.importComplete" translate-values="{records: \'{{vm.jobData.success_records}}\'}">Process Complete.</span> <span ng-if="vm.uploadType === \'SPREADSHEET\'" class="md-subhead" translate="atheer.userImport.validation.importCompleteForSpreedsheet" translate-values="{successRecords: \'{{vm.jobStream.success_rows}}\', failureRecords: \'{{vm.jobStream.failure_rows}}\'}">Process Complete.</span></div><div layout="row" layout-align="center"><md-button class="md-primary md-raised" ng-click="vm.downloadLogs()" translate="entity.action.downloadLogs">Download Log</md-button></div></div></div></div></md-content><md-card-actions layout="row" layout-align="end center"><span ng-if="vm.currentStep == \'validate\'" class="md-subhead" translate="atheer.userImport.sendInvitation">Send Invitation</span><md-switch ng-if="vm.currentStep == \'validate\'" ng-model="vm.fileImportInfo.send_notification" aria-label="Send Invitation"></md-switch><md-button class="md-primary" ng-click="vm.resetImport()" ng-hide="vm.importStatus ==\'importing\'" translate="entity.action.cancel">Cancel</md-button><md-button class="md-primary md-raised" ng-click="vm.moveNext()" ng-hide="vm.currentStep == \'start\' || vm.currentStep == \'upload\' || vm.currentStep == \'validating\' || vm.importStatus ==\'importing\' || vm.importStatus == \'failed\'" translate="entity.action.continue">Continue</md-button></md-card-actions>');
$templateCache.put('modules/user/invitation/user-invitation-dialog.html','<md-dialog flex class="fp-user-invitation-dialog"><md-toolbar md-theme="default"><div class="md-toolbar-tools"><div flex></div><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.clear()"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if="!vm.invitationSent" class="md-dialog-content"><div class="md-dialog-content" layout="column"><div flex layout="row" layout-align="center center"><span class="md-headline"><md-icon class="fa fa-send margin-right-20"></md-icon>{{\'atheer.userManagement.inviteTeamMembers\' | translate}}</span></div><div ng-if="vm.addManyAtOnce" layout="row" layout-align="center center" class="margin-top-20"><div flex="60" layout="column"><md-input-container flex class="md-block"><label translate="atheer.userManagement.multipleEmailAddresses">Enter multiple email addresses</label> <textarea ng-model="vm.invitationsString" rows="5" md-select-on-focus></textarea></md-input-container><span class="md-caption" translate="atheer.userManagement.copyAndPaste">Tip:Copy and paste a list of contacts from your email. Please separate multiple addresses with commas!</span><div layout="row" class="margin-top-40"><md-button class="md-primary md-raised" aria-label="primary button" ng-click="vm.addManyAtOnce = false; vm.parseToArray()" translate="atheer.userManagement.addInvitees">Add Invitees</md-button><md-button class="margin-right-20 md-raised" aria-label="primary button" ng-click="vm.addManyAtOnce = false" translate="entity.action.cancel">Cancel</md-button></div></div></div><div ng-if="!vm.addManyAtOnce" layout="column" layout-align="start center" class="margin-top-40"><div flex layout="row" ng-repeat="userInvitation in vm.invitations track by $index"><md-input-container flex="40" class="md-block"><label translate="atheer.userManagement.emailAddress">Email address</label> <input ng-model="userInvitation.email" placeholder="{{\'atheer.userManagement.emailAddressPlaceholder\' | translate}}" required><div ng-messages><span ng-if="!vm.isOnlyEmail(userInvitation.email)" translate="entity.validation.validEmailFormat">Please enter valid email.</span> <span ng-if="userInvitation.email != null && !userInvitation.email" translate="entity.validation.required">This field is required.</span></div></md-input-container><md-input-container class="md-block margin-left-20"><label translate="atheer.userManagement.firstName">First name</label> <input ng-model="userInvitation.first_name" placeholder="{{\'atheer.userManagement.optionalPlaceholder\' | translate}}"></md-input-container><md-input-container class="md-block margin-left-20"><label translate="atheer.userManagement.lastName">Last Name</label> <input ng-model="userInvitation.last_name" placeholder="Optional"></md-input-container><md-button ng-hide="vm.invitations.length == 1" class="md-icon-button margin-top-20" aria-label="primary button" ng-click="vm.remove($index)"><md-icon class="zmdi zmdi-close icon-size"></md-icon></md-button></div></div><div ng-if="!vm.addManyAtOnce" flex layout="row" layout-align="center start"><div flex="60" layout="row" layout-align="center start"><md-button class="md-primary" aria-label="primary button" ng-click="vm.addAnother()" translate="atheer.userManagement.addAnother">Add Another</md-button><span class="margin-top-10" translate="atheer.userManagement.or">or</span><md-button class="md-primary" aria-label="primary button" ng-click="vm.addManyAtOnce = true; vm.parseToString()" translate="atheer.userManagement.addMany">Add Many at once</md-button></div></div><div ng-if="!vm.addManyAtOnce" flex layout="row" layout-align="center start" class="margin-top-20"><div flex="60" layout="row" layout-align="space-around center"><md-button class="md-primary" aria-label="primary button" ng-click="vm.seePending()" translate="atheer.userManagement.seePendingAndAcceptedInvites">See pending and accepted invites</md-button><md-button class="md-primary md-raised" aria-label="primary button" ng-click="vm.sendInvitations()" translate="atheer.userManagement.sendInvitations" ng-disabled="!vm.validEmailList()">Send Invitations</md-button></div></div></div></md-dialog-content><md-dialog-content ng-if="vm.invitationSent" class="md-dialog-content"><div class="md-dialog-content" layout="column"><div flex ng-if="vm.invitationsSuccess.length == 0 && vm.invitationsFailed.length > 0" layout="column" layout-align="center center"><span class="md-headline" translate="atheer.userManagement.invitationSuccess.didntWork">That didn\u2019t work!</span> <span class="md-subhead margin-top-20" translate="atheer.userManagement.invitationSuccess.reviewErrors" translate-values="{invitationsFailedLength: \'{{vm.invitationsFailed.length}}\'}">{{vm.invitationsFailed.length}} invitation didn\u2019t send. Review the errors below.</span></div><div flex ng-if="vm.invitationsSuccess.length > 0 && vm.invitationsFailed.length > 0" layout="column" layout-align="center center"><span class="md-headline" translate="atheer.userManagement.invitationSuccess.partialSuccess">That was only a partial success.</span> <span class="md-subhead margin-top-20" translate="atheer.userManagement.invitationSuccess.partialMessage" translate-values="{invitationsSuccessLength: \'{{vm.invitationsSuccess.length}}\', invitationsFailedLength: \'{{vm.invitationsFailed.length}}\'}">You\u2019ve invited {{vm.invitationsSuccess.length}} Team Member, but {{vm.invitationsFailed.length}} invitation didn\u2019t send. Review the errors below.</span></div><div flex ng-if="vm.invitationsSuccess.length > 0 && vm.invitationsFailed.length == 0" layout="column" layout-align="center center"><span class="md-headline" translate="atheer.userManagement.invitationSuccess.invitationSent">Your invitation has been sent!</span> <span class="md-subhead margin-top-20" translate="atheer.userManagement.invitationSuccess.invitationSuccessMessage">You\'ve invited {{vm.invitationsSuccess.length}} team member.</span></div><div layout="row" ng-if="vm.invitationsSuccess.length > 0" layout-align="center center"><div flex="50" layout-align="center center"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head class="fp-user-invitation-success" md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.userManagement.emailAddress">Email Address</span></th><th md-column><span translate="atheer.userManagement.name">Name</span></th></tr></thead><tbody md-body><tr ng-repeat="userInvitation in vm.invitationsSuccess track by $index"><td md-cell>{{userInvitation.email}}</td><td md-cell>{{userInvitation.first_name}}</td></tr></tbody></table></md-table-container></div></div><div layout="row" ng-if="vm.invitationsFailed.length > 0" layout-align="center center" class="margin-top-20"><div flex="50" layout-align="center center"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead class="fp-user-invitation-failed" md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.userManagement.emailAddress">Email Address</span></th><th md-column><span translate="atheer.userManagement.whatWentWrong">What went wrong</span></th></tr></thead><tbody md-body><tr ng-repeat="userInvitation in vm.invitationsFailed track by $index"><td md-cell>{{userInvitation.email}}</td><td md-cell><span translate="atheer.userManagement.alreadyOnTeam">This person is already on your team.</span></td></tr></tbody></table></md-table-container></div></div><div flex layout="row" layout-align="center start" class="margin-top-40"><div flex="50" layout="row"><md-button class="md-raised" aria-label="primary button" ng-click="vm.seePending()" translate="atheer.userManagement.viewPendingInvites">View Pending Invites</md-button><md-button ng-if="vm.invitationsSuccess.length > 0 && vm.invitationsFailed.length == 0" class="md-raised" aria-label="primary button" ng-click="vm.inviteMore()" translate="atheer.userManagement.inviteMorePeople">Invite more People</md-button><md-button ng-if="vm.invitationsFailed.length > 0" class="md-raised" aria-label="primary button" ng-click="vm.inviteMore()" translate="atheer.userManagement.tryAgain">Try Again</md-button><div flex></div><md-button class="md-primary md-raised" aria-label="primary button" ng-click="vm.seePending()" translate="entity.action.done">Done</md-button></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/user/invitation/user-invitations.html','<div flex layout="column"><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ng-click="vm.back()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2 hide-xs flex><span translate="{{vm.pageTitleKey}}"></span></h2><span flex></span><md-button class="md-icon-button" ng-click="vm.loadAll()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userInvitation.refresh">Refresh</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><md-content layout="row" layout-align="center start"><div flex="70"><md-card class="padding-40"><div layout="row"><div flex="50" layout="row"><span class="md-title" translate="atheer.userInvitation.inviteOthers">Invite others to join your team</span></div><div flex="50" layout="column"><md-button class="md-primary md-raised" aria-label="primary button" ng-click="vm.createObject()" translate="atheer.userInvitation.inviteNewMembers">Invite New Members</md-button><div ng-if="vm.invitationOnly == \'false\'" layout="column"><span class="md-subhead" layout-padding translate="atheer.userInvitation.sendThisLinkToYourTeam">Or just send this link to your team to let them sign up with their email address: </span><a layout-padding ng-href="{{vm.signupUrl}}">{{vm.signupUrl}}</a></div><div ng-if="vm.invitationOnly == \'true\'" layout="column" class="margin-top-60"></div></div></div></md-card><md-card ng-if="vm.pendingInvitations.length > 0 || vm.acceptedInvitations.length > 0"><md-tabs md-dynamic-height class="md-primary" md-selected="selectedTabIndex"><md-tab ng-if="vm.pendingInvitations.length > 0" label="Pending Invitations ({{vm.pendingQueryCount}})"><md-list flex><md-list-item class="md-3-line" ng-repeat="userInvitation in vm.pendingInvitations"><div class="md-list-item-text" layout="column"><div layout="row" layout-align="start center" class="margin-left-10"><h3 flex>{{userInvitation.email}}</h3><h4><span translate="atheer.userInvitation.invited">Invited</span> <span am-time-ago="userInvitation.created_on"></span></h4></div><div layout="row" layout-align="start center"><md-button class="md-primary" aria-label="primary button" ng-click="vm.deleteObject(userInvitation.id)" translate="atheer.userInvitation.revokeInvitation">Revoke Invitation</md-button><md-button class="md-primary" aria-label="primary button" ng-click="vm.resend(userInvitation.id)" translate="atheer.userInvitation.resendInvitation">Resend Invitation</md-button><div flex></div><h4><span translate="atheer.userInvitation.invitedBy">Invited by </span><span>{{userInvitation.invited_by.firstName}} {{userInvitation.invited_by.lastName}}</span></h4></div></div><md-divider></md-divider></md-list-item></md-list><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.pendingQueryCount}}" md-page-select md-boundary-links="true" md-page="vm.pendingPage" md-on-paginate="vm.transitionPending"></md-table-pagination></md-tab><md-tab ng-if="vm.acceptedInvitations.length > 0" label="{{\'atheer.userInvitation.acceptedInvitation\' | translate: {acceptedQueryCount: vm.acceptedQueryCount} }}"><md-list flex><md-list-item class="md-3-line" ng-repeat="userInvitation in vm.acceptedInvitations" ng-click="null"><div class="md-avatar"><fp-avatar user="userInvitation.user" camel-case="true" presence="false" auto-color="true" bind="true" font-weight="400" font-scale="100" round-shape="true" class="md-avatar" width="40" height="40"></fp-avatar></div><div class="md-list-item-text" layout="column"><div layout="row"><span class="md-title" flex>{{userInvitation.first_name}} {{userInvitation.last_name}}</span><h4><span translate="atheer.userInvitation.joined">Joined </span><span am-time-ago="userInvitation.created_on"></h4></div><div layout="row"><h4 flex>{{userInvitation.email}}</h4><h4><span translate="atheer.userInvitation.invitedBy">Invited by </span><span>{{userInvitation.invited_by.firstName}} {{userInvitation.invited_by.lastName}}</span></h4></div></div></md-list-item></md-list><md-table-pagination md-limit="vm.query.limit" md-total="{{vm.acceptedQueryCount}}" md-page-select md-boundary-links="true" md-page="vm.acceptedPage" md-on-paginate="vm.transitionAccepted"></md-table-pagination></md-tab></md-tabs></md-card></div></md-content></div>');
$templateCache.put('modules/user/library/library-bookmarks.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.contents.length == 0" flex layout="column" layout-align="center center"><div class="fp-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.bookmarks.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.bookmarks.noBookmarks">No Bookmarks yet.</div></div></div><md-content flex ng-if="!vm.loadingData && vm.contents.length > 0"><fp-content-feed-list contents="vm.contents"></fp-content-feed-list></md-content><md-table-pagination ng-if="vm.contents.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/user/library/library-liked.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.contents.length == 0" flex layout="column" layout-align="center center"><div class="fp-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.liked.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.liked.noLike">No Liked Content yet.</div></div></div><md-content flex ng-if="!vm.loadingData && vm.contents.length > 0"><fp-content-feed-list contents="vm.contents"></fp-content-feed-list></md-content><md-table-pagination ng-if="vm.contents.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/user/library/library-shared.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.contents.length == 0" flex layout="column" layout-align="center center"><div class="fp-no-data" layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.shared.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.shared.noShare">No Shared Content yet.</div></div></div><md-content flex ng-if="!vm.loadingData && vm.contents.length > 0"><fp-content-feed-list contents="vm.contents"></fp-content-feed-list></md-content><md-table-pagination ng-if="vm.contents.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/user/library/library-uploads.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.queryCount == 0" flex layout="column" layout-align="center center"><div class="fp-no-data" layout="column" layout-align="center center"><img src="/assets/images/app/myuploads.svg"><div class="margin-top-10 main" translate="atheer.upload.uploads">Uploads</div><div class="margin-top-10 base" translate="atheer.upload.uploadedContent">Content uploaded by users will show here.</div></div></div><md-content flex ng-if="!vm.loadingData && vm.queryCount > 0"><fp-content-feed-list contents="vm.contents"></fp-content-feed-list></md-content><md-table-pagination ng-if="vm.queryCount > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/user/library/library.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><fp-help></fp-help></div></md-toolbar><md-tabs class="padding-left-10" md-center-tabs><md-tab ui-sref="storm.profile.library.bookmarks" md-active="vm.isActiveTab(\'storm.profile.library.bookmarks\')"><md-tab-label><span translate="atheer.library.bookmarks">Bookmarks</span></md-tab-label></md-tab><md-tab ui-sref="storm.profile.library.shared" md-active="vm.isActiveTab(\'storm.profile.library.shared\')"><md-tab-label><span translate="atheer.library.shared">Shared</span></md-tab-label></md-tab><md-tab ui-sref="storm.profile.library.liked" md-active="vm.isActiveTab(\'storm.profile.library.liked\')"><md-tab-label><span translate="atheer.library.liked">Liked</span></md-tab-label></md-tab><md-tab ui-sref="storm.profile.library.uploads" md-active="vm.isActiveTab(\'storm.profile.library.uploads\')"><md-tab-label><span translate="atheer.library.uploaded">Uploaded</span></md-tab-label></md-tab></md-tabs><div flex ui-view></div></div>');
$templateCache.put('modules/user/library/upload-dialog.tmpl.html','<md-dialog ng-cloak flex="70" flex-xs="100" flex-xl="40"><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.upload.dialog.content">Upload Content</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.upload.dialog.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content class="md-dialog-content"><div ng-if="vm.processStatus === \'PROCESSING\' || vm.processStatus === \'UPLOADED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50" class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.upload.dialog.processStatus.processing">Processing Content.</span></div><div layout="row" layout-align="center" class="margin-top-40 margin-bottom-40"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div></div></md-card></div><div ng-if="vm.processStatus === \'FAILED\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50" class="margin-top-60 margin-bottom-60"><div flex layout="column"><div layout="column" layout-padding layout-align="center" class="margin-top-40"><md-icon md-font-icon="zmdi zmdi-alert-circle" ng-style="{\'color\': \'#DA1F2D\', \'font-size\': \'72\' + \'px\', height: \'72\' + \'px\'}"></md-icon><div layout="row" layout-align="center"><span class="md-headline" translate="atheer.upload.dialog.processStatus.error">Error Processing Powerpoint. Try Again.</span></div></div></div></md-card></div><div ng-if="vm.processStatus === \'IDLE\'" layout="row" layout-align="center center" class="fp_full_background" layout-fill ng-cloak><md-card flex="50" flex-xs="90" flex-sm="90" flex-md="60" flex-lg="50" flex-xl="50"><div flex layout="column"><div layout="row" layout-align="center"><fp-upload flex fp-content-type="unknown" fp-max-size="50000000" fp-smart-upload-icon="{{vm.contentMetaData.icon}}" fp-smart-upload-label="Content" fp-ng-model="vm.contentModel.data.source_media" fp-bind-full-obj="true" fp-add-model-fn="vm.createContent(mediaId, responseObj)" fp-upload-type="smart" fp-pattern="audio/*,video/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></fp-upload></div></div></md-card></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/user/metadata/user-metadata.tmpl.html','<md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><md-button ng-click="vm.back()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><span translate="atheer.userFields.title">User Fields</span> <span flex></span><fp-help></fp-help></div></md-toolbar><div flex layout="row"><div flex="25" layout="column" class="fp-field-group-detail"><div layout="row" layout-align="center center" class="margin-10"><md-button class="md-raised md-primary" ng-click="vm.addFieldGroup()" aria-label="primary button"><span translate="atheer.userFields.newFieldGroup">New</span></md-button></div><md-list><md-list-item ng-repeat="fieldGroup in vm.metaDataObject.field_groups track by $index" ng-click="vm.selectFieldGroup(fieldGroup, $index)" ng-show="fieldGroup.locked == false || fieldGroup.name == \'profile\'" ng-class="{\'fp-field-group-active\': vm.selectedFieldGroup == fieldGroup}"><div layout="row"><h4 flex>{{fieldGroup.name == \'profile\' ? \'atheer.userFields.fields\' : (fieldGroup.is_many ? fieldGroup.plural_label : fieldGroup.label) | translate }}</h4><md-menu ng-if="fieldGroup == vm.selectedFieldGroup && fieldGroup.name != \'profile\'" class="md-secondary"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.editFieldGroup(fieldGroup, $index)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon><span translate="entity.action.edit">Edit</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteFieldGroup(fieldGroup, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-divider></md-divider></md-list-item></md-list><div flex></div></div><div flex="75" layout="row" ng-if="!vm.metaDataObject.field_groups || vm.metaDataObject.field_groups.length <= 0" layout-align="center center"><div><i class="zmdi zmdi-arrow-left" aria-hidden="true" ng-style="{\'font-size\': \'48\' + \'px\', height: \'48\' + \'px\',\'color\':\'#00bcd4\'}"></i></div><div flex class="margin-left-20"><span class="md-display-1" translate="atheer.userFields.addFieldGroup">Please add Field Group to add Fields to it.</span></div></div><div flex="75" ng-if="vm.selectedFieldGroup" flex layout="column"><div md-theme="{{triSkin.elements.toolbar}}" class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools md-accent"><span>{{vm.selectedFieldGroup.name == \'profile\' ? \'\' : vm.selectedFieldGroup.label}} {{vm.selectedFieldGroup.name == \'profile\' ? \'atheer.userFields.fields\' : \'atheer.userFields.fields\' | translate}}</span> <span flex></span><md-button class="md-icon-button" ng-click="vm.addField()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.userFields.addField">Add Field</span></fp-tooltip></md-button></div></div><md-content flex class="md-padding"><div ng-if="!vm.selectedFieldGroup.fields || vm.selectedFieldGroup.fields.length <= 0" layout-align="center center" layout="column"><div flex class="margin-left-20 margin-top-200"><span class="md-title" translate="atheer.userFields.noFields">No Fields.</span></div></div><div ng-if="vm.selectedFieldGroup.fields && vm.selectedFieldGroup.fields.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head><tr md-row><th md-column><span translate="atheer.userFields.label">Label</span></th><th md-column><span translate="atheer.userFields.name">Name</span></th><th md-column><span translate="atheer.userFields.type">Type</span></th><th></th></tr></thead><tbody md-body dragula=\'"user-group-fields"\' dragula-model="vm.selectedFieldGroup.fields"><tr ng-repeat="field in vm.selectedFieldGroup.fields track by $index"><td md-cell>{{field.label}}</td><td md-cell>{{field.name}}</td><td md-cell>{{field.data_type}}</td><td class="text-right"><md-icon ng-if="field.locked" md-font-icon="zmdi zmdi-lock" class="margin-right-10"></md-icon><md-button ng-if="!field.locked" class="md-icon-button" aria-label="primary button" ng-click="vm.editField(field, $index)"><md-icon class="zmdi zmdi-edit icon-size"></md-icon></md-button><md-menu ng-if="!field.locked"><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item><md-button aria-label="primary button" ng-click="vm.copyField(field, $index)"><md-icon class="zmdi zmdi-copy icon-size"></md-icon><span translate="entity.action.copy">Copy</span></md-button></md-menu-item><md-menu-item><md-button aria-label="primary button" ng-click="vm.deleteField(field, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container></div></md-content></div></div>');
$templateCache.put('modules/user/noaccess/404.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame" flex layout="column" layout-align="center center"><div flex layout="row" class="padding-100"><div flex layout="column" class="access-status" layout-align="center center"><h1 translate="noaccess.wrongUrl">Looks like you entered an incorrect URL or Website</h1><h2 translate="noaccess.enterCorrectUrl">Please enter correct URL</h2></div></div></div></div></div>');
$templateCache.put('modules/user/noaccess/noaccess.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame" flex layout="column" layout-align="center center" ng-if="!vm.isApiProcessing"><div flex layout="row" class="padding-100"><div flex layout="column" class="access-status" layout-align="center center"><div ng-if="vm.doesWorkspaceExist"><h1><span translate="noaccess.dontHaveAccess">You don\'t have access</span><span ng-if="vm.isWorkspaceInactive" translate="noaccess.workspace"> to this workspace.</span></h1><h2 translate="noaccess.contact">Please contact your system administrator</h2></div><div ng-if="!vm.doesWorkspaceExist"><h1>Workspace does not exist</h1><h2>Please enter correct URL</h2></div></div></div><fp-footer></fp-footer></div><div ng-if="vm.isApiProcessing" flex class="padding-100" layout-align="center center"><wave-spinner></wave-spinner></div></div></div>');
$templateCache.put('modules/user/overview/overview.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="!vm.loadingData"><div flex layout="row" layout-xs="column" class="padding-30"><div layout="row" layout-align="start center" class="padding-30"><div class="fp-profile-image-container" ng-mouseenter="image.showEditProfileImage = true;" ng-mouseleave="image.showEditProfileImage = false;"><img ng-src="{{vm.getUserProfileImageUrl()}}" alt="girl-avatar" class="make-round" width="150px" height="150px"><div class="fp-profile-image-edit-overlay" layout-align="center center" layout="row" ng-style="image.showEditProfileImage ? { \'top\':\'0\' } : {\'top\' : \'100%\'}"><fp-upload fp-content-type="picture" fp-ng-model="vm.user.picture_id" fp-multiple="true" fp-upload-icon-class="zmdi zmdi-edit icon-size" fp-add-model-fn="vm.updateUserProfileImage(mediaId, responseObj)" fp-pattern="image/*" fp-max-size="2000000" fp-upload-type="basic" fp-enable-preview="false" fp-all-button-color-class=""></fp-upload><md-button ng-if="vm.user.picture_id && vm.user.picture_id != null" ng-click="vm.removeUserProfileImage()" class="md-icon-button" aria-label="primary button"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></div></div></div><div flex="50" layout-align="space-around center" class="padding-30"><div class="md-title margin-bottom-10">{{::vm.user.first_name}} {{::vm.user.last_name}}</div><div flex layout="row" class="margin-top-20"><div flex="50" layout="column"><span class="md-body-2" translate="atheer.overview.form.phoneNumber">PHONE NUMBER</span> <span class="md-body-1">{{::vm.user.phone_number}}</span></div><div flex="50" layout="column"><span class="md-body-2" translate="atheer.overview.form.email">EMAIL</span> <span class="md-body-1">{{::vm.user.email}}</span></div></div><div flex layout="row" class="margin-top-20"><div flex="50" layout="column"><span class="md-body-2" translate="atheer.overview.form.jobTitle">JOB TITLE</span> <span class="md-body-1">{{::vm.user.job_title}}</span></div><div flex="50" layout="column"><span class="md-body-2" translate="atheer.overview.form.timezone">TIMEZONE</span> <span class="md-body-1">{{::vm.userTimezone.display_name}}</span></div></div></div><div flex layout="column" layout-align="center center"><img src="/assets/images/app/link-devices.png" border="0" width="100"><md-button class="md-primary" ng-click="vm.linkDevice(vm.user)" translate="entity.action.linkDevice">Link Device</md-button></div></div><div flex layout="row" layout-wrap layout-align="center center"><md-card flex="45" class="padding-bottom-30" permission permission-only="atheer_features.conversation.enable"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-icon md-font-icon="fa fa-comments margin-right-10"></md-icon><h2 flex><span translate="atheer.overview.conversations.title">Conversations</span></h2></div><div flex layout="row" class="padding-20"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.conversation_summary.conversations}}</span> <span class="md-body-1" translate="atheer.overview.conversations.title">Conversations</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.conversation_summary.oneToOne}}</span> <span class="md-body-1" translate="atheer.overview.conversations.oneOnOne">1-1</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.userOverviewSummary.conversation_summary.group}}</span> <span class="md-body-1" translate="atheer.overview.conversations.group">Group</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-3" md-colors="{background: \'blue-A100\', color: \'white\'}"><span class="md-display-2">{{vm.userOverviewSummary.conversation_summary.messages}}</span> <span class="md-body-1" translate="atheer.overview.conversations.messages">Messages</span></div></div></md-card><md-card flex="45" class="padding-bottom-30" permission permission-only="atheer_features.airsession.enable"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-icon md-font-icon="fa zmdi zmdi-comment-video margin-right-10"></md-icon><h2 flex><span translate="atheer.overview.airSessions.title">AiRSessions</span></h2></div><div flex layout="row" class="padding-20"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.session_summary.scheduled}}</span> <span class="md-body-1" translate="atheer.overview.airSessions.scheduled">Scheduled</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.session_summary.attended}}</span> <span class="md-body-1" translate="atheer.overview.airSessions.attended">Attended</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.userOverviewSummary.session_summary.avg_duration}}</span> <span class="md-body-1" translate="atheer.overview.airSessions.avgDuration">Avg. Duration</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-3" md-colors="{background: \'orange-400\', color: \'white\'}"><span class="md-display-2">{{vm.userOverviewSummary.session_summary.total_minutes}}</span> <span class="md-body-1" translate="atheer.overview.airSessions.totalMin">Total Minutes</span></div></div></md-card><md-card flex="45" flex class="padding-bottom-30"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-icon md-font-icon="zmdi zmdi-library margin-right-10"></md-icon><h2 flex><span translate="atheer.overview.content.title">Content</span></h2></div><div flex layout="row" class="padding-20"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.content_summary.shared}}</span> <span class="md-body-1" translate="atheer.overview.content.shared">Shared</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.content_summary.bookmarked}}</span> <span class="md-body-1" translate="atheer.overview.content.bookmarked">Bookmarked</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.userOverviewSummary.content_summary.created}}</span> <span class="md-body-1" translate="atheer.overview.content.created">Created</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-3" md-colors="{background: \'purple-300\', color: \'white\'}"><span class="md-display-2">{{vm.userOverviewSummary.content_summary.viewed}}</span> <span class="md-body-1" translate="atheer.overview.content.viewed">Viewed</span></div></div></md-card><md-card flex="45" class="padding-bottom-30" permission permission-only="atheer_features.airform.enable"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-icon md-font-icon="zmdi zmdi-assignment margin-right-10"></md-icon><h2 flex><span translate="atheer.overview.jobs.title">Jobs</span></h2></div><div flex layout="row" class="padding-20"><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.job_summary.assigned}}</span> <span class="md-body-1" translate="atheer.overview.jobs.assigned">Assigned</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-1"><span class="md-display-2">{{vm.userOverviewSummary.job_summary.in_progress}}</span> <span class="md-body-1" translate="atheer.overview.jobs.inProgress">In-Progress</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-2"><span class="md-display-2">{{vm.userOverviewSummary.job_summary.completed}}</span> <span class="md-body-1" translate="atheer.overview.jobs.completed">Completed</span></div><div flex="25" layout="column" layout-align="center center" class="fp-user-overview-metrics-3" md-colors="{background: \'green-500\', color: \'white\'}"><span class="md-display-2">{{vm.userOverviewSummary.job_summary.avg_duration}}</span> <span class="md-body-1" translate="atheer.overview.jobs.avgDuration">Avg. Duration</span></div></div></md-card></div></md-content></div>');
$templateCache.put('modules/user/overview/qrcode-dialog.tmpl.html','<md-dialog flex="50" flex-xs="100" flex-md="50" flex-lg="50" aria-label=""><md-toolbar class="toolbar-default margin-bottom-0"><div class="md-toolbar-tools"><span flex translate="atheer.overview.qrCode" translate-values="{loadingData: \'{{vm.loadingData}}\'}">QR Code to Link your device {{vm.loadingData}}</span><md-button class="md-icon-button" ng-click="vm.close()" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-close"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.overview.close">Close</span></fp-tooltip></md-button></div></md-toolbar><md-dialog-content flex layout="column" layout-align="center center"><div flex layout="row" layout-align="center center" class="padding-40"><div class="margin-top-10 base" translate="atheer.overview.linkDevice">You\u2019ll want to link your device to your Atheer account. Select \u201CAdd User\u201D in the Atheer application on your device and scan the QR code below.</div></div><div ng-if="!vm.codeExpired" flex layout="row" layout-align="center center"><fp-timer end-time="vm.startTime" interval="1000"><span class="md-display-2" translate="atheer.overview.minutesSeconds" translate-values="{minutes: \'{{minutes}}\', minutesS: \'{{minutesS}}\', seconds: \'{{seconds}}\', secondsS: \'{{secondsS}}\'}">{{minutes}} minute{{minutesS}}, {{seconds}} second{{secondsS}}</span></fp-timer></div><div ng-if="!vm.codeExpired" flex layout="row" layout-align="center center" class="margin-bottom-40"><div class="margin-top-20" ng-if="!vm.isQRLoading"><img ng-src="{{vm.qrCodeImage}}" border="0" width="300"></div></div><div ng-if="vm.codeExpired" flex layout="column" layout-align="center center" class="margin-120"><div class="margin-top-20"><span class="md-title" translate="atheer.overview.codeExpired">Code Expired</span></div><div layout-align="center center" class="margin-top-40"><md-button ng-click="vm.refreshQRCode()" class="md-primary md-raised" translate="atheer.overview.clickHere">Click here to refresh</md-button></div></div></md-dialog-content></md-dialog>');
$templateCache.put('modules/user/password/forced-password.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame" flex layout="column" layout-align="center center"><div layout="row" flex layout-padding layout-fill layout-align="center center"><md-card ng-if="!vm.isAppWorkspace" flex="30" flex-xs="100" flex-gt-xs="100" flex-md="70" flex-gt-md="70" flex-lg="30" flex-xl="30" class="padding-0 overflow-auto"><div class="padding-8"><md-toolbar class="padding-20" md-theme="{{!vm.useDarkBackGroundLogos ? \'white-theme\' : \'primary-theme\'}}"><div flex layout="row" layout-align="center center" class="margin-top-10"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}"></div><div layout="row" layout-align="center center" class="margin-top-10"><h1 style="text-align:center" class="md-headline" translate="atheer.forcedPassword.updateYourPassword">Please update your password before continuing further</h1></div></md-toolbar><div class="md-padding"><form ng-if="!vm.loadingData" name="password" novalidate><md-input-container class="md-block"><div><label for="password" translate="global.form.forcedNewPassword">New Password</label><div class="password-container"><input id="password" label="password" name="password" type="{{ vm.passwordVisibility.newPassword ? \'text\' : \'password\' }}" ng-model="vm.password" tri-same-password="password.confirm" ng-minlength="8" ng-maxlength="12" required> <button type="button" class="eye-icon" ng-click="vm.togglePasswordVisibility(\'newPassword\')"><md-icon class="{{ vm.passwordVisibility.newPassword ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div></div><span class="md-caption" translate="atheer.forcedPassword.passwordConditions">8-12 characters, must include one uppercase, one lowercase, one special case character and one number.</span><div ng-messages="password.password.$error" md-auto-hide="false"></div></md-input-container><md-input-container class="md-block"><label for="confirm" translate="global.form.confirmedForcedNewPassword">Confirm new Password</label><div><input id="confirm" label="confirm" name="confirm" type="{{ vm.passwordVisibility.confirmPassword ? \'text\' : \'password\' }}" ng-model="vm.confirmPassword" tri-same-password="password.password" ng-minlength="8" ng-maxlength="12" required> <button type="button" class="eye-icon" style="top: 0 !important;" ng-click="vm.togglePasswordVisibility(\'confirmPassword\')"><md-icon class="{{ vm.passwordVisibility.confirmPassword ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div></md-input-container></form></div><div layout="row" class="md-padding" layout-align="center center"><md-button class="md-accent md-raised" ng-click="vm.cancelChange()" aria-label="primary button"><span translate="entity.action.cancel">CANCEL</span></md-button><md-button class="md-accent md-raised" ng-click="vm.changePassword()" aria-label="primary button"><span translate="entity.action.save">SAVE</span></md-button></div></div></md-card></div></div></div></div>');
$templateCache.put('modules/user/password/forgot.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame" flex layout="column" layout-align="center center"><div layout="row" flex layout-fill layout-align="center center"><md-card flex="30" flex-xs="100" flex-gt-xs="100" flex-md="70" flex-gt-md="70" flex-lg="30" flex-xl="30"><md-toolbar class="padding-20" md-theme="{{!vm.useDarkBackGroundLogos ? \'white-theme\' : \'primary-theme\'}}"><div flex layout="row" layout-align="center center" class="margin-top-10"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}"></div><div layout="row" layout-align="center center" class="margin-top-10"><h1 class="md-headline" translate="atheer.forgotPassword.title">Password Reset</h1></div></md-toolbar><div class="md-padding"><div ng-show="vm.status == \'FAIL\'"><strong translate="atheer.forgotPassword.errorResetingPassword">Error reseting password. Please contact system administrator</strong></div><div ng-show="vm.status == \'OK\'" layout="row" layout-align="center center" class="margin-bottom-20"><img src="assets/images/app/placeholder-email.png" height="50"></div><div ng-show="vm.status == \'OK\'"><strong translate="atheer.forgotPassword.sentEmailWithFurtherInstructions" translate-values="{resetAccountUsername: \'{{vm.resetAccount.username}}\'}">We\'ve sent an email to {{vm.resetAccount.username}} with further instructions on resetting your password.</strong><p translate="atheer.forgotPassword.checkJunkMailFolder">If you don\'t see an email from us in your inbox, please check your junk mail folder as it may have been mistakenly categorized as spam or try a different email address.</p></div><div ng-show="vm.status == \'OK\'"><md-button class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ui-sref="account.signin" aria-label="{{\'Log in\' | triTranslate}}" translate="entity.action.login">Login</md-button></div><div ng-show="vm.status != \'OK\'"><p translate="atheer.forgotPassword.resetYourPassword">To reset your password, enter the username you use to sign in</p><form name="forgot" ng-submit="vm.resetClick()"><md-input-container class="md-block"><label for="username" translate="global.form.username">username</label> <input id="username" label="username" name="username" ng-model="vm.resetAccount.username" required><div ng-messages="forgot.username.$error" md-auto-hide="false" ng-show="forgot.username.$touched"><div ng-message when="required"><span translate="atheer.forgotPassword.enterYourUsername">Please enter your username.</span></div></div></md-input-container><md-button class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" type="submit" ng-disabled="forgot.$invalid" aria-label="Reset Password" translate="atheer.reset.request.form.button">Reset Password</md-button><md-button class="md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ui-sref="account.signin" translate="atheer.forgotPassword.rememberedIt" aria-label="{{\'Remembered it? Login in here\' | triTranslate}}"></md-button></form></div></div></md-card></div></div><fp-footer></fp-footer></div></div>');
$templateCache.put('modules/user/password/password.tmpl.html','<div flex layout="column" layout-fill><md-toolbar hide-xs hide-sm class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><div layout="row" layout-align="end center"><md-button class="md-raised md-accent margin-left-0" translate="entity.action.update" ng-click="vm.changePassword()" aria-label="Update Settings"></md-button></div><fp-help></fp-help></div></md-toolbar><fp-header hide-gt-sm is-public-user="vm.isPublicUser" user-info="vm.user" title="vm.title"></fp-header><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="column" ng-if="!vm.loadingData" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="50" flex-xs="90" flex-sm="90" layout="column" class="md-padding"><form name="password" novalidate><md-input-container ng-if="!vm.isAdminMode" class="md-block"><label for="old-password" translate="atheer.password.form.current">Current Password</label> <input id="old-password" label="old-password" name="old-password" type="password" ng-model="vm.currentPassword"></md-input-container><md-input-container class="md-block"><label for="password" translate="global.form.forcedNewPassword">New Password</label><div class="password-container"><input id="password" label="password" name="password" type="{{ vm.passwordVisibility.newPassword ? \'text\' : \'password\' }}" ng-model="vm.password" tri-same-password="password.confirm" ng-minlength="8" ng-maxlength="50" required> <button type="button" class="eye-icon" ng-click="vm.togglePasswordVisibility(\'newPassword\')"><md-icon class="{{ vm.passwordVisibility.newPassword ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div><span class="md-caption" translate="atheer.password.passwordDescription">8-12 characters, must include one uppercase, one lowercase, one special case character and one number.</span><div ng-messages="password.password.$error" md-auto-hide="false" ng-show="password.password.$touched"><div ng-message when="required"><span translate="atheer.password.messages.required">Please enter your first name.</span></div></div><div ng-messages="password.password.$error" md-auto-hide="false" ng-show="password.password.$touched"><div ng-message when="minlength"><span translate="atheer.password.messages.minLength">Your password must be greater than 8 characters long.</span></div></div><div ng-messages="password.password.$error" md-auto-hide="false" ng-show="password.password.$touched"><div ng-message when="maxlength"><span translate="atheer.password.messages.maxLength">This field cannot be longer than 50 characters.</span></div></div><div ng-messages="password.password.$error" md-auto-hide="false" ng-show="password.password.$touched"><div ng-message when="samePassword"><span translate="atheer.password.messages.samePassword">You need to enter the same password.</span></div></div></md-input-container><md-input-container class="md-block margin-top-40"><label for="confirm" translate="global.form.confirmedForcedNewPassword">confirm password</label><div class="password-container"><input id="confirm" label="confirm" name="confirm" type="{{ vm.passwordVisibility.confirmPassword ? \'text\' : \'password\' }}" ng-model="vm.confirmPassword" tri-same-password="password.password" ng-minlength="8" ng-maxlength="50" required> <button type="button" class="eye-icon" ng-click="vm.togglePasswordVisibility(\'confirmPassword\')"><md-icon class="{{ vm.passwordVisibility.confirmPassword ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div><div ng-messages="password.confirm.$error" md-auto-hide="false" ng-show="password.confirm.$touched"><div ng-message when="required"><span translate="atheer.password.messages.required">Please enter your first name.</span></div></div><div ng-messages="password.confirm.$error" md-auto-hide="false" ng-show="password.confirm.$touched"><div ng-message when="minlength"><span translate="atheer.password.messages.minLength">Your password must be greater than 8 characters long.</span></div></div><div ng-messages="password.confirm.$error" md-auto-hide="false" ng-show="password.confirm.$touched"><div ng-message when="maxlength"><span translate="atheer.password.messages.maxLength">This field cannot be longer than 50 characters.</span></div></div><div ng-messages="password.confirm.$error" md-auto-hide="false" ng-show="password.password.$touched"><div ng-message when="samePassword"><span translate="atheer.password.messages.samePassword">You need to enter the same password.</span></div></div></md-input-container></form><div ng-if="vm.featureForcedPassword && vm.isAdminMode" layout="row" layout-align="space-between center"><span flex translate="atheer.password.forcePasswordChange">Force password change on initial user login</span><md-switch name="forced_password_enabled" ng-model="vm.forcedPasswordEnabled" aria-label="Notify User"></md-switch></div><div hide-gt-sm layout="row" layout-align="center center"><md-button class="md-raised md-primary margin-left-0" translate="entity.action.update" ng-click="vm.changePassword()" aria-label="Update Settings" ng-disabled="password.$invalid"></md-button></div></div></div></md-content></div>');
$templateCache.put('modules/user/password/reset.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame" flex layout="column" layout-align="center center"><md-card><md-toolbar class="padding-20" md-theme="{{!vm.useDarkBackGroundLogos ? \'white-theme\' : \'primary-theme\'}}"><div flex layout="row" layout-align="center center" class="margin-top-10"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}"></div><div layout="row" layout-align="center center" class="margin-top-10"><h1 class="md-headline" translate="atheer.reset.title">Password Reset</h1></div></md-toolbar><md-content class="md-padding"><div class="row"><div class="col-md-4 col-md-offset-4"><div ng-show="vm.keyMissing" class="padding-40"><strong translate="atheer.reset.passwordResetKeyIsMissing">The password reset key is missing.</strong></div><div ng-hide="vm.success || vm.keyMissing"><p translate="atheer.reset.finish.messages.info">Choose a new password</p></div><div ng-show="vm.success"><p><strong translate="atheer.reset.passwordResetComplete">Your password has been reset.</strong></p></div><div ng-show="vm.success" layout="row" layout-align="end center"><md-button class="md-raised md-primary margin-left-0" ui-sref="account.signin" aria-label="Update Settings" translate="entity.action.login">Login</md-button></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="password" role="form"><md-input-container class="md-block"><label for="password" translate="global.form.forcedNewPassword">New Password</label><div class="password-container"><input id="password" label="password" name="password" type="{{ vm.passwordVisible ? \'text\' : \'password\' }}" ng-model="vm.password" tri-same-password="password.confirm" ng-minlength="8" ng-maxlength="50" required> <button type="button" class="eye-icon" ng-click="vm.togglePasswordVisibility()"><md-icon class="{{ vm.passwordVisible ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div><div><span class="md-caption" translate="atheer.forcedPassword.passwordConditions">8-12 characters, must include one uppercase, one lowercase, one special case character and one number.</span><div ng-messages="password.password.$error" md-auto-hide="false"></div></div></md-input-container><md-input-container class="md-block"><label for="confirm" translate="atheer.reset.confirmPassword">Confirm password</label><div><input id="confirm" label="confirm" name="confirm" type="{{ vm.confirmPasswordVisible ? \'text\' : \'password\' }}" ng-model="vm.confirmPassword" tri-same-password="password.password" ng-minlength="8" ng-maxlength="50" required> <button type="button" class="eye-icon" ng-click="vm.toggleConfirmPasswordVisibility()" style="margin-top: -10px;"><md-icon class="{{ vm.confirmPasswordVisible ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div></md-input-container><div layout="row" layout-align="end center"><md-button class="md-raised md-primary margin-left-0" ng-click="vm.finishReset()" ng-disabled="password.$invalid" aria-label="Update Settings" translate="atheer.reset.request.form.button">Reset Password</md-button></div></form></div></div></div></md-content></md-card></div></div></div>');
$templateCache.put('modules/user/preference/preferences.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><div layout="row" layout-align="end center"><md-button class="md-raised md-accent margin-left-0" ng-disabled="profile.$invalid" translate="entity.action.update"></md-button></div><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex layout="column" ng-if="!vm.loadingData" class="padded-content-page margin-top-20"><div layout="row" layout-align="center center"><div flex="50" layout="column" class="md-padding"><md-list><div ng-repeat="group in ::vm.settingsGroups"><md-subheader class="md-accent margin-top-10 margin-bottom-10" translate="{{::group.name}}"></md-subheader><md-list-item ng-repeat="setting in ::group.settings" layout="row" layout-align="space-around center"><md-icon md-font-icon="{{::setting.icon}}"></md-icon><p translate>{{::setting.title}}</p><md-switch class="md-secondary" ng-model="setting.enabled"></md-switch></md-list-item></div></md-list></div></div></md-content></div>');
$templateCache.put('modules/user/security-role/security-roles.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><md-button ng-if="!vm.disableAddUpdate" ng-click="vm.openAssignModal()" class="md-icon-button" aria-label="Assign Skill"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.assignSecurityRole">Assign Security Role</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.securityRoles.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.securityRole.noSecurityRoles.title">Uh!</div><div class="margin-top-10 base" translate="atheer.securityRole.noSecurityRoles.description">No Security Roles yet.</div><div permission permission-only="vm.permissions.create" class="margin-top-20" layout="column" layout-align="center center"><md-button ng-click="vm.openAssignModal()" class="md-primary md-raised" translate="atheer.securityRole.noSecurityRoles.button">Add Now</md-button></div></div><md-content flex ng-if="!vm.loadingData && vm.securityRoles.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column md-order-by="name"><span translate="atheer.securityRole.name">Name</span></th><th md-column><span translate="atheer.securityRole.type">Type</span></th><th md-column md-order-by="Assigned On"><span translate="atheer.securityRole.assignedOn">Assigned On</span></th><th ng-if="!vm.disableAddUpdate"></th></tr></thead><tbody md-body><tr ng-repeat="securityRole in vm.securityRoles track by securityRole.id"><td md-cell>{{securityRole.object.name}}</td><td md-cell><span ng-if="securityRole.object.acl === true" translate="atheer.securityRole.jobRole">Job Role</span> <span ng-if="securityRole.object.acl === false" translate="atheer.securityRole.standardRole">Standard Role</span></td><td md-cell>{{securityRole.assigned_on | date:\'MM/dd/yyyy\'}}</td><td ng-if="!vm.disableAddUpdate" class="text-right"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeUserSecurityRole(securityRole, $index)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.securityRole.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.securityRoles.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/user/session/sessions-past.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessions.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.session.pastSessions.noPastSessions">User does not have any past sessions.</div></div><md-content flex ng-if="!vm.loadingData && vm.sessions.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.session.sessionNo">No</span></th><th md-column md-order-by="topic"><span translate="atheer.session.topic">Topic</span></th><th md-column md-order-by="status"><span translate="atheer.session.startTime">Start Time</span></th><th md-column md-order-by="status"><span translate="atheer.session.noOfPartcipants">No of Participants</span></th><th md-column md-order-by="status"><span translate="atheer.session.duration">Duration</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="session in vm.sessions track by session.id"><td md-cell>{{session.session_no}}</td><td md-cell>{{session.topic}}</td><td md-cell>{{session.start_time | date: \'MMM dd, y hh:mm a\'}}</td><td md-cell>{{session.session_stats.no_of_participants}}</td><td md-cell>{{session.session_stats.duration}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button ng-if="session.session_stats.has_annotation" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'annotationsPanel\', session)"><md-icon class="zmdi zmdi-collection-image icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeAnnotations">See Annotations</span></fp-tooltip></md-button><md-button ng-if="session.conversation_info.last_message" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'conversationPanel\', session)"><md-icon class="fa fa-comments icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeSessionChat">See Session Chat</span></fp-tooltip></md-button><md-button ng-if="session.session_stats.has_recording" class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'recordingsPanel\', session)"><md-icon class="fa fa-youtube-play icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeRecordings">See Recordings</span></fp-tooltip></md-button><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.togglePanel(\'insightsPanel\', session)"><md-icon class="zmdi zmdi-chart icon-size"></md-icon><fp-tooltip><span translate="atheer.session.seeInsights">See Insights</span></fp-tooltip></md-button><md-menu><md-button class="md-icon-button" aria-label="open menu" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon></md-button><md-menu-content width="5"><md-menu-item permission permission-only="vm.permissions.delete"><md-button aria-label="primary button" ng-click="vm.deleteObject(session)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><span translate="entity.action.delete">Delete</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessions.length > 0"></md-table-pagination></div><ng-include src="\'modules/session/session-summary.tmpl.html\'"></ng-include>');
$templateCache.put('modules/user/session/sessions-upcoming.tmpl.html','<div flex layout="column" layout-fill><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.sessions.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.session.upcomingSessions.uh">Uh!</div><div class="margin-top-10 base" translate="atheer.session.upcomingSessions.noSessions">No upcoming sessions yet.</div></div><md-content flex ng-if="!vm.loadingData && vm.sessions.length > 0"><md-table-container ng-if="!vm.cardView"><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" md-on-reorder="vm.reOrder"><tr md-row><th md-column><span translate="atheer.session.sessionNo">No</span></th><th md-column md-order-by="topic"><span translate="atheer.session.topic">Topic</span></th><th md-column md-order-by="status"><span translate="atheer.session.startTime">Start Time</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="session in vm.sessions track by session.id"><td md-cell>{{session.session_no}}</td><td md-cell>{{session.topic}}</td><td md-cell>{{session.start_time | date: \'MMM dd, y hh:mm a\'}}</td><td class="text-right"><md-button aria-label="primary button" ng-click="vm.deleteObject(session)"><md-icon class="zmdi zmdi-delete icon-size"></md-icon></md-button></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit="vm.pageSize" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition" ng-if="vm.sessions.length > 0"></md-table-pagination></div>');
$templateCache.put('modules/user/session/sessions.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><fp-help></fp-help></div></md-toolbar><md-tabs class="padding-left-10" md-center-tabs><md-tab ui-sref="storm.profile.sessions.upcoming" md-active="vm.isActiveTab(\'storm.profile.sessions.upcoming\')"><md-tab-label><span translate="atheer.sessions.upcoming">Upcoming</span></md-tab-label></md-tab><md-tab ui-sref="storm.profile.sessions.past" md-active="vm.isActiveTab(\'storm.profile.sessions.past\')"><md-tab-label><span translate="atheer.sessions.past">Past</span></md-tab-label></md-tab></md-tabs><div flex ui-view></div></div>');
$templateCache.put('modules/user/signin/atheer-signin.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame" flex layout="column" layout-align="center center"><div ng-if="!vm.isAppWorkspace" class="full-width" layout="row" layout-align="space-between center"><div><md-button ng-click="vm.onGoBack()" ng-if="vm.isDesktop && !vm.isAppWorkspace && !vm.isWhitedLablled" class="md-icon-button margin-0 text-left"><md-icon md-font-icon="zmdi zmdi-long-arrow-left"></md-icon><fp-tooltip><span translate="atheer.signIn.back">Back</span></fp-tooltip></md-button></div><md-menu md-offset="0 40"><md-button class="md-icon-button margin-0 text-left" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-globe-alt"></md-icon></md-button><md-menu-content width="4"><md-menu-item ng-repeat="language in vm.supportedLanguages"><md-button ng-click="$mdCloseMenu;vm.onLanguageChange(language.value)">{{language.displayName}}</md-button></md-menu-item></md-menu-content></md-menu></div><div ng-if="!vm.isAppWorkspace" layout="row" flex layout-padding layout-fill layout-align="center center"><md-card flex="30" flex-xs="100" flex-gt-xs="100" flex-md="70" flex-gt-md="70" flex-lg="30" flex-xl="30" class="padding-0 overflow-auto"><md-toolbar class="padding-20" md-theme="{{!vm.useDarkBackGroundLogos ? \'white-theme\' : \'primary-theme\'}}"><div flex layout="row" layout-align="center center" class="margin-top-10"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}"></div><div ng-if="!vm.isMobileBrowser" layout="row" layout-align="center center" class="margin-top-10"><h1 class="md-headline" translate="atheer.signIn.title">Sign in</h1></div></md-toolbar><div ng-if="!vm.isMobileBrowser" class="md-padding"><form name="login" ng-submit="vm.login()"><md-input-container class="md-block"><label for="username" translate="global.form.username">username</label> <input id="username" label="username" name="username" type="textAngular" ng-model="vm.username" required><div ng-messages="login.username.$error" md-auto-hide="false" ng-show="login.username.$touched"><div ng-message when="required"><span translate="atheer.signIn.enterUsername">Please enter your Username.</span></div><div ng-message when="username"><span translate="atheer.signIn.enterValidUsername">Please enter a valid Username.</span></div></div></md-input-container><md-input-container class="md-block"><label for="password" translate="atheer.signIn.password">password</label><div class="password-container"><input id="password" label="password" name="password" type="{{ vm.passwordVisible ? \'text\' : \'password\' }}" ng-model="vm.password" required> <button type="button" class="eye-icon" ng-click="vm.togglePasswordVisibility()"><md-icon class="{{ vm.passwordVisible ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div><div ng-messages for="login.password.$error" md-auto-hide="false" ng-show="login.password.$touched"><div ng-message when="required"><span translate="atheer.signIn.enterPassword">Please enter your password.</span></div></div></md-input-container><md-button id="signin" class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ng-disabled="login.$invalid" aria-label="Sign in" type="submit" translate="entity.action.signIn">Sign in</md-button></form></div></md-card></div><div class="workspace-container" ng-if="vm.isAppWorkspace" layout="row" layout-xs="column" flex layout-fill layout-align="left right"><md-card class="app-workspace-container" flex="50" flex-xs="100" flex-gt-xs="100" flex-md="50" flex-gt-md="50" flex-lg="50" flex-xl="50"><div class="workspace-logo-container" layout="row" layout-align="center center"><img class="img-responsive" src="assets/images/ath-logo.png"></div><div class="app-left-side" layout="column" layout-align="start center"><div layout="column" layout-align="center left" class="app-left-side-content"><div class="workspace-title" translate="atheer.signIn.workspaceleftTitle">AR-powered front line worker platform</div><div class="workspace-content" translate="atheer.signIn.workspaceleftContent">Unleash the power of your front line</div><div class="workspace-description" translate="atheer.signIn.workspaceleftDescription">Atheer\u2019s AR-powered Front Line Worker Platform is a suite of modern digital tools used by the world\u2019s leading industrial enterprises to enable their front-line teams to work faster, better, and safer.</div><a href="https://www.atheerair.com/" target="_blank" class="workspace-link" translate="atheer.signIn.workspaceleftLink">Click here to learn more</a></div></div></md-card><md-card class="app-right" flex="50" flex-xs="100" flex-gt-xs="100" flex-md="50" flex-gt-md="50" flex-lg="50" flex-xl="50"><div class="full-width locale-menu-container" layout="row" layout-align="end start"><md-menu md-offset="0 40"><md-button class="md-icon-button margin-0 text-left" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-globe-alt"></md-icon></md-button><md-menu-content width="4"><md-menu-item ng-repeat="language in vm.supportedLanguages"><md-button ng-click="$mdCloseMenu;vm.onLanguageChange(language.value)">{{language.displayName}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class="full-width full-height app-right-side-container" layout="row" layout-align="center center"><div layout-align="center left"><div class="app-right-side-title" layout="row" layout-align="left center" translate="atheer.signIn.selectWorkspace">Enter Workspace</div><form class="workspace-right" name="login" ng-submit="vm.selectWorkspace()"><md-input-container class="md-block workspace-input"><label for="workspace" translate="atheer.signIn.workspace">Workspace Name</label> <input id="workspace" label="workspace" name="workspace" type="textAngular" ng-model="vm.workspace" required><div ng-messages="login.workspace.$error" md-auto-hide="false" ng-show="login.workspace.$touched"><div ng-message when="required"><span translate="atheer.signIn.enterWorkspaceName">Please enter workspace name.</span></div></div><div ng-if="vm.isWorkspaceError" class="error-message" translate="atheer.signIn.enterValidWorkspaceName">Please enter valid workspace name.</div><div class="workspace-input-info"><span translate="atheer.signIn.workspaceContent">If you don\'t know your workspance name, please contact your system administrator.</span></div></md-input-container><div layout="column" layout-align="center center"><md-button class="workspace-button margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ng-disabled="login.$invalid" aria-label="Sign in" type="submit" translate="entity.action.continue">Continue</md-button></div></form></div></div></md-card></div></div><fp-footer></fp-footer></div></div>');
$templateCache.put('modules/user/signin/signin.tmpl.html','<div class="fp_full_background" layout="row" layout-fill><div ng-if="vm.isLoading" flex layout="row" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.isLoading" class="animate-wrapper" flex layout="column"><div id="ui-login" class="login-frame signin" flex layout="column"><div ng-if="!vm.isAppWorkspace" hide show-gt-sm class="full-width" layout="row" layout-align="space-between center" ng-style="vm.backgroundColor"><div><md-button ng-click="vm.onGoBack()" ng-if="vm.isDesktop && !vm.isAppWorkspace && !vm.isWhitedLablled" class="md-icon-button margin-0 text-left"><md-icon md-font-icon="zmdi zmdi-long-arrow-left"></md-icon><fp-tooltip><span translate="atheer.signIn.back">Back</span></fp-tooltip></md-button></div><md-menu md-offset="0 40"><md-button class="md-icon-button margin-0 text-left" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-globe-alt"></md-icon></md-button><md-menu-content width="4"><md-menu-item ng-repeat="language in vm.supportedLanguages"><md-button ng-click="$mdCloseMenu;vm.onLanguageChange(language.value)">{{language.displayName}}</md-button></md-menu-item></md-menu-content></md-menu></div><div ng-if="!vm.isAppWorkspace" layout="row" flex layout-fill layout-align="center center" layout-align-sm="center stretch" layout-align-xs="center stretch" ng-style="vm.backgroundColor"><div flex="40" flex-xs="100" flex-md="60" flex-sm="100" layout="row" layout-xs="column" layout-sm="column"><md-card class="padding-0 margin-0" style="overflow: auto; width: 100%; height: auto;" ng-style="{\'height\': vm.isMobileBrowser ? \'100%\' : \'auto\'}"><div style="position: relative;"><md-menu class="lang-btn-mobile" hide-gt-sm><md-button class="md-icon-button margin-0 text-left" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-globe-alt"></md-icon></md-button><md-menu-content width="4"><md-menu-item ng-repeat="language in vm.supportedLanguages"><md-button ng-click="$mdCloseMenu;vm.onLanguageChange(language.value)">{{language.displayName}}</md-button></md-menu-item></md-menu-content></md-menu><md-toolbar class="padding-20" md-theme="{{!vm.useDarkBackGroundLogos ? \'white-theme\' : \'primary-theme\'}}"><div flex layout="row" layout-align="center center" class="margin-top-10"><img ng-src="{{::vm.triSettings.getLogoBig()}}" alt="{{vm.triSettings.name}}"></div></md-toolbar></div><div class="padding-40"><form ng-if="vm.enableAtheerLogin" name="login" ng-submit="vm.login()"><md-input-container class="md-block"><label for="username" translate="global.form.username">username</label> <input id="username" label="username" name="username" type="textAngular" ng-model="vm.username" required><div ng-messages="login.username.$error" md-auto-hide="false" ng-show="login.username.$touched"><div ng-message when="required"><span translate="atheer.signIn.enterUsername">Please enter your Username.</span></div><div ng-message when="username"><span translate="atheer.signIn.enterValidUsername">Please enter a valid Username.</span></div></div></md-input-container><md-input-container class="md-block margin-bottom-0"><label for="password" translate="atheer.signIn.password">password</label><div class="password-container"><input id="password" label="password" name="password" type="{{ vm.passwordVisible ? \'text\' : \'password\' }}" ng-model="vm.password" required> <button type="button" class="eye-icon" ng-click="vm.togglePasswordVisibility()"><md-icon class="{{ vm.passwordVisible ? \'zmdi zmdi-eye-off\' : \'zmdi zmdi-eye\' }}"></md-icon></button></div><div ng-messages for="login.password.$error" md-auto-hide="false" ng-show="login.password.$touched"><div ng-message when="required"><span translate="atheer.signIn.enterPassword">Please enter your password.</span></div></div></md-input-container><div class="forgot-password-container" layout="row" layout-align="space-between center"><label><input type="checkbox" id="rememberme" ng-model="vm.rememberMe"> <span translate="atheer.signIn.rememberMe">Remember Me</span></label><div ng-if="vm.enableForgotPassword"><a id="forgotpassword" class="forgot-password-link" flex ui-sref="account.forgot" aria-label="{{\'Forgot password?\' | triTranslate}}"><span translate="atheer.signIn.forgotPassword"></span></a></div></div><md-button id="signin" class="system-button md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ng-disabled="login.$invalid" aria-label="Sign in" type="submit" translate="entity.action.signIn">Sign in</md-button><div class="signup-container" layout="row" layout-align="center center" ng-if="vm.isSignupEnabled" permission permission-only="features.user.signup" ng-style="{\'margin-bottom\': vm.isMobileBrowser ? \'6rem\': \'1rem\'}"><span translate="atheer.signIn.dontHaveAnAccount"></span> <a id="createnewaccount" ui-sref="account.signup"><span class="singup-text" translate="atheer.signIn.signup"></span></a></div><div><md-button id="choosedifferentworkspace" ng-if="isDesktopApp" class="md-primary full-width margin-left-0 margin-right-0" ng-click="vm.chooseWorkspace()"><span translate="atheer.signIn.chooseDifferentWorkspace">Choose different workspace</span></md-button></div></form><div permission permission-only="atheer_features.system.sso"><md-divider ng-if="vm.showSSOLogin"></md-divider><div ng-if="vm.showSSOLogin" class="social-login" ng-style="{\'margin-bottom\': vm.isMobileBrowser ? \'6rem\': \'1rem\'}"><div ng-if="vm.enableAtheerLogin" class="text-center login-sign-with" translate="atheer.signIn.orSignInWith">or sign in with</div><div layout="row" layout-align="space-around center" layout-margin><md-button id="googlesso" ng-if="vm.googleSSO" ng-click="vm.redirect(vm.googleLogin.url)" class="md-raised md-primary adjust-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ng-style="{ \'background-color\': vm.googleLogin.color }"><md-icon class="adjust-height-icon" md-svg-icon="/assets/images/integration/ic_google_signin.svg"></md-icon><span style="color:red" translate="atheer.signIn.google">Google</span></md-button><md-button id="office365" ng-if="vm.azureAdSSO" ng-click="vm.redirect(vm.oidcLogin.url)" class="md-raised md-primary adjust-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ng-style="{ \'background-color\': vm.oidcLogin.color }" aria-label="{{vm.oidcLogin.icon}}"><md-icon class="adjust-height-icon" md-svg-icon="/assets/images/integration/ic_office_signin.svg"></md-icon><span style="color:red" translate="atheer.signIn.office365">Microsoft</span></md-button></div></div><md-divider ng-if="vm.enableAtheerLogin && vm.studioOidcSSO"></md-divider><div ng-if="vm.enableAtheerLogin && vm.studioOidcSSO" class="text-center login-sign-with" translate="atheer.signIn.orSignInWith">or sign in with</div><div ng-if="!vm.enableAtheerLogin && vm.studioOidcSSO" class="text-center login-sign-with" translate="atheer.signIn.signInWith">Sign in with</div><md-button id="odicSignOn" ng-if="vm.studioOidcSSO" ng-click="vm.redirect(vm.oidcSignOn.url)" class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-bottom-10" aria-label="Sign in" translate="atheer.signIn.odicSignOn">{{oidc_login_label}}</md-button><md-divider ng-if="vm.enableAtheerLogin && vm.samlSSO"></md-divider><div ng-if="vm.enableAtheerLogin && vm.samlSSO" class="text-center login-sign-with" translate="atheer.signIn.orSignInWith">or sign in with</div><div ng-if="!vm.enableAtheerLogin && vm.samlSSO" class="text-center login-sign-with" translate="atheer.signIn.signInWith">Sign in with</div><md-button id="yournetworkcredentials" ng-if="vm.samlSSO" ng-click="vm.redirect(vm.samlLogin.url)" class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-bottom-10" aria-label="Sign in" translate="atheer.signIn.yourNetworkCredentials">Your network credentials</md-button></div><md-divider></md-divider><div class="margin-bottom-20 margin-top-20" layout="row" layout-align="center center" ng-if="vm.isGuestFeature"><a ui-sref="account.guest-join"><span class="guest-text" translate="atheer.signIn.joinAirSessionAsGuest"></span></a></div></div></md-card></div></div><div ng-if="vm.isAppWorkspace" class="full-width locale-menu-container" layout="row" layout-align="end start"><md-menu md-offset="0 40" layout="row" layout-align="end start"><md-button class="md-icon-button margin-0 text-left" ng-click="$mdMenu.open()"><md-icon md-font-icon="zmdi zmdi-globe-alt"></md-icon></md-button><md-menu-content width="4"><md-menu-item ng-repeat="language in vm.supportedLanguages"><md-button ng-click="$mdCloseMenu;vm.onLanguageChange(language.value)">{{language.displayName}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class="workspace-container" ng-if="vm.isAppWorkspace" layout="row" layout-xs="column" flex layout-fill layout-align="left right"><md-card class="app-workspace-container" flex="50" flex-xs="100" flex-gt-xs="100" flex-md="50" flex-gt-md="50" flex-lg="50" flex-xl="50"><div class="workspace-logo-container" layout="row" layout-align="center center"><img class="img-responsive" src="assets/images/ath-logo.png"></div><div class="app-left-side" layout="column" layout-align="start start"><div layout="column" layout-align="center left" class="app-left-side-content"><div class="workspace-title" translate="atheer.signIn.workspaceleftTitle">AR-powered front line worker platform</div><div class="workspace-content" translate="atheer.signIn.workspaceleftContent">Unleash the power of your front line</div><div class="workspace-description" translate="atheer.signIn.workspaceleftDescription">Atheer\u2019s AR-powered Front Line Worker Platform is a suite of modern digital tools used by the world\u2019s leading industrial enterprises to enable their front-line teams to work faster, better, and safer.</div><a href="https://www.atheerair.com/" target="_blank" class="workspace-link" translate="atheer.signIn.workspaceleftLink">Click here to learn more</a></div></div></md-card><md-card class="app-right" flex="50" flex-xs="100" flex-gt-xs="100" flex-md="50" flex-gt-md="50" flex-lg="50" flex-xl="50"><div class="workspace-logo-container"></div><div class="full-width app-right-side-container" layout="row" layout-align="start start"><div layout-align="center left"><div class="app-right-side-title" layout="row" layout-align="left center" translate="atheer.signIn.selectWorkspace">Enter Workspace</div><form class="workspace-right" name="login" ng-submit="vm.selectWorkspace()"><md-input-container class="md-block workspace-input"><label for="workspace" translate="atheer.signIn.workspace">Workspace Name</label> <input id="workspace" label="workspace" name="workspace" type="textAngular" ng-model="vm.workspace" required><div ng-messages="login.workspace.$error" md-auto-hide="false" ng-show="login.workspace.$touched"><div ng-message when="required"><span translate="atheer.signIn.enterWorkspaceName">Please enter workspace name.</span></div></div><div ng-if="vm.isWorkspaceError" class="error-message" translate="atheer.signIn.enterValidWorkspaceName">Please enter valid workspace name.</div><div class="workspace-input-info"><span translate="atheer.signIn.workspaceContent">If you don\'t know your workspance name, please contact your system administrator.</span></div></md-input-container><div layout="column" layout-align="center center"><md-button class="workspace-button margin-left-0 margin-right-0 margin-top-10 margin-bottom-10" ng-disabled="login.$invalid" aria-label="Sign in" type="submit" translate="entity.action.continue">Continue</md-button></div></form></div></div></md-card></div></div><fp-footer></fp-footer></div></div>');
$templateCache.put('modules/user/signout/signout.tmpl.html','<div class="fp_full_background" layout="row" layout-fill layout-align="center center"><div flex="40" flex-md="50" flex-sm="100" flex-xs="100" layout="column"><md-card flex="100" class="padding-40"><div class="row" layout-align="center center"><h3 class="text-align-center" translate="atheer.signOut.signedOut">You\'ve signed out.</h3><div layout="row" layout-align="space-around center"><md-button class="md-raised md-primary adjust-width margin-left-0 margin-right-0 margin-top-40 margin-bottom-10" ui-sref="account.signin" translate="atheer.signOut.signInBack">Sign back in</md-button><md-button ng-if="vm.isDesktop && !vm.isWhiteLabelled" class="md-raised md-primary margin-left-0 margin-right-0 margin-top-40 adjust-width margin-bottom-10" ng-click="vm.changeWorkspace()" translate="atheer.signOut.changeWorkspace">Change Workspace</md-button></div></div></md-card></div></div><fp-footer></fp-footer>');
$templateCache.put('modules/user/team/teams.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><md-button ng-click="vm.openAssignModal()" class="md-icon-button" aria-label="Assign Skill"><md-icon md-font-icon="zmdi zmdi-plus"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.teams.assignTeam">Assign Team</span></fp-tooltip></md-button><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><div ng-if="!vm.loadingData && vm.teams.length == 0" flex layout="column" layout-align="center center"><img src="/assets/images/card/generic.png"><div class="margin-top-10 main" translate="atheer.teams.noTeams.heading">Uh!</div><div class="margin-top-10 base" translate="atheer.teams.noTeams.description">No Teams yet.</div><div permission permission-only="vm.permissions.create" class="margin-top-20" layout="column" layout-align="center center"><md-button ng-click="vm.createObject()" class="md-primary md-raised" translate="atheer.teams.noTeams.button">Add Now</md-button></div></div><md-content flex ng-if="!vm.loadingData && vm.teams.length > 0"><md-table-container><table md-table class="md-primary md-data-table" md-progress="vm.promise"><thead md-head md-order="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><tr md-row><th md-column><span translate="atheer.teams.table.name">Name</span></th><th md-column><span translate="atheer.team.type">Type</span></th><th md-column><span translate="atheer.teams.table.assignedOn">Assigned On</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat="team in vm.teams track by team.id"><td md-cell>{{team.object.name}}</td><td md-cell><div flex="30" layout-align="center center" class="fp-team-type-2" ng-style="team.object.type == \'STATIC\' ? {\'background-color\': \'{{vm.primaryBackgroundColor}}\'} : {\'background-color\': \'{{vm.secondaryBackgroundColor}}\'}">{{team.object.type == \'STATIC\' ? \'atheer.team.typeFixed\' : \'atheer.team.typeDynamic\' | translate}}</div></td><td md-cell>{{team.assigned_on | date:\'MM/dd/yyyy\'}}</td><td class="text-right"><md-button class="md-icon-button" aria-label="primary button" ng-click="vm.removeTeam(team)" ng-disabled="team.object.locked || team.object.type == \'SMART\'"><md-icon class="zmdi zmdi-delete icon-size"></md-icon><fp-tooltip placement="bottom"><span translate="atheer.teams.remove">Remove</span></fp-tooltip></md-button></td></tr></tbody></table></md-table-container></md-content><md-table-pagination ng-if="vm.teams.length > 0" md-limit="vm.query.limit" md-total="{{vm.queryCount}}" md-page-select md-boundary-links="true" md-page="vm.page" md-on-paginate="vm.transition"></md-table-pagination></div>');
$templateCache.put('modules/user/timeline/timeline.tmpl.html','<div flex layout="column" layout-fill><md-toolbar class="toolbar-default margin-bottom-0 md-whiteframe-z1" md-theme="{{::triSkin.elements.toolbar}}"><div class="md-toolbar-tools md-accent"><span flex></span><fp-help></fp-help></div></md-toolbar><div ng-if="vm.loadingData" flex class="fp-loading-panel" layout-align="center center"><wave-spinner></wave-spinner></div><md-content flex ng-if="!vm.loadingData"><div layout-padding ng-if="false"><div class="fp-no-data" layout="column" layout-align="center center"><div layout="column" layout-align="center center"><img src="/assets/images/card/timeline.png"></div><div class="margin-top-10 main" translate="atheer.timeline.noActivity.heading">No Enough Activity Yet !</div><div class="margin-top-10 base" translate="atheer.timeline.noActivity.description">We will show your timeline once we have enough activity of yours to put up..</div></div></div><div class="md-padding" ng-if="true"><md-list><div class="overlay-5 padded-content-page" animate-elements><div class="timeline" layout="row" ng-repeat="event in ::vm.events" ng-attr-layout-align="{{$odd? \'end end\':\'start start\'}}"><div layout="row" flex="50" flex-xs="100" ng-attr-layout-align="{{$odd? \'end\':\'start\'}} center"><div class="timeline-point md-whiteframe-z1" theme-background="primary" md-theme="{{triSkin.elements.content}}"><img ng-src="{{::event.image}}" class="timeline-point-avatar"> <span class="timeline-point-date">{{::event.date}}</span></div><md-divider class="timeline-x-axis" class="margin-0" flex flex-order="2"></md-divider><tri-widget class="timeline-widget margin-0 flex-70 flex-xs-100 {{::event.classes}}" title="{{::event.title}}" subtitle="{{::event.subtitle}}" title-position="bottom" ng-attr-flex-order="{{$odd? 2:1}}" palette-background="{{::event.palette}}"><div replace-with="{{event.content}}"></div></tri-widget><md-divider class="timeline-y-axis"></md-divider></div></div></div></md-list></div></md-content></div>');
$templateCache.put('modules/user/support/support-toolbar.tmpl.html','<md-toolbar class="md-primary toolbar-default margin-bottom-0 md-whiteframe-z1"><div class="md-toolbar-tools md-accent fp-admin-toolbar"><md-button ng-click="vm.back()" class="md-icon-button" aria-label="primary button"><md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon></md-button><h2><span>Support</span></h2><span flex></span></div></md-toolbar>');
$templateCache.put('modules/user/support/support.tmpl.html','<div ng-if="vm.loadingData" flex layout-align="center center"><wave-spinner></wave-spinner></div><div flex ng-if="!vm.loadingData"><md-content></md-content></div>');}]);})();